webpackJsonp([3],Array(24).concat([
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2446)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1414),
  /* template */
  __webpack_require__(3274),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4df80ca5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1394),
  /* template */
  __webpack_require__(3170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f635434",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SET_TAB_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return RESET_SURVEYBUILDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIST_SURVEYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIST_SURVEYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIST_SURVEYS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_SURVEY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_SURVEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SURVEY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_QUESTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_QUESTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_QUESTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return APPEND_QUESTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return APPEND_QUESTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return APPEND_QUESTIONS_FAILURE; });
/* unused harmony export SET_QUESTIONS_PAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_CHOICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_CHOICES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_CHOICES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return APPEND_CHOICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return APPEND_CHOICES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return APPEND_CHOICES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_CHOICE_TEMPLATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_CHOICE_TEMPLATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_CHOICE_TEMPLATES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return APPEND_CHOICE_TEMPLATES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return APPEND_CHOICE_TEMPLATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return APPEND_CHOICE_TEMPLATES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_QUESTION_CATEGORIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_QUESTION_CATEGORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_QUESTION_CATEGORIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CREATE_QUESTION_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CREATE_QUESTION_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CREATE_QUESTION_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GET_CHOICE_CATEGORIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_CHOICE_CATEGORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GET_CHOICE_CATEGORIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CREATE_CHOICE_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CREATE_CHOICE_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CREATE_CHOICE_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CREATE_SURVEY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CREATE_SURVEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CREATE_SURVEY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UPDATE_SURVEY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_SURVEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_SURVEY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_QUESTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_QUESTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_QUESTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_QUESTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_QUESTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_QUESTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CREATE_CHOICE_TEMPLATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CREATE_CHOICE_TEMPLATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CREATE_CHOICE_TEMPLATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return UPDATE_CHOICE_TEMPLATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UPDATE_CHOICE_TEMPLATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_CHOICE_TEMPLATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_CANVAS_QUESTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_CANVAS_QUESTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_CANVAS_QUESTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return GET_HOOKS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GET_HOOKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GET_HOOKS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CREATE_HOOK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CREATE_HOOK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CREATE_HOOK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return UPDATE_HOOK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return UPDATE_HOOK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return UPDATE_HOOK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return APPEND_HOOKS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return APPEND_HOOKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return APPEND_HOOKS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return GET_MATRIX_CHOICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return GET_MATRIX_CHOICES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return GET_MATRIX_CHOICES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CREATE_MATRIX_CHOICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CREATE_MATRIX_CHOICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CREATE_MATRIX_CHOICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return UPDATE_MATRIX_CHOICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return UPDATE_MATRIX_CHOICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return UPDATE_MATRIX_CHOICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return APPEND_MATRIX_CHOICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return APPEND_MATRIX_CHOICES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return APPEND_MATRIX_CHOICES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SET_SURVEY_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SET_SURVEY_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SET_SURVEY_INACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SET_SURVEY_FAVORITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SET_SURVEY_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SET_SURVEY_SORT_BY_FAVORITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return ADD_CANVAS_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SELECT_CANVAS_QUESTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return SET_CANVAS_QUESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return SELECT_SELECTOR_QUESTION_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return SELECT_SELECTOR_TEMPLATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return SELECT_SELECTOR_TEMPLATE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return SELECT_SELECTOR_CHOICE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SET_SELECTOR_QUESTION_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return SET_SELECTOR_TEMPLATE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SET_SELECTOR_CHOICE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SET_SELECTOR_HOOK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SET_SELECTOR_MATRIX_CHOICE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return RESET_SELECTOR_QUESTION_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return RESET_SELECTOR_TEMPLATE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return RESET_SELECTOR_CHOICE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return RESET_SELECTOR_HOOK_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return RESET_SELECTOR_MATRIX_CHOICE_FILTERS; });
/* unused harmony export CREATE_QUESTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SET_QUESTION_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return SET_QUESTION_DIALOG_ADD_TO_CANVAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return SET_QUESTION_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return RESET_QUESTION_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return SET_HOOK_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return SET_HOOK_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return RESET_HOOK_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return SET_MATRIX_CHOICE_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return SET_MATRIX_CHOICE_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return RESET_MATRIX_CHOICE_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE; });
/* unused harmony export SET_CHOICE_TEMPLATE_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SET_CHOICE_TEMPLATE_DIALOG_CHOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return SET_CHOICE_TEMPLATE_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return RESET_CHOICE_TEMPLATE_DIALOG_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CREATE_QUESTION_CATEGORY; });
/* unused harmony export SET_QUESTION_CATEGORY_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return SET_QUESTION_CATEGORY_DIALOG_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return SET_CHOICE_CATEGORY_DIALOG_VISIBILITY; });
var SET_TAB_ACTIVE = 'SET_TAB_ACTIVE';
var RESET_SURVEYBUILDER = 'RESET_SURVEYBUILDER';

// API
var LIST_SURVEYS_REQUEST = 'LIST_SURVEYS_REQUEST';
var LIST_SURVEYS_SUCCESS = 'LIST_SURVEYS_SUCCESS';
var LIST_SURVEYS_FAILURE = 'LIST_SURVEYS_FAILURE';

var GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
var GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
var GET_SURVEY_FAILURE = 'GET_SURVEY_FAILURE';

var GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
var GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
var GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';

var APPEND_QUESTIONS_REQUEST = 'APPEND_QUESTIONS_REQUEST';
var APPEND_QUESTIONS_SUCCESS = 'APPEND_QUESTIONS_SUCCESS';
var APPEND_QUESTIONS_FAILURE = 'APPEND_QUESTIONS_FAILURE';

var SET_QUESTIONS_PAGE = 'SET_QUESTIONS_PAGE';

var GET_CHOICES_REQUEST = 'GET_CHOICES_REQUEST';
var GET_CHOICES_SUCCESS = 'GET_CHOICES_SUCCESS';
var GET_CHOICES_FAILURE = 'GET_CHOICES_FAILURE';

var APPEND_CHOICES_REQUEST = 'APPEND_CHOICES_REQUEST';
var APPEND_CHOICES_SUCCESS = 'APPEND_CHOICES_SUCCESS';
var APPEND_CHOICES_FAILURE = 'APPEND_CHOICES_FAILURE';

var GET_CHOICE_TEMPLATES_REQUEST = 'GET_CHOICE_TEMPLATES_REQUEST';
var GET_CHOICE_TEMPLATES_SUCCESS = 'GET_CHOICE_TEMPLATES_SUCCESS';
var GET_CHOICE_TEMPLATES_FAILURE = 'GET_CHOICE_TEMPLATES_FAILURE';

var APPEND_CHOICE_TEMPLATES_REQUEST = 'APPEND_CHOICE_TEMPLATES_REQUEST';
var APPEND_CHOICE_TEMPLATES_SUCCESS = 'APPEND_CHOICE_TEMPLATES_SUCCESS';
var APPEND_CHOICE_TEMPLATES_FAILURE = 'APPEND_CHOICE_TEMPLATES_FAILURE';

var GET_QUESTION_CATEGORIES_REQUEST = 'GET_QUESTION_CATEGORIES_REQUEST';
var GET_QUESTION_CATEGORIES_SUCCESS = 'GET_QUESTION_CATEGORIES_SUCCESS';
var GET_QUESTION_CATEGORIES_FAILURE = 'GET_QUESTION_CATEGORIES_FAILURE';

var GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST = 'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST';
var GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS = 'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS';
var GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE = 'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE';

var CREATE_QUESTION_CATEGORY_REQUEST = 'CREATE_QUESTION_CATEGORY_REQUEST';
var CREATE_QUESTION_CATEGORY_SUCCESS = 'CREATE_QUESTION_CATEGORY_SUCCESS';
var CREATE_QUESTION_CATEGORY_FAILURE = 'CREATE_QUESTION_CATEGORY_FAILURE';

var GET_CHOICE_CATEGORIES_REQUEST = 'GET_CHOICE_CATEGORIES_REQUEST';
var GET_CHOICE_CATEGORIES_SUCCESS = 'GET_CHOICE_CATEGORIES_SUCCESS';
var GET_CHOICE_CATEGORIES_FAILURE = 'GET_CHOICE_CATEGORIES_FAILURE';

var CREATE_CHOICE_CATEGORY_REQUEST = 'CREATE_CHOICE_CATEGORY_REQUEST';
var CREATE_CHOICE_CATEGORY_SUCCESS = 'CREATE_CHOICE_CATEGORY_SUCCESS';
var CREATE_CHOICE_CATEGORY_FAILURE = 'CREATE_CHOICE_CATEGORY_FAILURE';

var CREATE_SURVEY_REQUEST = 'CREATE_SURVEY_REQUEST';
var CREATE_SURVEY_SUCCESS = 'CREATE_SURVEY_SUCCESS';
var CREATE_SURVEY_FAILURE = 'CREATE_SURVEY_FAILURE';

var UPDATE_SURVEY_REQUEST = 'UPDATE_SURVEY_REQUEST';
var UPDATE_SURVEY_SUCCESS = 'UPDATE_SURVEY_SUCCESS';
var UPDATE_SURVEY_FAILURE = 'UPDATE_SURVEY_FAILURE';

var CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST';
var CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
var CREATE_QUESTION_FAILURE = 'CREATE_QUESTION_FAILURE';

var UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST';
var UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
var UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';

var CREATE_CHOICE_TEMPLATE_REQUEST = 'CREATE_CHOICE_TEMPLATE_REQUEST';
var CREATE_CHOICE_TEMPLATE_SUCCESS = 'CREATE_CHOICE_TEMPLATE_SUCCESS';
var CREATE_CHOICE_TEMPLATE_FAILURE = 'CREATE_CHOICE_TEMPLATE_FAILURE';

var UPDATE_CHOICE_TEMPLATE_REQUEST = 'UPDATE_CHOICE_TEMPLATE_REQUEST';
var UPDATE_CHOICE_TEMPLATE_SUCCESS = 'UPDATE_CHOICE_TEMPLATE_SUCCESS';
var UPDATE_CHOICE_TEMPLATE_FAILURE = 'UPDATE_CHOICE_TEMPLATE_FAILURE';

var UPDATE_CANVAS_QUESTIONS_REQUEST = 'UPDATE_CANVAS_QUESTIONS_REQUEST';
var UPDATE_CANVAS_QUESTIONS_SUCCESS = 'UPDATE_CANVAS_QUESTIONS_SUCCESS';
var UPDATE_CANVAS_QUESTIONS_FAILURE = 'UPDATE_CANVAS_QUESTIONS_FAILURE';

var GET_HOOKS_REQUEST = 'GET_HOOKS_REQUEST';
var GET_HOOKS_SUCCESS = 'GET_HOOKS_SUCCESS';
var GET_HOOKS_FAILURE = 'GET_HOOKS_FAILURE';

var CREATE_HOOK_REQUEST = 'CREATE_HOOK_REQUEST';
var CREATE_HOOK_SUCCESS = 'CREATE_HOOK_SUCCESS';
var CREATE_HOOK_FAILURE = 'CREATE_HOOK_FAILURE';

var UPDATE_HOOK_REQUEST = 'UPDATE_HOOK_REQUEST';
var UPDATE_HOOK_SUCCESS = 'UPDATE_HOOK_SUCCESS';
var UPDATE_HOOK_FAILURE = 'UPDATE_HOOK_FAILURE';

var APPEND_HOOKS_REQUEST = 'APPEND_HOOKS_REQUEST';
var APPEND_HOOKS_SUCCESS = 'APPEND_HOOKS_SUCCESS';
var APPEND_HOOKS_FAILURE = 'APPEND_HOOKS_FAILURE';

var GET_MATRIX_CHOICES_REQUEST = 'GET_MATRIX_CHOICES_REQUEST';
var GET_MATRIX_CHOICES_SUCCESS = 'GET_MATRIX_CHOICES_SUCCESS';
var GET_MATRIX_CHOICES_FAILURE = 'GET_MATRIX_CHOICES_FAILURE';

var CREATE_MATRIX_CHOICE_REQUEST = 'CREATE_MATRIX_CHOICE_REQUEST';
var CREATE_MATRIX_CHOICE_SUCCESS = 'CREATE_MATRIX_CHOICE_SUCCESS';
var CREATE_MATRIX_CHOICE_FAILURE = 'CREATE_MATRIX_CHOICE_FAILURE';

var UPDATE_MATRIX_CHOICE_REQUEST = 'UPDATE_MATRIX_CHOICE_REQUEST';
var UPDATE_MATRIX_CHOICE_SUCCESS = 'UPDATE_MATRIX_CHOICE_SUCCESS';
var UPDATE_MATRIX_CHOICE_FAILURE = 'UPDATE_MATRIX_CHOICE_FAILURE';

var APPEND_MATRIX_CHOICES_REQUEST = 'APPEND_MATRIX_CHOICES_REQUEST';
var APPEND_MATRIX_CHOICES_SUCCESS = 'APPEND_MATRIX_CHOICES_SUCCESS';
var APPEND_MATRIX_CHOICES_FAILURE = 'APPEND_MATRIX_CHOICES_FAILURE';

// DASHBOARD
var SET_SURVEY_FILTER = 'SET_SURVEY_FILTER';
var SET_SURVEY_ACTIVE = 'SET_SURVEY_ACTIVE';
var SET_SURVEY_INACTIVE = 'SET_SURVEY_INACTIVE';
var SET_SURVEY_FAVORITE = 'SET_SURVEY_FAVORITE';
var SET_SURVEY_DELETE = 'SET_SURVEY_DELETE';
var SET_SURVEY_SORT_BY_FAVORITE = 'SET_SURVEY_SORT_BY_FAVORITE';

// CANVAS QUESTION
var ADD_CANVAS_QUESTION = 'ADD_CANVAS_QUESTION';
var SELECT_CANVAS_QUESTION_ID = 'SELECT_CANVAS_QUESTION';
var SET_CANVAS_QUESTIONS = 'SET_CANVAS_QUESTIONS';

// SELECTOR
var SELECT_SELECTOR_QUESTION_CATEGORY = 'SELECT_SELECTOR_QUESTION_CATEGORY';
var SELECT_SELECTOR_TEMPLATE_ID = 'SELECT_SELECTOR_TEMPLATE_ID';
var SELECT_SELECTOR_TEMPLATE_CATEGORY = 'SELECT_SELECTOR_TEMPLATE_CATEGORY';
var SELECT_SELECTOR_CHOICE_CATEGORY = 'SELECT_SELECTOR_CHOICE_CATEGORY';
var SET_SELECTOR_QUESTION_TEXT = 'SET_SELECTOR_QUESTION_TEXT';
var SET_SELECTOR_TEMPLATE_TEXT = 'SET_SELECTOR_TEMPLATE_TEXT';
var SET_SELECTOR_CHOICE_TEXT = 'SET_SELECTOR_CHOICE_TEXT';
var SET_SELECTOR_HOOK_TEXT = 'SET_SELECTOR_HOOK_TEXT';
var SET_SELECTOR_MATRIX_CHOICE_TEXT = 'SET_SELECTOR_MATRIX_CHOICE_TEXT';
var RESET_SELECTOR_QUESTION_FILTERS = 'RESET_SELECTOR_QUESTION_FILTERS';
var RESET_SELECTOR_TEMPLATE_FILTERS = 'RESET_SELECTOR_TEMPLATE_FILTERS';
var RESET_SELECTOR_CHOICE_FILTERS = 'RESET_SELECTOR_CHOICE_FILTERS';
var RESET_SELECTOR_HOOK_FILTERS = 'RESET_SELECTOR_HOOK_FILTERS';
var RESET_SELECTOR_MATRIX_CHOICE_FILTERS = 'RESET_SELECTOR_MATRIX_CHOICE_FILTERS';

var CREATE_QUESTION = 'CREATE_QUESTION';
var SET_QUESTION_DIALOG_VISIBILITY = 'SET_QUESTION_DIALOG_VISIBILITY';
var SET_QUESTION_DIALOG_ADD_TO_CANVAS = 'SET_QUESTION_DIALOG_ADD_TO_CANVAS';
var SET_QUESTION_DIALOG_FORM = 'SET_QUESTION_DIALOG_FORM';
var RESET_QUESTION_DIALOG_FORM = 'RESET_QUESTION_DIALOG_FORM';

var SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY = 'SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY';
var SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION = 'SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION';

var SET_HOOK_DIALOG_VISIBILITY = 'SET_HOOK_DIALOG_VISIBILITY';
var SET_HOOK_DIALOG_FORM = 'SET_HOOK_DIALOG_FORM';
var RESET_HOOK_DIALOG_FORM = 'RESET_HOOK_DIALOG_FORM';

var SET_MATRIX_CHOICE_DIALOG_VISIBILITY = 'SET_MATRIX_CHOICE_DIALOG_VISIBILITY';
var SET_MATRIX_CHOICE_DIALOG_FORM = 'SET_MATRIX_CHOICE_DIALOG_FORM';
var RESET_MATRIX_CHOICE_DIALOG_FORM = 'RESET_MATRIX_CHOICE_DIALOG_FORM';

var SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY = 'SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY';
var SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE = 'SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE';

var SET_CHOICE_TEMPLATE_LIST = 'SET_CHOICE_TEMPLATE_LIST';
var SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY = 'SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY';
var SET_CHOICE_TEMPLATE_DIALOG_CHOICES = 'SET_CHOICE_TEMPLATE_DIALOG_CHOICES';
var SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE = 'SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE';
var SET_CHOICE_TEMPLATE_DIALOG_FORM = 'SET_CHOICE_TEMPLATE_DIALOG_FORM';
var RESET_CHOICE_TEMPLATE_DIALOG_FORM = 'RESET_CHOICE_TEMPLATE_DIALOG_FORM';

var CREATE_QUESTION_CATEGORY = 'CREATE_QUESTION_CATEGORY';
var SET_QUESTION_CATEGORY_LIST = 'SET_QUESTION_CATEGORY_LIST';
var SET_QUESTION_CATEGORY_DIALOG_VISIBILITY = 'SET_QUESTION_CATEGORY_DIALOG_VISIBILITY';

var SET_CHOICE_CATEGORY_DIALOG_VISIBILITY = 'SET_CHOICE_CATEGORY_DIALOG_VISIBILITY';

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colony__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facebook__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instagram__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__telegram__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tiktok__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colony__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__facebook__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__instagram__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__telegram__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__tiktok__["a"]; });








/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1403),
  /* template */
  __webpack_require__(3179),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2383)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(3178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20db06ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__ = __webpack_require__(339);


 // eslint-disable-line

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    generateColorPool: function generateColorPool(columns) {
      var hueRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["a" /* hueRangeDefault */];

      var _this = this;

      var satRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["b" /* satRangeDefault */];
      var litRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["c" /* litRangeDefault */];

      return columns.map(function (c) {
        return _this.generateTitleColor(c[0], hueRange, satRange, litRange);
      });
    },
    generateTitleColor: function generateTitleColor(title) {
      var hueRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["a" /* hueRangeDefault */];
      var satRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["b" /* satRangeDefault */];
      var litRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["c" /* litRangeDefault */];

      return this.generateHTMLColor(title, hueRange, satRange, litRange);
    },
    generateHTMLColor: function generateHTMLColor(title) {
      var hueRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["a" /* hueRangeDefault */];

      var _this2 = this;

      var satRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["b" /* satRangeDefault */];
      var litRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["c" /* litRangeDefault */];

      var color = this.generateRGBColor(title, hueRange, satRange, litRange);
      var hexColor = [color.r, color.g, color.b].map(function (c) {
        return _this2.rgbToHex(c);
      });
      var htmlColor = '#' + hexColor.join('');

      return htmlColor;
    },
    generateRGBAColor: function generateRGBAColor(title, opacity) {
      var hueRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["a" /* hueRangeDefault */];
      var satRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["b" /* satRangeDefault */];
      var litRange = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["c" /* litRangeDefault */];

      var color = this.generateRGBColor(title, hueRange, satRange, litRange);
      var roundedColor = [color.r, color.g, color.b].map(function (c) {
        return Math.round(c);
      });

      return 'rgba(' + roundedColor.join() + ', ' + opacity + ')';
    },
    generateRGBColor: function generateRGBColor(title) {
      var hueRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["a" /* hueRangeDefault */];
      var satRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["b" /* satRangeDefault */];
      var litRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__colorConstants_live__["c" /* litRangeDefault */];

      // Ensure we're working with a string, otherwise we'll always get
      // the same color.
      var stringTitle = String(title);

      var hueSeed = this.generateSeedFromString(stringTitle, 11);
      var hueRnd = this.generateRnd(hueSeed, hueRange[0], hueRange[1]);

      var satSeed = this.generateSeedFromString(stringTitle, 3469);
      var satRnd = this.generateRnd(satSeed, satRange[0], satRange[1]);

      var litSeed = this.generateSeedFromString(stringTitle, 2207);
      var litRnd = this.generateRnd(litSeed, litRange[0], litRange[1]);

      var color = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* rgb */](__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* hsl */](hueRnd, satRnd, litRnd));
      return color;
    },
    generateRnd: function generateRnd(n, min, max) {
      var seed = n;

      seed = seed * 9301 * 49297 % 233280;
      var rnd = seed / 233280;

      return min + rnd * (max - min);
    },
    generateSeedFromString: function generateSeedFromString(string, salt) {
      var seed = 1;
      for (var i = 0; i < string.length; i += 1) {
        seed += string.charCodeAt(i) * salt; // Create a larger seed
      }

      return seed;
    },
    rgbToHex: function rgbToHex(rgb) {
      var hex = Number(Math.round(rgb)).toString(16);
      if (hex.length < 2) {
        hex = '0' + hex;
      }
      return hex;
    }
  }
});

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_INTERACTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_INTERACTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_INTERACTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SEARCH_INTERACTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLEAR_PANEL_INTERACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLEAR_PANEL_HAS_MORE_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NEW_INTERACTION_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_ONAIR_INTERACTION_RECEIVED; });
/* unused harmony export GET_SINGLE_INTERACTION_REQUEST */
/* unused harmony export GET_SINGLE_INTERACTION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_SINGLE_INTERACTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_INTERACTION_THREAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_INTERACTION_THREAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_INTERACTION_THREAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_THREADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return APPEND_THREAD_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_THREAD_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_THREAD_CHANNEL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_THREAD_DIALOG_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_MEDIA_IS_PLAYING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_INITIAL_PANEL_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return INCREMENT_PANEL_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DECREMENT_PANEL_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ADD_MANUAL_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_MANUAL_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_PANELS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_PANELS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_PANELS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CREATE_PANEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CREATE_PANEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CREATE_PANEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_PANEL_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_PANEL_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_PANEL_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DELETE_PANEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DELETE_PANEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DELETE_PANEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_PANEL_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PAUSE_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return UNPAUSE_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CLEAR_PANEL_PAUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CLEAR_DASHBOARD_PANEL_PAUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_GALLERY_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_GALLERY_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_GALLERY_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_PANEL_SETTINGS_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_PANEL_SETTINGS_DIALOG_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DELETE_INTERACTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DELETE_INTERACTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GET_SEARCH_RESULTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_SEARCH_RESULTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return GET_SEARCH_FIELDS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return GET_SEARCH_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return GET_SEARCH_FIELDS_FAILURE; });
/* unused harmony export GET_ONAIR_INTERACTIONS_REQUEST */
/* unused harmony export GET_ONAIR_INTERACTIONS_FAILURE */
/* unused harmony export GET_ONAIR_INTERACTIONS_SUCCESS */
/* unused harmony export UPDATE_INTERACTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return GET_TWITTER_TRENDS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return GET_TWITTER_TRENDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return GET_TWITTER_TRENDS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return EXPORT_TO_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return EXPORT_TO_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return EXPORT_TO_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_PANEL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_PANEL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_PANEL_ORDER__FAILURE; });
/* unused harmony export GET_INSTANT_POLL_STATS_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GET_INSTANT_POLL_STATS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GET_INSTANT_POLL_STATS_FAILURE; });
var GET_INTERACTIONS_REQUEST = 'GET_INTERACTIONS_REQUEST';
var GET_INTERACTIONS_FAILURE = 'GET_INTERACTIONS_FAILURE';
var GET_INTERACTIONS_SUCCESS = 'GET_INTERACTIONS_SUCCESS';
var SEARCH_INTERACTIONS_SUCCESS = 'SEARCH_INTERACTIONS_SUCCESS';
var CLEAR_PANEL_INTERACTIONS = 'CLEAR_PANEL_INTERACTIONS';
var CLEAR_PANEL_HAS_MORE_INDICATOR = 'CLEAR_PANEL_HAS_MORE_INDICATOR';

var NEW_INTERACTION_RECEIVED = 'NEW_INTERACTION_RECEIVED';
var NEW_ONAIR_INTERACTION_RECEIVED = 'NEW_ONAIR_INTERACTION_RECEIVED';

var GET_SINGLE_INTERACTION_REQUEST = 'GET_SINGLE_INTERACTION_REQUEST';
var GET_SINGLE_INTERACTION_FAILURE = 'GET_SINGLE_INTERACTION_FAILURE';
var GET_SINGLE_INTERACTION_SUCCESS = 'GET_SINGLE_INTERACTION_SUCCESS';

var GET_INTERACTION_THREAD_REQUEST = 'GET_INTERACTION_THREAD_REQUEST';
var GET_INTERACTION_THREAD_FAILURE = 'GET_INTERACTION_THREAD_FAILURE';
var GET_INTERACTION_THREAD_SUCCESS = 'GET_INTERACTION_THREAD_SUCCESS';

var CLEAR_THREADS = 'CLEAR_THREADS';
var APPEND_THREAD_REPLY = 'APPEND_THREAD_REPLY';
var SET_THREAD_ID = 'SET_THREAD_ID';
var SET_THREAD_CHANNEL_TYPE = 'SET_THREAD_CHANNEL_TYPE';
var SET_THREAD_DIALOG_VISIBLE = 'SET_THREAD_DIALOG_VISIBLE';

var SET_MEDIA_IS_PLAYING = 'SET_MEDIA_IS_PLAYING';

var SET_INITIAL_PANEL_PAGE = 'SET_PANEL_PAGE';
var INCREMENT_PANEL_PAGE = 'INCREMENT_PANEL_PAGE';
var DECREMENT_PANEL_PAGE = 'DECREMENT_PANEL_PAGE';

var ADD_MANUAL_PANEL = 'ADD_MANUAL_PANEL';
var REMOVE_MANUAL_PANEL = 'REMOVE_MANUAL_PANEL';

var GET_PANELS_REQUEST = 'GET_PANELS_REQUEST';
var GET_PANELS_FAILURE = 'GET_PANELS_FAILURE';
var GET_PANELS_SUCCESS = 'GET_PANELS_SUCCESS';

var CREATE_PANEL_REQUEST = 'CREATE_PANEL_REQUEST';
var CREATE_PANEL_FAILURE = 'CREATE_PANEL_FAILURE';
var CREATE_PANEL_SUCCESS = 'CREATE_PANEL_SUCCESS';

var UPDATE_PANEL_SETTINGS = 'UPDATE_PANEL_SETTINGS';
var UPDATE_PANEL_SETTINGS_FAILURE = 'UPDATE_PANEL_SETTINGS_FAILURE';
var UPDATE_PANEL_SETTINGS_SUCCESS = 'UPDATE_PANEL_SETTINGS_SUCCESS';

var DELETE_PANEL_REQUEST = 'DELETE_PANEL_REQUEST';
var DELETE_PANEL_FAILURE = 'DELETE_PANEL_FAILURE';
var DELETE_PANEL_SUCCESS = 'DELETE_PANEL_SUCCESS';
var UPDATE_PANEL_ORDER = 'UPDATE_PANEL_ORDER';

var PAUSE_PANEL = 'PAUSE_PANEL';
var UNPAUSE_PANEL = 'UNPAUSE_PANEL';
var CLEAR_PANEL_PAUSED = 'CLEAR_PANEL_PAUSED';
var CLEAR_DASHBOARD_PANEL_PAUSED = 'CLEAR_DASHBOARD_PANEL_PAUSED';

var SET_GALLERY_IMAGES = 'SET_GALLERY_IMAGES';
var SET_GALLERY_VISIBLE = 'SET_GALLERY_VISIBLE';
var SET_GALLERY_INDEX = 'SET_GALLERY_INDEX';

var SET_PANEL_SETTINGS_DIALOG = 'SET_PANEL_SETTINGS_DIALOG';
var SET_PANEL_SETTINGS_DIALOG_VISIBLE = 'SET_PANEL_SETTINGS_DIALOG_VISIBLE';

var DELETE_INTERACTION_SUCCESS = 'DELETE_INTERACTION_SUCCESS';
var DELETE_INTERACTION_FAILURE = 'DELETE_INTERACTION_FAILURE';

var SET_SEARCH_TERM = 'SET_SEARCH_TERM';

var GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS';
var GET_SEARCH_RESULTS_REQUEST = 'GET_SEARCH_RESULTS_REQUEST';
var GET_SEARCH_FIELDS_REQUEST = 'GET_SEARCH_FIELDS_REQUEST';
var GET_SEARCH_FIELDS_SUCCESS = 'GET_SEARCH_FIELDS_SUCCESS';
var GET_SEARCH_FIELDS_FAILURE = 'GET_SEARCH_FIELDS_FAILURE';

var GET_ONAIR_INTERACTIONS_REQUEST = 'GET_ONAIR_INTERACTIONS_REQUEST';
var GET_ONAIR_INTERACTIONS_FAILURE = 'GET_ONAIR_INTERACTIONS_FAILURE';
var GET_ONAIR_INTERACTIONS_SUCCESS = 'GET_ONAIR_INTERACTIONS_SUCCESS';

var UPDATE_INTERACTIONS = 'UPDATE_INTERACTIONS';

var GET_TWITTER_TRENDS_REQUEST = 'GET_TWITTER_TRENDS_REQUEST';
var GET_TWITTER_TRENDS_SUCCESS = 'GET_TWITTER_TRENDS_SUCCESS';
var GET_TWITTER_TRENDS_FAILURE = 'GET_TWITTER_TRENDS_FAILURE';

var EXPORT_TO_FILE_REQUEST = 'EXPORT_TO_FILE_REQUEST';
var EXPORT_TO_FILE_SUCCESS = 'EXPORT_TO_FILE_SUCCESS';
var EXPORT_TO_FILE_FAILURE = 'EXPORT_TO_FILE_FAILURE';

var UPDATE_PANEL_ORDER_REQUEST = 'UPDATE_PANEL_ORDER_REQUEST';
var UPDATE_PANEL_ORDER_SUCCESS = 'UPDATE_PANEL_ORDER_SUCCESS';
var UPDATE_PANEL_ORDER__FAILURE = 'UPDATE_PANEL_ORDER__FAILURE';

var GET_INSTANT_POLL_STATS_REQUEST = 'GET_INSTANT_POLL_STATS_REQUEST';
var GET_INSTANT_POLL_STATS_SUCCESS = 'GET_INSTANT_POLL_STATS_SUCCESS';
var GET_INSTANT_POLL_STATS_FAILURE = 'GET_INSTANT_POLL_STATS_FAILURE';

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1369),
  /* template */
  __webpack_require__(3186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2520)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1389),
  /* template */
  __webpack_require__(3371),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-966da568",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2469)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1469),
  /* template */
  __webpack_require__(3301),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1372),
  /* template */
  __webpack_require__(3273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colors__ = __webpack_require__(59);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colors__["a" /* default */]],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    legendPosition: {
      type: String,
      default: 'top'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    titlePosition: {
      type: String,
      default: 'top'
    },
    colorCycle: {
      type: Array
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tooltipsEnabled: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    getChartData: function getChartData() {
      var _this = this;

      var safeData = Array.isArray(this.data) ? this.data : [];

      return {
        labels: safeData.map(function (s) {
          return s[0];
        }),
        datasets: [{
          backgroundColor: safeData.map(function (s, i) {
            return _this.getColor(s[0], i);
          }),
          data: safeData.map(function (s) {
            return s[1];
          })
        }]
      };
    },
    getChartOptions: function getChartOptions() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: !!this.title,
          position: this.titlePosition,
          text: this.title || '',
          padding: 0
        },
        legend: {
          display: this.showLegend,
          position: this.legendPosition
        },
        animation: {
          duration: this.animationDuration,
          onComplete: function onComplete(event) {
            if (_this2.animationComplete !== undefined) {
              _this2.animationComplete(event);
            }
          }
        },
        tooltips: {
          enabled: this.tooltipsEnabled
        },
        onClick: function onClick(event, item) {
          return _this2.$emit('onClick', [event, item]);
        }
      }, this.options);
    }
  },
  methods: {
    getColor: function getColor(title, index) {
      var titleSwitcher = { male: 'Female', female: 'Male' };
      var titleColor = title;

      if (typeof title === 'string' && title.toLowerCase() in titleSwitcher) {
        titleColor = titleSwitcher[title.toLowerCase()];
      }

      if (!this.colorCycle) {
        return this.generateTitleColor(titleColor);
      }

      var colorsCount = this.colorCycle.length;
      return this.colorCycle[index % colorsCount];
    }
  }
});

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1371),
  /* template */
  __webpack_require__(3313),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export excludeProps */
/* unused harmony export cloneArrayList */
/* unused harmony export datePickerShortCutRanges */
/* unused harmony export isChoiceTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expandChoiceTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseChoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emptyChoice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(2836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);




var excludeProps = function excludeProps() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["omit"])(object, props);
};

var cloneArrayList = function cloneArrayList() {};

var datePickerShortCutRanges = {
  ONE_WEEK: 3600 * 1000 * 24 * 7,
  ONE_MONTH: 3600 * 1000 * 24 * 30,
  THREE_MONTHS: 3600 * 1000 * 24 * 90
};

var isChoiceTemplate = function isChoiceTemplate(item) {
  return 'choices' in item;
};

var expandChoiceTemplate = function expandChoiceTemplate(template) {
  return template.choices.map(function (c) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { templateId: template.id });
  });
};

var parseChoices = function parseChoices(values) {
  return values.map(function (value) {
    if (isChoiceTemplate(value)) {
      return expandChoiceTemplate(value);
    }
    return value;
  }).flatten();
};

var emptyChoice = function emptyChoice() {
  return { id: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(), title: '' };
};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  plugins: {
    emptyDataPlugin: {
      afterDraw: function afterDraw(chart) {
        var datasets = chart.data.datasets.filter(function (ds) {
          return ds.data.filter(function (x) {
            return x != null;
          }).length > 0;
        });
        if (datasets.length === 0) {
          // No data is present
          var ctx = chart.chart.ctx;
          var width = chart.chart.width;
          var height = chart.chart.height;
          chart.clear();

          ctx.save();
          ctx.textAlign = 'center';
          ctx.fillStyle = '#000000';
          ctx.textBaseline = 'middle';
          ctx.font = "16px normal 'Helvetica Nueue'";
          ctx.fillText('No data to display', width / 2, height / 2);
          ctx.restore();
        }
      }
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ANALYTICS_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUBTRACT_ANALYTICS_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ANALYTICS_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ANALYTICS_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ANALYTICS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ANALYTICS_TIMESLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ANALYTICS_CHARTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_ANALYTICS_CHARTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_ANALYTICS_CHARTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_ANALYTICS_MAIN_CHART_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_ANALYTICS_MAIN_CHART_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_ANALYTICS_MAIN_CHART_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ANALYTICS_MAIN_LEGEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_ANALYTICS_CAMPAIGN_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_ANALYTICS_CAMPAIGN_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_ANALYTICS_LIVE_STREAM_STATS; });
var ADD_ANALYTICS_DATE = 'ADD_ANALYTICS_DATE';
var SUBTRACT_ANALYTICS_DATE = 'SUBTRACT_ANALYTICS_DATE';

var SET_ANALYTICS_DATE = 'SET_ANALYTICS_DATE';
var SET_ANALYTICS_PERIOD = 'SET_ANALYTICS_PERIOD';
var SET_ANALYTICS_FILTER = 'SET_ANALYTICS_FILTER';
var SET_ANALYTICS_TIMESLOT = 'SET_ANALYTICS_TIMESLOT';

var GET_ANALYTICS_CHARTS_REQUEST = 'GET_ANALYTICS_CHARTS_REQUEST';
var GET_ANALYTICS_CHARTS_FAILURE = 'GET_ANALYTICS_CHARTS_FAILURE';
var GET_ANALYTICS_CHARTS_SUCCESS = 'GET_ANALYTICS_CHARTS_SUCCESS';

var GET_ANALYTICS_MAIN_CHART_REQUEST = 'GET_ANALYTICS_MAIN_CHART_REQUEST';
var GET_ANALYTICS_MAIN_CHART_FAILURE = 'GET_ANALYTICS_MAIN_CHART_FAILURE';
var GET_ANALYTICS_MAIN_CHART_SUCCESS = 'GET_ANALYTICS_MAIN_CHART_SUCCESS';

var SET_ANALYTICS_MAIN_LEGEND = 'SET_ANALYTICS_MAIN_LEGEND';

var GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST = 'GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST';
var GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS = 'GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS';
var GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE = 'GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE';

var GET_ANALYTICS_CAMPAIGN_LIST_REQUEST = 'GET_ANALYTICS_CAMPAIGN_LIST_REQUEST';
var GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS = 'GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS';
var GET_ANALYTICS_CAMPAIGN_LIST_FAILURE = 'GET_ANALYTICS_CAMPAIGN_LIST_FAILURE';

var SET_ANALYTICS_LIVE_STREAM_STATS = 'SET_ANALYTICS_LIVE_STREAM_STATS';

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_CHANNELS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CHANNELS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CHANNELS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_CHANNEL_LINKS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_CHANNEL_LINKS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_CHANNEL_LINKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SELECTED_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_SELECTED_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return POLL_FACEBOOK_PAGES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return POLL_FACEBOOK_PAGES_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLEAR_ADD_FACEBOOK_CHANNEL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_FACEBOOK_PAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_FACEBOOK_PAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_FACEBOOK_PAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADD_FACEBOOK_PAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ADD_FACEBOOK_PAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ADD_FACEBOOK_PAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return POLL_INSTAGRAM_PAGES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return POLL_INSTAGRAM_PAGES_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CLEAR_ADD_INSTAGRAM_CHANNEL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_INSTAGRAM_PAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_INSTAGRAM_PAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_INSTAGRAM_PAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ADD_INSTAGRAM_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ADD_INSTAGRAM_CHANNEL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ADD_INSTAGRAM_PAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ADD_INSTAGRAM_PAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ADD_INSTAGRAM_PAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ADD_TWITTER_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ADD_TWITTER_CHANNEL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ADD_EMAIL_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ADD_EMAIL_CHANNEL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ADD_TIKTOK_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ADD_TIKTOK_CHANNEL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ADD_WECHAT_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ADD_WECHAT_CHANNEL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ADD_WHATSAPP_CHANNEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ADD_WHATSAPP_CHANNEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ADD_WHATSAPP_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_WHATSAPP_AUTH_CODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_WHATSAPP_AUTH_CODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_WHATSAPP_AUTH_CODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPDATE_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPDATE_CHANNEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UPDATE_CHANNEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_TIKTOK_CREATOR_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return GET_TIKTOK_CREATOR_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return GET_TIKTOK_CREATOR_INFO_FAILURE; });
var SET_CHANNELS = 'SET_CHANNELS';

var GET_CHANNELS_REQUEST = 'GET_CHANNELS_REQUEST';
var GET_CHANNELS_FAILURE = 'GET_CHANNELS_FAILURE';
var GET_CHANNELS_SUCCESS = 'GET_CHANNELS_SUCCESS';

var GET_CHANNEL_LINKS_REQUEST = 'GET_CHANNEL_LINKS_REQUEST';
var GET_CHANNEL_LINKS_FAILURE = 'GET_CHANNEL_LINKS_FAILURE';
var GET_CHANNEL_LINKS_SUCCESS = 'GET_CHANNEL_LINKS_SUCCESS';

var SET_SELECTED_CHANNELS = 'SET_SELECTED_CHANNELS';
var CLEAR_SELECTED_CHANNELS = 'CLEAR_SELECTED_CHANNELS';

var POLL_FACEBOOK_PAGES_START = 'POLL_FACEBOOK_PAGES_START';
var POLL_FACEBOOK_PAGES_STOP = 'POLL_FACEBOOK_PAGES_STOP';
var CLEAR_ADD_FACEBOOK_CHANNEL_STATE = 'CLEAR_ADD_FACEBOOK_CHANNEL_STATE';

var GET_FACEBOOK_PAGES_REQUEST = 'GET_FACEBOOK_PAGES_REQUEST';
var GET_FACEBOOK_PAGES_SUCCESS = 'GET_FACEBOOK_PAGES_SUCCESS';
var GET_FACEBOOK_PAGES_FAILURE = 'GET_FACEBOOK_PAGES_FAILURE';

var ADD_FACEBOOK_PAGE_REQUEST = 'ADD_FACEBOOK_PAGE_REQUEST';
var ADD_FACEBOOK_PAGE_SUCCESS = 'ADD_FACEBOOK_PAGE_SUCCESS';
var ADD_FACEBOOK_PAGE_FAILURE = 'ADD_FACEBOOK_PAGE_FAILURE';

var POLL_INSTAGRAM_PAGES_START = 'POLL_INSTAGRAM_PAGES_START';
var POLL_INSTAGRAM_PAGES_STOP = 'POLL_INSTAGRAM_PAGES_STOP';
var CLEAR_ADD_INSTAGRAM_CHANNEL_STATE = 'CLEAR_ADD_INSTAGRAM_CHANNEL_STATE';

var GET_INSTAGRAM_PAGES_REQUEST = 'GET_INSTAGRAM_PAGES_REQUEST';
var GET_INSTAGRAM_PAGES_SUCCESS = 'GET_INSTAGRAM_PAGES_SUCCESS';
var GET_INSTAGRAM_PAGES_FAILURE = 'GET_INSTAGRAM_PAGES_FAILURE';

var ADD_INSTAGRAM_CHANNEL_REQUEST = 'ADD_INSTAGRAM_CHANNEL_REQUEST';
var ADD_INSTAGRAM_CHANNEL_DONE = 'ADD_INSTAGRAM_CHANNEL_DONE';
var ADD_INSTAGRAM_PAGE_REQUEST = 'ADD_INSTAGRAM_PAGE_REQUEST';
var ADD_INSTAGRAM_PAGE_SUCCESS = 'ADD_INSTAGRAM_PAGE_SUCCESS';
var ADD_INSTAGRAM_PAGE_FAILURE = 'ADD_INSTAGRAM_PAGE_FAILURE';

var ADD_TWITTER_CHANNEL_REQUEST = 'ADD_TWITTER_CHANNEL_REQUEST';
var ADD_TWITTER_CHANNEL_DONE = 'ADD_TWITTER_CHANNEL_DONE';

var ADD_EMAIL_CHANNEL_REQUEST = 'ADD_EMAIL_CHANNEL_REQUEST';
var ADD_EMAIL_CHANNEL_DONE = 'ADD_EMAIL_CHANNEL_DONE';

var ADD_TIKTOK_CHANNEL_REQUEST = 'ADD_TIKTOK_CHANNEL_REQUEST';
var ADD_TIKTOK_CHANNEL_DONE = 'ADD_TIKTOK_CHANNEL_DONE';

var ADD_WECHAT_CHANNEL_REQUEST = 'ADD_WECHAT_CHANNEL_REQUEST';
var ADD_WECHAT_CHANNEL_DONE = 'ADD_WECHAT_CHANNEL_DONE';

var ADD_WHATSAPP_CHANNEL_SUCCESS = 'ADD_WHATSAPP_CHANNEL_SUCCESS';
var ADD_WHATSAPP_CHANNEL_FAILURE = 'ADD_WHATSAPP_CHANNEL_FAILURE';
var ADD_WHATSAPP_CHANNEL_REQUEST = 'ADD_WHATSAPP_CHANNEL_REQUEST';

var GET_WHATSAPP_AUTH_CODE_REQUEST = 'GET_WHATSAPP_AUTH_CODE_REQUEST';
var GET_WHATSAPP_AUTH_CODE_SUCCESS = 'GET_WHATSAPP_AUTH_CODE_SUCCESS';
var GET_WHATSAPP_AUTH_CODE_FAILURE = 'GET_WHATSAPP_AUTH_CODE_FAILURE';

var UPDATE_CHANNEL_REQUEST = 'UPDATE_CHANNEL_REQUEST';
var UPDATE_CHANNEL_SUCCESS = 'UPDATE_CHANNEL_SUCCESS';
var UPDATE_CHANNEL_FAILURE = 'UPDATE_CHANNEL_FAILURE';

var GET_TIKTOK_CREATOR_INFO_REQUEST = 'GET_TIKTOK_CREATOR_INFO_REQUEST';
var GET_TIKTOK_CREATOR_INFO_SUCCESS = 'GET_TIKTOK_CREATOR_INFO_SUCCESS';
var GET_TIKTOK_CREATOR_INFO_FAILURE = 'GET_TIKTOK_CREATOR_INFO_FAILURE';

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_PROFILES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_PROFILES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_PROFILES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_MORE_PROFILES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_PROFILE_FIELDS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_PROFILE_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELECT_PROFILES_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SHOW_PROFILES_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_PAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET_PAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_PROFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_PROFILES_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SHOW_DISPLAY_PROFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_IS_SEARCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_DEMOGRAPHIC_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_CAMPAIGN_SURVEY_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_PROFILES_FILTER_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_PROFILE_IDENTITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_PROFILE_IDENTITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_PROFILE_IDENTITY_SUCCESS; });
var GET_PROFILES_REQUEST = 'GET_PROFILES_REQUEST';
var GET_PROFILES_FAILURE = 'GET_PROFILES_FAILURE';
var GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS';
var LOAD_MORE_PROFILES_SUCCESS = 'LOAD_MORE_PROFILES_SUCCESS';

var GET_PROFILE_FIELDS_FAILURE = 'GET_PROFILE_FIELDS_FAILURE';
var GET_PROFILE_FIELDS_SUCCESS = 'GET_PROFILE_FIELDS_SUCCESS';

var SELECT_PROFILES_PROFILE = 'SELECT_PROFILES_PROFILE';
var SHOW_PROFILES_DIALOG = 'SHOW_PROFILES_DIALOG';

var SET_PAGE_COUNT = 'SET_PAGE_COUNT';
var RESET_PAGE_COUNT = 'RESET_PAGE_COUNT';
var RESET_PROFILES = 'RESET_PROFILES';

var SET_PROFILES_COUNT = 'SET_PROFILES_COUNT';
var SHOW_DISPLAY_PROFILES = 'SHOW_DISPLAY_PROFILES';
var SET_IS_SEARCHING = 'SET_IS_SEARCHING';
var SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
var SET_DEMOGRAPHIC_FILTERS = 'SET_DEMOGRAPHIC_FILTERS';
var SET_CAMPAIGN_SURVEY_FILTERS = 'SET_CAMPAIGN_SURVEY_FILTERS';
var SET_PROFILES_FILTER_FIELDS = 'SET_PROFILES_FILTER_FIELDS';

var GET_PROFILE_IDENTITY_REQUEST = 'GET_PROFILE_IDENTITY_REQUEST';
var GET_PROFILE_IDENTITY_FAILURE = 'GET_PROFILE_IDENTITY_FAILURE';
var GET_PROFILE_IDENTITY_SUCCESS = 'GET_PROFILE_IDENTITY_SUCCESS';

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function() { return $$iterator; });
/* harmony export (immutable) */ __webpack_exports__["isIterable"] = isIterable;
/* harmony export (immutable) */ __webpack_exports__["isArrayLike"] = isArrayLike;
/* harmony export (immutable) */ __webpack_exports__["isCollection"] = isCollection;
/* harmony export (immutable) */ __webpack_exports__["getIterator"] = getIterator;
/* harmony export (immutable) */ __webpack_exports__["getIteratorMethod"] = getIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createIterator"] = createIterator;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$asyncIterator", function() { return $$asyncIterator; });
/* harmony export (immutable) */ __webpack_exports__["isAsyncIterable"] = isAsyncIterable;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIterator"] = getAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIteratorMethod"] = getAsyncIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createAsyncIterator"] = createAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["forAwaitEach"] = forAwaitEach;
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */

/**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */

/**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */

// In ES2015 environments, Symbol exists
var SYMBOL /*: any */ = typeof Symbol === 'function' ? Symbol : void 0

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator

/**
 * A property name to be used as the name of an Iterable's method responsible
 * for producing an Iterator, referred to as `@@iterator`. Typically represents
 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
 * `Symbol.iterator` is not defined.
 *
 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
 * but do not use it for accessing existing Iterables, instead use
 * {@link getIterator} or {@link isIterable}.
 *
 * @example
 *
 * var $$iterator = require('iterall').$$iterator
 *
 * function Counter (to) {
 *   this.to = to
 * }
 *
 * Counter.prototype[$$iterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       if (this.num >= this.to) {
 *         return { value: undefined, done: true }
 *       }
 *       return { value: this.num++, done: false }
 *     }
 *   }
 * }
 *
 * var counter = new Counter(3)
 * for (var number of counter) {
 *   console.log(number) // 0 ... 1 ... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$iterator: '@@iterator'; */
var $$iterator = SYMBOL_ITERATOR || '@@iterator'

/**
 * Returns true if the provided object implements the Iterator protocol via
 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
 *
 * @example
 *
 * var isIterable = require('iterall').isIterable
 * isIterable([ 1, 2, 3 ]) // true
 * isIterable('ABC') // true
 * isIterable({ length: 1, 0: 'Alpha' }) // false
 * isIterable({ key: 'value' }) // false
 * isIterable(new Map()) // true
 *
 * @param obj
 *   A value which might implement the Iterable protocol.
 * @return {boolean} true if Iterable.
 */
/*:: declare export function isIterable(obj: any): boolean; */
function isIterable(obj) {
  return !!getIteratorMethod(obj)
}

/**
 * Returns true if the provided object implements the Array-like protocol via
 * defining a positive-integer `length` property.
 *
 * @example
 *
 * var isArrayLike = require('iterall').isArrayLike
 * isArrayLike([ 1, 2, 3 ]) // true
 * isArrayLike('ABC') // true
 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
 * isArrayLike({ key: 'value' }) // false
 * isArrayLike(new Map()) // false
 *
 * @param obj
 *   A value which might implement the Array-like protocol.
 * @return {boolean} true if Array-like.
 */
/*:: declare export function isArrayLike(obj: any): boolean; */
function isArrayLike(obj) {
  var length = obj != null && obj.length
  return typeof length === 'number' && length >= 0 && length % 1 === 0
}

/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and is either Iterable or Array-like.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if an
 * object should be iterated-over. It always excludes string literals and
 * includes Arrays (regardless of if it is Iterable). It also includes other
 * Array-like objects such as NodeList, TypedArray, and Buffer.
 *
 * @example
 *
 * var isCollection = require('iterall').isCollection
 * isCollection([ 1, 2, 3 ]) // true
 * isCollection('ABC') // false
 * isCollection({ length: 1, 0: 'Alpha' }) // true
 * isCollection({ key: 'value' }) // false
 * isCollection(new Map()) // true
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 * if (isCollection(obj)) {
 *   forEach(obj, function (value) {
 *     console.log(value)
 *   })
 * }
 *
 * @param obj
 *   An Object value which might implement the Iterable or Array-like protocols.
 * @return {boolean} true if Iterable or Array-like Object.
 */
/*:: declare export function isCollection(obj: any): boolean; */
function isCollection(obj) {
  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
}

/**
 * If the provided object implements the Iterator protocol, its Iterator object
 * is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getIterator = require('iterall').getIterator
 * var iterator = getIterator([ 1, 2, 3 ])
 * iterator.next() // { value: 1, done: false }
 * iterator.next() // { value: 2, done: false }
 * iterator.next() // { value: 3, done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which is the source of an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var getIterator:
  & (<+TValue>(iterable: Iterable<TValue>) => Iterator<TValue>)
  & ((iterable: mixed) => void | Iterator<mixed>); */
function getIterator(iterable) {
  var method = getIteratorMethod(iterable)
  if (method) {
    return method.call(iterable)
  }
}

/**
 * If the provided object implements the Iterator protocol, the method
 * responsible for producing its Iterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getIteratorMethod = require('iterall').getIteratorMethod
 * var myArray = [ 1, 2, 3 ]
 * var method = getIteratorMethod(myArray)
 * if (method) {
 *   var iterator = method.call(myArray)
 * }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which defines an `@@iterator` method.
 * @return {function(): Iterator<T>} `@@iterator` method.
 */
/*:: declare export var getIteratorMethod:
  & (<+TValue>(iterable: Iterable<TValue>) => (() => Iterator<TValue>))
  & ((iterable: mixed) => (void | (() => Iterator<mixed>))); */
function getIteratorMethod(iterable) {
  if (iterable != null) {
    var method =
      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getIterator}, this method returns a new Iterator given an
 * Iterable. However it will also create an Iterator for a non-Iterable
 * Array-like collection, such as Array in a non-ES2015 environment.
 *
 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
 * iteration as opposed to `forEach`'s "push"-based iteration.
 *
 * `createIterator` produces an Iterator for Array-likes with the same behavior
 * as ArrayIteratorPrototype described in the ECMAScript specification, and
 * does *not* skip over "holes".
 *
 * @example
 *
 * var createIterator = require('iterall').createIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createIterator(myArraylike)
 * iterator.next() // { value: 'Alpha', done: false }
 * iterator.next() // { value: 'Bravo', done: false }
 * iterator.next() // { value: 'Charlie', done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   An Iterable or Array-like object to produce an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var createIterator:
  & (<+TValue>(collection: Iterable<TValue>) => Iterator<TValue>)
  & ((collection: {length: number}) => Iterator<mixed>)
  & ((collection: mixed) => (void | Iterator<mixed>)); */
function createIterator(collection) {
  if (collection != null) {
    var iterator = getIterator(collection)
    if (iterator) {
      return iterator
    }
    if (isArrayLike(collection)) {
      return new ArrayLikeIterator(collection)
    }
  }
}

// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function ArrayLikeIterator(obj) {
  this._o = obj
  this._i = 0
}

// Note: all Iterators are themselves Iterable.
ArrayLikeIterator.prototype[$$iterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
ArrayLikeIterator.prototype.next = function() {
  if (this._o === void 0 || this._i >= this._o.length) {
    this._o = void 0
    return { value: void 0, done: true }
  }
  return { value: this._o[this._i++], done: false }
}

/**
 * Given an object which either implements the Iterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
 * However `forEach` adheres to the behavior of [Array#forEach][] described in
 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
 * also delegate to a `forEach` method on `collection` if one is defined,
 * ensuring native performance for `Arrays`.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * Note: providing an infinite Iterator to forEach will produce an error.
 *
 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 *
 * forEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES6:
 * for (let value of myIterable) {
 *   console.log(value)
 * }
 *
 * // Any JavaScript environment:
 * forEach(myIterable, function (value) {
 *   console.log(value)
 * })
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   The Iterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forEach:
  & (<+TValue, TCollection: Iterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void)
  & (<TCollection: {length: number}>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void); */
function forEach(collection, callback, thisArg) {
  if (collection != null) {
    if (typeof collection.forEach === 'function') {
      return collection.forEach(callback, thisArg)
    }
    var i = 0
    var iterator = getIterator(collection)
    if (iterator) {
      var step
      while (!(step = iterator.next()).done) {
        callback.call(thisArg, step.value, i++, collection)
        // Infinite Iterators could cause forEach to run forever.
        // After a very large number of iterations, produce an error.
        /* istanbul ignore if */
        if (i > 9999999) {
          throw new TypeError('Near-infinite iteration.')
        }
      }
    } else if (isArrayLike(collection)) {
      for (; i < collection.length; i++) {
        if (collection.hasOwnProperty(i)) {
          callback.call(thisArg, collection[i], i, collection)
        }
      }
    }
  }
}

/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////

/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */

/**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */

// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator

/**
 * A property name to be used as the name of an AsyncIterable's method
 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
 * Typically represents the value `Symbol.asyncIterator` but falls back to the
 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
 *
 * Use `$$asyncIterator` for defining new AsyncIterables instead of
 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
 * instead use {@link getAsyncIterator} or {@link isAsyncIterable}.
 *
 * @example
 *
 * var $$asyncIterator = require('iterall').$$asyncIterator
 *
 * function Chirper (to) {
 *   this.to = to
 * }
 *
 * Chirper.prototype[$$asyncIterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       return new Promise(resolve => {
 *         if (this.num >= this.to) {
 *           resolve({ value: undefined, done: true })
 *         } else {
 *           setTimeout(() => {
 *             resolve({ value: this.num++, done: false })
 *           }, 1000)
 *         }
 *       })
 *     }
 *   }
 * }
 *
 * var chirper = new Chirper(3)
 * for await (var number of chirper) {
 *   console.log(number) // 0 ...wait... 1 ...wait... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$asyncIterator: '@@asyncIterator'; */
var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 *
 * @example
 *
 * var isAsyncIterable = require('iterall').isAsyncIterable
 * isAsyncIterable(myStream) // true
 * isAsyncIterable('ABC') // false
 *
 * @param obj
 *   A value which might implement the AsyncIterable protocol.
 * @return {boolean} true if AsyncIterable.
 */
/*:: declare export function isAsyncIterable(obj: any): boolean; */
function isAsyncIterable(obj) {
  return !!getAsyncIteratorMethod(obj)
}

/**
 * If the provided object implements the AsyncIterator protocol, its
 * AsyncIterator object is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getAsyncIterator = require('iterall').getAsyncIterator
 * var asyncIterator = getAsyncIterator(myStream)
 * asyncIterator.next().then(console.log) // { value: 1, done: false }
 * asyncIterator.next().then(console.log) // { value: 2, done: false }
 * asyncIterator.next().then(console.log) // { value: 3, done: false }
 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which is the source of an AsyncIterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var getAsyncIterator:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => AsyncIterator<TValue>)
  & ((asyncIterable: mixed) => (void | AsyncIterator<mixed>)); */
function getAsyncIterator(asyncIterable) {
  var method = getAsyncIteratorMethod(asyncIterable)
  if (method) {
    return method.call(asyncIterable)
  }
}

/**
 * If the provided object implements the AsyncIterator protocol, the method
 * responsible for producing its AsyncIterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
 * var method = getAsyncIteratorMethod(myStream)
 * if (method) {
 *   var asyncIterator = method.call(myStream)
 * }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which defines an `@@asyncIterator` method.
 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
 */
/*:: declare export var getAsyncIteratorMethod:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => (() => AsyncIterator<TValue>))
  & ((asyncIterable: mixed) => (void | (() => AsyncIterator<mixed>))); */
function getAsyncIteratorMethod(asyncIterable) {
  if (asyncIterable != null) {
    var method =
      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
      asyncIterable['@@asyncIterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getAsyncIterator}, this method returns a new AsyncIterator
 * given an AsyncIterable. However it will also create an AsyncIterator for a
 * non-async Iterable as well as non-Iterable Array-like collection, such as
 * Array in a pre-ES2015 environment.
 *
 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
 * "push"-based iteration.
 *
 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
 *
 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var createAsyncIterator = require('iterall').createAsyncIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createAsyncIterator(myArraylike)
 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
 * iterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var createAsyncIterator:
  & (<+TValue>(
      collection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>
    ) => AsyncIterator<TValue>)
  & ((collection: {length: number}) => AsyncIterator<mixed>)
  & ((collection: mixed) => (void | AsyncIterator<mixed>)); */
function createAsyncIterator(source) {
  if (source != null) {
    var asyncIterator = getAsyncIterator(source)
    if (asyncIterator) {
      return asyncIterator
    }
    var iterator = createIterator(source)
    if (iterator) {
      return new AsyncFromSyncIterator(iterator)
    }
  }
}

// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function AsyncFromSyncIterator(iterator) {
  this._i = iterator
}

// Note: all AsyncIterators are themselves AsyncIterable.
AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
AsyncFromSyncIterator.prototype.next = function() {
  var step = this._i.next()
  return Promise.resolve(step.value).then(function(value) {
    return { value: value, done: step.done }
  })
}

/**
 * Given an object which either implements the AsyncIterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forAwaitEach` where you would expect to use a [for-await-of](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements) loop.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var forAwaitEach = require('iterall').forAwaitEach
 *
 * forAwaitEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES2017:
 * for await (let value of myAsyncIterable) {
 *   console.log(await doSomethingAsync(value))
 * }
 * console.log('done')
 *
 * // Any JavaScript environment:
 * forAwaitEach(myAsyncIterable, function (value) {
 *   return doSomethingAsync(value).then(console.log)
 * }).then(function () {
 *   console.log('done')
 * })
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
 *   The AsyncIterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forAwaitEach:
  & (<+TValue, TCollection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>)
  & (<TCollection: { length: number }>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>); */
function forAwaitEach(source, callback, thisArg) {
  var asyncIterator = createAsyncIterator(source)
  if (asyncIterator) {
    var i = 0
    return new Promise(function(resolve, reject) {
      function next() {
        asyncIterator
          .next()
          .then(function(step) {
            if (!step.done) {
              Promise.resolve(callback.call(thisArg, step.value, i++, source))
                .then(next)
                .catch(reject)
            } else {
              resolve()
            }
            // Explicitly return null, silencing bluebird-style warnings.
            return null
          })
          .catch(reject)
        // Explicitly return null, silencing bluebird-style warnings.
        return null
      }
      next()
    })
  }
}


/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2543)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1370),
  /* template */
  __webpack_require__(3403),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da0b145a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1375),
  /* template */
  __webpack_require__(3398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1393),
  /* template */
  __webpack_require__(3134),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2370)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(3161),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b3470a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var client = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
client.defaults.baseURL = "https://api.live.colonyhq.com/";

// Interceptors makes mocking our tests very difficult, lets
// ignore them within tests.
if (true) {
  client.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    var requestConfig = config;
    if (token) {
      requestConfig.headers.Authorization = 'JWT ' + token;
    }
    return requestConfig;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  client.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // Handle when a token has expired
    if (error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.assign('/login');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}
/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return channelTypes; });
/* unused harmony export activityTypes */
var channelTypes = {
  SMS: 0,
  MMS_EMAIL: 1,
  TWITTER: 2,
  FB: 3,
  FACEBOOK: 3,
  GPLUS: 4,
  MIXIT: 5,
  WE_CHAT: 6,
  WEB_HOOK: 7,
  USSD: 8,
  WHATSAPP: 9,
  INSTAGRAM: 10,
  CELLFIND: 11,
  TELEGRAM: 12,
  WHATSAPPWEB: 13,
  DMS: 15,
  INFOBIP: 16,
  MTECH: 17,
  SMS_TRUMPIA: 18,
  SURVEY: 19,
  'DATA IMPORT': 20,
  BUMBLEBEE: 21,
  TIKTOK: 22
};

var activityTypes = {
  NOTE_TYPE: 0,
  PERCENT_TYPE: 1
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseProviderName; });
/* eslint import/prefer-default-export: "off" */
var parseProviderName = function parseProviderName(name) {
  return name.split('_').map(function (el) {
    return el.charAt(0).toUpperCase() + el.substring(1);
  }).join(' ');
};



/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1301),
  /* template */
  __webpack_require__(3227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1306),
  /* template */
  __webpack_require__(3309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1378),
  /* template */
  __webpack_require__(3207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1391),
  /* template */
  __webpack_require__(3174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fed23a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2403)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1552),
  /* template */
  __webpack_require__(3210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-334a6464",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2449)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1571),
  /* template */
  __webpack_require__(3277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f404b2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SEGMENT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SEGMENT_LABELS; });
/* unused harmony export SEGMENT_COLOURS */
/* unused harmony export SEGMENT_ICONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSegmentLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSegmentColour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSegmentIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCategoryColour; });
/* unused harmony export getCategoryExplanation */
/* unused harmony export IDENTIFIER_ICONS */
/* unused harmony export IDENTIFIER_LABELS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getIdentifierIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getIdentifierLabel; });
/* unused harmony export CHURN_RISK_COLOURS */
/* unused harmony export getChurnColour */
/* unused harmony export CHANNEL_NAMES */
/* unused harmony export CHANNEL_SOCIAL_ICON_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getChannelName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getChannelIconType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toPromoteField; });
/* unused harmony export DEMOGRAPHIC_COLOURS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getDemographicColours; });
/* unused harmony export CREDITS_EXHAUSTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCreditsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return featureLimitMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return formatRecency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return formatNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return formatPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return formatLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return recencyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return highlightInsightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNotFoundError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isLoadableImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LISTENERS_PER_PAGE; });
/* unused harmony export PAGES_PER_FETCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LISTENER_FETCH_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return tagInterests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return summariseSimilar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);




/**
 * Segmentation utility — labels, colours, icons, formatters.
 * Import from this file throughout all segmentation components.
 *
 * Sections in this file:
 *   1. Segments (order, labels, colours, icons)
 *   2. Segment categories (New / High Engagement / Active / Re-engagement)
 *   3. Identifiers (linked identifiers display)
 *   4. Churn risk
 *   5. Channels
 *   6. Demographic promotion (inferred -> declared field mapping)
 *   7. Demographic charts
 *   8. AI credits
 *   9. Formatters
 *   10. AI insights
 *   11. Misc
 */

// ============================================================
// 1. Segments
// ============================================================

/** Canonical segment order for display — most valuable to least active. */
var SEGMENT_ORDER = ['new_listener', 'super_fan', 'show_loyalist', 'competition_chaser', 'occasional_engager', 'at_risk', 'dormant'];

/** Human-readable label for each segment key. */
var SEGMENT_LABELS = {
  new_listener: 'New Listener',
  super_fan: 'Super Fan',
  show_loyalist: 'Show Loyalist',
  competition_chaser: 'Competition Chaser',
  occasional_engager: 'Occasional Engager',
  at_risk: 'At Risk',
  dormant: 'Dormant'
};

/** Colony brand colour per segment. */
var SEGMENT_COLOURS = {
  new_listener: 'rgb(45, 147, 207)',
  super_fan: 'rgb(104, 48, 144)',
  show_loyalist: 'rgb(20, 179, 147)',
  competition_chaser: 'rgb(242, 148, 33)',
  occasional_engager: 'rgb(52, 191, 194)',
  at_risk: 'rgb(238, 36, 101)',
  dormant: 'rgb(180, 180, 180)'
};

/** Font Awesome icon class per segment. */
var SEGMENT_ICONS = {
  new_listener: 'fa-star-o',
  super_fan: 'fa-star',
  show_loyalist: 'fa-headphones',
  competition_chaser: 'fa-trophy',
  occasional_engager: 'fa-hand-o-right',
  at_risk: 'fa-exclamation-triangle',
  dormant: 'fa-moon-o'
};

/**
 * @param {string} key
 * @returns {string}  human-readable label for a segment key
 */
var getSegmentLabel = function getSegmentLabel(key) {
  return SEGMENT_LABELS[key] || key;
};

/**
 * @param {string} key
 * @returns {string}  Colony brand colour for a segment key
 */
var getSegmentColour = function getSegmentColour(key) {
  return SEGMENT_COLOURS[key] || 'rgb(180,180,180)';
};

/**
 * @param {string} key
 * @returns {string}  Font Awesome icon class for a segment key
 */
var getSegmentIcon = function getSegmentIcon(key) {
  return SEGMENT_ICONS[key] || 'fa-users';
};

// ============================================================
// 2. Segment categories (New / High Engagement / Active / Re-engagement)
// ============================================================

/**
 * Colony brand colour per segment category.
 * Used for the "New", "High Engagement", "Active", and "Re-engagement" cards.
 */
var CATEGORY_COLOURS = {
  New: 'rgb(45, 147, 207)',
  'High Engagement': 'rgb(20, 179, 147)',
  Active: 'rgb(242, 148, 33)',
  'Re-engagement': 'rgb(238, 36, 101)'
};

/** Brief explanation shown in the category badge tooltip. */
var CATEGORY_EXPLANATIONS = {
  New: 'Recently joined — still building an engagement profile',
  'High Engagement': 'Your most valuable, consistently active listeners',
  Active: 'Engaged, but without a strong or predictable pattern',
  'Re-engagement': 'Declining or inactive — needs attention to win back'
};

/**
 * @param {string} category
 * @returns {string}
 */
var getCategoryColour = function getCategoryColour(category) {
  return CATEGORY_COLOURS[category] || 'rgb(153,153,153)';
};

/**
 * @param {string} category
 * @returns {string}
 */
var getCategoryExplanation = function getCategoryExplanation(category) {
  return CATEGORY_EXPLANATIONS[category] || '';
};

// ============================================================
// 3. Identifiers (linked identifiers display)
// ============================================================

/** Font Awesome icon class per identifier key. */
var IDENTIFIER_ICONS = {
  mobile_number: 'fa-mobile',
  email: 'fa-envelope-o',
  instagram_handle: 'fa-instagram',
  facebook_handle: 'fa-facebook',
  twitter_handle: 'fa-twitter',
  x_handle: 'fa-twitter',
  telegram_handle: 'fa-telegram',
  whatsapp_handle: 'fa-whatsapp',
  threads_handle: 'fa-at',
  social_handle: 'fa-at',
  id_number: 'fa-id-card-o'
};

/** Human-readable label for each identifier key. */
var IDENTIFIER_LABELS = {
  mobile_number: 'Mobile',
  email: 'Email',
  instagram_handle: 'Instagram',
  facebook_handle: 'Facebook',
  twitter_handle: 'Twitter',
  x_handle: 'X',
  telegram_handle: 'Telegram',
  whatsapp_handle: 'WhatsApp',
  threads_handle: 'Threads',
  social_handle: 'Social handle',
  id_number: 'ID number'
};

/**
 * @param {string} type
 * @returns {string}  Font Awesome icon class for an identifier key
 */
var getIdentifierIcon = function getIdentifierIcon(type) {
  return IDENTIFIER_ICONS[type] || 'fa-link';
};

/**
 * @param {string} type
 * @returns {string}  human-readable label for an identifier key
 */
var getIdentifierLabel = function getIdentifierLabel(type) {
  return IDENTIFIER_LABELS[type] || type;
};

// ============================================================
// 4. Churn risk
// ============================================================

/** Colony brand colour per churn risk level. */
var CHURN_RISK_COLOURS = {
  low: 'rgb(20, 179, 147)',
  medium: 'rgb(242, 148, 33)',
  high: 'rgb(238, 36, 101)'
};

/**
 * @param {string} risk
 * @returns {string}  Colony brand colour for a churn risk level
 */
var getChurnColour = function getChurnColour(risk) {
  return CHURN_RISK_COLOURS[risk] || '#ccc';
};

// ============================================================
// 5. Channels
// ============================================================

/**
 * Display name per channel type integer.
 * Matches primary_channel_type values stored in MongoDB.
 */
var CHANNEL_NAMES = {
  0: 'SMS',
  1: 'Email',
  2: 'Twitter',
  3: 'Facebook',
  8: 'USSD',
  9: 'WhatsApp',
  10: 'Instagram',
  12: 'Telegram',
  19: 'Survey',
  20: 'Import',
  22: 'TikTok'
};

/**
 * SocialIcon component type string per channel type integer.
 * Used with <social-icon :type="..." /> throughout the dashboard.
 */
var CHANNEL_SOCIAL_ICON_TYPE = {
  0: 'SMS',
  1: 'Email',
  2: 'Twitter',
  3: 'Facebook',
  8: 'USSD',
  9: 'WhatsApp',
  10: 'Instagram',
  12: 'Telegram',
  19: 'Survey',
  20: 'Import',
  22: 'TikTok'
};

/**
 * @param {number} type
 * @returns {string}  display name for a channel type integer
 */
var getChannelName = function getChannelName(type) {
  return CHANNEL_NAMES[type] || 'Channel ' + type;
};

/**
 * @param {number} type
 * @returns {string}  SocialIcon type string for a channel type integer
 */
var getChannelIconType = function getChannelIconType(type) {
  return CHANNEL_SOCIAL_ICON_TYPE[type] || 'SMS';
};

// ============================================================
// 6. Demographic promotion (inferred -> declared field mapping)
// ============================================================

/**
 * Maps a camelCase inferred-field name (as used in Vue, e.g. in
 * ListenerDialogAI's inferredRows) to the snake_case name the
 * promote-demographics backend expects.
 */
var DEMOGRAPHIC_FIELD_MAP = {
  gender: 'gender',
  ageGroup: 'age_group',
  location: 'location',
  language: 'language',
  ethnicity: 'ethnicity',
  incomeBracket: 'income_bracket',
  education: 'education',
  employmentStatus: 'employment_status',
  maritalStatus: 'marital_status',
  occupation: 'occupation',
  lifeStage: 'life_stage'
};

/**
 * Converts a camelCase inferred-field name to the snake_case name the
 * promote-demographics backend expects. Falls back to the field name
 * unchanged if it isn't in the map, so a typo or new unregistered
 * field still reaches the backend (which will reject it with a clear
 * error) rather than silently sending undefined.
 *
 * @param {string|null} field  camelCase field name, or null for bulk promote
 * @returns {string|null}      snake_case field name, or null unchanged
 */
var toPromoteField = function toPromoteField(field) {
  if (!field) {
    return null;
  }
  return DEMOGRAPHIC_FIELD_MAP[field] || field;
};

// ============================================================
// 7. Demographic charts
// ============================================================

/**
 * Ordered colour palette for demographic charts (gender, age, language, location).
 * Last entry (grey) is reserved for the "Other" bucket.
 */
var DEMOGRAPHIC_COLOURS = ['rgb(104,48,144)', 'rgb(45,147,207)', 'rgb(20,179,147)', 'rgb(242,148,33)', 'rgb(238,36,101)', 'rgb(52,191,194)', 'rgb(180,180,180)'];

/**
 * Picks a colour for one demographic key by index.
 * "Other", "other", or empty keys always get the grey fallback.
 *
 * @param {string} k
 * @param {number} i
 * @returns {string}
 */
var colourForKey = function colourForKey(k, i) {
  if (k === 'Other' || k === 'other' || !k) {
    return 'rgb(180,180,180)';
  }
  return DEMOGRAPHIC_COLOURS[i % (DEMOGRAPHIC_COLOURS.length - 1)];
};

/**
 * Maps an array of demographic keys to colours.
 *
 * @param {string[]} keys
 * @returns {string[]}
 */
var getDemographicColours = function getDemographicColours(keys) {
  return keys.map(function (k, i) {
    return colourForKey(k, i);
  });
};

// ============================================================
// 8. AI credits
// ============================================================

/** Error code returned when AI credits are exhausted. */
var CREDITS_EXHAUSTED = 'credits_exhausted';

/**
 * @param {Error} e  an Apollo error from a failed AI mutation/query
 * @returns {boolean}  true if the failure was specifically credits exhaustion
 */
var isCreditsError = function isCreditsError(e) {
  var gqlErrors = e && e.graphQLErrors || [];
  return gqlErrors.some(function (err) {
    return err.message === CREDITS_EXHAUSTED || err.extensions && err.extensions.code === CREDITS_EXHAUSTED;
  });
};

/**
 * The service's own message when a part of the product has used its monthly
 * limit (for example "Monthly limit reached for Bulk enrichment (500
 * credits). It resets on the 1st."), or '' for any other error.
 *
 * Note: Only that one part is blocked, so this is not a credits error and
 * the rest of AI keeps working.
 *
 * @param {Error} e  an Apollo error from a failed AI mutation/query
 * @returns {string}
 */
var featureLimitMessage = function featureLimitMessage(e) {
  var gqlErrors = e && e.graphQLErrors || [];
  var hit = gqlErrors.find(function (err) {
    return (/^Monthly limit reached/.test(err.message || '')
    );
  });
  return hit ? hit.message : '';
};

// ============================================================
// 9. Formatters
// ============================================================

/**
 * Formats a recency value (days since last interaction) as a human-readable string.
 * e.g. 0 -> 'Today', 1 -> 'Yesterday', 5 -> '5d ago', 14 -> '2w ago'
 *
 * @param {number|null} days
 * @returns {string}
 */
var formatRecency = function formatRecency(days) {
  if (days === null || days === undefined) return '—';
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return days + 'd ago';
  if (days < 30) return Math.floor(days / 7) + 'w ago';
  if (days < 365) return Math.floor(days / 30) + 'mo ago';
  return Math.floor(days / 365) + 'y ago';
};

/**
 * Formats a number for compact display.
 * e.g. 1500 -> '1.5K', 2300000 -> '2.3M', 0 -> '0'
 *
 * @param {number|null} n
 * @returns {string}
 */
var formatNumber = function formatNumber(n) {
  if (!n && n !== 0) return '—';
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
  return n.toLocaleString();
};

/**
 * Share of a total as text without the % sign. A group that has members
 * never reads as 0: below 0.01% it shows "<0.01".
 * @param {number} count
 * @param {number} total
 * @returns {string}
 */
var formatPercent = function formatPercent(count, total) {
  if (!total || !count) {
    return '0';
  }
  var pct = count / total * 100;
  if (pct < 0.01) {
    return '<0.01';
  }
  if (pct < 1) {
    return pct.toFixed(2);
  }
  return pct < 10 ? pct.toFixed(1) : pct.toFixed(0);
};

/**
 * Capitalises the first letter of each word in a snake_case or lowercase string.
 * e.g. 'drive_time' -> 'Drive Time', 'afternoon' -> 'Afternoon'
 *
 * @param {string|null} val
 * @returns {string}
 */
var formatLabel = function formatLabel(val) {
  if (!val) {
    return '—';
  }
  return val.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });
};

/**
 * Returns a CSS class for colouring recency values.
 * Green (navy) for recent, orange for moderate, red for stale.
 *
 * @param {number} days
 * @returns {string}
 */
var recencyClass = function recencyClass(days) {
  if (days <= 7) return 'text-navy';
  if (days <= 30) return 'text-warning';
  if (days <= 60) return 'text-warning';
  return 'text-danger';
};

// ============================================================
// 10. AI insights
// ============================================================

/**
 * Highlights numbers and known channel names in AI-generated text,
 * wrapping them in <strong> so key facts stand out visually without
 * relying on the LLM to format its own output consistently.
 *
 * @param {string} text
 * @returns {string}
 */
var highlightInsightText = function highlightInsightText(text) {
  if (!text) {
    return text;
  }

  var result = text;

  // Numbers (including decimals, commas as thousand separators, %)
  result = result.replace(/\b\d{1,3}(,\d{3})*(\.\d+)?%?\b/g, function (match) {
    return '<strong>' + match + '</strong>';
  });

  // Known channel names
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(CHANNEL_NAMES).forEach(function (channel) {
    var re = new RegExp('\\b' + channel + '\\b', 'g');
    result = result.replace(re, '<strong>' + channel + '</strong>');
  });

  return result;
};

// ============================================================
// 11. Misc
// ============================================================

/**
 * Picks a value from an object trying snake_case first, then camelCase.
 * Falls back to fallback (default '—') if neither key exists.
 * Useful for normalising API responses that may return either casing.
 *
 * @param {Object} obj
 * @param {string} snake   e.g. 'best_time'
 * @param {string} camel   e.g. 'bestTime'
 * @param {*}      fallback
 * @returns {*}
 */
var pick = function pick(obj, snake, camel, fallback) {
  return obj[snake] || obj[camel] || (fallback !== undefined ? fallback : '—');
};

// ============================================================
// 12. Profile images
// ============================================================

/**
 * True when a GraphQL error is the segmentation service saying the
 * listener has no profile under that identifier (for example a Facebook
 * listener whose "originator" is a display name rather than an account id).
 * @param {Error} e
 * @returns {boolean}
 */
var isNotFoundError = function isNotFoundError(e) {
  var gqlErrors = e && e.graphQLErrors || [];
  return gqlErrors.some(function (err) {
    return (/not found/i.test(err.message || '')
    );
  });
};

/**
 * True when a stored profile image value is worth handing to the browser.
 * Profile image URLs come from social platforms and are never guaranteed to
 * still resolve (CDN URLs expire, accounts change), so the component also
 * handles the load failing — this only filters out values that can never
 * load, avoiding a pointless request and the error flash that follows.
 *
 * @param {*} value  listener.profileImage
 * @returns {boolean}
 */
var isLoadableImageUrl = function isLoadableImageUrl(value) {
  return typeof value === 'string' && /^https?:\/\/\S+$/i.test(value.trim());
};

// ============================================================
// 13. Listener paging
// ============================================================

/** Listener cards shown per page in the browser. */
var LISTENERS_PER_PAGE = 12;

/** UI pages' worth of listeners fetched from the API in one request. */
var PAGES_PER_FETCH = 8;

/**
 * Listeners requested per API call. A whole multiple of LISTENERS_PER_PAGE,
 * so every fetched batch fills complete pages — a batch that ended mid-page
 * showed a short page that silently grew when the next batch arrived.
 */
var LISTENER_FETCH_SIZE = LISTENERS_PER_PAGE * PAGES_PER_FETCH;

// ============================================================
// 14. Similar listeners — what the matches have in common
// ============================================================

var lower = function lower(value) {
  return String(value).trim().toLowerCase();
};

/**
 * Splits one match's interests into the ones it shares with the reference
 * listener (shown first, highlighted) and the rest.
 * @param {string[]} interests  the match's inferred interests
 * @param {string[]} reference  the reference listener's inferred interests
 * @returns {{label: string, shared: boolean}[]}
 */
var tagInterests = function tagInterests(interests, reference) {
  var own = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a((reference || []).map(lower));
  var tagged = (interests || []).filter(Boolean).map(function (label) {
    return {
      label: label,
      shared: own.has(lower(label))
    };
  });
  return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(tagged.filter(function (t) {
    return t.shared;
  })), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(tagged.filter(function (t) {
    return !t.shared;
  })));
};

/**
 * Counts how many of the matches carry each value (interests, location,
 * age group, gender, segment), most common first. `enriched` is how many
 * matches have interests at all, so "3 of 4" is not mistaken for "3 of 20".
 * @param {Object[]} matches  similar listeners from the API
 * @param {number} top        how many values to keep per list
 */
var summariseSimilar = function summariseSimilar(matches) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var list = matches || [];

  var count = function count(select) {
    var tally = {};
    list.forEach(function (m) {
      var values = [].concat(select(m) || []);
      // a listener counts once per value, however often it is repeated
      new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(values.filter(Boolean).map(function (v) {
        return String(v).trim();
      })).forEach(function (v) {
        var key = lower(v);
        tally[key] = tally[key] || { label: v, count: 0 };
        tally[key].count += 1;
      });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(tally).sort(function (a, b) {
      return b.count - a.count || a.label.localeCompare(b.label);
    }).slice(0, top).map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { pct: Math.round(item.count / list.length * 100) });
    });
  };

  return {
    total: list.length,
    enriched: list.filter(function (m) {
      return (m.inferred_interests || []).length > 0;
    }).length,
    interests: count(function (m) {
      return m.inferred_interests;
    }),
    locations: count(function (m) {
      return m.location;
    }),
    ageGroups: count(function (m) {
      return m.age_group || m.inferred_age_group;
    }),
    genders: count(function (m) {
      return m.gender || m.inferred_gender;
    }),
    segments: count(function (m) {
      return m.current_segment;
    })
  };
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOreValue; });
/* unused harmony export getOreValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processInteraction; });
/* unused harmony export processOriginator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nl2br; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeHyperlinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return makeHashtags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeMentions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* eslint import/prefer-default-export: "off" */


/**
 * Get a single value from interaction ore.
 * @param {Array} interaction
 * @param {String} key
 * @param {*} defaultVal
 */
var getOreValue = function getOreValue(interaction, key) {
  var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
    return interaction.ore[key][0] && interaction.ore[key][0].value || defaultVal;
  }
  return defaultVal;
};

/**
 * Get multiple values from interaction ore.
 * @param {Array} interaction
 * @param {String} key
 */
var getOreValues = function getOreValues(interaction, key) {
  if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
    return interaction.ore[key] || [];
  }
  return [];
};

/**
 * Get a prettier format for our originator if available.
 * @param {String} originator
 * @param {String} channelType
 */
var processOriginator = function processOriginator(originator, channelType) {
  switch (channelType) {
    case 'whatsapp':
      return originator.match(/^([0-9]+)/) ? originator.match(/^([0-9]+)/)[1] : originator;
    default:
      return originator;
  }
};

/**
 * Process interaction data into a much simpler form.
 * @param {Array} interaction
 */
var processInteraction = function processInteraction(interaction) {
  // Search api from django gives us date_created, absinthe on elixir dateCreated
  var dateCreated = interaction.dateCreated || interaction.date_created;

  return {
    id: interaction.id,
    threadId: interaction.threadId,
    originator: processOriginator(getOreValue(interaction, 'originators'), interaction.type),
    originatorType: getOreValues(interaction, 'originators')[0].type,
    datetime: __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateCreated),
    channel: interaction.type,
    displayName: getOreValue(interaction, 'display_name')[0] || '',
    message: getOreValue(interaction, 'message'),
    avatar: getOreValue(interaction, 'profile_image', null),
    images: getOreValues(interaction, 'image').map(function (img) {
      return img.value;
    }),
    audio: getOreValues(interaction, 'audio').map(function (aud) {
      return aud.value;
    }),
    audioTranscript: getOreValues(interaction, 'audio').map(function (aud) {
      return aud.additional;
    }),
    video: getOreValues(interaction, 'video').map(function (vid) {
      return vid.value;
    }),
    document: getOreValues(interaction, 'application').map(function (doc) {
      return doc.value;
    }),
    text: getOreValues(interaction, 'text').map(function (txt) {
      return txt.value;
    }),
    replies: getOreValues(interaction, 'reply'),
    comments: getOreValues(interaction, 'comment'),
    sentiment: getOreValue(interaction, 'sentiment'),
    inCount: interaction.inCount,
    outCount: interaction.outCount,
    sentBy: interaction.sentBy || '',
    onAirId: interaction.onAirId || null,
    parent: interaction.parent || null
  };
};

var nl2br = function nl2br(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
};

var makeHyperlinks = function makeHyperlinks(str) {
  var regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/g;
  return str.replace(regex, function (match, $1) {
    return '<a href="' + $1 + '" target="_blank">' + $1 + '</a>';
  });
};

var makeHashtags = function makeHashtags(str) {
  var regex = /\B(#[0-9a-zA-Z]+\b)/g;
  return str.replace(regex, function (match, $1) {
    return '<span class="hashtag">' + $1 + '</span>';
  });
};

var makeMentions = function makeMentions(str) {
  var regex = /\B(@[0-9a-zA-Z_]+\b)/g;
  return str.replace(regex, function (match, $1) {
    return '<span class="mention">' + $1 + '</span>';
  });
};



/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_absinthe_upload_link__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_cache_inmemory__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link_context__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_phoenix__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_phoenix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_phoenix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_link__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__absinthe_socket_apollo_link__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jumpn_utils_graphql__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__absinthe_socket__ = __webpack_require__(305);










var middlewareLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_apollo_link_context__["a" /* setContext */])(function () {
  return {
    headers: {
      authorization: 'JWT ' + localStorage.getItem('token')
    }
  };
});

var v2HttpLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_apollo_absinthe_upload_link__["a" /* createLink */])({ uri: "https://apiv2.live.colonyhq.com/graphql" });

var absintheSocketLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__absinthe_socket_apollo_link__["a" /* createAbsintheSocketLink */])(__WEBPACK_IMPORTED_MODULE_8__absinthe_socket__["a" /* create */](new __WEBPACK_IMPORTED_MODULE_4_phoenix__["Socket"]("wss://apiv2.live.colonyhq.com/socket", {
  reconnect: true,
  params: { token: localStorage.getItem('token') }
})));

var v2LinkWithSubscriptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_apollo_link__["a" /* split */])(function (operation) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__jumpn_utils_graphql__["a" /* hasSubscription */])(operation.query);
}, absintheSocketLink, middlewareLink.concat(v2HttpLink));

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["a" /* ApolloClient */]({
  link: v2LinkWithSubscriptions,
  cache: new __WEBPACK_IMPORTED_MODULE_2_apollo_cache_inmemory__["a" /* InMemoryCache */]({ addTypename: false }),
  connectToDevTools: true
}));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chartMixin__ = __webpack_require__(162);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__chartMixin__["a" /* default */]],
  props: {
    barPercentage: {
      type: Number,
      default: 1
    },
    categoryPercentage: {
      type: Number,
      default: 0.7
    },
    showXAxes: {
      type: Boolean,
      default: true
    },
    showYAxes: {
      type: Boolean,
      default: true
    },
    showGridLines: {
      type: Boolean,
      default: false
    },
    stacked: {
      type: Boolean,
      default: false
    },
    autoSkipX: {
      type: Boolean,
      default: false
    },
    minXRotation: {
      type: Number,
      default: 0
    },
    maxXRotation: {
      type: Number,
      default: 360
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tooltipsEnabled: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    getChartData: function getChartData() {
      var _this = this;

      var chartDatasets = [{
        backgroundColor: this.data.map(function (s, i) {
          return _this.getColor(s[0], i);
        }),
        data: this.data.map(function (s) {
          return s[1];
        })
      }];

      // Determine if we're using multiple datasets
      // allows us to send in data as:
      // [
      //   ['SABC', {'revenue': 12233, 'count': 1222}],
      //   ['FirstRand Bank Ltd', {'revenue': 45433, 'count': 4552}]
      // ]
      if (this.data.length && this.data[0][1] instanceof Object) {
        // Get our data split into different sets based on their keys
        var sets = {};
        this.data.forEach(function (data) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data[1]).forEach(function (key) {
            if (!(key in sets)) {
              sets[key] = [];
            }
            sets[key].push(data[1][key]);
          });
        });

        // Now build the actual chart data
        chartDatasets = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sets).map(function (key) {
          return {
            label: key,
            backgroundColor: _this.generateTitleColor(key),
            data: sets[key]
          };
        });
      }

      var chartData = {
        labels: this.data.map(function (s) {
          return s[0];
        }),
        datasets: chartDatasets
      };

      return chartData;
    },
    getChartOptions: function getChartOptions() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: this.showGridLines
            },
            display: this.showXAxes,
            barPercentage: this.barPercentage,
            categoryPercentage: this.categoryPercentage,
            stacked: this.stacked,
            ticks: {
              autoSkip: this.autoSkipX,
              maxRotation: this.maxXRotation,
              minRotation: this.minXRotation,
              beginAtZero: true
            }
          }],
          yAxes: [{
            display: this.showYAxes,
            stacked: this.stacked,
            ticks: {
              beginAtZero: true
            }
          }]
        },
        animation: {
          duration: this.animationDuration,
          onComplete: function onComplete(event) {
            if (_this2.animationComplete !== undefined) {
              _this2.animationComplete(event);
            }
          }
        },
        onClick: function onClick(event, item) {
          return _this2.$emit('onClick', [event, item]);
        }
      }, this.options);
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countryCodes_json__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countryCodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__countryCodes_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getCountryByCode: function getCountryByCode(countryCode) {
      return __WEBPACK_IMPORTED_MODULE_0__countryCodes_json___default.a.filter(function (country) {
        return country.code === countryCode;
      })[0];
    },
    getCountryFromPhoneNumber: function getCountryFromPhoneNumber(number) {
      var filter = number[0] === '+' ? number : '+' + number;
      return __WEBPACK_IMPORTED_MODULE_0__countryCodes_json___default.a.filter(function (country) {
        return filter.startsWith(country.dial_code);
      })[0];
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProfileItemValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return profileCampaignDateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDataItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPrimaryIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProfileIdenticon; });
/* unused harmony export findWordInStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAgeFromYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getColourCode; });
/* unused harmony export orderAgeProfiles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jdenticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var getProfileItemValue = function getProfileItemValue(item) {
  return Array.isArray(item) ? item[0] : item;
};
var profileCampaignDateFormat = function profileCampaignDateFormat(text) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(text).format('DD/MM/YYYY');
};
var getDataItem = function getDataItem(profile, profileSection, property) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var currentProfile = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(profile);
  var dataItem = defaultValue;
  if (currentProfile && currentProfile[profileSection] && property in currentProfile[profileSection]) {
    var sortedIdentifiers = __WEBPACK_IMPORTED_MODULE_4_collect_js___default()(currentProfile[profileSection][property]).sortBy('score').toArray();

    if (sortedIdentifiers.length) {
      dataItem = sortedIdentifiers[0].value;
    }
  }

  return getProfileItemValue(dataItem);
};

var getPrimaryIdentifier = function getPrimaryIdentifier(profile) {
  var identifiers = [['identifiers', 'facebook_profile'], ['identifiers', 'twitter_handle'], ['identifiers', 'email_address'], ['identifiers', 'wechat_handle'], ['identifiers', 'instagram_handle'], ['identifiers', 'telegram'], ['identifiers', 'mobile_number'], ['identifiers', 'cellfind_handle'], ['identifiers', 'whatsapp_handle']];

  var primaries = identifiers.reduce(function (acc, ident) {
    var value = getDataItem(profile, ident[0], ident[1], null);
    if (value) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc), [value]);
    }
    return acc;
  }, []);

  if (!primaries.length) {
    return 'Unknown';
  }
  return primaries[0];
};

var getProfileIdenticon = function getProfileIdenticon(profile) {
  var identifier = getPrimaryIdentifier(profile);
  var identiconToBase64 = btoa(__WEBPACK_IMPORTED_MODULE_3_jdenticon___default.a.toSvg(identifier, 128));
  return 'data:image/svg+xml;base64,' + identiconToBase64;
};

var findWordInStr = function findWordInStr(word, str) {
  if (str === undefined) return 'other';
  var regex = new RegExp('' + word);
  var lowerCaseStr = str.toLowerCase();

  if (regex.exec(lowerCaseStr) !== null) {
    return word;
  }
  return 'other';
};
var getAgeFromYear = function getAgeFromYear(ageIndex) {
  var value = ageIndex.value;

  var birthYear = new Date(value).getFullYear();
  var currentYear = new Date(Date.now()).getFullYear();
  return Number(currentYear - birthYear);
};
var getColourCode = function getColourCode(score, discoveredBy) {
  var key = 'other';

  var hue = (score * 120).toString(10);

  var colourMap = {
    surveys: 'hsla(300, 100%, 25%, 0.4)',
    other: 'hsl(' + hue + ', 50%, 70%)'
  };

  var activeDataFields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(colourMap);
  for (var i = 0; i < activeDataFields.length; i += 1) {
    if (activeDataFields[i] === findWordInStr(activeDataFields[i], discoveredBy)) {
      key = activeDataFields[i];
      break;
    }
  }
  return colourMap[key];
};

var orderAgeProfiles = function orderAgeProfiles(ageProfiles) {
  var ageRanges = ['Under 18', '18-24', '25-34', '35-49', '50-64', '65+'];
  var orderedRanges = [];
  ageRanges.forEach(function (ageRangeKey) {
    var ageProfile = ageProfiles.find(function (c) {
      return c.ageBracket === ageRangeKey;
    });
    if (ageProfile) {
      orderedRanges.push(ageProfile);
    }
  });
  return orderedRanges;
};
// export const defaultProfileImg = '/static/assets/icons/user/default_profile_normal.png';

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return destructDate; });
/* unused harmony export getLastMonth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return friendlyDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var getLastMonth = function getLastMonth() {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'month');
};

var destructDate = function destructDate(date) {
  return {
    year: date.format('YYYY'),
    month: date.format('MM'),
    week: date.format('WW'),
    day: date.format('DD'),
    hour: date.format('HH')
  };
};

var friendlyDate = function friendlyDate(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'll';
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).locale(locale).format(format);
};
// eslint-disable-next-line import/prefer-default-export


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hueRangeDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return satRangeDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return litRangeDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return surveyHueRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return respondentsHueRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return heatmapLegendColors; });
var hueRangeDefault = [185, 340];
var satRangeDefault = [0.6, 0.9];
var litRangeDefault = [0.2, 0.7];
var surveyHueRange = [260, 290];
var respondentsHueRange = [260, 360];
var heatmapLegendColors = ['#bbacc7', '#583079'];

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_AFSTEREO_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUBTRACT_AFSTEREO_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_AFSTEREO_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_AFSTEREO_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_AFSTEREO_STATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_AFSTEREO_CHARTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_AFSTEREO_CHARTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_AFSTEREO_CHARTS_SUCCESS; });
/* unused harmony export GET_AFSTEREO_MAIN_CHART_REQUEST */
/* unused harmony export GET_AFSTEREO_MAIN_CHART_FAILURE */
/* unused harmony export GET_AFSTEREO_MAIN_CHART_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_AFSTEREO_STATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_AFSTEREO_STATIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_AFSTEREO_STATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_AFSTEREO_STATIONS_AREA; });
var ADD_AFSTEREO_DATE = 'ADD_AFSTEREO_DATE';
var SUBTRACT_AFSTEREO_DATE = 'SUBTRACT_AFSTEREO_DATE';

var SET_AFSTEREO_DATE = 'SET_AFSTEREO_DATE';
var SET_AFSTEREO_PERIOD = 'SET_AFSTEREO_PERIOD';
var SET_AFSTEREO_STATION = 'SET_AFSTEREO_STATION';

var GET_AFSTEREO_CHARTS_REQUEST = 'GET_AFSTEREO_CHARTS_REQUEST';
var GET_AFSTEREO_CHARTS_FAILURE = 'GET_AFSTEREO_CHARTS_FAILURE';
var GET_AFSTEREO_CHARTS_SUCCESS = 'GET_AFSTEREO_CHARTS_SUCCESS';

var GET_AFSTEREO_MAIN_CHART_REQUEST = 'GET_AFSTEREO_MAIN_CHART_REQUEST';
var GET_AFSTEREO_MAIN_CHART_FAILURE = 'GET_AFSTEREO_MAIN_CHART_FAILURE';
var GET_AFSTEREO_MAIN_CHART_SUCCESS = 'GET_AFSTEREO_MAIN_CHART_SUCCESS';

var GET_AFSTEREO_STATIONS_REQUEST = 'GET_AFSTEREO_STATIONS_REQUEST';
var GET_AFSTEREO_STATIONS_FAILURE = 'GET_AFSTEREO_STATIONS_FAILURE';
var GET_AFSTEREO_STATIONS_SUCCESS = 'GET_AFSTEREO_STATIONS_SUCCESS';

var RESET_AFSTEREO_STATIONS_AREA = 'RESET_AFSTEREO_STATIONS_AREA';

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_STAFF_ALERTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_STAFF_ALERTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_STAFF_ALERTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_STAFF_ALERT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_STAFF_ALERT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_STAFF_ALERT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_NEXT_STAFF_ALERT; });
var GET_STAFF_ALERTS_REQUEST = 'GET_STAFF_ALERTS_REQUEST';
var GET_STAFF_ALERTS_SUCCESS = 'GET_STAFF_ALERTS_SUCCESS';
var GET_STAFF_ALERTS_FAILURE = 'GET_STAFF_ALERTS_FAILURE';

var UPDATE_STAFF_ALERT_REQUEST = 'UPDATE_STAFF_ALERT_REQUEST';
var UPDATE_STAFF_ALERT_SUCCESS = 'UPDATE_STAFF_ALERT_SUCCESS';
var UPDATE_STAFF_ALERT_FAILURE = 'UPDATE_STAFF_ALERT_FAILURE';

var GET_NEXT_STAFF_ALERT = 'GET_NEXT_STAFF_ALERT';

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PASSWORD_RESET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PASSWORD_RESET_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PASSWORD_RESET_SUCCESS; });
var LOGIN_REQUEST = 'LOGIN_REQUEST';
var LOGIN_FAILURE = 'LOGIN_FAILURE';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

var LOGOUT_REQUEST = 'LOGOUT_REQUEST';

var PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
var PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
var PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CAMPAIGNS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_CAMPAIGNS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_CAMPAIGNS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_CAMPAIGN_DETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_CAMPAIGN_DETAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_CAMPAIGN_DETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CAMPAIGN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CAMPAIGN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CAMPAIGN_SUCCESS; });
/* unused harmony export GET_CAMPAIGN_MESSAGES_REQUEST */
/* unused harmony export GET_CAMPAIGN_MESSAGES_FAILURE */
/* unused harmony export GET_CAMPAIGN_MESSAGES_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_CAMPAIGN_MESSAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_CAMPAIGN_MESSAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_CAMPAIGN_MESSAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREATE_RANDOM_SELECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CREATE_RANDOM_SELECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CREATE_RANDOM_SELECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_REPLY_MESSAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_REPLY_MESSAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_REPLY_MESSAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_RANDOM_SELECTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_RANDOM_SELECTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_RANDOM_SELECTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_RANDOM_SELECTIONS_WINNER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_RANDOM_SELECTIONS_WINNER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_RANDOM_SELECTIONS_WINNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_CAMPAIGN_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_CAMPAIGN_PAGE; });
var GET_CAMPAIGNS_REQUEST = 'GET_CAMPAIGNS_REQUEST';
var GET_CAMPAIGNS_FAILURE = 'GET_CAMPAIGNS_FAILURE';
var GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';

var GET_CAMPAIGN_DETAIL_REQUEST = 'GET_CAMPAIGN_DETAIL_REQUEST';
var GET_CAMPAIGN_DETAIL_FAILURE = 'GET_CAMPAIGN_DETAIL_FAILURE';
var GET_CAMPAIGN_DETAIL_SUCCESS = 'GET_CAMPAIGN_DETAIL_SUCCESS';

var CREATE_CAMPAIGN_REQUEST = 'CREATE_CAMPAIGN_REQUEST';
var CREATE_CAMPAIGN_FAILURE = 'CREATE_CAMPAIGN_FAILURE';
var CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';

var GET_CAMPAIGN_MESSAGES_REQUEST = 'GET_CAMPAIGN_MESSAGES_REQUEST';
var GET_CAMPAIGN_MESSAGES_FAILURE = 'GET_CAMPAIGN_MESSAGES_FAILURE';
var GET_CAMPAIGN_MESSAGES_SUCCESS = 'GET_CAMPAIGN_MESSAGES_SUCCESS';

var CREATE_CAMPAIGN_MESSAGES_REQUEST = 'GET_CAMPAIGN_MESSAGES_REQUEST';
var CREATE_CAMPAIGN_MESSAGES_FAILURE = 'GET_CAMPAIGN_MESSAGES_FAILURE';
var CREATE_CAMPAIGN_MESSAGES_SUCCESS = 'GET_CAMPAIGN_MESSAGES_SUCCESS';

var CREATE_RANDOM_SELECTION_REQUEST = 'CREATE_RANDOM_SELECTION_REQUEST';
var CREATE_RANDOM_SELECTION_FAILURE = 'CREATE_RANDOM_SELECTION_FAILURE';
var CREATE_RANDOM_SELECTION_SUCCESS = 'CREATE_RANDOM_SELECTION_SUCCESS';

var GET_REPLY_MESSAGES_REQUEST = 'GET_REPLY_MESSAGES_REQUEST';
var GET_REPLY_MESSAGES_FAILURE = 'GET_REPLY_MESSAGES_FAILURE';
var GET_REPLY_MESSAGES_SUCCESS = 'GET_REPLY_MESSAGES_SUCCESS';

var GET_RANDOM_SELECTIONS_REQUEST = 'GET_RANDOM_SELECTIONS_REQUEST';
var GET_RANDOM_SELECTIONS_FAILURE = 'GET_RANDOM_SELECTIONS_FAILURE';
var GET_RANDOM_SELECTIONS_SUCCESS = 'GET_RANDOM_SELECTIONS_SUCCESS';

var SET_RANDOM_SELECTIONS_WINNER_REQUEST = 'SET_RANDOM_SELECTIONS_WINNER_REQUEST';
var SET_RANDOM_SELECTIONS_WINNER_FAILURE = 'SET_RANDOM_SELECTIONS_WINNER_FAILURE';
var SET_RANDOM_SELECTIONS_WINNER_SUCCESS = 'SET_RANDOM_SELECTIONS_WINNER_FAILURE';

var SET_CAMPAIGN_FILTERS = 'SET_CAMPAIGN_FILTERS';
var SET_CAMPAIGN_PAGE = 'SET_CAMPAIGN_PAGE';

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_SOCIAL_POST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_SOCIAL_POST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_SOCIAL_POST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EDITING_SOCIAL_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATING_SOCIAL_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_SCHEDULED_MESSAGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_SCHEDULED_MESSAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SCHEDULED_MESSAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_SCHEDULED_MESSAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SCHEDULED_MESSAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_SCHEDULED_MESSAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SCHEDULED_MESSAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_SCHEDULED_MESSAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_SCHEDULED_MESSAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_SELECTED_FACEBOOK_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_SELECTED_INSTAGRAM_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_FACEBOOK_PAGES; });
var CREATE_SOCIAL_POST_REQUEST = 'CREATE_SOCIAL_POST_REQUEST';
var CREATE_SOCIAL_POST_SUCCESS = 'CREATE_SOCIAL_POST_SUCCESS';
var CREATE_SOCIAL_POST_FAILURE = 'CREATE_SOCIAL_POST_FAILURE';

var EDITING_SOCIAL_POST = 'EDITING_SOCIAL_POST';
var CREATING_SOCIAL_POST = 'CREATING_SOCIAL_POST';

var GET_SCHEDULED_MESSAGES_REQUEST = 'GET_SCHEDULED_MESSAGES_REQUEST';
var GET_SCHEDULED_MESSAGES_SUCCESS = 'GET_SCHEDULED_MESSAGES_SUCCESS';
var GET_SCHEDULED_MESSAGES_FAILURE = 'GET_SCHEDULED_MESSAGES_FAILURE';

var DELETE_SCHEDULED_MESSAGE_REQUEST = 'DELETE_SCHEDULED_MESSAGE_REQUEST';
var DELETE_SCHEDULED_MESSAGE_SUCCESS = 'DELETE_SCHEDULED_MESSAGE_SUCCESS';
var DELETE_SCHEDULED_MESSAGE_FAILURE = 'DELETE_SCHEDULED_MESSAGE_FAILURE';

var UPDATE_SCHEDULED_MESSAGE_REQUEST = 'UPDATE_SCHEDULED_MESSAGE_REQUEST';
var UPDATE_SCHEDULED_MESSAGE_SUCCESS = 'UPDATE_SCHEDULED_MESSAGE_SUCCESS';
var UPDATE_SCHEDULED_MESSAGE_FAILURE = 'UPDATE_SCHEDULED_MESSAGE_FAILURE';

var SET_SELECTED_FACEBOOK_PAGE = 'SET_SELECTED_FACEBOOK_PAGE';
var SET_SELECTED_INSTAGRAM_PAGE = 'SET_SELECTED_INSTAGRAM_PAGE';
var SET_FACEBOOK_PAGES = 'SET_FACEBOOK_PAGES';

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_STATION_ACTIVITY_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_STATION_ACTIVITY_REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_STATION_ACTIVITY_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_STATION_ACTIVITY_END_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_STATION_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_STATION_ACTIVITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_STATION_ACTIVITY_FAILURE; });
var SET_STATION_ACTIVITY_OFFSET = 'SET_STATION_ACTIVITY_OFFSET';
var SET_STATION_ACTIVITY_REGION = 'SET_STATION_ACTIVITY_REGION';
var SET_STATION_ACTIVITY_START_DATE = 'SET_STATION_ACTIVITY_START_DATE';
var SET_STATION_ACTIVITY_END_DATE = 'SET_STATION_ACTIVITY_END_DATE';

var GET_STATION_ACTIVITY = 'GET_STATION_ACTIVITY';
var GET_STATION_ACTIVITY_SUCCESS = 'GET_STATION_ACTIVITY_SUCCESS';
var GET_STATION_ACTIVITY_FAILURE = 'GET_STATION_ACTIVITY_FAILURE';

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SURVEYS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SURVEYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SURVEYS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_SURVEY_CHARTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SURVEY_CHARTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_SURVEY_CHARTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLEAR_SURVEY_CHARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_PERIODS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_PERIODS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_PERIODS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_SPOT_CHARTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_SPOT_CHARTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_SPOT_CHARTS_FAILURE; });
/* unused harmony export CLEAR_SPOT_CHARTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_SPOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREATE_SPOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CREATE_SPOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_SURVEY_DEMOGRAPHICS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_SURVEY_DEMOGRAPHICS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_SURVEY_DEMOGRAPHICS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_SURVEY_RESPONDENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_SURVEY_RESPONDENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_SURVEY_RESPONDENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLEAR_SURVEY_RESPONDENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_SURVEY_ANSWER_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_SURVEY_ANSWER_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_SURVEY_ANSWER_GROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DOWNLOAD_SURVEY_RESPONSES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DOWNLOAD_SURVEY_RESPONSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DOWNLOAD_SURVEY_RESPONSES_FAILURE; });
var GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST';
var GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
var GET_SURVEYS_FAILURE = 'GET_SURVEYS_FAILURE';

var GET_SURVEY_CHARTS_REQUEST = 'GET_SURVEY_CHARTS_REQUEST';
var GET_SURVEY_CHARTS_SUCCESS = 'GET_SURVEY_CHARTS_SUCCESS';
var GET_SURVEY_CHARTS_FAILURE = 'GET_SURVEY_CHARTS_FAILURE';
var CLEAR_SURVEY_CHARTS = 'CLEAR_SURVEY_CHARTS';

var GET_PERIODS_REQUEST = 'GET_PERIODS_REQUEST';
var GET_PERIODS_SUCCESS = 'GET_PERIODS_SUCCESS';
var GET_PERIODS_FAILURE = 'GET_PERIODS_FAILURE';

var GET_SPOT_CHARTS_REQUEST = 'GET_SPOT_CHARTS_REQUEST';
var GET_SPOT_CHARTS_SUCCESS = 'GET_SPOT_CHARTS_SUCCESS';
var GET_SPOT_CHARTS_FAILURE = 'GET_SPOT_CHARTS_FAILURE';
var CLEAR_SPOT_CHARTS = 'CLEAR_SPOT_CHARTS';

var CREATE_SPOT_REQUEST = 'CREATE_SPOT_REQUEST';
var CREATE_SPOT_SUCCESS = 'CREATE_SPOT_SUCCESS';
var CREATE_SPOT_FAILURE = 'CREATE_SPOT_FAILURE';

var GET_SURVEY_DEMOGRAPHICS_REQUEST = 'GET_SURVEY_DEMOGRAPHICS_REQUEST';
var GET_SURVEY_DEMOGRAPHICS_SUCCESS = 'GET_SURVEY_DEMOGRAPHICS_SUCCESS';
var GET_SURVEY_DEMOGRAPHICS_FAILURE = 'GET_SURVEY_DEMOGRAPHICS_FAILURE';

var GET_SURVEY_RESPONDENTS_REQUEST = 'GET_SURVEY_RESPONDENTS_REQUEST';
var GET_SURVEY_RESPONDENTS_SUCCESS = 'GET_SURVEY_RESPONDENTS_SUCCESS';
var GET_SURVEY_RESPONDENTS_FAILURE = 'GET_SURVEY_RESPONDENTS_FAILURE';
var CLEAR_SURVEY_RESPONDENTS = 'CLEAR_SURVEY_RESPONDENTS';

var GET_SURVEY_ANSWER_GROUPS_REQUEST = 'GET_SURVEY_ANSWER_GROUPS_REQUEST';
var GET_SURVEY_ANSWER_GROUPS_SUCCESS = 'GET_SURVEY_ANSWER_GROUPS_SUCCESS';
var GET_SURVEY_ANSWER_GROUPS_FAILURE = 'GET_SURVEY_ANSWER_GROUPS_FAILURE';

var DOWNLOAD_SURVEY_RESPONSES_REQUEST = 'DOWNLOAD_SURVEY_RESPONSES_REQUEST';
var DOWNLOAD_SURVEY_RESPONSES_SUCCESS = 'DOWNLOAD_SURVEY_RESPONSES_SUCCESS';
var DOWNLOAD_SURVEY_RESPONSES_FAILURE = 'DOWNLOAD_SURVEY_RESPONSES_FAILURE';

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_TIMESLOTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EDIT_TIMESLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_TIMESLOT_FAILURE; });
var GET_TIMESLOTS_REQUEST = 'GET_TIMESLOTS_REQUEST';
var GET_TIMESLOT_SUCCESS = 'GET_TIMESLOT_SUCCESS';
var GET_TIMESLOT_FAILURE = 'GET_TIMESLOT_FAILURE';

var EDIT_TIMESLOT = 'EDIT_TIMESLOT';
var SAVE_TIMESLOT_REQUEST = 'SAVE_TIMESLOT_REQUEST';
var SAVE_TIMESLOT_SUCCESS = 'SAVE_TIMESLOT_SUCCESS';
var SAVE_TIMESLOT_FAILURE = 'SAVE_TIMESLOT_FAILURE';

var DELETE_TIMESLOT_REQUEST = 'DELETE_TIMESLOT_REQUEST';
var DELETE_TIMESLOT_SUCCESS = 'DELETE_TIMESLOT_SUCCESS';
var DELETE_TIMESLOT_FAILURE = 'DELETE_TIMESLOT_FAILURE';

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_TOAST; });
var SEND_TOAST = 'SEND_TOAST';
var RESET_TOAST = 'RESET_TOAST';

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ME_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ME_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_GROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_USER_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_USER_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_USER_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_COMPANY_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_COMPANY_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_COMPANY_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_COMPANY_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_COMPANY_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_COMPANY_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_USER_LOCALE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_USER_LOCALE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_USER_LOCALE_FAILURE; });
/* unused harmony export UPDATE_USER_PASSWORD_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_USER_PASSWORD_SUCCESS; });
/* unused harmony export UPDATE_USER_PASSWORD_FAILURE */
var GET_ME_REQUEST = 'GET_ME_REQUEST';
var GET_ME_FAILURE = 'GET_ME_FAILURE';
var GET_ME_SUCCESS = 'GET_ME_SUCCESS';

var GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
var GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';
var GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';

var UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST';
var UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
var UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';

var GET_COMPANY_USERS_REQUEST = 'GET_COMPANY_USERS_REQUEST';
var GET_COMPANY_USERS_FAILURE = 'GET_COMPANY_USERS_FAILURE';
var GET_COMPANY_USERS_SUCCESS = 'GET_COMPANY_USERS_SUCCESS';

var UPDATE_COMPANY_USER_REQUEST = 'UPDATE_COMPANY_USER_REQUEST';
var UPDATE_COMPANY_USER_SUCCESS = 'UPDATE_COMPANY_USER_SUCCESS';
var UPDATE_COMPANY_USER_FAILURE = 'UPDATE_COMPANY_USER_FAILURE';

var UPDATE_USER_LOCALE_REQUEST = 'UPDATE_USER_LOCALE_REQUEST';
var UPDATE_USER_LOCALE_SUCCESS = 'UPDATE_USER_LOCALE_SUCCESS';
var UPDATE_USER_LOCALE_FAILURE = 'UPDATE_USER_LOCALE_FAILURE';

var UPDATE_USER_PASSWORD_REQUEST = 'UPDATE_USER_PASSWORD_REQUEST';
var UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS';
var UPDATE_USER_PASSWORD_FAILURE = 'UPDATE_USER_PASSWORD_FAILURE';

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_WHATSAPP_QRCODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_WHATSAPP_QRCODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_WHATSAPP_QRCODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_WHATSAPP_QRCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_WHATSAPP_CHANNEL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_WHATSAPP_CHANNEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_WHATSAPP_CHANNEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_WHATSAPP_CHANNEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return POLL_WHATSAPP_SET_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return POLL_WHATSAPP_CHANNEL_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return POLL_WHATSAPP_CHANNEL_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return POLL_WHATSAPP_CHANNEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return POLL_WHATSAPP_CHANNEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return POLL_WHATSAPP_CHANNEL_RESET; });
var REQUEST_WHATSAPP_QRCODE_REQUEST = 'REQUEST_WHATSAPP_QRCODE_REQUEST';
var REQUEST_WHATSAPP_QRCODE_SUCCESS = 'REQUEST_WHATSAPP_QRCODE_SUCCESS';
var REQUEST_WHATSAPP_QRCODE_FAILURE = 'REQUEST_WHATSAPP_QRCODE_FAILURE';

var RESET_WHATSAPP_QRCODE = 'RESET_WHATSAPP_QRCODE';
var RESET_WHATSAPP_CHANNEL_ID = 'RESET_WHATSAPP_CHANNEL_ID';

var CREATE_WHATSAPP_CHANNEL_REQUEST = 'CREATE_WHATSAPP_CHANNEL_REQUEST';
var CREATE_WHATSAPP_CHANNEL_SUCCESS = 'CREATE_WHATSAPP_CHANNEL_SUCCESS';
var CREATE_WHATSAPP_CHANNEL_FAILURE = 'CREATE_WHATSAPP_CHANNEL_FAILED';

var POLL_WHATSAPP_SET_CHANNEL = 'POLL_WHATSAPP_SET_CHANNEL';
var POLL_WHATSAPP_CHANNEL_START = 'POLL_WHATSAPP_CHANNEL_START';
var POLL_WHATSAPP_CHANNEL_STOP = 'POLL_WHATSAPP_CHANNEL_STOP';
var POLL_WHATSAPP_CHANNEL_SUCCESS = 'POLL_WHATSAPP_CHANNEL_SUCCESS';
var POLL_WHATSAPP_CHANNEL_FAILURE = 'POLL_WHATSAPP_CHANNEL_FAILURE';
var POLL_WHATSAPP_CHANNEL_RESET = 'POLL_WHATSAPP_CHANNEL_RESET';

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2559)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1295),
  /* template */
  __webpack_require__(3423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2394)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1324),
  /* template */
  __webpack_require__(3198),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cf69cdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2550)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1361),
  /* template */
  __webpack_require__(3413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e82df8fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1363),
  /* template */
  __webpack_require__(3270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2535)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1364),
  /* template */
  __webpack_require__(3394),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb4c0656",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2398)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1365),
  /* template */
  __webpack_require__(3202),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f24308a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1368),
  /* template */
  __webpack_require__(3119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03cc1ac0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2458)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1388),
  /* template */
  __webpack_require__(3286),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-552257f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1397),
  /* template */
  __webpack_require__(3171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f7d6484",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2438)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1398),
  /* template */
  __webpack_require__(3261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4782f266",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2494)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1400),
  /* template */
  __webpack_require__(3329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70731958",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1402),
  /* template */
  __webpack_require__(3181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22a64a8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2527)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1405),
  /* template */
  __webpack_require__(3381),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b13c54be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2545)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1407),
  /* template */
  __webpack_require__(3405),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dec46556",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1411),
  /* template */
  __webpack_require__(3185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-250e3532",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2452)
  __webpack_require__(2453)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1449),
  /* template */
  __webpack_require__(3280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5029eb48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2554)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1474),
  /* template */
  __webpack_require__(3418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb1d42ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      '], ['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      ']);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showFacebookCreateDialog: false,
      showInstagramCreateDialog: false,
      showEmailCreateDialog: false,
      showWechatCreateDialog: false,
      showWhatsAppWebCreateDialog: false,
      showTelegramCreateDialog: false,
      channelTypeConfig: {
        facebook: { icon: 'fa-facebook', color: '#4767aa', title: 'Facebook', alwaysShow: true },
        twitter: { icon: 'fa-twitter', color: '#1da1f2', title: 'Twitter', alwaysShow: true },
        instagram: { icon: 'fa-instagram', color: '#ed1f65', title: 'Instagram', alwaysShow: true },
        // whatsapp: { icon: 'fa-whatsapp', color: '#0fa251', title: 'WhatsApp' },
        telegram: { icon: 'fa-telegram', color: '#1da1f2', title: 'Telegram', alwaysShow: true },
        email: {
          icon: 'fa-envelope',
          color: '#1da1f2',
          title: 'E-Mail',
          method: 'Email',
          alwaysShow: true
        },
        gmail: {
          icon: 'fa-google',
          color: '#5b0a91',
          title: 'Colony E-Mail',
          method: 'ColonyEmail',
          alwaysShow: false
        },
        tiktok: {
          icon: 'fa-play-circle',
          color: '#000101',
          title: 'TikTok',
          method: 'TikTok',
          alwaysShow: false
        }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('user', ['me'])),

  apollo: {
    channelList: {
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject)
    }
  },

  methods: {
    refetchChannelList: function refetchChannelList() {
      this.$apollo.queries.channelList.refetch();
      this.createChannelPrompt();
    },
    handleFacebookVisibilityChange: function handleFacebookVisibilityChange(value) {
      this.showFacebookCreateDialog = value;
    },
    handleInstagramVisibilityChange: function handleInstagramVisibilityChange(value) {
      this.showInstagramCreateDialog = value;
    },
    handleEmailDialogVisibilityChange: function handleEmailDialogVisibilityChange(value) {
      this.showEmailCreateDialog = value;
    },
    handleCellfindDialogVisibilityChange: function handleCellfindDialogVisibilityChange(value) {
      this.showCellfindCreateDialog = value;
    },
    handleWechatDialogVisibilityChange: function handleWechatDialogVisibilityChange(value) {
      this.showWechatCreateDialog = value;
    },
    handleWhatsappWebDialogVisibilityChange: function handleWhatsappWebDialogVisibilityChange(value) {
      this.showWhatsAppWebCreateDialog = value;
    },
    handleTelegramDialogVisibilityChange: function handleTelegramDialogVisibilityChange(value) {
      this.showTelegramCreateDialog = value;
    },
    createChannelPrompt: function createChannelPrompt() {
      var _this = this;

      this.$confirm('Would you like to create a campaign for this new channel?', 'Create Campaign', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(function () {
        _this.$router.push({ path: 'campaigns', query: { create: true } });
      });
    },
    connectTwitter: function connectTwitter() {
      this.$store.dispatch('channel/addTwitterChannel', this.me.id);
    },
    connectFacebook: function connectFacebook() {
      this.showFacebookCreateDialog = true;
    },
    connectTelegram: function connectTelegram() {
      this.showTelegramCreateDialog = true;
    },
    connectInstagram: function connectInstagram() {
      this.showInstagramCreateDialog = true;
    },
    connectWhatsApp: function connectWhatsApp() {
      this.showWhatsAppWebCreateDialog = true;
    },
    connectWeChat: function connectWeChat() {
      this.showWechatCreateDialog = true;
    },
    connectEmail: function connectEmail() {
      this.showEmailCreateDialog = true;
    },
    connectColonyEmail: function connectColonyEmail() {
      window.open("https://email.live.colonyhq.com/auth-email", '_blank');
    },
    connectTikTok: function connectTikTok() {
      this.$store.dispatch('channel/addTikTokChannel', this.me.id);
    },
    connectChannel: function connectChannel(channelType) {
      var methodName = 'connect' + channelType;
      this[methodName]();
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_profile_mutation_types__ = __webpack_require__(193);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      updatedProfileMap: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('profile', ['selectedProfile', 'profileDialogVisible'])),

  methods: {
    getProfileId: function getProfileId(profile) {
      // eslint-disable-next-line
      if (profile._id) return profile._id.$oid || profile._id;
      return profile.id;
    },
    handleProfileUpdated: function handleProfileUpdated(profile) {
      this.$set(this.updatedProfileMap, profile.id, profile);
    },
    handleProfileDialogVisibilityChanged: function handleProfileDialogVisibilityChanged(value) {
      if (!value) {
        this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_profile_mutation_types__["f" /* SELECT_PROFILES_PROFILE */], null);
      }
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], value);
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBase64FileObj; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var getBase64FileObj = function getBase64FileObj(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve({
        filesize: file.size,
        filetype: file.type,
        filename: file.name,
        base64: reader.result.slice(reader.result.indexOf(',') + 1)
      });
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

// eslint-disable-next-line


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRandomNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pickOne; });
/* unused harmony export getDataForLabels */
var getRandomNumber = function getRandomNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var pickOne = function pickOne(arr) {
  return arr[getRandomNumber(0, arr.length - 1)];
};

// Generates Random chart data for labels passed in
var getDataForLabels = function getDataForLabels(labels) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  return labels.map(function (x) {
    return [x, getRandomNumber(min, max)];
  });
};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    addEmptyAction: function addEmptyAction() {
      this.rule.actions.push({
        data: {},
        fields: {},
        key: null
      });
    },
    handleClose: function handleClose() {
      this.rule = {
        title: null,
        events: null,
        campaign: 1,
        actions: [],
        conditions: []
      };
      this.$emit('close');
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* unused harmony export SET_PAGE_TITLE */
/* unused harmony export SET_PAGE_BREADCRUMBS */
/* unused harmony export SET_PAGE_HEADER_ENABLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_FULLSCREEN; });
var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
var SET_PAGE_TITLE = 'SET_PAGE_TITLE';
var SET_PAGE_BREADCRUMBS = 'SET_PAGE_BREADCRUMBS';
var SET_PAGE_HEADER_ENABLED = 'SET_PAGE_HEADER_ENABLED';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ACTIVITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ACTIVITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ACTIVITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_ACTIVITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_ACTIVITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_ACTIVITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STOP_ACTIVITY_POLLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return START_ACTIVITY_POLLING; });
var GET_ACTIVITIES_REQUEST = 'GET_ACTIVITIES_REQUEST';
var GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
var GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE';

var DELETE_ACTIVITY_REQUEST = 'DELETE_ACTIVITY_REQUEST';
var DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
var DELETE_ACTIVITY_FAILURE = 'DELETE_ACTIVITY_FAILURE';

var STOP_ACTIVITY_POLLING = 'STOP_ACTIVITY_POLLING';
var START_ACTIVITY_POLLING = 'START_ACTIVITY_POLLING';

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  chartsData: {
    'hour-stats': { total: 0, growth: 0, points: [] },
    'day-stats': { total: 0, growth: 0, points: [] },
    'month-stats': { total: 0, growth: 0, points: [] },
    'year-stats': { total: 0, growth: 0, points: [] },
    advertisers: { top: [] },
    artists: { top: [] },
    categories: { top: [] },
    countries: { top: [] },
    decades: { top: [] },
    genres: { top: [] },
    tracks: { top: [] },
    stations: { top: [], area: [] },
    local_vs_international: { points: [{ local: 0, international: 0 }] },
    sold_out: {
      hours: {
        '00:00': 0,
        '01:00': 0,
        '02:00': 0,
        '03:00': 0,
        '04:00': 0,
        '05:00': 0,
        '06:00': 0,
        '07:00': 0,
        '08:00': 0,
        '09:00': 0,
        '10:00': 0,
        '11:00': 0,
        '12:00': 0,
        '13:00': 0,
        '14:00': 0,
        '15:00': 0,
        '16:00': 0,
        '17:00': 0,
        '18:00': 0,
        '19:00': 0,
        '20:00': 0,
        '21:00': 0,
        '22:00': 0,
        '23:00': 0
      }
    }
  },
  selectedDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
  selectedPeriod: 'month',
  selectedStation: null,
  stations: [],
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsError: null,
  loadingChartsSucceeded: false,
  loadingStations: false,
  loadingStationsFailed: false,
  loadingStationsSucceeded: false,
  loadingStationsError: null
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  chartsData: {
    'hour-stats': { total: 0, growth: 0, points: [] },
    'day-stats': { total: 0, growth: 0, points: [] },
    'week-stats': { total: 0, growth: 0, points: [] },
    'month-stats': { total: 0, growth: 0, points: [] },
    'year-stats': { total: 0, growth: 0, points: [] },
    'unique-stats': { 'total-vs-unique': [] },
    'campaign-stats': { points: [[]] },
    'channel-type-stats': { points: [[]] },
    'heat-map-stats': { points: {}, range: [] }
  },
  mainChartData: {
    stats: { points: [] }
  },
  campaignReportData: {
    totals: {
      total_lifetime: 0,
      unique_lifetime: 0,
      total_today: 0,
      unique_today: 0,
      total_this_week: 0,
      unique_this_week: 0,
      total_this_month: 0,
      unique_this_month: 0,
      total_vs_unique_channel_type: []
    },
    charts: {
      today: [],
      this_week: [],
      this_month: [],
      channels: []
    }
  },
  selectedDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
  selectedPeriod: 'year',
  selectedFilter: 'campaign',
  selectedTimeslot: 0,
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsError: null,
  loadingChartsSucceeded: false,
  loadingMainChart: false,
  loadingMainChartFailed: false,
  loadingMainChartError: null,
  loadingMainChartSucceeded: false,
  loadingCampaignReport: false,
  loadingCampaignReportFailed: false,
  loadingCampaignReportError: null,
  loadingCampaignReportSucceeded: false,

  campaignListChartsData: {},
  loadingCampaignListCharts: false,
  loadingCampaignListChartsFailed: false,
  loadingCampaignListChartsSucceeded: false,
  loadingCampaignListChartsError: null,

  showMainLegend: false,

  liveStreamingStates: {
    live_streams: 0,
    max_concurrent: 0
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BLACKLIST_ORIGINATORS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_BLACKLIST_ORIGINATORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_BLACKLIST_ORIGINATORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_BLACKLIST_ORIGINATOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_BLACKLIST_ORIGINATOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_BLACKLIST_ORIGINATOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_BLACKLIST_ORIGINATOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_BLACKLIST_ORIGINATOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_BLACKLIST_ORIGINATOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_BLACKLIST_ORIGINATOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_BLACKLIST_ORIGINATOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_BLACKLIST_ORIGINATOR_FAILURE; });
var GET_BLACKLIST_ORIGINATORS_REQUEST = 'GET_BLACKLIST_ORIGINATORS_REQUEST';
var GET_BLACKLIST_ORIGINATORS_SUCCESS = 'GET_BLACKLIST_ORIGINATORS_SUCCESS';
var GET_BLACKLIST_ORIGINATORS_FAILURE = 'GET_BLACKLIST_ORIGINATORS_FAILURE';

var CREATE_BLACKLIST_ORIGINATOR_REQUEST = 'CREATE_BLACKLIST_ORIGINATOR_REQUEST';
var CREATE_BLACKLIST_ORIGINATOR_SUCCESS = 'CREATE_BLACKLIST_ORIGINATOR_SUCCESS';
var CREATE_BLACKLIST_ORIGINATOR_FAILURE = 'CREATE_BLACKLIST_ORIGINATOR_FAILURE';

var UPDATE_BLACKLIST_ORIGINATOR_REQUEST = 'UPDATE_BLACKLIST_ORIGINATOR_REQUEST';
var UPDATE_BLACKLIST_ORIGINATOR_SUCCESS = 'UPDATE_BLACKLIST_ORIGINATOR_SUCCESS';
var UPDATE_BLACKLIST_ORIGINATOR_FAILURE = 'UPDATE_BLACKLIST_ORIGINATOR_FAILURE';

var DELETE_BLACKLIST_ORIGINATOR_REQUEST = 'DELETE_BLACKLIST_ORIGINATOR_REQUEST';
var DELETE_BLACKLIST_ORIGINATOR_SUCCESS = 'DELETE_BLACKLIST_ORIGINATOR_SUCCESS';
var DELETE_BLACKLIST_ORIGINATOR_FAILURE = 'DELETE_BLACKLIST_ORIGINATOR_FAILURE';

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_COMPANY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_COMPANY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_COMPANY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_COMPANY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_COMPANY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_COMPANY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_COMPANIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_COMPANIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_COMPANIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_TIMEZONES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_TIMEZONES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_TIMEZONES_FAILURE; });
var GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
var GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE';
var GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';

var UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
var UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE';
var UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';

var GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
var GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';
var GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';

var GET_TIMEZONES_REQUEST = 'GET_TIMEZONES_REQUEST';
var GET_TIMEZONES_SUCCESS = 'GET_TIMEZONES_SUCCESS';
var GET_TIMEZONES_FAILURE = 'GET_TIMEZONES_FAILURE';

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_MY_FILES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_MY_FILES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_MY_FILES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_COMPANY_FILES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_COMPANY_FILES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_COMPANY_FILES_SUCCESS; });
var GET_MY_FILES_REQUEST = 'GET_MY_FILES_REQUEST';
var GET_MY_FILES_FAILURE = 'GET_MY_FILES_FAILURE';
var GET_MY_FILES_SUCCESS = 'GET_MY_FILES_SUCCESS';

var GET_COMPANY_FILES_REQUEST = 'GET_COMPANY_FILES_REQUEST';
var GET_COMPANY_FILES_FAILURE = 'GET_COMPANY_FILES_FAILURE';
var GET_COMPANY_FILES_SUCCESS = 'GET_COMPANY_FILES_SUCCESS';

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_SOCIAL_POST_DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_SOCIAL_POST_DIALOG; });
var SHOW_SOCIAL_POST_DIALOG = 'SHOW_SOCIAL_POST_DIALOG';
var HIDE_SOCIAL_POST_DIALOG = 'HIDE_SOCIAL_POST_DIALOG';

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_PLUGINS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_PLUGINS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_PLUGINS_SUCCESS; });
var GET_PLUGINS_REQUEST = 'GET_PLUGINS_REQUEST';
var GET_PLUGINS_FAILURE = 'GET_PLUGINS_FAILURE';
var GET_PLUGINS_SUCCESS = 'GET_PLUGINS_SUCCESS';

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOWNLOAD_OPTINS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOWNLOAD_OPTINS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOWNLOAD_OPTINS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_OPTINS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_OPTINS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_OPTINS_FAILURE; });
var DOWNLOAD_OPTINS_REQUEST = 'DOWNLOAD_OPTINS_REQUEST';
var DOWNLOAD_OPTINS_SUCCESS = 'DOWNLOAD_OPTINS_SUCCESS';
var DOWNLOAD_OPTINS_FAILURE = 'DOWNLOAD_OPTINS_FAILURE';

var CREATE_OPTINS_REQUEST = 'CREATE_OPTINS_REQUEST';
var CREATE_OPTINS_SUCCESS = 'CREATE_OPTINS_SUCCESS';
var CREATE_OPTINS_FAILURE = 'CREATE_OPTINS_FAILURE';

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GENERATE_URL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GENERATE_URL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GENERATE_URL_FAILED; });
var GENERATE_URL_REQUEST = 'GENERATE_URL_REQUEST';
var GENERATE_URL_SUCCESS = 'GENERATE_URL_SUCCESS';
var GENERATE_URL_FAILED = 'GENERATE_URL_FAILED';

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_RULES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_RULES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_RULES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_RULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_RULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_RULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_RULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_RULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_RULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_RULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_RULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_RULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DELETE_RULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELETE_RULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DELETE_RULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_RULE_FIELDS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_RULE_FIELDS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_RULE_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_RULE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_RULE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ADD_RULE_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REMOVE_RULE_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_RULE_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ADD_RULE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_RULE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_RULE_ACTION; });
var GET_RULES_REQUEST = 'GET_RULES_REQUEST';
var GET_RULES_FAILURE = 'GET_RULES_FAILURE';
var GET_RULES_SUCCESS = 'GET_RULES_SUCCESS';

var CREATE_RULE_REQUEST = 'CREATE_RULE_REQUEST';
var CREATE_RULE_FAILURE = 'CREATE_RULE_FAILURE';
var CREATE_RULE_SUCCESS = 'CREATE_RULE_SUCCESS';

var GET_RULE_REQUEST = 'GET_RULE_REQUEST';
var GET_RULE_FAILURE = 'GET_RULE_FAILURE';
var GET_RULE_SUCCESS = 'GET_RULE_SUCCESS';

var UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
var UPDATE_RULE_FAILURE = 'UPDATE_RULE_FAILURE';
var UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';

var DELETE_RULE_REQUEST = 'DELETE_RULE_REQUEST';
var DELETE_RULE_FAILURE = 'DELETE_RULE_FAILURE';
var DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';

var GET_RULE_FIELDS_REQUEST = 'GET_RULE_FIELDS_REQUEST';
var GET_RULE_FIELDS_FAILURE = 'GET_RULE_FIELDS_FAILURE';
var GET_RULE_FIELDS_SUCCESS = 'GET_RULE_FIELDS_SUCCESS';

var SET_RULE_TITLE = 'SET_RULE_TITLE';
var SET_RULE_EVENT = 'SET_RULE_EVENT';
var ADD_RULE_CONDITION = 'ADD_RULE_CONDITION';
var REMOVE_RULE_CONDITION = 'REMOVE_RULE_CONDITION';
var SET_RULE_CONDITION = 'SET_RULE_CONDITION';
var ADD_RULE_ACTION = 'ADD_RULE_ACTION';
var REMOVE_RULE_ACTION = 'REMOVE_RULE_ACTION';
var SET_RULE_ACTION = 'SET_RULE_ACTION';

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  region: '',
  startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(20, 'days'),
  endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(),
  offset: 0,
  stationActivityData: { results: [] },
  loadingStationActivity: false,
  loadingStationActivityFailed: false,
  loadingStationActivitySucceeded: false,
  loadingStationActivityError: null
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export applyLinkMetadata */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyQuestionLinkMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return groupMediaQuestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ungroupMediaQuestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



// eslint-disable-next-line
var applyLinkMetadata = function applyLinkMetadata(items, links, linkIdField, overrideFields) {
  return items.map(function (item) {
    var link = links.find(function (l) {
      return l[linkIdField] === item.id;
    });
    var overrides = overrideFields.reduce(function (acc, field) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, field, link[field]));
    }, {});
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, overrides);
  });
};

var applyQuestionLinkMetadata = function applyQuestionLinkMetadata(question) {
  var choices = [];
  var matrixChoices = [];

  if (question.choices) {
    choices = applyLinkMetadata(question.choices, question.choiceLinks, 'choiceId', ['polarity', 'order']).sort(function (a, b) {
      return a.order - b.order;
    });
  }

  if (question.matrixChoices !== undefined) {
    matrixChoices = applyLinkMetadata(question.matrixChoices, question.matrixChoiceLinks, 'matrixChoiceId', ['order']).sort(function (a, b) {
      return a.order - b.order;
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, question, { choices: choices, matrixChoices: matrixChoices });
};

// eslint-disable-next-line
var groupMediaQuestions = function groupMediaQuestions(questions) {
  var firstMediaIndex = questions.findIndex(function (q) {
    return q.questionType === 'MEDIA';
  });
  var questionList = questions.filter(function (q) {
    return q.questionType !== 'MEDIA';
  });

  // No media questions, set up a blank group
  if (firstMediaIndex === -1) {
    questionList.push({
      questionType: 'MEDIA',
      title: 'Media survey',
      group: [],
      matrixChoices: []
    });
  } else {
    var mediaQuestionList = questions.filter(function (q) {
      return q.questionType === 'MEDIA';
    });

    // Media questions in a group should always use the same questions
    // so we'll only concern ourselves with the choices of the first
    var matrixChoices = mediaQuestionList[0].matrixChoices;

    var groupedMediaQuestion = {
      questionType: 'MEDIA',
      title: 'Media survey',
      group: mediaQuestionList,
      matrixChoices: matrixChoices
    };

    // Add the media group into the position where we found the first media entry before.
    questionList.splice(firstMediaIndex, 0, groupedMediaQuestion);
  }

  return questionList;
};

var ungroupMediaQuestions = function ungroupMediaQuestions(questions) {
  var mediaGroupIndex = questions.findIndex(function (q) {
    return q.questionType === 'MEDIA';
  });

  // No media group questions found, o need to continue further
  if (mediaGroupIndex === -1) {
    return questions;
  }

  var questionList = questions.filter(function (q) {
    return q.questionType !== 'MEDIA';
  });
  var matrixChoices = questions[mediaGroupIndex].matrixChoices.map(function (mc) {
    return {
      id: mc.id,
      name: mc.name,
      title: mc.title,
      visibleIf: mc.visibleIf,
      isRequired: true,
      choices: mc.choices
    };
  });
  var mediaQuestionList = questions[mediaGroupIndex].group
  // Set the matrix choices on each question in our group
  .map(function (mq) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mq, { mediaClipId: mq.mediaClip.id, matrixChoices: matrixChoices });
  });

  questionList.splice.apply(questionList, [mediaGroupIndex, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(mediaQuestionList)));

  return questionList;
};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return questionDialogFormInitial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return choiceTemplateDialogFormInitial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hookDialogFormInitial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return matrixChoiceDialogFormInitial; });
// eslint-disable-next-line
var questionDialogFormInitial = {
  id: null,
  title: null,
  categoryId: null,
  questionType: null,
  isRequired: true,
  isProfile: false,
  isGlobal: false,
  profileField: null,
  chart: 'VERTICAL_BAR',
  insight: 'As many as {positive_percentage} of respondents are positive about buying in this category',
  choices: []
};

var choiceTemplateDialogFormInitial = {
  title: null,
  description: null,
  categoryId: null,
  isGlobal: false,
  keywords: []
};

var hookDialogFormInitial = {
  id: null,
  title: null,
  artist: null,
  description: null,
  fileData: null,
  file: null
};

var matrixChoiceDialogFormInitial = {
  id: null,
  name: null,
  title: null,
  visibleIf: null,
  isRequired: null,
  choices: []
};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__initial_state__ = __webpack_require__(584);



var initialState = function initialState() {
  return {
    // TABS
    tabActive: 'setup',

    selectorPageSize: 100,

    // SURVEY STATE
    survey: {},
    surveyLoading: false,
    surveyLoadSuccess: false,
    surveyLoadError: null,
    surveySaving: false,
    surveySaveSuccess: false,
    surveySaveError: null,

    surveyList: [],
    surveyListLoading: false,
    surveyListSuccess: false,
    surveyListError: null,
    surveyListFilter: { title: null, state: 'ALL' },
    surveyListPage: 1,
    surveyListTotalPages: 1,

    // QUESTIONS
    questionList: [],
    questionsLoading: false,
    questionsLoadSuccess: false,
    questionsLoadError: null,
    questionsSaving: false,
    questionsSaveSuccess: false,
    questionsSaveError: null,
    questionsPage: 0,
    questionsTotalPages: 0,

    // CHOICE TEMPLATES
    choiceTemplateList: [],
    choiceTemplatesLoading: false,
    choiceTemplatesLoadSuccess: false,
    choiceTemplatesLoadError: null,
    choiceTemplatesSaving: false,
    choiceTemplatesSaveSuccess: false,
    choiceTemplatesSaveError: null,
    choiceTemplatesPage: 0,
    choiceTemplatesTotalPages: 0,

    choiceList: [],
    choicesLoading: false,
    choicesLoadSuccess: false,
    choicesLoadError: null,
    choicesPage: 0,
    choicesTotalPages: 0,

    // QUESTION CATEGORIES
    questionCategoryList: [],
    questionCategoriesLoading: false,
    questionCategoriesLoadSuccess: false,
    questionCategoriesLoadError: null,

    questionCategoryWithQuestionsList: [],
    questionCategoriesWithQuestionsLoading: false,
    questionCategoriesWithQuestionsLoadSuccess: false,
    questionCategoriesWithQuestionsLoadError: null,

    questionCategoriesCreating: false,
    questionCategoriesCreateSuccess: false,
    questionCategoriesCreateError: null,

    questionCategoryDialogVisible: false,

    // CHOICE CATEGORIES
    choiceCategoryList: [],
    choiceCategoriesLoading: false,
    choiceCategoriesLoadSuccess: false,
    choiceCategoriesLoadError: null,
    choiceCategoriesCreating: false,
    choiceCategoriesCreateSuccess: false,
    choiceCategoriesCreateError: null,

    choiceCategoryDialogVisible: false,

    // HOOKS
    hookList: [],
    hooksLoading: false,
    hooksLoadSuccess: false,
    hooksLoadError: null,
    hooksCreating: false,
    hooksCreateSuccess: false,
    hooksCreateError: null,
    hooksSaving: false,
    hooksSaveSuccess: false,
    hooksSaveError: null,
    hooksPage: 0,
    hooksTotalPages: 0,

    // MATRIX CHOICES (MUSIC QUESTIONS)
    matrixChoiceList: [],
    matrixChoicesLoading: false,
    matrixChoicesLoadSuccess: false,
    matrixChoicesLoadError: null,
    matrixChoicesCreating: false,
    matrixChoicesCreateSuccess: false,
    matrixChoicesCreateError: null,
    matrixChoicesSaving: false,
    matrixChoicesSaveSuccess: false,
    matrixChoicesSaveError: null,
    matrixChoicesPage: 0,
    matrixChoicesTotalPages: 0,

    // CANVAS STATE
    canvasQuestions: [],
    canvasQuestionsLoading: false,
    canvasQuestionsLoadSuccess: false,
    canvasQuestionsLoadError: null,
    canvasQuestionsUpdating: false,
    canvasQuestionsUpdateSuccess: false,
    canvasQuestionsUpdateError: null,

    canvasSelectedQuestionId: null,

    // SELECTORS STATE
    selectorSelectedQuestionCategory: null,
    selectorQuestionSearchText: '',
    selectorSelectedTemplateId: null,
    selectorSelectedTemplateCategory: null,
    selectorTemplateSearchText: '',
    selectorSelectedChoiceCategory: null,
    selectorChoiceSearchText: '',
    selectorHookSearchText: '',
    selectorMatrixChoiceSearchText: '',

    // QUESTION DIALOG STATE
    questionDialogVisible: false,
    questionDialogAddToCanvas: false,
    questionDialogForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__initial_state__["a" /* questionDialogFormInitial */]),

    // QUESTION CONDITIONAL LOGIC DIALOG STATE
    questionConditionalLogicDialogVisible: false,
    questionConditionalLogicDialogQuestion: null,

    // HOOK DIALOG STATE
    hookDialogVisible: false,
    hookDialogForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__initial_state__["b" /* hookDialogFormInitial */]),

    // MATRIX CHOICE SAVE DIALOG STATE
    matrixChoiceDialogVisible: false,
    matrixChoiceDialogForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__initial_state__["c" /* matrixChoiceDialogFormInitial */]),

    // MATRIX CONDITIONAL LOGIC DIALOG STATE
    matrixConditionalLogicDialogVisible: false,
    matrixConditionalLogicDialogMatrixChoice: null,

    // CHOICE TEMPLATE DIALOG STATE
    choiceTemplateDialogVisible: false,
    choiceTemplateDialogIsScale: false,
    choiceTemplateDialogChoices: [],
    choiceTemplateDialogForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__initial_state__["d" /* choiceTemplateDialogFormInitial */]),

    choiceTypes: ['SELECT', 'MULTI_SELECT', 'SCALE'],

    questionTypeList: [{ title: 'Text input', value: 'TEXT' }, { title: 'Positive / Negative scale', value: 'SCALE' }, { title: 'Single selection', value: 'SELECT' }, { title: 'Multiple selection', value: 'MULTI_SELECT' }, { title: 'Opt in', value: 'OPT_IN' }, { title: 'Permission to process', value: 'PERMISSION' }, { title: 'Age consent', value: 'AGE_CONSENT' }, { title: 'Radio group', value: 'RADIOGROUP' }, { title: 'Comment', value: 'COMMENT' }, { title: 'Sortable / Rank', value: 'SORTABLE' }, { title: 'Date', value: 'DATE' }, { title: 'Time', value: 'TIME' }, { title: 'URL', value: 'URL' }, { title: 'Password', value: 'PASSWORD' }, { title: 'Range', value: 'RANGE' }, { title: 'Telephone', value: 'TEL' }, { title: 'Email', value: 'EMAIL' }, { title: 'Media', value: 'MEDIA' }, { title: 'Media Group', value: 'MEDIA' }],

    questionProfileFieldList: [{ label: 'Age', value: 'age' }, { label: 'Age Range', value: 'age_range' }, { label: 'Country', value: 'country' }, { label: 'Dwelling Type', value: 'dwelling_type' }, { label: 'Education', value: 'education' }, { label: 'Ethnicity', value: 'ethnicity' }, { label: 'Event', value: 'event' }, { label: 'Gender', value: 'gender' }, { label: 'Income', value: 'income' }, { label: 'Language', value: 'language' }, { label: 'Location', value: 'location' }, { label: 'Name', value: 'name' }, { label: 'Product', value: 'product' }, { label: 'Residential Status', value: 'residential_status' }]
  };
};

/* harmony default export */ __webpack_exports__["a"] = (initialState);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TELEGRAM_NEW_DIALOG_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_TELEGRAM_SELECTED_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_TELEGRAM_CODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_TELEGRAM_CODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REQUEST_TELEGRAM_CODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SIGN_IN_TELEGRAM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SIGN_IN_TELEGRAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SIGN_IN_TELEGRAM_FAILED; });
/* unused harmony export REGISTER_TELEGRAM_REQUEST */
/* unused harmony export REGISTER_TELEGRAM_SUCCESS */
/* unused harmony export REGISTER_TELEGRAM_FAILED */
var SET_TELEGRAM_NEW_DIALOG_VISIBLE = 'SET_TELEGRAM_NEW_DIALOG_VISIBLE';
var SET_TELEGRAM_SELECTED_COUNTRY = 'SET_TELEGRAM_SELECTED_COUNTRY';

var REQUEST_TELEGRAM_CODE_REQUEST = 'REQUEST_TELEGRAM_CODE_REQUEST';
var REQUEST_TELEGRAM_CODE_SUCCESS = 'REQUEST_TELEGRAM_CODE_SUCCESS';
var REQUEST_TELEGRAM_CODE_FAILURE = 'REQUEST_TELEGRAM_CODE_FAILURE';

var SIGN_IN_TELEGRAM_REQUEST = 'SIGN_IN_TELEGRAM_REQUEST';
var SIGN_IN_TELEGRAM_SUCCESS = 'SIGN_IN_TELEGRAM_SUCCESS';
var SIGN_IN_TELEGRAM_FAILED = 'SIGN_IN_TELEGRAM_FAILED';

var REGISTER_TELEGRAM_REQUEST = 'REGISTER_TELEGRAM_REQUEST';
var REGISTER_TELEGRAM_SUCCESS = 'REGISTER_TELEGRAM_SUCCESS';
var REGISTER_TELEGRAM_FAILED = 'REGISTER_TELEGRAM_FAILED';

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SINGLE_USE_TOKEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_SINGLE_USE_TOKEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SINGLE_USE_TOKEN_SUCCESS; });
var GET_SINGLE_USE_TOKEN_REQUEST = 'GET_SINGLE_USE_TOKEN_REQUEST';
var GET_SINGLE_USE_TOKEN_FAILURE = 'GET_SINGLE_USE_TOKEN_FAILURE';
var GET_SINGLE_USE_TOKEN_SUCCESS = 'GET_SINGLE_USE_TOKEN_SUCCESS';

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 758 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTemplateData"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":154}};
    doc.loc.source = {"body":"mutation($id: Int, $data: EmailTemplateData!) {\n  updateTemplate(id: $id, data: $data) {\n      id\n      name\n      subject\n      type\n      content\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 759 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":94}};
    doc.loc.source = {"body":"query($provider: String) {\n  contactAccounts(provider: $provider) {\n    id,\n    provider\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 760 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constantContactLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_count"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":97}};
    doc.loc.source = {"body":"query(\n  $id: Int\n) {\n  constantContactLists(id: $id) {\n    id,\n    name,\n    contact_count\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 761 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailChimpLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_count"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":91}};
    doc.loc.source = {"body":"query(\n  $id: Int\n) {\n  mailChimpLists(id: $id) {\n    id,\n    name,\n    contact_count\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 762 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEditProfilePermissionModeInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEditPermissionProfileMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"mutation($query: UpdateEditProfilePermissionModeInput!) {\n  updateEditPermissionProfileMode(query: $query)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 763 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demographics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blacklisted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"optins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opt_in"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opt_out"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_opted_in"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"interactions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_updated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_blacklisted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_unsafe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_safe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_favourite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_winner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_comment"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_updated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_blacklisted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_unsafe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_safe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_favourite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_winner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag_comment"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":822}};
    doc.loc.source = {"body":"query($id: String) {\n  profile(id: $id) {\n    demographics {\n      title\n      field\n      label\n      blacklisted\n      value\n    }\n    campaigns {\n      title\n      type\n      date\n    }\n    optins {\n      channel\n      opt_in\n      opt_out\n      permission\n      date_opted_in\n    }\n    interactions {\n      id\n      company\n      channel\n      type\n      ore\n      parent {\n        id\n        company\n        channel\n        type\n        ore\n        direction\n        date_created\n        date_updated\n        flag_blacklisted\n        flag_unsafe\n        flag_safe\n        flag_favourite\n        flag_winner\n        flag_comment\n      }\n      direction\n      date_created\n      date_updated\n      flag_blacklisted\n      flag_unsafe\n      flag_safe\n      flag_favourite\n      flag_winner\n      flag_comment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 764 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"linkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":73}};
    doc.loc.source = {"body":"mutation($linkId: ID!) {\n  unlinkChannel(linkId: $linkId) {\n    ok\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 765 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApproveTranscriptInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveTranscript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":80}};
    doc.loc.source = {"body":"mutation($query: ApproveTranscriptInput!) {\n  approveTranscript(query: $query)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1299),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2411)
  __webpack_require__(2412)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1303),
  /* template */
  __webpack_require__(3220),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2490)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1333),
  /* template */
  __webpack_require__(3324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ade1932",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2551)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1349),
  /* template */
  __webpack_require__(3414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e83913f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2440)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1353),
  /* template */
  __webpack_require__(3265),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48f41f62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2462)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1354),
  /* template */
  __webpack_require__(3292),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-596a3b9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1367),
  /* template */
  __webpack_require__(3349),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1374),
  /* template */
  __webpack_require__(3283),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1376),
  /* template */
  __webpack_require__(3258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1379),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1383),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2476)
  __webpack_require__(2475)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1392),
  /* template */
  __webpack_require__(3307),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62ef96a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1395),
  /* template */
  __webpack_require__(3173),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fde30bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1396),
  /* template */
  __webpack_require__(3128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-091b7c04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2397)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1399),
  /* template */
  __webpack_require__(3201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ecc6c05",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2430)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1401),
  /* template */
  __webpack_require__(3246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-407b3c02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1404),
  /* template */
  __webpack_require__(3151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14ce1aba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2451)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1406),
  /* template */
  __webpack_require__(3279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ff9f74c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1408),
  /* template */
  __webpack_require__(3147),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14565b8f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2492)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1409),
  /* template */
  __webpack_require__(3326),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f36d559",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2480)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1410),
  /* template */
  __webpack_require__(3311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65ae7286",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2443)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1413),
  /* template */
  __webpack_require__(3269),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c5250c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1416),
  /* template */
  __webpack_require__(3387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2393)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1431),
  /* template */
  __webpack_require__(3195),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cc57225",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1436),
  /* template */
  __webpack_require__(3192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2507)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1444),
  /* template */
  __webpack_require__(3352),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7caa16f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2501)
  __webpack_require__(2500)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1447),
  /* template */
  __webpack_require__(3340),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-746576b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1454),
  /* template */
  __webpack_require__(3127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08f8e991",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1486),
  /* template */
  __webpack_require__(3175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2552)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1499),
  /* template */
  __webpack_require__(3415),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2493)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1503),
  /* template */
  __webpack_require__(3327),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f82357c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2437)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1504),
  /* template */
  __webpack_require__(3259),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-463ee082",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1506),
  /* template */
  __webpack_require__(3196),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1549),
  /* template */
  __webpack_require__(3412),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2404)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1587),
  /* template */
  __webpack_require__(3211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3484343a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1609),
  /* template */
  __webpack_require__(3316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */
/***/ (function(module, exports) {

module.exports = [{"name":"Afghanistan","flag":"🇦🇫","code":"AF","dial_code":"+93"},{"name":"Åland Islands","flag":"🇦🇽","code":"AX","dial_code":"+358"},{"name":"Albania","flag":"🇦🇱","code":"AL","dial_code":"+355"},{"name":"Algeria","flag":"🇩🇿","code":"DZ","dial_code":"+213"},{"name":"American Samoa","flag":"🇦🇸","code":"AS","dial_code":"+1684"},{"name":"Andorra","flag":"🇦🇩","code":"AD","dial_code":"+376"},{"name":"Angola","flag":"🇦🇴","code":"AO","dial_code":"+244"},{"name":"Anguilla","flag":"🇦🇮","code":"AI","dial_code":"+1264"},{"name":"Antarctica","flag":"🇦🇶","code":"AQ","dial_code":"+672"},{"name":"Antigua and Barbuda","flag":"🇦🇬","code":"AG","dial_code":"+1268"},{"name":"Argentina","flag":"🇦🇷","code":"AR","dial_code":"+54"},{"name":"Armenia","flag":"🇦🇲","code":"AM","dial_code":"+374"},{"name":"Aruba","flag":"🇦🇼","code":"AW","dial_code":"+297"},{"name":"Australia","flag":"🇦🇺","code":"AU","dial_code":"+61"},{"name":"Austria","flag":"🇦🇹","code":"AT","dial_code":"+43"},{"name":"Azerbaijan","flag":"🇦🇿","code":"AZ","dial_code":"+994"},{"name":"Bahamas","flag":"🇧🇸","code":"BS","dial_code":"+1242"},{"name":"Bahrain","flag":"🇧🇭","code":"BH","dial_code":"+973"},{"name":"Bangladesh","flag":"🇧🇩","code":"BD","dial_code":"+880"},{"name":"Barbados","flag":"🇧🇧","code":"BB","dial_code":"+1246"},{"name":"Belarus","flag":"🇧🇾","code":"BY","dial_code":"+375"},{"name":"Belgium","flag":"🇧🇪","code":"BE","dial_code":"+32"},{"name":"Belize","flag":"🇧🇿","code":"BZ","dial_code":"+501"},{"name":"Benin","flag":"🇧🇯","code":"BJ","dial_code":"+229"},{"name":"Bermuda","flag":"🇧🇲","code":"BM","dial_code":"+1441"},{"name":"Bhutan","flag":"🇧🇹","code":"BT","dial_code":"+975"},{"name":"Bolivia, Plurinational State of bolivia","flag":"🇧🇴","code":"BO","dial_code":"+591"},{"name":"Bosnia and Herzegovina","flag":"🇧🇦","code":"BA","dial_code":"+387"},{"name":"Botswana","flag":"🇧🇼","code":"BW","dial_code":"+267"},{"name":"Bouvet Island","flag":"🇧🇻","code":"BV","dial_code":"+47"},{"name":"Brazil","flag":"🇧🇷","code":"BR","dial_code":"+55"},{"name":"British Indian Ocean Territory","flag":"🇮🇴","code":"IO","dial_code":"+246"},{"name":"Brunei Darussalam","flag":"🇧🇳","code":"BN","dial_code":"+673"},{"name":"Bulgaria","flag":"🇧🇬","code":"BG","dial_code":"+359"},{"name":"Burkina Faso","flag":"🇧🇫","code":"BF","dial_code":"+226"},{"name":"Burundi","flag":"🇧🇮","code":"BI","dial_code":"+257"},{"name":"Cambodia","flag":"🇰🇭","code":"KH","dial_code":"+855"},{"name":"Cameroon","flag":"🇨🇲","code":"CM","dial_code":"+237"},{"name":"Canada","flag":"🇨🇦","code":"CA","dial_code":"+1"},{"name":"Cape Verde","flag":"🇨🇻","code":"CV","dial_code":"+238"},{"name":"Cayman Islands","flag":"🇰🇾","code":"KY","dial_code":"+ 345"},{"name":"Central African Republic","flag":"🇨🇫","code":"CF","dial_code":"+236"},{"name":"Chad","flag":"🇹🇩","code":"TD","dial_code":"+235"},{"name":"Chile","flag":"🇨🇱","code":"CL","dial_code":"+56"},{"name":"China","flag":"🇨🇳","code":"CN","dial_code":"+86"},{"name":"Christmas Island","flag":"🇨🇽","code":"CX","dial_code":"+61"},{"name":"Cocos (Keeling) Islands","flag":"🇨🇨","code":"CC","dial_code":"+61"},{"name":"Colombia","flag":"🇨🇴","code":"CO","dial_code":"+57"},{"name":"Comoros","flag":"🇰🇲","code":"KM","dial_code":"+269"},{"name":"Congo","flag":"🇨🇬","code":"CG","dial_code":"+242"},{"name":"Congo, The Democratic Republic of the Congo","flag":"🇨🇩","code":"CD","dial_code":"+243"},{"name":"Cook Islands","flag":"🇨🇰","code":"CK","dial_code":"+682"},{"name":"Costa Rica","flag":"🇨🇷","code":"CR","dial_code":"+506"},{"name":"Cote d'Ivoire","flag":"🇨🇮","code":"CI","dial_code":"+225"},{"name":"Croatia","flag":"🇭🇷","code":"HR","dial_code":"+385"},{"name":"Cuba","flag":"🇨🇺","code":"CU","dial_code":"+53"},{"name":"Cyprus","flag":"🇨🇾","code":"CY","dial_code":"+357"},{"name":"Czech Republic","flag":"🇨🇿","code":"CZ","dial_code":"+420"},{"name":"Denmark","flag":"🇩🇰","code":"DK","dial_code":"+45"},{"name":"Djibouti","flag":"🇩🇯","code":"DJ","dial_code":"+253"},{"name":"Dominica","flag":"🇩🇲","code":"DM","dial_code":"+1767"},{"name":"Dominican Republic","flag":"🇩🇴","code":"DO","dial_code":"+1849"},{"name":"Ecuador","flag":"🇪🇨","code":"EC","dial_code":"+593"},{"name":"Egypt","flag":"🇪🇬","code":"EG","dial_code":"+20"},{"name":"El Salvador","flag":"🇸🇻","code":"SV","dial_code":"+503"},{"name":"Equatorial Guinea","flag":"🇬🇶","code":"GQ","dial_code":"+240"},{"name":"Eritrea","flag":"🇪🇷","code":"ER","dial_code":"+291"},{"name":"Estonia","flag":"🇪🇪","code":"EE","dial_code":"+372"},{"name":"Ethiopia","flag":"🇪🇹","code":"ET","dial_code":"+251"},{"name":"Falkland Islands (Malvinas)","flag":"🇫🇰","code":"FK","dial_code":"+500"},{"name":"Faroe Islands","flag":"🇫🇴","code":"FO","dial_code":"+298"},{"name":"Fiji","flag":"🇫🇯","code":"FJ","dial_code":"+679"},{"name":"Finland","flag":"🇫🇮","code":"FI","dial_code":"+358"},{"name":"France","flag":"🇫🇷","code":"FR","dial_code":"+33"},{"name":"French Guiana","flag":"🇬🇫","code":"GF","dial_code":"+594"},{"name":"French Polynesia","flag":"🇵🇫","code":"PF","dial_code":"+689"},{"name":"French Southern Territories","flag":"🇹🇫","code":"TF","dial_code":"+262"},{"name":"Gabon","flag":"🇬🇦","code":"GA","dial_code":"+241"},{"name":"Gambia","flag":"🇬🇲","code":"GM","dial_code":"+220"},{"name":"Georgia","flag":"🇬🇪","code":"GE","dial_code":"+995"},{"name":"Germany","flag":"🇩🇪","code":"DE","dial_code":"+49"},{"name":"Ghana","flag":"🇬🇭","code":"GH","dial_code":"+233"},{"name":"Gibraltar","flag":"🇬🇮","code":"GI","dial_code":"+350"},{"name":"Greece","flag":"🇬🇷","code":"GR","dial_code":"+30"},{"name":"Greenland","flag":"🇬🇱","code":"GL","dial_code":"+299"},{"name":"Grenada","flag":"🇬🇩","code":"GD","dial_code":"+1473"},{"name":"Guadeloupe","flag":"🇬🇵","code":"GP","dial_code":"+590"},{"name":"Guam","flag":"🇬🇺","code":"GU","dial_code":"+1671"},{"name":"Guatemala","flag":"🇬🇹","code":"GT","dial_code":"+502"},{"name":"Guernsey","flag":"🇬🇬","code":"GG","dial_code":"+44"},{"name":"Guinea","flag":"🇬🇳","code":"GN","dial_code":"+224"},{"name":"Guinea-Bissau","flag":"🇬🇼","code":"GW","dial_code":"+245"},{"name":"Guyana","flag":"🇬🇾","code":"GY","dial_code":"+592"},{"name":"Haiti","flag":"🇭🇹","code":"HT","dial_code":"+509"},{"name":"Heard Island and Mcdonald Islands","flag":"🇭🇲","code":"HM","dial_code":"+0"},{"name":"Holy See (Vatican City State)","flag":"🇻🇦","code":"VA","dial_code":"+379"},{"name":"Honduras","flag":"🇭🇳","code":"HN","dial_code":"+504"},{"name":"Hong Kong","flag":"🇭🇰","code":"HK","dial_code":"+852"},{"name":"Hungary","flag":"🇭🇺","code":"HU","dial_code":"+36"},{"name":"Iceland","flag":"🇮🇸","code":"IS","dial_code":"+354"},{"name":"India","flag":"🇮🇳","code":"IN","dial_code":"+91"},{"name":"Indonesia","flag":"🇮🇩","code":"ID","dial_code":"+62"},{"name":"Iran, Islamic Republic of Persian Gulf","flag":"🇮🇷","code":"IR","dial_code":"+98"},{"name":"Iraq","flag":"🇮🇶","code":"IQ","dial_code":"+964"},{"name":"Ireland","flag":"🇮🇪","code":"IE","dial_code":"+353"},{"name":"Isle of Man","flag":"🇮🇲","code":"IM","dial_code":"+44"},{"name":"Israel","flag":"🇮🇱","code":"IL","dial_code":"+972"},{"name":"Italy","flag":"🇮🇹","code":"IT","dial_code":"+39"},{"name":"Jamaica","flag":"🇯🇲","code":"JM","dial_code":"+1876"},{"name":"Japan","flag":"🇯🇵","code":"JP","dial_code":"+81"},{"name":"Jersey","flag":"🇯🇪","code":"JE","dial_code":"+44"},{"name":"Jordan","flag":"🇯🇴","code":"JO","dial_code":"+962"},{"name":"Kazakhstan","flag":"🇰🇿","code":"KZ","dial_code":"+7"},{"name":"Kenya","flag":"🇰🇪","code":"KE","dial_code":"+254"},{"name":"Kiribati","flag":"🇰🇮","code":"KI","dial_code":"+686"},{"name":"Korea, Democratic People's Republic of Korea","flag":"🇰🇵","code":"KP","dial_code":"+850"},{"name":"Korea, Republic of South Korea","flag":"🇰🇷","code":"KR","dial_code":"+82"},{"name":"Kosovo","flag":"🇽🇰","code":"XK","dial_code":"+383"},{"name":"Kuwait","flag":"🇰🇼","code":"KW","dial_code":"+965"},{"name":"Kyrgyzstan","flag":"🇰🇬","code":"KG","dial_code":"+996"},{"name":"Laos","flag":"🇱🇦","code":"LA","dial_code":"+856"},{"name":"Latvia","flag":"🇱🇻","code":"LV","dial_code":"+371"},{"name":"Lebanon","flag":"🇱🇧","code":"LB","dial_code":"+961"},{"name":"Lesotho","flag":"🇱🇸","code":"LS","dial_code":"+266"},{"name":"Liberia","flag":"🇱🇷","code":"LR","dial_code":"+231"},{"name":"Libyan Arab Jamahiriya","flag":"🇱🇾","code":"LY","dial_code":"+218"},{"name":"Liechtenstein","flag":"🇱🇮","code":"LI","dial_code":"+423"},{"name":"Lithuania","flag":"🇱🇹","code":"LT","dial_code":"+370"},{"name":"Luxembourg","flag":"🇱🇺","code":"LU","dial_code":"+352"},{"name":"Macao","flag":"🇲🇴","code":"MO","dial_code":"+853"},{"name":"Macedonia","flag":"🇲🇰","code":"MK","dial_code":"+389"},{"name":"Madagascar","flag":"🇲🇬","code":"MG","dial_code":"+261"},{"name":"Malawi","flag":"🇲🇼","code":"MW","dial_code":"+265"},{"name":"Malaysia","flag":"🇲🇾","code":"MY","dial_code":"+60"},{"name":"Maldives","flag":"🇲🇻","code":"MV","dial_code":"+960"},{"name":"Mali","flag":"🇲🇱","code":"ML","dial_code":"+223"},{"name":"Malta","flag":"🇲🇹","code":"MT","dial_code":"+356"},{"name":"Marshall Islands","flag":"🇲🇭","code":"MH","dial_code":"+692"},{"name":"Martinique","flag":"🇲🇶","code":"MQ","dial_code":"+596"},{"name":"Mauritania","flag":"🇲🇷","code":"MR","dial_code":"+222"},{"name":"Mauritius","flag":"🇲🇺","code":"MU","dial_code":"+230"},{"name":"Mayotte","flag":"🇾🇹","code":"YT","dial_code":"+262"},{"name":"Mexico","flag":"🇲🇽","code":"MX","dial_code":"+52"},{"name":"Micronesia, Federated States of Micronesia","flag":"🇫🇲","code":"FM","dial_code":"+691"},{"name":"Moldova","flag":"🇲🇩","code":"MD","dial_code":"+373"},{"name":"Monaco","flag":"🇲🇨","code":"MC","dial_code":"+377"},{"name":"Mongolia","flag":"🇲🇳","code":"MN","dial_code":"+976"},{"name":"Montenegro","flag":"🇲🇪","code":"ME","dial_code":"+382"},{"name":"Montserrat","flag":"🇲🇸","code":"MS","dial_code":"+1664"},{"name":"Morocco","flag":"🇲🇦","code":"MA","dial_code":"+212"},{"name":"Mozambique","flag":"🇲🇿","code":"MZ","dial_code":"+258"},{"name":"Myanmar","flag":"🇲🇲","code":"MM","dial_code":"+95"},{"name":"Namibia","flag":"🇳🇦","code":"NA","dial_code":"+264"},{"name":"Nauru","flag":"🇳🇷","code":"NR","dial_code":"+674"},{"name":"Nepal","flag":"🇳🇵","code":"NP","dial_code":"+977"},{"name":"Netherlands","flag":"🇳🇱","code":"NL","dial_code":"+31"},{"name":"Netherlands Antilles","flag":"","code":"AN","dial_code":"+599"},{"name":"New Caledonia","flag":"🇳🇨","code":"NC","dial_code":"+687"},{"name":"New Zealand","flag":"🇳🇿","code":"NZ","dial_code":"+64"},{"name":"Nicaragua","flag":"🇳🇮","code":"NI","dial_code":"+505"},{"name":"Niger","flag":"🇳🇪","code":"NE","dial_code":"+227"},{"name":"Nigeria","flag":"🇳🇬","code":"NG","dial_code":"+234"},{"name":"Niue","flag":"🇳🇺","code":"NU","dial_code":"+683"},{"name":"Norfolk Island","flag":"🇳🇫","code":"NF","dial_code":"+672"},{"name":"Northern Mariana Islands","flag":"🇲🇵","code":"MP","dial_code":"+1670"},{"name":"Norway","flag":"🇳🇴","code":"NO","dial_code":"+47"},{"name":"Oman","flag":"🇴🇲","code":"OM","dial_code":"+968"},{"name":"Pakistan","flag":"🇵🇰","code":"PK","dial_code":"+92"},{"name":"Palau","flag":"🇵🇼","code":"PW","dial_code":"+680"},{"name":"Palestinian Territory, Occupied","flag":"🇵🇸","code":"PS","dial_code":"+970"},{"name":"Panama","flag":"🇵🇦","code":"PA","dial_code":"+507"},{"name":"Papua New Guinea","flag":"🇵🇬","code":"PG","dial_code":"+675"},{"name":"Paraguay","flag":"🇵🇾","code":"PY","dial_code":"+595"},{"name":"Peru","flag":"🇵🇪","code":"PE","dial_code":"+51"},{"name":"Philippines","flag":"🇵🇭","code":"PH","dial_code":"+63"},{"name":"Pitcairn","flag":"🇵🇳","code":"PN","dial_code":"+64"},{"name":"Poland","flag":"🇵🇱","code":"PL","dial_code":"+48"},{"name":"Portugal","flag":"🇵🇹","code":"PT","dial_code":"+351"},{"name":"Puerto Rico","flag":"🇵🇷","code":"PR","dial_code":"+1939"},{"name":"Qatar","flag":"🇶🇦","code":"QA","dial_code":"+974"},{"name":"Romania","flag":"🇷🇴","code":"RO","dial_code":"+40"},{"name":"Russia","flag":"🇷🇺","code":"RU","dial_code":"+7"},{"name":"Rwanda","flag":"🇷🇼","code":"RW","dial_code":"+250"},{"name":"Reunion","flag":"🇷🇪","code":"RE","dial_code":"+262"},{"name":"Saint Barthelemy","flag":"🇧🇱","code":"BL","dial_code":"+590"},{"name":"Saint Helena, Ascension and Tristan Da Cunha","flag":"🇸🇭","code":"SH","dial_code":"+290"},{"name":"Saint Kitts and Nevis","flag":"🇰🇳","code":"KN","dial_code":"+1869"},{"name":"Saint Lucia","flag":"🇱🇨","code":"LC","dial_code":"+1758"},{"name":"Saint Martin","flag":"🇲🇫","code":"MF","dial_code":"+590"},{"name":"Saint Pierre and Miquelon","flag":"🇵🇲","code":"PM","dial_code":"+508"},{"name":"Saint Vincent and the Grenadines","flag":"🇻🇨","code":"VC","dial_code":"+1784"},{"name":"Samoa","flag":"🇼🇸","code":"WS","dial_code":"+685"},{"name":"San Marino","flag":"🇸🇲","code":"SM","dial_code":"+378"},{"name":"Sao Tome and Principe","flag":"🇸🇹","code":"ST","dial_code":"+239"},{"name":"Saudi Arabia","flag":"🇸🇦","code":"SA","dial_code":"+966"},{"name":"Senegal","flag":"🇸🇳","code":"SN","dial_code":"+221"},{"name":"Serbia","flag":"🇷🇸","code":"RS","dial_code":"+381"},{"name":"Seychelles","flag":"🇸🇨","code":"SC","dial_code":"+248"},{"name":"Sierra Leone","flag":"🇸🇱","code":"SL","dial_code":"+232"},{"name":"Singapore","flag":"🇸🇬","code":"SG","dial_code":"+65"},{"name":"Slovakia","flag":"🇸🇰","code":"SK","dial_code":"+421"},{"name":"Slovenia","flag":"🇸🇮","code":"SI","dial_code":"+386"},{"name":"Solomon Islands","flag":"🇸🇧","code":"SB","dial_code":"+677"},{"name":"Somalia","flag":"🇸🇴","code":"SO","dial_code":"+252"},{"name":"South Africa","flag":"🇿🇦","code":"ZA","dial_code":"+27"},{"name":"South Sudan","flag":"🇸🇸","code":"SS","dial_code":"+211"},{"name":"South Georgia and the South Sandwich Islands","flag":"🇬🇸","code":"GS","dial_code":"+500"},{"name":"Spain","flag":"🇪🇸","code":"ES","dial_code":"+34"},{"name":"Sri Lanka","flag":"🇱🇰","code":"LK","dial_code":"+94"},{"name":"Sudan","flag":"🇸🇩","code":"SD","dial_code":"+249"},{"name":"Suriname","flag":"🇸🇷","code":"SR","dial_code":"+597"},{"name":"Svalbard and Jan Mayen","flag":"🇸🇯","code":"SJ","dial_code":"+47"},{"name":"Swaziland","flag":"🇸🇿","code":"SZ","dial_code":"+268"},{"name":"Sweden","flag":"🇸🇪","code":"SE","dial_code":"+46"},{"name":"Switzerland","flag":"🇨🇭","code":"CH","dial_code":"+41"},{"name":"Syrian Arab Republic","flag":"🇸🇾","code":"SY","dial_code":"+963"},{"name":"Taiwan","flag":"🇹🇼","code":"TW","dial_code":"+886"},{"name":"Tajikistan","flag":"🇹🇯","code":"TJ","dial_code":"+992"},{"name":"Tanzania, United Republic of Tanzania","flag":"🇹🇿","code":"TZ","dial_code":"+255"},{"name":"Thailand","flag":"🇹🇭","code":"TH","dial_code":"+66"},{"name":"Timor-Leste","flag":"🇹🇱","code":"TL","dial_code":"+670"},{"name":"Togo","flag":"🇹🇬","code":"TG","dial_code":"+228"},{"name":"Tokelau","flag":"🇹🇰","code":"TK","dial_code":"+690"},{"name":"Tonga","flag":"🇹🇴","code":"TO","dial_code":"+676"},{"name":"Trinidad and Tobago","flag":"🇹🇹","code":"TT","dial_code":"+1868"},{"name":"Tunisia","flag":"🇹🇳","code":"TN","dial_code":"+216"},{"name":"Turkey","flag":"🇹🇷","code":"TR","dial_code":"+90"},{"name":"Turkmenistan","flag":"🇹🇲","code":"TM","dial_code":"+993"},{"name":"Turks and Caicos Islands","flag":"🇹🇨","code":"TC","dial_code":"+1649"},{"name":"Tuvalu","flag":"🇹🇻","code":"TV","dial_code":"+688"},{"name":"Uganda","flag":"🇺🇬","code":"UG","dial_code":"+256"},{"name":"Ukraine","flag":"🇺🇦","code":"UA","dial_code":"+380"},{"name":"United Arab Emirates","flag":"🇦🇪","code":"AE","dial_code":"+971"},{"name":"United Kingdom","flag":"🇬🇧","code":"GB","dial_code":"+44"},{"name":"United States","flag":"🇺🇸","code":"US","dial_code":"+1"},{"name":"Uruguay","flag":"🇺🇾","code":"UY","dial_code":"+598"},{"name":"Uzbekistan","flag":"🇺🇿","code":"UZ","dial_code":"+998"},{"name":"Vanuatu","flag":"🇻🇺","code":"VU","dial_code":"+678"},{"name":"Venezuela, Bolivarian Republic of Venezuela","flag":"🇻🇪","code":"VE","dial_code":"+58"},{"name":"Vietnam","flag":"🇻🇳","code":"VN","dial_code":"+84"},{"name":"Virgin Islands, British","flag":"🇻🇬","code":"VG","dial_code":"+1284"},{"name":"Virgin Islands, U.S.","flag":"🇻🇮","code":"VI","dial_code":"+1340"},{"name":"Wallis and Futuna","flag":"🇼🇫","code":"WF","dial_code":"+681"},{"name":"Yemen","flag":"🇾🇪","code":"YE","dial_code":"+967"},{"name":"Zambia","flag":"🇿🇲","code":"ZM","dial_code":"+260"},{"name":"Zimbabwe","flag":"🇿🇼","code":"ZW","dial_code":"+263"}]

/***/ }),
/* 980 */,
/* 981 */,
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_MainApp__ = __webpack_require__(2881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_MainApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_MainApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audience__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__campaign__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filebox__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__interaction__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__channel__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__company__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__profile__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__social__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__surveys__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__surveybuilder__ = __webpack_require__(1160);





















var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */]), [{
  path: '/app',
  component: __WEBPACK_IMPORTED_MODULE_2__components_app_MainApp___default.a,
  children: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__admin__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__audience__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__campaign__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__dashboard__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__filebox__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__interaction__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__channel__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__company__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__profile__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__social__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__rules__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__surveys__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__surveybuilder__["a" /* default */]))
}, { path: '*', redirect: '/' }]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!localStorage.getItem('token')) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_activities__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_afstereo__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_alerts__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_analytics__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_auth__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_campaign__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_channel__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_company__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_contacts__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_filebox__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_interaction__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_modals__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_plugin__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_profile__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_rules__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_social__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_stationactivity__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_survey__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_telegram__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_timeslots__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_toast__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_tokens__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_user__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_blacklist__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_whatsapp__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_publishing__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_surveybuilder__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_privacy__ = __webpack_require__(1230);



































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  strict: "production" !== 'production'

}, __WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */], {
  modules: {
    activities: __WEBPACK_IMPORTED_MODULE_4__modules_activities__["a" /* default */],
    afstereo: __WEBPACK_IMPORTED_MODULE_5__modules_afstereo__["a" /* default */],
    alerts: __WEBPACK_IMPORTED_MODULE_6__modules_alerts__["a" /* default */],
    analytics: __WEBPACK_IMPORTED_MODULE_7__modules_analytics__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_8__modules_auth__["a" /* default */],
    campaign: __WEBPACK_IMPORTED_MODULE_9__modules_campaign__["a" /* default */],
    channel: __WEBPACK_IMPORTED_MODULE_10__modules_channel__["a" /* default */],
    company: __WEBPACK_IMPORTED_MODULE_11__modules_company__["a" /* default */],
    contacts: __WEBPACK_IMPORTED_MODULE_12__modules_contacts__["a" /* default */],
    filebox: __WEBPACK_IMPORTED_MODULE_13__modules_filebox__["a" /* default */],
    interaction: __WEBPACK_IMPORTED_MODULE_14__modules_interaction__["a" /* default */],
    modals: __WEBPACK_IMPORTED_MODULE_15__modules_modals__["a" /* default */],
    plugin: __WEBPACK_IMPORTED_MODULE_16__modules_plugin__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_17__modules_profile__["a" /* default */],
    rules: __WEBPACK_IMPORTED_MODULE_18__modules_rules__["a" /* default */],
    social: __WEBPACK_IMPORTED_MODULE_19__modules_social__["a" /* default */],
    stationactivity: __WEBPACK_IMPORTED_MODULE_20__modules_stationactivity__["a" /* default */],
    survey: __WEBPACK_IMPORTED_MODULE_21__modules_survey__["a" /* default */],
    telegram: __WEBPACK_IMPORTED_MODULE_22__modules_telegram__["a" /* default */],
    timeslots: __WEBPACK_IMPORTED_MODULE_23__modules_timeslots__["a" /* default */],
    toast: __WEBPACK_IMPORTED_MODULE_24__modules_toast__["a" /* default */],
    tokens: __WEBPACK_IMPORTED_MODULE_25__modules_tokens__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_26__modules_user__["a" /* default */],
    blacklist: __WEBPACK_IMPORTED_MODULE_27__modules_blacklist__["a" /* default */],
    whatsapp: __WEBPACK_IMPORTED_MODULE_28__modules_whatsapp__["a" /* default */],
    publishing: __WEBPACK_IMPORTED_MODULE_29__modules_publishing__["a" /* default */],
    surveybuilder: __WEBPACK_IMPORTED_MODULE_30__modules_surveybuilder__["a" /* default */],
    privacy: __WEBPACK_IMPORTED_MODULE_31__modules_privacy__["a" /* default */]
  }
})));

/***/ }),
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2530)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1291),
  /* template */
  __webpack_require__(3386),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */,
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPLETENESS_FIELD_LABELS; });
/* unused harmony export DAYS */
/* unused harmony export MONTHS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return dayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return monthName; });
/* unused harmony export toTitleCase */
/* unused harmony export recaseCounts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return buildFilterOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return buildAvailableSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deriveScopedCounts; });
/* unused harmony export visibleOptions */
/* unused harmony export filterNonZero */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return filtersFromAiSearch; });
/* unused harmony export timeslotTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return countActiveFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return buildActivePills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearPill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buildFilterSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return rgbAlpha; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__segmentation__ = __webpack_require__(307);
/* unused harmony reexport formatNumber */
/* unused harmony reexport getChannelName */



/**
 * Filter helpers for the Audience Segmentation dashboard.
 *
 * Sections in this file:
 *   1. Default state
 *   2. Static labels (completeness fields, days, months)
 *   3. Casing helpers (title-case, "Other" bucket recasing)
 *   4. Option builders (aggregate counts -> dropdown options)
 *   5. Derived "Other" counts (display-casing for the live aggregate)
 *   6. Filter params (localFilters -> GraphQL/REST query params)
 *   7. Active filter count / pills (for the filter drawer's summary UI)
 *   8. Misc display helpers (filter summary text, colour alpha)
 */



// ============================================================
// 1. Default state
// ============================================================

/** Empty/unfiltered shape of localFilters — every filter section's v-model starts here. */
var DEFAULT_FILTERS = {
  segments: [],
  genders: [],
  ageGroups: [],
  languages: [],
  locations: [],
  ethnicities: [],
  tags: [],
  channels: [],
  lsmTiers: [],
  campaignTypes: [],
  peakTimesOfDay: [],
  daysOfWeek: [],
  months: [],
  weekdayPattern: null,
  missingFields: [],
  publicHolidays: [],
  timeslots: [],
  interests: [],
  interestsAny: [],
  intentCategories: [],
  intentTier: '',
  optIn: false,
  permission: false,
  originator: '',
  // A saved audience whose members are listed; the name is display-only.
  audienceId: '',
  audienceName: '',
  profileComplete: null,
  enriched: null,
  linkedStatus: '',
  linkedTypes: []
};

// ============================================================
// 2. Static labels
// ============================================================

/** Display labels for the profile-completeness field list (matches backend COMPLETENESS_FIELDS). */
var COMPLETENESS_FIELD_LABELS = ['Mobile Number', 'Gender', 'Age', 'Location', 'Language', 'Ethnicity', 'Name', 'Email Address', 'ID Number'];

var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * @param {number} idx  0-6 (primary_day_of_week)
 * @returns {string}    e.g. "Monday", or "—" if out of range
 */
var dayName = function dayName(idx) {
  return DAYS[idx] || '—';
};

/**
 * @param {number} idx  1-12 (peak_month)
 * @returns {string}    e.g. "Jan", or "—" if out of range
 */
var monthName = function monthName(idx) {
  return MONTHS[(idx || 1) - 1] || '—';
};

// ============================================================
// 3. Casing helpers
// ============================================================

/**
 * Fields whose aggregate has a genuine "other" bucket (a catch-all for
 * values outside a small known set) that needs consistent display
 * casing — see aggregate_formatter.py on the backend for the matching
 * bucket logic. age_group is handled the same way but kept as its own
 * explicit line in deriveScopedCounts() rather than listed here.
 */
var OTHER_BUCKET_FIELDS = ['genderCounts', 'languageCounts', 'locationCounts', 'ethnicityCounts', 'inferredLsmCounts'];

/**
 * @param {string} str
 * @returns {string}  Title Case, e.g. "johannesburg" -> "Johannesburg"
 */
var toTitleCase = function toTitleCase(str) {
  return str.toLowerCase().split(' ').filter(Boolean).map(function (w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(' ');
};

/**
 * Title-cases every key in a counts map, merging any keys that collide
 * after casing (and treating a blank/whitespace key as "Other").
 * @param {Object} counts  raw counts keyed by lowercase value, e.g. {male: 4}
 * @returns {Object}       same counts, keyed by display-cased value
 */
var recaseCounts = function recaseCounts(counts) {
  if (!counts) {
    return {};
  }
  var result = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(counts).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var key = k && k.trim() ? toTitleCase(k.trim()) : 'Other';
    result[key] = (result[key] || 0) + v;
  });
  return result;
};

// ============================================================
// 4. Option builders
// ============================================================

/**
 * Builds a sorted, de-duplicated list of selectable option labels from
 * a raw counts map. "Other" (any casing) always sorts last.
 * @param {Object} counts  raw counts, e.g. {male: 4, other: 6}
 * @param {boolean} cap    title-case non-"other" values (used for free-text
 *                         fields like gender/location; left false for
 *                         fields whose values are already well-formed,
 *                         like segment keys or campaign types)
 * @returns {string[]}
 */
var fromCounts = function fromCounts(counts) {
  var cap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!counts) {
    return [];
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(counts).filter(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    return k && v > 0;
  }).map(function (_ref5) {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 1),
        k = _ref6[0];

    var s = k.trim();
    if (!s) {
      return null;
    }
    if (s.toLowerCase() === 'other') {
      return 'Other';
    }
    return cap ? toTitleCase(s) : s;
  }).filter(function (v) {
    return v !== null;
  }).filter(function (v, i, arr) {
    return arr.indexOf(v) === i;
  }).sort(function (a, b) {
    var aIsOther = a.toLowerCase() === 'other';
    var bIsOther = b.toLowerCase() === 'other';
    if (aIsOther) {
      return 1;
    }
    if (bIsOther) {
      return -1;
    }
    return a.localeCompare(b);
  });
};

/**
 * timeslot_counts is {id: {title, count}}, not {id: count} like every
 * other facet — needs its own builder rather than fromCounts.
 *
 * Note: Id 0 is "Other", the listeners with no timeslot. It always goes last,
 * whatever its count.
 * @param {Object} timeslotCounts
 * @returns {Array<{id: number, title: string, count: number}>}
 */
var fromTimeslotCounts = function fromTimeslotCounts(timeslotCounts) {
  if (!timeslotCounts) {
    return [];
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(timeslotCounts).map(function (_ref7) {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
        id = _ref8[0],
        data = _ref8[1];

    return {
      id: parseInt(id, 10),
      title: data.title,
      count: data.count
    };
  }).sort(function (a, b) {
    if (a.id === 0 || b.id === 0) {
      return a.id === 0 ? 1 : -1;
    }
    return b.count - a.count;
  });
};

/**
 * Builds every filter section's dropdown options from one aggregate
 * response. Called once whenever the unfiltered ("base") aggregate
 * query resolves.
 * @param {Object} agg  baseAggregate from the container
 * @returns {Object}    options keyed by filter group, e.g. {genders: [...], ...}
 */
var buildFilterOptions = function buildFilterOptions(agg) {
  return {
    genders: fromCounts(agg.genderCounts, true),
    ageGroups: fromCounts(agg.ageGroupCounts, false),
    languages: fromCounts(agg.languageCounts, true),
    locations: fromCounts(agg.locationCounts, true),
    ethnicities: fromCounts(agg.ethnicityCounts, true),
    tags: fromCounts(agg.tagCounts, false),
    campaignTypes: fromCounts(agg.campaignTypeCounts, false),
    peakTimesOfDay: fromCounts(agg.peakTimeOfDayCounts, true),
    publicHolidays: fromCounts(agg.publicHolidayCounts, false),
    timeslots: fromTimeslotCounts(agg.timeslotCounts),
    lsmTiers: fromCounts(agg.inferredLsmCounts, true),
    channels: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(agg.channelCounts || {}).filter(function (_ref9) {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
          v = _ref10[1];

      return v > 0;
    }).map(function (_ref11) {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 1),
          k = _ref12[0];

      return parseInt(k, 10);
    }).filter(function (n) {
      return !isNaN(n);
    }),
    daysOfWeek: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(agg.primaryDayOfWeekCounts || {}).filter(function (_ref13) {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
          v = _ref14[1];

      return v > 0;
    }).map(function (_ref15) {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref15, 1),
          k = _ref16[0];

      return parseInt(k, 10);
    }).filter(function (n) {
      return !isNaN(n);
    }).sort(function (a, b) {
      return a - b;
    }),
    months: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(agg.peakMonthCounts || {}).filter(function (_ref17) {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
          v = _ref18[1];

      return v > 0;
    }).map(function (_ref19) {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref19, 1),
          k = _ref20[0];

      return parseInt(k, 10);
    }).filter(function (n) {
      return !isNaN(n);
    }).sort(function (a, b) {
      return a - b;
    })
  };
};

/**
 * Builds the ordered segment list (with counts) for the segment
 * filter/summary, in SEGMENT_ORDER rather than count order.
 * @param {Object} segmentCounts  from summary.segmentCounts
 * @returns {Array<{key, count, label, colour, icon}>}
 */
var buildAvailableSegments = function buildAvailableSegments(segmentCounts) {
  return __WEBPACK_IMPORTED_MODULE_3__segmentation__["h" /* SEGMENT_ORDER */].map(function (key) {
    return {
      key: key,
      count: segmentCounts[key] || 0,
      label: __WEBPACK_IMPORTED_MODULE_3__segmentation__["i" /* SEGMENT_LABELS */][key] || key,
      colour: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__segmentation__["j" /* getSegmentColour */])(key),
      icon: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__segmentation__["k" /* getSegmentIcon */])(key)
    };
  });
};

// ============================================================
// 5. Derived "Other" counts
// ============================================================

/**
 * Re-cases a *live, filter-scoped* aggregate response so its "Other"
 * buckets display consistently with the option labels built from the
 * base aggregate (buildFilterOptions/fromCounts). Needed because the
 * raw GraphQL response is always lowercase (e.g. "male", "other").
 * @param {Object} agg  raw aggregate from the live, filter-scoped query
 * @returns {Object}    same aggregate with display-cased buckets
 */
var deriveScopedCounts = function deriveScopedCounts(agg) {
  if (!agg) {
    return agg;
  }
  var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, agg);
  OTHER_BUCKET_FIELDS.forEach(function (field) {
    result[field] = recaseCounts(agg[field]);
  });
  if (agg.ageGroupCounts) {
    result.ageGroupCounts = recaseCounts(agg.ageGroupCounts);
  }
  return result;
};

/**
 * Narrows a list of options down to only those with a non-zero count —
 * falls back to the full list if that would leave nothing to show.
 * @param {Array} options
 * @param {Object} counts
 * @returns {Array}
 */
var visibleOptions = function visibleOptions(options, counts) {
  if (!counts) {
    return options;
  }
  var filtered = options.filter(function (o) {
    return (counts[o] || 0) > 0;
  });
  return filtered.length > 0 ? filtered : options;
};

/**
 * Same idea as visibleOptions, but always narrows (no fallback) — used
 * where showing a stale option with a genuine zero count would be
 * actively misleading (e.g. active-pill chips).
 * @param {string[]} options
 * @param {Object}   counts
 * @returns {string[]}
 */
var filterNonZero = function filterNonZero(options, counts) {
  if (!counts) {
    return options;
  }
  return options.filter(function (o) {
    return (counts[o] || 0) > 0;
  });
};

// ============================================================
// 6. Filter params
// ============================================================

/**
 * Declarative config for buildFilterParams: most filters just need a
 * query param name and an optional lowercase transform. Entries
 * needing a different shape (single-vs-list, comma-join, booleans,
 * nullable scalars) are handled separately below the loop, since
 * forcing them into this table would obscure their real shape.
 */
var LIST_PARAM_MAP = [{ field: 'genders', param: 'gender', lower: true }, { field: 'ageGroups', param: 'ageGroup' }, { field: 'languages', param: 'language', lower: true }, { field: 'locations', param: 'location', lower: true }, { field: 'ethnicities', param: 'ethnicity', lower: true }, { field: 'lsmTiers', param: 'inferredLsm', lower: true }, { field: 'channels', param: 'channelType' }, { field: 'campaignTypes', param: 'campaignType' }, { field: 'peakTimesOfDay', param: 'peakTimeOfDay', lower: true }, { field: 'daysOfWeek', param: 'primaryDayOfWeek' }, { field: 'months', param: 'peakMonth' }, { field: 'missingFields', param: 'missingFields' }, { field: 'publicHolidays', param: 'publicHoliday' }, { field: 'timeslots', param: 'timeslotId' }, { field: 'intentCategories', param: 'intentCategory' }];

/**
 * Converts the dashboard's localFilters (display-cased, e.g. "Male",
 * "Lower-Middle") into the query params the backend expects (mostly
 * lowercase, since that's how values are stored in Mongo).
 * @param {Object} filters  localFilters from Dashboard data
 * @returns {Object}        params to emit to the container
 */
var buildFilterParams = function buildFilterParams(filters) {
  var p = {};

  LIST_PARAM_MAP.forEach(function (_ref21) {
    var field = _ref21.field,
        param = _ref21.param,
        lower = _ref21.lower;

    var values = filters[field];
    if (values && values.length > 0) {
      p[param] = lower ? values.map(function (v) {
        return v.toLowerCase();
      }) : values;
    }
  });

  // segment: single value when exactly one selected, list otherwise
  if (filters.segments.length > 0) {
    p.segment = filters.segments.length === 1 ? filters.segments[0] : filters.segments;
  }

  // tags: comma-joined string, not an array
  if (filters.tags.length > 0) {
    p.tags = filters.tags.join(',');
  }

  // interests: comma-joined strings — all of / any of
  if (filters.interests && filters.interests.length > 0) {
    p.inferredInterests = filters.interests.join(',');
  }
  if (filters.interestsAny && filters.interestsAny.length > 0) {
    p.interestsAny = filters.interestsAny.join(',');
  }

  if (filters.intentTier) {
    p.intentTier = filters.intentTier;
  }

  // booleans and nullable scalars — no list logic applies
  if (filters.weekdayPattern !== null && filters.weekdayPattern !== undefined) {
    p.weekdayPattern = filters.weekdayPattern;
  }
  if (filters.optIn) {
    p.optIn = true;
  }
  if (filters.permission) {
    p.permission = true;
  }
  if (filters.originator) {
    p.originator = filters.originator;
  }
  if (filters.audienceId) {
    p.audienceId = filters.audienceId;
  }
  if (filters.profileComplete !== null && filters.profileComplete !== undefined) {
    p.profileComplete = filters.profileComplete;
  }
  if (filters.enriched !== null && filters.enriched !== undefined) {
    p.enriched = filters.enriched;
  }
  if (filters.linkedStatus) {
    p.linkedStatus = filters.linkedStatus;
  }
  if ((filters.linkedTypes || []).length) {
    p.linkedType = filters.linkedTypes;
  }

  return p;
};

/**
 * Turns the search-filters API result (snake_case, lowercase values) into
 * a complete localFilters object. A search starts from a clean slate —
 * it replaces whatever was selected before.
 * @param {Object} ai  `filters` from the searchFilters mutation
 * @returns {Object}   localFilters
 */
var filtersFromAiSearch = function filtersFromAiSearch() {
  var ai = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_FILTERS, {
    segments: ai.segment || [],
    genders: (ai.gender || []).map(toTitleCase),
    ageGroups: (ai.age_group || []).map(toTitleCase),
    ethnicities: (ai.ethnicity || []).map(toTitleCase),
    languages: (ai.language || []).map(toTitleCase),
    locations: (ai.location || []).map(toTitleCase),
    channels: ai.channel_type || [],
    interests: ai.inferred_interests || [],
    interestsAny: ai.interests_any || [],
    optIn: ai.opt_in === true,
    permission: ai.permission === true
  });
};

// ============================================================
// 7. Active filter count / pills
// ============================================================

/**
 * @param {number} id
 * @param {Array} timeslotOptions  options.timeslots
 * @returns {string}
 */
var timeslotTitle = function timeslotTitle(id, timeslotOptions) {
  var match = (timeslotOptions || []).find(function (t) {
    return t.id === id;
  });
  if (match) {
    return match.title;
  }
  return id === 0 ? 'Other' : 'Timeslot ' + id;
};

/**
 * Total number of individually active filter selections, across every
 * group — drives the "N filters active" badge on the filter drawer.
 * @param {Object} filters  localFilters
 * @returns {number}
 */
var countActiveFilters = function countActiveFilters(filters) {
  return filters.segments.length + filters.genders.length + filters.ageGroups.length + filters.languages.length + filters.locations.length + filters.ethnicities.length + filters.tags.length + filters.channels.length + filters.lsmTiers.length + filters.campaignTypes.length + filters.peakTimesOfDay.length + filters.daysOfWeek.length + filters.months.length + filters.missingFields.length + filters.publicHolidays.length + filters.timeslots.length + (filters.interests || []).length + (filters.interestsAny || []).length + (filters.intentCategories || []).length + (filters.intentTier ? 1 : 0) + (filters.weekdayPattern !== null && filters.weekdayPattern !== undefined ? 1 : 0) + (filters.optIn ? 1 : 0) + (filters.permission ? 1 : 0) + (filters.originator ? 1 : 0) + (filters.audienceId ? 1 : 0) + (filters.profileComplete !== null && filters.profileComplete !== undefined ? 1 : 0) + (filters.enriched !== null && filters.enriched !== undefined ? 1 : 0) + (filters.linkedStatus ? 1 : 0) + (filters.linkedTypes || []).length;
};

/**
 * Builds the dismissible "active filter" chips shown above the listener
 * grid — one entry per individual selection, keyed so clearPill() can
 * remove exactly that one selection later.
 * @param {Object} filters  localFilters
 * @param {Array} timeslotOptions  options.timeslots, for title lookup
 * @returns {Object}        { key: label }
 */
var buildActivePills = function buildActivePills(filters) {
  var timeslotOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var pills = {};

  filters.segments.forEach(function (s) {
    pills['seg_' + s] = 'Segment: ' + (__WEBPACK_IMPORTED_MODULE_3__segmentation__["i" /* SEGMENT_LABELS */][s] || s);
  });
  filters.genders.forEach(function (g) {
    pills['gen_' + g] = 'Gender: ' + g;
  });
  filters.ageGroups.forEach(function (a) {
    pills['age_' + a] = 'Age: ' + a;
  });
  filters.languages.forEach(function (l) {
    pills['lang_' + l] = 'Language: ' + l;
  });
  filters.locations.forEach(function (l) {
    pills['loc_' + l] = 'Location: ' + l;
  });
  filters.ethnicities.forEach(function (e) {
    pills['eth_' + e] = 'Ethnicity: ' + e;
  });
  filters.tags.forEach(function (t) {
    pills['tag_' + t] = 'Tag: ' + t.replace(/_/g, ' ');
  });
  filters.channels.forEach(function (c) {
    pills['chan_' + c] = 'Channel: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__segmentation__["l" /* getChannelName */])(c);
  });
  filters.lsmTiers.forEach(function (l) {
    pills['lsm_' + l] = 'LSM: ' + l;
  });
  filters.campaignTypes.forEach(function (c) {
    pills['camp_' + c] = 'Campaign: ' + c.replace(/_/g, ' ');
  });
  filters.peakTimesOfDay.forEach(function (t) {
    pills['ptod_' + t] = 'Peak Time: ' + t;
  });
  filters.daysOfWeek.forEach(function (d) {
    pills['day_' + d] = 'Day: ' + dayName(d);
  });
  filters.months.forEach(function (m) {
    pills['month_' + m] = 'Month: ' + monthName(m);
  });
  filters.missingFields.forEach(function (f) {
    pills['miss_' + f] = 'Missing: ' + f;
  });
  filters.publicHolidays.forEach(function (h) {
    pills['hol_' + h] = 'Holiday: ' + h;
  });
  filters.timeslots.forEach(function (id) {
    pills['ts_' + id] = 'Timeslot: ' + timeslotTitle(id, timeslotOptions);
  });
  (filters.interests || []).forEach(function (i) {
    pills['int_' + i] = 'Interest (all): ' + i;
  });
  (filters.interestsAny || []).forEach(function (i) {
    pills['inta_' + i] = 'Interest (any): ' + i;
  });
  (filters.intentCategories || []).forEach(function (c) {
    pills['intc_' + c] = 'Intent in: ' + c;
  });
  if (filters.intentTier) {
    pills.intentTier = 'Intent: ' + filters.intentTier + ' or higher';
  }

  if (filters.weekdayPattern !== null && filters.weekdayPattern !== undefined) {
    pills.weekdayPattern = filters.weekdayPattern ? 'Weekday listener' : 'Weekend listener';
  }
  if (filters.optIn) {
    pills.optIn = 'Opted in';
  }
  if (filters.permission) {
    pills.permission = 'Permission granted';
  }
  if (filters.originator) {
    pills.originator = 'Search: ' + filters.originator;
  }
  if (filters.audienceId) {
    pills.audience = 'Audience: ' + (filters.audienceName || 'saved audience');
  }
  if (filters.profileComplete !== null && filters.profileComplete !== undefined) {
    pills.profileComplete = filters.profileComplete ? 'Complete profiles' : 'Incomplete profiles';
  }
  if (filters.linkedStatus) {
    var text = {
      any: 'Has linked identifiers',
      unreviewed: 'Linked, not reviewed',
      confirmed: 'Linked, confirmed'
    };
    pills.linkedStatus = text[filters.linkedStatus] || 'Linked identifiers';
  }
  (filters.linkedTypes || []).forEach(function (t) {
    pills['lnk_' + t] = 'Linked: ' + t.replace(/_handle$/, '').replace(/_/g, ' ');
  });
  if (filters.enriched !== null && filters.enriched !== undefined) {
    pills.enriched = filters.enriched ? 'AI enriched' : 'Needs AI enrichment';
  }

  return pills;
};

/**
 * Removes exactly one active-pill selection (by its buildActivePills
 * key) from localFilters, returning a new filters object.
 * @param {Object} filters  current localFilters
 * @param {string} key      pill key, e.g. 'gen_Male'
 * @returns {Object}        updated filters
 */
var clearPill = function clearPill(filters, key) {
  var f = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filters);

  var prefixMap = {
    seg_: 'segments',
    gen_: 'genders',
    age_: 'ageGroups',
    lang_: 'languages',
    loc_: 'locations',
    eth_: 'ethnicities',
    tag_: 'tags',
    chan_: 'channels',
    lsm_: 'lsmTiers',
    camp_: 'campaignTypes',
    ptod_: 'peakTimesOfDay',
    day_: 'daysOfWeek',
    month_: 'months',
    miss_: 'missingFields',
    hol_: 'publicHolidays',
    ts_: 'timeslots',
    int_: 'interests',
    inta_: 'interestsAny',
    intc_: 'intentCategories',
    lnk_: 'linkedTypes'
  };

  var match = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(prefixMap).find(function (_ref22) {
    var _ref23 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref22, 1),
        prefix = _ref23[0];

    return key.startsWith(prefix);
  });
  if (match) {
    var _match = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(match, 2),
        prefix = _match[0],
        field = _match[1];

    var raw = key.slice(prefix.length);
    var isNumericField = ['channels', 'daysOfWeek', 'months', 'timeslots'].includes(field);
    f[field] = f[field].filter(function (v) {
      if (isNumericField) {
        return Number(v) !== Number(raw);
      }
      return '' + prefix + v !== key;
    });
    return f;
  }

  if (key === 'intentTier') {
    f.intentTier = '';
  }
  if (key === 'weekdayPattern') {
    f.weekdayPattern = null;
  }
  if (key === 'optIn') {
    f.optIn = false;
  }
  if (key === 'permission') {
    f.permission = false;
  }
  if (key === 'originator') {
    f.originator = '';
  }
  if (key === 'audience') {
    f.audienceId = '';
    f.audienceName = '';
  }
  if (key === 'profileComplete') {
    f.profileComplete = null;
  }
  if (key === 'enriched') {
    f.enriched = null;
  }
  if (key === 'linkedStatus') {
    f.linkedStatus = '';
  }

  return f;
};

// ============================================================
// 8. Misc display helpers
// ============================================================

/**
 * Builds a short, readable English summary of active filters for the
 * AI campaign brief. Not exhaustive — caps at a few notable filters
 * plus a "+N more" tail, since the full structured filters are sent
 * to the backend separately via activeFilters regardless of this text.
 * @param {Object} filters  localFilters
 * @returns {string}
 */
var buildFilterSummary = function buildFilterSummary(filters) {
  var parts = [];

  if (filters.segments.length) {
    parts.push(filters.segments.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_3__segmentation__["i" /* SEGMENT_LABELS */][s] || s;
    }).join('/') + ' listeners');
  }
  if (filters.genders.length) {
    parts.push(filters.genders.join(' and '));
  }
  if (filters.ageGroups.length) {
    parts.push('aged ' + filters.ageGroups.join(', '));
  }
  if (filters.locations.length) {
    parts.push('in ' + filters.locations.slice(0, 2).join(', '));
  }
  if (filters.languages.length) {
    parts.push('speaking ' + filters.languages.join(', '));
  }
  if (filters.ethnicities.length) {
    parts.push(filters.ethnicities.join(', '));
  }
  if (filters.campaignTypes.length) {
    parts.push('engaging with ' + filters.campaignTypes.map(function (c) {
      return c.replace(/_/g, ' ');
    }).join(', ') + ' campaigns');
  }
  if ((filters.interestsAny || []).length) {
    parts.push('interested in ' + filters.interestsAny.slice(0, 3).join(' or '));
  }
  if ((filters.interests || []).length) {
    parts.push('interested in ' + filters.interests.slice(0, 3).join(' and '));
  }
  if (filters.tags.length) {
    parts.push('tagged ' + filters.tags.slice(0, 2).map(function (t) {
      return t.replace(/_/g, ' ');
    }).join(', '));
  }
  if (filters.peakTimesOfDay.length) {
    parts.push('peak ' + filters.peakTimesOfDay.map(function (t) {
      return t.replace(/_/g, ' ');
    }).join('/'));
  }
  if (filters.daysOfWeek.length) {
    parts.push('favouring ' + filters.daysOfWeek.map(dayName).join(', '));
  }
  if (filters.weekdayPattern !== null && filters.weekdayPattern !== undefined) {
    parts.push(filters.weekdayPattern ? 'weekday listeners' : 'weekend listeners');
  }
  if (filters.publicHolidays.length) {
    parts.push('active on ' + filters.publicHolidays.slice(0, 1).join(', '));
  }
  if (filters.optIn) {
    parts.push('opted in');
  }
  if (filters.permission) {
    parts.push('with permission granted');
  }

  var total = countActiveFilters(filters);
  var shown = parts.length;
  var capped = parts.slice(0, 5);
  var remaining = total - Math.min(shown, 5);

  var summary = capped.join(', ');
  if (remaining > 0) {
    summary += ' (+' + remaining + ' more filter' + (remaining > 1 ? 's' : '') + ')';
  }

  return summary;
};

/**
 * @param {string} colour  e.g. 'rgb(104, 48, 144)'
 * @param {number} alpha   opacity 0-1
 * @returns {string}       the same colour as rgba(), e.g. 'rgba(104, 48, 144, 0.06)'
 */
var rgbAlpha = function rgbAlpha(colour) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.06;
  return colour.replace('rgb(', 'rgba(').replace(')', ', ' + alpha + ')');
};



/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXPORT_FIELD_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUCKET_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXPORT_PRESETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_EXPORT_FIELDS; });
/* unused harmony export csvCell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toCsv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/**
 * Columns a station can put in a listener export. Keys match the
 * segmentation service's export catalog; anything else it ignores.
 */
var EXPORT_FIELD_GROUPS = [{
  label: 'Identity',
  icon: 'fa-id-card-o',
  fields: [{ key: 'originator', label: 'Originator', locked: true }, { key: 'name', label: 'Name' }, { key: 'mobile', label: 'Mobile number' }, { key: 'email', label: 'Email' }, { key: 'originator_type', label: 'Originator type' }]
}, {
  label: 'Engagement',
  icon: 'fa-bolt',
  fields: [{ key: 'segment', label: 'Segment' }, { key: 'channel', label: 'Main channel' }, { key: 'channels', label: 'All channels' }, { key: 'recency_days', label: 'Days since last activity' }, { key: 'last_interaction', label: 'Last interaction date' }, { key: 'first_interaction', label: 'First interaction date' }, { key: 'interactions_total', label: 'Total interactions' }, { key: 'interactions_30d', label: 'Interactions (30 days)' }, { key: 'tags', label: 'Tags' }]
}, {
  label: 'Demographics',
  icon: 'fa-users',
  fields: [{ key: 'gender', label: 'Gender' }, { key: 'age_group', label: 'Age group' }, { key: 'location', label: 'Location' }, { key: 'language', label: 'Language' }, { key: 'ethnicity', label: 'Ethnicity' }, { key: 'lsm', label: 'LSM tier' }]
}, {
  label: 'AI & consent',
  icon: 'fa-magic',
  fields: [{ key: 'interests', label: 'Interests (AI)' }, { key: 'return_likelihood', label: 'Return outlook' }, { key: 'opt_in', label: 'Opted in' }, { key: 'permission', label: 'Permission' }]
}, {
  label: 'Export',
  icon: 'fa-download',
  fields: [{ key: 'export_date', label: 'Export date' }]
}];

/** Offered only when exporting from the retarget bucket. */
var BUCKET_FIELDS = [{ key: 'group', label: 'Retarget group' }];

var EXPORT_PRESETS = [{ label: 'Just originator', fields: ['originator'] }, { label: 'Contact list', fields: ['originator', 'name', 'mobile', 'email', 'channel', 'opt_in'] }, {
  label: 'Audience profile',
  fields: ['originator', 'segment', 'gender', 'age_group', 'location', 'language']
}, {
  label: 'Engagement',
  fields: ['originator', 'segment', 'channel', 'last_interaction', 'interactions_total', 'recency_days']
}];

var DEFAULT_EXPORT_FIELDS = ['originator'];

/** Quotes a CSV cell (commas, quotes and newlines). */
var csvCell = function csvCell(value) {
  var text = value === null || value === undefined ? '' : String(value);
  return (/[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text
  );
};

/** { fields: [{label}], rows: [[...]] } -> CSV text. */
var toCsv = function toCsv(_ref) {
  var fields = _ref.fields,
      rows = _ref.rows;
  return [fields.map(function (f) {
    return csvCell(f.label);
  }).join(',')].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(rows.map(function (r) {
    return r.map(csvCell).join(',');
  }))).join('\n');
};

/***/ }),
/* 999 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCompany"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webSite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faxNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAudience"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"woeid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optinKeywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optoutKeywords"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":286}};
    doc.loc.source = {"body":"query {\n  myCompany {\n    title,\n    webSite,\n    shortName,\n    faxNumber,\n    telephoneNumber,\n    timezone,\n    cumulativeAudience,\n    dateCreated,\n    logoImage,\n    surveyImage,\n    format,\n    genre,\n    country,\n    state,\n    woeid,\n    optinKeywords,\n    optoutKeywords,\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 1000 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AiCredits"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiCredits"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":32}};
    doc.loc.source = {"body":"query AiCredits {\n  aiCredits\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AiCredits"] = oneQuery(doc, "AiCredits");
        


/***/ }),
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql__);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__type__);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__language__);
/* unused harmony reexport Source */
/* unused harmony reexport getLocation */
/* unused harmony reexport parse */
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2__language__, "print")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__language__["print"]; });
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport Kind */
/* unused harmony reexport TokenKind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport BREAK */
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__execution__);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__subscription__);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__validation__);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__error__);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport formatError */
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utilities__);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport getOperationRootType */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport printType */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport coerceValue */
/* unused harmony reexport isValidJSValue */
/* unused harmony reexport isValidLiteralValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findDeprecatedUsages */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */
// The primary entry point into fulfilling a GraphQL request.
 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.

 // Validate GraphQL queries.


// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.


/***/ }),
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var client = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
client.defaults.baseURL = "https://facebook.live.colonyhq.com";

// Interceptors makes mocking our tests very difficult, lets
// ignore them within tests.
if (true) {
  client.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    var requestConfig = config;
    if (token) {
      requestConfig.headers.Authorization = 'JWT ' + token;
    }
    return requestConfig;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  // client.interceptors.response.use(
  //   response => response,
  //   error => {
  //     // Handle when a token has expired
  //     if (error.response.status === 401) {
  //       localStorage.removeItem('token');
  //       window.location.assign('/login');
  //     }
  //     return Promise.reject(error);
  //   },
  // );
}

/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var client = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
client.defaults.baseURL = "https://instagram.live.colonyhq.com";

// Interceptors makes mocking our tests very difficult, lets
// ignore them within tests.
if (true) {
  client.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    var requestConfig = config;
    if (token) {
      requestConfig.headers.Authorization = 'JWT ' + token;
    }
    return requestConfig;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  client.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // Handle when a token has expired
    if (error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.assign('/login');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var client = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
client.defaults.baseURL = "https://telegram.live.colonyhq.com";

/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var client = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
client.defaults.baseURL = "https://stream.live.colonyhq.com";

/* harmony default export */ __webpack_exports__["a"] = (client);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOUR_STEPS; });
/**
 * The Audience Segmentation tour. Each step points at an element marked
 * `data-tour="<target>"`; steps whose element is not on the page (for
 * example the shortcut buttons when the header is hidden) are skipped.
 *
 * placement: where the card sits next to the element (default: below or
 * above, whichever has room). fab: the shortcut buttons must be open.
 */
var TOUR_STEPS = [{
  target: 'header',
  title: 'Welcome to Smart Segmentation',
  text: 'This tour walks through every part of the dashboard, top to bottom. ' + 'Use Next to move on, Back to go back, or Esc to leave at any time.'
}, {
  target: 'segments',
  title: 'Your segments',
  text: 'Every listener is placed in one behavioural segment, such as Super fans or At risk, ' + 'from how recently and how often they engage. Click a card to filter the whole ' + 'dashboard to that segment. The green and red arrows show how many listeners moved in ' + 'and out in the last 7 days (hover "Changed" for the date of the last move), and ' + 'the refresh button reloads the latest data.'
}, {
  target: 'distribution',
  title: 'Segment distribution',
  text: 'The share of your audience in each segment, at a glance.'
}, {
  target: 'breakdown',
  title: 'Segment insights',
  text: 'A closer look at each segment. Open one to see who is in it, how its listeners moved ' + 'between segments over the last 7 days, and an AI reading with a Return Outlook ' + '(uses AI credits, saved for 24 hours).'
}, {
  target: 'profiles',
  title: 'Engaged audience profiles',
  text: 'The make-up of your current audience: gender, age, language, location and more. ' + 'It follows whatever filters you apply.'
}, {
  target: 'cross-channel',
  title: 'Cross platform engagement',
  text: 'Which channels your listeners use together. Click a pair, such as WhatsApp and SMS, ' + 'to export the listeners who are active on both.'
}, {
  target: 'completeness',
  title: 'Profile completeness',
  text: 'How complete listener profiles are, and which details are missing most, so you know ' + 'what to collect next (for example through a survey).'
}, {
  target: 'listeners',
  title: 'Listener retargeting',
  text: 'The listeners behind the numbers. Open any listener for their full profile. Their ' + 'interests and product affinities appear without any AI credits, marked "From ' + 'activity", and AI Enrichment adds more, marked "AI-enriched", with return outlook, ' + 'risk and confidence. From here you can run AI Enrichment for many listeners, Retarget ' + 'them, or Export them. Listeners who have not given permission or opted in are left ' + 'out unless you choose to include them.'
}, {
  target: 'recommender',
  title: 'Campaign recommender',
  text: 'Paste an advertiser brief and the AI recommends who to target, on which channels and ' + 'when, from your real audience data.'
}, {
  target: 'fab-filters',
  title: 'Filters',
  placement: 'left',
  fab: true,
  text: 'Refine the whole dashboard by segment, demographics, channels, activity, consent and ' + 'more. The badge shows how many filters are active.'
}, {
  target: 'fab-find',
  title: 'Find listeners',
  placement: 'left',
  fab: true,
  text: 'Search by name, number or handle, or describe who you want in plain English and let ' + 'the AI turn it into filters.'
}, {
  target: 'fab-audiences',
  title: 'Audiences',
  placement: 'left',
  fab: true,
  text: 'Save a group of listeners by describing them in words. Audiences stay up to date ' + 'every night for free, and you can view, refresh or retarget them.'
}, {
  target: 'fab-advertiser',
  title: 'Advertiser hub',
  placement: 'left',
  fab: true,
  text: 'Prepare and prove a campaign for an advertiser in five tabs: who is ready to respond, ' + 'when to send, whether it worked, a report to hand over, and how earlier advice turned ' + 'out. Set your filters first. The first four tabs follow them.'
}, {
  target: 'fab-bucket',
  title: 'Retargeting bucket',
  placement: 'left',
  fab: true,
  text: 'Everything you set aside to retarget, grouped by where it came from. Export it all, ' + 'or by channel, with the columns you pick.'
}, {
  target: 'fab-ai-usage',
  title: 'AI usage',
  placement: 'left',
  fab: true,
  text: 'Your AI credit balance, what is using it and when it was topped up. Its colour tells ' + 'you at a glance when credit is running low, and it shows any monthly limit Colony ' + 'has set for a feature.'
}, {
  target: 'fab-toggle',
  title: 'Show or hide shortcuts',
  placement: 'left',
  text: 'Hide the shortcut buttons when they are in the way, and bring them back here. ' + 'That is the tour. You can run it again any time from "Take a tour".'
}];

/* unused harmony default export */ var _unused_webpack_default_export = (TOUR_STEPS);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export processDemographicDataByPropForChart */
/* unused harmony export getValueByKeyContaining */
/* unused harmony export processInsightsOverviewDataForChart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return processInsightsOverviewData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processDemographicData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);



var processDemographicDataByPropForChart = function processDemographicDataByPropForChart(values, prop) {
  var res = values ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(values[prop]).sort(function (a, b) {
    return b[1] - a[1];
  }) : [];
  return res;
};

var getValueByKeyContaining = function getValueByKeyContaining(obj, substr) {
  if (!obj) return null;
  var res = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(obj).find(function (x) {
    return x[0].indexOf(substr) !== -1;
  });
  return res ? res[1] : null;
};

var processInsightsOverviewDataForChart = function processInsightsOverviewDataForChart(metric) {
  var key = metric ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(metric)[0] : [];
  var metricsWithProps = getValueByKeyContaining(metric, key);
  var values = getValueByKeyContaining(metricsWithProps, 'values');
  return values || [];
};

var processInsightsOverviewData = function processInsightsOverviewData(data) {
  var viewsTotal = getValueByKeyContaining(data, 'pageViewsTotal');
  var impressionsUnique = getValueByKeyContaining(data, 'pageImpressionsUnique');
  var engagedUsers = getValueByKeyContaining(data, 'pagePostEngagements');
  var fanAddsByPaidNonPaidUnique = getValueByKeyContaining(data, 'pageFanAddsByPaidNonPaidUnique');

  var processedfanAddsPaidby = processInsightsOverviewDataForChart(fanAddsByPaidNonPaidUnique);

  var insightData = {
    pages_views: {
      name: 'page_views',
      title: 'Page Views',
      description: "The number of times a Page's profile has been viewed by logged in and logged out people.",
      values: processInsightsOverviewDataForChart(viewsTotal)
    },
    reach: {
      name: 'reach',
      title: 'Reach',
      description: 'The number of people who had any posts from your Page enter their screen.',
      values: processInsightsOverviewDataForChart(impressionsUnique)
    },
    post_engagements: {
      name: 'post_engagements',
      title: 'Post Engagements',
      description: 'The number of times people have engaged with your posts through likes, comments and shares and more.',
      values: processInsightsOverviewDataForChart(engagedUsers)
    },
    page_likes: {
      name: 'page_likes',
      title: 'Page Likes',
      description: 'The number of people who have liked your page',
      values: processedfanAddsPaidby.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, { value: x.value.total });
      })
    }
  };

  return insightData;
};

var processDemographicData = function processDemographicData(data) {
  // const genderAge = getValueByKeyContaining(data, 'gender');
  var city = getValueByKeyContaining(data, 'city');
  var country = getValueByKeyContaining(data, 'country');
  var locale = getValueByKeyContaining(data, 'locale');

  return {
    // gender: processDemographicDataByPropForChart(genderAge, 'gender'),
    // age: processDemographicDataByPropForChart(genderAge, 'age'),
    city: processDemographicDataByPropForChart(city, 'value'),
    country: processDemographicDataByPropForChart(country, 'value'),
    locale: processDemographicDataByPropForChart(locale, 'value')
  };
};

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageViewsByGenderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDataForLabels; });
var getRandomNumber = function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
var genderLabels = ['<13', '13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

var getPageViewsByGenderData = function getPageViewsByGenderData() {
  return genderLabels.map(function (x) {
    return [x, {
      male: getRandomNumber(0, 6),
      female: getRandomNumber(0, 6)
    }];
  });
};

var getDataForLabels = function getDataForLabels(labels) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  return labels.map(function (x) {
    return [x, getRandomNumber(min, max)];
  });
};

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMessageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCommercialLoadData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMusicalLoadData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTopTracksData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getContentThreadsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAudienceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPromotionsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_random__ = __webpack_require__(568);





var getMessageData = function getMessageData(_ref) {
  var engagement = _ref.engagement;
  var perChannel = engagement.perChannel,
      total = engagement.total,
      totalUnique = engagement.totalUnique,
      uniquesPerChannel = engagement.uniquesPerChannel;

  var channelData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(perChannel);
  var formatKey = function formatKey(key) {
    var formatedKey = key.replace(/([A-Z])/g, ' $1').trim();
    return formatedKey.charAt(0).toUpperCase() + formatedKey.slice(1);
  };
  var chartData = channelData.filter(function (_ref2) {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return key[0] !== '_' && val;
  }).map(function (_ref4) {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
        key = _ref5[0],
        val = _ref5[1];

    return [formatKey(key), { total: val, unique: uniquesPerChannel[key] }];
  });
  return {
    chartData: chartData,
    total: total,
    uniques: totalUnique,
    promos: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_random__["a" /* getRandomNumber */])(0, 100) + '% ??',
    proportion: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_random__["a" /* getRandomNumber */])(0, 25) + '% ??'
  };
};

var getCommercialLoadData = function getCommercialLoadData(_ref6) {
  var commercialLoad = _ref6.commercialLoad;
  return commercialLoad;
};
var getMusicalLoadData = function getMusicalLoadData(_ref7) {
  var musicalLoad = _ref7.musicalLoad;
  return musicalLoad;
};
var getTopTracksData = function getTopTracksData(_ref8) {
  var topTracks = _ref8.topTracks;
  return topTracks;
};
var getContentThreadsData = function getContentThreadsData(_ref9) {
  var contentThreads = _ref9.contentThreads;
  return contentThreads.topics;
};
var getAudienceData = function getAudienceData(_ref10) {
  var audience = _ref10.audience;
  return JSON.parse(audience.stats);
};
var getPromotionsData = function getPromotionsData(_ref11) {
  var promotions = _ref11.promotions;

  var uniqueMap = promotions.uniques.reduce(function (a, x) {
    a[x.campaignId] = x.value; // eslint-disable-line
    return a;
  }, {});

  return promotions.entries.map(function (x) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
      uniques: uniqueMap[x.campaignId],
      entries: x.value
    });
  }).sort(function (a, b) {
    return b.entries - a.entries;
  });
};

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findLangaugeNameFromKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lang_codes__ = __webpack_require__(2669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lang_codes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lang_codes__);


function findLangaugeNameFromKey() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var lang = __WEBPACK_IMPORTED_MODULE_0_lang_codes___default()(value, { prop: 'name' });
  return lang.name || 'N/A (' + value + ')';
}

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return discardItemsWithEmptyValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);



var discardItemsWithEmptyValues = function discardItemsWithEmptyValues(obj) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).reduce(function (acc, key) {
    var value = obj[key];
    if (value && value !== '') {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
    }
    return acc;
  }, {});
};

// eslint-disable-next-line


/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterUniqueItems; });
/* eslint import/prefer-default-export: "off" */

var filterUniqueItems = function filterUniqueItems(destination, source, key) {
  var uniqueItems = [];
  source.forEach(function (sourceItem) {
    var exists = destination.filter(function (destinationItem) {
      return destinationItem[key] === sourceItem[key];
    });
    if (!exists.length) {
      uniqueItems.push(sourceItem);
    }
  });
  return uniqueItems;
};



/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_style_style_scss__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_style_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_style_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_style_element_variables_scss__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_style_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_style_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_croppa_dist_vue_croppa_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__jumpn_utils_graphql__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apollo_client__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apollo_link_http__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apollo_link_context__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apollo_absinthe_upload_link__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apollo_cache_inmemory__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apollo_link__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_apollo__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_croppa__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_croppa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__absinthe_socket__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__absinthe_socket_apollo_link__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_phoenix__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_phoenix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_phoenix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sentry_browser__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sentry_integrations__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_cookies__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__App__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__router__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store__ = __webpack_require__(983);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


/**
 * Styling
 */






/**
 * Official vue libraries
 */




/**
 * Third party libraries
 */




















/**
 * App
 */




/**
 * Google analytics
 */
var isProd = "production" === 'production';

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_analytics___default.a, {
  id: "UA-150683399-1",
  router: __WEBPACK_IMPORTED_MODULE_28__router__["a" /* default */],
  autoTracking: {
    screenview: true,
    exception: true
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

/**
 * Apollo
 */
var middlewareLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_apollo_link_context__["a" /* setContext */])(function () {
  return {
    headers: {
      authorization: 'JWT ' + localStorage.getItem('token')
    }
  };
});

var v1HttpLink = new __WEBPACK_IMPORTED_MODULE_13_apollo_link_http__["a" /* HttpLink */]({ uri: "https://api.live.colonyhq.com/graphql/" });

// Create the apollo clients
var v1ApolloClient = new __WEBPACK_IMPORTED_MODULE_12_apollo_client__["a" /* ApolloClient */]({
  link: middlewareLink.concat(v1HttpLink),
  cache: new __WEBPACK_IMPORTED_MODULE_16_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  connectToDevTools: true
});

var v2HttpLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_apollo_absinthe_upload_link__["a" /* createLink */])({ uri: "https://apiv2.live.colonyhq.com/graphql" });
// const uploadLink = createUploadLink({ uri: process.env.GRAPHQL_COLONY_V2 });

window.phoenixSocket = new __WEBPACK_IMPORTED_MODULE_23_phoenix__["Socket"]("wss://apiv2.live.colonyhq.com/socket", {
  reconnect: true,
  params: { token: localStorage.getItem('token') }
});

var absintheSocketLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__absinthe_socket_apollo_link__["a" /* createAbsintheSocketLink */])(__WEBPACK_IMPORTED_MODULE_21__absinthe_socket__["a" /* create */](window.phoenixSocket));

var v2LinkWithSubscriptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_apollo_link__["a" /* split */])(function (operation) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__jumpn_utils_graphql__["a" /* hasSubscription */])(operation.query);
}, absintheSocketLink, middlewareLink.concat(v2HttpLink));

var v2ApolloClient = new __WEBPACK_IMPORTED_MODULE_12_apollo_client__["a" /* ApolloClient */]({
  link: middlewareLink.concat(v2LinkWithSubscriptions),
  cache: new __WEBPACK_IMPORTED_MODULE_16_apollo_cache_inmemory__["a" /* InMemoryCache */]({ addTypename: false }),
  connectToDevTools: true
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_18_vue_apollo__["a" /* default */]({
  clients: {
    apiv1: v1ApolloClient,
    apiv2: v2ApolloClient
  },
  defaultClient: v1ApolloClient
});

/**
 * Application wide components
 */
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_apollo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_croppa___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_cookies___default.a);

/**
 * Custom Vue Config
 * */
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.keyCodes.comma = 188;

/**
 * Sentry Configuration
 * */

if (isProd === true) {
  __WEBPACK_IMPORTED_MODULE_24__sentry_browser__["a" /* init */]({
    dsn: "http://e7ad00c255e6464286634bb425947724@sentry.colonyhq.com:9000/4",
    environment: "Production",
    integrations: [new __WEBPACK_IMPORTED_MODULE_25__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_5_vue__["default"], attachProps: true })]
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_28__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_29__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_27__App___default.a },
  apolloProvider: apolloProvider
});

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_admin_StationActivityContainer__ = __webpack_require__(3090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_admin_StationActivityContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_admin_StationActivityContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_admin_EmailDashboardContainer__ = __webpack_require__(3089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_admin_EmailDashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_admin_EmailDashboardContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_admin_EmailComposerContainer__ = __webpack_require__(3088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_admin_EmailComposerContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_admin_EmailComposerContainer__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/admin/stationActivity',
  name: 'StationActivity',
  meta: { requiresAuth: true, is_staff: true },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_admin_StationActivityContainer___default.a
}, {
  path: '/admin/templates',
  name: 'EmailDashboard',
  meta: { requiresAuth: true, is_staff: true },
  component: __WEBPACK_IMPORTED_MODULE_1__containers_admin_EmailDashboardContainer___default.a
}, {
  path: '/admin/templates/:id',
  name: 'EmailComposer',
  meta: { requiresAuth: true, is_staff: true },
  component: __WEBPACK_IMPORTED_MODULE_2__containers_admin_EmailComposerContainer___default.a
}]);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_analytics_EngagementsContainer__ = __webpack_require__(3093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_analytics_EngagementsContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_analytics_EngagementsContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_analytics_AudienceContainer__ = __webpack_require__(3092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_analytics_AudienceContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_analytics_AudienceContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_analytics_AfstereoContainer__ = __webpack_require__(3091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_analytics_AfstereoContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_analytics_AfstereoContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_analytics_ProgrammingDashboardContainer__ = __webpack_require__(3094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_analytics_ProgrammingDashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__containers_analytics_ProgrammingDashboardContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_analytics_VoiceIntelligenceContainer__ = __webpack_require__(3095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_analytics_VoiceIntelligenceContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__containers_analytics_VoiceIntelligenceContainer__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/analytics/engagements',
  name: 'Engagements',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_analytics_EngagementsContainer___default.a
}, {
  path: '/analytics/audience',
  name: 'Audience',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_1__containers_analytics_AudienceContainer___default.a
}, {
  path: '/analytics/afstereo',
  name: 'Afstereo',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_2__containers_analytics_AfstereoContainer___default.a
}, {
  path: '/analytics/programming',
  name: 'ProgrammingDashboard',
  alias: '/analytics/programmingDashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_3__containers_analytics_ProgrammingDashboardContainer___default.a
}, {
  path: '/analytics/voice-intelligence',
  name: 'VoiceIntelligence',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_4__containers_analytics_VoiceIntelligenceContainer___default.a
}]);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_audience_ContactsContainer__ = __webpack_require__(3096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_audience_ContactsContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_audience_ContactsContainer__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/audience/contacts/:authProvider?',
  name: 'audience',
  meta: { requiresAuth: true, action: 'view', subject: 'contact' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_audience_ContactsContainer___default.a
}]);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_auth_LoginContainer__ = __webpack_require__(3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_auth_LoginContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_auth_LoginContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_auth_PasswordResetContainer__ = __webpack_require__(3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_auth_PasswordResetContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_auth_PasswordResetContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_auth_PasswordRestWithTokenContainer__ = __webpack_require__(3099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_auth_PasswordRestWithTokenContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_auth_PasswordRestWithTokenContainer__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'Login',
  alias: '/login',
  component: __WEBPACK_IMPORTED_MODULE_0__containers_auth_LoginContainer___default.a
}, {
  path: '/forgot',
  name: 'PasswordReset',
  component: __WEBPACK_IMPORTED_MODULE_1__containers_auth_PasswordResetContainer___default.a
}, {
  path: '/password/:token',
  name: 'PasswordRestWithToken',
  component: __WEBPACK_IMPORTED_MODULE_2__containers_auth_PasswordRestWithTokenContainer___default.a
}]);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_campaign_CampaignDashboard__ = __webpack_require__(2901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_campaign_CampaignDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_campaign_CampaignDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_campaign_CampaignDetailContainer__ = __webpack_require__(3100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_campaign_CampaignDetailContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_campaign_CampaignDetailContainer__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/campaigns',
  name: 'Campaign',
  meta: { requiresAuth: true, action: 'view', subject: 'campaigns' },
  component: __WEBPACK_IMPORTED_MODULE_0__components_campaign_CampaignDashboard___default.a
}, {
  path: '/campaigns/:id',
  name: 'CampaignDetail',
  meta: { requiresAuth: true, action: 'view', subject: 'campaigns' },
  component: __WEBPACK_IMPORTED_MODULE_1__containers_campaign_CampaignDetailContainer___default.a
}]);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_channel_ChannelContainer__ = __webpack_require__(3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_channel_ChannelContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_channel_ChannelContainer__);
// import TelegramChannelContainer from '@/containers/channel/TelegramChannelContainer';
// import TwitterChannelContainer from '@/containers/channel/TwitterChannelContainer';


/* harmony default export */ __webpack_exports__["a"] = ([
// {
//   path: '/channels/telegram',
//   name: 'Telegram',
//   meta: { requiresAuth: true },
//   component: TelegramChannelContainer,
// },
// {
//   path: '/channels/twitter',
//   name: 'Twitter',
//   meta: { requiresAuth: true },
//   component: TwitterChannelContainer,
// },
{
  path: '/channels',
  name: 'Channel',
  meta: { requiresAuth: true, action: 'view', subject: 'channels' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_channel_ChannelContainer___default.a
}]);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_company_CompanyDashboard__ = __webpack_require__(2941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_company_CompanyDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_company_CompanyDashboard__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/company',
  name: 'Company',
  meta: { requiresAuth: true, action: 'view', subject: 'company' },
  component: __WEBPACK_IMPORTED_MODULE_0__components_company_CompanyDashboard___default.a
}]);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  name: 'Dashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'radio-dashboard' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer___default.a
}]);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_filebox_FileboxContainer__ = __webpack_require__(3102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_filebox_FileboxContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_filebox_FileboxContainer__);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/filebox',
  name: 'Filebox',
  meta: { requiresAuth: true, action: 'view', subject: 'filebox' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_filebox_FileboxContainer___default.a
}]);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_interaction_InteractionSearchContainer__ = __webpack_require__(3103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_interaction_InteractionSearchContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_interaction_InteractionSearchContainer__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/interactions',
  name: 'Interaction',
  meta: { requiresAuth: true, action: 'view', subject: 'interactions' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_interaction_DashboardContainer___default.a
}, {
  path: '/interactions/search',
  name: 'InteractionSearch',
  meta: { requiresAuth: true, action: 'view', subject: 'interactions' },
  component: __WEBPACK_IMPORTED_MODULE_1__containers_interaction_InteractionSearchContainer___default.a
}]);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_profile_ProfilesDashboardContainer__ = __webpack_require__(3106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_profile_ProfilesDashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_profile_ProfilesDashboardContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_permission_PermissionsDashboardContainer__ = __webpack_require__(3105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_permission_PermissionsDashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__containers_permission_PermissionsDashboardContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_segmentation_SegmentationDashboardContainer__ = __webpack_require__(3108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_segmentation_SegmentationDashboardContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_segmentation_SegmentationDashboardContainer__);




/* harmony default export */ __webpack_exports__["a"] = ([{ path: '/profiles_admin', redirect: '/profiles' }, {
  path: '/profiles',
  name: 'ProfilesDashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_profile_ProfilesDashboardContainer___default.a
}, {
  path: '/permissions',
  name: 'permissionsDashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
  component: __WEBPACK_IMPORTED_MODULE_1__containers_permission_PermissionsDashboardContainer___default.a
}, {
  path: '/segmentation',
  name: 'SegmentationDashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
  component: __WEBPACK_IMPORTED_MODULE_2__containers_segmentation_SegmentationDashboardContainer___default.a
}]);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_rules_RulesListContainer__ = __webpack_require__(3107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_rules_RulesListContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__containers_rules_RulesListContainer__);
// import RulesDetailContainer from '@/containers/rules/RulesDetailContainer';


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/rules/campaign/:campaignId',
  name: 'RulesList',
  meta: { requiresAuth: true, action: 'view', subject: 'rules' },
  component: __WEBPACK_IMPORTED_MODULE_0__containers_rules_RulesListContainer___default.a
}]);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_social_SocialAnalyticsDashboard__ = __webpack_require__(3019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_social_SocialAnalyticsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_social_SocialAnalyticsDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_social_SocialScheduleDashboard__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_social_SocialScheduleDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_social_SocialScheduleDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PageViewsDashboard__ = __webpack_require__(3027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PageViewsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PageViewsDashboard__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/social/analytics',
  name: 'SocialAnalytics',
  meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
  component: __WEBPACK_IMPORTED_MODULE_0__components_social_SocialAnalyticsDashboard___default.a
}, {
  path: '/social/schedules',
  name: 'SocialSchedules',
  meta: { requiresAuth: true, action: 'view', subject: 'social' },
  component: __WEBPACK_IMPORTED_MODULE_1__components_social_SocialScheduleDashboard___default.a
}, {
  path: '/social/facebook/pageViews',
  name: 'PageViewsDashboard',
  meta: { requiresAuth: true, action: 'view', subject: 'social' },
  component: __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PageViewsDashboard___default.a
}]);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_surveybuilder_SurveyBuilderDashboard__ = __webpack_require__(3035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_surveybuilder_SurveyBuilderDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_surveybuilder_SurveyBuilderDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_SurveyBuilderEditor__ = __webpack_require__(3036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_SurveyBuilderEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_SurveyBuilderEditor__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/surveybuilder',
  name: 'SurveyBuilderDashboard',
  // meta: { requiresAuth: true, is_staff: true, action: 'view', subject: 'survey-builder' },
  meta: { requiresAuth: true },
  component: __WEBPACK_IMPORTED_MODULE_0__components_surveybuilder_SurveyBuilderDashboard___default.a
}, {
  path: '/surveybuilder/editor',
  name: 'SurveyBuilderEditor',
  // meta: { requiresAuth: true, is_staff: true, action: 'view', subject: 'survey-builder' },
  meta: { requiresAuth: true },
  component: __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_SurveyBuilderEditor___default.a
}, {
  path: '/surveybuilder/editor/:id',
  name: 'SurveyBuilderItemEditor',
  meta: { requiresAuth: true },
  component: __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_SurveyBuilderEditor___default.a
}]);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_surveys_SurveyAnalyticsDashboard__ = __webpack_require__(3076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_surveys_SurveyAnalyticsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_surveys_SurveyAnalyticsDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveys_SpotSurveyDashboard__ = __webpack_require__(3075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveys_SpotSurveyDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_surveys_SpotSurveyDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_surveys_SurveyFilter__ = __webpack_require__(3079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_surveys_SurveyFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_surveys_SurveyFilter__);




/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/surveys',
  name: 'Surveys',
  meta: { requiresAuth: true, action: 'view', subject: 'surveys' },
  component: __WEBPACK_IMPORTED_MODULE_0__components_surveys_SurveyAnalyticsDashboard___default.a
}, {
  path: '/surveys/spots',
  name: 'Spot Surveys',
  medta: { requiesAuth: true, action: 'view', subject: 'surveys' },
  component: __WEBPACK_IMPORTED_MODULE_1__components_surveys_SpotSurveyDashboard___default.a
}, {
  path: '/surveys/filter',
  name: 'Survey Filter',
  media: { requiresAuth: true, action: 'view', subject: 'surveys' },
  component: __WEBPACK_IMPORTED_MODULE_2__components_surveys_SurveyFilter___default.a
}]);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadInitialData: function loadInitialData(_ref) {
    var dispatch = _ref.dispatch;

    dispatch('company/getCompanies');
    dispatch('campaign/getCampaigns');
    dispatch('channel/getChannels');
    dispatch('campaign/getReplyMessages');
    dispatch('user/getMe');
    // dispatch('user/getBrowserLocale');
    dispatch('alerts/getStaffAlerts');
    dispatch('activities/getAllActivities');
    dispatch('activities/startActivityPolling');
    dispatch('plugin/getPlugins');
    dispatch('survey/getDemographics');
    dispatch('survey/getSurveys');
  }
});

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1165);




/* harmony default export */ __webpack_exports__["a"] = ({
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(570);


var _types$TOGGLE_SIDEBAR;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$TOGGLE_SIDEBAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$TOGGLE_SIDEBAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state) {
  state.sidebarCollapsed = !state.sidebarCollapsed;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$TOGGLE_SIDEBAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_FULLSCREEN */], function (state) {
  state.fullscreen = !state.fullscreen;
}), _types$TOGGLE_SIDEBAR);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  sidebarCollapsed: false,
  pageTitle: '',
  searchTerm: '',
  pageSearchRoute: '',
  pageBreadcrumbs: [],
  pageHeaderEnabled: true,
  fullscreen: true,
  icons: {
    social: {
      facebook: { icon: 'fa-facebook', color: '#4767aa' },
      instagram: { icon: 'fa-instagram', color: '#ed1f65' },
      mail: { icon: 'fa-envelope-o', color: '#f39522' },
      whatsapp: { icon: 'fa-whatsapp', color: '#0fa251' },
      whatsappweb: { icon: 'fa-whatsapp', color: '#0fa251' },
      wechat: { icon: 'fa-wechat', color: '#7bb32e' },
      twitter: { icon: 'fa-twitter', color: '#1da1f2' },
      mobile: { icon: 'fa-mobile', color: '#2993cf' },
      sms: { icon: 'fa-mobile', color: '#2993cf' },
      webhook: { icon: 'fa-globe', color: '#cf2941' },
      cellfind: { icon: 'fa-mobile', color: '#2993cf' },
      ussd: { icon: 'fa-industry', color: '#ffffff' }
    },
    navigation: {
      campaigns: '/static/assets/icons/',
      channels: '',
      filebox: '',
      interactions: '',
      profiles: '',
      wallet: '',
      company: ''
    },
    plain: {
      pink: '/static/assets/icons/plain/pink.png',
      purple: '/static/assets/icons/plain/purple.png',
      teal: '/static/assets/icons/plain/teal.png',
      yellow: '/static/assets/icons/plain/yellow.png'
    },
    file: {
      log: '/static/assets/icons/plain/pink.png',
      xlsx: '/static/assets/icons/plain/purple.png',
      xls: '/static/assets/icons/plain/teal.png',
      pdf: '/static/assets/icons/plain/yellow.png',
      doc: '/static/assets/icons/plain/pink.png',
      csv: '/static/assets/icons/plain/teal.png'
    },
    campaign: {
      edit: '/static/assets/icons/canpaign/edit.png',
      download: '/static/assets/icons/campaign/download.png',
      live: '/static/assets/icons/campaign/live.png',
      winner: '/static/assets/icons/campaign/winner.png',
      trash: '/static/assets/icons/campaign/trash.png',
      stats: '/static/assets/icons/campaign/stats.png'
    }
  },
  channelTypes: {
    0: 'sms',
    1: 'mail',
    2: 'twitter',
    3: 'facebook',
    4: 'gplus',
    6: 'wechat',
    7: 'webhook',
    8: 'ussd',
    9: 'whatsapp',
    10: 'instagram',
    11: 'cellfind',
    12: 'telegram',
    13: 'whatsappweb'
  }
});

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(571);



/* harmony default export */ __webpack_exports__["a"] = ({
  getAllActivities: function getAllActivities(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_ACTIVITIES_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('activities/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_ACTIVITIES_SUCCESS */], response.data.results);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_ACTIVITIES_FAILURE */], error.error);
    });
  },
  deleteActivity: function deleteActivity(_ref2, id) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* DELETE_ACTIVITY_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].delete('activities/' + id + '/').then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* DELETE_ACTIVITY_SUCCESS */], id);
      dispatch('activities/getAllActivities', null, { root: true });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* DELETE_ACTIVITY_FAILURE */], error);
    });
  },
  startActivityPolling: function startActivityPolling(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        state = _ref3.state;

    if (state.activityPollInterval) {
      dispatch('activities/stopActivityPolling', null, { root: true });
    }

    var interval = setInterval(function () {
      return dispatch('activities/getAllActivities', null, { root: true });
    }, 15000);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* START_ACTIVITY_POLLING */], interval);
  },
  stopActivityPolling: function stopActivityPolling(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    clearInterval(state.activityPollInterval);
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* STOP_ACTIVITY_POLLING */]);
  }
});

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1169);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(571);


var _types$GET_ACTIVITIES;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_ACTIVITIES = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_ACTIVITIES_REQUEST */], function (state) {
  state.getActivitiesRequest = true;
  state.getActivitiesSuccess = false;
  state.getActivitiesFailed = false;
  state.getActivitiesErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_ACTIVITIES_SUCCESS */], function (state, results) {
  state.getActivitiesRequest = false;
  state.getActivitiesSuccess = true;
  state.getActivitiesFailed = false;
  state.getActivitiesErrors = null;
  state.activities = results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_ACTIVITIES_FAILURE */], function (state, error) {
  state.getActivitiesRequest = false;
  state.getActivitiesSuccess = false;
  state.getActivitiesFailed = true;
  state.getActivitiesErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* DELETE_ACTIVITY_REQUEST */], function (state) {
  state.deleteActivityRequest = true;
  state.deleteActivitySuccess = false;
  state.deleteActivityFailed = false;
  state.deleteActivityErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* DELETE_ACTIVITY_SUCCESS */], function (state, id) {
  state.deleteActivityRequest = false;
  state.deleteActivitySuccess = true;
  state.deleteActivityFailed = false;
  state.deleteActivityErrors = null;

  state.activities.splice(state.activities.findIndex(function (x) {
    return x.id === id;
  }), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* DELETE_ACTIVITY_FAILURE */], function (state, error) {
  state.deleteActivityRequest = false;
  state.deleteActivitySuccess = false;
  state.deleteActivityFailed = true;
  state.deleteActivityErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* START_ACTIVITY_POLLING */], function (state, interval) {
  state.activityPollInterval = interval;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ACTIVITIES, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* STOP_ACTIVITY_POLLING */], function (state) {
  state.activityPollInterval = null;
}), _types$GET_ACTIVITIES);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  activities: [],
  getActivitiesRequest: false,
  getActivitiesSuccess: false,
  getActivitiesFailed: false,
  getActivitiesErrors: null,
  activityPollInterval: null,

  deleteActivityRequest: false,
  deleteActivitySuccess: false,
  deleteActivityFailed: false,
  deleteActivityErrors: null
});

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_date__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(572);








/* harmony default export */ __webpack_exports__["a"] = ({
  getCharts: function getCharts(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* GET_AFSTEREO_CHARTS_REQUEST */]);

    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_date__["a" /* destructDate */])(__WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedDate), {
      unit: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedPeriod
    });

    var url = __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedStation ? '/analytics/afstereo/stats/station/' + __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedStation + '/' : '/analytics/afstereo/stats/';

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post(url, data).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* GET_AFSTEREO_CHARTS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* GET_AFSTEREO_CHARTS_FAILURE */], error);
    });
  },
  getStations: function getStations(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* GET_AFSTEREO_STATIONS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('/analytics/afstereo/stations/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* GET_AFSTEREO_STATIONS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* GET_AFSTEREO_STATIONS_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(572);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(340);


var _types$ADD_AFSTEREO_D;

/* eslint no-param-reassign: "off" */




/* harmony default export */ __webpack_exports__["a"] = (_types$ADD_AFSTEREO_D = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ADD_AFSTEREO_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.selectedDate).add(payload.amount, payload.period);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SUBTRACT_AFSTEREO_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.selectedDate).subtract(payload.amount, payload.period);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_AFSTEREO_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(payload.date);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_AFSTEREO_PERIOD */], function (state, payload) {
  state.selectedPeriod = payload.period;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_AFSTEREO_STATION */], function (state, payload) {
  state.selectedStation = payload.station;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_AFSTEREO_CHARTS_REQUEST */], function (state) {
  state.loadingCharts = true;
  state.loadingChartsFailed = false;
  state.loadingChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_AFSTEREO_CHARTS_FAILURE */], function (state, error) {
  state.loadingCharts = false;
  state.loadingChartsFailed = true;
  state.laodingChartsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_AFSTEREO_CHARTS_SUCCESS */], function (state, response) {
  state.loadingCharts = false;
  state.loadingChartsSucceeded = true;
  state.chartsData = response.data;
  state.selectedStation = response.data.current_station.station_id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_AFSTEREO_STATIONS_REQUEST */], function (state) {
  state.loadingStations = false;
  state.loadingStationsFailed = false;
  state.loadingStationsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_AFSTEREO_STATIONS_FAILURE */], function (state, error) {
  state.loadingStations = false;
  state.loadingStationsFailed = true;
  state.loadingStationsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* GET_AFSTEREO_STATIONS_SUCCESS */], function (state, response) {
  state.loadingStations = false;
  state.loadingStationsSucceeded = true;
  state.stations = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_AFSTEREO_D, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* RESET_AFSTEREO_STATIONS_AREA */], function (state) {
  state.chartsData.stations.area = [['x']];
}), _types$ADD_AFSTEREO_D);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(341);



/* harmony default export */ __webpack_exports__["a"] = ({
  getStaffAlerts: function getStaffAlerts(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_STAFF_ALERTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('staff-alerts/').then(function (resp) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_STAFF_ALERTS_SUCCESS */], resp);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_STAFF_ALERTS_FAILURE */], error);
    });
  },
  updateStaffAlertAsRead: function updateStaffAlertAsRead(_ref2, id) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_STAFF_ALERT_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].put('staff-alerts/' + id + '/', { read: true }).then(function (resp) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_STAFF_ALERT_SUCCESS */], resp);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_STAFF_ALERT_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getNextAlert: function getNextAlert(state) {
    return state.nextStaffAlert;
  },
  getAllAlerts: function getAllAlerts(state) {
    return state.staffAlerts;
  }
});

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(1174);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(341);


var _types$GET_STAFF_ALER;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_STAFF_ALER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_STAFF_ALERTS_REQUEST */], function (state) {
  state.getStaffAlertRequest = true;
  state.getStaffAlertSuccess = false;
  state.getStaffAlertFailed = false;
  state.getStaffAlertErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_STAFF_ALERTS_SUCCESS */], function (state, response) {
  state.getStaffAlertRequest = false;
  state.getStaffAlertSuccess = true;
  state.getStaffAlertFailed = false;
  state.getStaffAlertErrors = null;
  state.staffAlerts = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_STAFF_ALERTS_FAILURE */], function (state, error) {
  state.getStaffAlertRequest = false;
  state.getStaffAlertSuccess = false;
  state.getStaffAlertFailed = true;
  state.getStaffAlertErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_STAFF_ALERT_REQUEST */], function (state) {
  state.updateStaffAlertRequest = true;
  state.updateStaffAlertSuccess = false;
  state.updateStaffAlertFailed = false;
  state.updateStaffAlertErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_STAFF_ALERT_SUCCESS */], function (state) {
  state.updateStaffAlertRequest = false;
  state.updateStaffAlertSuccess = true;
  state.updateStaffAlertFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_STAFF_ALERT_FAILURE */], function (state, error) {
  state.updateStaffAlertRequest = false;
  state.updateStaffAlertSuccess = false;
  state.updateStaffAlertFailed = true;
  state.updateStaffAlertErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_STAFF_ALER, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GET_NEXT_STAFF_ALERT */], function (state) {
  state.nextStaffAlert = state.staffAlerts.shift();
}), _types$GET_STAFF_ALER);

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getStaffAlertRequest: false,
  getStaffAlertSuccess: false,
  getStaffAlertFailed: false,
  getStaffAlertErrors: null,
  staffAlerts: [],
  nextStaffAlert: null,

  updateStaffAlertRequest: false,
  updateStaffAlertSuccess: false,
  updateStaffAlertFailed: false,
  updateStaffAlertErrors: null
});

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_date__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(573);







/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCharts: function getAllCharts() {
    this.$store.dispatch('analytics/getCharts');
    this.$store.dispatch('analytics/getMainChart');
  },
  getCharts: function getCharts(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* GET_ANALYTICS_CHARTS_REQUEST */]);

    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_date__["a" /* destructDate */])(__WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedDate), {
      unit: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedPeriod,
      timeslot: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedTimeslot
    });

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('/analytics/engagements/', data).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* GET_ANALYTICS_CHARTS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* GET_ANALYTICS_CHARTS_FAILURE */], error);
    });
  },
  getMainChart: function getMainChart(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* GET_ANALYTICS_MAIN_CHART_REQUEST */]);

    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_date__["a" /* destructDate */])(__WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedDate), {
      unit: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedPeriod,
      timeslot: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedTimeslot,
      filtering: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */].selectedFilter
    });

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('/analytics/engagements/chart/', data).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* GET_ANALYTICS_MAIN_CHART_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* GET_ANALYTICS_MAIN_CHART_FAILURE */], error);
    });
  },
  getCampaignReport: function getCampaignReport(_ref3, campaignId) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('/analytics/engagements/campaign/' + campaignId + '/report/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE */], error);
    });
  },
  getCampaignListSimpleCharts: function getCampaignListSimpleCharts(_ref4, campaignIds) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* GET_ANALYTICS_CAMPAIGN_LIST_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('/analytics/engagements/campaign/simple-list/', { campaign_ids: campaignIds }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* GET_ANALYTICS_CAMPAIGN_LIST_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(573);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(191);


var _types$ADD_ANALYTICS_;

/* eslint no-param-reassign: "off" */




/* harmony default export */ __webpack_exports__["a"] = (_types$ADD_ANALYTICS_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ADD_ANALYTICS_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.selectedDate).add(payload.amount, payload.period);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SUBTRACT_ANALYTICS_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.selectedDate).subtract(payload.amount, payload.period);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_ANALYTICS_DATE */], function (state, payload) {
  state.selectedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(payload.date);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_ANALYTICS_PERIOD */], function (state, payload) {
  state.selectedPeriod = payload.period;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_ANALYTICS_FILTER */], function (state, payload) {
  state.selectedFilter = payload.filter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_ANALYTICS_TIMESLOT */], function (state, payload) {
  state.selectedTimeslot = payload.timeslot;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_ANALYTICS_CHARTS_REQUEST */], function (state) {
  state.loadingCharts = true;
  state.loadingChartsFailed = false;
  state.loadingChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_ANALYTICS_CHARTS_FAILURE */], function (state, error) {
  state.loadingCharts = false;
  state.loadingChartsFailed = true;
  state.loadingChartsError = error;
  state.loadingChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_ANALYTICS_CHARTS_SUCCESS */], function (state, response) {
  state.loadingCharts = false;
  state.loadingChartsSucceeded = true;
  state.chartsData = response.data;
  state.loadingChartsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_ANALYTICS_MAIN_CHART_REQUEST */], function (state) {
  state.loadingMainChart = true;
  state.loadingMainChartFailed = false;
  state.loadingMainChartSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* GET_ANALYTICS_MAIN_CHART_FAILURE */], function (state, error) {
  state.loadingMainChart = false;
  state.loadingMainChartFailed = true;
  state.loadingMainChartsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* GET_ANALYTICS_MAIN_CHART_SUCCESS */], function (state, response) {
  state.loadingMainChart = false;
  state.loadingMainChartSucceeded = true;
  state.mainChartData = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_ANALYTICS_MAIN_LEGEND */], function (state, payload) {
  state.showMainLegend = payload.option;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST */], function (state) {
  state.loadingCampaignReport = true;
  state.loadingCampaignReportFailed = false;
  state.loadingCampaignReportSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE */], function (state, error) {
  state.loadingCampaignReport = false;
  state.loadingCampaignReportFailed = true;
  state.loadingCampaignReportError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS */], function (state, response) {
  state.loadingCampaignReport = false;
  state.loadingCampaignReportSucceeded = true;
  state.campaignReportData = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* GET_ANALYTICS_CAMPAIGN_LIST_REQUEST */], function (state) {
  state.loadingCampaignListCharts = true;
  state.laodingCampaignListChartsFailed = false;
  state.loadingCampaignListChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* GET_ANALYTICS_CAMPAIGN_LIST_FAILURE */], function (state, error) {
  state.loadingCampaignListCharts = false;
  state.loadingCampaignReportFailed = true;
  state.loadingCampaignListChartsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS */], function (state, response) {
  state.loadingCampaignListCharts = false;
  state.loadingCampaignListChartsSucceeded = true;
  state.campaignListChartsData = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$ADD_ANALYTICS_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* SET_ANALYTICS_LIVE_STREAM_STATS */], function (state, data) {
  state.liveStreamingStates = data;
}), _types$ADD_ANALYTICS_);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(342);




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(_ref, credentials) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* LOGIN_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('api-token-auth/', credentials).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* LOGIN_SUCCESS */], response);
      dispatch('user/getMe', {}, { root: true });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* LOGIN_FAILURE */], error);
    });
  },
  resetPassword: function resetPassword(_ref2, emailAddress) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PASSWORD_RESET_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('accounts/users/password-reset/', emailAddress).then(function (response) {
      return dispatch('passwordResponseHandler', response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */], error);
    });
  },
  updatePassword: function updatePassword(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    var password = payload.password;
    var oldPassword = payload.oldPassword;
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PASSWORD_RESET_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].patch('accounts/users/' + payload.user + '/', { password: password, oldPassword: oldPassword }).then(function (response) {
      return dispatch('passwordResponseHandler', response);
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */]);
      if (error.response.status === 400) {
        dispatch('toast/error', 'Old password incorrect', {
          root: true
        });
      } else {
        dispatch('toast/error', 'Failed to reset password. Try again later.', {
          root: true
        });
      }
    });
  },
  updatePasswordOnUserList: function updatePasswordOnUserList(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var password = payload.password;
    var email = payload.email;
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PASSWORD_RESET_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].patch('accounts/users/' + payload.user + '/', { password: password, email: email }).then(function (response) {
      return dispatch('passwordResponseHandler', response);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */]);
    });
  },
  tokenPasswordReset: function tokenPasswordReset(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    var password = payload.password;
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PASSWORD_RESET_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('accounts/users/' + payload.token + '/password-reset/', { password: password }).then(function (response) {
      return dispatch('passwordResponseHandler', response);
    }).catch(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */]);
    });
  },
  passwordResponseHandler: function passwordResponseHandler(_ref6, response) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    if (response.status === 200 || response.status === 201) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PASSWORD_RESET_SUCCESS */], response.data);
      dispatch('toast/success', 'Password has been reset.', {
        root: true
      });
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */]);
      dispatch('toast/error', 'Failed to reset password. Try again later.', {
        root: true
      });
    }
  }
});

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isLoggedIn: function isLoggedIn() {
    var tokenExits = localStorage.getItem('token');
    if (tokenExits) {
      return true;
    }
    return false;
  }
});

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1185);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(342);


var _types$LOGIN_REQUEST$;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$LOGIN_REQUEST$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* LOGIN_REQUEST */], function (state) {
  state.loginPending = true;
  state.loginFailed = false;
  state.loginSucceeded = false;
  state.loginErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* LOGIN_SUCCESS */], function (state, response) {
  state.loginPending = false;
  state.loginSucceeded = true;
  localStorage.setItem('token', response.data.token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* LOGIN_FAILURE */], function (state, error) {
  state.loginPending = false;
  state.loginSucceeded = false;
  state.loginFailed = true;
  state.loginErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* LOGOUT_REQUEST */], function (state) {
  state.loginPending = false;
  state.loginSucceeded = false;
  localStorage.removeItem('token');
  window.location.assign('/login');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PASSWORD_RESET_REQUEST */], function (state) {
  state.passwordResetPending = true;
  state.passwordResetFailed = false;
  state.passwordResetSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PASSWORD_RESET_SUCCESS */], function (state) {
  state.passwordResetPending = false;
  state.passwordResetFailed = false;
  state.passwordResetSucceeded = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LOGIN_REQUEST$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PASSWORD_RESET_FAILURE */], function (state) {
  state.passwordResetPending = false;
  state.passwordResetFailed = true;
  state.passwordResetSucceeded = false;
}), _types$LOGIN_REQUEST$);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loginPending: false,
  loginFailed: false,
  loginSucceeded: false,
  loginErrors: null,

  passwordResetPending: false,
  passwordResetFailed: false,
  passwordResetSucceeded: false
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(574);



/* harmony default export */ __webpack_exports__["a"] = ({
  getBlacklistedOriginators: function getBlacklistedOriginators(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_BLACKLIST_ORIGINATORS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('interactions/blacklisted/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_BLACKLIST_ORIGINATORS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_BLACKLIST_ORIGINATORS_FAILURE */], error.error);
    });
  },
  addBlacklistOriginator: function addBlacklistOriginator(_ref2, data) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CREATE_BLACKLIST_ORIGINATOR_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('interactions/blacklisted/', data).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CREATE_BLACKLIST_ORIGINATOR_SUCCESS */], response.data);
      dispatch('getBlacklistedOriginators');
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CREATE_BLACKLIST_ORIGINATOR_FAILURE */], error.error);
    });
  },
  updateBlacklistOriginator: function updateBlacklistOriginator(_ref3, originator) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* UPDATE_BLACKLIST_ORIGINATOR_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].put('interactions/blacklisted/' + originator.id + '/', originator).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* UPDATE_BLACKLIST_ORIGINATOR_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* UPDATE_BLACKLIST_ORIGINATOR_FAILURE */], error.error);
    });
  },
  deleteBlacklistedOriginator: function deleteBlacklistedOriginator(_ref4, id) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].delete('interactions/blacklisted/' + id + '/').then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_BLACKLIST_ORIGINATOR_SUCCESS */], id);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* DELETE_BLACKLIST_ORIGINATOR_FAILURE */], error.error);
    });
  }
});

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1189);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(574);


var _types$GET_BLACKLIST_;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_BLACKLIST_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_BLACKLIST_ORIGINATORS_REQUEST */], function (state) {
  state.loadingBlacklistOriginators = true;
  state.loadingBlacklistOriginatorsSucceeded = false;
  state.loadingBlacklistOriginatorsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_BLACKLIST_ORIGINATORS_SUCCESS */], function (state, data) {
  state.loadingBlacklistOriginators = false;
  state.loadingBlacklistOriginatorsSucceeded = true;
  state.blacklistedOriginators = data.results;
  if (data.results != null) {
    state.blacklistedOriginators = state.blacklistedOriginators.map(function (originator) {
      if (originator.type === 'whatsapp') {
        originator.originator = originator.originator.split('@')[0];
      }
      return originator;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_BLACKLIST_ORIGINATORS_FAILURE */], function (state, error) {
  state.loadingBlacklistOriginators = false;
  state.loadingBlacklistOriginatorsSucceeded = false;
  state.loadingBlacklistOriginatorsFailed = true;
  state.loadingBlacklistOriginatorsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CREATE_BLACKLIST_ORIGINATOR_REQUEST */], function (state) {
  state.creatingBlacklistOriginator = true;
  state.creatingBlacklistOriginatorSucceeded = false;
  state.creatingBlacklistOriginatorFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CREATE_BLACKLIST_ORIGINATOR_SUCCESS */], function (state, data) {
  state.creatingBlacklistOriginator = false;
  state.creatingBlacklistOriginatorSucceeded = true;
  state.blacklistedOriginators.splice(0, 0, data);
  if (data != null) {
    state.blacklistedOriginators = state.blacklistedOriginators.map(function (originator) {
      if (originator.type === 'whatsapp') {
        originator.originator = originator.originator.split('@')[0];
      }
      return originator;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CREATE_BLACKLIST_ORIGINATOR_FAILURE */], function (state, error) {
  state.creatingBlacklistOriginator = false;
  state.creatingBlacklistOriginatorFailed = true;
  state.creatingBlacklistOriginatorError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* DELETE_BLACKLIST_ORIGINATOR_REQUEST */], function (state) {
  state.deletingBlacklistOriginator = true;
  state.deletingBlacklistOriginatorSucceeded = false;
  state.deletingBlacklistOriginatorFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_BLACKLIST_ORIGINATOR_SUCCESS */], function (state, id) {
  state.deletingBlacklistOriginator = false;
  state.deletingBlacklistOriginatorSucceeded = true;
  state.blacklistedOriginators.splice(state.blacklistedOriginators.findIndex(function (x) {
    return x.id === id;
  }), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_BLACKLIST_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* DELETE_BLACKLIST_ORIGINATOR_FAILURE */], function (state, error) {
  state.deletingBlacklistOriginator = false;
  state.deletingBlacklistOriginatorFailed = true;
  state.deletingBlacklistOriginatorError = error;
}), _types$GET_BLACKLIST_);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  blacklistedOriginators: [],

  loadingBlacklistOriginators: false,
  loadingBlacklistOriginatorsFailed: false,
  loadingBlacklistOriginatorsSucceeded: false,
  loadingBlacklistOriginatorsError: null,

  creatingBlacklistOriginator: false,
  creatingBlacklistOriginatorSucceeded: false,
  creatingBlacklistOriginatorFailed: false,

  deletingBlacklistOriginator: false,
  deletingBlacklistOriginatorSucceeded: false,
  deletingBlacklistOriginatorFailed: false
});

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_unlinkChannel_gql__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_unlinkChannel_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_unlinkChannel_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(343);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation {\n        createCampaign: {\n          title: $campaignTitle,\n          startDate: $campaignStartDate,\n          endDate: $campaignEndDate,\n          live: true,\n          default: $campaignIsDefault,\n        },\n        newAdvertiser: {\n          advertiser: $advertiserTitle,\n          leadsGenerated: $advertiserLeadsGenerated,\n          prizeQuantity: $advertiserPrizeQuantity,\n          prizeSpend: $advertiserPrizeSpend,\n          prizeVolume: $advertiserPrizeVolume,\n          salesGenerated: $advertiserSalesGenerated,\n          category: $advertiserCategory,\n          prizeCategory: $advertiserPrizeCategory,\n        },\n        newChannelLinks: {\n          keyword: $channelKeyword,\n          channelIds: $channelIds,\n        }\n      }'], ['mutation {\n        createCampaign: {\n          title: $campaignTitle,\n          startDate: $campaignStartDate,\n          endDate: $campaignEndDate,\n          live: true,\n          default: $campaignIsDefault,\n        },\n        newAdvertiser: {\n          advertiser: $advertiserTitle,\n          leadsGenerated: $advertiserLeadsGenerated,\n          prizeQuantity: $advertiserPrizeQuantity,\n          prizeSpend: $advertiserPrizeSpend,\n          prizeVolume: $advertiserPrizeVolume,\n          salesGenerated: $advertiserSalesGenerated,\n          category: $advertiserCategory,\n          prizeCategory: $advertiserPrizeCategory,\n        },\n        newChannelLinks: {\n          keyword: $channelKeyword,\n          channelIds: $channelIds,\n        }\n      }']);








/* harmony default export */ __webpack_exports__["a"] = ({
  createCampaign: function createCampaign(_ref, campaignData, advertiserData, channelData) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    this.$apollo.mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: {
        campaignTitle: campaignData.title,
        campaignStartDate: campaignData.startDate,
        campaignEndDate: campaignData.endDate,
        campaignIsDefault: campaignData.default,
        winningDisqualificationDuration: campaignData.winningDisqualificationDuration,

        advertiseerTitle: advertiserData.title,
        advertiserLeadsGenerated: advertiserData.leadsGenerated,
        advertiserPrizeQuantity: advertiserData.prizeQuantity,
        advertiserPrizeSpend: advertiserData.prizeSpend,
        advertiserPrizeVolume: advertiserData.prizeVolume,
        advertiserSalesGenerated: advertiserData.salesGenerated,
        advertiserCategory: advertiserData.category,
        advertiserPrizeCategory: advertiserData.prizeCategory,

        channelKeyword: channelData.keyword,
        channelIds: channelData.channelIds
      }
    });
  },
  getCampaigns: function getCampaigns(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* GET_CAMPAIGNS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].get('/campaigns/', { params: { cache: 60000 } }).then(function (response) {
      // dispatch('getReplyMessages');
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_CAMPAIGNS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_CAMPAIGNS_FAILURE */], error);
    });
  },
  getReplyMessages: function getReplyMessages(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["s" /* GET_REPLY_MESSAGES_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].get('/replymessages/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* GET_REPLY_MESSAGES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["t" /* GET_REPLY_MESSAGES_FAILURE */], error.response);
    });
  },


  /**
   * Get campaign detail.
   *
   * fetches campaign detail required on the campaign detail page.
   *
   * @param {any} { commit }
   * @param {any} id
   * @returns Promise
   */
  getCampaignDetail: function getCampaignDetail(_ref4, id) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* GET_CAMPAIGN_DETAIL_REQUEST */], id);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].get('/campaigns/linked/channels/' + id + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* GET_CAMPAIGN_DETAIL_SUCCESS */], response.data);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* GET_CAMPAIGN_DETAIL_FAILURE */], id);
    });
  },


  /**
   * Download messages.
   *
   * Calls the download messages api on colony core,
   * send a notification to the user indicating success
   * or error.
   *
   * @param {any} { commit }
   * @param {any} payload
   * @returns Promise
   */
  downloadMessages: function downloadMessages(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* CREATE_CAMPAIGN_MESSAGES_REQUEST */]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].post('/campaigns/' + payload.campaign_id + '/downloadmessages/', payload).then(function (response) {
      dispatch('toast/success', 'Your download message request has successfully been queued.', {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CREATE_CAMPAIGN_MESSAGES_SUCCESS */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      dispatch('toast/error', 'Unable to create your request for download messages. ' + error, {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* CREATE_CAMPAIGN_MESSAGES_FAILURE */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },


  /**
   * Download Bot report.
   *
   * Calls the bot reports api on colony core,
   * send a notification to the user indicating success
   * or error.
   *
   * @param {any} { commit }
   * @param {any} payload
   * @returns Promise
   */
  downloadBotReport: function downloadBotReport(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* CREATE_CAMPAIGN_MESSAGES_REQUEST */]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].post('/campaigns/' + payload.campaign_id + '/downloadbotreport/', payload).then(function (response) {
      dispatch('toast/success', 'Your request has been successfully received. You will be notified when the file is ready to download.', {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CREATE_CAMPAIGN_MESSAGES_SUCCESS */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      dispatch('toast/error', 'Unable to create your request for generating report. ' + error, {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* CREATE_CAMPAIGN_MESSAGES_FAILURE */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },


  /**
   * Run random selection.
   *
   * Calls the random selection api on colony core,
   * and send a notification to the user indicating if
   * it was successful or failed.
   *
   * @param {any} { commit, dispatch }
   * @param {any} payload
   * @returns Promise
   */
  runRandomSelector: function runRandomSelector(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* CREATE_RANDOM_SELECTION_REQUEST */]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].post('/randomselector/', payload).then(function (response) {
      dispatch('toast/success', 'Your random selection has successfully been queued.', {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* CREATE_RANDOM_SELECTION_SUCCESS */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (error) {
      dispatch('toast/error', 'Unable to create your random selection. ' + error, {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* CREATE_RANDOM_SELECTION_FAILURE */]);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },

  /**
   * Gets random selections .
   *
   * This will return all the random selections made
   *
   * @param {any} { commit }
   * @param {any} id
   * @returns Promise
   */
  getRandomSelections: function getRandomSelections(_ref8, id) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* GET_RANDOM_SELECTIONS_REQUEST */], id);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].get('/randomselector/' + id + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* GET_RANDOM_SELECTIONS_SUCCESS */], response.data);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* GET_RANDOM_SELECTIONS_FAILURE */], id);
    });
  },
  getRandomSelectionsWinner: function getRandomSelectionsWinner(_ref9, selection) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["p" /* SET_RANDOM_SELECTIONS_WINNER_REQUEST */], selection);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* colonyAPI */].get('/randomselector/winner/' + selection.id + '/').then(function (response) {
      dispatch('toast/success', 'Your winner has been successfully selected', {
        root: true
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["r" /* SET_RANDOM_SELECTIONS_WINNER_SUCCESS */], response.data);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["q" /* SET_RANDOM_SELECTIONS_WINNER_FAILURE */], selection.selection);
    });
  },
  unlinkChannel: function unlinkChannel(_ref10, linkId) {
    var commit = _ref10.commit;

    this.$apollo.mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_unlinkChannel_gql___default.a,
      variables: {
        linkId: linkId
      }
    });
  },
  setCamapignError: function setCamapignError(_ref11) {
    var commit = _ref11.commit,
        error = _ref11.error;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_CAMPAIGNS_FAILURE */], error);
  }
});

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  activeCampaigns: function activeCampaigns(state) {
    return state.campaigns.filter(function (campaign) {
      return campaign.live;
    });
  },
  inactiveCampaigns: function inactiveCampaigns(state) {
    return state.campaigns.filter(function (campaign) {
      return !campaign.live;
    });
  },
  instantPollCampaigns: function instantPollCampaigns(state) {
    return state.campaigns.filter(function (campaign) {
      return campaign.campaign_type === 'instant_poll';
    }).map(function (campaign) {
      return campaign.id;
    });
  }
});

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1194);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_unique__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(343);



var _types$CREATE_CAMPAIG;

/* eslint no-param-reassign: "off" */




/* harmony default export */ __webpack_exports__["a"] = (_types$CREATE_CAMPAIG = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* CREATE_CAMPAIGN_REQUEST */], function (state) {
  state.creatingCampaign = true;
  state.creatingCampaignFailed = false;
  state.creatingCampaignSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* CREATE_CAMPAIGN_FAILURE */], function (state, error) {
  state.creatingCampaign = false;
  state.creatingCampaignFailed = true;
  state.creatingCampaignError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* CREATE_CAMPAIGN_SUCCESS */], function (state) {
  state.creatingCampaign = false;
  state.creatingCampaignSucceeded = true;
  state.creatingCampaignFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* GET_CAMPAIGNS_REQUEST */], function (state) {
  state.loadingCampaigns = true;
  state.loadingCampaignsFailed = false;
  state.loadingCampaignsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* GET_CAMPAIGNS_FAILURE */], function (state, error) {
  state.loadingCampaigns = false;
  state.loadingCampaignsFailed = true;
  state.loadingCampaignsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* GET_CAMPAIGNS_SUCCESS */], function (state, response) {
  var _state$campaigns;

  state.loadingCampaigns = false;
  state.loadingCampaignsSucceeded = true;
  response.data.results.forEach(function (campaign) {
    campaign.channelLinks = null;
  });
  var newCampaigns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_unique__["a" /* filterUniqueItems */])(state.campaigns, response.data.results, 'id');
  (_state$campaigns = state.campaigns).push.apply(_state$campaigns, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newCampaigns));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* CREATE_CAMPAIGN_MESSAGES_REQUEST */], function (state) {
  state.downloadingCampaignMessages = true;
  state.downloadingCampaignMessagesFailed = false;
  state.downloadingCampaignMessagesSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* CREATE_CAMPAIGN_MESSAGES_FAILURE */], function (state, error) {
  state.downloadingCampaignMessages = false;
  state.downloadingCampaignMessagesFailed = true;
  state.downloadingCampaignMessagesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* CREATE_CAMPAIGN_MESSAGES_SUCCESS */], function (state) {
  state.downloadingCampaignMessages = false;
  state.downloadingCampaignMessagesSucceeded = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* CREATE_RANDOM_SELECTION_REQUEST */], function (state) {
  state.creatingRandomSelection = true;
  state.creatingRandomSelectionFailed = false;
  state.creatingRandomSelectionSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* CREATE_RANDOM_SELECTION_FAILURE */], function (state, error) {
  state.creatingRandomSelection = false;
  state.creatingRandomSelectionFailed = true;
  state.creatingRandomSelectionError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* CREATE_RANDOM_SELECTION_SUCCESS */], function (state) {
  state.creatingRandomSelection = false;
  state.creatingRandomSelectionSucceeded = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* GET_RANDOM_SELECTIONS_REQUEST */], function (state) {
  state.loadingRandomSelections = true;
  state.loadingRandomSelectionsFailed = false;
  state.loadingRandomSelectionsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* GET_RANDOM_SELECTIONS_FAILURE */], function (state, error) {
  state.loadingRandomSelections = false;
  state.loadingRandomSelectionsFailed = true;
  state.loadingRandomSelectionsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* GET_RANDOM_SELECTIONS_SUCCESS */], function (state, response) {
  state.loadingRandomSelections = false;
  state.loadingRandomSelectionsSucceeded = true;
  state.randomSelections = response.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* SET_RANDOM_SELECTIONS_WINNER_REQUEST */], function (state, winner) {
  winner.won_date = new Date().toISOString();
  state.settingRandomSelectionWinner = true;
  state.setRandomSelectionWinnerFailed = false;
  state.setRandomSelectionWinnerSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_RANDOM_SELECTIONS_WINNER_FAILURE */], function (state, error) {
  state.settingRandomSelectionWinner = false;
  state.setRandomSelectionWinnerFailed = true;
  state.setRandomSelectionWinnerError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_RANDOM_SELECTIONS_WINNER_SUCCESS */], function (state) {
  state.settingRandomSelectionWinner = false;
  state.setRandomSelectionWinnerSucceeded = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* GET_REPLY_MESSAGES_REQUEST */], function (state) {
  state.loadingReplyMessages = true;
  state.loadReplyMessagesFailed = false;
  state.loadReplyMessagesSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["t" /* GET_REPLY_MESSAGES_FAILURE */], function (state, error) {
  state.loadingReplyMessages = false;
  state.loadReplyMessagesFailed = true;
  state.loadReplyMessagesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* GET_REPLY_MESSAGES_SUCCESS */], function (state, response) {
  var _state$replyMessages;

  state.loadingReplyMessages = false;
  state.loadReplyMessagesSuccess = true;
  (_state$replyMessages = state.replyMessages).unshift.apply(_state$replyMessages, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.results));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["v" /* GET_CAMPAIGN_DETAIL_REQUEST */], function (state, id) {
  state.loadingCampaignDetail = true;
  state.loadingCampaignDetailSucceeded = false;
  state.loadingCampaignDetailFailed = false;
  state.campaignDetail[id] = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["w" /* GET_CAMPAIGN_DETAIL_SUCCESS */], function (state, data) {
  state.loadingCampaignDetail = false;
  state.loadingCampaignDetailSucceeded = true;
  state.loadingCampaignDetailFailed = false;
  state.campaignDetail[data.id] = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["x" /* GET_CAMPAIGN_DETAIL_FAILURE */], function (state, id) {
  state.loadingCampaignDetail = false;
  state.loadingCampaignDetailSucceeded = false;
  state.loadingCampaignDetailFailed = true;
  state.campaignDetail[id] = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["y" /* SET_CAMPAIGN_FILTERS */], function (state, _ref) {
  var title = _ref.title,
      type = _ref.type,
      isActive = _ref.isActive,
      sortBy = _ref.sortBy;

  state.filterTitle = title;
  state.filterType = type;
  state.filterIsActive = isActive;
  state.filterSortBy = sortBy;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_CAMPAIG, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* SET_CAMPAIGN_PAGE */], function (state, page) {
  state.filterPage = page;
}), _types$CREATE_CAMPAIG);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  campaigns: [],
  creatingCampaign: false,
  creatingCampaignFailed: false,
  creatingCampaignSucceeded: false,

  campaignDetail: {},
  loadingCampaignDetail: false,
  loadingCampaignDetailSucceeded: false,
  loadingCampaignDetailFailed: false,

  loadingCampaigns: false,
  loadingCampaignsFailed: false,
  loadingCampaignsError: null,
  loadingCampaignsSucceeded: false,

  replyMessages: [],
  loadingReplyMessages: false,
  loadReplyMessagesFailed: false,
  loadReplyMessagesSuccess: false,

  downloadingCampaignMessages: false,
  downloadingCampaignMessagesFailed: false,
  downloadingCampaignMessagesSucceeded: false,
  downloadingCampaignMessagesError: null,

  creatingRandomSelection: false,
  creatingRandomSelectionFailed: false,
  creatingRandomSelectionSucceeded: false,
  creatingRandomSelectionError: null,

  randomSelections: null,
  loadingRandomSelections: false,
  loadingRandomSelectionsSucceeded: false,
  loadingRandomSelectionsFailed: false,

  settingRandomSelectionWinner: false,
  setRandomSelectionWinnerFailed: false,
  setRandomSelectionWinnerSucceeded: false,

  filterTitle: null,
  filterType: null,
  filterIsActive: true,
  filterSortBy: 'title_ascending',
  filterPage: 1
});

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(192);





/* harmony default export */ __webpack_exports__["a"] = ({
  getChannels: function getChannels(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_CHANNELS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('campaigns/channels/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_CHANNELS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_CHANNELS_FAILURE */], error);
    });
  },
  getChannelLinks: function getChannelLinks(_ref2, campaign) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_CHANNEL_LINKS_REQUEST */]);
    var params = { cache: 60000, campaign: campaign };
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('campaigns/channels/links/', { params: params }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_CHANNEL_LINKS_SUCCESS */], { rootState: rootState, campaign: campaign, response: response });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_CHANNEL_LINKS_FAILURE */], error);
    });
  },
  addTwitterChannel: function addTwitterChannel(_ref3, uid) {
    var dispatch = _ref3.dispatch;

    var addChannelWindow = window.open("https://api.live.colonyhq.com/" + 'campaign/channel/twitter/login?userid=' + uid, 'ColonyLive twitter Auth', 'status=1,resizable=1,scrollbars=1,width=500,height=550');

    dispatch('isPopUpBlocked', addChannelWindow);
  },
  addTikTokChannel: function addTikTokChannel(_ref4, uid) {
    var dispatch = _ref4.dispatch;

    var addChannelWindow = window.open("https://api.live.colonyhq.com/" + 'campaign/channel/tiktok/login?userid=' + uid, 'ColonyLive tiktok Auth', 'status=1,resizable=1,scrollbars=1,width=500,height=550');

    dispatch('isPopUpBlocked', addChannelWindow);
  },
  getFacebookPages: function getFacebookPages(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* GET_FACEBOOK_PAGES_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["c" /* facebookAPI */].get('/userpages/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* GET_FACEBOOK_PAGES_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* GET_FACEBOOK_PAGES_FAILURE */], error);
    });
  },
  getInstagramPages: function getInstagramPages(_ref6, user) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* GET_INSTAGRAM_PAGES_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["d" /* instagramAPI */].get('/facebook/userpages/', { params: { user_id: user.id } }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["M" /* GET_INSTAGRAM_PAGES_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["N" /* GET_INSTAGRAM_PAGES_FAILURE */], error);
    });
  },
  addFacebookChannelAuth: function addFacebookChannelAuth(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    var token = localStorage.getItem('token');
    var addChannelWindow = window.open("https://api.live.colonyhq.com/" + 'campaign/channel/facebook/login/?token=' + token, 'Facebook Channel Service', 'width=650px,height=600px');

    var canShowDialog = dispatch('isPopUpBlocked', addChannelWindow).then(function (isPopUpBlocked) {
      if (!isPopUpBlocked) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* POLL_FACEBOOK_PAGES_START */], setInterval(function () {
          dispatch('channel/getFacebookPages', null, { root: true });
        }, 2 * 1000));
      }
      return !isPopUpBlocked;
    });
    return canShowDialog;
  },
  addInstagramChannelAuth: function addInstagramChannelAuth(_ref8, user) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    var addChannelWindow = window.open("https://instagram.live.colonyhq.com" + '/facebook/login/?user_id=' + user.id + '&company_id=' + user.use_as_company, 'Instagram Channel Service', 'width=500,height=300');
    var canShowDialog = dispatch('isPopUpBlocked', addChannelWindow).then(function (isPopUpBlocked) {
      if (!isPopUpBlocked) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["I" /* POLL_INSTAGRAM_PAGES_START */], setInterval(function () {
          dispatch('channel/getInstagramPages', user, { root: true });
        }, 2 * 1000));
      }
      return !isPopUpBlocked;
    });
    return canShowDialog;
  },
  addFacebookPage: function addFacebookPage(_ref9, pageId) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* ADD_FACEBOOK_PAGE_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["c" /* facebookAPI */].get('/createchannel/', { params: { page_id: pageId } }).then(function (resp) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* ADD_FACEBOOK_PAGE_SUCCESS */], resp.data);
    }).then(function () {
      return dispatch('channel/getChannels', null, { root: true });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* ADD_FACEBOOK_PAGE_FAILURE */], error);
    });
  },
  addInstagramPage: function addInstagramPage(_ref10, _ref11) {
    var commit = _ref10.commit;

    var _ref12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
        userId = _ref12[0],
        pageId = _ref12[1];

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["O" /* ADD_INSTAGRAM_PAGE_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["d" /* instagramAPI */].get('facebook/create/', { params: { user_id: userId, page_id: pageId } }).then(function (resp) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["P" /* ADD_INSTAGRAM_PAGE_SUCCESS */], resp.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["Q" /* ADD_INSTAGRAM_PAGE_FAILURE */], error);
    });
  },
  addEmailChannel: function addEmailChannel(_ref13, payload) {
    var commit = _ref13.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* ADD_EMAIL_CHANNEL_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('campaigns/channels/', payload).then(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* ADD_EMAIL_CHANNEL_DONE */])).catch(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* ADD_EMAIL_CHANNEL_DONE */]));
  },
  addWechatChannel: function addWechatChannel(_ref14, payload) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* ADD_WECHAT_CHANNEL_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('campaigns/channels/', payload).then(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["B" /* ADD_WECHAT_CHANNEL_DONE */])).catch(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["B" /* ADD_WECHAT_CHANNEL_DONE */]));
  },
  getWhatsAppAuthCode: function getWhatsAppAuthCode(_ref15, payload) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* GET_WHATSAPP_AUTH_CODE_REQUEST */]);
    var url = 'campaigns/channels/whatsapp/sms-code/?cc=' + payload.cc + '&phone=' + payload.phone;
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get(url).then(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["G" /* GET_WHATSAPP_AUTH_CODE_SUCCESS */])).catch(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["H" /* GET_WHATSAPP_AUTH_CODE_FAILURE */]));
  },
  addwhatsappChannel: function addwhatsappChannel(_ref16, payload) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* ADD_WHATSAPP_CHANNEL_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('campaigns/channels/whatsapp/add-account/', payload).then(function (response) {
      var createChannelPayload = {
        handle: payload.cc + payload.phoneNumber,
        extra_data: {
          login: response.data.login,
          pw: response.data.pw
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('campaigns/channels/', createChannelPayload).then(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["C" /* ADD_WHATSAPP_CHANNEL_SUCCESS */])).catch(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["D" /* ADD_WHATSAPP_CHANNEL_FAILURE */]));
    }).catch(commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["D" /* ADD_WHATSAPP_CHANNEL_FAILURE */]));
  },
  isPopUpBlocked: function isPopUpBlocked(_ref17, popUpWindow) {
    var dispatch = _ref17.dispatch;

    if (popUpWindow === null) {
      dispatch('toast/error', 'Disable your pop-up blocker then try again.', { root: true });
      return true;
    }
    return false;
  },
  updateChannel: function updateChannel(_ref18, channel) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["R" /* UPDATE_CHANNEL_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].put('campaigns/channels/' + channel.id + '/', channel).then(function () {
      return dispatch('channel/updateChannelSuccess', channel, { root: true });
    }).catch(function () {
      return dispatch('channel/updateChannelFailed', channel, { root: true });
    });
  },
  updateChannelSuccess: function updateChannelSuccess(_ref19, channel) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["S" /* UPDATE_CHANNEL_SUCCESS */]);
    dispatch('channel/getChannels', null, { root: true });
    dispatch('toast/success', channel.handle + ' updated successfully.', { root: true });
  },
  updateChannelFailed: function updateChannelFailed(_ref20, channel) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["T" /* UPDATE_CHANNEL_FAILURE */]);
    dispatch('toast/error', 'Unable to update channel ' + channel.handle + '.', { root: true });
  },
  getTiktokCreatorInfo: function getTiktokCreatorInfo(_ref21, _ref22) {
    var commit = _ref21.commit;
    var channel_handle = _ref22.channel_handle,
        company_id = _ref22.company_id;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["U" /* GET_TIKTOK_CREATOR_INFO_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["e" /* tiktokAPI */].post('/auth-tiktok/creator-info/', { channel_handle: channel_handle, company_id: company_id }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["V" /* GET_TIKTOK_CREATOR_INFO_SUCCESS */], response.data);
      return response.data;
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["W" /* GET_TIKTOK_CREATOR_INFO_FAILURE */], error);
      throw error;
    });
  }
});

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SMS: 0,
  EMAIL: 1,
  TWITTER: 2,
  FACEBOOK: 3,
  GPLUS: 4,
  MIXIT: 5,
  WE_CHAT: 6,
  WEBHOOK: 7,
  USSD: 8,
  WHATSAPP: 9,
  INSTAGRAM: 10,
  CELLFIND: 11,
  TELEGRAM: 12,
  TIKTOK: 22
});

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__channelTypes__ = __webpack_require__(1196);


/* harmony default export */ __webpack_exports__["a"] = ({
  activeChannels: function activeChannels(state) {
    return state.channels.filter(function (channel) {
      return channel.live;
    });
  },
  channels: function channels(state) {
    return state.channels;
  },
  channelIcons: function channelIcons() {
    return {
      0: { color: 'sms', icon: 'fa-mobile' },
      1: { color: 'email', icon: 'fa-envelope' },
      2: { color: 'twitter', icon: 'fa-twitter' },
      3: { color: 'facebook', icon: 'fa-facebook' },
      4: { color: 'gplus', icon: 'fa-google-plus' },
      6: { color: 'wechat', icon: 'fa-wechat' },
      7: { color: 'webhook', icon: 'fa-globe' },
      8: { color: 'ussd', icon: 'fa-call' },
      9: { color: 'whatsapp', icon: 'fa-whatsapp' },
      10: { color: 'instagram', icon: 'fa-instagram' },
      11: { color: 'cellfind', icon: 'fa-mobile' }
    };
  },
  inactiveChannels: function inactiveChannels(state) {
    return state.channels.filter(function (channel) {
      return !channel.live;
    });
  },


  /**
   * Get activechannels and return only social channels
   * @param {*} state
   * @param {*} getters
   */
  socialChannels: function socialChannels(state, getters) {
    return getters.activeChannels.filter(function (x) {
      return [__WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].FACEBOOK, __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].TWITTER, __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].TIKTOK].indexOf(x.channel_type) !== -1;
    });
  },
  facebookChannels: function facebookChannels(state, getters) {
    return getters.activeChannels.filter(function (x) {
      return x.channel_type === __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].FACEBOOK;
    });
  },
  instagramChannels: function instagramChannels(state, getters) {
    return getters.activeChannels.filter(function (x) {
      return x.channel_type === __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].INSTAGRAM;
    });
  },
  twitterChannels: function twitterChannels(state, getters) {
    return getters.activeChannels.filter(function (x) {
      return x.channel_type === __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].TWITTER;
    });
  },
  tiktokChannels: function tiktokChannels(state, getters) {
    return getters.activeChannels.filter(function (x) {
      return x.channel_type === __WEBPACK_IMPORTED_MODULE_0__channelTypes__["a" /* default */].TIKTOK;
    });
  }
});

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1200);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(192);


var _types$SET_CHANNELS$t;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$SET_CHANNELS$t = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_CHANNELS */], function (state, channels) {
  state.channels = channels;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_CHANNELS_REQUEST */], function (state) {
  state.loadingChannels = true;
  state.getChannelsRequestFailed = false;
  state.getChannelsRequestSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_CHANNELS_FAILURE */], function (state, error) {
  state.loadingChannels = false;
  state.loadingChannelsFailed = true;
  state.loadingChannelsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* GET_CHANNELS_SUCCESS */], function (state, response) {
  state.loadingChannels = false;
  state.loadingChannelsSuccess = true;
  state.channels = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* GET_CHANNEL_LINKS_REQUEST */], function (state) {
  state.loadingChannelLinks = true;
  state.loadChannelLinksFailed = false;
  state.loadChannelLinksSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GET_CHANNEL_LINKS_FAILURE */], function (state, error) {
  state.loadingChannelLinks = false;
  state.loadChannelLinksFailed = true;
  state.loadChannelLinksError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GET_CHANNEL_LINKS_SUCCESS */], function (state, payload) {
  state.loadingChannelLinks = false;
  state.loadChannelLinksFailed = true;
  var campaign = payload.rootState.campaign.campaigns.filter(function (c) {
    return c.id === payload.campaign;
  });
  if (campaign) {
    campaign[0].channelLinks = payload.response.data.results;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_SELECTED_CHANNELS */], function (state, payload) {
  state.selectedChannels = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* CLEAR_SELECTED_CHANNELS */], function (state) {
  state.selectedChannels = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* POLL_FACEBOOK_PAGES_START */], function (state, interval) {
  state.facebookPagePollInterval = interval;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* POLL_FACEBOOK_PAGES_STOP */], function (state) {
  state.facebookPagePollInterval = clearInterval(state.facebookPagePollInterval);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* CLEAR_ADD_FACEBOOK_CHANNEL_STATE */], function (state) {
  state.gettingFacebookPages = false;
  state.facebookPages = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* GET_FACEBOOK_PAGES_REQUEST */], function (state) {
  state.gettingFacebookPages = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* GET_FACEBOOK_PAGES_SUCCESS */], function (state, data) {
  state.gettingFacebookPages = false;
  if (data.constructor !== String) {
    state.facebookPages = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* GET_FACEBOOK_PAGES_FAILURE */], function (state) {
  state.gettingFacebookPages = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* ADD_FACEBOOK_PAGE_REQUEST */], function (state) {
  state.addingFacebookPage = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* ADD_FACEBOOK_PAGE_SUCCESS */], function (state) {
  state.addingFacebookPage = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* ADD_FACEBOOK_PAGE_FAILURE */], function (state) {
  state.addingFacebookPage = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["s" /* ADD_INSTAGRAM_CHANNEL_REQUEST */], function (state) {
  state.addingInstagramChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["t" /* ADD_INSTAGRAM_CHANNEL_DONE */], function (state) {
  state.addingInstagramChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["u" /* ADD_TWITTER_CHANNEL_REQUEST */], function (state) {
  state.addingTwitterChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* ADD_TWITTER_CHANNEL_DONE */], function (state) {
  state.addingTwitterChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* ADD_EMAIL_CHANNEL_REQUEST */], function (state) {
  state.addingEmailChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* ADD_EMAIL_CHANNEL_DONE */], function (state) {
  state.addingEmailChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["y" /* ADD_TIKTOK_CHANNEL_REQUEST */], function (state) {
  state.addingTiktokChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["z" /* ADD_TIKTOK_CHANNEL_DONE */], function (state) {
  state.addingTiktokChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["A" /* ADD_WECHAT_CHANNEL_REQUEST */], function (state) {
  state.addingWechatChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["B" /* ADD_WECHAT_CHANNEL_DONE */], function (state) {
  state.addingWechatChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["C" /* ADD_WHATSAPP_CHANNEL_SUCCESS */], function (state) {
  state.addingWhatsappChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["D" /* ADD_WHATSAPP_CHANNEL_FAILURE */], function (state) {
  state.addingWhatsappChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["E" /* ADD_WHATSAPP_CHANNEL_REQUEST */], function (state) {
  state.addingWhatsappChannel = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["F" /* GET_WHATSAPP_AUTH_CODE_REQUEST */], function (state) {
  state.requestingWhatsappCode = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["G" /* GET_WHATSAPP_AUTH_CODE_SUCCESS */], function (state) {
  state.requestingWhatsappCode = false;
  state.requestWhatsappAuthCodeSuccess = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["H" /* GET_WHATSAPP_AUTH_CODE_FAILURE */], function (state) {
  state.requestingWhatsappCode = false;
  state.requestWhatsappAuthCodeFailure = true;
  state.requestWhatsappAuthCodeSuccess = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["I" /* POLL_INSTAGRAM_PAGES_START */], function (state, interval) {
  state.instagramPagePollInterval = interval;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["J" /* POLL_INSTAGRAM_PAGES_STOP */], function (state) {
  state.instagramPagePollInterval = clearInterval(state.instagramPagePollInterval);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["K" /* CLEAR_ADD_INSTAGRAM_CHANNEL_STATE */], function (state) {
  state.gettingInstagramPages = false;
  state.instagramPages = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["L" /* GET_INSTAGRAM_PAGES_REQUEST */], function (state) {
  state.gettingInstagramPages = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["M" /* GET_INSTAGRAM_PAGES_SUCCESS */], function (state, data) {
  state.gettingInstagramPages = false;
  if (data.constructor !== String) {
    state.instagramPages = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["N" /* GET_INSTAGRAM_PAGES_FAILURE */], function (state) {
  state.gettingInstagramPages = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["O" /* ADD_INSTAGRAM_PAGE_REQUEST */], function (state) {
  state.addingInstagramPage = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["P" /* ADD_INSTAGRAM_PAGE_SUCCESS */], function (state) {
  state.addingInstagramPage = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["Q" /* ADD_INSTAGRAM_PAGE_FAILURE */], function (state) {
  state.addingInstagramPage = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["R" /* UPDATE_CHANNEL_REQUEST */], function (state) {
  state.updateChannelRequest = true;
  state.updateChannelSuccess = false;
  state.updateChannelFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["S" /* UPDATE_CHANNEL_SUCCESS */], function (state) {
  state.updateChannelRequest = false;
  state.updateChannelSuccess = true;
  state.updateChannelFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["T" /* UPDATE_CHANNEL_FAILURE */], function (state) {
  state.updateChannelRequest = false;
  state.updateChannelSuccess = false;
  state.updateChannelFailed = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["U" /* GET_TIKTOK_CREATOR_INFO_REQUEST */], function (state) {
  state.tiktokCreatorLoading = true;
  state.tiktokCreator = null;
  state.tiktokCreatorError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["V" /* GET_TIKTOK_CREATOR_INFO_SUCCESS */], function (state, payload) {
  state.tiktokCreatorLoading = false;
  state.tiktokCreator = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_CHANNELS$t, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["W" /* GET_TIKTOK_CREATOR_INFO_FAILURE */], function (state, error) {
  state.tiktokCreatorLoading = false;
  state.tiktokCreatorError = error;
}), _types$SET_CHANNELS$t);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  session: '',
  channels: [],
  selectedChannels: [],

  loadingChannels: false,
  loadingChannelsFailed: false,
  loadingChannelsSuccess: false,

  loadingChannelLinks: false,
  loadChannelLinksFailed: false,
  loadChannelLinksSuccess: false,

  /** Facebook */
  facebookPagePollInterval: null,
  gettingFacebookPages: false,
  addingFacebookPage: false,
  facebookPages: [],

  instagramPagePollInterval: null,
  gettingInstagramPages: false,
  addingInstagramPage: false,
  instagramPages: [],

  /** Instagram & twitter */
  addingTwitterChannel: false,
  addingEmailChannel: false,

  /** Tiktok */
  addingTiktokChannel: false,
  tiktokCreator: null,
  tiktokCreatorLoading: false,
  tiktokCreatorError: null,

  addingWechatChannel: false,
  addingWhatsappChannel: false,

  requestingWhatsappCode: false,
  requestWhatsappAuthCodeSuccess: false,
  requestWhatsappAuthCodeFailure: false,

  updateChannelRequest: false,
  updateChannelSuccess: false,
  updateChannelFailed: false
});

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(575);



/* harmony default export */ __webpack_exports__["a"] = ({
  getCompany: function getCompany(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_COMPANY_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/companies/active/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_COMPANY_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_COMPANY_FAILURE */], error);
    });
  },
  updateCompany: function updateCompany(_ref2, company) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_COMPANY_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].put('accounts/companies/' + company.id + '/', company).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_COMPANY_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_COMPANY_FAILURE */], error);
    });
  },
  getCompanies: function getCompanies(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GET_COMPANIES_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/companies/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* GET_COMPANIES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* GET_COMPANIES_FAILURE */], error);
    });
  },
  getTimezones: function getTimezones(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* GET_TIMEZONES_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/timezones/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* GET_TIMEZONES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* GET_TIMEZONES_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1204);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(575);


var _types$GET_COMPANY_RE;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_COMPANY_RE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_COMPANY_REQUEST */], function (state) {
  state.loadingCompany = true;
  state.loadingCompanyFailed = false;
  state.loadingCompanySucceeded = false;
  state.loadingCompanyErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_COMPANY_FAILURE */], function (state, error) {
  state.loadingCompany = false;
  state.loadingCompanyFailed = true;
  state.loadingCompanyErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_COMPANY_SUCCESS */], function (state, response) {
  state.loadingCompany = false;
  state.loadingCompanySucceeded = true;
  state.company = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_COMPANY_REQUEST */], function (state) {
  state.updatingCompany = true;
  state.updatingCompanyFailed = false;
  state.updatingCompanySucceeded = false;
  state.updatingCompanyErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_COMPANY_FAILURE */], function (state, error) {
  state.updatingCompany = false;
  state.updatingCompanyFailed = true;
  state.updatingCompanyErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_COMPANY_SUCCESS */], function (state, response) {
  state.updatingCompany = false;
  state.updatingCompanySucceeded = true;
  state.company = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GET_COMPANIES_REQUEST */], function (state) {
  state.loadingCompanies = true;
  state.laodingCompaniesSucceeded = false;
  state.loadingCompaniesFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* GET_COMPANIES_FAILURE */], function (state, error) {
  state.loadingCompanies = false;
  state.loadingCompaniesSucceeded = false;
  state.loadingCompaniesFailed = true;
  state.loadingCompaniesErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* GET_COMPANIES_SUCCESS */], function (state, response) {
  state.loadingCompanies = false;
  state.loadingCompaniesSucceeded = true;
  state.companies = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* GET_TIMEZONES_REQUEST */], function (state) {
  state.loadingTimezones = true;
  state.laodingTimezonesSucceeded = false;
  state.loadingTimezonesFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* GET_TIMEZONES_FAILURE */], function (state, error) {
  state.loadingTimezones = false;
  state.loadingTimezonesSucceeded = false;
  state.loadingTimezonesFailed = true;
  state.loadingTimezonesErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_COMPANY_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* GET_TIMEZONES_SUCCESS */], function (state, response) {
  state.loadingTimezones = false;
  state.loadingTimezonesSucceeded = true;
  state.timezones = response.data;
}), _types$GET_COMPANY_RE);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  company: {},
  loadingCompany: false,
  loadingCompanyFailed: false,
  loadingCompanySucceeded: false,
  loadingCompanyErrors: null,

  updatingCompany: false,
  updatingCompanyFailed: false,
  updatingCompanySucceeded: false,
  updatingCompanyErrors: null,

  companies: [],
  loadingCompanies: false,
  loadingCompaniesFailed: false,
  loadingCompaniesSucceeded: false,
  loadingCompaniesErrors: null,

  timezones: [],
  loadingTimezones: false,
  loadingTimezonesFailed: false,
  loadingTimezonesSucceeded: false,
  loadingTimezonesErrors: null
});

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  constantContactAuth: function constantContactAuth() {
    window.location = "undefined" + "&oauthSignup=true&client_id=" + "undefined" + "&redirect_uri=" + __webpack_require__.i({"NODE_ENV":"production","API_COLONY":"https://api.live.colonyhq.com/","API_COLONY_V2":"https://apiv2.live.colonyhq.com","API_FACEBOOK":"https://facebook.live.colonyhq.com","API_INSTAGRAM":"https://instagram.live.colonyhq.com","API_TELEGRAM":"https://telegram.live.colonyhq.com","API_TIKTOK":"https://stream.live.colonyhq.com","AUTH_CONSTANT_CONTACT":"undefined","KEY_CONSTANT_CONTACT":"undefined","AUTH_MAIL_CHIMP":"undefined","KEY_MAIL_CHIMP":"undefined","GRAPHQL_COLONY_V1":"https://api.live.colonyhq.com/graphql/","GRAPHQL_COLONY_V2":"https://apiv2.live.colonyhq.com/graphql","WS_COLONY_V2":"wss://apiv2.live.colonyhq.com/socket","GOOGLE_ANALYTICS_ID":"UA-150683399-1","TINYMCE_API_KEY":"undefined","SENTRY_ENV":"Production","SENTRY_DSN":"http://e7ad00c255e6464286634bb425947724@sentry.colonyhq.com:9000/4","API_EMAIL":"https://email.live.colonyhq.com/auth-email"}).REDIRECT_URI_CONSTANT_CONTACT;
  },
  mailChimpAuth: function mailChimpAuth() {
    window.location = "undefined" + "&client_id=" + "undefined" + "&redirect_uri=" + __webpack_require__.i({"NODE_ENV":"production","API_COLONY":"https://api.live.colonyhq.com/","API_COLONY_V2":"https://apiv2.live.colonyhq.com","API_FACEBOOK":"https://facebook.live.colonyhq.com","API_INSTAGRAM":"https://instagram.live.colonyhq.com","API_TELEGRAM":"https://telegram.live.colonyhq.com","API_TIKTOK":"https://stream.live.colonyhq.com","AUTH_CONSTANT_CONTACT":"undefined","KEY_CONSTANT_CONTACT":"undefined","AUTH_MAIL_CHIMP":"undefined","KEY_MAIL_CHIMP":"undefined","GRAPHQL_COLONY_V1":"https://api.live.colonyhq.com/graphql/","GRAPHQL_COLONY_V2":"https://apiv2.live.colonyhq.com/graphql","WS_COLONY_V2":"wss://apiv2.live.colonyhq.com/socket","GOOGLE_ANALYTICS_ID":"UA-150683399-1","TINYMCE_API_KEY":"undefined","SENTRY_ENV":"Production","SENTRY_DSN":"http://e7ad00c255e6464286634bb425947724@sentry.colonyhq.com:9000/4","API_EMAIL":"https://email.live.colonyhq.com/auth-email"}).REDIRECT_URI_MAIL_CHIMP;
  }
});

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1209);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CONTACTS_REQUEST; });
/* unused harmony export GET_CONTACTS_FAILURE */
/* unused harmony export GET_CONTACTS_SUCCESS */
var GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
var GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';
var GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(1207);

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_CONTACTS_REQUEST */], function (state) {
  state.loadingContacts = true;
  state.loadingContactsFailed = false;
  state.loadingContactsSucceeded = false;
  state.loadingContactsErrors = null;
}));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  contacts: [],
  loadingContacts: false,
  loadingContactsFailed: false,
  loadingContactsSucceeded: false,
  loadingContactsErrors: null
});

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(576);



/* harmony default export */ __webpack_exports__["a"] = ({
  getMyFiles: function getMyFiles(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_MY_FILES_REQUEST */]);
    var params = { user: '', page: state.myFilesPage };
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('/filebox/', { params: params }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_MY_FILES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_MY_FILES_FAILURE */], error);
    });
  },
  getCompanyFiles: function getCompanyFiles(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* GET_COMPANY_FILES_REQUEST */]);
    var params = { page: state.companyFilesPage };
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('/filebox/', { params: params }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GET_COMPANY_FILES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* GET_COMPANY_FILES_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  allFiles: function allFiles(state) {
    return state.companyFiles + state.myFiles;
  }
});

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1214);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(576);



var _types$GET_MY_FILES_R;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_MY_FILES_R = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_MY_FILES_REQUEST */], function (state) {
  state.loadingMyFiles = true;
  state.loadMyFilesFailed = false;
  state.loadMyFilesSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_MY_FILES_FAILURE */], function (state, error) {
  state.loadingMyFiles = false;
  state.loadMyFilesFailed = true;
  state.loadMyFilesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_MY_FILES_SUCCESS */], function (state, response) {
  var _state$myFiles;

  state.loadingMyFiles = false;
  state.loadMyFilesSuccess = true;
  (_state$myFiles = state.myFiles).push.apply(_state$myFiles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.results));
  state.myFilesPage += 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_COMPANY_FILES_REQUEST */], function (state) {
  state.loadingCompanyFiles = true;
  state.loadCompanyFilesFailed = false;
  state.loadCompanyFilesSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_COMPANY_FILES_FAILURE */], function (state, error) {
  state.loadingCompanyFiles = false;
  state.loadCompanyFilesFailed = true;
  state.loadCompanyFilesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_MY_FILES_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_COMPANY_FILES_SUCCESS */], function (state, response) {
  var _state$companyFiles;

  state.loadingCompanyFiles = false;
  state.loadCompanyFilesSuccess = true;
  (_state$companyFiles = state.companyFiles).push.apply(_state$companyFiles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.results));
  state.companyFilesPage += 1;
}), _types$GET_MY_FILES_R);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  myFiles: [],
  companyFiles: [],
  myFilesPage: 1,
  companyFilesPage: 1,

  loadingMyFiles: false,
  loadMyFilesSuccess: false,
  loadMyFilesFailed: false,
  loadMyFilesError: false,

  loadingCompanyFiles: false,
  loadCompanyFilesFailed: false,
  loadCompanyFilesError: false
});

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiv2Client__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__);






var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          query($page: Int, $campaigns: [Int], $channels: [Int]) {\n            interactions(page: $page, campaigns: $campaigns, channels: $channels) {\n              next\n              previous\n              results {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n                inCount\n                outCount\n                parent {\n                  id\n                  campaignId\n                  channelId\n                  companyId\n                  threadId\n                  dateCreated\n                  dateUpdated\n                  direction\n                  flagBlacklisted\n                  flagComment\n                  flagFavourite\n                  flagFraud\n                  flagSafe\n                  flagUnsafe\n                  flagWinner\n                  ore\n                  tags\n                  type\n                }\n              }\n            }\n          }\n        '], ['\n          query($page: Int, $campaigns: [Int], $channels: [Int]) {\n            interactions(page: $page, campaigns: $campaigns, channels: $channels) {\n              next\n              previous\n              results {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n                inCount\n                outCount\n                parent {\n                  id\n                  campaignId\n                  channelId\n                  companyId\n                  threadId\n                  dateCreated\n                  dateUpdated\n                  direction\n                  flagBlacklisted\n                  flagComment\n                  flagFavourite\n                  flagFraud\n                  flagSafe\n                  flagUnsafe\n                  flagWinner\n                  ore\n                  tags\n                  type\n                }\n              }\n            }\n          }\n        ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          query($page: Int) {\n            onairInteractions(page: $page) {\n              next\n              previous\n              results {\n                id\n                sentBy {\n                  firstName\n                  lastName\n                }\n                interaction {\n                  id\n                  campaignId\n                  channelId\n                  companyId\n                  threadId\n                  dateCreated\n                  dateUpdated\n                  direction\n                  flagBlacklisted\n                  flagComment\n                  flagFavourite\n                  flagFraud\n                  flagSafe\n                  flagUnsafe\n                  flagWinner\n                  ore\n                  tags\n                  type\n                  inCount\n                  outCount\n                  parent {\n                    id\n                    campaignId\n                    channelId\n                    companyId\n                    threadId\n                    dateCreated\n                    dateUpdated\n                    direction\n                    flagBlacklisted\n                    flagComment\n                    flagFavourite\n                    flagFraud\n                    flagSafe\n                    flagUnsafe\n                    flagWinner\n                    ore\n                    tags\n                    type\n                  }\n                }\n              }\n            }\n          }\n        '], ['\n          query($page: Int) {\n            onairInteractions(page: $page) {\n              next\n              previous\n              results {\n                id\n                sentBy {\n                  firstName\n                  lastName\n                }\n                interaction {\n                  id\n                  campaignId\n                  channelId\n                  companyId\n                  threadId\n                  dateCreated\n                  dateUpdated\n                  direction\n                  flagBlacklisted\n                  flagComment\n                  flagFavourite\n                  flagFraud\n                  flagSafe\n                  flagUnsafe\n                  flagWinner\n                  ore\n                  tags\n                  type\n                  inCount\n                  outCount\n                  parent {\n                    id\n                    campaignId\n                    channelId\n                    companyId\n                    threadId\n                    dateCreated\n                    dateUpdated\n                    direction\n                    flagBlacklisted\n                    flagComment\n                    flagFavourite\n                    flagFraud\n                    flagSafe\n                    flagUnsafe\n                    flagWinner\n                    ore\n                    tags\n                    type\n                  }\n                }\n              }\n            }\n          }\n        ']);




/* eslint-disable no-param-reassign, consistent-return */



/* harmony default export */ __webpack_exports__["a"] = ({
  fetchPanels: function fetchPanels(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* GET_PANELS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('radiodashboard/').then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["z" /* GET_PANELS_SUCCESS */], response.data);

      response.data.settings.forEach(function (panel) {
        // First get our initial set of interactions for this panel
        dispatch('interaction/fetchPanelInteractions', [panel.uuid, null, 1], {
          root: true
        });
      });
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* GET_PANELS_FAILURE */], error);
    });
  },
  createPanel: function createPanel(_ref2, settings) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* CREATE_PANEL_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('radiodashboard/panels/', { command: 'add', settings: settings }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* CREATE_PANEL_SUCCESS */], response.data);
      dispatch('interaction/fetchPanelInteractions', [response.data.uuid, null, 1], {
        root: true
      });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* CREATE_PANEL_FAILURE */], error);
    });
  },
  updatePanelSettings: function updatePanelSettings(_ref3, panel) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["B" /* UPDATE_PANEL_SETTINGS */]);
    var payload = {
      uuid: panel.uuid,
      command: 'update',
      data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, panel)
    };
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('radiodashboard/panels/', payload).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["D" /* UPDATE_PANEL_SETTINGS_SUCCESS */], [panel.uuid, response.data]);
      // Reload interactions for this panel
      dispatch('interaction/fetchPanelInteractions', [panel.uuid, null, 1], {
        root: true
      });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["C" /* UPDATE_PANEL_SETTINGS_FAILURE */], error);
    });
  },
  deletePanel: function deletePanel(_ref4, panelId) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var payload = {
      uuid: panelId,
      command: 'delete'
    };
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('radiodashboard/panels/', payload).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["J" /* DELETE_PANEL_SUCCESS */], panelId);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["I" /* DELETE_PANEL_FAILURE */]);
    });
  },
  reorderPanels: function reorderPanels(_ref5, panels) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    var payload = {
      data: panels,
      command: 'order'
    };
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('radiodashboard/panels/', payload).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_7" /* UPDATE_PANEL_ORDER_SUCCESS */], panels);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_8" /* UPDATE_PANEL_ORDER__FAILURE */]);
    });
  },
  fetchPanelInteractions: function fetchPanelInteractions(_ref6, _ref7) {
    var _this = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        state = _ref6.state;

    var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 4),
        panelId = _ref8[0],
        lastId = _ref8[1],
        page = _ref8[2],
        loadingMore = _ref8[3];

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var campaignId, settings, params, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadingMore = loadingMore || false;
              // If we're still busy loading something, don't issue more requests

              if (!state.loadingInteractions[panelId]) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              if (!(state.panelTypes[panelId] === 'onair')) {
                _context.next = 6;
                break;
              }

              dispatch('interaction/fetchOnAirInteractions', { panelId: panelId, page: page }, { root: true });
              return _context.abrupt('return');

            case 6:

              if ('instant_poll' in state.panelSettings[panelId] && state.panelSettings[panelId].instant_poll === true) {
                campaignId = state.panelSettings[panelId].campaign_ids[0];

                dispatch('interaction/fetchInstantPollStats', { panelId: panelId, campaignId: campaignId }, { root: true });
              }

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* GET_INTERACTIONS_REQUEST */], panelId);

              settings = state.panelSettings[panelId];
              params = {
                id__gt: lastId,
                page: page
              };


              if (state.panelTypes[panelId] === 'campaign') {
                params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params, {
                  channels: settings ? settings.channel_ids || [] : [],
                  campaigns: settings ? settings.campaign_ids || [] : []
                });
              }

              _context.prev = 11;
              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_6__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject),
                variables: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params)
              });

            case 14:
              res = _context.sent;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* GET_INTERACTIONS_SUCCESS */], [panelId, res.data.interactions, loadingMore]);
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context['catch'](11);

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* GET_INTERACTIONS_FAILURE */], [panelId, _context.t0]);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[11, 18]]);
    }))();
  },
  fetchThreads: function fetchThreads(_ref9, _ref10) {
    var commit = _ref9.commit;
    var threadId = _ref10.threadId,
        channelType = _ref10.channelType;

    commit('' + __WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* SET_THREAD_ID */], threadId);
    commit('' + __WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* SET_THREAD_CHANNEL_TYPE */], channelType);
    commit('' + __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* CLEAR_THREADS */]);
    commit('' + __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* SET_THREAD_DIALOG_VISIBLE */], true);
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_INTERACTION_THREAD_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('interactions/thread/' + threadId + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_INTERACTION_THREAD_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* GET_INTERACTION_THREAD_FAILURE */], error);
    });
  },
  fetchInstantPollStats: function fetchInstantPollStats(_ref11, _ref12) {
    var commit = _ref11.commit;
    var panelId = _ref12.panelId,
        campaignId = _ref12.campaignId;

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('polls/campaign/choices/?campaign=' + campaignId).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_9" /* GET_INSTANT_POLL_STATS_SUCCESS */], { stats: response.data.results, panelId: panelId });
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_10" /* GET_INSTANT_POLL_STATS_FAILURE */], error);
    });
  },
  searchPanelInteractions: function searchPanelInteractions(_ref13, _ref14) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch,
        state = _ref13.state;

    var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref14, 3),
        panelId = _ref15[0],
        nextPage = _ref15[1],
        query = _ref15[2];

    // If we're still busy loading something, don't issue more requests
    if (state.loadingInteractions[panelId]) {
      return;
    }

    if (!nextPage) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["s" /* SET_INITIAL_PANEL_PAGE */], panelId);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["t" /* INCREMENT_PANEL_PAGE */], panelId);
    }

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* GET_INTERACTIONS_REQUEST */], panelId);

    var panelSettings = state.panelSettings[panelId];

    var isActivity = state.panelTypes[panelId] === 'activity';

    var params = {
      page: state.panelPages[panelId] || 1,
      page_size: 60,
      channel_id: !isActivity && panelSettings.channel_ids && panelSettings.channel_ids.length > 0 ? panelSettings.channel_ids.toString() : null,
      campaign_id: !isActivity && panelSettings.campaign_ids && panelSettings.campaign_ids.length > 0 ? panelSettings.campaign_ids.toString() : null
    };

    var request = void 0;

    if (query.constructor === String) {
      request = __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('interactions/search/', { params: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params, { query: query }) });
    } else {
      request = __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].post('interactions/search/', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params, { query: query }));
    }

    return request.then(function (response) {
      return {
        count: response.data.count,
        results: response.data.results.map(function (item) {
          item.company = item.ore.company_id;
          item.campaign = item.ore.campaign_id;
          item.channel = item.ore.channel_id;
          item.threadId = item.ore.thread_id || null;
          item.inCount = item.ore.in_count || 0;
          item.outCount = item.ore.out_count || 0;
          return item;
        })
      };
    }).then(function (data) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["q" /* SEARCH_INTERACTIONS_SUCCESS */], [panelId, state.panelPages[panelId], data]);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* GET_INTERACTIONS_FAILURE */], [panelId, error]);
    });
  },
  fetchSingleInteraction: function fetchSingleInteraction(_ref16, interactionId) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('interactions/' + interactionId + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["r" /* GET_SINGLE_INTERACTION_SUCCESS */], response.data);
    });
  },
  fetchNextPageInteractions: function fetchNextPageInteractions(_ref17, panelId) {
    var commit = _ref17.commit,
        state = _ref17.state,
        dispatch = _ref17.dispatch;

    // If we're still busy loading something, don't issue more requests
    if (state.loadingInteractions[panelId]) {
      return;
    }
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["t" /* INCREMENT_PANEL_PAGE */], panelId);

    dispatch('interaction/fetchPanelInteractions', [panelId, null, state.panelPages[panelId] || 1, true], {
      root: true
    });
  },
  pausePanelInteractions: function pausePanelInteractions(_ref18, panelId) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["N" /* PAUSE_PANEL */], panelId);
  },
  unpausePanelInteractions: function unpausePanelInteractions(_ref19, panelId) {
    var commit = _ref19.commit,
        state = _ref19.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["O" /* UNPAUSE_PANEL */], panelId);
  },
  clearDashboardPanelPaused: function clearDashboardPanelPaused(_ref20) {
    var commit = _ref20.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["Q" /* CLEAR_DASHBOARD_PANEL_PAUSED */]);
  },
  fetchOnAirInteractions: function fetchOnAirInteractions(_ref21, _ref22) {
    var _this2 = this;

    var commit = _ref21.commit;
    var panelId = _ref22.panelId,
        page = _ref22.page;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* GET_INTERACTIONS_REQUEST */], panelId);
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject2),
                fetchPolicy: 'network-only',
                variables: {
                  page: page
                }
              });

            case 4:
              res = _context2.sent;
              data = res.data.onairInteractions.results.map(function (onairInteraction) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, onairInteraction.interaction, {
                  sentBy: onairInteraction.sentBy.firstName + ' ' + onairInteraction.sentBy.lastName,
                  onAirId: onairInteraction.id
                });
              });

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* GET_INTERACTIONS_SUCCESS */], [panelId, { results: data }]);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* GET_INTERACTIONS_FAILURE */], [panelId, _context2.t0]);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 9]]);
    }))();
  },
  fetchProfileInteractions: function fetchProfileInteractions(_ref23, _ref24) {
    var commit = _ref23.commit;

    var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref24, 4),
        panelId = _ref25[0],
        profileId = _ref25[1],
        _ref25$ = _ref25[2],
        campaignId = _ref25$ === undefined ? 0 : _ref25$,
        _ref25$2 = _ref25[3],
        page = _ref25$2 === undefined ? 1 : _ref25$2;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* GET_INTERACTIONS_REQUEST */], panelId);

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('construct/profiles/interactions/' + profileId + '/', { params: { page: page, campaignId: campaignId } }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* GET_INTERACTIONS_SUCCESS */], [panelId, { results: response.data }]);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* GET_INTERACTIONS_FAILURE */], [panelId, error]);
    });
  },
  fetchNextPageProfileInteractions: function fetchNextPageProfileInteractions(_ref26, _ref27) {
    var commit = _ref26.commit,
        state = _ref26.state,
        dispatch = _ref26.dispatch;

    var _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref27, 3),
        panelId = _ref28[0],
        profileId = _ref28[1],
        campaignId = _ref28[2];

    // If we're still busy loading something, don't issue more requests
    if (state.loadingInteractions[panelId]) {
      return;
    }
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["t" /* INCREMENT_PANEL_PAGE */], panelId);

    dispatch('interaction/fetchProfileInteractions', [panelId, profileId, campaignId, state.panelPages[panelId] || 1], {
      root: true
    });
  },
  removeOnAirInteraction: function removeOnAirInteraction(_ref29, _ref30) {
    var commit = _ref29.commit;

    var _ref31 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref30, 3),
        panelId = _ref31[0],
        onAirId = _ref31[1],
        interactionId = _ref31[2];

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].delete('interactions/onair/' + onAirId + '/').then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* DELETE_INTERACTION_SUCCESS */], [panelId, interactionId]);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_11" /* DELETE_INTERACTION_FAILURE */], error);
    });
  },
  sendToOnAir: function sendToOnAir(_ref32, _ref33) {
    var dispatch = _ref32.dispatch;
    var userId = _ref33.userId,
        interactionId = _ref33.interactionId;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].post('interactions/onair/', { user: userId, interaction: interactionId }).then(function (response) {
      return dispatch('toast/success', 'Interaction sent to ' + response.data.sent_to_fullname + '\'s \'On Air\' panel.', { root: true });
    }).catch(function (_ref34) {
      var response = _ref34.response;
      return dispatch('toast/error', 'We were unable to send message to on air. ' + (response.data && response.data.errors && response.data.errors[0] || ''), { root: true });
    });
  },
  sendReply: function sendReply(_ref35, _ref36) {
    var dispatch = _ref35.dispatch;
    var interactionId = _ref36.interactionId,
        message = _ref36.message,
        media = _ref36.media;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('interactions/' + interactionId + '/', { reply_message: message, media: media }).then(function () {
      dispatch('interaction/fetchSingleInteraction', interactionId, {
        root: true
      });
    }).catch(function () {
      dispatch('toast/error', 'We are unable to send your reply message at this time', {
        root: true
      });
    });
  },
  sendComment: function sendComment(_ref37, _ref38) {
    var dispatch = _ref37.dispatch;
    var interactionId = _ref38.interactionId,
        message = _ref38.message;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].patch('interactions/' + interactionId + '/', { comment: message }).then(function () {
      dispatch('dashboard/fetchSingleInteraction', interactionId, {
        root: true
      });
      dispatch('toast/success', 'Comment sent', { root: true });
    }).catch(function () {
      return dispatch('toast/error', 'We are unable to send your comment at this time', {
        root: true
      });
    });
  },
  getSearchFields: function getSearchFields(_ref39) {
    var commit = _ref39.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["W" /* GET_SEARCH_FIELDS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('construct/fields/config/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["X" /* GET_SEARCH_FIELDS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["Y" /* GET_SEARCH_FIELDS_FAILURE */], error.response);
    });
  },
  simpleSearch: function simpleSearch(_ref40, params) {
    var commit = _ref40.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* GET_SEARCH_RESULTS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('interactions/search/', { params: params }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["V" /* GET_SEARCH_RESULTS_SUCCESS */], response.data);
    });
  },
  advancedSearch: function advancedSearch(_ref41, query) {
    var commit = _ref41.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* GET_SEARCH_RESULTS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].post('interactions/search/', query).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["V" /* GET_SEARCH_RESULTS_SUCCESS */], response.data);
    });
  },
  exportToFile: function exportToFile(_ref42, query) {
    var commit = _ref42.commit,
        dispatch = _ref42.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_3" /* EXPORT_TO_FILE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].post('interactions/search/export/', query).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_4" /* EXPORT_TO_FILE_SUCCESS */]);
      if (response.data.success) {
        dispatch('toast/success', response.data.success, {
          root: true
        });
      }
    }).catch(function () {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_5" /* EXPORT_TO_FILE_FAILURE */]);
      dispatch('toast/error', 'Something went wrong please try again later', {
        root: true
      });
    });
  },
  fetchTwitterTrends: function fetchTwitterTrends(_ref43) {
    var commit = _ref43.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_0" /* GET_TWITTER_TRENDS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('/radiodashboard/twitter-trends/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_1" /* GET_TWITTER_TRENDS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["_2" /* GET_TWITTER_TRENDS_FAILURE */], error);
    });
  },
  exportFacebookPostComments: function exportFacebookPostComments(_ref44, facebookPost) {
    var commit = _ref44.commit,
        dispatch = _ref44.dispatch;

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].get('/campaigns/channels/facebook/export/comments/' + facebookPost.interactionId + '/').then(function (response) {
      if (response.data.success) {
        dispatch('toast/success', response.data.success, {
          root: true
        });
      }
    }).catch(function () {
      dispatch('toast/error', 'Something went wrong please try again later', {
        root: true
      });
    });
  },
  likeFacebookPost: function likeFacebookPost(_ref45, facebookPost) {
    var commit = _ref45.commit,
        dispatch = _ref45.dispatch;

    var payLoad = {
      interaction_id: facebookPost.id
    };

    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* colonyAPI */].post('/campaigns/channels/facebook/like', payLoad).then(function (response) {
      if (response.status === 201 || response.status === 200) {
        dispatch('toast/success', response.data, {
          root: true
        });
      } else {
        dispatch('toast/error', response.data, {
          root: true
        });
      }
    }).catch(function () {
      dispatch('toast/error', 'Something went wrong please try again later', {
        root: true
      });
    });
  }
});

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_interaction__ = __webpack_require__(308);


function interactions(state) {
  return function (panelId) {
    return (state.panelInteractions[panelId] || []).map(function (interactionId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_interaction__["a" /* processInteraction */])(state.interactions[interactionId]);
    }).sort(function (a, b) {
      return new Date(b.date_created).getTime() - new Date(a.date_created).getTime();
    });
  };
}

function interactionsOnAir(state) {
  return interactions(state)('onAir');
}

function pollStats(state) {
  return function (panelId) {
    return state.instantPollResults[panelId] || [];
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({ interactions: interactions, interactionsOnAir: interactionsOnAir, pollStats: pollStats });

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1219);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);







var _types$GET_INTERACTIO;





/* eslint no-param-reassign: "off" */
function addInteractionsToPanel(state, panelId, retrievedInteractions) {
  var updatedThreads = [];

  // Add all these interactions to our grand list of interactions
  state.interactions = retrievedInteractions.reduce(function (interactions, interaction) {
    var currentInteraction = interaction;

    // Prevent losing metadata such as when we assign values for on air
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["indexOf"])(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(interactions), String(interaction.id)) >= 0) {
      currentInteraction = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(state.interactions[interaction.id], interaction);
    }

    // Update thread counts
    var threadNotYetUpdated = updatedThreads.indexOf(interaction.threadId) === -1;
    var threadCountEntryExists = Object.prototype.hasOwnProperty.call(state.threadCounts, interaction.threadId);
    // Only update if required
    // * if it doesn't yet have an entry
    // * if there is an entry and values are less we need to ignore means it's old data
    if (threadNotYetUpdated && (!threadCountEntryExists || state.threadCounts[interaction.threadId].in <= interaction.inCount && state.threadCounts[interaction.threadId].out <= interaction.outCount)) {
      state.threadCounts = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.threadCounts, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, interaction.threadId, {
        in: interaction.inCount,
        out: interaction.outCount
      }));
      updatedThreads.push(interaction.threadId);
    }

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, interactions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, interaction.id, currentInteraction));
  }, state.interactions);

  var sortingKey = state.panelTypes[panelId] === 'onair' ? 'onAirId' : 'id';
  var isPaused = state.panelPaused[panelId];
  var interactionDest = isPaused ? 'panelPausedInteractions' : 'panelInteractions';

  // We now want to add only the id's of these interactions to the panel's
  // collection of ids
  state[interactionDest][panelId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["sortedUniq"])(state[interactionDest][panelId].sort(function (a, b) {
    return b[sortingKey] - a[sortingKey];
  }).concat(retrievedInteractions.map(function (interaction) {
    return interaction.id;
  })));

  state.loadingInteractions[panelId] = false;
  state.loadingInteractionsSuccess[panelId] = true;

  // If we have any current threads push interactions into those.
  if (state.threadId && state.threadDialogVisible) {
    var interactionIdsInThreads = state.threads.map(function (i) {
      return i.id;
    });
    var newThreadedInteractions = retrievedInteractions.filter(function (i) {
      return i.threadId === state.threadId && interactionIdsInThreads.indexOf(i.id) === -1;
    });
    state.threads = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.threads), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newThreadedInteractions));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (_types$GET_INTERACTIO = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["a" /* GET_INTERACTIONS_REQUEST */], function (state, panelId) {
  state.loadingInteractions[panelId] = true;
  state.loadingInteractionsFailed[panelId] = false;
  state.loadingInteractionsSuccess[panelId] = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["b" /* GET_INTERACTIONS_FAILURE */], function (state, _ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      panelId = _ref2[0],
      error = _ref2[1];

  state.loadingInteractions[panelId] = false;
  state.loadingInteractionsFailed[panelId] = true;
  state.loadingInteractionsError[panelId] = error;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["c" /* GET_INTERACTIONS_SUCCESS */], function (state, _ref3) {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 3),
      panelId = _ref4[0],
      response = _ref4[1],
      loadingMore = _ref4[2];

  if (loadingMore) {
    state.hasMoreInteractions[panelId] = !!response.next;
  }
  addInteractionsToPanel(state, panelId, response.results);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["d" /* NEW_INTERACTION_RECEIVED */], function (state, interaction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.panelSettings).forEach(function (panelId) {
    var panel = state.panelSettings[panelId];
    var panelType = state.panelTypes[panelId];

    var hasChannelFilter = Object.prototype.hasOwnProperty.call(panel, 'channel_ids') && panel.channel_ids.length > 0;
    var hasCampaignFilter = Object.prototype.hasOwnProperty.call(panel, 'campaign_ids') && panel.campaign_ids.length > 0;

    var hasChannel = !hasChannelFilter || hasChannelFilter && panel.channel_ids.indexOf(interaction.channelId) !== -1;
    var hasCampaign = !hasCampaignFilter || hasCampaignFilter && panel.campaign_ids.indexOf(interaction.campaignId) !== -1;
    var matchFilters = panelType === 'campaign' && hasChannel && hasCampaign;
    var isOnAir = panelType === 'onair';
    var isActivity = panelType === 'activity';

    if (!isOnAir && (isActivity || matchFilters)) {
      addInteractionsToPanel(state, panelId, [interaction]);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["e" /* NEW_ONAIR_INTERACTION_RECEIVED */], function (state, onairInteraction) {
  var onAirPanelId = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.panelTypes).find(function (panelId) {
    return state.panelTypes[panelId] === 'onair';
  });
  var interaction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, onairInteraction.interaction, {
    sentBy: onairInteraction.sentBy.firstName + ' ' + onairInteraction.sentBy.lastName,
    onAirId: onairInteraction.id
  });
  addInteractionsToPanel(state, onAirPanelId, [interaction]);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["f" /* GET_INTERACTION_THREAD_REQUEST */], function (state) {
  state.loadingThreads = true;
  state.loadingThreadsFailed = false;
  state.loadingThreadsSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["g" /* GET_INTERACTION_THREAD_FAILURE */], function (state, error) {
  state.loadingThreads = false;
  state.loadingThreadsFailed = true;
  state.loadingThreadsError = error;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["h" /* GET_INTERACTION_THREAD_SUCCESS */], function (state, response) {
  state.loadingThreads = false;
  state.loadingThreadsFailed = false;
  state.loadingThreadsSuccess = true;
  state.threads = response;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["i" /* CLEAR_THREADS */], function (state) {
  state.threads = [];
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["j" /* APPEND_THREAD_REPLY */], function (state, _ref5) {
  var interactionId = _ref5.interactionId,
      reply = _ref5.reply;

  state.threads = state.threads.map(function (interaction) {
    if (interaction.id !== interactionId) {
      return interaction;
    }

    if (!Object.prototype.hasOwnProperty.call(interaction.ore, 'reply')) {
      interaction.ore.reply = [];
    }
    interaction.ore.reply.push(reply);

    var currentCount = state.threadCounts[interaction.thread];
    state.threadCounts = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.threadCounts, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, interaction.thread, { in: currentCount.in, out: currentCount.out + 1 }));

    return interaction;
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_THREAD_ID */], function (state, threadId) {
  state.threadId = threadId;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["l" /* SET_THREAD_CHANNEL_TYPE */], function (state, channelType) {
  state.threadChannel = channelType;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["m" /* SET_THREAD_DIALOG_VISIBLE */], function (state, isVisible) {
  state.threadDialogVisible = isVisible;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["n" /* SET_MEDIA_IS_PLAYING */], function (state, mediaIsPlaying) {
  state.mediaIsPlaying = mediaIsPlaying;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["o" /* CLEAR_PANEL_INTERACTIONS */], function (state, panelId) {
  state.panelInteractions[panelId] = null;
  state.hasMoreInteractions[panelId] = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["p" /* CLEAR_PANEL_HAS_MORE_INDICATOR */], function (state, panelId) {
  state.hasMoreInteractions[panelId] = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["q" /* SEARCH_INTERACTIONS_SUCCESS */], function (state, _ref6) {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6, 3),
      panelId = _ref7[0],
      page = _ref7[1],
      response = _ref7[2];

  state.hasMoreInteractions[panelId] = response.count > 0 && response.results.length > 0;
  var retrievedInteractions = response.results;
  // Add all these interactions to our grand list of interactions
  var updatedThreads = [];
  state.interactions = retrievedInteractions.reduce(function (interactions, interaction) {
    var currentInteraction = interaction;

    // Prevent losing metadata such as when we assign values for on air
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["indexOf"])(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(interactions), String(interaction.id)) >= 0) {
      currentInteraction = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(state.interactions[interaction.id], interaction);
    }

    // Update thread counts
    var threadNotYetUpdated = updatedThreads.indexOf(interaction.threadId) === -1;
    var threadCountEntryExists = Object.prototype.hasOwnProperty.call(state.threadCounts, interaction.threadId);
    // Only update if required
    // * if it doesn't yet have an entry
    // * if there is an entry and values are less we need to ignore means it's old data
    if (threadNotYetUpdated && (!threadCountEntryExists || state.threadCounts[interaction.threadId].in <= interaction.inCount && state.threadCounts[interaction.threadId].out <= interaction.outCount)) {
      state.threadCounts = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.threadCounts, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, interaction.threadId, {
        in: interaction.inCount,
        out: interaction.outCount
      }));
      updatedThreads.push(interaction.threadId);
    }

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(interactions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, interaction.id, currentInteraction));
  }, state.interactions);

  if (page === 1) {
    state.panelInteractions[panelId] = [];
  }

  // We now want to add only the id's of these interactions to the panel's
  // collection of ids
  state.panelInteractions[panelId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["sortedUniq"])(state.panelInteractions[panelId].concat(retrievedInteractions.map(function (interaction) {
    return interaction.id;
  })).sort(function (a, b) {
    return b - a;
  }));
  state.loadingInteractions[panelId] = false;
  state.loadingInteractionsSuccess[panelId] = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* GET_SINGLE_INTERACTION_SUCCESS */], function (state, response) {
  state.interactions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.interactions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, response.id, response));
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* SET_INITIAL_PANEL_PAGE */], function (state, panelId) {
  state.panelPages[panelId] = 1;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* INCREMENT_PANEL_PAGE */], function (state, panelId) {
  state.panelPages[panelId] += 1;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* DECREMENT_PANEL_PAGE */], function (state, panelId) {
  state.panelPages[panelId] -= 1;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["v" /* GET_PANELS_REQUEST */], function (state) {
  state.loadingPanels = true;
  state.loadingPanelsFailed = false;
  state.loadingPanelsSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["w" /* GET_PANELS_FAILURE */], function (state, error) {
  state.loadingPanels = false;
  state.loadingPanelsFailed = true;
  state.loadingPanelsError = error;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* ADD_MANUAL_PANEL */], function (state, panel) {
  state.panels = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings.name), state.panels);
  state.panelSettings = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings), state.panelSettings);
  state.panelTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.type), state.panelTypes);
  state.panelPages = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, 1), state.panelPages);
  state.panelInteractions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, []), state.panelInteractions);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* REMOVE_MANUAL_PANEL */], function (state, panel) {
  state.panels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panels, panel.uuid);
  state.panelSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelSettings, panel.uuid);
  state.panelInteractions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelInteractions, panel.uuid);
  state.panelTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelTypes, panel.uuid);
  state.panelPages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelPages, panel.uuid);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["z" /* GET_PANELS_SUCCESS */], function (state, response) {
  // Create panel declarations
  state.panels = response.settings.reduce(function (titles, panel) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, titles, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings.name));
  }, state.panels);

  // Assign settings such as filters, colours and names
  state.panelSettings = response.settings.reduce(function (settings, panel) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, settings, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings));
  }, state.panelSettings);

  // Assign types
  state.panelTypes = response.settings.reduce(function (panelTypes, panel) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, panelTypes, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.type));
  }, state.panelTypes);

  // Initialize panel page
  state.panelPages = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.panels).reduce(function (panelPages, panelId) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, panelPages, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, 1));
  }, {});

  // Initialize with blank interaction data
  state.panelInteractions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.panels).reduce(function (panelInteractions, panelId) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, panelInteractions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, []));
  }, state.panelInteractions);

  state.loadingPanels = false;
  state.loadingPanelsSuccess = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* UPDATE_PANEL_ORDER */], function (state, panels) {
  state.panels.settings = panels;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* UPDATE_PANEL_SETTINGS */], function (state) {
  state.updatingPanelSettings = true;
  state.updatePanelSettingsSuccess = false;
  state.updatePanelSettingsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["C" /* UPDATE_PANEL_SETTINGS_FAILURE */], function (state) {
  state.updatingPanelSettings = false;
  state.updatePanelSettingsFailed = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["D" /* UPDATE_PANEL_SETTINGS_SUCCESS */], function (state, _ref8) {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
      panelId = _ref9[0],
      response = _ref9[1];

  state.updatingPanelSettings = false;
  state.updatePanelSettingsSuccess = true;

  var updatedPanel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["first"])(response.settings.filter(function (panel) {
    return panel.uuid === panelId;
  }));

  state.panels[panelId] = updatedPanel.settings.name;
  state.panelSettings[panelId] = updatedPanel.settings;
  state.panelPages[panelId] = 1;
  state.panelInteractions[panelId] = [];
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["E" /* CREATE_PANEL_REQUEST */], function (state) {
  state.creatingPanel = true;
  state.createPanelFailed = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["F" /* CREATE_PANEL_FAILURE */], function (state) {
  state.creatingPanel = false;
  state.createPanelFailed = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["G" /* CREATE_PANEL_SUCCESS */], function (state, panel) {
  state.creatingPanel = false;

  // Construct initial panel data
  state.panels = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.panels, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings.name));
  state.panelSettings = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.panelSettings, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.settings || {}));
  state.panelInteractions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.panelInteractions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, []));
  state.panelPages = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.panelPages, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, 1));
  state.panelTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.panelTypes, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panel.uuid, panel.type));
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["H" /* DELETE_PANEL_REQUEST */], function (state) {
  state.deletingPanel = true;
  state.deletePanelFailed = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["I" /* DELETE_PANEL_FAILURE */], function (state) {
  state.deletingPanel = false;
  state.deletePanelFailed = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["J" /* DELETE_PANEL_SUCCESS */], function (state, panelId) {
  state.deletingPanel = false;

  state.panels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panels, panelId);
  state.panelSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelSettings, panelId);
  state.panelInteractions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelInteractions, panelId);
  state.panelPages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelPages, panelId);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["K" /* SET_GALLERY_IMAGES */], function (state, images) {
  state.galleryImages = images;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["L" /* SET_GALLERY_VISIBLE */], function (state, isVisible) {
  state.galleryVisible = isVisible;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["M" /* SET_GALLERY_INDEX */], function (state, index) {
  state.galleryIndex = index;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["N" /* PAUSE_PANEL */], function (state, panelId) {
  state.panelPaused = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.panelPaused, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, true));
  state.panelPausedInteractions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.pausedInteractions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, []));
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["O" /* UNPAUSE_PANEL */], function (state, panelId) {
  state.panelPaused = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.panelPaused, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, false));

  if (!Object.prototype.hasOwnProperty.call(state.panelPausedInteractions, panelId)) {
    state.panelPausedInteractions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.pausedInteractions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, []));
  }

  var pausedInteractions = state.panelPausedInteractions[panelId];
  var sortingKey = state.panelTypes[panelId] === 'onair' ? 'onAirId' : 'id';

  if (!Array.isArray(state.panelInteractions[panelId])) {
    state.panelInteractions[panelId] = [];
  }

  state.panelInteractions[panelId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["sortedUniq"])(state.panelInteractions[panelId].sort(function (a, b) {
    return b[sortingKey] - a[sortingKey];
  }).concat(pausedInteractions));

  state.panelPausedInteractions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.pausedInteractions, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, []));
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["P" /* CLEAR_PANEL_PAUSED */], function (state, panelId) {
  state.panelPaused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.panelPaused, panelId);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Q" /* CLEAR_DASHBOARD_PANEL_PAUSED */], function (state) {
  state.panelPaused = {};
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["R" /* SET_PANEL_SETTINGS_DIALOG */], function (state, settings) {
  state.panelSettingsDialog = settings;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["S" /* SET_PANEL_SETTINGS_DIALOG_VISIBLE */], function (state, isVisible) {
  state.panelSettingsDialogVisible = isVisible;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["T" /* DELETE_INTERACTION_SUCCESS */], function (state, _ref10) {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
      panelId = _ref11[0],
      interactionId = _ref11[1];

  state.panelInteractions[panelId] = state.panelInteractions[panelId].filter(function (id) {
    return id !== interactionId;
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["U" /* GET_SEARCH_RESULTS_REQUEST */], function (state) {
  state.searching = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["V" /* GET_SEARCH_RESULTS_SUCCESS */], function (state, response) {
  state.searchResults = response.results;
  state.searchCount = response.count;
  state.searching = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["W" /* GET_SEARCH_FIELDS_REQUEST */], function (state) {
  state.searchFieldsLoading = true;
  state.searchFieldsFailure = false;
  state.searchFieldsSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["X" /* GET_SEARCH_FIELDS_SUCCESS */], function (state, response) {
  state.searchFields = response;
  state.searchFieldsSuccess = true;
  state.searchFieldsLoading = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Y" /* GET_SEARCH_FIELDS_FAILURE */], function (state, error) {
  state.searchFieldsFailure = true;
  state.searchFieldsLoading = false;
  state.searchFieldsError = error;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Z" /* SET_SEARCH_TERM */], function (state, term) {
  state.searchTerm = term;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_0" /* GET_TWITTER_TRENDS_REQUEST */], function (state) {
  state.fetchingTwitterTrends = true;
  state.fetchingTwitterTrendsSuccess = false;
  state.fetchingTwitterTrendsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_1" /* GET_TWITTER_TRENDS_SUCCESS */], function (state, data) {
  state.fetchingTwitterTrends = false;
  state.fetchingTwitterTrendsSuccess = true;
  state.twitterTrends = data;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_2" /* GET_TWITTER_TRENDS_FAILURE */], function (state, error) {
  state.fetchingTwitterTrends = false;
  state.fetchingTwitterTrendsFailed = true;
  state.twitterTrendsError = error;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_3" /* EXPORT_TO_FILE_REQUEST */], function (state) {
  state.loadingExportFiles = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_4" /* EXPORT_TO_FILE_SUCCESS */], function (state) {
  state.loadingExportFiles = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_5" /* EXPORT_TO_FILE_FAILURE */], function (state) {
  state.loadingExportFiles = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_6" /* UPDATE_PANEL_ORDER_REQUEST */], function (state, panels) {
  state.panels = panels;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_7" /* UPDATE_PANEL_ORDER_SUCCESS */], function (state) {
  state.updatePanelOrderSuccess = true;
  state.updatePanelOrderFailure = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_8" /* UPDATE_PANEL_ORDER__FAILURE */], function (state) {
  state.updatePanelOrderFailure = true;
  state.updatePanelOrderSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_types$GET_INTERACTIO, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_9" /* GET_INSTANT_POLL_STATS_SUCCESS */], function (state, _ref12) {
  var stats = _ref12.stats,
      panelId = _ref12.panelId;

  state.instantPollResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.instantPollResults, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, panelId, stats));
}), _types$GET_INTERACTIO);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Normalized panel data (to keep reactivity simpler)
  panels: {},
  panelSettings: {},
  panelInteractions: {},
  panelPages: {},
  panelIntervals: {},
  panelPaused: {},
  panelPausedInteractions: {},
  panelTypes: {},

  interactions: {},
  interactionHeights: {},
  pollingIntervals: {},
  instantPollResults: {},

  loadingInteractions: {},
  loadingInteractionsSuccess: {},
  loadingInteractionsFailed: {},
  loadingInteractionsError: {},
  hasMoreInteractions: {},

  threadId: null,
  threadChannel: null,
  threads: [],
  threadCounts: {},
  threadDialogVisible: false,
  loadingThreads: false,
  loadingThreadsSuccess: false,
  loadingThreadsFailed: false,
  loadingThreadsError: null,

  loadingPanels: false,
  loadingPanelsSuccess: false,
  loadingPanelsFailed: false,
  loadingPanelsError: null,

  mediaIsPlaying: [],

  galleryImages: [],
  galleryVisible: false,
  galleryIndex: 0,

  panelSettingsDialog: {
    id: null,
    name: '',
    color: '',
    columns: null,
    type: null,
    channelIds: [],
    campaignIds: []
  },
  panelSettingsDialogVisible: false,
  twitterTrends: [],

  searchTerm: null,
  searchResults: [],
  searchCount: 0,
  searching: false,
  searchFields: null,

  loadingExportFiles: false,

  updatePanelOrderSuccess: false,
  updatePanelOrderFailure: false
});

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(577);


/* harmony default export */ __webpack_exports__["a"] = ({
  showSocialPostDialog: function showSocialPostDialog(_ref, post) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    if (post && post.id) {
      dispatch('social/editingPost', post, { root: true });
    } else {
      dispatch('social/creatingPost', post, { root: true });
    }
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SHOW_SOCIAL_POST_DIALOG */]);
  },
  hideSocialPostDialog: function hideSocialPostDialog(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* HIDE_SOCIAL_POST_DIALOG */]);
  }
});

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1223);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(577);


var _types$SHOW_SOCIAL_PO;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$SHOW_SOCIAL_PO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SHOW_SOCIAL_PO, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SHOW_SOCIAL_POST_DIALOG */], function (state) {
  state.socialPostModal = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SHOW_SOCIAL_PO, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* HIDE_SOCIAL_POST_DIALOG */], function (state) {
  state.socialPostModal = false;
}), _types$SHOW_SOCIAL_PO);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  socialPostModal: false
});

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(578);



/* harmony default export */ __webpack_exports__["a"] = ({
  getPlugins: function getPlugins(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_PLUGINS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('plugins/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_PLUGINS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_PLUGINS_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  plugins: function plugins(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(state.plugins).sort(function (a, b) {
      return a.plugin - b.plugin;
    });
  }
});

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1228);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(578);


var _types$GET_PLUGINS_RE;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_PLUGINS_RE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PLUGINS_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_PLUGINS_REQUEST */], function (state) {
  state.loadingPlugins = true;
  state.loadingPluginsFailed = false;
  state.loadingPluginsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PLUGINS_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_PLUGINS_FAILURE */], function (state, error) {
  state.loadingPlugins = false;
  state.loadingPluginsFailed = true;
  state.loadingPluginsErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PLUGINS_RE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_PLUGINS_SUCCESS */], function (state, data) {
  state.loadingPlugins = false;
  state.loadingPluginsSucceeded = true;
  state.plugins = data.results;
}), _types$GET_PLUGINS_RE);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  plugins: [],
  loadingPlugins: false,
  loadingPluginsFailed: false,
  loadingPluginsSucceeded: false,
  loadingPluginsErrors: null
});

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(579);



/* harmony default export */ __webpack_exports__["a"] = ({
  downloadOptinsReport: function downloadOptinsReport(_ref, privacyTypes) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* DOWNLOAD_OPTINS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('/privacy/optins/download/', privacyTypes).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* DOWNLOAD_OPTINS_SUCCESS */]);
      dispatch('toast/success', 'Your request has been successfully received. You will be notified when the file is ready to download.', { root: true });
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* DOWNLOAD_OPTINS_FAILURE */], error);
      dispatch('toast/error', 'Your request to download messages failed. Please contact support for more help.', { root: true });
    });
  },
  createOptins: function createOptins(_ref2, _ref3) {
    var commit = _ref2.commit;
    var company = _ref3.company,
        payload = _ref3.payload;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CREATE_OPTINS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('/privacy/optins/system/' + company.id + '/', payload).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CREATE_OPTINS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CREATE_OPTINS_FAILURE */], error.error);
    });
  }
});

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1232);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(579);


var _types$DOWNLOAD_OPTIN;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$DOWNLOAD_OPTIN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* DOWNLOAD_OPTINS_REQUEST */], function (state) {
  state.downloadingOptins = true;
  state.downloadingOptinsFailed = false;
  state.downloadingOptinsSucceeded = false;
  state.downloadingOptinsError = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* DOWNLOAD_OPTINS_SUCCESS */], function (state) {
  state.downloadingOptins = false;
  state.downloadingOptinsFailed = false;
  state.downloadingOptinsSucceeded = true;
  state.downloadingOptinsError = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* DOWNLOAD_OPTINS_FAILURE */], function (state, error) {
  state.downloadingOptins = false;
  state.downloadingOptinsFailed = true;
  state.downloadingOptinsSucceeded = true;
  state.downloadingOptinsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CREATE_OPTINS_REQUEST */], function (state) {
  state.creatingOptins = true;
  state.creatingOptinsFailed = false;
  state.creatingOptinsSucceeded = false;
  state.creatingOptinsError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CREATE_OPTINS_SUCCESS */], function (state) {
  state.creatingOptins = false;
  state.creatingOptinsFailed = false;
  state.creatingOptinsSucceeded = true;
  state.creatingOptinsError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$DOWNLOAD_OPTIN, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CREATE_OPTINS_FAILURE */], function (state, error) {
  state.creatingOptins = false;
  state.creatingOptinsFailed = true;
  state.creatingOptinsSucceeded = false;
  state.creatingOptinsError = error;
}), _types$DOWNLOAD_OPTIN);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  optins: {},

  loadingOptins: false,
  loadingOptinsFailed: false,
  loadingOptinsSucceeded: false,
  loadingOptinsError: null,

  downloadOptinsUrl: null,
  downloadingOptins: false,
  downloadingOptinsFailed: false,
  downloadingOptinsSucceeded: false,
  downloadingOptinsError: null,

  creatingOptins: false,
  creatingOptinsFailed: false,
  creatingOptinsSucceeded: false,
  creatingOptinsError: null
});

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(193);




/* harmony default export */ __webpack_exports__["a"] = ({
  getProfileFields: function getProfileFields(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('/construct/profiles/fields/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_PROFILE_FIELDS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* GET_PROFILE_FIELDS_FAILURE */], error);
    });
  },
  getProfiles: function getProfiles(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var payload = { params: { page: state.page } };
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_PROFILES_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].get('/construct/profiles/query/', payload).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_PROFILES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_PROFILES_FAILURE */], error);
    });
  },
  searchProfiles: function searchProfiles(_ref3, query) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var payload = { params: { page: state.page } };
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_IS_SEARCHING */]);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_PROFILES_REQUEST */]);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* SET_SEARCH_QUERY */], query);

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('/construct/profiles/search/', query, payload).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_PROFILES_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_PROFILES_FAILURE */], error);
    });
  },
  loadMoreProfiles: function loadMoreProfiles(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_PAGE_COUNT */], state.page + 1);

    if (state.isSearching && state.searchQuery) {
      dispatch('searchProfiles', state.searchQuery);
    } else {
      dispatch('getProfiles');
    }
  },
  searchProfileForIdentity: function searchProfileForIdentity(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    var _ref7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
        originatorType = _ref7[0],
        originator = _ref7[1];

    var processedOriginator = originator;
    if (originatorType === 'whatsapp_handle') {
      processedOriginator = originator + '@s.whatsapp.net';
    }

    var query = {
      type: 'and',
      query: [{ field: 'identifiers.' + originatorType, lookup: 'equals', value: processedOriginator }]
    };
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* colonyAPI */].post('/construct/profiles/search/', query).then(function (response) {
      if (response.data.length) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* GET_PROFILE_IDENTITY_SUCCESS */], response.data);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SHOW_PROFILES_DIALOG */], true);
      } else {
        dispatch('toast/info', 'Profile not yet available for ' + originator, { root: true });
      }
    }).catch(function () {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* GET_PROFILE_IDENTITY_FAILURE */]);
      dispatch('toast/error', 'We were unable to get a profile for ' + originator, {
        root: true
      });
    });
  },
  updateDemographicFilters: function updateDemographicFilters(_ref8, _ref9) {
    var commit = _ref8.commit;
    var filterKeyValue = _ref9.filterKeyValue,
        val = _ref9.val;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* SET_DEMOGRAPHIC_FILTERS */], { filterKeyValue: filterKeyValue, val: val });
  },
  updateProfileFilters: function updateProfileFilters(_ref10, filters) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* SET_PROFILES_FILTER_FIELDS */], filters);
  }
});

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1236);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(193);



var _types$GET_PROFILE_FI;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_PROFILE_FI = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_PROFILE_FIELDS_SUCCESS */], function (state, response) {
  state.profileFields = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_PROFILES_REQUEST */], function (state) {
  state.loadingProfiles = true;
  state.loadProfilesFailed = false;
  state.loadProfilesSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_PROFILES_FAILURE */], function (state, error) {
  state.loadingProfiles = false;
  state.loadProfilesFailed = true;
  state.loadProfilesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_PROFILES_SUCCESS */], function (state, response) {
  state.loadingProfiles = false;
  state.loadProfilesSuccess = true;
  state.profiles = response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* LOAD_MORE_PROFILES_SUCCESS */], function (state, response) {
  state.loadingProfiles = false;
  state.loadProfilesSuccess = true;
  state.profiles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.profiles), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SELECT_PROFILES_PROFILE */], function (state, profile) {
  state.selectedProfile = profile;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* SET_PROFILES_COUNT */], function (state, profilesCount) {
  state.profilesCount = profilesCount;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* SHOW_PROFILES_DIALOG */], function (state, condition) {
  state.profileDialogVisible = condition;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SHOW_DISPLAY_PROFILES */], function (state, value) {
  state.showDisplayProfiles = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* SET_PAGE_COUNT */], function (state, page) {
  state.page = page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* RESET_PAGE_COUNT */], function (state) {
  state.page = 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* RESET_PROFILES */], function (state) {
  state.profileFilterFields = {};
  state.profiles = [];
  state.page = 1;
  state.searchQuery = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_IS_SEARCHING */], function (state) {
  state.isSearching = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* SET_SEARCH_QUERY */], function (state, query) {
  state.searchQuery = query;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* SET_DEMOGRAPHIC_FILTERS */], function (state, query) {
  state.profileFilters.demographicFilters[query.filterKeyValue] = query.val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* SET_CAMPAIGN_SURVEY_FILTERS */], function (state, query) {
  state.profileFilters.campaignSurveyFilters = query;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* SET_PROFILES_FILTER_FIELDS */], function (state, query) {
  state.profileFilterFields = query;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* GET_PROFILE_IDENTITY_REQUEST */], function (state) {
  state.loadingProfileIdentity = true;
  state.loadProfileIdentityFailed = false;
  state.loadProfileIdentitySuccess = false;
  state.selectedProfile = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* GET_PROFILE_IDENTITY_FAILURE */], function (state) {
  state.loadingProfileIdentity = false;
  state.loadProfileIdentityFailed = true;
  state.loadProfileIdentitySuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_PROFILE_FI, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* GET_PROFILE_IDENTITY_SUCCESS */], function (state, response) {
  state.loadingProfileIdentity = false;
  state.loadProfileIdentityFailed = false;
  state.loadProfileIdentitySuccess = true;

  if (response.length) {
    state.selectedProfile = response[0];
  } else {
    state.selectedProfile = {};
  }
}), _types$GET_PROFILE_FI);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  profiles: [],
  profileFields: {},
  profileFilters: {
    demographicFilters: {
      genderFilters: [],
      ethnicityFilters: [],
      languageFilters: [],
      locationFilters: [],
      contactFilters: [],
      channelsUsedFilters: [],
      engagedDates: [],
      duringWhichShowFilters: [],
      ageFilters: []
    },
    campaignSurveyFilters: []
  },
  profileFilterFields: {},
  selectedProfile: {},
  loadingProfiles: false,
  loadProfilesFailed: false,
  loadProfilesSuccess: false,
  profileDialogVisible: false,
  page: 1,
  profilesCount: 0,
  showDisplayProfiles: false,
  isSearching: false,
  searchQuery: null,

  loadingProfileIdentity: false,
  loadProfileIdentityFailed: false,
  loadProfileIdentitySuccess: false
});

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(580);



/* harmony default export */ __webpack_exports__["a"] = ({
  requestGenerateUrl: function requestGenerateUrl(_ref, data) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GENERATE_URL_REQUEST */]);

    var urls = {
      favourites: {
        json: 'construct/interactions/campaign_feed/',
        rss: 'construct/interactions/campaign_rssfeed/'
      },
      onair: {
        json: 'construct/interactions/onair_feed/',
        rss: 'construct/interactions/onair_rssfeed/'
      }
    };

    var generatedOption = data.isGenerateForOnAir ? 'onair' : 'favourites';
    var generatedType = data.isResponseTypeRSS ? 'rss' : 'json';
    var url = 'interactions/token/?id=' + data.selectedId;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get(url).then(function (response) {
      var generatedurl = '' + __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].defaults.baseURL + urls[generatedOption][generatedType] + response.data.access_token + '/';
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GENERATE_URL_SUCCESS */], generatedurl);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GENERATE_URL_FAILED */], error);
    });
  }
});

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1240);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(580);


var _types$GENERATE_URL_R;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GENERATE_URL_R = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GENERATE_URL_R, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GENERATE_URL_REQUEST */], function (state) {
  state.loadingGenerateUrl = true;
  state.generateUrlFailed = false;
  state.generateUrlSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GENERATE_URL_R, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GENERATE_URL_FAILED */], function (state) {
  state.loadingGenerateUrl = false;
  state.generateUrlFailed = true;
  state.generateUrlSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GENERATE_URL_R, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GENERATE_URL_SUCCESS */], function (state, payload) {
  state.loadingGenerateUrl = false;
  state.generateUrlFailed = false;
  state.generateUrlSuccess = true;
  state.generatedUrl = payload;
}), _types$GENERATE_URL_R);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingGenerateUrl: false,
  generateUrlFailed: false,
  generateUrlSuccess: false,
  generatedUrl: ''
});

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_colony__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(581);



/* harmony default export */ __webpack_exports__["a"] = ({
  getCampaignRules: function getCampaignRules(_ref, campaignId) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_RULES_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].get('rules/', { params: { campaign_id: campaignId } }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_RULES_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_RULES_FAILURE */], error);
    });
  },
  getRule: function getRule(_ref2, ruleId) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* GET_RULE_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].get('rules/' + ruleId + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GET_RULE_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* GET_RULE_FAILURE */], error);
    });
  },
  createRule: function createRule(_ref3, rule) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* CREATE_RULE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].post('rules/', rule).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* CREATE_RULE_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CREATE_RULE_FAILURE */], error);
    });
  },
  updateRule: function updateRule(_ref4, rule) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* UPDATE_RULE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].put('rules/' + rule.id + '/', rule).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* UPDATE_RULE_SUCCESS */]);
      dispatch('getCampaignRules', rule.campaign);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* UPDATE_RULE_FAILURE */], error);
    });
  },
  deleteRule: function deleteRule(_ref5, payload) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* DELETE_RULE_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].delete('rules/' + payload.rule.id + '/').then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* DELETE_RULE_SUCCESS */], payload.ruleIndex);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* DELETE_RULE_FAILURE */], error);
    });
  },
  getRuleFields: function getRuleFields(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* GET_RULE_FIELDS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].get('rules/fields/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* GET_RULE_FIELDS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* GET_RULE_FIELDS_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1244);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(581);





var _types$GET_RULES_REQU;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_RULES_REQU = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* GET_RULES_REQUEST */], function (state) {
  state.loadingRules = true;
  state.loadingRulesFailed = false;
  state.loadingRulesSuccess = false;
  state.loadingRulesError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* GET_RULES_FAILURE */], function (state, error) {
  state.loadingRules = false;
  state.loadingRulesFailed = true;
  state.loadingRulesSuccess = false;
  state.loadingRulesError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* GET_RULES_SUCCESS */], function (state, response) {
  state.loadingRules = false;
  state.loadingRulesFailed = false;
  state.loadingRulesSuccess = true;
  state.loadingRulesError = null;
  state.rules = response.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* GET_RULE_REQUEST */], function (state) {
  state.loadingRule = true;
  state.loadingRuleFailed = false;
  state.loadingRuleSuccess = false;
  state.loadingRuleError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* GET_RULE_FAILURE */], function (state, error) {
  state.loadingRule = false;
  state.loadingRuleFailed = true;
  state.loadingRuleSuccess = false;
  state.loadingRuleError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* GET_RULE_SUCCESS */], function (state, response) {
  state.loadingRule = false;
  state.loadingRuleFailed = false;
  state.loadingRuleSuccess = true;
  state.loadingRuleError = null;
  state.currentRule = response;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* CREATE_RULE_REQUEST */], function (state) {
  state.creatingRule = true;
  state.creatingRuleFailed = false;
  state.creatingRuleSuccess = false;
  state.creatingRuleError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CREATE_RULE_FAILURE */], function (state, error) {
  state.creatingRule = false;
  state.creatingRuleFailed = true;
  state.creatingRuleSuccess = false;
  state.creatingRuleError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CREATE_RULE_SUCCESS */], function (state, response) {
  state.creatingRule = false;
  state.creatingRuleFailed = false;
  state.creatingRuleSuccess = true;
  state.creatingRuleError = null;
  state.rules.push(response);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* UPDATE_RULE_REQUEST */], function (state) {
  state.updatingRule = true;
  state.updatingRuleFailed = false;
  state.updatingRuleSuccess = false;
  state.updatingRuleError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* UPDATE_RULE_FAILURE */], function (state, error) {
  state.updatingRule = false;
  state.updatingRuleFailed = true;
  state.updatingRuleSuccess = false;
  state.updatingRuleError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* UPDATE_RULE_SUCCESS */], function (state) {
  state.updatingRule = false;
  state.updatingRuleFailed = false;
  state.updatingRuleSuccess = true;
  state.updatingRuleError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* DELETE_RULE_REQUEST */], function (state) {
  state.deletingRule = true;
  state.deletingRuleFailed = false;
  state.deletingRuleSuccess = false;
  state.deletingRuleError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* DELETE_RULE_FAILURE */], function (state, error) {
  state.deletingRule = false;
  state.deletingRuleFailed = true;
  state.deletingRuleSuccess = false;
  state.deletingRuleError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* DELETE_RULE_SUCCESS */], function (state, ruleIndex) {
  state.deletingRule = false;
  state.deletingRuleFailed = false;
  state.deletingRuleSuccess = true;
  state.deletingRuleError = null;
  state.rules.splice(ruleIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* GET_RULE_FIELDS_REQUEST */], function (state) {
  state.loadingRuleFields = true;
  state.loadingRuleFieldsFailed = false;
  state.loadingRuleFieldsSuccess = false;
  state.loadingRuleFieldsError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* GET_RULE_FIELDS_FAILURE */], function (state, error) {
  state.loadingRuleFields = false;
  state.loadingRuleFieldsFailed = true;
  state.loadingRuleFieldsSuccess = false;
  state.loadingRuleFieldsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* GET_RULE_FIELDS_SUCCESS */], function (state, response) {
  state.loadingRuleFields = false;
  state.loadingRuleFieldsFailed = false;
  state.loadingRuleFieldsSuccess = true;
  state.loadingRuleFieldsError = null;
  state.ruleFields = response;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* SET_RULE_TITLE */], function (state, title) {
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, { title: title });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* SET_RULE_EVENT */], function (state, event) {
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, { events: event });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* ADD_RULE_CONDITION */], function (state) {
  var conditions = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.currentRule.conditions), [{}]);
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, { conditions: conditions });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* REMOVE_RULE_CONDITION */], function (state, index) {
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, {
    conditions: state.currentRule.conditions.filter(function (_condition, conditionIndex) {
      return index !== conditionIndex;
    })
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* SET_RULE_CONDITION */], function (state, _ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      index = _ref2[0],
      condition = _ref2[1];

  state.currentRule.conditions[index] = condition;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* ADD_RULE_ACTION */], function (state) {
  var actions = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.currentRule.actions), [{}]);
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, { actions: actions });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* REMOVE_RULE_ACTION */], function (state, index) {
  state.currentRule = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.currentRule, {
    actions: state.currentRule.actions.filter(function (_action, actionIndex) {
      return index !== actionIndex;
    })
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_RULES_REQU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* SET_RULE_ACTION */], function (state, _ref3) {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
      index = _ref4[0],
      action = _ref4[1];

  state.currentRule.actions[index] = action;
}), _types$GET_RULES_REQU);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rules: [],
  loadingRules: false,
  loadingRulesFailed: false,
  loadingRulesSuccess: false,
  loadingRulesError: null,

  currentRule: {
    title: '',
    events: '',
    conditions: [],
    actions: []
  },
  loadingRule: false,
  loadingRuleFailed: false,
  loadingRuleSuccess: false,
  loadingRuleError: null,

  creatingRule: false,
  creatingRuleFailed: false,
  creatingRuleSuccess: false,
  creatingRuleError: false,

  updatingRule: false,
  updatingRuleFailed: false,
  updatingRuleSuccess: false,
  updatingRuleError: null,

  deletingRule: false,
  deletingRuleFailed: false,
  deletingRuleSuccess: false,
  deletingRuleError: null,

  ruleFields: {
    events: {},
    conditions: {},
    actions: {}
  },
  loadingRuleFields: false,
  loadingRuleFieldsFailed: false,
  loadingRuleFieldsSuccess: false,
  loadingRuleFieldsError: null
});

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_colony__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(344);



/* harmony default export */ __webpack_exports__["a"] = ({
  createSocialPost: function createSocialPost(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CREATE_SOCIAL_POST_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].post('radiodashboard/post-message/', payload).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CREATE_SOCIAL_POST_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* CREATE_SOCIAL_POST_FAILURE */], error.error);
    });
  },
  updateScheduledPost: function updateScheduledPost(_ref2, payload) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* UPDATE_SCHEDULED_MESSAGE_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].patch('radiodashboard/scheduled-messages/' + payload.id + '/', payload).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* UPDATE_SCHEDULED_MESSAGE_SUCCESS */], payload);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* UPDATE_SCHEDULED_MESSAGE_FAILURE */], error);
    });
  },
  deleteScheduledPost: function deleteScheduledPost(_ref3, id) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* DELETE_SCHEDULED_MESSAGE_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].delete('radiodashboard/scheduled-messages/' + id + '/delete/').then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_SCHEDULED_MESSAGE_SUCCESS */], id);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* DELETE_SCHEDULED_MESSAGE_FAILURE */], error);
    });
  },
  getScheduledMessages: function getScheduledMessages(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* GET_SCHEDULED_MESSAGES_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].get('radiodashboard/scheduled-messages/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* GET_SCHEDULED_MESSAGES_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GET_SCHEDULED_MESSAGES_FAILURE */], error.error);
    });
  },
  editingPost: function editingPost(_ref5, post) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* EDITING_SOCIAL_POST */], post);
  },
  creatingPost: function creatingPost(_ref6, post) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* CREATING_SOCIAL_POST */], post);
  }
});

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mockUtils__ = __webpack_require__(1248);


/* harmony default export */ __webpack_exports__["a"] = ({
  facebookInsightsOverviewData: function facebookInsightsOverviewData(state) {
    return state.facebookPages.reduce(function (acc, x) {
      acc[x.id] = __WEBPACK_IMPORTED_MODULE_0__mockUtils__["a" /* default */].getInsightOverviewData();
      return acc;
    }, {});
  },
  instagramInsightsOverviewData: function instagramInsightsOverviewData(state) {
    return state.instagramPages.reduce(function (acc, x) {
      acc[x.id] = __WEBPACK_IMPORTED_MODULE_0__mockUtils__["a" /* default */].getInsightOverviewData();
      return acc;
    }, {});
  }
});

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1250);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var getRandomNumber = function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
var today = function today() {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
};
var days = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(56).keys()).reverse();

var metrics = function metrics() {
  return [{
    name: 'page_views',
    title: 'Page Views',
    description: "The number of times a Page's profile has been viewed by logged in and logged out people."
  }, {
    name: 'page_likes',
    title: 'Page Likes',
    description: 'The number of people who have liked your page'
  }, {
    name: 'reach',
    title: 'Reach',
    description: 'The number of people who had any posts from your Page enter their screen.'
  }, {
    name: 'post_engagements',
    title: 'Post Engagements',
    description: 'The number of times people have engaged with your posts through likes, comments and shares and more.'
  }];
};

var getInsightOverviewData = function getInsightOverviewData() {
  return metrics().reduce(function (acc, x) {
    var values = days.map(function (i) {
      return {
        value: getRandomNumber(0, 10),
        date: today().subtract(i, 'days').format('MMM D'),
        end_date: today().subtract(i, 'days').unix()
      };
    });

    acc[x.name] = x;
    acc[x.name].values = values;
    acc[x.name].value = values.reduce(function (ac, a) {
      return ac + a.value;
    }, 0);
    acc[x.name].difference = getRandomNumber(100, 400) - acc[x.name].value;

    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInsightOverviewData: getInsightOverviewData
});

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(344);


var _types$CREATE_SOCIAL_;

/* eslint no-param-reassign: "off" */



/* harmony default export */ __webpack_exports__["a"] = (_types$CREATE_SOCIAL_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* CREATE_SOCIAL_POST_REQUEST */], function (state) {
  state.createSocialPostRequest = true;
  state.createSocialPostSuccess = false;
  state.createSocialPostFailed = false;
  state.createSocialPostErrors = null;
  state.post = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CREATE_SOCIAL_POST_SUCCESS */], function (state) {
  state.createSocialPostRequest = false;
  state.createSocialPostSuccess = true;
  state.createSocialPostFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* CREATE_SOCIAL_POST_FAILURE */], function (state, error) {
  state.createSocialPostRequest = false;
  state.createSocialPostSuccess = false;
  state.createSocialPostFailed = true;
  state.createSocialPostError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_SCHEDULED_MESSAGES_REQUEST */], function (state) {
  state.getScheduledMessagesRequest = true;
  state.getScheduledMessagesSuccess = false;
  state.getScheduledMessagesFailed = false;
  state.getScheduledMessagesErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_SCHEDULED_MESSAGES_SUCCESS */], function (state, data) {
  state.getScheduledMessagesRequest = false;
  state.getScheduledMessagesSuccess = true;
  state.getScheduledMessagesFailed = false;
  state.scheduledMessages = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_SCHEDULED_MESSAGES_FAILURE */], function (state, errors) {
  state.getScheduledMessagesRequest = false;
  state.getScheduledMessagesSuccess = false;
  state.getScheduledMessagesFailed = true;
  state.getScheduledMessagesErrors = errors;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* DELETE_SCHEDULED_MESSAGE_REQUEST */], function (state) {
  state.deleteScheduledMessageRequest = true;
  state.deleteScheduledMessageSuccess = false;
  state.deleteScheduledMessageFailed = false;
  state.deleteScheduledMessageErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* DELETE_SCHEDULED_MESSAGE_SUCCESS */], function (state, id) {
  state.deleteScheduledMessageRequest = false;
  state.deleteScheduledMessageSuccess = true;
  state.deleteScheduledMessageFailed = false;
  state.scheduledMessages.splice(state.scheduledMessages.findIndex(function (x) {
    return x.id === id;
  }), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* DELETE_SCHEDULED_MESSAGE_FAILURE */], function (state, errors) {
  state.deleteScheduledMessageRequest = false;
  state.deleteScheduledMessageSuccess = false;
  state.deleteScheduledMessageFailed = true;
  state.deleteScheduledMessageErrors = errors;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* UPDATE_SCHEDULED_MESSAGE_REQUEST */], function (state) {
  state.updateScheduledMessageRequest = true;
  state.updateScheduledMessageSuccess = false;
  state.updateScheduledMessageFailed = false;
  state.updateScheduledMessageErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* UPDATE_SCHEDULED_MESSAGE_SUCCESS */], function (state, data) {
  state.updateScheduledMessageRequest = false;
  state.updateScheduledMessageSuccess = true;
  state.updateScheduledMessageFailed = false;

  var updated = {
    media: data.media || [],
    channels: data.channelIds || [],
    message: data.message || '',
    post_date: data.scheduleTimestamp ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.scheduleTimestamp * 1000).format('YYYY-MM-DDTHH:mm:ss') : null,
    id: data.id
  };

  var idx = state.scheduledMessages.findIndex(function (x) {
    return x.id === data.id;
  });

  if (updated.post_date) {
    state.scheduledMessages.splice(idx, 1, updated);
  } else {
    state.scheduledMessages.splice(idx, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* UPDATE_SCHEDULED_MESSAGE_FAILURE */], function (state, error) {
  state.updateScheduledMessageRequest = false;
  state.updateScheduledMessageSuccess = false;
  state.updateScheduledMessageFailed = true;
  state.updateScheduledMessageErrors = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* EDITING_SOCIAL_POST */], function (state, post) {
  state.isEditing = true;
  state.post = post;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* CREATING_SOCIAL_POST */], function (state, post) {
  state.isEditing = false;
  state.post = post;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* SET_SELECTED_FACEBOOK_PAGE */], function (state, pageId) {
  state.selectedFacebookPage = pageId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* SET_SELECTED_INSTAGRAM_PAGE */], function (state, pageId) {
  state.selectedInstagramPage = pageId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CREATE_SOCIAL_, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* SET_FACEBOOK_PAGES */], function (state, pages) {
  state.facebookPages = pages;
}), _types$CREATE_SOCIAL_);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  createSocialPostRequest: false,
  createSocialPostSuccess: false,
  createSocialPostFailed: false,
  createSocialPostErrors: null,

  deleteScheduledMessageRequest: false,
  deleteScheduledMessageSuccess: false,
  deleteScheduledMessageFailed: false,
  deleteScheduledMessageErrors: null,

  updateScheduledMessageRequest: false,
  updateScheduledMessageSuccess: false,
  updateScheduledMessageFailed: false,
  updateScheduledMessageErrors: null,

  getScheduledMessagesRequest: false,
  getScheduledMessagesSuccess: false,
  getScheduledMessagesFailed: false,
  getScheduledMessagesErrors: null,
  scheduledMessages: [],

  isEditing: false,
  post: null,

  /* facebook insights */

  facebookPages: [],

  selectedFacebookPage: null,

  /* Instagram Insights */
  instagramPages: [],
  selectedInstagramPage: null
});

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_colony__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(345);





/* harmony default export */ __webpack_exports__["a"] = ({
  getStationActivity: function getStationActivity(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_STATION_ACTIVITY */]);
    var params = {
      params: {
        region: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */].region,
        offset: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */].offset,
        startDate: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */].startDate.format(),
        endDate: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */].endDate.format()
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0__api_colony__["a" /* default */].get('station-activity/', params).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_STATION_ACTIVITY_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_STATION_ACTIVITY_FAILURE */], error.error);
    });
  }
});

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(582);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(345);


var _types$SET_STATION_AC;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$SET_STATION_AC = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_STATION_ACTIVITY_OFFSET */], function (state, payload) {
  state.offset = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_STATION_ACTIVITY_REGION */], function (state, payload) {
  state.region = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_STATION_ACTIVITY_START_DATE */], function (state, payload) {
  state.startDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_STATION_ACTIVITY_END_DATE */], function (state, payload) {
  state.endDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* GET_STATION_ACTIVITY */], function (state) {
  state.loadingStationActivity = true;
  state.loadingStationActivityFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* GET_STATION_ACTIVITY_FAILURE */], function (state, error) {
  state.loadingStationActivity = false;
  state.loadingStationActivityFailed = true;
  state.loadingStationActivityError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STATION_AC, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GET_STATION_ACTIVITY_SUCCESS */], function (state, response) {
  state.loadingStationActivity = false;
  state.stationActivityData = response.data;
  state.loadingStationActivityFailed = false;
}), _types$SET_STATION_AC);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiv2Client__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(346);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          query($surveyId: Int, $questionId: Int, $choiceId: Int, $page: Int) {\n            getQuestionChoiceRespondents(surveyId: $surveyId, questionId: $questionId, choiceId: $choiceId, page: $page) {\n              entries {\n                mobileNumber\n                dateAnswered\n                fingerprint\n                id\n                surveyId\n                answer {\n                  id\n                  choice {\n                    id\n                    title\n                  }\n                  choices {\n                    id\n                    title\n                  }\n                  choiceId\n                  question {\n                    id\n                    title\n                    questionType\n                    chart\n                    categoryId\n                    insight\n                    isRequired\n                    isGlobal\n                    isProfile\n                    isAnalytics\n                    profileField\n                  }\n                  questionId\n                  input\n                }\n              }\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n          }\n        '], ['\n          query($surveyId: Int, $questionId: Int, $choiceId: Int, $page: Int) {\n            getQuestionChoiceRespondents(surveyId: $surveyId, questionId: $questionId, choiceId: $choiceId, page: $page) {\n              entries {\n                mobileNumber\n                dateAnswered\n                fingerprint\n                id\n                surveyId\n                answer {\n                  id\n                  choice {\n                    id\n                    title\n                  }\n                  choices {\n                    id\n                    title\n                  }\n                  choiceId\n                  question {\n                    id\n                    title\n                    questionType\n                    chart\n                    categoryId\n                    insight\n                    isRequired\n                    isGlobal\n                    isProfile\n                    isAnalytics\n                    profileField\n                  }\n                  questionId\n                  input\n                }\n              }\n              pageNumber\n              pageSize\n              totalEntries\n              totalPages\n            }\n          }\n        ']);







/* harmony default export */ __webpack_exports__["a"] = ({
  getSurveyCharts: function getSurveyCharts(_ref, surveyId) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["d" /* GET_SURVEY_CHARTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].post('/analytics/surveys/', { survey_id: surveyId, filter_by: 'survey' }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["f" /* GET_SURVEY_CHARTS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["e" /* GET_SURVEY_CHARTS_FAILURE */], error);
    });
  },
  getSpotCharts: function getSpotCharts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["n" /* GET_SPOT_CHARTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/analytics/surveys/spots/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["p" /* GET_SPOT_CHARTS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["o" /* GET_SPOT_CHARTS_FAILURE */], error);
    });
  },
  getPeriodCharts: function getPeriodCharts(_ref3, _ref4) {
    var commit = _ref3.commit;
    var period = _ref4.period,
        date = _ref4.date;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["d" /* GET_SURVEY_CHARTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].post('/analytics/surveys/', { filter_by: 'period', period: period, date: date }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["f" /* GET_SURVEY_CHARTS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["e" /* GET_SURVEY_CHARTS_FAILURE */], error);
    });
  },
  getSurveys: function getSurveys(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["a" /* GET_SURVEYS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/surveys/list/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["c" /* GET_SURVEYS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["b" /* GET_SURVEYS_FAILURE */], error);
    });
  },
  getPeriods: function getPeriods(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["h" /* GET_PERIODS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/analytics/surveys/periods/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["j" /* GET_PERIODS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["i" /* GET_PERIODS_FAILURE */], error);
    });
  },
  getSurveyAnswerGroups: function getSurveyAnswerGroups(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* GET_SURVEY_ANSWER_GROUPS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/analytics/surveys/answer-groups/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["m" /* GET_SURVEY_ANSWER_GROUPS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["l" /* GET_SURVEY_ANSWER_GROUPS_FAILURE */], error);
    });
  },
  createSpotSurvey: function createSpotSurvey(_ref8, _ref9) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    var title = _ref9.title,
        campaignId = _ref9.campaignId,
        startDate = _ref9.startDate,
        endDate = _ref9.endDate,
        redirectUrl = _ref9.redirectUrl,
        logoUrl = _ref9.logoUrl,
        questions = _ref9.questions,
        profiles = _ref9.profiles;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["q" /* CREATE_SPOT_REQUEST */]);

    var postData = {
      title: title,
      campaign_id: campaignId,
      questions: questions,
      profiles: profiles,
      start_date: startDate,
      end_date: endDate,
      redirect_url: redirectUrl,
      logo_url: logoUrl
    };

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].post('/surveys/spots/', postData).then(function (response) {
      dispatch('getSpotCharts');
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* CREATE_SPOT_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* CREATE_SPOT_FAILURE */], error);
    });
  },
  getDemographics: function getDemographics(_ref10) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* GET_SURVEY_DEMOGRAPHICS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/surveys/demographics/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* GET_SURVEY_DEMOGRAPHICS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["v" /* GET_SURVEY_DEMOGRAPHICS_FAILURE */], error);
    });
  },
  getRespondents: function getRespondents(_ref11, filter) {
    var _this = this;

    var state = _ref11.state,
        commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, respondents;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["w" /* GET_SURVEY_RESPONDENTS_REQUEST */]);

              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
                variables: {
                  surveyId: filter.survey_id,
                  questionId: filter.question_id,
                  choiceId: filter.choice_id,
                  page: state.respondentMoreUrl
                }
              });

            case 4:
              res = _context.sent;
              respondents = res.data.getQuestionChoiceRespondents;

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* GET_SURVEY_RESPONDENTS_SUCCESS */], respondents);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* GET_SURVEY_RESPONDENTS_FAILURE */], _context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 9]]);
    }))();
  },
  getMoreRespondents: function getMoreRespondents(_ref12) {
    var state = _ref12.state,
        commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["w" /* GET_SURVEY_RESPONDENTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get(state.respondentMoreUrl).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* GET_SURVEY_RESPONDENTS_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* GET_SURVEY_RESPONDENTS_FAILURE */], error);
    });
  },
  downloadSurveyReport: function downloadSurveyReport(_ref13, surveyId) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* DOWNLOAD_SURVEY_RESPONSES_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/surveys/download/' + surveyId + '/').then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* DOWNLOAD_SURVEY_RESPONSES_SUCCESS */]);
      dispatch('toast/success', 'Your request has been successfully received. You will be notified when the file is ready to download.', { root: true });
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["C" /* DOWNLOAD_SURVEY_RESPONSES_FAILURE */], error);
      dispatch('toast/error', 'Your request to download messages failed. Please contact support for more help.', { root: true });
    });
  },
  surveyReport: function surveyReport(_ref14, surveyId) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* DOWNLOAD_SURVEY_RESPONSES_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* colonyAPI */].get('/surveys/download-survey/' + surveyId + '/').then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* DOWNLOAD_SURVEY_RESPONSES_SUCCESS */]);
      dispatch('toast/success', 'Your request has been successfully received. You will be notified when the file is ready to download.', { root: true });
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["C" /* DOWNLOAD_SURVEY_RESPONSES_FAILURE */], error);
      dispatch('toast/error', 'Your request to download messages failed. Please contact support for more help.', { root: true });
    });
  }
});

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  qualitativeSurveys: function qualitativeSurveys(state) {
    return state.surveys.filter(function (s) {
      return !s.is_spot;
    });
  },
  spotSurveys: function spotSurveys(state) {
    return state.surveys.filter(function (s) {
      return s.is_spot;
    });
  }
});

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(1255);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */]
});

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(346);



var _types$GET_SURVEYS_RE;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_SURVEYS_RE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_SURVEYS_REQUEST */], function (state) {
  state.loadingSurveys = true;
  state.loadingSurveysFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_SURVEYS_FAILURE */], function (state, error) {
  state.loadingSurveys = false;
  state.loadingSurveysFailed = true;
  state.loadingSurveysError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_SURVEYS_SUCCESS */], function (state, response) {
  state.loadingSurveys = false;
  state.surveys = response.data;
  state.loadingSurveysFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_SURVEY_CHARTS_REQUEST */], function (state) {
  state.loadingCharts = true;
  state.loadingChartsFailed = false;
  state.loadingChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_SURVEY_CHARTS_FAILURE */], function (state, error) {
  state.loadingCharts = false;
  state.loadingChartsFailed = true;
  state.loadingChartsError = error;
  state.loadingChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_SURVEY_CHARTS_SUCCESS */], function (state, response) {
  state.loadingCharts = false;
  state.loadingChartsSucceeded = true;
  state.chartsData = response.data;
  state.loadingChartsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* CLEAR_SURVEY_CHARTS */], function (state) {
  state.chartsData = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_PERIODS_REQUEST */], function (state) {
  state.loadingPeriods = true;
  state.loadingPeriodsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_PERIODS_FAILURE */], function (state, error) {
  state.loadingPeriods = false;
  state.loadingPeriodsFailed = true;
  state.loadingPeriodsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_PERIODS_SUCCESS */], function (state, response) {
  state.loadingPeriods = false;
  state.periods = response.data;
  state.loadingPeriodsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* GET_SURVEY_ANSWER_GROUPS_REQUEST */], function (state) {
  state.loadingPeriods = true;
  state.loadingPeriodsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* GET_SURVEY_ANSWER_GROUPS_FAILURE */], function (state, error) {
  state.loadingPeriods = false;
  state.loadingPeriodsFailed = true;
  state.loadingPeriodsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* GET_SURVEY_ANSWER_GROUPS_SUCCESS */], function (state, response) {
  state.loadingPeriods = false;
  state.periods = response.data;
  state.loadingPeriodsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* GET_SPOT_CHARTS_REQUEST */], function (state) {
  state.loadingSpotCharts = true;
  state.loadingSpotChartsFailed = false;
  state.loadingSpotChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* GET_SPOT_CHARTS_FAILURE */], function (state, error) {
  state.loadingSpotCharts = false;
  state.loadingSpotChartsFailed = true;
  state.loadingSpotChartsError = error;
  state.loadingSpotChartsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* GET_SPOT_CHARTS_SUCCESS */], function (state, response) {
  state.loadingSportCharts = false;
  state.loadingSpotChartsSucceeded = true;
  state.spotChartsData = response.data;
  state.loadingSpotChartsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* CLEAR_SURVEY_CHARTS */], function (state) {
  state.spotChartsData = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* CREATE_SPOT_REQUEST */], function (state) {
  state.creatingSpot = true;
  state.creatingSpotSucceeded = false;
  state.creatingSpotFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* CREATE_SPOT_SUCCESS */], function (state, response) {
  state.creatingSpot = false;
  state.creatingSpotSucceeded = true;
  state.chartsData.append(response.data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* CREATE_SPOT_FAILURE */], function (state, error) {
  state.creatingSpot = false;
  state.creatingSpotFailed = true;
  state.creatingSpotError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* GET_SURVEY_DEMOGRAPHICS_REQUEST */], function (state) {
  state.loadingDemographics = true;
  state.loadingDemographicsSucceeded = false;
  state.loadingDemographicsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* GET_SURVEY_DEMOGRAPHICS_SUCCESS */], function (state, response) {
  state.demographics = response;
  state.loadingDemographicsSucceeded = true;
  state.loadingDemographics = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* GET_SURVEY_DEMOGRAPHICS_FAILURE */], function (state, error) {
  state.loadingDemographicsFailed = true;
  state.loadingDemographicsSucceeded = false;
  state.loadingDemographicsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* GET_SURVEY_RESPONDENTS_REQUEST */], function (state) {
  state.loadingRespondents = true;
  state.loadingRespondentsSucceeded = false;
  state.loadingRespondentsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* GET_SURVEY_RESPONDENTS_SUCCESS */], function (state, response) {
  state.respondents = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.respondents), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.entries));
  state.respondentCount = response.totalPages;
  state.respondentPageInfo = { totalPages: response.totalPages, pageNumber: response.pageNumber };

  state.loadingRespondents = false;
  state.loadingRespondentsSucceeded = true;
  state.loadingRespondentsFailed = false;

  if (response.pageNumber <= response.totalPages) {
    state.respondentMoreUrl = response.pageNumber + 1;
  } else {
    state.respondentMoreUrl = null;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* GET_SURVEY_RESPONDENTS_FAILURE */], function (state, error) {
  state.loadingRespondents = false;
  state.loadingRespondentsFailed = true;
  state.loadingRespondentsSucceeded = false;
  state.loadingRespondentsError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["z" /* CLEAR_SURVEY_RESPONDENTS */], function (state) {
  state.respondents = [];
  state.respondentCount = 0;
  state.respondentMoreUrl = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* DOWNLOAD_SURVEY_RESPONSES_REQUEST */], function (state) {
  state.downloadingResponses = true;
  state.downloadingResponsesFailed = false;
  state.downloadingResponsesSucceeded = false;
  state.downloadingResponsesError = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["B" /* DOWNLOAD_SURVEY_RESPONSES_SUCCESS */], function (state) {
  state.downloadingResponses = false;
  state.downloadingResponsesFailed = false;
  state.downloadingResponsesSucceeded = true;
  state.downloadingResponsesError = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SURVEYS_RE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["C" /* DOWNLOAD_SURVEY_RESPONSES_FAILURE */], function (state, error) {
  state.downloadingResponses = false;
  state.downloadingResponsesFailed = true;
  state.downloadingResponsesSucceeded = true;
  state.downloadingResponsesError = error;
}), _types$GET_SURVEYS_RE);

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  chartsData: [],
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsSucceeded: false,
  loadingChartsError: null,

  spotChartsData: [],
  loadingSpotCharts: false,
  loadingSpotChartsFailed: false,
  loadingSpotChartsSucceeded: false,
  loadingSpotChartsError: null,

  surveys: [],
  loadingSurveys: false,
  loadingSurveysFailed: false,
  loadingSurveysError: null,

  periods: [],
  loadingPeriods: false,
  loadingPeriodsFailed: false,
  loadingPeriodsError: null,

  answerGroups: [],
  loadingAnswerGroups: false,
  loadingAnswerGroupsFailed: false,
  loadingAnswerGroupsError: null,

  creatingSpot: false,
  creatingSpotFailed: false,
  creatingSpotSucceeded: false,
  creatingSpotError: null,

  demographics: [],
  loadingDemographics: false,
  loadingDemographicsFailed: false,
  loadingDemographicsSucceeded: false,
  loadingDemographicsError: null,

  respondents: [],
  respondentCount: 1,
  respondentPageInfo: {
    pageNumber: 0,
    pageSize: 0,
    totalEntries: 0,
    totalPages: 0
  },
  respondentMoreUrl: null,
  loadingRespondents: false,
  loadingRespondentsFailed: false,
  loadingRespondentsSucceeded: false,
  loadingRespondentsError: null,

  downloadResponsesUrl: null,
  downloadingResponses: false,
  downloadingResponsesFailed: false,
  downloadingResponsesSucceeded: false,
  downloadingResponsesError: null
});

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
  canvasAddQuestion: function canvasAddQuestion(_ref, question) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_40" /* ADD_CANVAS_QUESTION */], question);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_41" /* SELECT_CANVAS_QUESTION_ID */], question.id);
  },
  canvasSetQuestions: function canvasSetQuestions(_ref2, questions) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_42" /* SET_CANVAS_QUESTIONS */], questions);
  },
  canvasAddChoice: function canvasAddChoice(_ref3, choice) {
    var commit = _ref3.commit,
        getters = _ref3.getters,
        state = _ref3.state;

    var question = getters.canvasSelectedQuestion;
    if (question && state.choiceTypes.includes(question.questionType)) {
      var currentChoices = question.choices || [];
      var questions = state.canvasQuestions.map(function (q) {
        if (q.id !== question.id) {
          return q;
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, q, { choices: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(currentChoices), [choice]) });
      });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_42" /* SET_CANVAS_QUESTIONS */], questions);
    }
  },
  canvasAddChoices: function canvasAddChoices(_ref4, choices) {
    var dispatch = _ref4.dispatch;

    choices.forEach(function (choice) {
      return dispatch('canvasAddChoice', choice);
    });
  },
  canvasSelectQuestion: function canvasSelectQuestion(_ref5, questionId) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_41" /* SELECT_CANVAS_QUESTION_ID */], questionId);
    dispatch('getChoiceTemplates');
  },
  selectorSelectQuestionCategory: function selectorSelectQuestionCategory(_ref6, categoryId) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_43" /* SELECT_SELECTOR_QUESTION_CATEGORY */], categoryId);
  },
  selectorSelectTemplateId: function selectorSelectTemplateId(_ref7, templateId) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_44" /* SELECT_SELECTOR_TEMPLATE_ID */], templateId);
    dispatch('getChoices');
  },
  selectorSelectTemplateCategory: function selectorSelectTemplateCategory(_ref8, categoryId) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_45" /* SELECT_SELECTOR_TEMPLATE_CATEGORY */], categoryId);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_46" /* SELECT_SELECTOR_CHOICE_CATEGORY */], categoryId);
  },
  selectorSelectChoiceCategory: function selectorSelectChoiceCategory(_ref9, categoryId) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_46" /* SELECT_SELECTOR_CHOICE_CATEGORY */], categoryId);
  },
  selectorSetTemplateSearchText: function selectorSetTemplateSearchText(_ref10, text) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_48" /* SET_SELECTOR_TEMPLATE_TEXT */], text);
  },
  selectorResetTemplateFilters: function selectorResetTemplateFilters(_ref11) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_53" /* RESET_SELECTOR_TEMPLATE_FILTERS */]);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_54" /* RESET_SELECTOR_CHOICE_FILTERS */]);
  },
  questionDialogCancel: function questionDialogCancel(_ref12) {
    var commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], false);
  },
  questionDialogCreate: function questionDialogCreate(_ref13, question) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    dispatch('createQuestion', question);

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], false);
  },
  questionDialogEdit: function questionDialogEdit(_ref14, question) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    dispatch('updateQuestion', question);

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], false);
  },
  choiceTemplateDialogCreate: function choiceTemplateDialogCreate(_ref15, template) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    dispatch('createChoiceTemplate', template);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], false);
  },
  choiceTemplateDialogEdit: function choiceTemplateDialogEdit(_ref16, template) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    dispatch('updateChoiceTemplate', template);

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], false);
  },
  choiceTemplateShowEditDialog: function choiceTemplateShowEditDialog(_ref17, _ref18) {
    var commit = _ref17.commit;
    var template = _ref18.template,
        choices = _ref18.choices;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_74" /* SET_CHOICE_TEMPLATE_DIALOG_FORM */], template);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_72" /* SET_CHOICE_TEMPLATE_DIALOG_CHOICES */], choices);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], true);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], false);
  },
  choiceTemplateShowCreateDialog: function choiceTemplateShowCreateDialog(_ref19, _ref20) {
    var commit = _ref19.commit;
    var choices = _ref20.choices,
        _ref20$isScale = _ref20.isScale,
        isScale = _ref20$isScale === undefined ? false : _ref20$isScale;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_72" /* SET_CHOICE_TEMPLATE_DIALOG_CHOICES */], choices);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], true);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], isScale);
  },
  choiceTemplateDialogCancel: function choiceTemplateDialogCancel(_ref21) {
    var commit = _ref21.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], false);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], false);
  },
  questionCategoryDialogCreate: function questionCategoryDialogCreate(_ref22, category) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;

    dispatch('createQuestionCategory', category);

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_77" /* SET_QUESTION_CATEGORY_DIALOG_VISIBILITY */], false);
  },
  choiceCategoryDialogCreate: function choiceCategoryDialogCreate(_ref23, category) {
    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;

    dispatch('createChoiceCategory', category);

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_78" /* SET_CHOICE_CATEGORY_DIALOG_VISIBILITY */], false);
  }
});

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apiv2Client__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(583);








var _this = this;

var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      query(\n        $filter: String\n        $categoryId: Int\n        $orderedByChoiceTemplate: Int\n        $pagination: PaginationInput\n      ) {\n        surveysListChoice(\n          filter: $filter\n          categoryId: $categoryId\n          orderedByChoiceTemplate: $orderedByChoiceTemplate\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            polarity\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    '], ['\n      query(\n        $filter: String\n        $categoryId: Int\n        $orderedByChoiceTemplate: Int\n        $pagination: PaginationInput\n      ) {\n        surveysListChoice(\n          filter: $filter\n          categoryId: $categoryId\n          orderedByChoiceTemplate: $orderedByChoiceTemplate\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            polarity\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      query(\n        $filter: String\n        $categoryId: Int\n        $orderedByMatchedKeywords: String\n        $pagination: PaginationInput\n      ) {\n        surveysListChoiceTemplate(\n          filter: $filter\n          categoryId: $categoryId\n          orderedByMatchedKeywords: $orderedByMatchedKeywords\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            description\n            keywords\n            categoryId\n            isGlobal\n            choices {\n              id\n              title\n              polarity\n            }\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    '], ['\n      query(\n        $filter: String\n        $categoryId: Int\n        $orderedByMatchedKeywords: String\n        $pagination: PaginationInput\n      ) {\n        surveysListChoiceTemplate(\n          filter: $filter\n          categoryId: $categoryId\n          orderedByMatchedKeywords: $orderedByMatchedKeywords\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            description\n            keywords\n            categoryId\n            isGlobal\n            choices {\n              id\n              title\n              polarity\n            }\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      query(\n        $filter: String\n        $categoryId: Int\n        $excludeQuestionTypes: [String]\n        $pagination: PaginationInput\n      ) {\n        surveysListQuestion(\n          filter: $filter\n          categoryId: $categoryId\n          excludeQuestionTypes: $excludeQuestionTypes\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            questionType\n            chart\n            categoryId\n            isGlobal\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    '], ['\n      query(\n        $filter: String\n        $categoryId: Int\n        $excludeQuestionTypes: [String]\n        $pagination: PaginationInput\n      ) {\n        surveysListQuestion(\n          filter: $filter\n          categoryId: $categoryId\n          excludeQuestionTypes: $excludeQuestionTypes\n          pagination: $pagination\n        ) {\n          entries {\n            id\n            title\n            questionType\n            chart\n            categoryId\n            isGlobal\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      query($filter: String, $pagination: PaginationInput) {\n        surveysListMediaClip(filter: $filter, pagination: $pagination) {\n          entries {\n            id\n            artist\n            title\n            description\n            fileUrl\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    '], ['\n      query($filter: String, $pagination: PaginationInput) {\n        surveysListMediaClip(filter: $filter, pagination: $pagination) {\n          entries {\n            id\n            artist\n            title\n            description\n            fileUrl\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      query($filter: String, $pagination: PaginationInput) {\n        surveysListMatrixChoice(filter: $filter, pagination: $pagination) {\n          entries {\n            id\n            title\n            visibleIf\n            isRequired\n            choices {\n              id\n              title\n            }\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    '], ['\n      query($filter: String, $pagination: PaginationInput) {\n        surveysListMatrixChoice(filter: $filter, pagination: $pagination) {\n          entries {\n            id\n            title\n            visibleIf\n            isRequired\n            choices {\n              id\n              title\n            }\n          }\n          pageNumber\n          totalPages\n        }\n      }\n    ']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          query($state: SurveyState, $title: String, $pagination: PaginationInput) {\n            surveysListSurvey(state: $state, title: $title, pagination: $pagination) {\n              entries {\n                id\n                title\n                description\n                startDate\n                endDate\n                createdBy {\n                  firstName\n                  lastName\n                }\n                url\n                successText\n                successRedirect\n                successAutoRedirect\n                privacyPolicy\n                collectNonVoluntaryIdentifiers\n                accentColor\n                logoUrl\n                logoImage\n                isActive\n                isPreview\n                surveyType\n                favorite\n                totalEntries\n              }\n              pageNumber\n              totalPages\n            }\n          }\n        '], ['\n          query($state: SurveyState, $title: String, $pagination: PaginationInput) {\n            surveysListSurvey(state: $state, title: $title, pagination: $pagination) {\n              entries {\n                id\n                title\n                description\n                startDate\n                endDate\n                createdBy {\n                  firstName\n                  lastName\n                }\n                url\n                successText\n                successRedirect\n                successAutoRedirect\n                privacyPolicy\n                collectNonVoluntaryIdentifiers\n                accentColor\n                logoUrl\n                logoImage\n                isActive\n                isPreview\n                surveyType\n                favorite\n                totalEntries\n              }\n              pageNumber\n              totalPages\n            }\n          }\n        ']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          query($surveyId: Int!) {\n            surveysGetSurvey(surveyId: $surveyId) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              config\n              pageSize\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  order\n                  polarity\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n                matrixChoiceLinks  {\n                  id\n                  order\n                  matrixChoiceId\n                }\n              }\n            }\n          }\n        '], ['\n          query($surveyId: Int!) {\n            surveysGetSurvey(surveyId: $surveyId) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              config\n              pageSize\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  order\n                  polarity\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n                matrixChoiceLinks  {\n                  id\n                  order\n                  matrixChoiceId\n                }\n              }\n            }\n          }\n        ']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($question: SurveysQuestionInput!) {\n            surveysCreateQuestion(question: $question) {\n              id\n              title\n              questionType\n              chart\n              categoryId\n              insight\n              isRequired\n              isGlobal\n              isProfile\n              profileField\n              visibilityCondition\n            }\n          }\n        '], ['\n          mutation($question: SurveysQuestionInput!) {\n            surveysCreateQuestion(question: $question) {\n              id\n              title\n              questionType\n              chart\n              categoryId\n              insight\n              isRequired\n              isGlobal\n              isProfile\n              profileField\n              visibilityCondition\n            }\n          }\n        ']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($questionId: Int!, $question: SurveysQuestionInput!) {\n            surveysUpdateQuestion(questionId: $questionId, question: $question) {\n              id\n              title\n              questionType\n              chart\n              categoryId\n              insight\n              isRequired\n              isGlobal\n              isProfile\n              profileField\n              isChoiceOrderReversed\n              visibilityCondition\n              choices {\n                id\n                title\n              }\n              choiceLinks {\n                choiceId\n                polarity\n                order\n              }\n            }\n          }\n        '], ['\n          mutation($questionId: Int!, $question: SurveysQuestionInput!) {\n            surveysUpdateQuestion(questionId: $questionId, question: $question) {\n              id\n              title\n              questionType\n              chart\n              categoryId\n              insight\n              isRequired\n              isGlobal\n              isProfile\n              profileField\n              isChoiceOrderReversed\n              visibilityCondition\n              choices {\n                id\n                title\n              }\n              choiceLinks {\n                choiceId\n                polarity\n                order\n              }\n            }\n          }\n        ']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($choiceTemplate: SurveysChoiceTemplateInput!) {\n            surveysCreateChoiceTemplate(choiceTemplate: $choiceTemplate) {\n              id\n              title\n              description\n              keywords\n              categoryId\n              isGlobal\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        '], ['\n          mutation($choiceTemplate: SurveysChoiceTemplateInput!) {\n            surveysCreateChoiceTemplate(choiceTemplate: $choiceTemplate) {\n              id\n              title\n              description\n              keywords\n              categoryId\n              isGlobal\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        ']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($choiceTemplateId: Int!, $choiceTemplate: SurveysChoiceTemplateInput!) {\n            surveysUpdateChoiceTemplate(\n              choiceTemplateId: $choiceTemplateId\n              choiceTemplate: $choiceTemplate\n            ) {\n              id\n              title\n              description\n              keywords\n              categoryId\n              isGlobal\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        '], ['\n          mutation($choiceTemplateId: Int!, $choiceTemplate: SurveysChoiceTemplateInput!) {\n            surveysUpdateChoiceTemplate(\n              choiceTemplateId: $choiceTemplateId\n              choiceTemplate: $choiceTemplate\n            ) {\n              id\n              title\n              description\n              keywords\n              categoryId\n              isGlobal\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        ']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          {\n            surveysListQuestionCategory {\n              id\n              title\n            }\n          }\n        '], ['\n          {\n            surveysListQuestionCategory {\n              id\n              title\n            }\n          }\n        ']),
    _templateObject13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          {\n            surveysListQuestionCategory(onlyWithQuestions: true) {\n              id\n              title\n            }\n          }\n        '], ['\n          {\n            surveysListQuestionCategory(onlyWithQuestions: true) {\n              id\n              title\n            }\n          }\n        ']),
    _templateObject14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($questionCategory: SurveysQuestionCategoryInput!) {\n            surveysCreateQuestionCategory(questionCategory: $questionCategory) {\n              id\n              title\n              description\n            }\n          }\n        '], ['\n          mutation($questionCategory: SurveysQuestionCategoryInput!) {\n            surveysCreateQuestionCategory(questionCategory: $questionCategory) {\n              id\n              title\n              description\n            }\n          }\n        ']),
    _templateObject15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($choiceCategory: SurveysChoiceCategoryInput!) {\n            surveysCreateChoiceCategory(choiceCategory: $choiceCategory) {\n              id\n              title\n              description\n            }\n          }\n        '], ['\n          mutation($choiceCategory: SurveysChoiceCategoryInput!) {\n            surveysCreateChoiceCategory(choiceCategory: $choiceCategory) {\n              id\n              title\n              description\n            }\n          }\n        ']),
    _templateObject16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          {\n            surveysListChoiceCategory {\n              id\n              title\n            }\n          }\n        '], ['\n          {\n            surveysListChoiceCategory {\n              id\n              title\n            }\n          }\n        ']),
    _templateObject17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($surveyInput: SurveysSurveyInput) {\n            surveysCreate(survey: $surveyInput) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              createdById\n            }\n          }\n        '], ['\n          mutation($surveyInput: SurveysSurveyInput) {\n            surveysCreate(survey: $surveyInput) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              createdById\n            }\n          }\n        ']),
    _templateObject18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($surveyId: Int, $surveyInput: SurveysSurveyInput) {\n            surveysUpdate(surveyId: $surveyId, survey: $surveyInput) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              createdById\n              config\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  polarity\n                  order\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n              }\n            }\n          }\n        '], ['\n          mutation($surveyId: Int, $surveyInput: SurveysSurveyInput) {\n            surveysUpdate(surveyId: $surveyId, survey: $surveyInput) {\n              id\n              title\n              description\n              startDate\n              endDate\n              url\n              successText\n              successRedirect\n              successAutoRedirect\n              privacyPolicy\n              collectNonVoluntaryIdentifiers\n              accentColor\n              logoUrl\n              logoImage\n              isActive\n              isPreview\n              surveyType\n              createdById\n              config\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  polarity\n                  order\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n              }\n            }\n          }\n        ']),
    _templateObject19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($surveyId: Int, $questions: SurveysQuestionInput) {\n            surveysUpdateQuestions(surveyId: $surveyId, questions: $questions) {\n              id\n              title\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  polarity\n                  order\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n                matrixChoiceLinks  {\n                  id\n                  order\n                  matrixChoiceId\n                }\n              }\n            }\n          }\n        '], ['\n          mutation($surveyId: Int, $questions: SurveysQuestionInput) {\n            surveysUpdateQuestions(surveyId: $surveyId, questions: $questions) {\n              id\n              title\n              questions {\n                id\n                title\n                questionType\n                chart\n                categoryId\n                insight\n                isRequired\n                isGlobal\n                isProfile\n                profileField\n                isChoiceOrderReversed\n                visibilityCondition\n                mediaClip {\n                  id\n                  title\n                  artist\n                  type\n                  fileUrl\n                }\n                choices {\n                  id\n                  title\n                }\n                choiceLinks {\n                  choiceId\n                  polarity\n                  order\n                }\n                matrixChoices {\n                  id\n                  name\n                  title\n                  visibleIf\n                  isRequired\n                  choices {\n                    id\n                    title\n                  }\n                }\n                matrixChoiceLinks  {\n                  id\n                  order\n                  matrixChoiceId\n                }\n              }\n            }\n          }\n        ']),
    _templateObject20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($matrixChoice: SurveysMatrixChoiceInput!) {\n            surveysCreateMatrixChoice(matrixChoice: $matrixChoice) {\n              id\n              title\n              name\n              visibleIf\n              isRequired\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        '], ['\n          mutation($matrixChoice: SurveysMatrixChoiceInput!) {\n            surveysCreateMatrixChoice(matrixChoice: $matrixChoice) {\n              id\n              title\n              name\n              visibleIf\n              isRequired\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        ']),
    _templateObject21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($mediaClip: SurveysMediaClipInput!) {\n            surveysCreateMediaClip(mediaClip: $mediaClip) {\n              id\n              artist\n              title\n              genre\n              description\n              type\n              fileUrl\n            }\n          }\n        '], ['\n          mutation($mediaClip: SurveysMediaClipInput!) {\n            surveysCreateMediaClip(mediaClip: $mediaClip) {\n              id\n              artist\n              title\n              genre\n              description\n              type\n              fileUrl\n            }\n          }\n        ']),
    _templateObject22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($mediaClipId: Int!, $mediaClip: SurveysMediaClipInput!) {\n            surveysUpdateMediaClip(\n              mediaClipId: $mediaClipId,\n              mediaClip: $mediaClip\n              ) {\n              id\n              artist\n              title\n              genre\n              description\n              type\n              fileUrl\n            }\n          }\n        '], ['\n          mutation($mediaClipId: Int!, $mediaClip: SurveysMediaClipInput!) {\n            surveysUpdateMediaClip(\n              mediaClipId: $mediaClipId,\n              mediaClip: $mediaClip\n              ) {\n              id\n              artist\n              title\n              genre\n              description\n              type\n              fileUrl\n            }\n          }\n        ']),
    _templateObject23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation($matrixChoiceId: Int!, $matrixChoice: SurveysMatrixChoiceInput!) {\n            surveysUpdateMatrixChoice(\n              matrixChoiceId: $matrixChoiceId\n              matrixChoice: $matrixChoice\n            ) {\n              id\n              name\n              title\n              visibleIf\n              isRequired\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        '], ['\n          mutation($matrixChoiceId: Int!, $matrixChoice: SurveysMatrixChoiceInput!) {\n            surveysUpdateMatrixChoice(\n              matrixChoiceId: $matrixChoiceId\n              matrixChoice: $matrixChoice\n            ) {\n              id\n              name\n              title\n              visibleIf\n              isRequired\n              choices {\n                id\n                title\n                polarity\n              }\n            }\n          }\n        ']);









// eslint-disable-next-line
var whitelistedFields = function whitelistedFields(whitelist, obj) {
  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(obj).reduce(function (acc, key) {
    if (whitelist.includes(key)) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, key, obj[key]));
    }
    return acc;
  }, {});
};

var sortByFavorite = function sortByFavorite(surveyData) {
  return surveyData.sort(function (a, b) {
    if (a.favorite === b.favorite) {
      return 0;
    } else if (a.favorite) {
      return -1;
    }
    return 1;
  });
};

var surveyWhitelist = [
// id, shouldn't be here it's set as a separate parameter on survey update
'title', 'description', 'startDate', 'endDate', 'successText', 'successRedirect', 'successAutoRedirect', 'privacyPolicy', 'collectNonVoluntaryIdentifiers', 'logoUrl', 'logoImage', 'surveyType', 'isPreview', 'isActive', 'accentColor', 'config', 'favorite', 'deleted', 'pageSize', 'createdById'];

var questionWhitelist = ['id', 'categoryId', 'chart', 'choices', 'matrixChoices', 'insight', 'isChoiceOrderReversed', 'isGlobal', 'isProfile', 'isRequired', 'profileField', 'questionType', 'title', 'visibilityCondition', 'mediaClipId'];

var choiceTemplateWhitelist = ['id', 'title', 'description', 'categoryId', 'choices', 'isGlobal', 'keywords'];

var queryChoices = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var orderedByChoiceTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
              query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject),
              variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                orderedByChoiceTemplate: orderedByChoiceTemplate,
                pagination: {
                  page_size: pageSize,
                  page: page
                }
              })
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function queryChoices() {
    return _ref.apply(this, arguments);
  };
}();

var queryChoiceTemplates = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var orderedByMatchedKeywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
              query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject2),
              variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                orderedByMatchedKeywords: orderedByMatchedKeywords,
                pagination: {
                  page_size: pageSize,
                  page: page
                }
              })
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function queryChoiceTemplates() {
    return _ref2.apply(this, arguments);
  };
}();

var queryQuestions = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
              query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject3),
              variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                excludeQuestionTypes: ['MEDIA'],
                pagination: {
                  page_size: pageSize,
                  page: page
                }
              }),
              fetchPolicy: 'network-only'
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function queryQuestions() {
    return _ref3.apply(this, arguments);
  };
}();

var queryHooks = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
              query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject4),
              variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                pagination: {
                  page_size: pageSize,
                  page: page
                }
              })
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function queryHooks() {
    return _ref4.apply(this, arguments);
  };
}();

var queryMatrixChoices = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
              query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject5),
              variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                pagination: {
                  page_size: pageSize,
                  page: page
                }
              })
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function queryMatrixChoices() {
    return _ref5.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  // Survey
  listSurveys: function listSurveys(_ref6) {
    var _this2 = this;

    var commit = _ref6.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var filters, page, pageSize, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              filters = payload.filters || {};
              page = payload.page || 1;
              pageSize = payload.pageSize || 25;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["a" /* LIST_SURVEYS_REQUEST */]);

              _context6.prev = 4;
              _context6.next = 7;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject6),
                variables: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filters, {
                  pagination: {
                    page: page,
                    page_size: pageSize
                  }
                })
              });

            case 7:
              res = _context6.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["b" /* LIST_SURVEYS_SUCCESS */], {
                surveys: sortByFavorite(res.data.surveysListSurvey.entries),
                pageNumber: res.data.surveysListSurvey.pageNumber,
                totalPages: res.data.surveysListSurvey.totalPages
              });
              _context6.next = 14;
              break;

            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6['catch'](4);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["c" /* LIST_SURVEYS_FAILURE */], _context6.t0);

            case 14:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2, [[4, 11]]);
    }))();
  },
  listSurveysGoToPage: function listSurveysGoToPage(_ref7, page) {
    var _this3 = this;

    var dispatch = _ref7.dispatch,
        state = _ref7.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch('listSurveys', { page: page, filter: state.surveyListFilter });

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this3);
    }))();
  },
  listSurveysNextPage: function listSurveysNextPage(_ref8) {
    var _this4 = this;

    var dispatch = _ref8.dispatch,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch('listSurveysGoToPage', state.surveyListPage + 1);

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this4);
    }))();
  },
  listSurveysPrevPage: function listSurveysPrevPage(_ref9) {
    var _this5 = this;

    var dispatch = _ref9.dispatch,
        state = _ref9.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch('listSurveysGoToPage', state.surveyListPage - 1);

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this5);
    }))();
  },
  getSurvey: function getSurvey(_ref10, surveyId) {
    var _this6 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var res, survey, questions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["d" /* GET_SURVEY_REQUEST */]);

              _context10.prev = 1;
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject7),
                variables: {
                  surveyId: parseInt(surveyId, 10)
                }
              });

            case 4:
              res = _context10.sent;
              survey = res.data.surveysGetSurvey;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["e" /* GET_SURVEY_SUCCESS */], survey);

              questions = survey.questions || [{ id: null }];

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_41" /* SELECT_CANVAS_QUESTION_ID */], questions[0].id);
              _context10.next = 14;
              break;

            case 11:
              _context10.prev = 11;
              _context10.t0 = _context10['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["f" /* GET_SURVEY_FAILURE */], _context10.t0);

            case 14:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this6, [[1, 11]]);
    }))();
  },


  // Questions
  getQuestions: function getQuestions(_ref11) {
    var _this7 = this;

    var commit = _ref11.commit,
        getters = _ref11.getters,
        state = _ref11.state;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var filters, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              filters = getters.selectorQuestionFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["g" /* GET_QUESTIONS_REQUEST */]);
              _context11.prev = 2;
              _context11.next = 5;
              return queryQuestions(filters, page, state.selectorPageSize);

            case 5:
              res = _context11.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["h" /* GET_QUESTIONS_SUCCESS */], res.data.surveysListQuestion);
              _context11.next = 12;
              break;

            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["i" /* GET_QUESTIONS_FAILURE */], _context11.t0);

            case 12:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this7, [[2, 9]]);
    }))();
  },
  getMoreQuestions: function getMoreQuestions(_ref12) {
    var _this8 = this;

    var commit = _ref12.commit,
        getters = _ref12.getters,
        state = _ref12.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var filters, nextPage, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              filters = getters.selectorQuestionFilters;
              nextPage = state.questionsPage + 1;

              if (!(nextPage > state.questionsTotalPages)) {
                _context12.next = 4;
                break;
              }

              return _context12.abrupt('return');

            case 4:

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["j" /* APPEND_QUESTIONS_REQUEST */]);
              _context12.prev = 5;
              _context12.next = 8;
              return queryQuestions(filters, nextPage, state.selectorPageSize);

            case 8:
              res = _context12.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["k" /* APPEND_QUESTIONS_SUCCESS */], res.data.surveysListQuestion);
              _context12.next = 15;
              break;

            case 12:
              _context12.prev = 12;
              _context12.t0 = _context12['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["l" /* APPEND_QUESTIONS_FAILURE */], _context12.t0);

            case 15:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this8, [[5, 12]]);
    }))();
  },
  createQuestion: function createQuestion(_ref13, question) {
    var _this9 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["m" /* CREATE_QUESTION_REQUEST */]);
              _context13.prev = 1;
              _context13.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject8),
                variables: {
                  question: whitelistedFields(questionWhitelist, question)
                }
              });

            case 4:
              res = _context13.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["n" /* CREATE_QUESTION_SUCCESS */], res.data.surveysCreateQuestion);
              _context13.next = 11;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["o" /* CREATE_QUESTION_FAILURE */], _context13.t0);

            case 11:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this9, [[1, 8]]);
    }))();
  },
  updateQuestion: function updateQuestion(_ref14, question) {
    var _this10 = this;

    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["p" /* UPDATE_QUESTION_REQUEST */]);
              _context14.prev = 1;
              _context14.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject9),
                variables: {
                  question: whitelistedFields(questionWhitelist, question),
                  questionId: question.id
                }
              });

            case 4:
              res = _context14.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["q" /* UPDATE_QUESTION_SUCCESS */], res.data.surveysUpdateQuestion);
              _context14.next = 11;
              break;

            case 8:
              _context14.prev = 8;
              _context14.t0 = _context14['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["r" /* UPDATE_QUESTION_FAILURE */], _context14.t0);

            case 11:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this10, [[1, 8]]);
    }))();
  },
  getChoices: function getChoices(_ref15) {
    var _this11 = this;

    var commit = _ref15.commit,
        getters = _ref15.getters,
        state = _ref15.state;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var filters, templateId, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              filters = getters.selectorChoiceFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["s" /* GET_CHOICES_REQUEST */]);
              _context15.prev = 2;
              templateId = state.selectorSelectedTemplateId || null;
              _context15.next = 6;
              return queryChoices(filters, templateId, page, state.selectorPageSize);

            case 6:
              res = _context15.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["t" /* GET_CHOICES_SUCCESS */], res.data.surveysListChoice);
              _context15.next = 13;
              break;

            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["u" /* GET_CHOICES_FAILURE */], _context15.t0);

            case 13:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this11, [[2, 10]]);
    }))();
  },
  getMoreChoices: function getMoreChoices(_ref16) {
    var _this12 = this;

    var commit = _ref16.commit,
        getters = _ref16.getters,
        state = _ref16.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var filters, nextPage, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              filters = getters.selectorChoiceFilters;
              nextPage = state.choicesPage + 1;

              if (!(nextPage > state.choicesTotalPages)) {
                _context16.next = 4;
                break;
              }

              return _context16.abrupt('return');

            case 4:

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["v" /* APPEND_CHOICES_REQUEST */]);
              _context16.prev = 5;
              _context16.next = 8;
              return queryChoices(filters, nextPage, state.selectorPageSize);

            case 8:
              res = _context16.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["w" /* APPEND_CHOICES_SUCCESS */], res.data.surveysListChoice);
              _context16.next = 15;
              break;

            case 12:
              _context16.prev = 12;
              _context16.t0 = _context16['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["x" /* APPEND_CHOICES_FAILURE */], _context16.t0);

            case 15:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this12, [[5, 12]]);
    }))();
  },
  getChoiceTemplates: function getChoiceTemplates(_ref17) {
    var _this13 = this;

    var commit = _ref17.commit,
        getters = _ref17.getters,
        state = _ref17.state;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var filters, selectedQuestion, keywordText, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              filters = getters.selectorChoiceTemplateFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["y" /* GET_CHOICE_TEMPLATES_REQUEST */]);
              _context17.prev = 2;
              selectedQuestion = getters.canvasSelectedQuestion;
              keywordText = selectedQuestion ? selectedQuestion.title : '';
              _context17.next = 7;
              return queryChoiceTemplates(filters, keywordText, page, state.selectorPageSize);

            case 7:
              res = _context17.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["z" /* GET_CHOICE_TEMPLATES_SUCCESS */], res.data.surveysListChoiceTemplate);
              _context17.next = 14;
              break;

            case 11:
              _context17.prev = 11;
              _context17.t0 = _context17['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["A" /* GET_CHOICE_TEMPLATES_FAILURE */], _context17.t0);

            case 14:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this13, [[2, 11]]);
    }))();
  },
  getMoreChoiceTemplates: function getMoreChoiceTemplates(_ref18) {
    var _this14 = this;

    var commit = _ref18.commit,
        getters = _ref18.getters,
        state = _ref18.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var filters, nextPage, keywordText, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              filters = getters.selectorChoiceTemplateFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["B" /* APPEND_CHOICE_TEMPLATES_REQUEST */]);
              nextPage = state.choiceTemplatesPage + 1;

              if (!(nextPage > state.choiceTemplatesTotalPages)) {
                _context18.next = 5;
                break;
              }

              return _context18.abrupt('return');

            case 5:
              _context18.prev = 5;
              keywordText = getters.canvasSelectedQuestion.title;
              _context18.next = 9;
              return queryChoiceTemplates(filters, keywordText, nextPage, state.selectorPageSize);

            case 9:
              res = _context18.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["C" /* APPEND_CHOICE_TEMPLATES_SUCCESS */], res.data.surveysListChoiceTemplate);
              _context18.next = 16;
              break;

            case 13:
              _context18.prev = 13;
              _context18.t0 = _context18['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["D" /* APPEND_CHOICE_TEMPLATES_FAILURE */], _context18.t0);

            case 16:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this14, [[5, 13]]);
    }))();
  },
  createChoiceTemplate: function createChoiceTemplate(_ref19, choiceTemplate) {
    var _this15 = this;

    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["E" /* CREATE_CHOICE_TEMPLATE_REQUEST */]);
              _context19.prev = 1;
              _context19.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject10),
                variables: {
                  choiceTemplate: whitelistedFields(choiceTemplateWhitelist, choiceTemplate)
                }
              });

            case 4:
              res = _context19.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["F" /* CREATE_CHOICE_TEMPLATE_SUCCESS */], res.data.surveysCreateChoiceTemplate);
              _context19.next = 11;
              break;

            case 8:
              _context19.prev = 8;
              _context19.t0 = _context19['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["G" /* CREATE_CHOICE_TEMPLATE_FAILURE */], _context19.t0);

            case 11:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this15, [[1, 8]]);
    }))();
  },
  updateChoiceTemplate: function updateChoiceTemplate(_ref20, choiceTemplate) {
    var _this16 = this;

    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var choiceTemplateWithoutChoices, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["H" /* UPDATE_CHOICE_TEMPLATE_REQUEST */]);
              _context20.prev = 1;
              choiceTemplateWithoutChoices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["omit"])(choiceTemplate, ['choices']);
              _context20.next = 5;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject11),
                variables: {
                  choiceTemplate: whitelistedFields(choiceTemplateWhitelist, choiceTemplateWithoutChoices),
                  choiceTemplateId: choiceTemplate.id
                }
              });

            case 5:
              res = _context20.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["I" /* UPDATE_CHOICE_TEMPLATE_SUCCESS */], res.data.surveysUpdateChoiceTemplate);
              _context20.next = 12;
              break;

            case 9:
              _context20.prev = 9;
              _context20.t0 = _context20['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["J" /* UPDATE_CHOICE_TEMPLATE_FAILURE */], _context20.t0);

            case 12:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this16, [[1, 9]]);
    }))();
  },


  // Hooks
  getHooks: function getHooks(_ref21) {
    var _this17 = this;

    var commit = _ref21.commit,
        getters = _ref21.getters,
        state = _ref21.state;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
      var filters, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              filters = getters.selectorHookFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_8" /* GET_HOOKS_REQUEST */]);
              _context21.prev = 2;
              _context21.next = 5;
              return queryHooks(filters, page, state.selectorPageSize);

            case 5:
              res = _context21.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_9" /* GET_HOOKS_SUCCESS */], res.data.surveysListMediaClip);
              _context21.next = 12;
              break;

            case 9:
              _context21.prev = 9;
              _context21.t0 = _context21['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_10" /* GET_HOOKS_FAILURE */], _context21.t0);

            case 12:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this17, [[2, 9]]);
    }))();
  },
  getMoreHooks: function getMoreHooks(_ref22) {
    var _this18 = this;

    var commit = _ref22.commit,
        getters = _ref22.getters,
        state = _ref22.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var filters, nextPage, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              filters = getters.selectorHookFilters;
              nextPage = state.hooksPage + 1;

              if (!(nextPage > state.hooksTotalPages)) {
                _context22.next = 4;
                break;
              }

              return _context22.abrupt('return');

            case 4:

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_17" /* APPEND_HOOKS_REQUEST */]);
              _context22.prev = 5;
              _context22.next = 8;
              return queryHooks(filters, nextPage, state.selectorPageSize);

            case 8:
              res = _context22.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_18" /* APPEND_HOOKS_SUCCESS */], res.data.surveysListHook);
              _context22.next = 15;
              break;

            case 12:
              _context22.prev = 12;
              _context22.t0 = _context22['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_19" /* APPEND_HOOKS_FAILURE */], _context22.t0);

            case 15:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this18, [[5, 12]]);
    }))();
  },


  // Matrix choices (Music questions)
  getMatrixChoices: function getMatrixChoices(_ref23) {
    var _this19 = this;

    var commit = _ref23.commit,
        getters = _ref23.getters,
        state = _ref23.state;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
      var filters, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              filters = getters.selectorMatrixChoiceFilters;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_20" /* GET_MATRIX_CHOICES_REQUEST */]);
              _context23.prev = 2;
              _context23.next = 5;
              return queryMatrixChoices(filters, page, state.selectorPageSize);

            case 5:
              res = _context23.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_21" /* GET_MATRIX_CHOICES_SUCCESS */], res.data.surveysListMatrixChoice);
              _context23.next = 12;
              break;

            case 9:
              _context23.prev = 9;
              _context23.t0 = _context23['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_22" /* GET_MATRIX_CHOICES_FAILURE */], _context23.t0);

            case 12:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this19, [[2, 9]]);
    }))();
  },
  getMoreMatrixChoices: function getMoreMatrixChoices(_ref24) {
    var _this20 = this;

    var commit = _ref24.commit,
        getters = _ref24.getters,
        state = _ref24.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var filters, nextPage, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              filters = getters.selectorMatrixChoiceFilters;
              nextPage = state.hooksPage + 1;

              if (!(nextPage > state.hooksTotalPages)) {
                _context24.next = 4;
                break;
              }

              return _context24.abrupt('return');

            case 4:

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_26" /* APPEND_MATRIX_CHOICES_REQUEST */]);
              _context24.prev = 5;
              _context24.next = 8;
              return queryMatrixChoices(filters, nextPage, state.selectorPageSize);

            case 8:
              res = _context24.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_27" /* APPEND_MATRIX_CHOICES_SUCCESS */], res.data.surveysListMatrixChoice);
              _context24.next = 15;
              break;

            case 12:
              _context24.prev = 12;
              _context24.t0 = _context24['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_28" /* APPEND_MATRIX_CHOICES_FAILURE */], _context24.t0);

            case 15:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this20, [[5, 12]]);
    }))();
  },
  getQuestionCategories: function getQuestionCategories(_ref25) {
    var _this21 = this;

    var commit = _ref25.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var res, categories;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["K" /* GET_QUESTION_CATEGORIES_REQUEST */]);
              _context25.prev = 1;
              _context25.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject12)
              });

            case 4:
              res = _context25.sent;
              categories = res.data.surveysListQuestionCategory;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["L" /* GET_QUESTION_CATEGORIES_SUCCESS */], categories);
              _context25.next = 12;
              break;

            case 9:
              _context25.prev = 9;
              _context25.t0 = _context25['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["M" /* GET_QUESTION_CATEGORIES_FAILURE */], _context25.t0);

            case 12:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this21, [[1, 9]]);
    }))();
  },
  getQuestionCategoriesWithQuestions: function getQuestionCategoriesWithQuestions(_ref26) {
    var _this22 = this;

    var commit = _ref26.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
      var res, categories;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["K" /* GET_QUESTION_CATEGORIES_REQUEST */]);
              _context26.prev = 1;
              _context26.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject13)
              });

            case 4:
              res = _context26.sent;
              categories = res.data.surveysListQuestionCategory;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["O" /* GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS */], categories);
              _context26.next = 12;
              break;

            case 9:
              _context26.prev = 9;
              _context26.t0 = _context26['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["P" /* GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE */], _context26.t0);

            case 12:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this22, [[1, 9]]);
    }))();
  },
  createQuestionCategory: function createQuestionCategory(_ref27, questionCategory) {
    var _this23 = this;

    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["Q" /* CREATE_QUESTION_CATEGORY_REQUEST */]);
              _context27.prev = 1;
              _context27.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject14),
                variables: {
                  questionCategory: questionCategory
                }
              });

            case 4:
              res = _context27.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["R" /* CREATE_QUESTION_CATEGORY_SUCCESS */], res.data.surveysCreateQuestionCategory);
              _context27.next = 11;
              break;

            case 8:
              _context27.prev = 8;
              _context27.t0 = _context27['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["S" /* CREATE_QUESTION_CATEGORY_FAILURE */], _context27.t0);

            case 11:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this23, [[1, 8]]);
    }))();
  },
  createChoiceCategory: function createChoiceCategory(_ref28, choiceCategory) {
    var _this24 = this;

    var commit = _ref28.commit,
        dispatch = _ref28.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["W" /* CREATE_CHOICE_CATEGORY_REQUEST */]);
              _context28.prev = 1;
              _context28.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject15),
                variables: {
                  choiceCategory: choiceCategory
                }
              });

            case 4:
              res = _context28.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["X" /* CREATE_CHOICE_CATEGORY_SUCCESS */], res.data.surveysCreateChoiceCategory);
              _context28.next = 11;
              break;

            case 8:
              _context28.prev = 8;
              _context28.t0 = _context28['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["Y" /* CREATE_CHOICE_CATEGORY_FAILURE */], _context28.t0);

            case 11:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this24, [[1, 8]]);
    }))();
  },
  getChoiceCategories: function getChoiceCategories(_ref29) {
    var _this25 = this;

    var commit = _ref29.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var res, categories;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["T" /* GET_CHOICE_CATEGORIES_REQUEST */]);
              _context29.prev = 1;
              _context29.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].query({
                query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject16)
              });

            case 4:
              res = _context29.sent;
              categories = res.data.surveysListChoiceCategory;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["U" /* GET_CHOICE_CATEGORIES_SUCCESS */], categories);
              _context29.next = 12;
              break;

            case 9:
              _context29.prev = 9;
              _context29.t0 = _context29['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["V" /* GET_CHOICE_CATEGORIES_FAILURE */], _context29.t0);

            case 12:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this25, [[1, 9]]);
    }))();
  },
  surveyCreate: function surveyCreate(_ref30, survey) {
    var _this26 = this;

    var commit = _ref30.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["Z" /* CREATE_SURVEY_REQUEST */]);
              _context30.prev = 1;
              _context30.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject17),
                variables: { surveyInput: survey }
              });

            case 4:
              response = _context30.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_0" /* CREATE_SURVEY_SUCCESS */], response);
              _context30.next = 11;
              break;

            case 8:
              _context30.prev = 8;
              _context30.t0 = _context30['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_1" /* CREATE_SURVEY_FAILURE */], _context30.t0);

            case 11:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this26, [[1, 8]]);
    }))();
  },
  surveyUpdate: function surveyUpdate(_ref31, survey) {
    var _this27 = this;

    var commit = _ref31.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_2" /* UPDATE_SURVEY_REQUEST */]);

              _context31.prev = 1;
              _context31.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject18),
                variables: { surveyId: survey.id, surveyInput: whitelistedFields(surveyWhitelist, survey) }
              });

            case 4:
              response = _context31.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_3" /* UPDATE_SURVEY_SUCCESS */], response);
              _context31.next = 11;
              break;

            case 8:
              _context31.prev = 8;
              _context31.t0 = _context31['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_4" /* UPDATE_SURVEY_FAILURE */], _context31.t0);

            case 11:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this27, [[1, 8]]);
    }))();
  },
  surveyUpdateConfig: function surveyUpdateConfig(_ref32, config) {
    var _this28 = this;

    var dispatch = _ref32.dispatch,
        state = _ref32.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              dispatch('surveyUpdate', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.survey, { config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config) }));

            case 1:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this28);
    }))();
  },
  updateCanvasQuestions: function updateCanvasQuestions(_ref33) {
    var _this29 = this;

    var dispatch = _ref33.dispatch,
        state = _ref33.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              dispatch('updateQuestions', { questions: state.canvasQuestions, surveyId: state.survey.id });

            case 1:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this29);
    }))();
  },
  updateQuestions: function updateQuestions(_ref34, _ref35) {
    var _this30 = this;

    var commit = _ref34.commit,
        state = _ref34.state;
    var questions = _ref35.questions,
        surveyId = _ref35.surveyId;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34() {
      var processedQuestions, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              if (state.survey.isPreview) {
                _context34.next = 2;
                break;
              }

              return _context34.abrupt('return');

            case 2:

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_5" /* UPDATE_CANVAS_QUESTIONS_REQUEST */]);
              _context34.prev = 3;
              processedQuestions = questions;


              processedQuestions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["c" /* ungroupMediaQuestions */])(processedQuestions);

              // Set default chart type if no chart type set
              processedQuestions = processedQuestions.map(function (question) {
                var chart = question.chart === '' ? 'VERTICAL_BAR' : question.chart;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, question, { chart: chart });
              });

              // Remove fields we don't need
              processedQuestions = processedQuestions.map(function (question) {
                var choices = question.choices || [];
                var updatedChoices = choices.map(function (choice) {
                  var omitFields = ['templateId', 'conditionalLink'];
                  if (isNaN(choice.id)) {
                    omitFields.push('id');
                  }
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["omit"])(choice, omitFields);
                });

                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, whitelistedFields(questionWhitelist, question), {
                  choices: updatedChoices
                });
              });

              _context34.next = 10;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject19),
                variables: {
                  surveyId: surveyId,
                  questions: processedQuestions
                }
              });

            case 10:
              res = _context34.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_6" /* UPDATE_CANVAS_QUESTIONS_SUCCESS */], res.data.surveysUpdateQuestions);
              _context34.next = 17;
              break;

            case 14:
              _context34.prev = 14;
              _context34.t0 = _context34['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_7" /* UPDATE_CANVAS_QUESTIONS_FAILURE */], _context34.t0);

            case 17:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this30, [[3, 14]]);
    }))();
  },
  createMatrixChoice: function createMatrixChoice(_ref36, _ref37) {
    var _this31 = this;

    var commit = _ref36.commit,
        state = _ref36.state;
    var matrixChoice = _ref37.matrixChoice;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_29" /* CREATE_MATRIX_CHOICE_REQUEST */]);
              _context35.prev = 1;
              _context35.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject20),
                variables: {
                  matrixChoice: {
                    title: matrixChoice.title,
                    choices: matrixChoice.choices
                  }
                }
              });

            case 4:
              res = _context35.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_30" /* CREATE_MATRIX_CHOICE_SUCCESS */], res.data.surveysCreateMatrixChoice);
              _context35.next = 11;
              break;

            case 8:
              _context35.prev = 8;
              _context35.t0 = _context35['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_31" /* CREATE_MATRIX_CHOICE_FAILURE */], _context35.t0);

            case 11:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this31, [[1, 8]]);
    }))();
  },
  createHook: function createHook(_ref38, _ref39) {
    var _this32 = this;

    var commit = _ref38.commit,
        state = _ref38.state;
    var hook = _ref39.hook;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_11" /* CREATE_HOOK_REQUEST */]);
              _context36.prev = 1;
              _context36.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject21),
                variables: {
                  mediaClip: {
                    title: hook.title,
                    artist: hook.artist,
                    description: hook.description,
                    type: 'audio',
                    fileData: hook.fileData
                  }
                }
              });

            case 4:
              res = _context36.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_12" /* CREATE_HOOK_SUCCESS */], res.data.surveysCreateMediaClip);
              _context36.next = 11;
              break;

            case 8:
              _context36.prev = 8;
              _context36.t0 = _context36['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_13" /* CREATE_HOOK_FAILURE */], _context36.t0);

            case 11:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this32, [[1, 8]]);
    }))();
  },
  updateHook: function updateHook(_ref40, _ref41) {
    var _this33 = this;

    var commit = _ref40.commit,
        state = _ref40.state;
    var hook = _ref41.hook;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee37() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_14" /* UPDATE_HOOK_REQUEST */]);
              _context37.prev = 1;
              _context37.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject22),
                variables: {
                  mediaClipId: hook.id,
                  mediaClip: {
                    title: hook.title,
                    artist: hook.artist,
                    description: hook.description,
                    type: 'audio',
                    fileData: hook.fileData
                  }
                }
              });

            case 4:
              res = _context37.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_15" /* UPDATE_HOOK_SUCCESS */], res.data.surveysUpdateMediaClip);
              _context37.next = 11;
              break;

            case 8:
              _context37.prev = 8;
              _context37.t0 = _context37['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_16" /* UPDATE_HOOK_FAILURE */], _context37.t0);

            case 11:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this33, [[1, 8]]);
    }))();
  },
  updateMatrixChoice: function updateMatrixChoice(_ref42, matrixChoice) {
    var _this34 = this;

    var commit = _ref42.commit,
        state = _ref42.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee38() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_23" /* UPDATE_MATRIX_CHOICE_REQUEST */]);
              _context38.prev = 1;
              _context38.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9__apiv2Client__["a" /* default */].mutate({
                mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject23),
                variables: {
                  matrixChoiceId: matrixChoice.id,
                  matrixChoice: {
                    name: matrixChoice.name,
                    title: matrixChoice.title,
                    visibleIf: matrixChoice.visibleIf,
                    isRequired: matrixChoice.isRequired,
                    choices: matrixChoice.choices
                  }
                }
              });

            case 4:
              res = _context38.sent;

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_24" /* UPDATE_MATRIX_CHOICE_SUCCESS */], res.data.surveysUpdateMatrixChoice);
              _context38.next = 11;
              break;

            case 8:
              _context38.prev = 8;
              _context38.t0 = _context38['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["_25" /* UPDATE_MATRIX_CHOICE_FAILURE */], _context38.t0);

            case 11:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, _this34, [[1, 8]]);
    }))();
  }
});

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(583);



var _types$LIST_SURVEYS_R;

/* eslint no-param-reassign: "off" */



var transformSurveyQuestions = function transformSurveyQuestions(surveyQuestions) {
  // Apply transformations on questions
  var questions = surveyQuestions;
  questions = questions.map(function (q) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* applyQuestionLinkMetadata */])(q);
  }) || [];
  questions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* groupMediaQuestions */])(questions);
  return questions;
};

/* harmony default export */ __webpack_exports__["a"] = (_types$LIST_SURVEYS_R = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* LIST_SURVEYS_REQUEST */], function (state) {
  state.surveyListLoading = true;
  state.surveyListSuccess = false;
  state.surveyListError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* LIST_SURVEYS_SUCCESS */], function (state, _ref) {
  var surveys = _ref.surveys,
      pageNumber = _ref.pageNumber,
      totalPages = _ref.totalPages;

  state.surveyListLoading = false;
  state.surveyListSuccess = true;
  state.surveyList = surveys;
  state.surveyListPage = pageNumber;
  state.surveyListTotalPages = totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* LIST_SURVEYS_FAILURE */], function (state, payload) {
  state.surveyListLoading = false;
  state.surveyListSuccess = false;
  state.surveyListError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* GET_SURVEY_REQUEST */], function (state) {
  state.surveyLoading = true;
  state.surveyLoadSuccess = false;
  state.surveyLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* GET_SURVEY_SUCCESS */], function (state, payload) {
  state.surveyLoading = false;
  state.surveyLoadSuccess = true;
  state.survey = payload;

  state.canvasQuestions = transformSurveyQuestions(state.survey.questions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* GET_SURVEY_FAILURE */], function (state, payload) {
  state.surveyLoading = false;
  state.surveyLoadSuccess = false;
  state.surveyLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_QUESTIONS_REQUEST */], function (state) {
  state.questionsLoading = true;
  state.questionsLoadSuccess = false;
  state.questionsLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_QUESTIONS_SUCCESS */], function (state, payload) {
  state.questionsLoading = false;
  state.questionsLoadSuccess = true;
  state.questionList = payload.entries;
  state.questionsPage = payload.pageNumber;
  state.questionsTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_QUESTIONS_FAILURE */], function (state, payload) {
  state.questionsLoading = false;
  state.questionsLoadSuccess = false;
  state.questionsLoadError = payload;
  state.questionList = [];
  state.questionsPage = 0;
  state.questionsTotalPages = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* APPEND_QUESTIONS_REQUEST */], function (state) {
  state.questionsLoading = true;
  state.questionsLoadSuccess = false;
  state.questionsLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* APPEND_QUESTIONS_SUCCESS */], function (state, payload) {
  state.questionsLoading = false;
  state.questionsLoadSuccess = true;
  state.questionList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.questionList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.entries));
  state.questionsPage = payload.pageNumber > state.questionsPage ? payload.pageNumber : state.questionsPage;
  state.questionsTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* APPEND_QUESTIONS_FAILURE */], function (state, payload) {
  state.questionsLoading = false;
  state.questionsLoadSuccess = false;
  state.questionsLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* CREATE_QUESTION_REQUEST */], function (state) {
  state.questionsSaving = true;
  state.questionsSaveSuccess = false;
  state.questionsSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* CREATE_QUESTION_SUCCESS */], function (state, payload) {
  state.questionsSaving = false;
  state.questionsSaveSuccess = true;
  state.questionList = [payload].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.questionList));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* CREATE_QUESTION_FAILURE */], function (state, payload) {
  state.questionsSaving = false;
  state.questionsSaveSuccess = false;
  state.questionsSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* UPDATE_QUESTION_REQUEST */], function (state) {
  state.questionsSaving = true;
  state.questionsSaveSuccess = false;
  state.questionsSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* UPDATE_QUESTION_SUCCESS */], function (state, payload) {
  state.questionsSaving = false;
  state.questionsSaveSuccess = true;

  var updateQuestions = function updateQuestions(questionCollection) {
    return questionCollection.map(function (question) {
      if (question.id === payload.id) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* applyQuestionLinkMetadata */])(payload);
      }
      return question;
    });
  };

  state.questionList = updateQuestions(state.questionList);
  state.canvasQuestions = updateQuestions(state.canvasQuestions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* UPDATE_QUESTION_FAILURE */], function (state, payload) {
  state.questionsSaving = false;
  state.questionsSaveSuccess = false;
  state.questionsSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* GET_CHOICES_REQUEST */], function (state) {
  state.choicesLoading = true;
  state.choicesLoadSuccess = false;
  state.choicesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* GET_CHOICES_SUCCESS */], function (state, payload) {
  state.choicesLoading = false;
  state.choicesLoadSuccess = true;
  state.choiceList = payload.entries;
  state.choicesPage = payload.pageNumber;
  state.choicesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* GET_CHOICES_FAILURE */], function (state, payload) {
  state.choicesLoading = false;
  state.choicesLoadSuccess = false;
  state.choicesLoadError = payload;
  state.choiceList = [];
  state.choicesPage = 0;
  state.choicesTotalPages = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* APPEND_CHOICES_REQUEST */], function (state) {
  state.choicesLoading = true;
  state.choicesLoadSuccess = false;
  state.choicesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* APPEND_CHOICES_SUCCESS */], function (state, payload) {
  state.choicesLoading = false;
  state.choicesLoadSuccess = true;
  state.choiceList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.choiceList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.entries));
  state.choicesPage = payload.pageNumber > state.choicesPage ? payload.pageNumber : state.choicesPage;
  state.choicesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["x" /* APPEND_CHOICES_FAILURE */], function (state, payload) {
  state.choicesLoading = false;
  state.choicesLoadSuccess = false;
  state.choicesLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* GET_CHOICE_TEMPLATES_REQUEST */], function (state) {
  state.choiceTemplatesLoading = true;
  state.choiceTemplatesLoadSuccess = false;
  state.choiceTemplatesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["z" /* GET_CHOICE_TEMPLATES_SUCCESS */], function (state, payload) {
  state.choiceTemplatesLoading = false;
  state.choiceTemplatesLoadSuccess = true;
  state.choiceTemplateList = payload.entries;
  state.choiceTemplatesPage = payload.pageNumber;
  state.choiceTemplatesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* GET_CHOICE_TEMPLATES_FAILURE */], function (state, payload) {
  state.choiceTemplatesLoading = false;
  state.choiceTemplatesLoadSuccess = false;
  state.choiceTemplatesLoadError = payload;
  state.choiceTemplateList = [];
  state.choiceTemplatesPage = 0;
  state.choiceTemplatesTotalPages = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["B" /* APPEND_CHOICE_TEMPLATES_REQUEST */], function (state) {
  state.choiceTemplatesLoading = true;
  state.choiceTemplatesLoadSuccess = false;
  state.choiceTemplatesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["C" /* APPEND_CHOICE_TEMPLATES_SUCCESS */], function (state, payload) {
  state.choiceTemplatesLoading = false;
  state.choiceTemplatesLoadSuccess = true;
  state.choiceTemplateList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.choiceTemplateList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.entries));
  state.choiceTemplatesPage = payload.pageNumber > state.choiceTemplatesPage ? payload.pageNumber : state.choiceTemplatesPage;
  state.choiceTemplatesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["D" /* APPEND_CHOICE_TEMPLATES_FAILURE */], function (state, payload) {
  state.choiceTemplatesLoading = false;
  state.choiceTemplatesLoadSuccess = false;
  state.choiceTemplatesLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* CREATE_CHOICE_TEMPLATE_REQUEST */], function (state) {
  state.choiceTemplateSaving = true;
  state.choiceTemplateSaveSuccess = false;
  state.choiceTemplateSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* CREATE_CHOICE_TEMPLATE_SUCCESS */], function (state, payload) {
  state.choiceTemplatesSaving = false;
  state.choiceTemplatesSaveSuccess = true;
  state.choiceTemplateList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.choiceTemplateList), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["G" /* CREATE_CHOICE_TEMPLATE_FAILURE */], function (state, payload) {
  state.choiceTemplatesSaving = false;
  state.choiceTemplatesSaveSuccess = false;
  state.choiceTemplatesSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["H" /* UPDATE_CHOICE_TEMPLATE_REQUEST */], function (state) {
  state.choiceTemplateSaving = true;
  state.choiceTemplateSaveSuccess = false;
  state.choiceTemplateSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["I" /* UPDATE_CHOICE_TEMPLATE_SUCCESS */], function (state, payload) {
  state.choiceTemplatesSaving = false;
  state.choiceTemplatesSaveSuccess = true;
  state.choiceTemplateList = state.choiceTemplateList.map(function (template) {
    if (template.id === payload.id) {
      return payload;
    }
    return template;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* UPDATE_CHOICE_TEMPLATE_FAILURE */], function (state, payload) {
  state.choiceTemplatesSaving = false;
  state.choiceTemplatesSaveSuccess = false;
  state.choiceTemplatesSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["K" /* GET_QUESTION_CATEGORIES_REQUEST */], function (state) {
  state.questionCategoriesLoading = true;
  state.questionCategoriesLoadSuccess = false;
  state.questionCategoriesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* GET_QUESTION_CATEGORIES_SUCCESS */], function (state, payload) {
  state.questionCategoriesLoading = false;
  state.questionCategoriesLoadSuccess = true;
  state.questionCategoryList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["M" /* GET_QUESTION_CATEGORIES_FAILURE */], function (state, payload) {
  state.questionCategoriesLoading = false;
  state.questionCategoriesLoadSuccess = false;
  state.questionCategoriesLoadError = payload;
  state.questionCategoryList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["N" /* GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST */], function (state) {
  state.questionCategoriesWithQuestionsLoading = true;
  state.questionCategoriesWithQuestionsLoadSuccess = false;
  state.questionCategoriesWithQuestionsLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["O" /* GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS */], function (state, payload) {
  state.questionCategoriesWithQuestionsLoading = false;
  state.questionCategoriesWithQuestionsLoadSuccess = true;
  state.questionCategoryWithQuestionsList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["P" /* GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE */], function (state, payload) {
  state.questionCategoriesWithQuestionsLoading = false;
  state.questionCategoriesWithQuestionsLoadSuccess = false;
  state.questionCategoriesWithQuestionsLoadError = payload;
  state.questionCategoryWithQuestionsList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Q" /* CREATE_QUESTION_CATEGORY_REQUEST */], function (state) {
  state.questionCategoriesCreating = true;
  state.questionCategoriesCreateSuccess = false;
  state.questionCategoriesCreateError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["R" /* CREATE_QUESTION_CATEGORY_SUCCESS */], function (state, payload) {
  state.questionCategoriesCreating = false;
  state.questionCategoriesCreateSuccess = true;
  state.questionCategoryList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.questionCategoryList), [payload]).sort(function (a, b) {
    return a.title.localeCompare(b.title);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["S" /* CREATE_QUESTION_CATEGORY_FAILURE */], function (state, payload) {
  state.questionCategoriesCreating = false;
  state.questionCategoriesCreateSuccess = false;
  state.questionCategoriesCreateError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["T" /* GET_CHOICE_CATEGORIES_REQUEST */], function (state) {
  state.choiceCategoriesLoading = true;
  state.choiceCategoriesLoadSuccess = false;
  state.choiceCategoriesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["U" /* GET_CHOICE_CATEGORIES_SUCCESS */], function (state, payload) {
  state.choiceCategoriesLoading = false;
  state.choiceCategoriesLoadSuccess = true;
  state.choiceCategoryList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["V" /* GET_CHOICE_CATEGORIES_FAILURE */], function (state, payload) {
  state.choiceCategoriesLoading = false;
  state.choiceCategoriesLoadSuccess = false;
  state.choiceCategoriesLoadError = payload;
  state.choiceCategoryList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["W" /* CREATE_CHOICE_CATEGORY_REQUEST */], function (state) {
  state.choiceCategoriesCreating = true;
  state.choiceCategoriesCreateSuccess = false;
  state.choiceCategoriesCreateError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["X" /* CREATE_CHOICE_CATEGORY_SUCCESS */], function (state, payload) {
  state.choiceCategoriesCreating = false;
  state.choiceCategoriesCreateSuccess = true;
  state.choiceCategoryList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.choiceCategoryList), [payload]).sort(function (a, b) {
    return a.title.localeCompare(b.title);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Y" /* CREATE_CHOICE_CATEGORY_FAILURE */], function (state, payload) {
  state.choiceCategoriesCreating = false;
  state.choiceCategoriesCreateSuccess = false;
  state.choiceCategoriesCreateError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Z" /* CREATE_SURVEY_REQUEST */], function (state) {
  state.survey = null;
  state.surveySaving = true;
  state.surveySaveSuccess = false;
  state.surveySaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_0" /* CREATE_SURVEY_SUCCESS */], function (state, payload) {
  state.survey = payload.data.surveysCreate;
  state.surveySaving = false;
  state.surveySaveSuccess = true;

  state.canvasQuestions = transformSurveyQuestions([]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_1" /* CREATE_SURVEY_FAILURE */], function (state, payload) {
  state.survey = null;
  state.surveySaving = false;
  state.surveySaveSuccess = false;
  state.surveySaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_2" /* UPDATE_SURVEY_REQUEST */], function (state) {
  state.surveySaving = true;
  state.surveySaveSuccess = false;
  state.surveySaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_3" /* UPDATE_SURVEY_SUCCESS */], function (state, payload) {
  state.survey = payload.data.surveysUpdate;
  state.surveySaving = false;
  state.surveySaveSuccess = true;

  state.canvasQuestions = transformSurveyQuestions(state.survey.questions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_4" /* UPDATE_SURVEY_FAILURE */], function (state, payload) {
  state.surveySaving = false;
  state.surveySaveSuccess = false;
  state.surveySaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_5" /* UPDATE_CANVAS_QUESTIONS_REQUEST */], function (state) {
  state.canvasQuestionsUpdating = true;
  state.canvasQuestionsUpdateSuccess = false;
  state.canvasQuestionsUpdateError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_6" /* UPDATE_CANVAS_QUESTIONS_SUCCESS */], function (state, payload) {
  state.canvasQuestionsUpdating = false;
  state.canvasQuestionsUpdateSuccess = true;

  state.canvasQuestions = transformSurveyQuestions(payload.questions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_7" /* UPDATE_CANVAS_QUESTIONS_FAILURE */], function (state, payload) {
  state.canvasQuestionsUpdating = false;
  state.canvasQuestionsUpdateSuccess = false;
  state.canvasQuestionsUpdateError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_8" /* GET_HOOKS_REQUEST */], function (state) {
  state.hooksLoading = true;
  state.hooksLoadSuccess = false;
  state.hooksLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_9" /* GET_HOOKS_SUCCESS */], function (state, payload) {
  state.hooksLoading = false;
  state.hooksLoadSuccess = true;
  state.hookList = payload.entries;
  state.hooksPage = payload.pageNumber;
  state.hooksTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_10" /* GET_HOOKS_FAILURE */], function (state, payload) {
  state.hooksLoading = false;
  state.hooksLoadSuccess = false;
  state.hooksLoadError = payload;
  state.hookList = [];
  state.hooksPage = 0;
  state.hooksTotalPages = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_11" /* CREATE_HOOK_REQUEST */], function (state) {
  state.hooksCreating = true;
  state.hooksCreateSuccess = false;
  state.hooksCreateError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_12" /* CREATE_HOOK_SUCCESS */], function (state, payload) {
  state.hooksCreating = false;
  state.hooksCreateSuccess = true;
  state.hookList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.hookList), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_13" /* CREATE_HOOK_FAILURE */], function (state, payload) {
  state.hooksCreating = false;
  state.hooksCreateSuccess = false;
  state.hooksCreateError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_14" /* UPDATE_HOOK_REQUEST */], function (state) {
  state.hooksSaving = true;
  state.hooksSaveSuccess = false;
  state.hooksSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_15" /* UPDATE_HOOK_SUCCESS */], function (state, payload) {
  state.hooksSaving = false;
  state.hooksSaveSuccess = true;
  state.hookList = state.hookList.map(function (hook) {
    if (hook.id === payload.id) {
      return payload;
    }
    return hook;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_16" /* UPDATE_HOOK_FAILURE */], function (state, payload) {
  state.hooksSaving = false;
  state.hooksSaveSuccess = false;
  state.hooksSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_17" /* APPEND_HOOKS_REQUEST */], function (state) {
  state.hooksLoading = true;
  state.hooksLoadSuccess = false;
  state.hooksLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_18" /* APPEND_HOOKS_SUCCESS */], function (state, payload) {
  state.hooksLoading = false;
  state.hooksLoadSuccess = true;
  state.hookList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.hookList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.entries));
  state.hooksPage = payload.pageNumber > state.hookssPage ? payload.pageNumber : state.hooksPage;
  state.hooksTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_19" /* APPEND_HOOKS_FAILURE */], function (state, payload) {
  state.hooksLoading = false;
  state.hooksLoadSuccess = false;
  state.hooksLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_20" /* GET_MATRIX_CHOICES_REQUEST */], function (state) {
  state.matrixChoicesLoading = true;
  state.matrixChoicesLoadSuccess = false;
  state.matrixChoicesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_21" /* GET_MATRIX_CHOICES_SUCCESS */], function (state, payload) {
  state.matrixChoicesLoading = false;
  state.matrixChoicesLoadSuccess = true;
  state.matrixChoiceList = payload.entries;
  state.matrixChoicesPage = payload.pageNumber;
  state.matrixChoicesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_22" /* GET_MATRIX_CHOICES_FAILURE */], function (state, payload) {
  state.matrixChoicesLoading = false;
  state.matrixChoicesLoadSuccess = false;
  state.matrixChoicesLoadError = payload;
  state.matrixChoiceList = [];
  state.matrixChoicesPage = 0;
  state.matrixChoicesTotalPages = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_23" /* UPDATE_MATRIX_CHOICE_REQUEST */], function (state) {
  state.matrixChoicesSaving = true;
  state.matrixChoicesSaveSuccess = false;
  state.matrixChoicesSaveError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_24" /* UPDATE_MATRIX_CHOICE_SUCCESS */], function (state, payload) {
  state.matrixChoicesSaving = false;
  state.matrixChoicesSaveSuccess = true;
  state.matrixChoiceList = state.matrixChoiceList.map(function (matrixChoice) {
    if (matrixChoice.id === payload.id) {
      return payload;
    }
    return matrixChoice;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_25" /* UPDATE_MATRIX_CHOICE_FAILURE */], function (state, payload) {
  state.matrixChoicesSaving = false;
  state.matrixChoicesSaveSuccess = false;
  state.matrixChoicesSaveError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_26" /* APPEND_MATRIX_CHOICES_REQUEST */], function (state) {
  state.matrixChoicesLoading = true;
  state.matrixChoicesLoadSuccess = false;
  state.matrixChoicesLoadError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_27" /* APPEND_MATRIX_CHOICES_SUCCESS */], function (state, payload) {
  state.matrixChoicesLoading = false;
  state.matrixChoicesLoadSuccess = true;
  state.matrixChoiceList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.matrixChoiceList), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.entries));
  state.matrixChoicesPage = payload.pageNumber > state.matrixChoicesPage ? payload.pageNumber : state.matrixChoicesPage;
  state.matrixChoicesTotalPages = payload.totalPages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_28" /* APPEND_MATRIX_CHOICES_FAILURE */], function (state, payload) {
  state.matrixChoicesLoading = false;
  state.matrixChoicesLoadSuccess = false;
  state.matrixChoicesLoadError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_29" /* CREATE_MATRIX_CHOICE_REQUEST */], function (state) {
  state.matrixChoicesCreating = true;
  state.matrixChoicesCreateSuccess = false;
  state.matrixChoicesCreateError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_30" /* CREATE_MATRIX_CHOICE_SUCCESS */], function (state, payload) {
  state.matrixChoicesCreating = false;
  state.matrixChoicesCreateSuccess = true;
  state.matrixChoiceList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.matrixChoiceList), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$LIST_SURVEYS_R, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_31" /* CREATE_MATRIX_CHOICE_FAILURE */], function (state, payload) {
  state.matrixChoicesCreating = false;
  state.matrixChoicesCreateSuccess = false;
  state.matrixChoicesCreateError = payload;
}), _types$LIST_SURVEYS_R);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_object__ = __webpack_require__(1144);




/* harmony default export */ __webpack_exports__["a"] = ({
  canvasSelectedQuestion: function canvasSelectedQuestion(state) {
    var questionId = state.canvasSelectedQuestionId;
    var question = state.canvasQuestions.find(function (q) {
      return q.id === questionId;
    });
    return question;
  },
  canvasParsedQuestions: function canvasParsedQuestions(state) {
    var conditionals = state.canvasQuestions.filter(function (q) {
      return q.visibilityCondition && q.visibilityCondition !== '';
    }).reduce(function (acc, q) {
      var regexp = /{question([\d]+)}=['"]([^']+)['"]/g;
      var matches = q.visibilityCondition.matchAll(regexp);
      var parsed = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(matches)).map(function (match) {
        return {
          link: q.id,
          questionId: parseInt(match[1], 10),
          choiceTitle: match[2]
        };
      });

      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(parsed));
    }, []);

    var updatedQuestions = state.canvasQuestions.map(function (question) {
      var choices = (question.choices || []).map(function (choice) {
        var conditional = conditionals.find(function (c) {
          return c.questionId === question.id && c.choiceTitle === choice.title;
        });

        if (!conditional) {
          return choice;
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, choice, { conditionalLink: conditional.link });
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, question, { choices: choices });
    });
    return updatedQuestions;
  },
  selectorQuestionFilters: function selectorQuestionFilters(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_object__["a" /* discardItemsWithEmptyValues */])({
      filter: state.selectorQuestionSearchText,
      categoryId: state.selectorSelectedQuestionCategory
    });
  },
  selectorChoiceFilters: function selectorChoiceFilters(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_object__["a" /* discardItemsWithEmptyValues */])({
      filter: state.selectorChoiceSearchText,
      categoryId: state.selectorSelectedChoiceCategory
    });
  },
  selectorChoiceTemplateFilters: function selectorChoiceTemplateFilters(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_object__["a" /* discardItemsWithEmptyValues */])({
      filter: state.selectorTemplateSearchText,
      categoryId: state.selectorSelectedTemplateCategory
    });
  },
  selectorHookFilters: function selectorHookFilters(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_object__["a" /* discardItemsWithEmptyValues */])({
      filter: state.selectorHookSearchText
    });
  },
  selectorMatrixChoiceFilters: function selectorMatrixChoiceFilters(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_object__["a" /* discardItemsWithEmptyValues */])({
      filter: state.selectorMatrixChoiceSearchText
    });
  },
  selectorDisabledQuestionIds: function selectorDisabledQuestionIds(state) {
    return state.canvasQuestions.map(function (q) {
      return q.id;
    });
  },
  selectorDisabledTemplateIds: function selectorDisabledTemplateIds(state, getters) {
    var selectedQuestion = getters.canvasSelectedQuestion;
    var choices = selectedQuestion && selectedQuestion.choices ? selectedQuestion.choices : [];
    return choices.map(function (c) {
      return c.templateId;
    });
  },
  selectorDisabledChoiceIds: function selectorDisabledChoiceIds(state, getters) {
    var selectedQuestion = getters.canvasSelectedQuestion;
    var choices = selectedQuestion && selectedQuestion.choices ? selectedQuestion.choices : [];
    return choices.map(function (c) {
      return c.id;
    });
  },
  hookQuestions: function hookQuestions(state) {
    return state.hookList.map(function (hook) {
      return {
        title: hook.title,
        questionType: 'MEDIA',
        chart: '',
        categoryId: null,
        insight: '',
        isRequired: true,
        isGlobal: false,
        isProfile: false,
        profileField: null,
        isChoiceOrderReversed: false,
        visibilityCondition: '',
        mediaClip: hook,
        choices: [],
        matrixChoices: []
      };
    });
  },
  matrixChoices: function matrixChoices(state) {
    var groupMediaQuestion = state.canvasQuestions.find(function (q) {
      return q.questionType === 'MEDIA';
    });
    if (!groupMediaQuestion) {
      return [];
    }
    return groupMediaQuestion.matrixChoices || [];
  }
});

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_actions__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_mutations__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state__ = __webpack_require__(585);








/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__api_actions__["a" /* default */]),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_mutations__["a" /* default */]),
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__state__["a" /* default */])(),
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */]
});

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__initial_state__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state__ = __webpack_require__(585);





var _types$RESET_SURVEYBU;

/* eslint no-param-reassign: "off" */




/* harmony default export */ __webpack_exports__["a"] = (_types$RESET_SURVEYBU = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_32" /* RESET_SURVEYBUILDER */], function (state) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__state__["a" /* default */])());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_33" /* SET_TAB_ACTIVE */], function (state, payload) {
  state.tabActive = payload;
  window.scrollTo(0, 0);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_34" /* SET_SURVEY_FILTER */], function (state, payload) {
  state.surveyListFilter = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_35" /* SET_SURVEY_ACTIVE */], function (state, id) {
  state.surveyList = state.surveyList.map(function (survey) {
    if (survey.id === id) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, survey, { isActive: true });
    }
    return survey;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_36" /* SET_SURVEY_INACTIVE */], function (state, id) {
  state.surveyList = state.surveyList.map(function (survey) {
    if (survey.id === id) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, survey, { isActive: false });
    }
    return survey;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_37" /* SET_SURVEY_FAVORITE */], function (state, data) {
  state.surveyList = state.surveyList.map(function (survey) {
    if (survey.id === data.id) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, survey, { favorite: data.favorite });
    }
    return survey;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_38" /* SET_SURVEY_SORT_BY_FAVORITE */], function (state) {
  state.surveyList = state.surveyList.sort(function (a, b) {
    if (a.favorite === b.favorite) {
      return 0;
    } else if (a.favorite) {
      return -1;
    }
    return 1;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_39" /* SET_SURVEY_DELETE */], function (state, data) {
  state.surveyList = state.surveyList.filter(function (survey) {
    return survey.id !== data.id;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_40" /* ADD_CANVAS_QUESTION */], function (state, payload) {
  state.canvasQuestions = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.canvasQuestions), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_41" /* SELECT_CANVAS_QUESTION_ID */], function (state, payload) {
  state.canvasSelectedQuestionId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_42" /* SET_CANVAS_QUESTIONS */], function (state, payload) {
  state.canvasQuestions = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_43" /* SELECT_SELECTOR_QUESTION_CATEGORY */], function (state, payload) {
  state.selectorSelectedQuestionCategory = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_44" /* SELECT_SELECTOR_TEMPLATE_ID */], function (state, payload) {
  state.selectorSelectedTemplateId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_45" /* SELECT_SELECTOR_TEMPLATE_CATEGORY */], function (state, payload) {
  state.selectorSelectedTemplateCategory = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_46" /* SELECT_SELECTOR_CHOICE_CATEGORY */], function (state, payload) {
  state.selectorSelectedChoiceCategory = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_47" /* SET_SELECTOR_QUESTION_TEXT */], function (state, payload) {
  state.selectorQuestionSearchText = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_48" /* SET_SELECTOR_TEMPLATE_TEXT */], function (state, payload) {
  state.selectorTemplateSearchText = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_49" /* SET_SELECTOR_CHOICE_TEXT */], function (state, payload) {
  state.selectorChoiceSearchText = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_50" /* SET_SELECTOR_HOOK_TEXT */], function (state, payload) {
  state.selectorHookSearchText = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_51" /* SET_SELECTOR_MATRIX_CHOICE_TEXT */], function (state, payload) {
  state.selectorMatrixChoiceSearchText = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_52" /* RESET_SELECTOR_QUESTION_FILTERS */], function (state) {
  state.selectorSelectedQuestionCategory = null;
  state.selectorQuestionSearchText = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_53" /* RESET_SELECTOR_TEMPLATE_FILTERS */], function (state) {
  state.selectorSelectedTemplateCategory = null;
  state.selectorTemplateSearchText = '';
  state.selectorSelectedChoiceCategory = null;
  state.selectorSelectedTemplateId = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_54" /* RESET_SELECTOR_CHOICE_FILTERS */], function (state) {
  state.selectorSelectedChoiceCategory = null;
  state.selectorChoiceSearchText = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_55" /* RESET_SELECTOR_HOOK_FILTERS */], function (state) {
  state.selectorHookSearchText = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_56" /* RESET_SELECTOR_MATRIX_CHOICE_FILTERS */], function (state) {
  state.selectorMatrixChoiceSearchText = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], function (state, payload) {
  state.questionDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], function (state, payload) {
  state.questionDialogAddToCanvas = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_59" /* SET_QUESTION_DIALOG_FORM */], function (state, payload) {
  state.questionDialogForm = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_60" /* RESET_QUESTION_DIALOG_FORM */], function (state) {
  state.questionDialogForm = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__initial_state__["a" /* questionDialogFormInitial */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_61" /* SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], function (state, payload) {
  state.questionConditionalLogicDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_62" /* SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION */], function (state, payload) {
  state.questionConditionalLogicDialogQuestion = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_63" /* SET_HOOK_DIALOG_VISIBILITY */], function (state, payload) {
  state.hookDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_64" /* SET_HOOK_DIALOG_FORM */], function (state, payload) {
  state.hookDialogForm = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_65" /* RESET_HOOK_DIALOG_FORM */], function (state) {
  state.hookDialogForm = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__initial_state__["b" /* hookDialogFormInitial */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_66" /* SET_MATRIX_CHOICE_DIALOG_VISIBILITY */], function (state, payload) {
  state.matrixChoiceDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_67" /* SET_MATRIX_CHOICE_DIALOG_FORM */], function (state, payload) {
  state.matrixChoiceDialogForm = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_68" /* RESET_MATRIX_CHOICE_DIALOG_FORM */], function (state) {
  state.matrixChoiceDialogForm = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__initial_state__["c" /* matrixChoiceDialogFormInitial */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_69" /* SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], function (state, payload) {
  state.matrixConditionalLogicDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_70" /* SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE */], function (state, payload) {
  state.matrixConditionalLogicDialogMatrixChoice = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], function (state, payload) {
  state.choiceTemplateDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_72" /* SET_CHOICE_TEMPLATE_DIALOG_CHOICES */], function (state, payload) {
  state.choiceTemplateDialogChoices = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_73" /* SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE */], function (state, payload) {
  state.choiceTemplateDialogIsScale = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_74" /* SET_CHOICE_TEMPLATE_DIALOG_FORM */], function (state, payload) {
  state.choiceTemplateDialogForm = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_75" /* RESET_CHOICE_TEMPLATE_DIALOG_FORM */], function (state) {
  state.choiceTemplateDialogForm = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__initial_state__["d" /* choiceTemplateDialogFormInitial */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_76" /* CREATE_QUESTION_CATEGORY */], function (state, payload) {
  state.questionCategoryList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.questionCategoryList), [payload]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_77" /* SET_QUESTION_CATEGORY_DIALOG_VISIBILITY */], function (state, payload) {
  state.questionCategoryDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$RESET_SURVEYBU, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_78" /* SET_CHOICE_CATEGORY_DIALOG_VISIBILITY */], function (state, payload) {
  state.choiceCategoryDialogVisible = payload;
}), _types$RESET_SURVEYBU);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(586);



/* harmony default export */ __webpack_exports__["a"] = ({
  requestCode: function requestCode(_ref, params) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* REQUEST_TELEGRAM_CODE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* telegramAPI */].get('api/auth', { params: params }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* REQUEST_TELEGRAM_CODE_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* REQUEST_TELEGRAM_CODE_FAILURE */], error);
    });
  },
  confirmCode: function confirmCode(_ref2, payload) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SIGN_IN_TELEGRAM_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["b" /* telegramAPI */].get('api/confirm', { params: payload }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SIGN_IN_TELEGRAM_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SIGN_IN_TELEGRAM_FAILED */], error);
    });
  }
});

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1268);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(586);


var _types$SET_TELEGRAM_N;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$SET_TELEGRAM_N = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_TELEGRAM_NEW_DIALOG_VISIBLE */], function (state, payload) {
  state.telegramNewDialogVisible = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_TELEGRAM_SELECTED_COUNTRY */], function (state, payload) {
  state.telegramSelectedCountry = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* REQUEST_TELEGRAM_CODE_REQUEST */], function (state) {
  state.loadingTelegramCodeRequest = true;
  state.telegramCodeRequestFailed = false;
  state.telegramCodeRequestSuccess = false;
  state.telegramClientStatus = null;
  state.telegramCodeRequestError = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* REQUEST_TELEGRAM_CODE_SUCCESS */], function (state, payload) {
  state.loadingTelegramCodeRequest = false;
  state.telegramClientStatus = payload.message;
  state.telegramCodeRequestSuccess = true;
  state.telegramCodeRequestFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* REQUEST_TELEGRAM_CODE_FAILURE */], function (state, payload) {
  state.loadingTelegramCodeRequest = false;
  state.telegramCodeRequestSuccess = false;
  state.telegramCodeRequestFailed = true;
  state.telegramCodeRequestError = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SIGN_IN_TELEGRAM_REQUEST */], function (state) {
  state.loadingTelegramSignIn = true;
  state.telegramSignInFailed = false;
  state.telegramSignInSuccess = false;
  state.telegramSignInStatus = null;
  state.telegramStatusMessage = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SIGN_IN_TELEGRAM_SUCCESS */], function (state, payload) {
  state.loadingTelegramSignIn = false;
  state.telegramSignInSuccess = true;
  state.telegramSignInFailed = false;
  state.telegramSignInStatus = payload.status;
  state.telegramStatusMessage = payload.message;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TELEGRAM_N, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SIGN_IN_TELEGRAM_FAILED */], function (state, error) {
  state.loadingTelegramSignIn = false;
  state.telegramSignInFailed = true;
  state.telegramSignInSuccess = false;
  state.telegramSignInError = error;
}), _types$SET_TELEGRAM_N);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  telegramNewDialogVisible: false,
  telegramSelectedCountry: { code: null, flag: null, dial_code: null },
  telegramPhoneCodeHash: null,
  telegramClientStatus: null,
  telegramSignInStatus: null,
  telegramStatusMessage: null,

  loadingTelegramCodeRequest: false,
  telegramCodeRequestFailed: false,
  telegramCodeRequestSuccess: false,
  telegramCodeRequestError: null,

  loadingTelegramSignIn: false,
  telegramSignInFailed: false,
  telegramSignInSuccess: false,
  telegramSignInError: null
});

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(347);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTimeslots: function getTimeslots(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_TIMESLOTS_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('timeslots/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_TIMESLOT_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_TIMESLOT_FAILURE */], error);
    });
  },
  createTimeslot: function createTimeslot(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_TIMESLOT_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('timeslots/', payload).then(function (response) {
      dispatch('getTimeslots');
      return response;
    }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SAVE_TIMESLOT_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SAVE_TIMESLOT_FAILURE */], error);
    });
  },
  updateTimeslot: function updateTimeslot(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_TIMESLOT_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].put('timeslots/' + payload.id + '/', payload).then(function (response) {
      dispatch('getTimeslots');
      return response;
    }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SAVE_TIMESLOT_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SAVE_TIMESLOT_FAILURE */], error);
    });
  },
  deleteTimeslot: function deleteTimeslot(_ref4, id) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* DELETE_TIMESLOT_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].delete('timeslots/' + id + '/').then(function (response) {
      dispatch('getTimeslots');
      return response;
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_TIMESLOT_SUCCESS */]);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* DELETE_TIMESLOT_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  activeTimeslots: function activeTimeslots(state) {
    return state.timeslots.filter(function (x) {
      return x.active;
    });
  }
});

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(1273);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]
});

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(347);


var _types$GET_TIMESLOTS_;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_TIMESLOTS_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_TIMESLOTS_REQUEST */], function (state) {
  state.loadingTimeslots = true;
  state.loadingTimeslotsSuccess = false;
  state.loadingTimeslotsFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_TIMESLOT_FAILURE */], function (state, error) {
  state.loadingTimeslots = false;
  state.loadingTimeslotsSuccess = false;
  state.loadingTimeslotsFailed = true;
  state.loadingCompaniesErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_TIMESLOT_SUCCESS */], function (state, response) {
  state.loadingTimeslots = false;
  state.loadingTimeslotsSuccess = true;
  state.loadingTimeslotsFailed = false;
  state.timeslots = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SAVE_TIMESLOT_REQUEST */], function (state) {
  state.saveTimeslotRequest = true;
  state.saveTimeslotSuccess = false;
  state.saveTimeslotFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SAVE_TIMESLOT_SUCCESS */], function (state) {
  state.saveTimeslotRequest = false;
  state.saveTimeslotSuccess = true;
  state.saveTimeslotFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SAVE_TIMESLOT_FAILURE */], function (state, error) {
  state.saveTimeslotRequest = false;
  state.saveTimeslotSuccess = false;
  state.saveTimeslotFailed = true;
  state.saveTimeslotErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* DELETE_TIMESLOT_REQUEST */], function (state) {
  state.deleteTimeslotsRequest = true;
  state.deleteTimeslotsSuccess = false;
  state.deleteTimeslotsFailed = false;
  state.deleteTimeslotErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_TIMESLOT_SUCCESS */], function (state) {
  state.deleteTimeslotsRequest = false;
  state.deleteTimeslotsSuccess = true;
  state.deleteTimeslotsFailed = false;
  state.deleteTimeslotErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* DELETE_TIMESLOT_FAILURE */], function (state, error) {
  state.deleteTimeslotsRequest = false;
  state.deleteTimeslotsSuccess = false;
  state.deleteTimeslotsFailed = true;
  state.deleteTimeslotErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_TIMESLOTS_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* EDIT_TIMESLOT */], function (state, timeslot) {
  state.selectedTimeslot = timeslot;
}), _types$GET_TIMESLOTS_);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  timeslots: [],
  selectedTimeslot: null,

  loadingTimeslots: false,
  loadingTimeslotsFailed: false,
  loadingTimeslotsSuccess: false,
  loadingTimeslotsErrors: null,

  saveTimeslotRequest: false,
  saveTimeslotSuccess: false,
  saveTimeslotFailed: false,
  saveTimeslotErrors: null,

  deleteTimeslotsRequest: false,
  deleteTimeslotsSuccess: false,
  deleteTimeslotsFailed: false,
  deleteTimeslotErrors: null
});

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(348);


/* harmony default export */ __webpack_exports__["a"] = ({
  info: function info(_ref, message) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SEND_TOAST */], {
      title: 'Info',
      type: 'info',
      message: message
    });
  },
  success: function success(_ref2, message) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SEND_TOAST */], {
      title: 'Success',
      type: 'success',
      message: message
    });
  },
  warning: function warning(_ref3, message) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SEND_TOAST */], {
      title: 'Warning',
      type: 'warning',
      message: message
    });
  },
  error: function error(_ref4, message) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SEND_TOAST */], {
      title: 'Error',
      type: 'error',
      message: message
    });
  }
});

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1277);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(348);


var _types$SEND_TOAST$typ;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$SEND_TOAST$typ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SEND_TOAST$typ, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SEND_TOAST */], function (state, _ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type;

  state.toastTitle = title;
  state.toastMessage = message;
  state.toastType = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SEND_TOAST$typ, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* RESET_TOAST */], function (state) {
  state.toastTitle = null;
  state.toastMessage = null;
  state.toastType = null;
}), _types$SEND_TOAST$typ);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toastTitle: null,
  toastMessage: null,
  toastType: null
});

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(587);



/* harmony default export */ __webpack_exports__["a"] = ({
  getSingleUseToken: function getSingleUseToken(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('tokens/single-use/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_SINGLE_USE_TOKEN_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_SINGLE_USE_TOKEN_FAILURE */], error);
    });
  }
});

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1281);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(587);


var _types$GET_SINGLE_USE;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_SINGLE_USE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SINGLE_USE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* GET_SINGLE_USE_TOKEN_REQUEST */], function (state) {
  state.loadingSingleUseToken = true;
  state.loadingSingleUseTokenSuccess = false;
  state.loadingSingleUseTokenFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SINGLE_USE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* GET_SINGLE_USE_TOKEN_FAILURE */], function (state, error) {
  state.loadingSingleUseToken = false;
  state.loadingSingleUseTokenSuccess = false;
  state.loadingSingleUseTokenFailed = true;
  state.loadingSingleUseTokenError = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_SINGLE_USE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* GET_SINGLE_USE_TOKEN_SUCCESS */], function (state, response) {
  state.loadingSingleUseToken = false;
  state.loadingSingleUseTokenSuccess = true;
  state.loadingSingleUseTokenFailed = false;
  state.singleUseToken = response.token;
}), _types$GET_SINGLE_USE);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  singleUseToken: null,
  loadingSingleUseToken: false,
  loadingSingleUseTokenSuccess: false,
  loadingSingleUseTokenFailed: false,
  loadingSingleUseTokenError: null
});

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(349);




/* harmony default export */ __webpack_exports__["a"] = ({
  updateUserCompany: function updateUserCompany(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* UPDATE_COMPANY_USER_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].patch('accounts/users/' + payload.user + '/', { use_as_company: payload.company }).then(function () {
      return location.reload();
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* UPDATE_COMPANY_USER_FAILURE */]);
    });
  },
  getMe: function getMe(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_ME_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/users/me/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_ME_SUCCESS */], response.data);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_ME_FAILURE */]);
    });
  },
  getGroups: function getGroups(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_GROUPS_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/groups/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_GROUPS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_GROUPS_FAILURE */], error);
    });
  },
  getCompanyUsers: function getCompanyUsers(_ref4) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('accounts/users/?org_users=True').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* GET_COMPANY_USERS_SUCCESS */], response);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* GET_COMPANY_USERS_FAILURE */], error);
    });
  },
  saveUser: function saveUser(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* UPDATE_COMPANY_USER_REQUEST */]);
    var apiMethod = payload.id ? __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].put('accounts/users/' + payload.id + '/', payload) : __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('accounts/users/', payload);

    return apiMethod.then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* UPDATE_COMPANY_USER_SUCCESS */], response);
    }).then(function () {
      return dispatch('getCompanyUsers');
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* UPDATE_COMPANY_USER_FAILURE */], error);
    });
  },
  deleteUser: function deleteUser(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* UPDATE_COMPANY_USER_REQUEST */]);
    var apiMethod = payload.id ? __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].delete('accounts/users/' + payload.id + '/', payload) : __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('accounts/users/', payload);

    return apiMethod.then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* UPDATE_COMPANY_USER_SUCCESS */], response);
    }).then(function () {
      return dispatch('getCompanyUsers');
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* UPDATE_COMPANY_USER_FAILURE */], error);
    });
  },
  updateUserProfile: function updateUserProfile(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* UPDATE_USER_PROFILE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].patch('accounts/users/' + payload.id + '/', payload.form).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* UPDATE_USER_PROFILE_SUCCESS */], response);
    }).then(function () {
      return dispatch('user/getMe', null, { root: true });
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* UPDATE_USER_PROFILE_FAILURE */]);
    });
  },
  getBrowserLocale: function getBrowserLocale(_ref8) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* UPDATE_USER_LOCALE_REQUEST */]);

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.ipdata.co').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* UPDATE_USER_LOCALE_SUCCESS */], response);
    }).catch(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* UPDATE_USER_LOCALE_FAILURE */]);
    });
  }
});

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1285);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(349);



var _types$GET_ME_REQUEST;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$GET_ME_REQUEST = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_ME_REQUEST */], function (state) {
  state.getMePending = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_ME_FAILURE */], function (state) {
  state.getMePending = false;
  state.getMeSuccess = false;
  state.getMeFailed = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* GET_ME_SUCCESS */], function (state, data) {
  state.getMePending = false;
  state.getMeSuccess = true;
  state.getMeFailed = false;

  state.me = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* UPDATE_USER_PROFILE_REQUEST */], function (state) {
  state.updatingProfile = true;
  state.updatingProfileFailed = false;
  state.updatingProfileSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* UPDATE_USER_PROFILE_FAILURE */], function (state) {
  state.updatingProfileFailed = true;
  state.updatingProfileSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* UPDATE_USER_PROFILE_SUCCESS */], function (state) {
  state.updatingProfileSuccess = true;
  state.updatingProfileFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* GET_GROUPS_REQUEST */], function (state) {
  state.loadingGroups = true;
  state.loadingGroupsFailed = false;
  state.loadingGroupsSucceeded = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_GROUPS_FAILURE */], function (state, error) {
  state.loadingGroupsFailed = true;
  state.loadingGroupsError = error.response;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* GET_GROUPS_SUCCESS */], function (state, response) {
  state.loadingGroups = false;
  state.loadingGroupsFailed = false;
  state.loadingGroupsSucceeded = true;
  state.groups = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_COMPANY_USERS_REQUEST */], function (state) {
  state.loadingCompanyUsers = true;
  state.loadingCompanyUsersSucceeded = false;
  state.loadingCompanyUsersFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* GET_COMPANY_USERS_FAILURE */], function (state, error) {
  state.loadingCompanyUsers = false;
  state.loadingCompanyUsersFailed = true;
  state.loadingCompanyUsersErrors = error.error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* GET_COMPANY_USERS_SUCCESS */], function (state, response) {
  state.loadingCompanyUsers = false;
  state.loadingCompanyUsersSucceeded = true;
  state.companyUsers = response.data.results;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* UPDATE_COMPANY_USER_REQUEST */], function (state) {
  state.updateCompanyUserRequest = true;
  state.updateCompanyUserSucceeded = false;
  state.updateCompanyUserFailed = false;
  state.updateCompanyUserErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* UPDATE_COMPANY_USER_SUCCESS */], function (state) {
  state.updateCompanyUserRequest = false;
  state.updateCompanyUserSucceeded = true;
  state.updateCompanyUserFailed = false;
  state.updateCompanyUserErrors = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* UPDATE_COMPANY_USER_FAILURE */], function (state, error) {
  state.updateCompanyUserRequest = false;
  state.updateCompanyUserSucceeded = false;
  state.updateCompanyUserFailed = true;
  state.updateCompanyUserErrors = error.response.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["p" /* UPDATE_USER_LOCALE_REQUEST */], function (state) {
  state.updateUserLocaleRequest = true;
  state.updateUserLocaleSuccess = false;
  state.updateUserLocaleFailure = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["q" /* UPDATE_USER_LOCALE_SUCCESS */], function (state, response) {
  state.updateUserLocaleRequest = false;
  state.updateUserLocaleSuccess = true;
  state.updateUserLocaleFailure = false;

  state.userCountryCode = response.data.country_code;
  localStorage.setItem('browserLocale', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["r" /* UPDATE_USER_LOCALE_FAILURE */], function (state) {
  state.updateUserLocaleRequest = false;
  state.updateUserLocaleSuccess = false;
  state.updateUserLocaleFailure = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$GET_ME_REQUEST, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["s" /* UPDATE_USER_PASSWORD_SUCCESS */], function (state, response) {
  state.userListSelectedUser = response.userListSelectedUser;
}), _types$GET_ME_REQUEST);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  me: {
    id: '',
    email: '',
    last_name: '',
    first_name: '',
    avatar: '',
    gravatar: '',
    is_streaming: '',
    company_name: '',
    company_id: 0,
    display_name: '',
    job_title: '',
    is_staff: false,
    is_admin: false
  },
  userListSelectedUser: {
    id: '',
    email: '',
    last_name: '',
    first_name: '',
    avatar: '',
    gravatar: '',
    is_streaming: '',
    company_name: '',
    company_id: 0,
    display_name: '',
    job_title: '',
    is_staff: false,
    is_admin: false
  },
  getUserListSelectedUserRequest: false,
  getUserListSelectedUserFailed: false,
  geUserListSelectedUserSuccess: false,

  getMePending: false,
  getMeFailed: false,
  getMeSuccess: false,
  groups: [],

  updatingProfile: false,
  updatingProfileFailed: false,
  updatingProfileSuccess: false,

  companyUsers: [],
  loadingCompanyUsers: false,
  loadingCompanyUsersFailed: false,
  loadingCompanyUsersSucceeded: false,
  loadingCompanyUsersErrors: null,

  updateCompanyUserRequest: false,
  updateCompanyUserSucceeded: false,
  updateCompanyUserFailed: false,
  updateCompanyUserErrors: null,

  updateUserLocaleRequest: false,
  updateUserLocaleSuccess: false,
  updateUserLocaleFailure: false,
  userCountryCode: null,

  loadingGroups: false,
  loadingGroupsFailed: false,
  loadingGroupsSucceeded: false
});

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(350);



/* harmony default export */ __webpack_exports__["a"] = ({
  requestWhatsappQRCode: function requestWhatsappQRCode(_ref, channelId) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* REQUEST_WHATSAPP_QRCODE_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('campaigns/channels/whatsapp/qrcode/' + channelId + '/').then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* REQUEST_WHATSAPP_QRCODE_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* REQUEST_WHATSAPP_QRCODE_FAILURE */], error);
    });
  },
  createWhatsappChannel: function createWhatsappChannel(_ref2, handle) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CREATE_WHATSAPP_CHANNEL_REQUEST */]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].post('campaigns/channels/whatsapp/channel/', { handle: handle }).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* CREATE_WHATSAPP_CHANNEL_SUCCESS */], response.data);
    }).catch(function (error) {
      return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CREATE_WHATSAPP_CHANNEL_FAILURE */], error);
    });
  },
  pollWhatsappStatus: function pollWhatsappStatus(_ref3, channelId) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* POLL_WHATSAPP_SET_CHANNEL */], channelId);
    var interval = setInterval(function () {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* colonyAPI */].get('campaigns/channels/whatsapp/status/' + channelId + '/').then(function (response) {
        if (response.data.is_connected && response.data.is_logged_in && response.data.is_scanned && !response.data.is_unauthorized) {
          commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* POLL_WHATSAPP_CHANNEL_SUCCESS */]);
          commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* POLL_WHATSAPP_CHANNEL_STOP */]);
        }
      }).catch(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CREATE_WHATSAPP_CHANNEL_FAILURE */]);
      });
    }, 2000);

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* POLL_WHATSAPP_CHANNEL_START */], interval);
  }
});

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(1289);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
});

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__ = __webpack_require__(350);


var _types$REQUEST_WHATSA;

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["a"] = (_types$REQUEST_WHATSA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["a" /* REQUEST_WHATSAPP_QRCODE_REQUEST */], function (state) {
  state.loadingWhatsappQRCodeRequest = true;
  state.whatsappQRCodeRequestFailed = false;
  state.whatsappQRCodeRequestSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["b" /* REQUEST_WHATSAPP_QRCODE_SUCCESS */], function (state, payload) {
  state.whatsappQRCode = payload.data;
  state.loadingWhatsappQRCodeRequest = false;
  state.whatsappQRCodeRequestFailed = false;
  state.whatsappQRCodeRequestSuccess = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["c" /* REQUEST_WHATSAPP_QRCODE_FAILURE */], function (state) {
  state.loadingWhatsappQRCodeRequest = false;
  state.whatsappQRCodeRequestFailed = false;
  state.whatsappQRCodeRequestSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["d" /* RESET_WHATSAPP_QRCODE */], function (state) {
  state.whatsappQRCode = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["e" /* RESET_WHATSAPP_CHANNEL_ID */], function (state) {
  state.whatsappChannelId = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["f" /* CREATE_WHATSAPP_CHANNEL_REQUEST */], function (state) {
  state.loadingWhatsappCreateChannel = true;
  state.whatsappChannelCreateSuccess = false;
  state.whatsappChannelCreateFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["g" /* CREATE_WHATSAPP_CHANNEL_SUCCESS */], function (state, payload) {
  state.whatsappChannelId = payload.id;
  state.whatsappChannelCreateSuccess = true;
  state.whatsappChannelCreateFailed = false;
  state.loadingWhatsappCreateChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["h" /* CREATE_WHATSAPP_CHANNEL_FAILURE */], function (state) {
  state.whatsappChannelCreateSuccess = false;
  state.whatsappChannelCreateFailed = true;
  state.loadingWhatsappCreateChannel = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["i" /* POLL_WHATSAPP_CHANNEL_START */], function (state, interval) {
  state.whatsappPollInterval = interval;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["j" /* POLL_WHATSAPP_CHANNEL_STOP */], function (state) {
  state.whatsappPollInterval = clearInterval(state.whatsappPollInterval);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["k" /* POLL_WHATSAPP_CHANNEL_SUCCESS */], function (state) {
  state.whatsappPollSuccess = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["l" /* POLL_WHATSAPP_CHANNEL_FAILURE */], function (state) {
  state.whatsappPollSuccess = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["m" /* POLL_WHATSAPP_CHANNEL_RESET */], function (state) {
  state.whatsappPollSuccess = null;
  state.whatsappPollInterval = null;
  state.whatsappPollChannelId = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$REQUEST_WHATSA, __WEBPACK_IMPORTED_MODULE_1__store_modules_whatsapp_mutation_types__["n" /* POLL_WHATSAPP_SET_CHANNEL */], function (state, channelId) {
  state.whatsappPollChannelId = channelId;
}), _types$REQUEST_WHATSA);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingWhatsappQRCodeRequest: false,
  whatsappQRCodeRequestFailed: false,
  whatsappQRCodeRequestSuccess: false,
  whatsappQRCode: null,
  whatsappQRCodeTimestamp: 0,

  loadingWhatsappCreateChannel: false,
  whatsappChannelCreateFailed: false,
  whatsappChannelCreateSuccess: false,
  whatsappChannelId: null,

  whatsappPollChannelId: null,
  whatsappPollInterval: null,
  whatsappPollSuccess: false
});

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElInputTag',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    addTagOnKeys: {
      type: Array,
      default: function _default() {
        return [13, 188, 9];
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    size: String
  },
  data: function data() {
    return {
      newTag: '',
      innerTags: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value))
    };
  },

  watch: {
    value: function value() {
      this.innerTags = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value));
    }
  },
  methods: {
    foucusTagInput: function foucusTagInput() {
      if (this.readOnly || !this.$el.querySelector('.tag-input')) {
        return;
      } else {
        this.$el.querySelector('.tag-input').focus();
      }
    },
    addNew: function addNew(e) {
      var _this = this;

      if (e && !this.addTagOnKeys.includes(e.keyCode) && e.type !== 'blur') {
        return;
      }
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      var addSuucess = false;
      if (this.newTag.includes(',')) {
        this.newTag.split(',').forEach(function (item) {
          if (_this.addTag(item.trim())) {
            addSuucess = true;
          }
        });
      } else {
        if (this.addTag(this.newTag.trim())) {
          addSuucess = true;
        }
      }
      if (addSuucess) {
        this.tagChange();
        this.newTag = '';
      }
    },
    addTag: function addTag(tag) {
      tag = tag.trim();
      if (tag && !this.innerTags.includes(tag)) {
        this.innerTags.push(tag);
        return true;
      }
      return false;
    },
    remove: function remove(index) {
      this.innerTags.splice(index, 1);
      this.tagChange();
    },
    removeLastTag: function removeLastTag() {
      if (this.newTag) {
        return;
      }
      this.innerTags.pop();
      this.tagChange();
    },
    tagChange: function tagChange() {
      this.$emit('input', this.innerTags);
    }
  }
});

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  created: function created() {
    if (localStorage.getItem('token')) {
      this.$store.dispatch('user/getMe');
    }
  }
});

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivitiesList',
  data: function data() {
    return {
      hoverDelete: false
    };
  },

  props: {
    activities: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    calculatePercentage: function calculatePercentage(activity) {
      if (!activity.max_pos || activity.max_pos === 0) return 100;
      return Math.floor(activity.cur_pos / activity.max_pos * 100);
    },
    getProgressStatus: function getProgressStatus(activity) {
      if (activity.error) return 'exception';
      return this.calculatePercentage(activity) === 100 ? 'success' : 'active';
    },
    formatRelativeTime: function formatRelativeTime(timestamp) {
      if (!timestamp) return 'Just now';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).fromNow();
    },
    removeActivity: function removeActivity(activity) {
      var _this = this;

      this.$confirm('This will permanently delete the activity. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        return _this.$emit('deleteActivity', activity.id);
      }).catch(function () {});
    },
    removeAllActivity: function removeAllActivity(activities) {
      var _this2 = this;

      this.$confirm('This will permanently delete all activities. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        activities.forEach(function (a) {
          return _this2.$emit('deleteActivity', a.id);
        });
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_countries_countryCodesMixin__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_common_countries_countryCodesMixin__["a" /* default */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_common_Loader___default.a,
    EmailIcon: __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default.a,
    FbIcon: __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a,
    InstagramIcon: __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default.a,
    SmsIcon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a,
    TwitterIcon: __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default.a,
    WhatsappIcon: __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default.a
  },
  data: function data() {
    return {
      searchTerm: '',
      filteredResults: [],
      selectedRange: '30 Days',
      selectedRegion: '',
      cellStyle: { background: 'none' }
    };
  },

  computed: {
    regions: function regions() {
      var _this = this;

      var regions = this.stationActivityData.results.map(function (station) {
        return station.region;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(regions))).sort().map(function (region) {
        return _this.getCountryByCode(region);
      }).filter(function (region) {
        return region !== undefined && region !== null;
      });
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    region: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    startDate: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
    },
    endDate: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
    },
    stationActivityData: {
      type: Object,
      default: function _default() {
        return {
          results: [],
          limit: 10
        };
      }
    },
    offset: {
      type: Object,
      default: function _default() {
        return {
          results: []
        };
      }
    }
  },
  methods: {
    getRegion: function getRegion() {
      return { region: this.selectedRegion };
    },
    getDateRange: function getDateRange() {
      var range = this.selectedRange.split(' ');
      var count = range[0];
      var unit = range[1];
      return {
        startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(count, unit),
        endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()()
      };
    },
    getPageChange: function getPageChange(page) {
      if (page > 1) {
        return page * 10 - 10;
      }
      return 0;
    },
    renderIcon: function renderIcon(h, _ref) {
      var column = _ref.column;

      var icon = this.getIcon(column.label);
      var tooltip = this.getIconTip(column.label);
      return h('el-tooltip', { attrs: { content: tooltip } }, [h(icon)]);
    },
    getIcon: function getIcon(name) {
      switch (name) {
        case 'F':
          return __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a;
        case 'T':
          return __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default.a;
        case 'I':
          return __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default.a;
        case 'W':
          return __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default.a;
        case 'TE':
          return __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon___default.a;
        case 'FM':
          return __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a;
        case 'SMS':
          return __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a;
        case 'E':
          return __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default.a;
        default:
          return __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a;
      }
    },
    getIconTip: function getIconTip(name) {
      switch (name) {
        case 'F':
          return 'Facebook Posts and Comments';
        case 'T':
          return 'Twitter';
        case 'I':
          return 'Instagram';
        case 'W':
          return 'WhatsApp';
        case 'TE':
          return 'Telegram';
        case 'FM':
          return 'Facebook Messages';
        case 'SMS':
          return 'SMS';
        case 'E':
          return 'Email';
        default:
          return '';
      }
    },
    formatDate: function formatDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('MM-DD-YY') : 'Date unavailable';
    },
    formatNumber: function formatNumber(num) {
      return new Intl.NumberFormat('en-US', { style: 'decimal', useGrouping: true }).format(num);
    }
  }
});

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Growth__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Growth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Growth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_AnalyticsUnitBlock__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_AnalyticsUnitBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_analytics_AnalyticsUnitBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsChart__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_analytics_charts_AnalyticsTimeSeriesAreaChart__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_analytics_charts_AnalyticsTimeSeriesAreaChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ContentLoaderPlaceholder__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ContentLoaderPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_ContentLoaderPlaceholder__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AfstereoDashboard',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_3__components_common_IBox___default.a,
    Growth: __WEBPACK_IMPORTED_MODULE_4__components_common_Growth___default.a,

    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_HorizontalBarChart___default.a,

    AnalyticsUnitBlock: __WEBPACK_IMPORTED_MODULE_6__components_analytics_AnalyticsUnitBlock___default.a,
    AnalyticsChart: __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsChart___default.a,
    AnalyticsTimeSeriesAreaChart: __WEBPACK_IMPORTED_MODULE_8__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default.a,
    ContentLoaderPlaceholder: __WEBPACK_IMPORTED_MODULE_9__components_common_ContentLoaderPlaceholder___default.a
  },
  data: function data() {
    return {
      units: ['minute', 'hour', 'day', 'month', 'year']
    };
  },
  props: {
    selectedStation: {
      type: Number,
      default: 0
    },
    selectedPeriod: {
      type: String,
      default: 'year'
    },
    selectedDate: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
    },
    stations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pluginEnabled: {
      type: Boolean,
      default: true
    },
    chartsData: {
      type: Object,
      default: function _default() {
        return {
          'hour-stats': { total: 0, growth: 0, points: [] },
          'day-stats': { total: 0, growth: 0, points: [] },
          'month-stats': { total: 0, growth: 0, points: [] },
          'year-stats': { total: 0, growth: 0, points: [] },
          advertisers: { top: [] },
          artists: { top: [] },
          categories: { top: [] },
          countries: { top: [] },
          decades: { top: [] },
          genres: { top: [] },
          tracks: { top: [] },
          stations: { top: [], area: [] },
          local_vs_international: { points: [{ local: 0, international: 0 }] },
          sold_out: {
            hours: {
              '00:00': 0,
              '01:00': 0,
              '02:00': 0,
              '03:00': 0,
              '04:00': 0,
              '05:00': 0,
              '06:00': 0,
              '07:00': 0,
              '08:00': 0,
              '09:00': 0,
              '10:00': 0,
              '11:00': 0,
              '12:00': 0,
              '13:00': 0,
              '14:00': 0,
              '15:00': 0,
              '16:00': 0,
              '17:00': 0,
              '18:00': 0,
              '19:00': 0,
              '20:00': 0,
              '21:00': 0,
              '22:00': 0,
              '23:00': 0
            }
          }
        };
      }
    }
  },
  computed: {
    currentStation: {
      get: function get() {
        return this.selectedStation;
      },
      set: function set(station) {
        this.$emit('changeStation', { station: station });
      }
    },

    // TODO: REFACTOR
    processAdvertisers: function processAdvertisers() {
      var maxCount = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.chartsData.advertisers.top.map(function (s) {
        return s.count;
      })));
      var maxRevenue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.chartsData.advertisers.top.map(function (s) {
        return s.revenue;
      })));

      return this.chartsData.advertisers.top.map(function (s) {
        return [s.advertiser, {
          Spots: Math.round(s.count / maxCount * 100),
          Revenue: Math.round(s.revenue / maxRevenue * 100)
        }];
      });
    },


    // TODO: REFACTOR
    processCategories: function processCategories() {
      var maxCount = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.chartsData.categories.top.map(function (s) {
        return s.count;
      })));
      var maxRevenue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.chartsData.categories.top.map(function (s) {
        return s.revenue;
      })));

      return this.chartsData.categories.top.map(function (s) {
        return [s.category, {
          Spots: Math.round(s.count / maxCount * 100),
          Revenue: Math.round(s.revenue / maxRevenue * 100)
        }];
      });
    },
    processLocalVsInternational: function processLocalVsInternational() {
      var points = this.chartsData.local_vs_international.points.length ? this.chartsData.local_vs_international.points[0] : { local: 0, international: 0 };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(points).map(function (key) {
        return [key, points[key]];
      });
    },
    processEngagementsVsRevenue: function processEngagementsVsRevenue() {
      var aliases = {
        revenue: 'Revenue %',
        uniques: 'Engagement %'
      };
      var stats = this.chartsData.stations.area.map(function (s) {
        var stat = s;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(aliases).indexOf(stat[0]) !== -1) {
          stat[0] = aliases[stat[0]];
        }

        return stat;
      });

      return stats;
    },
    processSoldOut: function processSoldOut() {
      var hours = this.chartsData.sold_out.hours;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(hours).map(function (key) {
        return [key, hours[key]];
      });
    },
    isSoldOutAveraging: function isSoldOutAveraging() {
      if (['week', 'month', 'year'].indexOf(this.selectedPeriod) !== -1) {
        return true;
      }
      return false;
    }
  },
  methods: {
    promptMailToSale: function promptMailToSale() {
      window.open('mailto:robby@colonyhq.com?subject=Colony%20Live%20Afstereo%20Plugin%20Request');
    }
  }
});

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetrend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsUnitBlock',
  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_0_vuetrend__["a" /* default */],
    IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a
  },
  props: {
    unit: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    received: {
      type: Number,
      default: 0
    },
    growth: {
      type: Number,
      default: 0
    },
    stats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    period: {
      type: String,
      required: true
    },
    unitClass: {
      type: String,
      default: 'label-success'
    },
    selected: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    processStats: function processStats() {
      // Always start at 0, and create a clean array of totals
      return [0].concat(this.stats.map(function (stat) {
        return stat.total;
      }));
    }
  },
  methods: {
    onClickPrevious: function onClickPrevious() {
      this.$emit('previous');
    },
    onClickNext: function onClickNext() {
      this.$emit('next');
    }
  }
});

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_charts_DoughnutChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudienceDashboard',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart___default.a,
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_3__components_charts_DoughnutChart___default.a
  },
  computed: {
    processGenderStats: function processGenderStats() {
      return [['male', 41], ['female', 59]];
    },
    processGenderProvinceStats: function processGenderProvinceStats() {
      return [['Eastern Cape', { male: 30, female: 40 }], ['Free State', { male: 15, female: 20 }], ['Gauteng', { male: 90, female: 95 }], ['KwaZulu-Natal', { male: 70, female: 65 }], ['Limpopo', { male: 10, female: 10 }], ['Mpumalanga', { male: 5, female: 6 }], ['North West', { male: 6, female: 7 }], ['Northern Cape', { male: 12, female: 19 }], ['Western Cape', { male: 20, female: 25 }]];
    },
    processGenderPopulationGroupStats: function processGenderPopulationGroupStats() {
      return [['Asian', { male: 10, female: 12 }], ['Black', { male: 30, female: 45 }], ['Coloured', { male: 15, female: 14 }], ['White', { male: 50, female: 60 }]];
    },
    processProvinceStats: function processProvinceStats() {
      return [['Western Cape', 600], ['Northern Cape', 50], ['North West', 150], ['Mpumalanga', 170], ['Limpopo', 70], ['KwaZulu-Natal', 200], ['Gauteng', 1200], ['Free State', 100], ['Eastern Cape', 180]];
    },
    processProvincePopulationGroupStats: function processProvincePopulationGroupStats() {
      return [['Asian', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['Black', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['Coloured', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['White', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }]];
    },
    processProvinceAgeStats: function processProvinceAgeStats() {
      return [['18-25', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['26-32', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['33-45', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['46-55', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['56-65', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['66-74', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }], ['75-150', {
        'Eastern Cape': this.rnd(),
        'Free State': this.rnd(),
        Gauteng: this.rnd(),
        'KwaZulu-Natal': this.rnd(),
        Limpopo: this.rnd(),
        Mpumalanga: this.rnd(),
        'North West': this.rnd(),
        'Northern Cape': this.rnd(),
        'Western Cape': this.rnd()
      }]];
    },
    processPopulationGroupStats: function processPopulationGroupStats() {
      return [['Asian', this.rnd()], ['Black', this.rnd()], ['Coloured', this.rnd()], ['White', this.rnd()]];
    },
    processPopulationGroupAgeStats: function processPopulationGroupAgeStats() {
      return [['18-25', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['26-32', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['33-45', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['46-55', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['56-65', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['66-74', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['75-150', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }]];
    },
    processPopulationGroupLsmStats: function processPopulationGroupLsmStats() {
      return [['poor', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['low', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['low mid', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['mid', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['up mid', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }], ['top', {
        Asian: this.rnd(),
        Black: this.rnd(),
        Coloured: this.rnd(),
        White: this.rnd()
      }]];
    },
    processAgeStats: function processAgeStats() {
      return [['18-25', 10], ['26-32', 50], ['33-45', 30], ['46-55', 20], ['56-65', 10], ['66-74', 5], ['75-150', 1]];
    },
    processAgeLsmStats: function processAgeLsmStats() {
      return [['poor', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['low', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['low mid', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['mid', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['up mid', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['top', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }]];
    },
    processAgeGenderStats: function processAgeGenderStats() {
      return [['Male', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }], ['Female', {
        '18-25': this.rnd(),
        '26-32': this.rnd(),
        '33-45': this.rnd(),
        '46-55': this.rnd(),
        '56-65': this.rnd(),
        '66-74': this.rnd(),
        '75-150': this.rnd()
      }]];
    },
    processLsmStats: function processLsmStats() {
      return [['poor', this.rnd()], ['low', this.rnd()], ['low mid', this.rnd()], ['mid', this.rnd()], ['up mid', this.rnd()], ['top', this.rnd()]];
    },
    processLsmGender: function processLsmGender() {
      return [['male', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd() }], ['female', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd() }]];
    },
    processLsmProvince: function processLsmProvince() {
      return [['Eastern Cape', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Free State', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Gauteng', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['KwaZulu-Natal', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Limpopo', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Mpumalanga', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['North West', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Northern Cape', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }], ['Western Cape', {
        poor: this.rnd(),
        low: this.rnd(),
        'low mid': this.rnd(),
        mid: this.rnd(),
        'up mid': this.rnd(),
        top: this.rnd()
      }]];
    }
  },
  methods: {
    rnd: function rnd() {
      return Math.floor(Math.random() * 100) + 1;
    }
  }
});

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_analytics_AnalyticsUnitBlock__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_analytics_AnalyticsUnitBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_analytics_AnalyticsUnitBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics_charts_AnalyticsChart__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics_charts_AnalyticsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_analytics_charts_AnalyticsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsHeatMap__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsHeatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsHeatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsTimeSeriesAreaChart__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsTimeSeriesAreaChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_ContentLoaderPlaceholder__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_ContentLoaderPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_ContentLoaderPlaceholder__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EngagementsDashboard',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default.a,

    AnalyticsUnitBlock: __WEBPACK_IMPORTED_MODULE_3__components_analytics_AnalyticsUnitBlock___default.a,
    AnalyticsChart: __WEBPACK_IMPORTED_MODULE_4__components_analytics_charts_AnalyticsChart___default.a,
    AnalyticsHeatMap: __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsHeatMap___default.a,
    AnalyticsTimeSeriesAreaChart: __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default.a,
    ContentLoaderPlaceholder: __WEBPACK_IMPORTED_MODULE_7__components_common_ContentLoaderPlaceholder___default.a
  },
  data: function data() {
    return {
      units: ['minute', 'hour', 'day', 'month', 'year']
    };
  },
  props: {
    selectedDate: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      },
      required: true
    },
    selectedPeriod: {
      type: String,
      default: 'year',
      required: true
    },
    selectedFilter: {
      type: String,
      default: 'campaign',
      required: true
    },
    chartsData: {
      type: Object,
      default: function _default() {
        return {
          'hour-stats': { total: 0, growth: 0, points: [] },
          'day-stats': { total: 0, growth: 0, points: [] },
          'month-stats': { total: 0, growth: 0, points: [] },
          'year-stats': { total: 0, growth: 0, points: [] },
          'unique-stats': { 'total-vs-unique': [] },
          'campaign-stats': { points: [[]] },
          'channel-type-stats': { points: [] },
          'heat-map-stats': { points: {}, range: [] }
        };
      },
      required: true
    },
    mainChartData: {
      type: Object,
      default: function _default() {
        return {
          stats: { points: [] }
        };
      },
      required: true
    }
  },
  computed: {
    processChannelStats: function processChannelStats() {
      if (!this.chartsData['channel-type-stats'].points.length) {
        return [];
      }
      var points = this.chartsData['channel-type-stats'].points[0];
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(points).map(function (key) {
        return [key, points[key]];
      });
    }
  }
});

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics_AnalyticsUnitBlock__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_analytics_AnalyticsUnitBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_analytics_AnalyticsUnitBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsChart__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsHeatMap__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsHeatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsHeatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsTimeSeriesAreaChart__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsTimeSeriesAreaChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_accounting__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuewordcloud__ = __webpack_require__(3435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuewordcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuewordcloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_random__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Growth__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Growth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_Growth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_BlurredImagePlaceHolder__ = __webpack_require__(2921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_BlurredImagePlaceHolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_common_BlurredImagePlaceHolder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_DoughnutChartPlaceholder__ = __webpack_require__(2923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_DoughnutChartPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_common_DoughnutChartPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_ContentLoaderPlaceholder__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_ContentLoaderPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_common_ContentLoaderPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__programmingDashboard_ProgrammingDashboardUnit__ = __webpack_require__(2866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__programmingDashboard_ProgrammingDashboardUnit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__programmingDashboard_ProgrammingDashboardUnit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__programmingDashboard_AudienceProfileTable__ = __webpack_require__(2863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__programmingDashboard_AudienceProfileTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__programmingDashboard_AudienceProfileTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__programmingDashboard_ContentThreadsTable__ = __webpack_require__(2864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__programmingDashboard_ContentThreadsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__programmingDashboard_ContentThreadsTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__programmingDashboard_PromotionsTable__ = __webpack_require__(2867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__programmingDashboard_PromotionsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__programmingDashboard_PromotionsTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__programmingDashboard_StreamingOverviewTable__ = __webpack_require__(2870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__programmingDashboard_StreamingOverviewTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__programmingDashboard_StreamingOverviewTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__programmingDashboard_PlayoutLoad__ = __webpack_require__(2865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__programmingDashboard_PlayoutLoad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__programmingDashboard_PlayoutLoad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__programmingDashboard_StreamingLoad__ = __webpack_require__(2868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__programmingDashboard_StreamingLoad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__programmingDashboard_StreamingLoad__);




var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



































var formatNumber = function formatNumber(x) {
  return __WEBPACK_IMPORTED_MODULE_9_accounting___default.a.formatNumber(x, 0, ' ');
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgrammingDashboard',

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_colors__["a" /* default */]],

  props: {
    selectedEngagementsFilter: {
      type: String,
      default: 'campaign',
      required: true
    },
    chartsData: {
      type: Object,
      default: function _default() {
        return {
          'hour-stats': { total: 0, growth: 0, points: [] },
          'day-stats': { total: 0, growth: 0, points: [] },
          'week-stats': { total: 0, growth: 0, points: [] },
          'month-stats': { total: 0, growth: 0, points: [] },
          'year-stats': { total: 0, growth: 0, points: [] },
          'unique-stats': { 'total-vs-unique': [] },
          'campaign-stats': { points: [[]] },
          'channel-type-stats': { points: [] },
          'heat-map-stats': { points: {}, range: [] }
        };
      },
      required: true
    },
    mainChartData: {
      type: Object,
      default: function _default() {
        return {
          stats: { points: [] }
        };
      },
      required: true
    },

    stationName: {
      type: String,
      default: ''
    },

    timeslots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    timeslot: {
      type: Number,
      default: null
    },

    date: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_8_moment___default()();
      },
      required: true
    },

    period: {
      type: String,
      default: 'month'
    },

    activeRange: {
      type: Object,
      default: null
    },

    streamingData: {
      type: Object,
      default: function _default() {
        return {
          streaming: {
            averageListeners: [],
            averageListenersTrimester: []
          }
        };
      }
    },

    messagesData: {
      type: Object,
      default: function _default() {
        return {
          chartData: []
        };
      }
    },

    stations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    selectedStation: {
      type: Number,
      default: null
    },
    isStreaming: {
      type: Boolean,
      default: false
    },

    /**
     * Expected Data:
     * {
     *  age: [{ title: '13-18', show: '25%', profile: '19%'}],
     *  gender: [{ title: 'Male', show: '42%', profile: '48%' }],
     * }
     */
    audienceProfileData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    contentThreadsData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    promotionsData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    commercialLoadData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    musicalLoadData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    topTracksData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    filtersLoading: {
      type: Boolean,
      default: true
    },

    dataLoading: {
      type: Boolean,
      default: false
    },
    loadingStreamingData: {
      type: Boolean,
      default: false
    },
    loadingPlugins: {
      type: Boolean,
      default: true
    },
    afstereoDataNotFound: {
      type: Boolean
    },
    loadingMessage: {
      type: String,
      default: 'loading'
    },

    afstereoPluginEnabled: {
      type: Boolean,
      default: true
    },
    loadingAudienceData: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      accounting: __WEBPACK_IMPORTED_MODULE_9_accounting___default.a,
      formatNumber: formatNumber,
      selectedFilter: 'Station',
      promotionsDialogVisible: false,
      messagesDialogVisible: false,
      streamingPeriodLabel: 'Full week average',
      isTrimesterComplete: false,
      selectedComparedStation: 'Select a station to compare',
      units: ['minute', 'hour', 'day', 'week', 'month', 'year'],
      streamingFilter: 'week',
      showNoContent: true,
      promotionBarChartHeight: 100,
      demographicTitles: {
        gender: 'Gender',
        birth_date: 'Age',
        ethnicity: 'Race'
      }

    };
  },
  computed: {
    sortMessagesChartData: function sortMessagesChartData() {
      return this.messagesData.chartData.sort(function (a, b) {
        return b[1].unique - a[1].unique;
      });
    },
    processChannelStats: function processChannelStats() {
      if (!this.chartsData['channel-type-stats'].points.length) {
        return [];
      }
      var points = this.chartsData['channel-type-stats'].points[0];
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(points).map(function (key) {
        return [key, points[key]];
      });
    },
    contentThreads: function contentThreads() {
      return this.contentThreadsData.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, x, { impactors: formatNumber(x.weight) });
      });
    },
    trendingTopics: function trendingTopics() {
      return this.contentThreads.map(function (x) {
        return [x.name, x.weight];
      });
    },


    selectedProgrammingDate: {
      get: function get() {
        return this.date;
      },
      set: function set(value) {
        this.$emit('onDateChange', value);
      }
    },

    prepareStreamingGraphData: function prepareStreamingGraphData() {
      var data = this.streamingData.streaming;
      this.isTrimesterComplete = data.isTrimesterComplete;
      return [data.averageListeners, data.averageListenersTrimester];
    },


    selectedProgrammingPeriod: {
      get: function get() {
        return this.period;
      },
      set: function set(value) {
        this.$emit('onPeriodChange', value);
      }
    },

    selectedTimeslot: {
      get: function get() {
        return this.timeslot;
      },
      set: function set(value) {
        this.$emit('onTimeslotChange', value);
      }
    },

    currentStation: {
      get: function get() {
        return this.selectedStation;
      },
      set: function set(value) {
        this.$emit('onStationChange', value);
        var isSameStationId = function isSameStationId(station) {
          return station.id === value;
        };
        var getStationTitle = function getStationTitle(arr) {
          return arr ? arr.filter(isSameStationId)[0].title : '';
        };
        this.selectedComparedStation = getStationTitle(this.stations);
      }
    },

    currentFilter: {
      get: function get() {
        return this.selectedFilter;
      },
      set: function set(value) {
        if (value === 'Station') {
          this.selectedFilter = 'Station';
          this.$emit('onTimeslotChange', 0);
        } else {
          this.selectedFilter = 'Show';
          this.$emit('onTimeslotChange', this.selectedTimeslot);
        }
      }
    },
    getTimeslotLabel: function getTimeslotLabel() {
      var _this = this;

      var period = 'FILTERED FOR: ' + this.selectedProgrammingPeriod.toUpperCase();
      if (this.timeslot === 0) {
        return period;
      }
      var showTitle = this.timeslots.filter(function (show) {
        return show.id === _this.timeslot;
      })[0].title;
      return period + ' - ' + showTitle.toUpperCase();
    },
    getStreamingOverviewPeriod: function getStreamingOverviewPeriod() {
      var selectedDate = this.selectedProgrammingDate;
      var formatedDate = '';
      switch (this.period) {
        case 'day':
          formatedDate = selectedDate.format('dddd Do');
          break;
        case 'week':
          formatedDate = selectedDate.format('YYYY [Week] WW');
          break;
        case 'month':
          formatedDate = selectedDate.format('MMMM');
          break;
        case 'year':
          formatedDate = selectedDate.format('YYYY');
          break;
        default:
          formatedDate = 'period not found';
      }
      return formatedDate;
    }
  },

  methods: {
    showAudienceChartData: function showAudienceChartData(key, data) {
      var _this2 = this;

      var dummyData = [];
      try {
        var audienceData = this.audienceProfileData[key][data];
        var chartData = audienceData.length ? audienceData.map(function (p) {
          return _this2.extractProfileKeyValues(p);
        }) : dummyData;
        return chartData;
      } catch (error) {
        return dummyData;
      }
    },
    extractProfileKeyValues: function extractProfileKeyValues(data) {
      var hasData = data.show > 0;
      return hasData ? [data.title, data.show] : [];
    },
    trendingWordsRotation: function trendingWordsRotation() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_random__["b" /* pickOne */])([0, 1 / 4]);
    },
    trendingWordColor: function trendingWordColor(item) {
      return this.generateTitleColor(item[0]);
    },
    promotionsUnitRightIconClick: function promotionsUnitRightIconClick() {
      this.promotionsDialogVisible = !this.promotionsDialogVisible;
    },
    messagesUnitRightIconClick: function messagesUnitRightIconClick() {
      this.messagesDialogVisible = !this.messagesDialogVisible;
    },
    getCorrectDate: function getCorrectDate(date) {
      var toMoment = __WEBPACK_IMPORTED_MODULE_8_moment___default()(__WEBPACK_IMPORTED_MODULE_8_moment___default()(date));
      return toMoment.add(1, 'd').format('YYYY-MM-DD');
    },
    changePeriod: function changePeriod(period) {
      this.$emit('onPeriodChange', period);
    },
    onChangeStreamingFilter: function onChangeStreamingFilter(tab) {
      this.streamingPeriodLabel = tab.label + ' average';
      this.$emit('onStreamingPeriodChange', tab.name);
    },
    getPromotionLabel: function getPromotionLabel(label) {
      // We spliting long promotional labels After every third space
      // (promoLabel) Vuejs charts takes each index in the array as a new line
      var unSplitPromLabel = label.trim();
      if (unSplitPromLabel.length > 22) {
        return this.spliter(unSplitPromLabel, 3);
      }
      return [unSplitPromLabel];
    },
    handleNoContent: function handleNoContent(value) {
      this.showNoContent = value;
    },
    spliter: function spliter(promo, spaces) {
      var n = spaces;
      var splitPromoLabel = [];
      var splitLabel = promo.split(' ');
      for (var i = 0; i < splitLabel.length - 1; i += spaces) {
        splitPromoLabel.push(splitLabel.slice(i, n).join(' '));
        n += spaces;
      }
      return splitPromoLabel;
    }
  },

  watch: {
    activeRange: function activeRange() {
      if (this.period === 'week') {
        this.activeRange.start = this.getCorrectDate(this.activeRange.start);
        this.activeRange.end = this.getCorrectDate(this.activeRange.end);
      }
    },
    promotionsData: function promotionsData() {
      var labelHeight = 100;
      this.promotionBarChartHeight = this.promotionsData.length * labelHeight;
    }
  },

  components: (_components = {
    Loader: __WEBPACK_IMPORTED_MODULE_17__components_common_Loader___default.a,
    BlurredImagePlaceHolder: __WEBPACK_IMPORTED_MODULE_18__components_common_BlurredImagePlaceHolder___default.a,
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_19__components_common_ContentPlaceholder___default.a,
    Growth: __WEBPACK_IMPORTED_MODULE_13__components_common_Growth___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_14__components_charts_BarChart___default.a,
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_15__components_charts_DoughnutChart___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_16__components_charts_HorizontalBarChart___default.a,
    ProgrammingDashboardUnit: __WEBPACK_IMPORTED_MODULE_22__programmingDashboard_ProgrammingDashboardUnit___default.a,
    ContentLoaderPlaceholder: __WEBPACK_IMPORTED_MODULE_21__components_common_ContentLoaderPlaceholder___default.a,
    DoughnutChartPlaceholder: __WEBPACK_IMPORTED_MODULE_20__components_common_DoughnutChartPlaceholder___default.a,
    AudienceProfileTable: __WEBPACK_IMPORTED_MODULE_23__programmingDashboard_AudienceProfileTable___default.a,
    ContentThreadsTable: __WEBPACK_IMPORTED_MODULE_24__programmingDashboard_ContentThreadsTable___default.a,
    PromotionsTable: __WEBPACK_IMPORTED_MODULE_25__programmingDashboard_PromotionsTable___default.a,
    StreamingOverviewTable: __WEBPACK_IMPORTED_MODULE_26__programmingDashboard_StreamingOverviewTable___default.a,
    PlayoutLoad: __WEBPACK_IMPORTED_MODULE_27__programmingDashboard_PlayoutLoad___default.a,
    StreamingLoad: __WEBPACK_IMPORTED_MODULE_28__programmingDashboard_StreamingLoad___default.a
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_vuewordcloud___default.a.name, __WEBPACK_IMPORTED_MODULE_10_vuewordcloud___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'IBox', __WEBPACK_IMPORTED_MODULE_3__components_common_IBox___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'AnalyticsUnitBlock', __WEBPACK_IMPORTED_MODULE_4__components_analytics_AnalyticsUnitBlock___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'AnalyticsChart', __WEBPACK_IMPORTED_MODULE_5__components_analytics_charts_AnalyticsChart___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'AnalyticsHeatMap', __WEBPACK_IMPORTED_MODULE_6__components_analytics_charts_AnalyticsHeatMap___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'AnalyticsTimeSeriesAreaChart', __WEBPACK_IMPORTED_MODULE_7__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default.a), _components)
});

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_charts__ = __webpack_require__(190);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_1__mixins_charts__["a" /* default */].plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_charts__ = __webpack_require__(190);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_1__mixins_charts__["a" /* default */].plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsAreaChart__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AnalyticsAreaChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsBarChart__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AnalyticsBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyticsDoughnutChart__ = __webpack_require__(2860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyticsDoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AnalyticsDoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnalyticsPieChart__ = __webpack_require__(2861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnalyticsPieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AnalyticsPieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnalyticsPolarAreaChart__ = __webpack_require__(2862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnalyticsPolarAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AnalyticsPolarAreaChart__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colors__["a" /* default */]],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: 'bar'
    },
    chartStyle: {
      type: String,
      default: ''
    },
    showTooltips: {
      type: Boolean,
      default: true
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    legendPosition: {
      type: String,
      default: 'top'
    },
    scalesEnabled: {
      type: Boolean,
      default: true
    },
    barPercentage: {
      type: Number,
      default: 1
    },
    categoryPercentage: {
      type: Number,
      default: 0.7
    }
  },
  components: {
    AnalyticsAreaChart: __WEBPACK_IMPORTED_MODULE_2__AnalyticsAreaChart___default.a,
    AnalyticsBarChart: __WEBPACK_IMPORTED_MODULE_3__AnalyticsBarChart___default.a,
    AnalyticsDoughnutChart: __WEBPACK_IMPORTED_MODULE_4__AnalyticsDoughnutChart___default.a,
    AnalyticsPieChart: __WEBPACK_IMPORTED_MODULE_5__AnalyticsPieChart___default.a,
    AnalyticsPolarAreaChart: __WEBPACK_IMPORTED_MODULE_6__AnalyticsPolarAreaChart___default.a
  },
  computed: {
    getChartData: function getChartData() {
      var _this = this;

      var chartDatasets = [{
        backgroundColor: this.data.map(function (s) {
          return _this.generateTitleColor(s[0]);
        }),
        data: this.data.map(function (s) {
          return s[1];
        })
      }];

      // Determine if we're using multiple datasets
      // allows us to send in data as:
      // [
      //   ['SABC', {'revenue': 12233, 'count': 1222}],
      //   ['FirstRand Bank Ltd', {'revenue': 45433, 'count': 4552}]
      // ]
      if (this.data.length && this.data[0][1] instanceof Object) {
        // Get our data split into different sets based on their keys
        var sets = {};
        this.data.forEach(function (data) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[1]).forEach(function (key) {
            if (!(key in sets)) {
              sets[key] = [];
            }
            sets[key].push(data[1][key]);
          });
        });

        // Now build the actual chart data
        chartDatasets = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sets).map(function (key) {
          return {
            label: key,
            backgroundColor: _this.generateRGBAColor(key, 0.5),
            borderColor: _this.generateRGBAColor(key, 1),
            pointBackgroundColor: _this.generateRGBAColor(key, 1),
            pointBorderColor: '#fff',
            data: sets[key]
          };
        });
      }

      var chartData = {
        labels: this.data.map(function (s) {
          return s[0];
        }),
        datasets: chartDatasets
      };

      return chartData;
    },
    getChartOptions: function getChartOptions() {
      var options = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: this.showTooltips
        },
        legend: {
          display: this.showLegend,
          position: this.legendPosition
        }
      };

      if (!this.scalesEnabled) {
        options.scales = {
          xAxes: [{
            display: false,
            barPercentage: this.barPercentage,
            categoryPercentage: this.categoryPercentage
          }],
          yAxes: [{
            display: false
          }]
        };
      }

      return options;
    }
  }
});

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_charts__ = __webpack_require__(190);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Doughnut"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_1__mixins_charts__["a" /* default */].plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cal_heatmap__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cal_heatmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cal_heatmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_colorConstants_live__ = __webpack_require__(339);


//
//
//
//
//
//



 // eslint-disable-line

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsHeatMap',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    range: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof this.heatMapCal !== 'undefined') {
      this.heatMapCal.destroy();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('analytics', ['selectedDate', 'selectedPeriod'])),
  watch: {
    data: function data() {
      this.generateHeatMap();
    }
  },
  methods: {
    generateHeatMap: function generateHeatMap() {
      var _this = this;

      if (this.heatMapCal) {
        this.heatMapCal.destroy();
      }

      var domainOptions = {
        year: {
          subDomain: 'x_month',
          rowLimit: 4,
          cellSize: 50,
          nextUnit: 'month'
        },
        month: { subDomain: 'x_day', nextUnit: 'day', cellSize: 30 },
        day: { subDomain: 'x_hour', cellSize: 35, nextUnit: 'hour' },
        hour: {
          subDomain: 'x_min',
          cellSize: 22,
          domainMargin: 5,
          nextUnit: 'hour'
        }
      };

      if (this.selectedPeriodselectedPeriod === 'week') domainOptions.month.nextUnit = 'day';

      var cleanData = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data).forEach(function (key) {
        cleanData[key] = _this.data[key];
      });

      var options = {
        data: cleanData,
        legend: this.range,
        domain: this.selectedPeriod,
        start: this.selectedDate.toDate(),
        cellSize: 17,
        cellRadius: 0,
        cellPadding: 1,
        range: 1,
        domainDynamicDimension: false,
        animationDuration: 0,
        legendColors: __WEBPACK_IMPORTED_MODULE_4__mixins_colorConstants_live__["f" /* heatmapLegendColors */],
        displayLegend: false,
        domainLabelFormat: '',
        onClick: function onClick(date) {
          var nextPeriod = domainOptions[_this.selectedPeriod].nextUnit;
          _this.$emit('onChangeDate', { date: date, period: nextPeriod });
        },
        afterLoadData: function afterLoadData(timestamps) {
          var offset = new Date().getTimezoneOffset() * 60;
          var results = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(timestamps).forEach(function (timestamp) {
            var total = timestamps[timestamp];
            results[parseInt(timestamp, 10) + offset] = total;
          });
          return results;
        }
      };

      // Assign domain / period specific options
      var unit = this.selectedPeriod;
      var selectedDomainOptions = domainOptions[unit];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selectedDomainOptions).forEach(function (key) {
        options[key] = selectedDomainOptions[key];
      });

      this.heatMapCal = new __WEBPACK_IMPORTED_MODULE_3_cal_heatmap___default.a();
      this.heatMapCal.init(options);
    }
  }
});

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_charts__ = __webpack_require__(190);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_1__mixins_charts__["a" /* default */].plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_charts__ = __webpack_require__(190);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["PolarArea"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    this.addPlugin(__WEBPACK_IMPORTED_MODULE_1__mixins_charts__["a" /* default */].plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsAreaChart__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AnalyticsAreaChart__);

//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsTimeSeriesAreaChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colors__["a" /* default */]],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tension: {
      type: Number,
      default: 0.1
    },
    timeFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    legendPosition: {
      type: String,
      default: 'bottom'
    },
    borderWidth: {
      type: Number,
      default: 1
    },
    unit: {
      type: String,
      required: true
    }
  },
  components: {
    AnalyticsAreaChart: __WEBPACK_IMPORTED_MODULE_3__AnalyticsAreaChart___default.a
  },
  computed: {
    getDateFormat: function getDateFormat() {
      if (this.unit === 'hour') {
        return 'HH:MM';
      }

      return 'YYYY-MM-DD';
    },
    getChartData: function getChartData() {
      var _this = this;

      if (!this.data.length) {
        return {};
      }

      var sets = {};
      this.data.slice(1).forEach(function (data) {
        var key = data[0];
        sets[key] = data.slice(1);
      });

      var formattedDateLabels = this.data[0].map(function (dateItem) {
        if (!dateItem.includes('x')) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateItem).format(_this.getDateFormat);
        }
        return '0';
      });
      var chartData = {
        labels: formattedDateLabels.filter(function (dateItem) {
          return dateItem !== '0';
        }),
        datasets: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sets).map(function (key) {
          return {
            label: key,
            backgroundColor: _this.generateRGBAColor(key, 0.5),
            borderColor: _this.generateRGBAColor(key, 1),
            pointBackgroundColor: _this.generateRGBAColor(key, 1),
            pointBorderColor: '#fff',
            borderWidth: _this.borderWidth,
            data: sets[key]
          };
        })
      };
      return chartData;
    },
    getChartOptions: function getChartOptions() {
      var options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition
        },
        elements: {
          line: {
            tension: this.tension
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              format: this.getDateFormat,
              unit: this.unit
            }
          }]
        }
      };

      return options;
    }
  }
});

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudienceProfileTable',
  props: {
    name: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  }
});

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colors__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentThreadsTable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colors__["a" /* default */]],

  props: {
    data: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      required: false
    }
  },

  computed: {
    contentThreads: function contentThreads() {
      return this.limit ? this.data.slice(0, this.limit) : this.data;
    }
  }
});

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_LineChart__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_LineChart__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PlayoutLoad',

  props: {
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: '1'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    showGridLines: {
      type: Boolean,
      default: false
    },
    station: {
      type: String,
      default: 'undefined'
    },
    comparedStaton: {
      type: String,
      default: 'undefined'
    },
    yAxeslabelString: {
      type: String,
      default: ''
    },
    xAxeslabelString: {
      type: String,
      default: ''
    }
  },

  computed: {
    labels: function labels() {
      return [this.station, this.comparedStaton];
    },
    average: function average() {
      if (!this.data.length) return null;
      var total = this.data.reduce(function (a, x) {
        return a + x.value;
      }, 0);
      var hours = this.data.reduce(function (a, x) {
        return a + x.hours;
      }, 0);
      return total / hours;
    },
    max: function max() {
      if (!this.data.length) return null;
      var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.data.map(function (x) {
        return x.value;
      })));
      return this.data.find(function (x) {
        return x.value === max;
      });
    },
    trendData: function trendData() {
      return this.data.map(function (x) {
        return x.map(function (y) {
          return [y.date, y.value];
        });
      });
    }
  },

  components: { LineChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_LineChart___default.a }
});

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgrammingDashboardUnit',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a
  },
  props: {
    title: {
      type: String,
      required: true
    },

    titleIconClass: {
      type: String,
      default: ''
    },

    height: {
      type: String,
      default: null
    },

    titleRightIcon: {
      type: Object,
      default: function _default() {
        return { tooltip: '', icon: '' };
      }
    }
  },
  methods: {
    rightIconClick: function rightIconClick() {
      this.$emit('unitRightIconClick');
    }
  }
});

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_accounting__);

//
//
//
//
//
//
//
//
//
//



var formatNumber = function formatNumber(x) {
  return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatNumber(x, 0, ' ');
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PromotionsTable',

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  computed: {
    promotionData: function promotionData() {
      return this.data.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
          entries: formatNumber(x.entries),
          uniques: formatNumber(x.uniques)
        });
      });
    }
  }
});

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_LineChart__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_charts_LineChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StreamingLoad',

  props: {
    data: {
      type: Array,
      default: []
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    isTrimesterComplete: {
      type: Boolean,
      default: false
    },
    showGridLines: {
      type: Boolean,
      default: true
    },
    periodLabel: {
      type: String,
      default: 'Full week average'
    },
    avg3monthsLabel: {
      type: String,
      default: '3 month average'
    },
    incomAvg3monthsLabel: {
      type: String,
      default: '3 months data not yet available'
    }
  },

  computed: {
    labels: function labels() {
      if (this.isTrimesterComplete) {
        return [this.periodLabel, this.avg3monthsLabel];
      }
      return [this.periodLabel, this.incomAvg3monthsLabel];
    },
    trendData: function trendData() {
      var _this = this;

      return this.data.map(function (x) {
        return x.map(function (y) {
          return [y.hour + ':' + y.interval, _this.getlisteners(y.value)];
        });
      });
    }
  },

  methods: {
    getlisteners: function getlisteners(listeners) {
      return listeners !== null ? listeners.toFixed() : 0;
    }
  },

  components: { LineChart: __WEBPACK_IMPORTED_MODULE_0__components_charts_LineChart___default.a }
});

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StreamOverViewStat',

  props: {
    statLabel: {
      type: String,
      default: ''
    },
    statValue: {
      default: ''
    }
  }
});

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StreamingOverviewItem__ = __webpack_require__(2869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StreamingOverviewItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StreamingOverviewItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StreamingOverviewTable',

  props: {
    avgData: {
      type: Object,
      default: function _default() {
        return {
          streaming: [],
          listeners: []
        };
      }
    },
    selectedPeriod: {
      type: String,
      default: ''
    }
  },
  components: {
    StreamingOverviewItem: __WEBPACK_IMPORTED_MODULE_0__StreamingOverviewItem___default.a
  },
  methods: {
    formatTime: function formatTime(time) {
      var toMins = time / 60;
      if (toMins > 59) {
        var toHour = toMins / 60;
        var remMins = toMins % 60;
        return toHour.toFixed() + 'h ' + remMins.toFixed() + 'm';
      }
      return '0h ' + toMins.toFixed() + 'm';
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    liveStats: function liveStats() {
      return this.$store.state.analytics.liveStreamingStates;
    }
  }
});

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log2__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_d3_cloud__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_d3_cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_d3_cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FiltersSidebar',
  components: { Cloud: __WEBPACK_IMPORTED_MODULE_5_vue_d3_cloud___default.a },
  props: {
    transcripts: { type: Array, required: true },
    toneOptions: { type: Array, required: true },
    tagOptions: { type: Array, required: true }
  },
  data: function data() {
    return {
      quickFilters: [{ label: 'Score ≥ 4', icon: 'fa fa-star', active: false, filter: function filter(t) {
          return t.score >= 4;
        } }, {
        label: 'Approved On Air',
        icon: 'fa fa-podcast',
        active: false,
        filter: function filter(t) {
          return t.approved;
        }
      }, {
        label: 'Needs Review',
        icon: 'fa fa-exclamation-circle',
        active: false,
        filter: function filter(t) {
          return t.flagged;
        }
      }, {
        label: 'Short (<30s)',
        icon: 'fa fa-clock-o',
        active: false,
        filter: function filter(t) {
          return t.audioDuration < 30;
        }
      }],
      filters: {
        minScore: 0,
        selectedTones: [],
        selectedTags: [],
        maxLength: 120
      }
    };
  },

  methods: {
    capitalize: __WEBPACK_IMPORTED_MODULE_6_lodash__["capitalize"],
    applyFilters: function applyFilters() {
      var activeQuickFilters = this.quickFilters.filter(function (f) {
        return f.active;
      }).map(function (f) {
        return f.filter;
      });
      this.$emit('apply-filters', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.filters, { quickFilters: activeQuickFilters }));
    },
    resetFilters: function resetFilters() {
      this.quickFilters = this.quickFilters.map(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, f, { active: false });
      });
      this.filters = { minScore: 0, selectedTones: [], selectedTags: [], maxLength: 120 };
      this.applyFilters();
    },
    toggleFilters: function toggleFilters(filter) {
      var updatedFilters = this.quickFilters.map(function (f) {
        if (f.label === filter.label) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, f, { active: !f.active });
        }
        return f;
      });
      this.quickFilters = updatedFilters;
      this.applyFilters();
    },

    fontSizeMapper: function fontSizeMapper(word) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log2___default()(word.value) * 12;
    }
  },
  computed: {
    wordCloudData: function wordCloudData() {
      var allWords = this.transcripts.flatMap(function (t) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(t.keywords || []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(t.topics || []));
      });

      var counts = allWords.reduce(function (acc, word) {
        if (!word) return acc;
        var key = word.toLowerCase();
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(counts).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            text = _ref2[0],
            value = _ref2[1];

        return {
          text: text.charAt(0).toUpperCase() + text.slice(1),
          value: value
        };
      });
    }
  }
});

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetrend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VoiceAnalyticsUnitBlock',

  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_0_vuetrend__["a" /* default */],
    IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a
  },

  props: {
    unit: {
      type: String,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: 'Voice notes received'
    },
    received: {
      type: Number,
      default: 0
    },
    growth: {
      type: Number,
      default: 0
    },
    stats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    unitClass: {
      type: String,
      default: 'label-primary'
    },
    selected: {
      type: Boolean,
      default: true
    },
    approved: {
      type: Number,
      default: null
    },
    flagged: {
      type: Number,
      default: null
    },
    pending: {
      type: Number,
      default: null
    },
    gradient: {
      type: Array,
      default: function _default() {
        return ['#683090', '#c97eff'];
      }
    }
  },

  computed: {
    showBreakdown: function showBreakdown() {
      return this.approved !== null || this.flagged !== null || this.pending !== null;
    },
    processStats: function processStats() {
      return [0].concat(this.stats.map(function (stat) {
        return stat.total;
      }));
    }
  },

  methods: {
    onClickPrevious: function onClickPrevious() {
      this.$emit('previous');
    },
    onClickNext: function onClickNext() {
      this.$emit('next');
    }
  }
});

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_voiceIntelligence_VoiceNotesTable__ = __webpack_require__(2875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_analytics_voiceIntelligence_VoiceNotesTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_analytics_voiceIntelligence_VoiceNotesTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_voiceIntelligence_VoiceNotesGrid__ = __webpack_require__(2874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_analytics_voiceIntelligence_VoiceNotesGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_analytics_voiceIntelligence_VoiceNotesGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_analytics_voiceIntelligence_VoiceAnalyticsUnitBlock__ = __webpack_require__(2872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_analytics_voiceIntelligence_VoiceAnalyticsUnitBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_analytics_voiceIntelligence_VoiceAnalyticsUnitBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_analytics_voiceIntelligence_modals_AudioPreviewModal__ = __webpack_require__(2877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_analytics_voiceIntelligence_modals_AudioPreviewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_analytics_voiceIntelligence_modals_AudioPreviewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_analytics_voiceIntelligence_modals_ApproveModal__ = __webpack_require__(2876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_analytics_voiceIntelligence_modals_ApproveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_analytics_voiceIntelligence_modals_ApproveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_analytics_voiceIntelligence_modals_BulkApproveModal__ = __webpack_require__(2878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_analytics_voiceIntelligence_modals_BulkApproveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_analytics_voiceIntelligence_modals_BulkApproveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_analytics_voiceIntelligence_modals_FlagModal__ = __webpack_require__(2879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_analytics_voiceIntelligence_modals_FlagModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_analytics_voiceIntelligence_modals_FlagModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_analytics_voiceIntelligence_FiltersSidebar__ = __webpack_require__(2871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_analytics_voiceIntelligence_FiltersSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_analytics_voiceIntelligence_FiltersSidebar__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VoiceIntelligenceDashboard',
  components: {
    VoiceNotesTable: __WEBPACK_IMPORTED_MODULE_6__components_analytics_voiceIntelligence_VoiceNotesTable___default.a,
    VoiceNotesGrid: __WEBPACK_IMPORTED_MODULE_7__components_analytics_voiceIntelligence_VoiceNotesGrid___default.a,
    VoiceAnalyticsUnitBlock: __WEBPACK_IMPORTED_MODULE_8__components_analytics_voiceIntelligence_VoiceAnalyticsUnitBlock___default.a,
    AudioPreviewModal: __WEBPACK_IMPORTED_MODULE_9__components_analytics_voiceIntelligence_modals_AudioPreviewModal___default.a,
    ApproveModal: __WEBPACK_IMPORTED_MODULE_10__components_analytics_voiceIntelligence_modals_ApproveModal___default.a,
    BulkApproveModal: __WEBPACK_IMPORTED_MODULE_11__components_analytics_voiceIntelligence_modals_BulkApproveModal___default.a,
    FlagModal: __WEBPACK_IMPORTED_MODULE_12__components_analytics_voiceIntelligence_modals_FlagModal___default.a,
    FiltersSidebar: __WEBPACK_IMPORTED_MODULE_13__components_analytics_voiceIntelligence_FiltersSidebar___default.a
  },
  props: {
    transcripts: { type: Array, required: true },
    timeslots: { type: Array, required: true },
    loadingTranscripts: { type: Boolean, default: false },
    loadingTimeslots: { type: Boolean, default: false },
    loadingAnalytics: { type: Boolean, default: false },
    transcriptAnalytics: { type: Object, default: null }
  },
  data: function data() {
    return {
      detailVisible: false,
      filters: {
        minScore: 0,
        selectedTones: [],
        selectedTags: [],
        maxLength: 120
      },

      previewVisible: false,
      previewNote: null,

      approveVisible: false,
      approveNote: null,
      approvingLoading: false,

      flagVisible: false,
      flagNote: null,
      flaggingLoading: false,

      bulkApproveVisible: false,
      bulkApprovingLoading: false,

      selectedNote: null,
      searchQuery: '',
      selectedFilter: 'Show',
      selectedRows: [],
      selectedTimeslot: '0',
      viewMode: 'table',
      selectedBlockUnit: 'Year'
    };
  },

  methods: {
    closePreview: function closePreview() {
      this.previewVisible = false;
      this.previewNote = null;
    },
    previewVoiceNote: function previewVoiceNote(transcript) {
      this.previewNote = transcript;
      this.previewVisible = true;
    },
    onApproveOnAir: function onApproveOnAir(transcript) {
      this.approveNote = transcript;
      this.approveVisible = true;
    },
    onBulkApprove: function onBulkApprove() {
      if (this.selectedRows.length === 0) {
        this.$notify.warning('Please select voice notes to approve');
        return;
      }
      this.bulkApproveVisible = true;
    },
    handleApproveSubmit: function handleApproveSubmit(payload) {
      this.approvingLoading = true;
      this.$emit('approve-query', payload);
      this.approvingLoading = false;
      this.closeApprove();
    },
    closeApprove: function closeApprove() {
      this.approveVisible = false;
      this.approveNote = null;
      this.approvingLoading = false;
    },
    onToggleFlag: function onToggleFlag(transcript) {
      this.flagNote = transcript;
      this.flagVisible = true;
    },
    handleFlagSubmit: function handleFlagSubmit(payload) {
      this.flaggingLoading = true;
      this.$emit('flag-query', {
        id: payload.id,
        flagStatus: payload.flagStatus,
        action: payload.flagStatus ? 'flagged' : 'unflagged',
        flaggedById: payload.flaggedById,
        flaggedBy: payload.flaggedBy,
        reason: payload.reason
      });
      this.flaggingLoading = false;
      this.closeFlag();
    },
    handleBulkApproveSubmit: function handleBulkApproveSubmit(payload) {
      this.bulkApprovingLoading = true;
      this.$emit('bulk-approve-query', payload.notes.map(function (note) {
        return {
          interactionId: note,
          approvedById: payload.approvedById,
          approvedBy: payload.approvedBy,
          approveStatus: payload.approveStatus,
          approveReason: payload.reason
        };
      }));
      this.bulkApprovingLoading = false;
      this.closeBulkApprove();
    },
    closeBulkApprove: function closeBulkApprove() {
      this.bulkApproveVisible = false;
      this.bulkApprovingLoading = false;
      this.selectedRows = [];
      this.clearSelection();
    },
    closeFlag: function closeFlag() {
      this.flagVisible = false;
      this.flagNote = null;
      this.flaggingLoading = false;
    },
    clearSelection: function clearSelection() {
      if (this.$refs.voiceNotesTable) {
        this.$refs.voiceNotesTable.onClearSelection();
      }
    },
    clearFilters: function clearFilters() {
      this.searchQuery = '';
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    openDetail: function openDetail(transcript) {
      this.selectedNote = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, transcript);
      this.detailVisible = true;
    },
    toggleViewMode: function toggleViewMode() {
      this.viewMode = this.viewMode === 'table' ? 'grid' : 'table';
    },
    getFilteredTranscripts: function getFilteredTranscripts(transcripts) {
      var _this = this;

      var filtered = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(transcripts));

      if (this.searchQuery) {
        var searchQuery = this.searchQuery.toLowerCase();

        filtered = filtered.filter(function (transcript) {
          var sender = transcript.sender ? transcript.sender.toLowerCase() : '';
          var body = transcript.transcript ? transcript.transcript.toLowerCase() : '';
          var tone = transcript.tone ? transcript.tone.toLowerCase() : '';
          var location = transcript.location ? transcript.location.toLowerCase() : '';
          var tags = transcript.tags || [];

          return sender.includes(searchQuery) || tags.some(function (tag) {
            return tag ? tag.toLowerCase().includes(searchQuery) : false;
          }) || body.includes(searchQuery) || tone.includes(searchQuery) || location.includes(searchQuery);
        });
      }

      if (this.filters.minScore > 0) {
        filtered = filtered.filter(function (transcript) {
          return transcript.score >= _this.filters.minScore;
        });
      }
      if (this.filters.selectedTones.length > 0) {
        filtered = filtered.filter(function (transcript) {
          return _this.filters.selectedTones.includes(transcript.tone);
        });
      }
      if (this.filters.selectedTags.length > 0) {
        filtered = filtered.filter(function (transcript) {
          return _this.filters.selectedTags.some(function (tag) {
            return transcript.tags.includes(tag);
          });
        });
      }
      if (this.filters.maxLength < 120) {
        filtered = filtered.filter(function (note) {
          return note.audioDuration <= _this.filters.maxLength;
        });
      }
      if (this.$refs.filtersSidebar) {
        this.$refs.filtersSidebar.quickFilters.forEach(function (filter) {
          if (filter.active) {
            filtered = filtered.filter(filter.filter);
          }
        });
      }
      return filtered;
    },
    onTimeslotChanged: function onTimeslotChanged(timeslotId) {
      this.selectedTimeslot = timeslotId;
      this.$emit('timeslot-query', timeslotId);
    },
    onRefreshTranscripts: function onRefreshTranscripts() {
      if (this.selectedTimeslot === '0') {
        this.$notify.warning('Please select a timeslot');
        return;
      }
      this.$emit('refresh-transcripts');
    },
    onExportSelected: function onExportSelected() {
      var _this2 = this;

      if (!this.selectedRows.length) {
        this.$notify.warning('Please select voice notes to export');
        return;
      }

      this.$confirm('Export ' + this.selectedRows.length + ' selected voice notes?', 'Export', {
        confirmButtonText: 'Export',
        cancelButtonText: 'Cancel'
      }).then(function () {
        _this2.$emit('export-selected-query', _this2.selectedRows);
        _this2.selectedRows = [];
        _this2.clearSelection();
      }).catch(function () {
        _this2.selectedRows = [];
        _this2.clearSelection();
      });
    },
    onBlockPrevious: function onBlockPrevious(block) {
      this.$emit('period-shift', { unit: block.unit, direction: 'previous' });
    },
    onBlockNext: function onBlockNext(block) {
      this.$emit('period-shift', { unit: block.unit, direction: 'next' });
    },
    selectBlock: function selectBlock(selectedBlock) {
      this.selectedBlockUnit = selectedBlock.unit;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])('user', ['me']), {
    analyticsBlocks: function analyticsBlocks() {
      var defaults = {
        period: '',
        received: 0,
        growth: 0,
        stats: [],
        approved: 0,
        flagged: 0,
        pending: 0
      };
      var toBlock = function toBlock(data) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaults, data);
      };

      var a = this.transcriptAnalytics;
      var day = toBlock(a && a.day);
      var week = toBlock(a && a.week);
      var month = toBlock(a && a.month);
      var year = toBlock(a && a.year);

      return [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        unit: 'Day',
        unitClass: 'label-info',
        description: 'Voice notes received today',
        selected: this.selectedBlockUnit === 'Day'
      }, day), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        unit: 'Week',
        unitClass: 'label-success',
        description: 'Voice notes received this week',
        selected: this.selectedBlockUnit === 'Week'
      }, week), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        unit: 'Month',
        unitClass: 'label-primary',
        description: 'Voice notes received this month',
        selected: this.selectedBlockUnit === 'Month'
      }, month), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        unit: 'Year',
        unitClass: 'label-danger',
        description: 'Voice notes received this year',
        selected: this.selectedBlockUnit === 'Year'
      }, year)];
    },
    isShowFilter: function isShowFilter() {
      return this.selectedFilter === 'Show';
    },
    getTranscripts: function getTranscripts() {
      return this.getFilteredTranscripts(this.transcripts);
    },
    getTagOptions: function getTagOptions() {
      var tagsSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      this.transcripts.forEach(function (t) {
        if (Array.isArray(t.tags)) t.tags.forEach(function (tag) {
          return tagsSet.add(tag);
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(tagsSet).sort();
    },
    getToneOptions: function getToneOptions() {
      var tonesSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
      this.transcripts.forEach(function (t) {
        if (t.tone) tonesSet.add(t.tone);
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(tonesSet).map(function (tone) {
        return { label: tone, value: tone };
      });
    }
  })
});

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VoiceNotesGrid',
  components: { Empty: __WEBPACK_IMPORTED_MODULE_2__components_common_Empty___default.a },
  props: {
    transcripts: { type: Array, default: function _default() {
        return [];
      } },
    loadingTranscripts: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      displayedTranscripts: [],
      itemsPerLoad: 3,
      disabled: false
    };
  },

  computed: {
    getTranscripts: function getTranscripts() {
      return this.transcripts;
    },
    noMore: function noMore() {
      return this.displayedTranscripts.length >= this.getTranscripts.length;
    }
  },
  watch: {
    transcripts: {
      immediate: true,
      handler: function handler(newTranscripts) {
        this.disabled = false;
        this.displayedTranscripts = newTranscripts.slice(0, this.itemsPerLoad);

        if (this.displayedTranscripts.length >= newTranscripts.length) {
          this.disabled = true;
        }
      }
    }
  },
  mounted: function mounted() {
    this.displayedTranscripts = this.getTranscripts.slice(0, this.itemsPerLoad);
    if (this.displayedTranscripts.length >= this.getTranscripts.length) {
      this.disabled = true;
    }
  },

  methods: {
    displayDatetime: function displayDatetime(ts) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(ts).fromNow();
    },
    loadMore: function loadMore() {
      if (this.noMore || this.loadingTranscripts || this.disabled) return;

      var nextIndex = this.displayedTranscripts.length;
      var nextItems = this.getTranscripts.slice(nextIndex, nextIndex + this.itemsPerLoad);

      if (nextItems.length) {
        var _displayedTranscripts;

        (_displayedTranscripts = this.displayedTranscripts).push.apply(_displayedTranscripts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(nextItems));
      }

      if (this.displayedTranscripts.length >= this.getTranscripts.length) {
        this.disabled = true;
      }
    },
    onApprove: function onApprove(row) {
      this.$emit('approve-on-air', row);
    },
    onToggleFlag: function onToggleFlag(row) {
      this.$emit('toggle-flag', row);
    },
    onPreviewAudio: function onPreviewAudio(row) {
      this.$emit('preview-audio', row);
    }
  }
});

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VoiceNotesTable',
  props: {
    transcripts: {
      type: Array,
      required: true
    },
    loadingTranscripts: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      pageSize: 3,
      pageCount: 5,
      currentPage: 1,
      selectedRows: []
    };
  },

  computed: {
    totalTranscripts: function totalTranscripts() {
      return this.transcripts.length;
    },
    totalViews: function totalViews() {
      return Math.ceil(this.totalTranscripts / this.pageSize);
    },
    paginatedTranscripts: function paginatedTranscripts() {
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var endIndex = Math.min(startIndex + this.pageSize, this.totalTranscripts);
      return this.transcripts.slice(startIndex, endIndex);
    }
  },
  methods: {
    capitalize: __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"],
    formatDate: function formatDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format('DD MMM YYYY, HH:mm');
    },
    previewSummary: function previewSummary(text) {
      if (!text) return '';
      return text.length > 70 ? text.slice(0, 70) + '...' : text;
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
      this.$emit('selection-change', selection);
    },
    onToggleFlag: function onToggleFlag(row) {
      this.$emit('toggle-flag', row);
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
    },
    onPreviewAudio: function onPreviewAudio(row) {
      this.$emit('preview-audio', row);
    },
    onApprove: function onApprove(row) {
      this.$emit('approve-on-air', row);
    },
    onClearSelection: function onClearSelection() {
      if (this.$refs.voiceTable) {
        this.$refs.voiceTable.clearSelection();
        this.selectedRows = [];
      }
    },
    onRefreshTranscripts: function onRefreshTranscripts() {
      this.$emit('refresh-transcripts');
    }
  }
});

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApproveModal',
  props: {
    visible: { type: Boolean, required: true },
    note: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      comments: '',
      selectedOnAirUser: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['companyUsers', 'me']), {
    internalVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    },
    computedOnAirUser: {
      get: function get() {
        return this.selectedOnAirUser || null;
      },
      set: function set(onAirUser) {
        this.selectedOnAirUser = onAirUser;
      }
    },
    approvedBy: function approvedBy() {
      return this.me ? this.me.display_name : '';
    },
    approvalDate: function approvalDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD MMM YYYY, HH:mm');
    },
    previewText: function previewText() {
      if (!this.note || !this.note.transcript) return 'No transcript available.';
      return this.note.transcript.length > 150 ? this.note.transcript.slice(0, 150) + '...' : this.note.transcript;
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('user/getCompanyUsers');
  },

  methods: {
    formatDate: function formatDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('DD MMM YYYY, HH:mm');
    },
    handleApprove: function handleApprove() {
      var userId = this.computedOnAirUser;
      if (!userId) {
        this.$notify.warning('Please select an on-air user');
        return;
      }

      this.$emit('approve', {
        id: this.note.id,
        approvedBy: this.me.display_name,
        approvedById: this.me.id,
        approveStatus: true,
        reason: this.comments
      });

      this.$store.dispatch('interaction/sendToOnAir', {
        interactionId: this.note.id,
        userId: userId
      });

      if (this.comments && this.comments.trim()) {
        this.$store.dispatch('interaction/sendComment', {
          interactionId: this.note.id,
          message: this.comments
        });
      }
    },
    handleClose: function handleClose() {
      this.comments = '';
      this.selectedOnAirUser = null;
      this.internalVisible = false;
      this.$emit('close');
    }
  }
});

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudioPreviewModal',
  props: {
    visible: { type: Boolean, required: true },
    note: { type: Object, default: null }
  },
  computed: {
    internalVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    }
  },
  methods: {
    capitalize: __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"],
    formatDate: function formatDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format('DD MMM YYYY, HH:mm');
    },
    handleClose: function handleClose() {
      this.internalVisible = false;
      this.$emit('close');
    }
  }
});

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BulkApproveModal',
  props: {
    visible: { type: Boolean, required: true },
    notes: { type: Array, default: function _default() {
        return [];
      } },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      comments: '',
      selectedOnAirUser: null
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('user/getCompanyUsers');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['companyUsers', 'me']), {
    internalVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    },
    computedOnAirUser: {
      get: function get() {
        return this.selectedOnAirUser || null;
      },
      set: function set(onAirUser) {
        this.selectedOnAirUser = onAirUser;
      }
    },
    approvedBy: function approvedBy() {
      return this.me ? this.me.display_name : '';
    },
    approvalDate: function approvalDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD MMM YYYY, HH:mm');
    },
    alreadyApproved: function alreadyApproved() {
      return this.notes.filter(function (n) {
        return n.approved;
      });
    },
    toApprove: function toApprove() {
      return this.notes.filter(function (n) {
        return !n.approved;
      });
    }
  }),
  methods: {
    formatDate: function formatDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('DD MMM YYYY, HH:mm');
    },
    handleApprove: function handleApprove() {
      var _this = this;

      var userId = this.computedOnAirUser;
      if (!userId) {
        this.$notify.warning('Please select an on-air user');
        return;
      }

      this.$emit('bulk-approve', {
        notes: this.toApprove,
        approvedBy: this.me.display_name,
        approvedById: this.me.id,
        approveStatus: true,
        reason: this.comments
      });

      this.toApprove.forEach(function (note) {
        _this.$store.dispatch('interaction/sendToOnAir', {
          interactionId: note.id,
          userId: userId
        });

        if (_this.comments && _this.comments.trim()) {
          _this.$store.dispatch('interaction/sendComment', {
            interactionId: note.id,
            message: _this.comments
          });
        }
      });
    },
    handleClose: function handleClose() {
      this.comments = '';
      this.selectedOnAirUser = null;
      this.internalVisible = false;
      this.$emit('close');
    }
  }
});

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FlagModal',
  props: {
    visible: { type: Boolean, required: true },
    note: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      reason: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), {
    internalVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    },
    actionBy: function actionBy() {
      return this.me ? this.me.display_name : '';
    },
    actionDate: function actionDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD MMM YYYY, HH:mm');
    },
    previewText: function previewText() {
      if (!this.note || !this.note.transcript) return 'No transcript available.';
      return this.note.transcript.length > 150 ? this.note.transcript.slice(0, 150) + '...' : this.note.transcript;
    }
  }),
  methods: {
    formatDate: function formatDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamp).format('DD MMM YYYY, HH:mm');
    },
    handleFlag: function handleFlag(flagStatus) {
      this.$emit('flag', {
        id: this.note.id,
        flagStatus: flagStatus,
        flaggedBy: this.me.display_name,
        flaggedById: this.me.id,
        reason: this.reason
      });

      if (this.reason && this.reason.trim()) {
        this.$store.dispatch('interaction/sendComment', {
          interactionId: this.note.id,
          message: this.reason
        });
      }
    },
    handleClose: function handleClose() {
      this.reason = '';
      this.internalVisible = false;
      this.$emit('close');
    }
  }
});

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_company_CompanySelector__ = __webpack_require__(2943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_company_CompanySelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_company_CompanySelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password_strength_meter__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_password_strength_meter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_password_strength_meter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activities_ActivitiesList__ = __webpack_require__(2853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activities_ActivitiesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_activities_ActivitiesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user_EditProfileForm__ = __webpack_require__(3085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user_EditProfileForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_user_EditProfileForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_auth_PasswordOnlyResetForm__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_auth_PasswordOnlyResetForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_auth_PasswordOnlyResetForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_analytics_mutation_types__ = __webpack_require__(191);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            streaming {\n              live_streams\n            }\n          }\n        '], ['\n          subscription {\n            streaming {\n              live_streams\n            }\n          }\n        ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint consistent-return: "off" */









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppHeader',

  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onLiveStatsUpdated: {
        query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
        result: function result(data) {
          this.nowLiveStreamingStates = data.data.streaming;
          this.prevLiveStreamingStates = this.$store.state.analytics.liveStreamingStates;
          this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_9__store_modules_analytics_mutation_types__["t" /* SET_ANALYTICS_LIVE_STREAM_STATS */], this.nowLiveStreamingStates);
        }
      }
    }
  },

  components: {
    CompanySelector: __WEBPACK_IMPORTED_MODULE_3__components_company_CompanySelector___default.a,
    Password: __WEBPACK_IMPORTED_MODULE_4_vue_password_strength_meter___default.a,
    ActivitiesList: __WEBPACK_IMPORTED_MODULE_5__components_activities_ActivitiesList___default.a,
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_7__components_user_EditProfileForm___default.a,
    PasswordOnlyResetForm: __WEBPACK_IMPORTED_MODULE_8__components_auth_PasswordOnlyResetForm___default.a
  },
  data: function data() {
    return {
      selectCompanyDialogVisible: false,
      restPasswordDialogVisible: false,
      showActivities: false,
      searchTerm: '',
      newPassword: null,
      confrimedPassword: null,

      showUserMenu: false,
      editProfileDialogVisible: false,
      showSubmenuTimeout: 150,
      prevLiveStreamingStates: { live_streams: 0 },
      nowLiveStreamingStates: { live_streams: 0 }
    };
  },
  props: {
    isPending: {
      type: Boolean,
      default: false
    },
    me: {
      type: Object,
      required: true
    },
    activities: {
      type: Array,
      default: function _default() {
        return [{}, {}];
      }
    },
    companies: {
      type: Array,
      required: true
    },
    breadCrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dashboardTitle: {
      type: String,
      default: ''
    },
    dashboardHeaderEnabled: {
      type: Boolean,
      default: false
    },
    scheduledPosts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isDisabled: function isDisabled() {
      return this.newPassword !== this.confirmedPassword;
    },
    user: function user() {
      return this.me;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['sidebarCollapsed']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])('auth', ['passwordResetFailed'])),
  watch: {
    passwordResetFailed: function passwordResetFailed(val) {
      if (val && !this.restPasswordDialogVisible) {
        this.restPasswordDialogVisible = true;
      }
    }
  },
  methods: {
    handleToggleDialog: function handleToggleDialog() {
      this.restPasswordDialogVisible = !this.restPasswordDialogVisible;
    },
    handleHelpClick: function handleHelpClick() {
      window.open('mailto:support@colonyhq.com?subject=Colony%20Live%20Support%20Request');
    },
    handleKnowledgeBaseClick: function handleKnowledgeBaseClick() {
      window.open('https://colonylive.com/knowledgebase/', '_blank');
    },
    getStreamingStats: function getStreamingStats() {
      var live = this.nowLiveStreamingStates.live_streams;
      var prevLive = this.prevLiveStreamingStates.live_streams;
      var liveGrowth = live - prevLive;
      var labelClass = liveGrowth >= 0 ? 'success' : 'danger';
      var arrowClass = liveGrowth >= 0 ? 'up' : 'down';
      return {
        now: live,
        growth: liveGrowth,
        streamingClass: labelClass,
        growthClass: arrowClass
      };
    },
    onSearch: function onSearch() {
      this.$emit('onSearch', { searchTerm: this.searchTerm });
    },
    onCollapseMenu: function onCollapseMenu() {
      this.$emit('onCollapseMenu');
    },
    onLogout: function onLogout() {
      this.$emit('onLogout');
    },
    onSwitchCompany: function onSwitchCompany(event) {
      var payload = {
        company: event.company,
        user: this.$store.state.user.me.id
      };
      this.$store.dispatch('user/updateUserCompany', payload);
    },
    onResetPassword: function onResetPassword() {
      var payload = {
        password: this.confrimPassword,
        user: this.$store.state.user.me.id
      };
      this.$store.dispatch('user/updatePassword', payload);
    },
    deleteActivity: function deleteActivity(id) {
      this.$store.dispatch('activities/deleteActivity', id);
    },
    handleNewSocialPost: function handleNewSocialPost() {
      this.$emit('onNewSocialPost');
    },
    handleDropdownCommand: function handleDropdownCommand(cmd) {
      if (cmd === 'onLogout') return this.onLogout();
      this[cmd] = !this[cmd];
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('activities/stopActivityPolling');
  },
  mounted: function mounted() {
    /*
    for some reason the dropdown popper did not show/hide the first time it was
    triggered. This emulates the initial non-working trigger of show and hide.
    Thereafter it works as expected. It's ugly, but it works.
    */
    this.$refs.userdropdown.createPopper();
    this.$refs.userdropdown.dropdown.show();
    setTimeout(this.$refs.userdropdown.dropdown.hide, 100);
  }
});

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_AppFooter__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_AppHeader__ = __webpack_require__(2880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_MainLayout__ = __webpack_require__(2882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_MainLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_app_MainLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_modals_ModalContainer__ = __webpack_require__(3104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_modals_ModalContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__containers_modals_ModalContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_notifications_Notification__ = __webpack_require__(2961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_notifications_Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_notifications_Notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_SideMenu__ = __webpack_require__(2883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_app_SideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_app_SideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_StaffAlerts__ = __webpack_require__(2927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_StaffAlerts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_StaffAlerts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Toast__ = __webpack_require__(2928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_app_mutation_types__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_interaction_mutation_types___ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_auth_mutation_types___ = __webpack_require__(342);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainApp',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_app_AppFooter___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_3__components_app_AppHeader___default.a,
    MainLayout: __WEBPACK_IMPORTED_MODULE_4__components_app_MainLayout___default.a,
    ModalContainer: __WEBPACK_IMPORTED_MODULE_5__containers_modals_ModalContainer___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_6__components_notifications_Notification___default.a,
    SideMenu: __WEBPACK_IMPORTED_MODULE_7__components_app_SideMenu___default.a,
    StaffAlerts: __WEBPACK_IMPORTED_MODULE_8__components_common_StaffAlerts___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_9__components_common_Toast___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('company', ['companies']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('activities', ['activities']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('social', ['scheduledMessages']), {
    action: function action() {
      return this.$route.meta.action || null;
    },
    subject: function subject() {
      return this.$route.meta.subject || null;
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('loadInitialData');
  },

  methods: {
    onNewSocialPost: function onNewSocialPost() {
      this.$store.dispatch('channel/getChannels');
      this.$store.dispatch('modals/showSocialPostDialog');
    },
    onSearch: function onSearch(event) {
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_11__store_modules_interaction_mutation_types___["Z" /* SET_SEARCH_TERM */], event.searchTerm);
      this.$store.dispatch('interaction/simpleSearch', {
        query: event.searchTerm,
        page: 1
      });
      this.$router.push({ name: 'InteractionSearch' });
    },
    onLogout: function onLogout() {
      this.$store.commit('auth/' + __WEBPACK_IMPORTED_MODULE_12__store_modules_auth_mutation_types___["d" /* LOGOUT_REQUEST */]);
    },
    onCollapseMenu: function onCollapseMenu() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__store_app_mutation_types__["a" /* TOGGLE_SIDEBAR */]);
      var bodyEl = document.getElementsByTagName('body')[0];

      if (this.hasMiniNavbar(bodyEl)) {
        this.removeMiniNavbar(bodyEl);
      } else {
        this.addMiniNavbar(bodyEl);
      }
    },
    addMiniNavbar: function addMiniNavbar(el) {
      var bodyEl = el;
      if (bodyEl.classList) {
        bodyEl.classList.add('mini-navbar');
      } else {
        bodyEl.className += ' mini-navbar';
      }
    },
    removeMiniNavbar: function removeMiniNavbar(el) {
      var bodyEl = el;
      if (bodyEl.classList) {
        bodyEl.classList.remove('mini-navbar');
      } else {
        bodyEl.className = bodyEl.className.replace(new RegExp('(^|\\b)mini-navbar(\\b|$)', 'gi'), ' ');
      }
    },
    hasMiniNavbar: function hasMiniNavbar(el) {
      if (el.classList) {
        return el.classList.contains('mini-navbar');
      }
      return new RegExp('(^| )mini-navbar( |$)', 'gi').test(el.className);
    }
  }
});

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_permissions_Can__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainLayout',
  props: ['action', 'subject'],

  components: {
    Can: __WEBPACK_IMPORTED_MODULE_0__components_permissions_Can___default.a
  }
});

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_perfect_scrollbar__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_permissions_Can__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint consistent-return: "off" */





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SideMenu',
  components: {
    Can: __WEBPACK_IMPORTED_MODULE_3__components_permissions_Can___default.a,
    PerfectScrollbar: __WEBPACK_IMPORTED_MODULE_2_vue2_perfect_scrollbar__["PerfectScrollbar"]
  },
  data: function data() {
    return {
      showUserMenu: false,
      showSubmenuTimeout: 150
    };
  },

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['sidebarCollapsed']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('plugin', ['plugins']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'])),

  methods: {
    pluginEnabled: function pluginEnabled(pluginRoute) {
      return this.plugins.filter(function (plugin) {
        return plugin.plugin_route === pluginRoute;
      }).length;
    }
  }
});

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_contact__ = __webpack_require__(245);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactListItem',
  props: {
    id: String,
    providerName: String
  },
  data: function data() {
    return {
      contactLists: []
    };
  },
  apollo: {
    $client: 'apiv2',
    constantContactLists: {
      query: __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql___default.a,
      skip: true,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        this.contactLists = !loading ? data.constantContactLists : [];
      }
    },
    mailChimpLists: {
      query: __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql___default.a,
      skip: true,
      variables: function variables() {
        return {
          id: this.id
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        this.contactLists = !loading ? data.mailChimpLists : [];
      }
    }
  },
  mounted: function mounted() {
    switch (this.providerName) {
      case 'constant_contact':
        this.$apollo.queries.constantContactLists.start();
        break;
      case 'mail_chimp':
        this.$apollo.queries.mailChimpLists.start();
        break;
      default:
        break;
    }
  },

  methods: {
    parseProviderName: __WEBPACK_IMPORTED_MODULE_2__helpers_contact__["a" /* parseProviderName */]
  }
});

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactListItem__ = __webpack_require__(2884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContactListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactsListDialog__ = __webpack_require__(2886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactsListDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContactsListDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactsDashboard',
  components: {
    ContactListItem: __WEBPACK_IMPORTED_MODULE_3__ContactListItem___default.a,
    ContactsListDialog: __WEBPACK_IMPORTED_MODULE_4__ContactsListDialog___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'], 'contacts')),
  data: function data() {
    return {
      contactsListVisible: false,
      selectedContactsList: { name: '', id: '' },
      selectedContactsAccount: { id: 0, providerName: '' }
    };
  },
  props: {
    contactAccounts: Array,
    isLoading: Boolean
  },
  methods: {
    constantContactAuth: function constantContactAuth() {
      this.$store.dispatch('contacts/constantContactAuth');
    },
    mailChimpAuth: function mailChimpAuth() {
      this.$store.dispatch('contacts/mailChimpAuth');
    },
    handleContactListClick: function handleContactListClick(accountId, providerName, contactList) {
      this.selectedContactsAccount.id = accountId;
      this.selectedContactsAccount.providerName = providerName;
      this.selectedContactsList = contactList;
      this.contactsListVisible = true;
    },
    handleContactListVisibilityChange: function handleContactListVisibilityChange(visiblity) {
      this.contactsListVisible = visiblity;
    }
  }
});

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactListContacts_gql__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactListContacts_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactListContacts_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpListContacts_gql__ = __webpack_require__(2592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpListContacts_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpListContacts_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactListDialog',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default.a
  },
  props: {
    contactAccount: {
      type: Object,
      required: true
    },
    listId: {
      type: String,
      required: true
    },
    listName: {
      type: String,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  },
  data: function data() {
    return {
      listContacts: [],
      skipContactListContactsQuery: true,
      skipMailChimpListContactsQuery: true
    };
  },
  apollo: {
    $client: 'apiv2',
    contactListContacts: {
      query: __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactListContacts_gql___default.a,
      skip: function skip() {
        return this.skipContactListContactsQuery;
      },
      variables: function variables() {
        return {
          id: this.contactAccount.id,
          listId: this.listId
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        this.listContacts = !loading ? data.contactListContacts : [];
      }
    },
    mailChimpListContacts: {
      query: __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpListContacts_gql___default.a,
      skip: function skip() {
        return this.skipMailChimpListContactsQuery;
      },
      variables: function variables() {
        return {
          id: this.contactAccount.id,
          listId: this.listId
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        this.listContacts = !loading ? data.mailChimpListContacts : [];
      }
    }
  },
  methods: {
    fetchContacts: function fetchContacts() {
      switch (this.contactAccount.providerName) {
        case 'constant_contact':
          this.skipContactListContactsQuery = false;
          this.$apollo.queries.contactListContacts.refetch({
            id: this.contactAccount.id, listId: this.listId
          });
          break;
        case 'mail_chimp':
          this.skipMailChimpListContactsQuery = false;
          this.$apollo.queries.mailChimpListContacts.refetch({
            id: this.contactAccount.id, listId: this.listId
          });
          break;
        default:
          break;
      }
    },
    clearContacts: function clearContacts() {
      this.listContacts = [];
    }
  }
});

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginForm',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter___default.a
  },
  props: {
    isPending: {
      type: Boolean,
      default: false
    },
    hasFailed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCookieWarning: true,
      loginForm: {
        email: null,
        password: null
      },
      loginFormRules: {
        email: [{
          type: 'email',
          required: true,
          message: 'Please enter your email address',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'Please enter your password',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.showCookieWarning = !this.$cookies.isKey('acceptCookieUse');
  },

  methods: {
    acceptCookies: function acceptCookies() {
      this.showCookieWarning = false;
      this.$cookies.set('acceptCookieUse', true, Infinity);
    },
    onClickLogin: function onClickLogin() {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.$emit('onLogin', {
            email: _this.loginForm.email,
            password: _this.loginForm.password
          });
        }
      });
    }
  }
});

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordOnlyResetForm',
  components: {
    Password: __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter___default.a
  },
  props: {
    requireOldPassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created: function created() {
    this.token = this.$route.params.token;
  },

  data: function data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmedPassword: null,
      token: null
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      var disable = true;
      if (this.newPassword !== null && this.confirmedPassword !== null && this.newPassword === this.confirmedPassword && this.confirmedPassword.length >= 8) {
        this.$message({
          type: 'success',
          message: 'Passwords match, click Reset password'
        });
        disable = false;
      }

      if ((this.oldPassword === null || this.oldPassword === '') && this.requireOldPassword) {
        disable = true;
      }

      return disable;
    }
  },
  methods: {
    onResetPassword: function onResetPassword() {
      var data = {
        password: this.confirmedPassword,
        user: this.$store.state.user.me.id,
        token: this.token,
        oldPassword: this.oldPassword
      };
      if (this.token === null || this.token === undefined) {
        this.$store.dispatch('auth/updatePassword', data);
      } else {
        this.$store.dispatch('auth/tokenPasswordReset', data);
      }
      this.clearRestForm();
      this.hideResetPasswordDialog();
    },
    clearRestForm: function clearRestForm() {
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmedPassword = null;
    },
    hideResetPasswordDialog: function hideResetPasswordDialog() {
      this.$emit('togglePasswordDialog');
    }
  }
});

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordOnlyResetFormOnUserList',
  components: {
    Password: __WEBPACK_IMPORTED_MODULE_0_vue_password_strength_meter___default.a
  },
  created: function created() {
    this.token = this.$route.params.token;
  },

  data: function data() {
    return {
      newPassword: null,
      confirmedPassword: null,
      token: null
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      var disable = true;
      if (this.newPassword !== null && this.confirmedPassword !== null && this.newPassword === this.confirmedPassword && this.confirmedPassword.length >= 8) {
        this.$message({
          type: 'success',
          message: 'Passwords match, click Reset password'
        });
        disable = false;
      }
      return disable;
    }
  },
  methods: {
    onResetPassword: function onResetPassword() {
      var data = {
        password: this.confirmedPassword,
        user: null,
        token: this.token,
        email: ''
      };

      if (this.$store.state.user.userListSelectedUser != null) {
        data.user = this.$store.state.user.userListSelectedUser.id;
        data.email = this.$store.state.user.userListSelectedUser.email;
      }

      if (this.token === null || this.token === undefined) {
        this.$store.dispatch('auth/updatePasswordOnUserList', data);
      } else {
        this.$store.dispatch('auth/tokenPasswordReset', data);
      }
      this.clearRestForm();
    },
    clearRestForm: function clearRestForm() {
      this.newPassword = null;
      this.confirmedPassword = null;
    }
  }
});

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordResetForm',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_0__components_app_AppFooter___default.a
  },
  props: {
    isPending: {
      type: Boolean,
      default: false
    },
    hasFailed: {
      type: Boolean,
      default: false
    },
    hasSucceeded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      passwordResetForm: {
        email: null
      },
      passwordResetFormRules: {
        email: [{
          type: 'email',
          required: true,
          message: 'Please enter your email address',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    onClickResetPassword: function onClickResetPassword() {
      var _this = this;

      this.$refs.passwordResetForm.validate(function (valid) {
        if (valid) {
          _this.$emit('onPasswordReset', {
            email: _this.passwordResetForm.email
          });
        }
      });
    }
  }
});

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PasswordOnlyResetForm__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PasswordOnlyResetForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PasswordOnlyResetForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordRestWithTokenForm',
  components: {
    PasswordOnlyResetForm: __WEBPACK_IMPORTED_MODULE_2__PasswordOnlyResetForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['passwordResetFailed', 'passwordResetSucceeded']))
});

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_automatedemails_emails_generateEmail_gql__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_automatedemails_emails_generateEmail_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql_automatedemails_emails_generateEmail_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_automatedemails_recipients_deleteRecipient_gql__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_automatedemails_recipients_deleteRecipient_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql_automatedemails_recipients_deleteRecipient_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientManage__ = __webpack_require__(2893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RecipientManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GenerateReport__ = __webpack_require__(2892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GenerateReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GenerateReport__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmailRecipientList',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companies: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    surveys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    recipients: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    me: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    RecipientManage: __WEBPACK_IMPORTED_MODULE_2__RecipientManage___default.a,
    GenerateReport: __WEBPACK_IMPORTED_MODULE_3__GenerateReport___default.a
  },
  data: function data() {
    return {
      keyword: '',
      selectedRecipient: null,
      showRecipientManage: false,
      showGenerator: false,
      generatingReport: false
    };
  },
  computed: {
    showCompanyColumn: function showCompanyColumn() {
      return this.me.is_org_admin || this.me.is_staff || this.me.is_superuser;
    },
    results: function results() {
      var _this = this;

      var recipients = this.recipients.filter(function (recipient) {
        return _this.find(_this.keyword, recipient.firstName) || _this.find(_this.keyword, recipient.lastName) || _this.find(_this.keyword, recipient.email);
      });
      return recipients.length ? recipients : [];
    }
  },
  methods: {
    find: function find(keyword, str) {
      return str.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
    },
    generateReport: function generateReport() {
      this.showGenerator = true;
    },
    handleGenerate: function handleGenerate(report) {
      var _this2 = this;

      this.generatingReport = true;
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_0__graphql_automatedemails_emails_generateEmail_gql___default.a,
        variables: report
      }).then(function () {
        _this2.showGenerator = false;
        _this2.$notify({
          title: 'Success!',
          message: 'Email successfully sent to your inbox!',
          type: 'success'
        });
      }).catch(function () {
        _this2.$notify({
          title: 'Error',
          message: 'Unable to generate report. Please contact support.',
          type: 'error'
        });
      }).finally(function () {
        _this2.generatingReport = false;
      });
    },
    manageRecipient: function manageRecipient(recipient) {
      // for some reason ElementUI does not use the latest user object from the list.
      // If a user was updated, and then edited again, the form populated with old data.
      // Therefore we get the user with the same ID from the list. This should be the updated user.
      this.selectedRecipient = this.recipients.find(function (x) {
        return recipient && x.id === recipient.id;
      }) || {
        firstName: null,
        lastName: null,
        email: null,
        campaignSummary: false,
        programmingSummary: false,
        surveySummary: false
      };

      this.showRecipientManage = true;
    },
    handleSaved: function handleSaved() {
      this.showRecipientManage = false;
      this.$emit('saved');
    },
    handleError: function handleError() {},
    handleDelete: function handleDelete() {
      this.$emit('deleted');
    },
    deleteRecipient: function deleteRecipient(recipient) {
      var _this3 = this;

      this.selectedRecipient = recipient;
      this.$confirm('Are you sure you want to stop ' + recipient.firstName + ' ' + recipient.lastName + ' from receiving all automated emails?').then(function () {
        _this3.$apollo.mutate({
          client: 'apiv2',
          mutation: __WEBPACK_IMPORTED_MODULE_1__graphql_automatedemails_recipients_deleteRecipient_gql___default.a,
          variables: { id: parseInt(recipient.id, 10) }
        }).then(function () {
          return _this3.handleDelete();
        });
      }).catch(function () {
        return null;
      }); // prevent uncaught exeptions warning in console...
    }
  }
});

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GenerateReport',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    surveys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      reportTypes: [{ value: 'PROGRAMMING', label: 'Programming Dashboard' }, { value: 'CAMPAIGN', label: 'Campaign Summary' }, { value: 'SURVEY', label: 'Survey Summary' }],
      report: {
        type: null,
        id: null
      },
      rules: {
        type: [{ required: true, message: 'Please select a report type', trigger: 'blur' }],
        id: [{ required: true, message: 'Please make a selection', trigger: 'blur' }]
      }
    };
  },
  methods: {
    generate: function generate() {
      var _this = this;

      this.$refs.generatorForm.validate(function (valid) {
        if (valid) return _this.$emit('generate', _this.report);
        return false;
      });
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_automatedemails_recipients_createRecipient_gql__ = __webpack_require__(2580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_automatedemails_recipients_createRecipient_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_automatedemails_recipients_createRecipient_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_automatedemails_recipients_updateRecipient_gql__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_automatedemails_recipients_updateRecipient_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_automatedemails_recipients_updateRecipient_gql__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecipientManage',
  props: {
    recipient: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companies: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    me: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      savingRecipient: false,
      localRecipient: {},
      rules: {
        email: [{ required: true, message: 'Please provide an email address' }],
        firstName: [{ required: true, message: 'Please provide a name' }],
        lastName: [{ required: true, message: 'Please provide a surname' }],
        companyId: [{ required: true, message: 'Please select a company' }]
      }
    };
  },

  mounted: function mounted() {
    /**
     * Deep copy user for for the form so that state is not directly mutated in child component
     */
    this.localRecipient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.recipient);
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('user', ['updateCompanyUserRequest', 'updateCompanyUserSucceeded'])),

  methods: {
    handleFormSave: function handleFormSave() {
      var _this = this;

      this.$refs.localRecipient.validate(function (valid) {
        if (valid) return _this.saveRecipient();
        return false;
      });
    },
    saveRecipient: function saveRecipient() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var recipient, id, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.savingRecipient = true;
                recipient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["omit"])(_this2.localRecipient, 'company');

                if (!('id' in recipient)) {
                  _context.next = 8;
                  break;
                }

                id = recipient.id, data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(recipient, ['id']);
                _context.next = 6;
                return _this2.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_7__graphql_automatedemails_recipients_updateRecipient_gql___default.a,
                  variables: { id: parseInt(id, 10), data: data }
                });

              case 6:
                _context.next = 10;
                break;

              case 8:
                _context.next = 10;
                return _this2.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_automatedemails_recipients_createRecipient_gql___default.a,
                  variables: { data: recipient }
                });

              case 10:
                _this2.savingRecipient = false;
                _this2.$emit('saved');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancelled');
    },
    handleSelect: function handleSelect(user) {
      this.localRecipient.email = user.email;
      this.localRecipient.firstName = user.firstName;
      this.localRecipient.lastName = user.lastName;
      this.localRecipient.companyId = parseInt(user.company.id, 10);
    },
    clearForm: function clearForm() {
      this.$refs.localRecipient.resetFields();
    },
    querySearch: function querySearch(queryString, cb) {
      var users = this.users;

      var results = queryString ? users.filter(function (user) {
        return user.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      }) : users;
      cb(results);
    }
  },

  watch: {
    updateCompanyUserRequest: function updateCompanyUserRequest(val, oldVal) {
      if (val !== oldVal && val) {
        this.savingUser = true;
      }

      if (!val) {
        this.savingUser = false;
        this.$emit(this.updateCompanyUserSucceeded ? 'saved' : 'saveError', this.user);
      }
    }
  }
});

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TemplateCard',
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    subject: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'PROGRAMMING'
    }

  },
  methods: {
    handleEdit: function handleEdit() {
      this.$emit('onEdit');
    },
    handleDelete: function handleDelete() {
      this.$emit('onDelete');
    },
    handleCommand: function handleCommand(command) {
      var commands = {
        edit: this.handleEdit,
        delete: this.handleDelete
      };
      return commands[command]();
    }
  }
});

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ckeditor4_vue__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ckeditor4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ckeditor4_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TemplateEditor',
  components: {
    ckEditor: __WEBPACK_IMPORTED_MODULE_1_ckeditor4_vue__["component"]
  },
  props: {
    template: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
      rules: {
        name: [{ required: true, message: 'Please give this email a nice name' }],
        type: [{ required: true, message: 'Please select a template type' }],
        subject: [{ required: true, message: 'Please input an email subject' }],
        content: [{ required: true, message: 'Please give this email a nice name' }]
      },
      templateTypes: [{ label: 'Programming Dashboard Summary', value: 'PROGRAMMING' }, { label: 'Campaign Lifetime Summary', value: 'CAMPAIGN' }, { label: 'Survey Lifetime Summary', value: 'SURVEY' }],
      templateVars: {
        global: ['station_name', 'day', 'month', 'year'],
        campaign: ['campaign_name', 'campaign_type', 'campaign_start_date', 'campaign_end_date'],
        survey: ['survey_name', 'survey_description', 'survey_start_date', 'survey_end_date']
      },
      editorConfig: {
        extraPlugins: 'preview',
        allowedContent: true
      }
    };
  },

  methods: {
    handleCancel: function handleCancel() {
      this.$emit('onCancel');
    },
    handleBack: function handleBack() {
      this.$router({ path: '/admin/templates' });
    },
    handleFormSave: function handleFormSave() {
      this.template.id = parseInt(this.template.id, 10);
      this.$emit('onSave', this.template);
    },
    onEditorReady: function onEditorReady(editor) {
      this.editor = editor;
    }
  }
});

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_automatedemails_templates_TemplateCard__ = __webpack_require__(2894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_automatedemails_templates_TemplateCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_automatedemails_templates_TemplateCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TemplateList',
  components: {
    TemplateCard: __WEBPACK_IMPORTED_MODULE_0__components_automatedemails_templates_TemplateCard___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default.a
  },
  props: {
    me: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    templates: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleOnEdit: function handleOnEdit(event, template) {
      var path = '/admin/templates/' + template.id;
      this.$router.push({ path: path });
    }
  }
});

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BlacklistOriginatorEdit',
  components: { SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a },
  data: function data() {
    return {
      savingTimeslot: false,
      blacklistedOriginator: {
        originator: ''
      }
    };
  },
  computed: {
    saving: function saving() {
      return this.$store.state.blacklist.creatingBlacklistOriginator || this.$store.state.blacklist.updatingBlacklistOriginator;
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    blacklistOriginator: function blacklistOriginator() {
      this.blacklistedOriginator.company = this.$store.state.user.me.use_as_company;
      this.$emit('save', this.blacklistedOriginator);
    }
  }
});

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BlacklistOriginatorEdit',
  components: { SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a },
  props: ['originator'],
  data: function data() {
    return {
      savingTimeslot: false,
      blacklistedOriginator: {
        originator: ''
      }
    };
  },
  computed: {
    saving: function saving() {
      return this.$store.state.blacklist.creatingBlacklistOriginator || this.$store.state.blacklist.updatingBlacklistOriginator;
    }
  },
  mounted: function mounted() {
    this.blacklistedOriginator = this.originator;
  },

  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    blacklistOriginator: function blacklistOriginator() {
      this.$emit('save', this.blacklistedOriginator);
    }
  }
});

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blacklist_BlacklistOriginatorEdit__ = __webpack_require__(2898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blacklist_BlacklistOriginatorEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_blacklist_BlacklistOriginatorEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blacklist_BlacklistOriginatorCreate__ = __webpack_require__(2897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blacklist_BlacklistOriginatorCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_blacklist_BlacklistOriginatorCreate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: "off" */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BlacklistOriginatorList',
  components: { SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a, BlacklistOriginatorEdit: __WEBPACK_IMPORTED_MODULE_1__components_blacklist_BlacklistOriginatorEdit___default.a, BlacklistOriginatorCreate: __WEBPACK_IMPORTED_MODULE_2__components_blacklist_BlacklistOriginatorCreate___default.a },
  data: function data() {
    return {
      showEditDialog: false,
      showCreateDialog: false,
      isNewBlacklistOriginator: false
    };
  },
  props: {
    blacklistedOriginators: {
      type: Array,
      required: true
    }
  },
  methods: {
    blacklistOriginator: function blacklistOriginator() {
      this.showCreateDialog = true;
    },
    addBlacklistOriginator: function addBlacklistOriginator(originator) {
      this.$store.dispatch('blacklist/addBlacklistOriginator', originator);
      this.showCreateDialog = false;
    },
    updateBlacklist: function updateBlacklist(originator) {
      var action = 'id' in originator ? 'blacklist/updateBlacklistOriginator' : 'blacklist/addBlacklistOriginator';
      this.$store.dispatch(action, originator);
      this.showEditDialog = false;
    },
    editBlacklistedOriginator: function editBlacklistedOriginator(originator) {
      this.showEditDialog = !this.showEditDialog;
      var newOriginator = {
        originator: '',
        company: this.$store.state.user.me.use_as_company
      };
      this.selectedBlacklistedOriginator = originator || newOriginator;
    },
    deleteBlacklistedOriginator: function deleteBlacklistedOriginator(originator) {
      var _this = this;

      var confirmationMessage = 'Are you sure you want to allow messages from ' + originator.originator + '?';
      this.$confirm(confirmationMessage, {
        confirmButtonText: "Yes, I'm sure",
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch('blacklist/deleteBlacklistedOriginator', originator.id);
      });
    },
    handleAction: function handleAction(command) {
      /**
       * Executes the action by passing the item as parameter.
       *
       * @param {command}: object with actions and item properties
       */
      command.action(command.item);
    }
  }
});

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(244);





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      '], ['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BotReportDialog',
  components: {
    ChannelSelect: __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect___default.a
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: Number,
      required: true
    },
    campaignTitle: {
      type: String,
      default: 'Campaign'
    },
    channelLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        fileName: '',
        rangeDate: [],
        channels: [],
        channel_types: []
      },
      rules: {
        fileName: [{ required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' }],

        rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }],

        channels: [{ required: true, trigger: 'change', message: 'Please select at least one channel.' }]
      },
      channelList: [],
      isLoading: false
    };
  },
  apollo: {
    channelList: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject)
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  },
  methods: {
    handleRunDownloadReport: function handleRunDownloadReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.validate().catch(function () {
                  return false;
                });

              case 2:
                valid = _context.sent;

                if (valid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                payload = {
                  campaign_id: _this.campaignId,
                  channels: _this.form.channels,
                  channel_types: _this.form.channel_types,
                  file_name: _this.form.fileName,
                  date_from: _this.form.rangeDate[0],
                  date_to: _this.form.rangeDate[1]
                };


                _this.isLoading = true;

                _context.prev = 7;
                _context.next = 10;
                return _this.$store.dispatch('campaign/downloadBotReport', payload);

              case 10:
                _this.$emit('onVisibleChanged', false);

              case 11:
                _context.prev = 11;

                _this.isLoading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7,, 11, 14]]);
      }))();
    },
    handleSelectedChannelsChanged: function handleSelectedChannelsChanged(selectedChannels) {
      this.form.channels = selectedChannels;
      var selectedChannelTypes = this.channelList.filter(function (channel) {
        return selectedChannels.includes(channel.id);
      }).map(function (channel) {
        return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* channelTypes */][channel.channelTypeTitle.toUpperCase()];
      });
      this.form.channel_types = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(selectedChannelTypes).toJSON();
    },
    handleCancel: function handleCancel() {
      this.$emit('onVisibleChanged', false);
    }
  },
  mounted: function mounted() {
    var filename = this.campaignTitle.replace(/[^\w\d]|[\s]/g, '-').toLowerCase();
    this.form.fileName = (filename + '-report').replace(/-{2,}/g, '-');
  }
});

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignListItem__ = __webpack_require__(2905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignManage__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_campaign_RandomSelectDialog__ = __webpack_require__(2907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_campaign_RandomSelectDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_campaign_RandomSelectDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_campaign_RandomSelectionsDialog__ = __webpack_require__(2908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_campaign_RandomSelectionsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_campaign_RandomSelectionsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_campaign_DownloadMessagesDialog__ = __webpack_require__(2906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_campaign_DownloadMessagesDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_campaign_DownloadMessagesDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_campaign_BotReportDialog__ = __webpack_require__(2900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_campaign_BotReportDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_campaign_BotReportDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_profile_ProfileDetailDialog__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_profile_ProfileDetailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_profile_ProfileDetailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDialogMixin__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_campaign_CampaignFilter__ = __webpack_require__(2903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_campaign_CampaignFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_campaign_CampaignFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Paginator__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_Paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_modules_campaign_mutation_types__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_permissions_Can__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_unlinkChannel_gql__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_unlinkChannel_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__graphql_unlinkChannel_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_favouriteCampaign_gql__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_favouriteCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__graphql_favouriteCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_liveCampaign_gql__ = __webpack_require__(2600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_liveCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__graphql_liveCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_campaignList_gql__ = __webpack_require__(2587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_campaignList_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__graphql_campaignList_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store_modules_profile_mutation_types__ = __webpack_require__(193);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignDashboard',

  components: {
    CampaignListItem: __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignListItem___default.a,
    CampaignManage: __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignManage___default.a,
    FabSpeedDial: __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default.a,
    Can: __WEBPACK_IMPORTED_MODULE_17__components_permissions_Can___default.a,
    RandomSelectDialog: __WEBPACK_IMPORTED_MODULE_8__components_campaign_RandomSelectDialog___default.a,
    RandomSelectionsDialog: __WEBPACK_IMPORTED_MODULE_9__components_campaign_RandomSelectionsDialog___default.a,
    DownloadMessagesDialog: __WEBPACK_IMPORTED_MODULE_10__components_campaign_DownloadMessagesDialog___default.a,
    BotReportDialog: __WEBPACK_IMPORTED_MODULE_11__components_campaign_BotReportDialog___default.a,
    ProfileDetailDialog: __WEBPACK_IMPORTED_MODULE_12__components_profile_ProfileDetailDialog___default.a,
    CampaignFilter: __WEBPACK_IMPORTED_MODULE_14__components_campaign_CampaignFilter___default.a,
    Paginator: __WEBPACK_IMPORTED_MODULE_15__components_common_Paginator___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDialogMixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('channel', ['addingInstagramChannel', 'addingTwitterChannel']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('campaign', ['filterTitle', 'filterType', 'filterIsActive', 'filterSortBy', 'filterPage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('survey', ['surveys', 'downloadingResponses', 'downloadingResponsesFailed', 'downloadingResponsesSucceeded'])),

  beforeDestroy: function beforeDestroy() {
    this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_22__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], false);
  },


  data: function data() {
    return {
      campaignList: [],
      moment: __WEBPACK_IMPORTED_MODULE_3_moment___default.a,
      campaignManageVisible: false,
      randomSelectVisible: false,
      randomSelectionsVisible: false,
      randomSelectCampaignId: 0,
      downloadMessagesVisible: false,
      downloadBotReportVisible: false,
      downloadMessagesCampaignId: 0,
      downloadMessagesCampaignTitle: '',
      campaignToEdit: null,
      editCampaign: false,
      selectedCampaignForProfile: 0,
      selectedChannelLink: []
    };
  },

  apollo: {
    campaignList: {
      query: __WEBPACK_IMPORTED_MODULE_21__graphql_campaignList_gql___default.a,
      prefetch: true,
      variables: function variables() {
        return {
          filterTitle: this.filterTitle,
          filterType: this.filterType,
          filterLive: this.filterIsActive,
          filterSortBy: this.filterSortBy,
          page: this.filterPage
        };
      }
    }
  },
  methods: {
    handleSelectProfile: function handleSelectProfile(event) {
      this.selectedCampaignForProfile = event.campaignId;
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_22__store_modules_profile_mutation_types__["f" /* SELECT_PROFILES_PROFILE */], event.profile);
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_22__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], true);
    },
    displayReplyMessage: function displayReplyMessage(replyMessage) {
      if (replyMessage) {
        return replyMessage.text;
      }
      return '';
    },
    handleNextPage: function handleNextPage() {
      this.handleGoToPage(this.filterPage + 1);
    },
    handlePreviousPage: function handlePreviousPage() {
      this.handleGoToPage(this.filterPage - 1);
    },
    handleGoToPage: function handleGoToPage(page) {
      this.$store.commit('campaign/' + __WEBPACK_IMPORTED_MODULE_16__store_modules_campaign_mutation_types__["z" /* SET_CAMPAIGN_PAGE */], page);
    },
    handleCreateCampaign: function handleCreateCampaign() {
      this.campaignToEdit = '';
      this.editCampaign = false;
      this.campaignManageVisible = true;
    },
    handleCampaignEdit: function handleCampaignEdit(campaignId) {
      this.campaignToEdit = campaignId;
      this.editCampaign = true;
      this.campaignManageVisible = true;
    },
    handleCreateCampaignVisibilityChanged: function handleCreateCampaignVisibilityChanged(visibility) {
      this.campaignManageVisible = visibility;
    },
    handleRandomSelectVisibilityChanged: function handleRandomSelectVisibilityChanged(visibility) {
      this.randomSelectVisible = visibility;
    },
    handleRandomSelectionsVisibilityChanged: function handleRandomSelectionsVisibilityChanged(visibility) {
      this.randomSelectionsVisible = visibility;
    },
    handleDownloadMessagesVisibilityChanged: function handleDownloadMessagesVisibilityChanged(visibility) {
      this.downloadMessagesVisible = visibility;
    },
    handleDownloadBotReportVisibilityChanged: function handleDownloadBotReportVisibilityChanged(visibility) {
      this.downloadBotReportVisible = visibility;
    },
    handleCampaignCreated: function handleCampaignCreated() {
      this.campaignManageVisible = false;
      this.$apollo.queries.campaignList.refetch();
    },
    handleRequestTwitterAuth: function handleRequestTwitterAuth() {
      this.$store.dispatch('channel/addTwitterChannel', this.me.id);
    },
    handleRequestInstagramAuth: function handleRequestInstagramAuth() {
      this.$store.dispatch('channel/addInstagramChannel', this.me.id);
    },
    handleRandomSelect: function handleRandomSelect(campaignId) {
      this.randomSelectVisible = true;
      this.randomSelectCampaignId = parseInt(campaignId, 10);
    },
    handleRandomSelections: function handleRandomSelections(campaignId) {
      this.randomSelectionsVisible = true;
      this.randomSelectCampaignId = parseInt(campaignId, 10);
    },
    handleDownloadMessages: function handleDownloadMessages(channelLinks) {
      this.selectedChannelLink = channelLinks;
      this.downloadMessagesVisible = true;
    },
    handleExportSurveyData: function handleExportSurveyData(survey) {
      this.$store.dispatch('survey/downloadSurveyReport', survey);
    },
    handleDownloadBotReport: function handleDownloadBotReport(channelLinks) {
      this.selectedChannelLink = channelLinks;
      this.downloadBotReportVisible = true;
    },
    handleUnlink: function handleUnlink(linkId, campaignId) {
      var _this = this;

      this.$confirm('This will permanently unlink this channel?', 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.$apollo.mutate({
          mutation: __WEBPACK_IMPORTED_MODULE_18__graphql_unlinkChannel_gql___default.a,
          variables: {
            linkId: linkId
          },
          update: function update(store) {
            var data = store.readQuery(_this.listQuery());
            var campaign = data.campaignList.objects.find(function (c) {
              return c.id === campaignId;
            });
            var links = campaign.linkedcampaignchannelSet.filter(function (l) {
              return parseInt(l.id, 10) !== parseInt(linkId, 10);
            });
            campaign.linkedcampaignchannelSet = links;
            store.writeQuery(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.listQuery(), { data: data }));
          }
        });
      });
    },
    handleFavourite: function handleFavourite(isFavourite, campaignId) {
      var _this2 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_19__graphql_favouriteCampaign_gql___default.a,
        variables: {
          id: campaignId,
          isFavourite: isFavourite
        },
        update: function update(store) {
          var data = store.readQuery(_this2.listQuery());
          var campaign = data.campaignList.objects.find(function (c) {
            return c.id === campaignId;
          });
          campaign.favourite = isFavourite;

          // Sort the campaigns by favourites
          data.campaignList.objects.sort(function (a, b) {
            if (a.favourite === b.favourite) {
              return 0;
            } else if (a.favourite) {
              return -1;
            }
            return 1;
          });

          store.writeQuery(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.listQuery(), { data: data }));
        }
      });
    },
    handleToggleLiveStatus: function handleToggleLiveStatus(isLive, campaignId) {
      var _this3 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_20__graphql_liveCampaign_gql___default.a,
        variables: {
          id: campaignId,
          isLive: isLive
        },
        update: function update(store) {
          var data = store.readQuery(_this3.listQuery());
          var campaign = data.campaignList.objects.find(function (c) {
            return c.id === campaignId;
          });
          campaign.live = isLive;
          store.writeQuery(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.listQuery(), { data: data }));
        }
      });
    },
    handleFilter: function handleFilter(_ref) {
      var title = _ref.title,
          type = _ref.type,
          isActive = _ref.isActive,
          sortBy = _ref.sortBy;

      this.$store.commit('campaign/' + __WEBPACK_IMPORTED_MODULE_16__store_modules_campaign_mutation_types__["y" /* SET_CAMPAIGN_FILTERS */], {
        title: title,
        type: type,
        isActive: isActive,
        sortBy: sortBy
      });
    },
    listQuery: function listQuery() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_21__graphql_campaignList_gql___default.a,
        variables: {
          filterTitle: this.filterTitle,
          filterType: this.filterType,
          filterLive: this.filterIsActive,
          filterSortBy: this.filterSortBy,
          page: this.filterPage
        }
      };
    },
    getSurvey: function getSurvey(id) {
      return this.surveys.find(function (survey) {
        return survey.id === id;
      });
    },
    getBotsLinks: function getBotsLinks(channelLinks) {
      return channelLinks.filter(function (handle) {
        return handle.channel.handle.match(/(\*[\d]+)+#/g);
      });
    }
  },
  mounted: function mounted() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["has"])(this.$route.query, 'create')) this.handleCreateCampaign();
  }
});

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_duration_format__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_duration_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetrend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Growth__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Growth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_Growth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_NoData__ = __webpack_require__(2926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_NoData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_NoData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_campaign_CampaignEngager__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_campaign_CampaignEngager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_campaign_CampaignEngager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDetailDialog__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDetailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDetailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_analytics_charts_AnalyticsChart__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_analytics_charts_AnalyticsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_analytics_charts_AnalyticsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_analytics_charts_AnalyticsTimeSeriesAreaChart__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_analytics_charts_AnalyticsTimeSeriesAreaChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanel__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_modules_interaction_mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_modules_profile_mutation_types__ = __webpack_require__(193);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignDetail',
  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_5_vuetrend__["a" /* default */],

    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_7__components_common_ContentPlaceholder___default.a,
    Growth: __WEBPACK_IMPORTED_MODULE_8__components_common_Growth___default.a,
    IBox: __WEBPACK_IMPORTED_MODULE_9__components_common_IBox___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default.a,
    NoData: __WEBPACK_IMPORTED_MODULE_11__components_common_NoData___default.a,
    Engager: __WEBPACK_IMPORTED_MODULE_12__components_campaign_CampaignEngager___default.a,

    ProfileDetailDialog: __WEBPACK_IMPORTED_MODULE_13__components_profile_ProfileDetailDialog___default.a,
    AnalyticsChart: __WEBPACK_IMPORTED_MODULE_14__components_analytics_charts_AnalyticsChart___default.a,
    AnalyticsTimeSeriesAreaChart: __WEBPACK_IMPORTED_MODULE_15__components_analytics_charts_AnalyticsTimeSeriesAreaChart___default.a,
    MessagePanel: __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanel___default.a,
    SocialIcon: __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_SocialIcon___default.a
  },
  data: function data() {
    return {
      dates: '',
      winners: '',
      dialogVisible: false,
      selectorDateRange: '',
      randomSelectorDialogVisible: false
    };
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    campaign: {
      type: Object,
      default: function _default() {}
    },
    campaignReportData: {
      type: Object,
      default: function _default() {}
    },
    loadingCampaignReport: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Object,
      default: function _default() {}
    },
    channelTypes: {
      type: Object,
      default: function _default() {}
    },
    replyMessage: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_17__store_modules_interaction_mutation_types__["x" /* ADD_MANUAL_PANEL */], this.panelSettings);
    this.$store.dispatch('interaction/fetchPanelInteractions', [this.panelSettings.uuid, null, 1]);
  },
  destroyed: function destroyed() {
    this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_17__store_modules_interaction_mutation_types__["y" /* REMOVE_MANUAL_PANEL */], this.panelSettings);
    this.$store.dispatch('interaction/clearDashboardPanelPaused');
    this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_18__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], false);
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('interaction', ['interactions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('interaction', ['loadingInteractions', 'hasMoreInteractions', 'loadingInteractionsSuccess', 'panelPaused']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('profile', ['selectedProfile', 'profileDialogVisible']), {
    panelSettings: function panelSettings() {
      return {
        uuid: 'campaign-panel-' + this.id,
        type: 'campaign',
        settings: {
          name: 'Recent Messages',
          campaign_ids: [this.id]
        }
      };
    },
    channelTypeChartData: function channelTypeChartData() {
      var _this = this;

      var data = this.campaignReportData.totals.total_vs_unique_channel_type;
      var totals = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).map(function (k) {
        return [k, _this.campaignReportData.totals.total_vs_unique_channel_type[k].total];
      });

      // Remove totals with 0
      return totals.filter(function (t) {
        return t[1] > 0;
      });
    },


    fileName: {
      get: function get() {
        var title = this.randomSelectorDialogVisible ? 'Random Selector' : 'Interactions';
        var data = this.campaignDetails(this.campaign.channel_data.links);
        return '-' + this.campaign.title + ' ' + data.map(function (channels) {
          return channels.channel_type_title;
        }) + '-' + title;
      },
      set: function set(newVal) {
        this.fileName = newVal;
      }
    },

    typesOfChannels: {
      get: function get() {
        var data = this.campaignDetails(this.campaign.channel_data.links);
        return '-' + data.map(function (types) {
          return types.handle;
        });
      },
      set: function set(newVal) {
        this.value = newVal;
      }
    },

    isDisabled: function isDisabled() {
      return this.dates === '';
    },
    isRandomDisabled: function isRandomDisabled() {
      return this.selectorDateRange === '';
    },
    hasChannelLinks: function hasChannelLinks() {
      return 'links' in this.campaign.channel_data;
    }
  }),
  methods: {
    convertMillisecondsToMomentDuration: function convertMillisecondsToMomentDuration(milliseconds) {
      __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration.format = __WEBPACK_IMPORTED_MODULE_4_moment_duration_format___default.a;
      var duration = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(milliseconds * 1000, 'milliseconds').format('d h:m:s');
      if (duration === '0') {
        return {
          duration_days: '90',
          duration_hours: '0',
          duration_minutes: '0',
          duration_seconds: '0'
        };
      }
      return {
        duration_days: duration.split(' ')[0] + ' days',
        duration_hours: duration.split(' ')[1].split(':')[0] + ' hours',
        duration_minutes: duration.split(' ')[1].split(':')[1] + ' minutes',
        duration_seconds: duration.split(' ')[1].split(':')[2] + ' seconds'
      };
    },
    panelHasMoreInteractions: function panelHasMoreInteractions(panelId) {
      return this.hasMoreInteractions[panelId] !== undefined ? this.hasMoreInteractions[panelId] : true;
    },
    getCleanName: function getCleanName(title) {
      return title.split('|')[1] || ' -- ';
    },
    takeCampaignOffline: function takeCampaignOffline() {
      this.showCampaignPopover = false;
      this.selectedCampaign.live = false;
      this.$message({
        message: this.selectedCampaign.title + ' is now offline',
        type: 'success'
      });
      this.selectedCampaign = null;
    },
    formatChannelName: function formatChannelName(channelName) {
      return channelName.replace(/_/g, ' ');
    },
    processSparklineData: function processSparklineData(data) {
      return [0].concat(data.map(function (stat) {
        return stat.total;
      }));
    },
    campaignDetails: function campaignDetails(data) {
      if (!this.hasChannelLinks) return [];

      return data.map(function (c) {
        return {
          channel_type: c.channel_type,
          channel_type_title: c.channel_type_title,
          handle: c.handle,
          keyword: c.keyword
        };
      });
    },
    unpausePanel: function unpausePanel(panelId) {
      this.$store.dispatch('interaction/unpausePanelInteractions', panelId);
    },
    pausePanel: function pausePanel(panelId) {
      this.$store.dispatch('interaction/pausePanelInteractions', panelId);
    },
    handleLoadMore: function handleLoadMore() {
      this.$store.dispatch('interaction/fetchNextPageInteractions', this.panelSettings.uuid);
    },
    handleOpenProfile: function handleOpenProfile(originatorType, originator) {
      this.$store.dispatch('profile/searchProfileForIdentity', [originatorType, originator]);
    },
    handleProfileVisibilityChange: function handleProfileVisibilityChange(visibility) {
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_18__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], visibility);
    },
    handleSelectProfile: function handleSelectProfile(profile) {
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_18__store_modules_profile_mutation_types__["f" /* SELECT_PROFILES_PROFILE */], profile);
      this.$store.commit('profile/' + __WEBPACK_IMPORTED_MODULE_18__store_modules_profile_mutation_types__["h" /* SHOW_PROFILES_DIALOG */], true);
    },
    handleChannelType: function handleChannelType(channelType) {
      return channelType.toLowerCase() === 'data import' ? 'Import' : channelType;
    }
  }
});

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profile_profileUtils__ = __webpack_require__(337);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Engager',
  props: ['profile'],

  data: function data() {
    return {
      showFallbackProfileImage: false
    };
  },

  computed: {
    engagerData: function engagerData() {
      return {
        name: this.getDataItem('personal', 'name'),
        identifier: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_profile_profileUtils__["d" /* getPrimaryIdentifier */])(this.profile),
        profileImg: this.getDataItem('personal', 'profile_image', this.identicon),
        count: this.profile.count
      };
    },
    identicon: function identicon() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_profile_profileUtils__["b" /* getProfileIdenticon */])(this.profile);
    }
  },

  methods: {
    getDataItem: function getDataItem(profileSection, property, defaultValue) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_profile_profileUtils__["a" /* getDataItem */])(this.profile, profileSection, property, defaultValue);
    },
    imageLoadError: function imageLoadError() {
      this.showFallbackProfileImage = true;
    }
  }
});

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable space-before-function-paren, func-names, prefer-arrow-callback */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignFilter',
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default.a
  },
  data: function data() {
    return {
      campaignTypeList: [{ type: null, title: 'All' }, { type: 'message_board', title: 'Message boards' }, { type: 'competition', title: 'Competitions' }, { type: 'poll', title: 'Poll' }, { type: 'survey', title: 'Survey' }, { type: 'instant_poll', title: 'Instant Polls' }],
      campaignSortByList: [{ type: 'start_date_ascending', title: 'Start date - Earliest to Latest' }, { type: 'start_date_descending', title: 'Start date - Latest to Earliest' }, { type: 'end_date_ascending', title: 'End date - Earliest to Latest' }, { type: 'end_date_descending', title: 'End date - Latest to Earliest' }, { type: 'title_ascending', title: 'Title - A to Z' }, { type: 'title_descending', title: 'Title - Z to A' }],
      currentFilters: {
        title: null,
        type: null,
        isActive: null,
        sortBy: null
      },
      hasFiltered: {
        title: false,
        type: false,
        isActive: false,
        sortBy: false
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('campaign', ['filterTitle', 'filterType', 'filterIsActive', 'filterSortBy']), {

    currentTitle: {
      get: function get() {
        return this.hasFiltered.title ? this.currentFilters.title : this.filterTitle;
      },
      set: function set(title) {
        this.currentFilters.title = title;
        this.hasFiltered.title = true;
      }
    },

    currentType: {
      get: function get() {
        return this.hasFiltered.type ? this.currentFilters.type : this.filterType;
      },
      set: function set(type) {
        this.currentFilters.type = type;
        this.hasFiltered.type = true;
      }
    },

    currentIsActive: {
      get: function get() {
        return this.hasFiltered.isActive ? this.currentFilters.isActive : this.filterIsActive;
      },
      set: function set(isActive) {
        this.currentFilters.isActive = isActive;
        this.hasFiltered.isActive = true;
      }
    },

    currentSortBy: {
      get: function get() {
        return this.hasFiltered.sortBy ? this.currentFilters.sortBy : this.filterSortBy;
      },
      set: function set(sortBy) {
        this.currentFilters.sortBy = sortBy;
        this.hasFiltered.sortBy = true;
      }
    }
  }),
  methods: {
    handleFilter: function handleFilter() {
      this.$emit('onFilter', {
        title: this.currentTitle,
        type: this.currentType,
        isActive: this.currentIsActive,
        sortBy: this.currentSortBy
      });
    },

    handleDebounceFilter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      this.handleFilter();
    }, 500)
  }
});

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_taxonomies_TaxonomySelect__ = __webpack_require__(3082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_taxonomies_TaxonomySelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_taxonomies_TaxonomySelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelSelect__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_polls_PollChoiceInput__ = __webpack_require__(2975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_polls_PollChoiceInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_polls_PollChoiceInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_duration_format__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_duration_format__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelType\n            channelTypeTitle\n          }\n        }\n      '], ['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelType\n            channelTypeTitle\n          }\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignForm',

  components: {
    ChannelSelect: __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelSelect___default.a,
    TaxonomySelect: __WEBPACK_IMPORTED_MODULE_1__components_taxonomies_TaxonomySelect___default.a,
    SocialIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default.a,
    PollChoiceInput: __WEBPACK_IMPORTED_MODULE_4__components_polls_PollChoiceInput___default.a
  },

  props: {
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    plugins: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    createChannels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    campaignToEdit: {
      type: Object,
      required: false
    },
    isEditing: {
      type: Boolean,
      required: false
    }
  },

  data: function data() {
    var _this = this;

    var validateReplyMessage = function validateReplyMessage(rule, value, callback) {
      if (_this.encryptOriginator) {
        var vars = _this.replyMessage.match(/{\s*[\w.]+\s*}/g);
        if (vars && vars.length) {
          callback();
        } else {
          callback(new Error('Please add a hash id to your message'));
        }
      } else {
        callback();
      }
    };

    return {
      campaignForm: {
        campaignTitle: '',
        campaignDates: [],
        campaignType: null,
        pollQuestion: '',
        perpetual: false,
        pollChoices: [{ choice: '', matches: [] }],
        channelKeyword: [],
        channels: [],
        campaignWinningQualificationDuration: '',
        duration_days: 0,
        duration_hours: 0,
        duration_minutes: 0,
        duration_seconds: 0
      },
      nextTick: '',
      keywordInputVisible: false,
      keyword: '',
      smsReplyCredentialsForm: {
        username: '',
        password: ''
      },
      showSmsCredentialsDialog: false,
      replyBoundSMSChannels: ['SMS', 'Dms', 'Infobip', 'Mtech', 'CellFind'],
      smsReplyCredentialsRequired: ['Dms', 'Infobip', 'Mtech'],
      // prettier-ignore
      smsCredentialsrules: {
        username: [{ required: true, message: 'Please input the username' }],
        password: [{ required: true, message: 'Please input your password' }]
      },
      rules: {
        campaignTitle: [{ required: true, message: 'Please input the name of your campaign' }],
        campaignDates: [{ required: true, message: 'Please select the date range for your campaign' }],
        campaignType: [{ required: true, message: 'Please select the type of campaign you wish to run' }],
        pollQuestion: [{ required: true, message: 'Poll question is required.' }],
        replyMessage: [{ validator: validateReplyMessage, trigger: 'change' }]
      },
      campaignTypeOptions: [{ label: 'Message Board', value: 'MESSAGE_BOARD' }, { label: 'Competition', value: 'COMPETITION' }, { label: 'Poll', value: 'POLL' }, { label: 'Survey', value: 'SURVEY' }, { label: 'Instant Poll', value: 'INSTANT_POLL' }],
      campaign: {
        details: {},
        advertiser: {
          category: null,
          prizeCategory: null
        },
        channels: [],
        keyword: '',
        perpetual: false
      },
      showReplyMessageBox: false,
      replyMessage: '',
      encryptOriginator: false,
      pollCampaignTypes: ['POLL', 'INSTANT_POLL']
    };
  },

  apollo: {
    channelList: {
      query: __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject)
    }
  },

  computed: {
    canEncryptOriginators: function canEncryptOriginators() {
      return this.plugins.map(function (plugin) {
        return plugin.plugin_route;
      }).includes('app.campaigns.encrypt_originators');
    },
    smsCount: function smsCount() {
      var maxLength = 160;
      var messCount = Math.floor(this.replyMessage.length / maxLength) + 1;
      var charCount = maxLength - (this.replyMessage.length - maxLength * (messCount - 1));
      return charCount + '/' + messCount;
    },
    smsChannelSelected: function smsChannelSelected() {
      var _this2 = this;

      var selectedSMSChannels = this.channels.filter(function (channel) {
        return _this2.campaignForm.channels.includes(String(channel.id));
      }).filter(function (channel) {
        return _this2.replyBoundSMSChannels.includes(channel.channelTypeTitle);
      });
      return selectedSMSChannels.length > 0;
    }
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.campaignForm.channelKeyword.splice(this.campaignForm.channelKeyword.indexOf(tag), 1);
    },
    handleChangeCampaignDate: function handleChangeCampaignDate(startDate) {
      this.campaignForm.campaignDates = [startDate, __WEBPACK_IMPORTED_MODULE_6_moment___default()(startDate).add(100, 'years')];
    },
    clearCampaignDates: function clearCampaignDates() {
      this.campaignForm.campaignDates = [];
    },
    showInput: function showInput() {
      var _this3 = this;

      this.keywordInputVisible = true;
      this.$nextTick(function (tick) {
        _this3.nextTick = tick;
        _this3.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var keyword = this.keyword;
      if (keyword) {
        this.campaignForm.channelKeyword.push(keyword);
      }
      this.keywordInputVisible = false;
      this.keyword = '';
    },
    range: function range(start, end) {
      return Array(end - start + 1).fill().map(function (_, idx) {
        return start + idx;
      });
    },
    handleSelectedChannelsChanged: function handleSelectedChannelsChanged(selectedChannels) {
      var _this4 = this;

      this.campaignForm.channels = selectedChannels;
      this.showSmsCredentialsDialog = this.channels.filter(function (channel) {
        return _this4.campaignForm.channels.includes(String(channel.id));
      }).filter(function (channel) {
        return _this4.smsReplyCredentialsRequired.includes(channel.channelTypeTitle);
      }).length > 0;
    },
    handleRequestTwitterAuth: function handleRequestTwitterAuth() {
      this.$emit('onRequestTwitterAuth');
    },
    handleRequestInstagramAuth: function handleRequestInstagramAuth() {
      this.$emit('onRequestInstagramAuth');
    },
    handleRequestFacebookAuth: function handleRequestFacebookAuth() {
      this.$emit('onRequestFacebookAuth');
    },
    handleRequestEmailChannelCreate: function handleRequestEmailChannelCreate() {
      this.$emit('onRequestEmailChannelCreate');
    },
    handleRequestWhatsappChannelCreate: function handleRequestWhatsappChannelCreate() {
      this.$emit('onRequestWhatsappChannelCreate');
    },
    handleCancel: function handleCancel() {
      this.$emit('onFormCancel');
    },
    handleAddPollChoice: function handleAddPollChoice() {
      this.campaignForm.pollChoices.push({ choice: '', matches: [] });
    },
    handleChoiceRemove: function handleChoiceRemove(idx) {
      this.campaignForm.pollChoices.splice(idx, 1);
    },
    handleFormSave: function handleFormSave() {
      var _this5 = this;

      this.$refs.campaignForm.validate(function (valid) {
        if (valid) {
          return _this5.saveForm();
        }

        return false;
      });
    },
    handleConfirmSmsCredential: function handleConfirmSmsCredential() {
      var _this6 = this;

      this.$refs.smsReplyCredentialsForm.validate(function (valid) {
        if (valid) {
          _this6.showSmsCredentialsDialog = false;
          return true;
        }
        return false;
      });
    },
    saveForm: function saveForm() {
      var winningDisqualificationInMilliSeconds = this.convertToMilliseconds();
      if (winningDisqualificationInMilliSeconds === 0) winningDisqualificationInMilliSeconds = null;

      var campaignData = {
        id: this.isEditing ? parseInt(this.campaignToEdit.id, 10) : null,
        title: this.campaignForm.campaignTitle,
        startDate: this.campaignForm.campaignDates[0],
        endDate: this.campaignForm.campaignDates[1],
        campaignType: this.campaignForm.campaignType,
        winningDisqualificationDuration: winningDisqualificationInMilliSeconds,
        default: false,
        perpetual: this.campaignForm.perpetual,
        live: true
      };

      var pollData = {
        question: this.campaignForm.pollQuestion,
        choices: this.campaignForm.pollChoices
      };

      var channelData = {
        keywords: this.getKeywords(),
        channels: this.campaignForm.channels
      };

      var replyMessageData = {
        text: this.replyMessage,
        encryptOriginator: this.encryptOriginator
      };

      var replyMessageCredentialsData = {
        username: this.smsReplyCredentialsForm.username,
        password: this.smsReplyCredentialsForm.password
      };

      this.$emit('onFormSave', {
        campaignData: campaignData,
        channelData: channelData,
        pollData: pollData,
        replyMessageData: replyMessageData,
        isEditing: this.isEditing,
        replyMessageCredentialsData: replyMessageCredentialsData
      });
    },
    getKeywords: function getKeywords() {
      return this.campaignForm.channelKeyword.length ? this.campaignForm.channelKeyword : [this.keyword];
    },
    convertToMilliseconds: function convertToMilliseconds() {
      var valueInMilliseconds = 0;
      valueInMilliseconds = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration({
        seconds: this.campaignForm.duration_seconds !== undefined ? this.campaignForm.duration_seconds.toString().replace(' seconds', '') : '',
        minutes: this.campaignForm.duration_minutes !== undefined ? this.campaignForm.duration_minutes.toString().replace(' minutes', '') : '',
        hours: this.campaignForm.duration_hours !== undefined ? this.campaignForm.duration_hours.toString().replace(' hours', '') : '',
        days: this.campaignForm.duration_days !== undefined ? this.campaignForm.duration_days.toString().replace(' days', '') : ''
      }).asMilliseconds();
      return valueInMilliseconds;
    },
    convertMillisecondsToMomentDuration: function convertMillisecondsToMomentDuration(milliseconds) {
      __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration.format = __WEBPACK_IMPORTED_MODULE_7_moment_duration_format___default.a;
      var duration = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration(milliseconds, 'milliseconds').format('d h:m:s');
      if (duration === '0') {
        return {
          duration_days: '90',
          duration_hours: '0',
          duration_minutes: '0',
          duration_seconds: '0'
        };
      }
      return {
        duration_days: duration.split(' ')[0] + ' days',
        duration_hours: duration.split(' ')[1].split(':')[0] + ' hours',
        duration_minutes: duration.split(' ')[1].split(':')[1] + ' minutes',
        duration_seconds: duration.split(' ')[1].split(':')[2] + ' seconds'
      };
    },

    /**
     * Campaign Edit methods.
     * Map campaign details to campaignForm fields.
     */
    mapCampaignDetails: function mapCampaignDetails() {
      var campaign = this.campaignToEdit;
      var durationMilliseconds = campaign.winningDisqualificationDuration;
      this.campaignForm.campaignType = campaign.campaignType;
      this.campaignForm.campaignTitle = campaign.title;
      this.campaignForm.campaignDates = [campaign.startDate, campaign.endDate];
      this.campaignForm.duration_days = this.convertMillisecondsToMomentDuration(durationMilliseconds).duration_days;
      this.campaignForm.duration_hours = this.convertMillisecondsToMomentDuration(durationMilliseconds).duration_hours;
      this.campaignForm.duration_minutes = this.convertMillisecondsToMomentDuration(durationMilliseconds).duration_minutes;
      this.campaignForm.duration_seconds = this.convertMillisecondsToMomentDuration(durationMilliseconds).duration_seconds;

      if (campaign.replymessage && campaign.replymessage.text) {
        this.replyMessage = campaign.replymessage.text;
        this.encryptOriginator = campaign.replymessage.encryptOriginator;
      }

      if (campaign.linkedcampaignchannelSet && campaign.linkedcampaignchannelSet.length) {
        this.mapLinkedCampaignChannels(campaign.linkedcampaignchannelSet);
      }

      if (this.pollCampaignTypes.includes(campaign.campaignType) && campaign.pollSet.length) {
        this.mapCampaignPollDetails(campaign.pollSet[0]);
      }
    },


    /**
     * Map Poll details to campaignForm fields.
     * */
    mapCampaignPollDetails: function mapCampaignPollDetails(pollSet) {
      this.campaignForm.pollQuestion = pollSet.question;
      this.campaignForm.pollChoices = pollSet.pollchoiceSet.map(function (_ref) {
        var choice = _ref.choice,
            matches = _ref.matches;
        return {
          choice: choice,
          matches: matches
        };
      });
    },


    /**
     * Map campaign channels to campaignForm channel input.
     * */
    mapLinkedCampaignChannels: function mapLinkedCampaignChannels(linkedCampaignChannels) {
      var keywords = linkedCampaignChannels.map(function (x) {
        return x.keyword;
      });
      this.campaignForm.channelKeyword = keywords.filter(function (item, idx) {
        return keywords.indexOf(item) === idx;
      });
      this.campaignForm.channels = linkedCampaignChannels.map(function (x) {
        return x.channel.id;
      });
    }
  },

  /**
   * Doing this in mounted hook since a watcher will not fire correctly
   * because the prop is being passed down from the parent.
   * */
  mounted: function mounted() {
    if (this.isEditing) {
      this.mapCampaignDetails();
    } else if (this.$refs.campaignForm && this.$refs.campaignForm.resetFields) {
      this.$refs.campaignForm.resetFields();
    }
  }
});

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jdenticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_Trend__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_Trend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_Trend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Growth__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Growth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Growth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignEngager__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignEngager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignEngager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_ChannelToCampaignLinkItem__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_ChannelToCampaignLinkItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_campaign_ChannelToCampaignLinkItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignListItem',
  components: {
    Can: __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default.a,
    Trend: __WEBPACK_IMPORTED_MODULE_1__components_charts_Trend___default.a,
    Growth: __WEBPACK_IMPORTED_MODULE_3__components_common_Growth___default.a,
    Engager: __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignEngager___default.a,
    ChannelToCampaignLinkItem: __WEBPACK_IMPORTED_MODULE_5__components_campaign_ChannelToCampaignLinkItem___default.a
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    live: {
      type: Boolean,
      default: false
    },
    perpetual: {
      type: Boolean,
      default: false
    },
    campaignType: {
      type: String,
      default: 'MESSAGE_BOARD'
    },
    startDate: {
      type: Object,
      required: true
    },
    endDate: {
      type: Object,
      required: true
    },
    createdBy: {
      type: Object,
      default: function _default() {
        return { displayName: '' };
      }
    },
    advertiser: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: 0
    },
    totalMessages: {
      type: Number,
      default: 0
    },
    uniqueMessages: {
      type: Number,
      default: 0
    },
    totalThisMonth: {
      type: Number,
      default: 0
    },
    totalPerDayThisMonth: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    channelLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    replyMessage: {
      type: String,
      default: ''
    },
    growth: {
      type: Number,
      default: 0
    },
    isFavourite: {
      type: Boolean,
      default: false
    },
    topEngagers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    survey: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    leadCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    adjustedProgress: function adjustedProgress() {
      return this.progress >= 100 ? 100 : this.progress;
    }
  },
  methods: {
    identicon: function identicon(originator) {
      return __WEBPACK_IMPORTED_MODULE_0_jdenticon___default.a.toSvg(originator, 128);
    },
    handleUnlink: function handleUnlink(linkId) {
      this.$emit('onUnlink', linkId);
    },
    handleToggleFavourite: function handleToggleFavourite() {
      this.$emit('onFavourite', !this.isFavourite);
    },
    handleCommand: function handleCommand(command) {
      var commands = {
        'edit-campaign': this.handleCampaignEdit,
        'campaign-report': this.handleCampaignReport,
        'random-select': this.handleRandomSelect,
        'random-selection': this.handleRandomSelecttion,
        'download-messages': this.handleDownloadMessages,
        'survey-report': this.handleSurveyReport,
        'bot-report': this.handleDownloadBotReport,
        'toggle-live-status': this.handleToggleCampaignStatus
      };
      return commands[command]();
    },
    handleRandomSelect: function handleRandomSelect() {
      this.$emit('onRandomSelect');
    },
    handleRandomSelecttion: function handleRandomSelecttion() {
      this.$emit('onRandomSelections');
    },
    handleDownloadMessages: function handleDownloadMessages() {
      this.$emit('onDownloadMessages', this.channelLinks);
    },
    handleSurveyReport: function handleSurveyReport() {
      this.$emit('onExportSurveyData', this.survey);
    },
    handleDownloadBotReport: function handleDownloadBotReport() {
      this.$emit('onDownloadBotReport', this.channelLinks);
    },
    handleCampaignReport: function handleCampaignReport() {
      this.$router.push({ path: '/campaigns/' + this.id });
    },
    handleCampaignEdit: function handleCampaignEdit() {
      this.$emit('onEditCampaign');
    },
    handleToggleCampaignStatus: function handleToggleCampaignStatus() {
      this.$emit('onToggleLiveStatus', !this.live);
    },
    showProfileDialog: function showProfileDialog(profile) {
      var campaignId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.$emit('onSelectProfile', { profile: profile, campaignId: campaignId });
    }
  }
});

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignForm__ = __webpack_require__(2904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_facebook_FacebookCreateDialog__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_facebook_FacebookCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_channel_facebook_FacebookCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_instagram_InstagramCreateDialog__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_instagram_InstagramCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_channel_instagram_InstagramCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_channel_email_EmailChannelCreateDialog__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_channel_email_EmailChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_channel_email_EmailChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_channel_mutation_types__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_createCompetitionCampaign_gql__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_createCompetitionCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__graphql_createCompetitionCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_createPollCampaign_gql__ = __webpack_require__(2598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_createPollCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__graphql_createPollCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_createMessageBoardCampaign_gql__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_createMessageBoardCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__graphql_createMessageBoardCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_updateCompetitionCampaign_gql__ = __webpack_require__(2644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_updateCompetitionCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__graphql_updateCompetitionCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_updatePollCampaign_gql__ = __webpack_require__(2646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_updatePollCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__graphql_updatePollCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__graphql_updateMessageBoardCampaign_gql__ = __webpack_require__(2645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__graphql_updateMessageBoardCampaign_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__graphql_updateMessageBoardCampaign_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_campaignEditQuery_gql__ = __webpack_require__(2586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_campaignEditQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__graphql_campaignEditQuery_gql__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      '], ['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignManage',

  components: {
    CampaignForm: __WEBPACK_IMPORTED_MODULE_5__components_campaign_CampaignForm___default.a,
    FacebookCreateDialog: __WEBPACK_IMPORTED_MODULE_6__components_channel_facebook_FacebookCreateDialog___default.a,
    InstagramCreateDialog: __WEBPACK_IMPORTED_MODULE_7__components_channel_instagram_InstagramCreateDialog___default.a,
    EmailChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_8__components_channel_email_EmailChannelCreateDialog___default.a,
    WhatsappWebChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_9__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default.a
  },

  data: function data() {
    return {
      channelList: [],
      showFacebookCreateDialog: false,
      showInstagramCreateDialog: false,
      showEmailCreateDialog: false,
      showWhatsappCreateDialog: false,
      showCampaignForm: false,
      campaignData: null,
      mutationLoading: false
    };
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },

    addingInstagramChannel: {
      type: Boolean,
      required: false
    },

    addingTwitterChannel: {
      type: Boolean,
      required: false
    },

    campaignToEdit: {
      type: String,
      required: false
    },

    editingCampaign: {
      type: Boolean,
      default: false
    },

    me: {
      type: Object,
      required: true
    }
  },

  apollo: {
    channelList: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject)
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('channel', ['selectedChannels']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('plugin', ['plugins']), {

    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }),

  mounted: function mounted() {
    var _this = this;

    this.refetchChannelList();
    if (this.editingCampaign) {
      this.showCampaignForm = false;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_18__graphql_campaignEditQuery_gql___default.a,
        variables: { campaignId: this.campaignToEdit }
      }).then(function (result) {
        _this.campaignData = result.data.campaign;
        _this.showCampaignForm = true;
      }).catch(function (error) {
        _this.$notify({
          title: 'Error!',
          message: 'Unable to load campaign detail: ' + _this.friendlyError(error) + '.',
          type: 'error'
        });
      });
    } else {
      this.showCampaignForm = true;
    }
  },


  methods: {
    /**
     * Creates a campaign of type competition.
     *
     * Competition campaigns include advertiser data.
     *
     * @param campaignData
     * @param advertiserData
     * @param channelData
     * @param replyMessageData
     * @param isEditing
     * @returns {*|void}
     */
    submitCompetitionCampaign: function submitCompetitionCampaign(campaignData, channelData, replyMessageData, isEditing, replyMessageCredentialsData) {
      var _this2 = this;

      this.mutationLoading = true;

      this.$apollo.mutate({
        mutation: isEditing ? __WEBPACK_IMPORTED_MODULE_15__graphql_updateCompetitionCampaign_gql___default.a : __WEBPACK_IMPORTED_MODULE_12__graphql_createCompetitionCampaign_gql___default.a,
        variables: {
          campaignId: isEditing ? campaignData.id : null,
          campaignTitle: campaignData.title,
          campaignStartDate: campaignData.startDate,
          campaignEndDate: campaignData.endDate,
          campaignType: campaignData.campaignType,
          channelKeywords: channelData.keywords.map(function (c) {
            return c.trim();
          }),
          channelIds: channelData.channels.map(function (c) {
            return parseInt(c, 10);
          }),
          perpetual: campaignData.perpetual,
          replyMessage: replyMessageData.text,
          encryptOriginator: replyMessageData.encryptOriginator,
          smsReplyUsername: replyMessageCredentialsData.username,
          smsReplyPassword: replyMessageCredentialsData.password,
          winningDisqualificationDuration: campaignData.winningDisqualificationDuration
        }
      }).then(function () {
        _this2.mutationLoading = false;
        _this2.$emit('onSaved');
        _this2.$notify({
          title: 'Success!',
          message: 'Your competition was ' + (isEditing ? 'updated' : 'created') + ' successfully.',
          type: 'success'
        });
      }).catch(function (error) {
        _this2.mutationLoading = false;
        _this2.$notify({
          title: 'Error!',
          message: 'Unable to ' + (isEditing ? 'update' : 'create') + ' your competition: ' + _this2.friendlyError(error) + '.',
          type: 'error'
        });
      });
    },


    /**
     * Creates a campaign of type Poll.
     *
     * @param campaignData
     * @param channelData
     * @param pollData
     * @param replyMessageData
     * @param isEditing
     * @returns {*|void}
     */
    submitPollCampaign: function submitPollCampaign(campaignData, channelData, pollData, replyMessageData, isEditing, replyMessageCredentialsData) {
      var _this3 = this;

      this.mutationLoading = true;

      this.$apollo.mutate({
        mutation: isEditing ? __WEBPACK_IMPORTED_MODULE_16__graphql_updatePollCampaign_gql___default.a : __WEBPACK_IMPORTED_MODULE_13__graphql_createPollCampaign_gql___default.a,
        variables: {
          campaignId: isEditing ? campaignData.id : null,
          campaignTitle: campaignData.title,
          campaignStartDate: campaignData.startDate,
          campaignEndDate: campaignData.endDate,
          campaignType: campaignData.campaignType,
          perpetual: campaignData.perpetual,
          channelKeywords: channelData.keywords.map(function (c) {
            return c.trim();
          }),
          channelIds: channelData.channels.map(function (c) {
            return parseInt(c, 10);
          }),
          pollQuestion: pollData.question,
          pollChoices: pollData.choices,
          replyMessage: replyMessageData.text,
          encryptOriginator: replyMessageData.encryptOriginator,
          smsReplyUsername: replyMessageCredentialsData.username,
          smsReplyPassword: replyMessageCredentialsData.password,
          winningDisqualificationDuration: campaignData.winningDisqualificationDuration
        }
      }).then(function () {
        _this3.mutationLoading = false;
        _this3.$emit('onSaved');
        _this3.$notify({
          title: 'Success!',
          message: 'Your Poll was ' + (isEditing ? 'updated' : 'created') + ' successfully.',
          type: 'success'
        });
      }).catch(function (error) {
        _this3.mutationLoading = false;
        _this3.$notify({
          title: 'Error!',
          message: 'Unable to ' + (isEditing ? 'update' : 'create') + ' your Poll: ' + _this3.friendlyError(error) + '.',
          type: 'error'
        });
      });
    },


    /**
     * Creates a campaign of type message board.
     *
     * @param campaignData
     * @param channelData
     * @param replyMessageData
     * @param isEditing
     * @returns {*|void}
     */
    submitMessageBoardCampaign: function submitMessageBoardCampaign(campaignData, channelData, replyMessageData, isEditing, replyMessageCredentialsData) {
      var _this4 = this;

      this.mutationLoading = true;
      this.$apollo.mutate({
        mutation: isEditing ? __WEBPACK_IMPORTED_MODULE_17__graphql_updateMessageBoardCampaign_gql___default.a : __WEBPACK_IMPORTED_MODULE_14__graphql_createMessageBoardCampaign_gql___default.a,
        variables: {
          campaignId: isEditing ? campaignData.id : null,
          campaignTitle: campaignData.title,
          campaignStartDate: campaignData.startDate,
          campaignEndDate: campaignData.endDate,
          campaignType: campaignData.campaignType,
          perpetual: campaignData.perpetual,
          channelKeywords: channelData.keywords.map(function (c) {
            return c.trim();
          }),
          channelIds: channelData.channels.map(function (c) {
            return parseInt(c, 10);
          }),
          replyMessage: replyMessageData.text,
          encryptOriginator: replyMessageData.encryptOriginator,
          smsReplyUsername: replyMessageCredentialsData.username,
          smsReplyPassword: replyMessageCredentialsData.password,
          winningDisqualificationDuration: campaignData.winningDisqualificationDuration
        }
      }).then(function () {
        _this4.mutationLoading = false;
        _this4.$emit('onSaved');
        _this4.$notify({
          title: 'Success!',
          message: 'Your message board was ' + (isEditing ? 'updated' : 'created') + ' successfully.',
          type: 'success'
        });
      }).catch(function (error) {
        _this4.mutationLoading = false;
        _this4.$notify({
          title: 'Error!',
          message: 'Unable to ' + (isEditing ? 'update' : 'create') + ' your message board: ' + _this4.friendlyError(error) + '.',
          type: 'error'
        });
      });
    },


    /**
     * Produce a friendly error message to display to a user.
     *
     * @param error: String
     * @returns String
     */
    friendlyError: function friendlyError(error) {
      var errors = {
        'GraphQL error: Cannot create duplicate rows.': 'A campaign with this keyword and channel combination already exists.'
      };
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors).indexOf(error.message) !== -1) {
        return errors[error.message];
      }

      // We didn't get the error message we expected, lets just make it
      // slightly friendlier.
      return error.message.replace('GraphQL error: ', '');
    },
    handleSelectedChannelsChanged: function handleSelectedChannelsChanged(selectedChannels) {
      this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_11__store_modules_channel_mutation_types__["h" /* SET_SELECTED_CHANNELS */], selectedChannels);
    },
    handleRequestTwitterAuth: function handleRequestTwitterAuth() {
      this.$emit('onRequestTwitterAuth');
    },
    handleRequestFacebookAuth: function handleRequestFacebookAuth() {
      this.showFacebookCreateDialog = true;
    },
    handleFacebookVisibilityChange: function handleFacebookVisibilityChange(value) {
      this.showFacebookCreateDialog = value;
    },
    handleRequestInstagramAuth: function handleRequestInstagramAuth() {
      this.showInstagramCreateDialog = true;
    },
    handleInstagramVisibilityChange: function handleInstagramVisibilityChange(value) {
      this.showInstagramCreateDialog = value;
    },
    handleRequestEmailChannelCreate: function handleRequestEmailChannelCreate() {
      this.showEmailCreateDialog = true;
    },
    handleEmailDialogVisibilityChange: function handleEmailDialogVisibilityChange(value) {
      this.showEmailCreateDialog = value;
    },
    handleRequestWhatsappChannelCreate: function handleRequestWhatsappChannelCreate() {
      this.showWhatsappCreateDialog = true;
    },
    handleWhatsappDialogVisibilityChange: function handleWhatsappDialogVisibilityChange(value) {
      this.showWhatsappCreateDialog = value;
    },
    handleFormCancel: function handleFormCancel() {
      this.$emit('onVisibleChanged', false);
    },


    /**
     * Handle the saving of a campaign from data received back from
     * the campaign form.
     *
     * @param campaignData
     * @param channelData
     * @param pollData
     * @param replyMessageData
     * @param isEditing
     * @returns {*|void}
     */
    handleFormSave: function handleFormSave(_ref) {
      var campaignData = _ref.campaignData,
          channelData = _ref.channelData,
          pollData = _ref.pollData,
          replyMessageData = _ref.replyMessageData,
          isEditing = _ref.isEditing,
          replyMessageCredentialsData = _ref.replyMessageCredentialsData;

      if (campaignData.campaignType === 'COMPETITION') {
        return this.submitCompetitionCampaign(campaignData, channelData, replyMessageData, isEditing, replyMessageCredentialsData);
      }

      if (campaignData.campaignType === 'POLL') {
        return this.submitPollCampaign(campaignData, channelData, pollData, replyMessageData, isEditing, replyMessageCredentialsData);
      }

      return this.submitMessageBoardCampaign(campaignData, channelData, replyMessageData, isEditing, replyMessageCredentialsData);
    },
    refetchChannelList: function refetchChannelList() {
      this.$apollo.queries.channelList.refetch();
    }
  },

  watch: {
    addingInstagramChannel: function addingInstagramChannel(adding, oldVal) {
      if (!adding && oldVal) {
        this.refetchChannelList();
      }
    },
    addingTwitterChannel: function addingTwitterChannel(adding, oldVal) {
      if (!adding && oldVal) {
        this.refetchChannelList();
      }
    }
  }
});

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelToCampaignLinkItem',
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a
  },
  props: {
    keyword: {
      type: String,
      default: ''
    },
    channelType: {
      type: String,
      required: true
    },
    handle: {
      type: String,
      required: true
    }
  },
  methods: {
    handleUnlink: function handleUnlink() {
      this.$emit('onUnlink');
    },
    handleChannelType: function handleChannelType(channelType) {
      return channelType.toLowerCase() === 'data import' ? 'Import' : channelType;
    }
  }
});

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(244);





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      '], ['\n        {\n          channelList(live: true) {\n            id\n            handle\n            channelTypeTitle\n          }\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownloadMessagesDialog',
  components: {
    ChannelSelect: __WEBPACK_IMPORTED_MODULE_5__components_channel_ChannelSelect___default.a
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: Number,
      required: true
    },
    campaignTitle: {
      type: String,
      default: 'Campaign'
    },
    channelLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        fileName: '',
        rangeDate: [],
        channels: [],
        channel_types: [],
        unique: false
      },
      rules: {
        fileName: [{ required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' }],

        rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }],

        channels: [{ required: true, trigger: 'change', message: 'Please select at least one channel.' }]
      },
      channelList: [],
      isLoading: false
    };
  },
  apollo: {
    channelList: {
      query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject)
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  },
  methods: {
    handleRunDownloadMessages: function handleRunDownloadMessages() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.validate().catch(function () {
                  return false;
                });

              case 2:
                valid = _context.sent;

                if (valid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                payload = {
                  campaign_id: _this.campaignId,
                  channel_types: _this.form.channel_types,
                  file_name: _this.form.fileName,
                  date_from: _this.form.rangeDate[0],
                  date_to: _this.form.rangeDate[1],
                  unique_originators: false
                };


                _this.isLoading = true;

                _context.prev = 7;
                _context.next = 10;
                return _this.$store.dispatch('campaign/downloadMessages', payload);

              case 10:
                _this.$emit('onVisibleChanged', false);

              case 11:
                _context.prev = 11;

                _this.isLoading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7,, 11, 14]]);
      }))();
    },
    handleSelectedChannelsChanged: function handleSelectedChannelsChanged(selectedChannels) {
      this.form.channels = selectedChannels;
      var selectedChannelTypes = this.channelList.filter(function (channel) {
        return selectedChannels.includes(channel.id);
      }).map(function (channel) {
        return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* channelTypes */][channel.channelTypeTitle.toUpperCase()];
      });
      this.form.channel_types = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(selectedChannelTypes).toJSON();
    },
    handleCancel: function handleCancel() {
      this.$emit('onVisibleChanged', false);
    }
  },
  mounted: function mounted() {
    var filename = this.campaignTitle.replace(/[^\w\d]|[\s]/g, '-').toLowerCase();
    this.form.fileName = (filename + '-interactions').replace(/-{2,}/g, '-');
  }
});

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RandomSelectDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: Number,
      requied: true
    }
  },
  data: function data() {
    return {
      form: {
        fileName: '',
        rangeDate: [],
        uniqueWinners: false,
        winners: 1
      },
      rules: {
        fileName: [{ required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' }],
        rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      isLoading: false
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  },
  methods: {
    handleRunRandomSelection: function handleRunRandomSelection() {
      var _this = this;

      var payload = {
        campaign: this.campaignId,
        file_name: this.form.fileName,
        range_date: this.form.rangeDate,
        unique_winners_flag: this.form.uniqueWinners,
        winners: this.form.winners
      };
      this.isLoading = true;
      this.$forceUpdate();
      return this.$store.dispatch('campaign/runRandomSelector', payload).then(function (data) {
        _this.$emit('onVisibleChanged', false);
        _this.isLoading = false;
        var isEmpty = !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(data.data.selections).some(function (x) {
          return x !== null && x !== '';
        });
        if (isEmpty) {
          // this.warningMessage();
        }
      }).catch(function () {
        _this.isLoading = false;
      });
    },
    warningMessage: function warningMessage() {
      this.$notify({
        title: 'Warning',
        message: 'There are no interactions within the requested time range',
        type: 'warning'
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('onVisibleChanged', false);
    }
  }
});

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: "off" */






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RandomSelectionsDialog',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default.a, Empty: __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default.a },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    campaignId: {
      type: Number,
      requied: true
    }
  },
  data: function data() {
    return {
      selectedWinner: null,
      collapeseTite: 'Show selections'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    dialogVisible: {
      get: function get() {
        this.$store.dispatch('campaign/getRandomSelections', this.campaignId);
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('campaign', ['randomSelections', 'loadingRandomSelections', 'settingRandomSelectionWinner'])),
  methods: {
    formateDate: function formateDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(date)).format('ddd Do MMMM YYYY');
    },
    formatRowDate: function formatRowDate(row, column, cellValue) {
      return this.formatDate(cellValue);
    },
    onSelectWinner: function onSelectWinner(selection) {
      this.selectedWinner = selection;
      this.$store.dispatch('campaign/getRandomSelectionsWinner', selection);
      // this.$forceUpdate();
    },
    handleChange: function handleChange(val) {
      this.collapeseTite = val === 'showSelections' ? 'Hide selections' : 'Show selections';
    },
    isDisqualified: function isDisqualified(date) {
      var dateWon = date;
      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var dif = now.diff(dateWon, 'days');
      return dif <= 90;
    }
  }
});

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_telegram_TelegramNewDialog__ = __webpack_require__(2913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_telegram_TelegramNewDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_channel_telegram_TelegramNewDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_email_EmailChannelCreateDialog__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_email_EmailChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_channel_email_EmailChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_wechat_WechatChannelCreateDialog__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_wechat_WechatChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_channel_wechat_WechatChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__channelCreateMixin__ = __webpack_require__(565);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelCreate',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__channelCreateMixin__["a" /* default */]],
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default.a,
    FacebookCreateDialog: __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog___default.a,
    InstagramCreateDialog: __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog___default.a,
    EmailChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_6__components_channel_email_EmailChannelCreateDialog___default.a,
    WechatChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_7__components_channel_wechat_WechatChannelCreateDialog___default.a,
    TelegramChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_5__components_channel_telegram_TelegramNewDialog___default.a,
    WhatsappWebChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_8__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default.a
  },
  data: function data() {
    return {
      selectedChannelType: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'])),

  methods: {
    showChannelIcon: function showChannelIcon(alwaysShow) {
      if (alwaysShow) {
        return alwaysShow;
      }
      return alwaysShow || this.me.is_staff;
    }
  }
});
/* eslint-enable no-console */

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_channel_Channels__ = __webpack_require__(2912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_channel_Channels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_channel_Channels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelCreate__ = __webpack_require__(2909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelCreate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelDashboard',
  components: { Channels: __WEBPACK_IMPORTED_MODULE_0__components_channel_Channels___default.a, ChannelCreate: __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelCreate___default.a },
  props: {
    channels: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    activeChannelTab: {
      type: String,
      default: 'activeChannels'
    }
  },
  methods: {
    onChangeTab: function onChangeTab(tab) {
      this.$emit('onChangeTab', { activeChannelTab: tab });
    }
  }
});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelList',
  components: { SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a },
  props: {
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    logoClass: function logoClass() {
      return this.active ? 'fa-times' : 'fa-check';
    },
    logoColor: function logoColor() {
      return this.active ? 'red' : 'green';
    }
  },
  methods: {
    toggleChannelActive: function toggleChannelActive(channel) {
      this.$emit(this.active ? 'deactivateChannel' : 'activateChannel', channel);
    }
  }
});

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_collect_js__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelSelector',
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a
  },
  props: {
    channels: {
      type: Array
    },
    createChannels: {
      type: Array
    },
    selectedChannels: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    currentChannels: {
      get: function get() {
        return this.selectedChannels;
      },
      set: function set(newSelectedChannels) {
        this.$emit('onSelectedChannelsChanged', newSelectedChannels);
      }
    },
    createChannelData: function createChannelData() {
      var collection = __WEBPACK_IMPORTED_MODULE_1_collect_js___default()(this.createChannels);
      var filteredChannels = collection.filter(function (value) {
        return value.channelTypeTitle !== 'Survey';
      });
      return filteredChannels.all().map(function (channel) {
        return {
          key: channel.id,
          label: channel.handle + ' (' + channel.channelTypeTitle + ')',
          disabled: false
        };
      });
    },
    channelData: function channelData() {
      return this.channels.map(function (_ref) {
        var channel = _ref.channel;
        return {
          key: channel.id,
          label: channel.handle + ' (' + channel.channelTypeTitle + ')',
          disabled: false
        };
      });
    },
    handleChannelData: function handleChannelData() {
      if (typeof this.channels !== 'undefined' && this.channels) {
        return this.channelData;
      }
      return this.createChannelData;
    }
  }
});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelList__ = __webpack_require__(2911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelList__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Channels',
  components: { ChannelList: __WEBPACK_IMPORTED_MODULE_1__components_channel_ChannelList___default.a },
  props: {
    channels: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    activeChannelTab: {
      type: String,
      default: 'inactiveChannels'
    }
  },
  methods: {
    onChangeTab: function onChangeTab(_ref) {
      var name = _ref.name;

      this.$emit('onChangeTab', { activeChannelTab: name });
    },
    activateChannel: function activateChannel(channel) {
      this.$store.dispatch('channel/updateChannel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, channel, { live: true }));
    },
    deactivateChannel: function deactivateChannel(channel) {
      var _this = this;

      this.$confirm('Are you sure you want to deactivate channel: ' + channel.handle).then(function () {
        _this.$store.dispatch('channel/updateChannel', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, channel, { live: false }));
      });
    }
  }
});

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(244);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmailChannelCreateDialog',

  data: function data() {
    return {
      emailChannelForm: {
        email: ''
      },
      emailInputRules: [{ type: 'email', message: 'Please provide a valid email address.', trigger: 'blur' }, { required: true, message: 'Email Address is required', trigger: 'blur' }]
    };
  },

  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('channel', ['addingEmailChannel']), {

    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }),

  methods: {
    handleSaveChannel: function handleSaveChannel() {
      var _this = this;

      this.$refs.emailChannelForm.validate(function (valid) {
        if (valid) return _this.addEmailChannel();
        return false;
      });
    },
    addEmailChannel: function addEmailChannel() {
      var _this2 = this;

      var emailChannel = {
        handle: this.emailChannelForm.email,
        channel_type: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* channelTypes */].MMS_EMAIL,
        live: true,
        extra_data: ''
      };

      this.$store.dispatch('channel/addEmailChannel', emailChannel).then(function () {
        _this2.$emit('onEmailChannelAdded');
        _this2.showDialog = false;
      });
    }
  },

  watch: {
    showDialog: function showDialog() {
      if (this.$refs && this.$refs.emailChannelForm) {
        this.$refs.emailChannelForm.resetFields();
      }
    }
  }
});

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__ = __webpack_require__(192);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FacebookCreateDialog',

  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default.a
  },

  data: function data() {
    return {
      selectedPages: [],
      isLoading: false,
      isSaving: false
    };
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    me: {
      type: Object,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('channel', ['facebookPages']), {

    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }),

  methods: {
    /**
     * Start Facebook oAuth process in new window.
     */
    handleRequestFacebookAuth: function handleRequestFacebookAuth() {
      var _this = this;

      this.$store.dispatch('channel/addFacebookChannelAuth', this.me).then(function (canShowDialog) {
        _this.showDialog = canShowDialog;
        _this.isLoading = canShowDialog;
      });
    },


    /**
     * Add channels for all selected pages. Then close dialog.
     */
    handleSaveChannel: function handleSaveChannel() {
      var _this2 = this;

      this.isSaving = true;

      var promises = this.selectedPages.map(function (pageId) {
        return _this2.$store.dispatch('channel/addFacebookPage', pageId);
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.$emit('onFacebookChannelAdded');
        _this2.isLoading = false;
        _this2.showDialog = false;
        _this2.isSaving = false;
      });
    },


    /**
     * Clean up intervals in case it's still polling
     * reset component state for next time
     */
    destroyState: function destroyState() {
      this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["k" /* POLL_FACEBOOK_PAGES_STOP */]);
      this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["l" /* CLEAR_ADD_FACEBOOK_CHANNEL_STATE */]);
    }
  },

  watch: {
    /**
     * Kick of Auth process when opening.
     * Destroy state for next time when closing.
     */
    showDialog: function showDialog(toShow) {
      if (toShow) {
        this.handleRequestFacebookAuth();
      } else {
        this.destroyState();
      }
    },


    /**
     * If facebookPages were fetched, stop polling
     */
    facebookPages: function facebookPages() {
      if (this.facebookPages.length > 0) {
        this.isLoading = false;
        this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["k" /* POLL_FACEBOOK_PAGES_STOP */]);
      }
    }
  }
});

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__ = __webpack_require__(192);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InstagramCreateDialog',

  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_Icons_SocialIcon___default.a
  },

  data: function data() {
    return {
      selectedPages: [],
      isLoading: false,
      isSaving: false
    };
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    me: {
      type: Object,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('channel', ['instagramPages']), {

    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }),

  methods: {
    /**
     * Start Facebook oAuth process in new window.
     */
    handleRequestInstagramAuth: function handleRequestInstagramAuth() {
      var _this = this;

      this.$store.dispatch('channel/addInstagramChannelAuth', this.me).then(function (canShowDialog) {
        _this.showDialog = canShowDialog;
        _this.isLoading = canShowDialog;
      });
    },


    /**
     * Add channels for all selected pages. Then close dialog.
     */
    handleSaveChannel: function handleSaveChannel() {
      var _this2 = this;

      this.isSaving = true;

      var promises = this.selectedPages.map(function (x) {
        return _this2.$store.dispatch('channel/addInstagramPage', [_this2.me.id, x]);
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.$emit('onInstagramChannelAdded');
        _this2.isLoading = false;
        _this2.showDialog = false;
      });
    },


    /**
     * Clean up intervals in case it's still polling
     * reset component state for next time
     */
    destroyState: function destroyState() {
      this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["J" /* POLL_INSTAGRAM_PAGES_STOP */]);
      this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["K" /* CLEAR_ADD_INSTAGRAM_CHANNEL_STATE */]);
    }
  },

  watch: {
    /**
     * Kick of Auth process when opening.
     * Destroy state for next time when closing.
     */
    showDialog: function showDialog(toShow) {
      if (toShow) {
        this.handleRequestInstagramAuth();
      } else {
        this.destroyState();
      }
    },


    /**
     * If facebookPages were fetched, stop polling
     */
    instagramPages: function instagramPages() {
      if (this.instagramPages.length > 0) {
        this.isLoading = false;
        this.$store.commit('channel/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_channel_mutation_types__["J" /* POLL_INSTAGRAM_PAGES_STOP */]);
      }
    }
  }
});

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_duration__ = __webpack_require__(2665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_humanize_duration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_countries_CountryCodeSelector__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_countries_CountryCodeSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_countries_CountryCodeSelector__);




var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TelegramChannelCreate',
  components: {
    CountryCodeSelector: __WEBPACK_IMPORTED_MODULE_5__components_common_countries_CountryCodeSelector___default.a
  },
  data: function data() {
    return this.initialData();
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    },
    countryCode: function countryCode() {
      return this.selectedCountry.dial_code ? this.selectedCountry.dial_code.substring(1) : null;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('user', ['userCountryCode', 'me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('telegram', ['loadingTelegramCodeRequest', 'telegramCodeRequestSuccess', 'telegramPhoneCodeHash', 'loadingTelegramSignIn', 'telegramSignInStatus', 'telegramSignInError', 'telegramStatusMessage', 'telegramClientStatus', 'telegramCodeRequestError'])),
  methods: {
    initialData: function initialData() {
      return {
        selectedCountry: {
          code: null,
          dial_code: null,
          flag: null
        },
        telegramChannelForm: {
          telegramCode: '',
          firstName: '',
          lastName: '',
          phoneNumber: ''
        },
        activeStep: 0,
        codeRequestHasFailed: false,
        fullPhoneNumber: '',
        existingAccount: 'Yes',
        errorMessage: null,
        validationError: false
      };
    },
    handleCountryChanged: function handleCountryChanged(country) {
      this.selectedCountry = country;
      this.telegramChannelForm.countryCode = this.countryCode;
    },
    next: function next() {
      this.activeStep += 1;
      if (this.activeStep > 3) this.activeStep = 0;
    },
    onClickRequestCode: function onClickRequestCode() {
      this.validationError = null;
      if (this.selectedCountry.dial_code && this.telegramChannelForm.phoneNumber.length > 0) {
        var dialCode = this.selectedCountry.dial_code.substring(1);
        this.fullPhoneNumber = '' + dialCode + this.telegramChannelForm.phoneNumber;
        this.$store.dispatch('telegram/requestCode', {
          phone_number: this.fullPhoneNumber,
          company_id: this.me.use_as_company,
          user_id: this.me.id
        });
      } else {
        this.validationError = true;
        this.errorMessage = 'Please provide your country code and phone number to proceed.';
      }
    },
    onClickChangeNumber: function onClickChangeNumber() {
      this.activeStep = 0;
    },
    onClickSignIn: function onClickSignIn() {
      var payload = {
        phone_number: this.fullPhoneNumber,
        code: this.telegramChannelForm.telegramCode,
        first_name: this.telegramChannelForm.firstName,
        last_name: this.telegramChannelForm.lastName
      };

      this.$store.dispatch('telegram/confirmCode', payload);
    },
    handleClose: function handleClose() {
      this.showDialog = false;
      this.activeStep = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.initialData());
    },
    handle400: function handle400() {
      this.errorMessage = 'Please make sure you provided the correct mobile number and dail code.';
    },
    handle403: function handle403() {
      return 'Telegram has blocked your number for privacy violations.';
    },
    handle408: function handle408() {
      return "The request has timed out. Please try again.";
    },
    handle409: function handle409() {
      return 'This number already has an active Telegram session.';
    },
    handle429: function handle429(message) {
      var seconds = message.match(/\d+/g);
      var duration = __WEBPACK_IMPORTED_MODULE_4_humanize_duration___default()(seconds * 1000, {
        conjunction: ' and ',
        serialComma: false
      });
      return 'You have made too many login attempts. Please wait ' + duration + ' before your next attempt.';
    },
    handle500: function handle500() {
      return 'We are currently unable to add your number. Please try again later or contact COLONYLive support.';
    },
    handleError: function handleError(error) {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            this.errorMessage = this.handle400();
            break;

          case 403:
            this.errorMessage = this.handle403();
            break;

          case 408:
            this.errorMessage = this.handle408();

          case 409:
            this.errorMessage = this.handle409();
            break;

          case 429:
            this.errorMessage = this.handle429(error.response.data.message);
            break;

          default:
            this.errorMessage = this.handle500();
        }
      }
    }
  },
  watch: (_watch = {
    telegramClientStatus: function telegramClientStatus() {
      switch (this.telegramClientStatus) {
        case 'connected':
          this.activeStep = 3;
          this.$notify({
            title: 'Success',
            message: 'You have successfully signed into your Telegram account ',
            type: 'success'
          });
          break;

        case 'waiting':
          this.activeStep = 1;
          break;

        default:
      }
    },
    loadingTelegramCodeRequest: function loadingTelegramCodeRequest() {
      if (!this.loadingTelegramCodeRequest) {
        this.codeRequestHasFailed = true;
      }
      if (this.telegramCodeRequestSuccess && this.telegramPhoneCodeHash !== undefined) {
        if (this.activeStep === 0) this.next();
        this.codeRequestHasFailed = false;
      }
    },
    telegramSignInStatus: function telegramSignInStatus() {
      this.handleError(this.telegramSignInError);
    },
    telegramCodeRequestError: function telegramCodeRequestError() {
      this.handleError(this.telegramCodeRequestError);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'telegramSignInStatus', function telegramSignInStatus() {
    if (this.telegramSignInStatus === 'success') {
      this.activeStep = 3;
      this.$notify({
        title: 'Success',
        message: 'You have successfully  signed into your Telegram account ',
        type: 'success'
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'activeStep', function activeStep() {
    if (this.activeStep === 3) {
      this.showDialog = false;
    }
  }), _watch)
});

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(244);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WechatChannelCreateDialog',

  data: function data() {
    return {
      wechatChannelForm: {
        name: '',
        token: '',
        token_secret: ''
      },
      wechatChannelFormRules: {
        name: [{ required: true, message: 'WeChat Name is required', trigger: 'blur' }],
        token: [{ required: true, message: 'Token is required', trigger: 'blur' }],
        token_secret: [{ required: true, message: 'Token Secret is required', trigger: 'blur' }]
      }
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('channel', ['addingWechatChannel']), {

    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  }),

  methods: {
    handleSaveChannel: function handleSaveChannel() {
      var _this = this;

      this.$refs.wechatChannelForm.validate(function (valid) {
        if (valid) return _this.addWechatChannel();
        return false;
      });
    },
    addWechatChannel: function addWechatChannel() {
      var _this2 = this;

      var wechatChannel = {
        handle: this.wechatChannelForm.name,
        token: this.wechatChannelForm.token,
        token_secret: this.wechatChannelForm.token_secret,
        channel_type: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* channelTypes */].WE_CHAT,
        live: true,
        extra_data: ''
      };

      this.$store.dispatch('channel/addWechatChannel', wechatChannel).then(function () {
        _this2.$emit('onWechatChannelAdded');
        _this2.showDialog = false;
      });
    }
  },

  watch: {
    showDialog: function showDialog() {
      if (this.$refs && this.$refs.wechatChannelForm) {
        this.$refs.wechatChannelForm.resetFields();
      }
    }
  }
});

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component__ = __webpack_require__(3110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_countries_CountryCodeSelector__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_countries_CountryCodeSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_countries_CountryCodeSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__ = __webpack_require__(350);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WhatsappChannelCreateDialog',
  components: { qrcode: __WEBPACK_IMPORTED_MODULE_3_vue_qrcode_component___default.a, SocialIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default.a, CountryCodeSelector: __WEBPACK_IMPORTED_MODULE_4__components_common_countries_CountryCodeSelector___default.a },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    intialData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      selectedCountry: {
        flag: null,
        code: null,
        dial_code: ''
      },
      phoneNumber: '',
      expiryRunning: false,
      expiryCounter: 15,
      isAuthed: false
    }, this.intialData);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me', 'userCountryCode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('whatsapp', ['loadingWhatsappQRCodeRequest', 'loadingWhatsappCreateChannel', 'whatsappQRCode', 'whatsappChannelId', 'whatsappPollSuccess']), {
    showDialog: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        if (!visibility) {
          this.resetState();
        }
        this.$emit('onVisibleChanged', visibility);
      }
    },
    validMobileNumber: function validMobileNumber() {
      var mobileNumber = this.selectedCountry.dial_code + this.phoneNumber;
      return (/^[^0]/.test(this.phoneNumber) && /^\+\d+$/.test(mobileNumber) && mobileNumber.length >= 9
      );
    }
  }),
  methods: {
    generateQRCode: function generateQRCode() {
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["j" /* POLL_WHATSAPP_CHANNEL_STOP */]);
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["m" /* POLL_WHATSAPP_CHANNEL_RESET */]);
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["d" /* RESET_WHATSAPP_QRCODE */]);
      this.$store.dispatch('whatsapp/requestWhatsappQRCode', this.whatsappChannelId);
      this.$store.dispatch('whatsapp/pollWhatsappStatus', this.whatsappChannelId);
    },
    clearQRCode: function clearQRCode() {
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["d" /* RESET_WHATSAPP_QRCODE */]);
    },
    resetState: function resetState() {
      // Reset state and close
      this.expiryRunning = false;
      this.selectedCountry = {
        flag: null,
        code: null,
        dial_code: ''
      };
      this.expiryCounter = 15;
      this.isAuthed = false;
      this.phoneNumber = '';
      this.clearQRCode();
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["e" /* RESET_WHATSAPP_CHANNEL_ID */]);
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["j" /* POLL_WHATSAPP_CHANNEL_STOP */]);
      this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["m" /* POLL_WHATSAPP_CHANNEL_RESET */]);
    },
    createChannel: function createChannel() {
      var mobileNumber = '' + this.selectedCountry.dial_code + this.phoneNumber;
      this.$store.dispatch('whatsapp/createWhatsappChannel', mobileNumber);
    },
    handleCountryChanged: function handleCountryChanged(country) {
      this.selectedCountry = country;
    },
    close: function close() {
      this.resetState();
      this.showDialog = false;
    },
    qrCodeTimeoutRun: function qrCodeTimeoutRun() {
      var _this = this;

      setTimeout(function () {
        _this.expiryCounter -= 1;
        if (_this.expiryCounter === 0) {
          _this.clearQRCode();
          _this.expiryCounter = 15;
          _this.$store.commit('whatsapp/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_whatsapp_mutation_types__["j" /* POLL_WHATSAPP_CHANNEL_STOP */]);
          _this.expiryRunning = false;
        }
        if (_this.expiryCounter > 0 && _this.expiryRunning) {
          _this.qrCodeTimeoutRun();
        }
      }, 1000);
    }
  },
  watch: {
    whatsappPollSuccess: function whatsappPollSuccess(value) {
      if (value) {
        this.$emit('onWhatsappChannelAdded');
        this.isAuthed = true;
        this.expiryRunning = false;
      }
    },
    whatsappQRCode: function whatsappQRCode(value) {
      if (value) {
        this.expiryRunning = true;
        this.expiryCounter = 15;
        this.qrCodeTimeoutRun();
      }
    }
  }
});

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BarChart',
  components: {
    BaseBarChart: __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__["a" /* default */]],
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    titleAlign: {
      type: String,
      default: 'center'
    },
    isPercentage: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__["a" /* default */]],
  computed: {
    totalDisplay: function totalDisplay() {
      var _this = this;

      return function (item) {
        var total = item[1].toLocaleString();
        if (_this.isPercentage) {
          return total + '%';
        }
        return total;
      };
    }
  }
});

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseDoughnutChart__ = __webpack_require__(2916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseDoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BaseDoughnutChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoughnutChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__["a" /* default */]],
  components: {
    BaseDoughnutChart: __WEBPACK_IMPORTED_MODULE_1__base_BaseDoughnutChart___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseHorizontalBarChart__ = __webpack_require__(2917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseHorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BaseHorizontalBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HorizontalBarChart',
  components: {
    BaseHorizontalBarChart: __WEBPACK_IMPORTED_MODULE_1__base_BaseHorizontalBarChart___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__["a" /* default */]],
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_chartMixin__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_BasePieChart__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_BasePieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__base_BasePieChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.plugins.datalabels.display = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LabelledPieChart',
  components: {
    BasePieChart: __WEBPACK_IMPORTED_MODULE_3__base_BasePieChart___default.a,
    ChartDataLabels: __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_chartMixin__["a" /* default */]],
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseLineChart__ = __webpack_require__(2918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseLineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BaseLineChart__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LineChart',
  components: {
    BaseLineChart: __WEBPACK_IMPORTED_MODULE_1__base_BaseLineChart___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colors__["a" /* default */]],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'title'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    yAxeslabelString: {
      type: String,
      default: ''
    },
    xAxeslabelString: {
      type: String,
      default: ''
    },
    showGridLines: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getChartData: function getChartData() {
      var _this = this;

      if (!this.data.length) {
        return {};
      }
      var datasets = this.data.map(function (d, i) {
        return {
          data: d.map(function (s) {
            return s[1];
          }),
          backgroundColor: _this.generateRGBAColor(i + '1', 0.5, [185, 340]),
          borderColor: _this.generateRGBAColor(i + '1', 1),
          tension: 0.3,
          borderWidth: 1,
          label: _this.labels[i]
        };
      });

      return {
        labels: this.data[0].map(function (s) {
          return s[0];
        }),
        datasets: datasets
      };
    },
    getChartOptions: function getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem) {
              return tooltipItem.yLabel;
            }
          }
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.yAxeslabelString
            }
          }],
          xAxes: [{
            gridLines: {
              display: this.showGridLines
            },
            scaleLabel: {
              display: true,
              labelString: this.xAxeslabelString
            }
          }]
        }
      };
    }
  }
});

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BasePieChart__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BasePieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BasePieChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PieChart',
  components: {
    BasePieChart: __WEBPACK_IMPORTED_MODULE_1__base_BasePieChart___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_chartMixin__["a" /* default */]],
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BarChart',
  components: {
    BaseBarChart: __WEBPACK_IMPORTED_MODULE_1__base_BaseBarChart___default.a
  },
  data: function data() {
    return {
      chart: null,
      imgData: null
    };
  },
  props: {
    data: {
      type: Object,
      default: {}
    },
    height: {
      type: Number
    },
    printable: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_barChartMixin__["a" /* default */]],
  computed: {
    getChartData: function getChartData() {
      return this.data;
    }
  },
  methods: {
    setChart: function setChart(chart) {
      this.chart = chart;
    },
    animationComplete: function animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    }
  }
});

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_chartMixin__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isPercentage: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_chartMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_colors__["a" /* default */]],
  computed: {
    choices: function choices() {
      return this.data.labels;
    }
  }
});

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetrend__ = __webpack_require__(179);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Trend: __WEBPACK_IMPORTED_MODULE_0_vuetrend__["a" /* default */] },
  props: {
    points: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 40
    },
    autoDraw: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  }
}));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Doughnut"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  }
}));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["HorizontalBar"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  }
}));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  }
}));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted: function mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  }
}));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelSelector',
  props: {
    notifications: {
      type: Object,
      default: {}
    },
    selectedTopic: {
      type: String
    },
    presences: {
      type: Object,
      default: {}
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getCompanyUsers');
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])('user', ['me', 'companyUsers']), {
    users: function users() {
      var _this = this;

      return this.companyUsers.filter(function (user) {
        return user.id !== _this.me.id;
      }).sort(function (a, b) {
        // Prepend with a value to force present users to sort to the top
        var present = function present(u) {
          return _this.presentUserIds.includes(u.id) ? 'AA' : 'ZZ';
        };
        return (present(a) + ' ' + a.first_name + ' ' + a.last_name).localeCompare(present(b) + ' ' + b.first_name + ' ' + b.last_name);
      }).map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, user, {
          topic: _this.userTopic(user),
          count: _this.notificationCount(_this.userTopic(user))
        });
      });
    },
    tags: function tags() {
      var _this2 = this;

      // Ensure all is unique by using a Set
      return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.me.tags))).sort().map(function (tag) {
        return {
          name: tag,
          topic: _this2.tagTopic(tag),
          count: _this2.notificationCount(_this2.tagTopic(tag))
        };
      });
    },
    allUnread: function allUnread() {
      // Channel all unread count
      return this.notificationCount('all');
    },
    presentUserIds: function presentUserIds() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.presences).map(function (key) {
        // eslint-disable-next-line
        var _key$split = key.split(':'),
            _key$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_key$split, 2),
            _ = _key$split2[0],
            userId = _key$split2[1];

        return parseInt(userId, 10);
      });
    }
  }),
  methods: {
    tagTopic: function tagTopic(tag) {
      return 'tag:' + tag;
    },
    userTopic: function userTopic(user) {
      var ids = [user.id, this.me.id].sort();
      return 'user:' + ids[0] + ',' + ids[1];
    },
    notificationCount: function notificationCount(topic) {
      if (topic in this.notifications) {
        return this.notifications[topic].count || 0;
      }
      return 0;
    },
    handleSelectTopic: function handleSelectTopic(topic) {
      this.$emit('onSelectTopic', topic);
    }
  }
});

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_phoenix__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_phoenix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_phoenix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_ChannelSelector__ = __webpack_require__(2919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_ChannelSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_chat_ChannelSelector__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chat',
  components: {
    ChannelSelector: __WEBPACK_IMPORTED_MODULE_10__components_chat_ChannelSelector___default.a,
    PerfectScrollbar: __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__["PerfectScrollbar"]
  },

  data: function data() {
    return {
      topic: 'all',
      chatInput: '',
      channelsList: [],
      page: 1,
      messages: [],
      notifications: {},
      waitForUserResolve: false,
      channelError: false,
      rerenderInterval: null,
      presences: {},
      isFetchingMore: false,
      scrollHeightBefore: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    // Ensure all auth has completed already
    if (this.me.use_as_company) {
      this.startPresence();
      this.startChannel();
    } else {
      this.waitForUserResolve = true;
    }

    this.rerenderInterval = setInterval(function () {
      _this.$forceUpdate();
    }, 60 * 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.rerenderInterval);
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])('user', ['me']), {
    computedMessages: function computedMessages() {
      var _this2 = this;

      return this.messages.map(function (message) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, message, {
          direction: _this2.me.id === message.user.id ? 'out' : 'in'
        });
      });
    },
    notificationItems: function notificationItems() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.notifications).filter(function (key) {
        return key !== 'total';
      }).map(function (key) {
        var prepend = '';
        if (key.startsWith('tag:')) {
          prepend = '#';
        } else if (key.startsWith('user:')) {
          prepend = '@';
        }

        return {
          prepend: prepend,
          topic: key,
          name: _this3.notifications[key].name,
          count: _this3.notifications[key].count
        };
      });
    },
    totalNotifications: function totalNotifications() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.notifications).reduce(function (acc, key) {
        return acc + _this4.notifications[key].count;
      }, 0);
    }
  }),

  methods: {
    /* eslint-disable no-console */
    startPresence: function startPresence() {
      var _this5 = this;

      this.presenceChannel = window.phoenixSocket.channel('chat:presence', {});
      this.presenceChannel.join().receive('ok', function (resp) {
        console.log('Presence joined successfully', resp);
      }).receive('error', function (resp) {
        console.log('Unable to join presence', resp);
      });

      this.presenceChannel.on('presence_state', function (state) {
        _this5.presences = __WEBPACK_IMPORTED_MODULE_8_phoenix__["Presence"].syncState(_this5.presences, state);
      });

      this.presenceChannel.on('presence_diff', function (diff) {
        _this5.presences = __WEBPACK_IMPORTED_MODULE_8_phoenix__["Presence"].syncDiff(_this5.presences, diff);
      });
    },
    startChannel: function startChannel() {
      var _this6 = this;

      this.channelError = false;

      var topic = this.me.use_as_company + '.' + this.topic;
      this.channel = window.phoenixSocket.channel('room:topic:' + topic, {});

      this.channel.join().receive('ok', function (resp) {
        console.log('Chat joined successfully', resp);
        _this6.messages = resp.messages.reverse();
        _this6.notifications = resp.notifications;
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this6.scrollToBottom();
        });
      }).receive('error', function (resp) {
        console.log('Unable to join chat', resp);
        _this6.channelError = true;
        _this6.channel.leave();
      });

      this.channel.on('room:topic:' + topic + ':new_message', function (message) {
        _this6.messages.push(message);
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this6.scrollToBottom();
        });
      });

      this.channel.on('user:new_notification', function (notification) {
        var notifyTopic = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(notification)[0];
        _this6.notifications = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this6.notifications, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, notifyTopic, notification[notifyTopic]));
        _this6.playNotificationSound();
      });

      this.channel.on('user:reset_notification', function (resetNotification) {
        var _notifications = _this6.notifications,
            remove = _notifications[resetNotification.topic],
            rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_notifications, [resetNotification.topic]);

        _this6.notifications = rest;
      });

      this.channel.on('message:more', function (response) {
        _this6.messages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.messages.reverse()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this6.messages));
        _this6.isFetchingMore = false;
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(_this6.adjustScrollPosition);
      });
    },
    loadMore: function loadMore() {
      var offset = this.messages.length;
      if (offset > 0) {
        this.channel.push('message:get_more', { offset: offset });
        this.isFetchingMore = true;
      }
    },
    playNotificationSound: function playNotificationSound() {
      // eslint-disable-next-line
      new Audio(__webpack_require__(2831)).play();
    },
    changeChannel: function changeChannel() {
      this.reset();
      this.startChannel();
    },
    reset: function reset() {
      this.channelError = false;
      if (this.channel) {
        this.channel.leave();
      }
      this.messages = [];
      this.page = 1;
    },
    submit: function submit() {
      this.channel.push('message:add', {
        message: this.chatInput
      });

      this.chatInput = '';
    },
    resetNotifications: function resetNotifications() {
      this.channel.push('notification:reset', {});
    },
    displayDatetime: function displayDatetime(datetime) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(datetime).fromNow();
    },
    scrollToBottom: function scrollToBottom() {
      var el = this.$refs.bottomScroll;

      if (el) {
        el.scrollIntoView({ behaviour: 'smooth' });
      }
    },
    adjustScrollPosition: function adjustScrollPosition() {
      var scrollHeightAfter = this.$refs.content.$el.scrollHeight - this.$refs.content.$el.clientHeight;
      this.$refs.content.$el.scrollTop = scrollHeightAfter - this.scrollHeightBefore;
    },
    handleTopicChange: function handleTopicChange(topic) {
      this.topic = topic;
      this.changeChannel();
    },
    handleScroll: function handleScroll() {
      this.scrollHeightBefore = this.$refs.content.$el.scrollHeight - this.$refs.content.$el.clientHeight;

      var scrollPosition = this.$refs.content.$el.scrollTop;
      if (scrollPosition === 0 && !this.isFetchingMore) {
        this.loadMore();
      }
    }
  },
  watch: {
    me: function me() {
      if (this.waitForUserResolve) {
        this.startChannel();
        this.startPresence();
        this.waitForUserResolve = false;
      }
    }
  }
});

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContactSales__ = __webpack_require__(2922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContactSales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ContactSales__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BlurredImagePlaceholder',
  components: {
    ContactSales: __WEBPACK_IMPORTED_MODULE_0__ContactSales___default.a
  },
  props: {
    imageSrc: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: null
    },
    showContactSales: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactSales',
  data: function data() {
    return {
      mailToSales: 'mailto:robby@colonyhq.com?subject=Colony%20Live%20Afstereo%20Plugin%20Request'
    };
  }
});

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_content_loaders_AnalyticsUnitBlockLoader__ = __webpack_require__(2932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_content_loaders_AnalyticsUnitBlockLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_content_loaders_AnalyticsUnitBlockLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_content_loaders_AudienceProfileLoader__ = __webpack_require__(2933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_content_loaders_AudienceProfileLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_content_loaders_AudienceProfileLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_content_loaders_AnalyticsHeatMapLoader__ = __webpack_require__(2931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_content_loaders_AnalyticsHeatMapLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_content_loaders_AnalyticsHeatMapLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_content_loaders_AnalyticsChartLoader__ = __webpack_require__(2930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_content_loaders_AnalyticsChartLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_content_loaders_AnalyticsChartLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_content_loaders_DoughnutChartLoader__ = __webpack_require__(2934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_content_loaders_DoughnutChartLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_content_loaders_DoughnutChartLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_content_loaders_WordCloudLoader__ = __webpack_require__(2940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_content_loaders_WordCloudLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_content_loaders_WordCloudLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_content_loaders_TimeSeriesGraphLoader__ = __webpack_require__(2939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_content_loaders_TimeSeriesGraphLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_content_loaders_TimeSeriesGraphLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_content_loaders_ListDividerLoader__ = __webpack_require__(2936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_content_loaders_ListDividerLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_content_loaders_ListDividerLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_content_loaders_AdvertisersChartLoader__ = __webpack_require__(2929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_content_loaders_AdvertisersChartLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_content_loaders_AdvertisersChartLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_content_loaders_EngagementGraphLoader__ = __webpack_require__(2935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_content_loaders_EngagementGraphLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_content_loaders_EngagementGraphLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_content_loaders_PolarChartLoader__ = __webpack_require__(2937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_content_loaders_PolarChartLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_common_content_loaders_PolarChartLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_content_loaders_ProgrammingDashboardUnitLoader__ = __webpack_require__(2938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_content_loaders_ProgrammingDashboardUnitLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_content_loaders_ProgrammingDashboardUnitLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentLoaderPlaceholder',
  props: {
    type: {
      type: String,
      default: function _default() {
        return '';
      }
    },

    fadeAfter: {
      type: Number,
      default: function _default() {
        return 12 * 3600;
      }
    },
    contentVisible: {
      type: Boolean,
      default: false
    },

    textArray: {
      type: Array
    }
  },
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_14__components_common_IBox___default.a,
    AnalyticsUnitBlockLoader: __WEBPACK_IMPORTED_MODULE_2__components_common_content_loaders_AnalyticsUnitBlockLoader___default.a,
    AudienceProfileLoader: __WEBPACK_IMPORTED_MODULE_3__components_common_content_loaders_AudienceProfileLoader___default.a,
    AnalyticsHeatMapLoader: __WEBPACK_IMPORTED_MODULE_4__components_common_content_loaders_AnalyticsHeatMapLoader___default.a,
    AnalyticsChartLoader: __WEBPACK_IMPORTED_MODULE_5__components_common_content_loaders_AnalyticsChartLoader___default.a,
    WordCloudLoader: __WEBPACK_IMPORTED_MODULE_7__components_common_content_loaders_WordCloudLoader___default.a,
    TimeSeriesGraphLoader: __WEBPACK_IMPORTED_MODULE_8__components_common_content_loaders_TimeSeriesGraphLoader___default.a,
    ListDividerLoader: __WEBPACK_IMPORTED_MODULE_9__components_common_content_loaders_ListDividerLoader___default.a,
    EngagementGraphLoader: __WEBPACK_IMPORTED_MODULE_11__components_common_content_loaders_EngagementGraphLoader___default.a,
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */],
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder___default.a,
    ProgrammingDashboardUnitLoader: __WEBPACK_IMPORTED_MODULE_13__components_common_content_loaders_ProgrammingDashboardUnitLoader___default.a,
    DoughnutChartLoader: __WEBPACK_IMPORTED_MODULE_6__components_common_content_loaders_DoughnutChartLoader___default.a,
    PolarChartLoader: __WEBPACK_IMPORTED_MODULE_12__components_common_content_loaders_PolarChartLoader___default.a,
    AdvertisersChartLoader: __WEBPACK_IMPORTED_MODULE_10__components_common_content_loaders_AdvertisersChartLoader___default.a
  },
  data: function data() {
    return {
      sizeReducer: [600, 500],
      noContent: true,
      clearInterval: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', this.getResolution);
    /*
      3. Hide Component after 30 seconds
      2. Check Content is still empty after 30
      1. Start 30s count down
    */
    this.clearInterval = setInterval(function () {
      /* eslint-disable */
      _this.noContent = !_this.noContent;

      _this.$emit('onNoContent', _this.noContent);
    }, this.fadeAfter);

    this.checkContentVisible(this.clearInterval);
  },


  methods: {
    getResolution: function getResolution(e) {
      var yHeight = e.currentTarget.outerHeight;
      var xWidth = e.currentTarget.outerWidth;
      var scalar = window.devicePixelRatio;

      this.sizeReducer = [yHeight / scalar, xWidth / scalar];
    },
    checkContentVisible: function checkContentVisible(clearIntervalStop) {
      return this.contentVisible ? clearInterval(clearIntervalStop) : 'Not Content Visible';
    }
  }
});

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentPlaceholder',
  props: {
    count: { type: Number, default: 3 },
    textOnly: { type: Boolean, default: false },
    textValue: { type: String, default: 'The End' },
    textArray: { type: Array, default: function _default() {
        return [];
      } }
  }
});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_emoji_picker__ = __webpack_require__(2851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_emoji_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_emoji_picker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmojiKeyboard',
  components: {
    EmojiPicker: __WEBPACK_IMPORTED_MODULE_0_vue_emoji_picker___default.a
  },
  data: function data() {
    return {
      search: ''
    };
  },
  methods: {
    insert: function insert(emoji) {
      this.$emit('onEmojiInsert', emoji);
    }
  }
});

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(2850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FabSpeedDial',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      toggle: false,
      iconSizes: {
        small: 'icon-sm',
        medium: 'icon-md',
        large: 'icon-lg'
      },
      mainIconSizes: {
        small: 'icon-md',
        medium: 'icon-lg',
        large: 'icon-xl'
      },
      paddingAmt: {
        small: '28px',
        medium: '32px',
        large: '38px'
      },
      positions: {
        'bottom-right': { right: '2vw', bottom: '6vh' },
        'bottom-left': { left: '5vw', bottom: '4vh' },
        'top-right': { right: '5vw', top: '4vh' },
        'top-left': { left: '5vw', top: '4vh' },
        default: { right: '2vw', bottom: '6vh' }
      }
    };
  },


  props: {
    bgColor: {
      type: String,
      default: null
    },
    position: {
      default: 'bottom-right'
    },
    positionType: {
      default: 'fixed'
    },
    zIndex: {
      default: '999'
    },
    mainIcon: {
      default: 'fa fa-plus'
    },
    iconSize: {
      default: 'medium'
    },
    mainTooltip: {
      default: null
    },
    fixedTooltip: {
      default: false
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    actionIconSize: function actionIconSize() {
      return this.iconSizes[this.iconSize] || 'icon-md';
    },
    mainIconSize: function mainIconSize() {
      return this.mainIconSizes[this.iconSize] || 'icon-lg';
    },
    paddingAmount: function paddingAmount() {
      return this.paddingAmt[this.iconSize] || '32px';
    },
    listPos: function listPos() {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          top: '-20px',
          paddingTop: '20px'
        };
      }
      return {
        bottom: '-20px',
        paddingBottom: '20px'
      };
    },
    transitionEnter: function transitionEnter() {
      return this.animation.enter;
    },
    transitionLeave: function transitionLeave() {
      return this.animation.leave;
    },
    animation: function animation() {
      if (this.position.indexOf('top') !== -1) {
        return {
          enter: 'animated quick fadeInDown',
          leave: 'animated quick fadeOutUp'
        };
      }

      return {
        enter: 'animated fadeInUp',
        leave: 'animated fadeOutDown'
      };
    },
    tooltipPos: function tooltipPos() {
      return this.position.indexOf('right') !== -1 ? 'left' : 'right';
    },
    fabPos: function fabPos() {
      return this.positions[this.position] || this.positions.default;
    }
  },
  methods: {
    handleToggle: function handleToggle() {
      this.$emit('click');

      if (this.actions.length) {
        this.toggle = !this.toggle;
      }
    },
    toParent: function toParent(name) {
      this.$emit(name);
      this.toggle = false;
    },
    away: function away() {
      this.toggle = false;
    }
  }
});

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Gallery',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      required: true
    },
    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('setVisible', value);
      }
    }
  },
  methods: {
    setNextIndex: function setNextIndex() {
      var nextIndex = this.selectedIndex + 1;
      if (nextIndex >= this.images.length) {
        nextIndex = 0;
      }
      this.selectedIndex = nextIndex;
    },
    setPrevIndex: function setPrevIndex() {
      var prevIndex = this.selectedIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.images.length - 1;
      }
      this.selectedIndex = prevIndex;
    }
  }
});

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Growth',
  props: {
    value: {
      type: Number,
      default: 0
    },
    isPercentage: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IBox',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  },
  props: {
    noPadding: false,
    selected: true,
    contentHeight: 0,
    fixed: false
  },
  computed: {
    contentStyle: function contentStyle() {
      if (!this.contentHeight) {
        return '';
      }

      return 'height: ' + this.contentHeight + 'px';
    }
  }
});

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cellfind'
});

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelAppIcon'
});

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Mail'
});

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    official: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoClass: function logoClass() {
      return this.official ? 'fa-facebook-official' : 'fa-facebook';
    }
  },
  name: 'Facebook'
});

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Import'
});

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Instagram'
});

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Mobile'
});

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sms'
});

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmsIcon__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmsIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SmsIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UssdIcon__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UssdIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UssdIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailIcon__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmailIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WechatIcon__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WechatIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WechatIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MobileIcon__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MobileIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MobileIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebhookIcon__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebhookIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__WebhookIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TwitterIcon__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TwitterIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TwitterIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FacebookIcon__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FacebookIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FacebookIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TelegramIcon__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TelegramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TelegramIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WhatsappIcon__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WhatsappIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__WhatsappIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhatsappWebIcon__ = __webpack_require__(2925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhatsappWebIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__WhatsappWebIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CellfindIcon__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CellfindIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CellfindIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InstagramIcon__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InstagramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__InstagramIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SurveyIcon__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SurveyIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SurveyIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ChannelAppIcon__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ChannelAppIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ChannelAppIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ImportIcon__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ImportIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ImportIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TiktokIcon__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TiktokIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__TiktokIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialIcon',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fbOfficial: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: 'inherit'
    }
  },
  components: {
    SmsIcon: __WEBPACK_IMPORTED_MODULE_0__SmsIcon___default.a,
    EmailIcon: __WEBPACK_IMPORTED_MODULE_2__EmailIcon___default.a,
    UssdIcon: __WEBPACK_IMPORTED_MODULE_1__UssdIcon___default.a,
    WechatIcon: __WEBPACK_IMPORTED_MODULE_3__WechatIcon___default.a,
    MobileIcon: __WEBPACK_IMPORTED_MODULE_4__MobileIcon___default.a,
    WebhookIcon: __WEBPACK_IMPORTED_MODULE_5__WebhookIcon___default.a,
    TwitterIcon: __WEBPACK_IMPORTED_MODULE_6__TwitterIcon___default.a,
    CellfindIcon: __WEBPACK_IMPORTED_MODULE_11__CellfindIcon___default.a,
    FacebookIcon: __WEBPACK_IMPORTED_MODULE_7__FacebookIcon___default.a,
    TelegramIcon: __WEBPACK_IMPORTED_MODULE_8__TelegramIcon___default.a,
    InstagramIcon: __WEBPACK_IMPORTED_MODULE_12__InstagramIcon___default.a,
    WhatsappIcon: __WEBPACK_IMPORTED_MODULE_9__WhatsappIcon___default.a,
    WhatsappWebIcon: __WEBPACK_IMPORTED_MODULE_10__WhatsappWebIcon___default.a,
    SurveyIcon: __WEBPACK_IMPORTED_MODULE_13__SurveyIcon___default.a,
    ChannelAppIcon: __WEBPACK_IMPORTED_MODULE_14__ChannelAppIcon___default.a,
    ImportIcon: __WEBPACK_IMPORTED_MODULE_15__ImportIcon___default.a,
    TiktokIcon: __WEBPACK_IMPORTED_MODULE_16__TiktokIcon___default.a
  }
});

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyIcon'
});

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Telegram'
});

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tiktok'
});

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Twitter'
});

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ussd'
});

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Webhook'
});

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Wechat'
});

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Whatsapp'
});

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WhatsappWeb'
});

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Gallery__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Gallery__);
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageGrid',
  components: {
    Gallery: __WEBPACK_IMPORTED_MODULE_0__components_common_Gallery___default.a
  },
  props: {
    boxWidth: {
      type: String,
      default: 'auto'
    },
    boxHeight: {
      type: String,
      default: '200px'
    },
    boxBorder: {
      type: Number,
      default: 0
    },
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      styles: {
        width: _this.boxWidth,
        height: _this.boxHeight,
        overflow: 'hidden'
      },
      imageClass: 'single-h',
      imageOrientation: 'h',
      selectedIndex: 0,
      galleryVisible: false
    };
  },
  mounted: function mounted() {
    this.imageClass = this.determineClass(this.$refs.images[0]);
    this.imageOrientation = this.determineOrientation(this.$refs.images[0].naturalWidth, this.$refs.images[0].naturalHeight);
  },

  methods: {
    totalImages: function totalImages() {
      return this.images.length;
    },
    remainingImages: function remainingImages() {
      return this.totalImages() - 4;
    },
    determineOrientation: function determineOrientation(width, height) {
      if (width > height) {
        return 'h';
      }
      return 'v';
    },
    determineClass: function determineClass(image) {
      var gridClasses = {
        1: 'single',
        2: 'double',
        3: 'triple',
        4: 'quadruple'
      };
      var gridClass = gridClasses[this.totalImages()] || 'quadruple';
      return gridClass + '-' + this.determineOrientation(image.naturalWidth, image.naturalHeight);
    },
    imageSelected: function imageSelected(index) {
      this.$emit('imageSelected', [this.images, index]);
    }
  }
});

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loader',
  props: {
    message: {
      type: String,
      default: 'Loading'
    },
    color: {
      type: String,
      default: '#ccc'
    },
    shadow: {
      type: String,
      default: '2px 2px 2px #efefef'
    }
  }
});

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoData',
  props: {
    isVisible: {
      type: Boolean,
      default: true,
      required: false
    }
  }
});

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Paginator',
  props: {
    pages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasNext: function hasNext() {
      return this.currentPage < this.pages;
    },
    hasPrevious: function hasPrevious() {
      return this.currentPage > 1;
    }
  },
  methods: {
    handleNextButton: function handleNextButton() {
      this.$emit('goToNextPage');
    },
    handlePreviousButton: function handlePreviousButton() {
      this.$emit('goToPreviousPage');
    },
    handlePageSelection: function handlePageSelection(page) {
      this.$emit('goToPage', page);
    }
  }
});

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_alerts_mutation_types__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_email_EmailChannelCreateDialog__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_channel_email_EmailChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_channel_email_EmailChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_wechat_WechatChannelCreateDialog__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_channel_wechat_WechatChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_channel_wechat_WechatChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_channel_whatsappweb_WhatsappWebChannelCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_countries_countryCodesMixin__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_channel_channelCreateMixin__ = __webpack_require__(565);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffAlerts',

  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_common_countries_countryCodesMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_channel_channelCreateMixin__["a" /* default */]],

  components: {
    WhatsappWebChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_7__components_channel_whatsappweb_WhatsappWebChannelCreateDialog___default.a,
    FacebookCreateDialog: __WEBPACK_IMPORTED_MODULE_3__components_channel_facebook_FacebookCreateDialog___default.a,
    InstagramCreateDialog: __WEBPACK_IMPORTED_MODULE_4__components_channel_instagram_InstagramCreateDialog___default.a,
    EmailChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_5__components_channel_email_EmailChannelCreateDialog___default.a,
    WechatChannelCreateDialog: __WEBPACK_IMPORTED_MODULE_6__components_channel_wechat_WechatChannelCreateDialog___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('alerts', ['getNextAlert', 'getAllAlerts'])),

  data: function data() {
    return {
      activeAlert: null,
      getAlertsTime: 5 * 60 * 1000, // every 5 minutes
      getAlertsInterval: null,
      alertOpen: false,
      severityTypes: ['info', 'warning', 'error'],
      phoneNumber: null,
      selectedCountry: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getAlertsInterval = setInterval(function (vm) {
      vm.$store.dispatch('alerts/getStaffAlerts');
    }, this.getAlertsTime, this);

    this.$store.subscribe(function (mutation) {
      if (mutation.type === 'alerts/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_alerts_mutation_types__["b" /* GET_STAFF_ALERTS_SUCCESS */]) {
        _this.showNextAlert();
      }
    });
  },
  destroyed: function destroyed() {
    // clean up intervals
    clearInterval(this.getAlertsInterval);
    clearInterval(this.processAlertsInterval);
  },


  methods: {
    handleDialogVisibilityChanged: function handleDialogVisibilityChanged(value, handler) {
      handler(value);

      if (!value) {
        this.alertOpen = false;
        this.showNextAlert();
      }
    },
    handleChannelAdded: function handleChannelAdded(visibilityProp) {
      if (this[visibilityProp]) this[visibilityProp] = false;
      if (this.alertOpen) this.alertOpen = false;

      // mark alert as read.
      this.markRead(this.activeAlert.id);
      this.refetchChannelList();
    },
    showAlert: function showAlert(alert, id) {
      var _this2 = this;

      this.activeAlert = alert;
      this.alertOpen = true;

      this.$msgbox({
        title: alert.title,
        message: alert.body,
        type: this.severityTypes[alert.severity],
        confirmButtonText: 'Read',
        cancelButtonText: alert.link === 'Channel' ? 'Authorise Channel' : null,
        cancelButtonClass: 'warning',
        showCancelButton: alert.link === 'Channel',
        distinguishCancelAndClose: true,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(function (action) {
        if (action === 'confirm') {
          _this2.markRead(id);
          _this2.alertOpen = false;
          _this2.showNextAlert();
        }
      }).catch(function (action) {
        // Authorise Channel sets 'cancel' action.
        if (action === 'cancel' && alert.channel) {
          // WhatsApp channel
          if (alert.channel.channel_type === 9) {
            var filterNumber = alert.channel.handle[0] === '+' ? alert.channel.handle : '+' + alert.channel.handle;
            var country = _this2.getCountryFromPhoneNumber(filterNumber);

            if (country) {
              _this2.phoneNumber = filterNumber.replace(country.dial_code, '');
              _this2.selectedCountry = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, country);
            }
            _this2.showWhatsAppWebCreateDialog = true;
            return;
          }

          _this2.connectChannel(alert.channel.channel_type_title);

          if ([2, 12].includes(alert.channel.channel_type)) {
            _this2.alertOpen = false;
            _this2.showNextAlert();
          }
          return;
        }

        _this2.alertOpen = false;
        _this2.showNextAlert();
      });
    },
    isCreateDialogVisible: function isCreateDialogVisible() {
      var _this3 = this;

      /**
       * Check if any of the create channel dialogs are visible. This avoids overloading
       * conditional logic to check for each one explicitely.
       */

      // property names used for showing channel dialogs.
      var keys = ['showFacebookCreateDialog', 'showInstagramCreateDialog', 'showEmailCreateDialog', 'showWechatCreateDialog', 'showWhatsAppWebCreateDialog'];

      return keys.reduce(function (a, x) {
        if (a) return a;
        return _this3[x];
      }, false);
    },
    showNextAlert: function showNextAlert() {
      if (!this.alertOpen && !this.isCreateDialogVisible()) {
        this.$store.commit('alerts/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_alerts_mutation_types__["g" /* GET_NEXT_STAFF_ALERT */]);
        var alert = this.getNextAlert;
        if (alert) {
          if (this.activeAlert && this.activeAlert.id === alert.id) {
            this.showNextAlert();
            return;
          }
          this.showAlert(alert.alert, alert.id);
        }
      }
    },
    markRead: function markRead(id) {
      this.$store.dispatch('alerts/updateStaffAlertAsRead', id);
    }
  }
});

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_toast_mutation_types___ = __webpack_require__(348);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Toast',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('toast', ['toastTitle', 'toastMessage', 'toastType'])),
  methods: {
    fireNotification: function fireNotification() {
      this.$notify({
        title: this.toastTitle,
        message: this.toastMessage,
        type: this.toastType
      });
      this.$store.commit('toast/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_toast_mutation_types___["b" /* RESET_TOAST */]);
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.toastMessage && this.toastTitle && this.toastType) {
      this.fireNotification();
    }
  }
});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdvertisersChartLoader',
  components: { ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */] }
});

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsChartLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  },
  computed: {
    calculatedHeight: function calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    }
  }
});

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsHeatMapLoader',
  conponents: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnalyticsUnitBlockLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DoughnutChartLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  },
  computed: {
    calculatedHeight: function calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    }
  }
});

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EngagementGraphLoader'
});

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListDividerLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PolarChartLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  },
  computed: {
    calculatedHeight: function calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    }
  }
});

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgrammingDashboardUnitLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeSeriesGraphLoader',
  props: {
    size: {
      type: Array,
      default: function _default() {
        return [780, 400];
      }
    }
  }
});

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WordCloudLoader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  }
});

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countryCodesMixin__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countryCodes_json__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__countryCodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__countryCodes_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CountryCodeSelector',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__countryCodesMixin__["a" /* default */]],

  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_1__countryCodes_json___default.a
    };
  },

  props: {
    browserCountryCode: {
      type: String,
      default: null
    },
    selectedCountry: {
      type: String,
      default: null
    }
  },

  computed: {
    currentCountry: {
      get: function get() {
        return this.selectedCountry;
      },
      set: function set(countryCode) {
        this.$emit('onCountryChanged', this.getCountryByCode(countryCode));
      }
    }
  },

  mounted: function mounted() {
    if (this.browserCountryCode) {
      this.$emit('onCountryChanged', this.getCountryByCode(this.browserCountryCode));
    }
  }
});

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugin_PluginList__ = __webpack_require__(2974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugin_PluginList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugin_PluginList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_UserList__ = __webpack_require__(3086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_user_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_timeslots_TimeslotList__ = __webpack_require__(3084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_timeslots_TimeslotList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_timeslots_TimeslotList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_blacklist_BlacklistOriginatorList__ = __webpack_require__(2899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_blacklist_BlacklistOriginatorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_blacklist_BlacklistOriginatorList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_automatedemails_recipients_EmailRecipientList__ = __webpack_require__(2891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_automatedemails_recipients_EmailRecipientList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_automatedemails_recipients_EmailRecipientList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_publishing_GenerateURL__ = __webpack_require__(3004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_publishing_GenerateURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_publishing_GenerateURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_permission_publishing_GeneratePermissionURL__ = __webpack_require__(2973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_permission_publishing_GeneratePermissionURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_permission_publishing_GeneratePermissionURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_accounts_myCompanyQuery_gql__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_accounts_myCompanyQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__graphql_accounts_myCompanyQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_accounts_myCompaniesQuery_gql__ = __webpack_require__(2567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_accounts_myCompaniesQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__graphql_accounts_myCompaniesQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_accounts_listOrgUsersQuery_gql__ = __webpack_require__(2566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_accounts_listOrgUsersQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__graphql_accounts_listOrgUsersQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_automatedemails_recipients_listRecipients_gql__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_automatedemails_recipients_listRecipients_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__graphql_automatedemails_recipients_listRecipients_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompanyDetail__ = __webpack_require__(2942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompanyDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CompanyDetail__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanyDashboard',
  components: {
    PluginsList: __WEBPACK_IMPORTED_MODULE_2__components_plugin_PluginList___default.a,
    CompanyDetails: __WEBPACK_IMPORTED_MODULE_13__CompanyDetail___default.a,
    UserList: __WEBPACK_IMPORTED_MODULE_3__components_user_UserList___default.a,
    TimeslotList: __WEBPACK_IMPORTED_MODULE_4__components_timeslots_TimeslotList___default.a,
    BlacklistOriginatorList: __WEBPACK_IMPORTED_MODULE_5__components_blacklist_BlacklistOriginatorList___default.a,
    EmailRecipientList: __WEBPACK_IMPORTED_MODULE_6__components_automatedemails_recipients_EmailRecipientList___default.a,
    GenerateURL: __WEBPACK_IMPORTED_MODULE_7__components_publishing_GenerateURL___default.a,
    GeneratePermissionURL: __WEBPACK_IMPORTED_MODULE_8__components_permission_publishing_GeneratePermissionURL___default.a
  },
  data: function data() {
    return {
      organizationUsers: [],
      myCompanies: [],
      myCompany: null,
      recipients: []
    };
  },
  apollo: {
    myCompanies: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_10__graphql_accounts_myCompaniesQuery_gql___default.a,
      prefetch: true
    },
    organizationUsers: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_11__graphql_accounts_listOrgUsersQuery_gql___default.a,
      prefetch: true
    },
    myCompany: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_9__graphql_accounts_myCompanyQuery_gql___default.a,
      prefetch: true
    },
    recipients: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_12__graphql_automatedemails_recipients_listRecipients_gql___default.a,
      prefetch: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('blacklist', ['blacklistedOriginators']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('timeslots', ['timeslots']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me', 'groups', 'companyUsers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('plugin', ['plugins', 'loadingPlugins']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('campaign', ['campaigns']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('company', ['companies']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('survey', ['surveys']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('campaign', ['activeCampaigns']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('publishing', ['generatedUrl', 'loadingGenerateUrl', 'generateUrlSuccess']), {
    emailUsers: function emailUsers() {
      return this.organizationUsers.length ? this.organizationUsers : this.companyUsers;
    },
    hasPermissionPlugin: function hasPermissionPlugin() {
      return this.plugins.some(function (permission) {
        return permission.plugin_route === 'app.profiles.permissions';
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapActions */])('company', ['updateCompany']), {
    refetchRecipients: function refetchRecipients() {
      this.$apollo.queries.recipients.refetch();
    }
  }),
  mounted: function mounted() {
    // this.$store.dispatch('company/getCompany');
    this.$store.dispatch('timeslots/getTimeslots');
    this.$store.dispatch('user/getGroups');
    this.$store.dispatch('user/getCompanyUsers');
    this.$store.dispatch('plugin/getPlugins');
    this.$store.dispatch('blacklist/getBlacklistedOriginators');
    this.$store.dispatch('campaign/getCampaigns');
    this.$store.dispatch('survey/getSurveys');
    this.$store.dispatch('company/getCompanies');
  },

  watch: {
    updatingCompanySucceeded: function updatingCompanySucceeded() {
      if (this.updatingCompanySucceeded) {
        this.$emit('closeUpdateCompanyDialog');
        this.$store.dispatch('toast/success', 'Company successfully updated.');
      }
    }
  }
});

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_accounts_updateCompanyMutation_gql__ = __webpack_require__(2568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_accounts_updateCompanyMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__graphql_accounts_updateCompanyMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_countries_allCountriesQuery_gql__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_countries_allCountriesQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_countries_allCountriesQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_countries_countryRegionsQuery_gql__ = __webpack_require__(2594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_countries_countryRegionsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_countries_countryRegionsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_permissions_Can__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanyDetail',
  components: {
    Can: __WEBPACK_IMPORTED_MODULE_5__components_permissions_Can___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('company', ['timezones', 'loadingTimezones'])),
  data: function data() {
    return {
      dialogVisible: false,
      logoImage: null,
      surveyImage: null,
      regions: [],
      inputVisible: { saveOptoutInput: false, saveOptinInput: false },
      inputValue: { saveOptinInput: '', saveOptoutInput: '' }
    };
  },
  props: {
    company: {
      type: Object,
      default: null
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    countries: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_countries_allCountriesQuery_gql___default.a,
      prefetch: true
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    handleLogoImageChange: function handleLogoImageChange(file) {
      this.logoImage = file.raw;
    },
    handleSurveyImageChange: function handleSurveyImageChange(file) {
      this.surveyImage = file.raw;
    },
    handleFileRemove: function handleFileRemove() {},
    handleCountryChange: function handleCountryChange(country) {
      var _this = this;

      this.$apollo.query({
        client: 'apiv2',
        query: __WEBPACK_IMPORTED_MODULE_4__graphql_countries_countryRegionsQuery_gql___default.a,
        variables: {
          country: country
        }
      }).then(function (_ref) {
        var data = _ref.data;

        _this.regions = data.regions;
      });
    },
    handleUpdateCompany: function handleUpdateCompany() {
      var _this2 = this;

      var company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.company);
      if (this.surveyImage) {
        company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, company, { surveyImage: this.surveyImage });
      } else {
        delete company.surveyImage;
      }
      if (this.logoImage) {
        company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, company, { logoImage: this.logoImage });
      } else {
        delete company.logoImage;
      }
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_2__graphql_accounts_updateCompanyMutation_gql___default.a,
        variables: {
          data: company
        }
      }).then(function () {
        _this2.closeDialog();
      });
    },
    handleClose: function handleClose(keywords, tag) {
      keywords.splice(keywords.indexOf(tag), 1);
    },
    showInput: function showInput(ref) {
      var _this3 = this;

      this.inputVisible[ref] = true;
      this.$nextTick(function () {
        _this3.$refs[ref].$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm(keywords, ref) {
      var inputValue = this.inputValue[ref];
      if (inputValue) {
        keywords.push(inputValue);
      }
      this.inputVisible[ref] = false;
      this.inputValue[ref] = '';
    }
  },
  created: function created() {
    this.$parent.$on('closeUpdateCompanyDialog', this.closeDialog);
  },
  mounted: function mounted() {
    this.$store.dispatch('company/getTimezones');
  }
});

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanySelector',
  data: function data() {
    return {
      search: ''
    };
  },
  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      return this.companies.filter(function (company) {
        return company.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
      });
    }
  },
  props: {
    companies: {
      type: Array,
      default: []
    }
  },
  methods: {
    switchCompany: function switchCompany(company) {
      this.$emit('onSwitchCompany', { company: company.id });
    }
  }
});

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_contactAccountsListProvider_gql__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_contactAccountsListProvider_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_contacts_contactAccountsListProvider_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_contact__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContactListsSelect__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContactListsSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ContactListsSelect__);






var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n              mutation($id: String!, $batchImport: Json!) {\n                constantContactImport(id: $id, batchImport: $batchImport) {\n                  id\n                  type\n                  errorCount\n                  contactCount\n                }\n              }\n            '], ['\n              mutation($id: String!, $batchImport: Json!) {\n                constantContactImport(id: $id, batchImport: $batchImport) {\n                  id\n                  type\n                  errorCount\n                  contactCount\n                }\n              }\n            ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConstantContactDialog',
  components: {
    ContactListsSelect: __WEBPACK_IMPORTED_MODULE_9__ContactListsSelect___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default.a
  },
  props: {
    contacts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingContacts: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['EMAIL', 'FIRST NAME', 'LAST NAME', 'HOME PHONE'];
      }
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'No emails were provided in this survey, make sure the survey asks for an email address.'
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    }
  },
  data: function data() {
    return {
      contactAccounts: [],
      selectedLists: {},
      lists: []
    };
  },
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_contactAccountsListProvider_gql___default.a,
      prefetch: true,
      variables: function variables() {
        return {
          provider: 'constant_contact'
        };
      }
    }
  },
  methods: {
    parseProviderName: __WEBPACK_IMPORTED_MODULE_8__helpers_contact__["a" /* parseProviderName */],
    handleSelectedListsChange: function handleSelectedListsChange(id, lists) {
      this.selectedLists[id] = lists;
    },
    buildMutations: function buildMutations() {
      var _this = this;

      var mutations = [];
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.selectedLists).forEach(function (key) {
        var val = _this.selectedLists[key];
        _this.importData = {
          import_data: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.contacts)),
          lists: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.lists), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(val)),
          column_names: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.columns))
        };
        mutations = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(mutations), [{
          client: 'apiv2',
          mutation: __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject),
          variables: { id: key, batchImport: _this.importData }
        }]);
      });
      return mutations;
    },
    open: function open() {
      this.$emit('open');
    },
    handleImportClick: function handleImportClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mutations;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.contacts.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                _this2.$notify({
                  title: 'No emails provided!',
                  message: _this2.errorMessage,
                  type: 'warning'
                });
                _this2.dialogVisible = false;
                return _context2.abrupt('return');

              case 4:
                mutations = _this2.buildMutations();


                mutations.forEach(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(mutation) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this2.$apollo.mutate(mutation);

                          case 2:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _this2.$notify({
                  title: 'Contacts imported!',
                  message: 'Contacts have been imported into the selected lists.',
                  type: 'success'
                });
                _this2.dialogVisible = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_contact__ = __webpack_require__(245);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactListsSelect',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default.a
  },
  props: {
    id: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      contactLists: [],
      selectedLists: [],
      skipConstantContactQuery: true,
      skipMailChimpQuery: true
    };
  },
  apollo: {
    $client: 'apiv2',
    constantContactLists: {
      query: __WEBPACK_IMPORTED_MODULE_0__graphql_contacts_contactList_gql___default.a,
      skip: function skip() {
        return this.skipConstantContactQuery;
      },
      variables: function variables() {
        return {
          id: this.id
        };
      },
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading;

        this.contactLists = !loading ? data.constantContactLists : [];
      }
    },
    mailChimpLists: {
      query: __WEBPACK_IMPORTED_MODULE_1__graphql_contacts_mailChimpContactLists_gql___default.a,
      skip: function skip() {
        return this.skipMailChimpQuery;
      },
      variables: function variables() {
        return {
          id: this.id
        };
      },
      result: function result(_ref2) {
        var data = _ref2.data,
            loading = _ref2.loading;

        this.contactLists = !loading ? data.mailChimpLists : [];
      }
    }
  },
  mounted: function mounted() {
    switch (this.provider) {
      case 'constant_contact':
        this.skipConstantContactQuery = false;
        this.$apollo.queries.constantContactLists.refetch({ id: this.id });
        break;
      case 'mail_chimp':
        this.skipMailChimpQuery = false;
        this.$apollo.queries.mailChimpLists.refetch({ id: this.id });
        break;
      default:
        break;
    }
  },

  methods: {
    parseProviderName: __WEBPACK_IMPORTED_MODULE_3__helpers_contact__["a" /* parseProviderName */],
    handleSelectedListsChange: function handleSelectedListsChange() {
      this.$emit('selectedListsChange', this.id, this.selectedLists);
    }
  }
});

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_contactAccountsListProvider_gql__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_contactAccountsListProvider_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_contacts_contactAccountsListProvider_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_contact__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContactListsSelect__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContactListsSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ContactListsSelect__);








var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n              mutation($id: String!, $operationsData: Json!) {\n                mailChimpImport(id: $id, operationsData: $operationsData) {\n                  id\n                  type\n                  errorCount\n                  contactCount\n                }\n              }\n            '], ['\n              mutation($id: String!, $operationsData: Json!) {\n                mailChimpImport(id: $id, operationsData: $operationsData) {\n                  id\n                  type\n                  errorCount\n                  contactCount\n                }\n              }\n            ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MailChimpDialog',
  components: {
    ContactListsSelect: __WEBPACK_IMPORTED_MODULE_11__ContactListsSelect___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_9__components_common_Loader___default.a
  },
  props: {
    contacts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    loadingContacts: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'No emails were provided in this survey, make sure the survey asks for an email address.'
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    },
    operations: function operations() {
      var _this = this;

      var listOperations = {};

      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.selectedLists).forEach(function (key) {
        var operations = [];
        var listIds = _this.selectedLists[key];

        listIds.forEach(function (listId) {
          operations = _this.contacts.map(function (contact) {
            return {
              method: 'POST',
              path: '/lists/' + listId + '/members/',
              operation_id: 'add-' + contact.email_address + '-' + listId,
              body: contact
            };
          });

          listOperations = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, listOperations, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(operations))));
        });
      });
      return listOperations;
    }
  },
  data: function data() {
    return {
      contactAccounts: [],
      selectedLists: {}
    };
  },
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_contactAccountsListProvider_gql___default.a,
      prefetch: true,
      variables: function variables() {
        return {
          provider: 'mail_chimp'
        };
      }
    }
  },
  methods: {
    parseProviderName: __WEBPACK_IMPORTED_MODULE_10__helpers_contact__["a" /* parseProviderName */],
    handleSelectedListsChange: function handleSelectedListsChange(id, lists) {
      this.selectedLists[id] = lists;
    },
    buildMutations: function buildMutations() {
      var _this2 = this;

      var mutations = [];
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.operations).forEach(function (key) {
        var operationList = _this2.operations[key];
        mutations = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(mutations), [{
          client: 'apiv2',
          mutation: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject),
          variables: { id: key, operationsData: operationList }
        }]);
      });
      return mutations;
    },
    handleImportClick: function handleImportClick() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var mutations;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(_this3.operations).length === 0)) {
                  _context2.next = 4;
                  break;
                }

                _this3.$notify({
                  title: 'No emails provided!',
                  message: _this3.errorMessage,
                  type: 'warning'
                });
                _this3.dialogVisible = false;
                return _context2.abrupt('return');

              case 4:
                mutations = _this3.buildMutations();

                mutations.forEach(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(mutation) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this3.$apollo.mutate(mutation);

                          case 2:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _this3.$notify({
                  title: 'Contacts imported!',
                  message: 'Please allow up to 24 hours for contacts to show in mail chimp.',
                  type: 'success'
                });
                _this3.dialogVisible = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    open: function open() {
      this.$emit('open');
    }
  }
});

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxList__ = __webpack_require__(2947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_filebox_FileboxStats__ = __webpack_require__(2948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_filebox_FileboxStats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_filebox_FileboxStats__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileboxDashboard',
  components: {
    FileboxList: __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxList___default.a,
    FileboxStats: __WEBPACK_IMPORTED_MODULE_1__components_filebox_FileboxStats___default.a
  },
  props: {
    myFiles: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    companyFiles: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    loadingMyFiles: {
      type: Boolean,
      default: false
    },
    loadingCompanyFiles: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Object,
      default: function _default() {},
      required: true
    }
  }
});

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxTable__ = __webpack_require__(2949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileboxList',
  components: { FileboxTable: __WEBPACK_IMPORTED_MODULE_0__components_filebox_FileboxTable___default.a, IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a },
  data: function data() {
    return {
      activeTabName: 'myFiles'
    };
  },
  props: {
    myFiles: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    companyFiles: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    loadingMyFiles: {
      type: Boolean,
      default: false
    },
    loadingCompanyFiles: {
      type: Boolean,
      default: false
    },
    icons: {
      type: Object,
      default: function _default() {},
      required: true
    }
  }
});

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileboxStats',
  components: { IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a },
  props: {
    numCompanyFiles: {
      type: Number,
      default: 0,
      required: true
    },
    numMyFiles: {
      type: Number,
      default: 0,
      required: true
    }
  }
});

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileboxTable',
  props: {
    files: {
      type: Array,
      required: true
    },
    icons: {
      type: Object,
      required: true
    }
  },
  methods: {
    moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
    getFileIcon: function getFileIcon(filename) {
      var fileExtension = filename.split('.').pop();
      return this.icons.file[fileExtension];
    },
    handleDownload: function handleDownload(fileURL) {
      window.open(fileURL, '_blank');
    }
  }
});

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Transcript',
  props: {
    transcript: {
      type: Array,
      required: true
    }
  },
  methods: {
    getTranscript: function getTranscript() {
      return this.transcript.filter(function (t) {
        return t && t.toString().trim().length > 0;
      }).join(' ');
    }
  }
});

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_FabSpeedDial__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_FabSpeedDial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_FabSpeedDial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_interaction_InstantPoll__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_interaction_InstantPoll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_interaction_InstantPoll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',

  components: {
    FabSpeedDial: __WEBPACK_IMPORTED_MODULE_0__components_common_FabSpeedDial___default.a,
    InstantPoll: __WEBPACK_IMPORTED_MODULE_1__components_interaction_InstantPoll___default.a
  },

  data: function data() {
    return {
      bgColor: '#ee2465',
      position: 'bottom-right',
      fabActions: [{
        name: 'addActivityFeed',
        icon: 'fa fa-fw fa-rss',
        tooltip: 'Activity Feed'
      }, {
        name: 'addOnAir',
        icon: 'fa fa-fw fa-microphone',
        tooltip: 'On Air'
      }, {
        name: 'addInstantPoll',
        icon: 'fa fa-fw fa-bolt',
        tooltip: 'New Instant Poll'
      },
      // {
      //   name: 'addTwitterTrends',
      //   icon: 'fa fa-fw fa-twitter',
      //   tooltip: 'Twitter Trends',
      // },
      {
        name: 'addChat',
        icon: 'fa fa-fw fa-comments',
        tooltip: 'Chat'
      }, {
        name: 'addNewPanel',
        icon: 'fa fa-fw fa-file-text-o',
        tooltip: 'New panel'
      }]
    };
  },

  methods: {
    handleAddPanel: function handleAddPanel() {
      this.$emit('onAddPanel');
    },
    handleAddOnAir: function handleAddOnAir() {
      this.$emit('onShowPanel', ['onair', false]);
    },
    handleAddActivityFeed: function handleAddActivityFeed() {
      this.$emit('onShowPanel', ['activity', false]);
    },
    handleAddTwitterTrends: function handleAddTwitterTrends() {
      this.$emit('onShowPanel', ['twittertrends', false]);
    },
    handleAddChat: function handleAddChat() {
      this.$emit('onShowPanel', ['chat', false]);
    },
    handleAddInstantPoll: function handleAddInstantPoll() {
      this.$emit('onInstantPoll', ['instantpoll', false]);
    }
  }
});

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_createInstantPollCampaignMutation_gql__ = __webpack_require__(2596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_createInstantPollCampaignMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_createInstantPollCampaignMutation_gql__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InstantPoll',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    pollChoices: function pollChoices() {
      return this.form.channelKeyword.map(function (choice) {
        return { choice: choice, matches: [choice] };
      });
    },
    channelsIds: function channelsIds() {
      return this.form.channels.map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            channelId = _ref2[1];

        return parseInt(channelId, 10);
      });
    },
    groupedChannels: function groupedChannels() {
      var channelTitles = { Dms: 'DMS' };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["groupBy"])(this.channels, 'channel_type_title')).filter(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
            label = _ref4[0];

        return label !== 'Survey';
      }).sort().map(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            label = _ref6[0],
            children = _ref6[1];

        return {
          label: channelTitles[label] || label,
          value: label,
          children: children.sort().map(function (channel) {
            return { label: channel.handle, value: channel.id };
          })
        };
      });
    }
  },
  methods: {
    handleCloseDialog: function handleCloseDialog(event) {
      this.form = {
        campaignTitle: '',
        campaignDates: [],
        campaignType: 'INSTANT_POLL',
        perpetual: false,
        channelKeyword: [],
        channels: [],
        isUnique: true
      };
      this.$emit(event);
    },
    handleCreateInstantPoll: function handleCreateInstantPoll() {
      var _this = this;

      this.mutationLoading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_createInstantPollCampaignMutation_gql___default.a,
        variables: {
          campaignTitle: this.form.campaignTitle,
          campaignStartDate: this.form.campaignDates[0],
          campaignEndDate: this.form.campaignDates[1],
          campaignType: this.form.campaignType,
          channelKeywords: this.form.channelKeyword,
          channelIds: this.channelsIds,
          pollQuestion: this.form.campaignTitle,
          pollChoices: this.pollChoices,
          winningDisqualificationDuration: null,
          isUnique: this.form.isUnique
        }
      }).then(function (response) {
        var campaignId = parseInt(response.data.createCampaign.campaign.id, 10);
        _this.$emit('createPanel', [_this.form.campaignTitle, [campaignId], _this.channelsIds]);
        _this.mutationLoading = false;
        _this.$notify({
          title: 'Success!',
          message: 'Your instant poll was successfully created',
          type: 'success'
        });
      }).catch(function () {
        _this.mutationLoading = false;
        _this.$notify({
          title: 'Error!',
          message: 'Unable to create your instant poll',
          type: 'error'
        });
      });
    },
    handlePickerShortcut: function handlePickerShortcut(picker, amount, unit) {
      var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate();
      var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(amount, unit).toDate();
      picker.$emit('pick', [startDate, endDate]);
    },
    handleInputConfirm: function handleInputConfirm() {
      var keyword = this.keyword;
      if (keyword) {
        this.form.channelKeyword.push(keyword);
      }
      this.keywordInputVisible = false;
      this.keyword = '';
    },
    showInput: function showInput() {
      var _this2 = this;

      this.keywordInputVisible = true;
      this.$nextTick(function (tick) {
        _this2.nextTick = tick;
        _this2.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose: function handleClose(tag) {
      this.form.channelKeyword.splice(this.form.channelKeyword.indexOf(tag), 1);
    }
  },
  data: function data() {
    return {
      form: {
        campaignTitle: '',
        campaignDates: [],
        campaignType: 'INSTANT_POLL',
        perpetual: false,
        channelKeyword: [],
        channels: []
      },
      mutationLoading: false,
      nextTick: '',
      keywordInputVisible: false,
      keyword: '',
      rules: {
        campaignTitle: [{ required: true, message: 'Please input the name of your instant poll' }],
        campaignDates: [{ required: true, message: 'Please select the date range for your instant poll' }]
      },
      pickerOptions: {
        shortcuts: [{
          text: '15 mins',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(15, 'minute').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '30 mins',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(30, 'minute').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '45 mins',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(45, 'minute').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '1 Hour',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(1, 'hour').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '1 Hour 30 Mins',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(1.5, 'hour').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '2 Hours',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(2, 'hour').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '3 Hours',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(5, 'minute').set({ seconds: 0, milliseconds: 0 }).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).add(3, 'hour').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }]
      }
    };
  }
});

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Interaction',
  props: ['interaction'],
  data: function data() {
    return {
      iconClasses: {
        facebook_post: 'fa-facebook',
        facebook_comment: 'fa-comment',
        facebook_message: 'fa-facebook',
        twitter: 'fa-twitter',
        tweet: 'fa-twitter',
        instagram: 'fa-instagram',
        message: 'fa-mobile',
        sms: 'fa-mobile',
        whatsapp: 'fa-whatsapp',
        email: 'fa-envelope-o',
        titkok: 'fa-play-circle-o'
      }
    };
  },
  computed: {
    mediaExists: function mediaExists() {
      return this.interaction.ore.image || this.interaction.ore.video || this.interaction.ore.audio;
    }
  },
  methods: {
    getMediaValue: function getMediaValue(interaction, mediaType) {
      /* eslint no-prototype-builtins :off */
      if (interaction.ore.hasOwnProperty(mediaType) && interaction.ore[mediaType] && interaction.ore[mediaType].length && interaction.ore[mediaType][0].hasOwnProperty('value')) {
        return interaction.ore[mediaType][0].value;
      }
      return '';
    },
    imageLoadOnError: function imageLoadOnError() {
      this.interaction.ore.profile_image[0].value = '/static/assets/icons/user/default_profile_normal.png';
    }
  }
});

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//

var cutJoin = function cutJoin(str) {
  return '' + str[0].toUpperCase() + str.slice(1).toLowerCase();
};
var capitalise = function capitalise(str) {
  var strArray = str.split('_');
  return Array.isArray(strArray) ? strArray.map(cutJoin).join(' ') : '' + str[0].toUpperCase() + str.slice(1).toLowerCase();
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InteractionsFilter',
  props: {
    profile: {
      type: Object,
      default: function _default() {}
    },
    interactions: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectedChannelFilterList: [],
      alternativeChannelNames: {
        tweet: {
          name: 'Twitter',
          key: 'tweet'
        },
        message: {
          name: 'SMS',
          key: 'message'
        },
        sms: { name: 'SMS', key: 'message' }
      }
    };
  },


  methods: {
    getChannelsList: function getChannelsList() {
      var channelNameKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.interactions).map(function (ch) {
        return capitalise(ch);
      });
      return channelNameKeys;
    },
    getChannelName: function getChannelName(channelName) {
      return this.alternativeChannelNames[channelName.toLowerCase()] ? this.alternativeChannelNames[channelName.toLowerCase()].name : channelName;
    },
    getChannelKey: function getChannelKey(ch) {
      return this.alternativeChannelNames[ch.toLowerCase()] ? this.alternativeChannelNames[ch.toLowerCase()].key : ch.toLowerCase();
    },
    handleInteractionFiltersChange: function handleInteractionFiltersChange(checkedChannelsList) {
      var channelKeys = checkedChannelsList.map(this.getChannelKey);
      this.$emit('onFilterInteractions', channelKeys);
    }
  }
});

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sanitize_html__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sanitize_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pipe_operator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pipe_operator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pipe_operator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_interaction__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ImageGrid__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_ImageGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_ImageGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_interaction_MessageComment__ = __webpack_require__(2954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_interaction_MessageComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_interaction_MessageComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_interaction_MessageReply__ = __webpack_require__(2956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_interaction_MessageReply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_interaction_MessageReply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_interaction_AudioTranscript__ = __webpack_require__(2950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_interaction_AudioTranscript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_interaction_AudioTranscript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ParentInteraction__ = __webpack_require__(2958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ParentInteraction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ParentInteraction__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Message',
  components: {
    AudioTranscript: __WEBPACK_IMPORTED_MODULE_12__components_interaction_AudioTranscript___default.a,
    ImageGrid: __WEBPACK_IMPORTED_MODULE_9__components_common_ImageGrid___default.a,
    MessageComment: __WEBPACK_IMPORTED_MODULE_10__components_interaction_MessageComment___default.a,
    MessageReply: __WEBPACK_IMPORTED_MODULE_11__components_interaction_MessageReply___default.a,
    ParentInteraction: __WEBPACK_IMPORTED_MODULE_14__ParentInteraction___default.a
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    threadId: {
      type: Number
    },
    originator: {
      type: String,
      required: true
    },
    originatorType: {
      type: String,
      required: true,
      default: 'telegram'
    },
    datetime: {
      type: Object,
      required: true
    },
    channel: {
      type: String,
      required: true
    },
    columns: {
      type: Number,
      default: 1
    },
    displayName: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    audio: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    video: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    document: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    text: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    avatar: {
      type: String,
      default: '/static/assets/icons/user/default_profile_normal.png'
    },
    comments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    replies: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onAirUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOnAir: {
      type: Boolean,
      default: false
    },
    sentOnAirBy: {
      type: String,
      default: ''
    },
    onAirId: {
      type: Number,
      default: null
    },
    datetimeIsChanged: {
      type: Boolean
    },
    parentInteraction: {
      type: Object,
      default: null,
      required: false
    },
    sentiment: {
      type: String,
      default: null
    },
    inCount: {
      type: Number,
      default: 0
    },
    outCount: {
      type: Number,
      default: 0
    },
    showTools: {
      type: Boolean,
      default: true
    },
    autoCollapseParentInteraction: {
      type: Boolean,
      default: false
    },
    shouldPause: {
      type: Boolean,
      default: false
    },
    mediaPreload: {
      type: String,
      default: 'auto'
    },
    audioTranscript: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      interval: null,
      avatarError: false,
      channelMeta: {
        facebook_comment: {
          icon: 'fa-facebook',
          color: '#4767aa',
          title: 'Facebook Comment'
        },
        facebook_post: {
          icon: 'fa-facebook',
          color: '#4767aa',
          title: 'Facebook Post'
        },
        facebook_message: {
          icon: 'fa-facebook',
          color: '#4767aa',
          title: 'Facebook Message'
        },
        twitter: { icon: 'fa-twitter', color: '#1da1f2', title: 'Twitter' },
        tweet: { icon: 'fa-twitter', color: '#1da1f2', title: 'Twitter' },
        message: { icon: 'fa-mobile', color: '#2993cf', title: 'SMS' },
        sms: { icon: 'fa-mobile', color: '#2993cf', title: 'SMS' },
        whatsapp: { icon: 'fa-whatsapp', color: '#0fa251', title: 'Whatsapp' },
        whatsappweb: { icon: 'fa-whatsapp', color: '#0fa251', title: 'Whatsapp' },
        instagram: { icon: 'fa-instagram', color: '#ed1f65', title: 'Instagram' },
        telegram: { icon: 'fa-telegram', color: '#1da1f2', title: 'Telegram' },
        dms: { icon: 'fa-mobile', color: '#1da1f2', title: 'Dms' },
        mtech: { icon: 'fa-mobile', color: '#1da1f2', title: 'Mtech' },
        infobip: { icon: 'fa-mobile', color: '#1da1f2', title: 'Infobip' },
        email: { icon: 'fa-envelope', color: '#1da1f2', title: 'E-Mail' },
        survey: { icon: 'fa-question', color: '#e47923', title: 'Survey' },
        profile_inject: { icon: 'fa-file', color: '#000000', title: 'Data Import' },
        ussd: { icon: 'fa-signal', color: '#2993cf', title: 'USSD' },
        webform: { icon: 'fa-upload', color: '#676A6C', title: 'Data Import' },
        tiktok: { icon: 'fa-play-circle', color: '#000000', title: 'TikTok' }
      },
      isExpanded: false,
      showInput: null,
      showCommentsAndReplies: false,
      showAudioTranscript: false,
      selectedOnAirUser: null,
      replyMessage: '',
      commentMessage: '',
      height: 0,
      videoListeners: {},
      commentsAndRepliesCount: 0,
      defaultAvatar: '/static/assets/icons/user/default_profile_normal.png',
      firstname: null,
      lastname: null,
      mediaIsPlaying: false,
      relativeTime: null
    };
  },
  created: function created() {
    var _this = this;

    this.lastname = this.$store.state.user.me.last_name;
    this.firstname = this.$store.state.user.me.first_name;
    this.interval = setInterval(function () {
      _this.relativeTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(_this.datetime).fromNow();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    clearInterval(this.interval);
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.videoListeners).forEach(function (key) {
      _this2.$refs[key][0].removeEventListener('ondurationchange', _this2.videoListeners[key]);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.commentsAndRepliesCount = this.commentsAndReplies.length;
    this.updateHeight();

    if (!this.video.length) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$refs).filter(function (refKey) {
      return refKey.startsWith('video');
    }).forEach(function (vidKey) {
      var vidElem = _this3.$refs[vidKey][0];
      _this3.videoListeners[vidKey] = vidElem.addEventListener('durationchange', function () {
        _this3.updateHeight();
        vidElem.removeEventListener('ondurationchange', _this3.videoListeners[vidKey]);
      });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('user', ['me']), {

    computedOnAirUser: {
      get: function get() {
        var _this4 = this;

        if (this.selectedOnAirUser) {
          return this.selectedOnAirUser;
        } else if (this.onAirUsers.find(function (u) {
          return u.id === _this4.me.id;
        })) {
          return this.me.id;
        }
        return null;
      },
      set: function set(onAirUser) {
        this.selectedOnAirUser = onAirUser;
      }
    },

    displayDatetime: function displayDatetime() {
      if (this.datetimeIsChanged) {
        var relativeTime = this.relativeTime || __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.datetime).fromNow();
        // If the relative time displays in the future, change the message to 'now'
        return relativeTime.startsWith('in') ? 'now' : relativeTime;
      }
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.datetime).format('LLLL');
    },
    showReplyOption: function showReplyOption() {
      var doNotReplyTo = ['Instagram'];
      var channelName = this.channelMeta[this.channel].title;
      return !doNotReplyTo.includes(channelName);
    },
    messageLength: function messageLength() {
      return this.columns && this.columns > 1 ? this.columns * 140 : 140;
    },
    getAvatar: function getAvatar() {
      if (this.avatarError) {
        return false;
      }
      return this.avatar || false;
    },
    formattedMessage: function formattedMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_pipe_operator__["take"])(this.message).pipe(this.truncate).pipe(__WEBPACK_IMPORTED_MODULE_5_sanitize_html___default.a).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["b" /* nl2br */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["c" /* makeHyperlinks */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["d" /* makeHashtags */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["e" /* makeMentions */]).result();
    },
    commentsAndReplies: function commentsAndReplies() {
      return [].concat(this.replies.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(r, { type: 'reply' });
      })).concat(this.comments.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(c, { type: 'comment' });
      })).sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
    },
    hasTranscript: function hasTranscript() {
      return Array.isArray(this.audioTranscript) && this.audioTranscript.some(function (t) {
        return t && t.toString().trim().length > 0;
      });
    }
  }),
  watch: {
    selectedOnAirUser: function selectedOnAirUser() {
      this.sendOnAir();
    },
    isExpanded: function isExpanded() {
      this.updateHeight();
    },
    shouldPause: function shouldPause() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$refs).filter(function (refKey) {
        return refKey.startsWith('audio') || refKey.startsWith('video');
      }).forEach(function (mediaKey) {
        var mediaElem = _this5.$refs[mediaKey][0];
        if (mediaElem) {
          mediaElem.pause();
        }
      });
    }
  },
  methods: {
    changeDatetimePostFormat: function changeDatetimePostFormat() {
      this.$emit('changeDatetimePostFormat', !this.datetimeIsChanged);
    },
    getDocumentName: function getDocumentName(filename) {
      return filename.endsWith('.bat') ? 'document_' + filename.slice(-20, -4) + '.txt' : 'document_' + filename.slice(-20);
    },
    sendReply: function sendReply() {
      this.$store.dispatch('interaction/sendReply', {
        interactionId: this.id,
        message: this.replyMessage
      });
      this.commentsAndRepliesCount = this.commentsAndRepliesCount + 1;
      var newReply = {
        type: 'reply',
        full_name: this.firstname + ' ' + this.lastname,
        value: this.replyMessage,
        date_created: new Date()
      };
      this.replies.push(newReply);
      this.commentsAndReplies = [].concat(this.replies.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(r, { type: 'reply' });
      })).concat(this.comments.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(c, { type: 'comment' });
      })).sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
      this.$forceUpdate();
      this.showInput = null;
      this.replyMessage = '';
    },
    sendComment: function sendComment() {
      this.$store.dispatch('interaction/sendComment', {
        interactionId: this.id,
        message: this.commentMessage
      });
      this.commentsAndRepliesCount = this.commentsAndRepliesCount + 1;
      var newComment = {
        type: 'comment',
        value: this.commentMessage,
        date_created: new Date()
      };
      this.comments.push(newComment);
      this.commentsAndReplies = [].concat(this.replies.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(r, { type: 'reply' });
      })).concat(this.comments.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(c, { type: 'comment' });
      })).sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
      this.$forceUpdate();
      this.showInput = null;
      this.commentMessage = '';
    },
    sendOnAir: function sendOnAir() {
      // If selected user is blank, don't do anything further
      var userId = this.computedOnAirUser;
      if (!userId) {
        return;
      }

      this.showInput = null;
      this.selectedOnAirUser = null;
      var user = this.onAirUsers.filter(function (u) {
        return userId === u.id;
      })[0];
      this.$store.dispatch('interaction/sendToOnAir', {
        interactionId: this.id,
        userName: user.first_name,
        userId: userId
      });
    },
    updateHeight: function updateHeight() {
      // Height plus padding
      this.height = this.$el.offsetHeight + 12;
      this.$emit('heightUpdated', [this.id, this.height]);
    },
    showGallery: function showGallery(args) {
      var _args = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(args, 2),
          images = _args[0],
          imageIndex = _args[1];

      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["K" /* SET_GALLERY_IMAGES */], images);
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["M" /* SET_GALLERY_INDEX */], imageIndex);
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["L" /* SET_GALLERY_VISIBLE */], true);
    },
    showThread: function showThread() {
      this.$store.dispatch('interaction/fetchThreads', {
        threadId: this.threadId,
        channelType: this.channel
      });
    },
    setInput: function setInput(inputType) {
      if (this.showInput === inputType) {
        this.showInput = null;
      } else {
        this.showInput = inputType;
      }
    },
    truncate: function truncate(str) {
      if (str.length > this.messageLength && !this.isExpanded) {
        return str.substring(0, this.messageLength) + '...';
      }
      return str;
    },
    switchDateOutput: function switchDateOutput() {
      this.$emit('switchDateOutput');
    },
    exportFacebookPostComments: function exportFacebookPostComments(interactionId) {
      this.$store.dispatch('interaction/exportFacebookPostComments', { interactionId: interactionId });
    },
    likePost: function likePost(id) {
      this.$store.dispatch('interaction/likeFacebookPost', { id: id });
    },
    handleOpenProfile: function handleOpenProfile() {
      this.$emit('onOpenProfile', this.originatorType, this.originator);
    },
    handleMediaStarted: function handleMediaStarted() {
      this.$emit('mediaStarted');
      this.isPlaying = true;
    },
    handleMediaEnded: function handleMediaEnded() {
      this.$emit('mediaEnded');
      this.isPlaying = false;
    }
  },

  destroyed: function destroyed() {
    if (this.isPlaying) {
      this.handleMediaEnded();
    }
  }
});

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageComment',
  props: {
    datetime: {
      type: Object,
      required: true
    },
    message: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      interval: null
    };
  },
  created: function created() {
    var _this = this;

    this.interval = setInterval(function () {
      return _this.$forceUpdate();
    }, 60000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  }
});

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pipe_operator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pipe_operator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pipe_operator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_interaction_mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_interaction_Message__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_interaction_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_interaction_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_interaction_Topic__ = __webpack_require__(2960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_interaction_Topic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_interaction_Topic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_colors__ = __webpack_require__(59);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var INSTANT_POLL_POLLING_SECS = 10;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagePanel',
  components: {
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_10__components_common_ContentPlaceholder___default.a,
    PerfectScrollbar: __WEBPACK_IMPORTED_MODULE_9_vue2_perfect_scrollbar__["PerfectScrollbar"],
    Message: __WEBPACK_IMPORTED_MODULE_11__components_interaction_Message___default.a,
    Topic: __WEBPACK_IMPORTED_MODULE_12__components_interaction_Topic___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_colors__["a" /* default */]],
  data: function data() {
    return {
      loadingTop: false,
      isLoading: false,
      scrolling: false,
      panelMediaIsPlaying: [],
      clusters: [],
      clusterCount: 3,
      clusterInteractions: 20,
      clusterGroup: 0,
      messageHeights: {},
      lastScrollPosition: 0,
      switchHeight: null,
      checkScrollInterval: null,
      hasNewMessages: false,
      lastInteractionId: 0,
      showPanelSearch: false,
      showMediaSearch: false,
      isSearching: false,
      searchCriteria: null,
      scrollCheckInterval: null,
      scrollBarSettings: {
        suppressScrollX: true
      },
      mediaTypes: ['Image', 'Video', 'Audio'],
      mediaSearchCriteria: [],
      datetimeIsChanged: null,
      trendInterval: null,
      instantPollInterval: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isPaused: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: null
    },
    columns: {
      type: String,
      default: null
    },
    canClose: {
      type: Boolean,
      default: true
    },
    hasSettings: {
      type: Boolean,
      default: true
    },
    interactions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    twitterTrends: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onAirUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    goToLastScrollPosition: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    loadingSuccess: {
      type: Boolean,
      required: true
    },
    hasMoreInteractions: {
      type: Boolean,
      default: true
    },
    isFixedPanel: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: true
    },
    pollStats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    settings: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mediaPreload: {
      type: String,
      default: 'auto'
    },
    panelLock: {
      type: String,
      default: 'auto'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.generateClusters();
    this.unpausePanel();

    if (localStorage.getItem('changeDatetimePostFormat')) {
      this.datetimeIsChanged = JSON.parse(localStorage.getItem('changeDatetimePostFormat'));
    }

    if (this.settings.instant_poll) {
      // Instant polls are only linked to a single campaign id
      var campaignId = this.settings.campaign_ids[0];
      this.instantPollInterval = setInterval(function () {
        _this.$store.dispatch('interaction/fetchInstantPollStats', { panelId: _this.id, campaignId: campaignId }, { root: true });
      }, 1000 * INSTANT_POLL_POLLING_SECS);
    }

    // if (this.type === 'twittertrends') {
    //   this.trendInterval = setInterval(() => {
    //     this.$store.dispatch('interaction/fetchTwitterTrends');
    //   }, 1200000); // update twitter trends every 20 minutes
    // }
  },
  destroyed: function destroyed() {
    this.pausePanel();
    this.scrollCheckInterval = clearInterval(this.scrollCheckInterval);
    this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_8__store_modules_interaction_mutation_types__["P" /* CLEAR_PANEL_PAUSED */], this.id);
    clearInterval(this.trendInterval);
    clearInterval(this.instantPollInterval);
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])('interaction', ['threadCounts']), {

    mediaIsPlaying: {
      get: function get() {
        return this.$store.state.interaction.mediaIsPlaying;
      },
      set: function set(mediaIsPlaying) {
        this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_8__store_modules_interaction_mutation_types__["n" /* SET_MEDIA_IS_PLAYING */], mediaIsPlaying);
      }
    },

    firstInteractionId: function firstInteractionId() {
      return this.interactions[0].id;
    },
    totalInstantPollResults: function totalInstantPollResults() {
      return this.pollStats.map(function (result) {
        return result.votes;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    visibleClusters: function visibleClusters() {
      if (this.clusters.length <= this.clusterCount) {
        return this.clusters;
      }

      var start = this.clusterGroup;
      if (start < 0) {
        start = 0;
      }

      if (start > this.clusters.length) {
        return this.clusters.slice(this.clusters.length - this.clushterCount);
      }

      var end = start + this.clusterCount;
      return this.clusters.slice(start, end);
    },
    topHeight: function topHeight() {
      return this.totalHeightOfInteractions(this.topInvisibleInteractions());
    },
    bottomHeight: function bottomHeight() {
      return this.totalHeightOfInteractions(this.bottomInvisibleInteractions());
    },
    panelColor: function panelColor() {
      return this.color || this.generateTitleColor(this.id, [0, 360], [0.6, 1], [0.5, 0.5]);
    },
    showSettings: function showSettings() {
      return this.hasSettings;
    },
    showClose: function showClose() {
      return this.canClose;
    },
    isLocked: function isLocked() {
      return this.panelMediaIsPlaying.length > 0;
    },
    lastInteractionHeight: function lastInteractionHeight() {
      if (!this.interactions || this.interactions.length === 0) return this.averageHeight();
      return this.totalHeightOfInteractions(this.interactions.slice(0, 1));
    },
    getColumnLayoutClass: function getColumnLayoutClass() {
      return this.columns ? 'column-layout-' + this.columns : null;
    },
    sortingKey: function sortingKey() {
      return this.type === 'onair' ? 'onAirId' : 'id';
    },
    panelLocker: function panelLocker() {
      return this.panelLock;
    }
  }),

  methods: {
    changeDateFormat: function changeDateFormat(date) {
      this.datetimeIsChanged = date;
      var parsed = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.datetimeIsChanged);
      localStorage.setItem('changeDatetimePostFormat', parsed);
    },
    isScrolling: function isScrolling() {
      if (this.interactions && this.interactions.length === 0) return false;
      if (!this.$refs.content) return false;
      return this.$refs.content.$el.scrollTop > this.lastInteractionHeight;
    },
    totalHeightOfInteractions: function totalHeightOfInteractions(interactions) {
      var _this2 = this;

      var averageHeight = this.averageHeight();
      return interactions.map(function (interaction) {
        return _this2.messageHeights[interaction.id] || averageHeight;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    averageHeight: function averageHeight() {
      var validHeights = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.messageHeights).filter(function (height) {
        return height > 0;
      });

      if (!validHeights.length) {
        return 0;
      }

      var sumHeights = validHeights.reduce(function (a, b) {
        return a + b;
      }, 0);
      return sumHeights / validHeights.length;
    },
    heightUpdated: function heightUpdated(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          interactionId = _ref2[0],
          height = _ref2[1];

      this.messageHeights[interactionId] = height;
    },
    loadMore: function loadMore() {
      if (!this.isLoading) {
        this.isLoading = true;
        if (this.isSearching && this.searchCriteria) {
          this.$emit('searchPanel', this.id, true, this.searchCriteria);
        } else if (this.isSearching && this.mediaSearchCriteria.length) {
          this.searchByMedia(true);
        } else if (this.hasMoreInteractions) {
          this.$emit('loadMore');
        }
      }
    },
    generateClusters: function generateClusters() {
      var _this3 = this;

      if (this.type === 'twittertrends') {
        this.lastInteractionId = this.twitterTrends.length > 0 && this.twitterTrends[0].name;
        this.hasNewMessages = false;

        var trendChunks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["chunk"])(this.twitterTrends, this.clusterInteractions);

        this.clusters = trendChunks.map(function (twitterTrends, id) {
          return {
            id: id,
            twitterTrends: twitterTrends
          };
        });
      } else {
        this.lastInteractionId = this.interactions.length > 0 && this.interactions[0].id;
        this.hasNewMessages = false;

        var interactionChunks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["chunk"])(this.interactions.sort(function (a, b) {
          return b[_this3.sortingKey] - a[_this3.sortingKey];
        }), this.clusterInteractions);

        this.clusters = interactionChunks.map(function (interactions, id) {
          return {
            id: id,
            interactions: interactions
          };
        });
      }
      this.$forceUpdate();
    },


    /**
     * Make the first cluster visible
     */
    firstCluster: function firstCluster() {
      this.clusterGroup = 0;
      this.switchHeight = null;
      this.$forceUpdate();
    },


    /**
     Make the next cluster visible
    */
    nextCluster: function nextCluster() {
      this.clusterGroup += 1;
      this.switchHeight = null;
      this.$forceUpdate();
    },


    /**
     Make the previous cluster visible
    */
    prevCluster: function prevCluster() {
      this.clusterGroup -= 1;

      if (this.clusterGroup < 0) {
        this.clusterGroup = 0;
      }

      this.switchHeight = null;
      this.$forceUpdate();
    },


    /**
     Flatten a set of clusters into interactions
    */
    flattenClusters: function flattenClusters(clusters) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["flatten"])(clusters.map(function (cluster) {
        return cluster.interactions;
      }));
    },


    /**
     Get all interactions that are not within a visible cluster at the
     top of the panel.
    */
    topInvisibleInteractions: function topInvisibleInteractions() {
      var start = 0;
      var end = this.clusterGroup;

      return this.flattenClusters(this.clusters.slice(start, end));
    },


    /**
     Get all interactions that are not within a visible cluster at the
     bottom of the panel.
    */
    bottomInvisibleInteractions: function bottomInvisibleInteractions() {
      var start = this.clusterGroup + this.clusterCount;
      var end = this.clusters.length;

      return this.flattenClusters(this.clusters.slice(start, end));
    },
    switchAtHeight: function switchAtHeight(clusterGroup) {
      if (!this.switchHeight) {
        var start = 0;
        var end = clusterGroup;

        this.switchHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_pipe_operator__["take"])(this.clusters.slice(start, end)).pipe(this.flattenClusters).pipe(this.totalHeightOfInteractions).result() + 12;
      }
      return this.switchHeight;
    },
    onScroll: function onScroll() {
      if (this.lastScrollPosition === this.$refs.content.$el.scrollTop) return;

      var scrollHeight = this.$refs.content.$el.scrollHeight - this.$refs.content.$el.clientHeight;
      var scrollPosition = this.$refs.content.$el.scrollTop;
      var switchAtHeight = this.switchAtHeight(this.clusterGroup + 1);
      var scrollDirection = this.lastScrollPosition < scrollPosition ? 'down' : 'up';
      var loadMoreAt = scrollHeight - this.totalHeightOfInteractions(this.interactions.slice(-10));

      this.scrolling = this.isScrolling();

      if (this.lastScrollPosition > this.lastInteractionHeight && scrollPosition <= this.lastInteractionHeight) {
        if (this.isPaused && !this.isSearching) this.unpausePanel();
        this.generateClusters();
      }

      // Switch to the next cluster
      if (scrollPosition > switchAtHeight && scrollDirection === 'down') {
        this.nextCluster();
        this.switchHeight = null;
      }

      // Switch to the previous cluster
      if (scrollPosition < switchAtHeight && scrollDirection === 'up') {
        this.prevCluster();
        this.switchHeight = null;
      }

      // Should we load more interactions
      if (scrollPosition > loadMoreAt && scrollDirection === 'down' && !this.isLoading) {
        this.loadMore();
      }

      this.lastScrollPosition = scrollPosition;
    },
    scrollToTop: function scrollToTop() {
      this.$refs.content.$el.scrollTop = 0;
      this.lastScrollPosition = 0;
      this.firstCluster();
    },
    scrollNewMessages: function scrollNewMessages() {
      this.scrolling = false;
      this.generateClusters();
      this.scrollToTop();
    },
    shouldPause: function shouldPause(interactionId) {
      var lastIndex = this.mediaIsPlaying.length - 1;
      var interactionIndex = this.mediaIsPlaying.indexOf(interactionId);
      return interactionIndex >= 0 && interactionIndex < lastIndex;
    },
    mediaStarted: function mediaStarted(interactionId) {
      this.mediaIsPlaying = this.mediaIsPlaying.concat(interactionId);
      this.panelMediaIsPlaying = this.panelMediaIsPlaying.concat(interactionId);
      this.pausePanel();
    },
    mediaEnded: function mediaEnded(interactionId) {
      this.mediaIsPlaying = this.mediaIsPlaying.filter(function (id) {
        return interactionId !== id;
      });
      this.panelMediaIsPlaying = this.panelMediaIsPlaying.filter(function (id) {
        return interactionId !== id;
      });
      this.unpausePanel();
    },
    pausePanel: function pausePanel() {
      this.$emit('pausePanel');
    },
    unpausePanel: function unpausePanel() {
      this.$emit('unpausePanel');
    },
    resetPanel: function resetPanel() {
      this.isSearching = false;
      this.$emit('resetPanel');
      this.unpausePanel();
    },
    toggleSearch: function toggleSearch() {
      if (this.showMediaSearch) this.showMediaSearch = false;
      this.showPanelSearch = !this.showPanelSearch;
      if (this.isSearching && !this.showPanelSearch) {
        this.resetPanel();
      }
    },
    toggleMediaSearch: function toggleMediaSearch() {
      if (this.showPanelSearch) this.showPanelSearch = false;
      this.showMediaSearch = !this.showMediaSearch;
      if (this.isSearching && !this.showPanelSearch) {
        this.resetPanel();
      }
    },
    clearPanelSearch: function clearPanelSearch(clearCriteria) {
      if (clearCriteria) {
        this[clearCriteria] = clearCriteria === 'searchCriteria' ? null : [];
      }

      if (this.isPaused) {
        this.isSearching = false;
        this.scrolling = false;
        this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_8__store_modules_interaction_mutation_types__["p" /* CLEAR_PANEL_HAS_MORE_INDICATOR */], this.id);
        this.scrollToTop();
        this.unpausePanel();
      }
    },
    searchPanelInteractions: function searchPanelInteractions() {
      if (!this.searchCriteria) return;

      this.pausePanel();
      this.isSearching = true;
      this.$emit('searchPanel', this.id, false, this.searchCriteria);
    },
    searchByMedia: function searchByMedia(nextPage) {
      if (!this.mediaSearchCriteria.length) return;

      this.pausePanel();
      this.isSearching = true;

      var query = this.mediaSearchCriteria.reduce(function (a, x) {
        return {
          or: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a.or), [{ field: x.toLowerCase(), match: 'exists' }])
        };
      }, { or: [] });

      this.$emit('searchPanel', this.id, !!nextPage, query);
    },
    getThreadCount: function getThreadCount(threadId, direction) {
      if (!Object.prototype.hasOwnProperty.call(this.threadCounts, threadId)) {
        return 0;
      }
      return this.threadCounts[threadId][direction];
    },
    getMediaIconClass: function getMediaIconClass(item) {
      if (item === 'Image') return 'fa-picture-o';
      if (item === 'Audio') return 'fa-headphones';
      return 'fa-video-camera';
    },
    getSearchBtnIcon: function getSearchBtnIcon(type) {
      if (type === 'media') {
        return this.showMediaSearch ? 'fa fa-times-circle-o' : 'fa fa-image';
      }
      return this.showPanelSearch ? 'fa fa-times-circle-o' : 'fa fa-search';
    },
    incomingInteractions: function incomingInteractions() {
      if (this.scrolling && this.interactions.length > 0 && this.lastInteractionId < this.interactions[0].id) {
        this.hasNewMessages = true;
        return;
      }

      this.loadingTop = false;
      this.generateClusters();
    },
    instantPollVotePercentage: function instantPollVotePercentage(votes) {
      if (this.totalInstantPollResults === 0) return 0;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["round"])(votes / this.totalInstantPollResults * 100, 2);
    },
    getAudioTranscript: function getAudioTranscript(additionalArray) {
      if (!Array.isArray(additionalArray)) return [];

      return additionalArray.filter(function (item) {
        return item && item.transcription && item.transcription.length > 0;
      }).map(function (item) {
        return item.transcription[0];
      });
    }
  },

  watch: {
    loadingSuccess: function loadingSuccess(val) {
      if (val) this.incomingInteractions();
    },
    interactions: function interactions() {
      if (!this.scrolling || this.isLoading) {
        this.generateClusters();
        if (this.isLoading) this.isLoading = false;
      }
    },
    loading: function loading(val) {
      if (!val) this.isLoading = false;
    },
    goToLastScrollPosition: function goToLastScrollPosition(shouldScroll) {
      if (!shouldScroll) {
        return;
      }
      // Dragging and dropping resets scroll position,
      // lets set it back to it's last known value
      this.$refs.content.$el.scrollTop = this.lastScrollPosition;
    },
    showPanelSearch: function showPanelSearch(newVal) {
      if (!newVal) {
        this.clearPanelSearch('searchCriteria');
      }
    },
    showMediaSearch: function showMediaSearch(newVal) {
      if (!newVal) {
        this.clearPanelSearch('mediaSearchCriteria');
      }
    }
  }
});

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagePanelSettings',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    columns: {
      type: String,
      default: '1'
    },
    panelType: {
      type: String,
      default: null
    },
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    campaignIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    channelIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mediaPreload: {
      type: String,
      default: 'auto'
    },
    panelLock: {
      type: String,
      default: 'auto'
    },
    updatingSettings: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      settings: {
        name: '',
        color: '',
        columns: '1',
        campaignIds: [],
        channelIds: [],
        mediaPreload: 'auto',
        panelLock: 'auto'
      }
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('setVisible', value);
      }
    },

    isOnAirOrActivity: function isOnAirOrActivity() {
      return this.panelType === 'onair' || this.panelType === 'activity' || this.panelType === 'twittertrends';
    },
    activeChannels: function activeChannels() {
      return this.channels.filter(function (channel) {
        return channel.live;
      });
    },


    isAllCampaignsChecked: {
      get: function get() {
        return this.settings.campaign_ids && this.settings.campaign_ids.length === this.campaigns.length;
      },
      set: function set() {
        if (this.isAllCampaignsChecked) {
          this.settings.campaign_ids = [];
        } else {
          this.settings.campaign_ids = this.campaigns.map(function (x) {
            return x.id;
          });
        }
      }
    },

    isAllChannelsChecked: {
      get: function get() {
        return this.settings.channel_ids && this.settings.channel_ids.length === this.channels.length;
      },
      set: function set() {
        if (this.isAllChannelsChecked) {
          this.settings.channel_ids = [];
        } else {
          this.settings.channel_ids = this.channels.map(function (x) {
            return x.id;
          });
        }
      }
    }
  },

  mounted: function mounted() {
    this.syncSettings();
  },


  methods: {
    saveSettings: function saveSettings() {
      this.$emit('saveSettings', this.settings);
    },
    syncSettings: function syncSettings() {
      this.settings = {
        uuid: this.id,
        name: this.name,
        colour: this.color,
        columns: this.columns,
        campaign_ids: this.campaignIds,
        channel_ids: this.channelIds,
        mediaPreload: this.mediaPreload,
        panelLock: this.panelLock
      };
    }
  },

  watch: {
    id: function id() {
      this.syncSettings();
    }
  }
});

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageReply',
  props: {
    datetime: {
      type: Object,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    fullName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      interval: null
    };
  },
  created: function created() {
    var _this = this;

    this.interval = setInterval(function () {
      return _this.$forceUpdate();
    }, 60000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },

  computed: {
    getFullName: function getFullName() {
      var names = this.fullName;
      return names ? names + ' replied' : 'We replied';
    }
  }
});

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParentInteraction',
  props: {
    interaction: {
      type: Object,
      required: true
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      iconClasses: {
        facebook_post: 'fa-facebook',
        facebook_comment: 'fa-facebook',
        facebook_message: 'fa-facebook',
        twitter: 'fa-twitter',
        tweet: 'fa-twitter',
        instagram: 'fa-instagram',
        message: 'fa-mobile',
        sms: 'fa-mobile',
        whatsapp: 'fa-whatsapp',
        email: 'fa-envelope-o',
        titkok: 'fa-play-circle-o'
      }
    };
  },
  computed: {
    mediaExists: function mediaExists() {
      return this.interaction.ore.image || this.interaction.ore.video || this.interaction.ore.audio;
    }
  },
  methods: {
    getMediaValue: function getMediaValue(interaction, mediaType) {
      /* eslint no-prototype-builtins :off */
      if (interaction.ore.hasOwnProperty(mediaType) && interaction.ore[mediaType] && interaction.ore[mediaType].length && interaction.ore[mediaType][0].hasOwnProperty('value')) {
        return interaction.ore[mediaType][0].value;
      }
      return '';
    },
    imageLoadOnError: function imageLoadOnError() {
      this.interaction.ore.profile_image[0].value = '/static/assets/icons/user/default_profile_normal.png';
    },
    toggle: function toggle() {
      this.collapsed = !this.collapsed;
    }
  }
});

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interaction__ = __webpack_require__(2952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Interaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_AdvancedSearchForm__ = __webpack_require__(3009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_AdvancedSearchForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__search_AdvancedSearchForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchResults',
  components: {
    Interaction: __WEBPACK_IMPORTED_MODULE_1__Interaction___default.a,
    AdvancedSearchForm: __WEBPACK_IMPORTED_MODULE_2__search_AdvancedSearchForm___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a
  },
  data: function data() {
    return {
      currentSearchTerm: '',
      isAdvancedSearch: false,
      hasSearched: false,
      scrollBarSettings: {
        suppressScrollX: true
      },
      showPanelDownload: false,
      filename: ''
    };
  },
  props: {
    searchTerm: {
      type: String,
      default: ''
    },
    searchResults: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchCount: {
      type: Number,
      default: 0
    },
    searching: {
      type: Boolean,
      default: false
    },
    searchFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  methods: {
    handleSimpleSearch: function handleSimpleSearch() {
      this.$emit('onSimpleSearch', { searchTerm: this.currentSearchTerm });
      this.hasSearched = true;
    },
    handleAdvancedSearch: function handleAdvancedSearch(event) {
      this.$emit('onAdvancedSearch', event);
      this.hasSearched = true;
    },
    exportToFile: function exportToFile(filename) {
      this.$emit('exportToFile', filename);
      this.clearFileNameInput();
    },
    toggleDownload: function toggleDownload() {
      this.showPanelDownload = !this.showPanelDownload;
    },
    clearFileNameInput: function clearFileNameInput() {
      this.filename = '';
    }
  },

  mounted: function mounted() {
    if (this.searchTerm) {
      this.currentSearchTerm = this.searchTerm;
      this.hasSearched = true;
    }
  },


  watch: {
    searchTerm: function searchTerm(term, oldVal) {
      if (term && term !== oldVal) this.currentSearchTerm = this.searchTerm;
    }
  }
});

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sanitize_html__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sanitize_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pipe_operator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pipe_operator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pipe_operator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_interaction__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_file__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_ImageGrid__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_ImageGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_ImageGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_EmojiKeyboard__ = __webpack_require__(2924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_EmojiKeyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_EmojiKeyboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__ = __webpack_require__(76);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ThreadDialog',
  data: function data() {
    return {
      reply: '',
      addMedia: false,
      fileList: [],
      mediaList: [],
      hasScrolled: false,
      lastScrolledThreadsCount: 0,
      showReplyOption: true,
      replyExpired: false
    };
  },
  components: {
    ImageGrid: __WEBPACK_IMPORTED_MODULE_11__components_common_ImageGrid___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__components_common_Loader___default.a,
    EmojiKeyboard: __WEBPACK_IMPORTED_MODULE_12__common_EmojiKeyboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('interaction', ['threadId', 'threadChannel', 'threads', 'threadDialogVisible', 'loadingThreads']), {

    dialogVisible: {
      get: function get() {
        return this.threadDialogVisible;
      },
      set: function set(isVisible) {
        this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["m" /* SET_THREAD_DIALOG_VISIBLE */], isVisible);
      }
    },

    mediaIsPlaying: {
      get: function get() {
        return this.$store.state.interaction.mediaIsPlaying;
      },
      set: function set(mediaIsPlaying) {
        this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["n" /* SET_MEDIA_IS_PLAYING */], mediaIsPlaying);
      }
    },

    mediaPreview: function mediaPreview() {
      return this.mediaList.map(function (item) {
        var fileName = item.filename;
        var fileType = item.filetype;
        var fileB64 = item.base64;
        var fileUrl = 'data:' + fileType + ';base64, ' + fileB64;
        return {
          url: fileUrl,
          filetype: fileType,
          filename: fileName
        };
      });
    },
    showMediaOption: function showMediaOption() {
      if (!this.latestInteraction) {
        return false;
      }

      var show = ['whatsapp'];
      var backend = this.latestInteraction.ore.backend[0];
      var isCM = Object.prototype.hasOwnProperty.call(backend, 'additional');
      return show.includes(this.threadChannel) && isCM;
    },
    latestInteraction: function latestInteraction() {
      return this.threads[0];
    },
    originator: function originator() {
      if (this.threads.length > 0) {
        var originator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["f" /* getOreValue */])(this.latestInteraction, 'originators');
        var displayName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["f" /* getOreValue */])(this.latestInteraction, 'display_name', [null])[0];
        return displayName || originator;
      }
      return '';
    },
    processedThreads: function processedThreads() {
      var _this = this;

      return this.threads.reduce(function (acc, interaction) {
        var interactionData = {
          id: interaction.id,
          message: interaction.ore.message[0].value,
          // Old api returns as date_created, new graphql comes through as dateCreated
          // TODO: remove once old interaction api is deprecated
          datetime: new Date(interaction.dateCreated || interaction.date_created),
          audio: null,
          video: null,
          image: null,
          direction: 'in'
        };

        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'video')) {
          interactionData.video = interaction.ore.video[0].value;
        }

        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'audio')) {
          interactionData.audio = interaction.ore.audio[0].value;
        }

        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'image')) {
          interactionData.image = interaction.ore.image[0].value;
        }

        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'application')) {
          interactionData.document = interaction.ore.application[0].value;
        }

        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'text')) {
          interactionData.text = interaction.ore.text[0].value;
        }

        var repliesData = [];
        if (Object.prototype.hasOwnProperty.call(interaction.ore, 'reply')) {
          repliesData = interaction.ore.reply.map(function (reply, index) {
            var mediaUrl = null;
            var mediaType = null;

            if (Object.prototype.hasOwnProperty.call(reply, 'media') && reply.media) {
              mediaType = ['image', 'audio', 'video', 'application', 'text'].reduce(function (a, t) {
                if (reply.media.filetype.startsWith(t)) {
                  return t;
                }
                return a;
              }, null);
              mediaUrl = reply.media.url;
            }

            return {
              id: 'r_' + interaction.id + '_' + index,
              message: reply.value,
              audio: mediaType === 'audio' ? mediaUrl : null,
              video: mediaType === 'video' ? mediaUrl : null,
              image: mediaType === 'image' ? mediaUrl : null,
              document: mediaType === 'application' ? mediaUrl : null,
              text: mediaType === 'text' ? mediaUrl : null,
              datetime: new Date(_this.handleDateCreated(reply)),
              direction: 'out'
            };
          });
        }

        return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(acc), [interactionData], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(repliesData));
      }, []).sort(function (a, b) {
        return a.datetime - b.datetime;
      });
    }
  }),
  mounted: function mounted() {
    this.scrollToBottom();
  },

  methods: {
    formatMessage: function formatMessage(message) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_pipe_operator__["take"])(message).pipe(__WEBPACK_IMPORTED_MODULE_6_sanitize_html___default.a).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["b" /* nl2br */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["c" /* makeHyperlinks */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["d" /* makeHashtags */]).pipe(__WEBPACK_IMPORTED_MODULE_8__helpers_interaction__["e" /* makeMentions */]).result();
    },
    getDocumentName: function getDocumentName(filename) {
      return filename.endsWith('.bat') ? 'document_' + filename.slice(-20, -4) + '.txt' : 'document_' + filename.slice(-20);
    },
    displayDatetime: function displayDatetime(datetime) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(datetime).fromNow();
    },
    scrollToBottom: function scrollToBottom() {
      var container = this.$el.querySelector('#threadContainer');
      if (!container) {
        return;
      }

      // Check that we have threads, on initial load we might have 0, in that case we wait.
      var hasThreads = this.threads.length > 0;
      var hasNewThreads = this.threads.length !== this.lastScrolledThreadCount;

      if (hasThreads && (!this.hasScrolled || hasNewThreads)) {
        container.scrollTop = container.scrollHeight;
        this.hasScrolled = true;
        this.lastScrolledThreadCount = this.threads.length;
      }
    },
    showGallery: function showGallery(args) {
      var _args = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(args, 2),
          images = _args[0],
          imageIndex = _args[1];

      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["K" /* SET_GALLERY_IMAGES */], images);
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["M" /* SET_GALLERY_INDEX */], imageIndex);
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["L" /* SET_GALLERY_VISIBLE */], true);
    },
    sendReply: function sendReply() {
      var _this2 = this;

      var media = null;
      if (this.mediaList.length) {
        var fileType = this.mediaList[0].filetype;
        var fileB64 = this.mediaList[0].base64;
        var fileUrl = 'data:' + fileType + ';base64, ' + fileB64;
        media = {
          url: fileUrl,
          filetype: fileType
        };
      }
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_13__store_modules_interaction_mutation_types__["j" /* APPEND_THREAD_REPLY */], {
        reply: { value: this.reply, date_created: new Date(), media: media },
        interactionId: this.latestInteraction.id
      });
      this.$store.dispatch('interaction/sendReply', {
        interactionId: this.latestInteraction.id,
        message: this.reply,
        media: this.mediaList
      }).then(function () {
        _this2.hasScrolled = false;
        setTimeout(function () {
          return _this2.scrollToBottom();
        }, 100);
      });
      this.reply = '';
      this.mediaList = [];
      this.fileList = [];
      this.addMedia = false;
    },
    validateFileSize: function validateFileSize(file) {
      var bytes = 1024;
      var fileSize = file.size / bytes / bytes; // in MB
      var isValidFileSize = true;
      if (!file.name.match(/.(jpg|jpeg|png|mp4|mp3|ogg|oga|csv|pdf|xls|xlsx|txt|doc|docx)$/i)) {
        this.$alert('Not a supported file type, only jpg / png images, mp4 video, mp3 / ogg audio,\n          csv / plain text, xlsx / docx / pdf applications are accepted');
        isValidFileSize = false;
      }
      if (fileSize > 10) {
        this.$alert('File size exceeds 10MB maximum limit');
        isValidFileSize = false;
      }

      return file && isValidFileSize;
    },
    toggleUpload: function toggleUpload() {
      this.addMedia = !this.addMedia;
    },
    mediaStarted: function mediaStarted(interactionId) {
      this.mediaIsPlaying = this.mediaIsPlaying.concat(interactionId);
    },
    mediaEnded: function mediaEnded(interactionId) {
      this.mediaIsPlaying = this.mediaIsPlaying.filter(function (id) {
        return interactionId !== id;
      });
    },
    pauseAllMedia: function pauseAllMedia() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).filter(function (refKey) {
        return refKey.startsWith('audio') || refKey.startsWith('video');
      }).forEach(function (mediaKey) {
        var mediaElem = _this3.$refs[mediaKey][0];
        if (mediaElem) {
          mediaElem.pause();
        }
      });
    },
    handleClearMedia: function handleClearMedia() {
      this.mediaList = [];
      this.fileList = [];
    },
    handleFileChange: function handleFileChange(file) {
      var _this4 = this;

      if (this.validateFileSize(file)) {
        this.fileList = [file]; // replace previous files.

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_file__["a" /* getBase64FileObj */])(file.raw).then(function (fileObj) {
          _this4.mediaList = [fileObj];
        }).catch(function () {
          _this4.$alert('Unable to read file', { type: 'error' });
          _this4.handleClearMedia();
        });
      } else {
        this.handleClearMedia();
      }
    },
    handleFileRemove: function handleFileRemove() {
      this.fileList = [];
      this.mediaList = [];
    },
    shouldShowReplyOption: function shouldShowReplyOption() {
      if (this.latestInteraction) {
        var expireChannels = ['whatsapp'];
        var hours = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.latestInteraction.date_created || this.latestInteraction.dateCreated), 'hours');
        this.replyExpired = expireChannels.includes(this.threadChannel) && hours >= 24;

        var doNotShow = ['instagram'];
        this.showReplyOption = !doNotShow.includes(this.threadChannel) && !this.replyExpired;

        var noReplyChannels = ['email', 'webform'];
        if (noReplyChannels.includes(this.threadChannel)) {
          this.showReplyOption = false;
        }
      }
    },
    handleInsertEmoji: function handleInsertEmoji(emoji) {
      this.reply += emoji;
    },
    handleDateCreated: function handleDateCreated(reply) {
      if (!reply.date_created) {
        var timestamp = reply.date;
        return timestamp.$date;
      }
      return reply.date_created;
    }
  },
  watch: {
    threads: function threads() {
      var _this5 = this;

      setTimeout(function () {
        return _this5.scrollToBottom();
      }, 0);
      this.shouldShowReplyOption();
    },
    threadDialogVisible: function threadDialogVisible() {
      var _this6 = this;

      // Ensure reply content is cleared when visibility changed
      this.reply = '';
      this.hasScrolled = false;
      this.fileList = [];
      this.mediaList = [];

      if (this.threadDialogVisible) {
        setTimeout(function () {
          return _this6.scrollToBottom();
        }, 0);
      } else {
        this.pauseAllMedia();
      }
    },
    mediaIsPlaying: function mediaIsPlaying() {
      var _this7 = this;

      var lastPlaying = this.mediaIsPlaying[this.mediaIsPlaying.length - 1];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).filter(function (refKey) {
        return (refKey.startsWith('audio') || refKey.startsWith('video')) && !refKey.includes(lastPlaying);
      }).forEach(function (mediaKey) {
        var mediaElem = _this7.$refs[mediaKey][0];
        if (mediaElem) {
          mediaElem.pause();
        }
      });
    }
  }
});

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topic',
  props: {
    index: {
      type: Number,
      default: 0
    },
    topic: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    position: function position() {
      return this.index + 1;
    }
  },
  mounted: function mounted() {
    // this.updateHeight();
  },

  methods: {
    updateHeight: function updateHeight() {
      // Height plus padding
      this.height = this.$el.offsetHeight + 12;
      this.$emit('heightUpdated', [this.id, this.height]);
    }
  }
});

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            onNotification {\n              message\n              type\n              resourceType\n            }\n          }\n        '], ['\n          subscription {\n            onNotification {\n              message\n              type\n              resourceType\n            }\n          }\n        ']);

//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onNotification: {
        query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
        result: function result(data) {
          var notification = data.data.onNotification;
          this.$notify({
            title: this.title(notification.resourceType),
            message: notification.message,
            type: notification.type.toLowerCase()
          });
        }
      }
    }
  },
  methods: {
    title: function title(str) {
      return str.replace('_', ' ').replace(/(^|\s)\S/g, function (t) {
        return t.toUpperCase();
      });
    }
  }
});

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permission_PermissionFilterCard__ = __webpack_require__(2963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permission_PermissionFilterCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_permission_PermissionFilterCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionDashboard',
  components: {
    ProfilePermissionFilterCard: __WEBPACK_IMPORTED_MODULE_0__components_permission_PermissionFilterCard___default.a
  },
  data: function data() {
    return {
      displayProfile: true
    };
  },
  props: {
    searching: {
      type: Boolean,
      default: false
    },
    loadingProfile: {
      type: Boolean,
      default: false
    },
    results: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_permission_PermissionSectionCard__ = __webpack_require__(2965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_permission_PermissionSectionCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_permission_PermissionSectionCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_PermissionProfileBrowser__ = __webpack_require__(2964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_PermissionProfileBrowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permission_PermissionProfileBrowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_permission_filters_IdentifierFilter__ = __webpack_require__(2966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_permission_filters_IdentifierFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_permission_filters_IdentifierFilter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionFilterCard',
  components: {
    PermissionSectionCard: __WEBPACK_IMPORTED_MODULE_1__components_permission_PermissionSectionCard___default.a,
    IdentifierFilter: __WEBPACK_IMPORTED_MODULE_3__components_permission_filters_IdentifierFilter___default.a,
    PermissionProfileBrowser: __WEBPACK_IMPORTED_MODULE_2__components_permission_PermissionProfileBrowser___default.a
  },
  data: function data() {
    return {
      profile: [],
      query: { identifier: '' },
      displayProfile: false
    };
  },
  props: {
    results: {
      type: Object,
      required: true
    },
    loadingProfile: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],
    handleDisplayProfile: function handleDisplayProfile() {
      this.displayProfile = !this.displayProfile;
      this.$emit('display-profile');
    }
  }
});

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_virtual_scroll_list__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_virtual_scroll_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_virtual_scroll_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_profile_GridCard__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_profile_GridCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_profile_GridCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_profile_DialogCard__ = __webpack_require__(2967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_profile_DialogCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permission_profile_DialogCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionProfileBrowser',
  data: function data() {
    return {
      gridView: true,
      showProfileCard: true,
      profile: null
    };
  },
  components: {
    VirtualList: __WEBPACK_IMPORTED_MODULE_0_vue_virtual_scroll_list___default.a,
    GridCard: __WEBPACK_IMPORTED_MODULE_1__components_profiles_profile_GridCard___default.a,
    DialogCard: __WEBPACK_IMPORTED_MODULE_2__components_permission_profile_DialogCard___default.a
  },
  methods: {
    handleCloseCard: function handleCloseCard() {
      this.showProfileCard = false;
      this.profile = null;
    },
    showProfile: function showProfile(profile) {
      this.profile = profile;
      this.showProfileCard = true;
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    profiles: {
      type: Array,
      required: true
    },
    loadingProfile: {
      type: Boolean,
      required: true
    },
    filteredTotal: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionSectionCard',
  props: {
    fixedHeight: {
      type: Boolean,
      default: true
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideDescription: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a
  }
});

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IdentifiersFilter',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      identifier: ''
    };
  },
  computed: {
    canSearch: function canSearch() {
      return this.identifier.trim() !== '';
    }
  },
  watch: {
    identifier: function identifier(value) {
      if (!value) {
        this.reset();
      }
    }
  },
  methods: {
    reset: function reset() {
      this.clearSearch();
    },
    searchProfile: function searchProfile() {
      if (this.canSearch) {
        this.$emit('search-profile', this.identifier);
      }
    },
    clearSearch: function clearSearch() {
      this.identifier = '';
      this.$emit('search-profile', this.identifier);
    }
  }
});

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jdenticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_profileQuery_gql__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_profileQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_profiles_profileQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_permission_getProfileActivity_gql__ = __webpack_require__(2604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_permission_getProfileActivity_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_permission_getProfileActivity_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_permission_getActivityLogs_gql__ = __webpack_require__(2603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_permission_getActivityLogs_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_permission_getActivityLogs_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_permission_removeNuggetMutation_gql__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_permission_removeNuggetMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_permission_removeNuggetMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_permission_editNuggetMutation_gql__ = __webpack_require__(2602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_permission_editNuggetMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__graphql_permission_editNuggetMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_permission_lockProfilePermissionMutation_gql__ = __webpack_require__(2605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_permission_lockProfilePermissionMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__graphql_permission_lockProfilePermissionMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_permission_deleteProfilePermissionMutation_gql__ = __webpack_require__(2601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_permission_deleteProfilePermissionMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__graphql_permission_deleteProfilePermissionMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_permission_updateProfilePermissionMutation_gql__ = __webpack_require__(2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_permission_updateProfilePermissionMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__graphql_permission_updateProfilePermissionMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_permission_editProfilePermissionModeMutation_gql__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_permission_editProfilePermissionModeMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__graphql_permission_editProfilePermissionModeMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_permission_profile_tabs_DemographicsTab__ = __webpack_require__(2972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_permission_profile_tabs_DemographicsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_permission_profile_tabs_DemographicsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_profiles_profile_tabs_InteractionsTab__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_profiles_profile_tabs_InteractionsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_profiles_profile_tabs_InteractionsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_profiles_profile_tabs_OptinsTab__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_profiles_profile_tabs_OptinsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_profiles_profile_tabs_OptinsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_permission_profile_tabs_ActivityLogsTab__ = __webpack_require__(2971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_permission_profile_tabs_ActivityLogsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_permission_profile_tabs_ActivityLogsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_permission_profile_dialogs_VerifyOTPDialog__ = __webpack_require__(2969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_permission_profile_dialogs_VerifyOTPDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_permission_profile_dialogs_VerifyOTPDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_permission_profile_forms_EnhanceProfileForm__ = __webpack_require__(2970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_permission_profile_forms_EnhanceProfileForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_permission_profile_forms_EnhanceProfileForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionProfileBaseballCard',
  components: {
    DemographicsTab: __WEBPACK_IMPORTED_MODULE_14__components_permission_profile_tabs_DemographicsTab___default.a,
    InteractionsTab: __WEBPACK_IMPORTED_MODULE_15__components_profiles_profile_tabs_InteractionsTab___default.a,
    OptinsTab: __WEBPACK_IMPORTED_MODULE_16__components_profiles_profile_tabs_OptinsTab___default.a,
    EnhanceProfileForm: __WEBPACK_IMPORTED_MODULE_19__components_permission_profile_forms_EnhanceProfileForm___default.a,
    ActivityLogsTab: __WEBPACK_IMPORTED_MODULE_17__components_permission_profile_tabs_ActivityLogsTab___default.a,
    VerifyDialog: __WEBPACK_IMPORTED_MODULE_18__components_permission_profile_dialogs_VerifyOTPDialog___default.a
  },
  data: function data() {
    return {
      showEnhanceProfileDialog: false,
      showVerifyOTPDialog: false,
      isProfileLocked: false,
      isProfileEditModeOn: false,
      shakeAnimation: false,
      loading: false,
      verificationAlert: '',
      activeName: 'demographics',
      activeTab: 'demographics',
      currentPage: 1,
      pageSize: 10,
      totalLogs: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
      activityLogs: [],
      defaultOptins: [{ channel: 'Email', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'SMS', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'WhatsApp', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'Telegram', opt_in: false, opt_out: false, permission: false, date_opted_in: false }]
    };
  },

  apollo: {
    profile: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_profileQuery_gql___default.a,
      skip: true,
      fetchPolicy: 'network-only',
      variables: {
        id: this.id
      }
    },
    profileActivity: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_permission_getProfileActivity_gql___default.a,
      skip: true,
      fetchPolicy: 'network-only',
      variables: {
        id: this.id
      }
    },
    profilePermissionActivityLogs: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_7__graphql_permission_getActivityLogs_gql___default.a,
      skip: true,
      fetchPolicy: 'network-only',
      variables: function variables() {
        return {
          profile_id: this.id,
          page: this.currentPage,
          size: this.pageSize
        };
      },
      update: function update(data) {
        if (data && data.profilePermissionActivityLogs.logs) {
          var newLogs = data.profilePermissionActivityLogs.logs.logs;
          if (this.currentPage === 1) {
            this.activityLogs = newLogs;
          } else {
            this.activityLogs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.activityLogs), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newLogs));
          }
          this.currentPage = data.profilePermissionActivityLogs.logs.current;
          this.hasNext = data.profilePermissionActivityLogs.logs.has_next;
          this.hasPrevious = data.profilePermissionActivityLogs.logs.has_previous;
          this.totalPages = data.profilePermissionActivityLogs.logs.pages;
          this.totalLogs = data.profilePermissionActivityLogs.logs.total;
          this.loading = false;
        }
      }
    }
  },

  computed: {
    demographics: function demographics() {
      return this.profile ? this.profile.demographics : [];
    },
    campaigns: function campaigns() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.profile, 'campaigns', []);
    },
    processedInteractions: function processedInteractions() {
      var interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.profile, 'interactions', []);
      return interactions.map(function (interaction) {
        return interaction;
      });
    },
    optins: function optins() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.profile, 'optins', []).filter(function (optin) {
        return optin.channel !== 'Email';
      });
    },
    profileActivities: function profileActivities() {
      return this.profileActivity;
    },
    panelSettings: function panelSettings() {
      return {
        uuid: 'profile-panel-' + this.panelId,
        type: 'profile',
        settings: {
          name: 'Recent Messages',
          campaign_ids: [this.id]
        }
      };
    },
    panelId: function panelId() {
      var length = 5;
      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1);
    },
    imageSrc: function imageSrc() {
      if (this.initialProfile.image) return this.initialProfile.image;
      var identiconToBase64 = btoa(__WEBPACK_IMPORTED_MODULE_4_jdenticon___default.a.toSvg(this.initialProfile.identifier, 128));
      return 'data:image/svg+xml;base64,' + identiconToBase64;
    },

    showProfileDialog: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('close', val);
      }
    },
    isDemographicsTabActive: function isDemographicsTabActive() {
      return this.activeName === 'demographics';
    }
  },
  props: {
    initialProfile: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"],
    handleQuery: function handleQuery(queryName, variables) {
      this.$apollo.queries[queryName].setVariables(variables);
      this.$apollo.queries[queryName].skip = false;
    },
    handleOpen: function handleOpen() {
      this.handleQuery('profile', { id: this.initialProfile.id });
    },
    handleGetActivity: function handleGetActivity() {
      this.handleQuery('profileActivity', { id: this.initialProfile.id });
    },
    handleActivityLogs: function handleActivityLogs() {
      this.handleQuery('profilePermissionActivityLogs', {
        profile_id: this.initialProfile.id,
        page: this.currentPage,
        size: this.pageSize
      });
    },
    handleLoadMore: function handleLoadMore() {
      if (this.hasNext) {
        this.currentPage += 1;
        this.loading = true;
        this.handleQuery('profilePermissionActivityLogs', {
          profile_id: this.initialProfile.id,
          page: this.currentPage,
          size: this.pageSize
        });
      }
    },
    handleLoadPrevious: function handleLoadPrevious() {
      if (this.hasPrevious) {
        this.currentPage -= 1;
        this.loading = true;
        this.handleQuery('profilePermissionActivityLogs', {
          profile_id: this.initialProfile.id,
          page: this.currentPage,
          size: this.pageSize
        });
      }
    },
    filterByChannelType: function filterByChannelType(interactions) {
      var filteredInteractions = __WEBPACK_IMPORTED_MODULE_3_collect_js___default()(interactions).whereIn('channel', this.filteredChannelKeys).all();

      return filteredInteractions.length ? filteredInteractions : interactions;
    },
    handleShowAlert: function handleShowAlert() {
      this.verificationAlert = 'To ensure data integrity and security, profile verification ' + 'is required before proceeding with any changes. Click "Verify Profile" to proceed.';
      this.shakeAnimation = true;
    },
    handleClearAlert: function handleClearAlert() {
      this.verificationAlert = '';
    },
    handleAnimationEnd: function handleAnimationEnd() {
      this.shakeAnimation = false;
    },
    handleLockProfileState: function handleLockProfileState() {
      this.handleLockProfile();
    },
    openEnhanceProfileForm: function openEnhanceProfileForm() {
      this.showEnhanceProfileDialog = true;
    },
    openVerifyOTPDialog: function openVerifyOTPDialog() {
      this.handleClearAlert();
      this.showVerifyOTPDialog = true;
    },
    openVericationAlert: function openVericationAlert() {
      this.showVerificationAlert = true;
    },
    getNuggetCategory: function getNuggetCategory(field) {
      var categoryMap = {
        name: 'personal',
        id_number: 'identifiers',
        mobile_number: 'identifiers',
        twitter_handle: 'identifiers',
        instagram_handle: 'identifiers',
        facebook_profile: 'identifiers',
        email_address: 'identifiers'
      };

      return categoryMap[field] || 'demographics';
    },
    handleEditNugget: function handleEditNugget(nugget) {
      var _this = this;

      var nuggetToEdit = {
        profile_id: this.initialProfile.id,
        field_key: nugget.field,
        value: nugget.value,
        category: this.getNuggetCategory(nugget.field)
      };
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9__graphql_permission_editNuggetMutation_gql___default.a,
        variables: { nugget: nuggetToEdit },
        client: 'apiv2'
      }).then(function () {
        _this.$notify({
          title: 'Success',
          message: 'Nugget updated successfully',
          type: 'success'
        });
        _this.$apollo.queries.profile.refetch();
      }).catch(function () {
        return _this.$notify({
          title: 'Error',
          message: 'Failed to update nugget',
          type: 'error'
        });
      });
    },
    handleRemoveNugget: function handleRemoveNugget(nugget) {
      var _this2 = this;

      var nuggetToRemove = {
        profile_id: this.initialProfile.id,
        field_key: nugget.field,
        value: nugget.value,
        category: this.getNuggetCategory(nugget.field)
      };
      setTimeout(function () {
        _this2.$confirm('Are you sure you want to remove this nugget?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No, Thanks',
          type: 'warning'
        }).then(function () {
          _this2.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_8__graphql_permission_removeNuggetMutation_gql___default.a,
            variables: { nugget: nuggetToRemove },
            client: 'apiv2'
          }).then(function () {
            _this2.$notify({
              title: 'Success',
              message: 'Nugget removed successfully',
              type: 'success'
            });
            _this2.$apollo.queries.profile.refetch();
          }).catch(function () {
            return _this2.$notify({
              title: 'Error',
              message: 'Failed to remove nugget',
              type: 'error'
            });
          });
        }).catch(function () {
          return null;
        });
      }, 0);
    },
    handleUpdateProfile: function handleUpdateProfile(profileForm) {
      var _this3 = this;

      var profileToUpdate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        profile_id: this.initialProfile.id
      }, profileForm, {
        category: 'demographics'
      });
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_12__graphql_permission_updateProfilePermissionMutation_gql___default.a,
        variables: { nugget: profileToUpdate },
        client: 'apiv2'
      }).then(function () {
        _this3.$notify({
          title: 'Success',
          message: 'Profile updated successfully',
          type: 'success'
        });
        _this3.showEnhanceProfileDialog = false;
        _this3.$apollo.queries.profile.refetch();
      }).catch(function () {
        return _this3.$notify({
          title: 'Error',
          message: 'Failed to update profile',
          type: 'error'
        });
      });
    },
    handleUpdateOptins: function handleUpdateOptins() {
      this.$notify({
        title: 'Success',
        message: 'Profile updated successfully',
        type: 'success'
      });
      this.showEnhanceProfileDialog = false;
      this.$apollo.queries.profile.refetch();
    },
    handleDeleteProfile: function handleDeleteProfile() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$confirm('Are you absolutely certain to permanently delete this profile?', 'Warning: Irreversible Action', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No, Thanks',
          type: 'warning'
        }).then(function () {
          _this4.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_11__graphql_permission_deleteProfilePermissionMutation_gql___default.a,
            variables: { id: _this4.initialProfile.id },
            client: 'apiv2'
          }).then(function () {
            _this4.$notify({
              title: 'Success',
              message: 'Profile deleted successfully',
              type: 'success'
            });
            _this4.showProfileDialog = false;
          }).catch(function () {
            return _this4.$notify({
              title: 'Error',
              message: 'Failed to delete profile',
              type: 'error'
            });
          });
        }).catch(function () {
          return null;
        });
      }, 0);
    },
    handleLockProfile: function handleLockProfile() {
      var _this5 = this;

      var state = this.isProfileLocked ? 'unlock' : 'lock';
      var profileToLock = {
        profile_id: this.initialProfile.id,
        profile_lock_status: !this.isProfileLocked,
        field_key: 'profile_lock',
        category: 'meta'
      };

      setTimeout(function () {
        _this5.$confirm('Are you sure you want to ' + state + ' this profile?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No, Thanks',
          type: 'warning'
        }).then(function () {
          _this5.loading = true;

          _this5.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_10__graphql_permission_lockProfilePermissionMutation_gql___default.a,
            variables: { query: profileToLock },
            client: 'apiv2'
          }).then(function () {
            _this5.loading = false;

            _this5.$notify({
              title: 'Success',
              message: 'Profile ' + state + 'ed successfully',
              type: 'success'
            });
            _this5.$apollo.queries.profileActivity.refetch();
          }).catch(function () {
            _this5.loading = false;

            _this5.$notify({
              title: 'Error',
              message: 'Failed to lock profile',
              type: 'error'
            });
          });
        }).catch(function () {
          return null;
        });
      }, 0);
    },
    handleDialogClose: function handleDialogClose() {
      var _this6 = this;

      var profileToUpdate = {
        profile_id: this.initialProfile.id,
        profile_edit_status: false,
        field_key: 'profile_edit',
        category: 'meta'
      };
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_13__graphql_permission_editProfilePermissionModeMutation_gql___default.a,
        variables: { query: profileToUpdate },
        client: 'apiv2'
      }).then(function () {
        _this6.$apollo.queries.profileActivity.refetch();
      });
    },
    handleCloseVerifyOTPDialog: function handleCloseVerifyOTPDialog() {
      this.showVerifyOTPDialog = false;
    },
    handleCloseVerificationAlert: function handleCloseVerificationAlert() {
      this.showVerificationAlert = false;
    },
    handleRequestOTP: function handleRequestOTP() {
      this.$notify({
        title: 'Success',
        message: 'OTP sent successfully',
        type: 'success'
      });
    },
    handleVerifyOTP: function handleVerifyOTP() {
      this.showVerifyOTPDialog = false;
      this.$apollo.queries.profileActivity.refetch();
    },
    initialMobileNumber: function initialMobileNumber() {
      var initialNumber = this.demographics.find(function (item) {
        return item.field === 'mobile_number';
      });
      return initialNumber ? initialNumber.label : '';
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.handleOpen();
    this.handleGetActivity();
    this.handleActivityLogs();
    this.$nextTick(function () {
      _this7.handleDialogClose();
    });
  },

  watch: {
    profileActivities: {
      immediate: true,
      handler: function handler(profile) {
        if (profile) {
          this.isProfileEditModeOn = profile.editStatus;
          this.isProfileLocked = profile.lockStatus;
        }
      }
    }
  }
});

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditNuggetDialog',
  data: function data() {
    return {
      localNugget: {},
      originalValue: null,
      savingNugget: false,
      rules: {
        value: [{ required: true, message: 'Please input a value' }]
      }
    };
  },
  props: {
    nugget: {
      type: Object,
      default: function _default() {}
    }
  },
  mounted: function mounted() {
    this.localNugget = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.nugget);
    this.originalValue = this.localNugget.value;
  },

  computed: {
    isValueChanged: function isValueChanged() {
      return this.localNugget.value !== this.originalValue;
    }
  },
  methods: {
    handleEditFormSave: function handleEditFormSave() {
      var _this = this;

      this.$refs.nuggetForm.validate(function (valid) {
        if (valid) return _this.saveNugget();
        return false;
      });
    },
    saveNugget: function saveNugget() {
      this.$emit('saveNugget', this.localNugget);
    }
  }
});

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_permission_editProfilePermissionModeMutation_gql__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_permission_editProfilePermissionModeMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_permission_editProfilePermissionModeMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_permission_sendOTPMutation_gql__ = __webpack_require__(2608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_permission_sendOTPMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_permission_sendOTPMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_permission_verifyOTPMutation_gql__ = __webpack_require__(2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_permission_verifyOTPMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_permission_verifyOTPMutation_gql__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VerifyOTPManage',
  computed: {
    showVerifyOTPDialog: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('close', val);
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      showPassword: false,
      otpSent: false,
      showCountdown: false,
      showResend: false,
      isValidPhoneNumber: true,
      countdown: '02:00',
      verificationForm: {
        mobile_number: '',
        otp: ''
      },
      mobileError: '',
      otpError: '',
      countdownInterval: null
    };
  },
  created: function created() {
    this.verificationForm.mobile_number = this.initialMobileNumber || '';
  },

  methods: {
    togglePasswordVisibility: function togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    sendOTP: function sendOTP() {
      var _this = this;

      this.validateMobileNumber();
      if (this.mobileError) return;
      this.loading = true;

      var mobileNumber = this.verificationForm.mobile_number;

      var OTP = {
        profile_id: this.initialProfile.id,
        destination: mobileNumber,
        source: 'live'
      };

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_permission_sendOTPMutation_gql___default.a,
        variables: { query: OTP },
        client: 'apiv2'
      }).then(function () {
        _this.loading = false;
        _this.otpSent = true;
        _this.startCountdown();
        _this.$emit('requestOTP', mobileNumber);
      }).catch(function () {
        _this.loading = false;
        _this.$notify({
          title: 'Error',
          message: 'Failed to send OTP. Please try again.',
          type: 'error'
        });
      });
    },
    verifyOTP: function verifyOTP() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profileToUpdate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.validateOTP();

              case 2:
                if (!_this2.otpError) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:

                _this2.loading = true;

                profileToUpdate = {
                  profile_id: _this2.initialProfile.id,
                  profile_edit_status: true,
                  field_key: 'profile_edit',
                  category: 'meta'
                };
                _context.prev = 6;
                _context.next = 9;
                return _this2.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_3__graphql_permission_editProfilePermissionModeMutation_gql___default.a,
                  variables: { query: profileToUpdate },
                  client: 'apiv2'
                });

              case 9:
                _this2.$notify({
                  title: 'Success',
                  message: 'OTP verified successfully',
                  type: 'success'
                });
                _this2.$emit('verifyOTP');
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](6);

                _this2.$notify({
                  title: 'Error',
                  message: 'Failed to verify OTP. Please try Again',
                  type: 'error'
                });

              case 16:
                _context.prev = 16;

                _this2.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 13, 16, 19]]);
      }))();
    },
    validateOTP: function validateOTP() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var OTP = (_this3.verificationForm.otp || '').trim();
        var mobileNumber = _this3.verificationForm.mobile_number;

        _this3.otpError = OTP.length === 0 ? 'OTP is required' : '';
        if (_this3.otpError) return;

        _this3.loading = true;

        var OTPData = {
          profile_id: _this3.initialProfile.id,
          originator: mobileNumber,
          otp: OTP
        };

        _this3.$apollo.mutate({
          mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_permission_verifyOTPMutation_gql___default.a,
          variables: { query: OTPData },
          client: 'apiv2'
        }).then(function (results) {
          _this3.loading = false;
          var status = results.data.verifyPermissionProfileOtp.status;

          if (status === 'invalid') {
            _this3.otpError = 'OTP is Invalid. Please try again';
            resolve(false);
          } else if (status === 'expired') {
            _this3.otpError = 'OTP has expired. Please request a new one';
            resolve(false);
          }
          resolve(true);
        }).catch(function () {
          _this3.loading = false;
          _this3.$notify({
            title: 'Error',
            message: 'Failed to verify OTP. Please try again.',
            type: 'error'
          });
          resolve(false);
        });
      });
    },
    resendOTP: function resendOTP() {
      var _this4 = this;

      this.validateMobileNumber();
      if (this.mobileError) return;
      this.showResend = false;

      var mobileNumber = this.verificationForm.mobile_number;

      var reSendOTP = {
        profile_id: this.initialProfile.id,
        destination: mobileNumber,
        source: 'live'
      };

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_permission_sendOTPMutation_gql___default.a,
        variables: { query: reSendOTP },
        client: 'apiv2'
      }).then(function () {
        _this4.startCountdown();
        _this4.$emit('requestOTP', mobileNumber);
      }).catch(function () {
        _this4.$notify({
          title: 'Error',
          message: 'Failed to send OTP. Please try again.',
          type: 'error'
        });
      });
    },
    validateMobileNumber: function validateMobileNumber() {
      var mobileNumber = (this.verificationForm.mobile_number || '').trim();
      var phoneRegex = /^(\+\d{1,3}\s?)?\d{9,}$/;

      this.isValidPhoneNumber = phoneRegex.test(mobileNumber);

      if (mobileNumber.length === 0 || !this.isValidPhoneNumber) {
        this.mobileError = 'Mobile number is invalid';
      } else {
        this.mobileError = '';
      }
    },
    clearOtpError: function clearOtpError() {
      this.otpError = '';
    },
    handleMobileNumberInput: function handleMobileNumberInput() {
      this.mobileError = '';
      this.refresh();
    },
    startCountdown: function startCountdown() {
      var _this5 = this;

      this.showCountdown = true;
      var totalSeconds = 120;
      this.countdownInterval = setInterval(function () {
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        _this5.countdown = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        if (totalSeconds === 0) {
          clearInterval(_this5.countdownInterval);
          _this5.showCountdown = false;
          _this5.showResend = true;
        } else {
          totalSeconds -= 1;
        }
      }, 1000);
    },
    refresh: function refresh() {
      this.otpSent = false;
      this.showCountdown = false;
      this.showResend = false;
      this.countdown = '02:00';
      clearInterval(this.countdownInterval);
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialProfile: {
      type: Object,
      required: true
    },
    initialMobileNumber: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnhanceProfileTab',
  components: {
    Empty: __WEBPACK_IMPORTED_MODULE_6__components_common_Empty___default.a
  },
  data: function data() {
    return {
      savingProfile: false,
      profileForm: {},
      emailError: '',
      initialOptins: []
    };
  },
  mounted: function mounted() {
    this.initialOptins = this.optins.map(function (optin) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, optin);
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])('user', ['me']), {
    isFormEmpty: function isFormEmpty() {
      var isProfileEmpty = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.profileForm).every(function (value) {
        return !value;
      });
      return isProfileEmpty;
    },
    isProfileComplete: function isProfileComplete() {
      return !this.showContactInfo && !this.showPersonalInfo && !this.showSocialInfo;
    },
    isOriginatorValid: function isOriginatorValid() {
      var mobileNumber = (this.profileForm && this.profileForm.mobile_number || this.initialMobileNumber || '').trim();
      var phoneRegex = /^(\+\d{1,3}\s?)?\d{9,}$/;
      return phoneRegex.test(mobileNumber);
    },
    showContactInfo: function showContactInfo() {
      return this.showInfo(['email_address', 'mobile_number']);
    },
    showPersonalInfo: function showPersonalInfo() {
      return this.showInfo(['name', 'gender', 'age_range', 'id_number', 'location']);
    },
    showSocialInfo: function showSocialInfo() {
      return this.showInfo(['twitter_handle', 'facebook_profile', 'instagram_handle']);
    }
  }),
  methods: {
    showInfo: function showInfo(fields) {
      var _this = this;

      return fields.some(function (field) {
        return !_this.isFieldPresent(field);
      });
    },
    isFieldPresent: function isFieldPresent(field) {
      return this.demographics.some(function (item) {
        return item.field === field;
      });
    },
    requiredOptins: function requiredOptins() {
      return this.initialOptins.map(function (optin) {
        return optin.channel;
      });
    },
    detectChanges: function detectChanges() {
      var _this2 = this;

      var changesDetected = false;
      this.initialOptins.forEach(function (initialOptin, index) {
        if (initialOptin.opt_in !== _this2.optins[index].opt_in) {
          changesDetected = true;
        }
      });
      return changesDetected;
    },
    handleUpdateOptin: function handleUpdateOptin(status, option) {
      var _this3 = this;

      var channel = option.channel === 'SMS' ? 'Message' : option.channel;
      var company = {
        id: this.me.use_as_company,
        company_name: this.me.company_name
      };

      this.isLoading = true;

      var payload = {
        originator: this.initialMobileNumber,
        company: company.id,
        campaign: '',
        channel_type: channel.toLowerCase(),
        optin: status,
        permission: status,
        age: status
      };
      this.$store.dispatch('privacy/createOptins', { company: company, payload: payload }).then(function () {
        _this3.isLoading = false;
      }).catch(function () {
        _this3.isLoading = false;
        _this3.$notify({
          type: 'info',
          message: 'Something went wrong. We are working on it.'
        });
      });
    },
    handleInput: function handleInput(field) {
      if (this.profileForm[field]) {
        this.profileForm[field] = this.profileForm[field].trim();
      }
    },
    handleAtSymbol: function handleAtSymbol(field) {
      if (this.profileForm[field]) {
        this.profileForm[field] = this.profileForm[field].trim().replace(/^@/, '');
      }
    },
    sanitizeInput: function sanitizeInput(fieldName) {
      this.profileForm[fieldName] = this.profileForm[fieldName].replace(/'/g, '');
    },
    validateEmail: function validateEmail() {
      this.handleInput('email_address');
      var email = (this.profileForm.email_address || '').trim();
      if (email.length === 0) {
        this.emailError = '';
        return;
      }

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.emailError = 'Please enter a valid email address';
      } else {
        this.emailError = '';
      }
    },
    handleFormSave: function handleFormSave() {
      var _this4 = this;

      this.$refs.profileForm.validate(function (valid) {
        if (valid) {
          var filteredProfileForm = {};
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this4.profileForm).forEach(function (field) {
            var value = _this4.profileForm[field];

            if (typeof value === 'string' && value.trim() !== '') {
              filteredProfileForm[field] = value;
            } else if (typeof value === 'boolean') {
              filteredProfileForm[field] = value;
            }
          });
          return _this4.updateProfile(filteredProfileForm);
        }
        return false;
      });
    },
    addCategoryToProfileForm: function addCategoryToProfileForm(profileForm) {
      var _this5 = this;

      var categorizedForm = {};

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(profileForm).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            field = _ref2[0],
            value = _ref2[1];

        var category = _this5.getNuggetCategory(field);
        categorizedForm[field] = { category: category, value: value };
      });
      return categorizedForm;
    },
    updateProfile: function updateProfile(filteredForm) {
      var profileOptins = this.requiredOptins();
      var filteredKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(filteredForm);

      var hasAnyOptin = profileOptins.some(function (optin) {
        return filteredKeys.includes(optin);
      });
      var isOnlyOptins = hasAnyOptin && filteredKeys.every(function (key) {
        return profileOptins.includes(key);
      });

      if (isOnlyOptins) {
        this.$emit('updateOptins');
      } else {
        var updatedForm = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, filteredForm);
        profileOptins.forEach(function (optin) {
          return delete updatedForm[optin];
        });

        this.$emit('updateProfile', {
          profileForm: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.addCategoryToProfileForm(updatedForm))
        });
      }
    }
  },
  props: {
    demographics: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    optins: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initialMobileNumber: {
      type: String,
      required: true
    },
    getNuggetCategory: {
      type: Function,
      required: true
    }
  }
});

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivityLogsTab',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    initialProfile: {
      type: Object,
      required: true
    },
    activityLogs: {
      type: Array,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    hasNext: {
      type: Boolean,
      required: true
    },
    hasPrevious: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      return date.toLocaleString();
    },
    loadMore: function loadMore() {
      this.$emit('loadMore');
    },
    loadPrevious: function loadPrevious() {
      this.$emit('loadPrevious');
    }
  }
});

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permission_profile_dialogs_EditNuggetDialog__ = __webpack_require__(2968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_permission_profile_dialogs_EditNuggetDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_permission_profile_dialogs_EditNuggetDialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemographicsTab',
  data: function data() {
    return {
      showEditNuggetDialog: false,
      selectedNugget: {}
    };
  },
  components: {
    EditNuggetDialog: __WEBPACK_IMPORTED_MODULE_0__components_permission_profile_dialogs_EditNuggetDialog___default.a
  },
  computed: {
    filteredDemographics: function filteredDemographics() {
      return this.demographics;
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    demographics: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isProfileEditModeOn: {
      type: Boolean,
      default: false
    },
    isProfileLocked: {
      type: Boolean,
      default: false
    },
    handleShowAlert: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleCloseDialog: function handleCloseDialog() {
      this.showEditNuggetDialog = false;
      this.selectedNugget = null;
    },
    editNugget: function editNugget(nugget) {
      this.selectedNugget = nugget;
      this.showEditNuggetDialog = true;
    },
    saveNugget: function saveNugget(nugget) {
      this.$emit('edit-nugget', nugget);
      this.showEditNuggetDialog = false;
    },
    removeNugget: function removeNugget(nugget) {
      this.$emit('remove-nugget', nugget);
    },
    parsedDemoValue: function parsedDemoValue(nugget) {
      var additionalParsing = {
        'Birth date': function BirthDate() {
          return nugget.label.match(/[\d]{4}-[\d]{2}-[\d]{2}/)[0];
        }
      };
      return additionalParsing[nugget.title]() || nugget.label;
    },
    canDelete: function canDelete(field) {
      var identifiers = ['id_number', 'mobile_number', 'name', 'facebook_profile', 'instagram_handle', 'twitter_handle', 'email_address'];
      return !identifiers.includes(field);
    }
  }
});

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          mutation {\n            generatePermissionProfileUrl\n        }'], ['\n          mutation {\n            generatePermissionProfileUrl\n        }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GeneratePermissionURL',
  data: function data() {
    return {
      loadingGenerateUrl: false,
      generateUrlSuccess: false,
      generatedUrl: ''
    };
  },

  methods: {
    generate: function generate() {
      var _this = this;

      this.loadingGenerateUrl = true;
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject)
      }).then(function (results) {
        _this.generatedUrl = results.data.generatePermissionProfileUrl.url;
        _this.generateUrlSuccess = true;
        _this.loadingGenerateUrl = false;
      }).catch(function () {
        _this.loadingGenerateUrl = false;
        _this.generateUrlSuccess = false;
        _this.$notify({
          title: 'Error',
          message: 'Failed to generate URL',
          type: 'error'
        });
      });
    },
    copyUrl: function copyUrl() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var input;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = _this2.$refs.form.$el.querySelector('.el-input__inner');

                input.select();
                _context.prev = 2;
                _context.next = 5;
                return navigator.clipboard.writeText(input.value);

              case 5:
                _this2.$notify({
                  title: 'Success',
                  message: 'URL copied to clipboard',
                  type: 'success'
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                _this2.$notify({
                  title: 'Error',
                  message: 'Failed to copy URL to clipboard',
                  type: 'error'
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Empty__);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          myAccess {\n            permission {\n              id\n              action\n              subject\n            }\n            organization\n            company\n            global\n          }\n        }\n      '], ['\n        {\n          myAccess {\n            permission {\n              id\n              action\n              subject\n            }\n            organization\n            company\n            global\n          }\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Can',
  components: {
    Empty: __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default.a
  },
  props: {
    action: {
      type: String,
      required: true
    },
    subject: {
      type: String,
      required: true
    },
    module: {
      type: String
    },
    region: {
      type: String
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      permissions: []
    };
  },
  apollo: {
    $client: 'apiv2',
    myAccess: {
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject)
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('user', ['me']), {
    hasAccess: function hasAccess() {
      var _this = this;

      var hasActionAndSubject = function hasActionAndSubject(p) {
        return p.action === _this.action && p.subject === _this.subject;
      };
      var hasOrgAccess = function hasOrgAccess(p) {
        return p.organization;
      };
      var hasCompAccess = function hasCompAccess(p) {
        return p.company && _this.me.company === _this.me.use_as_company;
      };
      var hasGlobalAccess = function hasGlobalAccess(p) {
        return p.global;
      };
      var hasPermissionAccess = function hasPermissionAccess(p) {
        return hasOrgAccess(p) || hasCompAccess(p) || hasGlobalAccess(p);
      };

      var hasModuleAccess = function hasModuleAccess() {
        return true;
      };
      var hasRegionAccess = function hasRegionAccess() {
        return true;
      };
      var hasLayerAccess = function hasLayerAccess(p) {
        return hasModuleAccess(p) && hasRegionAccess(p);
      };

      return this.permissions.findIndex(function (p) {
        return hasActionAndSubject(p) && hasPermissionAccess(p) && hasLayerAccess(p) || hasActionAndSubject(p) && hasGlobalAccess(p) && hasLayerAccess(p);
      }) !== -1;
    }
  }),
  watch: {
    myAccess: function myAccess() {
      this.permissions = this.myAccess.map(function (a) {
        return {
          action: a.permission.action,
          subject: a.permission.subject,
          organization: a.organization,
          company: a.company,
          global: a.global
        };
      });
    }
  }
});

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PluginsList',
  props: ['plugins', 'loading'],
  data: function data() {
    return {
      pluginDescriptions: {
        'app.dashboard.radio': 'Colony Radio Dashboard',
        'app.dashboard.analytics': 'Colony Analytics Reports Dashboard',
        'app.chat': 'Colony Chat Service',
        'app.profiles': 'Colony Profile',
        'app.afstereo': 'Afstereo Dashboard',
        'app.dashboard.qualitative': 'Colony Survey Builder',
        'app.profiles.permissions': 'Colony Personal Information Management',
        'app.dashboard.audio_transcriber': 'Colony Audio Transcriber',
        'app.profiles.segmentation': 'Colony Audience Segmentation'
      }
    };
  }
});

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PollChoiceInput',

  props: {
    choice: {
      type: Object,
      default: function _default() {
        return {
          choice: '',
          matches: []
        };
      }
    },

    idx: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      newTag: ''
    };
  },

  methods: {
    addTag: function addTag() {
      if (this.newTag) {
        if (!this.tagExists(this.newTag)) this.choice.matches.push(this.newTag);
        this.newTag = '';
      }
    },
    handleCloseTag: function handleCloseTag(tag) {
      this.choice.matches.splice(this.choice.matches.indexOf(tag), 1);
    },
    handleDeleteChoice: function handleDeleteChoice() {
      this.$emit('onRemoveChoice', this.idx);
    },
    tagExists: function tagExists(tag) {
      return this.choice.matches.findIndex(function (x) {
        return x === tag;
      }) !== -1;
    }
  }
});

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_privacy_PrivacyReportDialog__ = __webpack_require__(2977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_privacy_PrivacyReportDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_privacy_PrivacyReportDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_privacy_privacyQuery_gql__ = __webpack_require__(2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_privacy_privacyQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__graphql_privacy_privacyQuery_gql__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PrivacyDataList',
  props: {
    isloading: {
      type: Boolean,
      default: false
    }
  },
  components: { PrivacyReportDialog: __WEBPACK_IMPORTED_MODULE_1__components_privacy_PrivacyReportDialog___default.a },
  data: function data() {
    return {
      optins: {},
      selectedTotalDisplay: 'percentage',
      downloadPrivacyVisible: false
    };
  },

  apollo: {
    optins: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_2__graphql_privacy_privacyQuery_gql___default.a,
      loadingKey: 'isloading',
      update: function update(data) {
        return data.privacyOptinsCount || {};
      }
    }
  },
  computed: {
    respondents: function respondents() {
      return this.optins && this.optins.total || 0;
    },
    getOptins: function getOptins() {
      var optin = this.optins || {};
      if (!optin.total) return [];

      return [{ type: 'OptIns', count: optin.optin }, { type: 'Permissions', count: optin.permission }, { type: 'Over 18', count: optin.age }];
    }
  },
  methods: {
    totalDisplay: function totalDisplay(count) {
      if (!count) return 0;
      if (this.selectedTotalDisplay === 'percentage') {
        return Math.round(count / this.respondents * 100) + '%';
      }
      return count.toLocaleString();
    },
    getPrivacyTypes: function getPrivacyTypes() {
      this.downloadPrivacyVisible = true;
    },
    handleDownloadPrivacyVisibilityChanged: function handleDownloadPrivacyVisibilityChanged(visible) {
      this.downloadPrivacyVisible = visible;
    },
    getByChannelType: function getByChannelType(channel) {
      return __WEBPACK_IMPORTED_MODULE_0_collect_js___default()(this.optins).where('channel_type', channel).all();
    }
  }
});

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PrivacyReportDialog',
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    privacy: {
      required: true
    }
  },
  data: function data() {
    return {
      form: {
        fileName: '',
        rangeDate: []
      },
      rules: {
        fileName: [{ required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' }],
        rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }]
      },
      selectedPrivacyTypes: [],
      isLoading: false
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      }
    },
    currentPrivacyTypes: {
      get: function get() {
        return this.selectedPrivacyTypes;
      },
      set: function set(selectedPrivacyType) {
        this.selectedPrivacyTypes = selectedPrivacyType;
      }
    },
    privacyData: function privacyData() {
      return this.privacy.map(function (privacyTypes) {
        return {
          key: privacyTypes.type,
          label: privacyTypes.type,
          disabled: privacyTypes.count.yes <= 0
        };
      });
    }
  },
  methods: {
    handleFormSave: function handleFormSave() {
      var _this = this;

      this.$refs.privacyForm.validate(function (valid) {
        if (valid) return _this.downloadReport();
        return false;
      });
    },
    downloadReport: function downloadReport() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = {
                  file_name: _this2.form.fileName.replace(/ /g, '_').toLowerCase(),
                  date_from: _this2.form.rangeDate[0],
                  date_to: _this2.form.rangeDate[1],
                  privacy_types: _this2.selectedPrivacyTypes
                };

                _this2.isLoading = true;
                return _context.abrupt('return', _this2.$store.dispatch('privacy/downloadOptinsReport', payload).then(function () {
                  _this2.$emit('onVisibleChanged', false);
                  _this2.isLoading = false;
                }).catch(function () {
                  _this2.isLoading = false;
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$emit('onVisibleChanged', false);
    }
  },
  mounted: function mounted() {
    this.form.fileName = 'optin-contact-list-report';
  }
});

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_ProfileDetailFieldItem__ = __webpack_require__(2978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profile_ProfileDetailFieldItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_profile_ProfileDetailFieldItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_interaction_MessagePanel__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_interaction_MessagePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_interaction_MessagePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_interaction_InteractionsFilter__ = __webpack_require__(2953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_interaction_InteractionsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_interaction_InteractionsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_interaction_mutation_types__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__profileUtils__ = __webpack_require__(337);





var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation($filter: RemoveNuggetInput!) {\n              removeNuggetValue(filter: $filter) {\n                id\n                identifiers\n                interests\n                personal\n                demographics\n              }\n            }\n          '], ['\n            mutation($filter: RemoveNuggetInput!) {\n              removeNuggetValue(filter: $filter) {\n                id\n                identifiers\n                interests\n                personal\n                demographics\n              }\n            }\n          ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation($filter: BlacklistNuggetInput!) {\n              blacklistNuggetValue(filter: $filter) {\n                id\n                identifiers\n                interests\n                personal\n                demographics\n              }\n            }\n          '], ['\n            mutation($filter: BlacklistNuggetInput!) {\n              blacklistNuggetValue(filter: $filter) {\n                id\n                identifiers\n                interests\n                personal\n                demographics\n              }\n            }\n          ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileDetailDialog',
  components: { ProfileDetailFieldItem: __WEBPACK_IMPORTED_MODULE_7__components_profile_ProfileDetailFieldItem___default.a, MessagePanel: __WEBPACK_IMPORTED_MODULE_8__components_interaction_MessagePanel___default.a, Loader: __WEBPACK_IMPORTED_MODULE_9__components_common_Loader___default.a, InteractionsFilter: __WEBPACK_IMPORTED_MODULE_10__components_interaction_InteractionsFilter___default.a },

  props: {
    profileDialogVisible: {
      type: Boolean,
      required: true
    },
    originalProfile: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    campaignSurveys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    campaignId: {
      type: Number,
      default: 0
    },
    profileId: {
      type: String,
      required: true
    },
    updatedProfileMap: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      excludeCategories: ['_id', 'id', '__typename', 'meta'],
      excludeProps: ['profile_image', 'name'],
      showFallbackProfileImage: false,
      activeTab: 'personal',
      showBlacklisted: false,
      showDeleted: false,
      filteredChannelKeys: [],
      showProfileMap: false
    };
  },

  mounted: function mounted() {
    this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_11__store_modules_interaction_mutation_types__["x" /* ADD_MANUAL_PANEL */], this.panelSettings);
    this.$store.dispatch('interaction/fetchProfileInteractions', [this.panelSettings.uuid, this.profileId, this.campaignId]);
  },
  destroyed: function destroyed() {
    this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_11__store_modules_interaction_mutation_types__["y" /* REMOVE_MANUAL_PANEL */], this.panelSettings);
    this.$store.dispatch('interaction/stopPollPanelInteractions', this.panelSettings.uuid);
    this.$store.dispatch('interaction/cleanUpDashboardIntervals');
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('interaction', ['interactions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])('interaction', ['loadingInteractions', 'hasMoreInteractions', 'loadingInteractionsSuccess']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])('profile', ['profileFilters']), {
    showProfileDialog: {
      get: function get() {
        return this.profileDialogVisible;
      },
      set: function set(val) {
        this.$emit('onDialogVisibilityChange', val);
      },
      profileImage: function profileImage() {}
    },

    panelSettings: function panelSettings() {
      return {
        uuid: 'profile-panel-' + this.panelId,
        type: 'profile',
        settings: {
          name: 'Recent Messages',
          campaign_ids: [this.id]
        }
      };
    },
    panelId: function panelId() {
      var length = 5;
      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1);
    },
    profile: function profile() {
      return this.updatedProfileMap[this.profileId] || this.originalProfile;
    },
    profileImage: function profileImage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["a" /* getDataItem */])(this.profile, 'personal', 'profile_image', this.identicon);
    },
    identicon: function identicon() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["b" /* getProfileIdenticon */])(this.profile);
    },
    profileName: function profileName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["c" /* getProfileItemValue */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["a" /* getDataItem */])(this.profile, 'personal', 'name', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["d" /* getPrimaryIdentifier */])(this.profile)));
    },
    location: function location() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["c" /* getProfileItemValue */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["a" /* getDataItem */])(this.profile, 'demographics', 'location', '')).split('s').join('+');
    }
  }),

  methods: {
    handleShowProfileMap: function handleShowProfileMap() {
      this.showProfileMap = !this.showProfileMap;
    },
    filteredFields: function filteredFields(fields) {
      var _this = this;

      var fieldsList = Array.isArray(fields) ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fields)) : [fields];
      if (this.showBlacklisted && this.showDeleted) return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fieldsList));
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fieldsList)).filter(function (x) {
        var show = true;
        if (x.blacklisted !== undefined && !_this.showBlacklisted) show = x.blacklisted !== true;
        if (x.deleted !== undefined && !_this.showDeleted) show = x.deleted !== true;
        return show;
      });
    },
    appendProfileFields: function appendProfileFields(profile) {
      var _formatAgeGroup = this.formatAgeGroup(profile),
          age = _formatAgeGroup.age;

      if (age.length) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, profile, { age_index: this.formatAgeGroup(profile) });
      }

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, profile, { age_index: this.formatAgeGroup(profile) });
    },
    formatAgeGroup: function formatAgeGroup(profile) {
      var meta = profile.meta;

      var ageIndex = __WEBPACK_IMPORTED_MODULE_5_collect_js___default()(meta).get('age_index');

      if (ageIndex) {
        return {
          age: [{
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["e" /* getAgeFromYear */])(ageIndex),
            score: 1,
            comfirmations: 2
          }]
        };
      }
      return { age: [] };
    },
    formatCampaignSurveysData: function formatCampaignSurveysData() {
      var _this2 = this;

      var campaign = this.profile.meta.campaign;

      var profileCampaign = __WEBPACK_IMPORTED_MODULE_5_collect_js___default()(this.getProfileCampaigns(campaign)).map(function (item) {
        return item.value;
      }).all();

      var campaignCollection = __WEBPACK_IMPORTED_MODULE_5_collect_js___default()(this.campaignSurveys).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item.campaign, {
          id: Number(item.campaign.id),
          type: _this2.formatFieldName(item.type),
          startDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profileUtils__["f" /* profileCampaignDateFormat */])(item.startDate)
        });
      }).whereIn('id', profileCampaign).all();

      return campaignCollection;
    },
    showCategory: function showCategory(category) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(category).reduce(this.hasAllowedFields, false);
    },
    getKey: function getKey(key) {
      return key;
    },
    getStyleClass: function getStyleClass(key) {
      return key % 2 === 0;
    },
    getProfileCampaigns: function getProfileCampaigns(campaign) {
      return Array.isArray(campaign) ? campaign : [__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, campaign)];
    },
    handleRemoveNugget: function handleRemoveNugget(cfg) {
      var _this3 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
        variables: { filter: cfg },
        client: 'apiv2'
      }).then(function (resp) {
        _this3.$emit('profileUpdated', resp.data.removeNuggetValue);
      }).catch(console.log); // eslint-disable-line
    },
    handleBlacklistNugget: function handleBlacklistNugget(cfg) {
      var _this4 = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2),
        variables: { filter: cfg },
        client: 'apiv2'
      }).then(function (resp) {
        _this4.$emit('profileUpdated', resp.data.blacklistNuggetValue);
      }).catch(console.log); // eslint-disable-line
    },
    handleFilterInteractions: function handleFilterInteractions(channelKeys) {
      this.filteredChannelKeys = channelKeys;
    },
    filterByChannelType: function filterByChannelType(interactions) {
      var filteredInteractions = __WEBPACK_IMPORTED_MODULE_5_collect_js___default()(interactions).whereIn('channel', this.filteredChannelKeys).all();

      return filteredInteractions.length ? filteredInteractions : interactions;
    },
    panelHasMoreInteractions: function panelHasMoreInteractions(panelId) {
      return this.hasMoreInteractions[panelId] !== undefined ? this.hasMoreInteractions[panelId] : true;
    },
    filterBySurvey: function filterBySurvey(intercations) {
      return intercations.filter(function (interaction) {
        return interaction.channel === 'survey';
      });
    },
    groupByInterationChannel: function groupByInterationChannel(interactions) {
      return __WEBPACK_IMPORTED_MODULE_5_collect_js___default()(interactions).groupBy('channel').all();
    },
    handleLoadMore: function handleLoadMore() {
      this.$store.dispatch('interaction/fetchNextPageProfileInteractions', [this.panelSettings.uuid, this.profileId, this.campaignId]);
    },
    capitalise: function capitalise(content) {
      return content.split(' ').map(function (x) {
        return '' + x[0].toUpperCase() + x.slice(1);
      }).join(' ');
    },
    formatFieldName: function formatFieldName(text) {
      var transformText = function transformText(txt) {
        return ('' + txt[0].toUpperCase() + txt.slice(1)).replace('_', ' ');
      };
      if (text) {
        return transformText(text);
      }
      return 'other';
    },
    hasAllowedFields: function hasAllowedFields() {
      var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var fieldKey = arguments[1];

      /**
       * Reducer function used to determine if a category has any alowed fields.
       * Allowed fields is not in the excludeProps data property.
       */
      if (acc) return true; // short circuit if allowed field was found.
      if (!this.excludeProps.find(function (x) {
        return x === fieldKey;
      })) {
        return true;
      }
      return acc;
    },
    profileImageError: function profileImageError() {
      this.showFallbackProfileImage = true;
    }
  }
});

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_lang__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profileUtils__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileNuggetOptionsDialog__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileNuggetOptionsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProfileNuggetOptionsDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileDetailFieldItem',
  components: {
    NuggetOptions: __WEBPACK_IMPORTED_MODULE_4__ProfileNuggetOptionsDialog___default.a
  },
  props: {
    fieldKey: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    category: {
      type: String,
      default: ''
    },
    profileId: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      optionsVisible: false,
      selectedNuggetValue: '',
      formattedProfileFields: {
        mobile_number: '',
        email: '',
        gender: ''
      },
      showFieldLabel: false
    };
  },
  computed: {
    sortedFields: function sortedFields() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fields)).sort(function (a, b) {
        return b.score - a.score;
      });
    },
    label: function label() {
      return this.formatFieldName(this.fieldKey);
    }
  },

  methods: {
    getFieldLabel: function getFieldLabel(field) {
      this.showFieldLabel = true;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(field).length ? this.showFieldLabel : false;
    },

    findLangaugeNameFromKey: __WEBPACK_IMPORTED_MODULE_2__helpers_lang__["a" /* default */],
    handleOpenProfileMap: function handleOpenProfileMap() {
      this.$emit('onShowProfileMap');
    },
    capitalise: function capitalise(content) {
      return content.split(' ').map(function (x) {
        return '' + x[0].toUpperCase() + x.slice(1);
      }).join(' ');
    },
    scoreColor: function scoreColor(score, field) {
      return field ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__profileUtils__["g" /* getColourCode */])(score, field.discovered_by[0]) : '';
    },
    formatFieldName: function formatFieldName(text) {
      return ('' + text[0].toUpperCase() + text.slice(1)).replace('_', ' ');
    },
    showNuggetOptions: function showNuggetOptions(value) {
      this.selectedNuggetValue = value;
      this.optionsVisible = true;
    },
    closeOptionsDialog: function closeOptionsDialog() {
      this.selectedNuggetValue = '';
      this.optionsVisible = false;
    },
    getFieldValue: function getFieldValue(field) {
      if (field) {
        var value = field.value,
            confirmations = field.confirmations,
            score = field.score;

        return { value: value, confirmations: confirmations, score: score };
      }
      return { value: 'unknown', confirmations: 1, score: 1 };
    }
  }
});

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileNuggetOptionsDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    nuggetKey: {
      type: String,
      default: ''
    },
    nuggetValue: {
      type: String,
      default: ''
    },
    nuggetLabel: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    showDialog: {
      set: function set() {
        this.$emit('closeDialog');
      },
      get: function get() {
        return this.show;
      }
    }
  },

  methods: {
    removeNugget: function removeNugget() {
      var _this = this;

      this.$confirm('This will remove "' + this.nuggetValue + '" for the field "' + this.nuggetLabel + '" on the current profile. Are you sure you want to continue?', 'Remove Value').then(function () {
        _this.$emit('removeNugget', {
          value: _this.nuggetValue,
          fieldKey: _this.nuggetKey,
          category: _this.category,
          profileId: _this.profileId
        });
      }).catch(function () {
        return null;
      });
    },
    blacklistNugget: function blacklistNugget() {
      var _this2 = this;

      this.$confirm('This will blacklist "' + this.nuggetValue + '" for the field "' + this.nuggetLabel + '". This applies to all profiles. Are you sure you want to continue?', 'Remove Value').then(function () {
        _this2.$emit('blacklistNugget', {
          text: _this2.nuggetValue,
          field: _this2.nuggetKey,
          profileId: _this2.profileId
        });
      }).catch(function () {
        return null;
      });
    }
  }
});

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_ProfilesDataFilter__ = __webpack_require__(2985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_ProfilesDataFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_ProfilesDataFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_ProfilesCharts__ = __webpack_require__(2983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_ProfilesCharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profiles_ProfilesCharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_privacy_PrivacyDataList__ = __webpack_require__(2976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_privacy_PrivacyDataList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_privacy_PrivacyDataList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileProDashboard',
  components: {
    ProfilesCharts: __WEBPACK_IMPORTED_MODULE_2__components_profiles_ProfilesCharts___default.a,
    ProfilesDataFilter: __WEBPACK_IMPORTED_MODULE_1__components_profiles_ProfilesDataFilter___default.a,
    PrivacyDataList: __WEBPACK_IMPORTED_MODULE_3__components_privacy_PrivacyDataList___default.a
  },
  data: function data() {
    return {
      displayProfiles: true
    };
  },
  methods: {
    upperCase: __WEBPACK_IMPORTED_MODULE_0_lodash__["upperCase"]
  },
  props: {
    loadingFilters: {
      type: Boolean,
      default: false
    },
    searching: {
      type: Boolean,
      default: false
    },
    loadingProfiles: {
      type: Boolean,
      default: false
    },
    loadingSavedQueries: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: true
    },
    savedQueries: {
      type: Array,
      required: true
    },
    charts: {
      type: Object,
      required: true
    },
    results: {
      type: Object,
      required: true
    },
    loadingCharts: {
      type: Boolean,
      default: false
    },
    loadingPlugins: {
      type: Boolean,
      default: false
    },
    loadingOptins: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'lite'
    }
  }
});

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileDashboardCard',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a
  },
  props: {
    fixedHeight: {
      type: Boolean,
      default: true
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideDescription: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_GridCard__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_GridCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_GridCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_profile_DialogCard__ = __webpack_require__(3000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_profile_DialogCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_profile_DialogCard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var GRID_SIZE = 4;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfilesBrowser',
  data: function data() {
    return {
      gridView: true,
      showProfileCard: false,
      profile: null
    };
  },
  components: {
    VirtualList: __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list___default.a,
    GridCard: __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_GridCard___default.a,
    DialogCard: __WEBPACK_IMPORTED_MODULE_3__components_profiles_profile_DialogCard___default.a
  },
  computed: {
    rows: function rows() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"])(this.profiles, GRID_SIZE);
    },
    noMore: function noMore() {
      return this.profiles.length >= this.filteredTotal;
    },
    disabled: function disabled() {
      return this.loadingMore || this.noMore;
    }
  },
  methods: {
    load: function load() {
      this.$emit('load-more-profiles');
    },
    handleCloseCard: function handleCloseCard() {
      this.showProfileCard = false;
      this.profile = null;
    },
    showProfile: function showProfile(profile) {
      this.profile = profile;
      this.showProfileCard = true;
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    virtualListSize: {
      type: Number,
      default: 25
    },
    virtualListRemain: {
      type: Number,
      default: 18
    },
    profiles: {
      type: Array,
      required: true
    },
    filteredTotal: {
      type: Number,
      required: true
    }
  }
});

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profiles_charts_AudienceProfileChart__ = __webpack_require__(2987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profiles_charts_AudienceProfileChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_profiles_charts_AudienceProfileChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_charts_CrossPlatformEngagement__ = __webpack_require__(2988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_charts_CrossPlatformEngagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_charts_CrossPlatformEngagement__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfilesCharts',
  components: {
    AudienceProfileChart: __WEBPACK_IMPORTED_MODULE_0__components_profiles_charts_AudienceProfileChart___default.a,
    CrossPlatformEngagementChart: __WEBPACK_IMPORTED_MODULE_1__components_profiles_charts_CrossPlatformEngagement___default.a
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_SavedQueryList__ = __webpack_require__(2986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_SavedQueryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_SavedQueryList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfilesDataExport',
  components: {
    SavedQueryList: __WEBPACK_IMPORTED_MODULE_1__components_profiles_SavedQueryList___default.a
  },
  computed: {
    displayTooltipContent: function displayTooltipContent() {
      return this.profilesVisible ? 'Hide the profile browser' : 'View the profiles that meet your search criteria';
    }
  },
  data: function data() {
    return {
      savedQueriesVisible: false
    };
  },
  props: {
    profilesVisible: {
      type: Boolean,
      default: false
    },
    canDownload: {
      type: Boolean,
      default: false
    },
    loadingSavedQueries: {
      type: Boolean,
      default: true
    },
    savedQueries: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleCloseSavedQueries: function handleCloseSavedQueries() {
      this.savedQueriesVisible = false;
    },
    handleApplyQuery: function handleApplyQuery(queryId) {
      this.$emit('apply-query', queryId);
      this.savedQueriesVisible = false;
    },
    handleSaveQuery: function handleSaveQuery() {
      var _this = this;

      this.$prompt('Please enter a meaningful description of your filter', 'Save Filter', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        inputErrorMessage: 'Please enter a description',
        inputValidator: function inputValidator(value) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(value);
        }
      }).then(function (title) {
        return _this.$emit('save-query', title);
      });
    },
    createSampleset: function createSampleset() {
      var _this2 = this;

      this.$prompt('Please enter a description of your sample', 'Download Contact List', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputErrorMessage: 'Please enter a description',
        inputValidator: function inputValidator(value) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(value);
        }
      }).then(function (_ref) {
        var value = _ref.value;

        _this2.$emit('download', value);
      });
    }
  }
});

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_DashboardSectionCard__ = __webpack_require__(2981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_DashboardSectionCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profiles_DashboardSectionCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_DemographicsFilter__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_DemographicsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_DemographicsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_filters_CampaignsFilter__ = __webpack_require__(2992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_filters_CampaignsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_profiles_filters_CampaignsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profiles_filters_OptinsFilter__ = __webpack_require__(2998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profiles_filters_OptinsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_profiles_filters_OptinsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profiles_filters_RandomSampleFilter__ = __webpack_require__(2999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profiles_filters_RandomSampleFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_profiles_filters_RandomSampleFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profiles_ProfilesDataExport__ = __webpack_require__(2984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profiles_ProfilesDataExport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_profiles_ProfilesDataExport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profiles_ProfilesBrowser__ = __webpack_require__(2982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profiles_ProfilesBrowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_profiles_ProfilesBrowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profiles_filters_IdentifiersFilter__ = __webpack_require__(2997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profiles_filters_IdentifiersFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_profiles_filters_IdentifiersFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_accounting__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var DEFAULT_SAMPLE_SIZE = 250;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileDataFilter',
  components: {
    DashboardCard: __WEBPACK_IMPORTED_MODULE_2__components_profiles_DashboardSectionCard___default.a,
    DemographicsFilter: __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_DemographicsFilter___default.a,
    CampaignsFilter: __WEBPACK_IMPORTED_MODULE_4__components_profiles_filters_CampaignsFilter___default.a,
    OptinsFilter: __WEBPACK_IMPORTED_MODULE_5__components_profiles_filters_OptinsFilter___default.a,
    RandomSampleFilter: __WEBPACK_IMPORTED_MODULE_6__components_profiles_filters_RandomSampleFilter___default.a,
    ProfilesBrowser: __WEBPACK_IMPORTED_MODULE_8__components_profiles_ProfilesBrowser___default.a,
    ProfilesDataExport: __WEBPACK_IMPORTED_MODULE_7__components_profiles_ProfilesDataExport___default.a,
    IdentifiersFilter: __WEBPACK_IMPORTED_MODULE_9__components_profiles_filters_IdentifiersFilter___default.a
  },
  data: function data() {
    return {
      activeFilters: ['demographics'],
      profiles: [],
      query: { 'meta.opt_out': ['email', 'sms', 'whatsapp', 'telegram'] },
      campaigns: [],
      sampleSize: 0,
      displayProfiles: false
    };
  },
  computed: {
    computedEnableRandomSample: {
      get: function get() {
        return this.sampleSize > 0;
      },
      set: function set(value) {
        this.sampleSize = value ? DEFAULT_SAMPLE_SIZE : 0;
      }
    },
    demographics: function demographics() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(this.filters, 'demographics');
    },
    identifierSelected: function identifierSelected() {
      return 'identifiers' in this.query;
    },
    proMode: function proMode() {
      return this.mode === 'pro';
    }
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    results: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    loadingProfiles: {
      type: Boolean,
      required: true
    },
    loadingSavedQueries: {
      type: Boolean,
      required: true
    },
    searching: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'lite'
    },
    savedQueries: {
      type: Array,
      required: true
    }
  },
  watch: {
    filters: function filters(values) {
      this.campaigns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(values, 'campaigns');
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_11_lodash__["get"],
    formatNumber: __WEBPACK_IMPORTED_MODULE_10_accounting__["formatNumber"],
    handleDisplayProfiles: function handleDisplayProfiles() {
      this.displayProfiles = !this.displayProfiles;
      this.$emit('display-profiles');
    },
    handleOnFilter: function handleOnFilter(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          path = _ref2[0],
          value = _ref2[1];

      this.query[path] = value;
      this.query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["omitBy"])(this.query, function (v) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["isNumber"])(v) ? false : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["isEmpty"])(v);
      });
      this.$emit('filter', this.query);
    },
    handleClearFilters: function handleClearFilters() {
      var _this = this;

      ['demos', 'optin', 'identifier', 'randomsample'].forEach(function (ref) {
        if (_this.$refs[ref] && typeof _this.$refs[ref].reset === 'function') {
          _this.$refs[ref].reset();
        }
      });

      this.campaigns = this.campaigns.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, {
          selected: false
        });
      });
    },
    handleSaveQuery: function handleSaveQuery(title) {
      this.$emit('save-query', { title: title, query: this.query });
    },
    handleDownloadQuery: function handleDownloadQuery(title) {
      this.$emit('download', { title: title, query: this.query, sampleSize: this.sampleSize });
    },
    handleApplySavedQuery: function handleApplySavedQuery(query) {
      this.query = query;
      this.safeApplyFilter('demos', query);
      this.safeApplyFilter('optin', query);
      this.safeApplyFilter('randomsample', query);
      this.applyCampaignQuery(query);
      this.$emit('filter', this.query);
    },
    handleChangeSampleSize: function handleChangeSampleSize(sampleSize) {
      this.sampleSize = sampleSize;
    },
    applyCampaignQuery: function applyCampaignQuery(query) {
      var savedCampaigns = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(query, 'meta.campaign', []).map(function (c) {
        return c.toString();
      });

      this.campaigns = this.campaigns.map(function (c) {
        var campaign = c;
        if (savedCampaigns.includes(campaign.id)) {
          campaign.selected = true;
        }
        return campaign;
      });
    },
    safeApplyFilter: function safeApplyFilter(refName, query) {
      var component = this.$refs[refName];
      if (component && typeof component.apply === 'function') {
        component.apply(query);
      }
    }
  }
});

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SavedFilterList',
  data: function data() {
    return {
      dialogVisible: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    queries: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleApply: function handleApply(savedQuery) {
      this.$emit('apply-query', savedQuery.filter);
    },
    handleDelete: function handleDelete(savedQuery) {
      this.$emit('delete-query', savedQuery.id);
    }
  },
  watch: {
    visible: function visible(value) {
      this.dialogVisible = value;
    }
  }
});

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_LabelledPieChart__ = __webpack_require__(2914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_LabelledPieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_LabelledPieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_ProfileTableChart__ = __webpack_require__(2990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_ProfileTableChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_ProfileTableChart__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudienceProfileChart',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_LabelledPieChart___default.a,
    TableChart: __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_ProfileTableChart___default.a
  },
  data: function data() {
    return {
      options: {
        showTooltips: false,
        plugins: {
          datalabels: {
            display: 'auto',
            color: '#fff',
            formatter: function formatter(value, ctx) {
              if (value < 10) return '';
              return ctx.chart.data.labels[ctx.dataIndex] + ' - ' + value + '%';
            }
          }
        }
      }
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasData: function hasData() {
      if (!this.data) return false;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.data).some(function (val) {
        return Array.isArray(val) && val.length > 0;
      });
    }
  }
});

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_charts_CrossProfileTable__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_charts_CrossProfileTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_profiles_charts_CrossProfileTable__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossPlatformEngagement',
  props: {
    data: {
      type: Object,
      required: function required() {
        return {};
      }
    },
    title: {
      type: String,
      default: function _default() {
        return 'Cross Platform Engagement';
      }
    },
    loading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    CrossPlatformEngagementCellBlock: __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock___default.a,
    CrossProfileTable: __WEBPACK_IMPORTED_MODULE_4__components_profiles_charts_CrossProfileTable___default.a,
    SocialIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_Icons_SocialIcon___default.a,
    IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a
  },
  computed: {
    engagements: function engagements() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data).sort();
    }
  }
});

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossPlatformEngagementCellBlock',
  computed: {
    disabled: function disabled() {
      return this.roundedPercentage === 0 || isNaN(this.roundedPercentage);
    },
    roundedPercentage: function roundedPercentage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["round"])(parseFloat(this.percentage));
    },
    tooltip: function tooltip() {
      var firstName = this.format(this.first_platform);
      var secondName = this.format(this.second_platform);
      return this.roundedPercentage + '% of your audience engaged on both ' + firstName + ' and ' + secondName;
    }
  },
  props: {
    first_platform: {
      type: String,
      required: ''
    },
    second_platform: {
      type: String,
      required: ''
    },
    percentage: {
      type: Number,
      default: 0
    },
    isCross: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    format: function format(platform) {
      var cleanNames = {
        sms: 'SMS',
        whatsapp: 'WhatsApp'
      };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(cleanNames, platform, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["capitalize"])(platform));
    }
  }
});

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Icons_CellfindIcon__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Icons_CellfindIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_common_Icons_CellfindIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Icons_MobileIcon__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Icons_MobileIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_Icons_MobileIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Icons_UssdIcon__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Icons_UssdIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_Icons_UssdIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Icons_WebhookIcon__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Icons_WebhookIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_Icons_WebhookIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_Icons_WechatIcon__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_Icons_WechatIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_common_Icons_WechatIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_Icons_SurveyIcon__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_Icons_SurveyIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_common_Icons_SurveyIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_Icons_ImportIcon__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_Icons_ImportIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_common_Icons_ImportIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_Icons_TiktokIcon__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_Icons_TiktokIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_common_Icons_TiktokIcon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossProfileTable',
  props: {
    profilesData: {
      type: Object,
      required: function required() {}
    }
  },
  components: {
    CrossPlatformEngagementCellBlock: __WEBPACK_IMPORTED_MODULE_3__components_profiles_charts_CrossPlatformEngagementCellBlock___default.a,
    SocialIcon: __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon___default.a,
    EmailIcon: __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default.a,
    FbIcon: __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a,
    InstagramIcon: __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default.a,
    SmsIcon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a,
    TwitterIcon: __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default.a,
    WhatsappIcon: __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default.a,
    TelegramIcon: __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon___default.a,
    CellfindIcon: __WEBPACK_IMPORTED_MODULE_12__components_common_Icons_CellfindIcon___default.a,
    MobileIcon: __WEBPACK_IMPORTED_MODULE_13__components_common_Icons_MobileIcon___default.a,
    UssdIcon: __WEBPACK_IMPORTED_MODULE_14__components_common_Icons_UssdIcon___default.a,
    WebhookIcon: __WEBPACK_IMPORTED_MODULE_15__components_common_Icons_WebhookIcon___default.a,
    WechatIcon: __WEBPACK_IMPORTED_MODULE_16__components_common_Icons_WechatIcon___default.a,
    SurveyIcon: __WEBPACK_IMPORTED_MODULE_17__components_common_Icons_SurveyIcon___default.a,
    ChannelAppIcon: __WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon___default.a,
    ImportIcon: __WEBPACK_IMPORTED_MODULE_19__components_common_Icons_ImportIcon___default.a,
    TiktokIcon: __WEBPACK_IMPORTED_MODULE_20__components_common_Icons_TiktokIcon___default.a
  },
  data: function data() {
    return {
      channelIconList: {
        whatsapp: { name: 'WhatsApp', icon: __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default.a },
        whatsapp_web: { name: 'WhatsApp', icon: __WEBPACK_IMPORTED_MODULE_10__components_common_Icons_WhatsappIcon___default.a },
        import: { name: 'Import', icon: __WEBPACK_IMPORTED_MODULE_19__components_common_Icons_ImportIcon___default.a },
        wechat: { name: 'WeChat', icon: __WEBPACK_IMPORTED_MODULE_16__components_common_Icons_WechatIcon___default.a },
        waboxapp: { name: 'Waboxapp', icon: __WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon___default.a },
        twitter: { name: 'Twitter', icon: __WEBPACK_IMPORTED_MODULE_9__components_common_Icons_TwitterIcon___default.a },
        trumpia: { name: 'Trumpia', icon: __WEBPACK_IMPORTED_MODULE_18__components_common_Icons_ChannelAppIcon___default.a },
        telegram: { name: 'Telegram', icon: __WEBPACK_IMPORTED_MODULE_11__components_common_Icons_TelegramIcon___default.a },
        survey: { name: 'Survey', icon: __WEBPACK_IMPORTED_MODULE_17__components_common_Icons_SurveyIcon___default.a },
        sms: { name: 'SMS', icon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a },
        instagram: { name: 'Instagram', icon: __WEBPACK_IMPORTED_MODULE_7__components_common_Icons_InstagramIcon___default.a },
        facebook: { name: 'Facebook', icon: __WEBPACK_IMPORTED_MODULE_6__components_common_Icons_FacebookIcon___default.a },
        email: { name: 'Email', icon: __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_EmailIcon___default.a },
        dms: { name: 'Dms', icon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a },
        cellfind: { name: 'CellFind', icon: __WEBPACK_IMPORTED_MODULE_12__components_common_Icons_CellfindIcon___default.a },
        mtech: { name: 'Mtech', icon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a },
        default: { name: 'Default', icon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a },
        infobip: { name: 'Infobip', icon: __WEBPACK_IMPORTED_MODULE_8__components_common_Icons_SmsIcon___default.a },
        ussd: { name: 'Ussd', icon: __WEBPACK_IMPORTED_MODULE_14__components_common_Icons_UssdIcon___default.a },
        mobile: { name: 'Mobile', icon: __WEBPACK_IMPORTED_MODULE_13__components_common_Icons_MobileIcon___default.a },
        webhook: { name: 'Web Hook', icon: __WEBPACK_IMPORTED_MODULE_15__components_common_Icons_WebhookIcon___default.a },
        tiktok: { name: 'TikTok', icon: __WEBPACK_IMPORTED_MODULE_20__components_common_Icons_TiktokIcon___default.a }
      }
    };
  },
  computed: {
    platforms: function platforms() {
      return __WEBPACK_IMPORTED_MODULE_2_collect_js___default()(__WEBPACK_IMPORTED_MODULE_2_collect_js___default()(this.profilesData).toArray()).sortByDesc('uniques').all();
    },
    totalUniques: function totalUniques() {
      return __WEBPACK_IMPORTED_MODULE_2_collect_js___default()(this.platforms).sum('uniques');
    }
  },
  methods: {
    getChannelIconName: function getChannelIconName(engagementChannels, channelIndex) {
      var channelKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(engagementChannels).sort()[channelIndex];
      var channelName = this.channelIconList[channelKey] || this.channelIconList.default;
      return channelName.name;
    },
    formatUniquesNumber: function formatUniquesNumber(scope) {
      if (!scope) return 0;
      return new Intl.NumberFormat().format(scope.row.uniques);
    },
    getLinePercentage: function getLinePercentage(platformUniques, totalUniques) {
      if (!totalUniques || isNaN(platformUniques)) return 0;
      var total = platformUniques / totalUniques * 100;
      return Math.min(100, Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["round"])(total)));
    }
  }
});

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileTableChart',
  computed: {
    sortedData: function sortedData() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(this.data, ['percentage'], ['desc']);
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 270
    },
    data: {
      type: Array,
      required: true
    }
  }
});

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_date__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_collect_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignFilterTable',
  props: {
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    emptyText: {
      type: String,
      default: 'No Data'
    },
    selectorTable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formatNumber: __WEBPACK_IMPORTED_MODULE_2_accounting__["formatNumber"],
    cleanDate: function cleanDate(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_date__["b" /* friendlyDate */])(date, 'en-gb', 'L');
    },
    cleanType: function cleanType(type) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["capitalize"])(type.replace('_', ''));
    },
    handleChange: function handleChange() {
      var selectedCampaigns = __WEBPACK_IMPORTED_MODULE_3_collect_js___default()(this.campaigns).where('selected', true).all();
      this.$emit('change', selectedCampaigns.map(function (campaign) {
        return parseInt(campaign.id, 10);
      }));
    }
  },
  watch: {
    campaigns: function campaigns() {
      this.handleChange();
    }
  }
});

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_CampaignFilterTable__ = __webpack_require__(2991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_CampaignFilterTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_CampaignFilterTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignFilter',
  components: {
    CampaignFilterTable: __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_CampaignFilterTable___default.a
  },
  data: function data() {
    return {
      campaignTypes: [{ type: 'competition', label: 'Competitions' }, { type: 'survey', label: 'Surveys & Polls' }, { type: '*', label: 'Campaigns' }, { type: 'message_board', label: 'Message Boards' }, { type: 'sampleset', label: 'Sample Sets' }]
    };
  },
  computed: {
    selectedCampaigns: function selectedCampaigns() {
      return __WEBPACK_IMPORTED_MODULE_0_collect_js___default()(this.campaigns).where('selected', true).all();
    }
  },
  props: {
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleCampaignSelection: function handleCampaignSelection() {
      this.$emit('filter', ['meta.campaign', this.selectedCampaigns.map(function (campaign) {
        return parseInt(campaign.id, 10);
      })]);
    },
    getCampaignsByType: function getCampaignsByType(type) {
      if (type === '*') return this.campaigns;
      return __WEBPACK_IMPORTED_MODULE_0_collect_js___default()(this.campaigns).where('type', type).put('selected', false).all();
    },
    reset: function reset() {
      this.$refs.selections.map(function (selection) {
        return selection.reset();
      });
    }
  }
});

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelsFilter',
  components: { SocialIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default.a },

  props: {
    title: { type: String, required: true },
    path: { type: String, required: true },
    options: { type: Array, default: function _default() {
        return [];
      } },
    valueKey: { type: String, default: null },
    labelKey: { type: String, default: null },
    virtualListSize: { type: Number, default: 2 },
    virtualListVisible: { type: Number, default: 12 },
    isLong: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      selectedOptions: []
    };
  },

  computed: {
    groupedChannelOptions: function groupedChannelOptions() {
      var grouped = this.options.reduce(function (acc, channel) {
        var channelType = channel.type;
        if (!acc[channelType]) acc[channelType] = [];
        acc[channelType].push(channel);
        return acc;
      }, {});

      var sortedGrouped = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(grouped).sort(function (a, b) {
        return a.localeCompare(b);
      }).forEach(function (type) {
        sortedGrouped[type] = grouped[type].sort(function (a, b) {
          return a.handle.localeCompare(b.handle);
        });
      });

      return sortedGrouped;
    },
    selectedByGroup: function selectedByGroup() {
      var _this = this;

      var grouped = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedChannelOptions).forEach(function (type) {
        grouped[type] = _this.groupedChannelOptions[type].filter(function (opt) {
          return _this.selectedOptions.includes(opt.id);
        }).map(function (opt) {
          return opt.id;
        });
      });
      return grouped;
    },
    showGroup: function showGroup() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.options);
    }
  },

  methods: {
    capitalize: __WEBPACK_IMPORTED_MODULE_2_lodash__["capitalize"],
    handleChange: function handleChange() {
      this.$emit('change', [this.path, this.selectedOptions]);
    },
    reset: function reset() {
      this.selectedOptions = [];
      this.handleChange();
    },
    apply: function apply(filter) {
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(filter, this.path, []);
      this.selectedOptions = options;
    }
  }
});

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DateRangeFilter',
  data: function data() {
    return {
      dateRange: null,
      pickerOptions: {
        shortcuts: [{
          text: 'Last month',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').subtract('month', 1).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: 'Last 3 Months',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').subtract('month', 3).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: 'Last 6 Months',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day').subtract('month', 6).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: 'Last Year',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').subtract('year', 1).toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('year').subtract('year', 1).toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: 'This Year',
          onClick: function onClick(picker) {
            var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('year').toDate();
            var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('year').toDate();
            picker.$emit('pick', [startDate, endDate]);
          }
        }]
      }
    };
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    apply: function apply(filter) {
      var dates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(filter, 'meta.engagement', []);
      this.dateRange = dates;
    },
    reset: function reset() {
      this.dateRange = null;
      this.handleChange();
    },
    handleChange: function handleChange(dates) {
      this.dateRange = dates;

      var localDates = dates ? dates.map(function (date) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).local().format();
      }) : null;
      this.$emit('change', ['meta.engagement', localDates]);
    }
  }
});

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_FilterGroup__ = __webpack_require__(2996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_FilterGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_FilterGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_filters_DateRangeFilter__ = __webpack_require__(2994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_filters_DateRangeFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profiles_filters_DateRangeFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_ChannelsFilter__ = __webpack_require__(2993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_ChannelsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_ChannelsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemographicsFilter',
  components: {
    DateRangeFilter: __WEBPACK_IMPORTED_MODULE_2__components_profiles_filters_DateRangeFilter___default.a,
    FilterGroup: __WEBPACK_IMPORTED_MODULE_1__components_profiles_filters_FilterGroup___default.a,
    SocialIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_Icons_SocialIcon___default.a,
    ChannelsFilter: __WEBPACK_IMPORTED_MODULE_3__components_profiles_filters_ChannelsFilter___default.a
  },
  data: function data() {
    return {
      groupRefs: ['gender', 'language', 'location', 'age', 'race', 'identifier', 'channel', 'show', 'engaged']
    };
  },
  props: {
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_4_lodash__["get"],
    capitalize: __WEBPACK_IMPORTED_MODULE_4_lodash__["capitalize"],
    apply: function apply(filter) {
      var _this = this;

      this.groupRefs.forEach(function (group) {
        return _this.$refs[group].apply(filter);
      });
    },
    reset: function reset() {
      var _this2 = this;

      this.groupRefs.forEach(function (group) {
        return _this2.$refs[group].reset();
      });
    },
    handleFilterChange: function handleFilterChange(payload) {
      this.$emit('filter', payload);
    }
  }
});

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FilterGroup',
  components: {
    VirtualList: __WEBPACK_IMPORTED_MODULE_1_vue_virtual_scroll_list___default.a
  },
  props: {
    title: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelKey: {
      type: String,
      default: null
    },
    valueKey: {
      type: String,
      default: null
    },
    chunk: {
      type: Boolean,
      default: false
    },
    virtualListSize: {
      type: Number,
      default: 2
    },
    virtualListVisible: {
      type: Number,
      default: 12
    },
    isLong: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedOptions: []
    };
  },
  computed: {
    chunkedOptions: function chunkedOptions() {
      var CHUNK_SIZE = Math.floor(this.options.length / 2);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"])(this.options, CHUNK_SIZE);
    },
    showGroup: function showGroup() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.options);
    }
  },
  methods: {
    getItem: function getItem(value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isObject"])(value) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(value, key) : value;
    },
    handleChange: function handleChange() {
      this.$emit('change', [this.path, this.selectedOptions]);
    },
    reset: function reset() {
      this.selectedOptions = [];
      this.handleChange();
    },
    apply: function apply(filter) {
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(filter, this.path, []);
      this.selectedOptions = options;
    }
  }
});

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IdentifiersFilter',
  data: function data() {
    return {
      identifier: ''
    };
  },
  computed: {
    canSearch: function canSearch() {
      return this.identifier.trim() !== '';
    }
  },
  watch: {
    identifier: function identifier(value) {
      if (!value) {
        this.reset();
      }
    }
  },
  methods: {
    apply: function apply(filter) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(filter, 'identifier', []);
    },
    reset: function reset() {
      this.clearSearch();
    },
    searchProfile: function searchProfile() {
      if (this.canSearch) {
        var payload = ['identifier', this.identifier];
        this.$emit('filter', payload);
      }
    },
    clearSearch: function clearSearch() {
      this.identifier = '';
      this.$emit('filter', ['identifier', []]);
    }
  }
});

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OptinFilter',
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default.a
  },
  data: function data() {
    return {
      channels: [{ type: 'email', label: 'Email', optins: false, optouts: true }, { type: 'sms', label: 'SMS', optins: false, optouts: true }, { type: 'whatsapp', label: 'WhatsApp', optins: false, optouts: true }, { type: 'telegram', label: 'Telegram', optins: false, optouts: true }]
    };
  },
  methods: {
    handleChange: function handleChange() {
      var optins = this.channels.filter(function (channel) {
        return channel.optins;
      }).map(function (channel) {
        return channel.type;
      });
      this.$emit('filter', ['meta.opt_in', optins]);

      var optouts = this.channels.filter(function (channel) {
        return channel.optouts;
      }).map(function (channel) {
        return channel.type;
      });
      this.$emit('filter', ['meta.opt_out', optouts]);
    },
    reset: function reset() {
      this.channels = this.channels.map(function (c) {
        var channel = c;
        channel.optins = false;
        channel.optouts = true;
        return channel;
      });
      this.handleChange();
    },
    apply: function apply(filter) {
      this.clearChannelSelections();
      var optouts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(filter, 'meta.opt_out', []);
      var optins = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(filter, 'meta.opt_in', []);

      this.applyMechanism(optouts, 'optouts');
      this.applyMechanism(optins, 'optins');
    },
    applyMechanism: function applyMechanism(selections, mechanism) {
      var _this = this;

      selections.forEach(function (channelType) {
        var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["findIndex"])(_this.channels, { type: channelType });
        _this.channels[index][mechanism] = true;
      });
    },
    clearChannelSelections: function clearChannelSelections() {
      this.channels = this.channels.map(function (c) {
        var channel = c;
        channel.optins = false;
        channel.optouts = false;
        return channel;
      });
    }
  }
});

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RandomSampleFilter',
  props: {
    sampleSize: {
      type: Number,
      default: 250
    },
    availableProfiles: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      exclusionPeriod: null,
      exclusionPeriods: [{ value: 1, label: '1 Month' }, { value: 3, label: '3 Months' }, { value: 6, label: '6 Months' }, { value: 0, label: 'All time' }]
    };
  },
  methods: {
    handleSampleSizeChange: function handleSampleSizeChange(value) {
      this.$emit('change-sample-size', value);
    },
    handleExclusionChange: function handleExclusionChange() {
      this.$emit('filter', ['meta.sampleset', this.exclusionPeriod]);
    },
    apply: function apply(filter) {
      var exclusionPeriod = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(filter, 'meta.sampleset', null);
      this.exclusionPeriod = exclusionPeriod;
    },
    reset: function reset() {
      this.exclusionPeriod = null;
      this.handleExclusionChange();
    }
  },
  computed: {
    insufficientProfiles: function insufficientProfiles() {
      return this.sampleSize > this.availableProfiles;
    }
  }
});

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jdenticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_profiles_profileQuery_gql__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_profiles_profileQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_profiles_profileQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_profiles_pro_blacklistNuggetMutation_gql__ = __webpack_require__(2612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_profiles_pro_blacklistNuggetMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_profiles_pro_blacklistNuggetMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_removeNuggetMutation_gql__ = __webpack_require__(2618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_removeNuggetMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_removeNuggetMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profiles_profile_tabs_DemographicsTab__ = __webpack_require__(3003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profiles_profile_tabs_DemographicsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_profiles_profile_tabs_DemographicsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profiles_profile_tabs_CampaignsTab__ = __webpack_require__(3002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profiles_profile_tabs_CampaignsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_profiles_profile_tabs_CampaignsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profiles_profile_tabs_InteractionsTab__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profiles_profile_tabs_InteractionsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_profiles_profile_tabs_InteractionsTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profiles_profile_tabs_OptinsTab__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profiles_profile_tabs_OptinsTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_profiles_profile_tabs_OptinsTab__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileBaseballCard',
  components: {
    CampaignsAndSurveysTab: __WEBPACK_IMPORTED_MODULE_7__components_profiles_profile_tabs_CampaignsTab___default.a,
    DemographicsTab: __WEBPACK_IMPORTED_MODULE_6__components_profiles_profile_tabs_DemographicsTab___default.a,
    InteractionsTab: __WEBPACK_IMPORTED_MODULE_8__components_profiles_profile_tabs_InteractionsTab___default.a,
    OptinsTab: __WEBPACK_IMPORTED_MODULE_9__components_profiles_profile_tabs_OptinsTab___default.a
  },
  apollo: {
    profile: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_profiles_profileQuery_gql___default.a,
      skip: true,
      fetchPolicy: 'network-only',
      variables: {
        id: this.id
      }
    }
  },
  data: function data() {
    return {
      activeName: 'demographics',
      activeTab: 'demographics',
      defaultOptins: [{ channel: 'Email', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'SMS', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'WhatsApp', opt_in: false, opt_out: false, permission: false, date_opted_in: false }, { channel: 'Telegram', opt_in: false, opt_out: false, permission: false, date_opted_in: false }]
    };
  },

  computed: {
    demographics: function demographics() {
      return this.profile ? this.profile.demographics : [];
    },
    campaigns: function campaigns() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.profile, 'campaigns', []);
    },
    processedInteractions: function processedInteractions() {
      var interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.profile, 'interactions', []);
      return interactions.map(function (interaction) {
        return interaction;
      });
    },
    optins: function optins() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.profile, 'optins', []);
    },
    panelSettings: function panelSettings() {
      return {
        uuid: 'profile-panel-' + this.panelId,
        type: 'profile',
        settings: {
          name: 'Recent Messages',
          campaign_ids: [this.id]
        }
      };
    },
    panelId: function panelId() {
      var length = 5;
      return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1);
    },
    imageSrc: function imageSrc() {
      if (this.initialProfile.image) return this.initialProfile.image;
      var identiconToBase64 = btoa(__WEBPACK_IMPORTED_MODULE_2_jdenticon___default.a.toSvg(this.initialProfile.identifier, 128));
      return 'data:image/svg+xml;base64,' + identiconToBase64;
    },

    showProfileDialog: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('close', val);
      }
    }
  },
  props: {
    initialProfile: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    get: __WEBPACK_IMPORTED_MODULE_0_lodash__["get"],
    handleOpen: function handleOpen() {
      this.$apollo.queries.profile.setVariables({
        id: this.initialProfile.id
      });
      this.$apollo.queries.profile.skip = false;
    },
    handleBlacklistNugget: function handleBlacklistNugget(nugget) {
      var _this = this;

      var blacklistNugget = {
        profile_id: this.initialProfile.id,
        field: nugget.field,
        text: nugget.value
      };

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_profiles_pro_blacklistNuggetMutation_gql___default.a,
        variables: { nugget: blacklistNugget },
        client: 'apiv2'
      }).then(function () {
        _this.$apollo.queries.profile.refetch();
      }).catch(function () {
        return _this.$notify({
          title: 'Error',
          message: 'Failed to blacklist nugget',
          type: 'error'
        });
      });
    },
    handleRemoveNugget: function handleRemoveNugget(nugget) {
      var _this2 = this;

      var nuggetToRemove = {
        profile_id: this.initialProfile.id,
        field_key: nugget.field,
        value: nugget.value,
        category: 'demographics'
      };

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_removeNuggetMutation_gql___default.a,
        variables: { nugget: nuggetToRemove },
        client: 'apiv2'
      }).then(function () {
        _this2.$apollo.queries.profile.refetch();
      }).catch(function () {
        return _this2.$notify({
          title: 'Error',
          message: 'Failed to remove nugget',
          type: 'error'
        });
      });
    },
    filterByChannelType: function filterByChannelType(interactions) {
      var filteredInteractions = __WEBPACK_IMPORTED_MODULE_1_collect_js___default()(interactions).whereIn('channel', this.filteredChannelKeys).all();

      return filteredInteractions.length ? filteredInteractions : interactions;
    }
  },
  mounted: function mounted() {
    this.handleOpen();
  }
});

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jdenticon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GridCard',

  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showFallbackProfileImage: false
    };
  },

  computed: {
    layoutStyle: function layoutStyle() {
      var listViewSize = 12;
      return this.columnSize === listViewSize ? 'list-view ' : '';
    },
    identicon: function identicon() {
      var identiconToBase64 = btoa(__WEBPACK_IMPORTED_MODULE_0_jdenticon___default.a.toSvg(this.profile.identifier, 128));
      return 'data:image/svg+xml;base64,' + identiconToBase64;
    }
  },

  methods: {
    imageLoadError: function imageLoadError() {
      this.profile.image = null;
    }
  }
});

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelOptinDialog',
  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_Icons_SocialIcon___default.a
  },
  props: {
    channel: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('close', val);
      }
    },
    dialogTitle: function dialogTitle() {
      return 'Channel Opt-in & Permission';
    }
  },
  methods: {
    formatDateOptedIn: function formatDateOptedIn(dateOptedIn) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateOptedIn).format('dddd, MMMM D, YYYY');
    },
    getIconClass: function getIconClass(condition) {
      return condition ? 'el-icon-check' : 'el-icon-close';
    }
  }
});

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignsTab',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    campaigns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemographicsTab',
  data: function data() {
    return {
      showBlacklisted: false
    };
  },
  computed: {
    filteredDemographics: function filteredDemographics() {
      if (this.showBlacklisted) return this.demographics;
      return this.demographics.filter(function (demo) {
        return !demo.blacklisted;
      });
    },
    blacklistedDemographics: function blacklistedDemographics() {
      return this.demographics.filter(function (demo) {
        return demo.blacklisted;
      });
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    demographics: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    toggleBlacklist: function toggleBlacklist() {
      this.showBlacklisted = !this.showBlacklisted;
    },
    blacklistNugget: function blacklistNugget(nugget) {
      this.$emit('blacklist', nugget);
    },
    removeNugget: function removeNugget(nugget) {
      this.$emit('remove', nugget);
    },
    parsedDemoValue: function parsedDemoValue(nugget) {
      var additionalParsing = {
        'Birth date': function BirthDate() {
          return nugget.label.match(/[\d]{4}-[\d]{2}-[\d]{2}/)[0];
        }
      };
      return additionalParsing[nugget.title]() || nugget.label;
    }
  }
});

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_interaction_Message__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_interaction_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_interaction_Message__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileInteractionsTab',
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_2__components_interaction_Message___default.a
  },
  data: function data() {
    return {
      datetimeIsChanged: null
    };
  },
  props: {
    interactions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    onAirUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String
    }
  },
  methods: {
    changeDateFormat: function changeDateFormat(date) {
      this.datetimeIsChanged = date;
      var parsed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datetimeIsChanged);
      localStorage.setItem('changeDatetimePostFormat', parsed);
    },
    firstInteractionId: function firstInteractionId() {
      return this.interactions[0].id;
    },
    getOreValue: function getOreValue(interaction, key) {
      var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
        return interaction.ore[key].value[0] || defaultVal;
      }
      return defaultVal;
    },
    getOreValues: function getOreValues(interaction, key) {
      if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
        return interaction.ore[key] || [];
      }
      return [];
    },
    moment: function moment(datetime) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(datetime);
    }
  }
});

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_dialogs_ChannelOptinDialog__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_dialogs_ChannelOptinDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_dialogs_ChannelOptinDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OptinTab',
  components: {
    ChannelOptinDialog: __WEBPACK_IMPORTED_MODULE_2__components_profiles_profile_dialogs_ChannelOptinDialog___default.a
  },
  data: function data() {
    return {
      showChannelOptinCard: false,
      channelData: null
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    optins: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    getDateOptedIn: function getDateOptedIn() {
      if (this.optins.length > 0) {
        var datesOptedIn = this.optins.filter(function (optin) {
          return optin.date_opted_in !== null;
        }).map(function (optin) {
          return new Date(optin.date_opted_in);
        });

        if (datesOptedIn.length > 0) {
          var dateOptedIn = new Date(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(datesOptedIn)));
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateOptedIn).format('dddd, MMMM D, YYYY');
        }
      }
      return null;
    },
    showChannelOptin: function showChannelOptin(channelData) {
      if (channelData) {
        var channelSelected = this.optins.find(function (optin) {
          return optin.channel === channelData.channel;
        });
        if (channelSelected) {
          this.channelData = channelSelected;
          this.showChannelOptinCard = true;
        }
      }
    },
    handleCloseCard: function handleCloseCard() {
      this.showChannelOptinCard = false;
      this.channelData = null;
    }
  }
});

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GenerateURL',
  data: function data() {
    return {
      isGenerateForOnAir: true,
      isResponseTypeRSS: true,
      selectedId: null
    };
  },
  props: {
    companyUsers: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    activeCampaigns: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    generatedUrl: {
      type: String,
      default: '',
      required: false
    },
    loadingGenerateUrl: {
      type: Boolean,
      required: false,
      default: false
    },
    generateUrlSuccess: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    generate: function generate() {
      var payLoad = {
        selectedId: this.selectedId,
        isResponseTypeRSS: this.isResponseTypeRSS,
        isGenerateForOnAir: this.isGenerateForOnAir
      };

      this.$store.dispatch('publishing/requestGenerateUrl', payLoad);
    }
  }
});

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleAction__ = __webpack_require__(3005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_rules_RuleAction__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleCreate',
  components: { RuleAction: __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleAction___default.a },
  data: function data() {
    return {
      formLabelWidth: '120px'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('rules', ['ruleFields']), {
    fields: function fields() {
      var _this = this;

      if (!this.rule.events) return null;
      var fields = [];
      var eventActions = this.ruleFields.events[this.rule.events].actions;
      eventActions.forEach(function (field) {
        if (field in _this.ruleFields.actions) {
          fields.push(_this.ruleFields.actions[field]);
        }
      });
      return fields;
    }
  }),
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    campaign: {
      type: String,
      required: true
    },
    rule: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleChange: function handleChange() {
      this.rule.actions = [];
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('rules/getRuleFields');
  }
});

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleAction',
  computed: {
    inputFields: function inputFields() {
      if (!this.action.key) return null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.fields[this.action.key].fields);
    },
    inputFieldsKeys: function inputFieldsKeys() {
      if (!this.action.key) return null;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields[this.action.key].fields);
    }
  },
  data: function data() {
    return {
      executionOptions: [{ label: 'Immediately', value: 0 }, { label: 'At a predefined time', value: 1 }],
      executionTimeOptions: [['anydays', 'On any day'], ['weekdays', 'On a weekday'], ['weekends', 'On a weekend'], ['mondays', 'On a Monday'], ['tuesdays', 'On a Tuesday'], ['wednesdays', 'On a Wednesday'], ['thursdays', 'On a Thursday'], ['fridays', 'On a Friday'], ['saturdays', 'On a Saturday'], ['sundays', 'On a Sunday']]
    };
  },
  props: {
    action: {
      type: Object,
      default: {}
    },
    fields: {
      type: Object,
      required: true
    },
    actionKey: {
      type: String,
      default: ''
    },
    eventActions: {
      type: Array,
      default: []
    }
  },
  methods: {
    handleTimeChange: function handleTimeChange(time) {
      var day = this.action.execute_day;
      this.action.execution_data = day + ' ' + time.getHours() + ':' + time.getMinutes();
      this.action.execute_time_valid = true;
    },
    handleActionChange: function handleActionChange(action) {
      this.action.fields = this.fields[action].fields;
    }
  }
});

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_rules_Rule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rules__ = __webpack_require__(569);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleCreate',
  components: { Rule: __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rules__["a" /* default */]],
  data: function data() {
    return {
      rule: {
        title: null,
        events: null,
        campaign: 1,
        actions: [],
        conditions: []
      }
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    campaign: function campaign() {
      return this.$route.params.campaignId;
    }
  },
  methods: {
    handleSave: function handleSave(rule) {
      this.$store.dispatch('rules/createRule', rule);
    }
  }
});

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_rules_Rule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_rules__ = __webpack_require__(569);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleEdit',
  components: { Rule: __WEBPACK_IMPORTED_MODULE_0__components_rules_Rule___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_rules__["a" /* default */]],
  props: {
    rule: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSave: function handleSave(rule) {
      this.$store.dispatch('rules/updateRule', rule);
    }
  },
  watch: {
    saving: function saving(newValue) {
      if (newValue === true) this.$emit('close');
    }
  }
});

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rules_RuleCreate__ = __webpack_require__(3006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rules_RuleCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_rules_RuleCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleEdit__ = __webpack_require__(3007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_rules_RuleEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RuleList',
  components: { RuleCreate: __WEBPACK_IMPORTED_MODULE_1__components_rules_RuleCreate___default.a, RuleEdit: __WEBPACK_IMPORTED_MODULE_2__components_rules_RuleEdit___default.a },
  data: function data() {
    return {
      dialogTitle: null,
      createRuleDialogVisible: false,
      editRuleDialogVisible: false
    };
  },
  props: {
    rules: {
      type: Array,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('rules', ['currentRule', 'loadingRules', 'updatingRule', 'loadingRule']), {
    campaign: function campaign() {
      return this.$route.params.campaignId;
    }
  }),
  methods: {
    handleEdit: function handleEdit(index, row) {
      this.$store.dispatch('rules/getRule', row.id);
      this.editRuleDialogVisible = true;
    },
    handleDelete: function handleDelete(ruleIndex, rule) {
      var _this = this;

      this.$confirm('Are you sure you want to delete rule: ' + rule.title + '?').then(function () {
        _this.$store.dispatch('rules/deleteRule', { ruleIndex: ruleIndex, rule: rule });
      });
    }
  }
});

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeRangeSelect__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeRangeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TimeRangeSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchFieldSelect__ = __webpack_require__(3010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchFieldSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchFieldSelect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var randString = function randString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TimeRangeSelect: __WEBPACK_IMPORTED_MODULE_3__TimeRangeSelect___default.a,
    SearchFieldSelect: __WEBPACK_IMPORTED_MODULE_4__SearchFieldSelect___default.a
  },

  computed: {
    dateRange: {
      get: function get() {
        return this.dates;
      },
      set: function set(dateRange) {
        var datesOne = {
          start: dateRange[0].toISOString(),
          end: dateRange[1].toISOString()
        };
        this.dates = dateRange;
        this.updateRange(datesOne);
      }
    }
  },

  props: {
    searchFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      searchTypes: [{ id: 'and', value: 'and' }, { id: 'or', value: 'or' }],
      range: null,
      searchType: 'and',
      rows: [],
      showPicker: false,
      dates: []
    };
  },

  mounted: function mounted() {
    this.addRow();
  },


  methods: {
    addRow: function addRow() {
      var id = randString();
      this.rows = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.rows), [{ field: null, operator: null, input: null, id: id }]);
    },
    removeRow: function removeRow(rowIndex) {
      this.rows = this.rows.filter(function (row, index) {
        return index !== rowIndex;
      });
    },
    updateRowData: function updateRowData(id, data) {
      this.rows = this.rows.map(function (x) {
        return x.id === id ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, { id: id }) : x;
      });
    },
    updateDateRangeInput: function updateDateRangeInput(show) {
      this.showPicker = show;
    },
    updateRange: function updateRange(range) {
      this.range = range;
      this.$forceUpdate();
    },
    buildQuery: function buildQuery() {
      var rangeQuery = this.range ? [{ field: 'date_created', match: 'date_range', value: this.range }] : [];

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.searchType, [].concat(rangeQuery, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.rows.map(function (row) {
        return {
          field: row.field,
          match: row.operator,
          value: row.input
        };
      }))));
    },


    /**
     * Validates a row.
     * @param {Object} rowData - Row data with keys of field, match, value
     * @returns {boolean}
     */
    isRowValid: function isRowValid(rowData) {
      return Boolean(rowData.field && rowData.operator && (rowData.input || rowData.operator === 'exists'));
    },


    /**
     * Validates a collection of rows.
     * @param {Array} - Collection of row data with keys of field, match, value
     * @returns {boolean}
     */
    isAllRowsValid: function isAllRowsValid(rowsData) {
      return rowsData.every(this.isRowValid);
    },
    search: function search() {
      this.$emit('onSearch', this.buildQuery());
    }
  }
});

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: Array,
    required: true
  },
  data: function data() {
    return {
      selectedField: null,
      selectedOperator: null,
      selectedInput: null,
      rows: [],
      searchMatchers: {
        exact: 'is',
        contains: 'contains',
        exists: 'exists'
      }
    };
  },
  computed: {
    field: {
      get: function get() {
        return this.selectedField;
      },
      set: function set(newField) {
        this.selectedField = newField;
      }
    },

    operators: function operators() {
      var _this = this;

      return this.fieldFromId(this.selectedField).operators.map(function (operator) {
        return {
          id: operator,
          title: _this.searchMatchers[operator]
        };
      }) || [];
    },
    currentField: function currentField() {
      return this.fieldFromId(this.selectedField) || null;
    }
  },
  watch: {
    selectedField: function selectedField() {
      this.selectedOperator = null;
      this.selectedInput = null;
      this.emitChanges();
    },
    selectedOperator: function selectedOperator() {
      this.selectedInput = null;
      this.emitChanges();
    },
    selectedInput: function selectedInput() {
      this.emitChanges();
    }
  },
  methods: {
    fieldFromId: function fieldFromId(fieldId) {
      return this.fields.filter(function (field) {
        return field.field === fieldId;
      })[0];
    },
    emitChanges: function emitChanges() {
      this.$emit('onFieldsChanged', {
        field: this.selectedField,
        operator: this.selectedOperator,
        input: this.selectedInput
      });
    }
  }
});

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      range: 'any time',
      timeRanges: {
        'any time': {
          start: null,
          end: null
        },
        'date range': {
          start: null,
          end: null
        },
        'the last hour': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'hours');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        today: {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        yesterday: {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'days').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day');
          }
        },
        'the past week': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'weeks').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past month': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'months').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past 2 months': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(2, 'months').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past 3 months': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(3, 'months').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past year': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'years').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past 2 years': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(2, 'years').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        },
        'the past 3 years': {
          start: function start() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(3, 'years').startOf('day');
          },
          end: function end() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
          }
        }
      }
    };
  },
  computed: {
    selectedRange: {
      get: function get() {
        return this.range;
      },
      set: function set(newRange) {
        var showdateRangeDialog = newRange === 'date range';
        this.$emit('onDateRangeSelected', showdateRangeDialog);
        this.range = newRange;

        var timeRange = this.timeRanges[newRange];
        var start = timeRange.start ? timeRange.start().toISOString() : null;
        var end = timeRange.end ? timeRange.end().toISOString() : null;

        this.$emit('onRangeChanged', { start: start, end: end });
      }
    }
  }
});

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_segmentation_partials_DashboardHeader__ = __webpack_require__(3016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_segmentation_partials_DashboardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_segmentation_partials_DashboardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_segmentation_common_NoDataModal__ = __webpack_require__(3014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_segmentation_common_NoDataModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_segmentation_common_NoDataModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_segmentation_common_AiCreditsBanner__ = __webpack_require__(3013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_segmentation_common_AiCreditsBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_segmentation_common_AiCreditsBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_segmentation_common_SectionSkeleton__ = __webpack_require__(3015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_segmentation_common_SectionSkeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_segmentation_common_SectionSkeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_segmentation_utils_tourSteps__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_segmentation_utils_segmentation__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_segmentation_utils_exportFields__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_retarget_retargetBucketQuery_gql__ = __webpack_require__(2637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_retarget_retargetBucketQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_retarget_retargetBucketQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_retarget_addToRetargetBucketMutation_gql__ = __webpack_require__(2634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_retarget_addToRetargetBucketMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_retarget_addToRetargetBucketMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_retarget_exportRowsQuery_gql__ = __webpack_require__(2636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_retarget_exportRowsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_retarget_exportRowsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_retarget_retargetConsentCheckQuery_gql__ = __webpack_require__(2638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_retarget_retargetConsentCheckQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_retarget_retargetConsentCheckQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_retarget_exportConsentCheckQuery_gql__ = __webpack_require__(2635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_retarget_exportConsentCheckQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_retarget_exportConsentCheckQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__ = __webpack_require__(997);










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/**
 * The dashboard's components, loaded on demand and not with the first page.
 *
 * Note: The loading notice, header and credits banner are small and are
 * needed at once, so they stay in the main file. Everything else is fetched
 * while the loading notice is showing (see loadInterface), in two files: the
 * views and the dialogs (see lazy/). Opening a dialog later never waits for
 * a download.
 */
var loadViews = function loadViews() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3452));
};
var loadDialogs = function loadDialogs() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3451));
};
var from = function from(load, name) {
  return function () {
    return load().then(function (bundle) {
      return bundle.default[name];
    });
  };
};
var LOADERS = {
  SegmentsOverview: from(loadViews, 'SegmentsOverview'),
  EngagementOverview: from(loadViews, 'EngagementOverview'),
  ListenerRetargeting: from(loadViews, 'ListenerRetargeting'),
  CampaignRecommender: from(loadViews, 'CampaignRecommender'),
  DashboardFab: from(loadViews, 'DashboardFab'),
  AiUsageFab: from(loadViews, 'AiUsageFab'),
  FilterFab: from(loadViews, 'FilterFab'),
  ListenerDialog: from(loadDialogs, 'ListenerDialog'),
  FindListenersModal: from(loadDialogs, 'FindListenersModal'),
  AudiencesModal: from(loadDialogs, 'AudiencesModal'),
  BulkEnrichModal: from(loadDialogs, 'BulkEnrichModal'),
  RetargetBucketModal: from(loadDialogs, 'RetargetBucketModal'),
  ExportFieldsModal: from(loadDialogs, 'ExportFieldsModal'),
  ConsentCheckModal: from(loadDialogs, 'ConsentCheckModal'),
  SegmentationTour: from(loadDialogs, 'SegmentationTour'),
  AudienceFilters: from(loadDialogs, 'AudienceFilters'),
  AdvertiserHubModal: from(loadDialogs, 'AdvertiserHubModal')
};

/**
 * The height of each main section (in pixels), used for the placeholder
 * shown while its code downloads.
 */
var SECTION_HEIGHTS = {
  SegmentsOverview: 460,
  EngagementOverview: 520,
  ListenerRetargeting: 300,
  CampaignRecommender: 220
};

/**
 * A lazy component. A main section gets a shimmering placeholder card while
 * it downloads; dialogs and buttons need none.
 */
var lazyComponent = function lazyComponent(name) {
  var height = SECTION_HEIGHTS[name];
  if (!height) {
    return LOADERS[name];
  }
  var loading = {
    functional: true,
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_13__components_segmentation_common_SectionSkeleton___default.a, { props: { height: height } });
    }
  };
  return function () {
    return { component: LOADERS[name](), loading: loading, delay: 0 };
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SegmentationDashboard',
  components: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_10__components_segmentation_partials_DashboardHeader___default.a,
    NoDataModal: __WEBPACK_IMPORTED_MODULE_11__components_segmentation_common_NoDataModal___default.a,
    AiCreditsBanner: __WEBPACK_IMPORTED_MODULE_12__components_segmentation_common_AiCreditsBanner___default.a
  }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(LOADERS).map(function (name) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, name, lazyComponent(name));
  }))))),
  props: {
    hideHeader: { type: Boolean, default: false },
    summary: {
      type: Object,
      default: function _default() {
        return { totalListeners: 0, highEngagementCount: 0, segmentCounts: {} };
      }
    },
    insights: { type: Object, default: function _default() {
        return { segments: [] };
      } },
    listeners: { type: Object, default: function _default() {
        return { listeners: [], totalMatches: 0 };
      } },
    segmentStats: { type: Array, default: function _default() {
        return [];
      } },
    segmentTags: { type: Object, default: function _default() {
        return {};
      } },
    aggregate: {
      type: Object,
      default: function _default() {
        return {
          total: 0,
          channelCounts: {},
          genderCounts: {},
          ageGroupCounts: {},
          languageCounts: {},
          locationCounts: {},
          segmentCounts: {},
          momentumCounts: {},
          campaignTypeCounts: {},
          ethnicityCounts: {},
          tagCounts: {}
        };
      }
    },
    crossChannel: {
      type: Object,
      default: function _default() {
        return { total: 0, channels: [], uniques: {}, matrix: {}, percentages: {} };
      }
    },
    baseAggregate: {
      type: Object,
      default: function _default() {
        return {
          total: 0,
          channelCounts: {},
          genderCounts: {},
          ageGroupCounts: {},
          languageCounts: {},
          locationCounts: {},
          ethnicityCounts: {},
          tagCounts: {}
        };
      }
    },
    completeness: {
      type: Object,
      default: function _default() {
        return {
          total: 0,
          completeCount: 0,
          incompleteCount: 0,
          missingFieldCounts: {}
        };
      }
    },
    selectedListener: { type: Object, default: null },
    recommendationResult: { type: Object, default: null },
    recommendError: { type: Boolean, default: false },
    creditsExhausted: { type: Boolean, default: false },
    segmentFreshness: { type: Object, default: function _default() {
        return { data_updated_at: null, segments: {} };
      } },
    refreshing: { type: Boolean, default: false },
    enriching: { type: Boolean, default: false },
    enrichCreditsExhausted: { type: Boolean, default: false },
    loadingSummary: { type: Boolean, default: false },
    /**
     * How many of the first-load queries have finished, out of how many,
     * and the messages of the ones that failed. Without them the dashboard
     * cannot tell "still loading" from "no data".
     */
    loadTotal: { type: Number, default: 0 },
    loadDone: { type: Number, default: 0 },
    loadErrors: { type: Array, default: function _default() {
        return [];
      } },
    segmentationEnabled: { type: Boolean, default: true },
    loadingInsights: { type: Boolean, default: false },
    loadingListeners: { type: Boolean, default: false },
    loadingAggregate: { type: Boolean, default: false },
    loadingCompleteness: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      interfaceReady: false,
      activeSegment: null,
      showListeners: false,
      showDialog: false,
      openedReason: null,
      showFilters: false,
      filtersMounted: false,
      showFind: false,
      showAudiences: false,
      showBulkEnrich: false,
      /**
       * The key of the notice the station closed. A different notice (for
       * example an error after "no data") still shows.
       */
      dismissedNotice: '',
      showBucket: false,
      tourOpen: false,
      tourSteps: __WEBPACK_IMPORTED_MODULE_14__components_segmentation_utils_tourSteps__["a" /* TOUR_STEPS */],
      fabsOpen: false,
      showAdvertiserHub: false,
      fabsBeforeTour: null,
      bucket: { groups: [], total: 0 },
      bucketLoading: false,
      addingToBucket: false,
      lastBucketKey: '',
      pendingExport: null,
      exporting: false,
      consent: null,
      exportCounts: null,
      exportCountsLoading: false,
      preFillBrief: { text: '', ts: 0 },
      localFilters: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["a" /* DEFAULT_FILTERS */]),
      cachedFilterOptions: {
        genders: [],
        ageGroups: [],
        languages: [],
        locations: [],
        ethnicities: [],
        tags: [],
        channels: [],
        lsmTiers: []
      }
    };
  },

  computed: {
    dialogReason: function dialogReason() {
      var opened = this.openedReason;
      if (!opened || !this.selectedListener) {
        return null;
      }
      return opened.originator === this.selectedListener.originator ? opened.reason : null;
    },
    segmentCounts: function segmentCounts() {
      return this.summary.segmentCounts || {};
    },
    channelCounts: function channelCounts() {
      return this.aggregate && this.aggregate.channelCounts || {};
    },
    scopedCounts: function scopedCounts() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["b" /* deriveScopedCounts */])(this.aggregate || {});
    },
    audienceProfiles: function audienceProfiles() {
      var agg = this.aggregate;
      if (!agg || !agg.total) {
        return null;
      }
      var scoped = this.scopedCounts;
      return {
        gender: scoped.genderCounts,
        language: scoped.languageCounts,
        ageGroup: scoped.ageGroupCounts,
        location: scoped.locationCounts,
        ethnicity: scoped.ethnicityCounts
      };
    },
    filterOptions: function filterOptions() {
      return this.cachedFilterOptions;
    },
    retargetAlreadyAdded: function retargetAlreadyAdded() {
      var _currentGroup = this.currentGroup(),
          key = _currentGroup.key;

      return this.bucket.groups.some(function (g) {
        return g.group_key === key && g.full;
      });
    },
    retargetTip: function retargetTip() {
      return this.retargetAlreadyAdded ? 'This list is already in the retargeting bucket. Change the filters to add a different one.' : 'Set everyone in the current list aside in the retargeting bucket';
    },
    listenerRetargetTarget: function listenerRetargetTarget() {
      var _this = this;

      var last = this.bucket.groups.find(function (g) {
        return g.group_key === _this.lastBucketKey;
      });
      if (last) {
        return { key: last.group_key, label: last.label, kind: last.kind };
      }
      return this.contextGroup(this.selectedListener);
    },
    shortcutAlerts: function shortcutAlerts() {
      return this.activeFilterCount + (this.bucket.groups || []).length;
    },
    bucketItems: function bucketItems() {
      return (this.bucket.groups || []).length;
    },
    activeFilterCount: function activeFilterCount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["c" /* countActiveFilters */])(this.localFilters);
    },


    /**
     * What the pop-up should say, or null when there is nothing to say.
     *
     * Note: It shows a loading pop-up until every first-load query has
     * finished, then closes it, or lists what failed. A station that does
     * have data never sees "no data" flash while it loads.
     */
    notice: function notice() {
      if (!this.segmentationEnabled) {
        return {
          key: 'unavailable',
          tone: 'warning',
          icon: 'fa-ban',
          title: "Segmentation isn't available",
          text: "Segmentation isn't turned on for this station. Contact your account manager to have it enabled.",
          hint: '',
          refresh: false
        };
      }
      var total = this.loadTotal + 1;
      var done = this.loadDone + (this.interfaceReady ? 1 : 0);
      if (this.loadTotal > 0 && done < total) {
        var percent = Math.round(done / total * 100);
        return {
          key: 'loading',
          tone: 'info',
          icon: 'fa-bar-chart',
          title: 'Loading segmentation data',
          text: 'Getting your segments, insights and listeners ready…',
          progressText: done + ' of ' + total + ' loaded \xB7 ' + percent + '%',
          hint: '',
          refresh: false,
          loading: true,
          progress: percent
        };
      }
      if (this.loadErrors.length) {
        return {
          key: 'error:' + this.loadErrors.join('|'),
          tone: 'danger',
          icon: 'fa-exclamation-triangle',
          title: 'Could not load segmentation data',
          text: this.loadErrors.join('\n'),
          hint: 'The segmentation service may be down or restarting. Try again in a moment.',
          refresh: true
        };
      }
      if (this.loadingSummary) {
        return null;
      }
      if (!(this.summary && this.summary.totalListeners)) {
        return {
          key: 'empty',
          tone: 'info',
          icon: 'fa-database',
          title: 'No listener data yet',
          text: "Segmentation is turned on for this station, but there is no listener data to show. Segments, insights and charts appear here once the station's data has been loaded.",
          hint: 'If the data was loaded recently, refresh to check again.',
          refresh: true
        };
      }
      return null;
    },


    /**
     * What the listener's "why they match" panel names: the saved audience
     * being viewed, or else the interests being filtered on.
     */
    matchSourceName: function matchSourceName() {
      var f = this.localFilters;
      if (f.audienceName) {
        return f.audienceName;
      }
      var interests = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(f.interests || []), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(f.interestsAny || []));
      return interests.length ? 'interest: ' + interests.join(', ') : '';
    },


    /**
     * The filters AI enrichment can be limited to: the ones the listing is
     * using, sent the same way the listing sends them. Empty when nothing
     * is filtered.
     */
    bulkEnrichFilters: function bulkEnrichFilters() {
      return this.activeFilterCount > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(this.localFilters) : {};
    },


    /**
     * One short text per active filter, for the enrich dialog to show.
     */
    bulkEnrichFilterLabels: function bulkEnrichFilterLabels() {
      if (!this.activeFilterCount) {
        return [];
      }
      var pills = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["e" /* buildActivePills */])(this.localFilters, this.filterOptions.timeslots);
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(pills);
    }
  },

  watch: {
    pendingExport: function pendingExport(job) {
      this.loadExportCounts(job);
    },

    baseAggregate: {
      immediate: true,
      handler: function handler(agg) {
        if (!agg || !agg.total) {
          return;
        }
        var hasOptions = this.cachedFilterOptions.genders.length > 0 || this.cachedFilterOptions.channels.length > 0;
        if (hasOptions) {
          return;
        }
        this.cachedFilterOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["f" /* buildFilterOptions */])(agg);
      }
    },
    selectedListener: function selectedListener(val) {
      this.showDialog = !!val;
    },

    localFilters: {
      deep: true,
      handler: function handler() {
        this.preFillBrief = { text: '', ts: Date.now() };
      }
    },
    recommendError: function recommendError(val) {
      if (val && this.$refs.recommender) {
        this.$refs.recommender.onError();
      }
    }
  },

  created: function created() {
    this.loadInterface();
    if (!this.hideHeader) {
      this.loadBucket();
    }
  },


  methods: {
    /**
     * Downloads the dashboard's lazy components while the data loads, and
     * counts them as one more item in the loading notice.
     *
     * Note: A download that fails still marks the interface ready, so the
     * notice never stays up for good. Vue reports the missing component
     * when it tries to draw it.
     */
    loadInterface: function loadInterface() {
      var _this2 = this;

      var ready = function ready() {
        _this2.interfaceReady = true;
      };
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(LOADERS).map(function (load) {
        return load();
      })).then(ready, ready);
    },
    openFilters: function openFilters() {
      var _this3 = this;

      if (this.filtersMounted) {
        this.showFilters = true;
        return;
      }
      this.filtersMounted = true;
      this.$nextTick(function () {
        _this3.showFilters = true;
      });
    },
    startTour: function startTour() {
      this.fabsBeforeTour = this.fabsOpen;
      this.tourOpen = true;
    },
    onTourStep: function onTourStep(step) {
      if (step && step.fab) {
        this.fabsOpen = true;
      }
    },
    endTour: function endTour() {
      this.tourOpen = false;
      if (this.fabsBeforeTour !== null) {
        this.fabsOpen = this.fabsBeforeTour;
        this.fabsBeforeTour = null;
      }
    },
    toggleFabs: function toggleFabs() {
      this.fabsOpen = !this.fabsOpen;
    },


    /**
     * Loads the retarget bucket, for the count on its button.
     *
     * Note: If it cannot be loaded the bucket button simply shows no count.
     */
    loadBucket: function loadBucket() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.bucketLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this4.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_retarget_retargetBucketQuery_gql___default.a,
                  fetchPolicy: 'network-only'
                });

              case 4:
                _ref2 = _context.sent;
                data = _ref2.data;

                _this4.bucket = data.retargetBucket || { groups: [], total: 0 };
                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

              case 11:
                _context.prev = 11;

                _this4.bucketLoading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[1, 9, 11, 14]]);
      }))();
    },
    openBucket: function openBucket() {
      this.showBucket = true;
      this.loadBucket();
    },


    /**
     * Sets listeners aside in the bucket. `source` is one of
     * { originators }, { audienceId } or { params } (a filter set).
     */
    addToBucket: function addToBucket(group, source) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var include, working, _ref3, data, result, added, already;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this5.addingToBucket) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', false);

              case 2:
                _this5.addingToBucket = true;

                _context2.next = 5;
                return _this5.consentChoice('retarget', __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_retarget_retargetConsentCheckQuery_gql___default.a, source, 'retargetConsentCheck');

              case 5:
                include = _context2.sent;

                if (!(include === null)) {
                  _context2.next = 9;
                  break;
                }

                _this5.addingToBucket = false;
                return _context2.abrupt('return', false);

              case 9:
                working = _this5.$notify({
                  title: 'Retargeting bucket',
                  message: 'Processing\u2026 adding listeners to "' + group.label + '". This can take a few seconds for large lists.',
                  iconClass: 'fa fa-spinner fa-spin',
                  duration: 0,
                  showClose: false
                });
                _context2.prev = 10;
                _context2.next = 13;
                return _this5.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_retarget_addToRetargetBucketMutation_gql___default.a,
                  variables: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
                    groupKey: group.key,
                    groupLabel: group.label,
                    groupKind: group.kind,
                    includeUnconsented: include
                  }, source)
                });

              case 13:
                _ref3 = _context2.sent;
                data = _ref3.data;
                result = data.addToRetargetBucket || {};
                added = result.added || 0;
                already = result.already_present || 0;

                working.close();

                if (!(added === 0 && already > 0)) {
                  _context2.next = 22;
                  break;
                }

                _this5.$notify({
                  type: 'warning',
                  title: 'Already in the bucket',
                  message: already === 1 ? 'This listener is already in "' + group.label + '". Choose a different group, or create a new one.' : 'Everyone in this list is already in "' + group.label + '". Choose a different group, or create a new one.',
                  duration: 6000
                });
                return _context2.abrupt('return', false);

              case 22:

                _this5.$notify({
                  type: result.truncated ? 'warning' : 'success',
                  title: 'Retargeting bucket',
                  message: '' + (added.toLocaleString() + ' ' + (added === 1 ? 'listener' : 'listeners') + ' added to ' + ('"' + group.label + '".')) + (already ? ' ' + already.toLocaleString() + ' ' + (already === 1 ? 'was' : 'were') + ' already there.' : '') + (result.excluded ? ' ' + result.excluded.toLocaleString() + ' left out because they haven\'t opted in.' : '') + (result.truncated ? ' The list was larger than the group limit, so it was cut.' : '')
                });
                _context2.next = 25;
                return _this5.loadBucket();

              case 25:
                return _context2.abrupt('return', true);

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2['catch'](10);

                working.close();
                _this5.$notify({ type: 'error', message: 'Could not add to the retargeting bucket.' });
                return _context2.abrupt('return', false);

              case 33:
                _context2.prev = 33;

                _this5.addingToBucket = false;
                return _context2.finish(33);

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[10, 28, 33, 36]]);
      }))();
    },


    /**
     * The retarget group for the filters currently applied.
     *
     * Note: Same filters -> same group, so re-adding merges instead of
     * duplicating.
     */
    currentGroup: function currentGroup() {
      var f = this.localFilters;
      if (f.audienceId) {
        return {
          key: 'audience:' + f.audienceId,
          label: f.audienceName || 'Audience',
          kind: 'audience'
        };
      }
      if (f.segments.length === 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["c" /* countActiveFilters */])(f) === 1) {
        return {
          key: 'segment:' + f.segments[0],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__components_segmentation_utils_segmentation__["f" /* getSegmentLabel */])(f.segments[0]) + ' segment',
          kind: 'segment'
        };
      }
      var summary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["g" /* buildFilterSummary */])(f);
      if (!summary) {
        return { key: 'filters:all', label: 'All listeners', kind: 'filters' };
      }
      return {
        key: ('filters:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(f))).slice(0, 190),
        label: summary.charAt(0).toUpperCase() + summary.slice(1),
        kind: 'filters'
      };
    },
    retargetCurrent: function retargetCurrent() {
      var group = this.currentGroup();
      var source = this.localFilters.audienceId ? { audienceId: this.localFilters.audienceId } : { params: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(this.localFilters) };
      this.addToBucket(group, source);
    },
    contextGroup: function contextGroup(listener) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["c" /* countActiveFilters */])(this.localFilters) > 0) {
        return this.currentGroup();
      }
      if (listener && listener.currentSegment) {
        return {
          key: 'segment:' + listener.currentSegment,
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__components_segmentation_utils_segmentation__["f" /* getSegmentLabel */])(listener.currentSegment) + ' segment',
          kind: 'segment'
        };
      }
      return { key: 'listener:individual', label: 'Individual listeners', kind: 'listener' };
    },


    /**
     * target: {} (default group), { groupKey } (an existing bucket group) or
     * { newName } (a custom group). The group used is remembered, so the next
     * listener goes into the same one.
     */
    retargetListener: function retargetListener(_ref4) {
      var _this6 = this;

      var listener = _ref4.listener,
          _ref4$target = _ref4.target,
          target = _ref4$target === undefined ? {} : _ref4$target;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var group, existing, slug, added;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                group = void 0;

                if (target.groupKey) {
                  existing = _this6.bucket.groups.find(function (g) {
                    return g.group_key === target.groupKey;
                  });

                  group = existing ? { key: existing.group_key, label: existing.label, kind: existing.kind } : _this6.contextGroup(listener);
                } else if (target.newName) {
                  slug = target.newName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

                  group = { key: 'custom:' + (slug || 'group'), label: target.newName, kind: 'custom' };
                } else {
                  group = _this6.listenerRetargetTarget;
                }

                _context3.next = 4;
                return _this6.addToBucket(group, { originators: [listener.originator] });

              case 4:
                added = _context3.sent;

                if (added) {
                  _this6.lastBucketKey = group.key;
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },


    /**
     * One audience or several: each goes in as its own group, in turn.
     */
    retargetAudiences: function retargetAudiences(audiences) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                list = Array.isArray(audiences) ? audiences : [audiences];
                _context4.next = 3;
                return list.reduce(function (previous, audience) {
                  return previous.then(function () {
                    return _this7.addToBucket({ key: 'audience:' + audience.audience_id, label: audience.name, kind: 'audience' }, { audienceId: audience.audience_id });
                  });
                }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve());

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    viewAudience: function viewAudience(audience) {
      this.showAudiences = false;
      this.localFilters = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["a" /* DEFAULT_FILTERS */], {
        audienceId: audience.audience_id,
        audienceName: audience.name
      });
      this.activeSegment = null;
      this.applyFilters();
    },
    startExport: function startExport() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fromBucket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var channel = options.channelType !== undefined && options.channelType !== null ? options.channelType : null;
      this.pendingExport = {
        bucket: fromBucket,
        groupKeys: options.groupKeys || [],
        channelType: channel,
        channelPair: options.channelPair || null,
        tags: options.tags || null,
        label: this.exportLabel(options, fromBucket)
      };
    },
    exportLabel: function exportLabel(options, fromBucket) {
      var base = fromBucket ? options.label || 'Retarget bucket' : this.localFilters.audienceName || 'Current listener list';
      return options.label && !fromBucket ? base + ' \xB7 ' + options.label : base;
    },


    /**
     * What an export covers: the bucket, an audience or the current
     * filters, narrowed by channel.
     */
    exportSource: function exportSource(job) {
      var source = {};
      if (job.bucket) {
        source.useBucket = true;
        source.groupKeys = job.groupKeys;
      } else if (this.localFilters.audienceId) {
        source.audienceId = this.localFilters.audienceId;
      } else {
        source.params = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(this.localFilters));
        if (job.tags) {
          source.params.tags = job.tags;
        }
      }
      if (job.channelType !== null) {
        source.channelType = job.channelType;
      }
      if (job.channelPair) {
        source.channelPair = job.channelPair;
      }
      return source;
    },


    /**
     * Asks how many listeners an add to the bucket covers who have not
     * opted in, and lets the station decide.
     *
     * Resolves null if they cancel, otherwise whether to include them.
     *
     * Note: If the check itself fails, listeners who have not opted in stay
     * out, since the server leaves them out unless told otherwise.
     */
    consentChoice: function consentChoice(purpose, query, variables, field) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var counts, _ref5, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                counts = void 0;
                _context5.prev = 1;
                _context5.next = 4;
                return _this8.$apollo.query({
                  client: 'apiv2',
                  query: query,
                  variables: variables,
                  fetchPolicy: 'network-only'
                });

              case 4:
                _ref5 = _context5.sent;
                data = _ref5.data;

                counts = data[field];
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](1);
                return _context5.abrupt('return', false);

              case 12:
                if (!(!counts || !counts.without_opt_in)) {
                  _context5.next = 14;
                  break;
                }

                return _context5.abrupt('return', false);

              case 14:
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this8.consent = {
                    purpose: purpose,
                    total: counts.total,
                    without: counts.without_opt_in,
                    resolve: resolve
                  };
                }));

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[1, 9]]);
      }))();
    },


    /**
     * Counts who has not opted in for the export being set up, so the
     * dialog can show it up front.
     *
     * Note: If the count cannot be loaded the dialog shows no consent
     * section, and the server still leaves those listeners out.
     */
    loadExportCounts: function loadExportCounts(job) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.exportCounts = null;

                if (job) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt('return');

              case 3:
                _this9.exportCountsLoading = true;
                _context6.prev = 4;
                _context6.next = 7;
                return _this9.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_retarget_exportConsentCheckQuery_gql___default.a,
                  variables: _this9.exportSource(job),
                  fetchPolicy: 'network-only'
                });

              case 7:
                _ref6 = _context6.sent;
                data = _ref6.data;

                if (_this9.pendingExport === job) {
                  _this9.exportCounts = data.exportConsentCheck;
                }
                _context6.next = 14;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](4);

              case 14:
                _context6.prev = 14;

                if (_this9.pendingExport === job) {
                  _this9.exportCountsLoading = false;
                }
                return _context6.finish(14);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[4, 12, 14, 17]]);
      }))();
    },
    answerConsent: function answerConsent(include) {
      var _ref7 = this.consent || {},
          resolve = _ref7.resolve;

      this.consent = null;
      if (resolve) {
        resolve(include);
      }
    },
    runExport: function runExport(_ref8) {
      var _this10 = this;

      var fields = _ref8.fields,
          nonNull = _ref8.nonNull,
          includeUnconsented = _ref8.includeUnconsented;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var job, source, working, variables, _ref9, data, result, blob, url, a;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                job = _this10.pendingExport;

                if (job) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt('return');

              case 3:
                source = _this10.exportSource(job);

                _this10.exporting = true;
                working = _this10.$notify({
                  title: 'Export',
                  message: 'Processing… building your CSV. This can take a moment for large lists.',
                  iconClass: 'fa fa-spinner fa-spin',
                  duration: 0,
                  showClose: false
                });
                _context7.prev = 6;
                variables = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
                  fields: fields,
                  nonNull: nonNull,
                  includeUnconsented: includeUnconsented === true
                }, source);
                _context7.next = 10;
                return _this10.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_retarget_exportRowsQuery_gql___default.a,
                  variables: variables,
                  fetchPolicy: 'network-only'
                });

              case 10:
                _ref9 = _context7.sent;
                data = _ref9.data;
                result = data.exportRows;

                working.close();

                if (!(!result || !result.returned)) {
                  _context7.next = 17;
                  break;
                }

                _this10.$notify({ type: 'warning', message: 'No listeners to export.' });
                return _context7.abrupt('return');

              case 17:
                blob = new Blob([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__components_segmentation_utils_exportFields__["a" /* toCsv */])(result)], { type: 'text/csv;charset=utf-8;' });
                url = URL.createObjectURL(blob);
                a = document.createElement('a');

                a.href = url;
                a.download = job.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '-' + __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYYMMDD-HHmm') + '.csv';
                a.click();
                URL.revokeObjectURL(url);

                _this10.$notify({
                  type: 'success',
                  message: 'Exported ' + result.returned.toLocaleString() + ' of ' + result.total.toLocaleString() + ' listeners.' + (result.excluded ? ' ' + result.excluded.toLocaleString() + ' left out because they haven\'t opted in.' : '') + (result.truncated ? ' The list was larger than the export limit, so it was cut.' : '')
                });
                _this10.pendingExport = null;
                _context7.next = 32;
                break;

              case 28:
                _context7.prev = 28;
                _context7.t0 = _context7['catch'](6);

                working.close();
                _this10.$notify({ type: 'error', message: 'Export failed. Please try again.' });

              case 32:
                _context7.prev = 32;

                _this10.exporting = false;
                return _context7.finish(32);

              case 35:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[6, 28, 32, 35]]);
      }))();
    },
    onFilterUpdate: function onFilterUpdate(_ref10) {
      var field = _ref10.field,
          value = _ref10.value;

      this.$set(this.localFilters, field, value);
    },
    applyAiSearch: function applyAiSearch(aiFilters) {
      this.localFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["h" /* filtersFromAiSearch */])(aiFilters);
      this.activeSegment = this.localFilters.segments.length === 1 ? this.localFilters.segments[0] : null;
      this.applyFilters();
    },
    onRecommend: function onRecommend(_ref11) {
      var brief = _ref11.brief,
          filters = _ref11.filters;

      this.$emit('recommend', { brief: brief, filters: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(filters) });
    },
    onRecommenderCleared: function onRecommenderCleared() {
      this.preFillBrief = { text: '', ts: 0 };
      this.$emit('recommend-cleared');
    },

    /**
     * A number in the Buying intent card: lists the listeners at that
     * category and tier (or higher), keeping the other filters.
     */
    /**
     * Exporting from the recommender is how a recommendation counts as used.
     * The station is told which one, and the export carries on as before.
     */
    exportRecommended: function exportRecommended(channel) {
      var result = this.recommendationResult || {};
      var id = result.recommendation_id || result.recommendationId;
      if (id) {
        this.$emit('recommendation-used', {
          id: id,
          action: channel ? 'export_by_channel' : 'export_audience'
        });
      }
      this.startExport(channel);
    },
    handleHubPick: function handleHubPick(pick) {
      this.showAdvertiserHub = false;
      this.handleIntentPick(pick);
    },
    handleIntentPick: function handleIntentPick(_ref12) {
      var category = _ref12.category,
          tier = _ref12.tier;

      this.localFilters.intentCategories = [category];
      this.localFilters.intentTier = tier;
      this.preFillBrief = { text: '', ts: Date.now() };
      this.applyFilters();
    },
    handleSegmentClick: function handleSegmentClick(segment) {
      if ((this.segmentCounts[segment] || 0) === 0) {
        return;
      }

      this.activeSegment = this.activeSegment === segment ? null : segment;
      this.localFilters.segments = this.activeSegment ? [this.activeSegment] : [];
      this.preFillBrief = { text: '', ts: Date.now() };

      this.applyFilters({ scrollTo: '.seg-insights-row' });
    },


    /**
     * Plain search from the Find listeners window: runs here, and the
     * window reports the count; "View" then scrolls to the results.
     */
    findByTerm: function findByTerm(_ref13) {
      var originator = _ref13.originator;

      this.localFilters = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["a" /* DEFAULT_FILTERS */], { originator: originator });
      this.activeSegment = null;
      this.applyFilters({ scrollTo: null });
    },
    scrollToListeners: function scrollToListeners() {
      this.$nextTick(function () {
        var el = document.querySelector('.listener-retargeting-ibox');
        if (el) {
          window.scrollTo({
            top: el.getBoundingClientRect().top + window.scrollY - 20,
            behavior: 'smooth'
          });
        }
      });
    },


    /**
     * After a bulk enrich: reload what is on screen with the same filters.
     */
    refreshListeners: function refreshListeners() {
      this.$emit('filter', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(this.localFilters));
    },
    applyFilters: function applyFilters() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref14$scrollTo = _ref14.scrollTo,
          scrollTo = _ref14$scrollTo === undefined ? '.listener-retargeting-ibox' : _ref14$scrollTo;

      var params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["d" /* buildFilterParams */])(this.localFilters);

      this.preFillBrief = { text: '', ts: Date.now() };
      this.showListeners = true;
      this.$emit('filter', params);

      this.$nextTick(function () {
        var el = scrollTo && document.querySelector(scrollTo);

        if (el) {
          var offset = 20;
          var top = el.getBoundingClientRect().top + window.scrollY - offset;

          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      });
    },
    resetFilters: function resetFilters() {
      this.localFilters = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["a" /* DEFAULT_FILTERS */]);
      this.activeSegment = null;
      this.showListeners = false;
      this.preFillBrief = { text: '', ts: Date.now() };
      this.$emit('filter', {});
    },
    handleAiSuggest: function handleAiSuggest(_ref15) {
      var segment = _ref15.segment;

      var f = this.localFilters;
      var seg = f.segments[0] || segment;
      var summary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__components_segmentation_utils_filterHelpers__["g" /* buildFilterSummary */])(f);
      var text = summary ? 'Campaign targeting ' + summary : 'Campaign targeting ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__components_segmentation_utils_segmentation__["f" /* getSegmentLabel */])(seg || 'general') + ' audience';
      this.preFillBrief = { text: text, ts: Date.now() };
      this.$notify({
        type: 'info',
        title: 'AI Recommender',
        message: 'Brief pre-filled from your filters. Scroll down and click Generate.'
      });
      this.$nextTick(function () {
        var el = document.querySelector('.campaign-recommender-ibox');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },


    /**
     * Remembered so the Interactions tab can show only what matched the
     * audience being viewed.
     */
    openListener: function openListener(listener) {
      this.openedReason = listener.matchReason ? { originator: listener.originator, reason: listener.matchReason } : null;
      this.$emit('open-listener', listener);
    },
    closeDialog: function closeDialog() {
      this.showDialog = false;
      this.openedReason = null;
      this.$emit('close-listener');
    }
  }
});

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_segmentation_ai_aiCreditsQuery_gql__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_segmentation_ai_aiCreditsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__graphql_segmentation_ai_aiCreditsQuery_gql__);


//
//
//
//
//
//
//
//
//
//
//
//



var STORAGE_KEY = 'segmentation-credits-banner';

/**
 * A warning across the top of the dashboard when the station's AI credits
 * are running low, used up or paused, so it is not a surprise when an AI
 * action stops working.
 *
 * It uses the service's own status (the same one the AI usage window shows),
 * and a closed warning stays closed for the rest of the session unless the
 * status gets worse.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AiCreditsBanner',
  data: function data() {
    return { credits: null, dismissed: '' };
  },
  computed: {
    status: function status() {
      return this.credits && this.credits.status || null;
    },
    remaining: function remaining() {
      return Math.max(0, Math.round(Number(this.credits && this.credits.credits_remaining) || 0));
    },
    notice: function notice() {
      var key = this.status && this.status.key;
      if (!key || key === this.dismissed) {
        return null;
      }
      if (key === 'low') {
        return {
          type: 'warning',
          title: 'AI credits are running low',
          text: this.remaining.toLocaleString() + ' credits left. Contact Colony to top up before they run out.'
        };
      }
      if (key === 'exhausted') {
        return {
          type: 'error',
          title: 'AI credits are used up',
          text: 'AI features are unavailable until Colony tops up your credits.'
        };
      }
      if (key === 'paused') {
        return {
          type: 'error',
          title: 'AI is paused',
          text: this.status.reason || 'AI usage is paused for this station.'
        };
      }
      return null;
    }
  },
  created: function created() {
    this.dismissed = this.readDismissed();
    this.load();
  },

  methods: {
    /**
     * Note: Informational only. If the balance cannot be loaded, no banner
     * shows.
     */
    load: function load() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_2__graphql_segmentation_ai_aiCreditsQuery_gql___default.a,
                  fetchPolicy: 'network-only'
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.credits = data.aiCredits;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.credits = null;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },


    /**
     * Note: Browser storage can be blocked, so a failure just means the
     * warning comes back on the next visit.
     */
    readDismissed: function readDismissed() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY) || '';
      } catch (e) {
        return '';
      }
    },
    dismiss: function dismiss() {
      this.dismissed = this.status ? this.status.key : '';
      try {
        window.sessionStorage.setItem(STORAGE_KEY, this.dismissed);
      } catch (e) {
        /* Ignored on purpose: see the Note above readDismissed. */
      }
    }
  }
});

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A pop-up for a screen that has nothing to show yet, with a refresh to
 * check again. It only reports what was clicked: the parent decides what
 * Close and Refresh do.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoDataModal',
  props: {
    visible: { type: Boolean, default: false },
    refreshing: { type: Boolean, default: false },
    /**
     * info, warning or danger: the accent colour of the pop-up.
     */
    tone: { type: String, default: 'info' },
    showRefresh: { type: Boolean, default: true },
    /**
     * Shows the animated loading look with a progress bar (0 to 100) and no
     * buttons.
     */
    loading: { type: Boolean, default: false },
    progress: { type: Number, default: 0 },
    progressText: { type: String, default: '' },
    icon: { type: String, default: 'fa-database' },
    title: { type: String, default: 'No listener data yet' },
    text: {
      type: String,
      default: "Segmentation is turned on for this station, but there is no listener data to show. Segments, insights and charts appear here once the station's data has been loaded."
    },
    hint: {
      type: String,
      default: 'If the data was loaded recently, refresh to check again.'
    }
  }
});

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A card-shaped placeholder with shimmering blocks, shown in the place of a
 * dashboard section while its code is still being downloaded, so the page
 * never shows an empty gap.
 *
 * Note: `height` should be about the height of the real section, so the page
 * does not jump when the section appears.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SectionSkeleton',
  props: {
    height: { type: Number, default: 280 },
    blocks: { type: Number, default: 4 }
  }
});

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardHeader'
});

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: "off" */





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduledPost',

  data: function data() {
    return {
      colWidths: [12, 12],
      currentChannel: ''
    };
  },

  props: {
    post: {
      type: Object,
      required: true
    },
    channels: {
      type: Array,
      default: []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    containsMedia: function containsMedia() {
      return this.post.media.length > 0;
    },
    postTimestamp: function postTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.post.post_date).format('ddd, D MMMM YYYY HH:mm');
    },
    channelsFull: function channelsFull() {
      var _this = this;

      return this.post.channels.map(function (x) {
        return _this.channels.find(function (z) {
          return z.id === x;
        });
      });
    },
    channelTypes: function channelTypes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.channelsFull.reduce(function (acc, x) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, _this2.getDefinedValue(x, 'channle_type'), true));
      }, {}));
    }
  },
  methods: {
    getChannelHandlesByType: function getChannelHandlesByType(type) {
      var _this3 = this;

      return this.channelsFull.filter(function (x) {
        return _this3.getDefinedValue(x, 'channle_type') === type;
      }).map(function (x) {
        return _this3.getDefinedValue(x, 'handle');
      });
    },
    getDefinedValue: function getDefinedValue(value, requestData) {
      var type = typeof value !== 'undefined';
      var request = {
        handle: type ? value.handle : 'Not assigned',
        channle_type: type ? value.channel_type_title : 'Default'
      };
      return request[requestData];
    },
    isDefined: function isDefined(value) {
      return typeof value !== 'undefined';
    },
    handleDeletePost: function handleDeletePost() {
      var _this4 = this;

      this.$confirm('Are you sure you want to remove this scheduled post?').then(function () {
        _this4.$emit('delete', _this4.post.id);
      });
    },
    handleEditPost: function handleEditPost() {
      this.$emit('edit', this.post);
    },
    showScheduledPost: function showScheduledPost() {
      return this.channelTypes.includes('Facebook');
    }
  },

  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_5__components_common_Icons_SocialIcon___default.a,
    Emoji: __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__["Emoji"],
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_common_Loader___default.a
  }
});

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduledPost__ = __webpack_require__(3017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduledPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ScheduledPost__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduledPostList',

  components: {
    ScheduledPost: __WEBPACK_IMPORTED_MODULE_0__ScheduledPost___default.a
  },
  props: {
    posts: {
      type: Array,
      default: []
    },
    channels: {
      type: Array,
      default: []
    }
  },
  computed: {
    orderedPosts: function orderedPosts() {
      return this.posts.filter(function (p) {
        return !p.sent;
      }).slice().sort(function (a, b) {
        return new Date(a.post_date) > new Date(b.post_date);
      });
    }
  },

  methods: {
    handleNewPost: function handleNewPost() {
      this.$emit('newPost');
    },
    onDeletePost: function onDeletePost(id) {
      this.$emit('deletePost', id);
    },
    onEditPost: function onEditPost(post) {
      this.$emit('editPost', post);
    }
  }
});

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_social_mutation_types__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_social_facebook_InsightsOverview__ = __webpack_require__(3024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_social_facebook_InsightsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_social_facebook_InsightsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_social_facebook_PageDemographicsOverview__ = __webpack_require__(3026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_social_facebook_PageDemographicsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_social_facebook_PageDemographicsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_analytics_facebookPostAnalytics_gql__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_analytics_facebookPostAnalytics_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__graphql_analytics_facebookPostAnalytics_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_social_facebook_PostOverview__ = __webpack_require__(3029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_social_facebook_PostOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_social_facebook_PostOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_analytics_facebookPageFansDemographics_gql__ = __webpack_require__(2571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_analytics_facebookPageFansDemographics_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__graphql_analytics_facebookPageFansDemographics_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_analytics_facebookPageContentDemographics_gql__ = __webpack_require__(2570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_analytics_facebookPageContentDemographics_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__graphql_analytics_facebookPageContentDemographics_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_analytics_facebookPageImpressionsDemographics_gql__ = __webpack_require__(2572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_analytics_facebookPageImpressionsDemographics_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__graphql_analytics_facebookPageImpressionsDemographics_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_analytics_facebookPageInsightsOverviewQuery_gql__ = __webpack_require__(2573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_analytics_facebookPageInsightsOverviewQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__graphql_analytics_facebookPageInsightsOverviewQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_social_instagram_InsightsOverview__ = __webpack_require__(3032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_social_instagram_InsightsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_social_instagram_InsightsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SocialDashboardUtils__ = __webpack_require__(1140);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var queryMap = {
  fans: __WEBPACK_IMPORTED_MODULE_13__graphql_analytics_facebookPageFansDemographics_gql___default.a,
  engagements: __WEBPACK_IMPORTED_MODULE_15__graphql_analytics_facebookPageImpressionsDemographics_gql___default.a,
  content: __WEBPACK_IMPORTED_MODULE_14__graphql_analytics_facebookPageContentDemographics_gql___default.a
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialAnalyticsDashboard',

  data: function data() {
    return {
      demographicsLoading: false,
      insightsOverviewLoading: false,
      instagramInsightsOverviewLoading: false,
      facebookPostInsightLoading: false,
      selectedDemographic: 'fans',
      demographicData: null,
      insightOverviewData: null,
      instagramInsightOverviewData: null,
      facebookPostInsightData: null,
      postInsightPageSize: 0,
      currentPostInsightPage: 1,
      postInsightSearchTerm: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('social', ['selectedFacebookPage', 'selectedInstagramPage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('channel', ['loadingChannels']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('social', ['facebookInsightsOverviewData', 'instagramInsightsOverviewData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('channel', ['socialChannels', 'facebookChannels', 'instagramChannels']), {
    overviewData: function overviewData() {
      return this.facebookInsightsOverviewData[this.selectedFacebookPage];
    }
  }),

  mounted: function mounted() {
    this.$store.dispatch('channel/getChannels');
  },


  methods: {
    handlePageChange: function handlePageChange(value) {
      this.$store.commit('social/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_social_mutation_types__["o" /* SET_SELECTED_FACEBOOK_PAGE */], value);
    },
    changeSerachTerm: function changeSerachTerm(value) {
      this.postInsightSearchTerm = value;
      this.fetchFacebookPostAnalyticstData();
    },
    handleInstagramPageChange: function handleInstagramPageChange(value) {
      this.$store.commit('social/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_social_mutation_types__["p" /* SET_SELECTED_INSTAGRAM_PAGE */], value);
    },
    handleDemographicTypeChanged: function handleDemographicTypeChanged(value) {
      this.selectedDemographic = value;
    },
    fetchDemographicsData: function fetchDemographicsData() {
      var _this = this;

      if (!this.selectedDemographic || !this.selectedFacebookPage || !this.facebookChannels) return;

      this.demographicsLoading = true;

      this.$apollo.query({
        query: queryMap[this.selectedDemographic],
        variables: {
          channelId: this.selectedFacebookPage
        }
      }).then(function (resp) {
        _this.demographicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__SocialDashboardUtils__["a" /* processDemographicData */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(resp.data.pageDemographics)[0]);
        _this.demographicsLoading = false;
      });
    },
    fetchinsightsOverviewData: function fetchinsightsOverviewData() {
      var _this2 = this;

      if (!this.selectedFacebookPage || !this.facebookChannels) return;

      this.insightsOverviewLoading = true;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_16__graphql_analytics_facebookPageInsightsOverviewQuery_gql___default.a,
        variables: {
          channelId: this.selectedFacebookPage
        }
      }).then(function (resp) {
        var processedData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__SocialDashboardUtils__["b" /* processInsightsOverviewData */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(resp.data)[0]);
        var data = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(processedData).forEach(function (key) {
          data[key] = processedData[key];
        });

        _this2.insightOverviewData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data);

        _this2.insightsOverviewLoading = false;
      });
    },
    fetchFacebookPostAnalyticstData: function fetchFacebookPostAnalyticstData() {
      var _this3 = this;

      this.facebookPostInsightLoading = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_11__graphql_analytics_facebookPostAnalytics_gql___default.a,
        variables: {
          page: this.currentPostInsightPage,
          channelId: this.selectedFacebookPage,
          search: this.postInsightSearchTerm
        }
      }).then(function (resp) {
        var data = resp.data.postInsightsOverview;
        _this3.facebookPostInsightLoading = false;
        _this3.facebookPostInsightData = data.objects;
        _this3.setPostInsightPageData(data);
      }).catch(function () {
        _this3.facebookPostInsightData = [];
        _this3.facebookPostInsightLoading = false;
      });
    },
    setPostInsightPageData: function setPostInsightPageData(pageDate) {
      this.postInsightPageSize = pageDate.pages;
    },
    changePostInsightPage: function changePostInsightPage(page) {
      this.currentPostInsightPage = page;
      this.fetchFacebookPostAnalyticstData();
    },
    fetchInstagramInsightsOverviewData: function fetchInstagramInsightsOverviewData(period) {
      var _this4 = this;

      if (!this.selectedInstagramPage || !this.instagramChannels) return;
      this.instagramInsightsOverviewLoading = true;
      var periodMetrics = {
        day: 'views,reach,profile_views,follows_and_unfollows,follower_count',
        week: 'reach',
        month: 'reach',
        lifetime: 'reached_audience_demographics,engaged_audience_demographics,follower_demographics,follower_count'
      };
      var metrics = periodMetrics[period];
      var metricsPeriod = period === 'month' ? 'days_28' : period;

      var selectedInstagramChannel = this.instagramChannels.filter(function (channel) {
        return channel.id === _this4.selectedInstagramPage;
      });

      if (selectedInstagramChannel.length > 0) {
        var serviceId = selectedInstagramChannel[0].extra_data.channel_id;
        __WEBPACK_IMPORTED_MODULE_5__api__["d" /* instagramAPI */].get('facebook/insights/?channel=' + serviceId + '&metrics=' + metrics + '&period=' + metricsPeriod).then(function (response) {
          _this4.instagramInsightOverviewData = response.data.data;
          _this4.instagramInsightsOverviewLoading = false;
        });
      }
    }
  },

  watch: {
    facebookChannels: function facebookChannels() {
      if (this.facebookChannels.length && !this.selectedFacebookPage) {
        this.handlePageChange(this.facebookChannels[0].id);
      }
      this.fetchDemographicsData();
      this.fetchinsightsOverviewData();
      this.fetchFacebookPostAnalyticstData();
    },
    instagramChannels: function instagramChannels() {
      if (this.instagramChannels.length && !this.selectedInstagramPage) {
        this.handleInstagramPageChange(this.instagramChannels[0].id);
      }
      this.fetchInstagramInsightsOverviewData('day');
    },
    selectedFacebookPage: function selectedFacebookPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchDemographicsData();
        this.fetchinsightsOverviewData();
        this.fetchFacebookPostAnalyticstData();
      }
    },
    selectedInstagramPage: function selectedInstagramPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchInstagramInsightsOverviewData('day');
      }
    },
    selectedDemographic: function selectedDemographic(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchDemographicsData();
    }
  },

  components: {
    PostOverview: __WEBPACK_IMPORTED_MODULE_12__components_social_facebook_PostOverview___default.a,
    FacebookInsightsOverview: __WEBPACK_IMPORTED_MODULE_9__components_social_facebook_InsightsOverview___default.a,
    InstagramInsightsOverview: __WEBPACK_IMPORTED_MODULE_17__components_social_instagram_InsightsOverview___default.a,
    PageDemographicsOverview: __WEBPACK_IMPORTED_MODULE_10__components_social_facebook_PageDemographicsOverview___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_common_Loader___default.a,
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_8__components_common_ContentPlaceholder___default.a
  }
});

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_social_tiktok_TikTokOptions__ = __webpack_require__(3034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_social_tiktok_TikTokOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_social_tiktok_TikTokOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_collect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_collect_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_collect_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_file__ = __webpack_require__(567);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var disabledDate = function disabledDate(time) {
  return time < __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'day').toDate();
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialPost',

  components: {
    SocialIcon: __WEBPACK_IMPORTED_MODULE_4__components_common_Icons_SocialIcon___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__["Picker"],
    TikTokOptions: __WEBPACK_IMPORTED_MODULE_5__components_social_tiktok_TikTokOptions___default.a
  },

  props: {
    channels: {
      type: Array,
      default: []
    },
    post: {
      type: Object,
      required: false
    },
    editPost: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      sending: false,
      deleting: false,
      addMedia: false,
      isAllChecked: false,
      fileList: [],
      checkedChannels: [],
      mediaList: [],
      schedule: null,
      messageContent: '',
      messageCursorPos: 0,
      datePickerOptions: {
        disabledDate: disabledDate
      },
      pickerStyles: {
        height: '330px',
        borderRadius: '4px'
      },
      isLoadingTikTokCreator: false,
      tiktokSettings: {
        max_video_post_duration_sec: '',
        privacy_level_options: [],
        creator_avatar_url: '',
        creator_nickname: '',
        creator_username: '',
        allow_comment: false,
        allow_duet: false,
        allow_stitch: false
      }
    };
  },

  computed: {
    postSchedule: {
      set: function set(val) {
        this.schedule = val ? String(val.getTime() / 1000) : null;
      },
      get: function get() {
        return this.schedule ? new Date(parseInt(this.schedule, 10) * 1000) : null;
      }
    },
    getSelectedTwitterChannels: function getSelectedTwitterChannels() {
      var selectedChannels = this.checkedChannels;
      var filteredTwitterChannelSelected = __WEBPACK_IMPORTED_MODULE_6_collect_js___default()(this.channels).whereIn('id', selectedChannels).filter(function (channel) {
        return channel.channel_type_title.toLowerCase() === 'twitter';
      }).all();
      return filteredTwitterChannelSelected;
    },
    showImagePreview: function showImagePreview() {
      return this.editPost && this.mediaList.length && this.mediaList.reduce(function (show, x) {
        return show || !!x.url;
      }, false);
    },
    getSelectedTikTokChannels: function getSelectedTikTokChannels() {
      var selectedChannels = this.checkedChannels;
      var filteredTikTokChannels = __WEBPACK_IMPORTED_MODULE_6_collect_js___default()(this.channels).whereIn('id', selectedChannels).filter(function (channel) {
        return channel.channel_type_title.toLowerCase() === 'tiktok';
      }).all();
      return filteredTikTokChannels;
    },
    isPostDisabled: function isPostDisabled() {
      var hasTikTok = this.getSelectedTikTokChannels.length > 0;

      return hasTikTok && this.mediaList.length === 0 || hasTikTok && !this.tiktokSettings.privacy_level || hasTikTok && this.schedule;
    },
    tiktokMediaWarning: function tiktokMediaWarning() {
      if (!this.getSelectedTikTokChannels.length) return '';

      var rules = [{
        condition: this.schedule,
        message: 'Scheduling TikTok posts is not supported'
      }, {
        condition: !this.tiktokSettings.privacy_level,
        message: 'Please select who can view this video on TikTok'
      }, {
        condition: this.mediaList.length === 0,
        message: 'Please add a video to post on TikTok'
      }];

      var match = rules.find(function (r) {
        return r.condition;
      });
      return match ? match.message : '';
    }
  },

  methods: {
    handleSelectAll: function handleSelectAll() {
      var allChecked = this.checkedChannels.length === this.channels.length;
      this.checkedChannels = allChecked ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.channels.map(function (x) {
        return x.id;
      })));
      this.isAllChecked = this.checkedChannels.length === this.channels.length;
    },
    insertEmoji: function insertEmoji(emoji) {
      var cursorPos = this.messageCursorPos;
      this.messageContent = '' + this.messageContent.slice(0, cursorPos) + emoji.native + this.messageContent.slice(cursorPos);
    },
    isVideo: function isVideo(file) {
      return file.type && file.type.startsWith('video');
    },
    handleInputBlur: function handleInputBlur(e) {
      this.messageCursorPos = e.target.selectionStart;
    },
    handleCheckedChannelChange: function handleCheckedChannelChange(val) {
      var checkedCount = val.length;
      this.isAllChecked = checkedCount === this.channels.length;
    },
    handleSendPost: function handleSendPost() {
      if (this.getSelectedTikTokChannels.length > 0 && !this.tiktokSettings.privacy_level) {
        this.$alert('Please select a privacy level for TikTok before sending.', 'Missing Privacy', {
          type: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }

      if (this.checkedChannels.length === 0 || !this.messageContent) return;

      if (this.schedule && this.schedule < Date.now() / 1000) {
        var opts = {
          type: 'warning',
          title: 'Time in past',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        };

        this.$confirm('Scheduled date has already elapsed. Send imediately?', opts).then(this.sendPost).catch(function () {
          return null;
        });
      } else {
        this.sendPost();
      }
    },
    sendPost: function sendPost() {
      if (this.schedule < Date.now() / 1000) this.schedule = null;

      this.sending = true;
      this.$emit(this.editPost ? 'update' : 'send', {
        id: this.post ? this.post.id : null,
        channelIds: this.checkedChannels,
        message: this.messageContent,
        media: this.mediaList,
        scheduleTimestamp: this.schedule,
        settings: this.getSelectedTikTokChannels.length ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.tiktokSettings) : null
      });
    },
    validateFileSize: function validateFileSize(file) {
      var bytes = 1024;
      var fileSize = file.size / bytes / bytes; // in MB
      var isValidFileSize = true;
      var selectedTwitterChannels = this.getSelectedTwitterChannels;
      if (selectedTwitterChannels.length > 0) {
        if (fileSize > 0.1 && file.name.match(/.(jpg|jpeg|png)$/i)) {
          this.$alert('File size exceeds 5MB maximum limit for an image');
          isValidFileSize = false;
        }
        if (fileSize > 15) {
          this.$alert('File size exceeds 15MB maximum limit for a gif or video');
          isValidFileSize = false;
        }
      }

      return file && isValidFileSize;
    },
    handleFileChange: function handleFileChange(file) {
      var _this = this;

      if (!this.validateFileSize(file)) {
        this.handleFileRemove();
        return;
      }

      // Validate video duration for TikTok
      if (this.getSelectedTikTokChannels.length > 0 && file.raw.type.startsWith('video')) {
        var maxDuration = this.tiktokSettings.max_video_post_duration_sec;
        if (maxDuration) {
          var video = document.createElement('video');
          video.preload = 'metadata';
          video.onloadedmetadata = function () {
            URL.revokeObjectURL(video.src);
            if (video.duration > maxDuration) {
              _this.$alert('Video exceeds TikTok\'s maximum duration of ' + _this.formatDuration(maxDuration) + '.', 'Video Too Long', { type: 'warning' });
              _this.handleFileRemove();
              return;
            }
            _this.loadFileToMediaList(file);
          };
          video.src = URL.createObjectURL(file.raw);
          return;
        }
      }

      this.loadFileToMediaList(file);
    },
    loadFileToMediaList: function loadFileToMediaList(file) {
      var _this2 = this;

      this.fileList = [file];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_file__["a" /* getBase64FileObj */])(file.raw).then(function (fileObj) {
        _this2.mediaList = [fileObj];
      }).catch(function () {
        return _this2.$alert('Unable to read file', { type: 'error' });
      });
    },
    formatDuration: function formatDuration(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      if (hours > 0) return hours + ' hour' + (hours > 1 ? 's' : '');
      return minutes + ' minute' + (minutes > 1 ? 's' : '');
    },
    isChannelDisabled: function isChannelDisabled(channel) {
      var _this3 = this;

      var isTikTok = channel.channel_type_title.toLowerCase() === 'tiktok';
      var hasTikTokSelected = this.getSelectedTikTokChannels.length > 0;
      var hasOtherSelected = this.checkedChannels.some(function (id) {
        var ch = _this3.channels.find(function (c) {
          return c.id === id;
        });
        return ch && ch.channel_type_title.toLowerCase() !== 'tiktok';
      });

      if (isTikTok) return hasOtherSelected;
      return hasTikTokSelected;
    },
    handleFileRemove: function handleFileRemove() {
      this.fileList = [];
      this.mediaList = [];
    },
    handleDeletePost: function handleDeletePost() {
      var _this4 = this;

      this.$confirm('Are you sure you would like to delete this post?').then(function () {
        _this4.deleting = true;
        _this4.$emit('delete', _this4.post.id);
      });
    },
    fetchTikTokCreatorInfo: function fetchTikTokCreatorInfo(channel) {
      var _this5 = this;

      this.isLoadingTikTokCreator = true;

      this.$store.dispatch('channel/getTiktokCreatorInfo', {
        channel_handle: channel.handle,
        company_id: channel.company
      }).then(function (data) {
        _this5.tiktokSettings = {
          max_video_post_duration_sec: data.max_video_post_duration_sec,
          privacy_level_options: data.privacy_level_options,
          creator_avatar_url: data.creator_avatar_url,
          creator_nickname: data.creator_nickname,
          creator_username: data.creator_username,
          allow_comment: !data.comment_disabled,
          allow_duet: !data.duet_disabled,
          allow_stitch: !data.stitch_disabled
        };
      }).catch(function () {
        _this5.$alert('Failed to fetch TikTok creator info', 'Error', { type: 'error' });
        _this5.resetTikTokSettings();
      }).finally(function () {
        _this5.isLoadingTikTokCreator = false;
      });
    },
    resetTikTokSettings: function resetTikTokSettings() {
      this.tiktokSettings = {
        max_video_post_duration_sec: '',
        privacy_level_options: [],
        creator_avatar_url: '',
        creator_nickname: '',
        creator_username: '',
        allow_comment: false,
        allow_duet: false,
        allow_stitch: false
      };
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    if (this.post) {
      this.mediaList = this.post.media || [];
      this.post.channels = this.post.channels || [];
      this.checkedChannels = this.post.channels;
      this.schedule = new Date(this.post.post_date).getTime() / 1000;
      this.messageContent = this.post.message;
      this.allChecked = this.channels.reduce(function (acc, x) {
        if (_this6.post.channels.findIndex(function (p) {
          return x === p;
        }) !== -1) return false;
        return acc;
      }, true);
    }
  },


  watch: {
    getSelectedTikTokChannels: {
      handler: function handler(channels) {
        if (channels.length === 1) {
          this.fetchTikTokCreatorInfo(channels[0]);
        } else if (channels.length === 0) {
          this.resetTikTokSettings();
        }
      },

      immediate: true
    }
  }
});

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction__ = __webpack_require__(1044);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var channelTypeConfig = {
  2: { icon: 'fa-twitter', color: '#1DA1F2' },
  3: { icon: 'fa-facebook', color: '#4767aa' }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialPostCalendar',
  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__["a" /* default */]
  },
  props: {
    channels: {
      type: Array,
      default: []
    },
    posts: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      calendarPlugins: [__WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timegrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__fullcalendar_interaction__["a" /* default */]]
    };
  },

  computed: {
    calendarEvents: function calendarEvents() {
      var _this = this;

      return this.posts.map(function (p) {
        return {
          id: p.id,
          title: p.message,
          start: new Date(p.post_date),
          icon: 'twitter',
          editable: !p.sent,
          selectable: !p.sent,
          durationEditable: false,
          backgroundColor: _this.calculateBackgroundColor(p.channels),
          borderColor: p.sent ? '#f29421' : _this.calculateBackgroundColor(p.channels),
          channelIds: p.channels
        };
      });
    }
  },

  methods: {
    channelIconsHtml: function channelIconsHtml(event) {
      var _this2 = this;

      var uniqueChannelIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(event.extendedProps.channelIds)));
      var iconHtmlNodes = uniqueChannelIds.map(function (id) {
        var config = _this2.configForChannel(id);
        return config ? '<i class="fa ' + config.icon + '"></i>&nbsp' : '';
      });
      return iconHtmlNodes.join('');
    },
    channelForId: function channelForId(channelId) {
      return this.channels.find(function (c) {
        return c.id === channelId;
      });
    },
    postForId: function postForId(postId) {
      return this.posts.find(function (p) {
        return p.id === postId;
      });
    },
    configForChannel: function configForChannel(channelId) {
      var channel = this.channelForId(channelId);

      if (!channel) {
        return null;
      }

      var config = channelTypeConfig[channel.channel_type];
      return config;
    },
    calculateBackgroundColor: function calculateBackgroundColor(channelIds) {
      var _this3 = this;

      var colors = channelIds.map(function (id) {
        var config = _this3.configForChannel(id);
        return config ? config.color : '#000000';
      });

      return colors[colors.length - 1];
    },
    handleEventRender: function handleEventRender(e) {
      var titleEl = e.el.querySelector('.fc-title');
      titleEl.innerHTML = this.channelIconsHtml(e.event) + ' ' + titleEl.innerHTML;
    },
    handleDateClick: function handleDateClick(e) {
      if (e.date < new Date()) {
        this.$notify({
          type: 'warning',
          showClose: true,
          duration: 2500,
          title: 'Date is in the past',
          message: 'Unable to create a new scheduled post in the past.'
        });
        return;
      }
      this.$emit('newPost', e.date);
    },
    handleEventClick: function handleEventClick(e) {
      var post = this.postForId(parseInt(e.event.id, 10));
      if (post.sent) {
        this.$notify({
          type: 'warning',
          showClose: true,
          duration: 2500,
          title: 'Already sent',
          message: 'Unable to edit a post that has already been sent.'
        });
        return;
      }
      this.$emit('editPost', post);
    },
    handleEventDrop: function handleEventDrop(e) {
      var _this4 = this;

      var post = this.postForId(parseInt(e.event.id, 10));

      var data = {
        id: post.id,
        channelIds: post.channels,
        media: post.media,
        message: post.message,
        scheduleTimestamp: e.event.start.getTime() / 1000
      };

      this.$store.dispatch('social/updateScheduledPost', data).then(function () {
        return _this4.$store.dispatch('social/getScheduledMessages');
      }).catch(function () {
        _this4.$alert('An error occurred');
      });
    }
  }
});

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_social_ScheduledPostList__ = __webpack_require__(3018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_social_ScheduledPostList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_social_ScheduledPostList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_social_SocialPostCalendar__ = __webpack_require__(3021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_social_SocialPostCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_social_SocialPostCalendar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialScheduleDashboard',
  components: {
    ScheduledPostList: __WEBPACK_IMPORTED_MODULE_3__components_social_ScheduledPostList___default.a,
    SocialPostCalendar: __WEBPACK_IMPORTED_MODULE_4__components_social_SocialPostCalendar___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('social', ['scheduledMessages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('channel', ['socialChannels'])),
  mounted: function mounted() {
    this.$store.dispatch('social/getScheduledMessages');
    this.$store.dispatch('channel/getChannels');
  },

  methods: {
    onAddNewPost: function onAddNewPost(date) {
      var post = null;
      if (date) {
        post = {
          channels: [],
          company: null,
          id: null,
          media: [],
          message: '',
          post_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DDTHH:mm:ss')
        };
      }
      this.$store.dispatch('modals/showSocialPostDialog', post);
    },
    onEditPost: function onEditPost(post) {
      this.$store.dispatch('modals/showSocialPostDialog', post);
    },
    onDeleteScheduledPost: function onDeleteScheduledPost(id) {
      var _this = this;

      this.$store.dispatch('social/deleteScheduledPost', id).then(function () {
        return _this.$store.dispatch('social/getScheduledMessages');
      });
    }
  }
});

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_charts_DoughnutChart__);
//
//
//
//
//
//
//



var capitalise = function capitalise(str) {
  return '' + str[0].toUpperCase() + str.slice(1).toLowerCase();
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemographicsItem',

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    }
  },

  computed: {
    chartData: function chartData() {
      var limit = 10;
      return this.data.length > limit ? this.data.slice(0, limit) : this.data;
    },
    chartLabel: function chartLabel() {
      // Pad start with fixed width characters to align as close as possible to the center
      return this.label ? capitalise(this.label).padStart(7, ' ') : '';
    }
  },

  components: {
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_0__components_charts_DoughnutChart___default.a
  }
});

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InsightsOverviewItem__ = __webpack_require__(3025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InsightsOverviewItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InsightsOverviewItem__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InsightsOverview',

  components: {
    InsightsOverviewItem: __WEBPACK_IMPORTED_MODULE_3__InsightsOverviewItem___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default.a,
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder___default.a
  },

  props: {
    overviewData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    facebookPages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedPage: {
      type: Number,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      period: 'week',
      metricRoutes: {
        page_views: 'pageViews',
        page_likes: 'pageViews',
        reach: 'pageViews',
        post_engagements: 'pageViews'
      }
    };
  },

  computed: {
    facebookPage: {
      get: function get() {
        return this.selectedPage;
      },
      set: function set(value) {
        this.$emit('onSelectedPageChange', value);
      }
    },
    hasData: function hasData() {
      return this.overviewData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.overviewData).length > 0;
    }
  },

  methods: {
    handleItemNavigate: function handleItemNavigate(key) {
      this.$router.push('social/facebook/' + this.metricRoutes[key]);
    }
  },

  watch: {
    period: function period(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('onFacebookPeriodChanged', newVal);
      }
    }
  }
});

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetrend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_IBox__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDifference = function getDifference(a, b) {
  return (a || 0) - (b || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InsightsOverviewItem',

  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_1_vuetrend__["a" /* default */],
    IBox: __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default.a
  },

  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    period: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      periodDays: {
        day: 1,
        week: 7,
        month: 28
      }
    };
  },

  computed: {
    hasValidData: function hasValidData() {
      return this.data && this.data.values && Array.isArray(this.data.values) && this.data.values.length > 0;
    },
    dataByPeriod: function dataByPeriod() {
      if (!this.hasValidData) {
        return {
          title: 'No Data',
          description: '',
          values: [],
          value: 0,
          difference: 0
        };
      }

      var endIdx = this.data.values.length;
      var days = this.periodDays[this.period];
      var curStartIdx = Math.max(0, endIdx - days);
      var preStartIdx = Math.max(0, endIdx - days * 2);

      var currentPeriodValues = this.data.values.slice(curStartIdx, endIdx);
      var currentPeriodValue = currentPeriodValues.reduce(function (a, x) {
        return a + (x.value || 0);
      }, 0);
      var previousPeriodValues = this.data.values.slice(preStartIdx, curStartIdx);
      var previousPeriodValue = previousPeriodValues.reduce(function (a, x) {
        return a + (x.value || 0);
      }, 0);

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.data, {
        values: currentPeriodValues,
        difference: getDifference(currentPeriodValue, previousPeriodValue),
        value: currentPeriodValue
      });
    }
  },

  methods: {
    isBetween: function isBetween(value, start, end) {
      return value >= start && value <= end;
    },
    handleTitleClick: function handleTitleClick() {
      // this.$emit('onNavigate');
    }
  },

  watch: {
    data: function data(newVal, oldVal) {
      if (newVal !== oldVal) this.$forceUpdate();
    }
  }
});

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DemographicsItem__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DemographicsItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DemographicsItem__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageDemographicsOverview',

  data: function data() {
    return {
      demographicsDescription: {
        fans: 'Aggregated lifetime demographic data about the people who like your Page based on the information they provide in their user profiles.',
        content: 'Aggregated demographic data about the number of people who saw any content by your Page or about your Page over the past 28 days',
        engagements: 'Aggregated demographic data about the number of people talking about your Page over the past 28 days'
      }
    };
  },

  props: {
    demographicData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    facebookPages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedPage: {
      type: Number,
      default: null
    },
    selectedDemographicType: {
      type: String,
      default: 'fans'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    facebookPage: {
      get: function get() {
        return this.selectedPage;
      },
      set: function set(value) {
        this.$emit('onSelectedPageChange', value);
      }
    },

    demographicType: {
      get: function get() {
        return this.selectedDemographicType;
      },
      set: function set(value) {
        this.$emit('onSelectedDemographicTypeChanged', value);
      }
    },

    hasData: function hasData() {
      return this.demographicData && !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.demographicData).reduce(function (ac, x) {
        return ac && x.length;
      }, true);
    }
  },

  components: {
    DemographicsItem: __WEBPACK_IMPORTED_MODULE_3__DemographicsItem___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default.a,
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_2__components_common_ContentPlaceholder___default.a
  }
});

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metrics_PageViewsItem__ = __webpack_require__(3031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metrics_PageViewsItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__metrics_PageViewsItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__randomDataUtils__ = __webpack_require__(1141);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var countryLabels = ['Canada', 'New Zealand', 'South Africa', 'USA'];
var cityLabels = ['Montreal, Canada', 'Auckland, NZ', 'Pretoria, RSA', 'Austin, Texas, USA'];
var deviceLabels = ['Mobile Device', 'Computer', 'Smart TV'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageViewsDashboard',

  components: {
    PageViewsItem: __WEBPACK_IMPORTED_MODULE_0__metrics_PageViewsItem___default.a
  },

  data: function data() {
    return {
      insightItems: [{
        name: 'gender',
        title: 'Page views by gender',
        description: 'The number of people logged in to Facebook who have viewed your Page profile, broken down by gender group.',
        stacked: true,
        showLegend: true,
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__randomDataUtils__["a" /* getPageViewsByGenderData */])()
      }, {
        name: 'city',
        title: 'Page views by city',
        description: 'The number of people logged in to Facebook who have viewed your Page profile, broken down by city.',
        type: 'horizontal-bar',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__randomDataUtils__["b" /* getDataForLabels */])(cityLabels, 1, 6)
      }, {
        name: 'country',
        title: 'Page views by country',
        description: 'The number of people logged in to Facebook who have viewed your Page profile, broken down by Country.',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__randomDataUtils__["b" /* getDataForLabels */])(countryLabels, 1, 6)
      }, {
        name: 'device',
        title: 'Page views by Device',
        description: 'The number of people logged in to Facebook who have viewed your Page profile, broken down by device type.',
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__randomDataUtils__["b" /* getDataForLabels */])(deviceLabels, 1, 15)
      }]
    };
  }
});

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostInsightItem',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a
  },
  props: {
    description: {
      type: String,
      required: true,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      required: true,
      default: ''
    }
  }
});

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PostInsightItem__ = __webpack_require__(3028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PostInsightItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PostInsightItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_social_facebook_PostReactions__ = __webpack_require__(3030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_social_facebook_PostReactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_social_facebook_PostReactions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostInsights',

  props: {
    postInsights: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    facebookPages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    pages: {
      type: Number,
      default: 0
    },
    selectedPage: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      searchTerm: ''
    };
  },
  computed: {
    getPostInsights: function getPostInsights() {
      if (!this.postInsights || !this.postInsights.length) return [];
      return this.postInsights;
    },

    facebookPage: {
      get: function get() {
        return this.selectedPage;
      },
      set: function set(value) {
        this.$emit('onSelectedPageChange', value);
      }
    }
  },
  methods: {
    onChangePage: function onChangePage(page) {
      this.$emit('changePage', page);
    },
    getInsightValue: function getInsightValue(insight, chain) {
      return chain.split('.').reduce(function (acc, val) {
        return acc ? acc[val] : undefined;
      }, insight);
    },
    onChangeSearch: function onChangeSearch() {
      this.$emit('onChangeSerachTerm', this.searchTerm);
    }
  },

  components: {
    PostReactions: __WEBPACK_IMPORTED_MODULE_3__components_social_facebook_PostReactions___default.a,
    PostInsightItem: __WEBPACK_IMPORTED_MODULE_2__components_social_facebook_PostInsightItem___default.a,
    Emoji: __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__["Emoji"],
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_common_Loader___default.a
  }
});

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: "off" */


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      size: 24,
      description: 'The number of reactions your post received by reaction type (like, love, wow, haha, sad, anger).',
      emojiSet: 'emojione',
      reactionsMap: {
        like: {
          emoji: { id: 'thumbsup' }
        },
        love: {
          emoji: { id: 'heart_eyes' }
        },
        wow: {
          emoji: { id: 'astonished' }
        },
        haha: {
          emoji: { id: 'joy' }
        },
        anger: {
          emoji: { id: 'rage' }
        }
      }
    };
  },

  props: {
    reaction: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    Emoji: __WEBPACK_IMPORTED_MODULE_0_emoji_mart_vue__["Emoji"]
  }
});

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FacebookPageViewsItem',

  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'bar'
    },
    description: {
      type: String,
      default: ''
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    stacked: {
      type: Boolean,
      default: false
    },
    chartData: {
      type: Array,
      required: true
    }
  },

  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_0__components_common_IBox___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart___default.a
  }
});

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InsightsOverviewItem__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InsightsOverviewItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InsightsOverviewItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InsightsOverview',

  props: {
    overviewData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    instagramPages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedPage: {
      type: Number,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      period: 'day',
      metricRoutes: {
        profile_views: 'profile_views',
        follower_count: 'follower_count',
        reach: 'reach',
        impressions: 'impressions'
      }
    };
  },

  computed: {
    instagramPage: {
      get: function get() {
        return this.selectedPage;
      },
      set: function set(value) {
        this.$emit('onSelectedPageChange', value);
      }
    },
    hasData: function hasData() {
      return Array.isArray(this.overviewData) && this.overviewData.length > 0;
    }
  },

  methods: {
    handleItemNavigate: function handleItemNavigate(key) {
      this.$router.push('social/instagram/' + this.metricRoutes[key]);
    }
  },

  watch: {
    period: function period(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('onInstagramPeriodChanged', newVal);
      }
    }
  },

  components: {
    InsightsOverviewItem: __WEBPACK_IMPORTED_MODULE_2__InsightsOverviewItem___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_0__components_common_Loader___default.a,
    ContentPlaceholder: __WEBPACK_IMPORTED_MODULE_1__components_common_ContentPlaceholder___default.a
  }
});

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetrend__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_IBox__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDifference = function getDifference(a, b) {
  return (a || 0) - (b || 0);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InsightsOverviewItem',

  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_1_vuetrend__["a" /* default */],
    IBox: __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default.a
  },

  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    period: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      periodDays: {
        day: 1,
        week: 7,
        month: 28
      }
    };
  },

  computed: {
    hasValidData: function hasValidData() {
      return this.data && this.data.values && Array.isArray(this.data.values) && this.data.values.length > 0;
    },
    dataByPeriod: function dataByPeriod() {
      if (!this.hasValidData) {
        return {
          title: 'No Data',
          description: '',
          values: [],
          value: 0,
          difference: 0
        };
      }

      var endIdx = this.data.values.length;
      var days = this.periodDays[this.period];
      var curStartIdx = Math.max(0, endIdx - days);
      var preStartIdx = Math.max(0, endIdx - days * 2);

      var currentPeriodValues = this.data.values.slice(curStartIdx, endIdx);
      var currentPeriodValue = currentPeriodValues.reduce(function (a, x) {
        return a + (x.value || 0);
      }, 0);
      var previousPeriodValues = this.data.values.slice(preStartIdx, curStartIdx);
      var previousPeriodValue = previousPeriodValues.reduce(function (a, x) {
        return a + (x.value || 0);
      }, 0);

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.data, {
        values: currentPeriodValues,
        difference: getDifference(currentPeriodValue, previousPeriodValue),
        value: currentPeriodValue
      });
    }
  },

  methods: {
    isBetween: function isBetween(value, start, end) {
      return value >= start && value <= end;
    },
    handleTitleClick: function handleTitleClick() {
      // this.$emit('onNavigate');
    }
  },

  watch: {
    data: function data(newVal, oldVal) {
      if (newVal !== oldVal) this.$forceUpdate();
    }
  }
});

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TikTokOptions',
  props: {
    settings: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    privacyOptions: function privacyOptions() {
      var map = {
        PUBLIC_TO_EVERYONE: { value: 'PUBLIC_TO_EVERYONE', label: 'Public' },
        FOLLOWER_OF_CREATOR: { value: 'FOLLOWER_OF_CREATOR', label: 'Followers' },
        MUTUAL_FOLLOW_FRIENDS: { value: 'MUTUAL_FOLLOW_FRIENDS', label: 'Friends' },
        SELF_ONLY: { value: 'SELF_ONLY', label: 'Private (Only me)' }
      };
      return (this.settings.privacy_level_options || []).map(function (opt) {
        return map[opt];
      }).filter(Boolean);
    }
  },
  methods: {
    formatDuration: function formatDuration(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      if (hours > 0) return hours + ' hour' + (hours > 1 ? 's' : '');
      return minutes + ' minute' + (minutes > 1 ? 's' : '');
    }
  }
});

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Paginator__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_surveybuilder_SurveyFilter__ = __webpack_require__(3037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_surveybuilder_SurveyFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_surveybuilder_SurveyFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_surveybuilder_SurveyListItem__ = __webpack_require__(3038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_surveybuilder_SurveyListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_surveybuilder_SurveyListItem__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyBuilderDashboard',
  components: {
    SurveyFilter: __WEBPACK_IMPORTED_MODULE_7__components_surveybuilder_SurveyFilter___default.a,
    SurveyListItem: __WEBPACK_IMPORTED_MODULE_8__components_surveybuilder_SurveyListItem___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default.a,
    FabSpeedDial: __WEBPACK_IMPORTED_MODULE_6__components_common_FabSpeedDial___default.a,
    Paginator: __WEBPACK_IMPORTED_MODULE_5__components_common_Paginator___default.a
  },
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      currentFilter: {
        title: null,
        state: 'ALL'
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('surveybuilder/listSurveys');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['surveyList', 'surveyListLoading', 'surveyListPage', 'surveyListTotalPages'])),
  methods: {
    calculateProgress: function calculateProgress(survey) {
      var currentTime = new Date().getTime();
      var endTime = new Date(survey.endDate).getTime();
      return parseInt(currentTime / endTime * 100, 10);
    },
    determineSurveyState: function determineSurveyState(survey) {
      if (survey.isPreview) {
        return 'IS_PREVIEW';
      } else if (!survey.isActive) {
        return 'IS_INACTIVE';
      }
      return 'IS_ACTIVE';
    },
    handleNextPage: function handleNextPage() {
      this.$store.dispatch('surveybuilder/listSurveysNextPage');
    },
    handlePreviousPage: function handlePreviousPage() {
      this.$store.dispatch('surveybuilder/listSurveysPrevPage');
    },
    handleGoToPage: function handleGoToPage(page) {
      this.$store.dispatch('surveybuilder/listSurveysGoToPage', page);
    },
    handleCreateSurvey: function handleCreateSurvey() {
      this.$router.push('surveyBuilder/editor');
    },
    handleEditSurvey: function handleEditSurvey(survey) {
      this.$router.push('surveybuilder/editor/' + survey.id);
    }
  }
});

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs_CanvasTab__ = __webpack_require__(3067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs_CanvasTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tabs_CanvasTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabs_SetupTab__ = __webpack_require__(3069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabs_SetupTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tabs_SetupTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabs_PreviewTab__ = __webpack_require__(3068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabs_PreviewTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tabs_PreviewTab__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyBuilderEditor',
  components: {
    CanvasTab: __WEBPACK_IMPORTED_MODULE_3__tabs_CanvasTab___default.a,
    SetupTab: __WEBPACK_IMPORTED_MODULE_4__tabs_SetupTab___default.a,
    PreviewTab: __WEBPACK_IMPORTED_MODULE_5__tabs_PreviewTab___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey']), {

    tabActive: {
      get: function get() {
        return this.$store.state.surveybuilder.tabActive;
      },
      set: function set(tab) {
        if (tab === 'preview') {
          this.$refs.previewTab.reloadPreview();
        }

        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__["_33" /* SET_TAB_ACTIVE */], tab);
      }
    }
  }),
  created: function created() {
    var surveyId = this.$route.params.id || null;

    this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__["_32" /* RESET_SURVEYBUILDER */]);

    if (surveyId) {
      this.$store.dispatch('surveybuilder/getSurvey', parseInt(surveyId, 10));
    }

    this.$store.dispatch('surveybuilder/getQuestionCategories');
    this.$store.dispatch('surveybuilder/getQuestionCategoriesWithQuestions');
    this.$store.dispatch('surveybuilder/getChoiceCategories');
    this.$store.dispatch('surveybuilder/getQuestions');
    this.$store.dispatch('surveybuilder/getChoiceTemplates');
    this.$store.dispatch('surveybuilder/getChoices');

    this.$store.dispatch('surveybuilder/getHooks');
    this.$store.dispatch('surveybuilder/getMatrixChoices');
  },

  methods: {
    handleBack: function handleBack() {
      this.$router.push({ path: '/surveyBuilder' });
    }
  }
});

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable space-before-function-paren, func-names, prefer-arrow-callback */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyFilter',
  data: function data() {
    return {
      surveyTitle: null,
      statusFilter: 'ALL'
    };
  },
  computed: {
    currentStatusFilter: {
      get: function get() {
        return this.statusFilter;
      },
      set: function set(status) {
        this.statusFilter = status;
        this.handleFilter();
      }
    },
    currentSurveyTitle: {
      get: function get() {
        return this.surveyTitle;
      },
      set: function set(title) {
        this.surveyTitle = title;
        this.handleFilter();
      }
    }
  },
  methods: {
    handleDebounceFilter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function () {
      this.handleFilter();
    }, 500),

    handleFilter: function handleFilter() {
      var filters = {
        state: this.statusFilter,
        title: this.surveyTitle
      };
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_34" /* SET_SURVEY_FILTER */], filters);
      this.$store.dispatch('surveybuilder/listSurveys', { filters: filters });
    }
  }
});

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jdenticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jdenticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_Trend__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_Trend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_Trend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Growth__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Growth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Growth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_ChannelToCampaignLinkItem__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_ChannelToCampaignLinkItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_campaign_ChannelToCampaignLinkItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyListItem',
  components: {
    Trend: __WEBPACK_IMPORTED_MODULE_2__components_charts_Trend___default.a,
    Growth: __WEBPACK_IMPORTED_MODULE_3__components_common_Growth___default.a,
    ChannelToCampaignLinkItem: __WEBPACK_IMPORTED_MODULE_4__components_campaign_ChannelToCampaignLinkItem___default.a
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    live: {
      type: Boolean,
      default: false
    },
    favorite: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    isSpotSurvey: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: Object,
      required: true
    },
    endDate: {
      type: Object,
      required: true
    },
    createdBy: {
      type: Object,
      default: function _default() {
        return { displayName: '' };
      }
    },
    progress: {
      type: Number,
      default: 0
    },
    totalEntries: {
      type: Number,
      default: 0
    },
    uniqueMessages: {
      type: Number,
      default: 0
    },
    totalThisMonth: {
      type: Number,
      default: 0
    },
    totalPerDayThisMonth: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    channelLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    replyMessage: {
      type: String,
      default: ''
    },
    growth: {
      type: Number,
      default: 0
    },
    isFavourite: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isAdminUser: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: 'IS_ACTIVE'
    }
  },
  computed: {
    adjustedProgress: function adjustedProgress() {
      return this.progress >= 100 ? 100 : this.progress;
    },
    canShowReportSurvey: function canShowReportSurvey() {
      return this.state !== 'IS_PREVIEW' && this.totalEntries > 0;
    }
  },
  methods: {
    identicon: function identicon(originator) {
      return __WEBPACK_IMPORTED_MODULE_0_jdenticon___default.a.toSvg(originator, 128);
    },
    handleUnlink: function handleUnlink(linkId) {
      this.$emit('onUnlink', linkId);
    },
    handleToggleFavourite: function handleToggleFavourite() {
      var surveyData = { id: this.id, favorite: !this.favorite };
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_37" /* SET_SURVEY_FAVORITE */], surveyData);
      this.$store.dispatch('surveybuilder/surveyUpdate', surveyData);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_38" /* SET_SURVEY_SORT_BY_FAVORITE */]);
    },
    handleCommand: function handleCommand(command) {
      var commands = {
        'edit-survey': this.handleSurveyEdit,
        'view-survey': this.handleSurveyView,
        'toggle-live-status': this.handleToggleSurveyStatus,
        'make-inactive': this.handleMakeInactive,
        'make-active': this.handleMakeActive,
        'delete-survey': this.handleDeleteSurvey,
        'survey-report': this.handleSurveyReport
      };
      return commands[command]();
    },
    handleSurveyEdit: function handleSurveyEdit() {
      this.$emit('onEditSurvey');
    },
    handleSurveyView: function handleSurveyView() {
      this.$emit('onViewSurvey');
    },
    handleToggleSurveyStatus: function handleToggleSurveyStatus() {
      this.$emit('onToggleLiveStatus', !this.live);
    },
    handleSurveyTitle: function handleSurveyTitle() {
      if (this.isAdminUser || this.totalEntries === 0 || !this.editable) {
        this.handleSurveyEdit();
      } else {
        this.$notify({
          title: 'Error!',
          message: 'You cannot edit this survey',
          type: 'error'
        });
      }
    },
    handleMakeInactive: function handleMakeInactive() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_36" /* SET_SURVEY_INACTIVE */], this.id);
      this.$store.dispatch('surveybuilder/surveyUpdate', { id: this.id, isActive: false });
    },
    handleMakeActive: function handleMakeActive() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_35" /* SET_SURVEY_ACTIVE */], this.id);
      this.$store.dispatch('surveybuilder/surveyUpdate', { id: this.id, isActive: true });
    },
    handleDeleteSurvey: function handleDeleteSurvey() {
      var surveyData = { id: this.id, deleted: true };
      this.$store.dispatch('surveybuilder/surveyUpdate', surveyData);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_surveybuilder_mutation_types__["_39" /* SET_SURVEY_DELETE */], { id: this.id });
      this.$forceUpdate();
    },
    handleSurveyReport: function handleSurveyReport() {
      var surveyData = { id: this.id };
      this.$store.dispatch('survey/surveyReport', surveyData.id);
    },
    handleDisplayName: function handleDisplayName(displayName) {
      return displayName ? [displayName.firstName, displayName.lastName].join(' ') : 'Colony System';
    }
  }
});

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var initialFormData = function initialFormData() {
  return {
    title: '',
    description: ''
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChoiceCategoryCreateDialog',
  data: function data() {
    return {
      categoryForm: initialFormData(),
      rules: {
        title: [{ required: true, message: 'Please enter title of the category', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }]
      }
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.choiceCategoryDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_0__store_modules_surveybuilder_mutation_types__["_78" /* SET_CHOICE_CATEGORY_DIALOG_VISIBILITY */], value);
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.categoryForm = initialFormData();
      this.$refs.categoryForm.resetFields();
    },
    handleCancel: function handleCancel() {
      this.isVisible = false;
      this.resetForm();
    },
    handleCreate: function handleCreate() {
      var _this = this;

      this.$refs.categoryForm.validate(function (valid) {
        if (valid) {
          _this.$store.dispatch('surveybuilder/choiceCategoryDialogCreate', {
            title: _this.categoryForm.title,
            description: _this.categoryForm.description
          }).then(function () {
            _this.$store.dispatch('surveybuilder/getChoiceCategories');
            _this.resetForm();
            _this.isVisible = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_el_input_tag__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChoiceTemplateSaveDialog',
  components: {
    HelpText: __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default.a,
    ElInputTag: __WEBPACK_IMPORTED_MODULE_2_el_input_tag__["a" /* ElInputTag */]
  },
  data: function data() {
    return {
      templateForm: {},
      rules: {
        title: [{ required: true, message: 'Please enter title of the question', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }]
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['choiceCategoryList', 'choiceTemplateDialogChoices', 'choiceTemplateDialogIsScale', 'choiceTemplateDialogForm']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me']), {
    choiceTemplate: function choiceTemplate() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.templateForm, { choices: this.choiceTemplateDialogChoices });
    },


    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.choiceTemplateDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_71" /* SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY */], value);
      }
    }
  }),
  mounted: function mounted() {
    this.initForm();
  },

  methods: {
    initForm: function initForm() {
      this.templateForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.choiceTemplateDialogForm);
    },
    choiceScaleClass: function choiceScaleClass(choice) {
      var polarity = choice.polarity || 0;
      if (polarity > 0) {
        return 'positive';
      } else if (polarity < 0) {
        return 'negative';
      }
      return 'neutral';
    },
    resetForm: function resetForm() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_75" /* RESET_CHOICE_TEMPLATE_DIALOG_FORM */]);
      this.$refs.templateForm.resetFields();
    },
    handleCancel: function handleCancel() {
      this.$store.dispatch('surveybuilder/choiceTemplateDialogCancel');
      this.resetForm();
    },
    handleSave: function handleSave() {
      var _this = this;

      this.$refs.templateForm.validate(function (valid) {
        if (valid) {
          if (_this.templateForm.id) {
            _this.handleEdit();
          } else {
            _this.handleCreate();
          }
        }
      });
    },
    handleEdit: function handleEdit() {
      var _this2 = this;

      this.$store.dispatch('surveybuilder/choiceTemplateDialogEdit', this.templateForm).then(function () {
        _this2.resetForm();
        _this2.isVisible = false;
      });
    },
    handleCreate: function handleCreate() {
      this.$store.dispatch('surveybuilder/choiceTemplateDialogCreate', this.choiceTemplate);
      this.resetForm();
    },
    handleAddCategory: function handleAddCategory() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_78" /* SET_CHOICE_CATEGORY_DIALOG_VISIBILITY */], true);
    }
  },
  watch: {
    choiceTemplateDialogForm: function choiceTemplateDialogForm() {
      this.initForm();
    }
  }
});

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_HelpText__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_HelpText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_HelpText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_surveybuilder_editors_music_HookMedia__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_surveybuilder_editors_music_HookMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_surveybuilder_editors_music_HookMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HookSaveDialog',
  components: {
    HelpText: __WEBPACK_IMPORTED_MODULE_2__components_common_HelpText___default.a,
    HookMedia: __WEBPACK_IMPORTED_MODULE_3__components_surveybuilder_editors_music_HookMedia___default.a
  },
  data: function data() {
    return {
      hookForm: {},
      hookMeta: null,
      rules: {
        title: [{ required: true, message: 'Please enter a song name', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }],
        artist: [{ required: true, message: 'Please enter an artist', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }]
      },

      fileData: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['hookDialogForm', 'hooksCreating', 'hooksSaving']), {
    title: function title() {
      return this.hookForm.id ? 'Edit hook' : 'Add new hook';
    },
    currentFile: function currentFile() {
      if (!this.hookForm || !this.hookForm.fileUrl) {
        return [];
      }

      var fileName = this.hookForm.fileUrl.substring(this.hookForm.fileUrl.lastIndexOf('/') + 1, this.hookForm.fileUrl.lastIndexOf('?'));
      return [{ name: fileName, url: this.hookForm.fileUrl }];
    },


    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.hookDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_63" /* SET_HOOK_DIALOG_VISIBILITY */], value);
      }
    }
  }),
  mounted: function mounted() {
    this.initForm();
  },

  methods: {
    initForm: function initForm() {
      this.hookForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.hookDialogForm.mediaClip);
      this.hookMeta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.hookForm);
    },
    resetForm: function resetForm() {
      this.initForm();
      this.$refs.hookForm.resetFields();
      this.hookMeta = null;
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_65" /* RESET_HOOK_DIALOG_FORM */]);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_63" /* SET_HOOK_DIALOG_VISIBILITY */], false);
      this.currentFile = [];
      this.$refs.upload.clearFiles();
    },
    handleCancel: function handleCancel() {
      this.resetForm();
    },
    handleSave: function handleSave() {
      var _this = this;

      this.$refs.hookForm.validate(function (valid) {
        if (valid) {
          if (_this.hookForm.id) {
            _this.handleEdit();
          } else {
            _this.handleCreate();
          }
        }
      });
    },
    handleEdit: function handleEdit() {
      var _this2 = this;

      this.$store.dispatch('surveybuilder/updateHook', { hook: this.hookForm }).then(function () {
        _this2.resetForm();
        _this2.isVisible = false;
      });
    },
    handleCreate: function handleCreate() {
      var _this3 = this;

      this.$store.dispatch('surveybuilder/createHook', {
        hook: this.hookForm
      }).then(function () {
        return _this3.resetForm();
      });
    },
    handleFileChange: function handleFileChange(file) {
      this.hookForm.fileData = file.raw;
    }
  },
  watch: {
    hookDialogForm: function hookDialogForm() {
      this.initForm();
    }
  }
});

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MatrixChoiceSaveDialog',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    HelpText: __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default.a
  },
  data: function data() {
    return {
      matrixForm: {},
      rules: {
        title: [{ required: true, message: 'Please enter a question', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }]
      },

      choiceInput: '',
      choices: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['matrixChoiceDialogForm', 'matrixChoicesCreating', 'matrixChoicesSaving']), {
    title: function title() {
      return this.matrixForm.id ? 'Edit music question' : 'Add new music question';
    },


    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.matrixChoiceDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_66" /* SET_MATRIX_CHOICE_DIALOG_VISIBILITY */], value);
      }
    }
  }),
  mounted: function mounted() {
    this.initForm();
  },

  methods: {
    initForm: function initForm() {
      this.matrixForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.matrixChoiceDialogForm);
      this.choices = this.matrixForm.title !== null ? this.matrixForm.choices : [];
    },
    resetForm: function resetForm() {
      this.initForm();
      this.$refs.matrixForm.resetFields();
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_68" /* RESET_MATRIX_CHOICE_DIALOG_FORM */]);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_66" /* SET_MATRIX_CHOICE_DIALOG_VISIBILITY */], false);
    },
    handleCancel: function handleCancel() {
      this.resetForm();
    },
    handleSave: function handleSave() {
      var _this = this;

      this.$refs.matrixForm.validate(function (valid) {
        if (valid) {
          if (_this.matrixForm.id) {
            _this.handleEdit();
          } else {
            _this.handleCreate();
          }
        }
      });
    },
    handleEdit: function handleEdit() {
      var _this2 = this;

      var theChoices = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.matrixForm, {
        choices: this.choices.map(function (d, i) {
          return {
            title: d.title,
            polarity: i,
            order: i
          };
        }) });
      this.$store.dispatch('surveybuilder/updateMatrixChoice', theChoices).then(function () {
        _this2.resetForm();
        _this2.isVisible = false;
      });
    },
    handleCreate: function handleCreate() {
      var _this3 = this;

      var matrixChoice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.matrixForm, {
        choices: this.choices.map(function (d, i) {
          return {
            title: d.title,
            polarity: i,
            order: i
          };
        }) });
      this.$store.dispatch('surveybuilder/createMatrixChoice', {
        matrixChoice: matrixChoice
      }).then(function () {
        return _this3.resetForm();
      });
    },
    handleAddChoice: function handleAddChoice() {
      this.choices.push({ title: this.choiceInput });
      this.choiceInput = '';
    },
    handleRemoveChoice: function handleRemoveChoice(index) {
      this.choices.splice(index, 1);
    }
  },
  watch: {
    matrixChoiceDialogForm: function matrixChoiceDialogForm() {
      this.initForm();
    }
  }
});

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConditionalLogicDialog',
  data: function data() {
    return {
      selectedChoice: null,
      selectedMatrixChoice: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('surveybuilder', ['matrixChoices']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['canvasQuestions', 'survey']), {

    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.matrixConditionalLogicDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__["_69" /* SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], value);
      }
    },

    availableMatrixChoices: function availableMatrixChoices() {
      var _this = this;

      return this.matrixChoices.filter(function (mc) {
        return mc.id !== _this.currentMatrixChoice.id;
      });
    },


    currentMatrixChoice: {
      get: function get() {
        return this.selectedMatrixChoice || this.$store.state.surveybuilder.matrixConditionalLogicDialogMatrixChoice;
      },
      set: function set(value) {
        this.selectedMatrixChoice = value;
      }
    }
  }),
  methods: {
    handleRemoveLinks: function handleRemoveLinks() {
      this.currentMatrixChoice.visibleIf = '';
    },
    handleCancel: function handleCancel() {
      this.isVisible = false;
    },
    handleSave: function handleSave() {
      var _this2 = this;

      var updatedMatrixChoices = this.matrixChoices.map(function (mc) {
        if (mc.id !== _this2.currentMatrixChoice.id) {
          return mc;
        }
        return _this2.currentMatrixChoice;
      });

      var updatedQuestions = this.canvasQuestions.map(function (q) {
        if (q.questionType !== 'MEDIA') {
          return q;
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, q, { matrixChoices: updatedMatrixChoices });
      });

      this.$store.dispatch('surveybuilder/updateQuestions', {
        questions: updatedQuestions,
        surveyId: this.survey.id
      }).then(function () {
        _this2.isVisible = false;
      });
    }
  }
});

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var initialFormData = function initialFormData() {
  return {
    title: '',
    description: ''
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionCategoryCreateDialog',
  data: function data() {
    return {
      categoryForm: initialFormData(),
      rules: {
        title: [{ required: true, message: 'Please enter title of the category', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }]
      }
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.questionCategoryDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_0__store_modules_surveybuilder_mutation_types__["_77" /* SET_QUESTION_CATEGORY_DIALOG_VISIBILITY */], value);
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.categoryForm = initialFormData();
      this.$refs.categoryForm.resetFields();
    },
    handleCancel: function handleCancel() {
      this.isVisible = false;
      this.resetForm();
    },
    handleCreate: function handleCreate() {
      var _this = this;

      this.$refs.categoryForm.validate(function (valid) {
        if (valid) {
          _this.$store.dispatch('surveybuilder/questionCategoryDialogCreate', {
            title: _this.categoryForm.title,
            description: _this.categoryForm.description
          }).then(function () {
            _this.$store.dispatch('surveybuilder/getQuestionCategories');
            _this.resetForm();
            _this.isVisible = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConditionalLogicDialog',
  data: function data() {
    return {
      selectedChoice: null,
      selectedQuestion: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['canvasQuestions', 'survey']), {

    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.questionConditionalLogicDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__["_61" /* SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], value);
      }
    },

    visibilityCondition: {
      get: function get() {
        return this.currentQuestion.visibilityCondition.split(' or ').filter(function (c) {
          return c !== '';
        });
      },
      set: function set(conditions) {
        this.currentQuestion.visibilityCondition = conditions.filter(function (c) {
          return c !== '';
        }).join(' or ');
      }
    },

    availableQuestions: function availableQuestions() {
      var _this = this;

      var questionTypes = ['SELECT', 'SCALE', 'MULTI_SELECT', 'RADIOGROUP'];
      return this.canvasQuestions.filter(function (q) {
        return q.id !== _this.currentQuestion.id && questionTypes.includes(q.questionType);
      });
    },


    currentQuestion: {
      get: function get() {
        return this.selectedQuestion || this.$store.state.surveybuilder.questionConditionalLogicDialogQuestion;
      },
      set: function set(value) {
        this.selectedQuestion = value;
      }
    }
  }),
  methods: {
    handleRemoveLinks: function handleRemoveLinks() {
      this.currentQuestion.visibilityCondition = '';
    },
    handleCancel: function handleCancel() {
      this.isVisible = false;
    },
    handleSave: function handleSave() {
      var _this2 = this;

      var updatedQuestions = this.canvasQuestions.map(function (q) {
        if (q.id !== _this2.currentQuestion.id) {
          return q;
        }
        return _this2.currentQuestion;
      });

      this.$store.dispatch('surveybuilder/updateQuestions', {
        questions: updatedQuestions,
        surveyId: this.survey.id
      }).then(function () {
        _this2.isVisible = false;
      });
    },
    getLabel: function getLabel(question, choice) {
      var questionType = question.questionType;
      var defaultCondition = '{question' + question.id + '}=\'' + choice.title + '\'';
      var multiSelectCondition = '{question' + question.id + '} contains \'' + choice.title + '\'';
      return questionType === 'MULTI_SELECT' ? multiSelectCondition : defaultCondition;
    }
  }
});

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionCreateDialog',
  components: {
    HelpText: __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default.a
  },
  data: function data() {
    return {
      questionForm: {},
      rules: {
        title: [{ required: true, message: 'Please enter title of the question', trigger: 'blur' }, { min: 3, message: 'Length should be a minimum of 3 characters', trigger: 'blur' }],
        questionType: [{ required: true, message: 'Please select the type of the question', trigger: 'blur' }]
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['survey', 'canvasQuestions', 'questionsCreating', 'questionCategoryList', 'questionTypeList', 'questionProfileFieldList', 'questionDialogAddToCanvas', 'questionDialogForm']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), {
    title: function title() {
      return this.questionForm.id ? 'Edit question' : 'Add new question';
    },


    isVisible: {
      get: function get() {
        return this.$store.state.surveybuilder.questionDialogVisible;
      },
      set: function set(value) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], value);
      }
    }
  }),
  mounted: function mounted() {
    this.initForm();
  },

  methods: {
    handleQuestionTypeChange: function handleQuestionTypeChange(value) {
      if (value === 'COMMENT') {
        this.questionForm.chart = 'WORDCLOUD';
      }
      if (value === 'SORTABLE') {
        this.questionForm.chart = 'VERTICAL_BAR_STACKED';
      }
    },
    initForm: function initForm() {
      this.questionForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.questionDialogForm);
    },
    resetForm: function resetForm() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_60" /* RESET_QUESTION_DIALOG_FORM */]);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], false);
      this.$refs.questionForm.resetFields();
    },
    createQuestion: function createQuestion() {
      var _this = this;

      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_59" /* SET_QUESTION_DIALOG_FORM */], this.questionForm);
      this.$store.dispatch('surveybuilder/questionDialogCreate', this.questionForm).then(function () {
        _this.resetForm();
        _this.isVisible = false;
      });
    },
    createQuestionAndAddToCanvas: function createQuestionAndAddToCanvas() {
      var _this2 = this;

      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_59" /* SET_QUESTION_DIALOG_FORM */], this.questionForm);
      this.$store.dispatch('surveybuilder/updateQuestions', {
        questions: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.canvasQuestions), [this.questionForm]),
        surveyId: this.survey.id
      }).then(function () {
        _this2.$store.dispatch('surveybuilder/getQuestions');
        _this2.resetForm();
        _this2.isVisible = false;
      });
    },
    handleCancel: function handleCancel() {
      this.resetForm();
      this.$store.dispatch('surveybuilder/questionDialogCancel');
    },
    handleSave: function handleSave() {
      var _this3 = this;

      this.$refs.questionForm.validate(function (valid) {
        if (valid) {
          if (_this3.questionForm.id) {
            _this3.handleEdit();
          } else {
            _this3.handleCreate();
          }
        }
      });
    },
    handleEdit: function handleEdit() {
      var _this4 = this;

      this.$store.dispatch('surveybuilder/questionDialogEdit', this.questionForm).then(function () {
        _this4.resetForm();
        _this4.isVisible = false;
      });
    },
    handleCreate: function handleCreate() {
      if (this.questionDialogAddToCanvas) {
        this.createQuestionAndAddToCanvas();
      } else {
        this.createQuestion();
      }
    },
    handleAddCategory: function handleAddCategory() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_77" /* SET_QUESTION_CATEGORY_DIALOG_VISIBILITY */], true);
    }
  },
  watch: {
    questionDialogForm: function questionDialogForm() {
      this.initForm();
    }
  }
});

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConditionalLinkSelect',
  props: {
    value: {
      type: Number
    },
    excludeQuestions: {
      value: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['canvasQuestions']), {
    selectedIndex: function selectedIndex() {
      var _this = this;

      if (!this.value) {
        return '';
      }

      var index = this.canvasQuestions.findIndex(function (q) {
        return q.id === _this.value;
      });
      return index >= 0 ? index + 2 : null;
    },


    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value.id);
      }
    }
  }),
  methods: {
    handleCommand: function handleCommand(question) {
      this.computedValue = question;
    }
  }
});

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QuestionEditor__ = __webpack_require__(3048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QuestionEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__QuestionEditor__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// These question types are only available when specific survey types are set.
var DISPLAYABLE_WITH_SURVEY_TYPE = {
  MEDIA: ['MUSIC']
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionCanvas',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,

    Empty: __WEBPACK_IMPORTED_MODULE_7__components_common_Empty___default.a,

    QuestionEditor: __WEBPACK_IMPORTED_MODULE_8__QuestionEditor___default.a
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('surveybuilder', ['survey', 'canvasSelectedQuestionId', 'canvasShowChoicesModifiedMessage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('surveybuilder', ['canvasParsedQuestions']), {

    questionList: {
      get: function get() {
        var _this = this;

        return this.canvasParsedQuestions.filter(function (q) {
          return _this.shouldDisplayQuestion(q);
        });
      },
      set: function set(questions) {
        this.$store.dispatch('surveybuilder/canvasSetQuestions', questions);
      }
    },

    isEmpty: function isEmpty() {
      return this.questionList.length === 0;
    },
    isSelected: function isSelected() {
      var _this2 = this;

      return function (index) {
        return index === _this2.selectedQuestionIndex;
      };
    },
    isOdd: function isOdd() {
      var _this3 = this;

      return function (index) {
        return index % 2 !== 0 && !_this3.isSelected(index);
      };
    }
  }),
  methods: {
    shouldDisplayQuestion: function shouldDisplayQuestion(question) {
      // Do we have this question type as displayable?
      // if not set we default to displayable for this survey type.
      var displayableIn = DISPLAYABLE_WITH_SURVEY_TYPE[question.questionType] || [this.survey.surveyType];
      return displayableIn.includes(this.survey.surveyType);
    },
    handleSetQuestion: function handleSetQuestion(index, question) {
      var questions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.questionList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, question));
      this.questionList = questions;

      var choices = question.choices || [];
      var isAddingNewChoice = choices.some(function (choice) {
        return isNaN(choice.id) && choice.title === '';
      });

      if (!isAddingNewChoice) {
        this.$store.dispatch('surveybuilder/updateCanvasQuestions');
      }
    },
    handleSelectQuestion: function handleSelectQuestion(questionId) {
      this.$store.dispatch('surveybuilder/canvasSelectQuestion', questionId);
    },
    handleRemoveQuestion: function handleRemoveQuestion(index) {
      var questions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.questionList));

      questions.splice(index, 1);
      if (this.selectedQuestionIndex >= questions.length) {
        var newIndex = questions.length - 1;
        var newId = questions[newIndex].id;
        this.handleSelectQuestion(newId);
      }
      this.questionList = questions;
      this.$store.dispatch('surveybuilder/updateQuestions', {
        questions: this.questionList,
        surveyId: this.survey.id
      });
    },
    handleCreateQuestion: function handleCreateQuestion() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_surveybuilder_mutation_types__["_58" /* SET_QUESTION_DIALOG_ADD_TO_CANVAS */], true);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_surveybuilder_mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], true);
    },
    handleEditQuestion: function handleEditQuestion(question) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_surveybuilder_mutation_types__["_59" /* SET_QUESTION_DIALOG_FORM */], question);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_6__store_modules_surveybuilder_mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], true);
    },
    handleChange: function handleChange(_ref) {
      var _this4 = this;

      var added = _ref.added,
          moved = _ref.moved;

      var value = added || moved;
      if (value) {
        this.$store.dispatch('surveybuilder/canvasSelectQuestion', value.id);
        this.$store.dispatch('surveybuilder/updateQuestions', {
          surveyId: this.survey.id,
          questions: this.canvasParsedQuestions
        }).then(function () {
          // We have the "Add new question" dashed block at the bottom which also counts as an
          // index, so chances are that if our new index is more than the amount of questions
          // we have, that the user dragged onto that section, lets adjust it here.
          var index = value.newIndex;
          if (index > _this4.canvasParsedQuestions.length - 1) {
            index -= 1;
          }

          _this4.$store.dispatch('surveybuilder/canvasSelectQuestion', _this4.canvasParsedQuestions[index].id);
        });
      }
    }
  }
});

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scale_ScaleEditor__ = __webpack_require__(3053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scale_ScaleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scale_ScaleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_SelectEditor__ = __webpack_require__(3057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__select_SelectEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__select_SelectEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__music_MusicEditor__ = __webpack_require__(3049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__music_MusicEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__music_MusicEditor__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionEditor',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,

    Empty: __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default.a,

    ScaleEditor: __WEBPACK_IMPORTED_MODULE_5__scale_ScaleEditor___default.a,
    SelectEditor: __WEBPACK_IMPORTED_MODULE_6__select_SelectEditor___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      choicesList: [],
      isCollapsed: true
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey', 'questionTypeList']), {
    editors: function editors() {
      return [{
        component: __WEBPACK_IMPORTED_MODULE_5__scale_ScaleEditor___default.a,
        condition: function condition(q) {
          return q.questionType === 'SCALE';
        }
      }, {
        component: __WEBPACK_IMPORTED_MODULE_6__select_SelectEditor___default.a,
        condition: function condition(q) {
          return ['SELECT', 'MULTI_SELECT', 'RADIOGROUP', 'SORTABLE'].includes(q.questionType);
        }
      }, {
        component: __WEBPACK_IMPORTED_MODULE_7__music_MusicEditor___default.a,
        condition: function condition(q) {
          return q.questionType === 'MEDIA';
        }
      }];
    },
    friendlyQuestionType: function friendlyQuestionType() {
      var _this = this;

      var questionType = this.questionTypeList.find(function (x) {
        return x.value === _this.value.questionType;
      });
      return questionType.title || 'Unknown';
    },
    isEditableQuestion: function isEditableQuestion() {
      var editable = ['SCALE', 'SELECT', 'MULTI_SELECT', 'RADIOGROUP', 'SORTABLE', 'MEDIA'];
      return editable.includes(this.value.questionType);
    },
    isOdd: function isOdd() {
      return !this.isSelected && this.index % 2 !== 0;
    },


    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(item) {
        this.$emit('input', item);
      }
    },
    computedChoices: {
      get: function get() {
        return this.choicesList;
      },
      set: function set(items) {
        this.$emit('input', items);
      }
    }
  }),
  methods: {
    isConditional: function isConditional(question) {
      return question.visibilityCondition && question.visibilityCondition.trim() !== '';
    },
    handleSetConditional: function handleSetConditional(question) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_62" /* SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION */], question);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_61" /* SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], true);
    },
    handleSelect: function handleSelect() {
      this.$emit('onSelect');
    },
    handleRemove: function handleRemove() {
      this.$emit('onRemove');
    },
    handleToggleCollapse: function handleToggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleEdit: function handleEdit() {
      this.$emit('onEdit');
    }
  }
});

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HookMedia',
  props: {
    hook: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      audio: null,
      isPlaying: false,
      audioDuration: null,
      audioCurrentTime: null
    };
  },
  mounted: function mounted() {
    this.audio = new Audio(this.hook.fileUrl);
    this.audio.addEventListener('play', this.handleOnPlay);
    this.audio.addEventListener('pause', this.handleOnStop);
    this.audio.addEventListener('loadedmetadata', this.handleOnLoadedMetadata);
    this.audio.addEventListener('timeupdate', this.handleOnTimeUpdate);
  },

  computed: {
    duration: function duration() {
      if (!this.audio || !this.audioDuration) {
        return '00:00';
      }

      return this.calculateDuration(this.audioDuration);
    },
    currentTime: function currentTime() {
      if (!this.audio || !this.audioCurrentTime) {
        return '00:00';
      }

      return this.calculateDuration(this.audioCurrentTime);
    }
  },
  methods: {
    calculateDuration: function calculateDuration(durationSecs) {
      var duration = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(durationSecs);
      var minutes = Math.floor(duration / 60);
      var seconds = duration % 60;

      var padded = function padded(num) {
        return num.toString().padStart(2, '0');
      };

      return padded(minutes) + ':' + padded(seconds);
    },
    handlePlay: function handlePlay() {
      this.audio.play();
    },
    handleStop: function handleStop() {
      this.audio.pause();
      this.audio.currentTime = 0;
    },
    handleOnPlay: function handleOnPlay() {
      this.isPlaying = true;
    },
    handleOnStop: function handleOnStop() {
      this.isPlaying = false;
    },
    handleOnLoadedMetadata: function handleOnLoadedMetadata() {
      this.audioDuration = this.audio.duration;
    },
    handleOnTimeUpdate: function handleOnTimeUpdate() {
      this.audioCurrentTime = this.audio.currentTime;
    }
  }
});

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MusicEditorCollapsed__ = __webpack_require__(3050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MusicEditorCollapsed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MusicEditorCollapsed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MusicEditorExpanded__ = __webpack_require__(3051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MusicEditorExpanded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MusicEditorExpanded__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicEditor',
  components: {
    MusicEditorCollapsed: __WEBPACK_IMPORTED_MODULE_0__MusicEditorCollapsed___default.a,
    MusicEditorExpanded: __WEBPACK_IMPORTED_MODULE_1__MusicEditorExpanded___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      default: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    }
  }
});

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HookMedia__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HookMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HookMedia__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicEditorExpanded',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    HookMedia: __WEBPACK_IMPORTED_MODULE_1__HookMedia___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    }
  }
});

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HookMedia__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HookMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HookMedia__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicEditorExpanded',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    HookMedia: __WEBPACK_IMPORTED_MODULE_4__HookMedia___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isRandomized: false,
      conditionalVisibile: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey']), {

    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },

    computedHooks: {
      get: function get() {
        return this.value.group;
      },
      set: function set(value) {
        this.computedValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.computedValue, { group: value });
      }
    },

    computedMatrixChoices: {
      get: function get() {
        return this.value.matrixChoices;
      },
      set: function set(value) {
        this.computedValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.computedValue, { matrixChoices: value });
      }
    },

    computedIsRandomized: {
      get: function get() {
        return this.isRandomized;
      },
      set: function set(value) {
        // Optimistic update
        this.isRandomized = value;

        this.$store.dispatch('surveybuilder/surveyUpdateConfig', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.survey.config, {
          randomize_media: value
        }));
      }
    }
  }),
  methods: {
    isConditional: function isConditional(matrixChoice) {
      return matrixChoice.visibleIf && matrixChoice.visibleIf.trim() !== '';
    },
    handleRemoveHook: function handleRemoveHook(hookId) {
      this.computedHooks = this.computedHooks.filter(function (h) {
        return h.id !== hookId;
      });
    },
    handleRemoveMatrixChoice: function handleRemoveMatrixChoice(matrixChoiceId) {
      this.computedMatrixChoices = this.computedMatrixChoices.filter(function (m) {
        return m.id !== matrixChoiceId;
      });
    },
    handleSetConditional: function handleSetConditional(matrixChoice) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_70" /* SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE */], matrixChoice);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_69" /* SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY */], true);
    },
    getColumn: function getColumn() {
      return this.computedHooks.length ? 4 : 12;
    }
  },
  watch: {
    survey: function survey() {
      this.isRandomized = this.survey.config.randomize_media || false;
    }
  }
});

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScaleChoiceItem',
  components: {
    ConditionalLinkSelect: __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect___default.a
  },
  props: {
    choice: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      editTitle: null,
      isEditing: false,
      isConditional: false,
      conditionalLink: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.editTitle = this.choice.title;
    this.isEditing = this.choice.title === '';

    if (this.choice.conditionalLink) {
      this.conditionalLink = this.choice.conditionalLink;
      this.isConditional = true;
    }

    this.$nextTick(function () {
      return _this.$refs.choiceInput.focus();
    });
  },

  computed: {
    computedConditionalLink: {
      get: function get() {
        return this.conditionalLink;
      },
      set: function set(value) {
        this.conditionalLink = value;
        this.handleUpdateChoice();
      }
    },

    choiceScaleClass: function choiceScaleClass() {
      var polarity = this.choice.polarity || 0;
      if (polarity > 0) {
        return 'positive';
      } else if (polarity < 0) {
        return 'negative';
      }
      return 'neutral';
    },
    polarityIndicator: function polarityIndicator() {
      var polarity = this.choice.polarity || 0;
      if (polarity > 0) {
        return '+'.repeat(polarity);
      } else if (polarity < 0) {
        return '-'.repeat(polarity * -1);
      }
      return '';
    }
  },
  methods: {
    handleEdit: function handleEdit() {
      this.isEditing = !this.isEditing;

      if (this.isEditing) {
        this.$refs.choiceInput.focus();
      } else {
        this.handleUpdateChoice();
      }
    },
    handleRemove: function handleRemove() {
      this.$emit('onRemove', this.choice);
    },
    handleUpdateChoice: function handleUpdateChoice() {
      if (this.editTitle === '') {
        this.handleRevertUpdate();
      } else {
        var choice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.choice, {
          title: this.editTitle,
          conditionalLink: this.conditionalLink
        });
        this.$emit('onUpdateChoice', choice);
        this.isEditing = false;
      }
    },
    handleRevertUpdate: function handleRevertUpdate() {
      this.editTitle = this.choice.title;
      this.isEditing = false;
    },
    handleInputBlur: function handleInputBlur() {
      if (isNaN(this.choice.id) && this.editTitle === '') {
        this.$emit('onEmpty');
      } else {
        this.handleUpdateChoice();
      }
    },
    handleToggleConditional: function handleToggleConditional() {
      this.conditionalLink = null;
      this.isConditional = !this.isConditional;

      // Did we remove the conditional?
      if (!this.isConditional) {
        this.handleUpdateChoice();
      }
    }
  }
});

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScaleEditorCollapsed__ = __webpack_require__(3054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScaleEditorCollapsed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ScaleEditorCollapsed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScaleEditorExpanded__ = __webpack_require__(3055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScaleEditorExpanded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ScaleEditorExpanded__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScaleEditor',
  components: {
    ScaleEditorCollapsed: __WEBPACK_IMPORTED_MODULE_1__ScaleEditorCollapsed___default.a,
    ScaleEditorExpanded: __WEBPACK_IMPORTED_MODULE_2__ScaleEditorExpanded___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      default: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedChoices: {
      get: function get() {
        return this.value.choices || [];
      },
      set: function set(choices) {
        this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value, { choices: choices }));
      }
    }
  },
  methods: {
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
    handleReverseOrder: function handleReverseOrder(isReversed) {
      this.$store.dispatch('surveybuilder/updateQuestion', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value, {
        isChoiceOrderReversed: isReversed
      }));
    },
    sortChoices: function sortChoices(choices) {
      return choices.sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }
});

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(189);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScaleEditorCollapsed',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,

    Empty: __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default.a
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    isReverseOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(values) {
        var choices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* parseChoices */])(values);
        var polarisedChoices = this.calculatePolarity(choices);
        var combinedChoices = this.combineChoices(polarisedChoices);

        this.$emit('input', combinedChoices);
      }
    },
    positiveChoices: function positiveChoices() {
      return this.value.filter(function (c) {
        return c.polarity > 0;
      });
    },
    neutralChoices: function neutralChoices() {
      return this.value.filter(function (c) {
        return c.polarity === 0;
      });
    },
    negativeChoices: function negativeChoices() {
      return this.value.filter(function (c) {
        return c.polarity < 0;
      });
    }
  },
  methods: {
    combineChoices: function combineChoices(values) {
      var pos = values.filter(function (c) {
        return c.polarity > 0;
      });
      var neu = values.filter(function (c) {
        return c.polarity === 0;
      });
      var neg = values.filter(function (c) {
        return c.polarity < 0;
      });

      var combined = this.isReverseOrder ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(pos), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(neu), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(neg)) : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(neg), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(neu), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(pos));
      var orderedChoices = combined.map(function (c, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { order: idx + 1 });
      });
      return orderedChoices;
    },
    choiceScaleClass: function choiceScaleClass(choice) {
      var polarity = choice.polarity || 0;
      if (polarity > 0) {
        return 'positive';
      } else if (polarity < 0) {
        return 'negative';
      }
      return 'neutral';
    },
    calculatePolarity: function calculatePolarity(choices) {
      var positive = this.calculatePositivePolarity(choices.filter(function (c) {
        return c.polarity > 0;
      }));
      var neutral = this.calculateNeutralPolarity(choices.filter(function (c) {
        return c.polarity === 0 || !('polarity' in c);
      }));
      var negative = this.calculateNegativePolarity(choices.filter(function (c) {
        return c.polarity < 0;
      }));

      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(negative), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(neutral), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(positive)).sort(function (a, b) {
        return a.polarity < b.polarity;
      });
    },
    calculatePositivePolarity: function calculatePositivePolarity(choices) {
      return choices.map(function (c, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { polarity: choices.length - idx });
      });
    },
    calculateNeutralPolarity: function calculateNeutralPolarity(choices) {
      return choices.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { polarity: 0 });
      });
    },
    calculateNegativePolarity: function calculateNegativePolarity(choices) {
      return choices.map(function (c, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, { polarity: (idx + 1) * -1 });
      });
    },
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    }
  }
});

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScaleChoiceItem__ = __webpack_require__(3052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScaleChoiceItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ScaleChoiceItem__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScaleEditorExpanded',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,

    Empty: __WEBPACK_IMPORTED_MODULE_4__components_common_Empty___default.a,

    ScaleChoiceItem: __WEBPACK_IMPORTED_MODULE_6__ScaleChoiceItem___default.a
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    question: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    isReverseOrder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isModified: false,
      calculatedChoices: { positive: [], negative: [], neutral: [] },
      hasSavedTemplate: false
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(values) {
        var choices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* parseChoices */])(values);
        this.$emit('input', choices);
      }
    },

    reverseOrder: {
      get: function get() {
        return this.isReverseOrder;
      },
      set: function set(value) {
        this.$emit('onReverseOrder', value);
      }
    },

    positiveChoices: {
      get: function get() {
        return this.value.filter(function (c) {
          return c.polarity > 0;
        });
      },
      set: function set(choices) {
        this.calculatedChoices.positive = choices.map(function (c, idx) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, {
            polarity: idx + 1
          });
        });

        this.debounceAssignCombinedChoices();
      }
    },

    neutralChoices: {
      get: function get() {
        return this.value.filter(function (c) {
          return c.polarity === 0 || !('polarity' in c);
        });
      },
      set: function set(choices) {
        this.calculatedChoices.neutral = choices.map(function (c) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, { polarity: 0 });
        });

        this.debounceAssignCombinedChoices();
      }
    },

    negativeChoices: {
      get: function get() {
        return this.value.filter(function (c) {
          return c.polarity < 0;
        });
      },
      set: function set(choices) {
        this.calculatedChoices.negative = choices.map(function (c, idx) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, {
            polarity: (choices.length - idx) * -1
          });
        });

        this.debounceAssignCombinedChoices();
      }
    },

    isValid: function isValid() {
      return this.computedValue.length > 0 && this.computedValue.every(function (c) {
        return c !== '';
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isModified && this.computedValue.length > 0 && !this.hasSavedTemplate) {
      this.$confirm('Do you want to save this group of choices to use again in future with other questions?', 'Save as choice template?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(this.handleSaveTemplate);
    }
  },

  methods: {
    combineChoices: function combineChoices() {
      var combined = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.calculatedChoices.positive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.calculatedChoices.neutral), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.calculatedChoices.negative));
      var orderedChoices = combined.map(function (c, idx) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, c, { order: idx + 1 });
      });
      return orderedChoices;
    },


    // eslint-disable-next-line
    debounceAssignCombinedChoices: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      this.computedValue = this.combineChoices();
    }, 1),

    recalculateChoicesFromValue: function recalculateChoicesFromValue() {
      this.calculatedChoices = {
        positive: this.positiveChoices,
        neutral: this.neutralChoices,
        negative: this.negativeChoices
      };
    },
    handleRemove: function handleRemove(choiceId) {
      var filteredChoices = this.combineChoices({}).filter(function (c) {
        return c.id !== choiceId;
      });
      this.$emit('input', filteredChoices);
    },
    handleClear: function handleClear() {
      this.$emit('input', []);
    },
    handleUpdateChoice: function handleUpdateChoice(choice) {
      this.isModified = true;
      this.computedValue = this.computedValue.map(function (c) {
        return c.id === choice.id ? choice : c;
      });
    },
    handleCreatePositiveChoice: function handleCreatePositiveChoice() {
      this.positiveChoices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.positiveChoices), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* emptyChoice */])()]);
    },
    handleCreateNeutralChoice: function handleCreateNeutralChoice() {
      this.neutralChoices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.neutralChoices), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* emptyChoice */])()]);
    },
    handleCreateNegativeChoice: function handleCreateNegativeChoice() {
      this.negativeChoices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.negativeChoices), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* emptyChoice */])()]);
    },
    handleSaveTemplate: function handleSaveTemplate() {
      this.hasSavedTemplate = true;
      this.$store.dispatch('surveybuilder/choiceTemplateShowCreateDialog', {
        choices: this.computedValue,
        isScale: true
      });
    }
  },
  watch: {
    value: {
      handler: 'recalculateChoicesFromValue',
      immediate: true
    }
  }
});

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectChoiceItem',
  components: {
    ConditionalLinkSelect: __WEBPACK_IMPORTED_MODULE_1__components_surveybuilder_editors_ConditionalLinkSelect___default.a
  },
  props: {
    choice: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isEditing: false,
      editTitle: null,
      conditionalLink: null
    };
  },
  mounted: function mounted() {
    this.editTitle = this.choice.title;
    this.isEditing = this.choice.title === '';
  },


  methods: {
    handleEdit: function handleEdit() {
      this.isEditing = !this.isEditing;

      if (this.isEditing) {
        this.$refs.choiceInput.focus();
      } else {
        this.handleUpdateChoice();
      }
    },
    handleRemove: function handleRemove() {
      this.$emit('onRemove', this.choice);
    },
    handleUpdateChoice: function handleUpdateChoice() {
      if (this.editTitle === '') {
        this.handleRevertUpdate();
      } else {
        this.$emit('onUpdateChoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.choice, {
          title: this.editTitle,
          conditionalLink: this.conditionalLink
        }));
        this.isEditing = false;
      }
    },
    handleRevertUpdate: function handleRevertUpdate() {
      this.editTitle = this.choice.title;
      this.isEditing = false;
    },
    handleInputBlur: function handleInputBlur() {
      if (isNaN(this.choice.id) && this.editTitle === '') {
        this.$emit('onEmpty');
      } else {
        this.handleUpdateChoice();
      }
    }
  }
});

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectEditorCollapsed__ = __webpack_require__(3058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectEditorCollapsed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SelectEditorCollapsed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectEditorExpanded__ = __webpack_require__(3059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectEditorExpanded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SelectEditorExpanded__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectEditor',
  components: {
    SelectEditorCollapsed: __WEBPACK_IMPORTED_MODULE_1__SelectEditorCollapsed___default.a,
    SelectEditorExpanded: __WEBPACK_IMPORTED_MODULE_2__SelectEditorExpanded___default.a
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      default: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedChoices: {
      get: function get() {
        return this.value.choices || [];
      },
      set: function set(choices) {
        this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value, { choices: choices }));
      }
    }
  },
  methods: {
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    }
  }
});

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(189);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectEditorCollapsed',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_1__components_common_Empty___default.a
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(values) {
        var choices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* parseChoices */])(values);
        this.$emit('input', choices);
      }
    }
  },
  methods: {
    handleToggleCollapse: function handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    }
  }
});

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectChoiceItem__ = __webpack_require__(3056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectChoiceItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SelectChoiceItem__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectEditorExpanded',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,

    Empty: __WEBPACK_IMPORTED_MODULE_2__components_common_Empty___default.a,

    SelectChoiceItem: __WEBPACK_IMPORTED_MODULE_4__SelectChoiceItem___default.a
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    question: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isModified: false,
      hasSavedTemplate: false
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(values) {
        var choices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* parseChoices */])(values);
        this.$emit('input', choices);
      }
    },

    isValid: function isValid() {
      return this.computedValue.length > 0 && this.computedValue.every(function (c) {
        return c !== '';
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isModified && this.computedValue.length > 0 && !this.hasSavedTemplate) {
      this.$confirm('Do you want to save this group of choices to use again in future with other questions?', 'Save as choice template?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(this.handleSaveTemplate);
    }
  },

  methods: {
    handleRemove: function handleRemove(choiceId) {
      var filteredChoices = this.value.filter(function (c) {
        return c.id !== choiceId;
      });
      this.$emit('input', filteredChoices);
    },
    handleClear: function handleClear() {
      this.$emit('input', []);
    },
    handleUpdateChoice: function handleUpdateChoice(choice) {
      this.isModified = true;
      this.computedValue = this.computedValue.map(function (c) {
        if (c.id === choice.id) {
          return choice;
        }
        return c;
      });
    },
    handleCreateChoice: function handleCreateChoice() {
      this.computedValue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.computedValue), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* emptyChoice */])()]);
    },
    handleSaveTemplate: function handleSaveTemplate() {
      this.hasSavedTemplate = true;
      this.$store.dispatch('surveybuilder/choiceTemplateShowCreateDialog', {
        choices: this.computedValue,
        isScale: false
      });
    }
  }
});

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Selector__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Selector__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DEBOUNCE_DELAY = 600;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChoiceSelector',
  components: {
    Selector: __WEBPACK_IMPORTED_MODULE_5__Selector___default.a
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])('surveybuilder', ['choiceList', 'choicesLoading', 'choiceCategoryList', 'selectorSelectedChoiceCategory', 'selectorChoiceSearchText']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('surveybuilder', ['canvasSelectedQuestion', 'selectorDisabledChoiceIds']), {
    sortedChoiceList: function sortedChoiceList() {
      // TODO: BACKEND
      var question = this.canvasSelectedQuestion;
      var choices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.choiceList));
      if (!question) {
        return choices.sort(function (a, b) {
          return a.title - b.title;
        });
      }

      var words = question.title.toLowerCase().split(' ');
      var hasKeywords = function hasKeywords(keywords) {
        return keywords.map(function (k) {
          return k.toLowerCase();
        }).some(function (k) {
          return words.includes(k);
        });
      };

      var sortedChoices = choices.sort(function (a, b) {
        var aScore = 0;
        var bScore = 0;

        // Times used
        var aUsed = (a.usedWith || {})[question.id] || 0;
        var bUsed = (b.usedWith || {})[question.id] || 0;
        aScore += aUsed > bUsed ? 5 : 0;
        bScore += bUsed > aUsed ? 5 : 0;

        // Keywords
        aScore += hasKeywords(a.keywords || []) ? 3 : 0;
        bScore += hasKeywords(b.keywords || []) ? 3 : 0;

        // Alphabetical
        aScore += a.title < b.title ? 1 : 0;
        bScore += b.title < a.title ? 1 : 0;

        return bScore - aScore;
      });
      return sortedChoices;
    }
  }),
  methods: {
    handleAddChoice: function handleAddChoice(choice) {
      this.$store.dispatch('surveybuilder/canvasAddChoice', choice);
    },
    handleSelectCategory: function handleSelectCategory(categoryId) {
      this.$store.dispatch('surveybuilder/selectorSelectChoiceCategory', categoryId);
      this.$store.dispatch('surveybuilder/getChoices');
    },
    handleSearchText: function handleSearchText(text) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_49" /* SET_SELECTOR_CHOICE_TEXT */], text);
      this.handleDebounceGetChoices(text);
    },
    handleResetFilters: function handleResetFilters() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_surveybuilder_mutation_types__["_54" /* RESET_SELECTOR_CHOICE_FILTERS */]);
      this.$store.dispatch('surveybuilder/getChoices');
    },


    // eslint-disable-next-line
    handleDebounceGetChoices: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (text) {
      this.$store.dispatch('surveybuilder/getChoices');
    }, DEBOUNCE_DELAY),

    handleLoadMore: function handleLoadMore() {
      // Make sure we have actual choices before we can try load more.
      if (this.choiceList.length && !this.choicesLoading) {
        this.$store.dispatch('surveybuilder/getMoreChoices');
      }
    }
  }
});

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var DEBOUNCE_DELAY = 600;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChoiceTemplateSelector',
  components: {
    Selector: __WEBPACK_IMPORTED_MODULE_4__Selector___default.a
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedId: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['choiceTemplateList', 'choiceTemplatesLoading', 'choiceTemplatesPage', 'choiceCategoryList', 'selectorSelectedTemplateId', 'selectorSelectedTemplateCategory', 'selectorTemplateSearchText']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('surveybuilder', ['canvasSelectedQuestion', 'selectorDisabledTemplateIds']), {
    choiceTemplates: function choiceTemplates() {
      var _this = this;

      return this.choiceTemplateList.map(function (template) {
        if (template.isGlobal) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, template, {
            isEditable: _this.me.is_staff
          });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, template, { isEditable: true });
      });
    }
  }),
  methods: {
    handleAddTemplate: function handleAddTemplate(template) {
      var choices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* expandChoiceTemplate */])(template);
      this.$store.dispatch('surveybuilder/canvasAddChoices', choices);
    },
    handleEditTemplate: function handleEditTemplate(template) {
      this.$store.dispatch('surveybuilder/choiceTemplateShowEditDialog', {
        template: template,
        choices: template.choices
      });
    },
    handleSelectTemplate: function handleSelectTemplate(template) {
      this.$store.dispatch('surveybuilder/selectorSelectTemplateId', template.id);
    },
    handleSelectCategory: function handleSelectCategory(categoryId) {
      var _this2 = this;

      this.$store.dispatch('surveybuilder/selectorSelectTemplateCategory', categoryId).then(function () {
        _this2.$store.dispatch('surveybuilder/getChoiceTemplates');
      });
    },
    handleSearchText: function handleSearchText(text) {
      this.$store.dispatch('surveybuilder/selectorSetTemplateSearchText', text);
      this.handleDebounceGetTemplates();
    },
    handleResetFilters: function handleResetFilters() {
      this.$store.dispatch('surveybuilder/selectorResetTemplateFilters');
      this.$store.dispatch('surveybuilder/getChoiceTemplates');
    },


    // eslint-disable-next-line
    handleDebounceGetTemplates: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      this.$store.dispatch('surveybuilder/getChoiceTemplates');
    }, DEBOUNCE_DELAY),

    handleLoadMore: function handleLoadMore() {
      if (this.choiceTemplateList.length && !this.choiceTemplatesLoading) {
        this.$store.dispatch('surveybuilder/getMoreChoiceTemplates');
      }
    }
  }
});

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_surveybuilder_editors_music_HookMedia__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_surveybuilder_editors_music_HookMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_surveybuilder_editors_music_HookMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var DEBOUNCE_DELAY = 600;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HookSelector',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_5__components_common_Empty___default.a,
    HookMedia: __WEBPACK_IMPORTED_MODULE_6__components_surveybuilder_editors_music_HookMedia___default.a
  },
  directives: { infiniteScroll: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_scroll___default.a },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      disabledIds: []
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('surveybuilder', ['hookQuestions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['hooksLoading', 'hooksPage', 'selectorHookSearchText']), {

    searchText: {
      get: function get() {
        return this.selectorHookSearchText;
      },
      set: function set(text) {
        this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__["_50" /* SET_SELECTOR_HOOK_TEXT */], text);
        this.handleDebounceGetHooks();
      }
    }
  }),
  methods: {
    isDisabled: function isDisabled(itemId) {
      return this.disabledIds.includes(itemId);
    },
    itemStyle: function itemStyle(itemId) {
      var style = { padding: '8px' };
      if (this.isDisabled(itemId)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, { color: '#ccc', backgroundColor: '#eee', fontStyle: 'oblique' });
      }

      return style;
    },
    handleCreate: function handleCreate() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__["_63" /* SET_HOOK_DIALOG_VISIBILITY */], true);
    },
    handleEditItem: function handleEditItem(item) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__["_64" /* SET_HOOK_DIALOG_FORM */], item);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__["_63" /* SET_HOOK_DIALOG_VISIBILITY */], true);
    },
    handleResetFilters: function handleResetFilters() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_surveybuilder_mutation_types__["_55" /* RESET_SELECTOR_HOOK_FILTERS */]);
      this.$store.dispatch('surveybuilder/getHooks');
    },


    // eslint-disable-next-line
    handleDebounceGetHooks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      this.$store.dispatch('surveybuilder/getHooks');
    }, DEBOUNCE_DELAY),

    handleLoadMore: function handleLoadMore() {
      if (this.hookQuestions.length && !this.hooksLoading) {
        this.$store.dispatch('surveybuilder/getMoreHooks');
      }
    }
  }
});

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DEBOUNCE_DELAY = 600;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicQuestionSelector',
  components: {
    Selector: __WEBPACK_IMPORTED_MODULE_4__Selector___default.a
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['matrixChoiceList', 'matrixChoicesLoading', 'matrixChoicesPage', 'selectorMatrixChoiceSearchText']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), {
    musicQuestions: function musicQuestions() {
      return this.matrixChoiceList.map(function (matrixChoice) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matrixChoice, { isEditable: true });
      });
    }
  }),
  methods: {
    handleEditItem: function handleEditItem(item) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_67" /* SET_MATRIX_CHOICE_DIALOG_FORM */], item);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_66" /* SET_MATRIX_CHOICE_DIALOG_VISIBILITY */], true);
    },
    handleCreate: function handleCreate() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_66" /* SET_MATRIX_CHOICE_DIALOG_VISIBILITY */], true);
    },
    handleSearchText: function handleSearchText(text) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_51" /* SET_SELECTOR_MATRIX_CHOICE_TEXT */], text);
      this.handleDebounceGet();
    },
    handleResetFilters: function handleResetFilters() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_56" /* RESET_SELECTOR_MATRIX_CHOICE_FILTERS */]);
      this.$store.dispatch('surveybuilder/getMatrixChoices');
    },


    // eslint-disable-next-line
    handleDebounceGet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      this.$store.dispatch('surveybuilder/getMatrixChoices');
    }, DEBOUNCE_DELAY),

    handleLoadMore: function handleLoadMore() {
      if (this.matrixChoiceList.length && !this.matrixChoicesLoading) {
        this.$store.dispatch('surveybuilder/getMoreMatrixChoices');
      }
    }
  }
});

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_HookSelector__ = __webpack_require__(3062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_HookSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__selectors_HookSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_MusicQuestionSelector__ = __webpack_require__(3063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_MusicQuestionSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__selectors_MusicQuestionSelector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QualitativeSelectorTab',
  components: {
    HookSelector: __WEBPACK_IMPORTED_MODULE_2__selectors_HookSelector___default.a,
    MusicQuestionSelector: __WEBPACK_IMPORTED_MODULE_3__selectors_MusicQuestionSelector___default.a
  },
  data: function data() {
    return {
      selectorActive: 'hooks'
    };
  },
  props: {
    selectorFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey']))
});

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_ChoiceSelector__ = __webpack_require__(3060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_ChoiceSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__selectors_ChoiceSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_QuestionSelector__ = __webpack_require__(3066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_QuestionSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__selectors_QuestionSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_ChoiceTemplateSelector__ = __webpack_require__(3061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_ChoiceTemplateSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__selectors_ChoiceTemplateSelector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QualitativeSelectorTab',
  components: {
    ChoiceSelector: __WEBPACK_IMPORTED_MODULE_2__selectors_ChoiceSelector___default.a,
    ChoiceTemplateSelector: __WEBPACK_IMPORTED_MODULE_4__selectors_ChoiceTemplateSelector___default.a,
    QuestionSelector: __WEBPACK_IMPORTED_MODULE_3__selectors_QuestionSelector___default.a
  },
  props: {
    selectorFixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectorActive: 'questions'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey']))
});

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Selector__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DEBOUNCE_DELAY = 600;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionSelector',
  components: {
    Selector: __WEBPACK_IMPORTED_MODULE_4__Selector___default.a
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('surveybuilder', ['questionList', 'questionsLoading', 'questionsPage', 'questionCategoryWithQuestionsList', 'selectorSelectedQuestionCategory', 'selectorQuestionSearchText']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('surveybuilder', ['selectorDisabledQuestionIds']), {
    questions: function questions() {
      var _this = this;

      return this.questionList.map(function (question) {
        if (question.isGlobal) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, question, {
            isEditable: _this.me.is_staff
          });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, question, { isEditable: true });
      }).filter(function (question) {
        // Remove global questions that already have an exact version in company scope
        if (question.isGlobal) {
          var matchFields = ['title', 'questionType', 'categoryId'];
          var exactQuestions = _this.questionList.filter(function (q) {
            return !q.isGlobal && matchFields.every(function (field) {
              return q[field] === question[field];
            });
          });
          return exactQuestions.length === 0;
        }
        return true;
      });
    }
  }),
  methods: {
    handleAddQuestion: function handleAddQuestion(question) {
      this.$store.dispatch('surveybuilder/canvasAddQuestion', question);
    },
    handleEditQuestion: function handleEditQuestion(question) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_59" /* SET_QUESTION_DIALOG_FORM */], question);
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], true);
    },
    handleSelectCategory: function handleSelectCategory(categoryId) {
      this.$store.dispatch('surveybuilder/selectorSelectQuestionCategory', categoryId);
      this.$store.dispatch('surveybuilder/getQuestions');
    },
    handleCreateQuestion: function handleCreateQuestion() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_57" /* SET_QUESTION_DIALOG_VISIBILITY */], true);
    },
    handleSearchText: function handleSearchText(text) {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_47" /* SET_SELECTOR_QUESTION_TEXT */], text);
      this.handleDebounceGetQuestions();
    },
    handleResetFilters: function handleResetFilters() {
      this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_surveybuilder_mutation_types__["_52" /* RESET_SELECTOR_QUESTION_FILTERS */]);
      this.$store.dispatch('surveybuilder/getQuestions');
    },


    // eslint-disable-next-line
    handleDebounceGetQuestions: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      this.$store.dispatch('surveybuilder/getQuestions');
    }, DEBOUNCE_DELAY),

    handleLoadMore: function handleLoadMore() {
      if (this.questionList.length && !this.questionsLoading) {
        this.$store.dispatch('surveybuilder/getMoreQuestions');
      }
    }
  }
});

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuestionSelector',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default.a
  },
  directives: { infiniteScroll: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default.a },
  props: {
    itemName: {
      type: String,
      required: true
    },
    itemNamePlural: {
      type: String,
      required: true
    },
    draggableGroup: {
      type: String,
      default: 'defaultGroup'
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categoryList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    pool: {
      type: String,
      default: 'ALL'
    },
    showCategoryFilter: {
      type: Boolean,
      default: true
    },
    showTextFilter: {
      type: Boolean,
      default: true
    },
    selectedId: null,
    selectedCategoryId: null,
    searchText: ''
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    computedCategory: {
      get: function get() {
        return this.selectedCategoryId;
      },
      set: function set(categoryId) {
        this.$emit('onChangeCategory', categoryId);
      }
    },
    computedSearchText: {
      get: function get() {
        return this.searchText;
      },
      set: function set(text) {
        this.$emit('onChangeSearchText', text);
      }
    },
    computedPool: {
      get: function get() {
        return this.pool;
      },
      set: function set(pool) {
        this.$emit('onChangePool', pool);
      }
    },
    draggableId: function draggableId() {
      return 'draggable-' + this.itemName.replace(' ', '-');
    }
  },
  methods: {
    isDisabled: function isDisabled(itemId) {
      return this.disabledIds.includes(itemId);
    },
    itemStyle: function itemStyle(itemId) {
      var style = { padding: '8px' };
      if (this.isDisabled(itemId)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, { color: '#ccc', backgroundColor: '#eee', fontStyle: 'oblique' });
      }

      return style;
    },
    handleAddItem: function handleAddItem(item) {
      if (this.isDisabled(item.id) || !this.isEditable) {
        return;
      }

      this.$emit('onItemAdd', item);
    },
    handleEditItem: function handleEditItem(item) {
      this.$emit('onItemEdit', item);
    },
    handleSelect: function handleSelect(item) {
      this.$emit('onSelect', item);
    },
    handleCreate: function handleCreate() {
      this.$emit('onCreate');
    },
    handleResetFilters: function handleResetFilters() {
      this.$emit('onResetFilters');
    },
    handleLoadMore: function handleLoadMore() {
      this.$emit('onLoadMore');
    }
  }
});

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialogs_ChoiceCategoryCreateDialog__ = __webpack_require__(3039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialogs_ChoiceCategoryCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dialogs_ChoiceCategoryCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialogs_ChoiceTemplateSaveDialog__ = __webpack_require__(3040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialogs_ChoiceTemplateSaveDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dialogs_ChoiceTemplateSaveDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialogs_HookSaveDialog__ = __webpack_require__(3041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialogs_HookSaveDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dialogs_HookSaveDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialogs_MatrixChoiceSaveDialog__ = __webpack_require__(3042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialogs_MatrixChoiceSaveDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dialogs_MatrixChoiceSaveDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialogs_MatrixConditionalLogicDialog__ = __webpack_require__(3043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialogs_MatrixConditionalLogicDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__dialogs_MatrixConditionalLogicDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_MusicSelectorTab__ = __webpack_require__(3064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_MusicSelectorTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__selectors_MusicSelectorTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_QualitativeSelectorTab__ = __webpack_require__(3065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors_QualitativeSelectorTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__selectors_QualitativeSelectorTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editors_QuestionCanvas__ = __webpack_require__(3047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editors_QuestionCanvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__editors_QuestionCanvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs_QuestionCategoryCreateDialog__ = __webpack_require__(3044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs_QuestionCategoryCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dialogs_QuestionCategoryCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialogs_QuestionConditionalLogicDialog__ = __webpack_require__(3045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialogs_QuestionConditionalLogicDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__dialogs_QuestionConditionalLogicDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dialogs_QuestionSaveDialog__ = __webpack_require__(3046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dialogs_QuestionSaveDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__dialogs_QuestionSaveDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// At what height should we fix the selector
var SELECTOR_STICK = 200;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CanvasTab',
  components: {
    ChoiceCategoryCreateDialog: __WEBPACK_IMPORTED_MODULE_2__dialogs_ChoiceCategoryCreateDialog___default.a,
    ChoiceTemplateSaveDialog: __WEBPACK_IMPORTED_MODULE_3__dialogs_ChoiceTemplateSaveDialog___default.a,
    HookSaveDialog: __WEBPACK_IMPORTED_MODULE_4__dialogs_HookSaveDialog___default.a,
    MatrixChoiceSaveDialog: __WEBPACK_IMPORTED_MODULE_5__dialogs_MatrixChoiceSaveDialog___default.a,
    MatrixConditionalLogicDialog: __WEBPACK_IMPORTED_MODULE_6__dialogs_MatrixConditionalLogicDialog___default.a,
    MusicSelectorTab: __WEBPACK_IMPORTED_MODULE_7__selectors_MusicSelectorTab___default.a,
    QualitativeSelectorTab: __WEBPACK_IMPORTED_MODULE_8__selectors_QualitativeSelectorTab___default.a,
    QuestionCanvas: __WEBPACK_IMPORTED_MODULE_9__editors_QuestionCanvas___default.a,
    QuestionCategoryCreateDialog: __WEBPACK_IMPORTED_MODULE_10__dialogs_QuestionCategoryCreateDialog___default.a,
    QuestionConditionalLogicDialog: __WEBPACK_IMPORTED_MODULE_11__dialogs_QuestionConditionalLogicDialog___default.a,
    QuestionSaveDialog: __WEBPACK_IMPORTED_MODULE_12__dialogs_QuestionSaveDialog___default.a
  },
  data: function data() {
    return {
      selectorFixed: false,
      selectorFixedWidth: 0,
      selectorHeightModifier: 0,
      currentTab: 'qualitative'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey']), {
    selectorStyle: function selectorStyle() {
      if (this.selectorFixed && this.$refs.selectorWrapper) {
        var width = this.$refs.selectorWrapper.clientWidth + 20;
        return { width: width + 'px' };
      }
      return {
        'min-height': 'calc(100vh - ' + (210 - this.selectorHeightModifier) + 'px'
      };
    }
  }),
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      this.selectorFixed = window.scrollY >= SELECTOR_STICK;
      this.selectorHeightModifier = window.scrollY;
    }
  }
});

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateBoardPreviewSurveyForm',
  data: function data() {
    return {
      previewSize: '412'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey', 'surveySaving', 'surveySaveSuccess']), {
    previewUrl: function previewUrl() {
      return "https://apiv2.live.colonyhq.com" + '/surveys/preview/' + this.survey.id;
    },
    publishedUrl: function publishedUrl() {
      return this.survey.url;
    }
  }),
  methods: {
    reloadPreview: function reloadPreview() {
      // Touch the src of the iframe to reload it
      this.$refs.previewFrame.src += '';
    },
    publishedTitle: function publishedTitle() {
      return !this.survey.isPreview ? 'Published' : 'Publish';
    },
    handlePublish: function handlePublish() {
      var publishSurvey = { id: this.survey.id, isPreview: false, isActive: true };
      this.$store.dispatch('surveybuilder/surveyUpdate', publishSurvey);
    }
  }
});

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_HelpText__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetupTab',
  components: {
    HelpText: __WEBPACK_IMPORTED_MODULE_3__components_common_HelpText___default.a
  },
  data: function data() {
    return {
      // FORM
      successMethod: 'text',
      surveyForm: {
        title: '',
        description: '',
        dateRange: [],
        startDate: null,
        endDate: null,
        successText: '',
        successRedirect: '',
        successAutoRedirect: false,
        privacyPolicy: '',
        collectNonVoluntaryIdentifiers: true,
        showProgressBar: false,
        logoUrl: '',
        surveyType: 'QUALITATIVE'
      },
      progressBarOnValue: 1,
      progressBarOfValue: 0,
      rules: {
        title: [{ required: true, message: 'Please provide a title for this survey', trigger: 'blur' }],
        dateRange: [{
          required: true,
          message: 'Please provide the start and end date for this survey',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('surveybuilder', ['survey', 'surveySaving'])),
  methods: {
    initFormData: function initFormData() {
      this.surveyForm = {
        title: this.survey.title,
        description: this.survey.description,
        dateRange: [this.survey.startDate, this.survey.endDate],
        startDate: this.survey.startDate,
        endDate: this.survey.endDate,
        successText: this.survey.successText,
        successRedirect: this.survey.successRedirect,
        successAutoRedirect: this.survey.successAutoRedirect,
        privacyPolicy: this.survey.privacyPolicy,
        collectNonVoluntaryIdentifiers: this.survey.collectNonVoluntaryIdentifiers,
        logoUrl: this.survey.logoUrl,
        surveyType: this.survey.surveyType,
        showProgressBar: this.survey.pageSize === this.progressBarOnValue
      };
    },
    handleCancel: function handleCancel() {
      this.$router.push({ path: '/surveyBuilder' });
    },
    handleSaveSurvey: function handleSaveSurvey() {
      var _this = this;

      this.$refs.surveyForm.validate(function (valid) {
        if (valid) {
          var surveyData = {
            title: _this.surveyForm.title,
            description: _this.surveyForm.description,
            startDate: _this.surveyForm.dateRange[0],
            endDate: _this.surveyForm.dateRange[1],
            successText: _this.surveyForm.successText,
            successRedirect: _this.surveyForm.successRedirect,
            successAutoRedirect: _this.surveyForm.successAutoRedirect,
            privacyPolicy: _this.surveyForm.privacyPolicy,
            collectNonVoluntaryIdentifiers: _this.surveyForm.collectNonVoluntaryIdentifiers,
            surveyType: _this.surveyForm.surveyType,
            pageSize: _this.get_survey_page(),
            isPreview: true,
            isActive: false,
            createdById: _this.me.id
          };

          // Determine if we should create or update
          if (_this.survey && _this.survey.id) {
            surveyData.isPreview = _this.survey.isPreview;
            surveyData.isActive = _this.survey.isActive;
            _this.$store.dispatch('surveybuilder/surveyUpdate', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              id: _this.survey.id
            }, surveyData)).then(function () {
              _this.$notify({
                title: 'Survey Updated',
                message: _this.survey.title + ' updated successfully.',
                type: 'success'
              });
            });
          } else {
            _this.$store.dispatch('surveybuilder/surveyCreate', surveyData).then(function () {
              _this.$router.push({ path: '/surveybuilder/editor/' + _this.survey.id });

              _this.$notify({
                title: 'Survey Created',
                message: _this.survey.title + ' created successfully',
                type: 'success'
              });
            });
          }

          _this.$store.commit('surveybuilder/' + __WEBPACK_IMPORTED_MODULE_2__store_modules_surveybuilder_mutation_types__["_33" /* SET_TAB_ACTIVE */], 'canvas');
        }
      });
    },
    get_survey_page: function get_survey_page() {
      return this.surveyForm.showProgressBar ? this.progressBarOnValue : this.progressBarOfValue;
    }
  },
  watch: {
    survey: function survey() {
      this.initFormData();
    }
  }
});

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sanitize_html__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sanitize_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_printd__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_printd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_printd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_charts_PieChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_charts_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_charts_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_ChartLegend__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_ChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_charts_ChartLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_charts_StackedChartLegend__ = __webpack_require__(2915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_charts_StackedChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_charts_StackedChartLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_charts_StackedBarChart__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_charts_StackedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_charts_StackedBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud__);






var _templateObject = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        query($filter: QuestionSourcesFilter!) {\n          questionSource(filter: $filter) {\n            sourceNotes\n          }\n        }\n      '], ['\n        query($filter: QuestionSourcesFilter!) {\n          questionSource(filter: $filter) {\n            sourceNotes\n          }\n        }\n      ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation($filter: QuestionSourcesFilter!) {\n              addSourceNotes(filter: $filter) {\n                questionId\n                sourceNotes\n              }\n            }\n          '], ['\n            mutation($filter: QuestionSourcesFilter!) {\n              addSourceNotes(filter: $filter) {\n                questionId\n                sourceNotes\n              }\n            }\n          ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import moment from 'moment';










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_12__components_charts_PieChart___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_13__components_charts_BarChart___default.a,
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_15__components_charts_HorizontalBarChart___default.a,
    ChartLegend: __WEBPACK_IMPORTED_MODULE_16__components_charts_ChartLegend___default.a,
    StackedChartLegend: __WEBPACK_IMPORTED_MODULE_17__components_charts_StackedChartLegend___default.a,
    Cloud: __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud___default.a,
    StackedBarChart: __WEBPACK_IMPORTED_MODULE_18__components_charts_StackedBarChart___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_colors__["a" /* default */]],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    statData: {
      type: Object,
      default: function _default() {
        return {
          insight: '',
          answers: [],
          words: [],
          demographics: {}
        };
      }
    },
    selectedTotalDisplay: {
      type: String,
      default: 'percentage'
    }
  },
  data: function data() {
    return {
      selectedAnalytics: [{ chart: 'pie', key: null, showLegend: true }, { chart: 'pie', key: null, showLegend: true }, { chart: 'pie', key: null, showLegend: true }],
      isEditingTitle: false,
      isEditingInsight: false,
      isEditingTextBox: false,
      isEditSourcing: false,
      printCharts: true,
      textBoxContext: '',
      insightVariables: [{ key: 'positive_percentage', title: 'Positive by percentage' }, { key: 'positive_cume', title: 'Positive adjusted by cume' }, { key: 'positive_total', title: 'Total positive' }],
      customInsight: null,
      customTitle: null,
      colonyLogoB64: null,
      companyLogoB64: null,
      editedQuestions: [null, null, null],
      isEditingQuestion: [false, false, false],
      pageBreaks: { demographics: false, sourcing: false },

      questionLegend: true,
      newBulletPoint: { demographics: '', sourcing: '' },

      bulletPointsCollection: {
        hasBulletPoints: {
          demographics: false,
          sourcing: false,
          bullet: false
        },
        demographics: [],
        sourcing: [],
        bullet: []
      },

      sourcingNotes: null,

      positiveSelections: { main: false, 0: {}, 1: {}, 2: {} },

      printableCss: '\n    /* Print CSS Starts here */\n      body, html {\n        -webkit-print-color-adjust: exact;\n      }\n      img {\n        width: auto;\n        height: auto;\n      }\n      .one-page {\n        text-align: center;\n      }\n\n      .mast-head {\n        width: 100%;\n        text-align: left;\n        border-bottom: 1px solid #eee;\n      }\n\n      .mast-head img {\n        padding: 10px;\n      }\n\n      .logo-wrapper {\n        height: 120px;\n        display: table-cell;\n        vertical-align: middle;\n      }\n\n      .colony-logo {\n        float: left;\n        max-width: 300px;\n      }\n\n      .colony-logo img {\n        height: 70px;\n      }\n\n      .company-logo {\n        float: right;\n        max-width: 300px;\n      }\n\n      .company-logo img {\n        max-height: 120px;\n        width: auto;\n      }\n\n      .insight {\n        padding: 20px 0;\n        font-size: 18px;\n        line-height: 1.1;\n      }\n      .monitor {\n        display: none;\n      }\n      .selector {\n        margin-bottom: 15px;\n      }\n      .legend {\n        margin: auto;\n        border-collapse: collapse;\n        display: table;\n        padding: 12px 0;\n      }\n      .legend-row {\n        display: table-row;\n      }\n      .column {\n        display: table-cell;\n        padding: 0px 10px;\n      }\n      .color {\n        display: inline-block;\n        width: 10px;\n        height: 10px;\n      }\n      .total {\n        text-align: right;\n      }\n      .demographics .chart-title {\n        height: 120px;\n      }\n      .sourcing {\n        color: #999;\n        font-size: 0.8em;\n      }\n      .bullet-points {\n        text-align: center;\n        font-size: 1.3em;\n        font-weight: bold;\n      }\n      .bullet-points > ul {\n        display: inline-block;\n        text-align: left;\n      }\n      .page-break {\n          page-break-after: always;\n      }\n  '
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.d = new __WEBPACK_IMPORTED_MODULE_9_printd__["Printd"]();
    this.$store.dispatch('company/getCompany');

    this.getDataUrl('https://s3-eu-west-1.amazonaws.com/colonyng/logo/colony-logo-purple.png').then(function (dataUrl) {
      _this.colonyLogoB64 = dataUrl;
    });
  },

  apollo: {
    $client: 'apiv2',
    questionSource: {
      query: __WEBPACK_IMPORTED_MODULE_11_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return {
          filter: {
            questionId: this.questionId
          }
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])('company', ['company']), {
    isVisible: {
      get: function get() {
        this.sourcingNotes = null;
        return this.visible;
      },
      set: function set(value) {
        this.$emit('onChangeVisibility', value);
        if (!value) {
          this.resetData();
        }
      }
    },
    insight: {
      get: function get() {
        return this.customInsight === null ? this.statData.insight : this.customInsight;
      },
      set: function set(value) {
        this.customInsight = value;
      }
    },

    sourcing: {
      get: function get() {
        var defaultFooterText = 'Source: COLONYLive (insert date of survey).';
        var source = this.questionSource ? this.questionSource.sourceNotes : defaultFooterText;
        return this.sourcingNotes === null ? source : this.sourcingNotes;
      },
      set: function set(value) {
        this.sourcingNotes = value;
      }
    },
    displayWordData: function displayWordData() {
      var _this2 = this;

      return function (k) {
        if (!k) {
          return [];
        }

        var answersMap = {
          otherQuestions: _this2.otherQuestionWords
        };
        var keys = k.split('__');
        var answers = answersMap[keys[0]](keys[1]);
        return answers;
      };
    },
    displayKeyData: function displayKeyData() {
      var _this3 = this;

      return function (index, key, chart) {
        if (!key) {
          return [];
        }

        var answersMap = {
          otherQuestions: _this3.otherQuestionAnswers,
          demographics: _this3.demographicAnswers
        };

        var keys = key.split('__');
        var answers = answersMap[keys[0]](keys[1]);

        if (chart === 'vertical_bar_stacked') return _this3.stackedTotalDisplay(answers);

        var isPositiveOnly = _this3.positiveSelections[index][key] || false;

        return isPositiveOnly ? _this3.totalDisplayPositive(answers) : _this3.totalDisplay(answers);
      };
    },
    mainChartTotalDisplay: function mainChartTotalDisplay() {
      var _this4 = this;

      return function (answers) {
        var isPositiveOnly = _this4.positiveSelections.main || false;
        return isPositiveOnly ? _this4.totalDisplayPositive(answers) : _this4.totalDisplay(answers);
      };
    },
    selectedTitleDisplay: function selectedTitleDisplay() {
      var _this5 = this;

      return function (k) {
        if (!k) {
          return '';
        }

        var titleMap = {
          otherQuestions: _this5.otherQuestionTitle,
          demographics: _this5.demographicTitle
        };

        var keys = k.split('__');
        return titleMap[keys[0]](keys[1]);
      };
    },
    selectableAnalytics: function selectableAnalytics() {
      return [{
        label: 'Questions',
        key: 'otherQuestions',
        options: this.otherQuestionOptions()
      }, {
        label: 'Demographics',
        key: 'demographics',
        options: this.demographicChartOptions()
      }];
    },
    selectableCharts: function selectableCharts() {
      var _this6 = this;

      var chartTypes = ['vertical_bar_stacked', 'vertical_bar', 'horizontal_bar', 'pie', 'donut', 'word_cloud'];
      return chartTypes.map(function (c) {
        return { value: c, label: _this6.titleDisplay(c) };
      });
    },
    processedInsight: function processedInsight() {
      var _this7 = this;

      var positiveAnswers = function positiveAnswers() {
        return _this7.statData.answers.filter(function (a) {
          return a.polarity > 0;
        });
      };
      var substitutions = {
        positive_percentage: function positive_percentage() {
          var total = positiveAnswers().reduce(function (acc, a) {
            return acc + a.percentage;
          }, 0);
          return total + '%';
        },
        positive_cume: function positive_cume() {
          return positiveAnswers().reduce(function (acc, a) {
            return acc + a.cume;
          }, 0).toLocaleString();
        },
        positive_total: function positive_total() {
          return positiveAnswers().reduce(function (acc, a) {
            return acc + a.total;
          }, 0).toLocaleString();
        }
      };
      var re = /{([^}]+)}/g;

      var found = this.insight.match(re);

      if (!found) {
        return this.insight;
      }

      var newInsight = this.insight;
      found.forEach(function (f) {
        var k = f.replace(/[{}]/g, '');
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(substitutions).indexOf(k) >= 0) {
          newInsight = newInsight.replace(new RegExp(f, 'g'), '<strong>' + substitutions[k]() + '</strong>');
        }
      });

      // Convert new lines into br's
      newInsight = newInsight.replace(/(?:\r\n|\r|\n)/g, '<br>');

      return newInsight;
    },


    currentTitle: {
      get: function get() {
        return this.customTitle !== null ? this.customTitle : this.title;
      },
      set: function set(value) {
        this.customTitle = value;
      }
    },

    questionId: function questionId() {
      return this.statData.questionId;
    },
    filterVariables: function filterVariables() {
      var keyMap = {
        questionId: this.statData.questionId,
        sourceNotes: this.sourcingNotes
      };
      return keyMap;
    },
    stackedChartOptions: function stackedChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: 1
          }],
          yAxes: [{
            stacked: true
          }]
        }
      };
    }
  }),

  methods: {
    getDataUrl: function getDataUrl(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    },
    print: function print() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css').then(function (response) {
        var bootstrapCss = response.data;
        _this8.d.print(_this8.$refs.print, bootstrapCss + _this8.printableCss);
      });
    },
    totalDisplay: function totalDisplay(answers) {
      var _this9 = this;

      return answers ? answers.map(function (a) {
        return [a.title, a[_this9.selectedTotalDisplay]];
      }) : [];
    },
    totalDisplayPositive: function totalDisplayPositive(answers) {
      var positiveAnswers = answers.filter(function (a) {
        return a.polarity > 0;
      });
      return this.totalDisplay(positiveAnswers);
    },
    stackedTotalDisplay: function stackedTotalDisplay(answers) {
      var _this10 = this;

      /* eslint-disable-next-line */
      var result = {
        labels: answers.map(function (a) {
          return a.title;
        }),
        datasets: answers.map(function (a, i) {
          return {
            backgroundColor: _this10.generateTitleColor('Ranked # ' + (i + 1)),
            label: 'Ranked  #' + (i + 1),
            data: answers.map(function (d) {
              if (d[_this10.selectedTotalDisplay][i] === undefined) return 0;
              return d[_this10.selectedTotalDisplay][i];
            })
          };
        })
      };
      return result;
    },
    titleDisplay: function titleDisplay(str) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["upperFirst"])(str).replace(/_/g, ' ');
    },
    otherQuestionTitle: function otherQuestionTitle(key) {
      return this.selectableAnalytics.find(function (a) {
        return a.key === 'otherQuestions';
      }).options.find(function (o) {
        return o.value === parseInt(key, 10);
      }).label;
    },
    otherQuestionAnswers: function otherQuestionAnswers(key) {
      return this.statData.otherQuestions.find(function (q) {
        return q.question_id === parseInt(key, 10);
      }).answers;
    },
    otherQuestionWords: function otherQuestionWords(key) {
      return this.statData.otherQuestions.find(function (q) {
        return q.question_id === parseInt(key, 10);
      }).words;
    },
    otherQuestionOptions: function otherQuestionOptions() {
      return this.statData.otherQuestions.map(function (q) {
        return {
          value: q.question_id,
          label: q.question,
          type: q.question_type
        };
      });
    },
    demographicTitle: function demographicTitle(key) {
      return this.titleDisplay(key);
    },
    demographicAnswers: function demographicAnswers(key) {
      return this.statData.demographics[key];
    },
    demographicChartOptions: function demographicChartOptions() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.statData.demographics).map(function (k) {
        return {
          value: k,
          label: _this11.titleDisplay(k)
        };
      });
    },
    handleAppendInsightVariable: function handleAppendInsightVariable(ref, variable) {
      var cursorPosition = this.$refs[ref].selectionStart;
      this.insight = [this.insight.slice(0, cursorPosition), '{' + variable + '}', this.insight.slice(cursorPosition)].join('');
    },
    handleResetInsight: function handleResetInsight() {
      this.customInsight = this.statData.insight;
    },
    handleSaveInsight: function handleSaveInsight() {
      this.isEditingInsight = false;
    },
    handleSaveCustomText: function handleSaveCustomText() {
      this.isEditingTextBox = false;
    },
    handleResetCustomText: function handleResetCustomText() {
      this.textBoxContext = '';
    },
    handleQuestionChanged: function handleQuestionChanged(index, key) {
      this.editedQuestions[index] = this.selectedTitleDisplay(key);
    },
    handleEditQuestion: function handleEditQuestion(index) {
      this.isEditingQuestion[index] = true;
      this.$forceUpdate();
    },
    handleSaveQuestion: function handleSaveQuestion(index) {
      this.isEditingQuestion[index] = false;
      this.$forceUpdate();
    },
    handleResetQuestion: function handleResetQuestion(index, key) {
      this.isEditingQuestion[index] = false;
      this.editedQuestions[index] = this.selectedTitleDisplay(key);
      this.$forceUpdate();
    },
    handleResetTitle: function handleResetTitle() {
      this.customTitle = null;
    },
    handleSaveTitle: function handleSaveTitle() {
      this.isEditingTitle = false;
    },
    handleAddBulletPoint: function handleAddBulletPoint() {
      var indexName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'insight';

      this.bulletPointsCollection[indexName].push(this.newBulletPoint[indexName]);
      this.newBulletPoint[indexName] = '';
    },
    handleToggleBulletPoints: function handleToggleBulletPoints() {
      var indexName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'insight';

      this.bulletPointsCollection.hasBulletPoints[indexName] = !this.bulletPointsCollection.hasBulletPoints[indexName];
    },
    handleRemoveBulletPoint: function handleRemoveBulletPoint(index) {
      var indexName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'insight';

      this.bulletPointsCollection[indexName].splice(index, 1);
    },
    toggleSaveNotes: function toggleSaveNotes() {
      this.isEditSourcing = !this.isEditSourcing;
    },
    handleSaveSourceNotes: function handleSaveSourceNotes() {
      this.saveToExternal();
      this.toggleSaveNotes();
      this.$forceUpdate();
    },
    saveToExternal: function saveToExternal() {
      var _this12 = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_11_graphql_tag___default()(_templateObject2),
        variables: {
          filter: this.filterVariables
        }
      }).then(function (data) {
        var sourceNotes = data.sourceNotes;

        _this12.isEditSourcing = false;
        _this12.sourcingNotes = _this12.nl2br(sourceNotes);
      });
    },
    formatSourcing: function formatSourcing(sourcing) {
      return __WEBPACK_IMPORTED_MODULE_6_sanitize_html___default()(this.nl2br(sourcing));
    },
    nl2br: function nl2br(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
    resetData: function resetData() {
      var _this13 = this;

      var data = {
        selectedAnalytics: [{ chart: 'pie', key: null, showLegend: true }, { chart: 'pie', key: null, showLegend: true }, { chart: 'pie', key: null, showLegend: true }],
        isEditingTitle: false,
        isEditingInsight: false,
        isEditSourcing: false,
        printCharts: true,
        insightVariables: [{ key: 'positive_percentage', title: 'Positive by percentage' }, { key: 'positive_cume', title: 'Positive adjusted by cume' }, { key: 'positive_total', title: 'Total positive' }],
        customInsight: null,
        customTitle: null,
        editedQuestions: [null, null, null],
        isEditingQuestion: [false, false, false],
        pageBreaks: { demographics: false, sourcing: false },

        questionLegend: true,
        newBulletPoint: { demographics: '', sourcing: '' },

        bulletPointsCollection: {
          hasBulletPoints: {
            demographics: false,
            sourcing: false,
            bullet: false
          },
          demographics: [],
          sourcing: [],
          bullet: []
        },

        sourcingNotes: null
      };
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (k) {
        _this13[k] = data[k];
      });
    },

    fontSizeMapper: function fontSizeMapper(word) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()(word.value) * 20;
    }
  },
  watch: {
    company: function company() {
      var _this14 = this;

      if (this.company.logo) {
        this.getDataUrl(this.company.logo).then(function (dataUrl) {
          _this14.companyLogoB64 = dataUrl;
        });
      }
    }
  }
});

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_PieChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_charts_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_ChartLegend__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_ChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_charts_ChartLegend__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colors__["a" /* default */]],
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_2__components_common_IBox___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_3__components_common_Empty___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_4__components_charts_BarChart___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_PieChart___default.a,
    ChartLegend: __WEBPACK_IMPORTED_MODULE_6__components_charts_ChartLegend___default.a
  },
  props: {
    title: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: true
    },
    profileCharts: {
      type: Object,
      required: true
    },
    totalRespondents: {
      type: Number,
      default: 0
    },
    selectedTotalDisplay: {
      type: String,
      default: 'percentage'
    },
    hueRange: {
      type: Array,
      default: function _default() {
        return [0, 359];
      }
    }
  },
  data: function data() {
    return {
      itemsPerRow: 4
    };
  },
  computed: {
    profileGender: function profileGender() {
      var _this = this;

      // If our data hasn't populated yet, just return 0 as the percentage for now.
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.profileCharts).indexOf('gender') < 0) {
        return function () {
          return 0;
        };
      }

      var total = this.profileCharts.gender.reduce(function (a, b) {
        return a[_this.selectedTotalDisplay] + b[_this.selectedTotalDisplay];
      });

      var formatMap = {
        percentage: function percentage(c, t) {
          return Math.round(c / t * 100) + '%';
        },
        total: function total(c) {
          return c.toLocaleString();
        },
        cume: function cume(c) {
          return c.toLocaleString();
        }
      };

      return function (gender) {
        var count = _this.profileCharts.gender.filter(function (g) {
          return g.title === gender;
        })[0][_this.selectedTotalDisplay];
        var format = formatMap[_this.selectedTotalDisplay](count, total);
        return format;
      };
    },
    genderItem: function genderItem() {
      var _this2 = this;

      return function (gender) {
        return _this2.profileCharts.gender.filter(function (g) {
          return g.title === gender;
        })[0];
      };
    },
    pieChartOptions: function pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel
          }
        }
      };
    }
  },
  methods: {
    handleProfileClicked: function handleProfileClicked(event, title, profileItem) {
      this.$emit('onProfileClicked', event, title, profileItem);
    },
    totalDisplay: function totalDisplay(answers) {
      var _this3 = this;

      return Array.isArray(answers) ? answers.map(function (a) {
        return [a.title, a[_this3.selectedTotalDisplay]];
      }) : [];
    },
    handleGenderClicked: function handleGenderClicked(event, title, answer) {
      this.$emit('onGenderClicked', event, title, answer);
    },
    generateTooltipLabel: function generateTooltipLabel(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      var formatMap = {
        percentage: function percentage(l) {
          return l + '%';
        },
        total: function total(l) {
          return l.toLocaleString();
        },
        cume: function cume(l) {
          return l.toLocaleString();
        }
      };

      return formatMap[this.selectedTotalDisplay](label);
    },
    generatePieTooltipLabel: function generatePieTooltipLabel(tooltipItem, data) {
      var total = this.generateTooltipLabel(tooltipItem, data);
      var label = data.labels[tooltipItem.index];

      return label + ': ' + total;
    },
    capitalise: function capitalise(content) {
      return content.split('_').map(function (x) {
        return '' + x[0].toUpperCase() + x.slice(1);
      }).join(' ');
    }
  }
});

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_Trend__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_Trend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_charts_Trend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_ChartLegend__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_ChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_charts_ChartLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_surveys_SpotProfileChart__ = __webpack_require__(3073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_surveys_SpotProfileChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_surveys_SpotProfileChart__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpotItem',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_4__components_common_IBox___default.a,
    Trend: __WEBPACK_IMPORTED_MODULE_5__components_charts_Trend___default.a,

    BarChart: __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_7__components_charts_HorizontalBarChart___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart___default.a,
    DonutChart: __WEBPACK_IMPORTED_MODULE_9__components_charts_DoughnutChart___default.a,
    ChartLegend: __WEBPACK_IMPORTED_MODULE_10__components_charts_ChartLegend___default.a,

    SpotProfileChart: __WEBPACK_IMPORTED_MODULE_11__components_surveys_SpotProfileChart___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_colors__["a" /* default */]],
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    },
    entries: {
      type: Number,
      default: 0
    },
    entryChart: {
      type: Array,
      required: true
    },
    questionCharts: {
      type: Array,
      required: true
    },
    profileCharts: {
      type: Object,
      required: true
    },
    totalDisplayOption: {
      type: String,
      default: 'percentage'
    }
  },
  data: function data() {
    return {
      profileItemsPerRow: 2
    };
  },
  computed: {
    progress: function progress() {
      var totalSeconds = this.endDate.getTime() - this.startDate.getTime();
      var elapsedSeconds = new Date().getTime() - this.startDate.getTime();
      var percentage = elapsedSeconds / totalSeconds * 100;

      if (percentage > 100) {
        percentage = 100;
      }

      if (percentage < 0) {
        percentage = 0;
      }

      return Math.round(percentage);
    },
    hue: function hue() {
      var seed = this.generateSeedFromString(this.title, 12);
      var hueStart = this.generateRnd(seed, 1, 340);
      var hueEnd = hueStart + 20;
      var hueRange = [hueStart, hueEnd];
      return hueRange;
    },
    totalDisplay: function totalDisplay() {
      var _this = this;

      return function (answers) {
        return answers.map(function (a) {
          return [a.title, a[_this.totalDisplayOption]];
        });
      };
    },
    chartOptions: function chartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel
          }
        }
      };
    },
    pieChartOptions: function pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel
          }
        }
      };
    },
    profileRowCount: function profileRowCount() {
      return Math.ceil(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.profileCharts).length / this.profileItemsPerRow);
    },
    profileKeysForRow: function profileKeysForRow() {
      var _this2 = this;

      return function (row) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.profileCharts).slice((row - 1) * _this2.profileRowCount, row * _this2.profileRowCount);
      };
    }
  },
  methods: {
    generateTooltipLabel: function generateTooltipLabel(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      var formatMap = {
        percentage: function percentage(l) {
          return l + '%';
        },
        total: function total(l) {
          return l.toLocaleString();
        },
        cume: function cume(l) {
          return l.toLocaleString();
        }
      };

      return formatMap[this.totalDisplayOption](label);
    },
    generatePieTooltipLabel: function generatePieTooltipLabel(tooltipItem, data) {
      var total = this.generateTooltipLabel(tooltipItem, data);
      var label = data.labels[tooltipItem.index];

      return label + ': ' + total;
    },
    handleChartClicked: function handleChartClicked(event, questionItem) {
      /* eslint-disable no-underscore-dangle */
      var answer = questionItem.answers[event[1][0]._index];
      this.respondentFiltering = {
        choice_id: answer.choice_id,
        question_id: questionItem.question_id
      };
      this.handleRequestRespondents({
        filtering: this.respondentFiltering,
        title: questionItem.question,
        subtitle: answer.title
      });
    },
    handleRequestRespondents: function handleRequestRespondents(request) {
      request.filtering = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.filtering, {
        filter_by: 'survey',
        survey_id: this.id
      });
      this.$emit('onRequestRespondents', request);
    },
    handleShareSurvey: function handleShareSurvey() {
      this.$store.dispatch('modals/showSocialPostDialog', {
        message: 'Please complete our short survey ' + this.url
      });
    }
  }
});

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_PieChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartLegend__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_charts_ChartLegend__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpotProfileChart',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colors__["a" /* default */]],
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_BarChart___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_PieChart___default.a,
    ChartLegend: __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartLegend___default.a
  },
  props: {
    field: {
      type: String,
      required: true
    },
    hueRange: {
      type: Array,
      required: true
    },
    chartData: {
      type: Array,
      required: true
    },
    totalDisplayOption: {
      type: String,
      default: 'percentage'
    }
  },
  computed: {
    genderItem: function genderItem() {
      var _this = this;

      return function (gender) {
        return _this.chartData.filter(function (g) {
          return g.title === gender;
        })[0];
      };
    },
    genderPercentages: function genderPercentages() {
      var _this2 = this;

      return function (gender) {
        var genderData = _this2.chartData.filter(function (d) {
          return d[0] === gender;
        });
        return genderData[0][1];
      };
    },
    genderPercentage: function genderPercentage() {
      var _this3 = this;

      var total = this.chartData.reduce(function (a, b) {
        return a[_this3.totalDisplayOption] + b[_this3.totalDisplayOption];
      });

      var formatMap = {
        percentage: function percentage(c, t) {
          return Math.round(c / t * 100) + '%';
        },
        total: function total(c) {
          return c.toLocaleString();
        },
        cume: function cume(c) {
          return c.toLocaleString();
        }
      };

      return function (gender) {
        var count = _this3.chartData.filter(function (g) {
          return g.title === gender;
        })[0][_this3.totalDisplayOption];
        var format = formatMap[_this3.totalDisplayOption](count, total);
        return format;
      };
    },
    title: function title() {
      return this.field.replace('_', ' ').replace(/(^|\s)\S/g, function (t) {
        return t.toUpperCase();
      });
    },
    totalDisplay: function totalDisplay() {
      var _this4 = this;

      return function (answers) {
        return answers.map(function (a) {
          return [a.title, a[_this4.totalDisplayOption]];
        });
      };
    },
    chartOptions: function chartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel
          }
        }
      };
    },
    pieChartOptions: function pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel
          }
        }
      };
    }
  },
  methods: {
    generateTooltipLabel: function generateTooltipLabel(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      var formatMap = {
        percentage: function percentage(l) {
          return l + '%';
        },
        total: function total(l) {
          return l.toLocaleString();
        },
        cume: function cume(l) {
          return l.toLocaleString();
        }
      };

      return formatMap[this.totalDisplayOption](label);
    },
    generatePieTooltipLabel: function generatePieTooltipLabel(tooltipItem, data) {
      var total = this.generateTooltipLabel(tooltipItem, data);
      var label = data.labels[tooltipItem.index];

      return label + ': ' + total;
    },
    handleProfileClicked: function handleProfileClicked(event, profileItem) {
      /* eslint-disable no-underscore-dangle */
      var answer = profileItem[event[1][0]._index];
      this.$emit('onRequestRespondents', {
        filtering: { choice_id: answer.choice_id },
        title: this.title,
        subtitle: answer.title
      });
    },
    handleGenderClicked: function handleGenderClicked(event, answer) {
      this.$emit('onRequestRespondents', {
        filtering: { choice_id: answer.choice_id },
        title: this.title,
        subtitle: answer.title
      });
    }
  }
});

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpotSurveyCreateDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      surveyForm: {
        title: null,
        campaignId: null,
        startDate: null,
        endDate: null,
        redirectUrl: null,
        logoUrl: null,
        questions: [{ title: '', choices: [], newChoice: '' }],
        profiles: []
      },
      rules: {
        title: [{ required: true, message: 'Please provide a title', trigger: 'blur' }],
        campaignId: [{ required: true, message: 'Please select an active campaign', trigger: 'change' }],
        startDate: [{ type: 'date', required: true, message: 'Please pick a starting date', trigger: 'change' }],
        endDate: [{ type: 'date', required: true, message: 'Please pick an ending date', trigger: 'change' }],
        redirectUrl: [{
          message: 'Please provide a valid url',
          trigger: 'blur',
          pattern: /^https?:\/\/[^\s/$.?#].[^\s]*$/i
        }],
        logoUrl: [{
          message: 'Please provide a valid url',
          trigger: 'blur',
          pattern: /^https?:\/\/[^\s/$.?#].[^\s]*$/i
        }]
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('survey', ['demographics']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('campaign', ['activeCampaigns']), {
    demographicsTransfer: function demographicsTransfer() {
      return this.demographics.map(function (d) {
        return { key: d.id, label: d.title };
      });
    },

    currentlyVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(newValue) {
        this.$emit('onVisibilityChange', newValue);
        this.$refs.surveyForm.resetFields();
        this.surveyForm.questions = [{ title: '', choices: [], newChoice: '' }];
        this.surveyForm.profiles = [];
      }
    }
  }),
  methods: {
    handleAddChoice: function handleAddChoice(question, index) {
      if (question.newChoice.length > 0) {
        question.choices.push({ title: question.newChoice });
        this.surveyForm.questions[index].newChoice = '';
      }
    },
    handleAddQuestion: function handleAddQuestion() {
      this.surveyForm.questions.push({ title: '', choices: [], newChoice: '' });
    },
    handleCancel: function handleCancel() {
      this.currentlyVisible = false;
    },
    handleCreateSpotSurvey: function handleCreateSpotSurvey() {
      var _this = this;

      // Work with a copy of our form data
      var formData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.surveyForm);
      this.$refs.surveyForm.validate(function (valid) {
        if (valid && _this.choicesValid()) {
          _this.$store.dispatch('survey/createSpotSurvey', formData);
        }
      });
      // Silly thing!
      window.setTimeout(function () {
        _this.currentlyVisible = false;
      }, 0);
    },
    handleRemoveChoice: function handleRemoveChoice(questionIndex, choiceIndex) {
      this.surveyForm.questions[questionIndex].choices.splice(choiceIndex, 1);
    },
    handleRemoveQuestion: function handleRemoveQuestion(questionIndex) {
      this.surveyForm.questions.splice(questionIndex, 1);
    },
    choicesValid: function choicesValid() {
      var isValid = true;
      this.surveyForm.questions.forEach(function (question) {
        if (!question.choices.length) {
          isValid = false;
        }
      });
      return isValid;
    }
  }
});

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_FabSpeedDial__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_FabSpeedDial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_FabSpeedDial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_Trend__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_Trend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_charts_Trend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_surveys_SpotItem__ = __webpack_require__(3072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_surveys_SpotItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_surveys_SpotItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_surveys_SpotSurveyCreateDialog__ = __webpack_require__(3074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_surveys_SpotSurveyCreateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_surveys_SpotSurveyCreateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_surveys_SurveyRespondentsDialog__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_surveys_SurveyRespondentsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_surveys_SurveyRespondentsDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpotSurveyDashboard',
  components: {
    IBox: __WEBPACK_IMPORTED_MODULE_1__components_common_IBox___default.a,
    Trend: __WEBPACK_IMPORTED_MODULE_3__components_charts_Trend___default.a,
    SpotItem: __WEBPACK_IMPORTED_MODULE_4__components_surveys_SpotItem___default.a,
    FabSpeedDial: __WEBPACK_IMPORTED_MODULE_2__components_common_FabSpeedDial___default.a,
    SpotSurveyCreateDialog: __WEBPACK_IMPORTED_MODULE_5__components_surveys_SpotSurveyCreateDialog___default.a,
    SurveyRespondentsDialog: __WEBPACK_IMPORTED_MODULE_7__components_surveys_SurveyRespondentsDialog___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])('survey', ['spotChartsData', 'loadingSpotCharts'])),
  mounted: function mounted() {
    this.$store.dispatch('survey/getSpotCharts');
  },

  data: function data() {
    return {
      createDialogVisible: false,
      selectedTotalDisplay: 'percentage',
      respondentDialogVisible: false,
      respondentFiltering: {},
      respondentTitle: '',
      respondentSubtitle: ''
    };
  },
  methods: {
    handleCreateSpotSurvey: function handleCreateSpotSurvey() {
      this.createDialogVisible = true;
    },
    handleRespondentDialogVisibility: function handleRespondentDialogVisibility(event) {
      this.respondentDialogVisible = event;
    },
    handleRequestRespondents: function handleRequestRespondents(_ref) {
      var filtering = _ref.filtering,
          title = _ref.title,
          subtitle = _ref.subtitle;

      this.respondentDialogVisible = true;
      this.respondentFiltering = filtering;
      this.respondentTitle = title;
      this.respondentSubtitle = subtitle;
    }
  }
});

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_BarChart__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_charts_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_StackedBarChart__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_StackedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_charts_StackedBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_charts_HorizontalBarChart__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_charts_HorizontalBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_charts_HorizontalBarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_PieChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_charts_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_ChartLegend__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_ChartLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_charts_ChartLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_surveys_RespondentProfileChart__ = __webpack_require__(3071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_surveys_RespondentProfileChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_surveys_RespondentProfileChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_surveys_CategoryOneSheet__ = __webpack_require__(3070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_surveys_CategoryOneSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_surveys_CategoryOneSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_analytics_surveyAnalytics_gql__ = __webpack_require__(2578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_analytics_surveyAnalytics_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__graphql_analytics_surveyAnalytics_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_export_to_csv__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_surveys_SurveyRespondentsDialog__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_surveys_SurveyRespondentsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_surveys_SurveyRespondentsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_surveys_SurveyExportFormDialog__ = __webpack_require__(3077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_surveys_SurveyExportFormDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_surveys_SurveyExportFormDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_surveys_SurveyExportViewDialog__ = __webpack_require__(3078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_surveys_SurveyExportViewDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_surveys_SurveyExportViewDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_colorConstants_live__ = __webpack_require__(339);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























 // eslint-disable-line

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyAnalyticsDashboard',
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_9__components_charts_BarChart___default.a,
    CategoryOneSheet: __WEBPACK_IMPORTED_MODULE_17__components_surveys_CategoryOneSheet___default.a,
    ChartLegend: __WEBPACK_IMPORTED_MODULE_15__components_charts_ChartLegend___default.a,
    DonutChart: __WEBPACK_IMPORTED_MODULE_14__components_charts_DoughnutChart___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_11__components_common_Loader___default.a,
    Empty: __WEBPACK_IMPORTED_MODULE_8__components_common_Empty___default.a,
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_12__components_charts_HorizontalBarChart___default.a,
    IBox: __WEBPACK_IMPORTED_MODULE_7__components_common_IBox___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_13__components_charts_PieChart___default.a,
    RespondentProfileChart: __WEBPACK_IMPORTED_MODULE_16__components_surveys_RespondentProfileChart___default.a,
    StackedBarChart: __WEBPACK_IMPORTED_MODULE_10__components_charts_StackedBarChart___default.a,
    SurveyExportFormDialog: __WEBPACK_IMPORTED_MODULE_23__components_surveys_SurveyExportFormDialog___default.a,
    SurveyExportViewDialog: __WEBPACK_IMPORTED_MODULE_24__components_surveys_SurveyExportViewDialog___default.a,
    SurveyRespondentsDialog: __WEBPACK_IMPORTED_MODULE_22__components_surveys_SurveyRespondentsDialog___default.a,
    Cloud: __WEBPACK_IMPORTED_MODULE_19_vue_d3_cloud___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_colors__["a" /* default */]],
  data: function data() {
    return {
      analyticsPerRow: 2,
      filterBy: 'period',
      selectedPeriod: 'lifetime',
      selectedPeriodMonth: null,
      selectedPeriodQuarter: null,
      selectedPeriodYear: null,
      selectedSurvey: null,
      selectedCategory: null,
      surveyStats: {},
      hueRange: __WEBPACK_IMPORTED_MODULE_25__mixins_colorConstants_live__["d" /* surveyHueRange */],
      respHueRange: __WEBPACK_IMPORTED_MODULE_25__mixins_colorConstants_live__["e" /* respondentsHueRange */],
      selectedTotalDisplay: 'percentage',
      respondentDialogVisible: false,
      exportFormDialogVisible: false,
      exportViewDialogVisible: false,
      laodingSurveyAalytics: true,
      respondentFiltering: {},
      respondentTitle: '',
      respondentSubtitle: '',
      oneSheetVisible: false,
      oneSheetData: {},
      periods: [],
      surveys: [],
      colorBarChartSpectrum: [260, 360],
      colorPieChartSpectrum: [160, 260],
      companies: [4, 7, 11, 70]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapState */])('user', ['me']), {
    positiveCategoryProfiles: function positiveCategoryProfiles() {
      return this.extractProfileCategories(this.isViewingAllCategories() ? 'surveyCategoryProfile' : 'surveyCategoryProfilePositive');
    },
    categoryProfiles: function categoryProfiles() {
      return this.extractProfileCategories(this.isViewingAllCategories() ? 'surveyProfile' : 'surveyCategoryProfile');
    },
    analyticsCharts: function analyticsCharts() {
      var key = 'surveyAnalytics';
      var qtypes = ['PERMISSION', 'OPT_IN', 'AGE_CONSENT'];
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.surveyStats).indexOf(key) === -1) {
        return [];
      }
      return this.surveyStats[key].filter(function (c) {
        return !c.isProfile && !qtypes.includes(c.question_type);
      });
    },
    categoryAnalyticsCharts: function categoryAnalyticsCharts() {
      var _this = this;

      return this.analyticsCharts.filter(function (c) {
        return c.category === _this.currentCategory || _this.isViewingAllCategories();
      });
    },
    analyticsRowCount: function analyticsRowCount() {
      return Math.ceil(this.categoryAnalyticsCharts.length / this.analyticsPerRow);
    },
    isValidFilter: function isValidFilter() {
      if (this.filterBy === 'survey' && this.selectedSurvey !== null) {
        return true;
      }
      return this.filterBy === 'period';
    },


    currentCategory: {
      get: function get() {
        if (!this.selectedCategory && this.surveyStats.surveyCategories.length > 0 || this.surveyStats.surveyCategories.indexOf(this.selectedCategory) < 0) {
          this.selectedCategory = 'All';
        }

        return this.selectedCategory;
      }
    },

    chartOptions: function chartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel
          }
        }
      };
    },
    pieChartOptions: function pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel
          }
        }
      };
    },
    stackedChartOptions: function stackedChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: 1
          }],
          yAxes: [{
            stacked: true
          }]
        }
      };
    },
    selectedDatetime: function selectedDatetime() {
      var periodTypeMap = {
        lifetime: null,
        annual: this.selectedPeriodYear,
        quarter: this.selectedPeriodQuarter,
        month: this.selectedPeriodMonth
      };

      return periodTypeMap[this.selectedPeriod];
    },
    surveyName: function surveyName() {
      var _this2 = this;

      var survey = this.surveys.find(function (s) {
        return s.id === _this2.selectedSurvey;
      });
      if (!survey) {
        return null;
      }
      return survey.title;
    }
  }),
  mounted: function mounted() {
    this.filterBy = this.handleFilterBy();
    this.fetchSurveyAnalytics();
  },

  methods: {
    setSurveys: function setSurveys() {
      if (this.surveys.length !== 0) {
        this.selectedSurvey = this.surveys[0].id;
      }
    },
    currentCategory: function currentCategory() {
      // Should we set a default category?
      if (!this.selectedCategory && this.surveyStats.surveyCategories.length > 0 || this.surveyStats.surveyCategories.indexOf(this.selectedCategory) < 0) {
        this.selectedCategory = 'All';
      }

      return this.selectedCategory;
    },
    setPeriods: function setPeriods() {
      if (this.periods.month !== undefined) {
        this.selectedPeriodMonth = this.periods.month[0][0];
        this.selectedPeriodQuarter = this.periods.quarter[0][0];
        this.selectedPeriodYear = this.periods.annual[0][0];
      }
    },
    selectDatetime: function selectDatetime() {
      var periodTypeMap = {
        lifetime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format(),
        annual: this.selectedPeriodYear,
        quarter: this.selectedPeriodQuarter,
        month: this.selectedPeriodMonth
      };

      return periodTypeMap[this.selectedPeriod];
    },
    totalDisplay: function totalDisplay(answers) {
      var _this3 = this;

      return Array.isArray(answers) ? answers.map(function (a) {
        return [a.title, a[_this3.selectedTotalDisplay]];
      }) : [];
    },
    fetchSurveyAnalytics: function fetchSurveyAnalytics() {
      var _this4 = this;

      this.laodingSurveyAalytics = true;
      this.$apolloProvider.clients.apiv2.query({
        query: __WEBPACK_IMPORTED_MODULE_18__graphql_analytics_surveyAnalytics_gql___default.a,
        fetchPolicy: 'network-only',
        variables: {
          date: this.selectDatetime(),
          filterBy: this.filterBy,
          period: this.selectedPeriod,
          surveyId: this.getSelectedSurvey()
        }
      }).then(function (result) {
        _this4.surveyStats = result.data.surveyAnalytics[0];
        _this4.periods = _this4.surveyStats.periods;
        _this4.surveys = _this4.surveyStats.surveys;
        _this4.setPeriods();
        _this4.currentCategory();
        _this4.laodingSurveyAalytics = false;
      }).catch(function (error) {
        _this4.error = error;
        _this4.laodingSurveyAalytics = false;
      });
    },
    getSelectedSurvey: function getSelectedSurvey() {
      return this.selectedSurvey !== null ? this.selectedSurvey : 0;
    },
    stackedTotalDisplay: function stackedTotalDisplay(answers) {
      var _this5 = this;

      /* eslint-disable-next-line */
      var result = {
        labels: answers.map(function (a) {
          return a.title;
        }),
        datasets: answers.map(function (a, i) {
          return {
            backgroundColor: _this5.generateTitleColor('Ranked # ' + (i + 1)),
            label: 'Ranked #' + (i + 1),
            data: answers.map(function (d) {
              if (d[_this5.selectedTotalDisplay][i] === undefined) return 0;
              return d[_this5.selectedTotalDisplay][i];
            })
          };
        })
      };
      return result;
    },
    isViewingAllCategories: function isViewingAllCategories() {
      return this.currentCategory === 'All';
    },
    analyticsChartsInRow: function analyticsChartsInRow(index) {
      var _this6 = this;

      return this.categoryAnalyticsCharts.slice((index - 1) * this.analyticsPerRow, index * this.analyticsPerRow).filter(function (c) {
        return c.category === _this6.selectedCategory || _this6.isViewingAllCategories();
      });
    },
    handleFiltersChanged: function handleFiltersChanged() {
      if (this.filterBy === 'survey' && this.selectedSurvey === null) {
        this.setSurveys();
      }
      if (!this.isValidFilter) {
        return;
      }
      this.fetchSurveyAnalytics();
    },
    fetchSurvey: function fetchSurvey(surveyId) {
      this.$store.dispatch('survey/getSurveyCharts', surveyId);
    },
    fetchPeriod: function fetchPeriod(period, date) {
      this.$store.dispatch('survey/getPeriodCharts', { period: period, date: date });
    },
    handleChartClicked: function handleChartClicked(event, questionItem) {
      /* eslint-disable no-underscore-dangle */
      var answer = questionItem.answers[event[1][0]._index];
      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: questionItem.survey_id,
        choice_id: answer.choice_id,
        question_id: questionItem.question_id
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = questionItem.question;
      this.respondentSubtitle = answer.title;
    },
    handleProfileClicked: function handleProfileClicked(event, title, profileItem) {
      var answer = profileItem[event[1][0]._index];

      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: this.selectedSurvey,
        choice_id: answer.choice_id,
        category_id: this.categoryProfiles.category_id
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = title;
      this.respondentSubtitle = answer.title;
    },
    handlePositiveProfileClicked: function handlePositiveProfileClicked(event, title, profileItem) {
      this.handleProfileClicked(event, title, profileItem);
      this.respondentFiltering = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.respondentFiltering, { only_positive: 1 });
    },
    handleGenderClicked: function handleGenderClicked(event, title, answer) {
      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: this.selectedSurvey,
        choice_id: answer.choice_id,
        category_id: this.categoryProfiles.category_id
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = title;
      this.respondentSubtitle = answer.title;
    },
    handlePositiveGenderClicked: function handlePositiveGenderClicked(event, title, answer) {
      this.handleGenderClicked(event, title, answer);
      this.respondentFiltering = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.respondentFiltering, { only_positive: 1 });
    },
    handleRespondentDialogVisibility: function handleRespondentDialogVisibility(event) {
      this.respondentDialogVisible = event;
    },
    handleExportFormDialogVisibility: function handleExportFormDialogVisibility(event) {
      this.exportFormDialogVisible = event;
    },
    handleExportViewDialogVisibility: function handleExportViewDialogVisibility(event) {
      this.exportViewDialogVisible = event;
    },
    generateTooltipLabel: function generateTooltipLabel(tooltipItem, data) {
      var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      var formatMap = {
        percentage: function percentage(l) {
          return l + '%';
        },
        total: function total(l) {
          return l.toLocaleString();
        },
        cume: function cume(l) {
          return l.toLocaleString();
        }
      };

      return formatMap[this.selectedTotalDisplay](label);
    },
    generatePieTooltipLabel: function generatePieTooltipLabel(tooltipItem, data) {
      var total = this.generateTooltipLabel(tooltipItem, data);
      var label = data.labels[tooltipItem.index];

      return label + ': ' + total;
    },
    extractProfileCategories: function extractProfileCategories(key) {
      var _this7 = this;

      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.surveyStats).indexOf(key) < 0 && !this.isViewingAllCategories()) {
        return {};
      }

      var chart = this.isViewingAllCategories() ? this.surveyStats[key][0] : this.surveyStats[key].filter(function (c) {
        return c.category === _this7.selectedCategory;
      })[0];
      if (!chart || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(chart).indexOf('profiles') < 0) {
        return {};
      }

      return chart;
    },
    filterQuestionDemographics: function filterQuestionDemographics(data) {
      // const result = data.filter(s => s.question_id === questionId);
      // console.log(result);
      return this.prepareDemographicData(data);
    },
    prepareDemographicData: function prepareDemographicData(demographicData) {
      var profiles = {};
      demographicData.forEach(function (data) {
        var key = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data.profiles)[0];
        var profile = data.profiles[key];
        profiles[key] = profile;
      });
      return profiles;
    },
    assignPositiveKeysToDemographics: function assignPositiveKeysToDemographics(data) {
      var replaced = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).map(function (k) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, k + '_only_positive', data[k]);
      });
      if (replaced.length === 0) {
        return {};
      }
      return replaced.reduce(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, a, b);
      });
    },
    handleSetUpOneSheet: function handleSetUpOneSheet(questionItem) {
      // const questionId = questionItem.question_id;
      this.oneSheetData = {
        chart: questionItem.chart,
        answers: questionItem.answers,
        words: questionItem.words,
        otherQuestions: this.surveyStats.surveyAnalytics,
        demographics: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.filterQuestionDemographics(this.surveyStats.surveyQuestionProfile), this.assignPositiveKeysToDemographics(this.filterQuestionDemographics(this.surveyStats.surveyQuestionProfilePositive))),
        insight: questionItem.insight
      };

      this.oneSheetVisible = true;
    },
    handleCommand: function handleCommand(command) {
      var commandMap = {
        export: this.handleExport,
        view_exports: this.handleViewExports
      };
      commandMap[command]();
    },
    handleExport: function handleExport() {
      this.exportFormDialogVisible = true;
    },
    handleViewExports: function handleViewExports() {
      this.exportViewDialogVisible = true;
    },
    handleCSVExport: function handleCSVExport(question) {
      var csvExporter = new __WEBPACK_IMPORTED_MODULE_20_export_to_csv__["ExportToCsv"]({
        headers: [question.question],
        showLabels: true,
        filename: 'survey-answers-' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYYMMDDHHmmss')
      });
      csvExporter.generateCsv(question.answers.answers);
    },

    fontSizeMapper: function fontSizeMapper(word) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()(word.value) * 20;
    },

    handleFilterBy: function handleFilterBy() {
      return this.companies.includes(this.me.company) ? 'survey' : 'period';
    }
  }
});

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation($filter: SurveyRespondentFilter!) {\n              exportSurveyCsvRespondents(filter: $filter)\n            }\n          '], ['\n            mutation($filter: SurveyRespondentFilter!) {\n              exportSurveyCsvRespondents(filter: $filter)\n            }\n          ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyExportFormDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    filterBy: {
      type: String
    },
    surveyId: {
      type: Number
    },
    surveyName: {
      type: String
    },
    questionId: {
      type: Number,
      default: 0
    },
    questionTitle: {
      type: String
    },
    periodType: {
      type: String
    },
    datetime: {
      type: Date
    }
  },
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_3_moment___default.a
    };
  },
  computed: {
    period: function period() {
      return this.periodType.toUpperCase();
    },
    filterVariables: function filterVariables() {
      var _this = this;

      var keyMap = {
        survey: ['surveyId', 'questionId'],
        period: ['period', 'datetime']
      };
      return keyMap[this.filterBy].reduce(function (acc, k) {
        var value = _this[k];
        return value ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, k, value), acc) : acc;
      }, {});
    },

    currentlyVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(newValue) {
        this.$emit('onVisibilityChange', newValue);
      }
    }
  },
  methods: {
    exportRespondents: function exportRespondents() {
      var _this2 = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
        variables: {
          filter: this.filterVariables
        }
      }).then(function () {
        _this2.handleClose();
      });
    },
    handleClose: function handleClose() {
      this.$emit('onVisibilityChange', false);
    }
  }
});

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  fragment surveyExportFragment on SurveyExport {\n    id\n    fileUrl\n    periodDate\n    periodType\n    insertedAt\n    survey {\n      id\n      title\n    }\n    user {\n      id\n      firstName\n      lastName\n    }\n  }\n'], ['\n  fragment surveyExportFragment on SurveyExport {\n    id\n    fileUrl\n    periodDate\n    periodType\n    insertedAt\n    survey {\n      id\n      title\n    }\n    user {\n      id\n      firstName\n      lastName\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          surveyExports {\n            ...surveyExportFragment\n          }\n        }\n        ', '\n      '], ['\n        {\n          surveyExports {\n            ...surveyExportFragment\n          }\n        }\n        ', '\n      ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            onSurveyExport {\n              ...surveyExportFragment\n            }\n          }\n          ', '\n        '], ['\n          subscription {\n            onSurveyExport {\n              ...surveyExportFragment\n            }\n          }\n          ', '\n        ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var fragments = __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExportedSurveyRespondentList',
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    $client: 'apiv2',
    surveyExports: {
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2, fragments),
      subscribeToMore: {
        document: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject3, fragments),
        updateQuery: function updateQuery(previous, _ref) {
          var subscriptionData = _ref.subscriptionData;

          var surveyExports = [subscriptionData.data.onSurveyExport].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(previous.surveyExports));
          var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, previous, { surveyExports: surveyExports });
          return result;
        }
      }
    }
  },
  computed: {
    currentlyVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(newValue) {
        this.$emit('onVisiblityChange', newValue);
      }
    }
  },
  methods: {
    title: function title(str) {
      return str.replace('_', ' ').replace(/(^|\s)\S/g, function (t) {
        return t.toUpperCase();
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('onVisibilityChange', false);
    }
  }
});

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_export_to_csv__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Empty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_IBox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_IBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_common_IBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_email_ConstantContactDialog__ = __webpack_require__(2944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_email_ConstantContactDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_email_ConstantContactDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_email_MailChimpDialog__ = __webpack_require__(2945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_email_MailChimpDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_email_MailChimpDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_surveys_SurveyFilterSaveDialog__ = __webpack_require__(3081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_surveys_SurveyFilterSaveDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_surveys_SurveyFilterSaveDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_surveys_SurveyFilterLoadDialog__ = __webpack_require__(3080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_surveys_SurveyFilterLoadDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_surveys_SurveyFilterLoadDialog__);











var _templateObject = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          surveysListAllSurvey {\n            entries {\n              id\n              title\n            }\n          }\n        }\n      '], ['\n        {\n          surveysListAllSurvey {\n            entries {\n              id\n              title\n            }\n          }\n        }\n      ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            query($surveyId: Int!) {\n              surveysGetSurvey(surveyId: $surveyId) {\n                id\n                title\n                questionLinks {\n                  order\n                  question {\n                    id\n                    title\n                    isContact\n                    isDemographic\n                    profileField\n                    questionType\n                    choiceLinks {\n                      order\n                      polarity\n                      choice {\n                        id\n                        title\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          '], ['\n            query($surveyId: Int!) {\n              surveysGetSurvey(surveyId: $surveyId) {\n                id\n                title\n                questionLinks {\n                  order\n                  question {\n                    id\n                    title\n                    isContact\n                    isDemographic\n                    profileField\n                    questionType\n                    choiceLinks {\n                      order\n                      polarity\n                      choice {\n                        id\n                        title\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            query($filter: Json!, $fields: [String]!) {\n              surveyRespondentFilterMap(dynamicFilter: $filter, fields: $fields)\n            }\n          '], ['\n            query($filter: Json!, $fields: [String]!) {\n              surveyRespondentFilterMap(dynamicFilter: $filter, fields: $fields)\n            }\n          ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            query($dynamicFilter: Json!) {\n              surveysFilterRespondentsCount(dynamicFilter: $dynamicFilter)\n            }\n          '], ['\n            query($dynamicFilter: Json!) {\n              surveysFilterRespondentsCount(dynamicFilter: $dynamicFilter)\n            }\n          ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            query($filter: Json!, $fields: [String]!) {\n              surveysFilterRespondents(dynamicFilter: $filter, fields: $fields)\n            }\n          '], ['\n            query($filter: Json!, $fields: [String]!) {\n              surveysFilterRespondents(dynamicFilter: $filter, fields: $fields)\n            }\n          ']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation($savedFilter: SurveysSavedFilterInput!) {\n              surveyFilterCreateSaved(savedFilter: $savedFilter) {\n                id\n              }\n            }\n          '], ['\n            mutation($savedFilter: SurveysSavedFilterInput!) {\n              surveyFilterCreateSaved(savedFilter: $savedFilter) {\n                id\n              }\n            }\n          ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyFilter',
  components: {
    Empty: __WEBPACK_IMPORTED_MODULE_14__components_common_Empty___default.a,
    IBox: __WEBPACK_IMPORTED_MODULE_15__components_common_IBox___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_16__components_common_Loader___default.a,
    ConstantContactDialog: __WEBPACK_IMPORTED_MODULE_17__components_email_ConstantContactDialog___default.a,
    MailchimpDialog: __WEBPACK_IMPORTED_MODULE_18__components_email_MailChimpDialog___default.a,
    SurveyFilterSaveDialog: __WEBPACK_IMPORTED_MODULE_19__components_surveys_SurveyFilterSaveDialog___default.a,
    SurveyFilterLoadDialog: __WEBPACK_IMPORTED_MODULE_20__components_surveys_SurveyFilterLoadDialog___default.a
  },
  apollo: {
    $client: 'apiv2',
    surveysListAllSurvey: {
      query: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject)
    }
  },
  data: function data() {
    return {
      surveysListAllSurvey: { entries: [] },
      lists: [],
      contacts: [],
      selectedDemographics: [],
      stageCount: {
        survey: 0,
        demographics: 0,
        questions: 0
      },
      stageCountLoading: {
        survey: false,
        demographics: false,
        questions: false
      },
      filterData: {
        survey_id: null,
        demographics: [],
        questions: []
      },
      error: null,
      generatingList: false,
      fields: ['Mobile number'],
      constantContactVisible: false,
      mailChimpVisible: false,
      saveVisible: false,
      loadVisible: false,
      savedId: null,
      surveyRespondents: [],
      loadingSurveyRespondents: false,
      loadingSurvey: false
    };
  },
  computed: {
    surveys: function surveys() {
      return this.surveysListAllSurvey.entries;
    },
    surveyQuestions: function surveyQuestions() {
      var _this = this;

      if (!this.filterData.survey_id) {
        return [];
      }
      var survey = this.surveys.find(function (s) {
        return s.id === _this.filterData.survey_id;
      });

      return survey.questionLinks.map(function (l) {
        return l.question;
      });
    },
    selectableSurveyQuestions: function selectableSurveyQuestions() {
      var selectableTypes = ['SELECT', 'SCALE', 'MULTI_SELECT', 'RADIOGROUP'];
      return this.surveyQuestions.filter(function (q) {
        return selectableTypes.includes(q.questionType);
      });
    },
    contactQuestions: function contactQuestions() {
      var questions = this.surveyQuestions.filter(function (q) {
        return q.isContact;
      }).map(function (q) {
        return q.title;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default.a(questions)));
    },
    demographicQuestions: function demographicQuestions() {
      return this.selectableSurveyQuestions.filter(function (q) {
        return q.isDemographic;
      });
    },
    questions: function questions() {
      return this.selectableSurveyQuestions.filter(function (q) {
        return !q.isDemographic && !q.isContact;
      });
    },
    unusedQuestions: function unusedQuestions() {
      var usedQuestionIds = this.filterData.questions.map(function (q) {
        return q.question_id;
      });
      return this.questions.filter(function (q) {
        return !usedQuestionIds.includes(q.id);
      });
    },
    isQuestionUsed: function isQuestionUsed() {
      var _this2 = this;

      return function (questionId) {
        var usedQuestionIds = _this2.filterData.questions.map(function (q) {
          return q.question_id;
        });
        return usedQuestionIds.includes(questionId);
      };
    },
    questionChoices: function questionChoices() {
      var _this3 = this;

      return function (questionId) {
        var question = _this3.surveyQuestions.find(function (q) {
          return q.id === questionId;
        });
        if (!question || !question.choiceLinks) {
          return [];
        }

        return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(question.choiceLinks)).sort(function (a, b) {
          return a.order - b.order;
        });
      };
    },
    isGenerateDisabled: function isGenerateDisabled() {
      return this.stageCount.questions === 0 || this.fields.length === 0;
    },
    constantContactList: function constantContactList() {
      var contactList = [];
      for (var a = 0; a < this.surveyRespondents.length; a += 1) {
        var data = {};
        var hasEmail = this.hasEmailField(this.surveyRespondents[a]);
        if (hasEmail) {
          for (var i = 0; i < this.surveyRespondents[a].length; i += 1) {
            switch (this.surveyRespondents[a][i].profile_field) {
              case 'email':
                data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ email_addresses: [this.surveyRespondents[a][i].input] }, data);
                break;
              case 'name':
                {
                  var _getRespondentName = this.getRespondentName(this.surveyRespondents[a][i].input),
                      firstName = _getRespondentName.firstName,
                      lastName = _getRespondentName.lastName;

                  data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
                    first_name: firstName,
                    last_name: lastName,
                    home_phone: this.surveyRespondents[a][i].mobile_number
                  }, data);
                  break;
                }
              default:
                break;
            }
          }
          contactList = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(contactList), [data]);
        }
      }
      return contactList;
    },
    mailchimpContactList: function mailchimpContactList() {
      var contactList = [];
      for (var a = 0; a < this.surveyRespondents.length; a += 1) {
        var data = {};
        var hasEmail = this.hasEmailField(this.surveyRespondents[a]);
        if (hasEmail) {
          for (var i = 0; i < this.surveyRespondents[a].length; i += 1) {
            switch (this.surveyRespondents[a][i].profile_field) {
              case 'email':
                data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ email_address: this.surveyRespondents[a][i].input }, data);
                break;
              case 'name':
                {
                  var _getRespondentName2 = this.getRespondentName(this.surveyRespondents[a][i].input),
                      firstName = _getRespondentName2.firstName,
                      lastName = _getRespondentName2.lastName;

                  data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
                    status: 'subscribed',
                    merge_fields: {
                      FNAME: firstName,
                      LNAME: lastName,
                      PHONE: this.surveyRespondents[a][i].mobile_number
                    }
                  }, data);
                  break;
                }
              default:
                break;
            }
          }
          contactList = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.contactList), [data]);
        }
      }
      return contactList;
    }
  },

  methods: {
    hasEmailField: function hasEmailField(responses) {
      return responses.some(function (res) {
        return res.profile_field === 'email';
      });
    },
    fetchSurvey: function fetchSurvey() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, survey;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.loadingSurvey = true;
                _context.prev = 1;
                _context.next = 4;
                return _this4.$apolloProvider.clients.apiv2.query({
                  query: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject2),
                  variables: {
                    surveyId: parseInt(_this4.filterData.survey_id, 10)
                  }
                });

              case 4:
                res = _context.sent;
                survey = res.data.surveysGetSurvey;

                _this4.surveysListAllSurvey.entries[_this4.surveysListAllSurvey.entries.findIndex(function (el) {
                  return el.id === survey.id;
                })] = survey;
                _this4.loadingSurvey = false;
                _this4.handleCountStage('survey');
                _this4.handleCountStage('demographics');
                _this4.handleCountStage('questions');
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                _this4.loadingSurvey = false;
                _this4.error = _context.t0;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[1, 13]]);
      }))();
    },
    getRespondentName: function getRespondentName(name) {
      var splitName = name.split(' ');
      var firstName = '';
      var lastName = '';
      if (splitName.length > 2) {
        firstName = splitName[0];
        lastName = splitName[2];
        return { firstName: firstName, lastName: lastName };
      }
      firstName = splitName[0];
      lastName = splitName[1];
      return { firstName: firstName, lastName: lastName };
    },
    getSurveyRespondents: function getSurveyRespondents() {
      var _this5 = this;

      this.loadingSurveyRespondents = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject3),
        variables: {
          filter: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filterData),
          fields: this.fields
        }
      }).then(function (result) {
        _this5.surveyRespondents = result.data.surveyRespondentFilterMap;
        _this5.loadingSurveyRespondents = false;
      }).catch(function () {
        _this5.loadingSurveyRespondents = false;
      });
    },
    handleSurveyChanged: function handleSurveyChanged() {
      this.fetchSurvey();
      this.resetFilterData();
      // this.getSurveyRespondents();
    },
    buildImportList: function buildImportList() {
      var _this6 = this;

      var _loop = function _loop(a) {
        var data = {};
        var hasEmail = _this6.hasEmailField(_this6.dataRespondents[a]);
        if (hasEmail) {
          for (var i = 0; i < _this6.dataRespondents[a].length; i += 1) {
            switch (_this6.dataRespondents[a][i].profile_field) {
              case 'email':
                data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ email_address: _this6.dataRespondents[a][i].input }, data);
                break;
              case 'name':
                {
                  var _getRespondentName3 = _this6.getRespondentName(_this6.dataRespondents[a][i].input),
                      firstName = _getRespondentName3.firstName,
                      lastName = _getRespondentName3.lastName;

                  data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
                    status: 'subscribed',
                    merge_fields: {
                      FNAME: firstName,
                      LNAME: lastName,
                      PHONE: _this6.dataRespondents[a][i].mobile_number
                    }
                  }, data);
                  break;
                }
              default:
                break;
            }
          }
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this6.selectedLists).forEach(function (key) {
            var operations = [];
            var listIds = _this6.selectedLists[key];
            listIds.forEach(function (listId) {
              operations = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(operations), [{
                method: 'POST',
                path: '/lists/' + listId + '/members/',
                operation_id: 'add-' + data.email_address + '-' + listId,
                body: data
              }]);
              _this6.operations = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, _this6.operations, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(operations))));
            });
          });
        }
      };

      for (var a = 0; a < this.dataRespondents.length; a += 1) {
        _loop(a);
      }
    },
    handleDemographicsChanged: function handleDemographicsChanged() {
      this.handleCountStage('demographics');
      this.handleCountStage('questions');
    },
    handleQuestionsChanged: function handleQuestionsChanged() {
      this.handleCountStage('questions');
    },
    handleAddQuestion: function handleAddQuestion() {
      this.filterData.questions.push({ question_id: null, choices: [] });
    },
    handleRemoveQuestion: function handleRemoveQuestion(index) {
      this.filterData.questions.splice(index, 1);
      this.handleQuestionsChanged();
    },
    handleCountStage: function handleCountStage(stage) {
      var _this7 = this;

      var stageFields = {
        survey: ['survey_id'],
        demographics: ['survey_id', 'demographics'],
        questions: ['survey_id', 'demographics', 'questions', 'condition']
      };
      var stageFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["pick"])(this.filterData, stageFields[stage]);
      this.stageCountLoading[stage] = true;

      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject4),
        variables: { dynamicFilter: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(stageFilter) }
      }).then(function (result) {
        var count = result.data.surveysFilterRespondentsCount;
        _this7.stageCount[stage] = count;
        _this7.stageCountLoading[stage] = false;
        return count;
      });
    },
    handleGenerate: function handleGenerate() {
      var _this8 = this;

      if (this.fields.includes('All')) this.fields = ['All'];
      this.generatingList = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject5),
        variables: { filter: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filterData), fields: this.fields }
      }).then(function (result) {
        _this8.createCsv(result.data.surveysFilterRespondents, _this8.fields);
        _this8.generatingList = false;
      });
    },
    formatToCSV: function formatToCSV(rows) {
      return rows.map(function (row) {
        return row.map(function (value) {
          return value.answer;
        });
      });
    },
    handleGenerateCommand: function handleGenerateCommand(cmd) {
      switch (cmd) {
        case 'constant_contact':
          this.constantContactVisible = true;
          break;
        case 'mail_chimp':
          this.mailChimpVisible = true;
          break;
        default:
          break;
      }
    },
    handleSave: function handleSave(title) {
      var _this9 = this;

      this.saveVisible = false;
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_10_graphql_tag___default()(_templateObject6),
        variables: {
          savedFilter: {
            title: title,
            filter: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.filterData),
            fields: this.fields,
            surveyId: this.filterData.survey_id
          }
        }
      }).then(function () {
        _this9.$notify({
          title: 'Success',
          message: 'Saved survey filter successfully.',
          type: 'success'
        });
        _this9.saveVisible = false;
      });
    },
    handleLoad: function handleLoad(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
          id = _ref2[0],
          filterData = _ref2[1],
          fields = _ref2[2];

      this.savedId = id;
      this.filterData = filterData;
      this.fields = fields;
      this.selectedDemographics = filterData.demographics.flatMap(function (d) {
        return d.choices.map(function (c) {
          return d.question_id + ':' + c;
        });
      });
      this.loadVisible = false;

      // selected demographic watcher will update the demographics and question
      // stages, the only one that won't update is the survey stage, lets to that now.
      this.handleCountStage('survey');
    },
    resetFilterData: function resetFilterData() {
      this.selectedDemographics = [];
      this.filterData.demographics = [];
      this.filterData.questions = [];
      this.fields = ['Mobile number'];
    },
    createCsv: function createCsv(data) {
      var headers = this.getCsvHeaders(data);
      var rows = this.getCsvRows(data, headers);
      var csvExporter = new __WEBPACK_IMPORTED_MODULE_13_export_to_csv__["ExportToCsv"]({
        headers: this.escapeCommas(headers),
        showLabels: true,
        filename: 'survey-filter-' + __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYYMMDDHHmmss')
      });
      csvExporter.generateCsv(rows);
    },
    getCsvRows: function getCsvRows(data, headers) {
      var _this10 = this;

      var rows = [];
      data.forEach(function (responses) {
        var missingRows = _this10.getCsvMissingResponseRows(responses, headers);
        var row = [];
        responses.forEach(function (response, i) {
          var missing = missingRows[i];
          if (missing) {
            row = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(row), ['N/A']);
          }
          row = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(row), [response.answer]);
        });
        rows = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(rows), [row]);
      });
      return rows;
    },
    getCsvHeaders: function getCsvHeaders(data) {
      var headers = [];
      data.forEach(function (responses) {
        responses.forEach(function (response) {
          var found = headers.find(function (h) {
            return h === response.question;
          });
          if (!found) {
            headers = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(headers), [response.question]);
          }
        });
      });
      return headers;
    },
    getCsvMissingResponseRows: function getCsvMissingResponseRows(responses, headers) {
      var missing = {};
      var missingIndex = 0;
      headers.forEach(function (h, i) {
        var found = responses.find(function (r) {
          if (h === r.question) return true;
          missingIndex = i;
          return false;
        });
        if (!found) {
          missing = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, missing, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, missingIndex, h));
        }
      });
      return missing;
    },
    escapeCommas: function escapeCommas(headers) {
      return headers.map(function (h) {
        return '"' + h + '"';
      });
    }
  },
  watch: {
    selectedDemographics: function selectedDemographics(value) {
      var extractValues = function extractValues(v) {
        var _v$split = v.split(':'),
            _v$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_v$split, 2),
            questionId = _v$split2[0],
            choiceId = _v$split2[1];

        return { questionId: questionId, choiceId: choiceId };
      };

      this.filterData.demographics = value.reduce(function (acc, v) {
        var _extractValues = extractValues(v),
            questionId = _extractValues.questionId,
            choiceId = _extractValues.choiceId;

        var demographic = acc.find(function (a) {
          return a.question_id === Number(questionId);
        });

        if (!demographic) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(acc), [{ question_id: Number(questionId), choices: [Number(choiceId)] }]);
        }

        demographic.choices.push(choiceId);

        return acc;
      }, []);
      this.handleDemographicsChanged();
    }
  }
});

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        {\n          surveysFilterListSaved {\n            id\n            title\n            insertedAt\n            filter\n            fields\n            user {\n              firstName\n              lastName\n            }\n            survey {\n              title\n            }\n          }\n        }\n      '], ['\n        {\n          surveysFilterListSaved {\n            id\n            title\n            insertedAt\n            filter\n            fields\n            user {\n              firstName\n              lastName\n            }\n            survey {\n              title\n            }\n          }\n        }\n      ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n                mutation($id: ID!) {\n                  surveysFilterDeleteSaved(id: $id)\n                }\n              '], ['\n                mutation($id: ID!) {\n                  surveysFilterDeleteSaved(id: $id)\n                }\n              ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyFilterLoadDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentSelection: null
    };
  },
  apollo: {
    $client: 'apiv2',
    surveysFilterListSaved: {
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject)
    }
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visiblity) {
        this.$emit('onVisibleChanged', visiblity);
      }
    },
    filterData: function filterData() {
      if (!this.surveysFilterListSaved) {
        return [];
      }
      return this.surveysFilterListSaved.map(function (s) {
        var fullName = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(s, 'user.firstName', ''), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(s, 'user.lastName', '')].join(' ');

        return {
          id: s.id,
          title: s.title,
          survey: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(s, 'survey.title', ''),
          insertedAt: __WEBPACK_IMPORTED_MODULE_2_moment___default()(s.insertedAt).format('YYYY-MM-DD'),
          user: fullName,
          filter: s.filter,
          fields: s.fields
        };
      });
    }
  },
  methods: {
    refresh: function refresh() {
      this.$apollo.queries.surveyFilterListSaved.refetch();
    },
    handleClose: function handleClose() {
      this.$emit('onVisibleChanged', false);
    },
    handleCurrentChange: function handleCurrentChange(change) {
      this.currentSelection = change;
    },
    handleLoad: function handleLoad() {
      var _this = this;

      // We want to ensure the handleCurrentChange runs
      // before we start the process of loading.
      setTimeout(function () {
        _this.$emit('onLoad', [_this.currentSelection.id, _this.currentSelection.filter, _this.currentSelection.fields]);
      }, 0);
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      // We want to ensure the handleCurrentChange runs
      // before we start the process of deleting.
      setTimeout(function () {
        _this2.$confirm('This will permenantly delete this filter. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(function () {
          _this2.$apollo.mutate({
            client: 'apiv2',
            mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
            variables: {
              id: _this2.currentSelection.id
            }
          }).then(function () {
            _this2.$notify({
              title: 'Success',
              message: 'Saved survey filter deleted.',
              type: 'success'
            });
            _this2.refresh();
          });
        });
      }, 0);
    }
  },
  watch: {
    isVisible: function isVisible(visibility) {
      if (visibility) {
        this.refresh();
      }
    }
  }
});

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyFilterSaveDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        title: ''
      },
      rules: {
        title: [{
          required: true,
          trigger: 'blur',
          message: 'Please enter a title for this survey filter.'
        }]
      }
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(visiblity) {
        this.$emit('onVisibleChanged', visiblity);
      }
    }
  },
  methods: {
    resetAndHideDialog: function resetAndHideDialog() {
      this.$refs.saveForm.resetFields();
      this.$emit('onVisibleChanged', false);
    },
    handleCancel: function handleCancel() {
      this.resetAndHideDialog();
    },
    handleSave: function handleSave() {
      var _this = this;

      this.$refs.saveForm.validate(function (valid) {
        if (!valid) {
          return false;
        }

        _this.$emit('onSave', _this.form.title);
        _this.resetAndHideDialog();
        return true;
      });
    }
  }
});

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_survey_mutation_types__ = __webpack_require__(346);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SurveyRespondentsDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    filtering: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('survey', ['respondents', 'loadingRespondents', 'respondentMoreUrl', 'respondentPageInfo']), {

    currentlyVisible: {
      get: function get() {
        return this.isVisible;
      },
      set: function set(newValue) {
        this.$emit('onVisiblityChange', newValue);

        if (!newValue) {
          this.$store.commit('survey/' + __WEBPACK_IMPORTED_MODULE_5__store_modules_survey_mutation_types__["z" /* CLEAR_SURVEY_RESPONDENTS */]);
        }
      }
    },

    getTableData: function getTableData() {
      var _this = this;

      var resp = this.respondents.map(function (respondent) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          id: respondent.id,
          uuid: respondent.uuid,
          dateAnswered: __WEBPACK_IMPORTED_MODULE_3_moment___default()(respondent.dateAnswered).format('lll'),
          mobileNumber: _this.formatMobileNumber(respondent.mobileNumber),
          answers: _this.getAnswers(respondent.answer)
        }, _this.mapProfiles(respondent.answer));
      });
      return resp;
    }
  }),
  methods: {
    handleCancel: function handleCancel() {
      this.currentlyVisible = false;
    },
    getAnswers: function getAnswers(answers) {
      return answers.map(function (answer) {
        return {
          input: answer.input,
          answer_id: answer.id,
          choice_id: answer.choice === null ? '' : answer.choice.id,
          is_profile: answer.question.isProfile,
          category_id: answer.question.categoryId,
          choices_ids: answer.choices.map(function (choice) {
            return choice.id;
          }),
          question_id: answer.question.id,
          choice_title: answer.choice === null ? '' : answer.choice.title,
          is_analytics: answer.question.isAnalytics,
          profile_field: answer.question.profileField,
          question_type: answer.question.questionType,
          choices_titles: answer.choices.map(function (choice) {
            return choice.title;
          }),
          question_title: answer.question.title
        };
      });
    },
    mapProfiles: function mapProfiles(respondent) {
      return respondent.filter(function (answer) {
        return answer.is_profile;
      }).reduce(function (acc, ans) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, ans.profile_field, ans.input ? ans.input : ans.choice_title));
      }, {});
    },
    formatMobileNumber: function formatMobileNumber(mobileNumber) {
      if (!mobileNumber) {
        return mobileNumber;
      }
      var num = mobileNumber.replace(/\D+/g, '');
      return num.substring(0, 3) + ' ' + num.substring(3, 6) + ' ' + num.substring(6, 10);
    },
    handleLoadMore: function handleLoadMore() {
      this.$store.dispatch('survey/getRespondents', this.filtering);
    }
  },
  watch: {
    filtering: function filtering() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filtering).length > 0) {
        this.$store.dispatch('survey/getRespondents', this.filtering);
      }
    }
  }
});

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taxonomies_json__ = __webpack_require__(3443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taxonomies_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__taxonomies_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TaxonomySelect',
  data: function data() {
    return {
      taxonomies: __WEBPACK_IMPORTED_MODULE_2__taxonomies_json___default.a,
      taxonomySelection: []
    };
  },
  props: {
    selectedTaxonomy: {
      type: String,
      default: null
    }
  },
  computed: {
    currentTaxonomy: {
      get: function get() {
        return this.selectedTaxonomy;
      },
      set: function set(newTaxonomy) {
        this.$emit('onTaxonomyChanged', newTaxonomy);
      }
    },

    /**
     * Create a list of taxonomies sorted by the parent group it falls under.
     * For example a group 'Education' has a child 'Language Learning'
     *
     * @returns {Array<Object>}
     */
    taxonomyGroups: function taxonomyGroups() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.taxonomies).map(function (key) {
        return {
          label: key,
          options: [{ label: key, value: key }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.taxonomies[key].map(function (taxonomy) {
            return {
              value: taxonomy,
              label: taxonomy
            };
          })))
        };
      });
    }
  }
});

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_permissions_Can__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeslotEdit',
  components: { Can: __WEBPACK_IMPORTED_MODULE_1__components_permissions_Can___default.a },
  data: function data() {
    return {
      savingTimeslot: false,
      timeslot: null
    };
  },

  props: ['weekdays', 'isNew'],
  created: function created() {
    var fields = ['id', 'title', 'colour', 'start_day', 'end_day', 'start_time', 'end_time', 'live'];

    /* eslint-disable indent */
    this.timeslot = !this.isNew ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(this.$store.state.timeslots.selectedTimeslot, fields) : fields.reduce(function (acc, f) {
      acc[f] = null;
      if (f === 'colour') acc[f] = '#683090';
      if (f === 'live') acc[f] = true;
      return acc;
    }, {});
    /* eslint-enable indent */
  },

  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    saveTimeslot: function saveTimeslot() {
      this.$emit('save', this.timeslot);
    }
  }
});

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeslotEdit__ = __webpack_require__(3083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeslotEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TimeslotEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_timeslots_mutation_types__ = __webpack_require__(347);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var trimLast = function trimLast(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  return str.slice(0, str.lastIndexOf(char));
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeslotsList',
  props: ['timeslots'],
  components: { TimeslotEdit: __WEBPACK_IMPORTED_MODULE_3__TimeslotEdit___default.a, Can: __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default.a },

  data: function data() {
    return {
      weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      showEditDialog: false,
      selectedTimeslot: null,
      isNewTimeslot: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('timeslots', ['saveTimeslotRequest', 'saveTimeslotSuccess'])),

  methods: {
    days: function days(row) {
      return [this.weekdays[row.start_day], this.weekdays[row.end_day]] // day range
      .map(function (x) {
        return x.slice(0, 3);
      }) // shorten to 3 chars
      .join(' to '); // Mon to Fri
    },
    times: function times(row) {
      return trimLast(row.start_time) + ' - ' + trimLast(row.end_time);
    },
    daysAndTimes: function daysAndTimes(row) {
      return this.days(row) + ', ' + this.times(row);
    },
    getCellStyle: function getCellStyle(row) {
      return {
        'background-color': row.colour
      };
    },
    editTimeslot: function editTimeslot(id) {
      this.isNewTimeslot = id === null;
      this.selectedTimeslot = this.timeslots.find(function (x) {
        return x.id === id;
      });
      this.showEditDialog = true;
      this.$store.commit('timeslots/' + __WEBPACK_IMPORTED_MODULE_4__store_modules_timeslots_mutation_types__["j" /* EDIT_TIMESLOT */], this.selectedTimeslot);
    },
    saveTimeslot: function saveTimeslot(slot) {
      this.$store.dispatch('timeslots/' + (this.isNewTimeslot ? 'create' : 'update') + 'Timeslot', slot);
    },
    deleteTimeslot: function deleteTimeslot(id) {
      var _this = this;

      this.$confirm('Are you sure you want to remove this Timeslot?').then(function () {
        _this.$store.dispatch('timeslots/deleteTimeslot', id);
      }).catch(function () {
        return null;
      }); // prevent uncaught exeptions warning in console...
    },
    handleTimeslotAction: function handleTimeslotAction(command) {
      /**
       * Executes the action by passing the item as parameter.
       *
       * @param {command}: object with actions and item properties
       */
      command.action(command.item);
    }
  },

  watch: {
    saveTimeslotRequest: function saveTimeslotRequest(val, oldVal) {
      if (val === oldVal) return;

      if (!val && this.saveTimeslotSuccess) {
        this.showEditDialog = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          message: 'Timeslot saved successfully'
        });
      }

      if (!val && !this.saveTimeslotSuccess) {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Unable to save timeslot. Please confirm all fields and try again.'
        });
      }
    }
  }
});

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditProfileForm',
  props: {
    user: {
      type: Object
    }
  },
  created: function created() {
    this.id = this.$store.state.user.me.id;
    this.email = this.$store.state.user.me.email;
    this.lastname = this.$store.state.user.me.last_name;
    this.firstname = this.$store.state.user.me.first_name;
    this.avatar = this.$store.state.user.me.avatar;
  },

  data: function data() {
    return {
      // ...mapState('user', ['']),
      id: null,
      email: null,
      lastname: null,
      firstname: null,
      avatar: null,
      myCroppa: {},
      avatar_blob: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isDisabled: function isDisabled() {
      var disable = true;
      if (this.email.trim() !== '' && this.lastname.trim() !== '' && this.firstname.trim() !== '') {
        disable = false;
      }
      return disable;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['updatingProfileSuccess', 'updatingProfileFailed'])),
  watch: {
    updatingProfileSuccess: function updatingProfileSuccess(newValue) {
      if (newValue === true) {
        this.$store.dispatch('toast/success', 'Your profile has been updated.');
      }
    },
    updatingProfileFailed: function updatingProfileFailed(newValue) {
      if (newValue) {
        this.$store.dispatch('toast/error', 'Your profile could not be updated.');
      }
    }
  },
  methods: {
    handleClickUpdate: function handleClickUpdate() {
      var _this = this;

      this.myCroppa.generateBlob(function (blob) {
        var form = new FormData();
        form.append('id', _this.id);
        form.append('email', _this.email);
        form.append('last_name', _this.lastname);
        form.append('first_name', _this.firstname);
        form.append('avatar', blob, 'avatar.jpg');
        var payload = { id: _this.id, form: form };
        _this.$store.dispatch('user/updateUserProfile', payload);
      }, 'image/jpeg', 0.7);
    }
  }
});

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_PasswordOnlyResetFormOnUserList__ = __webpack_require__(2888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_auth_PasswordOnlyResetFormOnUserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_auth_PasswordOnlyResetFormOnUserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_user_mutation_types__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permissions_Can__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserManage__ = __webpack_require__(3087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UserManage__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserList',
  props: ['users', 'groups'],
  components: { UserManage: __WEBPACK_IMPORTED_MODULE_3__UserManage___default.a, PasswordOnlyResetFormOnUserList: __WEBPACK_IMPORTED_MODULE_0__components_auth_PasswordOnlyResetFormOnUserList___default.a, Can: __WEBPACK_IMPORTED_MODULE_2__components_permissions_Can___default.a },
  data: function data() {
    return {
      dialogVisible: false,
      showUserManage: false,
      upratingCompany: false,
      selectedUser: null,
      loggedInUser: null,
      restPasswordDialogVisible: false,
      keyword: ''
    };
  },

  computed: {
    results: function results() {
      var _this = this;

      var users = this.users.filter(function (user) {
        return user.display_name.toLowerCase().indexOf(_this.keyword.toLowerCase()) > -1;
      });
      return users.length ? users : [];
    }
  },

  mounted: function mounted() {
    this.loggedInUser = this.$store.state.user.me;
  },
  beforeUpdate: function beforeUpdate() {
    this.loggedInUser = this.$store.state.user.me;
  },


  methods: {
    manageUser: function manageUser(user) {
      // for some reason ElementUI does not use the latest user object from the list.
      // If a user was updated, and then edited again, the form populated with old data.
      // Therefore we get the user with the same ID from the list. This should be the updated user.
      this.selectedUser = this.users.find(function (x) {
        return user && x.id === user.id;
      }) || {
        email: null,
        first_name: null,
        last_name: null,
        job_title: null,
        is_admin: false,
        groups: []
      };

      this.showUserManage = true;
    },
    showPasswordResetPopup: function showPasswordResetPopup(user) {
      this.selectedUser = user;
      this.$store.commit('user/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_user_mutation_types__["s" /* UPDATE_USER_PASSWORD_SUCCESS */], {
        userListSelectedUser: user
      });
      this.restPasswordDialogVisible = true;
    },
    deleteUser: function deleteUser(user) {
      var _this2 = this;

      this.selectedUser = user;
      this.$confirm('Are you sure you want to delete this User?').then(function () {
        _this2.$store.dispatch('user/deleteUser', _this2.selectedUser);
      }).catch(function () {
        return null;
      }); // prevent uncaught exeptions warning in console...
    },
    handleSaved: function handleSaved() {
      this.showUserManage = false;
      this.$notify({
        type: 'success',
        showClose: false,
        duration: 2500,
        title: 'Success',
        message: 'User saved sucessfully'
      });
    },
    handleSaveError: function handleSaveError() {
      this.$notify({
        type: 'error',
        showClose: false,
        duration: 2500,
        title: 'Error',
        message: 'Please ensure that the email address provided is not already in use.'
      });
    }
  }
});

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserManage',
  props: ['groups', 'user', 'loggedInUser'],

  data: function data() {
    return {
      savingUser: false,
      localUser: {},
      rules: {
        email: [{ required: true, message: 'Please provide an email address' }],
        first_name: [{ required: true, message: 'Please provide a name' }],
        last_name: [{ required: true, message: 'Please provide a surname' }],
        job_title: [{ required: true, message: 'Job title is required' }],
        groups: [{ required: true, message: 'Please assign at least one group' }]
      },
      groupRoles: {
        1: { title: 'Company Admin', role: 2 },
        2: { title: 'Organisation Admin', role: 2 },
        3: { title: 'Regular User', role: 1 }
      },
      tagInputVisible: false,
      tagInputValue: ''
    };
  },

  mounted: function mounted() {
    /**
     * Deep copy user for for the form so that state is not directly mutated in child component
     */
    this.localUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.user);
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('user', ['updateCompanyUserRequest', 'updateCompanyUserSucceeded'])),

  methods: {
    handleFormSave: function handleFormSave() {
      var _this = this;

      this.$refs.localUser.validate(function (valid) {
        if (valid) return _this.saveUser();
        return false;
      });
    },
    saveUser: function saveUser() {
      this.handleUserRole();
      return this.$store.dispatch('user/saveUser', this.localUser);
    },
    cancel: function cancel() {
      this.$emit('cancelled');
    },
    handleUserRole: function handleUserRole() {
      var groups = this.localUser.groups;
      this.localUser.role = groups.length > 1 ? this.groupRoles[Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(groups))].role : this.groupRoles[groups[0]].role;
    },
    handleShowTagInput: function handleShowTagInput() {
      var _this2 = this;

      this.tagInputVisible = true;
      this.$nextTick(function () {
        _this2.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleCloseTag: function handleCloseTag(tag) {
      var index = this.localUser.tags.indexOf(tag);
      this.localUser.tags.splice(index, 1);
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tagInputValue;

      // Ensure tags is a list, on old users it may be null
      if (!this.localUser.tags) {
        this.localUser.tags = [];
      }

      if (inputValue) {
        this.localUser.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    }
  },

  watch: {
    updateCompanyUserRequest: function updateCompanyUserRequest(val, oldVal) {
      if (val !== oldVal && val) {
        this.savingUser = true;
      }

      if (!val) {
        this.savingUser = false;
        this.$emit(this.updateCompanyUserSucceeded ? 'saved' : 'saveError', this.user);
      }
    }
  }
});

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_automatedemails_templates_TemplateEditor__ = __webpack_require__(2895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_automatedemails_templates_TemplateEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_automatedemails_templates_TemplateEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateGetQuery_gql__ = __webpack_require__(2584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateGetQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateGetQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmailComposerContainer',
  computed: {
    editing: function editing() {
      return this.$router.currentRoute.params.id !== 'new';
    }
  },
  data: function data() {
    return {
      template: {
        name: null
      },
      loading: false
    };
  },
  components: {
    TemplateEditor: __WEBPACK_IMPORTED_MODULE_3__components_automatedemails_templates_TemplateEditor___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_common_Loader___default.a
  },
  mounted: function mounted() {
    if (this.editing) this.getEmail();
  },

  methods: {
    handleBack: function handleBack() {
      this.$router.back();
    },
    handleSave: function handleSave(_ref) {
      var _this = this;

      var id = _ref.id,
          email = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id']);

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql___default.a,
        variables: { id: id, data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, email) }
      }).then(function () {
        _this.$notify({
          title: 'Success!',
          message: 'Template successfully updated!',
          type: 'success'
        });

        _this.$router.push({ path: '/admin/templates' });
      }).catch(function (err) {
        _this.$message.error('Something went wrong -- ' + err.message);
      });
    },
    handleCancel: function handleCancel() {
      var path = '/admin/templates';
      this.$router.push({ path: path });
    },
    getEmail: function getEmail() {
      var _this2 = this;

      this.loading = true;
      var id = parseInt(this.$router.currentRoute.params.id, 10);
      this.$apollo.query({
        client: 'apiv2',
        query: __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateGetQuery_gql___default.a,
        variables: {
          id: id
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.template = data.template;
        _this2.template.id = parseInt(_this2.template.id, 10);
        _this2.loading = false;
      });
    }
  }
});

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_automatedemails_templates_TemplateList__ = __webpack_require__(2896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_automatedemails_templates_TemplateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_automatedemails_templates_TemplateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_automatedemails_templates_emailTemplateList_gql__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_automatedemails_templates_emailTemplateList_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_automatedemails_templates_emailTemplateList_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql__);

//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmailDashboardContainer',
  components: {
    TemplateList: __WEBPACK_IMPORTED_MODULE_2__components_automatedemails_templates_TemplateList___default.a
  },
  apollo: {
    $client: 'apiv2',
    templates: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_automatedemails_templates_emailTemplateList_gql___default.a,
      prefetch: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'])),
  mounted: function mounted() {
    this.$apollo.queries.templates.refetch();
  },

  methods: {
    redirect: function redirect() {
      this.$notify({
        title: 'Success!',
        message: 'Email successfully created!',
        type: 'success'
      });

      this.$router.push({ path: '/admin/templates' });
    },
    handleOnSave: function handleOnSave(email) {
      var _this = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_automatedemails_templates_emailTemplateUpdateMutation_gql___default.a,
        variables: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, email)
      }).then(function () {
        return _this.redirect();
      }).catch(function (err) {
        return _this.$message.error('Something went wrong -- ' + err.message);
      });
    }
  }
});

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_StationActivityDashboard__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_StationActivityDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_StationActivityDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__ = __webpack_require__(345);

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StationActivityContainer',
  components: {
    StationActivityDashboard: __WEBPACK_IMPORTED_MODULE_2__components_admin_StationActivityDashboard___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('stationactivity', ['region', 'startDate', 'endDate', 'stationActivityData', 'loadingStationActivity']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'])),

  mounted: function mounted() {
    this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["e" /* GET_STATION_ACTIVITY */]);
    this.$store.dispatch('stationactivity/getStationActivity', {
      startDate: this.startDate,
      endDate: this.endDate
    });
  },


  methods: {
    handleChangeRegion: function handleChangeRegion(event) {
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["b" /* SET_STATION_ACTIVITY_REGION */], event.region);
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["e" /* GET_STATION_ACTIVITY */]);
      this.$store.dispatch('stationactivity/getStationActivity');
    },
    handleChangeDate: function handleChangeDate(event) {
      if (this.startDate === event.startDate && this.endDate === event.endDate) return;

      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["c" /* SET_STATION_ACTIVITY_START_DATE */], event.startDate);
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["d" /* SET_STATION_ACTIVITY_END_DATE */], event.endDate);
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["e" /* GET_STATION_ACTIVITY */]);
      this.$store.dispatch('stationactivity/getStationActivity');
    },
    handleChangePage: function handleChangePage(offset) {
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["a" /* SET_STATION_ACTIVITY_OFFSET */], offset);
      this.$store.commit('stationactivity/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_stationactivity_mutation_types__["e" /* GET_STATION_ACTIVITY */]);
      this.$store.dispatch('stationactivity/getStationActivity');
    }
  }
});

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_AfstereoDashboard__ = __webpack_require__(2855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_AfstereoDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_analytics_AfstereoDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__ = __webpack_require__(340);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AfstereoContainer',
  components: {
    AfstereoDashboard: __WEBPACK_IMPORTED_MODULE_2__components_analytics_AfstereoDashboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('afstereo', ['selectedDate', 'selectedPeriod', 'selectedStation', 'chartsData', 'stations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('plugin', ['plugins'])),
  mounted: function mounted() {
    this.$store.dispatch('afstereo/getCharts');
    this.$store.dispatch('afstereo/getStations');
  },

  methods: {
    handlePrevious: function handlePrevious(event) {
      this.$store.commit('afstereo/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__["b" /* SUBTRACT_AFSTEREO_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    handleNext: function handleNext(event) {
      this.$store.commit('afstereo/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__["a" /* ADD_AFSTEREO_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    handleChangePeriod: function handleChangePeriod(event) {
      if (this.selectedPeriod === event.unit) return;

      this.$store.commit('afstereo/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__["d" /* SET_AFSTEREO_PERIOD */], { period: event.unit });
      this.$store.commit('afstereo/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__["l" /* RESET_AFSTEREO_STATIONS_AREA */]);
      this.$store.dispatch('afstereo/getCharts');
    },
    handleChangeStation: function handleChangeStation(event) {
      this.$store.commit('afstereo/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_afstereo_mutation_types__["e" /* SET_AFSTEREO_STATION */], {
        station: event.station
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    isPluginEnabled: function isPluginEnabled(pluginPermissions) {
      var permissions = this.plugins.filter(function (plugin) {
        return plugin.plugin_route === pluginPermissions;
      }).length;
      return permissions >= 1;
    }
  }
});

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_analytics_AudienceDashboard__ = __webpack_require__(2856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_analytics_AudienceDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_analytics_AudienceDashboard__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudienceContainer',
  components: {
    AudienceDashboard: __WEBPACK_IMPORTED_MODULE_0__components_analytics_AudienceDashboard___default.a
  }
});

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_EngagementsDashboard__ = __webpack_require__(2857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_EngagementsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_analytics_EngagementsDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__ = __webpack_require__(191);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EngagementsContainer',
  components: {
    EngagementsDashboard: __WEBPACK_IMPORTED_MODULE_2__components_analytics_EngagementsDashboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('analytics', ['selectedDate', 'selectedPeriod', 'selectedFilter', 'chartsData', 'mainChartData'])),
  mounted: function mounted() {
    this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["f" /* SET_ANALYTICS_TIMESLOT */], { timeslot: 0 });
    this.loadCharts();
  },

  methods: {
    loadCharts: function loadCharts() {
      this.$store.dispatch('analytics/getCharts');
      this.$store.dispatch('analytics/getMainChart');
    },
    handlePrevious: function handlePrevious(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["b" /* SUBTRACT_ANALYTICS_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.loadCharts();
    },
    handleNext: function handleNext(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["a" /* ADD_ANALYTICS_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.loadCharts();
    },
    handleChangePeriod: function handleChangePeriod(event) {
      if (this.selectedPeriod === event.unit) return;
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["d" /* SET_ANALYTICS_PERIOD */], {
        period: event.unit
      });
      this.loadCharts();
    },
    handleChangeFilter: function handleChangeFilter(event) {
      if (this.selectedFilter === event.filter) return;
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["e" /* SET_ANALYTICS_FILTER */], {
        filter: event.filter
      });
      this.$store.dispatch('analytics/getMainChart');
    },
    handleChangeDate: function handleChangeDate(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["c" /* SET_ANALYTICS_DATE */], { date: event.date });
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_analytics_mutation_types__["d" /* SET_ANALYTICS_PERIOD */], {
        period: event.period
      });
      this.loadCharts();
    }
  }
});

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_ProgrammingDashboard__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_analytics_ProgrammingDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_analytics_ProgrammingDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_analytics_audienceQuery_gql__ = __webpack_require__(2569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_analytics_audienceQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_analytics_audienceQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_analytics_programmingDashboardQuery_gql__ = __webpack_require__(2576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_analytics_programmingDashboardQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_analytics_programmingDashboardQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_analytics_programmingDashboardBasicQuery_gql__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_analytics_programmingDashboardBasicQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_analytics_programmingDashboardBasicQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_analytics_streamingLoadQuery_gql__ = __webpack_require__(2577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_analytics_streamingLoadQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_analytics_streamingLoadQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__ = __webpack_require__(1142);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var numberBetween = function numberBetween(num, a, b) {
  return a <= num && b >= num;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgrammingDashboardContainer',
  components: {
    ProgrammingDashboard: __WEBPACK_IMPORTED_MODULE_2__components_analytics_ProgrammingDashboard___default.a
  },

  data: function data() {
    return {
      afstereoDataNotFound: false,
      promotionsData: [],
      commercialLoadData: [],
      musicalLoadData: [],
      messagesData: {},
      contentThreadsData: [],
      topTracksData: [],
      audienceProfileData: {},
      selectedProgrammingDate: new Date(),
      selectedStation: null,
      selectedProgrammingPeriod: 'month',
      streamingPeriod: 'week',
      dataLoading: false,
      audienceDataLoading: true,
      loadingStreamingData: false,
      streamingData: { streaming: { averageListeners: [], averageListenersTrimester: [] } }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('analytics', ['selectedDate', 'selectedPeriod', 'selectedFilter', 'selectedTimeslot', 'chartsData', 'mainChartData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('user', ['me']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('timeslots', ['timeslots', 'loadingTimeslots']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('afstereo', ['stations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('timeslots', ['activeTimeslots']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])('plugin', ['plugins', 'loadingPlugins']), {
    activeRange: function activeRange() {
      var nowMoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.selectedProgrammingDate);
      var start = nowMoment.startOf(this.selectedProgrammingPeriod).format('YYYY-MM-DD');
      var end = nowMoment.endOf(this.selectedProgrammingPeriod).format('YYYY-MM-DD');

      return { start: start, end: end };
    },
    filtersLoading: function filtersLoading() {
      return this.loadingTimeslots;
    },
    loadingMessage: function loadingMessage() {
      if (this.loadingTimeslots) return 'Fetching Timeslots';
      if (this.loadingData) return 'Fetching Data';

      return 'Loading Data';
    },
    afstereoPluginEnabled: function afstereoPluginEnabled() {
      return this.isPluginEnabled('app.dashboard.afstereo');
    },
    query: function query() {
      if (this.afstereoPluginEnabled) return __WEBPACK_IMPORTED_MODULE_6__graphql_analytics_programmingDashboardQuery_gql___default.a;
      return __WEBPACK_IMPORTED_MODULE_7__graphql_analytics_programmingDashboardBasicQuery_gql___default.a;
    }
  }),

  mounted: function mounted() {
    this.$store.dispatch('timeslots/getTimeslots');
    this.$store.dispatch('afstereo/getStations');
    this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["f" /* SET_ANALYTICS_TIMESLOT */], {
      timeslot: 0
    });
    this.loadCharts();
  },

  methods: {
    loadCharts: function loadCharts() {
      this.$store.dispatch('analytics/getCharts');
      this.$store.dispatch('analytics/getMainChart');
    },
    handlePrevious: function handlePrevious(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["b" /* SUBTRACT_ANALYTICS_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.loadCharts();
      this.fetchDashboardData();
    },
    handleNext: function handleNext(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["a" /* ADD_ANALYTICS_DATE */], {
        period: event.unit,
        amount: 1
      });
      this.loadCharts();
      this.fetchDashboardData();
    },
    handleChangeFilter: function handleChangeFilter(event) {
      if (this.selectedFilter === event.filter) return;
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["e" /* SET_ANALYTICS_FILTER */], {
        filter: event.filter
      });
      this.$store.dispatch('analytics/getMainChart');
    },
    handleChangeDate: function handleChangeDate(event) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["c" /* SET_ANALYTICS_DATE */], { date: event.date });
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["d" /* SET_ANALYTICS_PERIOD */], {
        period: event.period
      });
      this.loadCharts();
      this.fetchDashboardData();
    },
    isPluginEnabled: function isPluginEnabled(pluginPermissions) {
      var permissions = this.plugins.filter(function (plugin) {
        return plugin.plugin_route === pluginPermissions;
      }).length;
      return permissions >= 1;
    },
    handleDateChange: function handleDateChange(val) {
      this.fetchDashboardData();
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["c" /* SET_ANALYTICS_DATE */], { date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(val) });
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["d" /* SET_ANALYTICS_PERIOD */], {
        period: this.selectedPeriod
      });
      this.loadCharts();
    },
    handleTimeslotChange: function handleTimeslotChange(val) {
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["f" /* SET_ANALYTICS_TIMESLOT */], {
        timeslot: val
      });
      this.loadCharts();
      this.fetchDashboardData();
    },
    handlePeriodChange: function handlePeriodChange(val) {
      if (this.selectedPeriod === val) return;
      this.$store.commit('analytics/' + __WEBPACK_IMPORTED_MODULE_1__store_modules_analytics_mutation_types__["d" /* SET_ANALYTICS_PERIOD */], {
        period: val
      });
      this.loadCharts();
      this.fetchDashboardData();
    },
    handleStationChange: function handleStationChange(val) {
      this.selectedStation = val;
      this.fetchDashboardData();
    },


    /**
     * Gets this first timeslot matching the current time or null if none is found
     */
    getTimeslotForCurrentDateTime: function getTimeslotForCurrentDateTime() {
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var nowStr = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
      var weekday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().isoWeekday() - 1;

      var timeslot = this.activeTimeslots.find(function (x) {
        if (!numberBetween(weekday, x.start_day, x.end_day)) return false;
        var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(nowStr + ' ' + x.start_time);
        var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(nowStr + ' ' + x.end_time);
        return now.isBetween(start, end, 'second', '[]');
      });

      return timeslot && timeslot.id ? timeslot.id : null;
    },
    fetchDashboardData: function fetchDashboardData() {
      var _this = this;

      this.dataLoading = true;
      this.audienceDataLoading = true;
      var variables = {
        timeslotId: this.selectedTimeslot,
        date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.selectedDate).format('YYYY-MM-DD'),
        unit: this.selectedPeriod
      };

      if (this.selectedStation) {
        variables = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, variables, { playoutCompare: this.selectedStation });
      }

      this.$apollo.query({
        client: 'apiv2',
        query: __WEBPACK_IMPORTED_MODULE_5__graphql_analytics_audienceQuery_gql___default.a,
        fetchPolicy: 'network-only',
        variables: variables
      }).then(function (result) {
        _this.audienceProfileData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["a" /* getAudienceData */])(result.data);
        _this.audienceDataLoading = false;
      }).catch(function () {
        _this.audienceDataLoading = false;
      });

      this.$apollo.query({
        query: this.query,
        fetchPolicy: 'network-only',
        variables: variables
      }).then(function (result) {
        _this.messagesData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["b" /* getMessageData */])(result.data.programmingDashboard);
        _this.commercialLoadData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["c" /* getCommercialLoadData */])(result.data.programmingDashboard);
        _this.musicalLoadData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["d" /* getMusicalLoadData */])(result.data.programmingDashboard);
        _this.topTracksData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["e" /* getTopTracksData */])(result.data.programmingDashboard);
        _this.contentThreadsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["f" /* getContentThreadsData */])(result.data.programmingDashboard);
        _this.promotionsData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programmingDashboardUtils__["g" /* getPromotionsData */])(result.data.programmingDashboard);

        _this.dataLoading = false;
      }).catch(function (error) {
        _this.afstereoDataNotFound = error.message.includes('Station matching query does not exist.');
        _this.dataLoading = false;
      });
      this.fetchStreamingData();
    },
    fetchStreamingData: function fetchStreamingData() {
      var _this2 = this;

      this.loadingStreamingData = true;
      this.$apolloProvider.clients.apiv2.query({
        query: __WEBPACK_IMPORTED_MODULE_8__graphql_analytics_streamingLoadQuery_gql___default.a,
        fetchPolicy: 'network-only',
        variables: {
          date: this.getStreamingDate().selectedDate,
          unit: this.getStreamingDate().unit,
          filter: this.streamingPeriod
        }
      }).then(function (result) {
        _this2.streamingData = result.data.programmingDashboard;
        _this2.loadingStreamingData = false;
      }).catch(function (error) {
        _this2.afstereoDataNotFound = error.message.includes('Streaming data not found');
        _this2.loadingStreamingData = false;
      });
    },
    getStreamingDate: function getStreamingDate() {
      return {
        unit: this.selectedPeriod,
        selectedDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.selectedDate).format('YYYY-MM-DD')
      };
    },
    handleStreamingPeriodChange: function handleStreamingPeriodChange(streamingPeriod) {
      this.streamingPeriod = streamingPeriod;
      this.fetchStreamingData();
    }
  },

  watch: {
    activeTimeslots: function activeTimeslots() {
      this.fetchDashboardData();
    },
    plugins: function plugins() {
      this.fetchDashboardData();
    }
  }
});

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_analytics_voiceIntelligence_VoiceIntelligenceDashboard__ = __webpack_require__(2873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_analytics_voiceIntelligence_VoiceIntelligenceDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_analytics_voiceIntelligence_VoiceIntelligenceDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_voiceintelligence_transcriptListQuery_gql__ = __webpack_require__(2650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_voiceintelligence_transcriptListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__graphql_voiceintelligence_transcriptListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_voiceintelligence_timeslotListQuery_gql__ = __webpack_require__(2648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_voiceintelligence_timeslotListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_voiceintelligence_timeslotListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_voiceintelligence_transcriptAnalyticsQuery_gql__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_voiceintelligence_transcriptAnalyticsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_voiceintelligence_transcriptAnalyticsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_voiceintelligence_approveTranscriptMutation_gql__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_voiceintelligence_approveTranscriptMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_voiceintelligence_approveTranscriptMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_voiceintelligence_flagTranscriptMutation_gql__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_voiceintelligence_flagTranscriptMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_voiceintelligence_flagTranscriptMutation_gql__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VoiceIntelligenceContainer',
  components: { VoiceIntelligenceDashboard: __WEBPACK_IMPORTED_MODULE_3__components_analytics_voiceIntelligence_VoiceIntelligenceDashboard___default.a, ExportToCsv: __WEBPACK_IMPORTED_MODULE_2_export_to_csv__["ExportToCsv"] },
  apollo: {
    transcripts: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_4__graphql_voiceintelligence_transcriptListQuery_gql___default.a,
      variables: function variables() {
        return {
          timeslotid: this.selectedTimeslot
        };
      },
      skip: function skip() {
        return this.selectedTimeslot === '0';
      },
      result: function result(_ref) {
        var data = _ref.data;

        if (data && data.transcripts) {
          this.transcripts = data.transcripts;
        }
      },

      fetchPolicy: 'network-only'
    },
    timeslots: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_5__graphql_voiceintelligence_timeslotListQuery_gql___default.a,
      result: function result(_ref2) {
        var data = _ref2.data;

        if (data && data.timeslots) {
          this.timeslots = data.timeslots;
        }
      }
    },
    transcriptAnalytics: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_voiceintelligence_transcriptAnalyticsQuery_gql___default.a,
      variables: function variables() {
        return {
          timeslotid: this.selectedTimeslot,
          dayOffset: this.periodOffsets.Day,
          weekOffset: this.periodOffsets.Week,
          monthOffset: this.periodOffsets.Month,
          yearOffset: this.periodOffsets.Year
        };
      },
      skip: function skip() {
        return this.selectedTimeslot === '0';
      },
      result: function result(_ref3) {
        var data = _ref3.data;

        if (data && data.transcriptAnalytics) {
          this.transcriptAnalytics = data.transcriptAnalytics;
        }
      },

      fetchPolicy: 'network-only'
    }
  },
  methods: {
    handleApproveQuery: function handleApproveQuery(query) {
      var _this = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_7__graphql_voiceintelligence_approveTranscriptMutation_gql___default.a,
        variables: {
          query: {
            interactionId: query.id,
            approveStatus: query.approveStatus,
            approvedById: query.approvedById,
            approvedBy: query.approvedBy,
            approveReason: query.reason
          }
        }
      }).then(function () {
        _this.$apollo.queries.transcripts.refetch();
        _this.$apollo.queries.transcriptAnalytics.refetch();
        _this.$notify({
          type: 'success',
          message: 'Voice note approved for on-air use'
        });
      }).catch(function () {
        _this.$notify({
          type: 'error',
          message: 'Failed to approve voice note for on-air use'
        });
      });
    },
    handleBulkApproveQuery: function handleBulkApproveQuery(transcripts) {
      var _this2 = this;

      var mutations = transcripts.map(function (transcript) {
        var query = {
          interactionId: transcript.interactionId.id,
          approveStatus: transcript.approveStatus,
          approvedById: transcript.approvedById,
          approvedBy: transcript.approvedBy,
          approveReason: transcript.approveReason
        };

        return _this2.$apollo.mutate({
          client: 'apiv2',
          mutation: __WEBPACK_IMPORTED_MODULE_7__graphql_voiceintelligence_approveTranscriptMutation_gql___default.a,
          variables: {
            query: query
          }
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(mutations).then(function () {
        _this2.$apollo.queries.transcripts.refetch();
        _this2.$apollo.queries.transcriptAnalytics.refetch();
        _this2.$notify({
          type: 'success',
          message: transcripts.length + ' voice notes approved'
        });
      }).catch(function (error) {
        _this2.$notify({
          type: 'error',
          message: 'Failed to approve one or more voice notes ' + error
        });
      });
    },
    handleFlagQuery: function handleFlagQuery(query) {
      var _this3 = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_8__graphql_voiceintelligence_flagTranscriptMutation_gql___default.a,
        variables: {
          query: {
            interactionId: query.id,
            flagStatus: query.flagStatus,
            flaggedById: query.flaggedById,
            flaggedBy: query.flaggedBy,
            flagReason: query.reason
          }
        }
      }).then(function () {
        _this3.$apollo.queries.transcripts.refetch();
        _this3.$apollo.queries.transcriptAnalytics.refetch();
        _this3.$notify({
          type: query.flagStatus ? 'warning' : 'success',
          message: 'Voice note ' + query.action + ' for review'
        });
      }).catch(function (error) {
        _this3.$notify({
          type: 'error',
          message: 'Failed to flag Transcript ' + error
        });
      });
    },
    handleSelectedTimeslotQuery: function handleSelectedTimeslotQuery(timeslotId) {
      this.selectedTimeslot = timeslotId;
      this.periodOffsets = { Day: 0, Week: 0, Month: 0, Year: 0 };
    },
    handleRefreshTranscripts: function handleRefreshTranscripts() {
      this.periodOffsets = { Day: 0, Week: 0, Month: 0, Year: 0 };
      this.$apollo.queries.transcripts.refetch();
      this.$apollo.queries.transcriptAnalytics.refetch();
    },
    handleExportSelectedQuery: function handleExportSelectedQuery(transcripts) {
      var options = {
        filename: 'voice_notes_export_' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYYMMDDHHmmss'),
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        headers: ['#', 'Sender', 'Date Created', 'Transcript', 'Tags', 'Tone', 'Score', 'Topics', 'Sentiment', 'AudioUrl']
      };

      var csvExporter = new __WEBPACK_IMPORTED_MODULE_2_export_to_csv__["ExportToCsv"](options);

      var data = transcripts.map(function (transcript, index) {
        return {
          '#': index + 1,
          Sender: transcript.sender,
          'Date Created': transcript.timestamp,
          Transcript: transcript.transcript,
          Tags: transcript.tags.join(', '),
          Tone: transcript.tone,
          Score: transcript.score,
          Topics: transcript.topics.join(', '),
          Sentiment: transcript.sentiment,
          AudioUrl: transcript.audioUrl
        };
      });

      csvExporter.generateCsv(data);
    },
    handlePeriodShift: function handlePeriodShift(_ref4) {
      var unit = _ref4.unit,
          direction = _ref4.direction;

      if (direction === 'previous') {
        this.periodOffsets[unit] -= 1;
      } else {
        this.periodOffsets[unit] += 1;
      }
      this.$apollo.queries.transcriptAnalytics.refetch();
    }
  },
  data: function data() {
    return {
      transcripts: [],
      timeslots: [],
      transcriptAnalytics: null,
      loadingTranscripts: false,
      loadingTimeslots: false,
      selectedTimeslot: '0',
      periodOffsets: {
        Day: 0,
        Week: 0,
        Month: 0,
        Year: 0
      }
    };
  }
});

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_addContactAccount_gql__ = __webpack_require__(2588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_addContactAccount_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_contacts_addContactAccount_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_contacts_contactAccountsList_gql__ = __webpack_require__(2589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_contacts_contactAccountsList_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_contacts_contactAccountsList_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_mailChimpAccessToken_gql__ = __webpack_require__(2591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_mailChimpAccessToken_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_contacts_mailChimpAccessToken_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_audience_ContactsDashboard__ = __webpack_require__(2885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_audience_ContactsDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_audience_ContactsDashboard__);





//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactsContainer',
  components: {
    ContactsDashboard: __WEBPACK_IMPORTED_MODULE_9__components_audience_ContactsDashboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])('user', ['me'], 'contacts')),
  data: function data() {
    return {
      contactAccounts: [],
      dialogVisible: true
    };
  },
  apollo: {
    $client: 'apiv2',
    contactAccounts: {
      query: __WEBPACK_IMPORTED_MODULE_7__graphql_contacts_contactAccountsList_gql___default.a,
      prefetch: true
    }
  },
  mounted: function mounted() {
    if (this.$route.params) {
      switch (this.$route.params.authProvider) {
        case 'constant_contact':
          this.addConstantContactAccount();
          break;
        case 'mail_chimp':
          this.addMailChimpAccount();
          break;
        default:
          break;
      }
    }
  },

  methods: {
    addConstantContactAccount: function addConstantContactAccount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _this.parseHashParams(_this.$route.hash);
                _context.next = 3;
                return _this.addContactAccount(params.access_token, _this.$route.params.authProvider);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addMailChimpAccount: function addMailChimpAccount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var code, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                code = _this2.$route.query.code;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$apollo.query({
                  $client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_8__graphql_contacts_mailChimpAccessToken_gql___default.a,
                  variables: {
                    code: code
                  }
                });

              case 4:
                res = _context2.sent;
                _context2.next = 7;
                return _this2.addContactAccount(res.data.accessToken.accessToken, _this2.$route.params.authProvider);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this2.$notify({
                  title: 'Error!',
                  message: 'Something went wrong while fetching access token.',
                  type: 'error'
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9]]);
      }))();
    },
    addContactAccount: function addContactAccount(bearerToken, provider) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.$apollo.mutate({
                  $client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_contacts_addContactAccount_gql___default.a,
                  variables: {
                    bearerToken: bearerToken,
                    provider: provider
                  }
                });

              case 3:
                _this3.$notify({
                  title: 'Success!',
                  message: 'Contact account has succesfully been added!',
                  type: 'success'
                });
                _context3.next = 6;
                return _this3.refetchContactAccounts();

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                _this3.$notify({
                  title: 'Error!',
                  message: 'Unable to save contact account: does account already exist?',
                  type: 'error'
                });

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8]]);
      }))();
    },
    refetchContactAccounts: function refetchContactAccounts() {
      this.$apollo.queries.contactAccounts.refresh();
    },
    parseHashParams: function parseHashParams(string) {
      var dict = {};
      var paramString = string.replace('#', '');
      var params = paramString.split('&');
      for (var i = 0; i < params.length; i += 1) {
        var _params$i$split = params[i].split('='),
            _params$i$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_params$i$split, 2),
            key = _params$i$split2[0],
            val = _params$i$split2[1];

        dict = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val), dict);
      }
      return dict;
    }
  }
});

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_LoginForm__ = __webpack_require__(2887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_LoginForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_LoginForm__);

//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoginContainer',
  components: {
    LoginForm: __WEBPACK_IMPORTED_MODULE_2__components_auth_LoginForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['loginPending', 'loginFailed', 'loginSucceeded', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('user', ['me'])),
  methods: {
    onLogin: function onLogin(event) {
      this.$store.dispatch('auth/login', {
        email: event.email,
        password: event.password
      });
    }
  },
  watch: {
    me: function me() {
      if (this.me) {
        this.$router.push({ name: 'Dashboard' });
      }
    },
    isLoggedIn: function isLoggedIn() {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'Dashboard' });
      }
    }
  }
});

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordResetForm__ = __webpack_require__(2889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordResetForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordResetForm__);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordResetContainer',
  components: {
    PasswordResetForm: __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordResetForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['passwordResetPending', 'passwordResetFailed', 'passwordResetSucceeded'])),
  methods: {
    onPasswordReset: function onPasswordReset(event) {
      this.$store.dispatch('auth/resetPassword', event);
    }
  }
});

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordRestWithTokenForm__ = __webpack_require__(2890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordRestWithTokenForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordRestWithTokenForm__);

//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordRestWithTokenContainer',
  components: {
    PasswordRestWithTokenForm: __WEBPACK_IMPORTED_MODULE_2__components_auth_PasswordRestWithTokenForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['passwordResetPending', 'passwordResetFailed', 'passwordResetSucceeded']))
});

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignDetail__ = __webpack_require__(2902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Loader__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_interaction_ThreadDialog__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_interaction_ThreadDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_interaction_ThreadDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_interaction_mutation_types__ = __webpack_require__(76);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            onInteraction {\n              id\n              campaignId\n              channelId\n              companyId\n              threadId\n              dateCreated\n              dateUpdated\n              direction\n              flagBlacklisted\n              flagComment\n              flagFavourite\n              flagFraud\n              flagSafe\n              flagUnsafe\n              flagWinner\n              ore\n              tags\n              type\n              inCount\n              outCount\n            }\n          }\n        '], ['\n          subscription {\n            onInteraction {\n              id\n              campaignId\n              channelId\n              companyId\n              threadId\n              dateCreated\n              dateUpdated\n              direction\n              flagBlacklisted\n              flagComment\n              flagFavourite\n              flagFraud\n              flagSafe\n              flagUnsafe\n              flagWinner\n              ore\n              tags\n              type\n              inCount\n              outCount\n            }\n          }\n        ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignDetailContainer',
  components: {
    CampaignDetail: __WEBPACK_IMPORTED_MODULE_4__components_campaign_CampaignDetail___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__components_common_Loader___default.a,
    ThreadDialog: __WEBPACK_IMPORTED_MODULE_6__components_interaction_ThreadDialog___default.a
  },
  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onInteraction: {
        query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
        result: function result(response) {
          this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_7__store_modules_interaction_mutation_types__["d" /* NEW_INTERACTION_RECEIVED */], response.data.onInteraction);
        }
      }
    }
  },
  data: function data() {
    return {
      id: null,
      campaign: null
    };
  },

  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.$store.dispatch('campaign/getCampaignDetail', this.id);
    this.$store.dispatch('analytics/getCampaignReport', this.id);
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['icons', 'channelTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('campaign', ['campaignDetail', 'replyMessages', 'loadingCampaignDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('interaction', ['interactions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('analytics', ['campaignReportData', 'loadingCampaignReport']), {
    replyMessage: function replyMessage() {
      var _this = this;

      var message = this.replyMessages.filter(function (replyMessage) {
        return replyMessage.campaign === _this.campaign.id;
      });
      if (message.length) {
        return '"' + message[0].text + '"';
      }
      return 'No reply message set';
    }
  }),

  methods: {
    onDownloadMessage: function onDownloadMessage(event) {
      var payload = {
        campaign_id: event.campaign_id,
        date_from: event.date_from,
        unique_originators: false,
        file_name: event.file_name,
        date_to: event.date_to
      };
      this.$store.dispatch('campaign/downloadMessages', payload);
    },
    onRandomSelector: function onRandomSelector(event) {
      this.$store.dispatch('campaign/runRandomSelector', event);
    }
  },

  watch: {
    loadingCampaignDetail: function loadingCampaignDetail(newVal, oldVal) {
      if (newVal !== oldVal && this.campaignDetail[this.id]) {
        this.campaign = this.campaignDetail[this.id];
      }
    }
  }
});

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelDashboard__ = __webpack_require__(2910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelDashboard__);

//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelContainer',
  data: function data() {
    return {
      activeChannelTab: 'activeChannels'
    };
  },
  components: {
    ChannelDashboard: __WEBPACK_IMPORTED_MODULE_2__components_channel_ChannelDashboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('channel', ['activeChannels', 'inactiveChannels', 'channelIcons']), {
    channels: function channels() {
      return this.activeChannelTab === 'activeChannels' ? this.activeChannels : this.inactiveChannels;
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('channel/getChannels');
  },

  methods: {
    onChangeTab: function onChangeTab(event) {
      this.activeChannelTab = event.activeChannelTab.activeChannelTab;
    }
  }
});

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filebox_FileboxDashboard__ = __webpack_require__(2946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filebox_FileboxDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_filebox_FileboxDashboard__);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FileboxContainer',
  components: {
    FileboxDashboard: __WEBPACK_IMPORTED_MODULE_2__components_filebox_FileboxDashboard___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['icons']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('filebox', ['myFiles', 'companyFiles', 'loadingMyFiles', 'loadingCompanyFiles'])),
  mounted: function mounted() {
    this.$store.dispatch('filebox/getMyFiles');
    this.$store.dispatch('filebox/getCompanyFiles');
  }
});

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat_Chat__ = __webpack_require__(2920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_chat_Chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Gallery__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_common_Gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_interaction_Dashboard__ = __webpack_require__(2951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_interaction_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_interaction_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_interaction_MessagePanel__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_interaction_MessagePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_interaction_MessagePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanelSettings__ = __webpack_require__(2955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanelSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanelSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_interaction_ThreadDialog__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_interaction_ThreadDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_interaction_ThreadDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_profile_ProfileDetailDialog__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_profile_ProfileDetailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_profile_ProfileDetailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_profile_ProfileDialogMixin__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_campaign_CampaignManage__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_campaign_CampaignManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_campaign_CampaignManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_interaction_InstantPoll__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_interaction_InstantPoll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_interaction_InstantPoll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_voiceintelligence_approveTranscriptMutation_gql__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_voiceintelligence_approveTranscriptMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__graphql_voiceintelligence_approveTranscriptMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_interaction_Panel__ = __webpack_require__(2957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_interaction_Panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_interaction_Panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__ = __webpack_require__(76);









var _templateObject = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            onInteraction {\n              id\n              campaignId\n              channelId\n              companyId\n              threadId\n              dateCreated\n              dateUpdated\n              direction\n              flagBlacklisted\n              flagComment\n              flagFavourite\n              flagFraud\n              flagSafe\n              flagUnsafe\n              flagWinner\n              ore\n              tags\n              type\n              inCount\n              outCount\n              parent {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n              }\n            }\n          }\n        '], ['\n          subscription {\n            onInteraction {\n              id\n              campaignId\n              channelId\n              companyId\n              threadId\n              dateCreated\n              dateUpdated\n              direction\n              flagBlacklisted\n              flagComment\n              flagFavourite\n              flagFraud\n              flagSafe\n              flagUnsafe\n              flagWinner\n              ore\n              tags\n              type\n              inCount\n              outCount\n              parent {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n              }\n            }\n          }\n        ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          subscription {\n            onairInteraction {\n              id\n              sentBy {\n                firstName\n                lastName\n              }\n              interaction {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n                inCount\n                outCount\n              }\n            }\n          }\n        '], ['\n          subscription {\n            onairInteraction {\n              id\n              sentBy {\n                firstName\n                lastName\n              }\n              interaction {\n                id\n                campaignId\n                channelId\n                companyId\n                threadId\n                dateCreated\n                dateUpdated\n                direction\n                flagBlacklisted\n                flagComment\n                flagFavourite\n                flagFraud\n                flagSafe\n                flagUnsafe\n                flagWinner\n                ore\n                tags\n                type\n                inCount\n                outCount\n              }\n            }\n          }\n        ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardHeader',
  mixins: [__WEBPACK_IMPORTED_MODULE_19__components_profile_ProfileDialogMixin__["a" /* default */]],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a,

    Chat: __WEBPACK_IMPORTED_MODULE_12__components_chat_Chat___default.a,
    Gallery: __WEBPACK_IMPORTED_MODULE_13__components_common_Gallery___default.a,
    Dashboard: __WEBPACK_IMPORTED_MODULE_14__components_interaction_Dashboard___default.a,
    MessagePanel: __WEBPACK_IMPORTED_MODULE_15__components_interaction_MessagePanel___default.a,
    MessagePanelSettings: __WEBPACK_IMPORTED_MODULE_16__components_interaction_MessagePanelSettings___default.a,
    ThreadDialog: __WEBPACK_IMPORTED_MODULE_17__components_interaction_ThreadDialog___default.a,
    Panel: __WEBPACK_IMPORTED_MODULE_23__components_interaction_Panel___default.a,
    ProfileDetailDialog: __WEBPACK_IMPORTED_MODULE_18__components_profile_ProfileDetailDialog___default.a,
    CampaignManage: __WEBPACK_IMPORTED_MODULE_20__components_campaign_CampaignManage___default.a,
    InstantPoll: __WEBPACK_IMPORTED_MODULE_21__components_interaction_InstantPoll___default.a,
    approveTranscriptMutation: __WEBPACK_IMPORTED_MODULE_22__graphql_voiceintelligence_approveTranscriptMutation_gql___default.a
  },
  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onInteraction: {
        query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject),
        result: function result(response) {
          this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["d" /* NEW_INTERACTION_RECEIVED */], response.data.onInteraction);
        }
      },
      onairInteraction: {
        query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject2),
        result: function result(response) {
          this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["e" /* NEW_ONAIR_INTERACTION_RECEIVED */], response.data.onairInteraction);
        }
      }
    }
  },
  data: function data() {
    return {
      instantPollDialogVisible: false,
      draggableOptions: {
        animation: 200,
        draggable: '.panel-container',
        dropzoneSelector: '.message-panels',
        handle: '.ibox-tools'
      },
      goToLastScrollPosition: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('interaction', ['interactions', 'interactionsOnAir', 'pollStats']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('campaign', ['activeCampaigns', 'instantPollCampaigns']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('channel', ['channels']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])('campaign', ['campaigns']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])('interaction', ['loadingInteractions', 'hasMoreInteractions', 'loadingInteractionsSuccess', 'galleryImages', 'galleryVisible', 'galleryIndex', 'panelPaused', 'panels', 'panelSettings', 'panelTypes', 'panelSettingsDialog', 'panelSettingsDialogVisible', 'twitterTrends', 'instantPollResults', 'panelPages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])('user', ['companyUsers', 'me']), {
    panelsList: {
      get: function get() {
        var _this = this;

        var panelList = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.panels).map(function (e) {
          return { id: e, title: _this.panels[e] };
        });
        return panelList;
      },
      set: function set(value) {
        var asObject = value.reduce(function (acc, cur) {
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, cur.id, cur.title));
        }, {});
        this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["_6" /* UPDATE_PANEL_ORDER_REQUEST */], asObject);
      }
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('user/getCompanyUsers');
    this.$store.dispatch('interaction/fetchPanels');
    this.$store.dispatch('interaction/fetchTwitterTrends');
    this.$store.dispatch('interaction/fetchOnAirInteractions', 'onAir');
    this.$store.dispatch('campaign/getCampaigns');
    this.$store.dispatch('channel/getChannels');
  },
  destroyed: function destroyed() {
    this.$store.dispatch('interaction/clearDashboardPanelPaused');
  },

  methods: {
    panelHasMoreInteractions: function panelHasMoreInteractions(panelId) {
      return this.hasMoreInteractions[panelId] !== undefined ? this.hasMoreInteractions[panelId] : true;
    },
    setGalleryVisible: function setGalleryVisible(isVisible) {
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["L" /* SET_GALLERY_VISIBLE */], isVisible);
    },
    setPanelSettingsVisible: function setPanelSettingsVisible(isVisible) {
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["S" /* SET_PANEL_SETTINGS_DIALOG_VISIBLE */], isVisible);
    },
    panelKeys: function panelKeys() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.panels);
    },
    loadMore: function loadMore(panelId) {
      this.$store.dispatch('interaction/fetchNextPageInteractions', panelId);
    },
    addPanel: function addPanel() {
      this.$store.dispatch('interaction/createPanel');
    },
    reorderPanels: function reorderPanels() {
      this.$store.dispatch('interaction/reorderPanels', this.panels);
    },
    resetPanel: function resetPanel(panelId) {
      this.$store.dispatch('interaction/fetchPanelInteractions', [panelId, null, 1]);
    },
    handleTogglePanelVisibilityByType: function handleTogglePanelVisibilityByType(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          type = _ref2[0],
          hidden = _ref2[1];

      var uuid = this.getPanelIdByType(type);
      var settings = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
        uuid: uuid,
        name: this.panels[uuid]
      }, this.panelSettings[uuid]);

      this.savePanelSettings(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, settings, { hidden: hidden }));
    },
    getPanelIdByType: function getPanelIdByType(type) {
      var _this2 = this;

      /* eslint-disable no-console */
      console.log(this.panelTypes);
      var panelIds = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.panelTypes);
      return panelIds.filter(function (x) {
        return _this2.panelTypes[x] === type;
      })[0];
    },
    isMessagePanel: function isMessagePanel(panelId) {
      var isHidden = this.panelSettings[panelId].hidden;
      var isProfilePanel = panelId.includes('profile-panel');
      var isChatPanel = this.panelTypes[panelId] === 'chat';
      return !isHidden && !isProfilePanel && !isChatPanel;
    },
    isChatPanel: function isChatPanel(panelId) {
      var isHidden = this.panelSettings[panelId].hidden;
      var isChatPanel = this.panelTypes[panelId] === 'chat';
      return !isHidden && isChatPanel;
    },
    closePanel: function closePanel(panelId) {
      var type = this.panelTypes[panelId];

      if (type === 'activity') {
        // Ignore if this is the activity feed.
        return;
      }

      var persistentPanelTypes = ['onair', 'twittertrends', 'chat'];

      if (persistentPanelTypes.includes(type)) {
        this.handleTogglePanelVisibilityByType([type, true]);
      } else {
        this.$store.dispatch('interaction/deletePanel', panelId);
      }
    },
    showSettings: function showSettings(panelId) {
      var settings = {
        id: panelId,
        name: this.panels[panelId],
        color: this.panelSettings[panelId].colour,
        columns: this.panelSettings[panelId].columns,
        type: this.panelTypes[panelId],
        channelIds: this.panelSettings[panelId].channel_ids || [],
        campaignIds: this.panelSettings[panelId].campaign_ids || [],
        mediaPreload: this.panelSettings[panelId].mediaPreload || 'auto',
        panelLock: this.panelSettings[panelId].panelLock || 'auto'
      };
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["R" /* SET_PANEL_SETTINGS_DIALOG */], settings);
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_24__store_modules_interaction_mutation_types__["S" /* SET_PANEL_SETTINGS_DIALOG_VISIBLE */], true);
    },
    savePanelSettings: function savePanelSettings(panel) {
      this.$store.dispatch('interaction/updatePanelSettings', panel);
      this.setPanelSettingsVisible(false);
    },
    dragStarted: function dragStarted() {
      this.goToLastScrollPosition = false;
    },
    dragEnded: function dragEnded() {
      this.goToLastScrollPosition = true;
      this.reorderPanels();
    },
    unpausePanel: function unpausePanel(panelId) {
      this.$store.dispatch('interaction/unpausePanelInteractions', panelId);
      this.handleInstantPollPanel(panelId);
    },
    pausePanel: function pausePanel(panelId) {
      this.$store.dispatch('interaction/pausePanelInteractions', panelId);
    },
    removeOnAir: function removeOnAir(_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 3),
          panelId = _ref4[0],
          interactionId = _ref4[1],
          onAirId = _ref4[2];

      this.$store.dispatch('interaction/removeOnAirInteraction', [panelId, interactionId, onAirId]);
      this.unapproveTranscript(onAirId);
    },
    searchPanelInteractions: function searchPanelInteractions(panelId, nextPage, searchStr) {
      this.$store.dispatch('interaction/searchPanelInteractions', [panelId, nextPage, searchStr]);
    },
    handleOpenProfile: function handleOpenProfile(originatorType, originator) {
      this.$store.dispatch('profile/searchProfileForIdentity', [originatorType, originator]);
    },
    handleShowInstantPollDialog: function handleShowInstantPollDialog() {
      this.instantPollDialogVisible = true;
    },
    handleCreatePanel: function handleCreatePanel(_ref5) {
      var _this3 = this;

      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 3),
          name = _ref6[0],
          camapaignIds = _ref6[1],
          channelIds = _ref6[2];

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var panelSettings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                panelSettings = {
                  name: name,
                  instant_poll: true,
                  campaign_ids: camapaignIds,
                  channel_ids: channelIds
                };
                _context.next = 3;
                return _this3.$store.dispatch('interaction/createPanel', panelSettings);

              case 3:
                _context.next = 5;
                return _this3.$store.dispatch('campaign/getCampaigns');

              case 5:
                _this3.instantPollDialogVisible = false;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getInstantPoll: function getInstantPoll(panelSettings, panelId) {
      if (!('campaign_ids' in panelSettings)) return null;

      // instant polls panels only have one campaign
      if (panelSettings.campaign_ids.length !== 1) return null;

      // check if sole campaign is attached to an instant poll
      if (!this.instantPollCampaigns.includes(panelSettings.campaign_ids[0])) {
        return null;
      }

      var instantPoll = this.campaigns.find(function (campaign) {
        return campaign.id === panelSettings.campaign_ids[0];
      });

      // check if the campaign is past the reporting time
      if (__WEBPACK_IMPORTED_MODULE_10_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_10_moment___default()(instantPoll.end_date), 'hours') > 3) {
        this.closePanel(panelId);
      }

      return instantPoll;
    },
    handleInstantPollPanel: function handleInstantPollPanel(panelId) {
      if (this.panelSettings[panelId].instant_poll === true) {
        this.getInstantPoll(this.panelSettings[panelId], panelId);
      }
    },
    handleCloseInstantPoll: function handleCloseInstantPoll() {
      this.instantPollDialogVisible = false;
    },
    unapproveTranscript: function unapproveTranscript(interactionId) {
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_22__graphql_voiceintelligence_approveTranscriptMutation_gql___default.a,
        variables: {
          query: {
            interactionId: String(interactionId),
            approveStatus: false,
            approvedById: this.me.id,
            approvedBy: this.me.first_name + ' ' + this.me.last_name,
            approveReason: ''
          }
        }
      });
    },
    addingInstagramChannel: function addingInstagramChannel() {},
    addingTwitterChannel: function addingTwitterChannel() {},
    handleCreateCampaignVisibilityChanged: function handleCreateCampaignVisibilityChanged() {},
    handleRequestTwitterAuth: function handleRequestTwitterAuth() {},
    handleRequestInstagramAuth: function handleRequestInstagramAuth() {},
    handleCampaignCreated: function handleCampaignCreated() {}
  }
});

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_interaction_SearchResults__ = __webpack_require__(2959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_interaction_SearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_interaction_SearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_interaction_mutation_types__ = __webpack_require__(76);

//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InteractionSearchContainer',
  components: {
    SearchResults: __WEBPACK_IMPORTED_MODULE_2__components_interaction_SearchResults___default.a
  },
  data: function data() {
    return {
      query: null,
      queryType: 'simple'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('interaction', ['searchTerm', 'searchResults', 'searchCount', 'searching', 'searchFields'])),
  mounted: function mounted() {
    this.$store.dispatch('interaction/getSearchFields');
    this.query = this.searchTerm;
  },

  methods: {
    handleSimpleSearch: function handleSimpleSearch(event) {
      this.$store.commit('interaction/' + __WEBPACK_IMPORTED_MODULE_3__store_modules_interaction_mutation_types__["Z" /* SET_SEARCH_TERM */], event.searchTerm);
      this.$store.dispatch('interaction/simpleSearch', {
        query: event.searchTerm,
        page: 1
      });
      this.query = event.searchTerm;
      this.queryType = 'simple';
    },
    handleAdvancedSearch: function handleAdvancedSearch(event) {
      this.query = event;
      this.$store.dispatch('interaction/advancedSearch', {
        query: event,
        page: 1
      });
      this.queryType = 'segmented';
    },
    exportToFile: function exportToFile(filename) {
      var data = {
        type: this.queryType,
        query: this.query,
        file_name: filename
      };

      if (this.$route.params.campaignId) {
        data = {
          type: this.queryType,
          query: this.query,
          file_name: filename,
          campaign_id: this.$route.params.campaignId
        };
      }

      this.$store.dispatch('interaction/exportToFile', data);
    }
  },
  watch: {
    searchTerm: function searchTerm(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.query = this.searchTerm;
        this.queryType = 'simple';
      }
    }
  }
});

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_social_SocialPostsContainer__ = __webpack_require__(3109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_social_SocialPostsContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_social_SocialPostsContainer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModalContainer',

  components: {
    SocialPostsContainer: __WEBPACK_IMPORTED_MODULE_2__containers_social_SocialPostsContainer___default.a
  },

  data: function data() {
    return {
      defaultTop: '5vh',
      innerInfoDialogIsVisible: false,
      instructions: ['Make sure you have a social media channel linked with your company, you can add media channel at the "Channels" dashboard', 'Select the social platforms you want to post to', 'You can add media like pictures or video for the post', 'You can schedule the time and date for the post, if you want to post now you dont have to schedule the post', 'Now you can click on Send to publish the post']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('channel', ['socialChannels']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('social', ['post', 'isEditing']), {
    socialPostModal: {
      get: function get() {
        return this.$store.state.modals.socialPostModal;
      },
      set: function set() {
        this.$store.dispatch('modals/hideSocialPostDialog');
      }
    },
    socialPostModalTitle: function socialPostModalTitle() {
      return this.isEditing ? 'Edit Post' : 'New Post';
    }
  }),

  methods: {
    closeSocialPostModal: function closeSocialPostModal() {
      this.$store.dispatch('modals/hideSocialPostDialog');
    }
  }
});

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_Dashboard__ = __webpack_require__(2962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_permission_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_permission_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_permission_searchQuery_gql__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_permission_searchQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphql_permission_searchQuery_gql__);


//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PermissionsDashboardContainer',
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_2__components_permission_Dashboard___default.a
  },
  apollo: {
    searchProfile: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_permission_searchQuery_gql___default.a,
      debounce: 200,
      variables: {
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
          identifier: ''
        })
      }
    }
  },
  data: function data() {
    return {
      loadingProfile: false,
      searchProfile: {
        filteredTotal: 0,
        profiles: []
      }
    };
  },

  methods: {
    handleDisplayProfile: function handleDisplayProfile() {
      this.loadingProfile = true;
    },
    handleSearchQuery: function handleSearchQuery(query) {
      var _this = this;

      this.loadingProfile = true;
      this.$apollo.queries.searchProfile.refetch({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
          identifier: query
        })
      }).then(function (result) {
        var updatedSearchProfile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.searchProfile, {
          profiles: result.data.searchProfile.profiles,
          filteredTotal: result.data.searchProfile.filteredTotal
        });
        _this.searchProfile = updatedSearchProfile;
        _this.loadingProfile = false;

        if (updatedSearchProfile.filteredTotal === 0 && query !== '') {
          _this.$notify({
            type: 'info',
            duration: 2500,
            message: 'No profile meeting the specified criteria found.'
          });
        }
      }).catch(function (error) {
        var errorMessage = error.response && error.response.data.errors[0].message ? error.response.data.errors[0].message : 'Something went wrong while trying to search profile.';
        _this.$notify({
          type: 'error',
          message: errorMessage
        });
        _this.loadingProfile = false;
      });
    }
  }
});

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_Dashboard__ = __webpack_require__(2980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profiles_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_profiles_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_chartsQuery_gql__ = __webpack_require__(2613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_chartsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_chartsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_profiles_pro_filtersQuery_gql__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_profiles_pro_filtersQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__graphql_profiles_pro_filtersQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_profiles_pro_searchQuery_gql__ = __webpack_require__(2621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_profiles_pro_searchQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__graphql_profiles_pro_searchQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_profiles_pro_pluginsQuery_gql__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_profiles_pro_pluginsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__graphql_profiles_pro_pluginsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_profiles_pro_savedQueries_gql__ = __webpack_require__(2620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_profiles_pro_savedQueries_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__graphql_profiles_pro_savedQueries_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_profiles_pro_createSampleset_gql__ = __webpack_require__(2614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_profiles_pro_createSampleset_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__graphql_profiles_pro_createSampleset_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_profiles_pro_saveQueryMutation_gql__ = __webpack_require__(2619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphql_profiles_pro_saveQueryMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__graphql_profiles_pro_saveQueryMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_profiles_pro_deleteQueryMutation_gql__ = __webpack_require__(2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphql_profiles_pro_deleteQueryMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__graphql_profiles_pro_deleteQueryMutation_gql__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfilesDashboardContainer',
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_4__components_profiles_Dashboard___default.a
  },
  apollo: {
    plugins: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_8__graphql_profiles_pro_pluginsQuery_gql___default.a
    },
    charts: {
      client: 'apiv2',
      prefetch: true,
      query: __WEBPACK_IMPORTED_MODULE_5__graphql_profiles_pro_chartsQuery_gql___default.a,
      result: function result(_ref) {
        var data = _ref.data;

        if (data && data.charts) {
          this.charts = {
            crossPlatformEngagement: data.charts.crossPlatformEngagement || {},
            audienceProfile: this.normalizeAudienceProfile(data.charts.audience)
          };
        }
      }
    },
    filters: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_profiles_pro_filtersQuery_gql___default.a
    },
    savedQueries: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_9__graphql_profiles_pro_savedQueries_gql___default.a
    },
    search: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_7__graphql_profiles_pro_searchQuery_gql___default.a,
      debounce: 200,
      variables: {
        query: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
          'meta.opt_out': ['email', 'sms', 'whatsapp', 'telegram']
        }),
        page: 0
      }
    }
  },
  methods: {
    handleFilter: function handleFilter(query) {
      this.$apollo.queries.search.refetch({ query: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(query) });
    },
    handleDisplayProfiles: function handleDisplayProfiles() {
      this.loadingProfiles = true;
    },
    handleLoadMoreProfiles: function handleLoadMoreProfiles() {
      this.page += 1;
      this.$apollo.queries.search.fetchMore({
        variables: {
          page: this.page
        },
        updateQuery: function updateQuery(previousResult, _ref2) {
          var fetchMoreResult = _ref2.fetchMoreResult;

          return {
            search: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, previousResult.search, {
              total: previousResult.search.total,
              filteredTotal: previousResult.search.filteredTotal,
              profiles: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(previousResult.search.profiles), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(fetchMoreResult.search.profiles))
            })
          };
        }
      });
    },
    handleDownload: function handleDownload(_ref3) {
      var _this = this;

      var name = _ref3.title,
          query = _ref3.query,
          sampleSize = _ref3.sampleSize;

      var filter = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(query);
      var exportType = sampleSize > 0 ? 'sample set' : 'contact list';
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_10__graphql_profiles_pro_createSampleset_gql___default.a,
        variables: {
          name: name,
          filter: filter,
          sampleSize: sampleSize
        }
      }).then(function () {
        return _this.$notify({
          type: 'success',
          message: 'You will receive a download link via email when your ' + exportType + ' is ready for download.'
        });
      });
    },
    handleSaveQuery: function handleSaveQuery(_ref4) {
      var _this2 = this;

      var title = _ref4.title,
          query = _ref4.query;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_11__graphql_profiles_pro_saveQueryMutation_gql___default.a,
        variables: {
          title: title.value,
          filter: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(query),
          fields: []
        }
      }).then(function () {
        _this2.$apollo.queries.savedQueries.refetch();

        _this2.$notify({
          type: 'success',
          message: 'Your query has been successfully saved.'
        });
      }).catch(function () {
        _this2.$notify({
          type: 'error',
          message: 'Something went wrong while trying to save your query.'
        });
      });
    },
    handleDeleteQuery: function handleDeleteQuery(id) {
      var _this3 = this;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_12__graphql_profiles_pro_deleteQueryMutation_gql___default.a,
        variables: {
          id: id
        }
      }).then(function () {
        _this3.$apollo.queries.savedQueries.refetch();

        _this3.$notify({
          type: 'success',
          message: 'Your query has been successfully deleted.'
        });
      }).catch(function () {
        _this3.$notify({
          type: 'error',
          message: 'Something went wrong while trying to deleted your saved query.'
        });
      });
    },
    normalizeAudienceProfile: function normalizeAudienceProfile(audience) {
      if (!audience) return {};
      var result = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(audience).forEach(function (key) {
        result[key] = Array.isArray(audience[key]) ? audience[key] : [];
      });
      return result;
    }
  },
  computed: {
    mode: function mode() {
      var hasProPlugin = this.plugins.map(function (plugin) {
        return plugin.plugin;
      }).includes('profiles');
      return hasProPlugin ? 'pro' : 'lite';
    }
  },
  data: function data() {
    return {
      filters: {},
      lastQuery: {},
      page: 0,
      plugins: [],
      loadingProfiles: false,
      savedQueries: [],
      search: {
        total: 0,
        filteredTotal: 0,
        profiles: []
      },
      charts: {
        crossPlatformEngagement: {},
        audienceProfile: {
          age: [],
          gender: [],
          ethnicity: [],
          location: [],
          language: [],
          numberOfChannels: []
        }
      }
    };
  }
});

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RulesList__ = __webpack_require__(3008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rules_RulesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_rules_RulesList__);

//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RulesListContainer',
  components: {
    RulesList: __WEBPACK_IMPORTED_MODULE_2__components_rules_RulesList___default.a
  },
  mounted: function mounted() {
    this.$store.dispatch('rules/getCampaignRules', this.$route.params.campaignId);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('rules', ['rules']))
});

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_segmentation_Dashboard__ = __webpack_require__(3012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_segmentation_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_segmentation_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_segmentation_segments_segmentsQuery_gql__ = __webpack_require__(2643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_segmentation_segments_segmentsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__graphql_segmentation_segments_segmentsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_segmentation_segments_segmentFreshnessQuery_gql__ = __webpack_require__(2640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_segmentation_segments_segmentFreshnessQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__graphql_segmentation_segments_segmentFreshnessQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_segmentation_segments_refreshStationDataMutation_gql__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__graphql_segmentation_segments_refreshStationDataMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__graphql_segmentation_segments_refreshStationDataMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_segmentation_segments_segmentSummaryQuery_gql__ = __webpack_require__(2642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_segmentation_segments_segmentSummaryQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__graphql_segmentation_segments_segmentSummaryQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__graphql_segmentation_segments_segmentInsightsQuery_gql__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__graphql_segmentation_segments_segmentInsightsQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__graphql_segmentation_segments_segmentInsightsQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_listeners_filterListenersQuery_gql__ = __webpack_require__(2630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_listeners_filterListenersQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_listeners_filterListenersQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_analytics_aggregateListenersQuery_gql__ = __webpack_require__(2627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_analytics_aggregateListenersQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_analytics_aggregateListenersQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_analytics_crossChannelEngagementQuery_gql__ = __webpack_require__(2628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_analytics_crossChannelEngagementQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_analytics_crossChannelEngagementQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_listeners_listenerProfileQuery_gql__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_listeners_listenerProfileQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_listeners_listenerProfileQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_ai_recommendCampaignQuery_gql__ = __webpack_require__(2625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_ai_recommendCampaignQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_ai_recommendCampaignQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__graphql_segmentation_ai_markRecommendationUsedMutation_gql__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__graphql_segmentation_ai_markRecommendationUsedMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__graphql_segmentation_ai_markRecommendationUsedMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__graphql_segmentation_listeners_similarListenersQuery_gql__ = __webpack_require__(2633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__graphql_segmentation_listeners_similarListenersQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__graphql_segmentation_listeners_similarListenersQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__graphql_segmentation_analytics_profileCompletenessQuery_gql__ = __webpack_require__(2629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__graphql_segmentation_analytics_profileCompletenessQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__graphql_segmentation_analytics_profileCompletenessQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__graphql_segmentation_ai_aiListenerProfileQuery_gql__ = __webpack_require__(2622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__graphql_segmentation_ai_aiListenerProfileQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__graphql_segmentation_ai_aiListenerProfileQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__graphql_segmentation_ai_promoteDemographicsMutation_gql__ = __webpack_require__(2624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__graphql_segmentation_ai_promoteDemographicsMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__graphql_segmentation_ai_promoteDemographicsMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__graphql_segmentation_ai_replaceDemographicMutation_gql__ = __webpack_require__(2626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__graphql_segmentation_ai_replaceDemographicMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__graphql_segmentation_ai_replaceDemographicMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__graphql_segmentation_listeners_reviewLinkedIdentifierMutation_gql__ = __webpack_require__(2632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__graphql_segmentation_listeners_reviewLinkedIdentifierMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__graphql_segmentation_listeners_reviewLinkedIdentifierMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__ = __webpack_require__(307);












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/**
 * The message to show for a failed load: the service's own text when there
 * is one, otherwise a plain description of a network failure.
 */
var errorText = function errorText(e) {
  var gql = e && e.graphQLErrors || [];
  if (gql.length && gql[0].message) {
    return gql[0].message;
  }
  if (e && e.networkError) {
    return 'Could not reach the server. Please check your connection and try again.';
  }
  return e && e.message || 'Something went wrong while loading segmentation data.';
};

/**
 * How often the dashboard asks whether the station's data has changed, while
 * the tab is open. The answer is a stored result on the server, so asking is
 * cheap.
 */
var AUTO_REFRESH_MS = 60 * 1000;

/**
 * The dashboard queries that are reloaded quietly when new data arrives. The
 * listener list is left alone so it does not change under someone who is
 * reading it.
 */
var AUTO_REFRESH_QUERIES = ['segmentSummary', 'segmentInsights', 'segmentTags', 'segmentStats', 'aggregateListeners', 'crossChannelEngagement', 'profileCompleteness'];

/**
 * The queries the first load waits for, so the dashboard can tell "still
 * loading" from "no data" and report every failure in one place.
 */
var LOAD_NAMES = ['segmentSummary', 'segmentFreshness', 'segmentInsights', 'segmentTags', 'segmentStats', 'filterListeners', 'aggregateListeners', 'crossChannelEngagement', 'profileCompleteness'];

/**
 * Hooks that report a query as loaded, or as failed with its message.
 */
var trackLoad = function trackLoad(name) {
  return {
    result: function result(_ref) {
      var loading = _ref.loading;

      if (!loading) {
        this.loadSettled(name);
      }
    },
    error: function error(e) {
      this.loadFailed(name, e);
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SegmentationDashboardContainer',
  components: { SegmentationDashboard: __WEBPACK_IMPORTED_MODULE_12__components_segmentation_Dashboard___default.a },

  data: function data() {
    return {
      page: 1,
      searchQuery: '',
      activeFilters: { page: 1, page_size: __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */] },
      loadingMore: false,
      recommendationResult: null,
      selectedListenerProfile: null,
      recommendError: false,
      creditsExhausted: false,
      enriching: false,
      enrichCreditsExhausted: false,
      refreshing: false,

      loadNames: LOAD_NAMES,

      /**
       * The queries the first load is still waiting on, and the message of
       * each one that failed (by query name).
       */
      pendingLoads: [].concat(LOAD_NAMES),
      loadErrors: {},

      segmentFreshness: {
        data_updated_at: null,
        segments: {}
      },

      segmentSummary: {
        totalListeners: 0,
        highEngagementCount: 0,
        segmentCounts: {}
      },

      segmentInsights: {
        totalListeners: 0,
        summary: null,
        segments: []
      },

      segmentTags: {
        segments: {}
      },

      segmentStats: {
        totalListeners: 0,
        segments: []
      },

      filterListeners: {
        totalMatches: 0,
        page: 1,
        pageSize: __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */],
        listeners: []
      },

      aggregateListeners: {
        total: 0,
        channelCounts: {},
        genderCounts: {},
        ageGroupCounts: {},
        languageCounts: {},
        locationCounts: {},
        segmentCounts: {},
        momentumCounts: {},
        campaignTypeCounts: {}
      },

      crossChannelEngagement: {
        total: 0,
        channels: [],
        uniques: {},
        matrix: {},
        percentages: {}
      },

      baseAggregate: {
        total: 0,
        channelCounts: {},
        genderCounts: {},
        ageGroupCounts: {},
        languageCounts: {},
        locationCounts: {}
      },

      profileCompleteness: {
        total: 0,
        completeCount: 0,
        incompleteCount: 0,
        missingFieldCounts: {}
      }
    };
  },

  apollo: {
    segmentSummary: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_16__graphql_segmentation_segments_segmentSummaryQuery_gql___default.a,
      skip: function skip() {
        return !this.segmentationEnabled;
      }
    }, trackLoad('segmentSummary')),

    segmentFreshness: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_14__graphql_segmentation_segments_segmentFreshnessQuery_gql___default.a,
      fetchPolicy: 'network-only',
      update: function update(data) {
        return data.segmentFreshness;
      },
      skip: function skip() {
        return !this.segmentationEnabled;
      }
    }, trackLoad('segmentFreshness')),

    segmentInsights: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_17__graphql_segmentation_segments_segmentInsightsQuery_gql___default.a,
      update: function update(data) {
        return data.segmentInsights;
      },
      skip: function skip() {
        return !this.segmentationEnabled;
      }
    }, trackLoad('segmentInsights')),
    segmentTags: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_17__graphql_segmentation_segments_segmentInsightsQuery_gql___default.a,
      update: function update(data) {
        return data.segmentTags;
      },
      skip: function skip() {
        return !this.segmentationEnabled;
      }
    }, trackLoad('segmentTags')),

    segmentStats: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_13__graphql_segmentation_segments_segmentsQuery_gql___default.a,
      update: function update(data) {
        return data.segments;
      },
      skip: function skip() {
        return !this.segmentationEnabled;
      }
    }, trackLoad('segmentStats')),

    filterListeners: {
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_18__graphql_segmentation_listeners_filterListenersQuery_gql___default.a,
      fetchPolicy: 'network-only',
      skip: function skip() {
        return !this.segmentationEnabled;
      },
      variables: function variables() {
        return {
          params: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, this.activeFilters, this.searchQuery ? { originator: this.searchQuery } : {})
        };
      },

      result: trackLoad('filterListeners').result,
      error: function error(err) {
        this.loadFailed('filterListeners', err);
        var isAuthError = (err.graphQLErrors || []).some(function (e) {
          return e.message && e.message.includes('resolve context');
        });
        if (isAuthError) {
          this.activeFilters = { page: 1, page_size: __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */] };
        }
      }
    },

    aggregateListeners: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_19__graphql_segmentation_analytics_aggregateListenersQuery_gql___default.a,
      skip: function skip() {
        return !this.segmentationEnabled;
      },
      variables: function variables() {
        return { params: this.activeFilters };
      }
    }, trackLoad('aggregateListeners')),

    crossChannelEngagement: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_20__graphql_segmentation_analytics_crossChannelEngagementQuery_gql___default.a,
      skip: function skip() {
        return !this.segmentationEnabled;
      },
      variables: function variables() {
        return { params: this.activeFilters };
      }
    }, trackLoad('crossChannelEngagement')),

    profileCompleteness: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({
      client: 'apiv2',
      query: __WEBPACK_IMPORTED_MODULE_25__graphql_segmentation_analytics_profileCompletenessQuery_gql___default.a,
      skip: function skip() {
        return !this.segmentationEnabled;
      },
      variables: function variables() {
        return { params: this.activeFilters };
      }
    }, trackLoad('profileCompleteness'))
  },

  watch: {
    aggregateListeners: function aggregateListeners(val) {
      if (val && val.total && !this.baseAggregate.total) {
        this.baseAggregate = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, val);
      }
    },


    /**
     * New data has arrived when the station's data-updated time moves on.
     *
     * Note: Not while a manual refresh is running (it reloads everything
     * itself), and not for the first answer.
     */
    segmentFreshness: function segmentFreshness(val, old) {
      var before = old && old.data_updated_at;
      if (before && val && val.data_updated_at !== before && !this.refreshing) {
        this.reloadQuietly();
      }
    }
  },

  created: function created() {
    this.quietCount = 0;
    this.autoRefreshTimer = setInterval(this.checkForNewData, AUTO_REFRESH_MS);
    document.addEventListener('visibilitychange', this.checkForNewData);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.autoRefreshTimer);
    document.removeEventListener('visibilitychange', this.checkForNewData);
  },


  computed: {
    /**
     * The distinct messages of the queries that failed, as the service
     * worded them.
     */
    loadErrorMessages: function loadErrorMessages() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(this.loadErrors))));
    },


    /**
     * Whether the station's plugin list has been answered yet.
     */
    pluginsKnown: function pluginsKnown() {
      var _$store$state$plugin = this.$store.state.plugin,
          loadingPluginsSucceeded = _$store$state$plugin.loadingPluginsSucceeded,
          loadingPluginsFailed = _$store$state$plugin.loadingPluginsFailed;

      return !!(loadingPluginsSucceeded || loadingPluginsFailed);
    },


    /**
     * Note: Until the plugin list arrives this is false, which is not the
     * same as "not enabled", so the dashboard is told `pluginsKnown` too.
     * If the list could not be loaded the queries run and report their own
     * errors rather than claiming the plugin is off.
     */
    segmentationEnabled: function segmentationEnabled() {
      if (this.$store.state.plugin.loadingPluginsFailed) {
        return true;
      }
      var plugins = this.$store.state.plugin.plugins || [];
      return plugins.some(function (plugin) {
        return plugin.plugin_route === 'app.profiles.segmentation';
      });
    }
  },

  methods: {
    /**
     * Asks the server whether the station's data has changed.
     *
     * Note: It only asks while the tab is showing, when the dashboard is
     * switched on for the station, and after the first load, so a hidden tab
     * costs nothing. If it fails nothing happens: the next check tries again.
     */
    checkForNewData: function checkForNewData() {
      if (document.hidden || !this.segmentationEnabled || this.pendingLoads.length) {
        return;
      }
      this.quietly(this.$apollo.queries.segmentFreshness.refetch());
    },


    /**
     * Waits for a background reload without ever reporting its failure to the
     * station: a failed check should not pop up an error over their work.
     */
    quietly: function quietly(promise) {
      var _this = this;

      this.quietCount += 1;
      return promise.catch(function () {
        return null;
      }).then(function () {
        _this.quietCount -= 1;
      });
    },


    /**
     * Reloads the dashboard's numbers without any loading screen.
     */
    reloadQuietly: function reloadQuietly() {
      var _this2 = this;

      AUTO_REFRESH_QUERIES.forEach(function (name) {
        var query = _this2.$apollo.queries[name];
        if (query) {
          _this2.quietly(query.refetch());
        }
      });
    },
    loadSettled: function loadSettled(name) {
      this.pendingLoads = this.pendingLoads.filter(function (n) {
        return n !== name;
      });
      if (this.loadErrors[name]) {
        var _loadErrors = this.loadErrors,
            cleared = _loadErrors[name],
            rest = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_objectWithoutProperties___default()(_loadErrors, [name]);

        this.loadErrors = rest;
      }
    },


    /**
     * Note: A failed query is also counted as finished, so the loading
     * pop-up gives way to the error instead of waiting forever.
     */
    loadFailed: function loadFailed(name, e) {
      if (this.quietCount > 0) {
        return;
      }
      this.pendingLoads = this.pendingLoads.filter(function (n) {
        return n !== name;
      });
      this.loadErrors = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, this.loadErrors, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, name, errorText(e)));
    },


    /**
     * Drops the station's saved results on the server, then reloads every
     * dashboard query so the numbers come from live data.
     */
    handleRefresh: function handleRefresh() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.refreshing) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this3.refreshing = true;
                _context.prev = 3;
                _context.next = 6;
                return _this3.$apollo.mutate({ client: 'apiv2', mutation: __WEBPACK_IMPORTED_MODULE_15__graphql_segmentation_segments_refreshStationDataMutation_gql___default.a });

              case 6:
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(_this3.$apollo.queries).map(function (q) {
                  return q.refetch().catch(function () {
                    return null;
                  });
                }));

              case 8:
                _this3.$notify({ type: 'success', message: 'Dashboard data refreshed.' });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                _this3.$notify({ type: 'error', message: 'Could not refresh right now. Please try again.' });

              case 14:
                _context.prev = 14;

                _this3.refreshing = false;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 11, 14, 17]]);
      }))();
    },
    handleFilter: function handleFilter(params) {
      this.page = 1;
      var sanitised = this.sanitiseParams(params);

      if (sanitised.originator) {
        this.searchQuery = sanitised.originator;
        delete sanitised.originator;
      } else {
        this.searchQuery = '';
      }

      this.activeFilters = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, sanitised, {
        page: 1,
        page_size: __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */]
      });
    },


    /**
     * Appends the next batch of listeners. Called by the browser when the
     * visitor is within a couple of pages of the end of what is loaded.
     *
     * The next API page is derived from how many listeners are already
     * loaded (not a running counter), and only one request runs at a time,
     * so repeated calls can never skip or double-fetch a batch.
     */
    handleLoadMore: function handleLoadMore() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var loaded;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loaded = (_this4.filterListeners.listeners || []).length;

                if (!(_this4.loadingMore || loaded >= (_this4.filterListeners.totalMatches || 0))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:

                _this4.loadingMore = true;
                _this4.page = Math.floor(loaded / __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */]) + 1;

                _context2.prev = 5;
                _context2.next = 8;
                return _this4.$apollo.queries.filterListeners.fetchMore({
                  variables: {
                    params: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, _this4.activeFilters, _this4.searchQuery ? { originator: _this4.searchQuery } : {}, {
                      page: _this4.page,
                      page_size: __WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["a" /* LISTENER_FETCH_SIZE */]
                    })
                  },
                  updateQuery: function updateQuery(prev, _ref2) {
                    var fetchMoreResult = _ref2.fetchMoreResult;

                    if (!fetchMoreResult) {
                      return prev;
                    }
                    // Never show the same listener twice if the result set shifted
                    var seen = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(prev.filterListeners.listeners.map(function (l) {
                      return l.originator;
                    }));
                    var fresh = fetchMoreResult.filterListeners.listeners.filter(function (l) {
                      return !seen.has(l.originator);
                    });
                    return {
                      filterListeners: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, fetchMoreResult.filterListeners, {
                        listeners: [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(prev.filterListeners.listeners), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(fresh))
                      })
                    };
                  }
                });

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](5);

                _this4.$notify({ type: 'error', message: 'Could not load more listeners.' });

              case 13:
                _context2.prev = 13;

                _this4.loadingMore = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 10, 13, 16]]);
      }))();
    },
    handleOpenListener: function handleOpenListener(listener) {
      var _this5 = this;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$fallback = _ref3.fallback,
          fallback = _ref3$fallback === undefined ? true : _ref3$fallback;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this5.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_21__graphql_segmentation_listeners_listenerProfileQuery_gql___default.a,
                  variables: { originator: listener.originator },
                  fetchPolicy: 'network-only'
                });

              case 3:
                _ref4 = _context3.sent;
                data = _ref4.data;

                _this5.selectedListenerProfile = data.listenerProfile;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                if (fallback) {
                  _this5.selectedListenerProfile = listener;
                }

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },


    /**
     * Opens another listener's profile, such as a linked one.
     *
     * Note: Says so when the profile cannot be opened. It used to fail
     * silently, which looked like the click did nothing.
     */
    handleViewProfile: function handleViewProfile(originator) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var opened;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.handleOpenListener({ originator: originator }, { fallback: false });

              case 2:
                opened = _this6.selectedListenerProfile;

                if (!opened || opened.originator !== originator) {
                  _this6.$notify({ type: 'warning', message: 'Could not open that profile.' });
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    handleCloseListener: function handleCloseListener() {
      this.selectedListenerProfile = null;
    },
    handleRecommend: function handleRecommend(_ref5) {
      var _this7 = this;

      var brief = _ref5.brief,
          filters = _ref5.filters;

      this.creditsExhausted = false;
      this.$apollo.query({
        client: 'apiv2',
        query: __WEBPACK_IMPORTED_MODULE_22__graphql_segmentation_ai_recommendCampaignQuery_gql___default.a,
        variables: { brief: brief, params: filters },
        fetchPolicy: 'network-only'
      }).then(function (_ref6) {
        var data = _ref6.data;

        _this7.recommendationResult = data.recommendCampaign;
      }).catch(function (e) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["b" /* isCreditsError */])(e)) {
          _this7.creditsExhausted = true;
          return;
        }
        _this7.$notify({
          type: 'error',
          message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["c" /* featureLimitMessage */])(e) || 'Failed to generate recommendation.'
        });
        _this7.recommendError = true;
        setTimeout(function () {
          _this7.recommendError = false;
        }, 100);
      });
    },


    /**
     * Tells the server a recommendation was acted on. A failure is ignored:
     * the export it came with must not be held up by the record.
     */
    handleRecommendationUsed: function handleRecommendationUsed(_ref7) {
      var id = _ref7.id,
          action = _ref7.action;

      this.$apollo.mutate({
        client: 'apiv2',
        mutation: __WEBPACK_IMPORTED_MODULE_23__graphql_segmentation_ai_markRecommendationUsedMutation_gql___default.a,
        variables: { recommendationId: id, action: action }
      }).catch(function () {});
    },
    handleRecommendCleared: function handleRecommendCleared() {
      this.creditsExhausted = false;
      this.recommendationResult = null;
    },


    /**
     * Enriches one listener.
     *
     * Note: The server refuses a listener who has not given permission and
     * says so, then the station is asked. Only "Enrich anyway" sends the
     * override, which the server records.
     */
    handleEnrich: function handleEnrich(listener) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref8, data, _ref9;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.enrichCreditsExhausted = false;
                _this8.enriching = true;

                _context5.prev = 2;
                _context5.next = 5;
                return _this8.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_26__graphql_segmentation_ai_aiListenerProfileQuery_gql___default.a,
                  variables: { originator: listener.originator, includeUnconsented: false },
                  fetchPolicy: 'network-only'
                });

              case 5:
                _ref8 = _context5.sent;
                data = _ref8.data;

                if (!data.aiListenerProfile.consent_required) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 10;
                return _this8.confirmUnconsented(listener.originator);

              case 10:
                if (_context5.sent) {
                  _context5.next = 13;
                  break;
                }

                _this8.$notify({
                  type: 'info',
                  message: listener.originator + ' was not enriched: they haven\'t given permission.'
                });
                return _context5.abrupt('return');

              case 13:
                _context5.next = 15;
                return _this8.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_26__graphql_segmentation_ai_aiListenerProfileQuery_gql___default.a,
                  variables: { originator: listener.originator, includeUnconsented: true },
                  fetchPolicy: 'network-only'
                });

              case 15:
                _ref9 = _context5.sent;
                data = _ref9.data;

              case 17:
                _context5.next = 19;
                return _this8.handleOpenListener({ originator: listener.originator }, { fallback: false });

              case 19:
                _this8.$notify({
                  type: 'success',
                  message: listener.originator + ' profile enriched successfully'
                });
                _context5.next = 25;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5['catch'](2);

                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["b" /* isCreditsError */])(_context5.t0)) {
                  _this8.enrichCreditsExhausted = true;
                } else {
                  _this8.$notify({
                    type: 'error',
                    message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["c" /* featureLimitMessage */])(_context5.t0) || (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["d" /* isNotFoundError */])(_context5.t0) ? 'This listener has no profile on record that can be enriched.' : 'Failed to enrich this profile.')
                  });
                }

              case 25:
                _context5.prev = 25;

                _this8.enriching = false;
                return _context5.finish(25);

              case 28:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[2, 22, 25, 28]]);
      }))();
    },


    /**
     * Asks whether to enrich a listener who has not given permission.
     * Resolves true only for "Enrich anyway".
     *
     * Note: Closing or cancelling the box rejects, which means "no".
     */
    confirmUnconsented: function confirmUnconsented(originator) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this9.$confirm(originator + ' hasn\'t given permission for their data to be processed.', 'Permission not given', {
                  type: 'warning',
                  confirmButtonText: 'Enrich anyway',
                  cancelButtonText: "Don't enrich"
                });

              case 3:
                return _context6.abrupt('return', true);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);
                return _context6.abrupt('return', false);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[0, 6]]);
      }))();
    },
    handleFindSimilar: function handleFindSimilar(_ref10) {
      var _this10 = this;

      var originator = _ref10.originator,
          _ref10$limit = _ref10.limit,
          limit = _ref10$limit === undefined ? 10 : _ref10$limit,
          _ref10$minScore = _ref10.minScore,
          minScore = _ref10$minScore === undefined ? 0.3 : _ref10$minScore,
          callback = _ref10.callback;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _ref11, data, results;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this10.$apollo.query({
                  client: 'apiv2',
                  query: __WEBPACK_IMPORTED_MODULE_24__graphql_segmentation_listeners_similarListenersQuery_gql___default.a,
                  variables: { originator: originator, limit: limit, minScore: minScore },
                  fetchPolicy: 'network-only'
                });

              case 3:
                _ref11 = _context7.sent;
                data = _ref11.data;
                results = data.similarListeners && data.similarListeners.listeners || [];

                if (callback) {
                  callback(results);
                }
                _context7.next = 13;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](0);

                _this10.$notify({
                  type: 'error',
                  message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["d" /* isNotFoundError */])(_context7.t0) ? 'This listener has no profile on record to compare against.' : 'Could not find similar listeners.'
                });
                if (callback) {
                  callback([]);
                }

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 9]]);
      }))();
    },
    handleApplyInferred: function handleApplyInferred(_ref12) {
      var _this11 = this;

      var field = _ref12.field,
          originator = _ref12.originator;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var apiField, _ref13, data, result, reason;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                apiField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__components_segmentation_utils_segmentation__["e" /* toPromoteField */])(field);
                _context8.prev = 1;
                _context8.next = 4;
                return _this11.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_27__graphql_segmentation_ai_promoteDemographicsMutation_gql___default.a,
                  variables: { originator: originator, field: apiField }
                });

              case 4:
                _ref13 = _context8.sent;
                data = _ref13.data;
                result = data.promoteDemographics;

                if (!(result.promoted && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(result.promoted).length > 0)) {
                  _context8.next = 13;
                  break;
                }

                _this11.$notify({ type: 'success', message: result.message });
                _context8.next = 11;
                return _this11.handleOpenListener({ originator: originator }, { fallback: false });

              case 11:
                _context8.next = 15;
                break;

              case 13:
                reason = apiField && result.skipped && result.skipped[apiField] || 'not eligible';

                _this11.$notify({ type: 'warning', message: 'Could not promote: ' + reason });

              case 15:
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](1);

                _this11.$notify({ type: 'error', message: 'Could not promote demographic.' });

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[1, 17]]);
      }))();
    },
    handleReplaceDemographic: function handleReplaceDemographic(_ref14) {
      var _this12 = this;

      var field = _ref14.field,
          originator = _ref14.originator;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return _this12.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_28__graphql_segmentation_ai_replaceDemographicMutation_gql___default.a,
                  variables: { originator: originator, field: field }
                });

              case 3:
                _this12.$notify({
                  type: 'success',
                  message: field ? 'Declared value replaced.' : 'Declared values replaced.'
                });
                _context9.next = 6;
                return _this12.handleOpenListener({ originator: originator }, { fallback: false });

              case 6:
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9['catch'](0);

                _this12.$notify({ type: 'error', message: 'Could not replace the declared value.' });

              case 11:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 8]]);
      }))();
    },
    handleReviewLink: function handleReviewLink(_ref15) {
      var _this13 = this;

      var originator = _ref15.originator,
          type = _ref15.type,
          value = _ref15.value,
          action = _ref15.action;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var done;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                done = {
                  confirm: 'Marked as the same person.',
                  dismiss: 'Suggestion dismissed.',
                  reset: 'Back to an unreviewed suggestion.'
                };
                _context10.prev = 1;
                _context10.next = 4;
                return _this13.$apollo.mutate({
                  client: 'apiv2',
                  mutation: __WEBPACK_IMPORTED_MODULE_29__graphql_segmentation_listeners_reviewLinkedIdentifierMutation_gql___default.a,
                  variables: { originator: originator, type: type, value: value, action: action }
                });

              case 4:
                _this13.$notify({ type: 'success', message: done[action] });
                _context10.next = 7;
                return _this13.handleOpenListener({ originator: originator }, { fallback: false });

              case 7:
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](1);

                _this13.$notify({ type: 'error', message: 'Could not save your decision.' });

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[1, 9]]);
      }))();
    },
    handleDeploy: function handleDeploy(_ref16) {
      var channel = _ref16.channel,
          segment = _ref16.segment;

      this.$notify({
        type: 'success',
        title: 'Campaign Queued',
        message: channel.toUpperCase() + ' campaign for ' + segment + ' audience will be deployed.',
        duration: 5000
      });
    },
    sanitiseParams: function sanitiseParams(params) {
      var MAP = {
        pageSize: 'page_size',
        ageGroup: 'age_group',
        inferredGender: 'inferred_gender',
        inferredAgeGroup: 'inferred_age_group',
        inferredLsm: 'inferred_lsm',
        inferredInterests: 'inferred_interests',
        inferredLanguage: 'inferred_language',
        inferredLocation: 'inferred_location',
        channelType: 'channel_type',
        hasChannel: 'has_channel',
        timeslotId: 'timeslot_id',
        peakTimeOfDay: 'peak_time_of_day',
        lastInteractionAfter: 'last_interaction_after',
        lastInteractionBefore: 'last_interaction_before',
        optIn: 'opt_in',
        audienceId: 'audience_id',
        profileComplete: 'profile_complete'
      };

      var result = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(params).forEach(function (_ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
            key = _ref18[0],
            val = _ref18[1];

        if (val === null || val === undefined || val === '') {
          return;
        }
        var mapped = MAP[key] || key;
        result[mapped] = val;
      });
      return result;
    }
  }
});

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_SocialPost__ = __webpack_require__(3020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_SocialPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_social_SocialPost__);

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialPostsContainer',

  components: {
    SocialPost: __WEBPACK_IMPORTED_MODULE_2__components_social_SocialPost___default.a
  },

  props: {
    channels: {
      type: Array,
      default: []
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('social', ['post', 'isEditing'])),

  methods: {
    onSendPost: function onSendPost(data) {
      var _this = this;

      this.$store.dispatch('social/createSocialPost', data).then(function () {
        return _this.$emit('close');
      }).then(function () {
        return _this.$store.dispatch('social/getScheduledMessages');
      }).catch(function () {
        _this.$alert('An error occurred');
      });
    },
    onUpdatePost: function onUpdatePost(data) {
      var _this2 = this;

      this.$store.dispatch('social/updateScheduledPost', data).then(function () {
        return _this2.$emit('close');
      }).then(function () {
        return _this2.$store.dispatch('social/getScheduledMessages');
      }).catch(function () {
        _this2.$alert('An error occurred');
      });
    },
    onDeletePost: function onDeletePost(id) {
      var _this3 = this;

      this.$store.dispatch('social/deleteScheduledPost', id).then(function () {
        return _this3.$emit('close');
      }).catch(function () {
        _this3.$alert('An error occurred');
      });
    },
    onClose: function onClose() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(2695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 2329 */,
/* 2330 */,
/* 2331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUsers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOrgAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStaff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":181}};
    doc.loc.source = {"body":"query {\n  organizationUsers {\n    id,\n    firstName,\n    lastName,\n    email,\n    isOrgAdmin,\n    isAdmin,\n    isStaff,\n    isActive,\n    company {\n      id,\n      title\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2567 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCompanies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webSite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faxNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAudience"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"woeid"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":257}};
    doc.loc.source = {"body":"query {\n  myCompanies {\n    id,\n    title,\n    webSite,\n    shortName,\n    faxNumber,\n    telephoneNumber,\n    timezone,\n    cumulativeAudience,\n    dateCreated,\n    logoImage,\n    surveyImage,\n    format,\n    genre,\n    country,\n    state,\n    woeid,\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2568 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyData"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":78}};
    doc.loc.source = {"body":"mutation($data: CompanyData!) {\n  updateCompany(data: $data) {\n    title\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2569 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":136}};
    doc.loc.source = {"body":"query($timeslotId: Int, $date: String, $unit: String) {\n  audience(timeslotId: $timeslotId, date: $date, unit: $unit) {\n    stats\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2570 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageDemographics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageContentDemographics"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":103}};
    doc.loc.source = {"body":"query($channelId: Int) {\n  pageDemographics(channelId: $channelId) {\n    pageContentDemographics\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2571 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageDemographics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageFansDemographics"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":100}};
    doc.loc.source = {"body":"query($channelId: Int) {\n  pageDemographics(channelId: $channelId) {\n    pageFansDemographics\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2572 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageDemographics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageImpressionsDemographics"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":107}};
    doc.loc.source = {"body":"query($channelId: Int) {\n  pageDemographics(channelId: $channelId) {\n    pageImpressionsDemographics\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2573 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInsightsOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageViewsTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageFanAddsByPaidNonPaidUnique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageImpressionsUnique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pagePostEngagements"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":183}};
    doc.loc.source = {"body":"query ($channelId: Int) {\n  pageInsightsOverview(channelId: $channelId) {\n    pageViewsTotal\n    pageFanAddsByPaidNonPaidUnique\n    pageImpressionsUnique\n    pagePostEngagements\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2574 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postInsightsOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasNext"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPrev"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reactions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":268}};
    doc.loc.source = {"body":"query ($page: Int, $channelId: Int, $search: String){\n  postInsightsOverview (page: $page, channelId: $channelId, search: $search) {\n    page\n    pages\n    hasNext\n    hasPrev\n    objects {\n      message\n      engagements\n      reactions\n      impressions\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2575 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmingDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"playoutCompare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUnique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniquesPerChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentThreads"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtopics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniques"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":960}};
    doc.loc.source = {"body":"query($timeslotId: Int, $date: String, $unit: String, $playoutCompare: Int) {\n  programmingDashboard(timeslotId: $timeslotId, date: $date, unit: $unit, playoutCompare: $playoutCompare) {\n    engagement {\n      total\n      totalUnique\n      perChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n      uniquesPerChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n    }\n    contentThreads {\n      topics {\n        name\n        subtopics\n        weight\n      }\n    }\n    promotions {\n      entries {\n        name\n        value\n        campaignId\n      }\n      uniques {\n        name\n        value\n        campaignId\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2576 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmingDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"playoutCompare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playoutCompare"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUnique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniquesPerChannel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookPost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cellfind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tweet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commercialLoad"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"musicalLoad"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"topTracks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"contentThreads"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtopics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uniques"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignId"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1140}};
    doc.loc.source = {"body":"query($timeslotId: Int, $date: String, $unit: String, $playoutCompare: Int) {\n  programmingDashboard(timeslotId: $timeslotId, date: $date, unit: $unit, playoutCompare: $playoutCompare) {\n    engagement {\n      total\n      totalUnique\n      perChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n      uniquesPerChannel {\n        message\n        email\n        facebookPost\n        facebookComment\n        facebookMessage\n        instagram\n        cellfind\n        whatsapp\n        tweet\n        telegram\n        survey\n      }\n    }\n    commercialLoad {\n      value\n      date\n      hours\n    }\n    musicalLoad {\n      value\n      date\n      hours\n    }\n    topTracks {\n      artist\n      title\n      count\n    }\n    contentThreads {\n      topics {\n        name\n        subtopics\n        weight\n      }\n    }\n    promotions {\n      entries {\n        name\n        value\n        campaignId\n      }\n      uniques {\n        name\n        value\n        campaignId\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2577 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programmingDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"unit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streaming"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueListeners"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxStreams"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageListeners"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hour"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"averageListenersTrimester"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hour"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"averageDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageConnections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalConnections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTrimesterComplete"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":622}};
    doc.loc.source = {"body":"# query ($startDate: String!, $endDate: String!, $uniquesEndDate: String!) {\n#   stats(startDate: $startDate, endDate: $endDate, uniquesEndDate: $uniquesEndDate)\n# }\n\n\n query ($date: String!, $unit: String!, $filter: String!) {\n  programmingDashboard(date: $date, unit: $unit, filter: $filter) {\n    streaming {\n        uniqueListeners,\n        maxStreams,\n        averageListeners {interval, value, hour},\n        averageListenersTrimester{\n          interval\n          value\n          hour\n        },\n      \taverageDuration,\n        averageConnections,\n        totalConnections,\n        isTrimesterComplete,\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2578 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"period"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"period"},"value":{"kind":"Variable","name":{"kind":"Name","value":"period"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyCategories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyCategoryProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyCategoryProfilePositive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyAnalytics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyProfilePositive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionProfilePositive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periods"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveys"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":406}};
    doc.loc.source = {"body":"query ($filterBy: String!, $period: String!, $surveyId: Int, $date: String!) {\n  surveyAnalytics(filterBy: $filterBy, surveyId: $surveyId, date: $date, period: $period) {\n    surveyCategories\n    surveyCategoryProfile\n    surveyCategoryProfilePositive\n    surveyProfile\n    surveyAnalytics\n    surveyProfilePositive\n    surveyQuestionProfile\n    surveyQuestionProfilePositive\n    periods\n    surveys\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2579 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":75}};
    doc.loc.source = {"body":"mutation($type: String, $id: Int) {\n  generateEmail(type: $type, id: $id)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2580 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailRecipientData"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignSummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveySummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"programmingSummary"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":181}};
    doc.loc.source = {"body":"mutation($data: EmailRecipientData) {\n  createRecipient(data: $data) {\n    id\n    email\n    firstName\n    lastName\n    campaignSummary\n    surveySummary\n    programmingSummary\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2581 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":62}};
    doc.loc.source = {"body":"mutation($id: Int) {\n  deleteRecipient(id: $id) {\n    id\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2582 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipients"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignSummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveySummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"programmingSummary"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":188}};
    doc.loc.source = {"body":"query {\n  recipients {\n    id\n    email\n    firstName\n    lastName\n    companyId\n    company {\n      id\n      title\n    }\n    campaignSummary\n    surveySummary\n    programmingSummary\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2583 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailRecipientData"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignSummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveySummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"programmingSummary"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":214}};
    doc.loc.source = {"body":"mutation($id: Int, $data: EmailRecipientData) {\n  updateRecipient(id: $id, data: $data) {\n    id\n    email\n    firstName\n    lastName\n    companyId\n    campaignSummary\n    surveySummary\n    programmingSummary\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2584 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":94}};
    doc.loc.source = {"body":"query($id: Int){\n  template(id: $id) {\n    id\n    name\n    subject\n    type\n    content\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2585 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":76}};
    doc.loc.source = {"body":"query{\n  templates {\n    id\n    name\n    subject\n    type\n    content\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2586 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"winningDisqualificationDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedcampaignchannelSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pollSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pollchoiceSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"choice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matches"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"replymessage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"encryptOriginator"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":489}};
    doc.loc.source = {"body":"query (\n  $campaignId: Int\n) {\n  campaign(id: $campaignId) {\n    id\n    title\n    startDate\n    endDate\n    campaignType\n    winningDisqualificationDuration\n    createdBy {\n      displayName\n    }\n    linkedcampaignchannelSet {\n      id\n      keyword\n      channel {\n        id\n        handle\n      }\n    }\n    pollSet {\n      id\n      question\n      pollchoiceSet {\n        id\n        choice\n        matches\n      }\n    }\n    replymessage {\n      text\n      encryptOriginator\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2587 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterLive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterChannel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterSortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterTitle"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterType"}}},{"kind":"Argument","name":{"kind":"Name","value":"live"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterLive"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterChannel"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterSortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasNext"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPrev"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perpetual"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"winningDisqualificationDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"favourite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalThisMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalPerDayThisMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedcampaignchannelSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channelTypeTitle"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"replymessage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"encryptOriginator"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":983}};
    doc.loc.source = {"body":"query(\n  $filterTitle: String\n  $filterType: String\n  $filterLive: Boolean\n  $filterChannel: Int\n  $filterSortBy: String\n  $page: Int\n) {\n  campaignList(\n    title: $filterTitle\n    campaignType: $filterType\n    live: $filterLive\n    channel: $filterChannel\n    sortBy: $filterSortBy\n    page: $page\n  ) {\n    page\n    pages\n    hasNext\n    hasPrev\n    objects {\n      id\n      title\n      live\n      perpetual\n      campaignType\n      winningDisqualificationDuration\n      startDate\n      endDate\n      progress\n      favourite\n      survey\n      leadCount\n      createdBy {\n        displayName\n      }\n      engagements {\n        total\n        unique\n        totalThisMonth\n        totalPerDayThisMonth\n        growth\n        # topEngagers\n      }\n      linkedcampaignchannelSet {\n        id\n        keyword\n        channel {\n          id\n          handle\n          channelTypeTitle\n        }\n      }\n      replymessage {\n        text\n        encryptOriginator\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2588 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bearerToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addContactAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bearerToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bearerToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":150}};
    doc.loc.source = {"body":"mutation(\n  $bearerToken: String\n  $provider: String\n) {\n  addContactAccount(\n    bearerToken: $bearerToken\n    provider: $provider\n  ) {\n    id\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2589 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactAccounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":54}};
    doc.loc.source = {"body":"query {\n  contactAccounts {\n    id,\n    provider\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2590 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactListContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":160}};
    doc.loc.source = {"body":"query(\n  $id: Int\n  $listId: String\n) {\n  contactListContacts(\n    id: $id\n    listId: $listId\n  ) {\n    id,\n    firstName,\n    lastName,\n    emailAddress\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2591 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":85}};
    doc.loc.source = {"body":"query(\n  $code: String\n) {\n  accessToken(\n    code: $code\n  ) {\n    accessToken\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2592 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailChimpListContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"listId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":162}};
    doc.loc.source = {"body":"query(\n  $id: Int\n  $listId: String\n) {\n  mailChimpListContacts(\n    id: $id\n    listId: $listId\n  ) {\n    id,\n    firstName,\n    lastName,\n    emailAddress\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2593 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alpha2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alpha3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"continent"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":69}};
    doc.loc.source = {"body":"{\n  countries {\n    name,\n    alpha2,\n    alpha3,\n    continent\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2594 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":72}};
    doc.loc.source = {"body":"query($country: String) {\n  regions(country: $country) {\n    name,\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2595 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignCampaignTypeEnumCreate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"replyMessageCredentials"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":924}};
    doc.loc.source = {"body":"mutation(\n  $campaignTitle: String!\n  $campaignStartDate: CustomDateTime\n  $campaignEndDate: CustomDateTime\n  $campaignType: CampaignCampaignTypeEnumCreate\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $replyMessage: String!\n  $smsReplyUsername: String!\n  $smsReplyPassword: String!,\n  $perpetual: Boolean,\n  $winningDisqualificationDuration: Float\n) {\n  createCampaign(\n    newCampaign: {\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      winningDisqualificationDuration: $winningDisqualificationDuration\n      perpetual: $perpetual\n      live: true\n      default: false\n    }\n    newChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    newReplyMessage: { text: $replyMessage }\n    replyMessageCredentials: { username: $smsReplyUsername, password: $smsReplyPassword }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2596 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignCampaignTypeEnumCreate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PollChoiceInputType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnique"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newPoll"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isUnique"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnique"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newPollChoices"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"choices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":848}};
    doc.loc.source = {"body":"mutation(\n  $campaignTitle: String!\n  $campaignStartDate: CustomDateTime\n  $campaignEndDate: CustomDateTime\n  $campaignType: CampaignCampaignTypeEnumCreate\n  $pollQuestion: String!\n  $pollChoices: [PollChoiceInputType!]!\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $winningDisqualificationDuration: Float\n  $isUnique: Boolean\n) {\n  createCampaign(\n    newCampaign: {\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      winningDisqualificationDuration: $winningDisqualificationDuration\n      live: true\n      default: false\n    }\n    newPoll: { question: $pollQuestion, isUnique: $isUnique }\n    newPollChoices: { choices: $pollChoices }\n    newChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2597 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignCampaignTypeEnumCreate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"replyMessageCredentials"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":924}};
    doc.loc.source = {"body":"mutation(\n  $campaignTitle: String!\n  $campaignStartDate: CustomDateTime\n  $campaignEndDate: CustomDateTime\n  $campaignType: CampaignCampaignTypeEnumCreate\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $replyMessage: String!\n  $smsReplyUsername: String!\n  $smsReplyPassword: String!,\n  $perpetual: Boolean,\n  $winningDisqualificationDuration: Float\n) {\n  createCampaign(\n    newCampaign: {\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      winningDisqualificationDuration: $winningDisqualificationDuration\n      perpetual: $perpetual\n      live: true\n      default: false\n    }\n    newChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    newReplyMessage: { text: $replyMessage }\n    replyMessageCredentials: { username: $smsReplyUsername, password: $smsReplyPassword }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2598 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomDateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignCampaignTypeEnumCreate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PollChoiceInputType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newPoll"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newPollChoices"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"choices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"newReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"replyMessageCredentials"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyUsername"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReplyPassword"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1094}};
    doc.loc.source = {"body":"mutation(\n  $campaignTitle: String!\n  $campaignStartDate: CustomDateTime\n  $campaignEndDate: CustomDateTime\n  $campaignType: CampaignCampaignTypeEnumCreate\n  $pollQuestion: String!\n  $pollChoices: [PollChoiceInputType!]!\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $smsReplyUsername: String!\n  $smsReplyPassword: String!\n  $replyMessage: String!\n  $winningDisqualificationDuration: Float\n  $perpetual: Boolean\n) {\n  createCampaign(\n    newCampaign: {\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      winningDisqualificationDuration: $winningDisqualificationDuration\n      perpetual: $perpetual\n      live: true\n      default: false\n    }\n    newPoll: {\n      question: $pollQuestion\n    }\n    newPollChoices: {\n      choices: $pollChoices\n    }\n    newChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    newReplyMessage: { text: $replyMessage }\n    replyMessageCredentials: { username: $smsReplyUsername, password: $smsReplyPassword }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2599 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFavourite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favouriteCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isFavourite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFavourite"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":116}};
    doc.loc.source = {"body":"mutation($id: ID!, $isFavourite: Boolean!) {\n  favouriteCampaign(id: $id, isFavourite: $isFavourite) {\n    ok\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2600 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLive"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isLive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLive"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":96}};
    doc.loc.source = {"body":"mutation($id: ID!, $isLive: Boolean!) {\n  liveCampaign(id: $id, isLive: $isLive) {\n    ok\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2601 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePermissionProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":62}};
    doc.loc.source = {"body":"mutation($id: String!) {\n  deletePermissionProfile(id: $id)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2602 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionNuggetInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermissionNugget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nugget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}}}],"directives":[]}]}}],"loc":{"start":0,"end":94}};
    doc.loc.source = {"body":"mutation($nugget: UpdatePermissionNuggetInput!) {\n  updatePermissionNugget(nugget: $nugget)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2603 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfilePermissionActivityLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profilePermissionActivityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logs"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":189}};
    doc.loc.source = {"body":"query GetProfilePermissionActivityLogs($profile_id: ID!, $page: Int, $size: Int) {\n  profilePermissionActivityLogs(profile_id: $profile_id, page: $page, size: $size) {\n    id\n    logs\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetProfilePermissionActivityLogs"] = oneQuery(doc, "GetProfilePermissionActivityLogs");
        


/***/ }),
/* 2604 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lockStatus"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":92}};
    doc.loc.source = {"body":"query($id: String) {\n  profileActivity(id: $id) {\n    id\n    editStatus\n    lockStatus\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2605 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LockProfilePermissionInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockPermissionProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":89}};
    doc.loc.source = {"body":"mutation($query: LockProfilePermissionInput!) {\n  lockPermissionProfile(query: $query)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2606 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovePermissionNuggetInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePermissionNugget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nugget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}}}],"directives":[]}]}}],"loc":{"start":0,"end":94}};
    doc.loc.source = {"body":"mutation($nugget: RemovePermissionNuggetInput!) {\n  removePermissionNugget(nugget: $nugget)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2607 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":138}};
    doc.loc.source = {"body":"query($query: Json!) {\n  searchProfile(query: $query) {\n    filteredTotal\n    profiles {\n      id\n      identifier\n      image\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2608 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendProfilePermissionVerificationInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPermissionProfileOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":104}};
    doc.loc.source = {"body":"mutation($query: SendProfilePermissionVerificationInput!) {\n  sendPermissionProfileOtp(query: $query)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2609 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProfilePermissionInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermissionProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nugget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}}}],"directives":[]}]}}],"loc":{"start":0,"end":96}};
    doc.loc.source = {"body":"mutation($nugget: UpdateProfilePermissionInput!) {\n  updatePermissionProfile(nugget: $nugget)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2610 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyProfilePermissionVerificationInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPermissionProfileOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":107}};
    doc.loc.source = {"body":"mutation($query: VerifyProfilePermissionVerificationInput!) {\n  verifyPermissionProfileOtp(query: $query)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2611 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"privacyOptinsCount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optin"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"age"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":161}};
    doc.loc.source = {"body":"query {\n  privacyOptinsCount {\n    total\n    optin {\n      yes\n      no\n    }\n    permission {\n      yes\n      no\n    }\n    age {\n      yes\n      no\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2612 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlacklistNuggetInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blacklistNugget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nugget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}}}],"directives":[]}]}}],"loc":{"start":0,"end":80}};
    doc.loc.source = {"body":"mutation($nugget: BlacklistNuggetInput!) {\n  blacklistNugget(nugget: $nugget)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2613 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossPlatformEngagement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audience"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethnicity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfChannels"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":338}};
    doc.loc.source = {"body":"query {\n  charts {\n    crossPlatformEngagement\n    audience {\n      age\n      gender\n      ethnicity {\n        label\n        percentage\n      }\n      location {\n        label\n        percentage\n      }\n      language {\n        label\n        percentage\n      }\n      numberOfChannels {\n        label\n        percentage\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2614 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sampleSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileCreateSampleset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sampleSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sampleSize"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sampleSize"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":185}};
    doc.loc.source = {"body":"mutation($name: String!, $filter: Json!, $sampleSize: Int!) {\n  profileCreateSampleset(name: $name, filter: $filter, sampleSize: $sampleSize) {\n    name\n    filter\n    sampleSize\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2615 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":59}};
    doc.loc.source = {"body":"mutation($id: Int) {\n  deleteQuery(id: $id) {\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2616 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demographics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethnicity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"show"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uniques"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":362}};
    doc.loc.source = {"body":"query {\n  filters {\n    demographics {\n      age \n      ethnicity\n      gender\n      location\n      language\n      contact {\n        id\n        title\n      }\n      channel {\n        id\n        handle\n        type\n      }\n      show {\n        id\n        title\n      }\n    }\n    campaigns {\n      id\n      title\n      type\n      startDate\n      uniques\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2617 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugins"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":36}};
    doc.loc.source = {"body":"query {\n  plugins {\n    plugin\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2618 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveNuggetInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeNugget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nugget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nugget"}}}],"directives":[]}]}}],"loc":{"start":0,"end":74}};
    doc.loc.source = {"body":"mutation($nugget: RemoveNuggetInput!) {\n  removeNugget(nugget: $nugget)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2619 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":163}};
    doc.loc.source = {"body":"mutation($title: String, $filter: Json!, $fields: [String]) {\n  saveQuery(title: $title, filter: $filter, fields: $fields) {\n    title\n    filter\n    fields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2620 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedQueries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":85}};
    doc.loc.source = {"body":"query {\n  savedQueries {\n    id\n    title\n    insertedAt\n    filter\n    fields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2621 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filteredTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":167}};
    doc.loc.source = {"body":"query ($query: Json!, $page: Int) {\n  search(query: $query, page: $page) {\n    total\n    filteredTotal\n    profiles {\n      id\n      identifier\n      image\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2622 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AiListenerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiListenerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUnconsented"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}}}],"directives":[]}]}}],"loc":{"start":0,"end":166}};
    doc.loc.source = {"body":"query AiListenerProfile($originator: String!, $includeUnconsented: Boolean) {\n  aiListenerProfile(originator: $originator, includeUnconsented: $includeUnconsented)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AiListenerProfile"] = oneQuery(doc, "AiListenerProfile");
        


/***/ }),
/* 2623 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkRecommendationUsed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recommendationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markRecommendationUsed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recommendationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recommendationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}}],"directives":[]}]}}],"loc":{"start":0,"end":161}};
    doc.loc.source = {"body":"mutation MarkRecommendationUsed($recommendationId: String!, $action: String!) {\n  markRecommendationUsed(recommendationId: $recommendationId, action: $action)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["MarkRecommendationUsed"] = oneQuery(doc, "MarkRecommendationUsed");
        


/***/ }),
/* 2624 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PromoteDemographics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoteDemographics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}},{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}}],"directives":[]}]}}],"loc":{"start":0,"end":133}};
    doc.loc.source = {"body":"mutation PromoteDemographics($originator: String!, $field: String) {\n  promoteDemographics(originator: $originator, field: $field)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["PromoteDemographics"] = oneQuery(doc, "PromoteDemographics");
        


/***/ }),
/* 2625 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brief"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brief"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brief"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[]}]}}],"loc":{"start":0,"end":119}};
    doc.loc.source = {"body":"query RecommendCampaign($brief: String!, $params: FilterInput) {\n  recommendCampaign(brief: $brief, params: $params)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RecommendCampaign"] = oneQuery(doc, "RecommendCampaign");
        


/***/ }),
/* 2626 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplaceDemographic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replaceDemographic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}},{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}}],"directives":[]}]}}],"loc":{"start":0,"end":131}};
    doc.loc.source = {"body":"mutation ReplaceDemographic($originator: String!, $field: String) {\n  replaceDemographic(originator: $originator, field: $field)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ReplaceDemographic"] = oneQuery(doc, "ReplaceDemographic");
        


/***/ }),
/* 2627 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateListeners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateListeners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channelCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genderCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageGroupCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locationCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethnicityCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segmentCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"momentumCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignTypeCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakTimeOfDayCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakHourCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryDayOfWeekCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakMonthCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patternCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publicHolidayCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeslotCounts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLsmCounts"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":464}};
    doc.loc.source = {"body":"query AggregateListeners($params: FilterInput) {\n  aggregateListeners(params: $params) {\n    total\n    channelCounts\n    genderCounts\n    ageGroupCounts\n    languageCounts\n    locationCounts\n    ethnicityCounts\n    segmentCounts\n    momentumCounts\n    campaignTypeCounts\n    tagCounts\n    peakTimeOfDayCounts\n    peakHourCounts\n    primaryDayOfWeekCounts\n    peakMonthCounts\n    patternCounts\n    publicHolidayCounts\n    timeslotCounts\n    inferredLsmCounts\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AggregateListeners"] = oneQuery(doc, "AggregateListeners");
        


/***/ }),
/* 2628 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CrossChannelEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crossChannelEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uniques"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matrix"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentages"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":165}};
    doc.loc.source = {"body":"query CrossChannelEngagement($params: FilterInput) {\n  crossChannelEngagement(params: $params) {\n    total\n    channels\n    uniques\n    matrix\n    percentages\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CrossChannelEngagement"] = oneQuery(doc, "CrossChannelEngagement");
        


/***/ }),
/* 2629 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileCompleteness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileCompleteness"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completeCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incompleteCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingFieldCounts"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":168}};
    doc.loc.source = {"body":"query ProfileCompleteness($params: FilterInput) {\n  profileCompleteness(params: $params) {\n    total\n    completeCount\n    incompleteCount\n    missingFieldCounts\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ProfileCompleteness"] = oneQuery(doc, "ProfileCompleteness");
        


/***/ }),
/* 2630 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterListeners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterListeners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMatches"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listeners"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originatorType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentSegment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousSegment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segmentUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethnicity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incomeBracket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"education"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occupation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"residentialStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryChannelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastChannelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distinctChannels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channelDistribution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryCampaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignTypeDistribution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topCampaigns"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryTimeslotId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryTimeslotTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeslotConsistency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakTimeOfDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakHour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryDayOfWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWeekendDominant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWeekdayDominant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastSevenDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastThirtyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastNinetyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsPreviousThirty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"momentum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recencyScore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frequencyScore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recencyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastInteractionAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastCampaignTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastCampaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstInteractionAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredGender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredGenderConfidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredAgeGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredAgeGroupConfidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLsm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLanguage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEthnicity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredIncomeBracket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEducation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEmploymentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredMaritalStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredOccupation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLifeStage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredReasoning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredInterests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredProductAffinity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestSources"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matchReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"competitionTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pollTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyInteractions"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1885}};
    doc.loc.source = {"body":"query FilterListeners($params: FilterInput) {\n  filterListeners(params: $params) {\n    totalMatches\n    page\n    pageSize\n    listeners {\n      originator\n      originatorType\n      displayName\n      profileImage\n\n      currentSegment\n      previousSegment\n      segmentUpdatedAt\n      tags\n\n      gender\n      ageGroup\n      location\n      language\n      ethnicity\n      name\n      email\n      mobileNumber\n      idNumber\n      incomeBracket\n      education\n      employmentStatus\n      maritalStatus\n      occupation\n      dwellingType\n      residentialStatus\n\n      primaryChannelType\n      lastChannelType\n      distinctChannels\n      channelDistribution\n\n      primaryCampaignType\n      campaignTypeDistribution\n      topCampaigns\n\n      primaryTimeslotId\n      primaryTimeslotTitle\n      timeslotConsistency\n\n      peakTimeOfDay\n      peakHour\n      peakMonth\n      primaryDayOfWeek\n      isWeekendDominant\n      isWeekdayDominant\n\n      interactionsLastSevenDays\n      interactionsLastThirtyDays\n      interactionsLastNinetyDays\n      interactionsTotal\n      interactionsPreviousThirty\n      momentum\n      recencyScore\n      frequencyScore\n      recencyDays\n\n      lastInteractionAt\n      lastCampaignTitle\n      lastCampaignType\n      firstInteractionAt\n      profileUpdatedAt\n\n      inferredGender\n      inferredGenderConfidence\n      inferredAgeGroup\n      inferredAgeGroupConfidence\n      inferredLocation\n      inferredLsm\n      inferredLanguage\n      inferredEthnicity\n      inferredIncomeBracket\n      inferredEducation\n      inferredEmploymentStatus\n      inferredMaritalStatus\n      inferredOccupation\n      inferredLifeStage\n      inferredReasoning\n      inferredInterests\n      inferredProductAffinity\n      interestSources\n      matchReason\n\n      competitionTier\n      pollTier\n      surveyTier\n\n      permission\n      optIn\n\n      monthlyInteractions\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FilterListeners"] = oneQuery(doc, "FilterListeners");
        


/***/ }),
/* 2631 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListenerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listenerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originatorType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentSegment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousSegment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segmentUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genderSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethnicity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"incomeBracket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"education"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maritalStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occupation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"residentialStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedIdentifiers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aiConflicts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scores"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"momentum"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recencyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastInteractionAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastChannelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastCampaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastCampaignTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastSevenDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastThirtyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsLastNinetyDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interactionsPreviousThirty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distinctChannels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryChannelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channelDistribution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryCampaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignTypeDistribution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeslotConsistency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryTimeslotId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryTimeslotTitle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timePatterns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peakHour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakTimeOfDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peakMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryDayOfWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWeekdayDominant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWeekendDominant"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignInterests"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topCampaigns"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"firstInteractionAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredGender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredGenderConfidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredAgeGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredAgeGroupConfidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLsm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLanguage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEthnicity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredIncomeBracket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEducation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredEmploymentStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredMaritalStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredOccupation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredLifeStage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredReasoning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredOutlook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profilesEnrichedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnLikelihood"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnProbability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredInterests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inferredProductAffinity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestSources"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"competitionTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pollTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyTier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optIn"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1946}};
    doc.loc.source = {"body":"query ListenerProfile($originator: String!) {\n  listenerProfile(originator: $originator) {\n    originator\n    originatorType\n    displayName\n    profileImage\n\n    currentSegment\n    previousSegment\n    segmentUpdatedAt\n    tags\n\n    name\n    gender\n    genderSource\n    ageGroup\n    location\n    language\n    ethnicity\n    email\n    mobileNumber\n    idNumber\n    incomeBracket\n    education\n    employmentStatus\n    maritalStatus\n    occupation\n    dwellingType\n    residentialStatus\n\n    interactions\n    linkedIdentifiers\n    linkedFrom\n    aiConflicts\n\n    scores {\n      recency\n      frequency\n      momentum\n    }\n\n    signals {\n      recencyDays\n      lastInteractionAt\n      lastChannelType\n      lastCampaignType\n      lastCampaignTitle\n      interactionsLastSevenDays\n      interactionsLastThirtyDays\n      interactionsLastNinetyDays\n      interactionsTotal\n      interactionsPreviousThirty\n      distinctChannels\n      primaryChannelType\n      channelDistribution\n      primaryCampaignType\n      campaignTypeDistribution\n      timeslotConsistency\n      primaryTimeslotId\n      primaryTimeslotTitle\n    }\n\n    timePatterns {\n      peakHour\n      peakTimeOfDay\n      peakMonth\n      primaryDayOfWeek\n      isWeekdayDominant\n      isWeekendDominant\n    }\n\n    campaignInterests {\n      topCampaigns\n    }\n\n    firstInteractionAt\n    profileUpdatedAt\n\n    inferredGender\n    inferredGenderConfidence\n    inferredAgeGroup\n    inferredAgeGroupConfidence\n    inferredLocation\n    inferredLsm\n    inferredLanguage\n    inferredEthnicity\n    inferredIncomeBracket\n    inferredEducation\n    inferredEmploymentStatus\n    inferredMaritalStatus\n    inferredOccupation\n    inferredLifeStage\n    inferredReasoning\n    inferredOutlook\n    profilesEnrichedAt\n    returnLikelihood\n    returnProbability\n    inferredInterests\n    inferredProductAffinity\n    interestSources\n\n    competitionTier\n    pollTier\n    surveyTier\n\n    permission\n    optIn\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ListenerProfile"] = oneQuery(doc, "ListenerProfile");
        


/***/ }),
/* 2632 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewLinkedIdentifier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewLinkedIdentifier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}}],"directives":[]}]}}],"loc":{"start":0,"end":211}};
    doc.loc.source = {"body":"mutation ReviewLinkedIdentifier(\n  $originator: String!\n  $type: String!\n  $value: String!\n  $action: String!\n) {\n  reviewLinkedIdentifier(originator: $originator, type: $type, value: $value, action: $action)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ReviewLinkedIdentifier"] = oneQuery(doc, "ReviewLinkedIdentifier");
        


/***/ }),
/* 2633 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SimilarListeners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minScore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"similarListeners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originator"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"minScore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minScore"}}}],"directives":[]}]}}],"loc":{"start":0,"end":160}};
    doc.loc.source = {"body":"query SimilarListeners($originator: String!, $limit: Int, $minScore: Float) {\n  similarListeners(originator: $originator, limit: $limit, minScore: $minScore)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SimilarListeners"] = oneQuery(doc, "SimilarListeners");
        


/***/ }),
/* 2634 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToRetargetBucket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupLabel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupKind"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToRetargetBucket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupLabel"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupKind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupKind"}}},{"kind":"Argument","name":{"kind":"Name","value":"originators"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originators"}}},{"kind":"Argument","name":{"kind":"Name","value":"audienceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUnconsented"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}}}],"directives":[]}]}}],"loc":{"start":0,"end":430}};
    doc.loc.source = {"body":"mutation AddToRetargetBucket(\n  $groupKey: String!\n  $groupLabel: String!\n  $groupKind: String\n  $originators: [String!]\n  $audienceId: String\n  $params: FilterInput\n  $includeUnconsented: Boolean\n) {\n  addToRetargetBucket(\n    groupKey: $groupKey\n    groupLabel: $groupLabel\n    groupKind: $groupKind\n    originators: $originators\n    audienceId: $audienceId\n    params: $params\n    includeUnconsented: $includeUnconsented\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AddToRetargetBucket"] = oneQuery(doc, "AddToRetargetBucket");
        


/***/ }),
/* 2635 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportConsentCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useBucket"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupKeys"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelPair"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportConsentCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}},{"kind":"Argument","name":{"kind":"Name","value":"audienceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useBucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useBucket"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupKeys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupKeys"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelType"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelPair"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelPair"}}}],"directives":[]}]}}],"loc":{"start":0,"end":352}};
    doc.loc.source = {"body":"query ExportConsentCheck(\n  $params: FilterInput\n  $audienceId: String\n  $useBucket: Boolean\n  $groupKeys: [String!]\n  $channelType: Int\n  $channelPair: String\n) {\n  exportConsentCheck(\n    params: $params\n    audienceId: $audienceId\n    useBucket: $useBucket\n    groupKeys: $groupKeys\n    channelType: $channelType\n    channelPair: $channelPair\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ExportConsentCheck"] = oneQuery(doc, "ExportConsentCheck");
        


/***/ }),
/* 2636 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nonNull"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useBucket"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupKeys"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelPair"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"nonNull"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonNull"}}},{"kind":"Argument","name":{"kind":"Name","value":"audienceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useBucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useBucket"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupKeys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupKeys"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelType"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelPair"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelPair"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUnconsented"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnconsented"}}}],"directives":[]}]}}],"loc":{"start":0,"end":494}};
    doc.loc.source = {"body":"query ExportRows(\n  $params: FilterInput\n  $fields: [String!]\n  $nonNull: Boolean\n  $audienceId: String\n  $useBucket: Boolean\n  $groupKeys: [String!]\n  $channelType: Int\n  $channelPair: String\n  $includeUnconsented: Boolean\n) {\n  exportRows(\n    params: $params\n    fields: $fields\n    nonNull: $nonNull\n    audienceId: $audienceId\n    useBucket: $useBucket\n    groupKeys: $groupKeys\n    channelType: $channelType\n    channelPair: $channelPair\n    includeUnconsented: $includeUnconsented\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ExportRows"] = oneQuery(doc, "ExportRows");
        


/***/ }),
/* 2637 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetargetBucket"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retargetBucket"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":42}};
    doc.loc.source = {"body":"query RetargetBucket {\n  retargetBucket\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RetargetBucket"] = oneQuery(doc, "RetargetBucket");
        


/***/ }),
/* 2638 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetargetConsentCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retargetConsentCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originators"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originators"}}},{"kind":"Argument","name":{"kind":"Name","value":"audienceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}],"directives":[]}]}}],"loc":{"start":0,"end":191}};
    doc.loc.source = {"body":"query RetargetConsentCheck($originators: [String!], $audienceId: String, $params: FilterInput) {\n  retargetConsentCheck(originators: $originators, audienceId: $audienceId, params: $params)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RetargetConsentCheck"] = oneQuery(doc, "RetargetConsentCheck");
        


/***/ }),
/* 2639 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshStationData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshStationData"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":53}};
    doc.loc.source = {"body":"mutation RefreshStationData {\n  refreshStationData\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RefreshStationData"] = oneQuery(doc, "RefreshStationData");
        


/***/ }),
/* 2640 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SegmentFreshness"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentFreshness"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":46}};
    doc.loc.source = {"body":"query SegmentFreshness {\n  segmentFreshness\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SegmentFreshness"] = oneQuery(doc, "SegmentFreshness");
        


/***/ }),
/* 2641 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SegmentInsights"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentInsights"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalListeners"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"summary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":213}};
    doc.loc.source = {"body":"query SegmentInsights {\n  segmentInsights {\n    totalListeners\n    summary\n    segments {\n      key\n      label\n      count\n      percentage\n      description\n      action\n      category\n    }\n  }\n  segmentTags\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SegmentInsights"] = oneQuery(doc, "SegmentInsights");
        


/***/ }),
/* 2642 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SegmentSummary"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalListeners"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highEngagementCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segmentCounts"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"query SegmentSummary {\n  segmentSummary {\n    totalListeners\n    highEngagementCount\n    segmentCounts\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["SegmentSummary"] = oneQuery(doc, "SegmentSummary");
        


/***/ }),
/* 2643 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Segments"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segments"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":30}};
    doc.loc.source = {"body":"query Segments {\n  segments\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Segments"] = oneQuery(doc, "Segments");
        


/***/ }),
/* 2644 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"encryptOriginator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedcampaignchannelSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pollSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pollchoiceSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"choice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matches"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignadvertiser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prizeCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prizeQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prizeSpend"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prizeVolume"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesGenerated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadsGenerated"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"replymessage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1418}};
    doc.loc.source = {"body":"mutation(\n  $campaignId: Int\n  $campaignTitle: String!\n  $campaignStartDate: DateTime\n  $campaignEndDate: DateTime\n  $campaignType: CampaignTypeEnum\n  $winningDisqualificationDuration: Float\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $replyMessage: String!\n  $perpetual: Boolean\n  $encryptOriginator: Boolean!\n) {\n  updateCampaign(\n    updatedCampaign: {\n      id: $campaignId\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      perpetual: $perpetual\n      winningDisqualificationDuration: $winningDisqualificationDuration\n    }\n    updatedChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    updatedReplyMessage: { text: $replyMessage, encryptOriginator: $encryptOriginator }\n  ) {\n    campaign {\n      id\n      title\n      startDate\n      endDate\n      campaignType\n      linkedcampaignchannelSet {\n        id\n        keyword\n        channel {\n          id\n          handle\n        }\n      }\n      pollSet {\n        id\n        question\n        pollchoiceSet {\n          id\n          choice\n          matches\n        }\n      }\n      campaignadvertiser {\n        id\n        advertiser\n        category\n        prizeCategory\n        prizeQuantity\n        prizeSpend\n        prizeVolume\n        salesGenerated\n        leadsGenerated\n      }\n      replymessage {\n        id\n        text\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2645 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"encryptOriginator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":833}};
    doc.loc.source = {"body":"mutation(\n  $campaignId: Int\n  $campaignTitle: String!\n  $campaignStartDate: DateTime\n  $campaignEndDate: DateTime\n  $campaignType: CampaignTypeEnum\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $replyMessage: String!\n  $encryptOriginator: Boolean!\n  $winningDisqualificationDuration: Float\n  $perpetual: Boolean\n) {\n  updateCampaign(\n    updatedCampaign: {\n      id: $campaignId\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      perpetual: $perpetual\n      winningDisqualificationDuration: $winningDisqualificationDuration\n    }\n    updatedChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    updatedReplyMessage: { text: $replyMessage, encryptOriginator: $encryptOriginator }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2646 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PollChoiceInputType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedCampaign"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignEndDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"campaignType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perpetual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perpetual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"winningDisqualificationDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"winningDisqualificationDuration"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedPoll"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollQuestion"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedPollChoices"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"choices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollChoices"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedChannelLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelKeywords"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"updatedReplyMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyMessage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"encryptOriginator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"encryptOriginator"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":993}};
    doc.loc.source = {"body":"mutation(\n  $campaignId: Int\n  $campaignTitle: String!\n  $campaignStartDate: DateTime\n  $campaignEndDate: DateTime\n  $campaignType: CampaignTypeEnum\n  $pollQuestion: String!\n  $pollChoices: [PollChoiceInputType!]!\n  $channelKeywords: [String]\n  $channelIds: [Int]\n  $replyMessage: String!\n  $encryptOriginator: Boolean!\n  $perpetual: Boolean\n  $winningDisqualificationDuration: Float\n) {\n  updateCampaign(\n    updatedCampaign: {\n      id: $campaignId\n      title: $campaignTitle\n      startDate: $campaignStartDate\n      endDate: $campaignEndDate\n      campaignType: $campaignType\n      perpetual: $perpetual\n      winningDisqualificationDuration: $winningDisqualificationDuration\n    }\n    updatedPoll: { question: $pollQuestion }\n    updatedPollChoices: { choices: $pollChoices }\n    updatedChannelLinks: { keywords: $channelKeywords, channelIds: $channelIds }\n    updatedReplyMessage: { text: $replyMessage, encryptOriginator: $encryptOriginator }\n  ) {\n    campaign {\n      id\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2647 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagTranscriptInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagTranscript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[]}]}}],"loc":{"start":0,"end":74}};
    doc.loc.source = {"body":"mutation($query: FlagTranscriptInput!) {\n  flagTranscript(query: $query)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2648 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeslots"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":45}};
    doc.loc.source = {"body":"query {\n  timeslots {\n    id\n    title\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2649 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TranscriptAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"weekOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"monthOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"yearOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearOffset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"week"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"month"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":909}};
    doc.loc.source = {"body":"query TranscriptAnalytics(\n  $timeslotid: String!\n  $dayOffset: Int\n  $weekOffset: Int\n  $monthOffset: Int\n  $yearOffset: Int\n) {\n  transcriptAnalytics(\n    timeslotId: $timeslotid\n    dayOffset: $dayOffset\n    weekOffset: $weekOffset\n    monthOffset: $monthOffset\n    yearOffset: $yearOffset\n  ) {\n    day {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    week {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    month {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    year {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["TranscriptAnalytics"] = oneQuery(doc, "TranscriptAnalytics");
        


/***/ }),
/* 2650 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcripts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeslotId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audioDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flaggedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentiment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"summary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flaggedById"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approvedById"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flaggedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approvedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approveReason"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":421}};
    doc.loc.source = {"body":"query($timeslotid: String!) {\n  transcripts(timeslotId: $timeslotid) {\n    id\n    timeslotId\n    audioUrl\n    audioDuration\n    approved\n    approvedAt\n    flagged\n    flaggedAt\n    keywords\n    location\n    people\n    score\n    sender\n    sentiment\n    summary\n    tags\n    timestamp\n    tone\n    topics\n    transcript\n    flaggedById\n    approvedById\n    flaggedBy\n    approvedBy\n    flagReason\n    approveReason\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 774,
	"./af.js": 774,
	"./ar": 781,
	"./ar-dz": 775,
	"./ar-dz.js": 775,
	"./ar-kw": 776,
	"./ar-kw.js": 776,
	"./ar-ly": 777,
	"./ar-ly.js": 777,
	"./ar-ma": 778,
	"./ar-ma.js": 778,
	"./ar-sa": 779,
	"./ar-sa.js": 779,
	"./ar-tn": 780,
	"./ar-tn.js": 780,
	"./ar.js": 781,
	"./az": 782,
	"./az.js": 782,
	"./be": 783,
	"./be.js": 783,
	"./bg": 784,
	"./bg.js": 784,
	"./bm": 785,
	"./bm.js": 785,
	"./bn": 786,
	"./bn.js": 786,
	"./bo": 787,
	"./bo.js": 787,
	"./br": 788,
	"./br.js": 788,
	"./bs": 789,
	"./bs.js": 789,
	"./ca": 790,
	"./ca.js": 790,
	"./cs": 791,
	"./cs.js": 791,
	"./cv": 792,
	"./cv.js": 792,
	"./cy": 793,
	"./cy.js": 793,
	"./da": 794,
	"./da.js": 794,
	"./de": 797,
	"./de-at": 795,
	"./de-at.js": 795,
	"./de-ch": 796,
	"./de-ch.js": 796,
	"./de.js": 797,
	"./dv": 798,
	"./dv.js": 798,
	"./el": 799,
	"./el.js": 799,
	"./en-SG": 800,
	"./en-SG.js": 800,
	"./en-au": 801,
	"./en-au.js": 801,
	"./en-ca": 802,
	"./en-ca.js": 802,
	"./en-gb": 803,
	"./en-gb.js": 803,
	"./en-ie": 804,
	"./en-ie.js": 804,
	"./en-il": 805,
	"./en-il.js": 805,
	"./en-nz": 806,
	"./en-nz.js": 806,
	"./eo": 807,
	"./eo.js": 807,
	"./es": 810,
	"./es-do": 808,
	"./es-do.js": 808,
	"./es-us": 809,
	"./es-us.js": 809,
	"./es.js": 810,
	"./et": 811,
	"./et.js": 811,
	"./eu": 812,
	"./eu.js": 812,
	"./fa": 813,
	"./fa.js": 813,
	"./fi": 814,
	"./fi.js": 814,
	"./fo": 815,
	"./fo.js": 815,
	"./fr": 818,
	"./fr-ca": 816,
	"./fr-ca.js": 816,
	"./fr-ch": 817,
	"./fr-ch.js": 817,
	"./fr.js": 818,
	"./fy": 819,
	"./fy.js": 819,
	"./ga": 820,
	"./ga.js": 820,
	"./gd": 821,
	"./gd.js": 821,
	"./gl": 822,
	"./gl.js": 822,
	"./gom-latn": 823,
	"./gom-latn.js": 823,
	"./gu": 824,
	"./gu.js": 824,
	"./he": 825,
	"./he.js": 825,
	"./hi": 826,
	"./hi.js": 826,
	"./hr": 827,
	"./hr.js": 827,
	"./hu": 828,
	"./hu.js": 828,
	"./hy-am": 829,
	"./hy-am.js": 829,
	"./id": 830,
	"./id.js": 830,
	"./is": 831,
	"./is.js": 831,
	"./it": 833,
	"./it-ch": 832,
	"./it-ch.js": 832,
	"./it.js": 833,
	"./ja": 834,
	"./ja.js": 834,
	"./jv": 835,
	"./jv.js": 835,
	"./ka": 836,
	"./ka.js": 836,
	"./kk": 837,
	"./kk.js": 837,
	"./km": 838,
	"./km.js": 838,
	"./kn": 839,
	"./kn.js": 839,
	"./ko": 840,
	"./ko.js": 840,
	"./ku": 841,
	"./ku.js": 841,
	"./ky": 842,
	"./ky.js": 842,
	"./lb": 843,
	"./lb.js": 843,
	"./lo": 844,
	"./lo.js": 844,
	"./lt": 845,
	"./lt.js": 845,
	"./lv": 846,
	"./lv.js": 846,
	"./me": 847,
	"./me.js": 847,
	"./mi": 848,
	"./mi.js": 848,
	"./mk": 849,
	"./mk.js": 849,
	"./ml": 850,
	"./ml.js": 850,
	"./mn": 851,
	"./mn.js": 851,
	"./mr": 852,
	"./mr.js": 852,
	"./ms": 854,
	"./ms-my": 853,
	"./ms-my.js": 853,
	"./ms.js": 854,
	"./mt": 855,
	"./mt.js": 855,
	"./my": 856,
	"./my.js": 856,
	"./nb": 857,
	"./nb.js": 857,
	"./ne": 858,
	"./ne.js": 858,
	"./nl": 860,
	"./nl-be": 859,
	"./nl-be.js": 859,
	"./nl.js": 860,
	"./nn": 861,
	"./nn.js": 861,
	"./pa-in": 862,
	"./pa-in.js": 862,
	"./pl": 863,
	"./pl.js": 863,
	"./pt": 865,
	"./pt-br": 864,
	"./pt-br.js": 864,
	"./pt.js": 865,
	"./ro": 866,
	"./ro.js": 866,
	"./ru": 867,
	"./ru.js": 867,
	"./sd": 868,
	"./sd.js": 868,
	"./se": 869,
	"./se.js": 869,
	"./si": 870,
	"./si.js": 870,
	"./sk": 871,
	"./sk.js": 871,
	"./sl": 872,
	"./sl.js": 872,
	"./sq": 873,
	"./sq.js": 873,
	"./sr": 875,
	"./sr-cyrl": 874,
	"./sr-cyrl.js": 874,
	"./sr.js": 875,
	"./ss": 876,
	"./ss.js": 876,
	"./sv": 877,
	"./sv.js": 877,
	"./sw": 878,
	"./sw.js": 878,
	"./ta": 879,
	"./ta.js": 879,
	"./te": 880,
	"./te.js": 880,
	"./tet": 881,
	"./tet.js": 881,
	"./tg": 882,
	"./tg.js": 882,
	"./th": 883,
	"./th.js": 883,
	"./tl-ph": 884,
	"./tl-ph.js": 884,
	"./tlh": 885,
	"./tlh.js": 885,
	"./tr": 886,
	"./tr.js": 886,
	"./tzl": 887,
	"./tzl.js": 887,
	"./tzm": 889,
	"./tzm-latn": 888,
	"./tzm-latn.js": 888,
	"./tzm.js": 889,
	"./ug-cn": 890,
	"./ug-cn.js": 890,
	"./uk": 891,
	"./uk.js": 891,
	"./ur": 892,
	"./ur.js": 892,
	"./uz": 894,
	"./uz-latn": 893,
	"./uz-latn.js": 893,
	"./uz.js": 894,
	"./vi": 895,
	"./vi.js": 895,
	"./x-pseudo": 896,
	"./x-pseudo.js": 896,
	"./yo": 897,
	"./yo.js": 897,
	"./zh-cn": 898,
	"./zh-cn.js": 898,
	"./zh-hk": 899,
	"./zh-hk.js": 899,
	"./zh-tw": 900,
	"./zh-tw.js": 900
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2676;

/***/ }),
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/afstereo-blurred.a144d0b.png";

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AFSTEREO.2ace1fe.PNG";

/***/ }),
/* 2829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2830 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notification-sound.aa22794.mp3";

/***/ }),
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/app"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/app","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 2850 */,
/* 2851 */,
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2434)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1290),
  /* template */
  __webpack_require__(3255),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-449eea92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2432)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1292),
  /* template */
  __webpack_require__(3252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4441a87b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1293),
  /* template */
  __webpack_require__(3122),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1294),
  /* template */
  __webpack_require__(3158),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17a5561c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1296),
  /* template */
  __webpack_require__(3167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e3847d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2420)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1297),
  /* template */
  __webpack_require__(3234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c17e7ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2558)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1298),
  /* template */
  __webpack_require__(3422),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f074f934",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1300),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1302),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1304),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1305),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2415)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1307),
  /* template */
  __webpack_require__(3226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39a45542",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2419)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1308),
  /* template */
  __webpack_require__(3233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bebd4d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1309),
  /* template */
  __webpack_require__(3120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05499c92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2468)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1310),
  /* template */
  __webpack_require__(3300),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5df38bd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2499)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1311),
  /* template */
  __webpack_require__(3338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72a06dd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2534)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1312),
  /* template */
  __webpack_require__(3392),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8ef9282",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1313),
  /* template */
  __webpack_require__(3295),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1314),
  /* template */
  __webpack_require__(3138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d36f8cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2426)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1315),
  /* template */
  __webpack_require__(3240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f372aca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2433)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1316),
  /* template */
  __webpack_require__(3254),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-446db288",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1317),
  /* template */
  __webpack_require__(3125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08982428",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2481)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1318),
  /* template */
  __webpack_require__(3312),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-660f0e7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2533)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1319),
  /* template */
  __webpack_require__(3391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8cc3074",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2532)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1320),
  /* template */
  __webpack_require__(3389),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c566b2e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2472)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1321),
  /* template */
  __webpack_require__(3304),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e8d8a3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2445)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1322),
  /* template */
  __webpack_require__(3272),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ce2cbc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2395)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1323),
  /* template */
  __webpack_require__(3199),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d6a89be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2447)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1325),
  /* template */
  __webpack_require__(3275),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1326),
  /* template */
  __webpack_require__(3342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1327),
  /* template */
  __webpack_require__(3364),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2525)
  __webpack_require__(2524)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1328),
  /* template */
  __webpack_require__(3379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1329),
  /* template */
  __webpack_require__(3241),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1330),
  /* template */
  __webpack_require__(3132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1331),
  /* template */
  __webpack_require__(3377),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2482)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1332),
  /* template */
  __webpack_require__(3315),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66f701a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2483)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1334),
  /* template */
  __webpack_require__(3317),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-677e5acf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2425)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1335),
  /* template */
  __webpack_require__(3239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f2b809a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2457)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1336),
  /* template */
  __webpack_require__(3285),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5475bc7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2544)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1337),
  /* template */
  __webpack_require__(3404),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc65c794",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2496)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1338),
  /* template */
  __webpack_require__(3332),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1339),
  /* template */
  __webpack_require__(3214),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1340),
  /* template */
  __webpack_require__(3183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24926cec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1341),
  /* template */
  __webpack_require__(3154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-169688e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2424)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1342),
  /* template */
  __webpack_require__(3238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e698818",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1343),
  /* template */
  __webpack_require__(3115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02b68f91",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2450)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1344),
  /* template */
  __webpack_require__(3278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f9f80df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2429)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1345),
  /* template */
  __webpack_require__(3245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40575973",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1346),
  /* template */
  __webpack_require__(3182),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2546)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1347),
  /* template */
  __webpack_require__(3406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dfb0b9b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2502)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1348),
  /* template */
  __webpack_require__(3344),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7684444e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1350),
  /* template */
  __webpack_require__(3291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2498)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1351),
  /* template */
  __webpack_require__(3336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-725006fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2548)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1352),
  /* template */
  __webpack_require__(3410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e691b0e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1355),
  /* template */
  __webpack_require__(3373),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1356),
  /* template */
  __webpack_require__(3157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2435)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1357),
  /* template */
  __webpack_require__(3256),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44a128bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2428)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1358),
  /* template */
  __webpack_require__(3244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40396f81",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2423)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1359),
  /* template */
  __webpack_require__(3237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1360),
  /* template */
  __webpack_require__(3124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-081d153a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1362),
  /* template */
  __webpack_require__(3290),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2442)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1366),
  /* template */
  __webpack_require__(3267),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a4e2b07",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1373),
  /* template */
  __webpack_require__(3363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2522)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1377),
  /* template */
  __webpack_require__(3374),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f912d68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1380),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1381),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1382),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2427)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1384),
  /* template */
  __webpack_require__(3243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4000cccd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2555)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1385),
  /* template */
  __webpack_require__(3419),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb4a5ac6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2416)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1386),
  /* template */
  __webpack_require__(3228),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1387),
  /* template */
  __webpack_require__(3113),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2491)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(3325),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cc7aee9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2542)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1390),
  /* template */
  __webpack_require__(3402),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d885e4aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2537)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1412),
  /* template */
  __webpack_require__(3396),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cca32878",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1415),
  /* template */
  __webpack_require__(3190),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1417),
  /* template */
  __webpack_require__(3426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1418),
  /* template */
  __webpack_require__(3427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1419),
  /* template */
  __webpack_require__(3331),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1420),
  /* template */
  __webpack_require__(3250),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1421),
  /* template */
  __webpack_require__(3159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1422),
  /* template */
  __webpack_require__(3370),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1423),
  /* template */
  __webpack_require__(3172),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2473)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1424),
  /* template */
  __webpack_require__(3305),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1425),
  /* template */
  __webpack_require__(3166),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1426),
  /* template */
  __webpack_require__(3131),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2485)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1427),
  /* template */
  __webpack_require__(3319),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1428),
  /* template */
  __webpack_require__(3221),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1429),
  /* template */
  __webpack_require__(3116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0391c990",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1430),
  /* template */
  __webpack_require__(3425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2409)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1432),
  /* template */
  __webpack_require__(3218),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36b29dab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1433),
  /* template */
  __webpack_require__(3189),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27ea0f6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1434),
  /* template */
  __webpack_require__(3253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1435),
  /* template */
  __webpack_require__(3335),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1437),
  /* template */
  __webpack_require__(3135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1438),
  /* template */
  __webpack_require__(3348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1439),
  /* template */
  __webpack_require__(3121),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1440),
  /* template */
  __webpack_require__(3429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2557)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1441),
  /* template */
  __webpack_require__(3421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ef58217e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2436)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1442),
  /* template */
  __webpack_require__(3257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44da4f5d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2477)
  __webpack_require__(2478)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1443),
  /* template */
  __webpack_require__(3308),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62f9d085",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1445),
  /* template */
  __webpack_require__(3117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03a45a7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1446),
  /* template */
  __webpack_require__(3248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1448),
  /* template */
  __webpack_require__(3129),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09a74d92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2521)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1450),
  /* template */
  __webpack_require__(3372),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-98f365c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1451),
  /* template */
  __webpack_require__(3153),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-166e3042",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2556)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(3420),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ee4f6716",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2414)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1452),
  /* template */
  __webpack_require__(3224),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38d161f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2509)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1453),
  /* template */
  __webpack_require__(3355),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f80f59f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2355)
  __webpack_require__(2354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1455),
  /* template */
  __webpack_require__(3141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f48fbc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1456),
  /* template */
  __webpack_require__(3333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2519)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1457),
  /* template */
  __webpack_require__(3369),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-926af554",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1458),
  /* template */
  __webpack_require__(3268),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2465)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1459),
  /* template */
  __webpack_require__(3296),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bbcd51c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2467)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1460),
  /* template */
  __webpack_require__(3299),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5da51df0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1461),
  /* template */
  __webpack_require__(3160),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a1ec9c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2504)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1462),
  /* template */
  __webpack_require__(3346),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1463),
  /* template */
  __webpack_require__(3298),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1464),
  /* template */
  __webpack_require__(3156),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1736c4d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2408)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1465),
  /* template */
  __webpack_require__(3217),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3665b4b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1466),
  /* template */
  __webpack_require__(3112),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00bddf5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2350)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1467),
  /* template */
  __webpack_require__(3133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c4eb56c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1468),
  /* template */
  __webpack_require__(3142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f6a827d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2396)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1470),
  /* template */
  __webpack_require__(3200),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2388)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1471),
  /* template */
  __webpack_require__(3188),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2413)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1472),
  /* template */
  __webpack_require__(3223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38974c92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1473),
  /* template */
  __webpack_require__(3118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2514)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1475),
  /* template */
  __webpack_require__(3360),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84d1674a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2561)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1476),
  /* template */
  __webpack_require__(3430),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9928b62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2517)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1477),
  /* template */
  __webpack_require__(3366),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ba18a9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2459)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1478),
  /* template */
  __webpack_require__(3287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2553)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1479),
  /* template */
  __webpack_require__(3417),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea38418a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1480),
  /* template */
  __webpack_require__(3152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2497)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1481),
  /* template */
  __webpack_require__(3334),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2471)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1482),
  /* template */
  __webpack_require__(3303),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e21b5ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2479)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1483),
  /* template */
  __webpack_require__(3310),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65565d1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2372)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1484),
  /* template */
  __webpack_require__(3163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c466a20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2405)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1485),
  /* template */
  __webpack_require__(3212),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34b16dab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2536)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1487),
  /* template */
  __webpack_require__(3395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb840904",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2466)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1488),
  /* template */
  __webpack_require__(3297),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5bbf54b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2431)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1489),
  /* template */
  __webpack_require__(3249),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1490),
  /* template */
  __webpack_require__(3139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2463)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1491),
  /* template */
  __webpack_require__(3293),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a16552f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2410)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1492),
  /* template */
  __webpack_require__(3219),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36d43450",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1493),
  /* template */
  __webpack_require__(3145),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-118329cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2474)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1494),
  /* template */
  __webpack_require__(3306),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6209c7a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2508)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1495),
  /* template */
  __webpack_require__(3353),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cb5510b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2503)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1496),
  /* template */
  __webpack_require__(3345),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7696c7ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2455)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1497),
  /* template */
  __webpack_require__(3282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52ceb1ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1498),
  /* template */
  __webpack_require__(3150),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2407)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1500),
  /* template */
  __webpack_require__(3216),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-361d3d3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1501),
  /* template */
  __webpack_require__(3176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2539)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1502),
  /* template */
  __webpack_require__(3399),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1e5f7e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1505),
  /* template */
  __webpack_require__(3165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1507),
  /* template */
  __webpack_require__(3408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1508),
  /* template */
  __webpack_require__(3337),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1509),
  /* template */
  __webpack_require__(3428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2441)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1510),
  /* template */
  __webpack_require__(3266),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1511),
  /* template */
  __webpack_require__(3130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aa99403",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2390)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1512),
  /* template */
  __webpack_require__(3191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-283ff0ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1513),
  /* template */
  __webpack_require__(3197),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1514),
  /* template */
  __webpack_require__(3203),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2399)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1515),
  /* template */
  __webpack_require__(3204),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30b46d35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2461)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1516),
  /* template */
  __webpack_require__(3289),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1517),
  /* template */
  __webpack_require__(3140),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ee41f2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2549)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1518),
  /* template */
  __webpack_require__(3411),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e6b19882",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2484)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1519),
  /* template */
  __webpack_require__(3318),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67d90b4d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2387)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1520),
  /* template */
  __webpack_require__(3187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-266982ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2470)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1521),
  /* template */
  __webpack_require__(3302),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e198fcb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1522),
  /* template */
  __webpack_require__(3144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10be1306",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2444)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1523),
  /* template */
  __webpack_require__(3271),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2505)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1524),
  /* template */
  __webpack_require__(3347),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77a38aa0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2418)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1525),
  /* template */
  __webpack_require__(3232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bd827ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2421)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1526),
  /* template */
  __webpack_require__(3235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ca93186",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2402)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1527),
  /* template */
  __webpack_require__(3209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3328aa70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2518)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1528),
  /* template */
  __webpack_require__(3368),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90cf6e02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2513)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1529),
  /* template */
  __webpack_require__(3359),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-829ea784",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2422)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1530),
  /* template */
  __webpack_require__(3236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3df7e4d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2512)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1531),
  /* template */
  __webpack_require__(3358),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81e0edfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2529)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1532),
  /* template */
  __webpack_require__(3384),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b6f88c9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2523)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1533),
  /* template */
  __webpack_require__(3378),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aaf06ae6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2400)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1534),
  /* template */
  __webpack_require__(3205),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31807a01",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2538)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1535),
  /* template */
  __webpack_require__(3397),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce228998",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2406)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1536),
  /* template */
  __webpack_require__(3215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-361a799f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1537),
  /* template */
  __webpack_require__(3194),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c9e9443",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1538),
  /* template */
  __webpack_require__(3407),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2456)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1539),
  /* template */
  __webpack_require__(3284),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2489)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1540),
  /* template */
  __webpack_require__(3323),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a7e7c4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1541),
  /* template */
  __webpack_require__(3328),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2401)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1542),
  /* template */
  __webpack_require__(3208),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-331b4198",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1543),
  /* template */
  __webpack_require__(3341),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2391)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1544),
  /* template */
  __webpack_require__(3193),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b11450a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2528)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1545),
  /* template */
  __webpack_require__(3383),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5687616",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1546),
  /* template */
  __webpack_require__(3262),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2454)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1547),
  /* template */
  __webpack_require__(3281),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52a8644c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1548),
  /* template */
  __webpack_require__(3251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2343)
  __webpack_require__(2342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1550),
  /* template */
  __webpack_require__(3123),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07319212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2439)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1551),
  /* template */
  __webpack_require__(3264),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-486ad08c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1553),
  /* template */
  __webpack_require__(3143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2562)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1554),
  /* template */
  __webpack_require__(3432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffa9ff70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2417)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1555),
  /* template */
  __webpack_require__(3231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b919cd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2510)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1556),
  /* template */
  __webpack_require__(3356),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-80084220",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1557),
  /* template */
  __webpack_require__(3247),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2547)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1558),
  /* template */
  __webpack_require__(3409),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e47f6d04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2335)
  __webpack_require__(2334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1559),
  /* template */
  __webpack_require__(3114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-023354e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1560),
  /* template */
  __webpack_require__(3137),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d0fab1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1561),
  /* template */
  __webpack_require__(3184),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2448)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1562),
  /* template */
  __webpack_require__(3276),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e50f0d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2488)
  __webpack_require__(2487)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1563),
  /* template */
  __webpack_require__(3322),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a5e07e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1564),
  /* template */
  __webpack_require__(3213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1565),
  /* template */
  __webpack_require__(3242),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2460)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1566),
  /* template */
  __webpack_require__(3288),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55f7a66d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1567),
  /* template */
  __webpack_require__(3230),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1568),
  /* template */
  __webpack_require__(3225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1569),
  /* template */
  __webpack_require__(3375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1570),
  /* template */
  __webpack_require__(3339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2560)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1572),
  /* template */
  __webpack_require__(3424),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4897ec8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1573),
  /* template */
  __webpack_require__(3260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1574),
  /* template */
  __webpack_require__(3362),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1575),
  /* template */
  __webpack_require__(3169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f144e6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2526)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1576),
  /* template */
  __webpack_require__(3380),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aedc9c7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1577),
  /* template */
  __webpack_require__(3162),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bfe84ed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2540)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1578),
  /* template */
  __webpack_require__(3400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d405f2e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2495)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1579),
  /* template */
  __webpack_require__(3330),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-707ed2b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2541)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1580),
  /* template */
  __webpack_require__(3401),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d6c39020",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2531)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1581),
  /* template */
  __webpack_require__(3388),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1a87a40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2486)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1582),
  /* template */
  __webpack_require__(3320),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6891d69c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2511)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1583),
  /* template */
  __webpack_require__(3357),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8129c55a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1584),
  /* template */
  __webpack_require__(3111),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-003caaaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1585),
  /* template */
  __webpack_require__(3416),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1586),
  /* template */
  __webpack_require__(3222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1588),
  /* template */
  __webpack_require__(3168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1589),
  /* template */
  __webpack_require__(3314),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2515)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1590),
  /* template */
  __webpack_require__(3361),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-853f491c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2464)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1591),
  /* template */
  __webpack_require__(3294),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2506)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1592),
  /* template */
  __webpack_require__(3350),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-794f4dbb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2381)
  __webpack_require__(2382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1593),
  /* template */
  __webpack_require__(3177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-209131c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1594),
  /* template */
  __webpack_require__(3148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1595),
  /* template */
  __webpack_require__(3343),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1596),
  /* template */
  __webpack_require__(3367),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1597),
  /* template */
  __webpack_require__(3351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1598),
  /* template */
  __webpack_require__(3431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1599),
  /* template */
  __webpack_require__(3390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1600),
  /* template */
  __webpack_require__(3393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1601),
  /* template */
  __webpack_require__(3155),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1602),
  /* template */
  __webpack_require__(3164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1603),
  /* template */
  __webpack_require__(3126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1604),
  /* template */
  __webpack_require__(3376),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1605),
  /* template */
  __webpack_require__(3385),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1606),
  /* template */
  __webpack_require__(3382),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1607),
  /* template */
  __webpack_require__(3321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1608),
  /* template */
  __webpack_require__(3180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1610),
  /* template */
  __webpack_require__(3136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1611),
  /* template */
  __webpack_require__(3149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14c74b07",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1612),
  /* template */
  __webpack_require__(3229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1613),
  /* template */
  __webpack_require__(3146),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1614),
  /* template */
  __webpack_require__(3263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2516)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1615),
  /* template */
  __webpack_require__(3365),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1616),
  /* template */
  __webpack_require__(3354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1617),
  /* template */
  __webpack_require__(3206),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "survey-filter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('i-box', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h2', [_vm._v("Filter Builder")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$apollo.loading) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading surveys..."
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.surveys.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Survey")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSurvey),
      expression: "loadingSurvey"
    }],
    attrs: {
      "placeholder": "Please select a survey",
      "clearable": ""
    },
    on: {
      "change": _vm.handleSurveyChanged
    },
    model: {
      value: (_vm.filterData.survey_id),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "survey_id", $$v)
      },
      expression: "filterData.survey_id"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "label": survey.title,
        "value": survey.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.filterData.survey_id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(_vm.stageCountLoading.survey) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.survey.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.filterData.survey_id) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Demographics")]), _vm._v(" "), _vm._l((_vm.demographicQuestions), function(question) {
    return _c('div', {
      key: question.id
    }, [_c('el-form-item', {
      attrs: {
        "label": question.title
      }
    }, [(question.choiceLinks) ? _c('el-checkbox-group', {
      model: {
        value: (_vm.selectedDemographics),
        callback: function($$v) {
          _vm.selectedDemographics = $$v
        },
        expression: "selectedDemographics"
      }
    }, _vm._l((_vm.questionChoices(question.id)), function(choice) {
      return _c('el-checkbox', {
        key: choice.id,
        attrs: {
          "label": ((question.id) + ":" + (choice.choice.id))
        }
      }, [_vm._v(_vm._s(choice.choice.title) + " ")])
    }), 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.demographicQuestions.length === 0) ? _c('empty', [_vm._v("No demographics questions were asked on this survey.")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Contact details")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, [_c('el-checkbox', {
    key: 'Mobile number',
    attrs: {
      "label": 'Mobile number'
    }
  }, [_vm._v("Mobile number")]), _vm._v(" "), _c('el-checkbox', {
    key: 'All',
    attrs: {
      "label": 'All'
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.contactQuestions), function(question) {
    return _c('el-checkbox', {
      key: question,
      attrs: {
        "label": question
      }
    }, [_vm._v(_vm._s(question))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.stageCountLoading.demographics) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.demographics.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Questions")]), _vm._v(" "), _vm._l((_vm.filterData.questions), function(selectedQuestion, index) {
    return _c('div', {
      key: index,
      staticClass: "question"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Question"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Please select a question"
      },
      on: {
        "change": function($event) {
          return _vm.handleQuestionsChanged()
        }
      },
      model: {
        value: (selectedQuestion.question_id),
        callback: function($$v) {
          _vm.$set(selectedQuestion, "question_id", $$v)
        },
        expression: "selectedQuestion.question_id"
      }
    }, _vm._l((_vm.questions), function(question) {
      return _c('el-option', {
        key: question.id,
        attrs: {
          "label": question.title,
          "value": question.id,
          "disabled": _vm.isQuestionUsed(question.id)
        }
      })
    }), 1)], 1), _vm._v(" "), (_vm.questionChoices(selectedQuestion.question_id).length > 0) ? _c('el-form-item', {
      attrs: {
        "label": "Answers"
      }
    }, [_c('el-checkbox-group', {
      on: {
        "change": function($event) {
          return _vm.handleQuestionsChanged()
        }
      },
      model: {
        value: (selectedQuestion.choices),
        callback: function($$v) {
          _vm.$set(selectedQuestion, "choices", $$v)
        },
        expression: "selectedQuestion.choices"
      }
    }, _vm._l((_vm.questionChoices(selectedQuestion.question_id)), function(choice) {
      return _c('el-checkbox', {
        key: choice.choice.id,
        attrs: {
          "label": choice.choice.id,
          "value": choice.choice.id
        }
      }, [_vm._v(_vm._s(choice.choice.title))])
    }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "question-remove pull-right"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveQuestion(index)
        }
      }
    }, [_vm._v("[Remove]")])], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (
      _vm.filterData.questions.length > 1 && index !== _vm.filterData.questions.length - 1
    ) ? _c('div', {
      staticClass: "question-condition"
    }, [_vm._v("AND they must have answered...")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Add another question from this survey",
      "placement": "bottom"
    }
  }, [(_vm.unusedQuestions.length > 0) ? _c('el-button', {
    attrs: {
      "type": "success",
      "round": "",
      "circle": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddQuestion()
      }
    }
  }) : _vm._e()], 1)], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [(_vm.stageCountLoading.questions) ? _c('i', {
    staticClass: "pull-right fa fa-spinner fa-spin"
  }) : _c('span', {
    staticClass: "pull-right respondent-count"
  }, [_vm._v("Respondents: " + _vm._s(_vm.stageCount.questions.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(this.filterData.survey_id) ? _c('el-button', {
    attrs: {
      "split-button": "",
      "type": "primary",
      "disabled": _vm.generatingList || _vm.isGenerateDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleGenerate()
      },
      "command": _vm.handleGenerateCommand
    }
  }, [(_vm.generatingList) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "else": ""
    }
  }, [_vm._v("Generate List")]), _vm._v(" "), _c('el-dropdown-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "constant_contact"
    }
  }, [_vm._v("Constant Contact")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mail_chimp"
    }
  }, [_vm._v("Mail Chimp")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.loadVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-folder-open-o"
  }), _vm._v(" Load\n                  ")]), _vm._v(" "), (this.filterData.survey_id) ? _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.saveVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-floppy-o"
  }), _vm._v(" Save\n                  ")]) : _vm._e()], 1)], 1)], 1)])])], 1)])], 1), _vm._v(" "), _c('survey-filter-save-dialog', {
    attrs: {
      "is-visible": _vm.saveVisible
    },
    on: {
      "onVisibleChanged": function($event) {
        _vm.saveVisible = $event
      },
      "onSave": _vm.handleSave
    }
  }), _vm._v(" "), _c('survey-filter-load-dialog', {
    attrs: {
      "is-visible": _vm.loadVisible
    },
    on: {
      "onVisibleChanged": function($event) {
        _vm.loadVisible = $event
      },
      "onLoad": _vm.handleLoad
    }
  }), _vm._v(" "), (_vm.constantContactVisible) ? _c('constant-contact-dialog', {
    attrs: {
      "contacts": _vm.constantContactList,
      "is-visible": _vm.constantContactVisible,
      "loadingContacts": _vm.loadingSurveyRespondents
    },
    on: {
      "open": _vm.getSurveyRespondents,
      "onVisibleChanged": function($event) {
        _vm.constantContactVisible = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mailChimpVisible) ? _c('mailchimp-dialog', {
    attrs: {
      "contacts": _vm.mailchimpContactList,
      "is-visible": _vm.mailChimpVisible,
      "loadingContacts": _vm.loadingSurveyRespondents
    },
    on: {
      "open": _vm.getSurveyRespondents,
      "onVisibleChanged": function($event) {
        _vm.mailChimpVisible = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('h1', [_vm._v("Survey Filter")])])])
}]}

/***/ }),
/* 3112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "logs-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [(!_vm.loading && _vm.activityLogs.length === 0) ? _c('div', [_vm._v("\n    Not enough data has been gathered yet to display any results\n  ")]) : _c('div', [_vm._l((_vm.activityLogs), function(log) {
    return _c('el-card', {
      key: log.id,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('strong', [_vm._v(_vm._s(log.user))]), _vm._v(" - " + _vm._s(_vm.formatDate(log.date_created)) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(log.action))])])
  }), _vm._v(" "), (_vm.loading && _vm.activityLogs.length > 0) ? _c('div', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons-container"
  }, [(!_vm.loading && _vm.hasNext) ? _c('el-button', {
    staticClass: "load-button",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load More")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.hasPrevious) ? _c('el-button', {
    staticClass: "load-button",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.loadPrevious
    }
  }, [_vm._v("Load Previous")]) : _vm._e()], 1), _vm._v(" "), (!_vm.loading && _vm.activityLogs.length > 0 && !_vm.hasNext && !_vm.hasPrevious) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_vm._v("End of logs")])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 3113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h4', [_vm._v("Please contact ColonyLive sales team to activate this feature.")]), _vm._v(" "), _c('div', {
    staticClass: "mail-container"
  }, [_c('a', {
    staticClass: "mail-to-link",
    attrs: {
      "href": _vm.mailToSales
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("\n      Contact Sales\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 3114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row scale positive"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Positive")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.positiveChoices),
      callback: function($$v) {
        _vm.positiveChoices = $$v
      },
      expression: "positiveChoices"
    }
  }, [_vm._l((_vm.positiveChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreatePositiveChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale neutral m-sm"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Neutral")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.neutralChoices),
      callback: function($$v) {
        _vm.neutralChoices = $$v
      },
      expression: "neutralChoices"
    }
  }, [_vm._l((_vm.neutralChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateNeutralChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale negative m-sm"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Negative")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.negativeChoices),
      callback: function($$v) {
        _vm.negativeChoices = $$v
      },
      expression: "negativeChoices"
    }
  }, [_vm._l((_vm.negativeChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateNegativeChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), (_vm.isEditable) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale m-sm"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Present in reverse order"
    },
    model: {
      value: (_vm.reverseOrder),
      callback: function($$v) {
        _vm.reverseOrder = $$v
      },
      expression: "reverseOrder"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.isEditable) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("   Clear all choices\n    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSaveTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("   Save as new Choice Template\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px",
      "model": _vm.blacklistedOriginator
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Originator"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Originator"
    },
    model: {
      value: (_vm.blacklistedOriginator.originator),
      callback: function($$v) {
        _vm.$set(_vm.blacklistedOriginator, "originator", $$v)
      },
      expression: "blacklistedOriginator.originator"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.saving,
      "plain": ""
    },
    on: {
      "click": _vm.blacklistOriginator
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-series-graph-loader"
  }, [_c('svg', {
    staticClass: "loader",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveAspectRatio": "xMidYMid meet",
      "viewBox": "111.73030062453554 63.94609929078007 447.8226950354632 221.97007515613478",
      "width": "750",
      "height": "350"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M265.27 64.95L321.27 64.95L321.27 73.45L265.27 73.45L265.27 64.95Z",
      "id": "bwf5jvTw0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M367.77 64.95L423.77 64.95L423.77 73.45L367.77 73.45L367.77 64.95Z",
      "id": "d2WiunIjb"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M559.55 285.92L547.48 162.42L526.56 266.92L524.95 177.42L512.88 268.92L495.98 188.92L492.76 260.92L483.91 122.92L473.45 268.42L469.43 146.92L450.12 263.92L443.68 155.42L431.61 256.92L421.95 190.92L412.3 266.92L399.42 111.42L386.55 272.92L370.45 245.92L361.6 266.42L351.94 243.92L343.09 261.92L327 179.42L317.34 261.92L307.69 141.42L292.4 271.92L265.04 159.92L258.6 261.42L236.07 151.42L230.44 225.92L213.54 144.42L205.49 273.42L180.55 187.42L167.67 280.42L165.26 158.92L155.6 224.42L153.99 121.92L139.51 263.92L133.07 163.92L123.41 274.92L115.37 203.42L112.15 284.42L559.55 285.92Z",
      "id": "b1QuT2UFOV"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.27 200.75C119.27 202.41 117.58 203.75 115.5 203.75C113.42 203.75 111.73 202.41 111.73 200.75C111.73 199.09 113.42 197.75 115.5 197.75C117.58 197.75 119.27 199.09 119.27 200.75Z",
      "id": "a35DhHQ2CQ"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M136.87 162.75C136.87 164.41 135.18 165.75 133.1 165.75C131.01 165.75 129.32 164.41 129.32 162.75C129.32 161.09 131.01 159.75 133.1 159.75C135.18 159.75 136.87 161.09 136.87 162.75Z",
      "id": "b3mgvDOKFs"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M157.81 119.75C157.81 121.41 156.12 122.75 154.04 122.75C151.96 122.75 150.27 121.41 150.27 119.75C150.27 118.09 151.96 116.75 154.04 116.75C156.12 116.75 157.81 118.09 157.81 119.75Z",
      "id": "g2KwcgpG8a"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M169.54 157.75C169.54 159.41 167.85 160.75 165.77 160.75C163.69 160.75 162 159.41 162 157.75C162 156.09 163.69 154.75 165.77 154.75C167.85 154.75 169.54 156.09 169.54 157.75Z",
      "id": "b3Je9DsGu"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M184.2 185.08C184.2 186.74 182.51 188.08 180.43 188.08C178.35 188.08 176.66 186.74 176.66 185.08C176.66 183.43 178.35 182.08 180.43 182.08C182.51 182.08 184.2 183.43 184.2 185.08Z",
      "id": "a20KNuUS2l"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M217.3 142.42C217.3 144.07 215.61 145.42 213.53 145.42C211.45 145.42 209.76 144.07 209.76 142.42C209.76 140.76 211.45 139.42 213.53 139.42C215.61 139.42 217.3 140.76 217.3 142.42Z",
      "id": "a4i0mUcmiz"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M239.92 149.08C239.92 150.74 238.23 152.08 236.15 152.08C234.07 152.08 232.38 150.74 232.38 149.08C232.38 147.43 234.07 146.08 236.15 146.08C238.23 146.08 239.92 147.43 239.92 149.08Z",
      "id": "a2tLi9UWsA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M268.82 158.42C268.82 160.07 267.13 161.42 265.05 161.42C262.97 161.42 261.28 160.07 261.28 158.42C261.28 156.76 262.97 155.42 265.05 155.42C267.13 155.42 268.82 156.76 268.82 158.42Z",
      "id": "bOywNEdbv"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M311.55 139.75C311.55 141.41 309.86 142.75 307.78 142.75C305.7 142.75 304.01 141.41 304.01 139.75C304.01 138.09 305.7 136.75 307.78 136.75C309.86 136.75 311.55 138.09 311.55 139.75Z",
      "id": "a4aKP6nqyA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M331.24 178.08C331.24 179.74 329.55 181.08 327.47 181.08C325.39 181.08 323.7 179.74 323.7 178.08C323.7 176.43 325.39 175.08 327.47 175.08C329.55 175.08 331.24 176.43 331.24 178.08Z",
      "id": "b15XTIKYxC"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M355.96 241.08C355.96 242.74 354.27 244.08 352.19 244.08C350.11 244.08 348.42 242.74 348.42 241.08C348.42 239.43 350.11 238.08 352.19 238.08C354.27 238.08 355.96 239.43 355.96 241.08Z",
      "id": "b2gWFYzOjw"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M373.97 242.08C373.97 243.74 372.28 245.08 370.2 245.08C368.12 245.08 366.43 243.74 366.43 242.08C366.43 240.43 368.12 239.08 370.2 239.08C372.28 239.08 373.97 240.43 373.97 242.08Z",
      "id": "b1CKowQP95"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M403.3 109.42C403.3 111.07 401.61 112.42 399.53 112.42C397.45 112.42 395.76 111.07 395.76 109.42C395.76 107.76 397.45 106.42 399.53 106.42C401.61 106.42 403.3 107.76 403.3 109.42Z",
      "id": "b1EUhezF3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M425.92 188.08C425.92 189.74 424.23 191.08 422.15 191.08C420.07 191.08 418.38 189.74 418.38 188.08C418.38 186.43 420.07 185.08 422.15 185.08C424.23 185.08 425.92 186.43 425.92 188.08Z",
      "id": "d6tgTwOmy"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M447.7 154.75C447.7 156.41 446.01 157.75 443.93 157.75C441.85 157.75 440.16 156.41 440.16 154.75C440.16 153.09 441.85 151.75 443.93 151.75C446.01 151.75 447.7 153.09 447.7 154.75Z",
      "id": "b1a6Nib1L7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M472.84 145.08C472.84 146.74 471.15 148.08 469.07 148.08C466.99 148.08 465.3 146.74 465.3 145.08C465.3 143.43 466.99 142.08 469.07 142.08C471.15 142.08 472.84 143.43 472.84 145.08Z",
      "id": "eceDevC05"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M487.92 122.42C487.92 124.07 486.23 125.42 484.15 125.42C482.07 125.42 480.38 124.07 480.38 122.42C480.38 120.76 482.07 119.42 484.15 119.42C486.23 119.42 487.92 120.76 487.92 122.42Z",
      "id": "b5AlKbWHU"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M500.07 188.08C500.07 189.74 498.38 191.08 496.3 191.08C494.22 191.08 492.53 189.74 492.53 188.08C492.53 186.43 494.22 185.08 496.3 185.08C498.38 185.08 500.07 186.43 500.07 188.08Z",
      "id": "a3uUJc6BqP"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M528.55 175.75C528.55 177.41 526.86 178.75 524.78 178.75C522.7 178.75 521.01 177.41 521.01 175.75C521.01 174.09 522.7 172.75 524.78 172.75C526.86 172.75 528.55 174.09 528.55 175.75Z",
      "id": "b7gyGI5oh1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M551.17 160.08C551.17 161.74 549.49 163.08 547.4 163.08C545.32 163.08 543.63 161.74 543.63 160.08C543.63 158.43 545.32 157.08 547.4 157.08C549.49 157.08 551.17 158.43 551.17 160.08Z",
      "id": "c13sj1Pqnr"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#bwf5jvTw0",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#bwf5jvTw0",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#ededed",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#d2WiunIjb",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#d2WiunIjb",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#ededed",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1QuT2UFOV",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1QuT2UFOV",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a35DhHQ2CQ",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a35DhHQ2CQ",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b3mgvDOKFs",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b3mgvDOKFs",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#g2KwcgpG8a",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#g2KwcgpG8a",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b3Je9DsGu",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b3Je9DsGu",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a20KNuUS2l",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a20KNuUS2l",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a4i0mUcmiz",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a4i0mUcmiz",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a2tLi9UWsA",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a2tLi9UWsA",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#bOywNEdbv",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#bOywNEdbv",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a4aKP6nqyA",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a4aKP6nqyA",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b15XTIKYxC",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b15XTIKYxC",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b2gWFYzOjw",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b2gWFYzOjw",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1CKowQP95",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1CKowQP95",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1EUhezF3z",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1EUhezF3z",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#d6tgTwOmy",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#d6tgTwOmy",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1a6Nib1L7",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1a6Nib1L7",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#eceDevC05",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#eceDevC05",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b5AlKbWHU",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b5AlKbWHU",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a3uUJc6BqP",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a3uUJc6BqP",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b7gyGI5oh1",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b7gyGI5oh1",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#c13sj1Pqnr",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#c13sj1Pqnr",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e4e4e4",
      "stroke-width": "0.7",
      "stroke-opacity": "1"
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 3117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-element"
  }, [_c('div', {
    staticClass: "interaction-avatar pull-left"
  }, [(_vm.interaction.ore.profile_image) ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.interaction.ore.profile_image[0].value
    },
    on: {
      "error": function($event) {
        return _vm.imageLoadOnError()
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-user-circle fa-3x"
  }), _vm._v(" "), _c('div', {
    staticClass: "interaction-type img-circle",
    class: _vm.interaction.type
  }, [_c('i', {
    staticClass: "fa fa-sm",
    class: _vm.iconClasses[_vm.interaction.type]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('small', {
    staticClass: "text-muted pull-right interaction-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.interaction.date_created, 'HH:MM Do MMM YYYY ')))]), _vm._v(" "), _c('div', {
    staticClass: "interaction-originator"
  }, [_vm._v(_vm._s(_vm.interaction.ore.originators[0].value))]), _vm._v(" "), (_vm.mediaExists) ? _c('div', {
    staticClass: "interaction-media"
  }, [(_vm.interaction.ore.image) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'image')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.video) ? _c('video', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'video'),
      "controls": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.audio) ? _c('audio', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'audio'),
      "controls": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "interaction-message"
  }, [_vm._v(_vm._s(_vm.interaction.ore.message[0].value))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interaction-tools"
  }, [_c('a', {
    staticClass: "onair"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('a', {
    staticClass: "reply"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })]), _vm._v(" "), _c('a', {
    staticClass: "comment"
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])])
}]}

/***/ }),
/* 3118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Download Privacy Contact List"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("From here you can download privacy data defined by your parameters to a CSV file.")]), _vm._v(" "), _c('el-form', {
    ref: "privacyForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Privacy Types",
      "prop": "privacy"
    }
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['Available', 'Enabled'],
      "data": _vm.privacyData
    },
    model: {
      value: (_vm.currentPrivacyTypes),
      callback: function($$v) {
        _vm.currentPrivacyTypes = $$v
      },
      expression: "currentPrivacyTypes"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading ||
        !_vm.selectedPrivacyTypes.length
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Download\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Link Whatsapp Channel",
      "width": "500px",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [(!_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body"
  }, [_c('p', [_vm._v("Please choose your country and enter your phone number.")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country"
    }
  }, [_c('country-code-selector', {
    staticClass: "country-selector",
    attrs: {
      "browserCountryCode": _vm.userCountryCode,
      "selectedCountry": _vm.selectedCountry.code
    },
    on: {
      "onCountryChanged": _vm.handleCountryChanged
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone number"
    },
    model: {
      value: (_vm.phoneNumber),
      callback: function($$v) {
        _vm.phoneNumber = $$v
      },
      expression: "phoneNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedCountry.flag) + "\n            " + _vm._s(_vm.selectedCountry.dial_code) + "\n          ")])], 2), _vm._v(" "), _c('small', {
    staticClass: "muted"
  }, [_vm._v("Phone number without a leading "), _c('em', [_vm._v("0 (zero)")]), _vm._v(" or "), _c('em', [_vm._v("spaces")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body text-center"
  }, [(!_vm.whatsappQRCode) ? _c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'WhatsApp'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loadingWhatsappQRCodeRequest) ? _c('div', {
    staticClass: "loader-text"
  }, [_vm._v("\n      Waiting for QR Code.\n      "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), (!_vm.loadingWhatsappQRCodeRequest && !_vm.whatsappQRCode) ? _c('div', {
    staticClass: "info-text"
  }, [_c('h2', [_vm._v("Please follow the instructions carefully.")]), _vm._v(" "), _c('p', [_vm._v("On your mobile device within "), _c('strong', [_vm._v("WhatsApp")]), _vm._v(",\n        go to Settings "), _c('strong', [_vm._v("WhatsApp Web/Desktop")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" "), _c('strong', [_vm._v("Scan QR Code")]), _vm._v(".\n        Once your phone's camera is "), _c('strong', [_vm._v("ready")]), _vm._v("\n        click the "), _c('em', [_vm._v("Request QR Code")]), _vm._v(" button below.")]), _vm._v(" "), _c('p', [_vm._v("When the QR code displays you will have around "), _c('strong', [_vm._v("10 to 15 seconds")]), _vm._v("\n        to scan the code before it will time out automatically, if you're unable  to scan it\n        within this time, you will return back to this screen and will be able to request a new\n        QR code.")]), _vm._v(" "), _c('p', [_vm._v("Once your mobile device has been linked, this window will close automatically.\n        Your mobile device will need to stay "), _c('strong', [_vm._v("powered on")]), _vm._v("\n        and "), _c('strong', [_vm._v("connected to the internet")]), _vm._v(" for your messages to be received by us.")])]) : _vm._e(), _vm._v(" "), (_vm.whatsappQRCode) ? _c('div', {
    staticClass: "qrcode"
  }, [_vm._v("\n      This QR code will expire in "), _c('strong', [_vm._v(_vm._s(_vm.expiryCounter))]), _vm._v(" seconds.\n      "), _c('qrcode', {
    attrs: {
      "text": _vm.whatsappQRCode,
      "size": 460
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-body"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'WhatsApp'
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h2', [_vm._v("Success.")]), _vm._v(" "), _c('p', [_vm._v("Your account has been linked "), _c('strong', [_vm._v("successfully")]), _vm._v(",\n        from time to time it may happen that\n        WhatsApp "), _c('strong', [_vm._v("expires")]), _vm._v(" your session, when this happens,\n        simply follow this process of linking your number again.")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-danger"
  }, [_c('small', [_c('em', [_vm._v("Please note this feature is HIGHLY EXPERIMENTAL!")])])]), _vm._v(" "), (!_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.validMobileNumber || _vm.loadingWhatsappCreateChannel,
      "plain": ""
    },
    on: {
      "click": _vm.createChannel
    }
  }, [(_vm.loadingWhatsappCreateChannel) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" Link\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.whatsappChannelId && !_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.whatsappQRCode) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generateQRCode
    }
  }, [_vm._v("Request QR Code")]) : _vm._e(), _vm._v(" "), (_vm.whatsappQRCode) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthed) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Accept")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playout-load-dashboard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.average) ? _c('div', {
    staticClass: "metric-text"
  }, [_c('span', {
    staticClass: "metric-text-title"
  }, [_vm._v("Average:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(Math.round(_vm.average)) + " minutes per hour")])]) : _vm._e(), _vm._v(" "), (_vm.max) ? _c('div', {
    staticClass: "metric-text"
  }, [_c('span', {
    staticClass: "metric-text-title"
  }, [_vm._v("Maximum:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.max.value) + " minutes, on " + _vm._s(_vm.max.date))])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('line-chart', {
    staticClass: "chart",
    staticStyle: {
      "min-height": "380px"
    },
    attrs: {
      "showLegend": _vm.showLegend,
      "data": _vm.trendData,
      "title": _vm.title,
      "labels": _vm.labels,
      "showGridLines": _vm.showGridLines,
      "yAxeslabelString": _vm.yAxeslabelString,
      "xAxeslabelString": _vm.xAxeslabelString
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "filebox"
    }
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Files")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTabName),
      callback: function($$v) {
        _vm.activeTabName = $$v
      },
      expression: "activeTabName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "My Files",
      "name": "myFiles"
    }
  }, [_c('filebox-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingMyFiles),
      expression: "loadingMyFiles"
    }],
    attrs: {
      "element-loading-text": "Loading your files...",
      "files": _vm.myFiles,
      "icons": _vm.icons
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Company Files",
      "name": "companyFiles"
    }
  }, [_c('filebox-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingCompanyFiles),
      expression: "loadingCompanyFiles"
    }],
    attrs: {
      "element-loading-text": "Loading company files...",
      "files": _vm.companyFiles,
      "icons": _vm.icons
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-left"
  }, [_c('el-radio-group', {
    nativeOn: {
      "change": function($event) {
        _vm.$emit('changeRegion', _vm.getRegion())
      }
    },
    model: {
      value: (_vm.selectedRegion),
      callback: function($$v) {
        _vm.selectedRegion = $$v
      },
      expression: "selectedRegion"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "type": "primary",
      "label": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.regions), function(region) {
    return _c('el-radio-button', {
      key: region.code,
      attrs: {
        "type": "primary",
        "label": region.code
      }
    }, [_vm._v(_vm._s(region.name) + "\n            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('el-radio-group', {
    nativeOn: {
      "change": function($event) {
        _vm.$emit('changeDate', _vm.getDateRange())
      }
    },
    model: {
      value: (_vm.selectedRange),
      callback: function($$v) {
        _vm.selectedRange = $$v
      },
      expression: "selectedRange"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "30 Days"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3 Months"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "6 Months"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "12 Months"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "data-table-container"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "msg": "Loading Station Activity"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('el-table', {
    staticClass: "data-table",
    attrs: {
      "row-key": "key",
      "size": "small",
      "stripe": "",
      "data": _vm.stationActivityData.results
        .filter(
          function (data) { return !_vm.searchTerm ||
          data.name.toLowerCase().includes(_vm.searchTerm.toLowerCase()) ||
          data.organization.toLowerCase().includes(_vm.searchTerm.toLowerCase()); }
        )
        .slice(0, 10),
      "cell-style": _vm.cellStyle,
      "tree-props": {
        children: 'users'
      }
    }
  }, [_c('el-table-column', [_c('template', {
    slot: "header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "placeholder": "Station search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "sortable": "",
      "prop": "name",
      "label": "Station"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            'bold-name': scope.row.is_admin
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1991868326)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "sortable": "",
      "prop": "name",
      "label": "Organization"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.organization))])]
      }
    }], null, false, 1820501917)
  })], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "height": "80",
      "align": "center",
      "label": "Users"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "sortable": "",
      "prop": "last_activity",
      "align": "center",
      "label": "Last Activity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.last_activity)))])]
      }
    }], null, false, 1489632776)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "sortable": "",
      "prop": "no_users",
      "align": "center",
      "label": "No. Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "perc_active",
      "align": "center",
      "label": "% Active"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Campaigns"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_last_created",
      "align": "center",
      "label": "Last Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.campaigns_last_created)))])]
      }
    }], null, false, 759395255)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_no_created",
      "align": "center",
      "label": "No. Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_no_active",
      "align": "center",
      "label": "No. Active"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Surveys"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_last_created",
      "align": "center",
      "label": "Last Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.surveys_last_created)))])]
      }
    }], null, false, 3486337655)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_no_created",
      "align": "center",
      "label": "No. Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_no_active",
      "align": "center",
      "label": "No. Active"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_latest_n",
      "align": "center",
      "label": "Latest n"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_avg_n",
      "align": "center",
      "label": "Avg n"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Messages"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "messages",
      "align": "center",
      "label": "F",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [(scope.row.messages[0].facebook_post || scope.row.messages[0].facebook_comment) ? _c('span', [_vm._v(_vm._s(_vm.formatNumber(
          scope.row.messages[0].facebook_post + scope.row.messages[0].facebook_comment
        )))]) : _vm._e()] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].tweet",
      "align": "center",
      "label": "T",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].tweet)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].instagram",
      "align": "center",
      "label": "I",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].instagram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].whatsapp",
      "align": "center",
      "label": "W",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].whatsapp)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].telegram",
      "align": "center",
      "label": "TE",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].telegram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].facebook_message",
      "align": "center",
      "label": "FM",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].facebook_message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].message",
      "align": "center",
      "label": "SMS",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].email",
      "align": "center",
      "label": "E",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].email)))])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Unique Users"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "unique_users",
      "align": "center",
      "label": "F",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [(
          scope.row.unique_users[0].facebook_post ||
          scope.row.unique_users[0].facebook_comment
        ) ? _c('span', [_vm._v(_vm._s(_vm.formatNumber(
          scope.row.unique_users[0].facebook_post +
          scope.row.unique_users[0].facebook_comment
        )))]) : _vm._e()] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].tweet",
      "align": "center",
      "label": "T",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].tweet)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].instagram",
      "align": "center",
      "label": "I",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].instagram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].whatsapp",
      "align": "center",
      "label": "W",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].whatsapp)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].telegram",
      "align": "center",
      "label": "TE",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].telegram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].facebook_message",
      "align": "center",
      "label": "FM",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].facebook_message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].message",
      "align": "center",
      "label": "SMS",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].email",
      "align": "center",
      "label": "E",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].email)))])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "qualitative_surveys",
      "align": "center",
      "label": "Qualitative"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.qualitative_surveys),
            callback: function($$v) {
              _vm.$set(scope.row, "qualitative_surveys", $$v)
            },
            expression: "scope.row.qualitative_surveys"
          }
        })]
      }
    }], null, false, 540383583)
  })], 1), _vm._v(" "), _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "is_streaming",
      "align": "center",
      "label": "Streaming"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.is_streaming),
            callback: function($$v) {
              _vm.$set(scope.row, "is_streaming", $$v)
            },
            expression: "scope.row.is_streaming"
          }
        })]
      }
    }], null, false, 2630274767)
  })], 1), _vm._v(" "), (_vm.selectedRegion === 'ZA' || _vm.selectedRegion === '') ? _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "afstereo",
      "align": "center",
      "label": "AFStereo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.afstereo),
            callback: function($$v) {
              _vm.$set(scope.row, "afstereo", $$v)
            },
            expression: "scope.row.afstereo"
          }
        })]
      }
    }], null, false, 4246715691)
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.stationActivityData.count
    },
    on: {
      "current-change": function($event) {
        _vm.$emit('changePage', _vm.getPageChange($event))
      }
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('span', [_vm._v("Station Activity Dashboard")])])
}]}

/***/ }),
/* 3123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('question-editor', {
    attrs: {
      "value": {
        title: 'Mobile Number',
        questionType: 'TEXT'
      },
      "is-static": true
    }
  }), _vm._v(" "), _c('draggable', {
    staticClass: "question-container",
    class: {
      empty: _vm.isEmpty
    },
    attrs: {
      "draggable": ".draggable",
      "group": "questions",
      "handle": ".header",
      "ghost-class": "question-ghost"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.questionList),
      callback: function($$v) {
        _vm.questionList = $$v
      },
      expression: "questionList"
    }
  }, [_vm._l((_vm.questionList), function(question, index) {
    return _c('div', {
      key: question.id,
      staticClass: "item",
      class: {
        draggable: _vm.isEditable
      }
    }, [_c('question-editor', {
      attrs: {
        "value": _vm.questionList[index],
        "index": index + 1,
        "is-selected": question.id === _vm.canvasSelectedQuestionId,
        "isEditable": _vm.isEditable
      },
      on: {
        "input": function($event) {
          return _vm.handleSetQuestion(index, $event)
        },
        "onSelect": function($event) {
          return _vm.handleSelectQuestion(question.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemoveQuestion(index)
        },
        "onEdit": function($event) {
          return _vm.handleEditQuestion(question)
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n        Drag or double-click a qualitative question here from the qualitative questions panel on the right, or \n        "), _c('a', {
    on: {
      "click": _vm.handleCreateQuestion
    }
  }, [_vm._v("Create qualitative question")])])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channel-list-wrapper"
  }, _vm._l((_vm.channels), function(channel) {
    return _c('div', {
      key: channel.id,
      staticStyle: {
        "margin": "0 10px 5px 0"
      }
    }, [_c('el-card', {
      attrs: {
        "shadow": "hover"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": channel.channel_type_title
      }
    }, [_c('social-icon', {
      staticClass: "social-icon",
      attrs: {
        "type": channel.channel_type_title
      }
    })], 1), _vm._v(" "), _c('strong', {
      staticClass: "channel-handle"
    }, [_vm._v(_vm._s(channel.handle))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": ((_vm.active ? 'Deactivate' : 'Activate') + " " + (channel.handle))
      }
    }, [_c('span', {
      staticClass: "fa fa-fw pull-right channel-action",
      class: _vm.logoClass,
      style: ({
        color: _vm.logoColor
      }),
      on: {
        "click": function($event) {
          return _vm.toggleChannelActive(channel)
        }
      }
    })])], 1)], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 3125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voice-intelligence-dashboard"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.isShowFilter) ? _c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('strong', [_vm._v("View by Show |")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "Select slot",
      "loading": _vm.loadingTimeslots
    },
    on: {
      "change": _vm.onTimeslotChanged
    },
    model: {
      value: (_vm.selectedTimeslot),
      callback: function($$v) {
        _vm.selectedTimeslot = $$v
      },
      expression: "selectedTimeslot"
    }
  }, _vm._l((_vm.timeslots), function(slot) {
    return _c('el-option', {
      key: slot.id,
      attrs: {
        "label": slot.title,
        "value": slot.id
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.analyticsBlocks), function(block) {
    return _c('div', {
      key: block.unit,
      staticClass: "col-md-3",
      on: {
        "click": function($event) {
          return _vm.selectBlock(block)
        }
      }
    }, [_c('voice-analytics-unit-block', {
      attrs: {
        "unit": block.unit,
        "unit-class": block.unitClass,
        "period": block.period,
        "description": block.description,
        "received": block.received,
        "growth": block.growth,
        "stats": block.stats,
        "approved": block.approved,
        "flagged": block.flagged,
        "pending": block.pending,
        "selected": block.selected
      },
      on: {
        "previous": function($event) {
          return _vm.onBlockPrevious(block)
        },
        "next": function($event) {
          return _vm.onBlockNext(block)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('filters-sidebar', {
    ref: "filtersSidebar",
    attrs: {
      "transcripts": _vm.transcripts,
      "tone-options": _vm.getToneOptions,
      "tag-options": _vm.getTagOptions
    },
    on: {
      "apply-filters": function($event) {
        _vm.filters = $event
      },
      "reset-filters": _vm.clearFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "space-between",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "flex": 1
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search by name, transcript, tags...",
      "prefix-icon": "el-icon-search",
      "clearable": "",
      "size": "small"
    },
    on: {
      "clear": function($event) {
        _vm.searchQuery = ''
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "flex": 0
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button-group', {
    attrs: {
      "size": "small"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.viewMode !== 'table',
      "size": "small"
    },
    on: {
      "click": _vm.onExportSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n                    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.viewMode !== 'table',
      "size": "small"
    },
    on: {
      "click": _vm.onBulkApprove
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Approve Selected\n                    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleViewMode
    }
  }, [_c('i', {
    class: _vm.viewMode === 'table' ? 'fa fa-th-large' : 'fa fa-list'
  }), _vm._v("\n                      " + _vm._s(_vm.viewMode === 'table' ? 'Grid' : 'Table') + "\n                    ")])], 1)], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [(_vm.viewMode === 'table') ? _c('voice-notes-table', {
    ref: "voiceNotesTable",
    attrs: {
      "transcripts": _vm.getTranscripts,
      "loadingTranscripts": _vm.loadingTranscripts
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "preview-audio": _vm.previewVoiceNote,
      "approve-on-air": _vm.onApproveOnAir,
      "toggle-flag": _vm.onToggleFlag,
      "refresh-transcripts": _vm.onRefreshTranscripts
    }
  }) : _c('voice-notes-grid', {
    attrs: {
      "transcripts": _vm.getTranscripts,
      "loadingTranscripts": _vm.loadingTranscripts
    },
    on: {
      "preview-audio": _vm.previewVoiceNote,
      "approve-on-air": _vm.onApproveOnAir,
      "toggle-flag": _vm.onToggleFlag
    }
  })], 1)])])], 2)]), _vm._v(" "), _c('audio-preview-modal', {
    attrs: {
      "visible": _vm.previewVisible,
      "note": _vm.previewNote
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVisible = $event
      },
      "close": _vm.closePreview
    }
  }), _vm._v(" "), _c('approve-modal', {
    attrs: {
      "visible": _vm.approveVisible,
      "note": _vm.approveNote,
      "loading": _vm.approvingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.approveVisible = $event
      },
      "approve": _vm.handleApproveSubmit,
      "close": _vm.closeApprove
    }
  }), _vm._v(" "), _c('flag-modal', {
    attrs: {
      "visible": _vm.flagVisible,
      "note": _vm.flagNote,
      "loading": _vm.flaggingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.flagVisible = $event
      },
      "flag": _vm.handleFlagSubmit,
      "close": _vm.closeFlag
    }
  }), _vm._v(" "), _c('bulk-approve-modal', {
    attrs: {
      "visible": _vm.bulkApproveVisible,
      "notes": _vm.selectedRows,
      "loading": _vm.bulkApprovingLoading
    },
    on: {
      "update:visible": function($event) {
        _vm.bulkApproveVisible = $event
      },
      "bulk-approve": _vm.handleBulkApproveSubmit,
      "close": _vm.closeBulkApprove
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 header-title"
  }, [_c('h2', [_c('span', {
    staticClass: "fa fa-microphone"
  }), _vm._v("\n        Voice Intelligence\n      ")])])
}]}

/***/ }),
/* 3126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('login-form', {
    attrs: {
      "isPending": _vm.loginPending,
      "hasFailed": _vm.loginFailed
    },
    on: {
      "onLogin": function($event) {
        return _vm.onLogin($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "700px",
      "title": _vm.originator,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.loadingThreads) ? _c('Loader', {
    attrs: {
      "msg": "Loading conversation"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thread-container",
    attrs: {
      "id": "threadContainer"
    }
  }, _vm._l((_vm.processedThreads), function(interaction) {
    return _c('div', {
      key: interaction.id
    }, [_c('div', {
      staticClass: "message",
      class: interaction.direction
    }, [(interaction.audio) ? _c('div', {
      staticClass: "audio-container"
    }, [_c('audio', {
      ref: ("audio" + (interaction.id)),
      refInFor: true,
      attrs: {
        "src": interaction.audio,
        "controls": "controls",
        "preload": "none"
      },
      on: {
        "play": function($event) {
          return _vm.mediaStarted(interaction.id)
        },
        "ended": function($event) {
          return _vm.mediaEnded(interaction.id)
        },
        "pause": function($event) {
          return _vm.mediaEnded(interaction.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (interaction.video) ? _c('div', {
      staticClass: "video-container"
    }, [_c('video', {
      ref: ("video" + (interaction.id)),
      refInFor: true,
      staticClass: "video-item",
      attrs: {
        "src": interaction.video,
        "controls": "controls",
        "preload": "meta"
      },
      on: {
        "play": function($event) {
          return _vm.mediaStarted(interaction.id)
        },
        "ended": function($event) {
          return _vm.mediaEnded(interaction.id)
        },
        "pause": function($event) {
          return _vm.mediaEnded(interaction.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (interaction.image) ? _c('div', {
      staticClass: "image-container"
    }, [_c('image-grid', {
      attrs: {
        "box-width": '370',
        "box-height": '370px',
        "images": [interaction.image]
      },
      on: {
        "imageSelected": _vm.showGallery
      }
    })], 1) : _vm._e(), _vm._v(" "), (interaction.document) ? _c('div', {
      staticClass: "message-container"
    }, [(interaction.document.endsWith('.pdf')) ? _c('div', [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.document
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v("\n              " + _vm._s(("document_" + (interaction.document.slice(-20)))) + "\n            ")])]) : _c('div', [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.document
      }
    }, [(interaction.document.endsWith('.doc') ||
      interaction.document.endsWith('.docx')) ? _c('i', {
      staticClass: "fa fa-file-word-o"
    }) : (interaction.document.endsWith('.xls') ||
      interaction.document.endsWith('.xlsx')) ? _c('i', {
      staticClass: "fa fa-file-excel-o"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(("document_" + (interaction.document.slice(-20)))) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (interaction.text) ? _c('div', {
      staticClass: "message-container"
    }, [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.text
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    }), _vm._v(" " + _vm._s(_vm.getDocumentName(interaction.text)) + "\n          ")])]) : _vm._e(), _vm._v(" "), (interaction.message) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMessage(interaction.message))
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(_vm.displayDatetime(interaction.datetime)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), (!_vm.loadingThreads && _vm.replyExpired) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "text-muted small center"
  }, [_vm._v("\n      24 hour WhatsApp reply period has expired. Due to WhatsApp restrictions replies to this\n      number will not be possible until this number first sends a message to us again.\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.loadingThreads && _vm.showReplyOption) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showMediaOption) ? _c('div', {
    staticClass: "upload-media"
  }, [_c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia),
      expression: "addMedia"
    }]
  }), _vm._v(" "), (_vm.mediaList.length > 0) ? _c('div', {
    staticClass: "preview"
  }, [_vm._l((_vm.mediaPreview), function(preview, index) {
    return _c('div', {
      key: index
    }, [(preview.filetype.startsWith('audio')) ? _c('div', {
      staticClass: "audio-preview"
    }, [_c('audio', {
      attrs: {
        "src": preview.url,
        "controls": "controls",
        "preload": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('video')) ? _c('div', {
      staticClass: "video-preview"
    }, [_c('video', {
      staticClass: "video-item",
      attrs: {
        "src": preview.url,
        "controls": "controls",
        "preload": "meta"
      }
    })]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('image')) ? _c('div', {
      staticClass: "image-preview"
    }, [_c('image-grid', {
      attrs: {
        "box-width": '370',
        "box-height": '370px',
        "images": [preview.url]
      },
      on: {
        "imageSelected": _vm.showGallery
      }
    })], 1) : _vm._e(), _vm._v(" "), (preview.filetype === 'application/pdf') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('text')) ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-text"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-word-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype === 'application/vnd.ms-excel' ||
      preview.filetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-excel-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-control"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.handleClearMedia
    }
  }, [_vm._v("Clear")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia && _vm.mediaList.length === 0),
      expression: "addMedia && mediaList.length === 0"
    }],
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/jpeg, image/png, video/mp4,\n          audio/aac, audio/m4a, audio/amr, audio/mpeg, audio/ogg,\n          application/pdf,\n          application/vnd.ms-excel,\n          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n          application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n          text/csv,\n          text/plain",
      "limit": 1,
      "list-type": 'text',
      "on-change": _vm.handleFileChange,
      "on-remove": _vm.handleFileRemove,
      "file-list": _vm.fileList,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("\n          Drop file here or\n          "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n          jpg / png images, mp4 video, mp3 / ogg audio, csv / plain text, xlsx / docx / pdf applications\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendReply($event)
      }
    },
    model: {
      value: (_vm.reply),
      callback: function($$v) {
        _vm.reply = $$v
      },
      expression: "reply"
    }
  }, [(_vm.showMediaOption) ? _c('el-button', {
    attrs: {
      "slot": "prepend",
      "icon": "fa fa-paperclip"
    },
    on: {
      "click": _vm.toggleUpload
    },
    slot: "prepend"
  }) : _vm._e(), _vm._v(" "), _c('EmojiKeyboard', {
    staticClass: "emoji-keyboard",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "onEmojiInsert": _vm.handleInsertEmoji
    },
    slot: "suffix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-arrow-up"
    },
    on: {
      "click": _vm.sendReply
    },
    slot: "append"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-comments-o"
  })
},staticRenderFns: []}

/***/ }),
/* 3129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "originator"
  }, [_vm._v("We commented")]), _vm._v(" "), _c('span', {
    staticClass: "time pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.datetime, 'from', 'now')))])]), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar pull-left"
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])
}]}

/***/ }),
/* 3130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advanced-search-form"
  }, [_c('div', {
    staticClass: "builder"
  }, _vm._l((_vm.rows), function(row, index) {
    return _c('div', {
      key: row.id,
      staticClass: "search-row"
    }, [_c('div', {
      staticClass: "is-valid-row pull-right"
    }, [(!_vm.isRowValid(row)) ? _c('i', {
      staticClass: "fa fa-times invalid"
    }) : _vm._e(), _vm._v(" "), (_vm.isRowValid(row)) ? _c('i', {
      staticClass: "fa fa-check valid"
    }) : _vm._e()]), _vm._v(" "), (index === 0) ? _c('div', [_c('span', {
      staticClass: "describe"
    }, [_vm._v("I want to find interactions for")]), _vm._v(" "), _c('time-range-select', {
      attrs: {
        "selectedRange": _vm.range
      },
      on: {
        "onRangeChanged": function($event) {
          return _vm.updateRange($event)
        },
        "onDateRangeSelected": function($event) {
          return _vm.updateDateRangeInput($event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "describe"
    }, [_vm._v("where")]), _vm._v(" "), _c('search-field-select', {
      attrs: {
        "fields": _vm.searchFields,
        "selectedField": row.field,
        "selectedOperator": row.operator,
        "selectedInput": row.input
      },
      on: {
        "onFieldsChanged": function($event) {
          return _vm.updateRowData(row.id, $event)
        }
      }
    }), _vm._v(" "), (_vm.showPicker) ? _c('span', {
      staticClass: "describe"
    }, [_vm._v("Range")]) : _vm._e(), _vm._v(" "), (_vm.showPicker) ? _c('el-date-picker', {
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "start-placeholder": "Start",
        "end-placeholder": "End",
        "type": "datetimerange",
        "range-separator": "-"
      },
      model: {
        value: (_vm.dateRange),
        callback: function($$v) {
          _vm.dateRange = $$v
        },
        expression: "dateRange"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (index >= 1) ? _c('div', [(index === 1) ? _c('el-select', {
      attrs: {
        "placeholder": "Please select"
      },
      model: {
        value: (_vm.searchType),
        callback: function($$v) {
          _vm.searchType = $$v
        },
        expression: "searchType"
      }
    }, _vm._l((_vm.searchTypes), function(currentType) {
      return _c('el-option', {
        key: currentType.id,
        attrs: {
          "label": currentType.value,
          "value": currentType.id
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), (index > 1) ? _c('span', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(_vm.searchType))]) : _vm._e(), _vm._v(" "), _c('search-field-select', {
      attrs: {
        "fields": _vm.searchFields,
        "selectedField": row.field,
        "selectedOperator": row.operator,
        "selectedInput": row.input
      },
      on: {
        "onFieldsChanged": function($event) {
          return _vm.updateRowData(row.id, $event)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-top": "1px"
      },
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          return _vm.removeRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.addRow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllRowsValid(_vm.rows)
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n      ")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 3131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "height": 760,
      "width": 550,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "33.06",
      "cy": "53.72",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "58.58",
      "y": "45.68",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "31.72",
      "cy": "134.24",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "33.06",
      "cy": "456.34",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "48",
      "y": "346.6",
      "rx": "5",
      "ry": "5",
      "width": "226.6",
      "height": "NaN"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "61.26",
      "y": "527.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "31.15",
      "y": "490.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "411.56",
      "y": "418.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "33.06",
      "cy": "535.52",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "31.15",
      "y": "408.86",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "29.8",
      "y": "333.71",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.49",
      "y": "254.52",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "31.15",
      "y": "174",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "57.24",
      "y": "367.78",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "31.72",
      "cy": "373.13",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "57.24",
      "y": "291.28",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "31.72",
      "cy": "295.29",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "58.58",
      "y": "448.3",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "57.24",
      "y": "208.07",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "31.72",
      "cy": "214.77",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "29.8",
      "y": "92.13",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "59.92",
      "y": "126.21",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "26.15",
      "y": "580.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "30.15",
      "y": "653.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "29.15",
      "y": "731.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.15",
      "y": "800.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.26",
      "y": "615.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "60.26",
      "y": "688.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "64.26",
      "y": "763.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "30.15",
      "y": "872.73",
      "rx": "0",
      "ry": "0",
      "width": "800",
      "height": "4.02"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "65.26",
      "y": "832.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "66.26",
      "y": "905.49",
      "rx": "5",
      "ry": "5",
      "width": "294.8",
      "height": "13.4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "37.06",
      "cy": "623.52",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "37.06",
      "cy": "695.52",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "38.06",
      "cy": "771.52",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40.06",
      "cy": "840.52",
      "r": "10.72"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "39.06",
      "cy": "911.52",
      "r": "10.72"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "msg": "Loading Contact Lists"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.contactAccounts), function(item) {
    return _c('contact-list-item', {
      key: item.id,
      attrs: {
        "id": item.id,
        "providerName": item.provider
      },
      on: {
        "onContactListClick": _vm.handleContactListClick
      }
    })
  })], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Add Account")])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content clearfix"
  }, [_c('el-button', {
    on: {
      "click": _vm.constantContactAuth
    }
  }, [_vm._v("Constant Contact")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.mailChimpAuth
    }
  }, [_vm._v("Mail Chimp")])], 1)])])], 1), _vm._v(" "), _c('contacts-list-dialog', {
    attrs: {
      "contactAccount": _vm.selectedContactsAccount,
      "isVisible": _vm.contactsListVisible,
      "listId": _vm.selectedContactsList.id,
      "listName": _vm.selectedContactsList.name
    },
    on: {
      "onVisibleChanged": _vm.handleContactListVisibilityChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "demographics-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [_vm._l((_vm.filteredDemographics), function(nugget) {
    return _c('div', {
      key: nugget.title
    }, [_c('el-card', {
      staticClass: "nugget-card",
      attrs: {
        "shadow": "hover"
      }
    }, [(_vm.canDelete(nugget.field)) ? _c('span', {
      staticClass: "delete",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Remove from profile",
        "placement": "right-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          !_vm.isProfileEditModeOn ? _vm.handleShowAlert() :
            _vm.removeNugget(nugget)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "edit",
      staticStyle: {
        "float": "right",
        "cursor": "pointer",
        "margin-right": "10px"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Edit",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-edit",
      on: {
        "click": function($event) {
          !_vm.isProfileEditModeOn ? _vm.handleShowAlert() :
            _vm.editNugget(nugget)
        }
      }
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "nugget-title"
    }, [_vm._v(_vm._s(nugget.title))]), _vm._v(" "), (nugget.field === 'birth_date') ? _c('div', [_c('span', {
      staticClass: "nugget-value"
    }, [_vm._v(_vm._s(nugget.label.split(" ")[0]))])]) : _c('div', [_c('span', {
      staticClass: "nugget-value"
    }, [_vm._v(_vm._s(nugget.label))])])])], 1)
  }), _vm._v(" "), (_vm.showEditNuggetDialog) ? _c('el-dialog', {
    attrs: {
      "id": "edit-nugget-dialog",
      "top": "30vh",
      "width": "60rem",
      "title": ("Edit " + (_vm.selectedNugget.title)),
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": true,
      "visible": _vm.showEditNuggetDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditNuggetDialog = $event
      }
    }
  }, [(_vm.showEditNuggetDialog) ? _c('edit-nugget-dialog', {
    attrs: {
      "nugget": _vm.selectedNugget,
      "visible": _vm.showEditNuggetDialog
    },
    on: {
      "close": function($event) {
        _vm.showEditNuggetDialog = false
      },
      "saveNugget": _vm.saveNugget
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'text-success': _vm.value > 0, 'text-danger': _vm.value < 0
    }
  }, [(_vm.value !== 0) ? _c('span', [_vm._v(_vm._s(Math.round(_vm.value)) + "\n    "), (_vm.isPercentage) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.value > 0,
        'fa-level-down': _vm.value < 0,
        'fa-minus': _vm.value === 0
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Mailchimp Accounts",
      "visible": _vm.dialogVisible,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "open": _vm.open
    }
  }, [(_vm.$apollo.loading || _vm.loadingContacts) ? _c('loader', {
    attrs: {
      "msg": "Loading Accounts"
    }
  }) : _vm._l((_vm.contactAccounts), function(account) {
    return _c('div', {
      key: account.id
    }, [_c('div', {
      staticClass: "ibox-title"
    }, [_c('h5', [_vm._v(_vm._s(_vm.parseProviderName(_vm.accounst.provider)))])]), _vm._v(" "), _c('contact-lists-select', {
      attrs: {
        "id": account.id,
        "provider": account.provider
      },
      on: {
        "selectedListsChange": _vm.handleSelectedListsChange
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.$apollo.loading && !_vm.loadingContacts) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleImportClick
    }
  }, [_vm._v("Import Contacts")]) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 3136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('search-results', {
    attrs: {
      "searchTerm": _vm.searchTerm,
      "searchResults": _vm.searchResults,
      "searchCount": _vm.searchCount,
      "searching": _vm.searching,
      "searchFields": _vm.searchFields
    },
    on: {
      "onSimpleSearch": function($event) {
        return _vm.handleSimpleSearch($event)
      },
      "onAdvancedSearch": function($event) {
        return _vm.handleAdvancedSearch($event)
      },
      "exportToFile": _vm.exportToFile
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-item container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('span', {
    staticClass: "choice-title"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing || !_vm.isEditable),
      expression: "!isEditing || !isEditable"
    }]
  }, [_vm._v(_vm._s(_vm.choice.title))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing && _vm.isEditable),
      expression: "isEditing && isEditable"
    }]
  }, [_c('el-input', {
    ref: "choiceInput",
    staticClass: "choice-editor",
    attrs: {
      "size": "mini",
      "autofocus": true,
      "focus": true
    },
    on: {
      "blur": _vm.handleInputBlur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleUpdateChoice($event)
      }
    },
    model: {
      value: (_vm.editTitle),
      callback: function($$v) {
        _vm.editTitle = $$v
      },
      expression: "editTitle"
    }
  })], 1)])]), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    staticClass: "col-xs-3"
  }, [_c('span', {
    staticClass: "choice-tools pull-right"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Edit"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil",
    on: {
      "click": _vm.handleEdit
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash",
    on: {
      "click": _vm.handleRemove
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tool-divider"
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-navicon"
  })])
}]}

/***/ }),
/* 3138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "livestats-table"
  }, [(Object.keys(_vm.liveStats()).length) ? _c('div', [_c('h4', {
    staticClass: "muted"
  }, [_vm._v("Overview for " + _vm._s(_vm.selectedPeriod))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Total streams',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.totalConnections)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Unique listeners',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.uniqueListeners)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Average duration',
      "statValue": _vm.formatTime(_vm.avgData.streaming.averageDuration)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Average concurrent streams',
      "statValue": _vm.avgData.streaming.averageConnections.toFixed()
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Maximum concurrent streams',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.maxStreams)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    staticClass: "label-success",
    attrs: {
      "statLabel": 'Live streams now',
      "statValue": _vm.formatNumber(_vm.liveStats().live_streams)
    }
  })], 1) : _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "loading",
    staticStyle: {
      "width": "100%"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 3139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, _vm._l((_vm.campaignTypes), function(type) {
    return _c('el-tab-pane', {
      key: type.type
    }, [_c('strong', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(type.label))]), _vm._v(" "), _c('el-card', [_c('campaign-filter-table', {
      attrs: {
        "campaigns": _vm.getCampaignsByType(type.type)
      },
      on: {
        "change": _vm.handleCampaignSelection
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    attrs: {
      "id": "selected-campaigns"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('strong', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Selected Campaigns")]), _vm._v(" "), _c('el-card', [_c('campaign-filter-table', {
    attrs: {
      "empty-text": 'No selected campaigns or surveys',
      "selectorTable": false,
      "campaigns": _vm.selectedCampaigns
    }
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins sec-skeleton"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    style: ({
      minHeight: (_vm.height + "px")
    })
  }, [_c('span', {
    staticClass: "sec-skeleton__bar sec-skeleton__bar--line"
  }), _vm._v(" "), _c('div', {
    staticClass: "sec-skeleton__grid"
  }, _vm._l((_vm.blocks), function(n) {
    return _c('span', {
      key: n,
      staticClass: "sec-skeleton__block"
    })
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('span', {
    staticClass: "sec-skeleton__bar sec-skeleton__bar--title"
  })])
}]}

/***/ }),
/* 3141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "originator"
  }, [_vm._v(_vm._s(_vm.topic.name))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  })]), _vm._v(" "), _c('div', {
    staticClass: "message-tools"
  })])
},staticRenderFns: []}

/***/ }),
/* 3142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Generate URL for profiles portal service\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "158px"
    }
  }, [(_vm.generateUrlSuccess) ? _c('el-form-item', {
    attrs: {
      "label": "Generated Url"
    }
  }, [_c('div', {
    staticClass: "copy-input"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.generatedUrl),
      callback: function($$v) {
        _vm.generatedUrl = $$v
      },
      expression: "generatedUrl"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "copy-button",
    attrs: {
      "type": "text",
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": _vm.copyUrl
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Generate URL",
      "prefix-icon": "el-icon-refresh"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.loadingGenerateUrl,
      "disabled": _vm.generateUrlSuccess,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("Generate")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Profiles Portal URL")])])
}]}

/***/ }),
/* 3143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCollapsed) ? _c('music-editor-collapsed', {
    attrs: {
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }) : _c('music-editor-expanded', {
    attrs: {
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12,
      "md": 24
    }
  }, [_c('div', {
    staticClass: "channel-container"
  }, [_c('span', {
    staticClass: "post-head"
  }, [_vm._v("Channels")]), _vm._v(" "), (_vm.channels.length && !_vm.editPost) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": _vm.isAllChecked ? 'danger' : '',
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.handleSelectAll
    }
  }, [_vm._v(_vm._s(_vm.isAllChecked ? 'Clear' : 'Select') + " All")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "channels"
  }, [(_vm.channels.length) ? _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChannelChange
    },
    model: {
      value: (_vm.checkedChannels),
      callback: function($$v) {
        _vm.checkedChannels = $$v
      },
      expression: "checkedChannels"
    }
  }, _vm._l((_vm.channels), function(channel) {
    return _c('div', {
      key: channel.id
    }, [_c('el-checkbox', {
      attrs: {
        "label": channel.id,
        "disabled": _vm.isChannelDisabled(channel)
      }
    }, [_c('social-icon', {
      staticClass: "channel-icon",
      attrs: {
        "type": channel.channel_type_title
      }
    }), _vm._v("\n                " + _vm._s(channel.title) + "\n              ")], 1)], 1)
  }), 0) : _c('p', {
    staticClass: "text-center text-muted"
  }, [_vm._v("No Social Channels")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12,
      "md": 24
    }
  }, [_c('div', {
    staticClass: "message-container"
  }, [_c('span', {
    staticClass: "post-head"
  }, [_vm._v("Message")]), _vm._v(" "), _c('el-input', {
    ref: "messageInput",
    staticClass: "post-message",
    attrs: {
      "type": "textarea",
      "resize": "none",
      "autosize": {
        minRows: 6,
        maxRows: 6
      },
      "placeholder": "Post Message..."
    },
    on: {
      "blur": _vm.handleInputBlur
    },
    model: {
      value: (_vm.messageContent),
      callback: function($$v) {
        _vm.messageContent = $$v
      },
      expression: "messageContent"
    }
  }), _vm._v(" "), _c('el-popover', {
    ref: "emojiPicker",
    attrs: {
      "placement": "right",
      "trigger": "click"
    }
  }, [_c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "pickerStyles": _vm.pickerStyles,
      "showPreview": false,
      "infiniteScroll": false,
      "sheetSize": 32,
      "exclude": ['recent']
    },
    on: {
      "select": _vm.insertEmoji
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message-controls"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Insert Emoticon",
      "placement": "bottom"
    }
  }, [_c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:emojiPicker",
      arg: "emojiPicker"
    }],
    staticClass: "message-control fa fa-smile-o"
  })])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "lg": 12,
      "md": 24
    }
  }, [_c('div', {
    staticClass: "post-schedule"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Scheduled Post",
      "picker-options": _vm.datePickerOptions,
      "disabled": _vm.getSelectedTikTokChannels.length > 0
    },
    model: {
      value: (_vm.postSchedule),
      callback: function($$v) {
        _vm.postSchedule = $$v
      },
      expression: "postSchedule"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12,
      "md": 24
    }
  }, [_c('div', {
    staticClass: "post-buttons"
  }, [_c('span', [_c('el-button', {
    attrs: {
      "icon": "fa fa-plus"
    },
    on: {
      "click": function($event) {
        _vm.addMedia = !_vm.addMedia
      }
    }
  }, [_vm._v(" Add Media")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.tiktokMediaWarning,
      "placement": "top",
      "disabled": !(_vm.getSelectedTikTokChannels.length > 0 && _vm.mediaList.length === 0)
    }
  }, [_c('span', [(!_vm.sending) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isPostDisabled,
      "plain": ""
    },
    on: {
      "click": _vm.handleSendPost
    }
  }, [_vm._v("\n                " + _vm._s(_vm.editPost ? 'Update' : _vm.schedule ? 'Schedule' : 'Send') + " \n                "), _c('i', {
    class: {
      'fa fa-paper-plane': !_vm.editPost && !_vm.schedule,
        'fa fa-calendar-o': !_vm.editPost && _vm.schedule,
    }
  })]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": true,
      "plain": ""
    }
  }, [_vm._v("\n                Working \n                "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })])], 1)])], 1), _vm._v(" "), (_vm.editPost) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "content": "Delete Post",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": _vm.deleting ? 'fa fa-spinner fa-pulse' : 'fa fa-trash',
      "plain": ""
    },
    on: {
      "click": _vm.handleDeletePost
    }
  })], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), (_vm.getSelectedTikTokChannels.length > 0) ? _c('el-row', [_c('hr'), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    ref: "tiktokOptionsWrapper"
  }, [_c('TikTokOptions', {
    attrs: {
      "settings": _vm.tiktokSettings
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia),
      expression: "addMedia"
    }]
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia),
      expression: "addMedia"
    }],
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": _vm.getSelectedTikTokChannels.length > 0 ? 'video/mp4' : 'image/*, video/*',
      "list-type": "text",
      "on-change": _vm.handleFileChange,
      "on-remove": _vm.handleFileRemove,
      "file-list": _vm.fileList,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n        Drop file here or\n        "), _c('em', [_vm._v("click to upload")])])])], 1), _vm._v(" "), (_vm.mediaList.length) ? _c('el-row', [_c('hr'), _vm._v(" "), _c('p', [_vm._v("Attached Media:")]), _vm._v(" "), (_vm.mediaList[0].filetype && _vm.mediaList[0].filetype.includes('video')) ? _c('video', {
    attrs: {
      "src": ("data:" + (_vm.mediaList[0].filetype) + ";base64," + (_vm.mediaList[0].base64)),
      "controls": "",
      "height": "150"
    }
  }) : _c('img', {
    attrs: {
      "src": ("data:" + (_vm.mediaList[0].filetype) + ";base64," + (_vm.mediaList[0].base64)),
      "height": "100"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [(_vm.total > 0) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "gender",
    attrs: {
      "title": 'Gender',
      "path": "demographics.gender",
      "options": _vm.get(_vm.filters, 'gender')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "age",
    attrs: {
      "title": 'Age',
      "path": "demographics.age",
      "options": _vm.get(_vm.filters, 'age')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "race",
    attrs: {
      "title": 'Race',
      "path": "demographics.ethnicity",
      "options": _vm.get(_vm.filters, 'ethnicity')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "language",
    attrs: {
      "title": 'Language',
      "virtualListSize": 25,
      "isLong": true,
      "path": "demographics.language",
      "options": _vm.get(_vm.filters, 'language')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "location",
    attrs: {
      "title": 'Location',
      "isLong": true,
      "path": "demographics.location",
      "options": _vm.get(_vm.filters, 'location')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "identifier",
    attrs: {
      "title": 'Contact Details',
      "options": _vm.get(_vm.filters, 'contact'),
      "isLong": true,
      "valueKey": "id",
      "labelKey": "title",
      "path": "identifiers"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.title))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('channels-filter', {
    ref: "channel",
    attrs: {
      "title": 'Channels used',
      "options": _vm.get(_vm.filters, 'channel'),
      "isLong": true,
      "valueKey": "id",
      "path": "meta.channel",
      "labelKey": "handle"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.handle))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('date-range-filter', {
    ref: "engaged",
    attrs: {
      "title": 'Engaged'
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('filter-group', {
    ref: "show",
    attrs: {
      "title": 'During the shows',
      "options": _vm.get(_vm.filters, 'show'),
      "chunk": (_vm.get(_vm.filters, 'show') || []).length > 1,
      "valueKey": "id",
      "labelKey": "title",
      "path": "meta.show_id"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.title))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    attrs: {
      "charts": _vm.charts,
      "filters": _vm.filters,
      "results": _vm.search,
      "savedQueries": _vm.savedQueries,
      "mode": _vm.mode,
      "loadingSavedQueries": this.$apollo.queries.savedQueries.loading,
      "loadingCharts": this.$apollo.queries.charts.loading,
      "loadingFilters": this.$apollo.queries.filters.loading,
      "loadingPlugins": this.$apollo.queries.plugins.loading,
      "searching": this.$apollo.queries.search.loading
    },
    on: {
      "download": _vm.handleDownload,
      "filter": _vm.handleFilter,
      "display-profiles": _vm.handleDisplayProfiles,
      "load-more-profiles": _vm.handleLoadMoreProfiles,
      "save-query": _vm.handleSaveQuery,
      "delete-query": _vm.handleDeleteQuery
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-signal"
  })
},staticRenderFns: []}

/***/ }),
/* 3148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header mb-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('el-page-header', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "content": "Automated Email Template Editor"
    },
    on: {
      "back": _vm.handleBack
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('loader', {
    attrs: {
      "msg": "Loading email template"
    }
  }) : _c('template-editor', {
    attrs: {
      "template": _vm.template
    },
    on: {
      "onCancel": _vm.handleCancel,
      "onSave": _vm.handleSave
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modals"
  }, [_c('el-dialog', {
    attrs: {
      "width": "40%",
      "title": _vm.socialPostModalTitle,
      "visible": _vm.socialPostModal,
      "center": true,
      "close-on-click-modal": false,
      "top": _vm.defaultTop
    },
    on: {
      "update:visible": function($event) {
        _vm.socialPostModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Help",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.innerInfoDialogIsVisible = true
      }
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "40%",
      "center": true,
      "title": "How to",
      "visible": _vm.innerInfoDialogIsVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.innerInfoDialogIsVisible = $event
      }
    }
  }, [_c('el-carousel', {
    attrs: {
      "interval": 4000,
      "type": "card",
      "height": "200px",
      "initial-index": 0,
      "autoplay": false,
      "trigger": "click"
    }
  }, _vm._l((_vm.instructions), function(instruction, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('h2', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('strong', [_vm._v("Step " + _vm._s(index + 1))])]), _vm._v(" "), _c('h2', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(instruction))])])
  }), 1)], 1), _vm._v(" "), (_vm.socialPostModal) ? _c('social-posts-container', {
    attrs: {
      "channels": _vm.socialChannels
    },
    on: {
      "close": _vm.closeSocialPostModal
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "baseball",
    attrs: {
      "id": "profile-dialog",
      "top": "10vh",
      "width": "64rem",
      "center": true,
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10%",
      "text-align": "center"
    }
  }, [_c('el-image', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "id": "image",
      "src": _vm.imageSrc,
      "fit": 'cover'
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.initialProfile.identifier))])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "id": "visible-tabs",
      "stretch": true
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "campaigns"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in & Permission",
      "name": "optin"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hidden-tabs"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }, [_c('demographics-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "demographics": _vm.demographics
    },
    on: {
      "blacklist": _vm.handleBlacklistNugget,
      "remove": _vm.handleRemoveNugget
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "campaigns"
    }
  }, [_c('campaigns-and-surveys-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "campaigns": _vm.campaigns
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [_c('interactions-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "interactions": _vm.processedInteractions
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in",
      "name": "optin"
    }
  }, [_c('optins-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "optins": _vm.optins
    }
  })], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-th-list fa-survey"
  })
},staticRenderFns: []}

/***/ }),
/* 3152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-12 col-md-12 col-sm-12"
  }, [_c('audience-profile-chart', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data.audienceProfile
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12"
  }, [_c('cross-platform-engagement-chart', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data.crossPlatformEngagement
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "originator"
  }, [_vm._v(" " + _vm._s(_vm.getFullName) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "time pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.datetime, 'from', 'now')))])]), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar pull-left"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])
}]}

/***/ }),
/* 3154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', {
    staticStyle: {
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form', {
    ref: "emailForm",
    staticClass: "template-form",
    attrs: {
      "model": _vm.template,
      "rules": _vm.rules,
      "label-width": "190px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Template Type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.template.type),
      callback: function($$v) {
        _vm.$set(_vm.template, "type", $$v)
      },
      expression: "template.type"
    }
  }, _vm._l((_vm.templateTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Subject",
      "prop": "subject"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Body",
      "prop": "content"
    }
  }, [_c('ck-editor', {
    attrs: {
      "config": _vm.editorConfig
    },
    on: {
      "ready": _vm.onEditorReady
    },
    model: {
      value: (_vm.template.content),
      callback: function($$v) {
        _vm.$set(_vm.template, "content", $$v)
      },
      expression: "template.content"
    }
  }), _vm._v(" "), (_vm.template.type) ? _c('div', [_vm._l((_vm.templateVars.global), function(temp) {
    return _c('el-tag', {
      key: temp,
      staticStyle: {
        "margin": "10px 5px"
      },
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(("{{" + temp + "}}")) + "\n            ")])
  }), _vm._v(" "), _vm._l((_vm.templateVars[_vm.template.type.toLowerCase()]), function(temp) {
    return _c('el-tag', {
      key: temp,
      staticStyle: {
        "margin": "10px 5px"
      },
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(("{{" + temp + "}}")) + "\n            ")])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n              Save\n            ")])], 1), _vm._v(" "), _c('br')])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('voice-intelligence-dashboard', {
    attrs: {
      "loadingTimeslots": this.$apollo.queries.timeslots.loading,
      "loadingTranscripts": this.$apollo.queries.transcripts.loading,
      "loadingAnalytics": this.$apollo.queries.transcriptAnalytics.loading,
      "transcripts": _vm.transcripts,
      "timeslots": _vm.timeslots,
      "transcriptAnalytics": _vm.transcriptAnalytics
    },
    on: {
      "approve-query": _vm.handleApproveQuery,
      "bulk-approve-query": _vm.handleBulkApproveQuery,
      "export-selected-query": _vm.handleExportSelectedQuery,
      "flag-query": _vm.handleFlagQuery,
      "timeslot-query": _vm.handleSelectedTimeslotQuery,
      "refresh-transcripts": _vm.handleRefreshTranscripts,
      "period-shift": _vm.handlePeriodShift
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "verifyOTPDialog",
    attrs: {
      "id": "verify-otp-dialog",
      "top": "30vh",
      "width": "50rem",
      "title": "Profile Verification",
      "visible": _vm.showVerifyOTPDialog,
      "destroy-on-close": true,
      "append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showVerifyOTPDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "verificationForm",
    staticClass: "verification-form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.verificationForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('p', [_vm._v("Please provide the mobile number of the person who requested profile enhancement.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Number",
      "prop": "mobile",
      "error": _vm.mobileError
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', [_vm._v("\n            Mobile Number\n            "), _c('i', {
          staticClass: "el-icon-phone",
          staticStyle: {
            "color": "#909399",
            "margin-left": "5px"
          }
        })])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "clearable": "",
      "oninput": "this.value = this.value.replace(/[^0-9]/g, '');",
      "placeholder": "Enter Mobile Number",
      "disabled": _vm.otpSent
    },
    on: {
      "blur": _vm.validateMobileNumber,
      "input": _vm.handleMobileNumberInput
    },
    model: {
      value: (_vm.verificationForm.mobile_number),
      callback: function($$v) {
        _vm.$set(_vm.verificationForm, "mobile_number", $$v)
      },
      expression: "verificationForm.mobile_number"
    }
  })], 1)], 1), _vm._v(" "), (_vm.otpSent) ? _c('div', {
    staticClass: "fixed-otp-height"
  }, [_c('p', [_vm._v("Please enter the 5-digit OTP sent to the above mobile number:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "OTP",
      "prop": "otp",
      "error": _vm.otpError
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', [_vm._v("OTP\n            "), _c('i', {
          staticClass: "el-icon-key",
          staticStyle: {
            "color": "#909399",
            "margin-left": "5px"
          }
        })])]
      },
      proxy: true
    }], null, false, 2029356969)
  }, [_vm._v(" "), _c('el-input', {
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "clearable": "",
      "type": _vm.showPassword ? 'text' : 'password',
      "maxlength": "5",
      "oninput": "this.value = this.value.replace(/[^0-9]/g, '');",
      "placeholder": "Enter OTP"
    },
    on: {
      "input": _vm.clearOtpError
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.showPassword) ? _c('el-button', {
          on: {
            "click": _vm.togglePasswordVisibility
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye-slash"
        })]) : _c('el-button', {
          on: {
            "click": _vm.togglePasswordVisibility
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye"
        })])]
      },
      proxy: true
    }], null, false, 1972162027),
    model: {
      value: (_vm.verificationForm.otp),
      callback: function($$v) {
        _vm.$set(_vm.verificationForm, "otp", $$v)
      },
      expression: "verificationForm.otp"
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCountdown),
      expression: "showCountdown"
    }],
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "countdown"
    }
  }, [_vm._v("\n        Time remaining: " + _vm._s(_vm.countdown) + "\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResend),
      expression: "showResend"
    }],
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "resend"
    }
  }, [_vm._v("\n        Didn't receive OTP? "), _c('a', {
    on: {
      "click": _vm.resendOTP
    }
  }, [_vm._v("Resend")])])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "icon": "el-icon-close",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.otpSent) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "success",
      "size": "small",
      "icon": "el-icon-success",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.verifyOTP
    }
  }, [_vm._v("Verify OTP")]) : _vm._e(), _vm._v(" "), (!_vm.otpSent) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-message",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send OTP")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Select random winners"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("\n    This will allow you to select a set of random winners for your campaign.\n    It will randomly select a set of messages that was sent into this campaign based on\n    the parameters you define below.\n  ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Winners",
      "prop": "winners"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.form.winners),
      callback: function($$v) {
        _vm.$set(_vm.form, "winners", $$v)
      },
      expression: "form.winners"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Unique",
      "prop": "uniqueWinners"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.uniqueWinners),
      callback: function($$v) {
        _vm.$set(_vm.form, "uniqueWinners", $$v)
      },
      expression: "form.uniqueWinners"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleRunRandomSelection
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Select\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.pluginEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('label', [_vm._v("Station")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.pluginEnabled) ? _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'h:00 a'),
      "unit": 'Hour',
      "unitClass": 'label-success',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'hour',
      "received": _vm.chartsData['hour-stats'].total,
      "growth": _vm.chartsData['hour-stats'].growth,
      "stats": _vm.chartsData['hour-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'hour'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'hour'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'hour'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['hour-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'day'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'month'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['month-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'year'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "480"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Engagement and revenue over time")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processEngagementsVsRevenue.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.processEngagementsVsRevenue,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedPeriod) - 1],
      "showLegend": false,
      "tension": 0.1
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processEngagementsVsRevenue.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'EngagementGraphLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "480"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("\n              Sold out\n              "), (_vm.isSoldOutAveraging) ? _c('span', [_vm._v("average")]) : _vm._e(), _vm._v(" %\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "showGridLines": true,
      "data": _vm.processSoldOut
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true,
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Advertisers")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processAdvertisers.length)) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['advertisers'].top), function(advertiser, index) {
    return _c('li', {
      key: advertiser.advertiser,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": advertiser.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(advertiser.advertiser))])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "scalesEnabled": false,
      "data": _vm.processAdvertisers
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processAdvertisers.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AdvertisersChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true,
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Advertising Categories")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processCategories.length)) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['categories'].top), function(category, index) {
    return _c('li', {
      key: category.category,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": category.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(_vm._s(category.category))])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "scalesEnabled": false,
      "data": _vm.processCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processCategories.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AdvertisersChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top 40 tracks")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['tracks'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['tracks'].top), function(track, index) {
    return _c('li', {
      key: track.track,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "track-position pull-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "pull-right text-right"
    }, [_c('growth', {
      attrs: {
        "value": track.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(track.count.toLocaleString()))])], 1), _vm._v(" "), _c('span', {
      staticClass: "track-artist text-muted"
    }, [_vm._v(_vm._s(track.artist))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(_vm._s(track.title))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top artists")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['artists'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['artists'].top), function(artist, index) {
    return _c('li', {
      key: artist.artist,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": artist.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(artist.artist))]), _vm._v(" "), _c('br')], 1)])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top genres")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['genres'].top.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "data": _vm.chartsData['genres'].top.map(function (s) { return [s.genre, s.count]; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['genres'].top.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['genres'].top), function(genre, index) {
    return _c('li', {
      key: genre.genre,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": genre.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(genre.genre))]), _vm._v(" "), _c('br')], 1)])
  }), 0)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top decades")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [(Boolean(_vm.chartsData['decades'].top.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "data": _vm.chartsData['decades'].top.map(function (s) { return [s.decade, s.count]; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['decades'].top.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e(), _vm._v(" "), (Boolean(_vm.chartsData['decades'].top.length)) ? _c('ul', _vm._l((_vm.chartsData['decades'].top), function(decade, index) {
    return _c('li', {
      key: decade.decade,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": decade.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(decade.decade) + "'s")]), _vm._v(" "), _c('br')], 1)])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Local vs International")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processLocalVsInternational.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "showLegend": false,
      "data": _vm.processLocalVsInternational
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processLocalVsInternational.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top Stations")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['stations'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['stations'].top), function(station, index) {
    return _c('li', {
      key: station.station,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "track-position pull-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "pull-right text-right"
    }, [_c('growth', {
      attrs: {
        "value": station.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(station.revenue.toLocaleString()))])], 1), _vm._v(" "), _c('span', {
      staticClass: "track-artist text-muted"
    }, [_vm._v(_vm._s(station.station))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(" ")])])])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1)])]) : _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('div', {
    staticClass: "text-center ibox-content"
  }, [_c('h3', [_vm._v("Please contact ColonyLive sales team to activate this feature")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.promptMailToSale
    }
  }, [_vm._v("Contact Sales")])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": __webpack_require__(2827),
      "alt": "Afstereo dashboard blured"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 afstereo-header"
  }, [_c('img', {
    staticClass: "afstereo-logo",
    attrs: {
      "src": __webpack_require__(2828),
      "alt": "AFSTEREO Logo"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "aircheck-logo",
    attrs: {
      "src": __webpack_require__(2829),
      "alt": "Aircheck Logo"
    }
  })])
}]}

/***/ }),
/* 3159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "height": 600,
      "width": 700,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "71",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "257",
      "y": "38",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": "Search profile..."
    },
    on: {
      "clear": _vm.reset
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchProfile($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('el-button', {
          attrs: {
            "disabled": !_vm.canSearch || _vm.loading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.searchProfile($event)
            }
          }
        }, [_c('i', {
          class: _vm.loading ? 'el-icon-loading' : 'el-icon-search'
        }), _vm._v(" Search Profile\n      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-text"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted count"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.url))]), _vm._v("\n         \n        "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleShareSurvey
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.questionCharts.length) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No entries received for this spot survey yet, charts will display once we've received more data.")])]) : _vm._e(), _vm._v(" "), (_vm.questionCharts.length) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.questionCharts), function(question) {
    return _c('div', {
      key: question.question,
      class: ("col-lg-" + (6 / _vm.questionCharts.length))
    }, [_c('h4', {
      staticClass: "chart-title"
    }, [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('bar-chart', {
      attrs: {
        "height": 350,
        "showYAxes": true,
        "showXAxes": false,
        "colorCycle": _vm.generateColorPool(question.answers, _vm.hue),
        "data": _vm.totalDisplay(question.answers),
        "options": _vm.chartOptions,
        "autoSkipX": false,
        "maxXRotation": 90
      },
      on: {
        "onClick": function($event) {
          return _vm.handleChartClicked($event, question)
        }
      }
    }), _vm._v(" "), _c('chart-legend', {
      attrs: {
        "colorCycle": _vm.generateColorPool(question.answers, _vm.hue),
        "data": _vm.totalDisplay(question.answers),
        "isPercentage": _vm.totalDisplayOption === 'percentage'
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.profileRowCount), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((_vm.profileKeysForRow(i)), function(key) {
      return _c('div', {
        key: key,
        staticClass: "col-lg-6 text-center"
      }, [_c('div', {
        staticClass: "v-chart-block"
      }, [_c('spot-profile-chart', {
        attrs: {
          "field": key,
          "hue-range": _vm.hue,
          "chartData": _vm.profileCharts[key],
          "totalDisplayOption": _vm.totalDisplayOption
        },
        on: {
          "onRequestRespondents": _vm.handleRequestRespondents
        }
      })], 1)])
    }), 0)
  }), 0)], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h4', [_vm._v("Total entries received")]), _vm._v(" "), _c('div', {
    staticClass: "entries"
  }, [_vm._v(_vm._s(_vm.entries.toLocaleString()))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Daily entry rate")]), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_c('trend', {
    attrs: {
      "points": _vm.entryChart,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Duration progress")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.progress + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "date-range"
  }, [_c('p', [_vm._v("\n            Survey is\n            "), _c('strong', [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" complete.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Running from\n            "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.startDate, 'MMM Do YYYY')))]), _vm._v(" to\n            "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.endDate, 'MMM Do YYYY')))])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 3163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', [_vm._v("Engaged Audience Profiles")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v("Statistics calculated from profiles that exist")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "Loading Audience Profiles..."
    }
  }, [(_vm.hasData) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('pie-chart', {
    attrs: {
      "height": 250,
      "data": _vm.data.age,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 7
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Language",
      "data": _vm.data.language
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 8
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Location",
      "data": _vm.data.location
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('pie-chart', {
    attrs: {
      "height": 250,
      "data": _vm.data.gender,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-box",
    attrs: {
      "span": 8
    }
  }, [_c('table-chart', {
    attrs: {
      "label": "Channels",
      "data": _vm.data.numberOfChannels
    }
  })], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "525px"
    }
  }, [_c('small', {
    staticClass: "graph-empty"
  }, [_vm._v("No Data Loaded")])])])])])
},staticRenderFns: []}

/***/ }),
/* 3164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('contacts-dashboard', {
    attrs: {
      "isLoading": _vm.$apollo.loading,
      "contact-accounts": _vm.contactAccounts
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Generate url feeds from on air panel or campaigns\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "158px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Generate For"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.isGenerateForOnAir),
      callback: function($$v) {
        _vm.isGenerateForOnAir = $$v
      },
      expression: "isGenerateForOnAir"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "label": true
    }
  }, [_vm._v("On Air")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "label": false
    }
  }, [_vm._v("Campaign")])], 1)], 1), _vm._v(" "), (!_vm.isGenerateForOnAir) ? _c('el-form-item', {
    attrs: {
      "label": "Available Campaigns"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedId),
      callback: function($$v) {
        _vm.selectedId = $$v
      },
      expression: "selectedId"
    }
  }, _vm._l((_vm.activeCampaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isGenerateForOnAir) ? _c('el-form-item', {
    attrs: {
      "label": "Available Users"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedId),
      callback: function($$v) {
        _vm.selectedId = $$v
      },
      expression: "selectedId"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Response Type"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.isResponseTypeRSS),
      callback: function($$v) {
        _vm.isResponseTypeRSS = $$v
      },
      expression: "isResponseTypeRSS"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "label": true
    }
  }, [_vm._v("RSS")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "label": false
    }
  }, [_vm._v("JSON")])], 1)], 1), _vm._v(" "), (_vm.generateUrlSuccess) ? _c('el-form-item', {
    attrs: {
      "label": "Generated Url"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.generatedUrl),
      callback: function($$v) {
        _vm.generatedUrl = $$v
      },
      expression: "generatedUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "loading": _vm.loadingGenerateUrl,
      "disabled": _vm.selectedId === null,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("Generate")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Generate URL")])])
}]}

/***/ }),
/* 3166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveAspectRatio": "xMidYMid meet",
      "viewBox": "82.82978723404256 61.9078014184397 505.41843971631215 279.88652482269515",
      "width": "701.42",
      "height": "475.89"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M585.25 338.79L568.23 258.65L533.48 303.33L476.74 296.24L429.93 277.8L397.3 141.63L360.43 262.91L305.11 309.72L268.94 268.58L234.18 329.57L192.34 255.82L156.17 329.57L111.49 250.14L83.83 338.79L585.25 338.79Z",
      "id": "b6RQ5J4bJ"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M568.94 337.38L534.18 162.2L505.82 279.22L476.03 238.79L438.44 321.77L395.18 273.55L351.91 321.77L320.71 142.34L315.74 313.97L291.63 289.86L274.61 311.13L258.3 292.7L238.44 311.13L219.29 247.3L183.83 316.1L153.33 62.91L113.62 306.17L101.56 173.55L83.83 337.38L568.94 337.38Z",
      "id": "b1RypI0Jnh"
    }
  })]), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "dur": "1s",
      "values": "0;1;0",
      "repeatCount": "indefinite",
      "begin": "0.1"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b6RQ5J4bJ",
      "opacity": "1",
      "fill": "#f0f0f0",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "dur": "1s",
      "values": "0;1;0",
      "repeatCount": "indefinite",
      "begin": "0.2"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b6RQ5J4bJ",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#f3f3f3",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1RypI0Jnh",
      "opacity": "1",
      "fill": "#f3f3f3",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b1RypI0Jnh",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#f3f3f3",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "dur": "1s",
      "values": "0;1;0",
      "repeatCount": "indefinite",
      "begin": "0.3"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 3167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "showLegend": true,
      "legendPosition": 'bottom',
      "data": _vm.processGenderStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender / Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processGenderProvinceStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Gender / Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processGenderPopulationGroupStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processProvinceStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province / Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processProvinceAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Province / Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processProvincePopulationGroupStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processPopulationGroupStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group / Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processPopulationGroupAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Population Group / LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processPopulationGroupLsmStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processAgeStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age / LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processAgeLsmStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Age / Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processAgeGenderStats
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('doughnut-chart', {
    attrs: {
      "data": _vm.processLsmStats
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM / Province")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processLsmProvince
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("LSM / Gender")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('bar-chart', {
    attrs: {
      "stacked": true,
      "data": _vm.processLsmGender
    }
  })], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "value": null,
      "filterable": ""
    },
    model: {
      value: (_vm.currentTaxonomy),
      callback: function($$v) {
        _vm.currentTaxonomy = $$v
      },
      expression: "currentTaxonomy"
    }
  }, _vm._l((_vm.taxonomyGroups), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: (index + "-" + (item.value)),
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 3169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('div', {
    ref: "print",
    staticClass: "one-page"
  }, [_c('div', {
    staticClass: "mast-head"
  }, [_c('div', {
    staticClass: "colony-logo"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.colonyLogoB64
    }
  })])]), _vm._v(" "), (_vm.company.logo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.companyLogoB64
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', [_c('h1', [_vm._v(_vm._s(_vm.currentTitle))]), _vm._v(" "), (!_vm.isEditingTitle) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit title",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingTitle = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('el-input', {
    model: {
      value: (_vm.currentTitle),
      callback: function($$v) {
        _vm.currentTitle = $$v
      },
      expression: "currentTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetTitle
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveTitle
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.statData.insight) ? _c('div', {
    staticClass: "insight"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.processedInsight)
    }
  }), _vm._v(" "), (!_vm.isEditingInsight) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit insight",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingInsight = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('div', {
    staticClass: "monitor"
  }, [_c('span', [_c('el-checkbox', {
    model: {
      value: (_vm.positiveSelections.main),
      callback: function($$v) {
        _vm.$set(_vm.positiveSelections, "main", $$v)
      },
      expression: "positiveSelections.main"
    }
  })], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insight),
      expression: "insight"
    }],
    ref: "insightTextArea",
    domProps: {
      "value": (_vm.insight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.insight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button-group', [_vm._l((_vm.insightVariables), function(item) {
    return _c('el-button', {
      key: item.key,
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleAppendInsightVariable('insightTextArea', item.key)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetInsight
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingInsight) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveInsight
    }
  }, [_vm._v("Save")]) : _vm._e()], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "insight-chart"
  }, [(_vm.statData.chart !== 'VERTICAL_BAR_STACKED') ? _c('div', {
    staticClass: "pull-right positive-only monitor"
  }, [_c('strong', {
    staticStyle: {}
  }, [_vm._v("Display only positive")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.positiveSelections.main),
      callback: function($$v) {
        _vm.$set(_vm.positiveSelections, "main", $$v)
      },
      expression: "positiveSelections.main"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix monitor"
  }), _vm._v(" "), _c('div', [(_vm.statData.chart.length === 0 || _vm.statData.chart === 'VERTICAL_BAR') ? _c('bar-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'HORIZONTAL_BAR') ? _c('horizontal-bar-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'PIE') ? _c('pie-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'DONUT') ? _c('doughnut-chart', {
    attrs: {
      "height": 200,
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'VERTICAL_BAR_STACKED') ? _c('stacked-bar-chart', {
    attrs: {
      "height": 300,
      "printable": _vm.printCharts,
      "tooltipsEnabled": !_vm.printCharts,
      "animationDuration": 1,
      "showLegend": true,
      "legendPosition": 'bottom',
      "colorCycle": [_vm.generateTitleColor(_vm.statData.question, [260, 290])],
      "data": _vm.stackedTotalDisplay(_vm.statData.answers),
      "options": _vm.stackedChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.statData.chart === 'WORDCLOUD') ? _c('cloud', {
    attrs: {
      "data": _vm.statData.words || [],
      "fontSizeMapper": _vm.fontSizeMapper,
      "width": 370,
      "height": 300,
      "padding": 5
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.questionLegend && _vm.statData.chart != 'VERTICAL_BAR_STACKED') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('chart-legend', {
    attrs: {
      "titleAlign": 'left',
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "isPercentage": _vm.selectedTotalDisplay === 'percentage'
    }
  })], 1)]) : (_vm.questionLegend) ? _c('stacked-chart-legend', {
    attrs: {
      "data": _vm.mainChartTotalDisplay(_vm.statData.answers),
      "isPercentage": _vm.selectedTotalDisplay === 'percentage'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor toggle text-right"
  }, [(_vm.questionLegend) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.questionLegend = false
      }
    }
  }, [_vm._v("[Hide legend]")]) : _vm._e(), _vm._v(" "), (!_vm.questionLegend) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.questionLegend = true
      }
    }
  }, [_vm._v("[Show legend]")]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle page break",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.pageBreaks.demographics = !_vm.pageBreaks.demographics
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-h"
  })])], 1)], 1), _vm._v(" "), (_vm.pageBreaks.demographics) ? _c('div', {
    staticClass: "page-break"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle bullet points",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleToggleBulletPoints('demographics')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  })])], 1)], 1), _vm._v(" "), (_vm.bulletPointsCollection.hasBulletPoints['demographics']) ? _c('div', {
    staticClass: "bullet-points"
  }, [_c('ul', _vm._l((_vm.bulletPointsCollection.demographics), function(bulletPoint, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "monitor"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('el-input', {
      staticClass: "bullet-edit",
      model: {
        value: (_vm.bulletPointsCollection.demographics[index]),
        callback: function($$v) {
          _vm.$set(_vm.bulletPointsCollection.demographics, index, $$v)
        },
        expression: "bulletPointsCollection.demographics[index]"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "print"
    }, [_vm._v(_vm._s(bulletPoint))]), _vm._v(" "), _c('span', {
      staticClass: "monitor"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveBulletPoint(index, 'demographics')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "monitor"
  }, [_c('el-form', {
    staticClass: "bullet-form",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "bullet-edit",
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddBulletPoint('demographics')
      }
    },
    model: {
      value: (_vm.newBulletPoint.demographics),
      callback: function($$v) {
        _vm.$set(_vm.newBulletPoint, "demographics", $$v)
      },
      expression: "newBulletPoint.demographics"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddBulletPoint('demographics')
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "demographics row"
  }, _vm._l((_vm.selectedAnalytics), function(selectedAnalytic, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "monitor selector"
    }, [_c('div', [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Select one"
      },
      on: {
        "change": function($event) {
          return _vm.handleQuestionChanged(index, selectedAnalytic.key)
        }
      },
      model: {
        value: (selectedAnalytic.key),
        callback: function($$v) {
          _vm.$set(selectedAnalytic, "key", $$v)
        },
        expression: "selectedAnalytic.key"
      }
    }, _vm._l((_vm.selectableAnalytics), function(group) {
      return _c('el-option-group', {
        key: group.label,
        attrs: {
          "label": group.label
        }
      }, _vm._l((group.options), function(item) {
        return _c('el-option', {
          key: ((group.key) + "__" + (item.value)),
          attrs: {
            "label": item.label,
            "value": ((group.key) + "__" + (item.value))
          }
        }, [_c('span', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), (item.type === 'SCALE') ? _c('span', {
          staticStyle: {
            "float": "right"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('strong', {
          staticClass: "positive-only-check-box"
        }, [_vm._v("Positive")]), _vm._v(" "), _c('el-checkbox', {
          model: {
            value: (_vm.positiveSelections[index][((group.key) + "__" + (item.value))]),
            callback: function($$v) {
              _vm.$set(_vm.positiveSelections[index], ((group.key) + "__" + (item.value)), $$v)
            },
            expression: "positiveSelections[index][`${group.key}__${item.value}`]"
          }
        })], 1) : _vm._e()])
      }), 1)
    }), 1)], 1), _vm._v(" "), _c('div', [_c('el-select', {
      attrs: {
        "placeholder": "Chart"
      },
      model: {
        value: (selectedAnalytic.chart),
        callback: function($$v) {
          _vm.$set(selectedAnalytic, "chart", $$v)
        },
        expression: "selectedAnalytic.chart"
      }
    }, _vm._l((_vm.selectableCharts), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "chart-title"
    }, [(!_vm.isEditingQuestion[index]) ? _c('h4', [_vm._v("\n            " + _vm._s(_vm.editedQuestions[index] || _vm.selectedTitleDisplay(selectedAnalytic.key)) + "\n          ")]) : _vm._e(), _vm._v(" "), (
      !_vm.isEditingQuestion[index] &&
      (_vm.editedQuestions[index] || _vm.selectedTitleDisplay(selectedAnalytic.key))
    ) ? _c('div', {
      staticClass: "monitor pull-right"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleEditQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.isEditingQuestion[index]) ? _c('div', [_c('div', {
      staticClass: "monitor"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editedQuestions[index]),
        expression: "editedQuestions[index]"
      }],
      domProps: {
        "value": (_vm.editedQuestions[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editedQuestions, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "insight-variables"
    }, [_c('el-button-group', [_c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleResetQuestion(index, selectedAnalytic.key)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingQuestion[index]) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleSaveQuestion(index)
        }
      }
    }, [_vm._v("Save")]) : _vm._e()], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', [(selectedAnalytic.key) ? _c('div', {
      staticClass: "chart-wrapper"
    }, [(selectedAnalytic.chart === 'horizontal_bar') ? _c('horizontal-bar-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "showYAxes": false,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'vertical_bar') ? _c('bar-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "showXAxes": false,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'pie') ? _c('pie-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'donut') ? _c('doughnut-chart', {
      attrs: {
        "height": 150,
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'word_cloud') ? _c('cloud', {
      attrs: {
        "data": _vm.displayWordData(selectedAnalytic.key),
        "fontSizeMapper": _vm.fontSizeMapper,
        "width": 170,
        "height": 350,
        "padding": 5
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.chart === 'vertical_bar_stacked') ? _c('stacked-bar-chart', {
      attrs: {
        "height": 300,
        "printable": _vm.printCharts,
        "tooltipsEnabled": !_vm.printCharts,
        "animationDuration": 1,
        "showLegend": selectedAnalytic.showLegend,
        "legendPosition": 'bottom',
        "data": _vm.displayKeyData(index, selectedAnalytic.key, selectedAnalytic.chart),
        "options": _vm.stackedChartOptions
      }
    }) : _vm._e(), _vm._v(" "), (
      selectedAnalytic.showLegend && selectedAnalytic.chart != 'vertical_bar_stacked'
    ) ? _c('chart-legend', {
      attrs: {
        "data": _vm.displayKeyData(index, selectedAnalytic.key),
        "isPercentage": _vm.selectedTotalDisplay === 'percentage'
      }
    }) : _vm._e(), _vm._v(" "), (selectedAnalytic.key) ? _c('div', {
      staticClass: "monitor toggle text-right"
    }, [(selectedAnalytic.showLegend) ? _c('a', {
      on: {
        "click": function($event) {
          selectedAnalytic.showLegend = false
        }
      }
    }, [_vm._v("[Hide legend]")]) : _vm._e(), _vm._v(" "), (!selectedAnalytic.showLegend) ? _c('a', {
      on: {
        "click": function($event) {
          selectedAnalytic.showLegend = true
        }
      }
    }, [_vm._v("[Show legend]")]) : _vm._e()]) : _vm._e()], 1) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle page break",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.pageBreaks.sourcing = !_vm.pageBreaks.sourcing
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ellipsis-h"
  })])], 1)], 1), _vm._v(" "), (_vm.pageBreaks.sourcing) ? _c('div', {
    staticClass: "page-break"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  }), _vm._v(" "), (true) ? _c('div', {
    staticClass: "insight"
  }, [_c('div', [_vm._v(_vm._s(_vm.textBoxContext))]), _vm._v(" "), (!_vm.isEditingTextBox) ? _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit text",
      "placement": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isEditingTextBox = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })])], 1)], 1) : _c('div', [_c('div', {
    staticClass: "monitor"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textBoxContext),
      expression: "textBoxContext"
    }],
    ref: "customTextArea",
    domProps: {
      "value": (_vm.textBoxContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textBoxContext = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleResetCustomText
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.isEditingTextBox) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSaveCustomText
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "monitor clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Toggle bullet points",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleToggleBulletPoints('sourcing')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-circle"
  })])], 1)], 1), _vm._v(" "), (_vm.bulletPointsCollection.hasBulletPoints['sourcing']) ? _c('div', {
    staticClass: "bullet-points"
  }, [_c('ul', _vm._l((_vm.bulletPointsCollection.sourcing), function(bulletPoint, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "monitor"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('el-input', {
      staticClass: "bullet-edit",
      model: {
        value: (_vm.bulletPointsCollection.sourcing[index]),
        callback: function($$v) {
          _vm.$set(_vm.bulletPointsCollection.sourcing, index, $$v)
        },
        expression: "bulletPointsCollection.sourcing[index]"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "print"
    }, [_vm._v(_vm._s(bulletPoint))]), _vm._v(" "), _c('span', {
      staticClass: "monitor"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveBulletPoint(index, 'sourcing')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "monitor"
  }, [_c('el-form', {
    staticClass: "bullet-form",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "bullet-edit",
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddBulletPoint('sourcing')
      }
    },
    model: {
      value: (_vm.newBulletPoint.sourcing),
      callback: function($$v) {
        _vm.$set(_vm.newBulletPoint, "sourcing", $$v)
      },
      expression: "newBulletPoint.sourcing"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddBulletPoint('sourcing')
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 sourcing"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('label', [_vm._v("Extra notes / sourcing information:  ")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSaveNotes()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEditSourcing ? 'Cancel' : 'Edit') + " Notes")]), _vm._v(" "), (_vm.isEditSourcing) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "el-icon-check"
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveSourceNotes(_vm.sourcing)
      }
    }
  }, [_vm._v("Save Notes")]) : _vm._e(), _vm._v(" "), (_vm.isEditSourcing) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      }
    },
    model: {
      value: (_vm.sourcing),
      callback: function($$v) {
        _vm.sourcing = $$v
      },
      expression: "sourcing"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isEditSourcing) ? _c('div', {
    staticClass: "well well-sm"
  }, [_vm._v(_vm._s(_vm.sourcing))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 print"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatSourcing(_vm.sourcing))
    }
  })])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("Print")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins",
    class: {
      'no-padding': _vm.noPadding
    }
  }, [_c('div', {
    staticClass: "ibox-title",
    class: {
      selected: _vm.selected
    }
  }, [_vm._t("title")], 2), _vm._v(" "), (_vm.$slots.heading) ? _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._t("heading")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    class: {
      fixed: _vm.fixed
    },
    style: (_vm.contentStyle)
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-envelope-o"
  })
},staticRenderFns: []}

/***/ }),
/* 3172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "height": 560,
      "width": 760,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "251.1",
      "cy": "143.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "431.1",
      "cy": "143.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "611.1",
      "cy": "141.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "248.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "430.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "608.1",
      "cy": "281.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "248.1",
      "cy": "425.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "428.1",
      "cy": "422.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "607.1",
      "cy": "421.1",
      "r": "62.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "196.56",
      "y": "46.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "376.56",
      "y": "43.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "555.56",
      "y": "42.61",
      "rx": "0",
      "ry": "0",
      "width": "107",
      "height": "14.96"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "89.61",
      "rx": "0",
      "ry": "0",
      "width": "16.05",
      "height": "97.9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "249.61",
      "rx": "0",
      "ry": "0",
      "width": "14.98",
      "height": "72.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.56",
      "y": "391.61",
      "rx": "0",
      "ry": "0",
      "width": "14.98",
      "height": "72.16"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-mobile"
  })
},staticRenderFns: []}

/***/ }),
/* 3174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "fab-wrapper",
    style: ([_vm.fabPos, {
      zIndex: _vm.zIndex
    }, {
      position: _vm.positionType
    }]),
    attrs: {
      "id": _vm.position + '-wrapper'
    }
  }, [_c('div', {
    staticClass: "actions-container",
    style: (_vm.listPos),
    attrs: {
      "id": _vm.position + '-action'
    }
  }, [_c('transition', {
    attrs: {
      "name": "fab-actions-appear",
      "enter-active-class": _vm.transitionEnter,
      "leave-active-class": _vm.transitionLeave
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggle),
      expression: "toggle"
    }],
    staticClass: "fab-list"
  }, [_vm._l((_vm.actions), function(action) {
    return [_c('transition', {
      attrs: {
        "enter-active-class": "animated quick zoomIn",
        "leave-active-class": "animated quick zoomOut"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": action.tooltip,
        "placement": _vm.tooltipPos,
        "disabled": !action.tooltip
      }
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.toggle),
        expression: "toggle"
      }],
      ref: "actions",
      refInFor: true,
      staticClass: "pointer",
      style: ({
        'background-color': action.color || _vm.bgColor
      }),
      on: {
        "click": function($event) {
          return _vm.toParent(action.name)
        }
      }
    }, [_c('i', {
      class: [_vm.actionIconSize, 'fab-icon', action.icon]
    })])])], 1)]
  })], 2)])], 1), _vm._v(" "), [_c('el-tooltip', {
    attrs: {
      "content": _vm.mainTooltip,
      "placement": _vm.tooltipPos,
      "disabled": !_vm.mainTooltip
    }
  }, [_c('div', {
    staticClass: "fab pointer",
    style: ({
      'background-color': _vm.bgColor,
      'padding': _vm.paddingAmount
    }),
    on: {
      "click": _vm.handleToggle
    }
  }, [_c('i', {
    class: [_vm.mainIconSize, {
      rotate: _vm.toggle
    }, 'fab-icon main', _vm.mainIcon]
  })])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 3175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-profile-box"
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disabled,
      "content": _vm.tooltip
    }
  }, [_c('div', {
    class: ("square square-color-tier-" + _vm.roundedPercentage)
  }, [_c('span', {
    staticClass: "square-text"
  }, [_vm._v(_vm._s(_vm.roundedPercentage))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "overflow-y": "scroll",
      "height": "430px",
      "padding": "0 8px"
    },
    attrs: {
      "element-loading-background": "#F7F8FC"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      key: campaign.title
    }, [_c('el-card', {
      staticStyle: {
        "height": "120px",
        "background-color": "#fff",
        "padding-bottom": "5px",
        "margin-bottom": "15px",
        "border": "none"
      },
      attrs: {
        "shadow": "hover"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "1.2em",
        "font-weight": "bold",
        "color": "#000",
        "margin-bottom": "10px"
      }
    }, [_vm._v(_vm._s(campaign.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-weight": "light",
        "margin-bottom": "12px"
      }
    }, [_vm._v(_vm._s(campaign.type))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-weight": "light"
      }
    }, [_vm._v(_vm._s(campaign.date))])])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 3177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "localUser",
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.localUser,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.localUser.email),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "email", $$v)
      },
      expression: "localUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "first_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: (_vm.localUser.first_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "first_name", $$v)
      },
      expression: "localUser.first_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Surname",
      "prop": "last_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Surname"
    },
    model: {
      value: (_vm.localUser.last_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "last_name", $$v)
      },
      expression: "localUser.last_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Job Title",
      "prop": "job_title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Job Title"
    },
    model: {
      value: (_vm.localUser.job_title),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "job_title", $$v)
      },
      expression: "localUser.job_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Groups",
      "prop": "groups"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select Groups",
      "disabled": !this.loggedInUser.is_admin
    },
    model: {
      value: (_vm.localUser.groups),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "groups", $$v)
      },
      expression: "localUser.groups"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tags",
      "prop": "tags"
    }
  }, [_vm._l((_vm.localUser.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), _vm._v(" "), (_vm.tagInputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.tagInputValue),
      callback: function($$v) {
        _vm.tagInputValue = $$v
      },
      expression: "tagInputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleShowTagInput
    }
  }, [_vm._v("\n        + New Tag\n      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company Admin",
      "prop": "is_admin"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "disabled": !this.loggedInUser.is_admin
    },
    model: {
      value: (_vm.localUser.is_admin),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "is_admin", $$v)
      },
      expression: "localUser.is_admin"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingUser,
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icons",
    style: ({
      fontSize: _vm.fontSize
    })
  }, [(_vm.type === 'Dms') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'SMS') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Sms') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Cellfind') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Mtech') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Default') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Infobip') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Bumblebee') ? _c('SmsIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Email') ? _c('EmailIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'USSD') ? _c('UssdIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'WeChat') ? _c('WechatIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Mobile') ? _c('MobileIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Twitter') ? _c('TwitterIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Web Hook') ? _c('WebhookIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Import') ? _c('ImportIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'CellFind') ? _c('CellfindIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Facebook') ? _c('FacebookIcon', {
    attrs: {
      "official": _vm.fbOfficial
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Telegram') ? _c('TelegramIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'WhatsApp') ? _c('WhatsappIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Whatsapp') ? _c('WhatsappIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'WhatsAppWeb') ? _c('WhatsappWebIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Instagram') ? _c('InstagramIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Survey') ? _c('SurveyIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'TikTok') ? _c('TiktokIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Waboxapp') ? _c('ChannelAppIcon') : _vm._e(), _vm._v(" "), (_vm.type === 'Trumpia') ? _c('ChannelAppIcon') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filebox-dashboard', {
    attrs: {
      "icons": _vm.icons,
      "myFiles": _vm.myFiles,
      "companyFiles": _vm.companyFiles,
      "loadingMyFiles": _vm.loadingMyFiles,
      "loadingCompanyFiles": _vm.loadingCompanyFiles
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-mobile"
  })
},staticRenderFns: []}

/***/ }),
/* 3182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Download Bot Report"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("From here you can download Bot reports defined by your parameters to a CSV file.")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Channels",
      "prop": "channels"
    }
  }, [_c('channel-select', {
    attrs: {
      "channels": _vm.channelLinks,
      "selectedChannels": _vm.form.channels
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleRunDownloadReport
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Download\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": ("/admin/templates/" + _vm.id)
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 3184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCollapsed) ? _c('select-editor-collapsed', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  }) : _c('select-editor-expanded', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-whatsapp"
  })
},staticRenderFns: []}

/***/ }),
/* 3186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-bar-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Upcoming Scheduled Social Posts")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.handleNewPost
    }
  }, [_vm._v("New Post")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.posts.length !== 0) ? _c('span', _vm._l((_vm.orderedPosts), function(post) {
    return _c('scheduled-post', {
      key: post.id,
      attrs: {
        "post": post,
        "channels": _vm.channels
      },
      on: {
        "edit": _vm.onEditPost,
        "delete": _vm.onDeletePost
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.posts.length) ? _c('p', {
    staticClass: "posts-placeholder"
  }, [_vm._v("No Scheduled Posts")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 3188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poll-choice"
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ((_vm.idx + 1) + ".")
    }
  }, [_c('el-input', {
    attrs: {
      "label": "Choice",
      "placeholder": "Choice",
      "debounce": "500",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.choice.choice),
      callback: function($$v) {
        _vm.$set(_vm.choice, "choice", $$v)
      },
      expression: "choice.choice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Matches",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "comma", undefined, $event.key, undefined) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.preventDefault();
        return _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }, [_c('template', {
    slot: "suffix"
  }, [_c('div', {
    staticClass: "poll-tags"
  }, _vm._l((_vm.choice.matches), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticClass: "poll-tag",
      attrs: {
        "size": "mini",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag) + "\n            ")])
  }), 1)])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "fa fa-trash",
      "type": "danger",
      "plain": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleDeleteChoice
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "company"
    }
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Company Details")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "edit",
      "subject": "company-details"
    }
  }, [_c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Edit",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = !_vm.dialogVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Contact, location and other various details related to my station.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.company),
      expression: "!company"
    }],
    staticClass: "ibox-content"
  }, [(_vm.company && _vm.company.logoImage) ? _c('div', {
    staticClass: "company-logo"
  }, [(_vm.company.logoImage) ? _c('img', {
    attrs: {
      "src": _vm.company.logoImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.company.logoImage) ? _c('hr') : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.company) ? _c('div', [(_vm.company.title) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Title:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.title))])]) : _vm._e(), _vm._v(" "), (_vm.company.webSite) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Website:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('a', {
    attrs: {
      "href": _vm.company.webSite,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.company.webSite))])]), _vm._v(" "), (_vm.company.telephoneNumber) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Telephone no:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.telephoneNumber))])]) : _vm._e(), _vm._v(" "), (_vm.company.faxNumber) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Fax no:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.faxNumber))])]) : _vm._e(), _vm._v(" "), (_vm.company.timezone) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Timezone:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.timezone))])]) : _vm._e(), _vm._v(" "), (_vm.company.woeid) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("WOEID:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.woeid))])]) : _vm._e(), _vm._v(" "), (_vm.company.cumulativeAudience) ? _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('strong', [_vm._v("Cume:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(_vm._s(_vm.company.cumulativeAudience.toLocaleString()))])]) : _c('br')]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.company) ? _c('el-dialog', {
    attrs: {
      "title": "Edit Company",
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.company
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Title"
    },
    model: {
      value: (_vm.company.title),
      callback: function($$v) {
        _vm.$set(_vm.company, "title", $$v)
      },
      expression: "company.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Short Name",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Short Name"
    },
    model: {
      value: (_vm.company.shortName),
      callback: function($$v) {
        _vm.$set(_vm.company, "shortName", $$v)
      },
      expression: "company.shortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "webSite"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Website"
    },
    model: {
      value: (_vm.company.webSite),
      callback: function($$v) {
        _vm.$set(_vm.company, "webSite", $$v)
      },
      expression: "company.webSite"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Format",
      "prop": "format"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Format"
    },
    model: {
      value: (_vm.company.format),
      callback: function($$v) {
        _vm.$set(_vm.company, "format", $$v)
      },
      expression: "company.format"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Genre",
      "prop": "genre"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Genre"
    },
    model: {
      value: (_vm.company.genre),
      callback: function($$v) {
        _vm.$set(_vm.company, "genre", $$v)
      },
      expression: "company.genre"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telephone no.",
      "prop": "telephoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Telephone no."
    },
    model: {
      value: (_vm.company.telephoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "telephoneNumber", $$v)
      },
      expression: "company.telephoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fax no.",
      "prop": "faxNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Fax no."
    },
    model: {
      value: (_vm.company.faxNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "faxNumber", $$v)
      },
      expression: "company.faxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.company.country),
      callback: function($$v) {
        _vm.$set(_vm.company, "country", $$v)
      },
      expression: "company.country"
    }
  }, _vm._l((_vm.countries), function(country, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": country.name,
        "value": country.alpha2
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select State",
      "disabled": _vm.regions.length === 0,
      "filterable": ""
    },
    model: {
      value: (_vm.company.state),
      callback: function($$v) {
        _vm.$set(_vm.company, "state", $$v)
      },
      expression: "company.state"
    }
  }, _vm._l((_vm.regions), function(region, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": region.name,
        "value": region.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Timezone",
      "prop": "timezone"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Select Timezone",
      "loading": _vm.loadingTimezones,
      "filterable": ""
    },
    model: {
      value: (_vm.company.timezone),
      callback: function($$v) {
        _vm.$set(_vm.company, "timezone", $$v)
      },
      expression: "company.timezone"
    }
  }, _vm._l((_vm.timezones), function(timezone, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": timezone[1],
        "value": timezone[0]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "WOEID",
      "prop": "woeid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "WOEID"
    },
    model: {
      value: (_vm.company.woeid),
      callback: function($$v) {
        _vm.$set(_vm.company, "woeid", $$v)
      },
      expression: "company.woeid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cume",
      "prop": "cume"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cume"
    },
    model: {
      value: (_vm.company.cumulativeAudience),
      callback: function($$v) {
        _vm.$set(_vm.company, "cumulativeAudience", $$v)
      },
      expression: "company.cumulativeAudience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Station Logo"
    }
  }, [_c('el-upload', {
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/*",
      "on-change": _vm.handleLogoImageChange,
      "on-remove": _vm.handleFileRemove,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n            Drop file here or\n            "), _c('em', [_vm._v("click to upload")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Survey Logo"
    }
  }, [_c('el-upload', {
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/*",
      "on-change": _vm.handleSurveyImageChange,
      "on-remove": _vm.handleFileRemove,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n            Drop file here or\n            "), _c('em', [_vm._v("click to upload")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opt-in Keywords"
    }
  }, [_vm._l((_vm.company.optinKeywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(_vm.company.optinKeywords, keyword)
        }
      }
    }, [_vm._v("\n          " + _vm._s(keyword) + "\n        ")])
  }), _vm._v(" "), (_vm.inputVisible.saveOptinInput) ? _c('el-input', {
    ref: "saveOptinInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInputConfirm(_vm.company.optinKeywords, 'saveOptinInput')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm(_vm.company.optinKeywords, 'saveOptinInput')
      }
    },
    model: {
      value: (_vm.inputValue.saveOptinInput),
      callback: function($$v) {
        _vm.$set(_vm.inputValue, "saveOptinInput", $$v)
      },
      expression: "inputValue.saveOptinInput"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showInput('saveOptinInput')
      }
    }
  }, [_vm._v("+ New Keyword")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opt-out Keywords",
      "prop": "cume"
    }
  }, [_vm._l((_vm.company.optoutKeywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(_vm.company.optoutKeywords, keyword)
        }
      }
    }, [_vm._v("\n          " + _vm._s(keyword) + "\n        ")])
  }), _vm._v(" "), (_vm.inputVisible.saveOptoutInput) ? _c('el-input', {
    ref: "saveOptoutInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInputConfirm(_vm.company.optoutKeywords, 'saveOptoutInput')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm(_vm.company.optoutKeywords, 'saveOptoutInput')
      }
    },
    model: {
      value: (_vm.inputValue.saveOptoutInput),
      callback: function($$v) {
        _vm.$set(_vm.inputValue, "saveOptoutInput", $$v)
      },
      expression: "inputValue.saveOptoutInput"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.showInput('saveOptoutInput')
      }
    }
  }, [_vm._v("+ New Keyword")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.handleUpdateCompany
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('el-select', {
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: (_vm.selectedField),
      callback: function($$v) {
        _vm.selectedField = $$v
      },
      expression: "selectedField"
    }
  }, _vm._l(([].concat( _vm.fields ).sort(function (a, b) { return a.order - b.order; })), function(field) {
    return _c('el-option', {
      key: field.field,
      attrs: {
        "label": field.title,
        "value": field.field
      }
    })
  }), 1), _vm._v(" "), (_vm.selectedField) ? _c('el-select', {
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: (_vm.selectedOperator),
      callback: function($$v) {
        _vm.selectedOperator = $$v
      },
      expression: "selectedOperator"
    }
  }, _vm._l((_vm.operators), function(operator) {
    return _c('el-option', {
      key: operator.id,
      attrs: {
        "label": operator.title,
        "value": operator.id
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.selectedField && _vm.selectedOperator) ? _c('span', [(_vm.currentField.input === 'text') ? _c('el-input', {
    staticClass: "text-input",
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.selectedInput),
      callback: function($$v) {
        _vm.selectedInput = $$v
      },
      expression: "selectedInput"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentField.input === 'number') ? _c('el-input-number', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.selectedInput),
      callback: function($$v) {
        _vm.selectedInput = $$v
      },
      expression: "selectedInput"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentField.input === 'select' || _vm.currentField.input === 'foreign_key') ? _c('el-select', {
    model: {
      value: (_vm.selectedInput),
      callback: function($$v) {
        _vm.selectedInput = $$v
      },
      expression: "selectedInput"
    }
  }, _vm._l((_vm.currentField.options), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.value,
        "value": option.id
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function($event) {
        return _vm.handleSelectedListsChange()
      }
    },
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  }, _vm._l((_vm.contactLists), function(list) {
    return _c('el-checkbox', {
      key: list.id,
      attrs: {
        "label": list.id
      }
    }, [_vm._v("\n            " + _vm._s(list.name) + "\n          ")])
  }), 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "matrixForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.matrixForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.matrixForm.title),
      callback: function($$v) {
        _vm.$set(_vm.matrixForm, "title", $$v)
      },
      expression: "matrixForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Choices"
    }
  }, [_c('draggable', {
    attrs: {
      "group": "matrix-sub-choices",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.choices),
      callback: function($$v) {
        _vm.choices = $$v
      },
      expression: "choices"
    }
  }, _vm._l((_vm.choices), function(choice, index) {
    return _c('div', {
      key: index,
      staticClass: "choice-item container-fluid draggable"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('strong', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v("\n              " + _vm._s(choice.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('span', {
      staticClass: "choice-tools pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveChoice(index)
        }
      }
    })])], 1)])])])
  }), 0), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Add new choice"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddChoice($event)
      }
    },
    model: {
      value: (_vm.choiceInput),
      callback: function($$v) {
        _vm.choiceInput = $$v
      },
      expression: "choiceInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.matrixChoicesCreating,
      "disabled": _vm.matrixChoicesCreating
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.matrixForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "survey-builder-dashboard"
    }
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header campaign-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("Survey Builder Dashboard")]), _vm._v(" "), _c('survey-filter', {
    staticClass: "pull-left",
    staticStyle: {
      "display": "inline"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.surveyListLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading surveys"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.surveyListLoading && _vm.surveyList && !_vm.surveyList.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.surveyListLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._l((_vm.surveyList), function(survey) {
    return _c('survey-list-item', {
      key: survey.id,
      attrs: {
        "id": parseInt(survey.id, 10),
        "title": survey.title,
        "state": _vm.determineSurveyState(survey),
        "growth": survey.growth,
        "totalEntries": survey.totalEntries,
        "totalThisMonth": survey.totalEntriesThisMonth,
        "totalPerDayThisMonth": survey.totalPerDayThisMonth,
        "progress": _vm.calculateProgress(survey),
        "isSpotSurvey": survey.isSpot,
        "favorite": survey.favorite,
        "isPreview": survey.isPreview,
        "startDate": _vm.moment(survey.startDate),
        "endDate": _vm.moment(survey.endDate),
        "createdBy": survey.createdBy,
        "editable": true,
        "isAdminUser": _vm.me.is_staff
      },
      on: {
        "onDownloadMessages": function($event) {
          return _vm.handleDownloadMessages(survey)
        },
        "onEditSurvey": function($event) {
          return _vm.handleEditSurvey(survey)
        },
        "onViewSurvey": function($event) {
          return _vm.handleViewSurvey(survey)
        },
        "onToggleActiveStatus": function($event) {
          return _vm.handleToggleLiveStatus($event, survey.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.surveyList.length == 0) ? _c('empty', [_vm._v("No surveys found.")]) : _vm._e(), _vm._v(" "), (_vm.surveyListTotalPages > 1) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.surveyList.length) ? _c('paginator', {
    attrs: {
      "id": "paginator",
      "pages": _vm.surveyListTotalPages,
      "currentPage": _vm.surveyListPage
    },
    on: {
      "goToNextPage": _vm.handleNextPage,
      "goToPreviousPage": _vm.handlePreviousPage,
      "goToPage": _vm.handleGoToPage
    }
  }) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "mainTooltip": "New Survey"
    },
    on: {
      "click": _vm.handleCreateSurvey
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No surveys found within the current filter.")])])
}]}

/***/ }),
/* 3195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "Select Country",
      "filterable": ""
    },
    model: {
      value: (_vm.currentCountry),
      callback: function($$v) {
        _vm.currentCountry = $$v
      },
      expression: "currentCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    }, [_c('span', {
      staticClass: "flag"
    }, [_vm._v(_vm._s(item.flag))]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "code"
    }, [_vm._v(_vm._s(item.dial_code))])])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 3196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "size": "small",
      "model": _vm.rule,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.rule.title),
      callback: function($$v) {
        _vm.$set(_vm.rule, "title", $$v)
      },
      expression: "rule.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Event",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select an event"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.rule.events),
      callback: function($$v) {
        _vm.$set(_vm.rule, "events", $$v)
      },
      expression: "rule.events"
    }
  }, _vm._l((_vm.ruleFields.events), function(ruleEvent, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": ruleEvent.title,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.rule.actions), function(action, key) {
    return _c('rule-action', {
      key: key,
      attrs: {
        "actionKey": _vm.rule.events.actions,
        "action": action,
        "eventActions": _vm.ruleFields.events[_vm.rule.events].actions,
        "fields": _vm.ruleFields.actions
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: (_vm.selectedRange),
      callback: function($$v) {
        _vm.selectedRange = $$v
      },
      expression: "selectedRange"
    }
  }, _vm._l((Object.keys(_vm.timeRanges)), function(key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": key,
        "value": key
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 3198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('strong', [_vm._v("Copyright")]), _vm._v(" " + _vm._s(_vm.year) + " ColonyHQ Pty Ltd.\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-link"
  }, [_c('a', {
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n      Privacy Policy\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-link"
  }, [_c('a', {
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/Web-Copy-TandC.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n      Terms & Conditions\n    ")])])
}]}

/***/ }),
/* 3199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": _vm.note && _vm.note.flagged ? 'Unflag Voice Note' : 'Flag for Review',
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.note.sender))])])]), _vm._v(" "), (_vm.note.timestamp) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Currently Flagged\n      ")]) : _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" Not Flagged\n      ")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript Preview\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.previewText))])]), _vm._v(" "), (_vm.note.flagged) ? _c('div', {
    staticClass: "previous-flag"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Previous Flag Info\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flag-info"
  }, [(_vm.note.flaggedBy) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Flagged by")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" " + _vm._s(_vm.note.flaggedBy) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.flaggedAt) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Flagged on")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" " + _vm._s(_vm.formatDate(_vm.note.flaggedAt)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.flagReason) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('span', {
    staticClass: "flag-reason"
  }, [_vm._v(_vm._s(_vm.note.flagReason))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Action By"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.actionBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.actionDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), (!_vm.note.flagged) ? _c('el-form-item', {
    attrs: {
      "label": "Reason / Comments (optional)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Leave a reason or comment...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.note && _vm.note.flagged) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleFlag(false)
      }
    }
  }, [_vm._v("\n      Unflag Voice Note\n    ")]) : _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "fa fa-flag",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleFlag(true)
      }
    }
  }, [_vm._v("\n      Flag for Review\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content no-padding"
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "list-group"
  }, _vm._l((_vm.plugins), function(plugin, index) {
    return _c('li', {
      key: plugin.id,
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "label label-success pull-right"
    }, [_vm._v("Enabled")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(plugin.plugin_display))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted p-xs"
    }, [_vm._v("\n          " + _vm._s(_vm.pluginDescriptions[plugin.plugin_route]) + "\n        ")])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Plugins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n    To activate plugins please contact us at\n    "), _c('a', {
    attrs: {
      "href": "mailto:support@colonyhq.com"
    }
  }, [_vm._v("support@colonyhq.com")]), _vm._v("\n    so that we can assist you in activating some of the great plugins we have to offer.\n  ")])
}]}

/***/ }),
/* 3201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-upload"
  })
},staticRenderFns: []}

/***/ }),
/* 3202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    key: "facebookDialog",
    attrs: {
      "title": "Create Instagram Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Instagram'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loader-text"
  }, [_vm._v("\n      Waiting for authorization.\n      "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]), _vm._v(" "), (_vm.instagramPages.length !== 0) ? _c('div', {
    staticClass: "instagram-pages"
  }, [_c('p', [_vm._v("Choose Page(s)")]), _vm._v(" "), _c('div', {
    staticClass: "page-list"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.selectedPages),
      callback: function($$v) {
        _vm.selectedPages = $$v
      },
      expression: "selectedPages"
    }
  }, _vm._l((_vm.instagramPages), function(page) {
    return _c('div', {
      key: page.page_id
    }, [_c('el-checkbox', {
      attrs: {
        "label": page.page_id
      }
    }, [_vm._v(_vm._s(page.page_name))])], 1)
  }), 0)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSaving || !_vm.selectedPages.length,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.isSaving) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hideHeader) ? _c('dashboard-header', {
    attrs: {
      "data-tour": "header"
    },
    on: {
      "tour": _vm.startTour
    }
  }) : _vm._e(), _vm._v(" "), (_vm.segmentationEnabled) ? _c('ai-credits-banner') : _vm._e(), _vm._v(" "), _c('no-data-modal', {
    attrs: {
      "visible": !!_vm.notice && _vm.dismissedNotice !== _vm.notice.key,
      "refreshing": _vm.refreshing,
      "icon": _vm.notice ? _vm.notice.icon : undefined,
      "title": _vm.notice ? _vm.notice.title : undefined,
      "text": _vm.notice ? _vm.notice.text : undefined,
      "hint": _vm.notice ? _vm.notice.hint : undefined,
      "tone": _vm.notice ? _vm.notice.tone : undefined,
      "show-refresh": _vm.notice ? _vm.notice.refresh : true,
      "loading": !!_vm.notice && !!_vm.notice.loading,
      "progress": _vm.notice && _vm.notice.progress ? _vm.notice.progress : 0,
      "progress-text": _vm.notice && _vm.notice.progressText ? _vm.notice.progressText : ''
    },
    on: {
      "close": function($event) {
        _vm.dismissedNotice = _vm.notice.key
      },
      "refresh": function($event) {
        return _vm.$emit('refresh')
      }
    }
  }), _vm._v(" "), _c('segments-overview', {
    attrs: {
      "summary": _vm.summary,
      "insights": _vm.insights,
      "segment-stats": _vm.segmentStats,
      "segment-tags": _vm.segmentTags,
      "active-segment": _vm.activeSegment,
      "loading-summary": _vm.loadingSummary,
      "loading-insights": _vm.loadingInsights,
      "freshness": _vm.segmentFreshness,
      "refreshing": _vm.refreshing
    },
    on: {
      "refresh": function($event) {
        return _vm.$emit('refresh')
      },
      "segment-click": _vm.handleSegmentClick
    }
  }), _vm._v(" "), _c('engagement-overview', {
    attrs: {
      "audience-profiles": _vm.audienceProfiles,
      "cross-channel": _vm.crossChannel,
      "completeness": _vm.completeness,
      "loading-aggregate": _vm.loadingAggregate,
      "loading-completeness": _vm.loadingCompleteness
    },
    on: {
      "export-pair": function($event) {
        return _vm.startExport($event)
      }
    }
  }), _vm._v(" "), _c('listener-retargeting', {
    attrs: {
      "data-tour": "listeners",
      "listeners": _vm.listeners.listeners || [],
      "total": _vm.listeners.totalMatches || 0,
      "loading": _vm.loadingListeners,
      "visible": _vm.showListeners,
      "has-brief": _vm.preFillBrief.text.length > 0,
      "is-search": !!_vm.localFilters.originator,
      "retarget-disabled": _vm.retargetAlreadyAdded || _vm.addingToBucket,
      "retarget-loading": _vm.addingToBucket,
      "retarget-tip": _vm.retargetTip
    },
    on: {
      "toggle-display": function($event) {
        _vm.showListeners = !_vm.showListeners
      },
      "load-more": function($event) {
        return _vm.$emit('load-more')
      },
      "open": _vm.openListener,
      "bulk-enrich": function($event) {
        _vm.showBulkEnrich = true
      },
      "retarget": _vm.retargetCurrent,
      "export": function($event) {
        return _vm.startExport()
      },
      "ai-suggest": _vm.handleAiSuggest,
      "reset": _vm.resetFilters
    }
  }), _vm._v(" "), _c('campaign-recommender', {
    ref: "recommender",
    attrs: {
      "data-tour": "recommender",
      "recommendation-result": _vm.recommendationResult,
      "pre-fill": _vm.preFillBrief,
      "listener-channel-counts": _vm.channelCounts,
      "active-filters": _vm.localFilters,
      "credits-exhausted": _vm.creditsExhausted
    },
    on: {
      "recommend": _vm.onRecommend,
      "export-audience": function($event) {
        return _vm.exportRecommended()
      },
      "export-by-channel": function($event) {
        return _vm.exportRecommended($event)
      },
      "cleared": _vm.onRecommenderCleared
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    attrs: {
      "icon": _vm.fabsOpen ? 'fa-chevron-down' : 'fa-th-large',
      "label": _vm.fabsOpen ? 'Hide shortcuts' : 'Show shortcuts',
      "bottom": 32,
      "type": "info",
      "badge": _vm.fabsOpen ? 0 : _vm.shortcutAlerts,
      "tour-key": "fab-toggle"
    },
    on: {
      "open": _vm.toggleFabs
    }
  }), _vm._v(" "), _c('filter-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "bottom": 104,
      "active-count": _vm.activeFilterCount
    },
    on: {
      "open": _vm.openFilters
    }
  }), _vm._v(" "), (!_vm.hideHeader) ? [_c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-search",
      "label": "Find listeners",
      "tour-key": "fab-find",
      "bottom": 176
    },
    on: {
      "open": function($event) {
        _vm.showFind = true
      }
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-users",
      "label": "Audiences",
      "tour-key": "fab-audiences",
      "bottom": 248
    },
    on: {
      "open": function($event) {
        _vm.showAudiences = true
      }
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-bullseye",
      "label": "Advertiser hub",
      "tour-key": "fab-advertiser",
      "bottom": 320
    },
    on: {
      "open": function($event) {
        _vm.showAdvertiserHub = true
      }
    }
  }), _vm._v(" "), _c('find-listeners-modal', {
    attrs: {
      "visible": _vm.showFind,
      "total": _vm.listeners.totalMatches || 0,
      "loading-listeners": _vm.loadingListeners
    },
    on: {
      "close": function($event) {
        _vm.showFind = false
      },
      "search": _vm.findByTerm,
      "view": _vm.scrollToListeners,
      "apply-ai": _vm.applyAiSearch
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-paper-plane",
      "label": "Retarget bucket",
      "tour-key": "fab-bucket",
      "bottom": 392,
      "badge": _vm.bucketItems
    },
    on: {
      "open": _vm.openBucket
    }
  }), _vm._v(" "), _c('ai-usage-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "bottom": 464
    }
  }), _vm._v(" "), _c('advertiser-hub-modal', {
    attrs: {
      "visible": _vm.showAdvertiserHub,
      "filters": _vm.bulkEnrichFilters,
      "filter-labels": _vm.bulkEnrichFilterLabels
    },
    on: {
      "close": function($event) {
        _vm.showAdvertiserHub = false
      },
      "pick": _vm.handleHubPick,
      "open-filters": _vm.openFilters
    }
  }), _vm._v(" "), _c('audiences-modal', {
    attrs: {
      "visible": _vm.showAudiences
    },
    on: {
      "close": function($event) {
        _vm.showAudiences = false
      },
      "view-members": _vm.viewAudience,
      "retarget": _vm.retargetAudiences
    }
  }), _vm._v(" "), _c('retarget-bucket-modal', {
    attrs: {
      "visible": _vm.showBucket,
      "groups": _vm.bucket.groups,
      "total": _vm.bucket.total,
      "loading": _vm.bucketLoading
    },
    on: {
      "close": function($event) {
        _vm.showBucket = false
      },
      "changed": _vm.loadBucket,
      "export": function($event) {
        return _vm.startExport($event, true)
      }
    }
  }), _vm._v(" "), _c('export-fields-modal', {
    attrs: {
      "visible": !!_vm.pendingExport,
      "source-label": _vm.pendingExport ? _vm.pendingExport.label : '',
      "bucket": !!(_vm.pendingExport && _vm.pendingExport.bucket),
      "busy": _vm.exporting,
      "consent-total": _vm.exportCounts ? _vm.exportCounts.total : 0,
      "consent-without": _vm.exportCounts ? _vm.exportCounts.without_opt_in : 0,
      "consent-loading": _vm.exportCountsLoading
    },
    on: {
      "close": function($event) {
        _vm.pendingExport = null
      },
      "confirm": _vm.runExport
    }
  }), _vm._v(" "), _c('consent-check-modal', {
    attrs: {
      "visible": !!_vm.consent,
      "purpose": _vm.consent ? _vm.consent.purpose : 'retarget',
      "total": _vm.consent ? _vm.consent.total : 0,
      "without": _vm.consent ? _vm.consent.without : 0
    },
    on: {
      "close": function($event) {
        return _vm.answerConsent(null)
      },
      "confirm": function($event) {
        return _vm.answerConsent($event)
      }
    }
  }), _vm._v(" "), _c('bulk-enrich-modal', {
    attrs: {
      "visible": _vm.showBulkEnrich,
      "segment-counts": _vm.segmentCounts,
      "filters": _vm.bulkEnrichFilters,
      "filter-labels": _vm.bulkEnrichFilterLabels,
      "filter-total": _vm.listeners.totalMatches || 0
    },
    on: {
      "close": function($event) {
        _vm.showBulkEnrich = false
      },
      "finished": _vm.refreshListeners
    }
  })] : _vm._e(), _vm._v(" "), _c('segmentation-tour', {
    attrs: {
      "visible": _vm.tourOpen,
      "steps": _vm.tourSteps
    },
    on: {
      "step": _vm.onTourStep,
      "close": _vm.endTour
    }
  }), _vm._v(" "), (_vm.filtersMounted) ? _c('audience-filters', {
    attrs: {
      "visible": _vm.showFilters,
      "filters": _vm.localFilters,
      "options": _vm.filterOptions,
      "counts": _vm.scopedCounts,
      "segment-counts": _vm.segmentCounts,
      "missing-field-counts": _vm.completeness.missingFieldCounts || {}
    },
    on: {
      "close": function($event) {
        _vm.showFilters = false
      },
      "update": _vm.onFilterUpdate,
      "apply": _vm.applyFilters,
      "reset": _vm.resetFilters
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedListener) ? _c('listener-dialog', {
    attrs: {
      "listener": _vm.selectedListener,
      "visible": _vm.showDialog,
      "enriching": _vm.enriching,
      "enrich-credits-exhausted": _vm.enrichCreditsExhausted,
      "bucket-groups": _vm.bucket.groups,
      "retarget-default-label": _vm.listenerRetargetTarget.label,
      "retargeting": _vm.addingToBucket,
      "match-reason": _vm.dialogReason,
      "audience-name": _vm.matchSourceName
    },
    on: {
      "close": _vm.closeDialog,
      "view-profile": function($event) {
        return _vm.$emit('view-profile', $event)
      },
      "enrich": function($event) {
        return _vm.$emit('enrich', $event)
      },
      "find-similar": function($event) {
        return _vm.$emit('find-similar', $event)
      },
      "retarget": _vm.retargetListener,
      "apply-inferred": function($event) {
        return _vm.$emit('apply-inferred', $event)
      },
      "review-link": function($event) {
        return _vm.$emit('review-link', $event)
      },
      "replace-demographic": function($event) {
        return _vm.$emit('replace-demographic', $event)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notice) ? _c('el-alert', {
    staticClass: "ai-credits-banner",
    attrs: {
      "type": _vm.notice.type,
      "title": _vm.notice.title,
      "description": _vm.notice.text,
      "show-icon": ""
    },
    on: {
      "close": _vm.dismiss
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Instagram Insights")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.instagramPage),
      callback: function($$v) {
        _vm.instagramPage = $$v
      },
      expression: "instagramPage"
    }
  }, _vm._l((_vm.instagramPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "day"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "insights-container"
  }, [_c('loader', {
    attrs: {
      "message": "Loading Insights",
      "shadow": "none"
    }
  })], 1) : (_vm.hasData) ? _c('div', {
    staticClass: "insights-container"
  }, _vm._l((_vm.overviewData), function(value, key) {
    return _c('InsightsOverviewItem', {
      key: key,
      staticClass: "insight-item",
      attrs: {
        "data": value,
        "period": _vm.period
      },
      on: {
        "onNavigate": function($event) {
          return _vm.handleItemNavigate(key)
        }
      }
    })
  }), 1) : _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": _vm.instagramPage ? 'No data' : 'No page connected'
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 3207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.points,
      "gradient": ['#683090', '#c97eff'],
      "height": _vm.height,
      "auto-draw": _vm.autoDraw
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Add new choice template",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "templateForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.templateForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template name",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.templateForm.title),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "title", $$v)
      },
      expression: "templateForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.templateForm.description),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "description", $$v)
      },
      expression: "templateForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keywords",
      "prop": "keywords"
    }
  }, [_c('el-input-tag', {
    model: {
      value: (_vm.templateForm.keywords),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "keywords", $$v)
      },
      expression: "templateForm.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select category",
      "filterable": ""
    },
    model: {
      value: (_vm.templateForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "categoryId", $$v)
      },
      expression: "templateForm.categoryId"
    }
  }, _vm._l((_vm.choiceCategoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.handleAddCategory
    }
  })], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Staff options")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isGlobal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Is global choice template",
      "disabled": !isNaN(_vm.templateForm.id)
    },
    model: {
      value: (_vm.templateForm.isGlobal),
      callback: function($$v) {
        _vm.$set(_vm.templateForm, "isGlobal", $$v)
      },
      expression: "templateForm.isGlobal"
    }
  }), _vm._v(" "), (!isNaN(_vm.templateForm.id)) ? _c('help-text', [_vm._v("(Disabled: this can only be set on new choice templates)")]) : _vm._e(), _vm._v(" "), _c('help-text', [_vm._v("Should this choice template be available to all companies (green template)")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h4', [_vm._v("Choices")]), _vm._v(" "), _c('div', {
    staticClass: "choice-container"
  }, _vm._l((_vm.choiceTemplateDialogChoices), function(choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "choice",
      class: _vm.choiceTemplateDialogIsScale ? _vm.choiceScaleClass(choice) : 'unpolarized'
    }, [_c('span', {
      staticClass: "choice-title"
    }, [_vm._v(_vm._s(choice.title))])])
  }), 0)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.templateForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    staticClass: "insights-unit"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [(_vm.hasValidData) ? _c('el-popover', {
    attrs: {
      "width": "260",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle pull-right",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "",
      "popper-class": "text-format-wrap"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.dataByPeriod.description.replace("the business account's", "your account's") ))])]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "unit-title",
    on: {
      "click": _vm.handleTitleClick
    }
  }, [_vm._v(_vm._s(_vm.dataByPeriod.title))])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.hasValidData) ? _c('div', [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.dataByPeriod.value).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: {
      'text-success': _vm.dataByPeriod.difference > 0,
        'text-danger': _vm.dataByPeriod.difference < 0,
        'text-muted': _vm.dataByPeriod.difference === 0,
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dataByPeriod.difference > 0 ? '+' : '') + _vm._s(_vm.dataByPeriod.difference.toLocaleString()) + "\n        "), _c('el-tooltip', {
    attrs: {
      "content": ("compared to previous " + _vm.period),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.dataByPeriod.difference > 0,
        'fa-level-down': _vm.dataByPeriod.difference < 0,
        'fa-minus': _vm.dataByPeriod.difference === 0,
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.dataByPeriod.values,
      "gradient": ['#683090', '#c97eff'],
      "height": 60,
      "auto-draw": ""
    }
  })], 1)]) : _c('div', {
    staticClass: "no-data-placeholder"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("-")])])])])
},staticRenderFns: []}

/***/ }),
/* 3210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hook"
  }, [_c('div', {
    staticClass: "pull-left play"
  }, [(!_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-fw fa-play",
    on: {
      "click": _vm.handlePlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-fw fa-stop",
    on: {
      "click": _vm.handleStop
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.hook.title))]), _vm._v(" "), _c('div', {
    staticClass: "artist"
  }, [_vm._v(_vm._s(_vm.hook.artist))])]), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    staticClass: "duration pull-right"
  }, [_vm._v(_vm._s(_vm.duration))]) : _c('div', {
    staticClass: "duration time pull-right"
  }, [_vm._v(_vm._s(_vm.currentTime))])])
},staticRenderFns: []}

/***/ }),
/* 3211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "title": "Respondents",
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), (_vm.respondents.length > 0) ? _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.getTableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-lg-8 questions-group"
        }, _vm._l((props.row.answers.filter(function (a) { return !a.is_profile; })), function(answer) {
          return _c('div', {
            key: answer.answer_id,
            staticClass: "answer-row"
          }, [_c('div', {
            staticClass: "question-title"
          }, [_vm._v(_vm._s(answer.question_title))]), _vm._v(" "), _c('div', {
            staticClass: "question-answer"
          }, [(answer.input) ? _c('span', [_vm._v(_vm._s(answer.input))]) : (answer.choice_id) ? _c('span', [_vm._v(_vm._s(answer.choice_title))]) : (answer.choices_ids) ? _c('span', _vm._l((answer.choices_titles), function(title) {
            return _c('ul', {
              key: title
            }, [_c('li', [_vm._v(_vm._s(title))])])
          }), 0) : _vm._e()])])
        }), 0), _vm._v(" "), _c('div', {
          staticClass: "col-lg-4 answers-group"
        }, _vm._l((props.row.answers.filter(function (a) { return a.is_profile; })), function(answer) {
          return _c('div', {
            key: answer.answer_id,
            staticClass: "answer-row text-right"
          }, [_c('div', {
            staticClass: "question-title"
          }, [_vm._v(_vm._s(answer.question_title))]), _vm._v(" "), _c('div', {
            staticClass: "question-answer"
          }, [_vm._v("\n                  " + _vm._s(answer.input ? answer.input : answer.choice_title) + "\n                ")])])
        }), 0)])]
      }
    }], null, false, 2422165517)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "dateAnswered"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mobile",
      "prop": "mobileNumber"
    }
  })], 1)], 1) : (!_vm.loadingRespondents) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n    Not enough data has been gathered yet to display any respondents.\n  ")]) : _vm._e(), _vm._v(" "), (_vm.loadingRespondents) ? _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Loading...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.respondentPageInfo.pageNumber !== _vm.respondentPageInfo.totalPages) ? _c('el-button', {
    staticClass: "load-more",
    attrs: {
      "type": "info",
      "round": ""
    },
    on: {
      "click": _vm.handleLoadMore
    }
  }, [_vm._v("Load more...")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v("Shows the proportion of profiles active across two channels.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "Loading Cross Platform Engagement..."
    }
  }, [(_vm.engagements.length && !_vm.loading) ? _c('div', {
    staticClass: "cross-engagement-profiles"
  }, [_c('cross-profile-table', {
    staticStyle: {
      "margin": "8px 0"
    },
    attrs: {
      "profilesData": _vm.data
    }
  })], 1) : _c('div', {
    staticStyle: {
      "height": "525px"
    }
  }, [_c('small', {
    staticClass: "graph-empty"
  }, [_vm._v("No Data Loaded")])])])])])
},staticRenderFns: []}

/***/ }),
/* 3213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "choices",
      "item-name-plural": "choices",
      "item-name": "choice",
      "category-list": _vm.choiceCategoryList,
      "disabled-ids": _vm.selectorDisabledChoiceIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorChoiceSearchText,
      "selected-category-id": _vm.selectorSelectedChoiceCategory
    },
    on: {
      "onItemAdd": _vm.handleAddChoice,
      "onChangeCategory": _vm.handleSelectCategory,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.choiceList),
      callback: function($$v) {
        _vm.choiceList = $$v
      },
      expression: "choiceList"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "localRecipient",
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.localRecipient,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "Email Address"
    },
    on: {
      "clear": _vm.clearForm,
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "value"
        }, [_vm._v(_vm._s(item.email))])]
      }
    }]),
    model: {
      value: (_vm.localRecipient.email),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "email", $$v)
      },
      expression: "localRecipient.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "firstName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.localRecipient.firstName),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "firstName", $$v)
      },
      expression: "localRecipient.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Surname",
      "prop": "lastName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Surname"
    },
    model: {
      value: (_vm.localRecipient.lastName),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "lastName", $$v)
      },
      expression: "localRecipient.lastName"
    }
  })], 1), _vm._v(" "), (_vm.companies.length) ? _c('el-form-item', {
    attrs: {
      "label": "Company",
      "prop": "companyId",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "clearable": true,
      "filterable": true
    },
    model: {
      value: (_vm.localRecipient.companyId),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "companyId", $$v)
      },
      expression: "localRecipient.companyId"
    }
  }, _vm._l((_vm.companies), function(company) {
    return _c('el-option', {
      key: company.id,
      attrs: {
        "label": company.title,
        "value": parseInt(company.id)
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reports"
    }
  }, [_c('div', [_c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Campaign Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.campaignSummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "campaignSummary", $$v)
      },
      expression: "localRecipient.campaignSummary"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Survey Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.surveySummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "surveySummary", $$v)
      },
      expression: "localRecipient.surveySummary"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small",
      "label": "Programming Summary",
      "border": ""
    },
    model: {
      value: (_vm.localRecipient.programmingSummary),
      callback: function($$v) {
        _vm.$set(_vm.localRecipient, "programmingSummary", $$v)
      },
      expression: "localRecipient.programmingSummary"
    }
  })], 1)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingRecipient,
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiktok-options"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.settings,
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-avatar', {
    attrs: {
      "src": _vm.settings.creator_avatar_url,
      "size": "small"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "creator-label"
  }, [_vm._v("Posting as: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.settings.creator_nickname || _vm.settings.creator_username))])]], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Who can view this video"
    }
  }, [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select visibility...",
      "clearable": ""
    },
    model: {
      value: (_vm.settings.privacy_level),
      callback: function($$v) {
        _vm.$set(_vm.settings, "privacy_level", $$v)
      },
      expression: "settings.privacy_level"
    }
  }, _vm._l((_vm.privacyOptions), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)]], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Allow users to"
    }
  }, [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-switch', {
    attrs: {
      "active-text": "Comment"
    },
    model: {
      value: (_vm.settings.allow_comment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_comment", $$v)
      },
      expression: "settings.allow_comment"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "Duet"
    },
    model: {
      value: (_vm.settings.allow_duet),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_duet", $$v)
      },
      expression: "settings.allow_duet"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "Stitch"
    },
    model: {
      value: (_vm.settings.allow_stitch),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_stitch", $$v)
      },
      expression: "settings.allow_stitch"
    }
  })]], 2), _vm._v(" "), (!_vm.loading && _vm.settings.max_video_post_duration_sec) ? _c('el-alert', {
    staticClass: "max-duration-alert",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._v("\n      Max video post duration: " + _vm._s(_vm.formatDuration(_vm.settings.max_video_post_duration_sec)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tiktok-terms"
  }, [_vm._v("\n      By posting, you agree to TikTok's\n      "), _c('a', {
    attrs: {
      "href": "https://www.tiktok.com/legal/page/global/music-usage-confirmation/en",
      "target": "_blank"
    }
  }, [_vm._v("Music Usage Confirmation")]), _vm._v(".\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "optinDialog",
    attrs: {
      "id": "channel-details-dialog",
      "title": _vm.dialogTitle,
      "top": "30vh",
      "width": "50rem",
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "channel-details"
  }, [_c('label', {
    staticClass: "form-label text-primary",
    attrs: {
      "for": "channelName"
    }
  }, [_vm._v("Channel Name:")]), _vm._v(" "), _c('div', {
    staticClass: "channel-item"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "type": _vm.channel.channel
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.channel.channel))])], 1), _vm._v(" "), _c('div', [_c('p', [_c('strong', [_vm._v("Opt In:")]), _c('i', {
    class: _vm.getIconClass(_vm.channel.opt_in)
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Opt Out:")]), _vm._v(" "), _c('i', {
    class: _vm.getIconClass(_vm.channel.opt_out)
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Permission to Process:")]), _vm._v(" "), _c('i', {
    class: _vm.getIconClass(_vm.channel.permission)
  })])]), _vm._v(" "), (_vm.channel.date_opted_in) ? _c('p', {
    staticClass: "date-opted-in"
  }, [_c('strong', [_vm._v("Date Opted In:")]), _vm._v(" " + _vm._s(_vm.formatDateOptedIn(_vm.channel.date_opted_in)) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 3217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "profileForm",
    staticClass: "profile-form",
    attrs: {
      "model": _vm.profileForm,
      "label-width": "190px",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isProfileComplete) ? _c('div', [_c('empty', [_vm._v("Profile Complete: All important sections of this profile are successfully completed!")])], 1) : _c('div', [_c('p', {
    staticClass: "info-text"
  }, [_vm._v("Add more information to this profile")])]), _vm._v(" "), (_vm.showContactInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" Contact Information\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('email_address')) ? _c('el-form-item', {
    attrs: {
      "label": "Email",
      "error": _vm.emailError
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.validateEmail,
      "input": function($event) {
        return _vm.sanitizeInput('email_address')
      }
    },
    model: {
      value: (_vm.profileForm.email_address),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "email_address", $$v)
      },
      expression: "profileForm.email_address"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('mobile_number')) ? _c('el-form-item', {
    attrs: {
      "label": "Mobile Number"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.profileForm.mobile_number = _vm.profileForm.mobile_number.replace(/[^0-9]/g, '');
      },
      "blur": function($event) {
        return _vm.handleInput('mobile_number')
      }
    },
    model: {
      value: (_vm.profileForm.mobile_number),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "mobile_number", $$v)
      },
      expression: "profileForm.mobile_number"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPersonalInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "user"
    }
  }), _vm._v(" Personal Information\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('name')) ? _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.handleInput('name')
      },
      "input": function($event) {
        return _vm.sanitizeInput('name')
      }
    },
    model: {
      value: (_vm.profileForm.name),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "name", $$v)
      },
      expression: "profileForm.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('gender')) ? _c('el-form-item', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Gender"
    },
    model: {
      value: (_vm.profileForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "gender", $$v)
      },
      expression: "profileForm.gender"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Male",
      "value": "Male"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Female",
      "value": "Female"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Other",
      "value": "Other"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('age_range')) ? _c('el-form-item', {
    attrs: {
      "label": "Age"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Age"
    },
    model: {
      value: (_vm.profileForm.age_range),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "age_range", $$v)
      },
      expression: "profileForm.age_range"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Under 18",
      "value": "Under 18"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "18-24",
      "value": "18-24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "25-34",
      "value": "25-34"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "35-49",
      "value": "35-49"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "50-64",
      "value": "50-64"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "65+",
      "value": "65+"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('id_number')) ? _c('el-form-item', {
    attrs: {
      "label": "ID Number"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        return _vm.sanitizeInput('id_number')
      },
      "blur": function($event) {
        return _vm.handleInput('id_number')
      }
    },
    model: {
      value: (_vm.profileForm.id_number),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "id_number", $$v)
      },
      expression: "profileForm.id_number"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('location')) ? _c('el-form-item', {
    attrs: {
      "label": "Location"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.handleInput('location')
      },
      "input": function($event) {
        return _vm.sanitizeInput('location')
      }
    },
    model: {
      value: (_vm.profileForm.location),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "location", $$v)
      },
      expression: "profileForm.location"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showSocialInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "link"
    }
  }), _vm._v(" Social Media\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('twitter_handle')) ? _c('el-form-item', {
    attrs: {
      "label": "Twitter"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "@twitter_handle"
    },
    on: {
      "blur": function($event) {
        return _vm.handleAtSymbol('twitter_handle')
      },
      "input": function($event) {
        return _vm.sanitizeInput('twitter_handle')
      }
    },
    model: {
      value: (_vm.profileForm.twitter_handle),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "twitter_handle", $$v)
      },
      expression: "profileForm.twitter_handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('instagram_handle')) ? _c('el-form-item', {
    attrs: {
      "label": "Instagram"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "@instagram_handle"
    },
    on: {
      "blur": function($event) {
        return _vm.handleAtSymbol('instagram_handle')
      },
      "input": function($event) {
        return _vm.sanitizeInput('instagram_handle')
      }
    },
    model: {
      value: (_vm.profileForm.instagram_handle),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "instagram_handle", $$v)
      },
      expression: "profileForm.instagram_handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('facebook_profile')) ? _c('el-form-item', {
    attrs: {
      "label": "Facebook"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Facebook username"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInput('facebook_profile')
      },
      "input": function($event) {
        return _vm.sanitizeInput('facebook_profile')
      }
    },
    model: {
      value: (_vm.profileForm.facebook_profile),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "facebook_profile", $$v)
      },
      expression: "profileForm.facebook_profile"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h3', [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Channels Optins and Permission\n      ")]), _vm._v(" "), _vm._l((_vm.initialOptins), function(option, index) {
    return _c('el-form-item', {
      key: index,
      staticClass: "optin-permission",
      attrs: {
        "label": option.channel
      }
    }, [(!_vm.isOriginatorValid) ? _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": "Mobile number is required for opt-in."
      }
    }, [_c('el-switch', {
      attrs: {
        "disabled": !_vm.isOriginatorValid
      },
      on: {
        "change": function (value) { return _vm.handleUpdateOptin(value, option); }
      },
      model: {
        value: (option.opt_in),
        callback: function($$v) {
          _vm.$set(option, "opt_in", $$v)
        },
        expression: "option.opt_in"
      }
    })], 1) : _c('el-switch', {
      attrs: {
        "disabled": !_vm.isOriginatorValid
      },
      on: {
        "change": function (value) { return _vm.handleUpdateOptin(value, option); }
      },
      model: {
        value: (option.opt_in),
        callback: function($$v) {
          _vm.$set(option, "opt_in", $$v)
        },
        expression: "option.opt_in"
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (!_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.savingProfile,
      "disabled": _vm.isFormEmpty && !_vm.detectChanges(),
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Got It")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('company-details', {
    attrs: {
      "company": _vm.myCompany,
      "groups": _vm.groups,
      "loading": _vm.$apollo.queries.myCompany.loading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('plugins-list', {
    attrs: {
      "plugins": _vm.plugins,
      "loading": _vm.loadingPlugins
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('generate-u-r-l', {
    attrs: {
      "companyUsers": _vm.companyUsers,
      "activeCampaigns": _vm.activeCampaigns,
      "generatedUrl": _vm.generatedUrl,
      "generateUrlSuccess": _vm.generateUrlSuccess,
      "loadingGenerateUrl": _vm.loadingGenerateUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.hasPermissionPlugin) ? _c('generate-permission-u-r-l') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('user-list', {
    staticClass: "user-list",
    attrs: {
      "users": _vm.companyUsers,
      "groups": _vm.groups
    }
  }), _vm._v(" "), _c('timeslot-list', {
    attrs: {
      "timeslots": _vm.timeslots
    }
  }), _vm._v(" "), _c('blacklist-originator-list', {
    attrs: {
      "blacklistedOriginators": _vm.blacklistedOriginators
    }
  }), _vm._v(" "), _c('email-recipient-list', {
    staticClass: "recipient-list",
    attrs: {
      "me": _vm.me,
      "campaigns": _vm.campaigns,
      "companies": _vm.myCompanies,
      "surveys": _vm.surveys,
      "recipients": _vm.recipients,
      "users": _vm.emailUsers,
      "loading": _vm.$apollo.queries.recipients.loading
    },
    on: {
      "deleted": _vm.refetchRecipients,
      "saved": _vm.refetchRecipients
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 3219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    ref: "picker",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "To",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "Start Date",
      "end-placeholder": "End Date",
      "picker-options": _vm.pickerOptions,
      "format": "dd-MM-yyyy HH:mm:ss"
    },
    on: {
      "input": _vm.handleChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heatmap-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "cal-heatmap"
    }
  })])
}]}

/***/ }),
/* 3221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "programming-dashboard-unit-loader"
  }, [_c('content-loader', {
    attrs: {
      "height": 189,
      "width": 530,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "191.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "19.61",
      "rx": "0",
      "ry": "0",
      "width": "207.44",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "39.71",
      "rx": "0",
      "ry": "0",
      "width": "172.87",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "72.26",
      "rx": "0",
      "ry": "0",
      "width": "138.29",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "92.36",
      "rx": "0",
      "ry": "0",
      "width": "103.72",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "123.5",
      "rx": "0",
      "ry": "0",
      "width": "34.57",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "142.19",
      "rx": "0",
      "ry": "0",
      "width": "25.93",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "170.33",
      "rx": "0",
      "ry": "0",
      "width": "12.97",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "284.5",
      "y": "188.81",
      "rx": "0",
      "ry": "0",
      "width": "8.64",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "191.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "81.56",
      "y": "24.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "68.63",
      "y": "19.61",
      "rx": "0",
      "ry": "0",
      "width": "207.44",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "102.55",
      "y": "39.71",
      "rx": "0",
      "ry": "0",
      "width": "172.87",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "137.25",
      "y": "72.26",
      "rx": "0",
      "ry": "0",
      "width": "138.29",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "171.94",
      "y": "92.36",
      "rx": "0",
      "ry": "0",
      "width": "103.72",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "241.32",
      "y": "142.52",
      "rx": "0",
      "ry": "0",
      "width": "34.57",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "249.8",
      "y": "122.5",
      "rx": "0",
      "ry": "0",
      "width": "25.93",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "263.68",
      "y": "168.97",
      "rx": "0",
      "ry": "0",
      "width": "12.97",
      "height": "16.97"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "261.42",
      "y": "188.13",
      "rx": "0",
      "ry": "0",
      "width": "14.95",
      "height": "16.97"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 3222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Save Filter",
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("Please provide a meaningful title by which this filter will be identified.")]), _vm._v(" "), _c('el-form', {
    ref: "saveForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Privacy")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "All respondents",
      "placement": "left"
    }
  }, [_c('span', {
    staticClass: "pull-right text-muted text-right count"
  }, [_c('em', [_vm._v("n")]), _vm._v(" = " + _vm._s(_vm.respondents) + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Statistics for opt-ins / permission to process / age data.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content privacy-list-content"
  }, [_c('div', {
    staticClass: "pull-right total-display"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.selectedTotalDisplay),
      callback: function($$v) {
        _vm.selectedTotalDisplay = $$v
      },
      expression: "selectedTotalDisplay"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "percentage"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("Total")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getOptins,
      "fit": true,
      "empty-text": 'No Privacy Data',
      "max-height": "400",
      "row-key": "type",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Type",
      "class-name": 'client-link'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.type) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Yes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.totalDisplay(scope.row.count.yes)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "No"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.totalDisplay(scope.row.count.no)) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools el-download-btn"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.getPrivacyTypes
    }
  }, [_vm._v("\n        Export\n      ")])], 1)]), _vm._v(" "), (_vm.downloadPrivacyVisible) ? _c('privacy-report-dialog', {
    attrs: {
      "privacy": _vm.getOptins,
      "isVisible": _vm.downloadPrivacyVisible
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadPrivacyVisibilityChanged
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.collapsible) ? _c('div', {
    staticClass: "text-center dropdown-block",
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.collapsed) ? _c('span', [_c('i', {
    staticClass: "el-icon-caret-top"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle"
    }
  }, [_vm._v("Hide related interaction")])]) : _c('span', [_c('i', {
    staticClass: "el-icon-caret-bottom"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle"
    }
  }, [_vm._v("View related interaction")])])]) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsible || _vm.collapsed),
      expression: "!collapsible || collapsed"
    }],
    staticClass: "feed-element"
  }, [_c('div', {
    staticClass: "interaction-avatar pull-left"
  }, [(_vm.interaction.ore.profile_image) ? _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.interaction.ore.profile_image[0].value
    },
    on: {
      "error": function($event) {
        return _vm.imageLoadOnError()
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-user-circle fa-3x"
  }), _vm._v(" "), _c('div', {
    staticClass: "interaction-type img-circle",
    class: _vm.interaction.type
  }, [_c('i', {
    staticClass: "fa fa-sm",
    class: _vm.iconClasses[_vm.interaction.type]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('small', {
    staticClass: "text-muted pull-right interaction-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.interaction.date_created, 'HH:MM Do MMM YYYY ')))]), _vm._v(" "), _c('div', {
    staticClass: "interaction-originator"
  }, [_vm._v(_vm._s(_vm.interaction.ore.originators[0].value))]), _vm._v(" "), (_vm.mediaExists) ? _c('div', {
    staticClass: "interaction-media"
  }, [(_vm.interaction.ore.image) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'image')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.video) ? _c('video', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'video'),
      "controls": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.interaction.ore.audio) ? _c('audio', {
    attrs: {
      "src": _vm.getMediaValue(_vm.interaction, 'audio'),
      "controls": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "interaction-message"
  }, [_vm._v(_vm._s(_vm.interaction.ore.message[0].value))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.selectorActive),
      callback: function($$v) {
        _vm.selectorActive = $$v
      },
      expression: "selectorActive"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "hooks"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Hooks")])]), _vm._v(" "), _c('hook-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "music-questions"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Music Questions")])]), _vm._v(" "), _c('music-question-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-table"
  }, [_c('table', [_c('thead', [_c('th', {
    staticClass: "col-xs-7"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Show")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.show) + "%")])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 3227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics-chart"
  }, [(_vm.type === 'area') ? _c('analytics-area-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'bar') ? _c('analytics-bar-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'doughnut') ? _c('analytics-doughnut-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'pie') ? _c('analytics-pie-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'polar-area') ? _c('analytics-polar-area-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-image"
  }, [_c('img', {
    staticClass: "blured-image",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.alt
    }
  })]), _vm._v(" "), (_vm.showContactSales) ? _c('div', {
    staticClass: "bg-text"
  }, [_c('contact-sales')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    attrs: {
      "results": _vm.searchProfile,
      "searching": this.$apollo.queries.searchProfile.loading,
      "loading-profile": _vm.loadingProfile
    },
    on: {
      "search-profile": _vm.handleSearchQuery,
      "display-profile": _vm.handleDisplayProfile
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('selector', {
    attrs: {
      "draggable-group": "music-questions",
      "item-name-plural": "music questions",
      "item-name": "music question",
      "can-add": true,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorMatrixChoiceSearchText,
      "show-category-filter": false
    },
    on: {
      "onItemEdit": _vm.handleEditItem,
      "onCreate": _vm.handleCreate,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.musicQuestions),
      callback: function($$v) {
        _vm.musicQuestions = $$v
      },
      expression: "musicQuestions"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ("col-sm-" + (_vm.getColumn()) + " items-col")
  }, [_c('draggable', {
    attrs: {
      "group": "hooks",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedHooks),
      callback: function($$v) {
        _vm.computedHooks = $$v
      },
      expression: "computedHooks"
    }
  }, [_vm._l((_vm.computedHooks), function(question) {
    return _c('div', {
      key: question.id,
      staticClass: "hook-item draggable"
    }, [_c('hook-media', {
      attrs: {
        "hook": question.mediaClip
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "options pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveHook(question.id)
        }
      }
    })])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container hook-placeholder-container"
  }, [_vm._v("Drag hook")])])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "65px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.computedIsRandomized),
      callback: function($$v) {
        _vm.computedIsRandomized = $$v
      },
      expression: "computedIsRandomized"
    }
  }, [_vm._v("Present in random order")])], 1)], 1), _vm._v(" "), (_vm.computedHooks.length) ? _c('div', {
    staticClass: "col-sm-8 items-col"
  }, [_c('draggable', {
    attrs: {
      "group": "music-questions",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedMatrixChoices),
      callback: function($$v) {
        _vm.computedMatrixChoices = $$v
      },
      expression: "computedMatrixChoices"
    }
  }, [_vm._l((_vm.computedMatrixChoices), function(matrixChoice) {
    return _c('div', {
      key: matrixChoice.title,
      staticClass: "question-item draggable"
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(matrixChoice.title))]), _vm._v(" "), _vm._l((matrixChoice.choices), function(choice) {
      return _c('div', {
        key: choice.id,
        staticClass: "choice"
      }, [_vm._v(_vm._s(choice.title))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "options pull-right"
    }, [(_vm.computedMatrixChoices.length > 1) ? _c('span', [_c('el-tooltip', {
      attrs: {
        "content": "Conditional"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-link",
      class: {
        'has-conditional': _vm.isConditional(matrixChoice)
      },
      on: {
        "click": function($event) {
          return _vm.handleSetConditional(matrixChoice)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "tool-divider"
    })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveMatrixChoice(matrixChoice.id)
        }
      }
    })])], 1)])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container media-question-placeholder-container"
  }, [_vm._v("Drag media question")])])], 2)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 3232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.chartLabel))]), _vm._v(" "), _c('doughnut-chart', {
    staticClass: "chart",
    attrs: {
      "data": _vm.chartData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "data": _vm.contentThreads,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Topic"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "content-threads-topic-name",
          style: ({
            'color': _vm.generateTitleColor(scope.row.name)
          })
        }, [_vm._v(_vm._s(scope.row.name) + "\n      ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'h:00 a'),
      "unit": 'Hour',
      "unitClass": 'label-success',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'hour',
      "received": _vm.chartsData['hour-stats'].total,
      "growth": _vm.chartsData['hour-stats'].growth,
      "stats": _vm.chartsData['hour-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'hour'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'hour'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'hour'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['hour-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'day'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'month'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['month-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Received',
      "selected": _vm.selectedPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'year'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total vs unique")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['unique-stats']['total-vs-unique'].length)) ? _c('analytics-chart', {
    attrs: {
      "type": "bar",
      "chartStyle": "max-height: 200px;",
      "barPercentage": 0.9,
      "categoryPercentage": 1,
      "scalesEnabled": false,
      "data": _vm.chartsData['unique-stats']['total-vs-unique'].filter(function (s) { return s[0] !== 'x'; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['unique-stats']['total-vs-unique'].length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total by campaign")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.chartsData['campaign-stats']['points'].length > 1) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px;",
      "data": _vm.chartsData['campaign-stats']['points'].map(function (s) { return [s.campaign, s.total]; })
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartsData['campaign-stats']['points'].length <= 1) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Total by channel type")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.processChannelStats.length) ? _c('analytics-chart', {
    attrs: {
      "type": "polar-area",
      "chartStyle": "max-height: 200px;",
      "data": _vm.processChannelStats
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.processChannelStats.length) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'PolarChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 235
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Heat map")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean([_vm.chartsData['heat-map-stats'].points].length)) ? _c('analytics-heat-map', {
    attrs: {
      "data": _vm.chartsData['heat-map-stats'].points,
      "range": _vm.chartsData['heat-map-stats'].range
    },
    on: {
      "onChangeDate": function($event) {
        return _vm.$emit('changeDate', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(Object.keys(_vm.chartsData['heat-map-stats'].points).length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsHeatMapLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "450"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Chart")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filters pull-right"
  }, [_c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'timeslot'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'timeslot'
        })
      }
    }
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'channel'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'channel'
        })
      }
    }
  }, [_vm._v("Channels")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedFilter === 'campaign'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'campaign'
        })
      }
    }
  }, [_vm._v("Campaigns")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.mainChartData.stats.points.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.mainChartData.stats.points,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedPeriod) - 1],
      "showLegend": false
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.mainChartData.stats.points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'EngagementGraphLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Insights")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "day"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "insights-container"
  }, [_c('loader', {
    attrs: {
      "message": "Loading Insights",
      "shadow": "none"
    }
  })], 1) : (_vm.hasData) ? _c('div', {
    staticClass: "insights-container"
  }, _vm._l((_vm.overviewData), function(value, key) {
    return _c('InsightsOverviewItem', {
      key: key,
      staticClass: "insight-item",
      attrs: {
        "data": value,
        "period": _vm.period
      },
      on: {
        "onNavigate": function($event) {
          return _vm.handleItemNavigate(key)
        }
      }
    })
  }), 1) : _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": _vm.facebookPage ? 'No data' : 'No page connected'
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insight-item"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [_c('el-popover', {
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('h5', {
    staticClass: "unit-title",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(Math.round(_vm.value).toLocaleString()))])])
},staticRenderFns: []}

/***/ }),
/* 3237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('channels', {
    staticClass: "match-height",
    attrs: {
      "channels": _vm.channels,
      "activeChannelTab": _vm.activeChannelTab
    },
    on: {
      "onChangeTab": function($event) {
        return _vm.onChangeTab($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('channel-create', {
    staticClass: "match-height"
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading email templates"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.templates && !_vm.templates.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, _vm._l((_vm.templates), function(template) {
    return _c('template-card', {
      key: template.id,
      attrs: {
        "id": parseInt(template.id, 10),
        "name": template.name,
        "subject": template.subject,
        "type": template.type,
        "content": template.content
      },
      on: {
        "onEdit": function($event) {
          return _vm.handleOnEdit($event, template)
        }
      }
    })
  }), 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row profile-dashboard-wrapper border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('h2', [_vm._v("Automated Email Templates")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No email templates found.")])])
}]}

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "password-reset-component"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.hasSucceeded) ? _c('el-alert', {
    attrs: {
      "title": "Success",
      "type": "success",
      "description": "Your request to reset your password has been received, please check your mailbox for details."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasFailed) ? _c('el-alert', {
    attrs: {
      "title": "Password Reset Failed",
      "type": "error",
      "description": "We couldn't reset your password. Please contact COLONY LIVE support for further assistance."
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "passwordResetForm",
    staticClass: "password-reset-form",
    attrs: {
      "model": _vm.passwordResetForm,
      "rules": _vm.passwordResetFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Email"
    },
    model: {
      value: (_vm.passwordResetForm.email),
      callback: function($$v) {
        _vm.$set(_vm.passwordResetForm, "email", $$v)
      },
      expression: "passwordResetForm.email"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "password-reset-btn",
      "type": "primary",
      "loading": _vm.isPending
    },
    on: {
      "click": _vm.onClickResetPassword
    }
  }, [_vm._v("\n        Reset Password\n      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Already have an account?")])], 1)], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-message"
  }, [_c('h4', [_vm._v("Password Recovery")]), _vm._v(" "), _c('p', [_vm._v("\n        Sorry to hear you forgot your password. "), _c('br'), _vm._v("Please provide the email address for the account you wish to reset.\n      ")])])
}]}

/***/ }),
/* 3240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "filters-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "el-row el-align-middle el-justify-space-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filters")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text",
      "size": "small",
      "icon": "el-icon-refresh-left"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("\n      Clear All\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Quick Filters")]), _vm._v(" "), _vm._l((_vm.quickFilters), function(filter) {
    return _c('el-button', {
      key: filter.label,
      staticStyle: {
        "margin": "4px 4px 4px 0",
        "min-width": "100px",
        "text-align": "center"
      },
      attrs: {
        "type": filter.active ? 'primary' : '',
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilters(filter)
        }
      }
    }, [_c('i', {
      class: filter.icon
    }), _vm._v(" " + _vm._s(filter.label) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Minimum Score")]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "texts": ['Poor', 'Fair', 'Average', 'Good', 'Excellent'],
      "show-text": ""
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.minScore),
      callback: function($$v) {
        _vm.$set(_vm.filters, "minScore", $$v)
      },
      expression: "filters.minScore"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Tone / Emotion")]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.selectedTones),
      callback: function($$v) {
        _vm.$set(_vm.filters, "selectedTones", $$v)
      },
      expression: "filters.selectedTones"
    }
  }, _vm._l((_vm.toneOptions), function(tone) {
    return _c('el-checkbox', {
      key: tone.value,
      staticClass: "d-block mb-1",
      attrs: {
        "label": tone.label
      }
    }, [_vm._v("\n        " + _vm._s(_vm.capitalize(tone.label)) + "\n      ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Tags")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select tags"
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.selectedTags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "selectedTags", $$v)
      },
      expression: "filters.selectedTags"
    }
  }, _vm._l((_vm.tagOptions), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Max Length (seconds)")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "max": 120,
      "step": 5,
      "show-stops": ""
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.maxLength),
      callback: function($$v) {
        _vm.$set(_vm.filters, "maxLength", $$v)
      },
      expression: "filters.maxLength"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-1"
  }, [_vm._v(_vm._s(_vm.filters.maxLength) + "s")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4 pt-3 border-top"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-fw fa-star"
  }), _vm._v(" Trending Topics")]), _vm._v(" "), _c('div', {
    staticClass: "cloud-wrapper"
  }, [_c('cloud', {
    attrs: {
      "data": _vm.wordCloudData,
      "fontSizeMapper": _vm.fontSizeMapper,
      "padding": 3,
      "width": "250",
      "height": "150"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v(_vm._s(_vm.parseProviderName(_vm.providerName)))])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, _vm._l((_vm.contactLists), function(list) {
    return _c('div', {
      key: list.id
    }, [_c('el-card', {
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('strong', [_c('el-link', {
      attrs: {
        "underline": false
      },
      on: {
        "click": function($event) {
          return _vm.$emit('onContactListClick', _vm.id, _vm.providerName, list)
        }
      }
    }, [_vm._v("\n              " + _vm._s(list.name) + "\n            ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('span', [_vm._v("Contact Count: " + _vm._s(list.contact_count))])])])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 3242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "choices",
      "item-name-plural": "choice templates",
      "item-name": "choice template",
      "category-list": _vm.choiceCategoryList,
      "disabled-ids": _vm.selectorDisabledTemplateIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorTemplateSearchText,
      "selected-category-id": _vm.selectorSelectedTemplateCategory,
      "selected-id": _vm.selectorSelectedTemplateId
    },
    on: {
      "onItemAdd": _vm.handleAddTemplate,
      "onItemEdit": _vm.handleEditTemplate,
      "onChangeCategory": _vm.handleSelectCategory,
      "onLoadMore": _vm.handleLoadMore,
      "onSelect": _vm.handleSelectTemplate,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.choiceTemplates),
      callback: function($$v) {
        _vm.choiceTemplates = $$v
      },
      expression: "choiceTemplates"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channels"
  }, [_c('div', {
    staticClass: "channel",
    class: {
      selected: _vm.selectedTopic === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.handleSelectTopic('all')
      }
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "room",
    class: {
      unread: _vm.allUnread > 0
    }
  }, [_vm._v("all")])]), _vm._v(" "), _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      key: tag.name,
      staticClass: "channel",
      class: {
        selected: _vm.selectedTopic === tag.topic
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectTopic(tag.topic)
        }
      }
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("#")]), _vm._v(" "), _c('span', {
      staticClass: "room",
      class: {
        unread: tag.count > 0
      }
    }, [_vm._v(_vm._s(tag.name))])])
  }), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "channel",
      class: {
        selected: _vm.selectedTopic === user.topic,
          present: _vm.presentUserIds.includes(user.id),
          unpresent: !_vm.presentUserIds.includes(user.id),
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectTopic(user.topic)
        }
      }
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("@")]), _vm._v(" "), _c('span', {
      staticClass: "room",
      class: {
        unread: user.count > 0
      }
    }, [_vm._v("\n      " + _vm._s(user.first_name) + " " + _vm._s(user.last_name) + "\n    ")])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox float-e-margins"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "ibox-content clearfix"
  }, _vm._l((_vm.channelTypeConfig), function(cfg) {
    return _c('span', {
      key: cfg.title,
      on: {
        "click": function($event) {
          return _vm.connectChannel(cfg.method || cfg.title)
        }
      }
    }, [(_vm.showChannelIcon(cfg.alwaysShow)) ? _c('div', {
      staticClass: "channel-add-item"
    }, [_c('span', {
      staticClass: "fa fa-fw fa-3x channel-logo",
      class: cfg.icon,
      style: (("color: " + (cfg.color)))
    }), _vm._v(" "), _c('span', {
      staticClass: "channel-title"
    }, [_vm._v(_vm._s(cfg.title))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('facebook-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showFacebookCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleFacebookVisibilityChange
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleInstagramVisibilityChange
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleEmailDialogVisibilityChange
    }
  }), _vm._v(" "), _c('wechat-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWechatCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWechatDialogVisibilityChange
    }
  }), _vm._v(" "), _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsAppWebCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWhatsappWebDialogVisibilityChange
    }
  }), _vm._v(" "), _c('telegram-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showTelegramCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleTelegramDialogVisibilityChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Add Channel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_c('p', [_vm._v("\n      A channel is simply a mechanism by which we can get your interactions into the system be it by email,\n      Facebook, WhatsApp, SMS... etc.\n    ")]), _vm._v(" "), _c('p', [_vm._v("Once we get the interaction, that's when the real magic happens! Choose a provider below to connect a new channel.")])])
}]}

/***/ }),
/* 3245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Blacklisted Originators")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Blacklist Originator",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Listeners who's messages we'd like to ban from showing on our interaction panels.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content blacklist-list-content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.blacklistedOriginators,
      "fit": true,
      "default-sort": {
        prop: 'title'
      },
      "row-key": "id",
      "max-height": "400",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "originator",
      "label": "Originator",
      "width": "200",
      "class-name": "client-link"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.editBlacklistedOriginator(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.originator))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "date_created",
      "label": "Date Added",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.date_created, "Do MMM YYYY")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom"
          },
          on: {
            "command": _vm.handleAction
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                Actions\n                "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.editBlacklistedOriginator,
              item: scope.row
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.deleteBlacklistedOriginator,
              item: scope.row
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": this.isNewBlacklistOriginator ? 'Blacklist Originator' : 'Edit Blacklisted Originator',
      "visible": _vm.showEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditDialog = $event
      }
    }
  }, [(_vm.showEditDialog) ? _c('blacklist-originator-edit', {
    attrs: {
      "originator": _vm.selectedBlacklistedOriginator
    },
    on: {
      "cancel": function($event) {
        _vm.showEditDialog = false
      },
      "save": _vm.updateBlacklist
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateDialog) ? _c('blacklist-originator-create', {
    on: {
      "cancel": function($event) {
        _vm.showCreateDialog = false
      },
      "save": _vm.addBlacklistOriginator
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Blacklist Originator',
      "visible": _vm.showCreateDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateDialog = $event
      }
    }
  }, [(_vm.showCreateDialog) ? _c('blacklist-originator-create', {
    on: {
      "cancel": function($event) {
        _vm.showCreateDialog = false
      },
      "save": _vm.addBlacklistOriginator
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-mobile"
  })
},staticRenderFns: []}

/***/ }),
/* 3247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCollapsed) ? _c('scale-editor-collapsed', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable,
      "isReverseOrder": _vm.value.isChoiceOrderReversed
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  }) : _c('scale-editor-expanded', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable,
      "isReverseOrder": _vm.value.isChoiceOrderReversed
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse,
      "onReverseOrder": _vm.handleReverseOrder
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleInteractionFiltersChange
    },
    model: {
      value: (_vm.selectedChannelFilterList),
      callback: function($$v) {
        _vm.selectedChannelFilterList = $$v
      },
      expression: "selectedChannelFilterList"
    }
  }, _vm._l((_vm.getChannelsList()), function(channel, i) {
    return _c('el-checkbox', {
      key: i,
      attrs: {
        "label": _vm.getChannelName(channel)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": _vm.emptyText,
      "fixed": "",
      "stripe": "",
      "data": _vm.campaigns,
      "height": "350"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "Name",
      "width": _vm.selectorTable ? 420 : 320
    }
  }), _vm._v(" "), (!_vm.selectorTable) ? _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.cleanType(scope.row.type)) + "\n      ")]
      }
    }], null, false, 3451053561)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "Start Date",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.cleanDate(scope.row.startDate)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.formatNumber(scope.row.uniques)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), (_vm.selectorTable) ? _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.selected),
            callback: function($$v) {
              _vm.$set(scope.row, "selected", $$v)
            },
            expression: "scope.row.selected"
          }
        })]
      }
    }], null, false, 1264612)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "width": 300,
      "height": _vm.calculatedHeight,
      "speed": "2",
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "8",
      "y": "18",
      "rx": "2",
      "ry": "2",
      "width": "143",
      "height": "184"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "165",
      "y": "105",
      "rx": "2",
      "ry": "2",
      "width": "143",
      "height": "96"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "questionForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.questionForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.questionForm.title),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "title", $$v)
      },
      expression: "questionForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Category",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select category",
      "filterable": ""
    },
    model: {
      value: (_vm.questionForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "categoryId", $$v)
      },
      expression: "questionForm.categoryId"
    }
  }, _vm._l((_vm.questionCategoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.handleAddCategory
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Question type",
      "prop": "questionType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select type"
    },
    on: {
      "change": _vm.handleQuestionTypeChange
    },
    model: {
      value: (_vm.questionForm.questionType),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "questionType", $$v)
      },
      expression: "questionForm.questionType"
    }
  }, _vm._l((_vm.questionTypeList), function(type) {
    return _c('el-option', {
      key: type.value,
      attrs: {
        "label": type.title,
        "value": type.value
      }
    })
  }), 1)], 1), _vm._v(" "), (['SCALE', 'SELECT', 'MULTI_SELECT'].includes(_vm.questionForm.questionType)) ? _c('el-form-item', {
    attrs: {
      "label": "Chart type",
      "prop": "chart"
    }
  }, [_c('div', [_c('el-radio', {
    attrs: {
      "label": "PIE"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Pie")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "DONUT"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Donut")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "VERTICAL_BAR"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Vertical bar")])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "HORIZONTAL_BAR"
    },
    model: {
      value: (_vm.questionForm.chart),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "chart", $$v)
      },
      expression: "questionForm.chart"
    }
  }, [_vm._v("Horizontal bar")])], 1), _vm._v(" "), _c('help-text', [_vm._v("Which kind of chart would best display the results of this question?")])], 1) : _vm._e(), _vm._v(" "), (_vm.questionForm.questionType === 'SCALE') ? _c('el-form-item', {
    attrs: {
      "label": "Insight",
      "prop": "insight"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.questionForm.insight),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "insight", $$v)
      },
      expression: "questionForm.insight"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        This is for providing a story on one sheets, Available variable substitutions are\n        {positive_percentage} {positive_cume} {positive_total}.\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isRequired"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Required"
    },
    model: {
      value: (_vm.questionForm.isRequired),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isRequired", $$v)
      },
      expression: "questionForm.isRequired"
    }
  })], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isProfile"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Store as audience profile information"
    },
    model: {
      value: (_vm.questionForm.isProfile),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isProfile", $$v)
      },
      expression: "questionForm.isProfile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionForm.isProfile),
      expression: "questionForm.isProfile"
    }],
    attrs: {
      "label": "Profile field",
      "prop": "profileField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select profile field",
      "filterable": ""
    },
    model: {
      value: (_vm.questionForm.profileField),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "profileField", $$v)
      },
      expression: "questionForm.profileField"
    }
  }, _vm._l((_vm.questionProfileFieldList), function(field) {
    return _c('el-option', {
      key: field.value,
      attrs: {
        "label": field.label,
        "value": field.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Staff options")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "isGlobal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Is global question",
      "disabled": _vm.questionDialogAddToCanvas || _vm.questionForm.id
    },
    model: {
      value: (_vm.questionForm.isGlobal),
      callback: function($$v) {
        _vm.$set(_vm.questionForm, "isGlobal", $$v)
      },
      expression: "questionForm.isGlobal"
    }
  }), _vm._v(" "), (_vm.questionDialogAddToCanvas) ? _c('help-text', [_vm._v("\n          (Disabled: Use the\n          "), _c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" button on the question selector to add this question,\n          if you need global)\n        ")]) : _vm._e(), _vm._v(" "), (_vm.questionForm.id) ? _c('help-text', [_vm._v("(Disabled: this can only be set on new questions)")]) : _vm._e(), _vm._v(" "), _c('help-text', [_vm._v("Should this question be available to all companies (green question)")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.questionsCreating
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.questionForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-list"
  }, [_c('el-row', {
    staticClass: "mb-2",
    staticStyle: {
      "border-bottom": "1px solid #ebeef5",
      "padding-bottom": "6px"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Recent Activities")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [(_vm.activities.length > 0) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.removeAllActivity(_vm.activities)
      }
    }
  }, [_vm._v("\n        Clear All\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activities.length === 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "empty-message"
  }, [_c('el-icon', {
    staticClass: "el-icon-info",
    attrs: {
      "size": 30
    }
  }), _vm._v(" "), _c('p', [_vm._v("No activities found")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtext",
    staticStyle: {
      "color": "#c0c4cc",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Your activities will appear here once added\n        ")])], 1)])], 1) : _c('div', {
    staticClass: "scroll-container"
  }, _vm._l((_vm.activities), function(row, index) {
    return _c('div', {
      key: row.id || index,
      staticClass: "activity-item"
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "align": "middle"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(row.title))]), _vm._v(" "), (row.error) ? _c('el-tooltip', {
      attrs: {
        "content": row.error
      }
    }, [_c('i', {
      staticClass: "el-icon-warning",
      staticStyle: {
        "color": "#ff4d4f",
        "cursor": "pointer"
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticClass: "text-right activity-meta text-muted",
      attrs: {
        "span": 8
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatRelativeTime(row.date_created || row.timestamp)))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      style: ({
        cursor: 'pointer',
        color: _vm.hoverDelete ? '#ff4d4f' : 'inherit'
      }),
      on: {
        "mouseover": function($event) {
          _vm.hoverDelete = true
        },
        "mouseleave": function($event) {
          _vm.hoverDelete = false
        },
        "click": function($event) {
          return _vm.removeActivity(row)
        }
      }
    })])], 1)], 1), _vm._v(" "), (row.activity_type === 1) ? _c('el-progress', {
      staticClass: "mt-1",
      attrs: {
        "percentage": _vm.calculatePercentage(row),
        "status": _vm.getProgressStatus(row),
        "show-text": ""
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 3253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Company Selector")]), _vm._v(" "), _c('el-input', {
    ref: "search",
    attrs: {
      "placeholder": "Search...",
      "prefix-icon": "el-icon-search",
      "autofocus": true
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', _vm._l((_vm.filteredItems), function(company) {
    return _c('tr', {
      key: company.id,
      on: {
        "click": function($event) {
          return _vm.switchCompany(company)
        }
      }
    }, [_c('td', [_c('a', [_vm._v(_vm._s(company.title))])])])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "selected": _vm.selected
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "arrow arrow-left",
    on: {
      "click": _vm.onClickPrevious
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-right",
    on: {
      "click": _vm.onClickNext
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "label pull-right",
    class: _vm.unitClass
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.period))])])]), _vm._v(" "), (_vm.processStats.length) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.received).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: {
      'text-success': _vm.growth > 0,
        'text-danger': _vm.growth < 0,
        'text-muted': _vm.growth === 0,
    }
  }, [_vm._v("\n      " + _vm._s(Math.round(_vm.growth)) + "%\n      "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.growth > 0,
        'fa-level-down': _vm.growth < 0,
        'fa-minus': _vm.growth === 0,
    }
  })]), _vm._v(" "), (_vm.showBreakdown) ? _c('div', {
    staticClass: "voice-breakdown"
  }, [(_vm.approved !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--approved"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.approved) + " approved\n      ")]) : _vm._e(), _vm._v(" "), (_vm.flagged !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--flagged"
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" " + _vm._s(_vm.flagged) + " flagged\n      ")]) : _vm._e(), _vm._v(" "), (_vm.pending !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--pending"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.pending) + " pending\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processStats,
      "gradient": _vm.gradient,
      "height": 40,
      "auto-draw": "",
      "smooth": ""
    }
  })], 1)]) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content-loader", [_c('div', {
    staticClass: "voice-skeleton"
  }, [_c('div', {
    staticClass: "skeleton-count"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-line skeleton-line--short"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-line skeleton-line--long"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-chart"
  })])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 3255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-input-tag input-tag-wrapper",
    class: [_vm.size ? 'el-input-tag--' + _vm.size : ''],
    on: {
      "click": _vm.foucusTagInput
    }
  }, [_vm._l((_vm.innerTags), function(tag, idx) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "size": _vm.size,
        "closable": !_vm.readOnly,
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.remove(idx)
        }
      }
    }, [_vm._v("\n    " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    staticClass: "tag-input",
    attrs: {
      "size": _vm.size
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        $event.stopPropagation();
        return _vm.removeLastTag($event)
      }, _vm.addNew],
      "blur": _vm.addNew,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._b({
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Random Selections"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, 'el-dialog', _vm.randomSelections, false), [(_vm.loadingRandomSelections) ? _c('div', {
    staticClass: "loader"
  }, [_c('loader', {
    attrs: {
      "message": "Loading random selections"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingRandomSelections && _vm.randomSelections.length === 0) ? _c('empty', [_c('p', {
    staticClass: "description"
  }, [_vm._v("There are No winner selections at the moment")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.randomSelections), function(randomSelection) {
    return (!_vm.loadingRandomSelections) ? _c('el-card', {
      key: randomSelection.id,
      staticClass: "box-card",
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formateDate(randomSelection.from_date)) + " - " + _vm._s(_vm.formateDate(randomSelection.to_date)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6"
    }, [_c('dl', {
      staticClass: "dl-horizontal"
    }, [_c('dt', [_vm._v("Created by:")]), _vm._v(" "), _c('dd', [_c('span', {
      staticClass: "word-wrap"
    }, [_vm._v(_vm._s(randomSelection.created_by_name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6"
    }, [_c('dl', {
      staticClass: "dl-horizontal"
    }, [_c('dt', [_vm._v("Winners:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(randomSelection.winners))])]), _vm._v(" "), _c('dt', [_vm._v("Status:")]), _vm._v(" "), _c('dd', [(randomSelection.status_display === 'Complete') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Complete")]) : _vm._e(), _vm._v(" "), (randomSelection.status_display === 'New') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("New")]) : _vm._e(), _vm._v(" "), (randomSelection.status_display === 'Processing') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Processing")]) : _vm._e()])])]), _vm._v(" "), (randomSelection.selections.length > 0) ? _c('div', {
      staticClass: "col-lg-12"
    }, [_c('el-collapse', {
      attrs: {
        "accordion": ""
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": "showSelections"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('a', [_vm._v(_vm._s(_vm.collapeseTite))])]), _vm._v(" "), _c('el-table', {
      attrs: {
        "data": randomSelection.selections
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "label": "#",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Originator",
        "sortable": "",
        "prop": "originator"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Date won",
        "sortable": "",
        "prop": "originator"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.won_date))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Action"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "primary",
              "disabled": _vm.isDisqualified(scope.row.won_date),
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.onSelectWinner(scope.row)
              }
            }
          }, [_c('i', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.settingRandomSelectionWinner && scope.row === _vm.selectedWinner),
              expression: "settingRandomSelectionWinner && scope.row === selectedWinner"
            }],
            staticClass: "fa fa-spinner fa-spin"
          }), _vm._v("\n                    Win\n                  ")])]
        }
      }], null, true)
    })], 1)], 2)], 1)], 1) : _vm._e()])]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transcript-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "transcript"
  }, [_vm._v("\n    " + _vm._s(_vm.getTranscript()) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transcript-header"
  }, [_c('h3', [_vm._v("Audio Transcript")])])
}]}

/***/ }),
/* 3258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-bar-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "overflow-y": "scroll",
      "height": "430px",
      "padding": "0 8px"
    },
    attrs: {
      "element-loading-background": "#F7F8FC"
    }
  }, [_c('el-card', [_c('el-table', {
    attrs: {
      "id": "optin-table",
      "striped": "false",
      "data": _vm.optins
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150px",
      "label": "Channels",
      "prop": "channel"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.showChannelOptin(scope.row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.channel) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Opt-in",
      "prop": "optin"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.opt_in) ? _c('i', {
          staticClass: "fa fa-check"
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Opt-out",
      "prop": "optout"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.opt_out) ? _c('i', {
          staticClass: "fa fa-check"
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Permission",
      "prop": "permission"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.permission) ? _c('i', {
          staticClass: "fa fa-check"
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.getDateOptedIn()) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Date Opted In:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDateOptedIn()))])]) : _vm._e()], 1), _vm._v(" "), (_vm.channelData) ? _c('channel-optin-dialog', {
    attrs: {
      "channel": _vm.channelData,
      "visible": _vm.showChannelOptinCard
    },
    on: {
      "close": _vm.handleCloseCard
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-board-preview-survey-form"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.previewSize),
      callback: function($$v) {
        _vm.previewSize = $$v
      },
      expression: "previewSize"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1300"
    }
  }, [_vm._v("Desktop")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1000"
    }
  }, [_vm._v("Tablet")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "412"
    }
  }, [_vm._v("Mobile")])], 1)], 1), _vm._v(" "), (!_vm.survey.isPreview) ? _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    Published Link:\n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.publishedUrl
    }
  }, [_vm._v(_vm._s(_vm.publishedUrl))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    External Preview Link:\n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.previewUrl
    }
  }, [_vm._v(_vm._s(_vm.previewUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('iframe', {
    ref: "previewFrame",
    attrs: {
      "src": _vm.previewUrl,
      "width": _vm.previewSize,
      "height": "600",
      "frameborder": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.survey.isPreview,
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handlePublish
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" " + _vm._s(_vm.publishedTitle()) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw",
    class: _vm.logoClass
  })
},staticRenderFns: []}

/***/ }),
/* 3262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Add new question category",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.categoryForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.categoryForm.title),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "title", $$v)
      },
      expression: "categoryForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.categoryForm.description),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "description", $$v)
      },
      expression: "categoryForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rules-list', {
    attrs: {
      "rules": _vm.rules
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question",
    class: {
      selected: _vm.isSelected, odd: _vm.isOdd, static: _vm.isStatic, editable: _vm.isEditable
    }
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.handleSelect
    }
  }, [_c('div', {
    staticClass: "question-title"
  }, [(!_vm.isStatic) ? _c('span', {
    staticClass: "order-indicator"
  }, [_vm._v("\n        " + _vm._s(_vm.index + 1) + ".\n        "), (_vm.value.visibilityCondition) ? _c('span', {
    staticClass: "conditional"
  }, [_vm._v("?")]) : _vm._e()]) : _c('span', {
    staticClass: "order-indicator"
  }, [_vm._v("1.")]), _vm._v("\n      " + _vm._s(_vm.value.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "question-type"
  }, [_vm._v(_vm._s(_vm.friendlyQuestionType))]), _vm._v(" "), (!_vm.isStatic) ? _c('div', {
    staticClass: "controls"
  }, [(_vm.isEditable) ? _c('span', [_c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Conditional"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-link",
    class: {
      'has-conditional': _vm.isConditional(_vm.value)
    },
    on: {
      "click": function($event) {
        return _vm.handleSetConditional(_vm.value)
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "tool-divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Edit"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil",
    on: {
      "click": _vm.handleEdit
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash",
    on: {
      "click": _vm.handleRemove
    }
  })])], 1), _vm._v(" "), (_vm.isEditableQuestion) ? _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isEditableQuestion) ? _c('span', {
    staticClass: "collapse-toggler option"
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: _vm.isCollapsed ? 'fa-angle-down' : 'fa-angle-up',
    on: {
      "click": _vm.handleToggleCollapse
    }
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isEditableQuestion) ? _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.editors), function(editor, index) {
    return _c('div', {
      key: index
    }, [(editor.condition(_vm.value)) ? _c(editor.component, {
      tag: "component",
      attrs: {
        "isCollapsed": _vm.isCollapsed,
        "isEditable": _vm.isEditable
      },
      on: {
        "onToggleCollapse": _vm.handleToggleCollapse
      },
      model: {
        value: (_vm.computedValue),
        callback: function($$v) {
          _vm.computedValue = $$v
        },
        expression: "computedValue"
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.editingCampaign ? 'Edit Campaign' : 'Create new campaign',
      "visible": _vm.dialogVisible,
      "top": "5vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.showCampaignForm) ? _c('campaign-form', {
    attrs: {
      "channels": _vm.channelList,
      "selectedChannels": _vm.selectedChannels,
      "loading": _vm.mutationLoading,
      "campaignToEdit": _vm.campaignData,
      "isEditing": _vm.editingCampaign,
      "plugins": _vm.plugins
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged,
      "onRequestTwitterAuth": _vm.handleRequestTwitterAuth,
      "onRequestFacebookAuth": _vm.handleRequestFacebookAuth,
      "onRequestInstagramAuth": _vm.handleRequestInstagramAuth,
      "onRequestEmailChannelCreate": _vm.handleRequestEmailChannelCreate,
      "onRequestWhatsappChannelCreate": _vm.handleRequestWhatsappChannelCreate,
      "onFormCancel": _vm.handleFormCancel,
      "onFormSave": _vm.handleFormSave
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showCampaignForm) ? _c('div', [_c('loader', {
    attrs: {
      "message": "Loading campaign detail"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('facebook-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showFacebookCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleFacebookVisibilityChange
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleEmailDialogVisibilityChange
    }
  }), _vm._v(" "), _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsappCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWhatsappDialogVisibilityChange
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onInstagramChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleInstagramVisibilityChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tooltip', {
    attrs: {
      "content": "Add Rule",
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "fa fa-plus",
    attrs: {
      "id": "addCampaignBtn",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createRuleDialogVisible = true
      }
    }
  })], 1), _vm._v(" "), _c('rule-create', {
    attrs: {
      "visible": _vm.createRuleDialogVisible,
      "campaign": _vm.campaign
    },
    on: {
      "close": function($event) {
        _vm.createRuleDialogVisible = false
      }
    }
  }), _vm._v(" "), _c('rule-edit', {
    attrs: {
      "rule": _vm.currentRule,
      "loading": _vm.loadingRule,
      "saving": _vm.updatingRule,
      "visible": _vm.editRuleDialogVisible,
      "campaign": _vm.campaign
    },
    on: {
      "close": function($event) {
        _vm.editRuleDialogVisible = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ibox float-e-margins"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRules),
      expression: "loadingRules"
    }],
    ref: "rulesTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.rules,
      "empty-text": "No rules configured"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Rule",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Channel Rules")])])
}]}

/***/ }),
/* 3267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "New Telegram channel",
      "visible": _vm.showDialog,
      "before-close": _vm.handleClose,
      "center": true,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-telegram"
  }), _vm._v(" Telegram channel")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [_c('el-steps', {
    staticClass: "telegramSteps",
    attrs: {
      "active": _vm.activeStep,
      "align-center": "",
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Request Code"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Sign in"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Finished"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "center",
    attrs: {
      "span": 24
    }
  }, [(_vm.activeStep == 0) ? _c('p', [_vm._v("Please choose your country and enter your phone number.")]) : _vm._e(), _vm._v(" "), (_vm.activeStep == 1) ? _c('p', [_vm._v(" The login code has been sent to "), _c('strong', [_vm._v(" " + _vm._s(_vm.fullPhoneNumber))]), _vm._v(". "), _c('br'), _c('br'), _vm._v("Please enter your code below or click "), _c('a', {
    on: {
      "click": _vm.onClickChangeNumber
    }
  }, [_vm._v(" here")]), _vm._v(" to change your number.")]) : _vm._e(), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.codeRequestHasFailed || _vm.validationError) ? _c('el-alert', {
    staticClass: "alert",
    attrs: {
      "title": "Code request failed",
      "type": "error",
      "closable": false
    }
  }, [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.codeRequestHasFailed || _vm.validationError) ? _c('br') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.activeStep == 0) ? _c('el-form', {
    ref: "telegramChannelForm",
    attrs: {
      "model": _vm.telegramChannelForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "countryCode"
    }
  }, [_c('country-code-selector', {
    staticClass: "country-selector",
    attrs: {
      "selectedCountry": _vm.selectedCountry.code,
      "browserCountryCode": _vm.userCountryCode
    },
    on: {
      "onCountryChanged": _vm.handleCountryChanged
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone number"
    },
    model: {
      value: (_vm.telegramChannelForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "phoneNumber", $$v)
      },
      expression: "telegramChannelForm.phoneNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n                " + _vm._s(_vm.selectedCountry.flag) + "\n                " + _vm._s(_vm.selectedCountry.dial_code) + "\n              ")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account status"
    }
  }, [_c('P', [_vm._v("Do you have a Telegram account?")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.existingAccount),
      callback: function($$v) {
        _vm.existingAccount = $$v
      },
      expression: "existingAccount"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Yes"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "No"
    }
  })], 1)], 1), _vm._v(" "), (_vm.existingAccount == 'No') ? _c('div', [_c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20,
      "offset": 2
    }
  }, [_c('small', [_c('p', {
    staticClass: "center"
  }, [_vm._v("Telegram requires you to add a This is what other users will see when they view your contact on Telegram,\n                    this is required by Telegram, we suggest using your station name instead.")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "First name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ACME"
    },
    model: {
      value: (_vm.telegramChannelForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "firstName", $$v)
      },
      expression: "telegramChannelForm.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Last name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "FM"
    },
    model: {
      value: (_vm.telegramChannelForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "lastName", $$v)
      },
      expression: "telegramChannelForm.lastName"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activeStep == 1) ? _c('el-form', {
    attrs: {
      "model": _vm.telegramChannelForm,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.telegramSignInError) ? _c('el-alert', {
    attrs: {
      "title": "Sign In Failed",
      "type": "error",
      "description": "The code you entered is invalid or has expired. Please try again or request a new code."
    }
  }) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter code here",
      "clearable": ""
    },
    model: {
      value: (_vm.telegramChannelForm.telegramCode),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "telegramCode", $$v)
      },
      expression: "telegramChannelForm.telegramCode"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramCodeRequest),
      expression: "loadingTelegramCodeRequest"
    }],
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.onClickRequestCode
    },
    slot: "append"
  }, [_vm._v("Resend code")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.activeStep == 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramCodeRequest),
      expression: "loadingTelegramCodeRequest"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickRequestCode
    }
  }, [_vm._v("Request code")]) : _vm._e(), _vm._v(" "), (_vm.activeStep == 1) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramSignIn),
      expression: "loadingTelegramSignIn"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickSignIn
    }
  }, [_vm._v("Sign in")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('permission-section-card', {
    attrs: {
      "fixedHeight": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(" Profiles Filter")])]), _vm._v(" "), _c('div', [_c('identifier-filter', {
    ref: "identifier",
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "loading": _vm.loadingProfile
    },
    on: {
      "search-profile": function($event) {
        return _vm.$emit('search-profile', $event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n    Utilize the search functionality to identify the target profile\n  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(!_vm.displayProfile) ? _c('permission-profile-browser', {
    attrs: {
      "profiles": _vm.results.profiles,
      "filtered-total": _vm.results.filteredTotal,
      "loadingProfile": _vm.loadingProfile
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-grid"
  }, [_c('div', {
    staticClass: "image-container",
    style: (_vm.styles)
  }, [_vm._l((_vm.images), function(image, index) {
    return (index < 4) ? _c('img', {
      key: image,
      ref: "images",
      refInFor: true,
      staticClass: "image",
      class: _vm.imageClass,
      attrs: {
        "src": image
      },
      on: {
        "click": function($event) {
          return _vm.imageSelected(index)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.remainingImages() > 0) ? _c('div', {
    class: ("excess-" + _vm.imageOrientation),
    on: {
      "click": function($event) {
        return _vm.showGallery(3)
      }
    }
  }, [_c('p', [_vm._v("+" + _vm._s(_vm.remainingImages()))])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 3270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Create Email Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    ref: "emailChannelForm",
    attrs: {
      "model": _vm.emailChannelForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "rules": _vm.emailInputRules
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.emailChannelForm.email),
      callback: function($$v) {
        _vm.$set(_vm.emailChannelForm, "email", $$v)
      },
      expression: "emailChannelForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addingEmailChannel,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.addingEmailChannel) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Scheduled Social Post Calendar")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('full-calendar', {
    ref: "fullCalendar",
    attrs: {
      "defaultView": "dayGridMonth",
      "plugins": _vm.calendarPlugins,
      "header": {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      "events": _vm.calendarEvents,
      "droppable": true,
      "editable": true,
      "nowIndicator": true,
      "eventRender": _vm.handleEventRender,
      "timeZone": 'local'
    },
    on: {
      "eventClick": _vm.handleEventClick,
      "dateClick": _vm.handleDateClick,
      "eventDrop": _vm.handleEventDrop
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "55%",
      "title": "Bulk Approve for On-Air",
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "bulk-summary"
  }, [_c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.notes.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Voice notes selected")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.alreadyApproved.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Already on-air")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-stat"
  }, [_c('span', {
    staticClass: "summary-number"
  }, [_vm._v(_vm._s(_vm.toApprove.length))]), _vm._v(" "), _c('span', {
    staticClass: "summary-label"
  }, [_vm._v("Will be approved")])])]), _vm._v(" "), (_vm.alreadyApproved.length > 0) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "type": "warning",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.alreadyApproved.length) + " voice note" + _vm._s(_vm.alreadyApproved.length !== 1 ? 's are' : ' is') + "\n      already on-air and will be skipped.\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notes-list"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      key: note.id,
      staticClass: "note-item",
      class: {
        'note-item--approved': note.approved
      }
    }, [_c('div', {
      staticClass: "note-item-left"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" "), _c('span', {
      staticClass: "note-sender"
    }, [_vm._v(_vm._s(note.sender))]), _vm._v(" "), _c('span', {
      staticClass: "note-time"
    }, [_vm._v(_vm._s(_vm.formatDate(note.timestamp)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-item-right"
    }, [(note.approved) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "success",
        "effect": "dark"
      }
    }, [_c('i', {
      staticClass: "fa fa-podcast"
    }), _vm._v(" Already On Air\n        ")]) : (note.flagged) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "danger",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "fa fa-flag"
    }), _vm._v(" Flagged\n        ")]) : _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    }), _vm._v(" Ready to Approve\n        ")])], 1)])
  }), 0), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approving As"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvedBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send On-Air To"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select on-air user"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    }, [_c('span', [_vm._v(_vm._s(user.display_name))]), _vm._v(" "), (user.id === _vm.me.id) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#67c23a",
        "font-size": "12px"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" You\n          ")]) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date of Approval"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvalDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Batch Comment (applies to all)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Add a reason or comment for this batch approval...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading,
      "disabled": _vm.toApprove.length === 0
    },
    on: {
      "click": _vm.handleApprove
    }
  }, [_vm._v("\n      Approve " + _vm._s(_vm.toApprove.length) + " Voice Note" + _vm._s(_vm.toApprove.length !== 1 ? 's' : '') + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-horizontal-bar-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader",
    style: ({
      color: _vm.color,
      textShadow: _vm.shadow
    })
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }), _vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 3275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row border-bottom"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top gray-bg",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary",
    on: {
      "click": _vm.onCollapseMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('form', {
    staticClass: "navbar-form-custom",
    attrs: {
      "role": "search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search interactions...",
      "name": "top-search",
      "id": "top-search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-top-links navbar-right"
  }, [_c('li', [_c('span', {
    staticClass: "m-r-sm text-muted welcome-message"
  }, [(!_vm.me.is_staff && !_vm.me.is_admin && !_vm.me.is_org_admin) ? _c('span', [_vm._v(_vm._s(_vm.me.company_name))]) : _vm._e(), _vm._v(" "), (_vm.me.is_staff || _vm.me.is_admin || _vm.me.is_org_admin) ? _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.selectCompanyDialogVisible = !_vm.selectCompanyDialogVisible
      }
    }
  }, [_vm._v(_vm._s(_vm.me.company_name))])]) : _vm._e()]), _vm._v(" "), (_vm.me.is_streaming) ? _c('span', {
    class: ("label label-" + (_vm.getStreamingStats().streamingClass))
  }, [_vm._v("\n              Streaming: " + _vm._s(_vm.getStreamingStats().now) + "\n              "), (_vm.getStreamingStats().growth !== 0) ? _c('i', {
    class: ("fa fa-level-" + (_vm.getStreamingStats().growthClass))
  }, [_vm._v(_vm._s(_vm.getStreamingStats().growth))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Knowledge Base",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleKnowledgeBaseClick
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "New Social Post",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleNewSocialPost
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Support"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.handleHelpClick
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "header-item"
  }, [_c('el-dropdown', {
    attrs: {
      "hide-on-click": false,
      "trigger": "hover",
      "placement": "bottom"
    }
  }, [_c('el-badge', {
    staticClass: "activity-badge",
    attrs: {
      "value": _vm.activities.length
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "plain": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "id": "item"
    }
  }, [_c('activities-list', {
    attrs: {
      "activities": _vm.activities
    },
    on: {
      "deleteActivity": _vm.deleteActivity
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "spacing"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover",
      "placement": "bottom",
      "show-timeout": 100
    },
    on: {
      "command": _vm.handleDropdownCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.user.avatar || _vm.user.gravatar,
      "width": "32px",
      "size": 32
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    ref: 'userdropdown',
    attrs: {
      "slot": "dropdown",
      "id": "user-dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "editProfileDialogVisible"
    }
  }, [_c('span', {
    staticClass: "fa fa-user"
  }), _vm._v(" Edit Profile\n                ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "restPasswordDialogVisible"
    }
  }, [_c('span', {
    staticClass: "fa fa-key"
  }), _vm._v("Change Password\n                ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "onLogout",
      "divided": true
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("Log out\n                ")])], 1)], 1)], 1)])])]), _vm._v(" "), (_vm.dashboardHeaderEnabled) ? _c('div', {
    staticClass: "row wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dashboardTitle))]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumbs), function(breadcrumb) {
    return _c('li', {
      key: breadcrumb
    }, [_vm._v(_vm._s(breadcrumb))])
  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.restPasswordDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "Change Password",
      "visible": _vm.restPasswordDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.restPasswordDialogVisible = $event
      }
    }
  }, [_c('PasswordOnlyResetForm', {
    attrs: {
      "requireOldPassword": true
    },
    on: {
      "togglePasswordDialog": _vm.handleToggleDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Profile",
      "visible": _vm.editProfileDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.editProfileDialogVisible = $event
      }
    }
  }, [_c('edit-profile-form', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Select Company",
      "visible": _vm.selectCompanyDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectCompanyDialogVisible = $event
      }
    }
  }, [_c('company-selector', {
    attrs: {
      "companies": _vm.companies
    },
    on: {
      "onSwitchCompany": function($event) {
        return _vm.onSwitchCompany($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.length === 0) ? _c('div', {
    staticClass: "empty-container"
  }, [_c('div', {
    on: {
      "click": _vm.handleToggleCollapse
    }
  }, [_vm._v("Expand to add choices for this question")])]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "draggable": ".draggable"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleCollapse($event)
      }
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, _vm._l((_vm.computedValue), function(choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "choice",
      class: {
        draggable: _vm.isEditable
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(choice.title))])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 3277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.showCategoryFilter) ? _c('el-col', {
    attrs: {
      "span": _vm.showTextFilter ? 10 : 20
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Category",
      "size": "mini"
    },
    model: {
      value: (_vm.computedCategory),
      callback: function($$v) {
        _vm.computedCategory = $$v
      },
      expression: "computedCategory"
    }
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showTextFilter) ? _c('el-col', {
    attrs: {
      "span": _vm.showCategoryFilter ? 10 : 20
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Search",
      "prefix-icon": "el-icon-search",
      "size": "mini"
    },
    model: {
      value: (_vm.computedSearchText),
      callback: function($$v) {
        _vm.computedSearchText = $$v
      },
      expression: "computedSearchText"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.canAdd) ? _c('el-tooltip', {
    attrs: {
      "content": ("Add new " + _vm.itemName)
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle filter-btn filter-add",
    on: {
      "click": _vm.handleCreate
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Clear filters"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle filter-btn filter-clear",
    on: {
      "click": _vm.handleResetFilters
    }
  })])], 1)])], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('draggable', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.handleLoadMore),
      expression: "handleLoadMore"
    }],
    staticClass: "draggable-group",
    class: {
      'draggable-fixed': _vm.isFixed
    },
    attrs: {
      "draggable": ".draggable",
      "body-style": {
        padding: '0'
      },
      "group": {
        name: _vm.draggableGroup,
        pull: 'clone',
        put: false
      },
      "id": _vm.draggableId,
      "sort": false
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, [_vm._l((_vm.computedValue), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        draggable: !_vm.isDisabled(item.id) && _vm.isEditable,
          enabled: !_vm.isDisabled(item.id),
          disabled: _vm.isDisabled(item.id),
      }
    }, [_c('el-card', {
      key: item.id,
      class: {
        selected: item.id === _vm.selectedId, 'is-global': item.isGlobal || false
      },
      staticStyle: {
        "margin": "4px 0"
      },
      attrs: {
        "shadow": "never",
        "body-style": _vm.itemStyle(item.id)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelect(item)
        },
        "dblclick": function($event) {
          return _vm.handleAddItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "handle pull-right"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ellipsis-v"
    })]), _vm._v(" "), (item.isEditable || false) ? _c('div', {
      staticClass: "options pull-right"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.handleEditItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])], 1)
  }), _vm._v(" "), (_vm.computedValue.length === 0) ? _c('empty', [_vm._v("No " + _vm._s(_vm.itemNamePlural) + " found.")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px",
      "model": _vm.blacklistedOriginator
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Originator"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Originator"
    },
    model: {
      value: (_vm.blacklistedOriginator.originator),
      callback: function($$v) {
        _vm.$set(_vm.blacklistedOriginator, "originator", $$v)
      },
      expression: "blacklistedOriginator.originator"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.saving,
      "plain": ""
    },
    on: {
      "click": _vm.blacklistOriginator
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "tiktok-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 17",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.3146 4.97107C13.4001 4.97107 12.5562 4.66813 11.8787 4.15702C11.1016 3.57107 10.5432 2.71169 10.3461 1.72111C10.297 1.47631 10.2709 1.22369 10.2682 0.964844H7.65577V8.10333L7.65257 12.0134C7.65257 13.0587 6.97186 13.9451 6.02821 14.2568C5.75444 14.3472 5.45861 14.3901 5.15053 14.3732C4.75746 14.3517 4.3891 14.2329 4.06893 14.0415C3.3875 13.634 2.92564 12.8946 2.91301 12.0489C2.89328 10.7272 3.9619 9.64964 5.28261 9.64964C5.54341 9.64964 5.79373 9.69213 6.02821 9.76947V7.81853V7.1172C5.78093 7.08058 5.52937 7.06155 5.27479 7.06155C3.8291 7.06155 2.4771 7.66244 1.51053 8.74511C0.780037 9.56324 0.341815 10.607 0.274259 11.7016C0.185726 13.1394 0.71177 14.5062 1.73221 15.5147C1.88208 15.6628 2.03959 15.8002 2.20421 15.927C3.07906 16.5999 4.14857 16.9648 5.27497 16.9648C5.52937 16.9648 5.7811 16.946 6.02839 16.9094C7.08066 16.7535 8.0515 16.2719 8.81773 15.5144C9.75924 14.5839 10.2794 13.3485 10.2849 12.0336L10.2714 6.19471C10.7205 6.5412 11.2117 6.82795 11.7386 7.05035C12.5583 7.39613 13.4275 7.57142 14.3219 7.57124V5.67435V4.97053C14.3226 4.97107 14.3151 4.97107 14.3146 4.97107Z"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-panel-container",
    class: {
      'fixed-container': _vm.isFixedPanel, 'profile-container': _vm.type === 'profile'
    }
  }, [_c('div', {
    staticClass: "ibox message-panel",
    class: [{
      fixed: _vm.isFixedPanel
    }, _vm.getColumnLayoutClass]
  }, [_c('div', {
    staticClass: "ibox-title",
    style: ({
      'border-top': ("2px solid " + _vm.panelColor)
    })
  }, [(!_vm.isFixedPanel) ? _c('div', {
    staticClass: "drag-indicator"
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  })]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.isLocked) ? _c('span', {
    staticClass: "locked"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasNewMessages && _vm.lastScrollPosition > 0) ? _c('el-tooltip', {
    attrs: {
      "content": "New Message(s)"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.isLocked
    },
    on: {
      "click": _vm.scrollNewMessages
    }
  }, [_c('el-badge', {
    staticClass: "new-message",
    attrs: {
      "is-dot": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.scrolling && !_vm.isLocked) ? _c('el-tooltip', {
    attrs: {
      "content": "Scroll to top",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.scrollToTop
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocked && _vm.type !== 'onair' && _vm.type !== 'twittertrends' && _vm.hasSearch) ? _c('el-tooltip', {
    attrs: {
      "content": ("" + (_vm.showPanelSearch ? 'Close Search' : 'Search Panel')),
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": _vm.getSearchBtnIcon('search')
    },
    on: {
      "click": _vm.toggleSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocked && _vm.type !== 'onair' && _vm.type !== 'twittertrends' && _vm.hasSearch) ? _c('el-tooltip', {
    attrs: {
      "content": ("" + (_vm.showMediaSearch ? 'Close Media Search' : 'Search by Media')),
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": _vm.getSearchBtnIcon('media')
    },
    on: {
      "click": _vm.toggleMediaSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSettings) ? _c('el-tooltip', {
    attrs: {
      "content": "Panel settings",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('showSettings')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showClose && !_vm.settings.instant_poll && _vm.panelLocker === 'auto') ? _c('el-tooltip', {
    attrs: {
      "content": "Close panel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closePanel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanelSearch),
      expression: "showPanelSearch"
    }],
    staticClass: "panel-search"
  }, [_c('el-input', {
    staticStyle: {
      "margin": "5px auto"
    },
    attrs: {
      "placeholder": "Search",
      "size": "mini"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchPanelInteractions($event)
      }
    },
    model: {
      value: (_vm.searchCriteria),
      callback: function($$v) {
        _vm.searchCriteria = $$v
      },
      expression: "searchCriteria"
    }
  }, [_c('i', {
    staticClass: "el-icon-search el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-search"
    },
    on: {
      "click": _vm.searchPanelInteractions
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), (_vm.showMediaSearch) ? _c('div', {
    staticClass: "panel-search"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Use these options to search by specific media types.")]), _vm._v(" "), _c('div', {
    staticClass: "media-search"
  }, [_c('el-checkbox-group', {
    staticClass: "media-search-chk",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.mediaSearchCriteria),
      callback: function($$v) {
        _vm.mediaSearchCriteria = $$v
      },
      expression: "mediaSearchCriteria"
    }
  }, _vm._l((_vm.mediaTypes), function(item) {
    return _c('el-tooltip', {
      key: item,
      attrs: {
        "content": item,
        "placement": "bottom"
      }
    }, [_c('el-checkbox-button', {
      attrs: {
        "label": item
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.getMediaIconClass(item)
    })])], 1)
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "media-search-btn",
    attrs: {
      "icon": "fa fa-search",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.searchByMedia(false)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.settings.instant_poll) ? _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('h2', {
    attrs: {
      "id": "instant-poll-title"
    }
  }, [_vm._v(_vm._s(_vm.settings.name))]), _vm._v(" "), _vm._l((_vm.pollStats), function(result) {
    return _c('el-progress', {
      key: result.id,
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "text-inside": true,
        "stroke-width": 26,
        "format": function (percentage) { return ((result.choice) + " - " + (result.votes) + " votes - " + percentage + "%"); },
        "color": _vm.generateTitleColor(result.choice),
        "percentage": _vm.instantPollVotePercentage(result.votes)
      }
    })
  }), _vm._v(" "), _vm._m(0)], 2) : _vm._e(), _vm._v(" "), _c('perfect-scrollbar', {
    ref: 'content',
    staticClass: "ibox-content",
    on: {
      "ps-scroll-y": _vm.onScroll
    }
  }, [_c('div', {
    style: ({
      height: ((this.topHeight) + "px")
    })
  }), _vm._v(" "), (_vm.loadingTop) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    key: "top",
    attrs: {
      "count": 2
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleClusters), function(cluster) {
    return _c('div', {
      key: cluster.id
    }, [(_vm.type != 'twittertrends') ? _vm._l((cluster.interactions), function(interaction) {
      return _c('div', {
        key: interaction.id
      }, [(
        interaction.channel != 'survey' && !interaction.message.startsWith('sha256:')
      ) ? _c('message', {
        staticClass: "message",
        class: {
          'first-message': interaction.id === _vm.firstInteractionId
        },
        attrs: {
          "audio": interaction.audio,
          "audioTranscript": _vm.getAudioTranscript(interaction.audioTranscript),
          "avatar": interaction.avatar,
          "channel": interaction.channel,
          "columns": (_vm.columns && +_vm.columns) || 1,
          "comments": interaction.comments,
          "datetime": interaction.datetime,
          "datetimeIsChanged": _vm.datetimeIsChanged,
          "displayName": interaction.displayName,
          "id": interaction.id,
          "threadId": interaction.threadId,
          "images": interaction.images,
          "isOnAir": _vm.type === 'onair',
          "message": interaction.message,
          "onAirUsers": _vm.onAirUsers,
          "originator": interaction.originator,
          "originatorType": interaction.originatorType,
          "parentInteraction": interaction.parent,
          "replies": interaction.replies,
          "sentOnAirBy": interaction.sentBy,
          "video": interaction.video,
          "document": interaction.document,
          "text": interaction.text,
          "sentiment": interaction.sentiment,
          "shouldPause": _vm.shouldPause(interaction.id),
          "inCount": _vm.getThreadCount(interaction.threadId, 'in'),
          "outCount": _vm.getThreadCount(interaction.threadId, 'out'),
          "mediaPreload": _vm.mediaPreload
        },
        on: {
          "changeDatetimePostFormat": _vm.changeDateFormat,
          "heightUpdated": _vm.heightUpdated,
          "mediaStarted": function($event) {
            return _vm.mediaStarted(interaction.id)
          },
          "mediaEnded": function($event) {
            return _vm.mediaEnded(interaction.id)
          },
          "removeOnAir": function($event) {
            return _vm.$emit('removeOnAir', [_vm.id, interaction.onAirId, interaction.id])
          },
          "onOpenProfile": function (originatorType, originator) { return _vm.$emit('onOpenProfile', originatorType, originator); }
        }
      }) : _vm._e()], 1)
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'twittertrends') ? _vm._l((_vm.twitterTrends), function(topic, index) {
      return _c('topic', {
        key: index,
        attrs: {
          "index": index,
          "topic": topic
        }
      })
    }) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.visibleClusters.length == 0 && !(_vm.loading || _vm.isLoading)) ? _c('div', [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": 'No Interactions'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading && (_vm.hasMoreInteractions || !_vm.interactions.length)) ? _c('div', {
    staticClass: "placeholder",
    class: {
      'initial-placeholder': !_vm.interactions.length
    }
  }, [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": _vm.interactions.length ? 1 : 3
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.interactions.length && !_vm.hasMoreInteractions) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": 'End of Interactions'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      height: ((this.bottomHeight) + "px")
    })
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "instant-profile-warning"
    }
  }, [_vm._v("\n          This panel will disappear 3 hours after the instant poll closes. The results can be\n          accessed at any time under the Campaigns menu. "), _c('br'), _vm._v("If this menu isn't available please\n          contact your administrator.\n        ")])
}]}

/***/ }),
/* 3281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentQuestion) ? _c('el-dialog', {
    attrs: {
      "title": "Select visibility condition",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "help-description"
  }, [_vm._v("\n    Only display the question\n    "), _c('strong', [_vm._v("\"" + _vm._s(_vm.currentQuestion.title) + "\"")]), _vm._v(", once the user has selected a specific choice\n    from one of the following questions.\n  ")]), _vm._v(" "), _vm._l((_vm.availableQuestions), function(question) {
    return _c('div', {
      key: question.id,
      staticClass: "question-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(question.title))]), _vm._v(" "), _c('el-checkbox-group', {
      attrs: {
        "size": "mini"
      },
      model: {
        value: (_vm.visibilityCondition),
        callback: function($$v) {
          _vm.visibilityCondition = $$v
        },
        expression: "visibilityCondition"
      }
    }, [_c('span', _vm._l((question.choices), function(choice) {
      return _c('el-checkbox-button', {
        key: choice.id,
        attrs: {
          "label": _vm.getLabel(question, choice)
        }
      }, [_vm._v(_vm._s(choice.title))])
    }), 1)])], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "disabled": !_vm.currentQuestion,
      "type": "danger"
    },
    on: {
      "click": _vm.handleRemoveLinks
    }
  }, [_vm._v("Remove condition")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "sample-size"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      Randomly select\n      "), _c('el-input-number', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "min": 1,
      "size": "mini"
    },
    on: {
      "change": _vm.handleSampleSizeChange
    },
    model: {
      value: (_vm.sampleSize),
      callback: function($$v) {
        _vm.sampleSize = $$v
      },
      expression: "sampleSize"
    }
  }), _vm._v("\n      profiles that fit the above criteria\n    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "exclusion-period"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      Exclude profiles sampled in the last\n      "), _c('el-select', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "placeholder": "Select",
      "size": "mini",
      "clearable": ""
    },
    on: {
      "change": _vm.handleExclusionChange
    },
    model: {
      value: (_vm.exclusionPeriod),
      callback: function($$v) {
        _vm.exclusionPeriod = $$v
      },
      expression: "exclusionPeriod"
    }
  }, _vm._l((_vm.exclusionPeriods), function(exclusionPeriod) {
    return _c('el-option', {
      key: exclusionPeriod.value,
      attrs: {
        "label": exclusionPeriod.label,
        "value": exclusionPeriod.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), (_vm.insufficientProfiles) ? _c('el-alert', {
    attrs: {
      "title": "There are insufficient profiles fitting your filter criteria to draw this sample size",
      "type": "error"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-line-chart', {
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "survey-filter-container"
  }, [_c('el-input', {
    staticClass: "title-filter",
    attrs: {
      "clearable": "",
      "placeholder": "Title"
    },
    on: {
      "clear": _vm.handleFilter,
      "input": _vm.handleDebounceFilter
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter($event)
      }
    },
    model: {
      value: (_vm.surveyTitle),
      callback: function($$v) {
        _vm.surveyTitle = $$v
      },
      expression: "surveyTitle"
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-top": "1px"
    },
    model: {
      value: (_vm.currentStatusFilter),
      callback: function($$v) {
        _vm.currentStatusFilter = $$v
      },
      expression: "currentStatusFilter"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 'ALL'
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 'IS_ACTIVE'
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 'IS_INACTIVE'
    }
  }, [_vm._v("Inactive")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 'IS_PREVIEW'
    }
  }, [_vm._v("Preview")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-filter"
  }), _vm._v(" Filter\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "password-reset-component"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.passwordResetSucceeded) ? _c('el-alert', {
    attrs: {
      "title": "Success",
      "type": "success",
      "description": "Your password has been reset successfully!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordResetFailed) ? _c('el-alert', {
    attrs: {
      "title": "Password Reset Failed",
      "type": "error",
      "description": "We couldn't reset your password. Please contact COLONY LIVE support for further assistance."
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.passwordResetSucceeded) ? _c('div', [_c('PasswordOnlyResetForm')], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [(!_vm.passwordResetSucceeded) ? _c('div', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Already have an account?")])], 1) : _c('div', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-message"
  }, [_c('h4', [_vm._v("Password Recovery")]), _vm._v(" "), _c('p', [_vm._v("\n        Sorry to hear you forgot your password. "), _c('br'), _vm._v("Please provide the email address for the account you wish to reset.\n      ")])])
}]}

/***/ }),
/* 3286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.noContent) ? _c('div', {
    staticClass: "content-loader-placeholder"
  }, [(_vm.type === 'AnalyticsUnitBlock') ? _c('analytics-unit-block-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AudienceProfileLoader') ? _c('audience-profile-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AnalyticsHeatMapLoader') ? _c('div', [_c('content-loader', {
    attrs: {
      "height": Math.abs(_vm.sizeReducer[1]),
      "width": Math.abs(_vm.sizeReducer[0]),
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "71",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "257",
      "y": "38",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "20",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "114.75",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "72.64",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "169.02",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "265.39",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "361.78",
      "y": "207.86",
      "rx": "0",
      "ry": "0",
      "width": "88.51",
      "height": "86.87"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'WordCloudLoader') ? _c('word-cloud-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'TimeSeriesGraphLoader') ? _c('time-series-graph-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'ListDividerLoader') ? _c('list-divider-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'EngagementGraphLoader') ? _c('engagement-graph-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'ProgrammingDashboardUnitLoader') ? _c('programming-dashboard-unit-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AnalyticsChartLoader') ? _c('analytics-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'DoughnutChartLoader') ? _c('doughnut-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'PolarChartLoader') ? _c('polar-chart-loader') : _vm._e(), _vm._v(" "), (_vm.type === 'AdvertisersChartLoader') ? _c('advertisers-chart-loader') : _vm._e()], 1) : _c('span', [_c('content-placeholder', {
    staticStyle: {
      "width": "100%",
      "min-height": "200px",
      "display": "block"
    },
    attrs: {
      "slot": "unit-content",
      "text-value": "Not enough data available",
      "text-array": !_vm.noContent && ['Not enough data available.', 'Try running some Competition campaigns.'],
      "text-only": true,
      "count": 1
    },
    slot: "unit-content"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "fixed": _vm.fixedHeight
    }
  }, [(!_vm.hideTitle) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title", [_c('h3', [_vm._v("Title")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.hideDescription) ? _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._t("description", [_vm._v("\n      Description\n    ")])], 2) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Search",
      "prefix-icon": "el-icon-search",
      "size": "mini"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Add new hook"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle filter-btn filter-add",
    on: {
      "click": _vm.handleCreate
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Clear filters"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle filter-btn filter-clear",
    on: {
      "click": _vm.handleResetFilters
    }
  })])], 1)])], 1), _vm._v(" "), _c('draggable', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.handleLoadMore),
      expression: "handleLoadMore"
    }],
    staticClass: "draggable-group",
    class: {
      'draggable-fixed': _vm.isFixed
    },
    attrs: {
      "id": "draggable-hook",
      "draggable": ".draggable",
      "body-style": {
        padding: '0'
      },
      "group": {
        name: 'hooks',
        pull: 'clone',
        put: false
      },
      "sort": false
    },
    model: {
      value: (_vm.hookQuestions),
      callback: function($$v) {
        _vm.hookQuestions = $$v
      },
      expression: "hookQuestions"
    }
  }, [_vm._l((_vm.hookQuestions), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        draggable: !_vm.isDisabled(item.id) && _vm.isEditable,
          enabled: !_vm.isDisabled(item.id),
          disabled: _vm.isDisabled(item.id),
      }
    }, [_c('el-card', {
      key: item.id,
      staticStyle: {
        "margin": "4px 0"
      },
      attrs: {
        "shadow": "never",
        "body-style": _vm.itemStyle(item.id)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelect(item)
        },
        "dblclick": function($event) {
          return _vm.handleAddItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "handle pull-right"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ellipsis-v"
    })]), _vm._v(" "), _c('div', {
      staticClass: "options pull-right"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.handleEditItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hook-item"
    }, [_c('hook-media', {
      attrs: {
        "hook": item.mediaClip
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])], 1)
  }), _vm._v(" "), (_vm.hookQuestions.length === 0) ? _c('empty', [_vm._v("No hooks found.")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "width": "440px",
      "append-to-body": "",
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": ("nd-modal nd-modal--" + _vm.tone)
    }
  }, [_c('div', {
    staticClass: "nd-modal__body"
  }, [_c('div', {
    staticClass: "nd-modal__badge"
  }, [_c('span', {
    class: ['nd-modal__ring', {
      'nd-modal__ring--spin': _vm.loading
    }]
  }), _vm._v(" "), _c('i', {
    class: ['fa', _vm.icon, 'nd-modal__icon', {
      'nd-modal__icon--pulse': _vm.loading
    }]
  })]), _vm._v(" "), _c('h4', {
    staticClass: "nd-modal__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "nd-modal__text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.hint) ? _c('p', {
    staticClass: "nd-modal__hint"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" " + _vm._s(_vm.hint))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('el-progress', {
    staticClass: "nd-modal__progress",
    attrs: {
      "percentage": _vm.progress,
      "stroke-width": 6,
      "show-text": false,
      "color": "rgb(104, 48, 144)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading && _vm.progressText) ? _c('p', {
    staticClass: "nd-modal__progress-text"
  }, [_vm._v(_vm._s(_vm.progressText))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "nd-modal__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.showRefresh) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-refresh",
      "loading": _vm.refreshing
    },
    on: {
      "click": function($event) {
        return _vm.$emit('refresh')
      }
    }
  }, [_vm._v("\n      Refresh\n    ")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "value": "activeChannels"
    },
    on: {
      "tab-click": _vm.onChangeTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Active Channels",
      "name": "activeChannels"
    }
  }, [_c('channel-list', {
    attrs: {
      "channels": _vm.channels,
      "active": _vm.activeChannelTab === 'activeChannels'
    },
    on: {
      "deactivateChannel": _vm.deactivateChannel
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inactive Channels",
      "name": "inactiveChannels"
    }
  }, [_c('channel-list', {
    attrs: {
      "channels": _vm.channels,
      "active": _vm.activeChannelTab === 'activeChannels'
    },
    on: {
      "activateChannel": _vm.activateChannel
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "value": 0,
      "placeholder": "Sort by"
    },
    on: {
      "change": _vm.handleFilter
    },
    model: {
      value: (_vm.currentSortBy),
      callback: function($$v) {
        _vm.currentSortBy = $$v
      },
      expression: "currentSortBy"
    }
  }, _vm._l((_vm.campaignSortByList), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.title,
        "value": item.type
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Title"
    },
    on: {
      "input": _vm.handleDebounceFilter
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter($event)
      }
    },
    model: {
      value: (_vm.currentTitle),
      callback: function($$v) {
        _vm.currentTitle = $$v
      },
      expression: "currentTitle"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "value": 0,
      "placeholder": "Campaign type"
    },
    on: {
      "change": _vm.handleFilter
    },
    model: {
      value: (_vm.currentType),
      callback: function($$v) {
        _vm.currentType = $$v
      },
      expression: "currentType"
    }
  }, _vm._l((_vm.campaignTypeList), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.title,
        "value": item.type
      }
    })
  }), 1), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-top": "1px"
    },
    on: {
      "input": _vm.handleDebounceFilter
    },
    model: {
      value: (_vm.currentIsActive),
      callback: function($$v) {
        _vm.currentIsActive = $$v
      },
      expression: "currentIsActive"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("Inactive")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "middle",
      "text-align": "center"
    },
    attrs: {
      "width": "5%"
    }
  }, [_c('social-icon', {
    staticClass: "channel-icon",
    attrs: {
      "type": _vm.handleChannelType(_vm.channelType)
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "project-title",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [(_vm.keyword.length > 0) ? _c('div', [_c('span', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.keyword))]), _vm._v(" "), _c('strong', [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handle))])]) : _vm._e(), _vm._v(" "), (!_vm.keyword.length) ? _c('div', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.handle))])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "project-actions",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('el-button', {
    staticClass: "unlink-button",
    attrs: {
      "plain": true,
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleUnlink
    }
  }, [_vm._v("Unlink")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showGroup) ? _c('div', {
    staticClass: "channels-filters"
  }, [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "channels-scroll",
    class: {
      'long-group': _vm.isLong, 'short-group': !_vm.isLong
    }
  }, [_c('el-collapse', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.groupedChannelOptions), function(channelOptions, channelType) {
    return _c('el-collapse-item', {
      key: channelType,
      attrs: {
        "name": channelType
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "collapse-title"
    }, [_vm._v(_vm._s(channelType.toUpperCase()))])]), _vm._v(" "), _c('div', [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: (_vm.selectedOptions),
        callback: function($$v) {
          _vm.selectedOptions = $$v
        },
        expression: "selectedOptions"
      }
    }, _vm._l((channelOptions), function(option) {
      return _c('div', {
        key: option.id
      }, [_c('el-checkbox', {
        attrs: {
          "label": option.id
        }
      }, [_c('social-icon', {
        staticClass: "fa fa-fw",
        attrs: {
          "type": _vm.capitalize(option.type)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "option"
      }, [_vm._v(_vm._s(option.handle))])], 1)], 1)
    }), 0)], 1)], 2)
  }), 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "edit-profile-form"
  }, [_c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('croppa', {
    ref: "croppa",
    attrs: {
      "width": 256,
      "height": 256,
      "canvas-color": 'transparent',
      "placeholder": 'Choose an avatar',
      "show-loading": true,
      "initial-image": _vm.avatar,
      "accept": 'image/*'
    },
    model: {
      value: (_vm.myCroppa),
      callback: function($$v) {
        _vm.myCroppa = $$v
      },
      expression: "myCroppa"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("First name")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "First name"
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("Last name")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Last name"
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "update-btn",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleClickUpdate()
      }
    }
  }, [_vm._v("Update")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row p-xs"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('strong', [_vm._v(_vm._s(_vm.statLabel) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.statValue))])])])
},staticRenderFns: []}

/***/ }),
/* 3296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading && !_vm.profiles.length),
      expression: "loading && !profiles.length"
    }],
    attrs: {
      "element-loading-text": "Loading Profile..."
    }
  }, [_c('div', {
    staticClass: "infinite-list-wrapper",
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "infinite-scroll-disabled": "disabled"
    }
  }, [_c('el-row', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "gutter": 6
    }
  }, _vm._l((_vm.profiles), function(profile) {
    return _c('el-col', {
      key: profile.id,
      attrs: {
        "span": 6
      }
    }, [_c('grid-card', {
      staticStyle: {
        "margin": "12px 0px"
      },
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showProfile(profile)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [(_vm.loading && !_vm.profiles.length) ? _c('p', {
    staticClass: "loading-profile"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e()])], 1), _vm._v(" "), (_vm.profile) ? _c('dialog-card', {
    attrs: {
      "initialProfile": _vm.profile,
      "visible": _vm.showProfileCard
    },
    on: {
      "close": _vm.handleCloseCard
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "height": _vm.height,
      "border": "",
      "data": _vm.sortedData
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(scope.row.label))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "align": "right",
      "sortable": "",
      "width": "80px",
      "prop": "percentage"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "percentage"
        }, [_vm._v(_vm._s(scope.row.percentage.toFixed(2)) + "%")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "nuggetForm",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.localNugget,
      "rules": _vm.rules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ("" + (_vm.localNugget.title)),
      "prop": "value"
    }
  }, [(_vm.localNugget.field === 'gender') ? [_c('el-select', {
    attrs: {
      "placeholder": "Select Gender"
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Male",
      "value": "Male"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Female",
      "value": "Female"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Other",
      "value": "Other"
    }
  })], 1)] : (_vm.localNugget.field === 'age_range') ? [_c('el-select', {
    attrs: {
      "placeholder": "Select Age"
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Under 18",
      "value": "Under 18"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "18-24",
      "value": "18-24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "25-34",
      "value": "25-34"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "35-49",
      "value": "35-49"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "50-64",
      "value": "50-64"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "65+",
      "value": "65+"
    }
  })], 1)] : [_c('el-input', {
    attrs: {
      "placeholder": ("Enter new " + (_vm.localNugget.title))
    },
    model: {
      value: (_vm.localNugget.value),
      callback: function($$v) {
        _vm.$set(_vm.localNugget, "value", $$v)
      },
      expression: "localNugget.value"
    }
  })]], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.savingNugget,
      "disabled": !_vm.isValueChanged || _vm.savingNugget,
      "plain": ""
    },
    on: {
      "click": _vm.handleEditFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "fixed": _vm.fixedHeight
    }
  }, [(!_vm.hideTitle) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title", [_c('h3', [_vm._v("Title")])])], 2) : _vm._e(), _vm._v(" "), (!_vm.hideDescription) ? _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._t("description", [_vm._v("\n      Description\n    ")])], 2) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i-box', {
    staticClass: "dashboard-unit",
    style: ({
      height: _vm.height
    })
  }, [_c('span', {
    staticClass: "unit-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('span', {
    class: _vm.titleIconClass
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.titleRightIcon.tooltip,
      "placement": "top"
    }
  }, [_c('span', {
    class: _vm.titleRightIcon.icon,
    on: {
      "click": _vm.rightIconClick
    }
  })])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "unit-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("unit-content")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasAccess) ? _c('div', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (!_vm.hasAccess && _vm.isPage && !_vm.$apollo.loading) ? _c('div', [_c('empty', [_c('p', [_vm._v("You don't have permission to access this resource.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Please contact your administrator if you feel this is in error.")])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dasboard-container"
  }, [(_vm.loadingChannels) ? _c('div', [_c('loader', {
    attrs: {
      "message": "Fetching Social Channels",
      "shadow": "none"
    }
  })], 1) : (!_vm.socialChannels || !_vm.socialChannels.length) ? _c('div', [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": "You don't have any social channels. Please go to channels to add some."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "row row-1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('page-demographics-overview', {
    attrs: {
      "demographicData": _vm.demographicData,
      "isLoading": _vm.demographicsLoading,
      "facebookPages": _vm.facebookChannels,
      "selectedPage": _vm.selectedFacebookPage,
      "selectedDemographicType": _vm.selectedDemographic
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange,
      "onSelectedDemographicTypeChanged": _vm.handleDemographicTypeChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('facebook-insights-overview', {
    staticClass: "insights",
    attrs: {
      "isLoading": _vm.insightsOverviewLoading,
      "overviewData": _vm.insightOverviewData,
      "facebookPages": _vm.facebookChannels,
      "selectedPage": _vm.selectedFacebookPage
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('instagram-insights-overview', {
    staticClass: "insights",
    attrs: {
      "isLoading": _vm.instagramInsightsOverviewLoading,
      "overviewData": _vm.instagramInsightOverviewData,
      "instagramPages": _vm.instagramChannels,
      "selectedPage": _vm.selectedInstagramPage
    },
    on: {
      "onInstagramPeriodChanged": _vm.fetchInstagramInsightsOverviewData,
      "onSelectedPageChange": _vm.handleInstagramPageChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('post-overview', {
    attrs: {
      "isLoading": _vm.facebookPostInsightLoading,
      "facebookPages": _vm.facebookChannels,
      "postInsights": _vm.facebookPostInsightData,
      "selectedPage": _vm.selectedFacebookPage,
      "pages": _vm.postInsightPageSize
    },
    on: {
      "onSelectedPageChange": _vm.handlePageChange,
      "changePage": _vm.changePostInsightPage,
      "onChangeSerachTerm": _vm.changeSerachTerm
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', [_vm._v("Social Analytics")])])])
}]}

/***/ }),
/* 3303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-card', {
    attrs: {
      "fixedHeight": false,
      "hideDescription": _vm.mode === 'lite'
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(" Profiles Filter")])]), _vm._v(" "), _c('div', [(_vm.mode === 'lite') ? _c('identifiers-filter', {
    ref: "identifier",
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "filter": _vm.handleOnFilter
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.mode === 'pro') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v("\n            Profiles: "), _c('strong', [_vm._v(_vm._s(_vm.formatNumber(_vm.results.total, 0, ',')))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("Select the fields you would like to use to filter the profiles")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "Loading Profile Filters..."
    }
  }, [(_vm.mode === 'pro') ? _c('el-collapse', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeFilters),
      callback: function($$v) {
        _vm.activeFilters = $$v
      },
      expression: "activeFilters"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "demographics"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "collapse-title"
  }, [_vm._v("Demographics")])]), _vm._v(" "), _c('demographics-filter', {
    ref: "demos",
    attrs: {
      "filters": _vm.demographics,
      "total": _vm.results.total
    },
    on: {
      "filter": _vm.handleOnFilter
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "campaignsAndSurveys"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "collapse-title"
  }, [_vm._v("Campaigns & Surveys")])]), _vm._v(" "), _c('campaigns-filter', {
    ref: "campaign",
    attrs: {
      "campaigns": _vm.campaigns
    },
    on: {
      "filter": _vm.handleOnFilter
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "optins"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "collapse-title"
  }, [_vm._v("Opt-in Status")])]), _vm._v(" "), _c('optins-filter', {
    ref: "optin",
    on: {
      "filter": _vm.handleOnFilter
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "profileSearch"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "collapse-title"
  }, [_vm._v("Profile Search")])]), _vm._v(" "), _c('identifiers-filter', {
    ref: "identifier",
    on: {
      "filter": _vm.handleOnFilter
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "randomSample"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "collapse-title"
  }, [_vm._v("Random Sample")])]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.computedEnableRandomSample),
      callback: function($$v) {
        _vm.computedEnableRandomSample = $$v
      },
      expression: "computedEnableRandomSample"
    }
  }, [_vm._v("Enable random sampling")]), _vm._v(" "), (_vm.sampleSize > 0) ? _c('random-sample-filter', {
    ref: "randomsample",
    attrs: {
      "sample-size": _vm.sampleSize,
      "available-profiles": _vm.results.filteredTotal
    },
    on: {
      "change-sample-size": _vm.handleChangeSampleSize,
      "filter": _vm.handleOnFilter
    }
  }) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'pro') ? _c('div', {
    staticClass: "row filtered-count"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.searching) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v("Profiles: "), _c('strong', [_vm._v(_vm._s(_vm.formatNumber(_vm.results.filteredTotal, 0, ',')))])])])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'pro') ? _c('profiles-data-export', {
    attrs: {
      "canDownload": _vm.identifierSelected,
      "profilesVisible": _vm.displayProfiles,
      "saved-queries": _vm.savedQueries,
      "loading-saved-queries": _vm.loadingSavedQueries,
      "v-if": _vm.mode === 'pro',
      "id": "profile-data-export"
    },
    on: {
      "download": _vm.handleDownloadQuery,
      "display-profiles": _vm.handleDisplayProfiles,
      "clear-filters": _vm.handleClearFilters,
      "save-query": _vm.handleSaveQuery,
      "apply-query": _vm.handleApplySavedQuery,
      "delete-query": function($event) {
        return _vm.$emit('delete-query', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.proMode || _vm.displayProfiles) ? _c('profiles-browser', {
    attrs: {
      "profiles": _vm.results.profiles,
      "filtered-total": _vm.results.filteredTotal,
      "loading": _vm.searching,
      "loading-profiles": _vm.loadingProfiles
    },
    on: {
      "load-more-profiles": function($event) {
        return _vm.$emit('load-more-profiles')
      }
    }
  }) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "audio-preview",
      "width": "50%",
      "title": "Audio Preview",
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.sender))])]), _vm._v(" "), (_vm.note.location) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-location"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.location))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]), _vm._v(" "), (_vm.note.score) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('el-rate', {
    attrs: {
      "value": _vm.note.score,
      "disabled": "",
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "text-color": "#ff9900"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "meta-badges"
  }, [(_vm.note.approved) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On Air\n        ")]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Flagged\n        ")]) : _vm._e(), _vm._v(" "), (_vm.note.tone) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.capitalize(_vm.note.tone)) + "\n        ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.note.audioUrl) ? _c('div', {
    staticClass: "audio-player"
  }, [_c('audio', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls": "",
      "src": _vm.note.audioUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript ")]), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.note.transcript || 'No transcript available.'))])]), _vm._v(" "), (_vm.note.tags && _vm.note.tags.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-collection-tag"
  }), _vm._v(" Tags\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "size": "mini",
        "type": "warning",
        "effect": "plain"
      }
    }, [_vm._v(_vm._s(tag))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.note.people && _vm.note.people.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" People Mentioned\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.people), function(person) {
    return _c('el-tag', {
      key: person,
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" " + _vm._s(person) + "\n        ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.note.keywords && _vm.note.keywords.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-price-tag"
  }), _vm._v(" Keywords\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.keywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "size": "mini",
        "type": "success",
        "effect": "plain"
      }
    }, [_vm._v(_vm._s(keyword))])
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Close")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donut-chart-loader"
  }, [_c('svg', {
    staticClass: "loader",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveAspectRatio": "xMidYMid meet",
      "viewBox": "0 0 150 200",
      "width": "200"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M146.46 73.81C146.46 113.54 114.2 145.8 74.47 145.8C34.74 145.8 2.49 113.54 2.49 73.81C2.49 34.08 34.74 1.83 74.47 1.83C114.2 1.83 146.46 34.08 146.46 73.81Z",
      "id": "a187zY3obG"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M113.84 71.76C113.84 93.48 96.2 111.12 74.47 111.12C52.75 111.12 35.11 93.48 35.11 71.76C35.11 50.03 52.75 32.4 74.47 32.4C96.2 32.4 113.84 50.03 113.84 71.76Z",
      "id": "cBWDMaKOE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "",
      "id": "i1HnPNnU2L"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a187zY3obG",
      "opacity": "1",
      "fill": "#ececec",
      "fill-opacity": "1"
    }
  })]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#cBWDMaKOE",
      "opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#i1HnPNnU2L",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e9e9e9",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 3306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showGroup) ? _c('div', {
    staticClass: "age-filters"
  }, [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-checkbox-group', {
    class: {
      'long-group': _vm.isLong, 'short-group': !_vm.isLong
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  }, [(_vm.chunk) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.chunkedOptions[0]), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey)
    }, [_c('virtual-list', {
      attrs: {
        "size": _vm.virtualListSize,
        "remain": _vm.virtualListVisible
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1), _vm._v(" "), _c('br')], 1)
  }), 0), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, _vm._l((_vm.chunkedOptions[1]), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey),
      staticClass: "overflow-text"
    }, [_c('virtual-list', {
      attrs: {
        "size": _vm.virtualListSize,
        "remain": _vm.virtualListVisible
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1), _vm._v(" "), _c('br')], 1)
  }), 0)], 1) : _c('div', [_c('virtual-list', {
    attrs: {
      "size": _vm.virtualListSize,
      "remain": _vm.virtualListVisible
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: _vm.getItem(option, _vm.valueKey)
    }, [_c('el-checkbox', {
      attrs: {
        "label": _vm.getItem(option, _vm.valueKey)
      }
    }, [_c('el-row', [_vm._t("default", [_c('span', {
      staticClass: "option"
    }, [_vm._v(_vm._s(option))])], {
      "option": option
    })], 2)], 1)], 1)
  }), 0), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isVisible,
      "model": true,
      "lockScroll": true,
      "custom-class": 'gallery-dialog'
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('span', [(_vm.images.length > 1) ? _c('div', {
    staticClass: "controls-wrapper"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.setPrevIndex()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "right",
    on: {
      "click": function($event) {
        return _vm.setNextIndex()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.images[_vm.selectedIndex]
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 3308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("panels"), _vm._v(" "), _vm._t("gallery"), _vm._v(" "), _vm._t("settings"), _vm._v(" "), _vm._t("add-btn"), _vm._v(" "), _vm._t("modals"), _vm._v(" "), _c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "position": _vm.position,
      "bg-color": _vm.bgColor,
      "actions": _vm.fabActions
    },
    on: {
      "addNewPanel": _vm.handleAddPanel,
      "addOnAir": _vm.handleAddOnAir,
      "addActivityFeed": _vm.handleAddActivityFeed,
      "addTwitterTrends": _vm.handleAddTwitterTrends,
      "addInstantPoll": _vm.handleAddInstantPoll,
      "addChat": _vm.handleAddChat
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    staticClass: "analytics-chart"
  }, [_c('analytics-area-chart', {
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "35%",
      "title": "Saved Profile Filters",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "optin-table",
      "data": _vm.queries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "width": "250",
      "label": "Title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "insertedAt",
      "width": "180",
      "label": "Date Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.inserted_at, 'lll')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Actions",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popconfirm', {
          attrs: {
            "confirm-button-text": "Yes, I'm sure",
            "cancel-button-text": "Cancel",
            "icon": "el-icon-info",
            "icon-color": "red",
            "title": "Are you want to apply this filter?"
          },
          on: {
            "onConfirm": function($event) {
              return _vm.handleApply(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "confirm-button-text": "Yes, Delete",
            "cancel-button-text": "Cancel",
            "icon": "el-icon-info",
            "icon-color": "red",
            "title": "Are you sure to delete this filter?"
          },
          on: {
            "onConfirm": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "danger",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-wechat"
  })
},staticRenderFns: []}

/***/ }),
/* 3312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTranscripts && _vm.displayedTranscripts.length === 0),
      expression: "loadingTranscripts && displayedTranscripts.length === 0"
    }],
    attrs: {
      "element-loading-text": "Loading voice notes transcripts..."
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "infinite-list-wrapper",
    attrs: {
      "infinite-scroll-disabled": "disabled",
      "infinite-scroll-distance": "100"
    }
  }, [_c('el-row', {
    staticClass: "voice-grid",
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.displayedTranscripts), function(vn) {
    return _c('el-col', {
      key: vn.id,
      staticClass: "voice-col",
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 12,
        "lg": 12,
        "xl": 12
      }
    }, [_c('el-card', {
      staticClass: "voice-card",
      attrs: {
        "shadow": "hover",
        "body-style": {
          padding: '15px',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "align": "middle"
      }
    }, [_c('el-rate', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (vn.score),
        callback: function($$v) {
          _vm.$set(vn, "score", $$v)
        },
        expression: "vn.score"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header-badges"
    }, [(vn.approved) ? _c('el-tag', {
      attrs: {
        "type": "success",
        "effect": "dark",
        "size": "small"
      }
    }, [_c('i', {
      staticClass: "fa fa-podcast",
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" On Air\n                ")]) : _vm._e(), _vm._v(" "), (vn.flagged) ? _c('el-tag', {
      attrs: {
        "type": "danger",
        "effect": "plain",
        "size": "small"
      }
    }, [_c('i', {
      staticClass: "fa fa-flag",
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" Flagged\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "voice-content"
    }, [_c('div', {
      staticClass: "note-name"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(vn.sender))])]), _vm._v(" "), (vn.location) ? _c('div', {
      staticClass: "note-location"
    }, [_c('i', {
      staticClass: "el-icon-location"
    }), _vm._v(" " + _vm._s(vn.location) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "note-time"
    }, [_c('i', {
      staticClass: "el-icon-time"
    }), _vm._v(" " + _vm._s(_vm.displayDatetime(vn.timestamp)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "note-summary"
    }, [_vm._v(_vm._s(vn.transcript))]), _vm._v(" "), (vn.tags && vn.tags.length) ? _c('div', {
      staticClass: "note-tags"
    }, [_c('span', {
      staticClass: "tag-label"
    }, [_vm._v("Tags")]), _vm._v(" "), _vm._l((vn.tags.slice(0, 2)), function(tag) {
      return _c('el-tag', {
        key: tag,
        staticClass: "tag",
        attrs: {
          "size": "mini",
          "effect": "light"
        }
      }, [_c('i', {
        staticClass: "fa fa-tag"
      }), _vm._v(" " + _vm._s(tag) + "\n              ")])
    }), _vm._v(" "), (vn.tags.length > 2) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_vm._v("\n                +" + _vm._s(vn.tags.length - 2) + "\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (vn.people && vn.people.length) ? _c('div', {
      staticClass: "note-tags"
    }, [_c('span', {
      staticClass: "tag-label"
    }, [_vm._v("People")]), _vm._v(" "), _vm._l((vn.people.slice(0, 2)), function(person) {
      return _c('el-tag', {
        key: person,
        staticClass: "tag",
        attrs: {
          "size": "mini",
          "type": "info",
          "effect": "plain"
        }
      }, [_c('i', {
        staticClass: "el-icon-user"
      }), _vm._v(" " + _vm._s(person) + "\n              ")])
    }), _vm._v(" "), (vn.people.length > 2) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_vm._v("\n                +" + _vm._s(vn.people.length - 2) + "\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (vn.audioUrl) ? _c('audio', {
      staticClass: "voice-audio",
      attrs: {
        "src": vn.audioUrl,
        "controls": "",
        "preload": "meta"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "voice-actions"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": vn.approved ? 'success' : '',
        "plain": vn.approved
      },
      on: {
        "click": function($event) {
          return _vm.onApprove(vn)
        }
      }
    }, [_c('i', {
      class: vn.approved ? 'fa fa-podcast' : 'fa fa-check'
    }), _vm._v("\n              " + _vm._s(vn.approved ? 'On Air' : 'Approve') + "\n            ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "type": vn.flagged ? 'danger' : '',
        "plain": vn.flagged
      },
      on: {
        "click": function($event) {
          return _vm.onToggleFlag(vn)
        }
      }
    }, [_c('i', {
      class: vn.flagged ? 'fa fa-flag' : 'fa fa-flag-o'
    }), _vm._v("\n              " + _vm._s(vn.flagged ? 'Flagged' : 'Flag') + "\n            ")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-left": "auto"
      },
      attrs: {
        "size": "small",
        "type": "info",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.onPreviewAudio(vn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Preview\n            ")])], 1)])], 1)
  }), 1), _vm._v(" "), (_vm.displayedTranscripts.length > 0) ? _c('div', {
    staticClass: "no-more"
  }, [_c('el-divider', [_c('i', {
    staticClass: "el-icon-finished"
  }), _vm._v(" All voice notes loaded ")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_vm._v("\n        Displaying " + _vm._s(_vm.displayedTranscripts.length) + " of " + _vm._s(_vm.transcripts.length) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingTranscripts && _vm.displayedTranscripts.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('empty', {
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("No voice notes found")])], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-doughnut-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "edit",
      "subject": "timeslots"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px",
      "model": _vm.timeslot
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Title"
    },
    model: {
      value: (_vm.timeslot.title),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "title", $$v)
      },
      expression: "timeslot.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Days"
    }
  }, [_c('span', [_c('el-select', {
    attrs: {
      "placeholder": "Start Day"
    },
    model: {
      value: (_vm.timeslot.start_day),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_day", $$v)
      },
      expression: "timeslot.start_day"
    }
  }, _vm._l((_vm.weekdays), function(day, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": i,
        "label": day
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "auto 1em"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', [_c('el-select', {
    attrs: {
      "placeholder": "Start Day"
    },
    model: {
      value: (_vm.timeslot.end_day),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_day", $$v)
      },
      expression: "timeslot.end_day"
    }
  }, _vm._l((_vm.weekdays), function(day, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": i,
        "label": day
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Times"
    }
  }, [_c('span', [_c('el-time-picker', {
    attrs: {
      "value-format": "HH:mm:ss",
      "placeholder": "Start Time"
    },
    model: {
      value: (_vm.timeslot.start_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_time", $$v)
      },
      expression: "timeslot.start_time"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "auto 1em"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', [_c('el-time-picker', {
    attrs: {
      "value-format": "HH:mm:ss",
      "placeholder": "End Time"
    },
    model: {
      value: (_vm.timeslot.end_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_time", $$v)
      },
      expression: "timeslot.end_time"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Colour"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.timeslot.colour),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "colour", $$v)
      },
      expression: "timeslot.colour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dialog-footer clearfix"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingTimeslot,
      "plain": ""
    },
    on: {
      "click": _vm.saveTimeslot
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [(_vm.showCookieWarning) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 mt-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-center card cookie p-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.acceptCookies
    }
  }, [_vm._v("Got It")])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    attrs: {
      "id": "login-component"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.hasFailed) ? _c('el-alert', {
    attrs: {
      "title": "Login Failed",
      "type": "error",
      "description": "Sorry, your email address or password is incorrect"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginFormRules
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickLogin($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Email"
    },
    model: {
      value: (_vm.loginForm.email),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "email", $$v)
      },
      expression: "loginForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Password",
      "type": "password"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "login-btn",
      "type": "primary",
      "loading": _vm.isPending
    },
    on: {
      "click": _vm.onClickLogin
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'PasswordReset'
      }
    }
  }, [_vm._v("Forgot Password?")])], 1)], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/cookie.png",
      "width": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2 mr-2"
  }, [_c('span', [_vm._v("We use third party cookies to personalize content and analyze site traffic. By using this website, you automatically accept that we use cookies")]), _c('a', {
    staticClass: "learn-more",
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf"
    }
  }, [_vm._v(" Learn more"), _c('i', {
    staticClass: "fa fa-angle-right ml-2"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-text"
  }, [_c('h4', [_vm._v("A warm welcome to you")]), _vm._v(" "), _c('p', [_vm._v("Login and feel free to leave us your feedback.")])])
}]}

/***/ }),
/* 3316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    on: {
      "onAddPanel": _vm.addPanel,
      "onShowPanel": _vm.handleTogglePanelVisibilityByType,
      "onInstantPoll": _vm.handleShowInstantPollDialog
    }
  }, [_c('div', {
    attrs: {
      "slot": "panels"
    },
    slot: "panels"
  }, [_c('draggable', _vm._b({
    ref: "message_panels",
    staticClass: "message-panels",
    on: {
      "start": _vm.dragStarted,
      "end": _vm.dragEnded
    },
    model: {
      value: (_vm.panelsList),
      callback: function($$v) {
        _vm.panelsList = $$v
      },
      expression: "panelsList"
    }
  }, 'draggable', _vm.draggableOptions, false), _vm._l((_vm.panelsList), function(el) {
    return _c('panel', {
      key: el.id
    }, [(_vm.isMessagePanel(el.id)) ? _c('message-panel', {
      key: el.id,
      attrs: {
        "id": el.id,
        "title": el.title,
        "type": _vm.panelTypes[el.id],
        "interactions": _vm.interactions(el.id),
        "onAirUsers": _vm.companyUsers,
        "loading": _vm.loadingInteractions[el.id],
        "loadingSuccess": _vm.loadingInteractionsSuccess[el.id],
        "color": _vm.panelSettings[el.id].colour,
        "columns": _vm.panelSettings[el.id].columns ? _vm.panelSettings[el.id].columns.toString() : null,
        "goToLastScrollPosition": _vm.goToLastScrollPosition,
        "isPaused": !!_vm.panelPaused[el.id],
        "hasMoreInteractions": _vm.panelHasMoreInteractions(el.id),
        "twitterTrends": _vm.twitterTrends,
        "pollStats": _vm.pollStats(el.id),
        "campaigns": _vm.campaigns,
        "channels": _vm.channels,
        "settings": _vm.panelSettings[el.id],
        "canClose": !['activity'].includes(_vm.panelTypes[el.id]),
        "mediaPreload": _vm.panelSettings[el.id].mediaPreload,
        "panelLock": _vm.panelSettings[el.id].panelLock
      },
      on: {
        "closePanel": function($event) {
          return _vm.closePanel(el.id)
        },
        "loadMore": function($event) {
          return _vm.loadMore(el.id)
        },
        "showSettings": function($event) {
          return _vm.showSettings(el.id)
        },
        "pausePanel": function($event) {
          return _vm.pausePanel(el.id)
        },
        "unpausePanel": function($event) {
          return _vm.unpausePanel(el.id)
        },
        "resetPanel": function($event) {
          return _vm.resetPanel(el.id)
        },
        "searchPanel": _vm.searchPanelInteractions,
        "removeOnAir": _vm.removeOnAir,
        "onOpenProfile": _vm.handleOpenProfile
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isChatPanel(el.id)) ? _c('chat', {
      on: {
        "closePanel": function($event) {
          return _vm.closePanel(el.id)
        }
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "gallery"
    },
    slot: "gallery"
  }, [_c('gallery', {
    attrs: {
      "visible": _vm.galleryVisible,
      "images": _vm.galleryImages,
      "selectedIndex": _vm.galleryIndex
    },
    on: {
      "setVisible": _vm.setGalleryVisible
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "settings"
    },
    slot: "settings"
  }, [(_vm.panelSettingsDialog.id) ? _c('message-panel-settings', {
    attrs: {
      "visible": _vm.panelSettingsDialogVisible,
      "id": _vm.panelSettingsDialog.id,
      "name": _vm.panelSettingsDialog.name,
      "color": _vm.panelSettingsDialog.color,
      "columns": _vm.panelSettingsDialog.columns,
      "channelIds": _vm.panelSettingsDialog.channelIds,
      "campaignIds": _vm.panelSettingsDialog.campaignIds,
      "channels": _vm.channels,
      "panelType": _vm.panelSettingsDialog.type,
      "mediaPreload": _vm.panelSettingsDialog.mediaPreload,
      "panelLock": _vm.panelSettingsDialog.panelLock,
      "campaigns": _vm.activeCampaigns
    },
    on: {
      "setVisible": _vm.setPanelSettingsVisible,
      "saveSettings": _vm.savePanelSettings
    }
  }) : _vm._e(), _vm._v(" "), _c('instant-poll', {
    attrs: {
      "channels": _vm.channels,
      "visible": _vm.instantPollDialogVisible
    },
    on: {
      "close": _vm.handleCloseInstantPoll,
      "cancel": _vm.handleCloseInstantPoll,
      "createPanel": _vm.handleCreatePanel
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "originalProfile": _vm.selectedProfile,
      "updatedProfileMap": _vm.updatedProfileMap,
      "profileId": _vm.getProfileId(_vm.selectedProfile),
      "profileDialogVisible": _vm.profileDialogVisible
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileDialogVisibilityChanged,
      "profileUpdated": _vm.handleProfileUpdated
    }
  }) : _vm._e(), _vm._v(" "), _c('thread-dialog')], 1)])
},staticRenderFns: []}

/***/ }),
/* 3317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "password-rest-form"
  }, [_c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password",
    attrs: {
      "placeholder": "Enter new password",
      "id": "new-password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("Minimum 8 Characters")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password-reset-form",
    attrs: {
      "placeholder": "Confirm new password",
      "id": "confirm-password"
    },
    model: {
      value: (_vm.confirmedPassword),
      callback: function($$v) {
        _vm.confirmedPassword = $$v
      },
      expression: "confirmedPassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "password-reset-btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.onResetPassword
    }
  }, [_vm._v("Reset password")])], 1)
},staticRenderFns: []}

/***/ }),
/* 3318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduled-post"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.colWidths[0]
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.post.message))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.colWidths[1]
    }
  }, [_c('span', {
    staticClass: "post-time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }, [_vm._v(" ")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.postTimestamp))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.colWidths[0]
    }
  }, [(_vm.containsMedia) ? _c('el-tooltip', {
    attrs: {
      "content": "Contains Media",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "contains-media"
  }, [_c('i', {
    staticClass: "fa fa-image"
  })])]) : _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-col', [_c('span', {
    staticClass: "post-controls"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Edit",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    on: {
      "click": _vm.handleEditPost
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Delete",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    on: {
      "click": _vm.handleDeletePost
    }
  })])], 1), _vm._v(" "), (_vm.channels.length) ? _c('div', _vm._l((_vm.channelTypes), function(channel) {
    return _c('el-tooltip', {
      key: channel
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, _vm._l((_vm.getChannelHandlesByType(channel)), function(handle) {
      return _c('span', {
        key: handle,
        staticClass: "social-icons"
      }, [_vm._v("\n              " + _vm._s(handle) + "\n              "), _c('br')])
    }), 0), _vm._v(" "), (channel) ? _c('social-icon', {
      staticClass: "channel-icon",
      attrs: {
        "type": channel
      }
    }) : _vm._e()], 1)
  }), 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "polar-chart-loader"
  }, [_c('svg', {
    staticClass: "loader",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "preserveAspectRatio": "xMidYMid meet",
      "viewBox": "0 0 150 200",
      "width": "200"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M146.32 71.99C146.32 111.72 114.06 143.97 74.33 143.97C34.6 143.97 2.35 111.72 2.35 71.99C2.35 32.26 34.6 0 74.33 0C114.06 0 146.32 32.26 146.32 71.99Z",
      "id": "jRHPh46y"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M128.94 71.99C128.94 102.13 104.47 126.6 74.33 126.6C44.19 126.6 19.72 102.13 19.72 71.99C19.72 41.85 44.19 17.38 74.33 17.38C104.47 17.38 128.94 41.85 128.94 71.99Z",
      "id": "a2fmJNEbGz"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M108.38 71.99C108.38 90.77 93.12 106.03 74.33 106.03C55.55 106.03 40.29 90.77 40.29 71.99C40.29 53.2 55.55 37.94 74.33 37.94C93.12 37.94 108.38 53.2 108.38 71.99Z",
      "id": "gaSHP5GaGd"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.35 60.6L75.26 71.99L11.89 35.94L2.35 60.6Z",
      "id": "a1U9FFrxqz"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104.26 26.17L74.99 71.78L121.86 43.35L104.26 26.17Z",
      "id": "b6SFCFi1fx"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('g', [_c('use', {
    attrs: {
      "xlink:href": "#jRHPh46y",
      "opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#jRHPh46y",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#f2f2f2",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a2fmJNEbGz",
      "opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a2fmJNEbGz",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#f2f2f2",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#gaSHP5GaGd",
      "opacity": "1",
      "fill": "#ffffff",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#gaSHP5GaGd",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#f2f2f2",
      "stroke-width": "1",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a1U9FFrxqz",
      "opacity": "1",
      "fill": "#f2f2f2",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#a1U9FFrxqz",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e9e9e9",
      "stroke-width": "0",
      "stroke-opacity": "1"
    }
  })])]), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b6SFCFi1fx",
      "opacity": "1",
      "fill": "#f2f2f2",
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _c('g', [_c('use', {
    attrs: {
      "xlink:href": "#b6SFCFi1fx",
      "opacity": "1",
      "fill-opacity": "0",
      "stroke": "#e9e9e9",
      "stroke-width": "0",
      "stroke-opacity": "1"
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 3320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "before-close": _vm.handleClose,
      "title": "Export current selection",
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "action-text"
  }, [(_vm.filterBy === 'survey') ? _c('div', [_vm._v("\n      Exporting all respondents to\n      "), _c('strong', [_vm._v("CSV")]), _vm._v(" for survey\n      "), _c('strong', [_vm._v(_vm._s(_vm.surveyName))]), _vm._v(".\n      "), (_vm.questionTitle !== '') ? _c('span', [_vm._v("\n        For the question:\n        "), _c('em', {
    staticClass: "question-title"
  }, [_vm._v(_vm._s(_vm.questionTitle))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period') ? _c('div', [_vm._v("\n      Exporting respondents to\n      "), _c('strong', [_vm._v("CSV")]), _vm._v(" for the period\n      "), _c('strong', [_vm._v(_vm._s(_vm.periodType) + ".")]), _vm._v(" "), (_vm.periodType !== 'lifetime') ? _c('span', [_vm._v("\n        Starting from\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.datetime, 'Do MMM YYYY')) + ".")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportRespondents
    }
  }, [_vm._v("Export")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('channel-dashboard', {
    attrs: {
      "channels": _vm.channels,
      "activeChannelTab": _vm.activeChannelTab
    },
    on: {
      "onChangeTab": function($event) {
        return _vm.onChangeTab($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row select"
  }, [_c('div', {
    staticClass: "col-md-12 select-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, [_vm._l((_vm.computedValue), function(choice) {
    return _c('select-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.isEditable) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("   Clear all choices\n      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSaveTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("   Save as new Choice Template\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 3323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-more",
      "plain": ""
    }
  }, [_vm._v("More Options")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.editable,
      "command": "edit-survey"
    }
  }, [_vm._v("Edit Survey")]), _vm._v(" "), (_vm.state === 'IS_ACTIVE') ? _c('el-dropdown-item', {
    attrs: {
      "command": "make-inactive"
    }
  }, [_vm._v("Make inactive")]) : _vm._e(), _vm._v(" "), (_vm.state === 'IS_INACTIVE') ? _c('el-dropdown-item', {
    attrs: {
      "command": "make-active"
    }
  }, [_vm._v("Make active")]) : _vm._e(), _vm._v(" "), (_vm.state === 'IS_PREVIEW') ? _c('el-dropdown-item', {
    attrs: {
      "command": "delete-survey"
    }
  }, [_vm._v("Delete survey")]) : _vm._e(), _vm._v(" "), (_vm.canShowReportSurvey) ? _c('el-dropdown-item', {
    attrs: {
      "command": "survey-report"
    }
  }, [_vm._v("Survey Report")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "favourite active pull-left",
    on: {
      "click": _vm.handleToggleFavourite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-star': _vm.favorite, 'fa-star-o': !_vm.favorite
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleSurveyTitle
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Status:")]), _vm._v(" "), _c('dd', [(_vm.state == 'IS_ACTIVE') ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (_vm.state == 'IS_INACTIVE') ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Inactive")]) : _vm._e(), _vm._v(" "), (_vm.state == 'IS_PREVIEW') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Preview")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Type:")]), _vm._v(" "), _c('dd', [(_vm.isSpotSurvey) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Spot")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Qualitative")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Start Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.startDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("End Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.endDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("Created By:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.handleDisplayName(_vm.createdBy)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Total:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.totalEntries))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 3324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "password-rest-form"
  }, [(_vm.requireOldPassword) ? _c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password-reset-form",
    attrs: {
      "placeholder": "Confirm old password",
      "id": "old-password"
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password",
    attrs: {
      "placeholder": "Enter new password",
      "id": "new-password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("Minimum 8 Characters")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password-reset-form",
    attrs: {
      "placeholder": "Confirm new password",
      "id": "confirm-password"
    },
    model: {
      value: (_vm.confirmedPassword),
      callback: function($$v) {
        _vm.confirmedPassword = $$v
      },
      expression: "confirmedPassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "password-reset-btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.onResetPassword
    }
  }, [_vm._v("Change password")])], 1)
},staticRenderFns: []}

/***/ }),
/* 3325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doughnut"
  }, [_c('p', {
    staticClass: "no-data"
  }, [_c('strong', [_vm._v(" No Data ")])])])
}]}

/***/ }),
/* 3326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-globe"
  })
},staticRenderFns: []}

/***/ }),
/* 3327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "interactions-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, _vm._l((_vm.interactions), function(interaction) {
    return _c('el-card', {
      key: interaction.id,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('message', {
      key: interaction.id,
      staticClass: "message",
      class: {
        'first-message': interaction.id === _vm.firstInteractionId
      },
      attrs: {
        "audio": _vm.getOreValues(interaction, 'audio').value,
        "avatar": _vm.getOreValue(interaction, 'profile_image', null),
        "comments": interaction.comments,
        "channel": interaction.type,
        "displayName": _vm.getOreValue(interaction, 'display_name')[0] || '',
        "datetime": _vm.moment(interaction.date_created),
        "datetimeIsChanged": _vm.datetimeIsChanged,
        "images": _vm.getOreValues(interaction, 'image').value,
        "id": interaction.id,
        "isOnAir": _vm.type === 'onair',
        "message": _vm.getOreValue(interaction, 'message'),
        "originator": _vm.getOreValue(interaction, 'originators'),
        "originatorType": _vm.getOreValues(interaction, 'originators').type[0],
        "onAirUsers": _vm.onAirUsers,
        "parentInteraction": interaction.parent,
        "replies": interaction.replies,
        "video": _vm.getOreValues(interaction, 'video').value,
        "showTools": false,
        "autoCollapseParentInteraction": true
      },
      on: {
        "changeDatetimePostFormat": _vm.changeDateFormat
      }
    })], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 3328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Add new choice category",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.categoryForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.categoryForm.title),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "title", $$v)
      },
      expression: "categoryForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.categoryForm.description),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "description", $$v)
      },
      expression: "categoryForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-instagram"
  })
},staticRenderFns: []}

/***/ }),
/* 3330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "title": "Create Spot Survey",
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Create a new spot survey by asking questions, and providing the possible choices a user can select from")]), _vm._v(" "), _c('el-form', {
    ref: "surveyForm",
    attrs: {
      "label-width": "120px",
      "model": _vm.surveyForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Survey title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.title),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "title", $$v)
      },
      expression: "surveyForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Campaign",
      "prop": "campaignId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.surveyForm.campaignId),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "campaignId", $$v)
      },
      expression: "surveyForm.campaignId"
    }
  }, _vm._l((_vm.activeCampaigns), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Start date",
      "prop": "startDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.surveyForm.startDate),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "startDate", $$v)
      },
      expression: "surveyForm.startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "End date",
      "prop": "endDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.surveyForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "endDate", $$v)
      },
      expression: "surveyForm.endDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Redirect URL",
      "prop": "redirectUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.redirectUrl),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "redirectUrl", $$v)
      },
      expression: "surveyForm.redirectUrl"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("After the listener has completed the survey successfully, where do we want to redirect them?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logo URL",
      "prop": "logoUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.logoUrl),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "logoUrl", $$v)
      },
      expression: "surveyForm.logoUrl"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("Display this logo image on the spot survey form presented to the listener.")])], 1), _vm._v(" "), _vm._l((_vm.surveyForm.questions), function(question, index) {
    return _c('div', {
      key: question.id,
      staticClass: "question-block"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Question",
        "prop": ("questions." + index + ".title"),
        "rules": {
          required: true,
          message: 'Please provide a question',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (question.title),
        callback: function($$v) {
          _vm.$set(question, "title", $$v)
        },
        expression: "question.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-6"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Choice"
      }
    }, [_c('el-input', {
      model: {
        value: (question.newChoice),
        callback: function($$v) {
          _vm.$set(question, "newChoice", $$v)
        },
        expression: "question.newChoice"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "info",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleAddChoice(question, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus"
    }), _vm._v(" Add choice\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6"
    }, [(question.choices.length === 0) ? _c('div', {
      staticClass: "el-form-item__error"
    }, [_c('em', [_vm._v("No choices have been added for this question yet!")])]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "todo-list choices"
    }, _vm._l((question.choices), function(choice, choiceIndex) {
      return _c('li', {
        key: choice.id
      }, [_vm._v("\n              " + _vm._s(choice.title) + "\n              "), _c('span', {
        staticClass: "pull-right"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.handleRemoveChoice(index, choiceIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-trash"
      })])])])
    }), 0)])]), _vm._v(" "), (_vm.surveyForm.questions.length < 2) ? _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "success",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": _vm.handleAddQuestion
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus"
    }), _vm._v("Add another question\n      ")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      staticClass: "add-btn pull-right",
      attrs: {
        "type": "danger",
        "size": "mini",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleRemoveQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    }), _vm._v("Remove question\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "question-block"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Profiles"
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.demographicsTransfer,
      "titles": ['Available', 'Enabled'],
      "button-texts": ['Disable', 'Enable']
    },
    model: {
      value: (_vm.surveyForm.profiles),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "profiles", $$v)
      },
      expression: "surveyForm.profiles"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_c('strong', [_vm._v("Note:")]), _vm._v(" Due to the way we currently process survey data,\n      once you click\n      "), _c('em', [_vm._v("Create")]), _vm._v(", you will not be able to modify this spot survey again.\n      Please ensure that all information is correct before proceeding.\n    ")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreateSpotSurvey
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "width": "500",
      "height": "340",
      "speed": "2",
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "19",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "21",
      "y": "15",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "44",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "21",
      "y": "40",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "70",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "21",
      "y": "66",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "96",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "21",
      "y": "91",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "120",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "116",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "146",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "142",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "171",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "167",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "197",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "193",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "221",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "217",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "247",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "242",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "272",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "268",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "298",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "293",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "11",
      "cy": "322",
      "r": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "318",
      "rx": "5",
      "ry": "5",
      "width": "180",
      "height": "9"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "266",
      "y": "15",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "277",
      "y": "111",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "299",
      "y": "15",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "310",
      "y": "111",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "334",
      "y": "13",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "345",
      "y": "109",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "366",
      "y": "14",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "377",
      "y": "110",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "400",
      "y": "15",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "411",
      "y": "111",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "432",
      "y": "14",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "443",
      "y": "110",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "232",
      "y": "14",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "243",
      "y": "110",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "468",
      "y": "12",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "310"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "479",
      "y": "108",
      "rx": "0",
      "ry": "0",
      "width": "9",
      "height": "214"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "generatorForm",
    attrs: {
      "model": _vm.report,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.report.type),
      callback: function($$v) {
        _vm.$set(_vm.report, "type", $$v)
      },
      expression: "report.type"
    }
  }, _vm._l((_vm.reportTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.report.type === 'CAMPAIGN') ? _c('el-form-item', {
    attrs: {
      "label": "Campaign",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "clearable": true,
      "filterable": true
    },
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.report.type === 'SURVEY') ? _c('el-form-item', {
    attrs: {
      "label": "Survey",
      "prop": "id"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.report.id),
      callback: function($$v) {
        _vm.$set(_vm.report, "id", $$v)
      },
      expression: "report.id"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "label": survey.title,
        "value": survey.id
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.loading,
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Generate")]) : _c('span', [_vm._v("Generating")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 3334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-button-group', {
    staticClass: "pull-left"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canDownload
    },
    on: {
      "click": _vm.createSampleset
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "disabled": _vm.canDownload,
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n            Select one or more "), _c('em', [_vm._v("\"Contact Details\"")]), _vm._v(" from Demographics"), _c('br'), _vm._v("filters before you can\n            download a contact list.\n          ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Contact List")])])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.displayTooltipContent,
      "placement": "bottom"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('display-profiles')
      }
    }
  }, [(!_vm.profilesVisible) ? _c('span', [_c('i', {
    staticClass: "el-icon-view"
  }), _vm._v(" Display Profiles ")]) : _c('span', [_c('span', [_c('i', {
    staticClass: "fa fa-fw fa-eye-slash"
  }), _vm._v(" Hide Profiles")])])])], 1), _vm._v(" "), _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-button', [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v(" Export for Email"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("Constant Contact")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("MailChimp")])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Reset all filter selections",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('clear-filters')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" Reset Filters")])])], 1)], 1), _vm._v(" "), _c('el-button-group', {
    staticClass: "pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Apply previously saved filters",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "icon": "fa fa-fw fa-folder-open-o"
    },
    on: {
      "click": function($event) {
        _vm.savedQueriesVisible = true
      }
    }
  }, [_vm._v(" Load")])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Save current filter selection",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "icon": "fa fa-fw fa-floppy-o"
    },
    on: {
      "click": _vm.handleSaveQuery
    }
  }, [_vm._v(" Save")])], 1)], 1)], 1), _vm._v(" "), _c('saved-query-list', {
    attrs: {
      "visible": _vm.savedQueriesVisible,
      "loading": _vm.loadingSavedQueries,
      "queries": _vm.savedQueries
    },
    on: {
      "apply-query": _vm.handleApplyQuery,
      "delete-query": function($event) {
        return _vm.$emit('delete-query', $event)
      },
      "close": _vm.handleCloseSavedQueries
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Constant Contact Accounts",
      "visible": _vm.dialogVisible,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "open": _vm.open
    }
  }, [(_vm.$apollo.loading || _vm.loadingContacts) ? _c('loader', {
    attrs: {
      "msg": "Loading"
    }
  }) : _vm._l((_vm.contactAccounts), function(account) {
    return _c('div', {
      key: account.id
    }, [_c('div', {
      staticClass: "ibox-title"
    }, [_c('h5', [_vm._v(_vm._s(_vm.parseProviderName(account.provider)))])]), _vm._v(" "), _c('contact-lists-select', {
      attrs: {
        "id": account.id,
        "provider": account.provider
      },
      on: {
        "selectedListsChange": _vm.handleSelectedListsChange
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.$apollo.loading && !_vm.loadingContacts) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleImportClick
    }
  }, [_vm._v("\n      Import Contacts\n    ")]) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 3336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "campaignForm",
    staticClass: "campaign-form",
    attrs: {
      "model": _vm.campaignForm,
      "rules": _vm.rules,
      "label-width": "190px",
      "label-position": "left"
    }
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), (!_vm.isEditing) ? _c('p', [_vm._v("\n      Let's first get some details on what we want to call this new campaign, we need to know when\n      this campaign is starting and ending as well.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isEditing) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      The campaign type is very important, getting this right ensures the best reporting\n      available. This cannot be changed once the campaign is created.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isEditing) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Due to interaction processing and analytics the campaign type and keyword cannot be changed.\n    ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "campaignTitle"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.campaignForm.campaignTitle),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignTitle", $$v)
      },
      expression: "campaignForm.campaignTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Perpetual Campaign",
      "prop": "perpetual"
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.clearCampaignDates
    },
    model: {
      value: (_vm.campaignForm.perpetual),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "perpetual", $$v)
      },
      expression: "campaignForm.perpetual"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Select to setup a permanent campaign without an end date.")])], 1), _vm._v(" "), (_vm.campaignForm.perpetual) ? _c('el-form-item', {
    attrs: {
      "label": "Start Date",
      "prop": "campaignDates"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime"
    },
    on: {
      "change": _vm.handleChangeCampaignDate
    },
    model: {
      value: (_vm.campaignForm.campaignDates[0]),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm.campaignDates, 0, $$v)
      },
      expression: "campaignForm.campaignDates[0]"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "campaignDates"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "To"
    },
    model: {
      value: (_vm.campaignForm.campaignDates),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignDates", $$v)
      },
      expression: "campaignForm.campaignDates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Type",
      "prop": "campaignType"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "value": null,
      "disabled": _vm.isEditing
    },
    model: {
      value: (_vm.campaignForm.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignType", $$v)
      },
      expression: "campaignForm.campaignType"
    }
  }, _vm._l((_vm.campaignTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Winning Disqualification Duration",
      "prop": "campaignWinningQualificationDuration"
    }
  }, [_c('el-select', {
    staticClass: "duration-selectors",
    attrs: {
      "value": null,
      "filterable": "",
      "placeholder": "days"
    },
    model: {
      value: (_vm.campaignForm.duration_days),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "duration_days", $$v)
      },
      expression: "campaignForm.duration_days"
    }
  }, _vm._l((_vm.range(0, 100)), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item + ' days',
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.pollCampaignTypes.includes(_vm.campaignForm.campaignType)) ? _c('div', [_c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('h3', [_vm._v("Poll Details")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "question"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.campaignForm.pollQuestion),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "pollQuestion", $$v)
      },
      expression: "campaignForm.pollQuestion"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "poll-choice-container",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('h4', [_vm._v("Choices")]), _vm._v(" "), _c('p', [_vm._v("Specify poll choices along with possible matches for each choice")]), _vm._v(" "), _vm._l((_vm.campaignForm.pollChoices), function(choice, idx) {
    return _c('poll-choice-input', {
      key: idx,
      attrs: {
        "choice": choice,
        "idx": idx,
        "disabled": _vm.isEditing
      },
      on: {
        "onRemoveChoice": _vm.handleChoiceRemove
      }
    })
  })], 2), _vm._v(" "), _c('div', [(!_vm.isEditing) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "icon": "fa fa-plus"
    },
    on: {
      "click": _vm.handleAddPollChoice
    }
  }, [_vm._v("Add Choice")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('h3', [_vm._v("Channels")]), _vm._v(" "), _c('p', [_vm._v("These are the means by which interactions come into or get sent out of a campaign.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keyword"
    }
  }, [_vm._l((_vm.campaignForm.channelKeyword), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticStyle: {
        "margin-left": "2px"
      },
      attrs: {
        "closable": !_vm.isEditing,
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.keywordInputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "disabled": _vm.isEditing
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isEditing) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add keyword")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Keywords cannot be added when campaign is live",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-lg"
  })]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Press enter key after each keyword added.")])], 1) : _c('p', [_vm._v("Keywords cannot be added when campaign is live")])], 2), _vm._v(" "), (_vm.smsChannelSelected && _vm.canEncryptOriginators) ? _c('el-form-item', {
    attrs: {
      "label": "Encrypt Originator",
      "prop": "encryptOriginator"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.encryptOriginator),
      callback: function($$v) {
        _vm.encryptOriginator = $$v
      },
      expression: "encryptOriginator"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.smsChannelSelected) ? _c('el-form-item', {
    attrs: {
      "label": "Reply Message",
      "prop": "replyMessage"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.replyMessage),
      callback: function($$v) {
        _vm.replyMessage = $$v
      },
      expression: "replyMessage"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.smsCount) + " (chars left / messages)")]), _vm._v(" "), (_vm.encryptOriginator) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n        Please replace the part of the reply would like encrypted with "), _c('strong', [_vm._v("{hashid}")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("e.g. Thank you for entering, please visit https://example.com/enter?uid="), _c('strong', [_vm._v("{hashid}")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "SMS Credentials",
      "visible": _vm.showSmsCredentialsDialog,
      "width": "30%",
      "show-close": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showSmsCredentialsDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "smsReplyCredentialsForm",
    attrs: {
      "model": _vm.smsReplyCredentialsForm,
      "rules": _vm.smsCredentialsrules
    }
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v("\n          Kindly provide us with the username and password for your sms line. These detials are\n          vital for us to pull in your interactions.\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Username"
    },
    model: {
      value: (_vm.smsReplyCredentialsForm.username),
      callback: function($$v) {
        _vm.$set(_vm.smsReplyCredentialsForm, "username", $$v)
      },
      expression: "smsReplyCredentialsForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "password"
    },
    model: {
      value: (_vm.smsReplyCredentialsForm.password),
      callback: function($$v) {
        _vm.$set(_vm.smsReplyCredentialsForm, "password", $$v)
      },
      expression: "smsReplyCredentialsForm.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmSmsCredential
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('channel-select', {
    attrs: {
      "createChannels": this.channelList,
      "selectedChannels": _vm.campaignForm.channels
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Create a new channel")]), _vm._v(" "), _c('p', [_vm._v("The channel you're looking for not listed above, create a new one below.")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    on: {
      "click": _vm.handleRequestTwitterAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Twitter'
    }
  }), _vm._v("Twitter\n      ")], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleRequestFacebookAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Facebook'
    }
  }), _vm._v("Facebook\n      ")], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleRequestInstagramAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Instagram'
    }
  }), _vm._v("Instagram\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n          Save\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Create Rule",
      "before-close": _vm.handleClose,
      "show-close": false,
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('rule', {
    attrs: {
      "rule": _vm.rule,
      "campaign": _vm.campaign
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.rule.events) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addEmptyAction
    }
  }, [_vm._v("Add Action")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSave(_vm.rule)
      }
    }
  }, [_vm._v("Save Rule")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.promotionData,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Competition",
      "class-name": "promotion-topic-name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entries",
      "label": "Entries",
      "width": "75"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques",
      "width": "75"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "questions",
      "item-name-plural": "questions",
      "item-name": "question",
      "can-add": true,
      "category-list": _vm.questionCategoryWithQuestionsList,
      "disabled-ids": _vm.selectorDisabledQuestionIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorQuestionSearchText,
      "selected-category-id": _vm.selectorSelectedQuestionCategory
    },
    on: {
      "onItemAdd": _vm.handleAddQuestion,
      "onItemEdit": _vm.handleEditQuestion,
      "onChangeCategory": _vm.handleSelectCategory,
      "onCreate": _vm.handleCreateQuestion,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.questions),
      callback: function($$v) {
        _vm.questions = $$v
      },
      expression: "questions"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "message"
  }, [(_vm.sentiment) ? _c('div', {
    staticClass: "sentiment pull-right"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Neutral"
    }
  }, [(_vm.sentiment === 'neutral') ? _c('span', [_c('i', {
    staticClass: "fa fa-minus neutral"
  })]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Negative"
    }
  }, [(_vm.sentiment === 'negative') ? _c('span', [_c('i', {
    staticClass: "fa fa-arrow-down negative"
  })]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Positive"
    }
  }, [(_vm.sentiment === 'positive') ? _c('span', [_c('i', {
    staticClass: "fa fa-arrow-up positive"
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "avatar pull-left"
  }, [(_vm.getAvatar) ? _c('img', {
    staticClass: "img-circle",
    class: {
      clickable: _vm.getAvatar !== _vm.defaultAvatar
    },
    attrs: {
      "src": _vm.getAvatar
    },
    on: {
      "error": function($event) {
        _vm.avatarError = true
      },
      "click": function($event) {
        _vm.getAvatar !== _vm.defaultAvatar && _vm.showGallery([
          [_vm.getAvatar], 0
        ])
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getAvatar) ? _c('div', {
    staticClass: "img-circle",
    style: ({
      'background-color': _vm.channelMeta[_vm.channel].color
    })
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.channelMeta[_vm.channel].icon
  })]) : _vm._e()]), _vm._v(" "), (_vm.displayName.length > 0) ? _c('div', {
    staticClass: "originator"
  }, [_c('span', {
    staticClass: "profile-display",
    on: {
      "click": _vm.handleOpenProfile
    }
  }, [_vm._v(_vm._s(_vm.displayName))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.originator))])])]) : _vm._e(), _vm._v(" "), (_vm.displayName.length === 0) ? _c('div', {
    staticClass: "originator"
  }, [_c('span', {
    staticClass: "profile-display",
    on: {
      "click": _vm.handleOpenProfile
    }
  }, [_vm._v(_vm._s(_vm.originator))])]) : _vm._e(), _vm._v(" "), (_vm.isOnAir) ? _c('span', {
    staticClass: "sent-by pull-right"
  }, [_vm._v("\n        " + _vm._s(_vm.sentOnAirBy) + "\n        "), _c('i', {
    staticClass: "fa fa-user"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "time",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeDatetimePostFormat($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.displayDatetime) + "\n        via " + _vm._s(_vm.channelMeta[_vm.channel].title) + "\n        "), _c('span', {
    staticClass: "originator-type img-circle",
    style: ({
      'background-color': _vm.channelMeta[_vm.channel].color
    })
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.channelMeta[_vm.channel].icon
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMessage)
    }
  }), _vm._v(" "), (_vm.message.length > _vm.messageLength && !_vm.isExpanded) ? _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isExpanded = true
      }
    }
  }, [_vm._v("\n          Show more\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])]) : _vm._e(), _vm._v(" "), (_vm.message.length > _vm.messageLength && _vm.isExpanded) ? _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.isExpanded = false
      }
    }
  }, [_vm._v("\n          Show less\n          "), _c('i', {
    staticClass: "fa fa-angle-up"
  })])]) : _vm._e(), _vm._v(" "), (_vm.audio.length) ? _c('div', {
    staticClass: "audio-container"
  }, _vm._l((_vm.audio), function(aud, index) {
    return _c('audio', {
      key: aud,
      ref: ("audio" + index),
      refInFor: true,
      attrs: {
        "src": aud,
        "controls": "controls",
        "preload": _vm.mediaPreload
      },
      on: {
        "play": function($event) {
          return _vm.handleMediaStarted()
        },
        "ended": function($event) {
          return _vm.handleMediaEnded()
        },
        "pause": function($event) {
          return _vm.handleMediaEnded()
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.video.length) ? _c('div', {
    staticClass: "video-container"
  }, _vm._l((_vm.video), function(vid, index) {
    return _c('video', {
      key: vid,
      ref: ("video" + index),
      refInFor: true,
      staticClass: "video-item",
      attrs: {
        "src": vid,
        "controls": "controls",
        "preload": _vm.mediaPreload
      },
      on: {
        "play": function($event) {
          return _vm.handleMediaStarted()
        },
        "ended": function($event) {
          return _vm.handleMediaEnded()
        },
        "pause": function($event) {
          return _vm.handleMediaEnded()
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length) ? _c('div', {
    staticClass: "images-container"
  }, [_c('image-grid', {
    attrs: {
      "box-width": '370',
      "box-height": '370px',
      "images": _vm.images
    },
    on: {
      "imageSelected": _vm.showGallery
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.document.length) ? _c('div', {
    staticClass: "message-container"
  }, _vm._l((_vm.document), function(doc, index) {
    return _c('a', {
      key: doc,
      ref: ("document" + index),
      refInFor: true,
      attrs: {
        "href": doc
      }
    }, [_vm._v(_vm._s(("document_" + (doc.slice(-20)))))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.text.length) ? _c('div', {
    staticClass: "message-container"
  }, _vm._l((_vm.text), function(txt, index) {
    return _c('a', {
      key: txt,
      ref: ("text" + index),
      refInFor: true,
      attrs: {
        "href": txt
      }
    }, [_vm._v(_vm._s(_vm.getDocumentName(txt)))])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "message-tools"
  }, [(_vm.showTools && !_vm.isOnAir) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Send to on air",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "onair",
    on: {
      "click": function($event) {
        return _vm.setInput('onair')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.threadId && _vm.threadId !== '' && _vm.inCount > 0) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Conversation",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "thread",
    on: {
      "click": _vm.showThread
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.threadId && _vm.threadId !== '' && _vm.inCount > 0) ? _c('div', {
    staticClass: "thread-counts"
  }, [_c('span', {
    staticClass: "in"
  }, [_vm._v(_vm._s(_vm.inCount))]), _vm._v(" "), (_vm.outCount > 0) ? _c('span', [_vm._v("\n        /\n        "), _c('span', {
    staticClass: "out"
  }, [_vm._v(_vm._s(_vm.outCount))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTools) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Comment",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "comment",
    on: {
      "click": function($event) {
        return _vm.setInput('comment')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.channelMeta[_vm.channel].title === 'Facebook Comment') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Like",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "like",
    on: {
      "click": function($event) {
        return _vm.likePost(_vm.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.channelMeta[_vm.channel].title === 'Facebook Post') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Export comments",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "export-comments",
    on: {
      "click": function($event) {
        return _vm.exportFacebookPostComments(_vm.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showTools && _vm.hasTranscript) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Transcript",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "show-audio-transcript",
    on: {
      "click": function($event) {
        _vm.showAudioTranscript = !_vm.showAudioTranscript
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o"
  })])]) : _vm._e(), _vm._v(" "), (_vm.commentsAndRepliesCount && !_vm.showCommentsAndReplies) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showCommentsAndReplies = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-toggle-down"
  }), _vm._v(" "), _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsAndRepliesCount))])]) : _vm._e(), _vm._v(" "), (_vm.commentsAndRepliesCount && _vm.showCommentsAndReplies) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showCommentsAndReplies = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-toggle-up"
  }), _vm._v(" "), _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsAndRepliesCount))])]) : _vm._e(), _vm._v(" "), (_vm.isOnAir) ? _c('span', [_c('el-tooltip', {
    staticClass: "pull-right",
    attrs: {
      "effect": "dark",
      "content": "Remove from on air",
      "placement": "bottom"
    }
  }, [_c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.$emit('removeOnAir')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.parentInteraction !== null && _vm.parentInteraction.ore !== null) ? _c('parent-interaction', {
    attrs: {
      "collapsible": _vm.autoCollapseParentInteraction,
      "interaction": _vm.parentInteraction
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showInput == 'onair') ? _c('div', {
    staticClass: "onair-input"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Send on air to"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.onAirUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "input-controls"
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendOnAir
    }
  }, [_vm._v("Send")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showInput == 'comment') ? _c('div', {
    staticClass: "comment-input"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "Leave a comment..."
    },
    model: {
      value: (_vm.commentMessage),
      callback: function($$v) {
        _vm.commentMessage = $$v
      },
      expression: "commentMessage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-controls"
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendComment
    },
    model: {
      value: (_vm.commentMessage),
      callback: function($$v) {
        _vm.commentMessage = $$v
      },
      expression: "commentMessage"
    }
  }, [_vm._v("Comment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCommentsAndReplies && _vm.commentsAndRepliesCount) ? _c('div', {
    staticClass: "interact"
  }, _vm._l((_vm.commentsAndReplies), function(commentOrReply) {
    return _c('div', {
      key: commentOrReply.batch_uuid
    }, [(commentOrReply.type === 'comment') ? _c('div', {
      staticClass: "comments"
    }, [_c('message-comment', {
      attrs: {
        "datetime": commentOrReply.date_created,
        "message": commentOrReply.value
      }
    })], 1) : _vm._e(), _vm._v(" "), (commentOrReply.type === 'reply') ? _c('div', {
      staticClass: "replies"
    }, [_c('message-reply', {
      attrs: {
        "fullName": commentOrReply.full_name,
        "datetime": commentOrReply.date_created,
        "message": commentOrReply.value
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showAudioTranscript) ? _c('div', {
    staticClass: "transcript"
  }, [_c('audio-transcript', {
    attrs: {
      "transcript": _vm.audioTranscript
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 3341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "hookForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.hookForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Song name",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hookForm.title),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "title", $$v)
      },
      expression: "hookForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Artist",
      "prop": "artist"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.hookForm.artist),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "artist", $$v)
      },
      expression: "hookForm.artist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.hookForm.description),
      callback: function($$v) {
        _vm.$set(_vm.hookForm, "description", $$v)
      },
      expression: "hookForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "File",
      "prop": "file",
      "file-list": _vm.currentFile
    }
  }, [(_vm.hookForm.fileUrl) ? _c('div', [_c('el-card', {
    staticStyle: {
      "margin": "4px 0"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('hook-media', {
    attrs: {
      "hook": _vm.hookMeta
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "audio/mpeg, audio/mp4, audio/ogg, audio/vorbis, audio/vnd.wav",
      "name": "file_data",
      "on-change": _vm.handleFileChange,
      "auto-upload": false,
      "multiple": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" Click to upload hook")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.hooksCreating || _vm.hooksSaving,
      "disabled": _vm.hooksCreating || _vm.hooksSaving
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.hookForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', {
    attrs: {
      "action": _vm.action,
      "subject": _vm.subject
    }
  }, [_c('div', {
    attrs: {
      "slot": "side-menu"
    },
    slot: "side-menu"
  }, [_c('side-menu', {
    attrs: {
      "user": _vm.me
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('app-header', {
    attrs: {
      "me": _vm.me,
      "activities": _vm.activities,
      "scheduledPosts": _vm.scheduledMessages,
      "companies": _vm.companies,
      "breadCrumbs": []
    },
    on: {
      "onNewSocialPost": _vm.onNewSocialPost,
      "onSearch": function($event) {
        return _vm.onSearch($event)
      },
      "onCollapseMenu": function($event) {
        return _vm.onCollapseMenu()
      },
      "onLogout": function($event) {
        return _vm.onLogout()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('app-footer')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "alerts"
    },
    slot: "alerts"
  }, [_c('staff-alerts')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "toast"
    },
    slot: "toast"
  }, [_c('toast'), _vm._v(" "), _c('notification')], 1)]), _vm._v(" "), _c('modal-container')], 1)
},staticRenderFns: []}

/***/ }),
/* 3343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('template-list', {
    attrs: {
      "me": _vm.me,
      "loading": _vm.$apollo.queries.templates.loading,
      "templates": _vm.templates
    },
    on: {
      "onSave": function($event) {
        return _vm.handleOnSave($event)
      },
      "onDelete": function($event) {
        return _vm.handleOnDelete($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_vm._v("Campaigns")]), _vm._v(" "), _c('h3', {
    staticClass: "campaign-align-title pull-right"
  }, [_vm._v(_vm._s(_vm.campaign.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 interaction-container"
  }, [_c('message-panel', {
    attrs: {
      "id": _vm.panelSettings.uuid,
      "isPaused": !!_vm.panelPaused[_vm.panelSettings.uuid],
      "title": 'Recent Messages',
      "type": 'campaign',
      "color": '#ee2465',
      "canClose": false,
      "hasSettings": false,
      "interactions": _vm.interactions(_vm.panelSettings.uuid),
      "hasSearch": false,
      "isFixedPanel": true,
      "loadingSuccess": !!_vm.loadingInteractionsSuccess[_vm.panelSettings.uuid] || false,
      "loading": _vm.loadingInteractions[_vm.panelSettings.uuid] || false,
      "hasMoreInteractions": _vm.panelHasMoreInteractions(_vm.panelSettings.uuid) || false
    },
    on: {
      "loadMore": _vm.handleLoadMore,
      "onOpenProfile": _vm.handleOpenProfile,
      "pausePanel": function($event) {
        return _vm.pausePanel(_vm.panelSettings.uuid)
      },
      "unpausePanel": function($event) {
        return _vm.unpausePanel(_vm.panelSettings.uuid)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadingCampaignReport) ? _c('div', {
    staticClass: "col-lg-8"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaign's details..."
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaign) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingCampaignReport),
      expression: "!loadingCampaignReport"
    }],
    staticClass: "col-lg-8 campaign-details"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('router-link', {
    staticClass: "close-link",
    attrs: {
      "to": {
        name: 'Campaign'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row campaign-details"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('h5', {
    staticClass: "campaign-title"
  }, [_vm._v(_vm._s(_vm.campaign.title))]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Created on:")]), _vm._v(_vm._s(_vm._f("moment")(_vm.campaign.date_created, 'YYYY-MM-DD')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Campaign Type:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaign.campaign_type_display))])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Created By:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaign.created_by))])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-type"
  }, [_c('strong', [_vm._v("Winning Disqualification Duration:")]), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(_vm.convertMillisecondsToMomentDuration(
    _vm.campaign.winning_disqualification_duration
  ).duration_days) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.campaignDetails(_vm.campaign.channel_data.links)), function(channelLink) {
    return _c('div', {
      key: channelLink.id,
      staticClass: "campaign-channels"
    }, [_c('div', {
      staticClass: "campaign-channel"
    }, [_c('label', [_c('social-icon', {
      staticClass: "fa fa-fw",
      attrs: {
        "type": _vm.handleChannelType(channelLink.channel_type_title)
      }
    })], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(channelLink.handle) + ":")]), _vm._v(" "), _c('span', [_vm._v("Keyword: \"" + _vm._s(channelLink.keyword) + "\"")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "campaign-reply-message"
  }, [_c('strong', [_vm._v("Reply Message:")]), _vm._v(" "), _c('span', [_vm._v("\"" + _vm._s(_vm.replyMessage) + "\"")])]), _vm._v(" "), (_vm.campaign.top_engagers.length) ? _c('strong', [_vm._v("Top Engagers:")]) : _vm._e(), _vm._v(" "), _c('dd', {
    staticClass: "project-people"
  }, _vm._l((_vm.campaign.top_engagers), function(profile, index) {
    return _c('engager', {
      key: index,
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelectProfile(profile)
        }
      }
    })
  }), 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('strong', [_vm._v("Start")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(_vm.campaign.start_date, 'YYYY-MM-DD HH:mm')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('strong', [_vm._v("End")]), _vm._v(" "), (_vm.campaign.perpetual) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Perpetual Campaign")]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.campaign.end_date, 'YYYY-MM-DD HH:mm')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row campaign-breakdown-stats"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "chartStyle": "max-height: 60px",
      "scalesEnabled": false,
      "barPercentage": 0.9,
      "categoryPercentage": 1,
      "show-tooltips": false,
      "data": [
        ['total', _vm.campaignReportData.totals.total_lifetime],
        ['unique', _vm.campaignReportData.totals.unique_lifetime] ]
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 60px",
      "show-tooltips": false,
      "data": _vm.channelTypeChartData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "campaign-totals pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                      " + _vm._s(_vm.campaignReportData.totals.total_lifetime.toLocaleString()) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Total Interactions")])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-totals pull-right"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                      " + _vm._s(_vm.campaignReportData.totals.unique_lifetime.toLocaleString()) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Total Uniques")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "campaign-channel-stats"
  }, _vm._l((_vm.campaignReportData.totals
    .total_vs_unique_channel_type), function(item, key) {
    return (item.total > 0 && item.unique > 0) ? _c('div', {
      key: key,
      staticClass: "row campaign-channel-stat border-top"
    }, [_c('div', {
      staticClass: "col-lg-4 channel-total"
    }, [_vm._v(_vm._s(item.total.toLocaleString()))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 channel-title"
    }, [_vm._v(_vm._s(_vm.formatChannelName(key)))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 channel-unique"
    }, [_vm._v("\n                        " + _vm._s(item.unique.toLocaleString()) + "\n                      ")])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row border-top campaign-periodic-stats"
  }, [(
    _vm.campaignReportData.totals.growth_day ||
    _vm.campaignReportData.totals.growth_week ||
    _vm.campaignReportData.totals.growth_month
  ) ? _c('div', {
    staticClass: "campaign-periodic-stats"
  }, [_c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_today.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_day
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-success"
  }, [_vm._v("Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.today),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_today.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_this_week.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_week
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-info"
  }, [_vm._v("This Week")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.this_week),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_this_week.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 campaign-periodic-stat"
  }, [_c('div', {
    staticClass: "periodic-total-block pull-left"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.total_this_month.toLocaleString()) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("Received")])]), _vm._v(" "), _c('div', {
    staticClass: "periodic-unit-block pull-right"
  }, [_c('div', {
    staticClass: "growth"
  }, [_c('growth', {
    attrs: {
      "value": _vm.campaignReportData.totals.growth_month
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "label label-primary"
  }, [_vm._v("This Month")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processSparklineData(_vm.campaignReportData.charts.this_month),
      "gradient": ['#683090', '#c97eff'],
      "height": 40,
      "auto-draw": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "periodic-unique-block"
  }, [_c('div', {
    staticClass: "unique"
  }, [_vm._v("\n                    " + _vm._s(_vm.campaignReportData.totals.unique_this_month.toLocaleString()) + "\n                    "), _c('sup', [_vm._v("Unique")])])])])]) : _c('div', {
    staticClass: "campaign-periodic-stats no-data"
  }, [_c('no-data', {
    staticClass: "label"
  }, [_vm._v("Not enough data to display analytics")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 campaign-main-chart"
  }, [_c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.campaignReportData.charts.channels.constructor === Array ?
        _vm.campaignReportData.charts.channels :
        [],
      "unit": 'month',
      "showLegend": false
    }
  })], 1)])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "profile": _vm.selectedProfile,
      "profileDialogVisible": _vm.profileDialogVisible,
      "campaignId": _vm.id
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileVisibilityChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "id": "optin-table",
      "data": _vm.channels
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label",
      "label": "Channel",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('social-icon', {
          staticClass: "fa fa-fw",
          attrs: {
            "type": scope.row.type
          }
        }), _vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optins",
      "align": "center",
      "label": "Opt-ins",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.optins),
            callback: function($$v) {
              _vm.$set(scope.row, "optins", $$v)
            },
            expression: "scope.row.optins"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "optouts",
      "align": "center",
      "label": "Exclude opt-outs",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          on: {
            "change": _vm.handleChange
          },
          model: {
            value: (scope.row.optouts),
            callback: function($$v) {
              _vm.$set(scope.row, "optouts", $$v)
            },
            expression: "scope.row.optouts"
          }
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "baseball",
    attrs: {
      "id": "permission-profile-dialog",
      "top": "3vh",
      "width": "60rem",
      "center": true,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "visible": _vm.showProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "profile-card"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-card"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "0",
      "text-align": "center"
    }
  }, [_c('el-image', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "id": "image",
      "src": _vm.imageSrc,
      "fit": 'cover'
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.initialProfile.identifier))])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "id": "visible-tabs",
      "stretch": true
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "OptIns",
      "name": "optin"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Activity Logs",
      "name": "logs"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hidden-tabs"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }, [(_vm.demographics.length === 0 && !_vm.$apollo.queries.profile.loading) ? _c('p', [_vm._v("\n            Not enough demographics has been gathered yet to display any results\n          ")]) : _vm._e(), _vm._v(" "), _c('demographics-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "demographics": _vm.demographics,
      "isProfileEditModeOn": _vm.isProfileEditModeOn,
      "isProfileLocked": _vm.isProfileLocked,
      "handleShowAlert": _vm.handleShowAlert
    },
    on: {
      "edit-nugget": _vm.handleEditNugget,
      "remove-nugget": _vm.handleRemoveNugget
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [(_vm.processedInteractions.length === 0 && !_vm.$apollo.queries.profile.loading) ? _c('p', [_vm._v("\n            Not enough Interactions have been gathered yet to display any results\n          ")]) : _vm._e(), _vm._v(" "), _c('interactions-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "interactions": _vm.processedInteractions
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in",
      "name": "optin"
    }
  }, [_c('optins-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "optins": _vm.optins
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Logs",
      "name": "logs"
    }
  }, [_c('activity-logs-tab', {
    attrs: {
      "loading": _vm.loading,
      "initialProfile": _vm.initialProfile,
      "activityLogs": _vm.activityLogs,
      "currentPage": _vm.currentPage,
      "hasNext": _vm.hasNext,
      "hasPrevious": _vm.hasPrevious
    },
    on: {
      "loadMore": _vm.handleLoadMore,
      "loadPrevious": _vm.handleLoadPrevious
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.verificationAlert) ? _c('div', {
    class: {
      'verification-alert': true, 'shake': _vm.shakeAnimation, 'alert-danger': true,
      'text-center': true, 'animated': true
    },
    on: {
      "animationend": _vm.handleAnimationEnd
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleClearAlert
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.verificationAlert) + "\n        "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openVerifyOTPDialog($event)
      }
    }
  }, [_vm._v("Verify Profile")])])]) : _vm._e()]), _vm._v(" "), (_vm.showEnhanceProfileDialog) ? _c('el-dialog', {
    attrs: {
      "id": "enhance-profile-dialog",
      "top": "5vh",
      "width": "100rem",
      "title": "Update Profile",
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showEnhanceProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showEnhanceProfileDialog = $event
      }
    }
  }, [_c('enhance-profile-form', {
    attrs: {
      "demographics": _vm.demographics,
      "optins": _vm.optins,
      "initialMobileNumber": _vm.initialMobileNumber(),
      "visible": _vm.showEnhanceProfileDialog,
      "getNuggetCategory": _vm.getNuggetCategory
    },
    on: {
      "close": function($event) {
        _vm.showEnhanceProfileDialog = false
      },
      "updateProfile": _vm.handleUpdateProfile,
      "updateOptins": _vm.handleUpdateOptins
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showVerifyOTPDialog) ? _c('verify-dialog', {
    attrs: {
      "visible": _vm.showVerifyOTPDialog,
      "initialProfile": _vm.initialProfile,
      "initialMobileNumber": _vm.initialMobileNumber()
    },
    on: {
      "close": _vm.handleCloseVerifyOTPDialog,
      "requestOTP": _vm.handleRequestOTP,
      "verifyOTP": _vm.handleVerifyOTP
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add profile demographics",
      "placement": "top"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDemographicsTabActive),
      expression: "isDemographicsTabActive"
    }],
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": "el-icon-edit",
      "type": "primary",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading
    },
    on: {
      "click": function($event) {
        !_vm.isProfileEditModeOn ? _vm.handleShowAlert() : _vm.openEnhanceProfileForm()
      }
    }
  }, [_vm._v("Enhance Profile")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": _vm.isProfileLocked ? 'Make profile accessible externally' : 'Make profile inaccessible externally',
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": _vm.isProfileLocked ? 'el-icon-unlock' : 'el-icon-lock',
      "type": "default",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleLockProfileState
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isProfileLocked ? 'Unlock Profile' : 'Lock Profile') + "\n        ")])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Delete profile",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": "el-icon-delete",
      "type": "danger",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading
    },
    on: {
      "click": function($event) {
        !_vm.isProfileEditModeOn ? _vm.handleShowAlert() : _vm.handleDeleteProfile()
      }
    }
  }, [_vm._v("Delete Profile")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 3347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dashboard-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('scheduled-post-list', {
    attrs: {
      "channels": _vm.socialChannels,
      "posts": _vm.scheduledMessages
    },
    on: {
      "newPost": _vm.onAddNewPost,
      "editPost": _vm.onEditPost,
      "deletePost": _vm.onDeleteScheduledPost
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('social-post-calendar', {
    attrs: {
      "channels": _vm.socialChannels,
      "posts": _vm.scheduledMessages
    },
    on: {
      "newPost": _vm.onAddNewPost,
      "editPost": _vm.onEditPost
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', [_vm._v("Scheduled Posts")])])])
}]}

/***/ }),
/* 3348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('div', {
    staticClass: "row animated fadeInUp"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('filebox-list', {
    attrs: {
      "icons": _vm.icons,
      "myFiles": _vm.myFiles,
      "companyFiles": _vm.companyFiles,
      "loadingMyFiles": _vm.loadingMyFiles,
      "loadingCompanyFiles": _vm.loadingCompanyFiles
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 3349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Create WeChat Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    ref: "wechatChannelForm",
    attrs: {
      "model": _vm.wechatChannelForm,
      "rules": _vm.wechatChannelFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "WeChat Name"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.name),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "name", $$v)
      },
      expression: "wechatChannelForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "token",
      "label": "Token"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.token),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "token", $$v)
      },
      expression: "wechatChannelForm.token"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "token_secret",
      "label": "Token Secret"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.token_secret),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "token_secret", $$v)
      },
      expression: "wechatChannelForm.token_secret"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addingWechatChannel,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.addingWechatChannel) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "users"
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Users")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "create",
      "subject": "add-user"
    }
  }, [_c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add user",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.manageUser(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("General user login and profile information for employees using the system.")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content user-list-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "input form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search users..."
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n            ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.results,
      "fit": true,
      "default-sort": {
        prop: 'display_name'
      },
      "empty-text": !_vm.results.length && _vm.users.length ? ("No users found matching " + _vm.keyword) : 'No users',
      "max-height": "400",
      "width": "100%",
      "row-key": "id",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "avatar",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "user-avatar",
          attrs: {
            "src": scope.row.avatar || scope.row.gravatar
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'client-link',
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.manageUser(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.display_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "job_title",
      "label": "Job title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "fa fa-envelope"
        }), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.email))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "Roles"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "client-status pull-right"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Company Admin",
            "placement": "top"
          }
        }, [(scope.row.is_admin) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Organization Admin",
            "placement": "top"
          }
        }, [(scope.row.is_org_admin) ? _c('span', {
          staticClass: "label label-primary"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Inactive",
            "placement": "top"
          }
        }, [(!scope.row.user_is_active) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Active",
            "placement": "top"
          }
        }, [(scope.row.user_is_active) ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v(" ")]) : _vm._e()])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loggedInUser.is_admin) ? _c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom",
            "show-timeout": 100,
            "hide-on-click": false
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                  Actions\n                  "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.manageUser(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), (_vm.loggedInUser.id != scope.row.id && scope.row.user_is_active === true) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.deleteUser(scope.row)
            }
          }
        }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.loggedInUser.id != scope.row.id && scope.row.user_is_active === true) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.showPasswordResetPopup(scope.row)
            }
          }
        }, [_vm._v("Change Password")]) : _vm._e()], 1)], 1) : _vm._e()]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "edit",
      "subject": "accounts-users"
    }
  }, [(_vm.showUserManage) ? _c('el-dialog', {
    attrs: {
      "title": _vm.selectedUser.id ? 'Edit User' : 'New User',
      "visible": _vm.showUserManage,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showUserManage = $event
      }
    }
  }, [(_vm.showUserManage) ? _c('user-manage', {
    attrs: {
      "user": _vm.selectedUser,
      "groups": _vm.groups,
      "loggedInUser": _vm.loggedInUser
    },
    on: {
      "cancelled": function($event) {
        _vm.showUserManage = false
      },
      "saved": _vm.handleSaved,
      "saveError": _vm.handleSaveError
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.restPasswordDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "Reset Password",
      "visible": _vm.restPasswordDialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.restPasswordDialogVisible = $event
      }
    }
  }, [_c('PasswordOnlyResetFormOnUserList')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('afstereo-dashboard', {
    attrs: {
      "selectedDate": _vm.selectedDate,
      "selectedPeriod": _vm.selectedPeriod,
      "selectedStation": _vm.selectedStation,
      "chartsData": _vm.chartsData,
      "stations": _vm.stations,
      "pluginEnabled": _vm.isPluginEnabled('app.dashboard.afstereo')
    },
    on: {
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changePeriod": function($event) {
        return _vm.handleChangePeriod($event)
      },
      "changeStation": function($event) {
        return _vm.handleChangeStation($event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('el-dialog', {
    attrs: {
      "title": "New Instant Poll",
      "visible": _vm.visible,
      "top": "5vh"
    },
    on: {
      "close": function($event) {
        return _vm.handleCloseDialog('close')
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "instantPollForm",
    staticClass: "instant-poll",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "190px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "campaignTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.form.campaignTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "campaignTitle", $$v)
      },
      expression: "form.campaignTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "campaignDates"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "To"
    },
    model: {
      value: (_vm.form.campaignDates),
      callback: function($$v) {
        _vm.$set(_vm.form, "campaignDates", $$v)
      },
      expression: "form.campaignDates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Channels",
      "prop": "channels"
    }
  }, [_c('el-cascader', {
    staticClass: "full-width",
    attrs: {
      "options": _vm.groupedChannels,
      "props": {
        multiple: true,
        checkStrictly: false
      },
      "clearable": ""
    },
    model: {
      value: (_vm.form.channels),
      callback: function($$v) {
        _vm.$set(_vm.form, "channels", $$v)
      },
      expression: "form.channels"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Only count unique",
      "prop": "isUnique"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.isUnique),
      callback: function($$v) {
        _vm.$set(_vm.form, "isUnique", $$v)
      },
      expression: "form.isUnique"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keyword"
    }
  }, [_vm._l((_vm.form.channelKeyword), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticStyle: {
        "margin-left": "2px"
      },
      attrs: {
        "disable-transitions": false,
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.keywordInputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add keyword")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Press enter key after each keyword added.")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseDialog('cancel')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.mutationLoading
    },
    on: {
      "click": _vm.handleCreateInstantPoll
    }
  }, [(_vm.mutationLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n            Save\n          ")])], 1)])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": "Search profile..."
    },
    on: {
      "clear": _vm.reset
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchProfile($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('el-button', {
          attrs: {
            "disabled": !_vm.canSearch
          },
          nativeOn: {
            "click": function($event) {
              return _vm.searchProfile($event)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-search"
        }), _vm._v(" Search Profile\n      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('social-post', {
    attrs: {
      "channels": _vm.channels,
      "post": _vm.post,
      "editPost": _vm.isEditing
    },
    on: {
      "send": _vm.onSendPost,
      "update": _vm.onUpdatePost,
      "delete": _vm.onDeletePost,
      "close": _vm.onClose
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("Search for interactions. Toggle advanced seach to do an advanced search")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSimpleSearch($event)
      }
    }
  }, [(!_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "simple"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search....",
      "name": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSimpleSearch($event)
      }
    },
    model: {
      value: (_vm.currentSearchTerm),
      callback: function($$v) {
        _vm.currentSearchTerm = $$v
      },
      expression: "currentSearchTerm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleSimpleSearch
    }
  }, [_vm._v("Search")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "advanced"
  }, [_c('advanced-search-form', {
    attrs: {
      "search-fields": _vm.searchFields
    },
    on: {
      "onSearch": _vm.handleAdvancedSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "block",
      "padding-top": "10px"
    },
    attrs: {
      "active-color": "#683090",
      "inactive-color": "#683090",
      "active-text": "Advanced",
      "inactive-text": "Simple"
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  })], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'fixed-container': true
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title",
    style: ({
      'border-top': "2px solid #ee2465"
    })
  }, [_c('h5', [(!_vm.searching) ? _c('span', [_vm._v(_vm._s(_vm.searchCount.toLocaleString()) + " results found.")]) : _vm._e(), _vm._v(" "), (_vm.searching) ? _c('span', [_vm._v("Searching...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.searchCount > 0) ? _c('el-tooltip', {
    attrs: {
      "content": "Export to Excel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.toggleDownload
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.searchCount > 0 && _vm.showPanelDownload) ? _c('div', {
    staticClass: "panel-download"
  }, [_c('el-input', {
    staticStyle: {
      "margin": "5px auto"
    },
    attrs: {
      "placeholder": "File name",
      "size": "mini"
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.filename),
      expression: "!!filename"
    }],
    staticClass: "fa fa-times el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    on: {
      "click": _vm.clearFileNameInput
    },
    slot: "prefix"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.filename),
      expression: "!filename"
    }],
    staticClass: "el-icon-download el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": _vm.filename.length < 1,
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.exportToFile(_vm.filename)
      }
    },
    slot: "append"
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("Interactions search results")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content content-style",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: 'content',
    staticClass: "ibox-content content-style",
    attrs: {
      "settings": _vm.scrollBarSettings
    }
  }, _vm._l((_vm.searchResults), function(interaction) {
    return _c('div', {
      key: interaction.id,
      staticClass: "search-results"
    }, [_c('div', {
      staticClass: "search-result"
    }, [_c('interaction', {
      attrs: {
        "interaction": interaction
      }
    })], 1)])
  }), 0)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Search")])])
}]}

/***/ }),
/* 3356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-item container-fluid",
    class: _vm.choiceScaleClass
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [(!_vm.isEditing) ? _c('div', {
    staticClass: "choice-polarity"
  }, [_vm._v(_vm._s(_vm.polarityIndicator))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "choice-title"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing || !_vm.isEditable),
      expression: "!isEditing || !isEditable"
    }]
  }, [_vm._v(_vm._s(_vm.choice.title))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing && _vm.isEditable),
      expression: "isEditing && isEditable"
    }]
  }, [_c('el-input', {
    ref: "choiceInput",
    staticClass: "choice-editor",
    attrs: {
      "size": "mini",
      "autofocus": true,
      "focus": true
    },
    on: {
      "blur": _vm.handleInputBlur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleUpdateChoice($event)
      }
    },
    model: {
      value: (_vm.editTitle),
      callback: function($$v) {
        _vm.editTitle = $$v
      },
      expression: "editTitle"
    }
  })], 1)])]), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    staticClass: "col-xs-3"
  }, [_c('span', {
    staticClass: "choice-tools pull-right"
  }, [(_vm.isConditional) ? _c('span', {
    staticClass: "conditional-link",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('conditional-link-select', {
    attrs: {
      "excludeQuestions": [_vm.question.id]
    },
    model: {
      value: (_vm.computedConditionalLink),
      callback: function($$v) {
        _vm.computedConditionalLink = $$v
      },
      expression: "computedConditionalLink"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', [_c('el-tooltip', {
    attrs: {
      "content": "Conditional link"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-link",
    on: {
      "click": _vm.handleToggleConditional
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "tool-divider"
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Edit"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil",
    on: {
      "click": _vm.handleEdit
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash",
    on: {
      "click": _vm.handleRemove
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tool-divider"
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "handle"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-navicon"
  })])
}]}

/***/ }),
/* 3357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "before-close": _vm.handleCancel,
      "title": "Exported respondents"
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.surveyExports
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Created",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("moment")(scope.row.insertedAt, 'LL HH:mm')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "User",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(((scope.row.user.firstName) + " " + (scope.row.user.lastName))))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Export type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.survey) ? _c('div', [_c('div', {
          staticClass: "title"
        }, [_vm._v("Survey")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(scope.row.survey.title))])]) : _c('div', [_c('div', {
          staticClass: "title"
        }, [_vm._v("Period")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.title(scope.row.periodType)) + "\n            "), (scope.row.periodType !== 'LIFETIME') ? _c('span', [_vm._v("from " + _vm._s(_vm._f("moment")(scope.row.periodDate, 'Do MMM YYYY')))]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-right"
        }, [_c('a', {
          attrs: {
            "href": scope.row.fileUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-download"
        })])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Post Insights")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search post...",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeSearch
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onChangeSearch
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "insights-container"
  }, [_c('loader', {
    attrs: {
      "message": "Loading Post Insights",
      "shadow": "none"
    }
  })], 1) : _c('div', _vm._l((_vm.getPostInsights), function(postInsight) {
    return _c('div', {
      key: postInsight.post_id,
      staticClass: "post-insight"
    }, [_c('div', {
      staticClass: "text-center post-content"
    }, [_vm._v(_vm._s(postInsight.message.text))]), _vm._v(" "), _c('div', {
      staticClass: "insights-container"
    }, [_c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Impression',
        "description": 'The number of times your Pages post entered a persons screen.\
                    Posts include statuses, photos, links, videos and more.',
        "value": _vm.getInsightValue(postInsight, 'impressions.total')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged users',
        "description": 'The number of unique people who engaged in certain ways with your Page post,\
                    for example by commenting on, liking, sharing, or clicking upon particular elements of the post.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_engaged_users')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged fans',
        "description": 'The number of people who have liked your Page and clicked anywhere in your posts.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_engaged_fan')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged clicks',
        "description": 'The number of clicks anywhere in your post on News Feed from the user that matched\
                    the audience targeting on it.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_clicks')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-reactions', {
      staticClass: "text-center",
      attrs: {
        "reaction": postInsight.reactions
      }
    })], 1)])])])
  }), 0)]), _vm._v(" "), _c('el-pagination', {
    staticClass: "text-center paginate",
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": 1,
      "total": _vm.pages
    },
    on: {
      "current-change": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, _vm._l((_vm.insightItems), function(item) {
    return _c('page-views-item', {
      key: item.name,
      staticClass: "metric-item",
      attrs: {
        "title": item.title,
        "description": item.description,
        "chartData": item.data,
        "stacked": item.stacked,
        "showLegend": item.showLegend,
        "type": item.type
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 3360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-item row",
    staticStyle: {
      "width": "470px !important"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showFieldLabel) ? _c('span', {
    staticClass: "item-label"
  }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 values"
  }, [_vm._l(([_vm.sortedFields[0]]), function(field, i) {
    return _c('span', {
      key: i
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('strong', [_vm._v("Confirmations:")]), _vm._v("\n          " + _vm._s(_vm.getFieldValue(field).confirmations) + "\n          "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Score:")]), _vm._v("\n          " + _vm._s(_vm.getFieldValue(field).score.toFixed(2)) + "\n        ")]), _vm._v(" "), (_vm.getFieldLabel(field) && !Array.isArray(_vm.getFieldValue(field).value) && field !== null) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.showNuggetOptions(_vm.getFieldValue(field).value)
        }
      }
    }, [_c('el-tag', {
      staticClass: "item-value",
      attrs: {
        "size": "small"
      }
    }, [_vm._v("\n            " + _vm._s(field && field.hasOwnProperty('friendly_value') ?
      field.friendly_value :
      _vm.findLangaugeNameFromKey(_vm.getFieldValue(field).value).includes('N/A') ?
      _vm.getFieldValue(field).value :
      _vm.findLangaugeNameFromKey(_vm.getFieldValue(field).value)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (Array.isArray(_vm.getFieldValue(field).value)) ? _c('span', _vm._l((_vm.getFieldValue(field).value), function(value) {
      return _c('span', {
        key: value,
        staticClass: "item-value",
        style: ({
          'background-color': _vm.scoreColor(_vm.getFieldValue(field).value, field),
        }),
        attrs: {
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.showNuggetOptions(value)
          }
        }
      }, [_vm._v(_vm._s(value))])
    }), 0) : _vm._e()])], 1)
  }), _vm._v(" "), (_vm.label === 'Location') ? _c('span', {
    staticClass: "location-marker",
    on: {
      "click": _vm.handleOpenProfileMap
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('NuggetOptions', {
    attrs: {
      "show": _vm.optionsVisible,
      "nuggetValue": _vm.selectedNuggetValue,
      "nuggetLabel": _vm.label,
      "nuggetKey": _vm.fieldKey,
      "category": _vm.category,
      "profileId": _vm.profileId
    },
    on: {
      "closeDialog": _vm.closeOptionsDialog,
      "removeNugget": function (cfg) { return _vm.$emit('removeNugget', cfg); },
      "blacklistNugget": function (cfg) { return _vm.$emit('blacklistNugget', cfg); }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "timeslots"
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Timeslots")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('can', {
    attrs: {
      "action": "edit",
      "subject": "timeslots"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add timeslot",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.editTimeslot(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("On which days and at what times do our various radio shows commence?")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content timeslot-list-content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "row-key": "id",
      "max-height": "400",
      "width": "100%",
      "show-timeout": 150,
      "data": _vm.timeslots,
      "fit": true,
      "default-sort": {
        prop: 'title'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "Title",
      "class-name": 'client-link'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.editTimeslot(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.title))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.days,
      "label": "Days",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.times,
      "label": "Times",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "color",
      "label": "Color",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: (_vm.getCellStyle(scope.row)),
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom"
          },
          on: {
            "command": _vm.handleTimeslotAction
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                  Actions\n                  "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.editTimeslot,
              item: scope.row.id
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.deleteTimeslot,
              item: scope.row.id
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": this.isNewTimeslot ? 'New Timeslot' : 'Edit Timeslot',
      "visible": _vm.showEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditDialog = $event
      }
    }
  }, [(_vm.showEditDialog) ? _c('timeslot-edit', {
    attrs: {
      "weekdays": _vm.weekdays,
      "is-new": _vm.isNewTimeslot
    },
    on: {
      "cancel": function($event) {
        _vm.showEditDialog = false
      },
      "save": _vm.saveTimeslot
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', [_c('h3', [_vm._v("Survey details")]), _vm._v(" "), _c('el-form', {
    ref: "surveyForm",
    attrs: {
      "model": _vm.surveyForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "300px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.title),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "title", $$v)
      },
      expression: "surveyForm.title"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("What would you like this survey to be called?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.description),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "description", $$v)
      },
      expression: "surveyForm.description"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("A brief summary of what our survey is about.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date range",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.surveyForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "dateRange", $$v)
      },
      expression: "surveyForm.dateRange"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Period of time in which we'll be running this survey.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Survey Type",
      "prop": "surveyType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.surveyForm.surveyType),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "surveyType", $$v)
      },
      expression: "surveyForm.surveyType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "QUALITATIVE"
    }
  }, [_vm._v("Qualitative Survey")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "MUSIC"
    }
  }, [_vm._v("Music Survey")])], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Completion")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "On survey completed"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.surveyForm.successAutoRedirect),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successAutoRedirect", $$v)
      },
      expression: "surveyForm.successAutoRedirect"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("Display a message")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Redirect to a webpage")])], 1), _vm._v(" "), _c('help-text', [_vm._v("What should we do once a listener has completed this survey?")])], 1), _vm._v(" "), (!_vm.surveyForm.successAutoRedirect) ? _c('el-form-item', {
    attrs: {
      "label": "Success message",
      "prop": "successText"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.surveyForm.successText),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successText", $$v)
      },
      expression: "surveyForm.successText"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Once the listener has completed their survey, we'll display this message.")])], 1) : _vm._e(), _vm._v(" "), (_vm.surveyForm.successAutoRedirect) ? _c('el-form-item', {
    attrs: {
      "label": "Redirect URL",
      "prop": "successRedirect"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.successRedirect),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successRedirect", $$v)
      },
      expression: "surveyForm.successRedirect"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Once the listener has completed their survey, we'll take them to this webpage.")])], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Privacy")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Privacy Policy URL",
      "prop": "privacyPolicy"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.privacyPolicy),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "privacyPolicy", $$v)
      },
      expression: "surveyForm.privacyPolicy"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Should we include a link to our privacy policy?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Collect non voluntary identifiers",
      "prop": "collectNonVoluntaryIdentifiers"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.surveyForm.collectNonVoluntaryIdentifiers),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "collectNonVoluntaryIdentifiers", $$v)
      },
      expression: "surveyForm.collectNonVoluntaryIdentifiers"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        Should we capture information from the listener's browser, that could uniquely identify\n        the listener, such as ip address and browser / device fingerprints? (Please make mention\n        of this within your privacy policy should you choose this option)\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show progress bar",
      "prop": "showProgressBar"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.surveyForm.showProgressBar),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "showProgressBar", $$v)
      },
      expression: "surveyForm.showProgressBar"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        Turning this on will show a progress Bar at the bottom of each survey page.\n      ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handleSaveSurvey
    }
  }, [_vm._v("Save Survey")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-pie-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper navbar-mini"
    }
  }, [_vm._t("side-menu"), _vm._v(" "), _c('div', {
    staticClass: "gray-bg",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_vm._t("header"), _vm._v(" "), (_vm.action && _vm.subject) ? _c('can', {
    attrs: {
      "action": _vm.action,
      "subject": _vm.subject,
      "is-page": true
    }
  }, [_c('router-view')], 1) : _c('div', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _vm._t("footer")], 2), _vm._v(" "), _vm._t("toast"), _vm._v(" "), _vm._t("alerts")], 2)
},staticRenderFns: []}

/***/ }),
/* 3365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('segmentation-dashboard', {
    attrs: {
      "summary": _vm.segmentSummary,
      "insights": _vm.segmentInsights,
      "segment-stats": _vm.segmentStats.segments,
      "segment-tags": _vm.segmentTags.segments,
      "listeners": _vm.filterListeners,
      "aggregate": _vm.aggregateListeners,
      "cross-channel": _vm.crossChannelEngagement,
      "selected-listener": _vm.selectedListenerProfile,
      "recommendation-result": _vm.recommendationResult,
      "base-aggregate": _vm.baseAggregate,
      "is-search": !!_vm.searchQuery,
      "completeness": _vm.profileCompleteness,
      "recommend-error": _vm.recommendError,
      "credits-exhausted": _vm.creditsExhausted,
      "enriching": _vm.enriching,
      "enrich-credits-exhausted": _vm.enrichCreditsExhausted,
      "segment-freshness": _vm.segmentFreshness,
      "refreshing": _vm.refreshing,
      "loading-completeness": _vm.$apollo.queries.profileCompleteness.loading,
      "loading-summary": _vm.$apollo.queries.segmentSummary.loading,
      "load-total": _vm.loadNames.length,
      "load-done": _vm.loadNames.length - _vm.pendingLoads.length,
      "load-errors": _vm.loadErrorMessages,
      "segmentation-enabled": _vm.segmentationEnabled || !_vm.pluginsKnown,
      "loading-insights": _vm.$apollo.queries.segmentInsights.loading,
      "loading-listeners": _vm.$apollo.queries.filterListeners.loading,
      "loading-aggregate": _vm.$apollo.queries.aggregateListeners.loading
    },
    on: {
      "refresh": _vm.handleRefresh,
      "filter": _vm.handleFilter,
      "load-more": _vm.handleLoadMore,
      "recommend": _vm.handleRecommend,
      "recommend-cleared": _vm.handleRecommendCleared,
      "recommendation-used": _vm.handleRecommendationUsed,
      "enrich": _vm.handleEnrich,
      "find-similar": _vm.handleFindSimilar,
      "apply-inferred": _vm.handleApplyInferred,
      "review-link": _vm.handleReviewLink,
      "replace-demographic": _vm.handleReplaceDemographic,
      "deploy": _vm.handleDeploy,
      "open-listener": _vm.handleOpenListener,
      "close-listener": _vm.handleCloseListener,
      "view-profile": _vm.handleViewProfile
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row profile-dashboard-wrapper border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-4 col-xl-3"
  }, [_c('h2', [_vm._v("\n        Profiles Dashboard\n        "), (!_vm.loadingPlugins) ? _c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v(_vm._s(_vm.upperCase(_vm.mode)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(!_vm.loadingPlugins) ? _c('profiles-charts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'pro'),
      expression: "mode === 'pro'"
    }],
    attrs: {
      "id": "dashboard-charts",
      "loading": _vm.loadingCharts,
      "data": _vm.charts
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.loadingPlugins) ? _c('profiles-data-filter', {
    attrs: {
      "loading-profiles": _vm.loadingProfiles,
      "loading-saved-queries": _vm.loadingSavedQueries,
      "loading": _vm.loadingFilters,
      "searching": _vm.searching,
      "filters": _vm.filters,
      "results": _vm.results,
      "savedQueries": _vm.savedQueries,
      "mode": _vm.mode
    },
    on: {
      "filter": function($event) {
        return _vm.$emit('filter', $event)
      },
      "download": function($event) {
        return _vm.$emit('download', $event)
      },
      "display-profiles": function($event) {
        return _vm.$emit('display-profiles')
      },
      "load-more-profiles": function($event) {
        return _vm.$emit('load-more-profiles')
      },
      "save-query": function($event) {
        return _vm.$emit('save-query', $event)
      },
      "delete-query": function($event) {
        return _vm.$emit('delete-query', $event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('privacy-data-list', {
    staticClass: "privacy-list",
    attrs: {
      "isloading": _vm.loadingOptins
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('station-activity-dashboard', {
    attrs: {
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "stationActivityData": _vm.stationActivityData,
      "isLoading": _vm.loadingStationActivity
    },
    on: {
      "changeRegion": _vm.handleChangeRegion,
      "changeDate": _vm.handleChangeDate,
      "changePage": _vm.handleChangePage
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Demographics")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "content": _vm.demographicsDescription[_vm.selectedDemographicType],
      "placement": "bottom-start",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-fw fa-info-circle",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Channel",
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.demographicType),
      callback: function($$v) {
        _vm.demographicType = $$v
      },
      expression: "demographicType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "fans"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('loader', {
    attrs: {
      "message": "Loading demographics",
      "shadow": "none"
    }
  })], 1) : _c('div', {
    staticClass: "card-content"
  }, [(!_vm.hasData) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": _vm.facebookPage ? 'No data' : 'No channel connected'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "insights-container"
  }, _vm._l((_vm.demographicData), function(value, key) {
    return _c('DemographicsItem', {
      key: key,
      staticClass: "insight-item",
      attrs: {
        "data": value,
        "label": key
      }
    })
  }), 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 3369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('profile-permission-filter-card', {
    attrs: {
      "fixedHeight": false,
      "loading-profile": _vm.loadingProfile,
      "searching": _vm.searching,
      "results": _vm.results
    },
    on: {
      "search-profile": function($event) {
        return _vm.$emit('search-profile', $event)
      },
      "display-profile": function($event) {
        return _vm.$emit('display-profile')
      }
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xl-3"
  }, [_c('h2', [_vm._v("\n        Personal Information Management\n      ")])])])
}]}

/***/ }),
/* 3370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytic-unit-block-loader"
  }, [_c('content-loader', {
    attrs: {
      "height": 300,
      "width": 500,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "33",
      "y": "18.61",
      "rx": "3",
      "ry": "3",
      "width": "391.85",
      "height": "24.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "34",
      "y": "54.4",
      "rx": "3",
      "ry": "3",
      "width": "430.5",
      "height": "7.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "81",
      "rx": "3",
      "ry": "3",
      "width": "56.28",
      "height": "59.64"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "459.68",
      "cy": "32.7",
      "r": "11.7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "107.56",
      "y": "79.61",
      "rx": "0",
      "ry": "0",
      "width": "364",
      "height": "22"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "414.56",
      "y": "85.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "107.56",
      "y": "118.61",
      "rx": "0",
      "ry": "0",
      "width": "364",
      "height": "22"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.56",
      "y": "190",
      "rx": "0",
      "ry": "0",
      "width": "435",
      "height": "93"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 3371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper"
  }, _vm._l((_vm.count), function(item, index) {
    return (!_vm.textOnly) ? _c('div', {
      key: item,
      staticClass: "timeline-item"
    }, [_vm._m(0, true), _vm._v(" "), (index < (_vm.count - 1)) ? _c('hr') : _vm._e()]) : _c('div', {
      staticClass: "timeline-item"
    }, [(!_vm.textArray.length) ? _c('span', [_c('p', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm.textValue))])]) : _c('span', _vm._l((_vm.textArray), function(item) {
      return _c('p', {
        staticClass: "text-item"
      }, [_vm._v(_vm._s(item))])
    }), 0)])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated-background"
  }, [_c('div', {
    staticClass: "background-masker header-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker header-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker subheader-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-first-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-second-end"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "background-masker content-third-end"
  })])
}]}

/***/ }),
/* 3372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "top": "5vh",
      "visible": _vm.isVisible,
      "width": '25%',
      "custom-class": 'panel-settings-dialog',
      "title": 'Panel configuration'
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Settings for interactions that show up in the panel.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Name of the panel",
      "placement": "bottom"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Panel name"
    }
  }, [_c('el-input', {
    attrs: {
      "minlength": 1,
      "maxlength": 40,
      "disabled": _vm.panelType === 'onair'
    },
    model: {
      value: (_vm.settings.name),
      callback: function($$v) {
        _vm.$set(_vm.settings, "name", $$v)
      },
      expression: "settings.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Set the panel layout size",
      "placement": "bottom"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Column Layout"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.columns),
      callback: function($$v) {
        _vm.$set(_vm.settings, "columns", $$v)
      },
      expression: "settings.columns"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("1 Column")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("2 Column")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("3 Column")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Preload media"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Preload audio and video",
      "placement": "bottom"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.mediaPreload),
      callback: function($$v) {
        _vm.$set(_vm.settings, "mediaPreload", $$v)
      },
      expression: "settings.mediaPreload"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("On")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("Off")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType !== 'activity'),
      expression: "panelType !== 'activity'"
    }],
    attrs: {
      "label": "Panel Locker"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Panel exit locker",
      "placement": "bottom"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.panelLock),
      callback: function($$v) {
        _vm.$set(_vm.settings, "panelLock", $$v)
      },
      expression: "settings.panelLock"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("On")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("Off")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Panel Color"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Set a unique colour for your panel",
      "placement": "bottom"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.settings.colour),
      callback: function($$v) {
        _vm.$set(_vm.settings, "colour", $$v)
      },
      expression: "settings.colour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOnAirOrActivity),
      expression: "!isOnAirOrActivity"
    }],
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Select campaigns you want to get interactions from",
      "placement": "bottom"
    }
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n          Campaigns\n          "), _c('el-tooltip', {
    attrs: {
      "content": "Select All",
      "placement": "right"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.isAllCampaignsChecked),
      callback: function($$v) {
        _vm.isAllCampaignsChecked = $$v
      },
      expression: "isAllCampaignsChecked"
    }
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "large",
      "placeholder": "Select...",
      "filterable": "",
      "collapse-tags": "",
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.settings.campaign_ids),
      callback: function($$v) {
        _vm.$set(_vm.settings, "campaign_ids", $$v)
      },
      expression: "settings.campaign_ids"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOnAirOrActivity),
      expression: "!isOnAirOrActivity"
    }],
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Select channels you want to get interactions from",
      "placement": "bottom"
    }
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n          Channels\n          "), _c('el-tooltip', {
    attrs: {
      "content": "Select All",
      "placement": "right"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.isAllChannelsChecked),
      callback: function($$v) {
        _vm.isAllChannelsChecked = $$v
      },
      expression: "isAllChannelsChecked"
    }
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "placeholder": "Select...",
      "multiple": "",
      "filterable": "",
      "collapse-tags": "",
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.settings.channel_ids),
      callback: function($$v) {
        _vm.$set(_vm.settings, "channel_ids", $$v)
      },
      expression: "settings.channel_ids"
    }
  }, _vm._l((_vm.activeChannels), function(channel) {
    return _c('el-option', {
      key: channel.id,
      attrs: {
        "label": channel.title,
        "value": channel.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "0.7em",
        "margin-right": "1.6em"
      }
    }, [_vm._v(_vm._s(channel.channel_type_title))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.updatingSettings
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("Save Panel Settings")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Download messages"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("\n    From here you can download a collection of messages defined by your parameters to a CSV file.\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Channels",
      "prop": "channels"
    }
  }, [_c('channel-select', {
    attrs: {
      "channels": _vm.channelLinks,
      "selectedChannels": _vm.form.channels
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleRunDownloadMessages
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Download\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.data.datasets), function(item) {
    return _c('td', {
      key: item,
      attrs: {
        "width": "90px"
      }
    }, [(typeof(item[1]) != 'object') ? _c('span', {
      staticClass: "color",
      style: ({
        'background-color': _vm.generateTitleColor(item.label) + ' !important'
      })
    }) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.choices), function(choice, index) {
    return _c('tr', {
      key: choice
    }, [_c('td', {
      staticClass: "align-left"
    }, [_vm._v(_vm._s(choice))]), _vm._v(" "), _vm._l((_vm.data.datasets[index].data), function(result) {
      return _c('td', {
        key: result,
        staticClass: "align-center"
      }, [_vm._v("\n          " + _vm._s(result) + "\n          "), (_vm.isPercentage) ? _c('span', [_vm._v("%")]) : _vm._e()])
    })], 2)
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 3375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.selectorActive),
      callback: function($$v) {
        _vm.selectorActive = $$v
      },
      expression: "selectorActive"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Questions",
      "name": "questions"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Questions")])]), _vm._v(" "), _c('question-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "templates"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Template for choices")])]), _vm._v(" "), _c('choice-template-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "choices"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('h3', [_vm._v("Choices")])]), _vm._v(" "), _c('choice-selector', {
    attrs: {
      "isFixed": _vm.selectorFixed,
      "isEditable": _vm.survey.isPreview
    }
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('password-reset-form', {
    attrs: {
      "isPending": _vm.passwordResetPending,
      "hasFailed": _vm.passwordResetFailed,
      "hasSucceeded": _vm.passwordResetSucceeded
    },
    on: {
      "onPasswordReset": function($event) {
        return _vm.onPasswordReset($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.listName,
      "visible": _vm.dialogVisible,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "open": _vm.fetchContacts,
      "closed": _vm.clearContacts
    }
  }, [(_vm.$apollo.loading) ? _c('loader', {
    attrs: {
      "msg": "Loading Contacts"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.listContacts), function(contact) {
    return _c('div', {
      key: contact.id
    }, [_c('span', [_vm._v(_vm._s(contact.firstName) + " " + _vm._s(contact.lastName))])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 3378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    staticClass: "metric-unit"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "unit-title"
  }, [_c('el-popover', {
    ref: "popover-hint",
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle pull-right",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.type === 'bar') ? _c('bar-chart', {
    staticClass: "content-chart",
    attrs: {
      "data": _vm.chartData,
      "stacked": _vm.stacked,
      "showLegend": _vm.showLegend
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'horizontal-bar') ? _c('horizontal-bar-chart', {
    staticClass: "content-chart",
    attrs: {
      "data": _vm.chartData,
      "stacked": _vm.stacked,
      "showLegend": _vm.showLegend
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar-default navbar-static-side"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCollapsed),
      expression: "sidebarCollapsed"
    }]
  }, [_c('el-menu', {
    staticStyle: {
      "padding-bottom": "0px !important"
    },
    attrs: {
      "collapse": _vm.sidebarCollapsed,
      "router": false,
      "unique-opened": true
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interactions"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(2830)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("home")])])], 1)], 1), _vm._v(" "), _c('perfect-scrollbar', [_c('el-menu', {
    staticClass: "custom-scroll side-menu-padding-bottom",
    attrs: {
      "id": "side-menu",
      "collapse": _vm.sidebarCollapsed,
      "router": true,
      "unique-opened": true
    }
  }, [_c('can', {
    attrs: {
      "action": "view",
      "subject": "campaigns"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/campaigns"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Campaigns")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/interactions",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Interactions")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions"
    }
  }, [(_vm.pluginEnabled('app.dashboard.radio')) ? _c('el-menu-item', {
    attrs: {
      "index": "/interactions"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Dashboard")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "interactions-search"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interactions/search"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Search")])])], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "analytics"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/analytics",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Analytics")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "programming"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/analytics/programming"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Programming")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "afstereo",
      "region": "za"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/analytics/afstereo"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("AFSTEREO")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "voice-analytics"
    }
  }, [(_vm.pluginEnabled('app.dashboard.audio_transcriber')) ? _c('el-menu-item', {
    attrs: {
      "index": "/analytics/voice-intelligence"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Voice Intelligence")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "qualitative"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/qualitative",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Qualitative")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "surveys"
    }
  }, [(_vm.me.is_admin) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveys"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Qualitative Ratings")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "audience"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/audience/contacts"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Audience")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin"
    }
  }, [(_vm.user.is_admin) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveys/filter"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Survey Filter")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "survey-builder"
    }
  }, [(_vm.pluginEnabled('app.dashboard.qualitative')) ? _c('el-menu-item', {
    attrs: {
      "index": "/surveybuilder"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Survey Builder")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "social"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/social"
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Social")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/social/analytics"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Social Analytics")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/social/schedules"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Scheduled Posts")])])], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "/profiles",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profiles"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles Dashboard")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [(_vm.pluginEnabled('app.profiles.segmentation')) ? _c('el-menu-item', {
    attrs: {
      "index": "/segmentation",
      "title": "Smart Segmentation and Targeting"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Smart Segmentation")])]) : _vm._e()], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [(_vm.pluginEnabled('app.profiles.permissions')) ? _c('el-menu-item', {
    attrs: {
      "index": "/permissions"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("PI Management")])]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "channels"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Channels")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "filebox"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/filebox"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Filebox")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "company"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/company"
    }
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("My Station")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin"
    }
  }, [(_vm.user.is_staff) ? _c('el-submenu', {
    attrs: {
      "index": "/admin",
      "show-timeout": _vm.showSubmenuTimeout
    }
  }, [_c('template', {
    staticClass: "menu-title",
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "false"
    }
  }), _vm._v(" "), (_vm.sidebarCollapsed) ? _c('i', {
    staticClass: "fa fa-angle-right"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Admin")])]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "admin-station-activity"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin/stationActivity"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Station Activity")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "email-dashboard"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin/templates"
    }
  }, [_c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Email Templates")])])], 1), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "profiles"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profiles_admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Profiles")])])], 1)], 2) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-header profile-element"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(298)
    }
  })])
}]}

/***/ }),
/* 3380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "pull-right text-muted count"
  }, [_c('em', [_vm._v("n")]), _vm._v("\n      =" + _vm._s(_vm.totalRespondents) + "\n    ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), (_vm.profileCharts && Object.keys(_vm.profileCharts).length > 0) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((Math.ceil(Object.keys(_vm.profileCharts).length / _vm.itemsPerRow)), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((Object.keys(_vm.profileCharts).sort().slice((i - 1) * _vm.itemsPerRow, i * _vm.itemsPerRow)), function(key) {
      return _c('div', {
        key: key,
        staticClass: "col-lg-3"
      }, [_c('h4', [_vm._v(_vm._s(_vm.capitalise(key)))]), _vm._v(" "), (false) ? _c('div', [_c('div', {
        staticClass: "gender-respondents"
      }, [_c('div', {
        staticClass: "gender-block"
      }, [_c('div', {
        on: {
          "click": function($event) {
            _vm.handleGenderClicked($event, 'Gender', _vm.genderItem('Male'))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-male",
        style: ({
          color: _vm.generateTitleColor('male', _vm.hueRange)
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "gender-percentage"
      }, [_vm._v(_vm._s(_vm.profileGender('Male')))])]), _vm._v(" "), _c('div', {
        staticClass: "gender-block"
      }, [_c('div', {
        on: {
          "click": function($event) {
            _vm.handleGenderClicked($event, 'Gender', _vm.genderItem('Female'))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-female",
        style: ({
          color: _vm.generateTitleColor('female', _vm.hueRange)
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "gender-percentage"
      }, [_vm._v(_vm._s(_vm.profileGender('Female')))])])]), _vm._v(" "), _c('chart-legend', {
        attrs: {
          "data": [
            ['Male', _vm.profileGender('Male')],
            ['Female', _vm.profileGender('Female')]
          ],
          "colorCycle": [_vm.generateTitleColor('male', _vm.hueRange), _vm.generateTitleColor('female', _vm.hueRange)]
        }
      })], 1) : _vm._e(), _vm._v(" "), (true) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "155px"
        }
      }, [_c('pie-chart', {
        attrs: {
          "height": 155,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.profileCharts[key]), _vm.hueRange),
          "data": _vm.totalDisplay(_vm.profileCharts[key]),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleProfileClicked($event, key, _vm.profileCharts[key])
          }
        }
      })], 1), _vm._v(" "), _c('chart-legend', {
        attrs: {
          "data": _vm.totalDisplay(_vm.profileCharts[key]),
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.profileCharts[key]), _vm.hueRange),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      })], 1) : _vm._e()])
    }), 0)
  }), 0) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('empty', [_vm._v("No respondents found.")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-telegram"
  })
},staticRenderFns: []}

/***/ }),
/* 3382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.campaign) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaign"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaign) ? _c('div', [_c('campaign-detail', {
    attrs: {
      "id": parseInt(_vm.campaign.id, 10),
      "campaign": _vm.campaign,
      "interactions": _vm.interactions,
      "loadingCampaignReport": _vm.loadingCampaignReport,
      "campaignReportData": _vm.campaignReportData,
      "icons": _vm.icons,
      "channelTypes": _vm.channelTypes,
      "replyMessage": _vm.replyMessage
    },
    on: {
      "onDownloadMessage": function($event) {
        return _vm.onDownloadMessage($event)
      },
      "onRandomSelector": function($event) {
        return _vm.onRandomSelector($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('thread-dialog')], 1)
},staticRenderFns: []}

/***/ }),
/* 3383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentMatrixChoice) ? _c('el-dialog', {
    attrs: {
      "title": "Select visibility condition",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "help-description"
  }, [_vm._v("\n    Only display the question\n    "), _c('strong', [_vm._v("\"" + _vm._s(_vm.currentMatrixChoice.title) + "\"")]), _vm._v(", once the user has selected a specific\n    choice from one of the following questions.\n  ")]), _vm._v(" "), _vm._l((_vm.availableMatrixChoices), function(matrixChoice) {
    return _c('div', {
      key: matrixChoice.id,
      staticClass: "matrix-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(matrixChoice.title))]), _vm._v(" "), _c('el-radio-group', {
      attrs: {
        "size": "mini"
      },
      model: {
        value: (_vm.currentMatrixChoice.visibleIf),
        callback: function($$v) {
          _vm.$set(_vm.currentMatrixChoice, "visibleIf", $$v)
        },
        expression: "currentMatrixChoice.visibleIf"
      }
    }, [_c('span', _vm._l((matrixChoice.choices), function(choice) {
      return _c('el-radio-button', {
        key: choice.id,
        attrs: {
          "label": ("{row.matrix" + (matrixChoice.id) + "}='" + (choice.title) + "'")
        }
      }, [_vm._v(_vm._s(choice.title))])
    }), 1)])], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "disabled": !_vm.currentMatrixChoice,
      "type": "danger"
    },
    on: {
      "click": _vm.handleRemoveLinks
    }
  }, [_vm._v("Remove condition")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 3384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insight-item"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [_c('el-popover', {
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('h5', {
    staticClass: "unit-title",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("Reactions")])])], 1), _vm._v(" "), (_vm.reaction && _vm.reaction.total) ? _c('div', _vm._l((_vm.reactionsMap), function(cfg, key) {
    return _c('span', {
      key: key
    }, [(_vm.reaction[key]) ? _c('el-tooltip', {
      attrs: {
        "content": key
      }
    }, [_c('el-badge', {
      staticClass: "reaction",
      attrs: {
        "value": _vm.reaction[key] || 0
      }
    }, [_c('emoji', {
      staticClass: "emoji-icon",
      attrs: {
        "emoji": cfg.emoji,
        "set": _vm.emojiSet,
        "size": _vm.size
      }
    })], 1)], 1) : _vm._e()], 1)
  }), 0) : _c('div', {
    staticClass: "no-reactions"
  }, [_vm._v("None")])])
},staticRenderFns: []}

/***/ }),
/* 3385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PasswordRestWithTokenForm', {
    attrs: {
      "isPending": _vm.passwordResetPending,
      "hasFailed": _vm.passwordResetFailed,
      "hasSucceeded": _vm.passwordResetSucceeded
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 3387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": !_vm.hasPrevious,
      "type": "button"
    },
    on: {
      "click": _vm.handlePreviousButton
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('button', {
      key: page,
      staticClass: "btn btn-white",
      class: {
        'active': _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          return _vm.handlePageSelection(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasNext
    },
    on: {
      "click": _vm.handleNextButton
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])], 2)
},staticRenderFns: []}

/***/ }),
/* 3388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sticky row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-center"
  }, [_c('div', {
    staticClass: "filters"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Filter by"
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.filterBy),
      callback: function($$v) {
        _vm.filterBy = $$v
      },
      expression: "filterBy"
    }
  }, [_c('el-option', {
    key: 'survey',
    attrs: {
      "value": 'survey',
      "label": 'Survey'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'period',
    attrs: {
      "value": 'period',
      "label": 'Period'
    }
  })], 1), _vm._v(" "), (_vm.filterBy === 'survey') ? _c('el-select', {
    attrs: {
      "placeholder": "Select survey",
      "filterable": "",
      "value": _vm.selectedSurvey
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedSurvey),
      callback: function($$v) {
        _vm.selectedSurvey = $$v
      },
      expression: "selectedSurvey"
    }
  }, _vm._l((_vm.surveys), function(survey) {
    return _c('el-option', {
      key: survey.id,
      attrs: {
        "value": survey.id,
        "label": survey.title
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period') ? _c('el-select', {
    attrs: {
      "placeholder": "Select period",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriod),
      callback: function($$v) {
        _vm.selectedPeriod = $$v
      },
      expression: "selectedPeriod"
    }
  }, [_c('el-option', {
    key: 'month',
    attrs: {
      "value": 'month',
      "label": 'Monthly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'quarter',
    attrs: {
      "value": 'quarter',
      "label": 'Quarterly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'year',
    attrs: {
      "value": 'annual',
      "label": 'Yearly'
    }
  }), _vm._v(" "), _c('el-option', {
    key: 'lifetime',
    attrs: {
      "value": 'lifetime',
      "label": 'Lifetime'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'month') ? _c('el-select', {
    attrs: {
      "placeholder": "Select month",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodMonth),
      callback: function($$v) {
        _vm.selectedPeriodMonth = $$v
      },
      expression: "selectedPeriodMonth"
    }
  }, _vm._l((_vm.periods.month), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'quarter') ? _c('el-select', {
    attrs: {
      "placeholder": "Select quarter",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodQuarter),
      callback: function($$v) {
        _vm.selectedPeriodQuarter = $$v
      },
      expression: "selectedPeriodQuarter"
    }
  }, _vm._l((_vm.periods.quarter), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period' && _vm.selectedPeriod === 'annual') ? _c('el-select', {
    attrs: {
      "placeholder": "Select year",
      "filterable": ""
    },
    on: {
      "change": _vm.handleFiltersChanged
    },
    model: {
      value: (_vm.selectedPeriodYear),
      callback: function($$v) {
        _vm.selectedPeriodYear = $$v
      },
      expression: "selectedPeriodYear"
    }
  }, _vm._l((_vm.periods.annual), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "total-display"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.selectedTotalDisplay),
      callback: function($$v) {
        _vm.selectedTotalDisplay = $$v
      },
      expression: "selectedTotalDisplay"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "percentage"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "cume"
    }
  }, [_vm._v("Cume")])], 1)], 1)])]), _vm._v(" "), (!_vm.isValidFilter) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your surveys"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidFilter && _vm.analyticsRowCount === 0 && !_vm.loadingCharts && !_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('empty', [_vm._v("Not enough data has been gathered yet to display any results for your filter.")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isValidFilter && _vm.analyticsRowCount > 0 && !_vm.laodingSurveyAalytics) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentCategory))]), _vm._v(" "), _vm._l((_vm.analyticsRowCount), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((_vm.analyticsChartsInRow(i)), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "col-lg-6"
      }, [_c('i-box', [_c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_c('span', {
        staticClass: "pull-right text-muted text-right count"
      }, [_c('em', [_vm._v("n")]), _vm._v("\n                " + _vm._s(item.respondents) + "\n                "), _c('br'), _vm._v(" "), (item.chart !== 'WORDCLOUD') ? _c('span', {
        staticStyle: {
          "cursor": "pointer"
        }
      }, [_vm._v("\n                  [\n                  "), _c('a', {
        on: {
          "click": function($event) {
            return _vm.handleSetUpOneSheet(item)
          }
        }
      }, [_vm._v("One sheet")]), _vm._v("\n                  ]\n                ")]) : _vm._e(), _vm._v(" "), (item.chart == 'WORDCLOUD') ? _c('span', [_vm._v("\n                  [\n                  "), _c('a', {
        on: {
          "click": function($event) {
            return _vm.handleCSVExport(item)
          }
        }
      }, [_vm._v("Download")]), _vm._v("\n                  ]\n                ")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('div', {
        staticClass: "chart-content"
      }, [(item.chart.length === 0 || item.chart === 'VERTICAL_BAR') ? _c('bar-chart', {
        attrs: {
          "height": 300,
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.chartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'VERTICAL_BAR_STACKED') ? _c('stacked-bar-chart', {
        attrs: {
          "height": 300,
          "showLegend": true,
          "legendPosition": 'bottom',
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.stackedTotalDisplay(item.answers),
          "options": _vm.stackedChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'HORIZONTAL_BAR') ? _c('horizontal-bar-chart', {
        attrs: {
          "height": 300,
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.chartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'PIE') ? _c('pie-chart', {
        attrs: {
          "height": 300,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart === 'DONUT') ? _c('donut-chart', {
        attrs: {
          "height": 300,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleChartClicked($event, item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.chart == 'WORDCLOUD') ? _c('cloud', {
        attrs: {
          "data": item.answers.words || [],
          "fontSizeMapper": _vm.fontSizeMapper,
          "width": 370,
          "height": 280,
          "padding": 3
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "legend-content"
      }, [(['HORIZONTAL_BAR', 'VERTICAL_BAR'].includes(item.chart)) ? _c('chart-legend', {
        attrs: {
          "colorCycle": [_vm.generateTitleColor(item.question, _vm.hueRange)],
          "data": _vm.totalDisplay(item.answers),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      }) : _vm._e(), _vm._v(" "), (['PIE', 'DONUT'].includes(item.chart)) ? _c('chart-legend', {
        attrs: {
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(item.answers), _vm.hueRange),
          "data": _vm.totalDisplay(item.answers),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      }) : _vm._e()], 1)])])], 1)
    }), 0)
  }), _vm._v(" "), (_vm.positiveCategoryProfiles.profiles && !_vm.isViewingAllCategories()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('respondent-profile-chart', {
    attrs: {
      "title": "Only positive respondents",
      "heading": ("Demographic of our listenership that shown interest in " + _vm.currentCategory),
      "profileCharts": _vm.positiveCategoryProfiles.profiles,
      "totalRespondents": _vm.positiveCategoryProfiles.respondents,
      "selectedTotalDisplay": _vm.selectedTotalDisplay,
      "hueRange": _vm.colorPieChartSpectrum
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.categoryProfiles.profiles) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('respondent-profile-chart', {
    attrs: {
      "title": "All respondents",
      "heading": ("Demographic of our listenership that completed questions on " + _vm.currentCategory),
      "profileCharts": _vm.categoryProfiles.profiles,
      "totalRespondents": _vm.categoryProfiles.respondents,
      "selectedTotalDisplay": _vm.selectedTotalDisplay,
      "hueRange": _vm.respHueRange
    }
  })], 1)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "categories col-lg-2 sidebar"
  }, [_c('h3', [_vm._v("Categories")]), _vm._v(" "), _c('el-menu', {
    staticClass: "survey-analytics-menu",
    attrs: {
      "default-active": _vm.selectedCategory
    }
  }, [_c('el-menu-item', {
    key: 'All',
    attrs: {
      "index": "All",
      "active": _vm.currentCategory === 'All'
    },
    on: {
      "click": function($event) {
        _vm.selectedCategory = 'All'
      }
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.surveyStats.surveyCategories), function(category) {
    return _c('el-menu-item', {
      key: category,
      attrs: {
        "index": category,
        "active": category === _vm.currentCategory
      },
      on: {
        "click": function($event) {
          _vm.selectedCategory = category
        }
      }
    }, [_vm._v(_vm._s(category))])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('survey-export-form-dialog', {
    attrs: {
      "isVisible": _vm.exportFormDialogVisible,
      "filterBy": _vm.filterBy,
      "surveyId": parseInt(_vm.selectedSurvey, 10),
      "surveyName": _vm.surveyName,
      "periodType": _vm.selectedPeriod,
      "datetime": new Date(_vm.selectedDatetime)
    },
    on: {
      "onVisibilityChange": _vm.handleExportFormDialogVisibility
    }
  }), _vm._v(" "), _c('survey-export-view-dialog', {
    attrs: {
      "isVisible": _vm.exportViewDialogVisible
    },
    on: {
      "onVisibilityChange": _vm.handleExportViewDialogVisibility
    }
  }), _vm._v(" "), (_vm.oneSheetData && Object.keys(_vm.oneSheetData).length > 0) ? _c('category-one-sheet', {
    attrs: {
      "visible": _vm.oneSheetVisible,
      "title": _vm.selectedCategory,
      "statData": _vm.oneSheetData,
      "selectedTotalDisplay": _vm.selectedTotalDisplay
    },
    on: {
      "onChangeVisibility": function (visible) { return (_vm.oneSheetVisible = visible); }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h1', [_vm._v("Qualitative Surveys")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No data found, please select your filters.")])])
}]}

/***/ }),
/* 3389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": _vm.note && _vm.note.approved ? 'On-Air Details' : 'Approve for On-Air',
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.note.sender))])])]), _vm._v(" "), (_vm.note.timestamp) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]) : _vm._e(), _vm._v(" "), (_vm.note.approved) ? _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On Air\n      ")]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Flagged\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript Preview\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.previewText))])]), _vm._v(" "), (_vm.note.approved) ? _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On-Air Info ")]), _vm._v(" "), _c('div', {
    staticClass: "approved-info"
  }, [(_vm.note.approvedBy) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Approved by")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" " + _vm._s(_vm.note.approvedBy) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.approvedAt) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Approved on")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" " + _vm._s(_vm.formatDate(_vm.note.approvedAt)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.approveReason) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('span', {
    staticClass: "info-reason"
  }, [_vm._v(_vm._s(_vm.note.approveReason))])]) : _vm._e()]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n          To remove this voice note from on-air, go to the\n          "), _c('strong', [_vm._v("On-Air Panel")]), _vm._v(" on your dashboard.\n        ")])])], 1) : _c('div', [_c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approving As"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvedBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send On-Air To"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Select on-air user"
    },
    model: {
      value: (_vm.computedOnAirUser),
      callback: function($$v) {
        _vm.computedOnAirUser = $$v
      },
      expression: "computedOnAirUser"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    }, [_c('span', [_vm._v(_vm._s(user.display_name))]), _vm._v(" "), (user.id === _vm.me.id) ? _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#67c23a",
        "font-size": "12px"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" You\n              ")]) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date of Approval"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.approvalDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reason / Comments (optional)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Add a reason or comment for this approval...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.note && _vm.note.approved ? 'Close' : 'Cancel') + "\n    ")]), _vm._v(" "), (_vm.note && !_vm.note.approved) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleApprove
    }
  }, [_vm._v("\n      Approve & Send On-Air\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 3390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('engagements-dashboard', {
    attrs: {
      "selectedDate": _vm.selectedDate,
      "selectedPeriod": _vm.selectedPeriod,
      "selectedFilter": _vm.selectedFilter,
      "chartsData": _vm.chartsData,
      "mainChartData": _vm.mainChartData
    },
    on: {
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changePeriod": function($event) {
        return _vm.handleChangePeriod($event)
      },
      "changeFilter": function($event) {
        return _vm.handleChangeFilter($event)
      },
      "changeDate": function($event) {
        return _vm.handleChangeDate($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "el-row el-align-middle el-justify-space-between clearfix"
        }, [_c('span', {
          staticClass: "card-head"
        }, [_vm._v("Voice Insights")]), _vm._v(" "), _c('el-button', {
          staticClass: "pull-right",
          attrs: {
            "size": "small",
            "type": "text",
            "icon": "el-icon-refresh",
            "disabled": _vm.loadingTranscripts,
            "loading": _vm.loadingTranscripts
          },
          on: {
            "click": _vm.onRefreshTranscripts
          }
        }, [_vm._v("\n        Refresh\n      ")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTranscripts),
      expression: "loadingTranscripts"
    }],
    ref: "voiceTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.paginatedTranscripts,
      "element-loading-text": "Loading...",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "reserve-selection": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "score",
      "label": "Score",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-rate', {
          attrs: {
            "disabled": "",
            "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
            "text-color": "#ff9900",
            "size": 12
          },
          model: {
            value: (row.score),
            callback: function($$v) {
              _vm.$set(row, "score", $$v)
            },
            expression: "row.score"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sender",
      "label": "Sender",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "sender-name"
        }, [_c('i', {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(row.sender) + " ")]), _vm._v(" "), (row.location) ? _c('span', {
          staticClass: "sender-info"
        }, [_c('i', {
          staticClass: "el-icon-location"
        }), _vm._v(" " + _vm._s(row.location) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "sender-info"
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v(" " + _vm._s(_vm.formatDate(row.timestamp)) + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "summary",
      "label": "Summary",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "summary"
        }, [_vm._v("\"" + _vm._s(_vm.previewSummary(row.transcript)) + "\"")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tags",
      "label": "Tags",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "tags-cell"
        }, _vm._l((row.tags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tone",
      "label": "Tone",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.tone) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.capitalize(row.tone)) + "\n        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', {
          staticClass: "action-group"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Preview Audio",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "fa fa-eye"
          },
          on: {
            "click": function($event) {
              return _vm.onPreviewAudio(row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": row.approved ? 'Approved for On-Air' : 'Approve for On-Air',
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": row.approved ? 'fa fa-podcast' : 'el-icon-success'
          },
          on: {
            "click": function($event) {
              return _vm.onApprove(row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": row.flagged ? 'Unflag' : 'Flag for Review',
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": row.flagged ? 'fa fa-flag' : 'fa fa-flag-o'
          },
          on: {
            "click": function($event) {
              return _vm.onToggleFlag(row)
            }
          }
        })], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n      Showing page " + _vm._s(this.currentPage) + " to " + _vm._s(this.totalViews) + " of " + _vm._s(_vm.totalTranscripts) + " voice\n      notes\n    ")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pageCount,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totalTranscripts
    },
    on: {
      "current-change": _vm.onPageChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playout-load-dashboard"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('line-chart', {
    staticClass: "chart",
    staticStyle: {
      "min-height": "380px"
    },
    attrs: {
      "showLegend": _vm.showLegend,
      "showGridLines": _vm.showLegend,
      "data": _vm.trendData,
      "labels": _vm.labels,
      "xAxeslabelString": 'Quarter Hour Uniques'
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 3393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('programming-dashboard', {
    attrs: {
      "stationName": _vm.me.company_name,
      "isStreaming": _vm.me.is_streaming,
      "afstereoDataNotFound": _vm.afstereoDataNotFound,
      "date": _vm.selectedDate,
      "messagesData": _vm.messagesData,
      "audienceProfileData": _vm.audienceProfileData,
      "contentThreadsData": _vm.contentThreadsData,
      "promotionsData": _vm.promotionsData,
      "commercialLoadData": _vm.commercialLoadData,
      "musicalLoadData": _vm.musicalLoadData,
      "topTracksData": _vm.topTracksData,
      "timeslots": _vm.activeTimeslots,
      "timeslot": _vm.selectedTimeslot,
      "activeRange": _vm.activeRange,
      "period": _vm.selectedPeriod,
      "filtersLoading": _vm.filtersLoading,
      "dataLoading": _vm.dataLoading,
      "loadingStreamingData": _vm.loadingStreamingData,
      "loadingMessage": _vm.loadingMessage,
      "loadingAudienceData": _vm.audienceDataLoading,
      "stations": _vm.stations,
      "streamingData": _vm.streamingData,
      "selectedStation": _vm.selectedStation,
      "afstereoPluginEnabled": _vm.afstereoPluginEnabled,
      "loadingPlugins": _vm.loadingPlugins,
      "selectedEngagementsFilter": _vm.selectedFilter,
      "chartsData": _vm.chartsData,
      "mainChartData": _vm.mainChartData
    },
    on: {
      "onDateChange": _vm.handleDateChange,
      "onHeatMapDateChange": _vm.handleChangeDate,
      "onTimeslotChange": _vm.handleTimeslotChange,
      "onPeriodChange": _vm.handlePeriodChange,
      "onStreamingPeriodChange": _vm.handleStreamingPeriodChange,
      "onStationChange": _vm.handleStationChange,
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changeFilter": function($event) {
        return _vm.handleChangeFilter($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 3394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    key: "facebookDialog",
    attrs: {
      "title": "Create Facebook Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Facebook'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loader-text"
  }, [_vm._v("\n      Waiting for authorization.\n      "), _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]), _vm._v(" "), (_vm.facebookPages.length !== 0) ? _c('div', {
    staticClass: "facebook-pages"
  }, [_c('p', [_vm._v("Choose Page(s)")]), _vm._v(" "), _c('div', {
    staticClass: "page-list"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.selectedPages),
      callback: function($$v) {
        _vm.selectedPages = $$v
      },
      expression: "selectedPages"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('div', {
      key: page.page_id
    }, [_c('el-checkbox', {
      attrs: {
        "label": page.page_id
      }
    }, [_vm._v(_vm._s(page.page_name))])], 1)
  }), 0)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSaving || !_vm.selectedPages.length,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.isSaving) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-profile-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.platforms,
      "border": true,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('SocialIcon', {
          attrs: {
            "fontSize": '12px',
            "type": _vm.channelIconList[scope.row.platform].name
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.platforms), function(column, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "fixed": false,
        "label": _vm.channelIconList[column.platform].name,
        "width": "50",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_c('cross-platform-engagement-cell-block', {
            attrs: {
              "first_platform": column.platform,
              "second_platform": _vm.platforms[scope.$index].platform,
              "isCross": true,
              "percentage": _vm.platforms[scope.$index].engagement[column.platform]
            }
          })], 1)]
        }
      }], null, true)
    }, [_c('template', {
      attrs: {
        "fixed": ""
      },
      slot: "header"
    }, [_c('SocialIcon', {
      attrs: {
        "fontSize": '18px',
        "type": _vm.channelIconList[column.platform].name
      }
    })], 1)], 2)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatUniquesNumber(scope)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "percentage",
      "label": "",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('el-progress', {
          attrs: {
            "text-inside": true,
            "stroke-width": 24,
            "color": '#6f7ad3',
            "percentage": _vm.getLinePercentage(scope.row.uniques, _vm.totalUniques)
          }
        })], 1)]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 3396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-whatsapp"
  })
},staticRenderFns: []}

/***/ }),
/* 3397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    staticClass: "insights-unit"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [(_vm.hasValidData) ? _c('el-popover', {
    attrs: {
      "width": "260",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle pull-right",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "",
      "popper-class": "text-format-wrap"
    },
    slot: "default"
  }, [_vm._v(_vm._s(_vm.dataByPeriod.description.replace("the business account's", "your account's") ))])]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "unit-title",
    on: {
      "click": _vm.handleTitleClick
    }
  }, [_vm._v(_vm._s(_vm.dataByPeriod.title))])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.hasValidData) ? _c('div', [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.dataByPeriod.value).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: {
      'text-success': _vm.dataByPeriod.difference > 0,
        'text-danger': _vm.dataByPeriod.difference < 0,
        'text-muted': _vm.dataByPeriod.difference === 0,
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dataByPeriod.difference > 0 ? '+' : '') + _vm._s(_vm.dataByPeriod.difference.toLocaleString()) + "\n        "), _c('el-tooltip', {
    attrs: {
      "content": ("compared to previous " + _vm.period),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.dataByPeriod.difference > 0,
        'fa-level-down': _vm.dataByPeriod.difference < 0,
        'fa-minus': _vm.dataByPeriod.difference === 0,
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.dataByPeriod.values,
      "gradient": ['#683090', '#c97eff'],
      "height": 60,
      "auto-draw": ""
    }
  })], 1)]) : _c('div', {
    staticClass: "no-data-placeholder"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("-")])])])])
},staticRenderFns: []}

/***/ }),
/* 3398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('base-pie-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.printable || (!_vm.imgData && _vm.printable)),
      expression: "!printable || (!imgData && printable)"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : null,
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    },
    on: {
      "chartCreated": _vm.setChart
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable && _vm.imgData),
      expression: "printable && imgData"
    }],
    attrs: {
      "height": _vm.height ? _vm.height : 200,
      "src": _vm.imgData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "demographics-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [_vm._l((_vm.filteredDemographics), function(demo) {
    return _c('div', {
      key: demo.title
    }, [_c('el-card', {
      staticClass: "demo-card",
      class: {
        blacklisted: demo.blacklisted
      },
      attrs: {
        "shadow": "hover"
      }
    }, [(!demo.blacklisted) ? _c('el-popconfirm', {
      attrs: {
        "title": "Are you sure to blacklist this demographic?",
        "icon": "el-icon-info",
        "icon-color": "red",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No"
      },
      on: {
        "onConfirm": function($event) {
          return _vm.blacklistNugget(demo)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      attrs: {
        "slot": "reference",
        "id": "remove-nugget"
      },
      slot: "reference"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Blacklist field",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-close-notification"
    })])], 1)]) : _vm._e(), _vm._v(" "), (demo.blacklisted) ? _c('span', {
      attrs: {
        "id": "blacklisted-nugget"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "This field is blacklisted",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-star-on"
    })])], 1) : _vm._e(), _vm._v(" "), _c('el-popconfirm', {
      attrs: {
        "title": "Are you sure to permanently delete this?",
        "icon": "el-icon-info",
        "icon-color": "red",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No"
      },
      on: {
        "onConfirm": function($event) {
          return _vm.removeNugget(demo)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Remove from profile",
        "placement": "right-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-minus"
    })])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "demo-title"
    }, [_vm._v(_vm._s(demo.title))]), _vm._v(" "), (demo.field === 'birth_date') ? _c('div', [_c('span', {
      staticClass: "demo-value"
    }, [_vm._v(_vm._s(demo.label.split(" ")[0]))])]) : _c('div', [_c('span', {
      staticClass: "demo-value"
    }, [_vm._v(_vm._s(demo.label))])])], 1)], 1)
  }), _vm._v(" "), (_vm.blacklistedDemographics.length) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "blacklist-toggle"
    },
    on: {
      "click": _vm.toggleBlacklist
    }
  }, [(!_vm.showBlacklisted) ? _c('span', [_vm._v("Show")]) : _c('span', [_vm._v("Hide")]), _vm._v(" Blacklisted Demographics\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 3400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "height": 155,
      "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.chartData), _vm.hueRange),
      "data": _vm.totalDisplay(_vm.chartData),
      "options": _vm.pieChartOptions
    },
    on: {
      "onClick": function($event) {
        return _vm.handleProfileClicked($event, _vm.chartData)
      }
    }
  }), _vm._v(" "), _c('chart-legend', {
    attrs: {
      "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.chartData), _vm.hueRange),
      "data": _vm.totalDisplay(_vm.chartData),
      "isPercentage": _vm.totalDisplayOption === 'percentage'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-center"
  }, [_c('div', {
    staticClass: "total-display"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.selectedTotalDisplay),
      callback: function($$v) {
        _vm.selectedTotalDisplay = $$v
      },
      expression: "selectedTotalDisplay"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "percentage"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "cume"
    }
  }, [_vm._v("Cume")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('br'), _vm._v(" "), (!_vm.spotChartsData.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("No spot surveys found.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.spotChartsData), function(spot) {
    return _c('spot-item', {
      key: spot.id,
      attrs: {
        "id": spot.id,
        "title": spot.title,
        "url": spot.url,
        "startDate": new Date(spot.start_date),
        "endDate": new Date(spot.end_date),
        "entries": spot.total_entries,
        "entryChart": spot.daily_entry_rate,
        "questionCharts": spot.question_stats,
        "profileCharts": spot.profile_stats,
        "totalDisplayOption": _vm.selectedTotalDisplay
      },
      on: {
        "onRequestRespondents": _vm.handleRequestRespondents
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "mainTooltip": "New Spot Survey"
    },
    on: {
      "click": _vm.handleCreateSpotSurvey
    }
  }), _vm._v(" "), _c('spot-survey-create-dialog', {
    attrs: {
      "isVisible": _vm.createDialogVisible
    },
    on: {
      "onVisibilityChange": function($event) {
        _vm.createDialogVisible = $event
      }
    }
  }), _vm._v(" "), _c('survey-respondents-dialog', {
    attrs: {
      "isVisible": _vm.respondentDialogVisible,
      "filtering": _vm.respondentFiltering,
      "title": _vm.respondentTitle,
      "subtitle": _vm.respondentSubtitle
    },
    on: {
      "onVisiblityChange": _vm.handleRespondentDialogVisibility
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h1', [_vm._v("Spot Polls")])])
}]}

/***/ }),
/* 3402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('emoji-picker', {
    attrs: {
      "search": _vm.search
    },
    on: {
      "emoji": _vm.insert
    },
    scopedSlots: _vm._u([{
      key: "emoji-invoker",
      fn: function(ref) {
        var clickEvent = ref.events.click;

        return _c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return clickEvent($event)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "append",
            "type": "text",
            "icon": "fa fa-smile-o"
          },
          slot: "append"
        })], 1)
      }
    }, {
      key: "emoji-picker",
      fn: function(ref) {
        var emojis = ref.emojis;
        var insert = ref.insert;

        return _c('div', {}, [_c('div', {
          staticClass: "emoji-picker"
        }, [_c('div', {
          staticClass: "emoji-picker__search"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.search),
            expression: "search"
          }],
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.search)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.search = $event.target.value
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "emojis"
        }, _vm._l((emojis), function(emojiGroup, category) {
          return _c('div', {
            key: category
          }, [_c('h5', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('div', _vm._l((emojiGroup), function(emoji, emojiName) {
            return _c('span', {
              key: emojiName,
              attrs: {
                "title": emojiName
              },
              on: {
                "click": function($event) {
                  return insert(emoji)
                }
              }
            }, [_vm._v(_vm._s(emoji))])
          }), 0)])
        }), 0)])])
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 3403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: item[0],
      staticClass: "legend-row"
    }, [(typeof(item[1]) != 'object') ? _c('span', {
      staticClass: "column color",
      style: ({
        'background-color': _vm.getColor(item[0], index) + ' !important'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "column",
      style: ({
        'text-align': _vm.titleAlign
      })
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('span', {
      staticClass: "column total"
    }, [_vm._v(_vm._s(_vm.totalDisplay(item)))])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 3404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Automated Emails")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add new recipient",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.manageRecipient(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Generate Report",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Manage who can receive automated campaign, survey and programming dashboard reports.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content user-list-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "input form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.results,
      "fit": true,
      "empty-text": !_vm.results.length && _vm.recipients.length ?
        ("No recipients found matching " + _vm.keyword) :
        'No recipients',
      "max-height": "400",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(((scope.row.firstName) + " " + (scope.row.lastName))))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }), _vm._v(" "), (_vm.companies.length) ? _c('el-table-column', {
    attrs: {
      "label": "Company"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.company.title) + "\n          ")]
      }
    }], null, false, 2276206164)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Reports",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "client-status center"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Campaign Summary",
            "placement": "top"
          }
        }, [(scope.row.campaignSummary) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Survey Summary",
            "placement": "top"
          }
        }, [(scope.row.surveySummary) ? _c('span', {
          staticClass: "label label-warning-light"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Programming Dashboard",
            "placement": "top"
          }
        }, [(scope.row.programmingSummary) ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), (
          !scope.row.campaignSummary &&
          !scope.row.surveySummary &&
          !scope.row.programmingSummary
        ) ? _c('span', [_c('i', [_vm._v("None")])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.manageRecipient(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRecipient(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), (_vm.showRecipientManage) ? _c('el-dialog', {
    attrs: {
      "title": _vm.selectedRecipient.id ? 'Edit Automated Email Recipient' : 'New Automated Email Recipient',
      "visible": _vm.showRecipientManage,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showRecipientManage = $event
      }
    }
  }, [(_vm.showRecipientManage) ? _c('recipient-manage', {
    attrs: {
      "recipient": _vm.selectedRecipient,
      "users": _vm.users,
      "me": _vm.me,
      "companies": _vm.companies
    },
    on: {
      "cancelled": function($event) {
        _vm.showRecipientManage = false
      },
      "saved": _vm.handleSaved,
      "deleted": _vm.handleDelete,
      "error": _vm.handleError
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showGenerator) ? _c('el-dialog', {
    attrs: {
      "title": "Generate Automated Email",
      "visible": _vm.showGenerator,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showGenerator = $event
      }
    }
  }, [_c('generate-report', {
    attrs: {
      "loading": _vm.generatingReport,
      "surveys": _vm.surveys,
      "campaigns": _vm.campaigns
    },
    on: {
      "generate": function($event) {
        return _vm.handleGenerate($event)
      },
      "cancel": function($event) {
        _vm.showGenerator = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])])
}]}

/***/ }),
/* 3405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-fw fa-twitter"
  })
},staticRenderFns: []}

/***/ }),
/* 3406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header campaign-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Campaigns")]), _vm._v(" "), _c('campaign-filter', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "inline"
    },
    on: {
      "onFilter": _vm.handleFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.$apollo.queries.campaignList.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaigns"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (
    !_vm.$apollo.queries.campaignList.loading &&
    _vm.campaignList.objects &&
    !_vm.campaignList.objects.length
  ) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$apollo.queries.campaignList.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._l((_vm.campaignList.objects), function(item) {
    return _c('campaign-list-item', {
      key: item.id,
      attrs: {
        "id": parseInt(item.id, 10),
        "title": item.title,
        "live": item.live,
        "perpetual": item.perpetual,
        "progress": item.progress,
        "advertiser": item.campaignadvertiser && item.campaignadvertiser.advertiser,
        "startDate": _vm.moment(item.startDate),
        "endDate": _vm.moment(item.endDate),
        "createdBy": item.createdBy,
        "campaignType": item.campaignType,
        "totalMessages": item.engagements.total,
        "uniqueMessages": item.engagements.unique,
        "totalThisMonth": item.engagements.totalThisMonth,
        "totalPerDayThisMonth": item.engagements.totalPerDayThisMonth,
        "channelLinks": item.linkedcampaignchannelSet,
        "replyMessage": _vm.displayReplyMessage(item.replymessage),
        "growth": item.engagements.growth,
        "isFavourite": item.favourite,
        "topEngagers": item.engagements.topEngagers,
        "survey": _vm.getSurvey(item.survey),
        "bots": _vm.getBotsLinks(item.linkedcampaignchannelSet),
        "leadCount": item.leadCount
      },
      on: {
        "onRandomSelect": function($event) {
          return _vm.handleRandomSelect(item.id)
        },
        "onRandomSelections": function($event) {
          return _vm.handleRandomSelections(item.id)
        },
        "onDownloadMessages": function($event) {
          return _vm.handleDownloadMessages(item)
        },
        "onEditCampaign": function($event) {
          return _vm.handleCampaignEdit(item.id)
        },
        "onFavourite": function($event) {
          return _vm.handleFavourite($event, item.id)
        },
        "onToggleLiveStatus": function($event) {
          return _vm.handleToggleLiveStatus($event, item.id)
        },
        "onUnlink": function($event) {
          return _vm.handleUnlink($event, item.id)
        },
        "onSelectProfile": function($event) {
          return _vm.handleSelectProfile($event)
        },
        "onExportSurveyData": function($event) {
          return _vm.handleExportSurveyData(item.survey)
        },
        "onDownloadBotReport": function($event) {
          return _vm.handleDownloadBotReport(item)
        }
      }
    })
  }), _vm._v(" "), (_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "originalProfile": _vm.selectedProfile,
      "updatedProfileMap": _vm.updatedProfileMap,
      "profileDialogVisible": _vm.profileDialogVisible,
      "profileId": _vm.getProfileId(_vm.selectedProfile),
      "campaignId": _vm.selectedCampaignForProfile
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileDialogVisibilityChanged,
      "profileUpdated": _vm.handleProfileUpdated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.campaignList.pages > 1) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.campaignList.objects) ? _c('paginator', {
    attrs: {
      "id": "paginator",
      "hasNext": _vm.campaignList.hasNext,
      "hasPrevious": _vm.campaignList.hasPrev,
      "pages": _vm.campaignList.pages,
      "currentPage": _vm.campaignList.page
    },
    on: {
      "goToNextPage": _vm.handleNextPage,
      "goToPreviousPage": _vm.handlePreviousPage,
      "goToPage": _vm.handleGoToPage
    }
  }) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), (_vm.campaignManageVisible) ? _c('campaign-manage', {
    attrs: {
      "me": _vm.me,
      "campaignToEdit": _vm.campaignToEdit,
      "editingCampaign": _vm.editCampaign,
      "isVisible": _vm.campaignManageVisible,
      "addingInstagramChannel": _vm.addingInstagramChannel,
      "addingTwitterChannel": _vm.addingTwitterChannel
    },
    on: {
      "onVisibleChanged": _vm.handleCreateCampaignVisibilityChanged,
      "onRequestTwitterAuth": _vm.handleRequestTwitterAuth,
      "onRequestInstagramAuth": _vm.handleRequestInstagramAuth,
      "onSaved": _vm.handleCampaignCreated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.campaignList && _vm.campaignList.objects && _vm.campaignList.objects.length > 0) ? _c('div', [(_vm.randomSelectVisible) ? _c('random-select-dialog', {
    attrs: {
      "isVisible": _vm.randomSelectVisible,
      "campaignId": _vm.randomSelectCampaignId
    },
    on: {
      "onVisibleChanged": _vm.handleRandomSelectVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.randomSelectionsVisible) ? _c('random-selections-dialog', {
    attrs: {
      "isVisible": _vm.randomSelectionsVisible,
      "campaignId": _vm.randomSelectCampaignId
    },
    on: {
      "onVisibleChanged": _vm.handleRandomSelectionsVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.downloadMessagesVisible) ? _c('download-messages-dialog', {
    attrs: {
      "channelLinks": _vm.selectedChannelLink['linkedcampaignchannelSet'],
      "isVisible": _vm.downloadMessagesVisible,
      "campaignId": parseInt(_vm.selectedChannelLink['id'], 10),
      "campaignTitle": _vm.selectedChannelLink['title']
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadMessagesVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.downloadBotReportVisible) ? _c('bot-report-dialog', {
    attrs: {
      "channelLinks": _vm.getBotsLinks(_vm.selectedChannelLink['linkedcampaignchannelSet']),
      "isVisible": _vm.downloadBotReportVisible,
      "campaignId": parseInt(_vm.selectedChannelLink['id'], 10),
      "campaignTitle": _vm.selectedChannelLink['title']
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadBotReportVisibilityChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('can', {
    attrs: {
      "action": "create",
      "subject": "campaigns"
    }
  }, [_c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "mainTooltip": "New campaign"
    },
    on: {
      "click": _vm.handleCreateCampaign
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No campaigns found.")])])
}]}

/***/ }),
/* 3407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Back",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "el-icon-back",
    staticStyle: {
      "font-size": "4rem",
      "padding": "3px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleBack
    }
  })])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Setup",
      "name": "setup"
    }
  }, [_c('setup-tab')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Canvas",
      "name": "canvas",
      "disabled": !_vm.survey.id
    }
  }, [_c('canvas-tab')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Preview & Publish",
      "name": "preview",
      "disabled": !_vm.survey.id
    }
  }, [_c('preview-tab', {
    ref: "previewTab"
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Survey Builder")])])
}]}

/***/ }),
/* 3408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr'), _vm._v(" "), (_vm.fields) ? _c('el-form', {
    attrs: {
      "size": "small",
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Action"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select an action"
    },
    on: {
      "change": _vm.handleActionChange
    },
    model: {
      value: (_vm.action.key),
      callback: function($$v) {
        _vm.$set(_vm.action, "key", $$v)
      },
      expression: "action.key"
    }
  }, _vm._l((_vm.eventActions), function(item, key) {
    return (item in _vm.fields) ? _c('el-option', {
      key: key,
      attrs: {
        "label": _vm.fields[item].title,
        "value": item
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.inputFields), function(inputField, key) {
    return _c('el-form-item', {
      key: key
    }, [_c('el-input', {
      attrs: {
        "type": inputField.type,
        "placeholder": inputField.title
      },
      model: {
        value: (_vm.action.data[_vm.inputFieldsKeys[key]]),
        callback: function($$v) {
          _vm.$set(_vm.action.data, _vm.inputFieldsKeys[key], $$v)
        },
        expression: "action.data[inputFieldsKeys[key]]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select an execution option"
    },
    model: {
      value: (_vm.action.execution_option),
      callback: function($$v) {
        _vm.$set(_vm.action, "execution_option", $$v)
      },
      expression: "action.execution_option"
    }
  }, _vm._l((_vm.executionOptions), function(option, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.action.execution_option == 1) ? _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select an execution day"
    },
    model: {
      value: (_vm.action.execute_day),
      callback: function($$v) {
        _vm.$set(_vm.action, "execute_day", $$v)
      },
      expression: "action.execute_day"
    }
  }, _vm._l((_vm.executionTimeOptions), function(option, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": option[1],
        "value": option[0]
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.action.execution_option == 1) ? _c('el-form-item', [_c('el-time-picker', {
    attrs: {
      "placeholder": "Please select an execution time"
    },
    on: {
      "change": _vm.handleTimeChange
    },
    model: {
      value: (_vm.action.execute_time),
      callback: function($$v) {
        _vm.$set(_vm.action, "execute_time", $$v)
      },
      expression: "action.execute_time"
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.length === 0) ? _c('div', {
    staticClass: "empty-container"
  }, [_c('div', {
    on: {
      "click": _vm.handleToggleCollapse
    }
  }, [_vm._v("Expand to add choices for this question")])]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "draggable": ".draggable"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleCollapse($event)
      }
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, _vm._l((_vm.computedValue), function(choice) {
    return _c('div', {
      key: choice.id,
      staticClass: "choice",
      class: [_vm.choiceScaleClass(choice), {
        draggable: _vm.isEditable
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(choice.title))])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 3410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-more",
      "plain": ""
    }
  }, [_vm._v("More Options")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "edit-campaign"
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "campaign-report"
    }
  }, [_vm._v("Campaign Report")]), _vm._v(" "), (_vm.survey) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "survey-report"
    }
  }, [_vm._v("Survey Report")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bots.length ? true : false),
      expression: "bots.length ? true : false"
    }],
    attrs: {
      "command": "bot-report"
    }
  }, [_vm._v("Bot Report\n              ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "download-messages"
    }
  }, [_vm._v("Download messages")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "random-select"
    }
  }, [_vm._v("Select a random winner")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "random-selection"
    }
  }, [_vm._v("Random selections")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "campaigns-offline"
    }
  }, [(_vm.live) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "toggle-live-status"
    }
  }, [_vm._v("Take Offline")]) : _vm._e()], 1), _vm._v(" "), (!_vm.live) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "toggle-live-status"
    }
  }, [_vm._v("Take Online")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "favourite active pull-left",
    class: {
      active: _vm.isFavourite, inactive: !_vm.isFavourite
    },
    on: {
      "click": _vm.handleToggleFavourite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-star': _vm.isFavourite, 'fa-star-o': !_vm.isFavourite
    }
  })]), _vm._v(" "), _c('h2', [_c('router-link', {
    attrs: {
      "to": ("/campaigns/" + _vm.id)
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Status:")]), _vm._v(" "), _c('dd', [(_vm.live) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (!_vm.live) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Inactive")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Type:")]), _vm._v(" "), _c('dd', [(_vm.campaignType === 'COMPETITION') ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Competition")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'MESSAGE_BOARD') ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Message Board")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'POLL') ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Poll")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'SURVEY') ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Survey")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'INSTANT_POLL') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Instant Poll")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Total Messages:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(Math.round(_vm.totalMessages).toLocaleString()))]), _vm._v(" "), _c('dt', [_vm._v("Unique Messages:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(Math.round(_vm.uniqueMessages).toLocaleString()))]), _vm._v(" "), _c('dt', [_vm._v("Growth")]), _vm._v(" "), _c('dd', [_c('growth', {
    attrs: {
      "value": _vm.growth,
      "isPercentage": true
    }
  })], 1), _vm._v(" "), (_vm.leadCount && _vm.leadCount > 0) ? _c('div', [_c('dt', [_vm._v("Lead Total:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.leadCount))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Start Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.startDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("End Date:")]), _vm._v(" "), (_vm.perpetual) ? _c('dd', [_c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Perpetual Campaign")])]) : _c('dd', [_vm._v(_vm._s(_vm.endDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("Created By:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.createdBy ? _vm.createdBy.displayName : ''))]), _vm._v(" "), _c('dt', [_vm._v("Progress:")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "progress m-b-sm"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.adjustedProgress + "%")
    })
  })]), _vm._v(" "), (_vm.adjustedProgress < 100) ? _c('small', [_vm._v("\n              This campaign is currently\n              "), _c('strong', [_vm._v(_vm._s(_vm.adjustedProgress) + "%")]), _vm._v("\n              completed and will end\n              "), _c('strong', [_vm._v(_vm._s(_vm.endDate.fromNow()))]), _vm._v(".\n            ")]) : _vm._e(), _vm._v(" "), (_vm.adjustedProgress === 100) ? _c('small', [_vm._v("\n              This campaign has\n              "), _c('strong', [_vm._v("completed " + _vm._s(_vm.endDate.fromNow()))]), _vm._v(".\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.topEngagers.length) ? _c('dt', [_vm._v("Top Engagers:")]) : _vm._e(), _vm._v(" "), _c('dd', {
    staticClass: "project-people"
  }, _vm._l((_vm.topEngagers), function(profile, index) {
    return _c('engager', {
      key: index,
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProfileDialog(profile, _vm.id)
        }
      }
    })
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('small', [_vm._v("Interactions this month")]), _vm._v(" "), _c('h2', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.totalThisMonth).toLocaleString()))]), _vm._v(" "), _c('trend', {
    attrs: {
      "points": _vm.totalPerDayThisMonth,
      "height": 50
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-8': _vm.replyMessage.length > 0, 'col-lg-12': _vm.replyMessage.length === 0
    }
  }, [_c('h3', [_vm._v("Channels")]), _vm._v(" "), (_vm.channelLinks.length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "unlink-channels"
    }
  }, _vm._l((_vm.channelLinks), function(item) {
    return _c('channel-to-campaign-link-item', {
      key: item.id,
      attrs: {
        "keyword": item.keyword,
        "handle": item.channel.handle,
        "channelType": item.channel.channelTypeTitle
      },
      on: {
        "onUnlink": function($event) {
          return _vm.handleUnlink(item.id)
        }
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.channelLinks.length) ? _c('div', {
    staticClass: "no-channels"
  }, [_c('span', [_vm._v("You currently have no channels linked on this campaign.")])]) : _vm._e()]), _vm._v(" "), (_vm.replyMessage.length > 0) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h5', [_vm._v("Reply Messages")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('em', [_vm._v(_vm._s(_vm.replyMessage))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr')])
}]}

/***/ }),
/* 3411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col text-right dashboard-header__actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('tour')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-compass"
  }), _vm._v(" Take a tour\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-xl-3"
  }, [_c('h2', [_vm._v("\n      Smart Segmentation\n      "), _c('span', {
    staticClass: "targeting-badge"
  }, [_vm._v("+Targeting")])])])
}]}

/***/ }),
/* 3412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    attrs: {
      "split-button": "",
      "size": "mini",
      "type": "info",
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [(this.value) ? _c('strong', [_vm._v(_vm._s(_vm.selectedIndex))]) : _c('strong', [_vm._v("?")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.canvasQuestions), function(question, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": question,
        "disabled": _vm.excludeQuestions.includes(question.id)
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 2) + ".")]), _vm._v("\n      " + _vm._s(question.title) + "\n    ")])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-transfer', {
    attrs: {
      "titles": ['Available', 'Enabled'],
      "data": _vm.handleChannelData
    },
    model: {
      value: (_vm.currentChannels),
      callback: function($$v) {
        _vm.currentChannels = $$v
      },
      expression: "currentChannels"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 3414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.engagerData.name || _vm.engagerData.identifier
    }
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.showFallbackProfileImage ? _vm.identicon : _vm.engagerData.profileImg
    },
    on: {
      "error": _vm.imageLoadError
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 3415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("col-xs-12 profile-card " + _vm.layoutStyle)
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        padding: '0px'
      },
      "shadow": "hover"
    }
  }, [_c('div', {
    attrs: {
      "id": "grid-image-container"
    }
  }, [_c('el-image', {
    staticClass: "grid-image",
    attrs: {
      "fit": "'cover'",
      "lazy": "",
      "src": _vm.profile.image ? _vm.profile.image : _vm.identicon
    },
    on: {
      "error": _vm.imageLoadError
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "placeholder"
    },
    slot: "placeholder"
  }, [_c('img', {
    attrs: {
      "width": "120",
      "height": "120",
      "src": _vm.identicon
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-card-content"
  }, [_c('div', {
    staticClass: "top-content"
  }, [(_vm.profile.name) ? _c('div', {
    staticClass: "profile-name"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.profile.name,
      "placement": "bottom"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.profile.name))])])], 1) : _c('div', {
    staticClass: "profile-name"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.profile.identifier,
      "placement": "bottom"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.profile.identifier))])])], 1), _vm._v(" "), (_vm.profile.name) ? _c('div', {
    staticClass: "profile-identifier"
  }, [_vm._v(_vm._s(_vm.profile.identifier))]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Load Filter"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-table', {
    ref: "loadTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData,
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "title",
      "label": "Title",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "survey",
      "label": "Survey"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "insertedAt",
      "label": "Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-trash"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleLoad()
            }
          }
        }, [_vm._v("Load")])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading && !_vm.profiles.length),
      expression: "loading && !profiles.length"
    }],
    attrs: {
      "element-loading-text": "Loading Profiles..."
    }
  }, [_c('div', {
    staticClass: "infinite-list-wrapper",
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "infinite-scroll-disabled": "disabled"
    }
  }, [_c('el-row', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticStyle: {
      "height": "600px",
      "overflow": "auto"
    },
    attrs: {
      "gutter": 6
    }
  }, _vm._l((_vm.profiles), function(profile) {
    return _c('el-col', {
      key: profile.id,
      attrs: {
        "span": 6
      }
    }, [_c('grid-card', {
      staticStyle: {
        "margin": "12px 0px"
      },
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          return _vm.showProfile(profile)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-center",
    attrs: {
      "span": 24
    }
  }, [(_vm.loading && _vm.profiles.length) ? _c('p', {
    staticClass: "load-more"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" Loading Profiles...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('p', [_vm._v("All Profiles Loaded")]) : _vm._e()])], 1), _vm._v(" "), (_vm.profile) ? _c('dialog-card', {
    attrs: {
      "initialProfile": _vm.profile,
      "visible": _vm.showProfileCard
    },
    on: {
      "close": _vm.handleCloseCard
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50rem",
      "top": "2vh",
      "center": true,
      "show-close": false,
      "close-on-click-modal": true,
      "visible": _vm.showProfileDialog,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "profile-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "profile-controls"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.showBlacklisted ? 'Hide Blacklisted' : 'Show Blacklisted'
    }
  }, [_c('el-button', {
    style: (_vm.showBlacklisted ? 'color: white;' : ''),
    attrs: {
      "type": "text",
      "icon": "fa fa-ban"
    },
    on: {
      "click": function($event) {
        _vm.showBlacklisted = !_vm.showBlacklisted
      }
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.showDeleted ? 'Hide Removed' : 'Show Removed'
    }
  }, [_c('el-button', {
    style: (_vm.showDeleted ? 'color: white;' : ''),
    attrs: {
      "type": "text",
      "icon": "fa fa-trash-o"
    },
    on: {
      "click": function($event) {
        _vm.showDeleted = !_vm.showDeleted
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-container"
  }, [_c('img', {
    staticClass: "avatar-image",
    attrs: {
      "src": _vm.showFallbackProfileImage ? _vm.identicon : _vm.profileImage
    },
    on: {
      "error": _vm.profileImageError
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.profileName))])]), _vm._v(" "), _c('el-tabs', {
    staticStyle: {
      "width": "48rem",
      "margin": "auto -15px"
    },
    attrs: {
      "stretch": true
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "personal"
    }
  }, [_c('table', [_c('tbody', _vm._l((_vm.appendProfileFields(_vm.profile)), function(content, category) {
    return _c('tr', {
      key: category
    }, [(
      !_vm.excludeCategories.find(function (x) { return x === category; }) &&
      _vm.appendProfileFields(_vm.profile) &&
      _vm.showCategory(_vm.appendProfileFields(_vm.profile))
    ) ? _c('span', _vm._l((content), function(fields, key) {
      return _c('td', {
        key: key,
        staticStyle: {
          "display": "table-row"
        }
      }, [(!_vm.excludeProps.find(function (x) { return x === key; })) ? _c('ProfileDetailFieldItem', {
        key: (category + "-" + key),
        attrs: {
          "fieldKey": _vm.getKey(key),
          "category": category,
          "fields": _vm.filteredFields(fields),
          "profileId": _vm.profileId
        },
        on: {
          "removeNugget": _vm.handleRemoveNugget,
          "blacklistNugget": _vm.handleBlacklistNugget,
          "onShowProfileMap": _vm.handleShowProfileMap
        }
      }) : _vm._e(), _vm._v(" "), (key === 'location' && _vm.showProfileMap) ? _c('div', {
        staticClass: "mapouter"
      }, [_c('div', {
        staticClass: "gmap_canvas"
      }, [_c('iframe', {
        staticClass: "map_frame",
        attrs: {
          "id": "gmap_canvas",
          "src": ("https://maps.google.com/maps?q=" + _vm.location + "&z=10&output=embed"),
          "frameborder": "0",
          "scrolling": "no",
          "marginheight": "0",
          "marginwidth": "0"
        }
      }), _vm._v(" "), _c('a', {
        attrs: {
          "href": "https://www.embedgooglemap.net"
        }
      })])]) : _vm._e()], 1)
    }), 0) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [(_vm.loadingInteractions[_vm.panelSettings.uuid] && !_vm.interactions(_vm.panelSettings.uuid).length) ? _c('loader', {
    attrs: {
      "message": "Loading interactions"
    }
  }) : _vm._e(), _vm._v(" "), _c('interactions-filter', {
    attrs: {
      "interactions": _vm.groupByInterationChannel(_vm.interactions(_vm.panelSettings.uuid)),
      "profile": _vm.profile
    },
    on: {
      "onFilterInteractions": _vm.handleFilterInteractions
    }
  }), _vm._v(" "), (!_vm.loadingInteractions[_vm.panelSettings.uuid]) ? _c('message-panel', {
    attrs: {
      "id": _vm.panelSettings.uuid,
      "polling": false,
      "title": 'Message history',
      "type": 'profile',
      "color": '#ee2465',
      "canClose": false,
      "hasSettings": false,
      "interactions": _vm.filterByChannelType(_vm.interactions(_vm.panelSettings.uuid)),
      "hasSearch": false,
      "isFixedPanel": true,
      "loadingSuccess": !!_vm.loadingInteractionsSuccess[_vm.panelSettings.uuid] || false,
      "loading": _vm.loadingInteractions[_vm.panelSettings.uuid] || false,
      "hasMoreInteractions": _vm.panelHasMoreInteractions(_vm.panelSettings.uuid) || false
    },
    on: {
      "loadMore": _vm.handleLoadMore
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "Surveys"
    }
  }, [(_vm.loadingInteractions[_vm.panelSettings.uuid] && !_vm.interactions(_vm.panelSettings.uuid).length) ? _c('loader', {
    attrs: {
      "message": "Loading Campaigns & Surveys"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingInteractions[_vm.panelSettings.uuid]) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.formatCampaignSurveysData()
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Title",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Type",
      "prop": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Date",
      "prop": "startDate"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showProfileDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-panel-container chat-panel-container"
  }, [_c('div', {
    staticClass: "ibox chat-panel"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Chat")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.totalNotifications > 0) ? _c('el-dropdown', {
    on: {
      "command": _vm.handleTopicChange
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('el-badge', {
    staticClass: "new-message",
    attrs: {
      "value": _vm.totalNotifications
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })]), _vm._v(" "), (_vm.totalNotifications === 0) ? _c('i', {
    staticClass: "fa fa-bell"
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.notificationItems), function(notificationItem) {
    return _c('el-dropdown-item', {
      key: notificationItem.topic,
      attrs: {
        "command": notificationItem.topic
      }
    }, [_c('div', {
      staticClass: "notification-item"
    }, [_c('div', {
      staticClass: "notification-prepend"
    }, [_vm._v(_vm._s(notificationItem.prepend))]), _vm._v(" "), _c('div', {
      staticClass: "notification-name"
    }, [_vm._v(_vm._s(notificationItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "notification-count"
    }, [_vm._v(_vm._s(notificationItem.count))])])])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Close panel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closePanel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('channel-selector', {
    staticClass: "channel-selector",
    attrs: {
      "channels": _vm.channelsList,
      "notifications": _vm.notifications,
      "selected-topic": _vm.topic,
      "presences": _vm.presences
    },
    on: {
      "onSelectTopic": _vm.handleTopicChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chat-area"
  }, [_c('perfect-scrollbar', {
    ref: "content",
    staticClass: "chat-content",
    on: {
      "ps-scroll-y": _vm.handleScroll
    }
  }, [(_vm.channelError) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Unable to join this converstaion")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedMessages), function(message) {
    return _c('div', {
      key: message.id
    }, [_c('div', {
      staticClass: "message",
      class: message.direction
    }, [(message.direction === 'in') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(message.user.first_name) + " " + _vm._s(message.user.last_name) + "\n              ")]) : _vm._e(), _vm._v(" "), (message.direction === 'out') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("You")]) : _vm._e(), _vm._v("\n              " + _vm._s(message.body) + "\n              "), _c('div', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(_vm.displayDatetime(message.datetime)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), _c('div', {
    ref: "bottomScroll"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "chat-input"
  }, [_c('el-input', {
    on: {
      "focus": _vm.resetNotifications,
      "blur": _vm.resetNotifications
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.chatInput),
      callback: function($$v) {
        _vm.chatInput = $$v
      },
      expression: "chatInput"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-arrow-up"
    },
    on: {
      "click": _vm.submit
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-indicator"
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  })])
}]}

/***/ }),
/* 3420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 3421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "480",
      "data": _vm.files
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v("Campaign: " + _vm._s(props.row.campaign_title))]), _vm._v(" "), _c('p', [_vm._v("File Type: " + _vm._s(props.row.file_type))]), _vm._v(" "), _c('p', [_vm._v("File Size: " + _vm._s(props.row.size))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file_name",
      "min-width": "420",
      "label": "File name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.file_name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_first_name",
      "min-width": "180",
      "label": "User"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.user_first_name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date_created",
      "min-width": "220",
      "label": "Date / Time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.moment(scope.row.date_created).format('ddd Do MMMM YYYY')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_file",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownload(scope.row.user_file)
            }
          }
        }, [_vm._v("\n        Download\n      ")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-building"
  }), _vm._v(" "), _c('strong', [_vm._v("View by")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "value": null
    },
    model: {
      value: (_vm.currentFilter),
      callback: function($$v) {
        _vm.currentFilter = $$v
      },
      expression: "currentFilter"
    }
  }, _vm._l(([{
    option: 'Station'
  }, {
    option: 'Show'
  }]), function(type, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": type.option,
        "value": type.option
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.selectedFilter === 'Show') ? _c('div', {
    staticClass: "header-item"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('strong', [_vm._v("Show |")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "value": null
    },
    model: {
      value: (_vm.selectedTimeslot),
      callback: function($$v) {
        _vm.selectedTimeslot = $$v
      },
      expression: "selectedTimeslot"
    }
  }, _vm._l((_vm.timeslots), function(slot) {
    return _c('el-option', {
      key: slot.id,
      attrs: {
        "label": slot.title,
        "value": slot.id
      }
    })
  }), 1)], 1) : _vm._e()])]), _vm._v(" "), (_vm.filtersLoading) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": _vm.loadingMessage
    }
  })], 1)])]) : _c('div', {
    staticClass: "dashboard-content"
  }, [_c('div', {
    staticClass: "unit-block-row"
  }, [_c('div', {
    staticClass: "row row-1"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('day')
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock',
      "contentVisible": _vm.showNoContent
    },
    on: {
      "onNoContent": _vm.handleNoContent
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'YYYY [Week] WW'),
      "unit": 'Week',
      "unitClass": 'label-success',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'week',
      "received": _vm.chartsData['week-stats'].total,
      "growth": _vm.chartsData['week-stats'].growth,
      "stats": _vm.chartsData['week-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'week'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'week'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('week')
      }
    }
  }, [(!Boolean(_vm.chartsData['week-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('month')
      }
    }
  }, [_c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedProgrammingDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Received',
      "selected": _vm.selectedProgrammingPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePeriod('year')
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Messages",
      "titleIconClass": "fa fa-fw fa-envelope-o",
      "height": "280px",
      "titleRightIcon": {
        icon: 'fa fa-info-circle',
        tooltip: 'Click to view more info about messages',
      }
    },
    on: {
      "unitRightIconClick": _vm.messagesUnitRightIconClick
    }
  }, [(_vm.messagesData.total) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('horizontal-bar-chart', {
    staticStyle: {
      "max-height": "120px",
      "min-height": "120px"
    },
    attrs: {
      "showYAxes": true,
      "showXAxes": false,
      "data": _vm.sortMessagesChartData
    }
  })], 1) : _vm._e(), _vm._v(" "), (!Boolean(_vm.messagesData.total)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ProgrammingDashboardUnitLoader'
    },
    slot: "unit-content"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Competitions",
      "visible": _vm.promotionsDialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.promotionsDialogVisible = $event
      }
    }
  }, [(_vm.loadingAudienceData) ? _c('loader', {
    attrs: {
      "message": 'Loading...'
    }
  }) : _c('promotions-table', {
    attrs: {
      "data": _vm.promotionsData
    }
  })], 1), _vm._v(" "), _c('programming-dashboard-unit', {
    attrs: {
      "title": "Competitions",
      "titleIconClass": "fa fa-fw fa-gift",
      "height": "280px",
      "titleRightIcon": {
        icon: 'fa fa-info-circle',
        tooltip: 'Click to view Competitions table report',
      }
    },
    on: {
      "unitRightIconClick": _vm.promotionsUnitRightIconClick
    }
  }, [(_vm.promotionsData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('horizontal-bar-chart', {
    staticStyle: {
      "max-height": "180px",
      "min-height": "180px",
      "overflow-y": "scroll"
    },
    attrs: {
      "height": _vm.promotionBarChartHeight,
      "showYAxes": true,
      "showXAxes": false,
      "data": _vm.promotionsData.map(function (p) { return [
        _vm.getPromotionLabel(p.name),
        {
          Entries: p.entries,
          Uniques: p.uniques
        } ]; })
    }
  })], 1) : _vm._e(), _vm._v(" "), (!Boolean(Object.keys(_vm.promotionsData).length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ProgrammingDashboardUnitLoader',
      "contentVisible": _vm.showNoContent
    },
    on: {
      "onNoContent": _vm.handleNoContent
    },
    slot: "unit-content"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": 237
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-calendar"
  }), _vm._v("Heat Map\n            ")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['heat-map-stats'].points)) ? _c('analytics-heat-map', {
    attrs: {
      "data": _vm.chartsData['heat-map-stats'].points,
      "range": _vm.chartsData['heat-map-stats'].range
    },
    on: {
      "onChangeDate": function($event) {
        return _vm.$emit('onHeatMapDateChange', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['heat-map-stats'].points)) ? _c('content-loader-placeholder', {
    attrs: {
      "type": 'AnalyticsHeatMapLoader'
    }
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', {
    staticClass: "chart-title"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" "), _c('strong', [_vm._v("Engagement")])]), _vm._v(" "), _c('div', {
    staticClass: "chart-filters pull-right"
  }, [_c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'timeslot'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'timeslot'
        })
      }
    }
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'channel'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'channel'
        })
      }
    }
  }, [_vm._v("Channels")]), _vm._v(" "), _c('label', {
    staticClass: "label label-primary chart-label",
    class: {
      active: _vm.selectedEngagementsFilter === 'campaign'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeFilter', {
          filter: 'campaign'
        })
      }
    }
  }, [_vm._v("Campaigns")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.mainChartData.stats.points.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.mainChartData.stats.points,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedProgrammingPeriod) - 1],
      "showLegend": false
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.mainChartData.stats.points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'EngagementGraphLoader'
    },
    slot: "unit-content"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Topics Trending",
      "titleIconClass": "fa fa-fw fa-star"
    }
  }, [(_vm.trendingTopics.length) ? _c('vue-word-cloud', {
    staticStyle: {
      "width": "100%",
      "min-height": "465px",
      "display": "block"
    },
    attrs: {
      "slot": "unit-content",
      "font-family": "'Helvetica Neue', sans-serif",
      "rotationUnit": "turn",
      "color": _vm.trendingWordColor,
      "rotation": _vm.trendingWordsRotation,
      "animationDuration": 1500,
      "spacing": 0.3,
      "words": _vm.trendingTopics
    },
    slot: "unit-content"
  }) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'WordCloudLoader'
    },
    slot: "unit-content"
  })], 1)], 1)]), _vm._v(" "), (_vm.isStreaming) ? _c('div', {
    staticClass: "row row-4"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "height": "570px",
      "title": "Streaming Load",
      "titleIconClass": "fa fa-fw fa-area-chart"
    }
  }, [_c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStreamingData),
      expression: "loadingStreamingData"
    }],
    staticClass: "col-lg-8"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onChangeStreamingFilter
    },
    model: {
      value: (_vm.streamingFilter),
      callback: function($$v) {
        _vm.streamingFilter = $$v
      },
      expression: "streamingFilter"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Full week",
      "name": "week"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Week day",
      "name": "weekday"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Saturday",
      "name": "saturday"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Sunday",
      "name": "sunday"
    }
  })], 1), _vm._v(" "), _c('streaming-load', {
    attrs: {
      "showLegend": true,
      "showGridLines": true,
      "periodLabel": _vm.streamingPeriodLabel,
      "isTrimesterComplete": _vm.isTrimesterComplete,
      "data": _vm.prepareStreamingGraphData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('streaming-overview-table', {
    attrs: {
      "avgData": _vm.streamingData,
      "selectedPeriod": _vm.getStreamingOverviewPeriod
    }
  })], 1)])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-5"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Commercial Load",
      "titleIconClass": "fa fa-fw fa-bullhorn",
      "height": "580px"
    }
  }, [(_vm.commercialLoadData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Compare with Station  ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('playout-load', {
    attrs: {
      "showLegend": true,
      "station": _vm.stationName,
      "comparedStaton": _vm.selectedComparedStation,
      "data": _vm.commercialLoadData,
      "showGridLines": true,
      "yAxeslabelString": "Seconds",
      "xAxeslabelString": "Hour",
      "title": "commercial"
    }
  })], 1) : _c('blurred-image-place-holder', {
    attrs: {
      "slot": "unit-content",
      "showContactSales": true,
      "height": "500px",
      "imageSrc": '/static/assets/images/analytics/comercial-load-unblured.png',
      "alt": 'Comercial load blured image'
    },
    slot: "unit-content"
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Content Threads",
      "titleIconClass": "fa fa-fw fa-file-text-o",
      "height": "580px"
    }
  }, [(_vm.contentThreads.length) ? _c('content-threads-table', {
    attrs: {
      "slot": "unit-content",
      "data": _vm.contentThreads,
      "limit": 12
    },
    slot: "unit-content"
  }) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Musical Load",
      "titleIconClass": "fa fa-fw fa-bullhorn"
    }
  }, [(_vm.musicalLoadData.length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('label', [_vm._v("Compare with Station  ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('playout-load', {
    attrs: {
      "showLegend": true,
      "showGridLines": true,
      "station": _vm.stationName,
      "comparedStaton": _vm.selectedComparedStation,
      "data": _vm.musicalLoadData,
      "yAxeslabelString": "No. of songs",
      "xAxeslabelString": "Hour",
      "title": "music"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row top-track"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 ours"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stationName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('h3', [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 theirs"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedComparedStation))])])]), _vm._v(" "), _vm._l((10), function(i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "row top-track"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticClass: "count"
    }, [_vm._v(_vm._s(i))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 ours"
    }, [(
      _vm.topTracksData.length > 0 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].artist))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
      _vm.topTracksData.length > 0 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('title')
    ) ? _c('span', {
      staticClass: "track"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].title))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Number of times song played",
        "placement": "bottom"
      }
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[0].length >= i &&
      _vm.topTracksData[0][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "label pull-right"
    }, [_vm._v(_vm._s(_vm.topTracksData[0][i - 1].count))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 status"
    }, [_c('growth', {
      attrs: {
        "is-percentage": false,
        "value": 0
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-5 theirs"
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].artist))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "track"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].title))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Number of times song played",
        "placement": "bottom"
      }
    }, [(
      _vm.topTracksData.length > 1 &&
      _vm.topTracksData[1].length >= i &&
      _vm.topTracksData[1][i - 1].hasOwnProperty('artist')
    ) ? _c('span', {
      staticClass: "label pull-left"
    }, [_vm._v(_vm._s(_vm.topTracksData[1][i - 1].count))]) : _vm._e()])], 1)])])
  })], 2)])]) : _c('blurred-image-place-holder', {
    attrs: {
      "slot": "unit-content",
      "showContactSales": true,
      "imageSrc": '/static/assets/images/analytics/musical-load-unblured.png',
      "alt": 'Musical load blured image'
    },
    slot: "unit-content"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('programming-dashboard-unit', {
    attrs: {
      "title": "Audience Profile",
      "titleIconClass": "fa fa-fw fa-user-o"
    }
  }, [(_vm.loadingAudienceData) ? _c('content-placeholder', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5%"
    },
    attrs: {
      "slot": "unit-content",
      "text-value": "Loading...",
      "text-only": true,
      "count": 1
    },
    slot: "unit-content"
  }) : (Object.keys(_vm.audienceProfileData).length) ? _c('div', {
    attrs: {
      "slot": "unit-content"
    },
    slot: "unit-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v(_vm._s(_vm.getTimeslotLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v("ALL PROFILES")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 audience-title"
  }, [_vm._v("STATION AUDIENCE")])]), _vm._v(" "), _vm._l((Object.keys(_vm.audienceProfileData)), function(demographic) {
    return _c('div', {
      key: demographic,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 vertical-text"
    }, [_vm._v(_vm._s(_vm.demographicTitles[demographic] || demographic))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.showAudienceChartData(_vm.key, 'filtered').length) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[_vm.key].filtered.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.showAudienceChartData(demographic, 'total').length) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[demographic].total.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(
      _vm.showAudienceChartData(demographic, 'external').length &&
      _vm.showAudienceChartData(demographic, 'external')[0].length
    ) ? _c('doughnut-chart', {
      attrs: {
        "height": 120,
        "showLegend": false,
        "data": _vm.audienceProfileData[demographic].external.map(function (p) { return [p.title, p.show]; })
      }
    }) : _c('doughnut-chart-placeholder')], 1)])
  })], 2) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'AudienceProfileLoader'
    },
    slot: "unit-content"
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Messages",
      "visible": _vm.messagesDialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.messagesDialogVisible = $event
      }
    }
  }, [(!_vm.loadingAudienceData) ? _c('div', [_c('span', [_c('strong', {
    staticClass: "purple"
  }, [_vm._v("Total:")]), _vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.messagesData.total)) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', {
    staticClass: "purple"
  }, [_vm._v("Uniques:")]), _vm._v("\n        " + _vm._s(_vm.formatNumber(_vm.messagesData.uniques)) + "\n      ")])]) : _c('loader', {
    attrs: {
      "message": 'Loading Data'
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "selected": _vm.selected
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "arrow arrow-left",
    on: {
      "click": function($event) {
        return _vm.onClickPrevious()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-right",
    on: {
      "click": function($event) {
        return _vm.onClickNext()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "label pull-right",
    class: _vm.unitClass
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.period))])])]), _vm._v(" "), (_vm.processStats.length) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.received).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold text-success",
    class: {
      'text-success': _vm.growth > 0, 'text-danger': _vm.growth < 0
    }
  }, [_vm._v("\n      " + _vm._s(Math.round(_vm.growth)) + "%\n      "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.growth > 0, 'fa-level-down': _vm.growth < 0
    }
  })]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processStats,
      "gradient": ['#683090', '#c97eff'],
      "height": 60,
      "auto-draw": ""
    }
  })], 1)]) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content-loader")], 2)])
},staticRenderFns: []}

/***/ }),
/* 3424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.survey.isPreview) ? _c('el-alert', {
    attrs: {
      "title": "This survey has been published. Questions will not be editable.",
      "type": "warning",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 canvas-wrapper"
  }, [_c('el-card', {
    staticClass: "canvas-card",
    attrs: {
      "shadow": "never",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('question-canvas', {
    attrs: {
      "isEditable": _vm.survey.isPreview
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    ref: "selectorWrapper",
    staticClass: "col-md-4 selector-wrapper"
  }, [_c('el-card', {
    ref: "selectorCard",
    staticClass: "selector-card",
    class: {
      'selector-fixed': _vm.selectorFixed
    },
    style: (_vm.selectorStyle),
    attrs: {
      "shadow": "never",
      "body-style": {
        padding: '0 6px'
      }
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Qualitative",
      "name": "qualitative"
    }
  }, [_c('qualitative-selector-tab', {
    attrs: {
      "selectorFixed": _vm.selectorFixed
    }
  })], 1), _vm._v(" "), (_vm.survey.surveyType === 'MUSIC') ? _c('el-tab-pane', {
    attrs: {
      "label": "Music",
      "name": "music"
    }
  }, [_c('music-selector-tab', {
    attrs: {
      "selectorFixed": _vm.selectorFixed
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('choice-category-create-dialog'), _vm._v(" "), _c('choice-template-save-dialog'), _vm._v(" "), _c('hook-save-dialog'), _vm._v(" "), _c('matrix-choice-save-dialog'), _vm._v(" "), _c('matrix-conditional-logic-dialog'), _vm._v(" "), _c('question-category-create-dialog'), _vm._v(" "), _c('question-conditional-logic-dialog'), _vm._v(" "), _c('question-save-dialog')], 1)
},staticRenderFns: []}

/***/ }),
/* 3425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('content-loader', {
    attrs: {
      "height": 675,
      "width": 600,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "92.7",
      "y": "115.61",
      "rx": "4",
      "ry": "4",
      "width": "169.58",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "45",
      "y": "64.43",
      "rx": "5",
      "ry": "5",
      "width": "20.74",
      "height": "408.17"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "63",
      "y": "150",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "01",
      "y": "151",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "79.24",
      "y": "150.13",
      "rx": "4",
      "ry": "4",
      "width": "397.72",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "311.62",
      "y": "112.04",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "74.35",
      "y": "389.4",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "205",
      "y": "391",
      "rx": "4",
      "ry": "4",
      "width": "174",
      "height": "19"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "85.36",
      "y": "188.22",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "114.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "113.49",
      "y": "265.6",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "114.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "114.71",
      "y": "235.84",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "146.51",
      "y": "358.45",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "79.24",
      "y": "77.52",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "148.96",
      "y": "260.84",
      "rx": "5",
      "ry": "5",
      "width": "15.86",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "273.7",
      "y": "43",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "178.31",
      "y": "325.12",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "238.24",
      "y": "226.32",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "282.26",
      "y": "356.06",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "123.27",
      "y": "185.84",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "272.48",
      "y": "215.6",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "260.25",
      "y": "189.41",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "493.84",
      "y": "164.42",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "114.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "623.2",
      "y": "239.41",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "171.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "502.12",
      "y": "323.93",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "466.94",
      "y": "219.17",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "535.43",
      "y": "129.9",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "377.66",
      "y": "252.5",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "344.64",
      "y": "220.36",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "343.41",
      "y": "257.26",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "306.72",
      "y": "225.13",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "114.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "76.8",
      "y": "419.15",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "114.24"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "106.15",
      "y": "439.39",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "133.06",
      "y": "422.73",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "360.54",
      "y": "420.34",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "141.62",
      "y": "462.01",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "171.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "174.64",
      "y": "456.06",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "192.98",
      "y": "487",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "399.67",
      "y": "451.29",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "199.1",
      "y": "527.48",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "230.9",
      "y": "516.76",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "230.9",
      "y": "556.05",
      "rx": "4",
      "ry": "4",
      "width": "212.28",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "447.37",
      "y": "482.24",
      "rx": "5",
      "ry": "5",
      "width": "17.08",
      "height": "94.01"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "320.18",
      "y": "485.81",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "514.64",
      "y": "454.86",
      "rx": "5",
      "ry": "5",
      "width": "18.3",
      "height": "171.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "233.34",
      "y": "586.99",
      "rx": "4",
      "ry": "4",
      "width": "111.02",
      "height": "22.61"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 3426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-alerts"
  }, [_c('facebook-create-dialog', {
    attrs: {
      "isVisible": _vm.showFacebookCreateDialog,
      "me": _vm.me
    },
    on: {
      "onFacebookChannelAdded": function () { return _vm.handleChannelAdded('showFacebookCreateDialog'); },
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleFacebookVisibilityChange); }
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleInstagramVisibilityChange); }
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleEmailDialogVisibilityChange); }
    }
  }), _vm._v(" "), _c('wechat-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWechatCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleWechatDialogVisibilityChange); }
    }
  }), _vm._v(" "), (_vm.showWhatsAppWebCreateDialog) ? _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsAppWebCreateDialog,
      "intialData": {
        phoneNumber: _vm.phoneNumber,
        selectedCountry: _vm.selectedCountry
      }
    },
    on: {
      "onWhatsappChannelAdded": function () { return _vm.handleChannelAdded('showWhatsAppWebCreateDialog'); },
      "onVisibleChanged": function (value) { return _vm.handleDialogVisibilityChanged(value, _vm.handleWhatsappWebDialogVisibilityChange); }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 3427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast"
  }, [_vm._v("\n  " + _vm._s(_vm.toastTitle) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 3428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Edit Rule",
      "before-close": _vm.handleClose,
      "show-close": false,
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('rule', {
    attrs: {
      "rule": _vm.rule,
      "campaign": _vm.rule.campaign
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.rule.events) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addEmptyAction
    }
  }, [_vm._v("Add Action")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.saving,
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSave(_vm.rule)
      }
    }
  }, [_vm._v("Save Rule")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 3429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Filebox Stats")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n      Total Company Files: " + _vm._s(_vm.numCompanyFiles)), _c('br'), _c('br'), _vm._v("\n      Total User Files: " + _vm._s(_vm.numMyFiles)), _c('br'), _c('br')])])], 1)
},staticRenderFns: []}

/***/ }),
/* 3430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "30%",
      "top": "25vh",
      "center": true,
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.nuggetLabel) + ":")]), _vm._v("\n      " + _vm._s(_vm.nuggetValue) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('el-button', {
    staticClass: "nugget-control",
    attrs: {
      "size": "small",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.blacklistNugget
    }
  }, [_vm._v("Blacklist for all profiles")]), _vm._v(" "), _c('el-button', {
    staticClass: "nugget-control",
    attrs: {
      "size": "small",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.removeNugget
    }
  }, [_vm._v("Remove from profile")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 3431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audience-dashboard')
},staticRenderFns: []}

/***/ }),
/* 3432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.group.length === 0) ? _c('div', {
    staticClass: "empty-container"
  }, [_c('div', {
    on: {
      "click": _vm.handleToggleCollapse
    }
  }, [_vm._v("Expand to add media questions")])]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "hook-container",
    attrs: {
      "group": "hooks",
      "draggable": ".draggable"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggleCollapse($event)
      }
    }
  }, _vm._l((_vm.value.group), function(question) {
    return _c('div', {
      key: question.id,
      staticClass: "hook-item draggable"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(question.mediaClip.title))]), _vm._v(" "), _c('div', {
      staticClass: "artist"
    }, [_vm._v(_vm._s(question.mediaClip.artist))])])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */
/***/ (function(module, exports) {

module.exports = {"Arts & Entertainment":["Books & Literature","Celebrity Fan/Gossip","Fine Art","Humor","Movies","Music","Television"],"Automotive":["Auto Parts","Auto Repair","Buying/Selling Cars","Car Culture","Certified Pre-Owned","Convertible","Coupe","Crossover","Diesel","Electric Vehicle","Hatchback","Hybrid","Luxury","MiniVan","Mororcycles","Off-Road Vehicles","Performance Vehicles","Pickup","Road-Side Assistance","Sedan","Trucks & Accessories","Vintage Cars","Wagon"],"Business":["Advertising","Agriculture","Biotech/Biomedical","Business Software","Construction","Forestry","Government","Green Solutions","Human Resources","Logistics","Marketing","Metals"],"Careers":["Career Planning","College","Financial Aid","Job Fairs","Job Search","Resume Writing/Advice","Nursing","Scholarships","Telecommuting","U.S. Military","Career Advice"],"Education":["7-12 Education","Adult Education","Art History","Colledge Administration","College Life","Distance Learning","English as a 2nd Language","Language Learning","Graduate School","Homeschooling","Homework/Study Tips","K-6 Educators","Private School","Special Education","Studying Business"],"Family & Parenting":["Adoption","Babies & Toddlers","Daycare/Pre School","Family Internet","Parenting - K-6 Kids","Parenting teens","Pregnancy","Special Needs Kids","Eldercare"],"Health & Fitness":["Exercise","A.D.D.","AIDS/HIV","Allergies","Alternative Medicine","Arthritis","Asthma","Autism/PDD","Bipolar Disorder","Brain Tumor","Cancer","Cholesterol","Chronic Fatigue Syndrome","Chronic Pain","Cold & Flu","Deafness","Dental Care","Depression","Dermatology","Diabetes","Epilepsy","GERD/Acid Reflux","Headaches/Migraines","Heart Disease","Herbs for Health","Holistic Healing","IBS/Crohn's Disease","Incest/Abuse Support","Incontinence","Infertility","Men's Health","Nutrition","Orthopedics","Panic/Anxiety Disorders","Pediatrics","Physical Therapy","Psychology/Psychiatry","Senor Health","Sexuality","Sleep Disorders","Smoking Cessation","Substance Abuse","Thyroid Disease","Weight Loss","Women's Health"],"Food & Drink":["American Cuisine","Barbecues & Grilling","Cajun/Creole","Chinese Cuisine","Cocktails/Beer","Coffee/Tea","Cuisine-Specific","Desserts & Baking","Dining Out","Food Allergies","French Cuisine","Health/Lowfat Cooking","Italian Cuisine","Japanese Cuisine","Mexican Cuisine","Vegan","Vegetarian","Wine"],"Hobbies & Interests":["Art/Technology","Arts & Crafts","Beadwork","Birdwatching","Board Games/Puzzles","Candle & Soap Making","Card Games","Chess","Cigars","Collecting","Comic Books","Drawing/Sketching","Freelance Writing","Genealogy","Getting Published","Guitar","Home Recording","Investors & Patents","Jewelry Making","Magic & Illusion","Needlework","Painting","Photography","Radio","Roleplaying Games","Sci-Fi & Fantasy","Scrapbooking","Screenwriting","Stamps & Coins","Video & Computer Games","Woodworking"],"Home & Garden":["Appliances","Entertaining","Environmental Safety","Gardening","Home Repair","Home Theater","Interior Decorating","Landscaping","Remodeling & Construction"],"Law, Gov't & Politics":["Immigration","Legal Issues","U.S. Government Resources","Politics","Commentary"],"News":["International News","National News","Local News"],"Personal Finance":["Beginning Investing","Credit/Debt & Loans","Financial News","Financial Planning","Hedge Fund","Insurance","Investing","Mutual Funds","Options","Retirement Planning","Stocks","Tax Planning"],"Society":["Dating","Divorce Support","Gay Life","Marriage","Senior Living","Teens","Weddings","Ethnic Specific"],"Science":["Astrology","Biology","Chemistry","Geology","Paranormal Phenomena","Physics","Space/Astronomy","Geography","Botany","Weather"],"Pets":["Aquariums","Birds","Cats","Dogs","Large Animals","Reptiles","Veterinary Medicine"],"Sports":["Auto Racing","Baseball","Bicycling","Bodybuilding","Boxing","Canoeing/Kayaking","Cheerleading","Climbing","Cricket","Figure Skating","Fly Fishing","Football","Freshwater Fishing","Game & Fish","Golf","Horse Racing","Horses","Hunting/Shooting","Inline Skating","Martial Arts","Mountain Biking","NASCAR Racing","Olympics","Paintball","Power & Motorcycles","Pro Basketball","Pro Ice Hockey","Rodeo","Rugby","Running/Jogging","Sailing","Saltwater Fishing","Scuba Diving","Skateboarding","Skiing","Snowboarding","Surfing/Bodyboarding","Swimming","Table Tennis/Ping-Pong","Tennis","Volleyball","Walking","Waterski/Wakeboard","World Soccer"],"Style & Fashion":["Beauty","Body Art","Fashion","Jewelry","Clothing","Accessories"],"Technology & Computing":["3-D Graphics","Animation","Antivirus Software","C/C++","Cameras & Camcorders","Cell Phones","Computer Certification","Computer Networking","Computer Peripherals","Computer Reviews","Data Centers","Databases","Desktop Publishing","Desktop Video","Email","Graphics Software","Home Video/DVD","Internet Technology","Java","JavaScript","Mac Support","MP3/MIDI","Net Conferencing","Net for Beginners","Network Security","Palmtops/PDAs","PC Support","Portable","Entertainment","Shareware/Freeware","Unix","Visual Basic","Web Clip Art","Web Design/HTML","Web Search","Windows"],"Travel":["Adventure Travel","Africa","Air Travel","Australia & New Zealand","Bed & Breakfasts","Budget Travel","Business Travel","By US Locale","Camping","Canada","Caribbean","Cruises","Eastern Europe","Europe","France","Greece","Honeymoons/Getaways","Hotels","Italy","Japan","Mexico & Central America","National Parks","South America","Spas","Theme Parks","Traveling with Kids","United Kingdom"],"Real Estate":["Apartments","Architects","Buying/Selling Homes"],"Shopping":["Contests & Freebies","Couponing","Comparison","Engines"],"Religion & Spirituality":["Alternative Religions","Atheism/Agnosticism","Buddhism","Catholicism","Christianity","Hinduism","Islam","Judaism","Latter-Day Saints","Pagan/Wiccan"],"Uncategorized":[],"Non-Standard Content":["Unmoderated UGC","Extreme Graphic/Explicit Violence","Pornography","Profane Content","Hate Content","Under Construction","Incentivized"],"Illegal Content":["Illegal Content","Warez","Spyware/Malware","CopyrightInfringement"]}

/***/ }),
/* 3444 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3445 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3446 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3447 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3448 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[1146]);


// WEBPACK FOOTER //
// static/js/app.a6c2245df3137fe2e588.js